import * as ne from "react";
import oe, { createContext as _t, useContext as tt, useMemo as Re, useRef as Le, useCallback as et, useEffect as Xe, useState as Ve, useLayoutEffect as b1, forwardRef as zs, Fragment as ft, isValidElement as Ho, cloneElement as cr, createElement as hi, useId as Et, useReducer as Ri, useSyncExternalStore as h8, createRef as Nu, PureComponent as Ln, Children as xs, Component as w1, useImperativeHandle as f8 } from "react";
import { format as _s, parse as KD, isBefore as Xp, sub as p8, isAfter as Vl, add as g8, formatISO as YD, differenceInMonths as m8, intlFormatDistance as v8, intlFormat as b8, isValid as N5, set as QD, isMatch as w8, getHours as y8, getMinutes as k8, isSameDay as $5 } from "date-fns";
import Ce from "classnames";
import ZD from "@react-hook/resize-observer";
import { debounce as _8, merge as y1, pick as XD, get as A8, chain as C8, head as x8, nth as E8 } from "lodash";
import { c as wa } from "./colors.856f51da.js";
import { FontAwesomeIcon as S8 } from "@fortawesome/react-fontawesome";
import M8 from "@tippyjs/react";
import * as Vu from "react-dom";
import { createPortal as JD, flushSync as oi } from "react-dom";
import { useDayzed as e4 } from "dayzed";
import T8 from "react-textarea-autosize";
import D8 from "react-fast-compare";
var ai = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function t4(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jp = { exports: {} }, wu = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L5;
function I8() {
  if (L5)
    return wu;
  L5 = 1;
  var e = oe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(f, p, v) {
    var b, y = {}, k = null, _ = null;
    v !== void 0 && (k = "" + v), p.key !== void 0 && (k = "" + p.key), p.ref !== void 0 && (_ = p.ref);
    for (b in p)
      o.call(p, b) && !u.hasOwnProperty(b) && (y[b] = p[b]);
    if (f && f.defaultProps)
      for (b in p = f.defaultProps, p)
        y[b] === void 0 && (y[b] = p[b]);
    return { $$typeof: n, type: f, key: k, ref: _, props: y, _owner: s.current };
  }
  return wu.Fragment = r, wu.jsx = h, wu.jsxs = h, wu;
}
var yu = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j5;
function P8() {
  return j5 || (j5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = oe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), E = Symbol.iterator, x = "@@iterator";
    function D(re) {
      if (re === null || typeof re != "object")
        return null;
      var Me = E && re[E] || re[x];
      return typeof Me == "function" ? Me : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function N(re) {
      {
        for (var Me = arguments.length, je = new Array(Me > 1 ? Me - 1 : 0), Qe = 1; Qe < Me; Qe++)
          je[Qe - 1] = arguments[Qe];
        O("error", re, je);
      }
    }
    function O(re, Me, je) {
      {
        var Qe = I.ReactDebugCurrentFrame, bt = Qe.getStackAddendum();
        bt !== "" && (Me += "%s", je = je.concat([bt]));
        var Ct = je.map(function(wt) {
          return String(wt);
        });
        Ct.unshift("Warning: " + Me), Function.prototype.apply.call(console[re], console, Ct);
      }
    }
    var P = !1, S = !1, $ = !1, L = !1, B = !1, U;
    U = Symbol.for("react.module.reference");
    function G(re) {
      return !!(typeof re == "string" || typeof re == "function" || re === o || re === u || B || re === s || re === v || re === b || L || re === _ || P || S || $ || typeof re == "object" && re !== null && (re.$$typeof === k || re.$$typeof === y || re.$$typeof === h || re.$$typeof === f || re.$$typeof === p || re.$$typeof === U || re.getModuleId !== void 0));
    }
    function q(re, Me, je) {
      var Qe = re.displayName;
      if (Qe)
        return Qe;
      var bt = Me.displayName || Me.name || "";
      return bt !== "" ? je + "(" + bt + ")" : je;
    }
    function Y(re) {
      return re.displayName || "Context";
    }
    function Q(re) {
      if (re == null)
        return null;
      if (typeof re.tag == "number" && N("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof re == "function")
        return re.displayName || re.name || null;
      if (typeof re == "string")
        return re;
      switch (re) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case u:
          return "Profiler";
        case s:
          return "StrictMode";
        case v:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof re == "object")
        switch (re.$$typeof) {
          case f:
            var Me = re;
            return Y(Me) + ".Consumer";
          case h:
            var je = re;
            return Y(je._context) + ".Provider";
          case p:
            return q(re, re.render, "ForwardRef");
          case y:
            var Qe = re.displayName || null;
            return Qe !== null ? Qe : Q(re.type) || "Memo";
          case k: {
            var bt = re, Ct = bt._payload, wt = bt._init;
            try {
              return Q(wt(Ct));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, ae = 0, ie, pe, ce, ue, X, se, he;
    function de() {
    }
    de.__reactDisabledLog = !0;
    function me() {
      {
        if (ae === 0) {
          ie = console.log, pe = console.info, ce = console.warn, ue = console.error, X = console.group, se = console.groupCollapsed, he = console.groupEnd;
          var re = {
            configurable: !0,
            enumerable: !0,
            value: de,
            writable: !0
          };
          Object.defineProperties(console, {
            info: re,
            log: re,
            warn: re,
            error: re,
            group: re,
            groupCollapsed: re,
            groupEnd: re
          });
        }
        ae++;
      }
    }
    function we() {
      {
        if (ae--, ae === 0) {
          var re = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, re, {
              value: ie
            }),
            info: Z({}, re, {
              value: pe
            }),
            warn: Z({}, re, {
              value: ce
            }),
            error: Z({}, re, {
              value: ue
            }),
            group: Z({}, re, {
              value: X
            }),
            groupCollapsed: Z({}, re, {
              value: se
            }),
            groupEnd: Z({}, re, {
              value: he
            })
          });
        }
        ae < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ae = I.ReactCurrentDispatcher, Se;
    function ke(re, Me, je) {
      {
        if (Se === void 0)
          try {
            throw Error();
          } catch (bt) {
            var Qe = bt.stack.trim().match(/\n( *(at )?)/);
            Se = Qe && Qe[1] || "";
          }
        return `
` + Se + re;
      }
    }
    var ge = !1, xe;
    {
      var Te = typeof WeakMap == "function" ? WeakMap : Map;
      xe = new Te();
    }
    function J(re, Me) {
      if (!re || ge)
        return "";
      {
        var je = xe.get(re);
        if (je !== void 0)
          return je;
      }
      var Qe;
      ge = !0;
      var bt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ct;
      Ct = Ae.current, Ae.current = null, me();
      try {
        if (Me) {
          var wt = function() {
            throw Error();
          };
          if (Object.defineProperty(wt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(wt, []);
            } catch (Ar) {
              Qe = Ar;
            }
            Reflect.construct(re, [], wt);
          } else {
            try {
              wt.call();
            } catch (Ar) {
              Qe = Ar;
            }
            re.call(wt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ar) {
            Qe = Ar;
          }
          re();
        }
      } catch (Ar) {
        if (Ar && Qe && typeof Ar.stack == "string") {
          for (var ht = Ar.stack.split(`
`), ln = Qe.stack.split(`
`), hn = ht.length - 1, bn = ln.length - 1; hn >= 1 && bn >= 0 && ht[hn] !== ln[bn]; )
            bn--;
          for (; hn >= 1 && bn >= 0; hn--, bn--)
            if (ht[hn] !== ln[bn]) {
              if (hn !== 1 || bn !== 1)
                do
                  if (hn--, bn--, bn < 0 || ht[hn] !== ln[bn]) {
                    var ur = `
` + ht[hn].replace(" at new ", " at ");
                    return re.displayName && ur.includes("<anonymous>") && (ur = ur.replace("<anonymous>", re.displayName)), typeof re == "function" && xe.set(re, ur), ur;
                  }
                while (hn >= 1 && bn >= 0);
              break;
            }
        }
      } finally {
        ge = !1, Ae.current = Ct, we(), Error.prepareStackTrace = bt;
      }
      var Gr = re ? re.displayName || re.name : "", Zs = Gr ? ke(Gr) : "";
      return typeof re == "function" && xe.set(re, Zs), Zs;
    }
    function Ge(re, Me, je) {
      return J(re, !1);
    }
    function De(re) {
      var Me = re.prototype;
      return !!(Me && Me.isReactComponent);
    }
    function He(re, Me, je) {
      if (re == null)
        return "";
      if (typeof re == "function")
        return J(re, De(re));
      if (typeof re == "string")
        return ke(re);
      switch (re) {
        case v:
          return ke("Suspense");
        case b:
          return ke("SuspenseList");
      }
      if (typeof re == "object")
        switch (re.$$typeof) {
          case p:
            return Ge(re.render);
          case y:
            return He(re.type, Me, je);
          case k: {
            var Qe = re, bt = Qe._payload, Ct = Qe._init;
            try {
              return He(Ct(bt), Me, je);
            } catch {
            }
          }
        }
      return "";
    }
    var at = Object.prototype.hasOwnProperty, qt = {}, An = I.ReactDebugCurrentFrame;
    function Lt(re) {
      if (re) {
        var Me = re._owner, je = He(re.type, re._source, Me ? Me.type : null);
        An.setExtraStackFrame(je);
      } else
        An.setExtraStackFrame(null);
    }
    function Ft(re, Me, je, Qe, bt) {
      {
        var Ct = Function.call.bind(at);
        for (var wt in re)
          if (Ct(re, wt)) {
            var ht = void 0;
            try {
              if (typeof re[wt] != "function") {
                var ln = Error((Qe || "React class") + ": " + je + " type `" + wt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof re[wt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ln.name = "Invariant Violation", ln;
              }
              ht = re[wt](Me, wt, Qe, je, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (hn) {
              ht = hn;
            }
            ht && !(ht instanceof Error) && (Lt(bt), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Qe || "React class", je, wt, typeof ht), Lt(null)), ht instanceof Error && !(ht.message in qt) && (qt[ht.message] = !0, Lt(bt), N("Failed %s type: %s", je, ht.message), Lt(null));
          }
      }
    }
    var mr = Array.isArray;
    function _r(re) {
      return mr(re);
    }
    function Mn(re) {
      {
        var Me = typeof Symbol == "function" && Symbol.toStringTag, je = Me && re[Symbol.toStringTag] || re.constructor.name || "Object";
        return je;
      }
    }
    function Pe(re) {
      try {
        return Ke(re), !1;
      } catch {
        return !0;
      }
    }
    function Ke(re) {
      return "" + re;
    }
    function zt(re) {
      if (Pe(re))
        return N("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Mn(re)), Ke(re);
    }
    var nn = I.ReactCurrentOwner, Cn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Hr, Mr, vi;
    vi = {};
    function ji(re) {
      if (at.call(re, "ref")) {
        var Me = Object.getOwnPropertyDescriptor(re, "ref").get;
        if (Me && Me.isReactWarning)
          return !1;
      }
      return re.ref !== void 0;
    }
    function Tn(re) {
      if (at.call(re, "key")) {
        var Me = Object.getOwnPropertyDescriptor(re, "key").get;
        if (Me && Me.isReactWarning)
          return !1;
      }
      return re.key !== void 0;
    }
    function Zt(re, Me) {
      if (typeof re.ref == "string" && nn.current && Me && nn.current.stateNode !== Me) {
        var je = Q(nn.current.type);
        vi[je] || (N('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Q(nn.current.type), re.ref), vi[je] = !0);
      }
    }
    function vn(re, Me) {
      {
        var je = function() {
          Hr || (Hr = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Me));
        };
        je.isReactWarning = !0, Object.defineProperty(re, "key", {
          get: je,
          configurable: !0
        });
      }
    }
    function Bi(re, Me) {
      {
        var je = function() {
          Mr || (Mr = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Me));
        };
        je.isReactWarning = !0, Object.defineProperty(re, "ref", {
          get: je,
          configurable: !0
        });
      }
    }
    var Fi = function(re, Me, je, Qe, bt, Ct, wt) {
      var ht = {
        $$typeof: n,
        type: re,
        key: Me,
        ref: je,
        props: wt,
        _owner: Ct
      };
      return ht._store = {}, Object.defineProperty(ht._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ht, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.defineProperty(ht, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: bt
      }), Object.freeze && (Object.freeze(ht.props), Object.freeze(ht)), ht;
    };
    function zi(re, Me, je, Qe, bt) {
      {
        var Ct, wt = {}, ht = null, ln = null;
        je !== void 0 && (zt(je), ht = "" + je), Tn(Me) && (zt(Me.key), ht = "" + Me.key), ji(Me) && (ln = Me.ref, Zt(Me, bt));
        for (Ct in Me)
          at.call(Me, Ct) && !Cn.hasOwnProperty(Ct) && (wt[Ct] = Me[Ct]);
        if (re && re.defaultProps) {
          var hn = re.defaultProps;
          for (Ct in hn)
            wt[Ct] === void 0 && (wt[Ct] = hn[Ct]);
        }
        if (ht || ln) {
          var bn = typeof re == "function" ? re.displayName || re.name || "Unknown" : re;
          ht && vn(wt, bn), ln && Bi(wt, bn);
        }
        return Fi(re, ht, ln, bt, Qe, nn.current, wt);
      }
    }
    var bi = I.ReactCurrentOwner, Ks = I.ReactDebugCurrentFrame;
    function Vi(re) {
      if (re) {
        var Me = re._owner, je = He(re.type, re._source, Me ? Me.type : null);
        Ks.setExtraStackFrame(je);
      } else
        Ks.setExtraStackFrame(null);
    }
    var na;
    na = !1;
    function Ur(re) {
      return typeof re == "object" && re !== null && re.$$typeof === n;
    }
    function Fa() {
      {
        if (bi.current) {
          var re = Q(bi.current.type);
          if (re)
            return `

Check the render method of \`` + re + "`.";
        }
        return "";
      }
    }
    function Wn(re) {
      {
        if (re !== void 0) {
          var Me = re.fileName.replace(/^.*[\\\/]/, ""), je = re.lineNumber;
          return `

Check your code at ` + Me + ":" + je + ".";
        }
        return "";
      }
    }
    var Ys = {};
    function Wr(re) {
      {
        var Me = Fa();
        if (!Me) {
          var je = typeof re == "string" ? re : re.displayName || re.name;
          je && (Me = `

Check the top-level render call using <` + je + ">.");
        }
        return Me;
      }
    }
    function _o(re, Me) {
      {
        if (!re._store || re._store.validated || re.key != null)
          return;
        re._store.validated = !0;
        var je = Wr(Me);
        if (Ys[je])
          return;
        Ys[je] = !0;
        var Qe = "";
        re && re._owner && re._owner !== bi.current && (Qe = " It was passed a child from " + Q(re._owner.type) + "."), Vi(re), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', je, Qe), Vi(null);
      }
    }
    function Qs(re, Me) {
      {
        if (typeof re != "object")
          return;
        if (_r(re))
          for (var je = 0; je < re.length; je++) {
            var Qe = re[je];
            Ur(Qe) && _o(Qe, Me);
          }
        else if (Ur(re))
          re._store && (re._store.validated = !0);
        else if (re) {
          var bt = D(re);
          if (typeof bt == "function" && bt !== re.entries)
            for (var Ct = bt.call(re), wt; !(wt = Ct.next()).done; )
              Ur(wt.value) && _o(wt.value, Me);
        }
      }
    }
    function Cc(re) {
      {
        var Me = re.type;
        if (Me == null || typeof Me == "string")
          return;
        var je;
        if (typeof Me == "function")
          je = Me.propTypes;
        else if (typeof Me == "object" && (Me.$$typeof === p || Me.$$typeof === y))
          je = Me.propTypes;
        else
          return;
        if (je) {
          var Qe = Q(Me);
          Ft(je, re.props, "prop", Qe, re);
        } else if (Me.PropTypes !== void 0 && !na) {
          na = !0;
          var bt = Q(Me);
          N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", bt || "Unknown");
        }
        typeof Me.getDefaultProps == "function" && !Me.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xc(re) {
      {
        for (var Me = Object.keys(re.props), je = 0; je < Me.length; je++) {
          var Qe = Me[je];
          if (Qe !== "children" && Qe !== "key") {
            Vi(re), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Qe), Vi(null);
            break;
          }
        }
        re.ref !== null && (Vi(re), N("Invalid attribute `ref` supplied to `React.Fragment`."), Vi(null));
      }
    }
    function wi(re, Me, je, Qe, bt, Ct) {
      {
        var wt = G(re);
        if (!wt) {
          var ht = "";
          (re === void 0 || typeof re == "object" && re !== null && Object.keys(re).length === 0) && (ht += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ln = Wn(bt);
          ln ? ht += ln : ht += Fa();
          var hn;
          re === null ? hn = "null" : _r(re) ? hn = "array" : re !== void 0 && re.$$typeof === n ? (hn = "<" + (Q(re.type) || "Unknown") + " />", ht = " Did you accidentally export a JSX literal instead of a component?") : hn = typeof re, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", hn, ht);
        }
        var bn = zi(re, Me, je, bt, Ct);
        if (bn == null)
          return bn;
        if (wt) {
          var ur = Me.children;
          if (ur !== void 0)
            if (Qe)
              if (_r(ur)) {
                for (var Gr = 0; Gr < ur.length; Gr++)
                  Qs(ur[Gr], re);
                Object.freeze && Object.freeze(ur);
              } else
                N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Qs(ur, re);
        }
        return re === o ? xc(bn) : Cc(bn), bn;
      }
    }
    function Ec(re, Me, je) {
      return wi(re, Me, je, !0);
    }
    function Hi(re, Me, je) {
      return wi(re, Me, je, !1);
    }
    var Tr = Hi, Sc = Ec;
    yu.Fragment = o, yu.jsx = Tr, yu.jsxs = Sc;
  }()), yu;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = I8() : e.exports = P8();
})(Jp);
const bo = Jp.exports.Fragment, M = Jp.exports.jsx, K = Jp.exports.jsxs, n4 = _t(void 0);
function O8({
  locale: e = "en-US",
  children: n
}) {
  return /* @__PURE__ */ M(n4.Provider, {
    value: e,
    children: n
  });
}
function sn(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : e.defaultWidth, o = e.formats[r] || e.formats[e.defaultWidth];
    return o;
  };
}
function pt(e) {
  return function(n, r) {
    var o = r != null && r.context ? String(r.context) : "standalone", s;
    if (o === "formatting" && e.formattingValues) {
      var u = e.defaultFormattingWidth || e.defaultWidth, h = r != null && r.width ? String(r.width) : u;
      s = e.formattingValues[h] || e.formattingValues[u];
    } else {
      var f = e.defaultWidth, p = r != null && r.width ? String(r.width) : e.defaultWidth;
      s = e.values[p] || e.values[f];
    }
    var v = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[v];
  };
}
function gt(e) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.width, s = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], u = n.match(s);
    if (!u)
      return null;
    var h = u[0], f = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], p = Array.isArray(f) ? N8(f, function(y) {
      return y.test(h);
    }) : R8(f, function(y) {
      return y.test(h);
    }), v;
    v = e.valueCallback ? e.valueCallback(p) : p, v = r.valueCallback ? r.valueCallback(v) : v;
    var b = n.slice(h.length);
    return {
      value: v,
      rest: b
    };
  };
}
function R8(e, n) {
  for (var r in e)
    if (e.hasOwnProperty(r) && n(e[r]))
      return r;
}
function N8(e, n) {
  for (var r = 0; r < e.length; r++)
    if (n(e[r]))
      return r;
}
function Na(e) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.match(e.matchPattern);
    if (!o)
      return null;
    var s = o[0], u = n.match(e.parsePattern);
    if (!u)
      return null;
    var h = e.valueCallback ? e.valueCallback(u[0]) : u[0];
    h = r.valueCallback ? r.valueCallback(h) : h;
    var f = n.slice(s.length);
    return {
      value: h,
      rest: f
    };
  };
}
function $8(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var n = Number(e);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function k1(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function df(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? df = function(r) {
    return typeof r;
  } : df = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, df(e);
}
function L8(e) {
  k1(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || df(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
var j8 = {};
function B8() {
  return j8;
}
function B5(e, n) {
  var r, o, s, u, h, f, p, v;
  k1(1, arguments);
  var b = B8(), y = $8((r = (o = (s = (u = n?.weekStartsOn) !== null && u !== void 0 ? u : n == null || (h = n.locale) === null || h === void 0 || (f = h.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && s !== void 0 ? s : b.weekStartsOn) !== null && o !== void 0 ? o : (p = b.locale) === null || p === void 0 || (v = p.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var k = L8(e), _ = k.getUTCDay(), E = (_ < y ? 7 : 0) + _ - y;
  return k.setUTCDate(k.getUTCDate() - E), k.setUTCHours(0, 0, 0, 0), k;
}
var F8 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, z8 = function(n, r, o) {
  var s, u = F8[n];
  return typeof u == "string" ? s = u : r === 1 ? s = u.one : s = u.other.replace("{{count}}", r.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + s : s + " ago" : s;
};
const r4 = z8;
var V8 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, H8 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, U8 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, W8 = {
  date: sn({
    formats: V8,
    defaultWidth: "full"
  }),
  time: sn({
    formats: H8,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: U8,
    defaultWidth: "full"
  })
};
const G8 = W8;
var q8 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, K8 = function(n, r, o, s) {
  return q8[n];
};
const i4 = K8;
var Y8 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Q8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Z8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, X8 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, J8 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, eF = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, tF = function(n, r) {
  var o = Number(n), s = o % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, nF = {
  ordinalNumber: tF,
  era: pt({
    values: Y8,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: Q8,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: Z8,
    defaultWidth: "wide"
  }),
  day: pt({
    values: X8,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: J8,
    defaultWidth: "wide",
    formattingValues: eF,
    defaultFormattingWidth: "wide"
  })
};
const o4 = nF;
var rF = /^(\d+)(th|st|nd|rd)?/i, iF = /\d+/i, oF = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, aF = {
  any: [/^b/i, /^(a|c)/i]
}, sF = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, lF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cF = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, uF = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, dF = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, hF = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, fF = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, pF = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gF = {
  ordinalNumber: Na({
    matchPattern: rF,
    parsePattern: iF,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: oF,
    defaultMatchWidth: "wide",
    parsePatterns: aF,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: sF,
    defaultMatchWidth: "wide",
    parsePatterns: lF,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: cF,
    defaultMatchWidth: "wide",
    parsePatterns: uF,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: dF,
    defaultMatchWidth: "wide",
    parsePatterns: hF,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: fF,
    defaultMatchWidth: "any",
    parsePatterns: pF,
    defaultParseWidth: "any"
  })
};
const a4 = gF;
var mF = {
  code: "en-US",
  formatDistance: r4,
  formatLong: G8,
  formatRelative: i4,
  localize: o4,
  match: a4,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const vF = mF;
function F5(e, n, r) {
  k1(2, arguments);
  var o = B5(e, r), s = B5(n, r);
  return o.getTime() === s.getTime();
}
var bF = {
  lessThanXSeconds: {
    one: {
      regular: "m\xE9n\u011B ne\u017E sekunda",
      past: "p\u0159ed m\xE9n\u011B ne\u017E sekundou",
      future: "za m\xE9n\u011B ne\u017E sekundu"
    },
    few: {
      regular: "m\xE9n\u011B ne\u017E {{count}} sekundy",
      past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
      future: "za m\xE9n\u011B ne\u017E {{count}} sekundy"
    },
    many: {
      regular: "m\xE9n\u011B ne\u017E {{count}} sekund",
      past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
      future: "za m\xE9n\u011B ne\u017E {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "p\u0159ed sekundou",
      future: "za sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "p\u0159ed {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "p\u0159ed {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "p\u016Fl minuty",
      past: "p\u0159ed p\u016Fl minutou",
      future: "za p\u016Fl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "m\xE9n\u011B ne\u017E minuta",
      past: "p\u0159ed m\xE9n\u011B ne\u017E minutou",
      future: "za m\xE9n\u011B ne\u017E minutu"
    },
    few: {
      regular: "m\xE9n\u011B ne\u017E {{count}} minuty",
      past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
      future: "za m\xE9n\u011B ne\u017E {{count}} minuty"
    },
    many: {
      regular: "m\xE9n\u011B ne\u017E {{count}} minut",
      past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
      future: "za m\xE9n\u011B ne\u017E {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "p\u0159ed minutou",
      future: "za minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "p\u0159ed {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "p\u0159ed {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "p\u0159ibli\u017En\u011B hodina",
      past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
      future: "p\u0159ibli\u017En\u011B za hodinu"
    },
    few: {
      regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
      future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
    },
    many: {
      regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
      future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "hodina",
      past: "p\u0159ed hodinou",
      future: "za hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "p\u0159ed {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "p\u0159ed {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "den",
      past: "p\u0159ed dnem",
      future: "za den"
    },
    few: {
      regular: "{{count}} dny",
      past: "p\u0159ed {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dn\xED",
      past: "p\u0159ed {{count}} dny",
      future: "za {{count}} dn\xED"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "p\u0159ibli\u017En\u011B t\xFDden",
      past: "p\u0159ibli\u017En\u011B p\u0159ed t\xFDdnem",
      future: "p\u0159ibli\u017En\u011B za t\xFDden"
    },
    few: {
      regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdny",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
      future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdny"
    },
    many: {
      regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdn\u016F",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
      future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdn\u016F"
    }
  },
  xWeeks: {
    one: {
      regular: "t\xFDden",
      past: "p\u0159ed t\xFDdnem",
      future: "za t\xFDden"
    },
    few: {
      regular: "{{count}} t\xFDdny",
      past: "p\u0159ed {{count}} t\xFDdny",
      future: "za {{count}} t\xFDdny"
    },
    many: {
      regular: "{{count}} t\xFDdn\u016F",
      past: "p\u0159ed {{count}} t\xFDdny",
      future: "za {{count}} t\xFDdn\u016F"
    }
  },
  aboutXMonths: {
    one: {
      regular: "p\u0159ibli\u017En\u011B m\u011Bs\xEDc",
      past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xEDcem",
      future: "p\u0159ibli\u017En\u011B za m\u011Bs\xEDc"
    },
    few: {
      regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDce",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
      future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDce"
    },
    many: {
      regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDc\u016F",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
      future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDc\u016F"
    }
  },
  xMonths: {
    one: {
      regular: "m\u011Bs\xEDc",
      past: "p\u0159ed m\u011Bs\xEDcem",
      future: "za m\u011Bs\xEDc"
    },
    few: {
      regular: "{{count}} m\u011Bs\xEDce",
      past: "p\u0159ed {{count}} m\u011Bs\xEDci",
      future: "za {{count}} m\u011Bs\xEDce"
    },
    many: {
      regular: "{{count}} m\u011Bs\xEDc\u016F",
      past: "p\u0159ed {{count}} m\u011Bs\xEDci",
      future: "za {{count}} m\u011Bs\xEDc\u016F"
    }
  },
  aboutXYears: {
    one: {
      regular: "p\u0159ibli\u017En\u011B rok",
      past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
      future: "p\u0159ibli\u017En\u011B za rok"
    },
    few: {
      regular: "p\u0159ibli\u017En\u011B {{count}} roky",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
      future: "p\u0159ibli\u017En\u011B za {{count}} roky"
    },
    many: {
      regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
      past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
      future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
    }
  },
  xYears: {
    one: {
      regular: "rok",
      past: "p\u0159ed rokem",
      future: "za rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "p\u0159ed {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} rok\u016F",
      past: "p\u0159ed {{count}} roky",
      future: "za {{count}} rok\u016F"
    }
  },
  overXYears: {
    one: {
      regular: "v\xEDce ne\u017E rok",
      past: "p\u0159ed v\xEDce ne\u017E rokem",
      future: "za v\xEDce ne\u017E rok"
    },
    few: {
      regular: "v\xEDce ne\u017E {{count}} roky",
      past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
      future: "za v\xEDce ne\u017E {{count}} roky"
    },
    many: {
      regular: "v\xEDce ne\u017E {{count}} rok\u016F",
      past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
      future: "za v\xEDce ne\u017E {{count}} rok\u016F"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro rok",
      past: "skoro p\u0159ed rokem",
      future: "skoro za rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro p\u0159ed {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} rok\u016F",
      past: "skoro p\u0159ed {{count}} roky",
      future: "skoro za {{count}} rok\u016F"
    }
  }
}, wF = function(n, r, o) {
  var s, u = bF[n];
  u.type === "other" ? s = u.other : r === 1 ? s = u.one : r > 1 && r < 5 ? s = u.few : s = u.many;
  var h = o?.addSuffix === !0, f = o?.comparison, p;
  return h && f === -1 ? p = s.past : h && f === 1 ? p = s.future : p = s.regular, p.replace("{{count}}", String(r));
};
const yF = wF;
var kF = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, _F = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, AF = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, CF = {
  date: sn({
    formats: kF,
    defaultWidth: "full"
  }),
  time: sn({
    formats: _F,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: AF,
    defaultWidth: "full"
  })
};
const xF = CF;
var EF = ["ned\u011Bli", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159edu", "\u010Dtvrtek", "p\xE1tek", "sobotu"], SF = {
  lastWeek: "'posledn\xED' eeee 've' p",
  yesterday: "'v\u010Dera v' p",
  today: "'dnes v' p",
  tomorrow: "'z\xEDtra v' p",
  nextWeek: function(n) {
    var r = n.getUTCDay();
    return "'v " + EF[r] + " o' p";
  },
  other: "P"
}, MF = function(n, r) {
  var o = SF[n];
  return typeof o == "function" ? o(r) : o;
};
const TF = MF;
var DF = {
  narrow: ["p\u0159. n. l.", "n. l."],
  abbreviated: ["p\u0159. n. l.", "n. l."],
  wide: ["p\u0159ed na\u0161\xEDm letopo\u010Dtem", "na\u0161eho letopo\u010Dtu"]
}, IF = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"],
  wide: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"]
}, PF = {
  narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
  abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
  wide: ["leden", "\xFAnor", "b\u0159ezen", "duben", "kv\u011Bten", "\u010Derven", "\u010Dervenec", "srpen", "z\xE1\u0159\xED", "\u0159\xEDjen", "listopad", "prosinec"]
}, OF = {
  narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
  abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
  wide: ["ledna", "\xFAnora", "b\u0159ezna", "dubna", "kv\u011Btna", "\u010Dervna", "\u010Dervence", "srpna", "z\xE1\u0159\xED", "\u0159\xEDjna", "listopadu", "prosince"]
}, RF = {
  narrow: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
  short: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
  abbreviated: ["ned", "pon", "\xFAte", "st\u0159", "\u010Dtv", "p\xE1t", "sob"],
  wide: ["ned\u011Ble", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159eda", "\u010Dtvrtek", "p\xE1tek", "sobota"]
}, NF = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  }
}, $F = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "p\u016Flnoc",
    noon: "poledne",
    morning: "r\xE1no",
    afternoon: "odpoledne",
    evening: "ve\u010Der",
    night: "noc"
  }
}, LF = function(n, r) {
  var o = Number(n);
  return o + ".";
}, jF = {
  ordinalNumber: LF,
  era: pt({
    values: DF,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: IF,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: PF,
    defaultWidth: "wide",
    formattingValues: OF,
    defaultFormattingWidth: "wide"
  }),
  day: pt({
    values: RF,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: NF,
    defaultWidth: "wide",
    formattingValues: $F,
    defaultFormattingWidth: "wide"
  })
};
const BF = jF;
var FF = /^(\d+)\.?/i, zF = /\d+/i, VF = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, HF = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, UF = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, WF = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, GF = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, qF = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
}, KF = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, YF = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, QF = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, ZF = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, XF = {
  ordinalNumber: Na({
    matchPattern: FF,
    parsePattern: zF,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: VF,
    defaultMatchWidth: "wide",
    parsePatterns: HF,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: UF,
    defaultMatchWidth: "wide",
    parsePatterns: WF,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: GF,
    defaultMatchWidth: "wide",
    parsePatterns: qF,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: KF,
    defaultMatchWidth: "wide",
    parsePatterns: YF,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: QF,
    defaultMatchWidth: "any",
    parsePatterns: ZF,
    defaultParseWidth: "any"
  })
};
const JF = XF;
var ez = {
  code: "cs",
  formatDistance: yF,
  formatLong: xF,
  formatRelative: TF,
  localize: BF,
  match: JF,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const tz = ez;
var z5 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, nz = function(n, r, o) {
  var s, u = o != null && o.addSuffix ? z5[n].withPreposition : z5[n].standalone;
  return typeof u == "string" ? s = u : r === 1 ? s = u.one : s = u.other.replace("{{count}}", String(r)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + s : "vor " + s : s;
};
const rz = nz;
var iz = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, oz = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, az = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, sz = {
  date: sn({
    formats: iz,
    defaultWidth: "full"
  }),
  time: sn({
    formats: oz,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: az,
    defaultWidth: "full"
  })
};
const lz = sz;
var cz = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, uz = function(n, r, o, s) {
  return cz[n];
};
const dz = uz;
var hz = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, fz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, yb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, pz = {
  narrow: yb.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: yb.wide
}, gz = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, mz = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, vz = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, bz = function(n) {
  var r = Number(n);
  return r + ".";
}, wz = {
  ordinalNumber: bz,
  era: pt({
    values: hz,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: fz,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: yb,
    formattingValues: pz,
    defaultWidth: "wide"
  }),
  day: pt({
    values: gz,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: mz,
    defaultWidth: "wide",
    formattingValues: vz,
    defaultFormattingWidth: "wide"
  })
};
const yz = wz;
var kz = /^(\d+)(\.)?/i, _z = /\d+/i, Az = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, Cz = {
  any: [/^v/i, /^n/i]
}, xz = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Ez = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Sz = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Mz = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Tz = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Dz = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Iz = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Pz = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
}, Oz = {
  ordinalNumber: Na({
    matchPattern: kz,
    parsePattern: _z,
    valueCallback: function(n) {
      return parseInt(n);
    }
  }),
  era: gt({
    matchPatterns: Az,
    defaultMatchWidth: "wide",
    parsePatterns: Cz,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: xz,
    defaultMatchWidth: "wide",
    parsePatterns: Ez,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: Sz,
    defaultMatchWidth: "wide",
    parsePatterns: Mz,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: Tz,
    defaultMatchWidth: "wide",
    parsePatterns: Dz,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: Iz,
    defaultMatchWidth: "wide",
    parsePatterns: Pz,
    defaultParseWidth: "any"
  })
};
const Rz = Oz;
var Nz = {
  code: "de",
  formatDistance: rz,
  formatLong: lz,
  formatRelative: dz,
  localize: yz,
  match: Rz,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const $z = Nz;
var Lz = {
  lessThanXSeconds: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  xSeconds: {
    one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
    other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
  },
  halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
  lessThanXMinutes: {
    one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  xMinutes: {
    one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
    other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
  },
  aboutXHours: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xHours: {
    one: "1 \u03CE\u03C1\u03B1",
    other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
  },
  xDays: {
    one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
    other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
  },
  aboutXWeeks: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  xWeeks: {
    one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
    other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
  },
  aboutXMonths: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  xMonths: {
    one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
    other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
  },
  aboutXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  xYears: {
    one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  overXYears: {
    one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  },
  almostXYears: {
    one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
    other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
  }
}, jz = function(n, r, o) {
  var s, u = Lz[n];
  return typeof u == "string" ? s = u : r === 1 ? s = u.one : s = u.other.replace("{{count}}", String(r)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "\u03C3\u03B5 " + s : s + " \u03C0\u03C1\u03B9\u03BD" : s;
};
const Bz = jz;
var Fz = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
}, zz = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Vz = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Hz = {
  date: sn({
    formats: Fz,
    defaultWidth: "full"
  }),
  time: sn({
    formats: zz,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: Vz,
    defaultWidth: "full"
  })
};
const Uz = Hz;
var Wz = {
  lastWeek: function(n) {
    switch (n.getUTCDay()) {
      case 6:
        return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
      default:
        return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
    }
  },
  yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
  today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
  tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
  nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
  other: "P"
}, Gz = function(n, r) {
  var o = Wz[n];
  return typeof o == "function" ? o(r) : o;
};
const qz = Gz;
var Kz = {
  narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
  abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
  wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
}, Yz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
  wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
}, Qz = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
}, Zz = {
  narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
  abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
  wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
}, Xz = {
  narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
  short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
  abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
  wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
}, Jz = {
  narrow: {
    am: "\u03C0\u03BC",
    pm: "\u03BC\u03BC",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  abbreviated: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  },
  wide: {
    am: "\u03C0.\u03BC.",
    pm: "\u03BC.\u03BC.",
    midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
    noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
    morning: "\u03C0\u03C1\u03C9\u03AF",
    afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
    evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
    night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
  }
}, e9 = function(n, r) {
  var o = Number(n), s = r?.unit, u;
  return s === "year" || s === "month" ? u = "\u03BF\u03C2" : s === "week" || s === "dayOfYear" || s === "day" || s === "hour" || s === "date" ? u = "\u03B7" : u = "\u03BF", o + u;
}, t9 = {
  ordinalNumber: e9,
  era: pt({
    values: Kz,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: Yz,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: Qz,
    defaultWidth: "wide",
    formattingValues: Zz,
    defaultFormattingWidth: "wide"
  }),
  day: pt({
    values: Xz,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: Jz,
    defaultWidth: "wide"
  })
};
const n9 = t9;
var r9 = /^(\d+)(ος|η|ο)?/i, i9 = /\d+/i, o9 = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
}, a9 = {
  any: [/^π/i, /^(μ|κ)/i]
}, s9 = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
}, l9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c9 = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
}, u9 = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
}, d9 = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
}, h9 = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
}, f9 = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
}, p9 = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
}, g9 = {
  ordinalNumber: Na({
    matchPattern: r9,
    parsePattern: i9,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: o9,
    defaultMatchWidth: "wide",
    parsePatterns: a9,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: s9,
    defaultMatchWidth: "wide",
    parsePatterns: l9,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: c9,
    defaultMatchWidth: "wide",
    parsePatterns: u9,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: d9,
    defaultMatchWidth: "wide",
    parsePatterns: h9,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: f9,
    defaultMatchWidth: "any",
    parsePatterns: p9,
    defaultParseWidth: "any"
  })
};
const m9 = g9;
var v9 = {
  code: "el",
  formatDistance: Bz,
  formatLong: Uz,
  formatRelative: qz,
  localize: n9,
  match: m9,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const b9 = v9;
var w9 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, y9 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, k9 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _9 = {
  date: sn({
    formats: w9,
    defaultWidth: "full"
  }),
  time: sn({
    formats: y9,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: k9,
    defaultWidth: "full"
  })
};
const A9 = _9;
var C9 = {
  code: "en-GB",
  formatDistance: r4,
  formatLong: A9,
  formatRelative: i4,
  localize: o4,
  match: a4,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const x9 = C9;
var V5 = {
  lessThanXSeconds: {
    standalone: {
      one: "v\xE4hem kui \xFCks sekund",
      other: "v\xE4hem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "v\xE4hem kui \xFChe sekundi",
      other: "v\xE4hem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "\xFCks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "\xFChe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "v\xE4hem kui \xFCks minut",
      other: "v\xE4hem kui {{count}} minutit"
    },
    withPreposition: {
      one: "v\xE4hem kui \xFChe minuti",
      other: "v\xE4hem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "\xFCks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "\xFChe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes \xFCks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes \xFChe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "\xFCks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "\xFChe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "\xFCks p\xE4ev",
      other: "{{count}} p\xE4eva"
    },
    withPreposition: {
      one: "\xFChe p\xE4eva",
      other: "{{count}} p\xE4eva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes \xFCks n\xE4dal",
      other: "umbes {{count}} n\xE4dalat"
    },
    withPreposition: {
      one: "umbes \xFChe n\xE4dala",
      other: "umbes {{count}} n\xE4dala"
    }
  },
  xWeeks: {
    standalone: {
      one: "\xFCks n\xE4dal",
      other: "{{count}} n\xE4dalat"
    },
    withPreposition: {
      one: "\xFChe n\xE4dala",
      other: "{{count}} n\xE4dala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes \xFCks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes \xFChe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "\xFCks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "\xFChe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes \xFCks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes \xFChe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "\xFCks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "\xFChe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui \xFCks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui \xFChe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu \xFCks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu \xFChe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, E9 = function(n, r, o) {
  var s = o != null && o.addSuffix ? V5[n].withPreposition : V5[n].standalone, u;
  return typeof s == "string" ? u = s : r === 1 ? u = s.one : u = s.other.replace("{{count}}", String(r)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? u + " p\xE4rast" : u + " eest" : u;
};
const S9 = E9;
var M9 = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, T9 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, D9 = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, I9 = {
  date: sn({
    formats: M9,
    defaultWidth: "full"
  }),
  time: sn({
    formats: T9,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: D9,
    defaultWidth: "full"
  })
};
const P9 = I9;
var O9 = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'t\xE4na kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'j\xE4rgmine' eeee 'kell' p",
  other: "P"
}, R9 = function(n, r, o, s) {
  return O9[n];
};
const N9 = R9;
var $9 = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise j\xE4rgi"]
}, L9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, H5 = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jaan", "veebr", "m\xE4rts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
  wide: ["jaanuar", "veebruar", "m\xE4rts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
}, U5 = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: ["p\xFChap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
  wide: ["p\xFChap\xE4ev", "esmasp\xE4ev", "teisip\xE4ev", "kolmap\xE4ev", "neljap\xE4ev", "reede", "laup\xE4ev"]
}, j9 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6",
    noon: "keskp\xE4ev",
    morning: "hommik",
    afternoon: "p\xE4rastl\xF5una",
    evening: "\xF5htu",
    night: "\xF6\xF6"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6",
    noon: "keskp\xE4ev",
    morning: "hommik",
    afternoon: "p\xE4rastl\xF5una",
    evening: "\xF5htu",
    night: "\xF6\xF6"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6",
    noon: "keskp\xE4ev",
    morning: "hommik",
    afternoon: "p\xE4rastl\xF5una",
    evening: "\xF5htu",
    night: "\xF6\xF6"
  }
}, B9 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6l",
    noon: "keskp\xE4eval",
    morning: "hommikul",
    afternoon: "p\xE4rastl\xF5unal",
    evening: "\xF5htul",
    night: "\xF6\xF6sel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6l",
    noon: "keskp\xE4eval",
    morning: "hommikul",
    afternoon: "p\xE4rastl\xF5unal",
    evening: "\xF5htul",
    night: "\xF6\xF6sel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesk\xF6\xF6l",
    noon: "keskp\xE4eval",
    morning: "hommikul",
    afternoon: "p\xE4rastl\xF5unal",
    evening: "\xF5htul",
    night: "\xF6\xF6sel"
  }
}, F9 = function(n, r) {
  var o = Number(n);
  return o + ".";
}, z9 = {
  ordinalNumber: F9,
  era: pt({
    values: $9,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: L9,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: H5,
    defaultWidth: "wide",
    formattingValues: H5,
    defaultFormattingWidth: "wide"
  }),
  day: pt({
    values: U5,
    defaultWidth: "wide",
    formattingValues: U5,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: pt({
    values: j9,
    defaultWidth: "wide",
    formattingValues: B9,
    defaultFormattingWidth: "wide"
  })
};
const V9 = z9;
var H9 = /^\d+\./i, U9 = /\d+/i, W9 = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, G9 = {
  any: [/^e/i, /^(m|p)/i]
}, q9 = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, K9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Y9 = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, Q9 = {
  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Z9 = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, X9 = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, J9 = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, eV = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, tV = {
  ordinalNumber: Na({
    matchPattern: H9,
    parsePattern: U9,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: W9,
    defaultMatchWidth: "wide",
    parsePatterns: G9,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: q9,
    defaultMatchWidth: "wide",
    parsePatterns: K9,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: Y9,
    defaultMatchWidth: "wide",
    parsePatterns: Q9,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: Z9,
    defaultMatchWidth: "wide",
    parsePatterns: X9,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: J9,
    defaultMatchWidth: "any",
    parsePatterns: eV,
    defaultParseWidth: "any"
  })
};
const nV = tV;
var rV = {
  code: "et",
  formatDistance: S9,
  formatLong: P9,
  formatRelative: N9,
  localize: V9,
  match: nV,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const iV = rV;
function W5(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function G5(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function q5(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function oV(e) {
  return e.replace(/päivää?/, "p\xE4iv\xE4n");
}
function K5(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function Y5(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Gh(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var aV = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: W5
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: W5
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(n) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: G5
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: G5
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: q5
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: q5
  },
  xDays: {
    one: "p\xE4iv\xE4",
    other: "{{count}} p\xE4iv\xE4\xE4",
    futureTense: oV
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: K5
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: K5
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: Y5
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: Y5
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Gh
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Gh
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Gh
  },
  almostXYears: {
    one: "l\xE4hes vuosi",
    other: "l\xE4hes {{count}} vuotta",
    futureTense: Gh
  }
}, sV = function(n, r, o) {
  var s = aV[n], u = r === 1 ? s.one : s.other.replace("{{count}}", String(r));
  return o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? s.futureTense(u) + " kuluttua" : u + " sitten" : u;
};
const lV = sV;
var cV = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, uV = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, dV = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, hV = {
  date: sn({
    formats: cV,
    defaultWidth: "full"
  }),
  time: sn({
    formats: uV,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: dV,
    defaultWidth: "full"
  })
};
const fV = hV;
var pV = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'t\xE4n\xE4\xE4n klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, gV = function(n, r, o, s) {
  return pV[n];
};
const mV = gV;
var vV = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "j\xE4lkeen ajanlaskun alun"]
}, bV = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, kb = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kes\xE4", "hein\xE4", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\xE4kuu", "hein\xE4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, wV = {
  narrow: kb.narrow,
  abbreviated: kb.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kes\xE4kuuta", "hein\xE4kuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, hf = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, yV = {
  narrow: hf.narrow,
  short: hf.short,
  abbreviated: hf.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, kV = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6ll\xE4",
    noon: "keskip\xE4iv\xE4ll\xE4",
    morning: "aamup\xE4iv\xE4ll\xE4",
    afternoon: "iltap\xE4iv\xE4ll\xE4",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  }
}, _V = function(n, r) {
  var o = Number(n);
  return o + ".";
}, AV = {
  ordinalNumber: _V,
  era: pt({
    values: vV,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: bV,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: kb,
    defaultWidth: "wide",
    formattingValues: wV,
    defaultFormattingWidth: "wide"
  }),
  day: pt({
    values: hf,
    defaultWidth: "wide",
    formattingValues: yV,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: pt({
    values: kV,
    defaultWidth: "wide"
  })
};
const CV = AV;
var xV = /^(\d+)(\.)/i, EV = /\d+/i, SV = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, MV = {
  any: [/^e/i, /^j/i]
}, TV = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, DV = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, IV = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, PV = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, OV = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, RV = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, NV = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, $V = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, LV = {
  ordinalNumber: Na({
    matchPattern: xV,
    parsePattern: EV,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: SV,
    defaultMatchWidth: "wide",
    parsePatterns: MV,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: TV,
    defaultMatchWidth: "wide",
    parsePatterns: DV,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: IV,
    defaultMatchWidth: "wide",
    parsePatterns: PV,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: OV,
    defaultMatchWidth: "wide",
    parsePatterns: RV,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: NV,
    defaultMatchWidth: "any",
    parsePatterns: $V,
    defaultParseWidth: "any"
  })
};
const jV = LV;
var BV = {
  code: "fi",
  formatDistance: lV,
  formatLong: fV,
  formatRelative: mV,
  localize: CV,
  match: jV,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const FV = BV;
function zV(e, n) {
  return n === 1 && e.one ? e.one : n >= 2 && n <= 4 && e.twoFour ? e.twoFour : e.other;
}
function lv(e, n, r) {
  var o = zV(e, n), s = o[r];
  return s.replace("{{count}}", String(n));
}
function VV(e) {
  var n = ["lessThan", "about", "over", "almost"].filter(function(r) {
    return !!e.match(new RegExp("^" + r));
  });
  return n[0];
}
function cv(e) {
  var n = "";
  return e === "almost" && (n = "takmer"), e === "about" && (n = "pribli\u017Ene"), n.length > 0 ? n + " " : "";
}
function uv(e) {
  var n = "";
  return e === "lessThan" && (n = "menej ne\u017E"), e === "over" && (n = "viac ne\u017E"), n.length > 0 ? n + " " : "";
}
function HV(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
var UV = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sek\xFAnd",
      past: "{{count}} sekundami",
      future: "{{count}} sek\xFAnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol min\xFAty",
      past: "pol min\xFAtou",
      future: "pol min\xFAty"
    }
  },
  xMinutes: {
    one: {
      present: "min\xFAta",
      past: "min\xFAtou",
      future: "min\xFAtu"
    },
    twoFour: {
      present: "{{count}} min\xFAty",
      past: "{{count}} min\xFAtami",
      future: "{{count}} min\xFAty"
    },
    other: {
      present: "{{count}} min\xFAt",
      past: "{{count}} min\xFAtami",
      future: "{{count}} min\xFAt"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hod\xEDn",
      past: "{{count}} hodinami",
      future: "{{count}} hod\xEDn"
    }
  },
  xDays: {
    one: {
      present: "de\u0148",
      past: "d\u0148om",
      future: "de\u0148"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} d\u0148ami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dn\xED",
      past: "{{count}} d\u0148ami",
      future: "{{count}} dn\xED"
    }
  },
  xWeeks: {
    one: {
      present: "t\xFD\u017Ede\u0148",
      past: "t\xFD\u017Ed\u0148om",
      future: "t\xFD\u017Ede\u0148"
    },
    twoFour: {
      present: "{{count}} t\xFD\u017Edne",
      past: "{{count}} t\xFD\u017Ed\u0148ami",
      future: "{{count}} t\xFD\u017Edne"
    },
    other: {
      present: "{{count}} t\xFD\u017Ed\u0148ov",
      past: "{{count}} t\xFD\u017Ed\u0148ami",
      future: "{{count}} t\xFD\u017Ed\u0148ov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, WV = function(n, r, o) {
  var s = VV(n) || "", u = HV(n.substring(s.length)), h = UV[u];
  return o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? cv(s) + "o " + uv(s) + lv(h, r, "future") : cv(s) + "pred " + uv(s) + lv(h, r, "past") : cv(s) + uv(s) + lv(h, r, "present");
};
const GV = WV;
var qV = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, KV = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, YV = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, QV = {
  date: sn({
    formats: qV,
    defaultWidth: "full"
  }),
  time: sn({
    formats: KV,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: YV,
    defaultWidth: "full"
  })
};
const ZV = QV;
var _1 = ["nede\u013Eu", "pondelok", "utorok", "stredu", "\u0161tvrtok", "piatok", "sobotu"];
function XV(e) {
  var n = _1[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'minul\xFA " + n + " o' p";
    default:
      return "'minul\xFD' eeee 'o' p";
  }
}
function Q5(e) {
  var n = _1[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + n + " o' p";
}
function JV(e) {
  var n = _1[e];
  switch (e) {
    case 0:
    case 4:
    case 6:
      return "'bud\xFAcu " + n + " o' p";
    default:
      return "'bud\xFAci' eeee 'o' p";
  }
}
var eH = {
  lastWeek: function(n, r, o) {
    var s = n.getUTCDay();
    return F5(n, r, o) ? Q5(s) : XV(s);
  },
  yesterday: "'v\u010Dera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: function(n, r, o) {
    var s = n.getUTCDay();
    return F5(n, r, o) ? Q5(s) : JV(s);
  },
  other: "P"
}, tH = function(n, r, o, s) {
  var u = eH[n];
  return typeof u == "function" ? u(r, o, s) : u;
};
const nH = tH;
var rH = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, iH = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. \u0161tvr\u0165rok", "2. \u0161tvr\u0165rok", "3. \u0161tvr\u0165rok", "4. \u0161tvr\u0165rok"]
}, oH = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["janu\xE1r", "febru\xE1r", "marec", "apr\xEDl", "m\xE1j", "j\xFAn", "j\xFAl", "august", "september", "okt\xF3ber", "november", "december"]
}, aH = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
  wide: ["janu\xE1ra", "febru\xE1ra", "marca", "apr\xEDla", "m\xE1ja", "j\xFAna", "j\xFAla", "augusta", "septembra", "okt\xF3bra", "novembra", "decembra"]
}, sH = {
  narrow: ["n", "p", "u", "s", "\u0161", "p", "s"],
  short: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
  wide: ["nede\u013Ea", "pondelok", "utorok", "streda", "\u0161tvrtok", "piatok", "sobota"]
}, lH = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "r\xE1no",
    afternoon: "pop.",
    evening: "ve\u010D.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "r\xE1no",
    afternoon: "popol.",
    evening: "ve\u010Der",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "r\xE1no",
    afternoon: "popoludnie",
    evening: "ve\u010Der",
    night: "noc"
  }
}, cH = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "r\xE1no",
    afternoon: "pop.",
    evening: "ve\u010D.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "r\xE1no",
    afternoon: "popol.",
    evening: "ve\u010Der",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "r\xE1no",
    afternoon: "popoludn\xED",
    evening: "ve\u010Der",
    night: "v noci"
  }
}, uH = function(n, r) {
  var o = Number(n);
  return o + ".";
}, dH = {
  ordinalNumber: uH,
  era: pt({
    values: rH,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: iH,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: oH,
    defaultWidth: "wide",
    formattingValues: aH,
    defaultFormattingWidth: "wide"
  }),
  day: pt({
    values: sH,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: lH,
    defaultWidth: "wide",
    formattingValues: cH,
    defaultFormattingWidth: "wide"
  })
};
const hH = dH;
var fH = /^(\d+)\.?/i, pH = /\d+/i, gH = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, mH = {
  any: [/^pr/i, /^(po|n)/i]
}, vH = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, bH = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wH = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, yH = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, kH = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, _H = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, AH = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, CH = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, xH = {
  ordinalNumber: Na({
    matchPattern: fH,
    parsePattern: pH,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: gH,
    defaultMatchWidth: "wide",
    parsePatterns: mH,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: vH,
    defaultMatchWidth: "wide",
    parsePatterns: bH,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: wH,
    defaultMatchWidth: "wide",
    parsePatterns: yH,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: kH,
    defaultMatchWidth: "wide",
    parsePatterns: _H,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: AH,
    defaultMatchWidth: "any",
    parsePatterns: CH,
    defaultParseWidth: "any"
  })
};
const EH = xH;
var SH = {
  code: "sk",
  formatDistance: GV,
  formatLong: ZV,
  formatRelative: nH,
  localize: hH,
  match: EH,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const MH = SH;
var TH = {
  lessThanXSeconds: {
    one: "mindre \xE4n en sekund",
    other: "mindre \xE4n {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre \xE4n en minut",
    other: "mindre \xE4n {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungef\xE4r en timme",
    other: "ungef\xE4r {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungef\xE4r en vecka",
    other: "ungef\xE4r {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungef\xE4r en m\xE5nad",
    other: "ungef\xE4r {{count}} m\xE5nader"
  },
  xMonths: {
    one: "en m\xE5nad",
    other: "{{count}} m\xE5nader"
  },
  aboutXYears: {
    one: "ungef\xE4r ett \xE5r",
    other: "ungef\xE4r {{count}} \xE5r"
  },
  xYears: {
    one: "ett \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "\xF6ver ett \xE5r",
    other: "\xF6ver {{count}} \xE5r"
  },
  almostXYears: {
    one: "n\xE4stan ett \xE5r",
    other: "n\xE4stan {{count}} \xE5r"
  }
}, DH = ["noll", "en", "tv\xE5", "tre", "fyra", "fem", "sex", "sju", "\xE5tta", "nio", "tio", "elva", "tolv"], IH = function(n, r, o) {
  var s, u = TH[n];
  return typeof u == "string" ? s = u : r === 1 ? s = u.one : o && o.onlyNumeric ? s = u.other.replace("{{count}}", String(r)) : s = u.other.replace("{{count}}", r < 13 ? DH[r] : String(r)), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "om " + s : s + " sedan" : s;
};
const PH = IH;
var OH = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, RH = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, NH = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, $H = {
  date: sn({
    formats: OH,
    defaultWidth: "full"
  }),
  time: sn({
    formats: RH,
    defaultWidth: "full"
  }),
  dateTime: sn({
    formats: NH,
    defaultWidth: "full"
  })
};
const LH = $H;
var jH = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'ig\xE5r kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, BH = function(n, r, o, s) {
  return jH[n];
};
const FH = BH;
var zH = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["f\xF6re Kristus", "efter Kristus"]
}, VH = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, HH = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, UH = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF6", "m\xE5", "ti", "on", "to", "fr", "l\xF6"],
  abbreviated: ["s\xF6n", "m\xE5n", "tis", "ons", "tors", "fre", "l\xF6r"],
  wide: ["s\xF6ndag", "m\xE5ndag", "tisdag", "onsdag", "torsdag", "fredag", "l\xF6rdag"]
}, WH = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  wide: {
    am: "f\xF6rmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kv\xE4ll",
    night: "natt"
  }
}, GH = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morgonen",
    afternoon: "p\xE5 eftermiddagen",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  }
}, qH = function(n, r) {
  var o = Number(n), s = o % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
      case 2:
        return o + ":a";
    }
  return o + ":e";
}, KH = {
  ordinalNumber: qH,
  era: pt({
    values: zH,
    defaultWidth: "wide"
  }),
  quarter: pt({
    values: VH,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: pt({
    values: HH,
    defaultWidth: "wide"
  }),
  day: pt({
    values: UH,
    defaultWidth: "wide"
  }),
  dayPeriod: pt({
    values: WH,
    defaultWidth: "wide",
    formattingValues: GH,
    defaultFormattingWidth: "wide"
  })
};
const YH = KH;
var QH = /^(\d+)(:a|:e)?/i, ZH = /\d+/i, XH = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, JH = {
  any: [/^f/i, /^[ev]/i]
}, eU = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, tU = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nU = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, rU = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, iU = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, oU = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, aU = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, sU = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, lU = {
  ordinalNumber: Na({
    matchPattern: QH,
    parsePattern: ZH,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: gt({
    matchPatterns: XH,
    defaultMatchWidth: "wide",
    parsePatterns: JH,
    defaultParseWidth: "any"
  }),
  quarter: gt({
    matchPatterns: eU,
    defaultMatchWidth: "wide",
    parsePatterns: tU,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: gt({
    matchPatterns: nU,
    defaultMatchWidth: "wide",
    parsePatterns: rU,
    defaultParseWidth: "any"
  }),
  day: gt({
    matchPatterns: iU,
    defaultMatchWidth: "wide",
    parsePatterns: oU,
    defaultParseWidth: "any"
  }),
  dayPeriod: gt({
    matchPatterns: aU,
    defaultMatchWidth: "any",
    parsePatterns: sU,
    defaultParseWidth: "any"
  })
};
const cU = lU;
var uU = {
  code: "sv",
  formatDistance: PH,
  formatLong: LH,
  formatRelative: FH,
  localize: YH,
  match: cU,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const dU = uU, ku = {
  enUS: {
    dateLocale: vF,
    dateFormat: "MM/dd/yyyy"
  },
  enGB: {
    dateLocale: x9,
    dateFormat: "dd/MM/yyyy"
  },
  cs: {
    dateLocale: tz,
    dateFormat: "dd.MM.yyyy"
  },
  de: {
    dateLocale: $z,
    dateFormat: "dd.MM.y"
  },
  el: {
    dateLocale: b9,
    dateFormat: "d/M/yy"
  },
  et: {
    dateLocale: iV,
    dateFormat: "dd.MM.y"
  },
  fi: {
    dateLocale: FV,
    dateFormat: "d.M.y"
  },
  sk: {
    dateLocale: MH,
    dateFormat: "d. M. y"
  },
  sv: {
    dateLocale: dU,
    dateFormat: "y-MM-dd"
  }
};
function ga(e) {
  const n = e.replace("[-_]", "");
  if (Object.prototype.hasOwnProperty.call(ku, n))
    return ku[n];
  const r = n.substring(0, 2);
  return Object.prototype.hasOwnProperty.call(ku, r) ? ku[r] : ku.enUS;
}
function Z5(e, n = "short", r = !0, o = !1) {
  const s = ga(e).dateLocale;
  switch (!0) {
    case (r && o):
      return s.formatLong?.dateTime({ width: n });
    case o:
      return s.formatLong?.time({ width: n });
    default:
      return s.formatLong?.date({ width: n });
  }
}
function s4() {
  const e = tt(n4);
  if (typeof e > "u")
    throw new Error("Use LocaleContext.Provider first");
  return Re(() => ({
    locale: e,
    formatDate: (n, r = "PP") => _s(n, r, { locale: ga(e).dateLocale }),
    date: {
      format: (n, r = "short", o = !0, s = !1) => _s(
        n,
        Z5(e, r, o, s),
        { locale: ga(e).dateLocale }
      ),
      parse: (n, r = "short", o = !0, s = !1) => KD(
        n,
        Z5(e, r, o, s),
        new Date(),
        { locale: ga(e).dateLocale }
      ),
      month: (n) => ga(e).dateLocale.localize?.month(n),
      day: (n) => ga(e).dateLocale.localize?.day(n, { width: "short" })
    },
    dateFormat: ga(e).dateFormat,
    weekStartsOn: ga(e).dateLocale.options?.weekStartsOn ?? 1
  }), [e]);
}
const l4 = typeof document < "u" ? oe.useLayoutEffect : () => {
};
function hU(e) {
  const n = Le(null);
  return l4(() => {
    n.current = e;
  }, [
    e
  ]), et((...r) => {
    const o = n.current;
    return o?.(...r);
  }, []);
}
const nd = (e) => {
  var n;
  return (n = e?.ownerDocument) !== null && n !== void 0 ? n : document;
}, As = (e) => e && "window" in e && e.window === e ? e : nd(e).defaultView || window;
function fU(e) {
  var n;
  return typeof window > "u" || window.navigator == null ? !1 : ((n = window.navigator.userAgentData) === null || n === void 0 ? void 0 : n.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function pU(e) {
  var n;
  return typeof window < "u" && window.navigator != null ? e.test(((n = window.navigator.userAgentData) === null || n === void 0 ? void 0 : n.platform) || window.navigator.platform) : !1;
}
function c4(e) {
  let n = null;
  return () => (n == null && (n = e()), n);
}
const gU = c4(function() {
  return pU(/^Mac/i);
}), mU = c4(function() {
  return fU(/Android/i);
});
function vU(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : mU() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class bU {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(n, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = n;
  }
}
function u4(e) {
  let n = Le({
    isFocused: !1,
    observer: null
  });
  l4(() => {
    const o = n.current;
    return () => {
      o.observer && (o.observer.disconnect(), o.observer = null);
    };
  }, []);
  let r = hU((o) => {
    e?.(o);
  });
  return et((o) => {
    if (o.target instanceof HTMLButtonElement || o.target instanceof HTMLInputElement || o.target instanceof HTMLTextAreaElement || o.target instanceof HTMLSelectElement) {
      n.current.isFocused = !0;
      let s = o.target, u = (h) => {
        n.current.isFocused = !1, s.disabled && r(new bU("blur", h)), n.current.observer && (n.current.observer.disconnect(), n.current.observer = null);
      };
      s.addEventListener("focusout", u, {
        once: !0
      }), n.current.observer = new MutationObserver(() => {
        if (n.current.isFocused && s.disabled) {
          var h;
          (h = n.current.observer) === null || h === void 0 || h.disconnect();
          let f = s === document.activeElement ? null : document.activeElement;
          s.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: f
          })), s.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: f
          }));
        }
      }), n.current.observer.observe(s, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function wU(e) {
  let { isDisabled: n, onFocus: r, onBlur: o, onFocusChange: s } = e;
  const u = et((p) => {
    if (p.target === p.currentTarget)
      return o && o(p), s && s(!1), !0;
  }, [
    o,
    s
  ]), h = u4(u), f = et((p) => {
    const v = nd(p.target);
    p.target === p.currentTarget && v.activeElement === p.target && (r && r(p), s && s(!0), h(p));
  }, [
    s,
    r,
    h
  ]);
  return {
    focusProps: {
      onFocus: !n && (r || s || o) ? f : void 0,
      onBlur: !n && (o || s) ? u : void 0
    }
  };
}
let rd = null, _b = /* @__PURE__ */ new Set(), $u = /* @__PURE__ */ new Map(), Ds = !1, Ab = !1;
const yU = {
  Tab: !0,
  Escape: !0
};
function A1(e, n) {
  for (let r of _b)
    r(e, n);
}
function kU(e) {
  return !(e.metaKey || !gU() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function zf(e) {
  Ds = !0, kU(e) && (rd = "keyboard", A1("keyboard", e));
}
function ii(e) {
  rd = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (Ds = !0, A1("pointer", e));
}
function d4(e) {
  vU(e) && (Ds = !0, rd = "virtual");
}
function h4(e) {
  e.target === window || e.target === document || (!Ds && !Ab && (rd = "virtual", A1("virtual", e)), Ds = !1, Ab = !1);
}
function f4() {
  Ds = !1, Ab = !0;
}
function Cb(e) {
  if (typeof window > "u" || $u.get(As(e)))
    return;
  const n = As(e), r = nd(e);
  let o = n.HTMLElement.prototype.focus;
  n.HTMLElement.prototype.focus = function() {
    Ds = !0, o.apply(this, arguments);
  }, r.addEventListener("keydown", zf, !0), r.addEventListener("keyup", zf, !0), r.addEventListener("click", d4, !0), n.addEventListener("focus", h4, !0), n.addEventListener("blur", f4, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", ii, !0), r.addEventListener("pointermove", ii, !0), r.addEventListener("pointerup", ii, !0)) : (r.addEventListener("mousedown", ii, !0), r.addEventListener("mousemove", ii, !0), r.addEventListener("mouseup", ii, !0)), n.addEventListener("beforeunload", () => {
    p4(e);
  }, {
    once: !0
  }), $u.set(n, {
    focus: o
  });
}
const p4 = (e, n) => {
  const r = As(e), o = nd(e);
  n && o.removeEventListener("DOMContentLoaded", n), $u.has(r) && (r.HTMLElement.prototype.focus = $u.get(r).focus, o.removeEventListener("keydown", zf, !0), o.removeEventListener("keyup", zf, !0), o.removeEventListener("click", d4, !0), r.removeEventListener("focus", h4, !0), r.removeEventListener("blur", f4, !1), typeof PointerEvent < "u" ? (o.removeEventListener("pointerdown", ii, !0), o.removeEventListener("pointermove", ii, !0), o.removeEventListener("pointerup", ii, !0)) : (o.removeEventListener("mousedown", ii, !0), o.removeEventListener("mousemove", ii, !0), o.removeEventListener("mouseup", ii, !0)), $u.delete(r));
};
function _U(e) {
  const n = nd(e);
  let r;
  return n.readyState !== "loading" ? Cb(e) : (r = () => {
    Cb(e);
  }, n.addEventListener("DOMContentLoaded", r)), () => p4(e, r);
}
typeof document < "u" && _U();
function g4() {
  return rd !== "pointer";
}
const AU = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function CU(e, n, r) {
  var o;
  const s = typeof window < "u" ? As(r?.target).HTMLInputElement : HTMLInputElement, u = typeof window < "u" ? As(r?.target).HTMLTextAreaElement : HTMLTextAreaElement, h = typeof window < "u" ? As(r?.target).HTMLElement : HTMLElement, f = typeof window < "u" ? As(r?.target).KeyboardEvent : KeyboardEvent;
  return e = e || r?.target instanceof s && !AU.has(r == null || (o = r.target) === null || o === void 0 ? void 0 : o.type) || r?.target instanceof u || r?.target instanceof h && r?.target.isContentEditable, !(e && n === "keyboard" && r instanceof f && !yU[r.key]);
}
function xU(e, n, r) {
  Cb(), Xe(() => {
    let o = (s, u) => {
      !CU(!!r?.isTextInput, s, u) || e(g4());
    };
    return _b.add(o), () => {
      _b.delete(o);
    };
  }, n);
}
function EU(e) {
  let { isDisabled: n, onBlurWithin: r, onFocusWithin: o, onFocusWithinChange: s } = e, u = Le({
    isFocusWithin: !1
  }), h = et((v) => {
    u.current.isFocusWithin && !v.currentTarget.contains(v.relatedTarget) && (u.current.isFocusWithin = !1, r && r(v), s && s(!1));
  }, [
    r,
    s,
    u
  ]), f = u4(h), p = et((v) => {
    !u.current.isFocusWithin && document.activeElement === v.target && (o && o(v), s && s(!0), u.current.isFocusWithin = !0, f(v));
  }, [
    o,
    s,
    f
  ]);
  return n ? {
    focusWithinProps: {
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: p,
      onBlur: h
    }
  };
}
let Vf = !1, dv = 0;
function xb() {
  Vf = !0, setTimeout(() => {
    Vf = !1;
  }, 50);
}
function X5(e) {
  e.pointerType === "touch" && xb();
}
function SU() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", X5) : document.addEventListener("touchend", xb), dv++, () => {
      dv--, !(dv > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", X5) : document.removeEventListener("touchend", xb));
    };
}
function Yo(e) {
  let { onHoverStart: n, onHoverChange: r, onHoverEnd: o, isDisabled: s } = e, [u, h] = Ve(!1), f = Le({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Xe(SU, []);
  let { hoverProps: p, triggerHoverEnd: v } = Re(() => {
    let b = (_, E) => {
      if (f.pointerType = E, s || E === "touch" || f.isHovered || !_.currentTarget.contains(_.target))
        return;
      f.isHovered = !0;
      let x = _.currentTarget;
      f.target = x, n && n({
        type: "hoverstart",
        target: x,
        pointerType: E
      }), r && r(!0), h(!0);
    }, y = (_, E) => {
      if (f.pointerType = "", f.target = null, E === "touch" || !f.isHovered)
        return;
      f.isHovered = !1;
      let x = _.currentTarget;
      o && o({
        type: "hoverend",
        target: x,
        pointerType: E
      }), r && r(!1), h(!1);
    }, k = {};
    return typeof PointerEvent < "u" ? (k.onPointerEnter = (_) => {
      Vf && _.pointerType === "mouse" || b(_, _.pointerType);
    }, k.onPointerLeave = (_) => {
      !s && _.currentTarget.contains(_.target) && y(_, _.pointerType);
    }) : (k.onTouchStart = () => {
      f.ignoreEmulatedMouseEvents = !0;
    }, k.onMouseEnter = (_) => {
      !f.ignoreEmulatedMouseEvents && !Vf && b(_, "mouse"), f.ignoreEmulatedMouseEvents = !1;
    }, k.onMouseLeave = (_) => {
      !s && _.currentTarget.contains(_.target) && y(_, "mouse");
    }), {
      hoverProps: k,
      triggerHoverEnd: y
    };
  }, [
    n,
    r,
    o,
    s,
    f
  ]);
  return Xe(() => {
    s && v({
      currentTarget: f.target
    }, f.pointerType);
  }, [
    s
  ]), {
    hoverProps: p,
    isHovered: u
  };
}
function wo(e = {}) {
  let { autoFocus: n = !1, isTextInput: r, within: o } = e, s = Le({
    isFocused: !1,
    isFocusVisible: n || g4()
  }), [u, h] = Ve(!1), [f, p] = Ve(() => s.current.isFocused && s.current.isFocusVisible), v = et(() => p(s.current.isFocused && s.current.isFocusVisible), []), b = et((_) => {
    s.current.isFocused = _, h(_), v();
  }, [
    v
  ]);
  xU((_) => {
    s.current.isFocusVisible = _, v();
  }, [], {
    isTextInput: r
  });
  let { focusProps: y } = wU({
    isDisabled: o,
    onFocusChange: b
  }), { focusWithinProps: k } = EU({
    isDisabled: !o,
    onFocusWithinChange: b
  });
  return {
    isFocused: u,
    isFocusVisible: f,
    focusProps: o ? k : y
  };
}
var MU = Object.defineProperty, TU = (e, n, r) => n in e ? MU(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r, hv = (e, n, r) => (TU(e, typeof n != "symbol" ? n + "" : n, r), r);
class DU {
  constructor() {
    hv(this, "current", this.detect()), hv(this, "handoffState", "pending"), hv(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.handoffState = "pending", this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}
let Es = new DU();
function Ni(e) {
  return Es.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function id(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function fi() {
  let e = [], n = { addEventListener(r, o, s, u) {
    return r.addEventListener(o, s, u), n.add(() => r.removeEventListener(o, s, u));
  }, requestAnimationFrame(...r) {
    let o = requestAnimationFrame(...r);
    return n.add(() => cancelAnimationFrame(o));
  }, nextFrame(...r) {
    return n.requestAnimationFrame(() => n.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let o = setTimeout(...r);
    return n.add(() => clearTimeout(o));
  }, microTask(...r) {
    let o = { current: !0 };
    return id(() => {
      o.current && r[0]();
    }), n.add(() => {
      o.current = !1;
    });
  }, style(r, o, s) {
    let u = r.style.getPropertyValue(o);
    return Object.assign(r.style, { [o]: s }), this.add(() => {
      Object.assign(r.style, { [o]: u });
    });
  }, group(r) {
    let o = fi();
    return r(o), this.add(() => o.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let o = e.indexOf(r);
      if (o >= 0)
        for (let s of e.splice(o, 1))
          s();
    };
  }, dispose() {
    for (let r of e.splice(0))
      r();
  } };
  return n;
}
function Qo() {
  let [e] = Ve(fi);
  return Xe(() => () => e.dispose(), [e]), e;
}
let ct = (e, n) => {
  Es.isServer ? Xe(e, n) : b1(e, n);
};
function hr(e) {
  let n = Le(e);
  return ct(() => {
    n.current = e;
  }, [e]), n;
}
let ye = function(e) {
  let n = hr(e);
  return oe.useCallback((...r) => n.current(...r), [n]);
};
function IU(e) {
  let n = e.width / 2, r = e.height / 2;
  return { top: e.clientY - r, right: e.clientX + n, bottom: e.clientY + r, left: e.clientX - n };
}
function PU(e, n) {
  return !(!e || !n || e.right < n.left || e.left > n.right || e.bottom < n.top || e.top > n.bottom);
}
function Jl({ disabled: e = !1 } = {}) {
  let n = Le(null), [r, o] = Ve(!1), s = Qo(), u = ye(() => {
    n.current = null, o(!1), s.dispose();
  }), h = ye((f) => {
    if (s.dispose(), n.current === null) {
      n.current = f.currentTarget, o(!0);
      {
        let p = Ni(f.currentTarget);
        s.addEventListener(p, "pointerup", u, !1), s.addEventListener(p, "pointermove", (v) => {
          if (n.current) {
            let b = IU(v);
            o(PU(b, n.current.getBoundingClientRect()));
          }
        }, !1), s.addEventListener(p, "pointercancel", u, !1);
      }
    }
  });
  return { pressed: r, pressProps: e ? {} : { onPointerDown: h, onPointerUp: u, onClick: u } };
}
let m4 = _t(void 0);
function Vs() {
  return tt(m4);
}
function OU({
  value: e,
  children: n
}) {
  return oe.createElement(m4.Provider, {
    value: e
  }, n);
}
function Eb(...e) {
  return Array.from(new Set(e.flatMap((n) => typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}
function Nt(e, n, ...r) {
  if (e in n) {
    let s = n[e];
    return typeof s == "function" ? s(...r) : s;
  }
  let o = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((s) => `"${s}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, Nt), o;
}
var gr = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(gr || {}), _a = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(_a || {});
function st() {
  let e = NU();
  return et((n) => RU({ mergeRefs: e, ...n }), [e]);
}
function RU({ ourProps: e, theirProps: n, slot: r, defaultTag: o, features: s, visible: u = !0, name: h, mergeRefs: f }) {
  f = f ?? $U;
  let p = v4(n, e);
  if (u)
    return qh(p, r, o, h, f);
  let v = s ?? 0;
  if (v & 2) {
    let { static: b = !1, ...y } = p;
    if (b)
      return qh(y, r, o, h, f);
  }
  if (v & 1) {
    let { unmount: b = !0, ...y } = p;
    return Nt(b ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return qh({ ...y, hidden: !0, style: { display: "none" } }, r, o, h, f);
    } });
  }
  return qh(p, r, o, h, f);
}
function qh(e, n = {}, r, o, s) {
  let { as: u = r, children: h, refName: f = "ref", ...p } = fv(e, ["unmount", "static"]), v = e.ref !== void 0 ? { [f]: e.ref } : {}, b = typeof h == "function" ? h(n) : h;
  "className" in p && p.className && typeof p.className == "function" && (p.className = p.className(n)), p["aria-labelledby"] && p["aria-labelledby"] === p.id && (p["aria-labelledby"] = void 0);
  let y = {};
  if (n) {
    let k = !1, _ = [];
    for (let [E, x] of Object.entries(n))
      typeof x == "boolean" && (k = !0), x === !0 && _.push(E.replace(/([A-Z])/g, (D) => `-${D.toLowerCase()}`));
    if (k) {
      y["data-headlessui-state"] = _.join(" ");
      for (let E of _)
        y[`data-${E}`] = "";
    }
  }
  if (u === ft && (Object.keys(ya(p)).length > 0 || Object.keys(ya(y)).length > 0))
    if (!Ho(b) || Array.isArray(b) && b.length > 1) {
      if (Object.keys(ya(p)).length > 0)
        throw new Error(['Passing props on "Fragment"!', "", `The current component <${o} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(ya(p)).concat(Object.keys(ya(y))).map((k) => `  - ${k}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((k) => `  - ${k}`).join(`
`)].join(`
`));
    } else {
      let k = b.props, _ = k?.className, E = typeof _ == "function" ? (...I) => Eb(_(...I), p.className) : Eb(_, p.className), x = E ? { className: E } : {}, D = v4(b.props, ya(fv(p, ["ref"])));
      for (let I in y)
        I in D && delete y[I];
      return cr(b, Object.assign({}, D, y, v, { ref: s(LU(b), v.ref) }, x));
    }
  return hi(u, Object.assign({}, fv(p, ["ref"]), u !== ft && v, u !== ft && y), b);
}
function NU() {
  let e = Le([]), n = et((r) => {
    for (let o of e.current)
      o != null && (typeof o == "function" ? o(r) : o.current = r);
  }, []);
  return (...r) => {
    if (!r.every((o) => o == null))
      return e.current = r, n;
  };
}
function $U(...e) {
  return e.every((n) => n == null) ? void 0 : (n) => {
    for (let r of e)
      r != null && (typeof r == "function" ? r(n) : r.current = n);
  };
}
function v4(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, r = {};
  for (let o of e)
    for (let s in o)
      s.startsWith("on") && typeof o[s] == "function" ? (r[s] != null || (r[s] = []), r[s].push(o[s])) : n[s] = o[s];
  if (n.disabled || n["aria-disabled"])
    for (let o in r)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(o) && (r[o] = [(s) => {
        var u;
        return (u = s?.preventDefault) == null ? void 0 : u.call(s);
      }]);
  for (let o in r)
    Object.assign(n, { [o](s, ...u) {
      let h = r[o];
      for (let f of h) {
        if ((s instanceof Event || s?.nativeEvent instanceof Event) && s.defaultPrevented)
          return;
        f(s, ...u);
      }
    } });
  return n;
}
function kr(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, r = {};
  for (let o of e)
    for (let s in o)
      s.startsWith("on") && typeof o[s] == "function" ? (r[s] != null || (r[s] = []), r[s].push(o[s])) : n[s] = o[s];
  for (let o in r)
    Object.assign(n, { [o](...s) {
      let u = r[o];
      for (let h of u)
        h?.(...s);
    } });
  return n;
}
function nt(e) {
  var n;
  return Object.assign(zs(e), { displayName: (n = e.displayName) != null ? n : e.name });
}
function ya(e) {
  let n = Object.assign({}, e);
  for (let r in n)
    n[r] === void 0 && delete n[r];
  return n;
}
function fv(e, n = []) {
  let r = Object.assign({}, e);
  for (let o of n)
    o in r && delete r[o];
  return r;
}
function LU(e) {
  return oe.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
function C1(e, n, r) {
  let [o, s] = Ve(r), u = e !== void 0, h = Le(u), f = Le(!1), p = Le(!1);
  return u && !h.current && !f.current ? (f.current = !0, h.current = u, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !u && h.current && !p.current && (p.current = !0, h.current = u, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [u ? e : o, ye((v) => (u || s(v), n?.(v)))];
}
function x1(e) {
  let [n] = Ve(e);
  return n;
}
function b4(e = {}, n = null, r = []) {
  for (let [o, s] of Object.entries(e))
    y4(r, w4(n, o), s);
  return r;
}
function w4(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function y4(e, n, r) {
  if (Array.isArray(r))
    for (let [o, s] of r.entries())
      y4(e, w4(n, o.toString()), s);
  else
    r instanceof Date ? e.push([n, r.toISOString()]) : typeof r == "boolean" ? e.push([n, r ? "1" : "0"]) : typeof r == "string" ? e.push([n, r]) : typeof r == "number" ? e.push([n, `${r}`]) : r == null ? e.push([n, ""]) : b4(r, n, e);
}
function k4(e) {
  var n, r;
  let o = (n = e?.form) != null ? n : e.closest("form");
  if (o) {
    for (let s of o.elements)
      if (s !== e && (s.tagName === "INPUT" && s.type === "submit" || s.tagName === "BUTTON" && s.type === "submit" || s.nodeName === "INPUT" && s.type === "image")) {
        s.click();
        return;
      }
    (r = o.requestSubmit) == null || r.call(o);
  }
}
let jU = "span";
var Ii = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ii || {});
function BU(e, n) {
  var r;
  let { features: o = 1, ...s } = e, u = { ref: n, "aria-hidden": (o & 2) === 2 ? !0 : (r = s["aria-hidden"]) != null ? r : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
  return st()({ ourProps: u, theirProps: s, slot: {}, defaultTag: jU, name: "Hidden" });
}
let Pi = nt(BU), _4 = _t(null);
function FU(e) {
  let [n, r] = Ve(null);
  return oe.createElement(_4.Provider, {
    value: {
      target: n
    }
  }, e.children, oe.createElement(Pi, {
    features: Ii.Hidden,
    ref: r
  }));
}
function zU({
  children: e
}) {
  let n = tt(_4);
  if (!n)
    return oe.createElement(oe.Fragment, null, e);
  let {
    target: r
  } = n;
  return r ? JD(oe.createElement(oe.Fragment, null, e), r) : null;
}
function E1({
  data: e,
  form: n,
  disabled: r,
  onReset: o,
  overrides: s
}) {
  let [u, h] = Ve(null), f = Qo();
  return Xe(() => {
    if (o && u)
      return f.addEventListener(u, "reset", o);
  }, [u, n, o]), oe.createElement(zU, null, /* @__PURE__ */ M(VU, {
    setForm: h,
    formId: n
  }), b4(e).map(([p, v]) => oe.createElement(Pi, {
    features: Ii.Hidden,
    ...ya({
      key: p,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: n,
      disabled: r,
      name: p,
      value: v,
      ...s
    })
  })));
}
function VU({
  setForm: e,
  formId: n
}) {
  return Xe(() => {
    if (n) {
      let r = document.getElementById(n);
      r && e(r);
    }
  }, [e, n]), n ? null : oe.createElement(Pi, {
    features: Ii.Hidden,
    as: "input",
    type: "hidden",
    hidden: !0,
    readOnly: !0,
    ref: (r) => {
      if (!r)
        return;
      let o = r.closest("form");
      o && e(o);
    }
  });
}
let A4 = _t(void 0);
function eg() {
  return tt(A4);
}
function HU({
  id: e,
  children: n
}) {
  return oe.createElement(A4.Provider, {
    value: e
  }, n);
}
function $a(e) {
  let n = e.parentElement, r = null;
  for (; n && !(n instanceof HTMLFieldSetElement); )
    n instanceof HTMLLegendElement && (r = n), n = n.parentElement;
  let o = n?.getAttribute("disabled") === "";
  return o && UU(r) ? !1 : o;
}
function UU(e) {
  if (!e)
    return !1;
  let n = e.previousElementSibling;
  for (; n !== null; ) {
    if (n instanceof HTMLLegendElement)
      return !1;
    n = n.previousElementSibling;
  }
  return !0;
}
let C4 = Symbol();
function S1(e, n = !0) {
  return Object.assign(e, { [C4]: n });
}
function vt(...e) {
  let n = Le(e);
  Xe(() => {
    n.current = e;
  }, [e]);
  let r = ye((o) => {
    for (let s of n.current)
      s != null && (typeof s == "function" ? s(o) : s.current = o);
  });
  return e.every((o) => o == null || o?.[C4]) ? void 0 : r;
}
let tg = _t(null);
tg.displayName = "DescriptionContext";
function x4() {
  let e = tt(tg);
  if (e === null) {
    let n = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, x4), n;
  }
  return e;
}
function M1() {
  var e, n;
  return (n = (e = tt(tg)) == null ? void 0 : e.value) != null ? n : void 0;
}
function ec() {
  let [e, n] = Ve([]);
  return [e.length > 0 ? e.join(" ") : void 0, Re(() => function(r) {
    let o = ye((u) => (n((h) => [...h, u]), () => n((h) => {
      let f = h.slice(), p = f.indexOf(u);
      return p !== -1 && f.splice(p, 1), f;
    }))), s = Re(() => ({ register: o, slot: r.slot, name: r.name, props: r.props, value: r.value }), [o, r.slot, r.name, r.props, r.value]);
    return oe.createElement(tg.Provider, { value: s }, r.children);
  }, [n])];
}
let WU = "p";
function GU(e, n) {
  let r = Et(), o = Vs(), { id: s = `headlessui-description-${r}`, ...u } = e, h = x4(), f = vt(n);
  ct(() => h.register(s), [s, h.register]);
  let p = o || !1, v = Re(() => ({ ...h.slot, disabled: p }), [h.slot, p]), b = { ref: f, ...h.props, id: s };
  return st()({ ourProps: b, theirProps: u, slot: v, defaultTag: WU, name: h.name || "Description" });
}
let qU = nt(GU), T1 = Object.assign(qU, {});
var ze = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ze || {});
let ng = _t(null);
ng.displayName = "LabelContext";
function D1() {
  let e = tt(ng);
  if (e === null) {
    let n = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, D1), n;
  }
  return e;
}
function tc(e) {
  var n, r, o;
  let s = (r = (n = tt(ng)) == null ? void 0 : n.value) != null ? r : void 0;
  return ((o = e?.length) != null ? o : 0) > 0 ? [s, ...e].filter(Boolean).join(" ") : s;
}
function Hs({ inherit: e = !1 } = {}) {
  let n = tc(), [r, o] = Ve([]), s = e ? [n, ...r].filter(Boolean) : r;
  return [s.length > 0 ? s.join(" ") : void 0, Re(() => function(u) {
    let h = ye((p) => (o((v) => [...v, p]), () => o((v) => {
      let b = v.slice(), y = b.indexOf(p);
      return y !== -1 && b.splice(y, 1), b;
    }))), f = Re(() => ({ register: h, slot: u.slot, name: u.name, props: u.props, value: u.value }), [h, u.slot, u.name, u.props, u.value]);
    return oe.createElement(ng.Provider, { value: f }, u.children);
  }, [o])];
}
let KU = "label";
function YU(e, n) {
  var r;
  let o = Et(), s = D1(), u = eg(), h = Vs(), { id: f = `headlessui-label-${o}`, htmlFor: p = u ?? ((r = s.props) == null ? void 0 : r.htmlFor), passive: v = !1, ...b } = e, y = vt(n);
  ct(() => s.register(f), [f, s.register]);
  let k = ye((D) => {
    let I = D.currentTarget;
    if (I instanceof HTMLLabelElement && D.preventDefault(), s.props && "onClick" in s.props && typeof s.props.onClick == "function" && s.props.onClick(D), I instanceof HTMLLabelElement) {
      let N = document.getElementById(I.htmlFor);
      if (N) {
        let O = N.getAttribute("disabled");
        if (O === "true" || O === "")
          return;
        let P = N.getAttribute("aria-disabled");
        if (P === "true" || P === "")
          return;
        (N instanceof HTMLInputElement && (N.type === "radio" || N.type === "checkbox") || N.role === "radio" || N.role === "checkbox" || N.role === "switch") && N.click(), N.focus({ preventScroll: !0 });
      }
    }
  }), _ = h || !1, E = Re(() => ({ ...s.slot, disabled: _ }), [s.slot, _]), x = { ref: y, ...s.props, id: f, htmlFor: p, onClick: k };
  return v && ("onClick" in x && (delete x.htmlFor, delete x.onClick), "onClick" in b && delete b.onClick), st()({ ourProps: x, theirProps: b, slot: E, defaultTag: p ? KU : "div", name: s.name || "Label" });
}
let QU = nt(YU), od = Object.assign(QU, {}), ZU = _t(() => {
});
function I1({ value: e, children: n }) {
  return oe.createElement(ZU.Provider, { value: e }, n);
}
function _u(e, n, r) {
  let o = r.initialDeps ?? [], s;
  return () => {
    var u, h, f, p;
    let v;
    r.key && ((u = r.debug) == null ? void 0 : u.call(r)) && (v = Date.now());
    const b = e();
    if (!(b.length !== o.length || b.some((_, E) => o[E] !== _)))
      return s;
    o = b;
    let k;
    if (r.key && ((h = r.debug) == null ? void 0 : h.call(r)) && (k = Date.now()), s = n(...b), r.key && ((f = r.debug) == null ? void 0 : f.call(r))) {
      const _ = Math.round((Date.now() - v) * 100) / 100, E = Math.round((Date.now() - k) * 100) / 100, x = E / 16, D = (I, N) => {
        for (I = String(I); I.length < N; )
          I = " " + I;
        return I;
      };
      console.info(
        `%c\u23F1 ${D(E, 5)} /${D(_, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * x, 120)
        )}deg 100% 31%);`,
        r?.key
      );
    }
    return (p = r?.onChange) == null || p.call(r, s), s;
  };
}
function pv(e, n) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${n ? `: ${n}` : ""}`);
  return e;
}
const XU = (e, n) => Math.abs(e - n) < 1, JU = (e, n, r) => {
  let o;
  return function(...s) {
    e.clearTimeout(o), o = e.setTimeout(() => n.apply(this, s), r);
  };
}, eW = (e) => e, tW = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), o = [];
  for (let s = n; s <= r; s++)
    o.push(s);
  return o;
}, nW = (e, n) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  const s = (h) => {
    const { width: f, height: p } = h;
    n({ width: Math.round(f), height: Math.round(p) });
  };
  if (s(r.getBoundingClientRect()), !o.ResizeObserver)
    return () => {
    };
  const u = new o.ResizeObserver((h) => {
    const f = h[0];
    if (f?.borderBoxSize) {
      const p = f.borderBoxSize[0];
      if (p) {
        s({ width: p.inlineSize, height: p.blockSize });
        return;
      }
    }
    s(r.getBoundingClientRect());
  });
  return u.observe(r, { box: "border-box" }), () => {
    u.unobserve(r);
  };
}, J5 = {
  passive: !0
}, rW = typeof window > "u" ? !0 : "onscrollend" in window, iW = (e, n) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const o = e.targetWindow;
  if (!o)
    return;
  let s = 0;
  const u = rW ? () => {
  } : JU(
    o,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), h = (v) => () => {
    const { horizontal: b, isRtl: y } = e.options;
    s = b ? r.scrollLeft * (y && -1 || 1) : r.scrollTop, u(), n(s, v);
  }, f = h(!0), p = h(!1);
  return p(), r.addEventListener("scroll", f, J5), r.addEventListener("scrollend", p, J5), () => {
    r.removeEventListener("scroll", f), r.removeEventListener("scrollend", p);
  };
}, oW = (e, n, r) => {
  if (n?.borderBoxSize) {
    const o = n.borderBoxSize[0];
    if (o)
      return Math.round(
        o[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, aW = (e, {
  adjustments: n = 0,
  behavior: r
}, o) => {
  var s, u;
  const h = e + n;
  (u = (s = o.scrollElement) == null ? void 0 : s.scrollTo) == null || u.call(s, {
    [o.options.horizontal ? "left" : "top"]: h,
    behavior: r
  });
};
class sW {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const o = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((u) => {
          this._measureElement(u.target, u);
        });
      }));
      return {
        disconnect: () => {
          var s;
          return (s = o()) == null ? void 0 : s.disconnect();
        },
        observe: (s) => {
          var u;
          return (u = o()) == null ? void 0 : u.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var u;
          return (u = o()) == null ? void 0 : u.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([o, s]) => {
        typeof s > "u" && delete r[o];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: eW,
        rangeExtractor: tW,
        onChange: () => {
        },
        measureElement: oW,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...r
      };
    }, this.notify = (r, o) => {
      var s, u;
      const { startIndex: h, endIndex: f } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, p = this.calculateRange();
      (r || h !== p?.startIndex || f !== p?.endIndex) && ((u = (s = this.options).onChange) == null || u.call(s, this, o));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const o = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== o) {
        if (this.cleanup(), !o) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = o, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, u) => {
            this.scrollAdjustments = 0, this.scrollDirection = u ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s;
            const h = this.isScrolling;
            this.isScrolling = u, this.notify(h !== u, u);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, o) => {
      const s = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
      for (let h = o - 1; h >= 0; h--) {
        const f = r[h];
        if (s.has(f.lane))
          continue;
        const p = u.get(
          f.lane
        );
        if (p == null || f.end > p.end ? u.set(f.lane, f) : f.end < p.end && s.set(f.lane, !0), s.size === this.options.lanes)
          break;
      }
      return u.size === this.options.lanes ? Array.from(u.values()).sort((h, f) => h.end === f.end ? h.index - f.index : h.end - f.end)[0] : void 0;
    }, this.getMeasurementOptions = _u(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, o, s, u, h) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: o,
        scrollMargin: s,
        getItemKey: u,
        enabled: h
      }),
      {
        key: !1
      }
    ), this.getMeasurements = _u(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: o, scrollMargin: s, getItemKey: u, enabled: h }, f) => {
        var p;
        if (!h)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((y) => {
          this.itemSizeCache.set(y.key, y.size);
        }));
        const v = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const b = this.measurementsCache.slice(0, v);
        for (let y = v; y < r; y++) {
          let k = (p = this.measurementsCache[y]) == null ? void 0 : p.measureElement;
          k || (k = (P) => {
            const S = u(y), $ = this.elementsCache.get(S);
            if (!P) {
              $ && (this.observer.unobserve($), this.elementsCache.delete(S));
              return;
            }
            $ !== P && ($ && this.observer.unobserve($), this.observer.observe(P), this.elementsCache.set(S, P)), P.isConnected && this.resizeItem(
              y,
              this.options.measureElement(P, void 0, this)
            );
          });
          const _ = u(y), E = this.options.lanes === 1 ? b[y - 1] : this.getFurthestMeasurement(b, y), x = E ? E.end + this.options.gap : o + s, D = f.get(_), I = typeof D == "number" ? D : this.options.estimateSize(y), N = x + I, O = E ? E.lane : y % this.options.lanes;
          b[y] = {
            index: y,
            start: x,
            size: I,
            end: N,
            key: _,
            lane: O,
            measureElement: k
          };
        }
        return this.measurementsCache = b, b;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = _u(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (r, o, s) => this.range = r.length > 0 && o > 0 ? lW({
        measurements: r,
        outerSize: o,
        scrollOffset: s
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = _u(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, o, s, u) => o === null ? [] : r({
        startIndex: o.startIndex,
        endIndex: o.endIndex,
        overscan: s,
        count: u
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const o = this.options.indexAttribute, s = r.getAttribute(o);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${o}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, o) => {
      const s = this.indexFromElement(r), u = this.getMeasurements()[s];
      if (!u || !r.isConnected) {
        this.elementsCache.forEach((f, p) => {
          f === r && (this.observer.unobserve(r), this.elementsCache.delete(p));
        });
        return;
      }
      const h = this.elementsCache.get(u.key);
      h !== r && (h && this.observer.unobserve(h), this.observer.observe(r), this.elementsCache.set(u.key, r)), this.resizeItem(s, this.options.measureElement(r, o, this));
    }, this.resizeItem = (r, o) => {
      const s = this.getMeasurements()[r];
      if (!s)
        return;
      const u = this.itemSizeCache.get(s.key) ?? s.size, h = o - u;
      h !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, h, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", h), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += h,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, o)), this.notify(!0, !1));
    }, this.measureElement = (r) => {
      !r || this._measureElement(r, void 0);
    }, this.getVirtualItems = _u(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, o) => {
        const s = [];
        for (let u = 0, h = r.length; u < h; u++) {
          const f = r[u], p = o[f];
          s.push(p);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const o = this.getMeasurements();
      if (o.length !== 0)
        return pv(
          o[E4(
            0,
            o.length - 1,
            (s) => pv(o[s]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, o) => {
      const s = this.getSize(), u = this.getScrollOffset();
      o === "auto" && (r <= u ? o = "start" : r >= u + s ? o = "end" : o = "start"), o === "start" ? r = r : o === "end" ? r = r - s : o === "center" && (r = r - s / 2);
      const h = this.options.horizontal ? "scrollWidth" : "scrollHeight", p = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[h] : this.scrollElement[h] : 0) - s;
      return Math.max(Math.min(p, r), 0);
    }, this.getOffsetForIndex = (r, o = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const s = this.getMeasurements()[r];
      if (!s)
        return;
      const u = this.getSize(), h = this.getScrollOffset();
      if (o === "auto")
        if (s.end >= h + u - this.options.scrollPaddingEnd)
          o = "end";
        else if (s.start <= h + this.options.scrollPaddingStart)
          o = "start";
        else
          return [h, o];
      const f = o === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(f, o), o];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: o = "start", behavior: s } = {}) => {
      this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, o), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (r, { align: o = "auto", behavior: s } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const u = this.getOffsetForIndex(r, o);
      if (!u)
        return;
      const [h, f] = u;
      this._scrollToOffset(h, { adjustments: void 0, behavior: s }), s !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [v] = pv(
            this.getOffsetForIndex(r, f)
          );
          XU(v, this.getScrollOffset()) || this.scrollToIndex(r, { align: f, behavior: s });
        } else
          this.scrollToIndex(r, { align: f, behavior: s });
      }));
    }, this.scrollBy = (r, { behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: o
      });
    }, this.getTotalSize = () => {
      var r;
      const o = this.getMeasurements();
      let s;
      return o.length === 0 ? s = this.options.paddingStart : s = this.options.lanes === 1 ? ((r = o[o.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...o.slice(-this.options.lanes).map((u) => u.end)
      ), s - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (r, {
      adjustments: o,
      behavior: s
    }) => {
      this.options.scrollToFn(r, { behavior: s, adjustments: o }, this);
    }, this.measure = () => {
      var r, o;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (o = (r = this.options).onChange) == null || o.call(r, this, !1);
    }, this.setOptions(n);
  }
}
const E4 = (e, n, r, o) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, u = r(s);
    if (u < o)
      e = s + 1;
    else if (u > o)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function lW({
  measurements: e,
  outerSize: n,
  scrollOffset: r
}) {
  const o = e.length - 1, u = E4(0, o, (f) => e[f].start, r);
  let h = u;
  for (; h < o && e[h].end < r + n; )
    h++;
  return { startIndex: u, endIndex: h };
}
const cW = typeof document < "u" ? ne.useLayoutEffect : ne.useEffect;
function uW(e) {
  const n = ne.useReducer(() => ({}), {})[1], r = {
    ...e,
    onChange: (s, u) => {
      var h;
      u ? oi(n) : n(), (h = e.onChange) == null || h.call(e, s, u);
    }
  }, [o] = ne.useState(
    () => new sW(r)
  );
  return o.setOptions(r), ne.useEffect(() => o._didMount(), []), cW(() => o._willUpdate()), o;
}
function dW(e) {
  return uW({
    observeElementRect: nW,
    observeElementOffset: iW,
    scrollToFn: aW,
    ...e
  });
}
function hW(e, n) {
  return e !== null && n !== null && typeof e == "object" && typeof n == "object" && "id" in e && "id" in n ? e.id === n.id : e === n;
}
function S4(e = hW) {
  return et((n, r) => {
    if (typeof e == "string") {
      let o = e;
      return n?.[o] === r?.[o];
    }
    return e(n, r);
  }, [e]);
}
function fW(e) {
  if (e === null)
    return { width: 0, height: 0 };
  let { width: n, height: r } = e.getBoundingClientRect();
  return { width: n, height: r };
}
function Hf(e, n = !1) {
  let [r, o] = Ri(() => ({}), {}), s = Re(() => fW(e), [e, r]);
  return ct(() => {
    if (!e)
      return;
    let u = new ResizeObserver(o);
    return u.observe(e), () => {
      u.disconnect();
    };
  }, [e]), n ? { width: `${s.width}px`, height: `${s.height}px` } : s;
}
class pW extends Map {
  constructor(n) {
    super(), this.factory = n;
  }
  get(n) {
    let r = super.get(n);
    return r === void 0 && (r = this.factory(n), this.set(n, r)), r;
  }
}
function M4(e, n) {
  let r = e(), o = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(s) {
    return o.add(s), () => o.delete(s);
  }, dispatch(s, ...u) {
    let h = n[s].call(r, ...u);
    h && (r = h, o.forEach((f) => f()));
  } };
}
function T4(e) {
  return h8(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let gW = new pW(() => M4(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let n = this.indexOf(e);
  if (n === -1)
    return this;
  let r = this.slice();
  return r.splice(n, 1), r;
} }));
function nc(e, n) {
  let r = gW.get(n), o = Et(), s = T4(r);
  if (ct(() => {
    if (e)
      return r.dispatch("ADD", o), () => r.dispatch("REMOVE", o);
  }, [r, e]), !e)
    return !1;
  let u = s.indexOf(o), h = s.length;
  return u === -1 && (u = h, h += 1), u === h - 1;
}
let Sb = /* @__PURE__ */ new Map(), Lu = /* @__PURE__ */ new Map();
function eE(e) {
  var n;
  let r = (n = Lu.get(e)) != null ? n : 0;
  return Lu.set(e, r + 1), r !== 0 ? () => tE(e) : (Sb.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => tE(e));
}
function tE(e) {
  var n;
  let r = (n = Lu.get(e)) != null ? n : 1;
  if (r === 1 ? Lu.delete(e) : Lu.set(e, r - 1), r !== 1)
    return;
  let o = Sb.get(e);
  o && (o["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", o["aria-hidden"]), e.inert = o.inert, Sb.delete(e));
}
function P1(e, { allowed: n, disallowed: r } = {}) {
  let o = nc(e, "inert-others");
  ct(() => {
    var s, u;
    if (!o)
      return;
    let h = fi();
    for (let p of (s = r?.()) != null ? s : [])
      p && h.add(eE(p));
    let f = (u = n?.()) != null ? u : [];
    for (let p of f) {
      if (!p)
        continue;
      let v = Ni(p);
      if (!v)
        continue;
      let b = p.parentElement;
      for (; b && b !== v.body; ) {
        for (let y of b.children)
          f.some((k) => y.contains(k)) || h.add(eE(y));
        b = b.parentElement;
      }
    }
    return h.dispose;
  }, [o, n, r]);
}
function rg(e, n, r) {
  let o = hr((s) => {
    let u = s.getBoundingClientRect();
    u.x === 0 && u.y === 0 && u.width === 0 && u.height === 0 && r();
  });
  Xe(() => {
    if (!e)
      return;
    let s = n === null ? null : n instanceof HTMLElement ? n : n.current;
    if (!s)
      return;
    let u = fi();
    if (typeof ResizeObserver < "u") {
      let h = new ResizeObserver(() => o.current(s));
      h.observe(s), u.add(() => h.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let h = new IntersectionObserver(() => o.current(s));
      h.observe(s), u.add(() => h.disconnect());
    }
    return () => u.dispose();
  }, [n, o, e]);
}
let Uf = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), mW = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Pt = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(Pt || {}), si = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(si || {}), vW = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(vW || {});
function ad(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Uf)).sort((n, r) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function bW(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(mW)).sort((n, r) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var ig = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(ig || {});
function og(e, n = 0) {
  var r;
  return e === ((r = Ni(e)) == null ? void 0 : r.body) ? !1 : Nt(n, { [0]() {
    return e.matches(Uf);
  }, [1]() {
    let o = e;
    for (; o !== null; ) {
      if (o.matches(Uf))
        return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
function D4(e) {
  let n = Ni(e);
  fi().nextFrame(() => {
    n && !og(n.activeElement, 0) && ho(e);
  });
}
var wW = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(wW || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function ho(e) {
  e?.focus({ preventScroll: !0 });
}
let yW = ["textarea", "input"].join(",");
function kW(e) {
  var n, r;
  return (r = (n = e?.matches) == null ? void 0 : n.call(e, yW)) != null ? r : !1;
}
function Bo(e, n = (r) => r) {
  return e.slice().sort((r, o) => {
    let s = n(r), u = n(o);
    if (s === null || u === null)
      return 0;
    let h = s.compareDocumentPosition(u);
    return h & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : h & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function _W(e, n) {
  return $n(ad(), n, { relativeTo: e });
}
function $n(e, n, { sorted: r = !0, relativeTo: o = null, skipElements: s = [] } = {}) {
  let u = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, h = Array.isArray(e) ? r ? Bo(e) : e : n & 64 ? bW(e) : ad(e);
  s.length > 0 && h.length > 1 && (h = h.filter((_) => !s.some((E) => E != null && "current" in E ? E?.current === _ : E === _))), o = o ?? u.activeElement;
  let f = (() => {
    if (n & 5)
      return 1;
    if (n & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p = (() => {
    if (n & 1)
      return 0;
    if (n & 2)
      return Math.max(0, h.indexOf(o)) - 1;
    if (n & 4)
      return Math.max(0, h.indexOf(o)) + 1;
    if (n & 8)
      return h.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), v = n & 32 ? { preventScroll: !0 } : {}, b = 0, y = h.length, k;
  do {
    if (b >= y || b + y <= 0)
      return 0;
    let _ = p + b;
    if (n & 16)
      _ = (_ + y) % y;
    else {
      if (_ < 0)
        return 3;
      if (_ >= y)
        return 1;
    }
    k = h[_], k?.focus(v), b += f;
  } while (k !== u.activeElement);
  return n & 6 && kW(k) && k.select(), 2;
}
function I4() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function AW() {
  return /Android/gi.test(window.navigator.userAgent);
}
function P4() {
  return I4() || AW();
}
function Au(e, n, r, o) {
  let s = hr(r);
  Xe(() => {
    if (!e)
      return;
    function u(h) {
      s.current(h);
    }
    return document.addEventListener(n, u, o), () => document.removeEventListener(n, u, o);
  }, [e, n, o]);
}
function O4(e, n, r, o) {
  let s = hr(r);
  Xe(() => {
    if (!e)
      return;
    function u(h) {
      s.current(h);
    }
    return window.addEventListener(n, u, o), () => window.removeEventListener(n, u, o);
  }, [e, n, o]);
}
const nE = 30;
function ag(e, n, r) {
  let o = nc(e, "outside-click"), s = hr(r), u = et(function(p, v) {
    if (p.defaultPrevented)
      return;
    let b = v(p);
    if (b === null || !b.getRootNode().contains(b) || !b.isConnected)
      return;
    let y = function k(_) {
      return typeof _ == "function" ? k(_()) : Array.isArray(_) || _ instanceof Set ? _ : [_];
    }(n);
    for (let k of y)
      if (k !== null && (k.contains(b) || p.composed && p.composedPath().includes(k)))
        return;
    return !og(b, ig.Loose) && b.tabIndex !== -1 && p.preventDefault(), s.current(p, b);
  }, [s, n]), h = Le(null);
  Au(o, "pointerdown", (p) => {
    var v, b;
    h.current = ((b = (v = p.composedPath) == null ? void 0 : v.call(p)) == null ? void 0 : b[0]) || p.target;
  }, !0), Au(o, "mousedown", (p) => {
    var v, b;
    h.current = ((b = (v = p.composedPath) == null ? void 0 : v.call(p)) == null ? void 0 : b[0]) || p.target;
  }, !0), Au(o, "click", (p) => {
    P4() || h.current && (u(p, () => h.current), h.current = null);
  }, !0);
  let f = Le({ x: 0, y: 0 });
  Au(o, "touchstart", (p) => {
    f.current.x = p.touches[0].clientX, f.current.y = p.touches[0].clientY;
  }, !0), Au(o, "touchend", (p) => {
    let v = { x: p.changedTouches[0].clientX, y: p.changedTouches[0].clientY };
    if (!(Math.abs(v.x - f.current.x) >= nE || Math.abs(v.y - f.current.y) >= nE))
      return u(p, () => p.target instanceof HTMLElement ? p.target : null);
  }, !0), O4(o, "blur", (p) => u(p, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function $i(...e) {
  return Re(() => Ni(...e), [...e]);
}
function sg(e, n, r, o) {
  let s = hr(r);
  Xe(() => {
    e = e ?? window;
    function u(h) {
      s.current(h);
    }
    return e.addEventListener(n, u, o), () => e.removeEventListener(n, u, o);
  }, [e, n, o]);
}
function R4(e) {
  let n = Le({ value: "", selectionStart: null, selectionEnd: null });
  return sg(e, "blur", (r) => {
    let o = r.target;
    o instanceof HTMLInputElement && (n.current = { value: o.value, selectionStart: o.selectionStart, selectionEnd: o.selectionEnd });
  }), ye(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== n.current.value)
        e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: r, selectionEnd: o } = n.current;
        r !== null && o !== null && e.setSelectionRange(r, o);
      }
      n.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function rc(e, n) {
  return Re(() => {
    var r;
    if (e.type)
      return e.type;
    let o = (r = e.as) != null ? r : "button";
    if (typeof o == "string" && o.toLowerCase() === "button" || n?.tagName === "BUTTON" && !n.hasAttribute("type"))
      return "button";
  }, [e.type, e.as, n]);
}
function CW() {
  let e;
  return { before({ doc: n }) {
    var r;
    let o = n.documentElement, s = (r = n.defaultView) != null ? r : window;
    e = Math.max(0, s.innerWidth - o.clientWidth);
  }, after({ doc: n, d: r }) {
    let o = n.documentElement, s = Math.max(0, o.clientWidth - o.offsetWidth), u = Math.max(0, e - s);
    r.style(o, "paddingRight", `${u}px`);
  } };
}
function xW() {
  return I4() ? { before({ doc: e, d: n, meta: r }) {
    function o(s) {
      return r.containers.flatMap((u) => u()).some((u) => u.contains(s));
    }
    n.microTask(() => {
      var s;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let f = fi();
        f.style(e.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => f.dispose()));
      }
      let u = (s = window.scrollY) != null ? s : window.pageYOffset, h = null;
      n.addEventListener(e, "click", (f) => {
        if (f.target instanceof HTMLElement)
          try {
            let p = f.target.closest("a");
            if (!p)
              return;
            let { hash: v } = new URL(p.href), b = e.querySelector(v);
            b && !o(b) && (h = b);
          } catch {
          }
      }, !0), n.addEventListener(e, "touchstart", (f) => {
        if (f.target instanceof HTMLElement)
          if (o(f.target)) {
            let p = f.target;
            for (; p.parentElement && o(p.parentElement); )
              p = p.parentElement;
            n.style(p, "overscrollBehavior", "contain");
          } else
            n.style(f.target, "touchAction", "none");
      }), n.addEventListener(e, "touchmove", (f) => {
        if (f.target instanceof HTMLElement) {
          if (f.target.tagName === "INPUT")
            return;
          if (o(f.target)) {
            let p = f.target;
            for (; p.parentElement && p.dataset.headlessuiPortal !== "" && !(p.scrollHeight > p.clientHeight || p.scrollWidth > p.clientWidth); )
              p = p.parentElement;
            p.dataset.headlessuiPortal === "" && f.preventDefault();
          } else
            f.preventDefault();
        }
      }, { passive: !1 }), n.add(() => {
        var f;
        let p = (f = window.scrollY) != null ? f : window.pageYOffset;
        u !== p && window.scrollTo(0, u), h && h.isConnected && (h.scrollIntoView({ block: "nearest" }), h = null);
      });
    });
  } } : {};
}
function EW() {
  return { before({ doc: e, d: n }) {
    n.style(e.documentElement, "overflow", "hidden");
  } };
}
function SW(e) {
  let n = {};
  for (let r of e)
    Object.assign(n, r(n));
  return n;
}
let Cs = M4(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var r;
  let o = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: fi(), meta: /* @__PURE__ */ new Set() };
  return o.count++, o.meta.add(n), this.set(e, o), this;
}, POP(e, n) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: r }) {
  let o = { doc: e, d: n, meta: SW(r) }, s = [xW(), CW(), EW()];
  s.forEach(({ before: u }) => u?.(o)), s.forEach(({ after: u }) => u?.(o));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Cs.subscribe(() => {
  let e = Cs.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [r] of e)
    n.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let o = n.get(r.doc) === "hidden", s = r.count !== 0;
    (s && !o || !s && o) && Cs.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Cs.dispatch("TEARDOWN", r);
  }
});
function MW(e, n, r = () => ({ containers: [] })) {
  let o = T4(Cs), s = n ? o.get(n) : void 0, u = s ? s.count > 0 : !1;
  return ct(() => {
    if (!(!n || !e))
      return Cs.dispatch("PUSH", n, r), () => Cs.dispatch("POP", n, r);
  }, [e, n]), u;
}
function lg(e, n, r = () => [document.body]) {
  let o = nc(e, "scroll-lock");
  MW(o, n, (s) => {
    var u;
    return { containers: [...(u = s.containers) != null ? u : [], r] };
  });
}
function rE(e) {
  return [e.screenX, e.screenY];
}
function N4() {
  let e = Le([-1, -1]);
  return { wasMoved(n) {
    let r = rE(n);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(n) {
    e.current = rE(n);
  } };
}
function TW(e = 0) {
  let [n, r] = Ve(e), o = et((p) => r(p), [n]), s = et((p) => r((v) => v | p), [n]), u = et((p) => (n & p) === p, [n]), h = et((p) => r((v) => v & ~p), [r]), f = et((p) => r((v) => v ^ p), [r]);
  return { flags: n, setFlag: o, addFlag: s, hasFlag: u, removeFlag: h, toggleFlag: f };
}
var iE, oE;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((iE = process == null ? void 0 : process.env) == null ? void 0 : iE.NODE_ENV) === "test" && typeof ((oE = Element?.prototype) == null ? void 0 : oE.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var DW = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(DW || {});
function ic(e) {
  let n = {};
  for (let r in e)
    e[r] === !0 && (n[`data-${r}`] = "");
  return n;
}
function oc(e, n, r, o) {
  let [s, u] = Ve(r), { hasFlag: h, addFlag: f, removeFlag: p } = TW(e && s ? 3 : 0), v = Le(!1), b = Le(!1), y = Qo();
  return ct(() => {
    var k;
    if (e) {
      if (r && u(!0), !n) {
        r && f(3);
        return;
      }
      return (k = o?.start) == null || k.call(o, r), IW(n, { inFlight: v, prepare() {
        b.current ? b.current = !1 : b.current = v.current, v.current = !0, !b.current && (r ? (f(3), p(4)) : (f(4), p(2)));
      }, run() {
        b.current ? r ? (p(3), f(4)) : (p(4), f(3)) : r ? p(1) : f(1);
      }, done() {
        var _;
        b.current && typeof n.getAnimations == "function" && n.getAnimations().length > 0 || (v.current = !1, p(7), r || u(!1), (_ = o?.end) == null || _.call(o, r));
      } });
    }
  }, [e, r, n, y]), e ? [s, { closed: h(1), enter: h(2), leave: h(4), transition: h(2) || h(4) }] : [r, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function IW(e, { prepare: n, run: r, done: o, inFlight: s }) {
  let u = fi();
  return OW(e, { prepare: n, inFlight: s }), u.nextFrame(() => {
    r(), u.requestAnimationFrame(() => {
      u.add(PW(e, o));
    });
  }), u.dispose;
}
function PW(e, n) {
  var r, o;
  let s = fi();
  if (!e)
    return s.dispose;
  let u = !1;
  s.add(() => {
    u = !0;
  });
  let h = (o = (r = e.getAnimations) == null ? void 0 : r.call(e).filter((f) => f instanceof CSSTransition)) != null ? o : [];
  return h.length === 0 ? (n(), s.dispose) : (Promise.allSettled(h.map((f) => f.finished)).then(() => {
    u || n();
  }), s.dispose);
}
function OW(e, { inFlight: n, prepare: r }) {
  if (n != null && n.current) {
    r();
    return;
  }
  let o = e.style.transition;
  e.style.transition = "none", r(), e.offsetHeight, e.style.transition = o;
}
function $4(e, { container: n, accept: r, walk: o }) {
  let s = Le(r), u = Le(o);
  Xe(() => {
    s.current = r, u.current = o;
  }, [r, o]), ct(() => {
    if (!n || !e)
      return;
    let h = Ni(n);
    if (!h)
      return;
    let f = s.current, p = u.current, v = Object.assign((y) => f(y), { acceptNode: f }), b = h.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, v, !1);
    for (; b.nextNode(); )
      p(b.currentNode);
  }, [n, e, s, u]);
}
function Hu(e, n) {
  let r = Le([]), o = ye(e);
  Xe(() => {
    let s = [...r.current];
    for (let [u, h] of n.entries())
      if (r.current[u] !== h) {
        let f = o(n, s);
        return r.current = n, f;
      }
  }, [o, ...n]);
}
function ac(e) {
  return L4(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function zr(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Zo(e) {
  var n;
  return (n = (L4(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function L4(e) {
  return e instanceof Node || e instanceof zr(e).Node;
}
function fr(e) {
  return e instanceof Element || e instanceof zr(e).Element;
}
function go(e) {
  return e instanceof HTMLElement || e instanceof zr(e).HTMLElement;
}
function aE(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof zr(e).ShadowRoot;
}
function sd(e) {
  const {
    overflow: n,
    overflowX: r,
    overflowY: o,
    display: s
  } = Oi(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + o + r) && !["inline", "contents"].includes(s);
}
function RW(e) {
  return ["table", "td", "th"].includes(ac(e));
}
function cg(e) {
  return [":popover-open", ":modal"].some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function O1(e) {
  const n = R1(), r = fr(e) ? Oi(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !n && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !n && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (r.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (r.contain || "").includes(o));
}
function NW(e) {
  let n = Ma(e);
  for (; go(n) && !Hl(n); ) {
    if (O1(n))
      return n;
    if (cg(n))
      return null;
    n = Ma(n);
  }
  return null;
}
function R1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Hl(e) {
  return ["html", "body", "#document"].includes(ac(e));
}
function Oi(e) {
  return zr(e).getComputedStyle(e);
}
function ug(e) {
  return fr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ma(e) {
  if (ac(e) === "html")
    return e;
  const n = e.assignedSlot || e.parentNode || aE(e) && e.host || Zo(e);
  return aE(n) ? n.host : n;
}
function j4(e) {
  const n = Ma(e);
  return Hl(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : go(n) && sd(n) ? n : j4(n);
}
function Uu(e, n, r) {
  var o;
  n === void 0 && (n = []), r === void 0 && (r = !0);
  const s = j4(e), u = s === ((o = e.ownerDocument) == null ? void 0 : o.body), h = zr(s);
  if (u) {
    const f = Mb(h);
    return n.concat(h, h.visualViewport || [], sd(s) ? s : [], f && r ? Uu(f) : []);
  }
  return n.concat(s, Uu(s, [], r));
}
function Mb(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function $W() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((n) => {
    let {
      brand: r,
      version: o
    } = n;
    return r + "/" + o;
  }).join(" ") : navigator.userAgent;
}
const Aa = Math.min, Lr = Math.max, Wf = Math.round, Kh = Math.floor, Ta = (e) => ({
  x: e,
  y: e
}), LW = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, jW = {
  start: "end",
  end: "start"
};
function sE(e, n, r) {
  return Lr(e, Aa(n, r));
}
function sc(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Da(e) {
  return e.split("-")[0];
}
function ld(e) {
  return e.split("-")[1];
}
function B4(e) {
  return e === "x" ? "y" : "x";
}
function F4(e) {
  return e === "y" ? "height" : "width";
}
function Is(e) {
  return ["top", "bottom"].includes(Da(e)) ? "y" : "x";
}
function z4(e) {
  return B4(Is(e));
}
function BW(e, n, r) {
  r === void 0 && (r = !1);
  const o = ld(e), s = z4(e), u = F4(s);
  let h = s === "x" ? o === (r ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return n.reference[u] > n.floating[u] && (h = Gf(h)), [h, Gf(h)];
}
function FW(e) {
  const n = Gf(e);
  return [Tb(e), n, Tb(n)];
}
function Tb(e) {
  return e.replace(/start|end/g, (n) => jW[n]);
}
function zW(e, n, r) {
  const o = ["left", "right"], s = ["right", "left"], u = ["top", "bottom"], h = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? n ? s : o : n ? o : s;
    case "left":
    case "right":
      return n ? u : h;
    default:
      return [];
  }
}
function VW(e, n, r, o) {
  const s = ld(e);
  let u = zW(Da(e), r === "start", o);
  return s && (u = u.map((h) => h + "-" + s), n && (u = u.concat(u.map(Tb)))), u;
}
function Gf(e) {
  return e.replace(/left|right|bottom|top/g, (n) => LW[n]);
}
function HW(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function UW(e) {
  return typeof e != "number" ? HW(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function qf(e) {
  const {
    x: n,
    y: r,
    width: o,
    height: s
  } = e;
  return {
    width: o,
    height: s,
    top: r,
    left: n,
    right: n + o,
    bottom: r + s,
    x: n,
    y: r
  };
}
function lE(e, n, r) {
  let {
    reference: o,
    floating: s
  } = e;
  const u = Is(n), h = z4(n), f = F4(h), p = Da(n), v = u === "y", b = o.x + o.width / 2 - s.width / 2, y = o.y + o.height / 2 - s.height / 2, k = o[f] / 2 - s[f] / 2;
  let _;
  switch (p) {
    case "top":
      _ = {
        x: b,
        y: o.y - s.height
      };
      break;
    case "bottom":
      _ = {
        x: b,
        y: o.y + o.height
      };
      break;
    case "right":
      _ = {
        x: o.x + o.width,
        y
      };
      break;
    case "left":
      _ = {
        x: o.x - s.width,
        y
      };
      break;
    default:
      _ = {
        x: o.x,
        y: o.y
      };
  }
  switch (ld(n)) {
    case "start":
      _[h] -= k * (r && v ? -1 : 1);
      break;
    case "end":
      _[h] += k * (r && v ? -1 : 1);
      break;
  }
  return _;
}
const WW = async (e, n, r) => {
  const {
    placement: o = "bottom",
    strategy: s = "absolute",
    middleware: u = [],
    platform: h
  } = r, f = u.filter(Boolean), p = await (h.isRTL == null ? void 0 : h.isRTL(n));
  let v = await h.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: b,
    y
  } = lE(v, o, p), k = o, _ = {}, E = 0;
  for (let x = 0; x < f.length; x++) {
    const {
      name: D,
      fn: I
    } = f[x], {
      x: N,
      y: O,
      data: P,
      reset: S
    } = await I({
      x: b,
      y,
      initialPlacement: o,
      placement: k,
      strategy: s,
      middlewareData: _,
      rects: v,
      platform: h,
      elements: {
        reference: e,
        floating: n
      }
    });
    b = N ?? b, y = O ?? y, _ = {
      ..._,
      [D]: {
        ..._[D],
        ...P
      }
    }, S && E <= 50 && (E++, typeof S == "object" && (S.placement && (k = S.placement), S.rects && (v = S.rects === !0 ? await h.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : S.rects), {
      x: b,
      y
    } = lE(v, k, p)), x = -1);
  }
  return {
    x: b,
    y,
    placement: k,
    strategy: s,
    middlewareData: _
  };
};
async function dg(e, n) {
  var r;
  n === void 0 && (n = {});
  const {
    x: o,
    y: s,
    platform: u,
    rects: h,
    elements: f,
    strategy: p
  } = e, {
    boundary: v = "clippingAncestors",
    rootBoundary: b = "viewport",
    elementContext: y = "floating",
    altBoundary: k = !1,
    padding: _ = 0
  } = sc(n, e), E = UW(_), D = f[k ? y === "floating" ? "reference" : "floating" : y], I = qf(await u.getClippingRect({
    element: (r = await (u.isElement == null ? void 0 : u.isElement(D))) == null || r ? D : D.contextElement || await (u.getDocumentElement == null ? void 0 : u.getDocumentElement(f.floating)),
    boundary: v,
    rootBoundary: b,
    strategy: p
  })), N = y === "floating" ? {
    x: o,
    y: s,
    width: h.floating.width,
    height: h.floating.height
  } : h.reference, O = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(f.floating)), P = await (u.isElement == null ? void 0 : u.isElement(O)) ? await (u.getScale == null ? void 0 : u.getScale(O)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = qf(u.convertOffsetParentRelativeRectToViewportRelativeRect ? await u.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: f,
    rect: N,
    offsetParent: O,
    strategy: p
  }) : N);
  return {
    top: (I.top - S.top + E.top) / P.y,
    bottom: (S.bottom - I.bottom + E.bottom) / P.y,
    left: (I.left - S.left + E.left) / P.x,
    right: (S.right - I.right + E.right) / P.x
  };
}
const GW = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var r, o;
      const {
        placement: s,
        middlewareData: u,
        rects: h,
        initialPlacement: f,
        platform: p,
        elements: v
      } = n, {
        mainAxis: b = !0,
        crossAxis: y = !0,
        fallbackPlacements: k,
        fallbackStrategy: _ = "bestFit",
        fallbackAxisSideDirection: E = "none",
        flipAlignment: x = !0,
        ...D
      } = sc(e, n);
      if ((r = u.arrow) != null && r.alignmentOffset)
        return {};
      const I = Da(s), N = Is(f), O = Da(f) === f, P = await (p.isRTL == null ? void 0 : p.isRTL(v.floating)), S = k || (O || !x ? [Gf(f)] : FW(f)), $ = E !== "none";
      !k && $ && S.push(...VW(f, x, E, P));
      const L = [f, ...S], B = await dg(n, D), U = [];
      let G = ((o = u.flip) == null ? void 0 : o.overflows) || [];
      if (b && U.push(B[I]), y) {
        const Z = BW(s, h, P);
        U.push(B[Z[0]], B[Z[1]]);
      }
      if (G = [...G, {
        placement: s,
        overflows: U
      }], !U.every((Z) => Z <= 0)) {
        var q, Y;
        const Z = (((q = u.flip) == null ? void 0 : q.index) || 0) + 1, ae = L[Z];
        if (ae)
          return {
            data: {
              index: Z,
              overflows: G
            },
            reset: {
              placement: ae
            }
          };
        let ie = (Y = G.filter((pe) => pe.overflows[0] <= 0).sort((pe, ce) => pe.overflows[1] - ce.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!ie)
          switch (_) {
            case "bestFit": {
              var Q;
              const pe = (Q = G.filter((ce) => {
                if ($) {
                  const ue = Is(ce.placement);
                  return ue === N || ue === "y";
                }
                return !0;
              }).map((ce) => [ce.placement, ce.overflows.filter((ue) => ue > 0).reduce((ue, X) => ue + X, 0)]).sort((ce, ue) => ce[1] - ue[1])[0]) == null ? void 0 : Q[0];
              pe && (ie = pe);
              break;
            }
            case "initialPlacement":
              ie = f;
              break;
          }
        if (s !== ie)
          return {
            reset: {
              placement: ie
            }
          };
      }
      return {};
    }
  };
};
async function qW(e, n) {
  const {
    placement: r,
    platform: o,
    elements: s
  } = e, u = await (o.isRTL == null ? void 0 : o.isRTL(s.floating)), h = Da(r), f = ld(r), p = Is(r) === "y", v = ["left", "top"].includes(h) ? -1 : 1, b = u && p ? -1 : 1, y = sc(n, e);
  let {
    mainAxis: k,
    crossAxis: _,
    alignmentAxis: E
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...y
  };
  return f && typeof E == "number" && (_ = f === "end" ? E * -1 : E), p ? {
    x: _ * b,
    y: k * v
  } : {
    x: k * v,
    y: _ * b
  };
}
const KW = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var r, o;
      const {
        x: s,
        y: u,
        placement: h,
        middlewareData: f
      } = n, p = await qW(n, e);
      return h === ((r = f.offset) == null ? void 0 : r.placement) && (o = f.arrow) != null && o.alignmentOffset ? {} : {
        x: s + p.x,
        y: u + p.y,
        data: {
          ...p,
          placement: h
        }
      };
    }
  };
}, YW = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: r,
        y: o,
        placement: s
      } = n, {
        mainAxis: u = !0,
        crossAxis: h = !1,
        limiter: f = {
          fn: (D) => {
            let {
              x: I,
              y: N
            } = D;
            return {
              x: I,
              y: N
            };
          }
        },
        ...p
      } = sc(e, n), v = {
        x: r,
        y: o
      }, b = await dg(n, p), y = Is(Da(s)), k = B4(y);
      let _ = v[k], E = v[y];
      if (u) {
        const D = k === "y" ? "top" : "left", I = k === "y" ? "bottom" : "right", N = _ + b[D], O = _ - b[I];
        _ = sE(N, _, O);
      }
      if (h) {
        const D = y === "y" ? "top" : "left", I = y === "y" ? "bottom" : "right", N = E + b[D], O = E - b[I];
        E = sE(N, E, O);
      }
      const x = f.fn({
        ...n,
        [k]: _,
        [y]: E
      });
      return {
        ...x,
        data: {
          x: x.x - r,
          y: x.y - o
        }
      };
    }
  };
};
const QW = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      const {
        placement: r,
        rects: o,
        platform: s,
        elements: u
      } = n, {
        apply: h = () => {
        },
        ...f
      } = sc(e, n), p = await dg(n, f), v = Da(r), b = ld(r), y = Is(r) === "y", {
        width: k,
        height: _
      } = o.floating;
      let E, x;
      v === "top" || v === "bottom" ? (E = v, x = b === (await (s.isRTL == null ? void 0 : s.isRTL(u.floating)) ? "start" : "end") ? "left" : "right") : (x = v, E = b === "end" ? "top" : "bottom");
      const D = _ - p.top - p.bottom, I = k - p.left - p.right, N = Aa(_ - p[E], D), O = Aa(k - p[x], I), P = !n.middlewareData.shift;
      let S = N, $ = O;
      if (y ? $ = b || P ? Aa(O, I) : I : S = b || P ? Aa(N, D) : D, P && !b) {
        const B = Lr(p.left, 0), U = Lr(p.right, 0), G = Lr(p.top, 0), q = Lr(p.bottom, 0);
        y ? $ = k - 2 * (B !== 0 || U !== 0 ? B + U : Lr(p.left, p.right)) : S = _ - 2 * (G !== 0 || q !== 0 ? G + q : Lr(p.top, p.bottom));
      }
      await h({
        ...n,
        availableWidth: $,
        availableHeight: S
      });
      const L = await s.getDimensions(u.floating);
      return k !== L.width || _ !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function V4(e) {
  const n = Oi(e);
  let r = parseFloat(n.width) || 0, o = parseFloat(n.height) || 0;
  const s = go(e), u = s ? e.offsetWidth : r, h = s ? e.offsetHeight : o, f = Wf(r) !== u || Wf(o) !== h;
  return f && (r = u, o = h), {
    width: r,
    height: o,
    $: f
  };
}
function N1(e) {
  return fr(e) ? e : e.contextElement;
}
function jl(e) {
  const n = N1(e);
  if (!go(n))
    return Ta(1);
  const r = n.getBoundingClientRect(), {
    width: o,
    height: s,
    $: u
  } = V4(n);
  let h = (u ? Wf(r.width) : r.width) / o, f = (u ? Wf(r.height) : r.height) / s;
  return (!h || !Number.isFinite(h)) && (h = 1), (!f || !Number.isFinite(f)) && (f = 1), {
    x: h,
    y: f
  };
}
const ZW = /* @__PURE__ */ Ta(0);
function H4(e) {
  const n = zr(e);
  return !R1() || !n.visualViewport ? ZW : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function XW(e, n, r) {
  return n === void 0 && (n = !1), !r || n && r !== zr(e) ? !1 : n;
}
function Ps(e, n, r, o) {
  n === void 0 && (n = !1), r === void 0 && (r = !1);
  const s = e.getBoundingClientRect(), u = N1(e);
  let h = Ta(1);
  n && (o ? fr(o) && (h = jl(o)) : h = jl(e));
  const f = XW(u, r, o) ? H4(u) : Ta(0);
  let p = (s.left + f.x) / h.x, v = (s.top + f.y) / h.y, b = s.width / h.x, y = s.height / h.y;
  if (u) {
    const k = zr(u), _ = o && fr(o) ? zr(o) : o;
    let E = k, x = Mb(E);
    for (; x && o && _ !== E; ) {
      const D = jl(x), I = x.getBoundingClientRect(), N = Oi(x), O = I.left + (x.clientLeft + parseFloat(N.paddingLeft)) * D.x, P = I.top + (x.clientTop + parseFloat(N.paddingTop)) * D.y;
      p *= D.x, v *= D.y, b *= D.x, y *= D.y, p += O, v += P, E = zr(x), x = Mb(E);
    }
  }
  return qf({
    width: b,
    height: y,
    x: p,
    y: v
  });
}
function JW(e) {
  let {
    elements: n,
    rect: r,
    offsetParent: o,
    strategy: s
  } = e;
  const u = s === "fixed", h = Zo(o), f = n ? cg(n.floating) : !1;
  if (o === h || f && u)
    return r;
  let p = {
    scrollLeft: 0,
    scrollTop: 0
  }, v = Ta(1);
  const b = Ta(0), y = go(o);
  if ((y || !y && !u) && ((ac(o) !== "body" || sd(h)) && (p = ug(o)), go(o))) {
    const k = Ps(o);
    v = jl(o), b.x = k.x + o.clientLeft, b.y = k.y + o.clientTop;
  }
  return {
    width: r.width * v.x,
    height: r.height * v.y,
    x: r.x * v.x - p.scrollLeft * v.x + b.x,
    y: r.y * v.y - p.scrollTop * v.y + b.y
  };
}
function eG(e) {
  return Array.from(e.getClientRects());
}
function U4(e) {
  return Ps(Zo(e)).left + ug(e).scrollLeft;
}
function tG(e) {
  const n = Zo(e), r = ug(e), o = e.ownerDocument.body, s = Lr(n.scrollWidth, n.clientWidth, o.scrollWidth, o.clientWidth), u = Lr(n.scrollHeight, n.clientHeight, o.scrollHeight, o.clientHeight);
  let h = -r.scrollLeft + U4(e);
  const f = -r.scrollTop;
  return Oi(o).direction === "rtl" && (h += Lr(n.clientWidth, o.clientWidth) - s), {
    width: s,
    height: u,
    x: h,
    y: f
  };
}
function nG(e, n) {
  const r = zr(e), o = Zo(e), s = r.visualViewport;
  let u = o.clientWidth, h = o.clientHeight, f = 0, p = 0;
  if (s) {
    u = s.width, h = s.height;
    const v = R1();
    (!v || v && n === "fixed") && (f = s.offsetLeft, p = s.offsetTop);
  }
  return {
    width: u,
    height: h,
    x: f,
    y: p
  };
}
function rG(e, n) {
  const r = Ps(e, !0, n === "fixed"), o = r.top + e.clientTop, s = r.left + e.clientLeft, u = go(e) ? jl(e) : Ta(1), h = e.clientWidth * u.x, f = e.clientHeight * u.y, p = s * u.x, v = o * u.y;
  return {
    width: h,
    height: f,
    x: p,
    y: v
  };
}
function cE(e, n, r) {
  let o;
  if (n === "viewport")
    o = nG(e, r);
  else if (n === "document")
    o = tG(Zo(e));
  else if (fr(n))
    o = rG(n, r);
  else {
    const s = H4(e);
    o = {
      ...n,
      x: n.x - s.x,
      y: n.y - s.y
    };
  }
  return qf(o);
}
function W4(e, n) {
  const r = Ma(e);
  return r === n || !fr(r) || Hl(r) ? !1 : Oi(r).position === "fixed" || W4(r, n);
}
function iG(e, n) {
  const r = n.get(e);
  if (r)
    return r;
  let o = Uu(e, [], !1).filter((f) => fr(f) && ac(f) !== "body"), s = null;
  const u = Oi(e).position === "fixed";
  let h = u ? Ma(e) : e;
  for (; fr(h) && !Hl(h); ) {
    const f = Oi(h), p = O1(h);
    !p && f.position === "fixed" && (s = null), (u ? !p && !s : !p && f.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || sd(h) && !p && W4(e, h)) ? o = o.filter((b) => b !== h) : s = f, h = Ma(h);
  }
  return n.set(e, o), o;
}
function oG(e) {
  let {
    element: n,
    boundary: r,
    rootBoundary: o,
    strategy: s
  } = e;
  const h = [...r === "clippingAncestors" ? cg(n) ? [] : iG(n, this._c) : [].concat(r), o], f = h[0], p = h.reduce((v, b) => {
    const y = cE(n, b, s);
    return v.top = Lr(y.top, v.top), v.right = Aa(y.right, v.right), v.bottom = Aa(y.bottom, v.bottom), v.left = Lr(y.left, v.left), v;
  }, cE(n, f, s));
  return {
    width: p.right - p.left,
    height: p.bottom - p.top,
    x: p.left,
    y: p.top
  };
}
function aG(e) {
  const {
    width: n,
    height: r
  } = V4(e);
  return {
    width: n,
    height: r
  };
}
function sG(e, n, r) {
  const o = go(n), s = Zo(n), u = r === "fixed", h = Ps(e, !0, u, n);
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const p = Ta(0);
  if (o || !o && !u)
    if ((ac(n) !== "body" || sd(s)) && (f = ug(n)), o) {
      const y = Ps(n, !0, u, n);
      p.x = y.x + n.clientLeft, p.y = y.y + n.clientTop;
    } else
      s && (p.x = U4(s));
  const v = h.left + f.scrollLeft - p.x, b = h.top + f.scrollTop - p.y;
  return {
    x: v,
    y: b,
    width: h.width,
    height: h.height
  };
}
function gv(e) {
  return Oi(e).position === "static";
}
function uE(e, n) {
  return !go(e) || Oi(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function G4(e, n) {
  const r = zr(e);
  if (cg(e))
    return r;
  if (!go(e)) {
    let s = Ma(e);
    for (; s && !Hl(s); ) {
      if (fr(s) && !gv(s))
        return s;
      s = Ma(s);
    }
    return r;
  }
  let o = uE(e, n);
  for (; o && RW(o) && gv(o); )
    o = uE(o, n);
  return o && Hl(o) && gv(o) && !O1(o) ? r : o || NW(e) || r;
}
const lG = async function(e) {
  const n = this.getOffsetParent || G4, r = this.getDimensions, o = await r(e.floating);
  return {
    reference: sG(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function cG(e) {
  return Oi(e).direction === "rtl";
}
const uG = {
  convertOffsetParentRelativeRectToViewportRelativeRect: JW,
  getDocumentElement: Zo,
  getClippingRect: oG,
  getOffsetParent: G4,
  getElementRects: lG,
  getClientRects: eG,
  getDimensions: aG,
  getScale: jl,
  isElement: fr,
  isRTL: cG
};
function dG(e, n) {
  let r = null, o;
  const s = Zo(e);
  function u() {
    var f;
    clearTimeout(o), (f = r) == null || f.disconnect(), r = null;
  }
  function h(f, p) {
    f === void 0 && (f = !1), p === void 0 && (p = 1), u();
    const {
      left: v,
      top: b,
      width: y,
      height: k
    } = e.getBoundingClientRect();
    if (f || n(), !y || !k)
      return;
    const _ = Kh(b), E = Kh(s.clientWidth - (v + y)), x = Kh(s.clientHeight - (b + k)), D = Kh(v), N = {
      rootMargin: -_ + "px " + -E + "px " + -x + "px " + -D + "px",
      threshold: Lr(0, Aa(1, p)) || 1
    };
    let O = !0;
    function P(S) {
      const $ = S[0].intersectionRatio;
      if ($ !== p) {
        if (!O)
          return h();
        $ ? h(!1, $) : o = setTimeout(() => {
          h(!1, 1e-7);
        }, 1e3);
      }
      O = !1;
    }
    try {
      r = new IntersectionObserver(P, {
        ...N,
        root: s.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(P, N);
    }
    r.observe(e);
  }
  return h(!0), u;
}
function hG(e, n, r, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: u = !0,
    elementResize: h = typeof ResizeObserver == "function",
    layoutShift: f = typeof IntersectionObserver == "function",
    animationFrame: p = !1
  } = o, v = N1(e), b = s || u ? [...v ? Uu(v) : [], ...Uu(n)] : [];
  b.forEach((I) => {
    s && I.addEventListener("scroll", r, {
      passive: !0
    }), u && I.addEventListener("resize", r);
  });
  const y = v && f ? dG(v, r) : null;
  let k = -1, _ = null;
  h && (_ = new ResizeObserver((I) => {
    let [N] = I;
    N && N.target === v && _ && (_.unobserve(n), cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      var O;
      (O = _) == null || O.observe(n);
    })), r();
  }), v && !p && _.observe(v), _.observe(n));
  let E, x = p ? Ps(e) : null;
  p && D();
  function D() {
    const I = Ps(e);
    x && (I.x !== x.x || I.y !== x.y || I.width !== x.width || I.height !== x.height) && r(), x = I, E = requestAnimationFrame(D);
  }
  return r(), () => {
    var I;
    b.forEach((N) => {
      s && N.removeEventListener("scroll", r), u && N.removeEventListener("resize", r);
    }), y?.(), (I = _) == null || I.disconnect(), _ = null, p && cancelAnimationFrame(E);
  };
}
const mv = dg, fG = KW, pG = YW, gG = GW, mG = QW, vG = (e, n, r) => {
  const o = /* @__PURE__ */ new Map(), s = {
    platform: uG,
    ...r
  }, u = {
    ...s.platform,
    _c: o
  };
  return WW(e, n, {
    ...s,
    platform: u
  });
};
var ff = typeof document < "u" ? b1 : Xe;
function Kf(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let r, o, s;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== n.length)
        return !1;
      for (o = r; o-- !== 0; )
        if (!Kf(e[o], n[o]))
          return !1;
      return !0;
    }
    if (s = Object.keys(e), r = s.length, r !== Object.keys(n).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!{}.hasOwnProperty.call(n, s[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      const u = s[o];
      if (!(u === "_owner" && e.$$typeof) && !Kf(e[u], n[u]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function q4(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dE(e, n) {
  const r = q4(e);
  return Math.round(n * r) / r;
}
function hE(e) {
  const n = ne.useRef(e);
  return ff(() => {
    n.current = e;
  }), n;
}
function bG(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: s,
    elements: {
      reference: u,
      floating: h
    } = {},
    transform: f = !0,
    whileElementsMounted: p,
    open: v
  } = e, [b, y] = ne.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [k, _] = ne.useState(o);
  Kf(k, o) || _(o);
  const [E, x] = ne.useState(null), [D, I] = ne.useState(null), N = ne.useCallback((pe) => {
    pe !== $.current && ($.current = pe, x(pe));
  }, []), O = ne.useCallback((pe) => {
    pe !== L.current && (L.current = pe, I(pe));
  }, []), P = u || E, S = h || D, $ = ne.useRef(null), L = ne.useRef(null), B = ne.useRef(b), U = p != null, G = hE(p), q = hE(s), Y = ne.useCallback(() => {
    if (!$.current || !L.current)
      return;
    const pe = {
      placement: n,
      strategy: r,
      middleware: k
    };
    q.current && (pe.platform = q.current), vG($.current, L.current, pe).then((ce) => {
      const ue = {
        ...ce,
        isPositioned: !0
      };
      Q.current && !Kf(B.current, ue) && (B.current = ue, Vu.flushSync(() => {
        y(ue);
      }));
    });
  }, [k, n, r, q]);
  ff(() => {
    v === !1 && B.current.isPositioned && (B.current.isPositioned = !1, y((pe) => ({
      ...pe,
      isPositioned: !1
    })));
  }, [v]);
  const Q = ne.useRef(!1);
  ff(() => (Q.current = !0, () => {
    Q.current = !1;
  }), []), ff(() => {
    if (P && ($.current = P), S && (L.current = S), P && S) {
      if (G.current)
        return G.current(P, S, Y);
      Y();
    }
  }, [P, S, Y, G, U]);
  const Z = ne.useMemo(() => ({
    reference: $,
    floating: L,
    setReference: N,
    setFloating: O
  }), [N, O]), ae = ne.useMemo(() => ({
    reference: P,
    floating: S
  }), [P, S]), ie = ne.useMemo(() => {
    const pe = {
      position: r,
      left: 0,
      top: 0
    };
    if (!ae.floating)
      return pe;
    const ce = dE(ae.floating, b.x), ue = dE(ae.floating, b.y);
    return f ? {
      ...pe,
      transform: "translate(" + ce + "px, " + ue + "px)",
      ...q4(ae.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: ce,
      top: ue
    };
  }, [r, f, ae.floating, b.x, b.y]);
  return ne.useMemo(() => ({
    ...b,
    update: Y,
    refs: Z,
    elements: ae,
    floatingStyles: ie
  }), [b, Y, Z, ae, ie]);
}
const K4 = (e, n) => ({
  ...fG(e),
  options: [e, n]
}), wG = (e, n) => ({
  ...pG(e),
  options: [e, n]
}), yG = (e, n) => ({
  ...gG(e),
  options: [e, n]
}), kG = (e, n) => ({
  ...mG(e),
  options: [e, n]
}), Y4 = {
  ...ne
}, _G = Y4.useInsertionEffect, AG = _G || ((e) => e());
function Q4(e) {
  const n = ne.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return AG(() => {
    n.current = e;
  }), ne.useCallback(function() {
    for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++)
      o[s] = arguments[s];
    return n.current == null ? void 0 : n.current(...o);
  }, []);
}
var Db = typeof document < "u" ? b1 : Xe;
let fE = !1, CG = 0;
const pE = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + CG++;
function xG() {
  const [e, n] = ne.useState(() => fE ? pE() : void 0);
  return Db(() => {
    e == null && n(pE());
  }, []), ne.useEffect(() => {
    fE = !0;
  }, []), e;
}
const EG = Y4.useId, SG = EG || xG;
let Wu;
process.env.NODE_ENV !== "production" && (Wu = /* @__PURE__ */ new Set());
function MG() {
  for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  const s = "Floating UI: " + r.join(" ");
  if (!((e = Wu) != null && e.has(s))) {
    var u;
    (u = Wu) == null || u.add(s), console.warn(s);
  }
}
function TG() {
  for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  const s = "Floating UI: " + r.join(" ");
  if (!((e = Wu) != null && e.has(s))) {
    var u;
    (u = Wu) == null || u.add(s), console.error(s);
  }
}
function DG() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(n, r) {
      var o;
      (o = e.get(n)) == null || o.forEach((s) => s(r));
    },
    on(n, r) {
      e.set(n, [...e.get(n) || [], r]);
    },
    off(n, r) {
      var o;
      e.set(n, ((o = e.get(n)) == null ? void 0 : o.filter((s) => s !== r)) || []);
    }
  };
}
const IG = /* @__PURE__ */ ne.createContext(null), PG = /* @__PURE__ */ ne.createContext(null), OG = () => {
  var e;
  return ((e = ne.useContext(IG)) == null ? void 0 : e.id) || null;
}, RG = () => ne.useContext(PG);
function NG(e) {
  const {
    open: n = !1,
    onOpenChange: r,
    elements: o
  } = e, s = SG(), u = ne.useRef({}), [h] = ne.useState(() => DG()), f = OG() != null;
  if (process.env.NODE_ENV !== "production") {
    const _ = o.reference;
    _ && !fr(_) && TG("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [p, v] = ne.useState(o.reference), b = Q4((_, E, x) => {
    u.current.openEvent = _ ? E : void 0, h.emit("openchange", {
      open: _,
      event: E,
      reason: x,
      nested: f
    }), r?.(_, E, x);
  }), y = ne.useMemo(() => ({
    setPositionReference: v
  }), []), k = ne.useMemo(() => ({
    reference: p || o.reference || null,
    floating: o.floating || null,
    domReference: o.reference
  }), [p, o.reference, o.floating]);
  return ne.useMemo(() => ({
    dataRef: u,
    open: n,
    onOpenChange: b,
    elements: k,
    events: h,
    floatingId: s,
    refs: y
  }), [n, b, k, h, s, y]);
}
function $G(e) {
  e === void 0 && (e = {});
  const {
    nodeId: n
  } = e, r = NG({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), o = e.rootContext || r, s = o.elements, [u, h] = ne.useState(null), [f, p] = ne.useState(null), b = s?.reference || u, y = ne.useRef(null), k = RG();
  Db(() => {
    b && (y.current = b);
  }, [b]);
  const _ = bG({
    ...e,
    elements: {
      ...s,
      ...f && {
        reference: f
      }
    }
  }), E = ne.useCallback((O) => {
    const P = fr(O) ? {
      getBoundingClientRect: () => O.getBoundingClientRect(),
      contextElement: O
    } : O;
    p(P), _.refs.setReference(P);
  }, [_.refs]), x = ne.useCallback((O) => {
    (fr(O) || O === null) && (y.current = O, h(O)), (fr(_.refs.reference.current) || _.refs.reference.current === null || O !== null && !fr(O)) && _.refs.setReference(O);
  }, [_.refs]), D = ne.useMemo(() => ({
    ..._.refs,
    setReference: x,
    setPositionReference: E,
    domReference: y
  }), [_.refs, x, E]), I = ne.useMemo(() => ({
    ..._.elements,
    domReference: b
  }), [_.elements, b]), N = ne.useMemo(() => ({
    ..._,
    ...o,
    refs: D,
    elements: I,
    nodeId: n
  }), [_, D, I, n, o]);
  return Db(() => {
    o.dataRef.current.floatingContext = N;
    const O = k?.nodesRef.current.find((P) => P.id === n);
    O && (O.context = N);
  }), ne.useMemo(() => ({
    ..._,
    context: N,
    refs: D,
    elements: I
  }), [_, D, I, N]);
}
const gE = "active", mE = "selected";
function vv(e, n, r) {
  const o = /* @__PURE__ */ new Map(), s = r === "item";
  let u = e;
  if (s && e) {
    const {
      [gE]: h,
      [mE]: f,
      ...p
    } = e;
    u = p;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1
    },
    ...u,
    ...n.map((h) => {
      const f = h ? h[r] : null;
      return typeof f == "function" ? e ? f(e) : null : f;
    }).concat(e).reduce((h, f) => (f && Object.entries(f).forEach((p) => {
      let [v, b] = p;
      if (!(s && [gE, mE].includes(v)))
        if (v.indexOf("on") === 0) {
          if (o.has(v) || o.set(v, []), typeof b == "function") {
            var y;
            (y = o.get(v)) == null || y.push(b), h[v] = function() {
              for (var k, _ = arguments.length, E = new Array(_), x = 0; x < _; x++)
                E[x] = arguments[x];
              return (k = o.get(v)) == null ? void 0 : k.map((D) => D(...E)).find((D) => D !== void 0);
            };
          }
        } else
          h[v] = b;
    }), h), {})
  };
}
function LG(e) {
  e === void 0 && (e = []);
  const n = e.map((f) => f?.reference), r = e.map((f) => f?.floating), o = e.map((f) => f?.item), s = ne.useCallback(
    (f) => vv(f, e, "reference"),
    n
  ), u = ne.useCallback(
    (f) => vv(f, e, "floating"),
    r
  ), h = ne.useCallback(
    (f) => vv(f, e, "item"),
    o
  );
  return ne.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: u,
    getItemProps: h
  }), [s, u, h]);
}
function vE(e, n) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: n
      }
    }
  };
}
const jG = (e) => ({
  name: "inner",
  options: e,
  async fn(n) {
    const {
      listRef: r,
      overflowRef: o,
      onFallbackChange: s,
      offset: u = 0,
      index: h = 0,
      minItemsVisible: f = 4,
      referenceOverflowThreshold: p = 0,
      scrollRef: v,
      ...b
    } = sc(e, n), {
      rects: y,
      elements: {
        floating: k
      }
    } = n, _ = r.current[h];
    if (process.env.NODE_ENV !== "production" && (n.placement.startsWith("bottom") || MG('`placement` side must be "bottom" when using the `inner`', "middleware.")), !_)
      return {};
    const E = {
      ...n,
      ...await K4(-_.offsetTop - k.clientTop - y.reference.height / 2 - _.offsetHeight / 2 - u).fn(n)
    }, x = v?.current || k, D = await mv(vE(E, x.scrollHeight), b), I = await mv(E, {
      ...b,
      elementContext: "reference"
    }), N = Math.max(0, D.top), O = E.y + N, P = Math.max(0, x.scrollHeight - N - Math.max(0, D.bottom));
    return x.style.maxHeight = P + "px", x.scrollTop = N, s && (x.offsetHeight < _.offsetHeight * Math.min(f, r.current.length - 1) - 1 || I.top >= -p || I.bottom >= -p ? Vu.flushSync(() => s(!0)) : Vu.flushSync(() => s(!1))), o && (o.current = await mv(vE({
      ...E,
      y: O
    }, x.offsetHeight), b)), {
      y: O
    };
  }
});
function BG(e, n) {
  const {
    open: r,
    elements: o
  } = e, {
    enabled: s = !0,
    overflowRef: u,
    scrollRef: h,
    onChange: f
  } = n, p = Q4(f), v = ne.useRef(!1), b = ne.useRef(null), y = ne.useRef(null);
  ne.useEffect(() => {
    if (!s)
      return;
    function _(x) {
      if (x.ctrlKey || !E || u.current == null)
        return;
      const D = x.deltaY, I = u.current.top >= -0.5, N = u.current.bottom >= -0.5, O = E.scrollHeight - E.clientHeight, P = D < 0 ? -1 : 1, S = D < 0 ? "max" : "min";
      E.scrollHeight <= E.clientHeight || (!I && D > 0 || !N && D < 0 ? (x.preventDefault(), Vu.flushSync(() => {
        p(($) => $ + Math[S](D, O * P));
      })) : /firefox/i.test($W()) && (E.scrollTop += D));
    }
    const E = h?.current || o.floating;
    if (r && E)
      return E.addEventListener("wheel", _), requestAnimationFrame(() => {
        b.current = E.scrollTop, u.current != null && (y.current = {
          ...u.current
        });
      }), () => {
        b.current = null, y.current = null, E.removeEventListener("wheel", _);
      };
  }, [s, r, o.floating, u, h, p]);
  const k = ne.useMemo(() => ({
    onKeyDown() {
      v.current = !0;
    },
    onWheel() {
      v.current = !1;
    },
    onPointerMove() {
      v.current = !1;
    },
    onScroll() {
      const _ = h?.current || o.floating;
      if (!(!u.current || !_ || !v.current)) {
        if (b.current !== null) {
          const E = _.scrollTop - b.current;
          (u.current.bottom < -0.5 && E < -1 || u.current.top < -0.5 && E > 1) && Vu.flushSync(() => p((x) => x + E));
        }
        requestAnimationFrame(() => {
          b.current = _.scrollTop;
        });
      }
    }
  }), [o.floating, p, u, h]);
  return ne.useMemo(() => s ? {
    floating: k
  } : {}, [s, k]);
}
let lc = _t({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
lc.displayName = "FloatingContext";
let $1 = _t(null);
$1.displayName = "PlacementContext";
function L1(e) {
  return Re(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function j1() {
  return tt(lc).setReference;
}
function FG() {
  return tt(lc).getReferenceProps;
}
function B1() {
  let { getFloatingProps: e, slot: n } = tt(lc);
  return et((...r) => Object.assign({}, e(...r), { "data-anchor": n.anchor }), [e, n]);
}
function F1(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let n = tt($1), r = Re(() => e, [JSON.stringify(e, (s, u) => {
    var h;
    return (h = u?.outerHTML) != null ? h : u;
  })]);
  ct(() => {
    n?.(r ?? null);
  }, [n, r]);
  let o = tt(lc);
  return Re(() => [o.setFloating, e ? o.styles : {}], [o.setFloating, e, o.styles]);
}
let bE = 4;
function z1({ children: e, enabled: n = !0 }) {
  let [r, o] = Ve(null), [s, u] = Ve(0), h = Le(null), [f, p] = Ve(null);
  zG(f);
  let v = n && r !== null && f !== null, { to: b = "bottom", gap: y = 0, offset: k = 0, padding: _ = 0, inner: E } = VG(r, f), [x, D = "center"] = b.split(" ");
  ct(() => {
    v && u(0);
  }, [v]);
  let { refs: I, floatingStyles: N, context: O } = $G({ open: v, placement: x === "selection" ? D === "center" ? "bottom" : `bottom-${D}` : D === "center" ? `${x}` : `${x}-${D}`, strategy: "absolute", transform: !1, middleware: [K4({ mainAxis: x === "selection" ? 0 : y, crossAxis: k }), wG({ padding: _ }), x !== "selection" && yG({ padding: _ }), x === "selection" && E ? jG({ ...E, padding: _, overflowRef: h, offset: s, minItemsVisible: bE, referenceOverflowThreshold: _, onFallbackChange(q) {
    var Y, Q;
    if (!q)
      return;
    let Z = O.elements.floating;
    if (!Z)
      return;
    let ae = parseFloat(getComputedStyle(Z).scrollPaddingBottom) || 0, ie = Math.min(bE, Z.childElementCount), pe = 0, ce = 0;
    for (let ue of (Q = (Y = O.elements.floating) == null ? void 0 : Y.childNodes) != null ? Q : [])
      if (ue instanceof HTMLElement) {
        let X = ue.offsetTop, se = X + ue.clientHeight + ae, he = Z.scrollTop, de = he + Z.clientHeight;
        if (X >= he && se <= de)
          ie--;
        else {
          ce = Math.max(0, Math.min(se, de) - Math.max(X, he)), pe = ue.clientHeight;
          break;
        }
      }
    ie >= 1 && u((ue) => {
      let X = pe * ie - ce + ae;
      return ue >= X ? ue : X;
    });
  } }) : null, kG({ padding: _, apply({ availableWidth: q, availableHeight: Y, elements: Q }) {
    Object.assign(Q.floating.style, { overflow: "auto", maxWidth: `${q}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${Y}px)` });
  } })].filter(Boolean), whileElementsMounted: hG }), [P = x, S = D] = O.placement.split("-");
  x === "selection" && (P = "selection");
  let $ = Re(() => ({ anchor: [P, S].filter(Boolean).join(" ") }), [P, S]), L = BG(O, { overflowRef: h, onChange: u }), { getReferenceProps: B, getFloatingProps: U } = LG([L]), G = ye((q) => {
    p(q), I.setFloating(q);
  });
  return ne.createElement($1.Provider, { value: o }, ne.createElement(lc.Provider, { value: { setFloating: G, setReference: I.setReference, styles: N, getReferenceProps: B, getFloatingProps: U, slot: $ } }, e));
}
function zG(e) {
  ct(() => {
    if (!e)
      return;
    let n = new MutationObserver(() => {
      let r = window.getComputedStyle(e).maxHeight, o = parseFloat(r);
      if (isNaN(o))
        return;
      let s = parseInt(r);
      isNaN(s) || o !== s && (e.style.maxHeight = `${Math.ceil(o)}px`);
    });
    return n.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      n.disconnect();
    };
  }, [e]);
}
function VG(e, n) {
  var r, o, s;
  let u = bv((r = e?.gap) != null ? r : "var(--anchor-gap, 0)", n), h = bv((o = e?.offset) != null ? o : "var(--anchor-offset, 0)", n), f = bv((s = e?.padding) != null ? s : "var(--anchor-padding, 0)", n);
  return { ...e, gap: u, offset: h, padding: f };
}
function bv(e, n, r = void 0) {
  let o = Qo(), s = ye((p, v) => {
    if (p == null)
      return [r, null];
    if (typeof p == "number")
      return [p, null];
    if (typeof p == "string") {
      if (!v)
        return [r, null];
      let b = wE(p, v);
      return [b, (y) => {
        let k = Z4(p);
        {
          let _ = k.map((E) => window.getComputedStyle(v).getPropertyValue(E));
          o.requestAnimationFrame(function E() {
            o.nextFrame(E);
            let x = !1;
            for (let [I, N] of k.entries()) {
              let O = window.getComputedStyle(v).getPropertyValue(N);
              if (_[I] !== O) {
                _[I] = O, x = !0;
                break;
              }
            }
            if (!x)
              return;
            let D = wE(p, v);
            b !== D && (y(D), b = D);
          });
        }
        return o.dispose;
      }];
    }
    return [r, null];
  }), u = Re(() => s(e, n)[0], [e, n]), [h = u, f] = Ve();
  return ct(() => {
    let [p, v] = s(e, n);
    if (f(p), !!v)
      return v(f);
  }, [e, n]), h;
}
function Z4(e) {
  let n = /var\((.*)\)/.exec(e);
  if (n) {
    let r = n[1].indexOf(",");
    if (r === -1)
      return [n[1]];
    let o = n[1].slice(0, r).trim(), s = n[1].slice(r + 1).trim();
    return s ? [o, ...Z4(s)] : [o];
  }
  return [];
}
function wE(e, n) {
  let r = document.createElement("div");
  n.appendChild(r), r.style.setProperty("margin-top", "0px", "important"), r.style.setProperty("margin-top", e, "important");
  let o = parseFloat(window.getComputedStyle(r).marginTop) || 0;
  return n.removeChild(r), o;
}
function HG({
  children: e,
  freeze: n
}) {
  let r = Ib(n, e);
  return oe.createElement(oe.Fragment, null, r);
}
function Ib(e, n) {
  let [r, o] = Ve(n);
  return !e && r !== n && o(n), e ? r : n;
}
let hg = _t(null);
hg.displayName = "OpenClosedContext";
var Qt = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Qt || {});
function Xo() {
  return tt(hg);
}
function cd({
  value: e,
  children: n
}) {
  return oe.createElement(hg.Provider, {
    value: e
  }, n);
}
function V1({
  children: e
}) {
  return oe.createElement(hg.Provider, {
    value: null
  }, e);
}
function UG(e) {
  function n() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", n));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", n), n());
}
let lo = [];
UG(() => {
  function e(n) {
    if (!(n.target instanceof HTMLElement) || n.target === document.body || lo[0] === n.target)
      return;
    let r = n.target;
    r = r.closest(Uf), lo.unshift(r ?? n.target), lo = lo.filter((o) => o != null && o.isConnected), lo.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function WG(e) {
  throw new Error("Unexpected object: " + e);
}
var xt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(xt || {});
function ju(e, n) {
  let r = n.resolveItems();
  if (r.length <= 0)
    return null;
  let o = n.resolveActiveIndex(), s = o ?? -1;
  switch (e.focus) {
    case 0: {
      for (let u = 0; u < r.length; ++u)
        if (!n.resolveDisabled(r[u], u, r))
          return u;
      return o;
    }
    case 1: {
      s === -1 && (s = r.length);
      for (let u = s - 1; u >= 0; --u)
        if (!n.resolveDisabled(r[u], u, r))
          return u;
      return o;
    }
    case 2: {
      for (let u = s + 1; u < r.length; ++u)
        if (!n.resolveDisabled(r[u], u, r))
          return u;
      return o;
    }
    case 3: {
      for (let u = r.length - 1; u >= 0; --u)
        if (!n.resolveDisabled(r[u], u, r))
          return u;
      return o;
    }
    case 4: {
      for (let u = 0; u < r.length; ++u)
        if (n.resolveId(r[u], u, r) === e.id)
          return u;
      return o;
    }
    case 5:
      return null;
    default:
      WG(e);
  }
}
var H1 = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(H1 || {});
function X4(e) {
  let n = ye(e), r = Le(!1);
  Xe(() => (r.current = !1, () => {
    r.current = !0, id(() => {
      r.current && n();
    });
  }), [n]);
}
function GG() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in ne ? ((n) => n.useSyncExternalStore)(ne)(() => () => {
  }, () => !1, () => !e) : !1;
}
function ud() {
  let e = GG(), [n, r] = ne.useState(Es.isHandoffComplete);
  return n && Es.isHandoffComplete === !1 && r(!1), ne.useEffect(() => {
    n !== !0 && r(!0);
  }, [n]), ne.useEffect(() => Es.handoff(), []), e ? !1 : n;
}
let J4 = _t(!1);
function qG() {
  return tt(J4);
}
function yE(e) {
  return oe.createElement(J4.Provider, {
    value: e.force
  }, e.children);
}
function KG(e) {
  let n = qG(), r = tt(tI), o = $i(e), [s, u] = Ve(() => {
    var h;
    if (!n && r !== null)
      return (h = r.current) != null ? h : null;
    if (Es.isServer)
      return null;
    let f = o?.getElementById("headlessui-portal-root");
    if (f)
      return f;
    if (o === null)
      return null;
    let p = o.createElement("div");
    return p.setAttribute("id", "headlessui-portal-root"), o.body.appendChild(p);
  });
  return Xe(() => {
    s !== null && (o != null && o.body.contains(s) || o == null || o.body.appendChild(s));
  }, [s, o]), Xe(() => {
    n || r !== null && u(r.current);
  }, [r, u, n]), s;
}
let eI = ft, YG = nt(function(e, n) {
  let r = e, o = Le(null), s = vt(S1((y) => {
    o.current = y;
  }), n), u = $i(o), h = KG(o), [f] = Ve(() => {
    var y;
    return Es.isServer ? null : (y = u?.createElement("div")) != null ? y : null;
  }), p = tt(Pb), v = ud();
  ct(() => {
    !h || !f || h.contains(f) || (f.setAttribute("data-headlessui-portal", ""), h.appendChild(f));
  }, [h, f]), ct(() => {
    if (f && p)
      return p.register(f);
  }, [p, f]), X4(() => {
    var y;
    !h || !f || (f instanceof Node && h.contains(f) && h.removeChild(f), h.childNodes.length <= 0 && ((y = h.parentElement) == null || y.removeChild(h)));
  });
  let b = st();
  return v ? !h || !f ? null : JD(b({ ourProps: { ref: s }, theirProps: r, slot: {}, defaultTag: eI, name: "Portal" }), f) : null;
});
function QG(e, n) {
  let r = vt(n), { enabled: o = !0, ...s } = e, u = st();
  return o ? oe.createElement(YG, { ...s, ref: r }) : u({ ourProps: { ref: r }, theirProps: s, slot: {}, defaultTag: eI, name: "Portal" });
}
let ZG = ft, tI = _t(null);
function XG(e, n) {
  let { target: r, ...o } = e, s = { ref: vt(n) }, u = st();
  return oe.createElement(tI.Provider, { value: r }, u({ ourProps: s, theirProps: o, defaultTag: ZG, name: "Popover.Group" }));
}
let Pb = _t(null);
function nI() {
  let e = tt(Pb), n = Le([]), r = ye((u) => (n.current.push(u), e && e.register(u), () => o(u))), o = ye((u) => {
    let h = n.current.indexOf(u);
    h !== -1 && n.current.splice(h, 1), e && e.unregister(u);
  }), s = Re(() => ({ register: r, unregister: o, portals: n }), [r, o, n]);
  return [n, Re(() => function({ children: u }) {
    return oe.createElement(Pb.Provider, { value: s }, u);
  }, [s])];
}
let JG = nt(QG), rI = nt(XG), fg = Object.assign(JG, { Group: rI });
var eq = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(eq || {}), tq = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(tq || {}), nq = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(nq || {}), rq = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(rq || {});
function wv(e, n = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, o = n(e.options.slice()), s = o.length > 0 && o[0].dataRef.current.order !== null ? o.sort((h, f) => h.dataRef.current.order - f.dataRef.current.order) : Bo(o, (h) => h.dataRef.current.domRef.current), u = r ? s.indexOf(r) : null;
  return u === -1 && (u = null), { options: s, activeOptionIndex: u };
}
let iq = { [1](e) {
  var n;
  return (n = e.dataRef.current) != null && n.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, [0](e) {
  var n, r;
  if ((n = e.dataRef.current) != null && n.disabled || e.comboboxState === 0)
    return e;
  if ((r = e.dataRef.current) != null && r.value) {
    let o = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (o !== -1)
      return { ...e, activeOptionIndex: o, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, [3](e, n) {
  return e.isTyping === n.isTyping ? e : { ...e, isTyping: n.isTyping };
}, [2](e, n) {
  var r, o, s, u;
  if ((r = e.dataRef.current) != null && r.disabled || e.optionsElement && !((o = e.dataRef.current) != null && o.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let { options: v, disabled: b } = e.virtual, y = n.focus === xt.Specific ? n.idx : ju(n, { resolveItems: () => v, resolveActiveIndex: () => {
      var _, E;
      return (E = (_ = e.activeOptionIndex) != null ? _ : v.findIndex((x) => !b(x))) != null ? E : null;
    }, resolveDisabled: b, resolveId() {
      throw new Error("Function not implemented.");
    } }), k = (s = n.trigger) != null ? s : 2;
    return e.activeOptionIndex === y && e.activationTrigger === k ? e : { ...e, activeOptionIndex: y, activationTrigger: k, isTyping: !1, __demoMode: !1 };
  }
  let h = wv(e);
  if (h.activeOptionIndex === null) {
    let v = h.options.findIndex((b) => !b.dataRef.current.disabled);
    v !== -1 && (h.activeOptionIndex = v);
  }
  let f = n.focus === xt.Specific ? n.idx : ju(n, { resolveItems: () => h.options, resolveActiveIndex: () => h.activeOptionIndex, resolveId: (v) => v.id, resolveDisabled: (v) => v.dataRef.current.disabled }), p = (u = n.trigger) != null ? u : 2;
  return e.activeOptionIndex === f && e.activationTrigger === p ? e : { ...e, ...h, isTyping: !1, activeOptionIndex: f, activationTrigger: p, __demoMode: !1 };
}, [4]: (e, n) => {
  var r, o, s;
  if ((r = e.dataRef.current) != null && r.virtual)
    return { ...e, options: [...e.options, n.payload] };
  let u = n.payload, h = wv(e, (p) => (p.push(u), p));
  e.activeOptionIndex === null && (o = e.dataRef.current) != null && o.isSelected(n.payload.dataRef.current.value) && (h.activeOptionIndex = h.options.indexOf(u));
  let f = { ...e, ...h, activationTrigger: 2 };
  return (s = e.dataRef.current) != null && s.__demoMode && e.dataRef.current.value === void 0 && (f.activeOptionIndex = 0), f;
}, [5]: (e, n) => {
  var r;
  if ((r = e.dataRef.current) != null && r.virtual)
    return { ...e, options: e.options.filter((s) => s.id !== n.id) };
  let o = wv(e, (s) => {
    let u = s.findIndex((h) => h.id === n.id);
    return u !== -1 && s.splice(u, 1), s;
  });
  return { ...e, ...o, activationTrigger: 2 };
}, [6]: (e, n) => e.activationTrigger === n.trigger ? e : { ...e, activationTrigger: n.trigger }, [7]: (e, n) => {
  var r, o;
  if (e.virtual === null)
    return { ...e, virtual: { options: n.options, disabled: (r = n.disabled) != null ? r : () => !1 } };
  if (e.virtual.options === n.options && e.virtual.disabled === n.disabled)
    return e;
  let s = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let u = n.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    u !== -1 ? s = u : s = null;
  }
  return { ...e, activeOptionIndex: s, virtual: { options: n.options, disabled: (o = n.disabled) != null ? o : () => !1 } };
}, [8]: (e, n) => e.inputElement === n.element ? e : { ...e, inputElement: n.element }, [9]: (e, n) => e.buttonElement === n.element ? e : { ...e, buttonElement: n.element }, [10]: (e, n) => e.optionsElement === n.element ? e : { ...e, optionsElement: n.element } }, U1 = _t(null);
U1.displayName = "ComboboxActionsContext";
function dd(e) {
  let n = tt(U1);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, dd), r;
  }
  return n;
}
let iI = _t(null);
function oq(e) {
  let n = cc("VirtualProvider"), { options: r } = n.virtual, [o, s] = Re(() => {
    let v = n.optionsElement;
    if (!v)
      return [0, 0];
    let b = window.getComputedStyle(v);
    return [parseFloat(b.paddingBlockStart || b.paddingTop), parseFloat(b.paddingBlockEnd || b.paddingBottom)];
  }, [n.optionsElement]), u = dW({ enabled: r.length !== 0, scrollPaddingStart: o, scrollPaddingEnd: s, count: r.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return n.optionsElement;
  }, overscan: 12 }), [h, f] = Ve(0);
  ct(() => {
    f((v) => v + 1);
  }, [r]);
  let p = u.getVirtualItems();
  return p.length === 0 ? null : oe.createElement(iI.Provider, { value: u }, oe.createElement("div", { style: { position: "relative", width: "100%", height: `${u.getTotalSize()}px` }, ref: (v) => {
    v && n.activationTrigger !== 0 && n.activeOptionIndex !== null && r.length > n.activeOptionIndex && u.scrollToIndex(n.activeOptionIndex);
  } }, p.map((v) => {
    var b;
    return oe.createElement(ft, { key: v.key }, oe.cloneElement((b = e.children) == null ? void 0 : b.call(e, { ...e.slot, option: r[v.index] }), { key: `${h}-${v.key}`, "data-index": v.index, "aria-setsize": r.length, "aria-posinset": v.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${v.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Gu = _t(null);
Gu.displayName = "ComboboxDataContext";
function cc(e) {
  let n = tt(Gu);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, cc), r;
  }
  return n;
}
function aq(e, n) {
  return Nt(n.type, iq, e, n);
}
let sq = ft;
function lq(e, n) {
  var r, o;
  let s = Vs(), { value: u, defaultValue: h, onChange: f, form: p, name: v, by: b, disabled: y = s || !1, onClose: k, __demoMode: _ = !1, multiple: E = !1, immediate: x = !1, virtual: D = null, nullable: I, ...N } = e, O = x1(h), [P = E ? [] : void 0, S] = C1(u, f, O), [$, L] = Ri(aq, { dataRef: Nu(), comboboxState: _ ? 0 : 1, isTyping: !1, options: [], virtual: D ? { options: D.options, disabled: (r = D.disabled) != null ? r : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: _ }), B = Le(!1), U = Le({ static: !1, hold: !1 }), G = S4(b), q = ye((De) => D ? b === null ? D.options.indexOf(De) : D.options.findIndex((He) => G(He, De)) : $.options.findIndex((He) => G(He.dataRef.current.value, De))), Y = et((De) => Nt(Z.mode, { [1]: () => P.some((He) => G(He, De)), [0]: () => G(P, De) }), [P]), Q = ye((De) => $.activeOptionIndex === q(De)), Z = Re(() => ({ ...$, immediate: x, optionsPropsRef: U, value: P, defaultValue: O, disabled: y, mode: E ? 1 : 0, virtual: D ? $.virtual : null, get activeOptionIndex() {
    if (B.current && $.activeOptionIndex === null && (D ? D.options.length > 0 : $.options.length > 0)) {
      if (D) {
        let He = D.options.findIndex((at) => {
          var qt, An;
          return !((An = (qt = D.disabled) == null ? void 0 : qt.call(D, at)) != null && An);
        });
        if (He !== -1)
          return He;
      }
      let De = $.options.findIndex((He) => !He.dataRef.current.disabled);
      if (De !== -1)
        return De;
    }
    return $.activeOptionIndex;
  }, calculateIndex: q, compare: G, isSelected: Y, isActive: Q }), [P, O, y, E, _, $, D]);
  ct(() => {
    var De;
    D && L({ type: 7, options: D.options, disabled: (De = D.disabled) != null ? De : null });
  }, [D, D?.options, D?.disabled]), ct(() => {
    $.dataRef.current = Z;
  }, [Z]);
  let ae = Z.comboboxState === 0;
  ag(ae, [Z.buttonElement, Z.inputElement, Z.optionsElement], () => ke.closeCombobox());
  let ie = Re(() => {
    var De, He, at;
    return { open: Z.comboboxState === 0, disabled: y, activeIndex: Z.activeOptionIndex, activeOption: Z.activeOptionIndex === null ? null : Z.virtual ? Z.virtual.options[(De = Z.activeOptionIndex) != null ? De : 0] : (at = (He = Z.options[Z.activeOptionIndex]) == null ? void 0 : He.dataRef.current.value) != null ? at : null, value: P };
  }, [Z, y, P]), pe = ye(() => {
    if (Z.activeOptionIndex !== null) {
      if (ke.setIsTyping(!1), Z.virtual)
        de(Z.virtual.options[Z.activeOptionIndex]);
      else {
        let { dataRef: De } = Z.options[Z.activeOptionIndex];
        de(De.current.value);
      }
      ke.goToOption(xt.Specific, Z.activeOptionIndex);
    }
  }), ce = ye(() => {
    L({ type: 0 }), B.current = !0;
  }), ue = ye(() => {
    L({ type: 1 }), B.current = !1, k?.();
  }), X = ye((De) => {
    L({ type: 3, isTyping: De });
  }), se = ye((De, He, at) => (B.current = !1, De === xt.Specific ? L({ type: 2, focus: xt.Specific, idx: He, trigger: at }) : L({ type: 2, focus: De, trigger: at }))), he = ye((De, He) => (L({ type: 4, payload: { id: De, dataRef: He } }), () => {
    Z.isActive(He.current.value) && (B.current = !0), L({ type: 5, id: De });
  })), de = ye((De) => Nt(Z.mode, { [0]() {
    return S?.(De);
  }, [1]() {
    let He = Z.value.slice(), at = He.findIndex((qt) => G(qt, De));
    return at === -1 ? He.push(De) : He.splice(at, 1), S?.(He);
  } })), me = ye((De) => {
    L({ type: 6, trigger: De });
  }), we = ye((De) => {
    L({ type: 8, element: De });
  }), Ae = ye((De) => {
    L({ type: 9, element: De });
  }), Se = ye((De) => {
    L({ type: 10, element: De });
  }), ke = Re(() => ({ onChange: de, registerOption: he, goToOption: se, setIsTyping: X, closeCombobox: ue, openCombobox: ce, setActivationTrigger: me, selectActiveOption: pe, setInputElement: we, setButtonElement: Ae, setOptionsElement: Se }), []), [ge, xe] = Hs(), Te = n === null ? {} : { ref: n }, J = et(() => {
    if (O !== void 0)
      return S?.(O);
  }, [S, O]), Ge = st();
  return oe.createElement(xe, { value: ge, props: { htmlFor: (o = Z.inputElement) == null ? void 0 : o.id }, slot: { open: Z.comboboxState === 0, disabled: y } }, oe.createElement(z1, null, oe.createElement(U1.Provider, { value: ke }, oe.createElement(Gu.Provider, { value: Z }, oe.createElement(cd, { value: Nt(Z.comboboxState, { [0]: Qt.Open, [1]: Qt.Closed }) }, v != null && oe.createElement(E1, { disabled: y, data: P != null ? { [v]: P } : {}, form: p, onReset: J }), Ge({ ourProps: Te, theirProps: N, slot: ie, defaultTag: sq, name: "Combobox" }))))));
}
let cq = "input";
function uq(e, n) {
  var r, o, s, u, h;
  let f = cc("Combobox.Input"), p = dd("Combobox.Input"), v = Et(), b = eg(), { id: y = b || `headlessui-combobox-input-${v}`, onChange: k, displayValue: _, disabled: E = f.disabled || !1, autoFocus: x = !1, type: D = "text", ...I } = e, N = Le(null), O = vt(N, n, j1(), p.setInputElement), P = $i(f.inputElement), S = Qo(), $ = ye(() => {
    p.onChange(null), f.optionsElement && (f.optionsElement.scrollTop = 0), p.goToOption(xt.Nothing);
  }), L = Re(() => {
    var de;
    return typeof _ == "function" && f.value !== void 0 ? (de = _(f.value)) != null ? de : "" : typeof f.value == "string" ? f.value : "";
  }, [f.value, _]);
  Hu(([de, me], [we, Ae]) => {
    if (f.isTyping)
      return;
    let Se = N.current;
    Se && ((Ae === 0 && me === 1 || de !== we) && (Se.value = de), requestAnimationFrame(() => {
      if (f.isTyping || !Se || P?.activeElement !== Se)
        return;
      let { selectionStart: ke, selectionEnd: ge } = Se;
      Math.abs((ge ?? 0) - (ke ?? 0)) === 0 && ke === 0 && Se.setSelectionRange(Se.value.length, Se.value.length);
    }));
  }, [L, f.comboboxState, P, f.isTyping]), Hu(([de], [me]) => {
    if (de === 0 && me === 1) {
      if (f.isTyping)
        return;
      let we = N.current;
      if (!we)
        return;
      let Ae = we.value, { selectionStart: Se, selectionEnd: ke, selectionDirection: ge } = we;
      we.value = "", we.value = Ae, ge !== null ? we.setSelectionRange(Se, ke, ge) : we.setSelectionRange(Se, ke);
    }
  }, [f.comboboxState]);
  let B = Le(!1), U = ye(() => {
    B.current = !0;
  }), G = ye(() => {
    S.nextFrame(() => {
      B.current = !1;
    });
  }), q = ye((de) => {
    switch (p.setIsTyping(!0), de.key) {
      case ze.Enter:
        if (f.comboboxState !== 0 || B.current)
          return;
        if (de.preventDefault(), de.stopPropagation(), f.activeOptionIndex === null) {
          p.closeCombobox();
          return;
        }
        p.selectActiveOption(), f.mode === 0 && p.closeCombobox();
        break;
      case ze.ArrowDown:
        return de.preventDefault(), de.stopPropagation(), Nt(f.comboboxState, { [0]: () => p.goToOption(xt.Next), [1]: () => p.openCombobox() });
      case ze.ArrowUp:
        return de.preventDefault(), de.stopPropagation(), Nt(f.comboboxState, { [0]: () => p.goToOption(xt.Previous), [1]: () => {
          oi(() => p.openCombobox()), f.value || p.goToOption(xt.Last);
        } });
      case ze.Home:
        if (de.shiftKey)
          break;
        return de.preventDefault(), de.stopPropagation(), p.goToOption(xt.First);
      case ze.PageUp:
        return de.preventDefault(), de.stopPropagation(), p.goToOption(xt.First);
      case ze.End:
        if (de.shiftKey)
          break;
        return de.preventDefault(), de.stopPropagation(), p.goToOption(xt.Last);
      case ze.PageDown:
        return de.preventDefault(), de.stopPropagation(), p.goToOption(xt.Last);
      case ze.Escape:
        return f.comboboxState !== 0 ? void 0 : (de.preventDefault(), f.optionsElement && !f.optionsPropsRef.current.static && de.stopPropagation(), f.mode === 0 && f.value === null && $(), p.closeCombobox());
      case ze.Tab:
        if (f.comboboxState !== 0)
          return;
        f.mode === 0 && f.activationTrigger !== 1 && p.selectActiveOption(), p.closeCombobox();
        break;
    }
  }), Y = ye((de) => {
    k?.(de), f.mode === 0 && de.target.value === "" && $(), p.openCombobox();
  }), Q = ye((de) => {
    var me, we, Ae;
    let Se = (me = de.relatedTarget) != null ? me : lo.find((ke) => ke !== de.currentTarget);
    if (!((we = f.optionsElement) != null && we.contains(Se)) && !((Ae = f.buttonElement) != null && Ae.contains(Se)) && f.comboboxState === 0)
      return de.preventDefault(), f.mode === 0 && f.value === null && $(), p.closeCombobox();
  }), Z = ye((de) => {
    var me, we, Ae;
    let Se = (me = de.relatedTarget) != null ? me : lo.find((ke) => ke !== de.currentTarget);
    (we = f.buttonElement) != null && we.contains(Se) || (Ae = f.optionsElement) != null && Ae.contains(Se) || f.disabled || f.immediate && f.comboboxState !== 0 && S.microTask(() => {
      oi(() => p.openCombobox()), p.setActivationTrigger(1);
    });
  }), ae = tc(), ie = M1(), { isFocused: pe, focusProps: ce } = wo({ autoFocus: x }), { isHovered: ue, hoverProps: X } = Yo({ isDisabled: E }), se = Re(() => ({ open: f.comboboxState === 0, disabled: E, hover: ue, focus: pe, autofocus: x }), [f, ue, pe, x, E]), he = kr({ ref: O, id: y, role: "combobox", type: D, "aria-controls": (r = f.optionsElement) == null ? void 0 : r.id, "aria-expanded": f.comboboxState === 0, "aria-activedescendant": f.activeOptionIndex === null ? void 0 : f.virtual ? (o = f.options.find((de) => !de.dataRef.current.disabled && f.compare(de.dataRef.current.value, f.virtual.options[f.activeOptionIndex]))) == null ? void 0 : o.id : (s = f.options[f.activeOptionIndex]) == null ? void 0 : s.id, "aria-labelledby": ae, "aria-describedby": ie, "aria-autocomplete": "list", defaultValue: (h = (u = e.defaultValue) != null ? u : f.defaultValue !== void 0 ? _?.(f.defaultValue) : null) != null ? h : f.defaultValue, disabled: E || void 0, autoFocus: x, onCompositionStart: U, onCompositionEnd: G, onKeyDown: q, onChange: Y, onFocus: Z, onBlur: Q }, ce, X);
  return st()({ ourProps: he, theirProps: I, slot: se, defaultTag: cq, name: "Combobox.Input" });
}
let dq = "button";
function hq(e, n) {
  var r;
  let o = cc("Combobox.Button"), s = dd("Combobox.Button"), u = vt(n, s.setButtonElement), h = Et(), { id: f = `headlessui-combobox-button-${h}`, disabled: p = o.disabled || !1, autoFocus: v = !1, ...b } = e, y = R4(o.inputElement), k = ye((L) => {
    switch (L.key) {
      case ze.Space:
      case ze.Enter:
        L.preventDefault(), L.stopPropagation(), o.comboboxState === 1 && oi(() => s.openCombobox()), y();
        return;
      case ze.ArrowDown:
        L.preventDefault(), L.stopPropagation(), o.comboboxState === 1 && (oi(() => s.openCombobox()), o.value || s.goToOption(xt.First)), y();
        return;
      case ze.ArrowUp:
        L.preventDefault(), L.stopPropagation(), o.comboboxState === 1 && (oi(() => s.openCombobox()), o.value || s.goToOption(xt.Last)), y();
        return;
      case ze.Escape:
        if (o.comboboxState !== 0)
          return;
        L.preventDefault(), o.optionsElement && !o.optionsPropsRef.current.static && L.stopPropagation(), oi(() => s.closeCombobox()), y();
        return;
      default:
        return;
    }
  }), _ = ye((L) => {
    L.preventDefault(), !$a(L.currentTarget) && (L.button === H1.Left && (o.comboboxState === 0 ? s.closeCombobox() : s.openCombobox()), y());
  }), E = tc([f]), { isFocusVisible: x, focusProps: D } = wo({ autoFocus: v }), { isHovered: I, hoverProps: N } = Yo({ isDisabled: p }), { pressed: O, pressProps: P } = Jl({ disabled: p }), S = Re(() => ({ open: o.comboboxState === 0, active: O || o.comboboxState === 0, disabled: p, value: o.value, hover: I, focus: x }), [o, I, x, O, p]), $ = kr({ ref: u, id: f, type: rc(e, o.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (r = o.optionsElement) == null ? void 0 : r.id, "aria-expanded": o.comboboxState === 0, "aria-labelledby": E, disabled: p || void 0, autoFocus: v, onMouseDown: _, onKeyDown: k }, D, N, P);
  return st()({ ourProps: $, theirProps: b, slot: S, defaultTag: dq, name: "Combobox.Button" });
}
let fq = "div", pq = gr.RenderStrategy | gr.Static;
function gq(e, n) {
  var r, o, s;
  let u = Et(), { id: h = `headlessui-combobox-options-${u}`, hold: f = !1, anchor: p, portal: v = !1, modal: b = !0, transition: y = !1, ...k } = e, _ = cc("Combobox.Options"), E = dd("Combobox.Options"), x = L1(p);
  x && (v = !0);
  let [D, I] = F1(x), [N, O] = Ve(null), P = B1(), S = vt(n, x ? D : null, E.setOptionsElement, O), $ = $i(_.optionsElement), L = Xo(), [B, U] = oc(y, N, L !== null ? (L & Qt.Open) === Qt.Open : _.comboboxState === 0);
  rg(B, _.inputElement, E.closeCombobox);
  let G = _.__demoMode ? !1 : b && _.comboboxState === 0;
  lg(G, $);
  let q = _.__demoMode ? !1 : b && _.comboboxState === 0;
  P1(q, { allowed: et(() => [_.inputElement, _.buttonElement, _.optionsElement], [_.inputElement, _.buttonElement, _.optionsElement]) }), ct(() => {
    var he;
    _.optionsPropsRef.current.static = (he = e.static) != null ? he : !1;
  }, [_.optionsPropsRef, e.static]), ct(() => {
    _.optionsPropsRef.current.hold = f;
  }, [_.optionsPropsRef, f]), $4(_.comboboxState === 0, { container: _.optionsElement, accept(he) {
    return he.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : he.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(he) {
    he.setAttribute("role", "none");
  } });
  let Y = tc([(r = _.buttonElement) == null ? void 0 : r.id]), Q = Re(() => ({ open: _.comboboxState === 0, option: void 0 }), [_.comboboxState]), Z = ye(() => {
    E.setActivationTrigger(0);
  }), ae = ye((he) => {
    he.preventDefault(), E.setActivationTrigger(0);
  }), ie = kr(x ? P() : {}, { "aria-labelledby": Y, role: "listbox", "aria-multiselectable": _.mode === 1 ? !0 : void 0, id: h, ref: S, style: { ...k.style, ...I, "--input-width": Hf(_.inputElement, !0).width, "--button-width": Hf(_.buttonElement, !0).width }, onWheel: _.activationTrigger === 0 ? void 0 : Z, onMouseDown: ae, ...ic(U) }), pe = B && _.comboboxState === 1, ce = Ib(pe, (o = _.virtual) == null ? void 0 : o.options), ue = Ib(pe, _.value), X = ye((he) => _.compare(ue, he));
  if (_.virtual) {
    if (ce === void 0)
      throw new Error("Missing `options` in virtual mode");
    Object.assign(k, { children: oe.createElement(Gu.Provider, { value: ce !== _.virtual.options ? { ..._, virtual: { ..._.virtual, options: ce } } : _ }, oe.createElement(oq, { slot: Q }, k.children)) });
  }
  let se = st();
  return oe.createElement(fg, { enabled: v ? e.static || B : !1 }, oe.createElement(Gu.Provider, { value: _.mode === 1 ? _ : { ..._, isSelected: X } }, se({ ourProps: ie, theirProps: { ...k, children: oe.createElement(HG, { freeze: pe }, typeof k.children == "function" ? (s = k.children) == null ? void 0 : s.call(k, Q) : k.children) }, slot: Q, defaultTag: fq, features: pq, visible: B, name: "Combobox.Options" })));
}
let mq = "div";
function vq(e, n) {
  var r, o, s, u;
  let h = cc("Combobox.Option"), f = dd("Combobox.Option"), p = Et(), { id: v = `headlessui-combobox-option-${p}`, value: b, disabled: y = (s = (o = (r = h.virtual) == null ? void 0 : r.disabled) == null ? void 0 : o.call(r, b)) != null ? s : !1, order: k = null, ..._ } = e, E = R4(h.inputElement), x = h.virtual ? h.activeOptionIndex === h.calculateIndex(b) : h.activeOptionIndex === null ? !1 : ((u = h.options[h.activeOptionIndex]) == null ? void 0 : u.id) === v, D = h.isSelected(b), I = Le(null), N = hr({ disabled: y, value: b, domRef: I, order: k }), O = tt(iI), P = vt(n, I, O ? O.measureElement : null), S = ye(() => {
    f.setIsTyping(!1), f.onChange(b);
  });
  ct(() => f.registerOption(v, N), [N, v]);
  let $ = Le(!(h.virtual || h.__demoMode));
  ct(() => {
    if (!h.virtual && !h.__demoMode)
      return fi().requestAnimationFrame(() => {
        $.current = !0;
      });
  }, [h.virtual, h.__demoMode]), ct(() => {
    if ($.current && h.comboboxState === 0 && x && h.activationTrigger !== 0)
      return fi().requestAnimationFrame(() => {
        var ae, ie;
        (ie = (ae = I.current) == null ? void 0 : ae.scrollIntoView) == null || ie.call(ae, { block: "nearest" });
      });
  }, [I, x, h.comboboxState, h.activationTrigger, h.activeOptionIndex]);
  let L = ye((ae) => {
    ae.preventDefault(), ae.button === H1.Left && (y || (S(), P4() || requestAnimationFrame(() => E()), h.mode === 0 && f.closeCombobox()));
  }), B = ye(() => {
    if (y)
      return f.goToOption(xt.Nothing);
    let ae = h.calculateIndex(b);
    f.goToOption(xt.Specific, ae);
  }), U = N4(), G = ye((ae) => U.update(ae)), q = ye((ae) => {
    if (!U.wasMoved(ae) || y || x)
      return;
    let ie = h.calculateIndex(b);
    f.goToOption(xt.Specific, ie, 0);
  }), Y = ye((ae) => {
    U.wasMoved(ae) && (y || x && (h.optionsPropsRef.current.hold || f.goToOption(xt.Nothing)));
  }), Q = Re(() => ({ active: x, focus: x, selected: D, disabled: y }), [x, D, y]), Z = { id: v, ref: P, role: "option", tabIndex: y === !0 ? void 0 : -1, "aria-disabled": y === !0 ? !0 : void 0, "aria-selected": D, disabled: void 0, onMouseDown: L, onFocus: B, onPointerEnter: G, onMouseEnter: G, onPointerMove: q, onMouseMove: q, onPointerLeave: Y, onMouseLeave: Y };
  return st()({ ourProps: Z, theirProps: _, slot: Q, defaultTag: mq, name: "Combobox.Option" });
}
let bq = nt(lq), oI = nt(hq), aI = nt(uq), wq = od, sI = nt(gq), lI = nt(vq), kE = Object.assign(bq, { Input: aI, Button: oI, Label: wq, Options: sI, Option: lI });
function yq(e, n = typeof document < "u" ? document.defaultView : null, r) {
  let o = nc(e, "escape");
  sg(n, "keydown", (s) => {
    o && (s.defaultPrevented || s.key === ze.Escape && r(s));
  });
}
function kq() {
  var e;
  let [n] = Ve(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [r, o] = Ve((e = n?.matches) != null ? e : !1);
  return ct(() => {
    if (!n)
      return;
    function s(u) {
      o(u.matches);
    }
    return n.addEventListener("change", s), () => n.removeEventListener("change", s);
  }, [n]), r;
}
function cI({
  defaultContainers: e = [],
  portals: n,
  mainTreeNode: r
} = {}) {
  let o = $i(r), s = ye(() => {
    var u, h;
    let f = [];
    for (let p of e)
      p !== null && (p instanceof HTMLElement ? f.push(p) : "current" in p && p.current instanceof HTMLElement && f.push(p.current));
    if (n != null && n.current)
      for (let p of n.current)
        f.push(p);
    for (let p of (u = o?.querySelectorAll("html > *, body > *")) != null ? u : [])
      p !== document.body && p !== document.head && p instanceof HTMLElement && p.id !== "headlessui-portal-root" && (r && (p.contains(r) || p.contains((h = r?.getRootNode()) == null ? void 0 : h.host)) || f.some((v) => p.contains(v)) || f.push(p));
    return f;
  });
  return {
    resolveContainers: s,
    contains: ye((u) => s().some((h) => h.contains(u)))
  };
}
let uI = _t(null);
function Yf({
  children: e,
  node: n
}) {
  let [r, o] = Ve(null), s = W1(n ?? r);
  return oe.createElement(uI.Provider, {
    value: s
  }, e, s === null && /* @__PURE__ */ M(Pi, {
    features: Ii.Hidden,
    ref: (u) => {
      var h, f;
      if (u) {
        for (let p of (f = (h = Ni(u)) == null ? void 0 : h.querySelectorAll("html > *, body > *")) != null ? f : [])
          if (p !== document.body && p !== document.head && p instanceof HTMLElement && p != null && p.contains(u)) {
            o(p);
            break;
          }
      }
    }
  }));
}
function W1(e = null) {
  var n;
  return (n = tt(uI)) != null ? n : e;
}
function pg() {
  let e = Le(!1);
  return ct(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var Br = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Br || {});
function G1() {
  let e = Le(0);
  return O4(!0, "keydown", (n) => {
    n.key === "Tab" && (e.current = n.shiftKey ? 1 : 0);
  }, !0), e;
}
function dI(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let n = /* @__PURE__ */ new Set();
  for (let r of e.current)
    r.current instanceof HTMLElement && n.add(r.current);
  return n;
}
let _q = "div";
var bs = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(bs || {});
function Aq(e, n) {
  let r = Le(null), o = vt(r, n), { initialFocus: s, initialFocusFallback: u, containers: h, features: f = 15, ...p } = e;
  ud() || (f = 0);
  let v = $i(r);
  Sq(f, { ownerDocument: v });
  let b = Mq(f, { ownerDocument: v, container: r, initialFocus: s, initialFocusFallback: u });
  Tq(f, { ownerDocument: v, container: r, containers: h, previousActiveElement: b });
  let y = G1(), k = ye((N) => {
    let O = r.current;
    !O || ((P) => P())(() => {
      Nt(y.current, { [Br.Forwards]: () => {
        $n(O, Pt.First, { skipElements: [N.relatedTarget, u] });
      }, [Br.Backwards]: () => {
        $n(O, Pt.Last, { skipElements: [N.relatedTarget, u] });
      } });
    });
  }), _ = nc(!!(f & 2), "focus-trap#tab-lock"), E = Qo(), x = Le(!1), D = { ref: o, onKeyDown(N) {
    N.key == "Tab" && (x.current = !0, E.requestAnimationFrame(() => {
      x.current = !1;
    }));
  }, onBlur(N) {
    if (!(f & 4))
      return;
    let O = dI(h);
    r.current instanceof HTMLElement && O.add(r.current);
    let P = N.relatedTarget;
    P instanceof HTMLElement && P.dataset.headlessuiFocusGuard !== "true" && (hI(O, P) || (x.current ? $n(r.current, Nt(y.current, { [Br.Forwards]: () => Pt.Next, [Br.Backwards]: () => Pt.Previous }) | Pt.WrapAround, { relativeTo: N.target }) : N.target instanceof HTMLElement && ho(N.target)));
  } }, I = st();
  return oe.createElement(oe.Fragment, null, _ && oe.createElement(Pi, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: k, features: Ii.Focusable }), I({ ourProps: D, theirProps: p, defaultTag: _q, name: "FocusTrap" }), _ && oe.createElement(Pi, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: k, features: Ii.Focusable }));
}
let Cq = nt(Aq), xq = Object.assign(Cq, { features: bs });
function Eq(e = !0) {
  let n = Le(lo.slice());
  return Hu(([r], [o]) => {
    o === !0 && r === !1 && id(() => {
      n.current.splice(0);
    }), o === !1 && r === !0 && (n.current = lo.slice());
  }, [e, lo, n]), ye(() => {
    var r;
    return (r = n.current.find((o) => o != null && o.isConnected)) != null ? r : null;
  });
}
function Sq(e, { ownerDocument: n }) {
  let r = !!(e & 8), o = Eq(r);
  Hu(() => {
    r || n?.activeElement === n?.body && ho(o());
  }, [r]), X4(() => {
    r && ho(o());
  });
}
function Mq(e, { ownerDocument: n, container: r, initialFocus: o, initialFocusFallback: s }) {
  let u = Le(null), h = nc(!!(e & 1), "focus-trap#initial-focus"), f = pg();
  return Hu(() => {
    if (e === 0)
      return;
    if (!h) {
      s != null && s.current && ho(s.current);
      return;
    }
    let p = r.current;
    p && id(() => {
      if (!f.current)
        return;
      let v = n?.activeElement;
      if (o != null && o.current) {
        if (o?.current === v) {
          u.current = v;
          return;
        }
      } else if (p.contains(v)) {
        u.current = v;
        return;
      }
      if (o != null && o.current)
        ho(o.current);
      else {
        if (e & 16) {
          if ($n(p, Pt.First | Pt.AutoFocus) !== si.Error)
            return;
        } else if ($n(p, Pt.First) !== si.Error)
          return;
        if (s != null && s.current && (ho(s.current), n?.activeElement === s.current))
          return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      u.current = n?.activeElement;
    });
  }, [s, h, e]), u;
}
function Tq(e, { ownerDocument: n, container: r, containers: o, previousActiveElement: s }) {
  let u = pg(), h = !!(e & 4);
  sg(n?.defaultView, "focus", (f) => {
    if (!h || !u.current)
      return;
    let p = dI(o);
    r.current instanceof HTMLElement && p.add(r.current);
    let v = s.current;
    if (!v)
      return;
    let b = f.target;
    b && b instanceof HTMLElement ? hI(p, b) ? (s.current = b, ho(b)) : (f.preventDefault(), f.stopPropagation(), ho(v)) : ho(s.current);
  }, !0);
}
function hI(e, n) {
  for (let r of e)
    if (r.contains(n))
      return !0;
  return !1;
}
function fI(e) {
  var n;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((n = e.as) != null ? n : gI) !== ft || oe.Children.count(e.children) === 1;
}
let gg = _t(null);
gg.displayName = "TransitionContext";
var Dq = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Dq || {});
function Iq() {
  let e = tt(gg);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function Pq() {
  let e = tt(mg);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let mg = _t(null);
mg.displayName = "NestingContext";
function vg(e) {
  return "children" in e ? vg(e.children) : e.current.filter(({ el: n }) => n.current !== null).filter(({ state: n }) => n === "visible").length > 0;
}
function pI(e, n) {
  let r = hr(e), o = Le([]), s = pg(), u = Qo(), h = ye((_, E = _a.Hidden) => {
    let x = o.current.findIndex(({ el: D }) => D === _);
    x !== -1 && (Nt(E, { [_a.Unmount]() {
      o.current.splice(x, 1);
    }, [_a.Hidden]() {
      o.current[x].state = "hidden";
    } }), u.microTask(() => {
      var D;
      !vg(o) && s.current && ((D = r.current) == null || D.call(r));
    }));
  }), f = ye((_) => {
    let E = o.current.find(({ el: x }) => x === _);
    return E ? E.state !== "visible" && (E.state = "visible") : o.current.push({ el: _, state: "visible" }), () => h(_, _a.Unmount);
  }), p = Le([]), v = Le(Promise.resolve()), b = Le({ enter: [], leave: [] }), y = ye((_, E, x) => {
    p.current.splice(0), n && (n.chains.current[E] = n.chains.current[E].filter(([D]) => D !== _)), n?.chains.current[E].push([_, new Promise((D) => {
      p.current.push(D);
    })]), n?.chains.current[E].push([_, new Promise((D) => {
      Promise.all(b.current[E].map(([I, N]) => N)).then(() => D());
    })]), E === "enter" ? v.current = v.current.then(() => n?.wait.current).then(() => x(E)) : x(E);
  }), k = ye((_, E, x) => {
    Promise.all(b.current[E].splice(0).map(([D, I]) => I)).then(() => {
      var D;
      (D = p.current.shift()) == null || D();
    }).then(() => x(E));
  });
  return Re(() => ({ children: o, register: f, unregister: h, onStart: y, onStop: k, wait: v, chains: b }), [f, h, o, y, k, b, v]);
}
let gI = ft, mI = gr.RenderStrategy;
function Oq(e, n) {
  var r, o;
  let { transition: s = !0, beforeEnter: u, afterEnter: h, beforeLeave: f, afterLeave: p, enter: v, enterFrom: b, enterTo: y, entered: k, leave: _, leaveFrom: E, leaveTo: x, ...D } = e, [I, N] = Ve(null), O = Le(null), P = fI(e), S = vt(...P ? [O, n, N] : n === null ? [] : [n]), $ = (r = D.unmount) == null || r ? _a.Unmount : _a.Hidden, { show: L, appear: B, initial: U } = Iq(), [G, q] = Ve(L ? "visible" : "hidden"), Y = Pq(), { register: Q, unregister: Z } = Y;
  ct(() => Q(O), [Q, O]), ct(() => {
    if ($ === _a.Hidden && O.current) {
      if (L && G !== "visible") {
        q("visible");
        return;
      }
      return Nt(G, { hidden: () => Z(O), visible: () => Q(O) });
    }
  }, [G, O, Q, Z, L, $]);
  let ae = ud();
  ct(() => {
    if (P && ae && G === "visible" && O.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [O, G, ae, P]);
  let ie = U && !B, pe = B && L && U, ce = Le(!1), ue = pI(() => {
    ce.current || (q("hidden"), Z(O));
  }, Y), X = ye((Se) => {
    ce.current = !0;
    let ke = Se ? "enter" : "leave";
    ue.onStart(O, ke, (ge) => {
      ge === "enter" ? u?.() : ge === "leave" && f?.();
    });
  }), se = ye((Se) => {
    let ke = Se ? "enter" : "leave";
    ce.current = !1, ue.onStop(O, ke, (ge) => {
      ge === "enter" ? h?.() : ge === "leave" && p?.();
    }), ke === "leave" && !vg(ue) && (q("hidden"), Z(O));
  });
  Xe(() => {
    P && s || (X(L), se(L));
  }, [L, P, s]);
  let he = (() => !(!s || !P || !ae || ie))(), [, de] = oc(he, I, L, { start: X, end: se }), me = ya({ ref: S, className: ((o = Eb(D.className, pe && v, pe && b, de.enter && v, de.enter && de.closed && b, de.enter && !de.closed && y, de.leave && _, de.leave && !de.closed && E, de.leave && de.closed && x, !de.transition && L && k)) == null ? void 0 : o.trim()) || void 0, ...ic(de) }), we = 0;
  G === "visible" && (we |= Qt.Open), G === "hidden" && (we |= Qt.Closed), de.enter && (we |= Qt.Opening), de.leave && (we |= Qt.Closing);
  let Ae = st();
  return oe.createElement(mg.Provider, { value: ue }, oe.createElement(cd, { value: we }, Ae({ ourProps: me, theirProps: D, defaultTag: gI, features: mI, visible: G === "visible", name: "Transition.Child" })));
}
function Rq(e, n) {
  let { show: r, appear: o = !1, unmount: s = !0, ...u } = e, h = Le(null), f = fI(e), p = vt(...f ? [h, n] : n === null ? [] : [n]);
  ud();
  let v = Xo();
  if (r === void 0 && v !== null && (r = (v & Qt.Open) === Qt.Open), r === void 0)
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [b, y] = Ve(r ? "visible" : "hidden"), k = pI(() => {
    r || y("hidden");
  }), [_, E] = Ve(!0), x = Le([r]);
  ct(() => {
    _ !== !1 && x.current[x.current.length - 1] !== r && (x.current.push(r), E(!1));
  }, [x, r]);
  let D = Re(() => ({ show: r, appear: o, initial: _ }), [r, o, _]);
  ct(() => {
    r ? y("visible") : !vg(k) && h.current !== null && y("hidden");
  }, [r, k]);
  let I = { unmount: s }, N = ye(() => {
    var S;
    _ && E(!1), (S = e.beforeEnter) == null || S.call(e);
  }), O = ye(() => {
    var S;
    _ && E(!1), (S = e.beforeLeave) == null || S.call(e);
  }), P = st();
  return oe.createElement(mg.Provider, { value: k }, oe.createElement(gg.Provider, { value: D }, P({ ourProps: { ...I, as: ft, children: oe.createElement(vI, { ref: p, ...I, ...u, beforeEnter: N, beforeLeave: O }) }, theirProps: {}, defaultTag: ft, features: mI, visible: b === "visible", name: "Transition" })));
}
function Nq(e, n) {
  let r = tt(gg) !== null, o = Xo() !== null;
  return oe.createElement(oe.Fragment, null, !r && o ? oe.createElement(Ob, { ref: n, ...e }) : oe.createElement(vI, { ref: n, ...e }));
}
let Ob = nt(Rq), vI = nt(Oq), Uo = nt(Nq), rr = Object.assign(Ob, { Child: Uo, Root: Ob });
var $q = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($q || {}), Lq = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(Lq || {});
let jq = { [0](e, n) {
  return e.titleId === n.id ? e : { ...e, titleId: n.id };
} }, q1 = _t(null);
q1.displayName = "DialogContext";
function bg(e) {
  let n = tt(q1);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, bg), r;
  }
  return n;
}
function Bq(e, n) {
  return Nt(n.type, jq, e, n);
}
let _E = nt(function(e, n) {
  let r = Et(), { id: o = `headlessui-dialog-${r}`, open: s, onClose: u, initialFocus: h, role: f = "dialog", autoFocus: p = !0, __demoMode: v = !1, unmount: b = !1, ...y } = e, k = Le(!1);
  f = function() {
    return f === "dialog" || f === "alertdialog" ? f : (k.current || (k.current = !0, console.warn(`Invalid role [${f}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let _ = Xo();
  s === void 0 && _ !== null && (s = (_ & Qt.Open) === Qt.Open);
  let E = Le(null), x = vt(E, n), D = $i(E), I = s ? 0 : 1, [N, O] = Ri(Bq, { titleId: null, descriptionId: null, panelRef: Nu() }), P = ye(() => u(!1)), S = ye((se) => O({ type: 0, id: se })), $ = ud() ? I === 0 : !1, [L, B] = nI(), U = { get current() {
    var se;
    return (se = N.panelRef.current) != null ? se : E.current;
  } }, G = W1(), { resolveContainers: q } = cI({ mainTreeNode: G, portals: L, defaultContainers: [U] }), Y = _ !== null ? (_ & Qt.Closing) === Qt.Closing : !1;
  P1(v || Y ? !1 : $, { allowed: ye(() => {
    var se, he;
    return [(he = (se = E.current) == null ? void 0 : se.closest("[data-headlessui-portal]")) != null ? he : null];
  }), disallowed: ye(() => {
    var se;
    return [(se = G?.closest("body > *:not(#headlessui-portal-root)")) != null ? se : null];
  }) }), ag($, q, (se) => {
    se.preventDefault(), P();
  }), yq($, D?.defaultView, (se) => {
    se.preventDefault(), se.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), P();
  }), lg(v || Y ? !1 : $, D, q), rg($, E, P);
  let [Q, Z] = ec(), ae = Re(() => [{ dialogState: I, close: P, setTitleId: S, unmount: b }, N], [I, N, P, S, b]), ie = Re(() => ({ open: I === 0 }), [I]), pe = { ref: x, id: o, role: f, tabIndex: -1, "aria-modal": v ? void 0 : I === 0 ? !0 : void 0, "aria-labelledby": N.titleId, "aria-describedby": Q, unmount: b }, ce = !kq(), ue = bs.None;
  $ && !v && (ue |= bs.RestoreFocus, ue |= bs.TabLock, p && (ue |= bs.AutoFocus), ce && (ue |= bs.InitialFocus));
  let X = st();
  return oe.createElement(V1, null, oe.createElement(yE, { force: !0 }, oe.createElement(fg, null, oe.createElement(q1.Provider, { value: ae }, oe.createElement(rI, { target: E }, oe.createElement(yE, { force: !1 }, oe.createElement(Z, { slot: ie }, oe.createElement(B, null, oe.createElement(xq, { initialFocus: h, initialFocusFallback: E, containers: q, features: ue }, oe.createElement(I1, { value: P }, X({ ourProps: pe, theirProps: y, slot: ie, defaultTag: Fq, features: zq, visible: I === 0, name: "Dialog" })))))))))));
}), Fq = "div", zq = gr.RenderStrategy | gr.Static;
function Vq(e, n) {
  let { transition: r = !1, open: o, ...s } = e, u = Xo(), h = e.hasOwnProperty("open") || u !== null, f = e.hasOwnProperty("onClose");
  if (!h && !f)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!h)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!f)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!u && typeof e.open != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (o !== void 0 || r) && !s.static ? oe.createElement(Yf, null, oe.createElement(rr, { show: o, transition: r, unmount: s.unmount }, oe.createElement(_E, { ref: n, ...s }))) : oe.createElement(Yf, null, oe.createElement(_E, { ref: n, open: o, ...s }));
}
let Hq = "div";
function Uq(e, n) {
  let r = Et(), { id: o = `headlessui-dialog-panel-${r}`, transition: s = !1, ...u } = e, [{ dialogState: h, unmount: f }, p] = bg("Dialog.Panel"), v = vt(n, p.panelRef), b = Re(() => ({ open: h === 0 }), [h]), y = ye((D) => {
    D.stopPropagation();
  }), k = { ref: v, id: o, onClick: y }, _ = s ? Uo : ft, E = s ? { unmount: f } : {}, x = st();
  return oe.createElement(_, { ...E }, x({ ourProps: k, theirProps: u, slot: b, defaultTag: Hq, name: "Dialog.Panel" }));
}
let Wq = "div";
function Gq(e, n) {
  let { transition: r = !1, ...o } = e, [{ dialogState: s, unmount: u }] = bg("Dialog.Backdrop"), h = Re(() => ({ open: s === 0 }), [s]), f = { ref: n, "aria-hidden": !0 }, p = r ? Uo : ft, v = r ? { unmount: u } : {}, b = st();
  return oe.createElement(p, { ...v }, b({ ourProps: f, theirProps: o, slot: h, defaultTag: Wq, name: "Dialog.Backdrop" }));
}
let qq = "h2";
function Kq(e, n) {
  let r = Et(), { id: o = `headlessui-dialog-title-${r}`, ...s } = e, [{ dialogState: u, setTitleId: h }] = bg("Dialog.Title"), f = vt(n);
  Xe(() => (h(o), () => h(null)), [o, h]);
  let p = Re(() => ({ open: u === 0 }), [u]), v = { ref: f, id: o };
  return st()({ ourProps: v, theirProps: s, slot: p, defaultTag: qq, name: "Dialog.Title" });
}
let Yq = nt(Vq), wg = nt(Uq);
nt(Gq);
let yg = nt(Kq), Ss = Object.assign(Yq, { Panel: wg, Title: yg, Description: T1 });
var AE;
let Qq = (AE = oe.startTransition) != null ? AE : function(e) {
  e();
};
var Zq = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Zq || {}), Xq = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(Xq || {});
let Jq = { [0]: (e) => ({ ...e, disclosureState: Nt(e.disclosureState, { [0]: 1, [1]: 0 }) }), [1]: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, [2](e, n) {
  return e.buttonId === n.buttonId ? e : { ...e, buttonId: n.buttonId };
}, [3](e, n) {
  return e.panelId === n.panelId ? e : { ...e, panelId: n.panelId };
}, [4](e, n) {
  return e.buttonElement === n.element ? e : { ...e, buttonElement: n.element };
}, [5](e, n) {
  return e.panelElement === n.element ? e : { ...e, panelElement: n.element };
} }, K1 = _t(null);
K1.displayName = "DisclosureContext";
function Y1(e) {
  let n = tt(K1);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Y1), r;
  }
  return n;
}
let Q1 = _t(null);
Q1.displayName = "DisclosureAPIContext";
function bI(e) {
  let n = tt(Q1);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, bI), r;
  }
  return n;
}
let Z1 = _t(null);
Z1.displayName = "DisclosurePanelContext";
function eK() {
  return tt(Z1);
}
function tK(e, n) {
  return Nt(n.type, Jq, e, n);
}
let nK = ft;
function rK(e, n) {
  let { defaultOpen: r = !1, ...o } = e, s = Le(null), u = vt(n, S1((x) => {
    s.current = x;
  }, e.as === void 0 || e.as === ft)), h = Ri(tK, { disclosureState: r ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: f, buttonId: p }, v] = h, b = ye((x) => {
    v({ type: 1 });
    let D = Ni(s);
    if (!D || !p)
      return;
    let I = (() => x ? x instanceof HTMLElement ? x : x.current instanceof HTMLElement ? x.current : D.getElementById(p) : D.getElementById(p))();
    I?.focus();
  }), y = Re(() => ({ close: b }), [b]), k = Re(() => ({ open: f === 0, close: b }), [f, b]), _ = { ref: u }, E = st();
  return oe.createElement(K1.Provider, { value: h }, oe.createElement(Q1.Provider, { value: y }, oe.createElement(I1, { value: b }, oe.createElement(cd, { value: Nt(f, { [0]: Qt.Open, [1]: Qt.Closed }) }, E({ ourProps: _, theirProps: o, slot: k, defaultTag: nK, name: "Disclosure" })))));
}
let iK = "button";
function oK(e, n) {
  let r = Et(), { id: o = `headlessui-disclosure-button-${r}`, disabled: s = !1, autoFocus: u = !1, ...h } = e, [f, p] = Y1("Disclosure.Button"), v = eK(), b = v === null ? !1 : v === f.panelId, y = Le(null), k = vt(y, n, ye((U) => {
    if (!b)
      return p({ type: 4, element: U });
  }));
  Xe(() => {
    if (!b)
      return p({ type: 2, buttonId: o }), () => {
        p({ type: 2, buttonId: null });
      };
  }, [o, p, b]);
  let _ = ye((U) => {
    var G;
    if (b) {
      if (f.disclosureState === 1)
        return;
      switch (U.key) {
        case ze.Space:
        case ze.Enter:
          U.preventDefault(), U.stopPropagation(), p({ type: 0 }), (G = f.buttonElement) == null || G.focus();
          break;
      }
    } else
      switch (U.key) {
        case ze.Space:
        case ze.Enter:
          U.preventDefault(), U.stopPropagation(), p({ type: 0 });
          break;
      }
  }), E = ye((U) => {
    switch (U.key) {
      case ze.Space:
        U.preventDefault();
        break;
    }
  }), x = ye((U) => {
    var G;
    $a(U.currentTarget) || s || (b ? (p({ type: 0 }), (G = f.buttonElement) == null || G.focus()) : p({ type: 0 }));
  }), { isFocusVisible: D, focusProps: I } = wo({ autoFocus: u }), { isHovered: N, hoverProps: O } = Yo({ isDisabled: s }), { pressed: P, pressProps: S } = Jl({ disabled: s }), $ = Re(() => ({ open: f.disclosureState === 0, hover: N, active: P, disabled: s, focus: D, autofocus: u }), [f, N, P, D, s, u]), L = rc(e, f.buttonElement), B = kr(b ? { ref: k, type: L, disabled: s || void 0, autoFocus: u, onKeyDown: _, onClick: x } : { ref: k, id: o, type: L, "aria-expanded": f.disclosureState === 0, "aria-controls": f.panelElement ? f.panelId : void 0, disabled: s || void 0, autoFocus: u, onKeyDown: _, onKeyUp: E, onClick: x }, I, O, S);
  return st()({ ourProps: B, theirProps: h, slot: $, defaultTag: iK, name: "Disclosure.Button" });
}
let aK = "div", sK = gr.RenderStrategy | gr.Static;
function lK(e, n) {
  let r = Et(), { id: o = `headlessui-disclosure-panel-${r}`, transition: s = !1, ...u } = e, [h, f] = Y1("Disclosure.Panel"), { close: p } = bI("Disclosure.Panel"), [v, b] = Ve(null), y = vt(n, ye((N) => {
    Qq(() => f({ type: 5, element: N }));
  }), b);
  Xe(() => (f({ type: 3, panelId: o }), () => {
    f({ type: 3, panelId: null });
  }), [o, f]);
  let k = Xo(), [_, E] = oc(s, v, k !== null ? (k & Qt.Open) === Qt.Open : h.disclosureState === 0), x = Re(() => ({ open: h.disclosureState === 0, close: p }), [h.disclosureState, p]), D = { ref: y, id: o, ...ic(E) }, I = st();
  return oe.createElement(V1, null, oe.createElement(Z1.Provider, { value: h.panelId }, I({ ourProps: D, theirProps: u, slot: x, defaultTag: aK, features: sK, visible: _, name: "Disclosure.Panel" })));
}
let cK = nt(rK), uK = nt(oK), dK = nt(lK), yv = Object.assign(cK, { Button: uK, Panel: dK }), hK = "div";
function fK(e, n) {
  let r = `headlessui-control-${Et()}`, [o, s] = Hs(), [u, h] = ec(), f = Vs(), { disabled: p = f || !1, ...v } = e, b = Re(() => ({ disabled: p }), [p]), y = { ref: n, disabled: p || void 0, "aria-disabled": p || void 0 }, k = st();
  return oe.createElement(OU, { value: p }, oe.createElement(s, { value: o }, oe.createElement(h, { value: u }, oe.createElement(HU, { id: r }, k({ ourProps: y, theirProps: { ...v, children: oe.createElement(FU, null, typeof v.children == "function" ? v.children(b) : v.children) }, slot: b, defaultTag: hK, name: "Field" })))));
}
let wI = nt(fK);
function pK(e, n) {
  let r = Le({ left: 0, top: 0 });
  if (ct(() => {
    if (!n)
      return;
    let s = n.getBoundingClientRect();
    s && (r.current = s);
  }, [e, n]), n == null || !e || n === document.activeElement)
    return !1;
  let o = n.getBoundingClientRect();
  return o.top !== r.current.top || o.left !== r.current.left;
}
let CE = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function xE(e) {
  var n, r;
  let o = (n = e.innerText) != null ? n : "", s = e.cloneNode(!0);
  if (!(s instanceof HTMLElement))
    return o;
  let u = !1;
  for (let f of s.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    f.remove(), u = !0;
  let h = u ? (r = s.innerText) != null ? r : "" : o;
  return CE.test(h) && (h = h.replace(CE, "")), h;
}
function gK(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string")
    return n.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let o = r.split(" ").map((s) => {
      let u = document.getElementById(s);
      if (u) {
        let h = u.getAttribute("aria-label");
        return typeof h == "string" ? h.trim() : xE(u).trim();
      }
      return null;
    }).filter(Boolean);
    if (o.length > 0)
      return o.join(", ");
  }
  return xE(e).trim();
}
function mK(e) {
  let n = Le(""), r = Le("");
  return ye(() => {
    let o = e.current;
    if (!o)
      return "";
    let s = o.innerText;
    if (n.current === s)
      return r.current;
    let u = gK(o).trim().toLowerCase();
    return n.current = s, r.current = u, u;
  });
}
var vK = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(vK || {}), bK = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(bK || {}), wK = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(wK || {});
function kv(e, n = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, o = Bo(n(e.items.slice()), (u) => u.dataRef.current.domRef.current), s = r ? o.indexOf(r) : null;
  return s === -1 && (s = null), { items: o, activeItemIndex: s };
}
let yK = { [1](e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, [0](e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, [2]: (e, n) => {
  var r, o, s, u, h;
  if (e.menuState === 1)
    return e;
  let f = { ...e, searchQuery: "", activationTrigger: (r = n.trigger) != null ? r : 1, __demoMode: !1 };
  if (n.focus === xt.Nothing)
    return { ...f, activeItemIndex: null };
  if (n.focus === xt.Specific)
    return { ...f, activeItemIndex: e.items.findIndex((b) => b.id === n.id) };
  if (n.focus === xt.Previous) {
    let b = e.activeItemIndex;
    if (b !== null) {
      let y = e.items[b].dataRef.current.domRef, k = ju(n, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (_) => _.id, resolveDisabled: (_) => _.dataRef.current.disabled });
      if (k !== null) {
        let _ = e.items[k].dataRef.current.domRef;
        if (((o = y.current) == null ? void 0 : o.previousElementSibling) === _.current || ((s = _.current) == null ? void 0 : s.previousElementSibling) === null)
          return { ...f, activeItemIndex: k };
      }
    }
  } else if (n.focus === xt.Next) {
    let b = e.activeItemIndex;
    if (b !== null) {
      let y = e.items[b].dataRef.current.domRef, k = ju(n, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (_) => _.id, resolveDisabled: (_) => _.dataRef.current.disabled });
      if (k !== null) {
        let _ = e.items[k].dataRef.current.domRef;
        if (((u = y.current) == null ? void 0 : u.nextElementSibling) === _.current || ((h = _.current) == null ? void 0 : h.nextElementSibling) === null)
          return { ...f, activeItemIndex: k };
      }
    }
  }
  let p = kv(e), v = ju(n, { resolveItems: () => p.items, resolveActiveIndex: () => p.activeItemIndex, resolveId: (b) => b.id, resolveDisabled: (b) => b.dataRef.current.disabled });
  return { ...f, ...p, activeItemIndex: v };
}, [3]: (e, n) => {
  let r = e.searchQuery !== "" ? 0 : 1, o = e.searchQuery + n.value.toLowerCase(), s = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((h) => {
    var f;
    return ((f = h.dataRef.current.textValue) == null ? void 0 : f.startsWith(o)) && !h.dataRef.current.disabled;
  }), u = s ? e.items.indexOf(s) : -1;
  return u === -1 || u === e.activeItemIndex ? { ...e, searchQuery: o } : { ...e, searchQuery: o, activeItemIndex: u, activationTrigger: 1 };
}, [4](e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, [5]: (e, n) => {
  let r = kv(e, (o) => [...o, { id: n.id, dataRef: n.dataRef }]);
  return { ...e, ...r };
}, [6]: (e, n) => {
  let r = kv(e, (o) => {
    let s = o.findIndex((u) => u.id === n.id);
    return s !== -1 && o.splice(s, 1), o;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, [7]: (e, n) => e.buttonElement === n.element ? e : { ...e, buttonElement: n.element }, [8]: (e, n) => e.itemsElement === n.element ? e : { ...e, itemsElement: n.element } }, X1 = _t(null);
X1.displayName = "MenuContext";
function kg(e) {
  let n = tt(X1);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, kg), r;
  }
  return n;
}
function kK(e, n) {
  return Nt(n.type, yK, e, n);
}
let _K = ft;
function AK(e, n) {
  let { __demoMode: r = !1, ...o } = e, s = Ri(kK, { __demoMode: r, menuState: r ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: u, itemsElement: h, buttonElement: f }, p] = s, v = vt(n);
  ag(u === 0, [f, h], (E, x) => {
    p({ type: 1 }), og(x, ig.Loose) || (E.preventDefault(), f?.focus());
  });
  let b = ye(() => {
    p({ type: 1 });
  }), y = Re(() => ({ open: u === 0, close: b }), [u, b]), k = { ref: v }, _ = st();
  return oe.createElement(z1, null, oe.createElement(X1.Provider, { value: s }, oe.createElement(cd, { value: Nt(u, { [0]: Qt.Open, [1]: Qt.Closed }) }, _({ ourProps: k, theirProps: o, slot: y, defaultTag: _K, name: "Menu" }))));
}
let CK = "button";
function xK(e, n) {
  var r;
  let o = Et(), { id: s = `headlessui-menu-button-${o}`, disabled: u = !1, autoFocus: h = !1, ...f } = e, [p, v] = kg("Menu.Button"), b = FG(), y = vt(n, j1(), ye((L) => v({ type: 7, element: L }))), k = ye((L) => {
    switch (L.key) {
      case ze.Space:
      case ze.Enter:
      case ze.ArrowDown:
        L.preventDefault(), L.stopPropagation(), oi(() => v({ type: 0 })), v({ type: 2, focus: xt.First });
        break;
      case ze.ArrowUp:
        L.preventDefault(), L.stopPropagation(), oi(() => v({ type: 0 })), v({ type: 2, focus: xt.Last });
        break;
    }
  }), _ = ye((L) => {
    switch (L.key) {
      case ze.Space:
        L.preventDefault();
        break;
    }
  }), E = ye((L) => {
    var B;
    if ($a(L.currentTarget))
      return L.preventDefault();
    u || (p.menuState === 0 ? (oi(() => v({ type: 1 })), (B = p.buttonElement) == null || B.focus({ preventScroll: !0 })) : (L.preventDefault(), v({ type: 0 })));
  }), { isFocusVisible: x, focusProps: D } = wo({ autoFocus: h }), { isHovered: I, hoverProps: N } = Yo({ isDisabled: u }), { pressed: O, pressProps: P } = Jl({ disabled: u }), S = Re(() => ({ open: p.menuState === 0, active: O || p.menuState === 0, disabled: u, hover: I, focus: x, autofocus: h }), [p, I, x, O, u, h]), $ = kr(b(), { ref: y, id: s, type: rc(e, p.buttonElement), "aria-haspopup": "menu", "aria-controls": (r = p.itemsElement) == null ? void 0 : r.id, "aria-expanded": p.menuState === 0, disabled: u || void 0, autoFocus: h, onKeyDown: k, onKeyUp: _, onClick: E }, D, N, P);
  return st()({ ourProps: $, theirProps: f, slot: S, defaultTag: CK, name: "Menu.Button" });
}
let EK = "div", SK = gr.RenderStrategy | gr.Static;
function MK(e, n) {
  var r, o;
  let s = Et(), { id: u = `headlessui-menu-items-${s}`, anchor: h, portal: f = !1, modal: p = !0, transition: v = !1, ...b } = e, y = L1(h), [k, _] = kg("Menu.Items"), [E, x] = F1(y), D = B1(), [I, N] = Ve(null), O = vt(n, y ? E : null, ye((ce) => _({ type: 8, element: ce })), N), P = $i(k.itemsElement);
  y && (f = !0);
  let S = Xo(), [$, L] = oc(v, I, S !== null ? (S & Qt.Open) === Qt.Open : k.menuState === 0);
  rg($, k.buttonElement, () => {
    _({ type: 1 });
  });
  let B = k.__demoMode ? !1 : p && k.menuState === 0;
  lg(B, P);
  let U = k.__demoMode ? !1 : p && k.menuState === 0;
  P1(U, { allowed: et(() => [k.buttonElement, k.itemsElement], [k.buttonElement, k.itemsElement]) });
  let G = k.menuState !== 0, q = pK(G, k.buttonElement) ? !1 : $;
  Xe(() => {
    let ce = k.itemsElement;
    ce && k.menuState === 0 && ce !== P?.activeElement && ce.focus({ preventScroll: !0 });
  }, [k.menuState, k.itemsElement, P]), $4(k.menuState === 0, { container: k.itemsElement, accept(ce) {
    return ce.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : ce.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(ce) {
    ce.setAttribute("role", "none");
  } });
  let Y = Qo(), Q = ye((ce) => {
    var ue, X, se;
    switch (Y.dispose(), ce.key) {
      case ze.Space:
        if (k.searchQuery !== "")
          return ce.preventDefault(), ce.stopPropagation(), _({ type: 3, value: ce.key });
      case ze.Enter:
        if (ce.preventDefault(), ce.stopPropagation(), _({ type: 1 }), k.activeItemIndex !== null) {
          let { dataRef: he } = k.items[k.activeItemIndex];
          (X = (ue = he.current) == null ? void 0 : ue.domRef.current) == null || X.click();
        }
        D4(k.buttonElement);
        break;
      case ze.ArrowDown:
        return ce.preventDefault(), ce.stopPropagation(), _({ type: 2, focus: xt.Next });
      case ze.ArrowUp:
        return ce.preventDefault(), ce.stopPropagation(), _({ type: 2, focus: xt.Previous });
      case ze.Home:
      case ze.PageUp:
        return ce.preventDefault(), ce.stopPropagation(), _({ type: 2, focus: xt.First });
      case ze.End:
      case ze.PageDown:
        return ce.preventDefault(), ce.stopPropagation(), _({ type: 2, focus: xt.Last });
      case ze.Escape:
        ce.preventDefault(), ce.stopPropagation(), oi(() => _({ type: 1 })), (se = k.buttonElement) == null || se.focus({ preventScroll: !0 });
        break;
      case ze.Tab:
        ce.preventDefault(), ce.stopPropagation(), oi(() => _({ type: 1 })), _W(k.buttonElement, ce.shiftKey ? Pt.Previous : Pt.Next);
        break;
      default:
        ce.key.length === 1 && (_({ type: 3, value: ce.key }), Y.setTimeout(() => _({ type: 4 }), 350));
        break;
    }
  }), Z = ye((ce) => {
    switch (ce.key) {
      case ze.Space:
        ce.preventDefault();
        break;
    }
  }), ae = Re(() => ({ open: k.menuState === 0 }), [k.menuState]), ie = kr(y ? D() : {}, { "aria-activedescendant": k.activeItemIndex === null || (r = k.items[k.activeItemIndex]) == null ? void 0 : r.id, "aria-labelledby": (o = k.buttonElement) == null ? void 0 : o.id, id: u, onKeyDown: Q, onKeyUp: Z, role: "menu", tabIndex: k.menuState === 0 ? 0 : void 0, ref: O, style: { ...b.style, ...x, "--button-width": Hf(k.buttonElement, !0).width }, ...ic(L) }), pe = st();
  return oe.createElement(fg, { enabled: f ? e.static || $ : !1 }, pe({ ourProps: ie, theirProps: b, slot: ae, defaultTag: EK, features: SK, visible: q, name: "Menu.Items" }));
}
let TK = ft;
function DK(e, n) {
  let r = Et(), { id: o = `headlessui-menu-item-${r}`, disabled: s = !1, ...u } = e, [h, f] = kg("Menu.Item"), p = h.activeItemIndex !== null ? h.items[h.activeItemIndex].id === o : !1, v = Le(null), b = vt(n, v);
  ct(() => {
    if (!h.__demoMode && h.menuState === 0 && p && h.activationTrigger !== 0)
      return fi().requestAnimationFrame(() => {
        var q, Y;
        (Y = (q = v.current) == null ? void 0 : q.scrollIntoView) == null || Y.call(q, { block: "nearest" });
      });
  }, [h.__demoMode, v, p, h.menuState, h.activationTrigger, h.activeItemIndex]);
  let y = mK(v), k = Le({ disabled: s, domRef: v, get textValue() {
    return y();
  } });
  ct(() => {
    k.current.disabled = s;
  }, [k, s]), ct(() => (f({ type: 5, id: o, dataRef: k }), () => f({ type: 6, id: o })), [k, o]);
  let _ = ye(() => {
    f({ type: 1 });
  }), E = ye((q) => {
    if (s)
      return q.preventDefault();
    f({ type: 1 }), D4(h.buttonElement);
  }), x = ye(() => {
    if (s)
      return f({ type: 2, focus: xt.Nothing });
    f({ type: 2, focus: xt.Specific, id: o });
  }), D = N4(), I = ye((q) => {
    D.update(q), !s && (p || f({ type: 2, focus: xt.Specific, id: o, trigger: 0 }));
  }), N = ye((q) => {
    D.wasMoved(q) && (s || p || f({ type: 2, focus: xt.Specific, id: o, trigger: 0 }));
  }), O = ye((q) => {
    D.wasMoved(q) && (s || p && f({ type: 2, focus: xt.Nothing }));
  }), [P, S] = Hs(), [$, L] = ec(), B = Re(() => ({ active: p, focus: p, disabled: s, close: _ }), [p, s, _]), U = { id: o, ref: b, role: "menuitem", tabIndex: s === !0 ? void 0 : -1, "aria-disabled": s === !0 ? !0 : void 0, "aria-labelledby": P, "aria-describedby": $, disabled: void 0, onClick: E, onFocus: x, onPointerEnter: I, onMouseEnter: I, onPointerMove: N, onMouseMove: N, onPointerLeave: O, onMouseLeave: O }, G = st();
  return oe.createElement(S, null, oe.createElement(L, null, G({ ourProps: U, theirProps: u, slot: B, defaultTag: TK, name: "Menu.Item" })));
}
let IK = "div";
function PK(e, n) {
  let [r, o] = Hs(), s = e, u = { ref: n, "aria-labelledby": r, role: "group" }, h = st();
  return oe.createElement(o, null, h({ ourProps: u, theirProps: s, slot: {}, defaultTag: IK, name: "Menu.Section" }));
}
let OK = "header";
function RK(e, n) {
  let r = Et(), { id: o = `headlessui-menu-heading-${r}`, ...s } = e, u = D1();
  ct(() => u.register(o), [o, u.register]);
  let h = { id: o, ref: n, role: "presentation", ...u.props };
  return st()({ ourProps: h, theirProps: s, slot: {}, defaultTag: OK, name: "Menu.Heading" });
}
let NK = "div";
function $K(e, n) {
  let r = e, o = { ref: n, role: "separator" };
  return st()({ ourProps: o, theirProps: r, slot: {}, defaultTag: NK, name: "Menu.Separator" });
}
let LK = nt(AK), yI = nt(xK), kI = nt(MK), J1 = nt(DK), jK = nt(PK), BK = nt(RK), FK = nt($K), zK = Object.assign(LK, { Button: yI, Items: kI, Item: J1, Section: jK, Heading: BK, Separator: FK });
var VK = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(VK || {}), HK = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(HK || {});
let UK = { [0]: (e) => ({ ...e, popoverState: Nt(e.popoverState, { [0]: 1, [1]: 0 }), __demoMode: !1 }), [1](e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, [2](e, n) {
  return e.button === n.button ? e : { ...e, button: n.button };
}, [3](e, n) {
  return e.buttonId === n.buttonId ? e : { ...e, buttonId: n.buttonId };
}, [4](e, n) {
  return e.panel === n.panel ? e : { ...e, panel: n.panel };
}, [5](e, n) {
  return e.panelId === n.panelId ? e : { ...e, panelId: n.panelId };
} }, ey = _t(null);
ey.displayName = "PopoverContext";
function _g(e) {
  let n = tt(ey);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, _g), r;
  }
  return n;
}
let Ag = _t(null);
Ag.displayName = "PopoverAPIContext";
function ty(e) {
  let n = tt(Ag);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ty), r;
  }
  return n;
}
let ny = _t(null);
ny.displayName = "PopoverGroupContext";
function _I() {
  return tt(ny);
}
let Cg = _t(null);
Cg.displayName = "PopoverPanelContext";
function WK() {
  return tt(Cg);
}
function GK(e, n) {
  return Nt(n.type, UK, e, n);
}
let qK = "div";
function KK(e, n) {
  var r;
  let { __demoMode: o = !1, ...s } = e, u = Le(null), h = vt(n, S1((ue) => {
    u.current = ue;
  })), f = Le([]), p = Ri(GK, { __demoMode: o, popoverState: o ? 0 : 1, buttons: f, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: Nu(), afterPanelSentinel: Nu(), afterButtonSentinel: Nu() }), [{ popoverState: v, button: b, buttonId: y, panel: k, panelId: _, beforePanelSentinel: E, afterPanelSentinel: x, afterButtonSentinel: D }, I] = p, N = $i((r = u.current) != null ? r : b), O = Re(() => {
    if (!b || !k)
      return !1;
    for (let we of document.querySelectorAll("body > *"))
      if (Number(we?.contains(b)) ^ Number(we?.contains(k)))
        return !0;
    let ue = ad(), X = ue.indexOf(b), se = (X + ue.length - 1) % ue.length, he = (X + 1) % ue.length, de = ue[se], me = ue[he];
    return !k.contains(de) && !k.contains(me);
  }, [b, k]), P = hr(y), S = hr(_), $ = Re(() => ({ buttonId: P, panelId: S, close: () => I({ type: 1 }) }), [P, S, I]), L = _I(), B = L?.registerPopover, U = ye(() => {
    var ue;
    return (ue = L?.isFocusWithinPopoverGroup()) != null ? ue : N?.activeElement && (b?.contains(N.activeElement) || k?.contains(N.activeElement));
  });
  Xe(() => B?.($), [B, $]);
  let [G, q] = nI(), Y = W1(b), Q = cI({ mainTreeNode: Y, portals: G, defaultContainers: [b, k] });
  sg(N?.defaultView, "focus", (ue) => {
    var X, se, he, de, me, we;
    ue.target !== window && ue.target instanceof HTMLElement && v === 0 && (U() || b && k && (Q.contains(ue.target) || (se = (X = E.current) == null ? void 0 : X.contains) != null && se.call(X, ue.target) || (de = (he = x.current) == null ? void 0 : he.contains) != null && de.call(he, ue.target) || (we = (me = D.current) == null ? void 0 : me.contains) != null && we.call(me, ue.target) || I({ type: 1 })));
  }, !0), ag(v === 0, Q.resolveContainers, (ue, X) => {
    I({ type: 1 }), og(X, ig.Loose) || (ue.preventDefault(), b?.focus());
  });
  let Z = ye((ue) => {
    I({ type: 1 });
    let X = (() => ue ? ue instanceof HTMLElement ? ue : "current" in ue && ue.current instanceof HTMLElement ? ue.current : b : b)();
    X?.focus();
  }), ae = Re(() => ({ close: Z, isPortalled: O }), [Z, O]), ie = Re(() => ({ open: v === 0, close: Z }), [v, Z]), pe = { ref: h }, ce = st();
  return oe.createElement(Yf, { node: Y }, oe.createElement(z1, null, oe.createElement(Cg.Provider, { value: null }, oe.createElement(ey.Provider, { value: p }, oe.createElement(Ag.Provider, { value: ae }, oe.createElement(I1, { value: Z }, oe.createElement(cd, { value: Nt(v, { [0]: Qt.Open, [1]: Qt.Closed }) }, oe.createElement(q, null, ce({ ourProps: pe, theirProps: s, slot: ie, defaultTag: qK, name: "Popover" })))))))));
}
let YK = "button";
function QK(e, n) {
  let r = Et(), { id: o = `headlessui-popover-button-${r}`, disabled: s = !1, autoFocus: u = !1, ...h } = e, [f, p] = _g("Popover.Button"), { isPortalled: v } = ty("Popover.Button"), b = Le(null), y = `headlessui-focus-sentinel-${Et()}`, k = _I(), _ = k?.closeOthers, E = WK() !== null;
  Xe(() => {
    if (!E)
      return p({ type: 3, buttonId: o }), () => {
        p({ type: 3, buttonId: null });
      };
  }, [E, o, p]);
  let [x] = Ve(() => Symbol()), D = vt(b, n, j1(), ye((X) => {
    if (!E) {
      if (X)
        f.buttons.current.push(x);
      else {
        let se = f.buttons.current.indexOf(x);
        se !== -1 && f.buttons.current.splice(se, 1);
      }
      f.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), X && p({ type: 2, button: X });
    }
  })), I = vt(b, n), N = $i(b), O = ye((X) => {
    var se, he, de;
    if (E) {
      if (f.popoverState === 1)
        return;
      switch (X.key) {
        case ze.Space:
        case ze.Enter:
          X.preventDefault(), (he = (se = X.target).click) == null || he.call(se), p({ type: 1 }), (de = f.button) == null || de.focus();
          break;
      }
    } else
      switch (X.key) {
        case ze.Space:
        case ze.Enter:
          X.preventDefault(), X.stopPropagation(), f.popoverState === 1 && _?.(f.buttonId), p({ type: 0 });
          break;
        case ze.Escape:
          if (f.popoverState !== 0)
            return _?.(f.buttonId);
          if (!b.current || N != null && N.activeElement && !b.current.contains(N.activeElement))
            return;
          X.preventDefault(), X.stopPropagation(), p({ type: 1 });
          break;
      }
  }), P = ye((X) => {
    E || X.key === ze.Space && X.preventDefault();
  }), S = ye((X) => {
    var se, he;
    $a(X.currentTarget) || s || (E ? (p({ type: 1 }), (se = f.button) == null || se.focus()) : (X.preventDefault(), X.stopPropagation(), f.popoverState === 1 && _?.(f.buttonId), p({ type: 0 }), (he = f.button) == null || he.focus()));
  }), $ = ye((X) => {
    X.preventDefault(), X.stopPropagation();
  }), { isFocusVisible: L, focusProps: B } = wo({ autoFocus: u }), { isHovered: U, hoverProps: G } = Yo({ isDisabled: s }), { pressed: q, pressProps: Y } = Jl({ disabled: s }), Q = f.popoverState === 0, Z = Re(() => ({ open: Q, active: q || Q, disabled: s, hover: U, focus: L, autofocus: u }), [Q, U, L, q, s, u]), ae = rc(e, f.button), ie = kr(E ? { ref: I, type: ae, onKeyDown: O, onClick: S, disabled: s || void 0, autoFocus: u } : { ref: D, id: f.buttonId, type: ae, "aria-expanded": f.popoverState === 0, "aria-controls": f.panel ? f.panelId : void 0, disabled: s || void 0, autoFocus: u, onKeyDown: O, onKeyUp: P, onClick: S, onMouseDown: $ }, B, G, Y), pe = G1(), ce = ye(() => {
    let X = f.panel;
    if (!X)
      return;
    function se() {
      Nt(pe.current, { [Br.Forwards]: () => $n(X, Pt.First), [Br.Backwards]: () => $n(X, Pt.Last) }) === si.Error && $n(ad().filter((he) => he.dataset.headlessuiFocusGuard !== "true"), Nt(pe.current, { [Br.Forwards]: Pt.Next, [Br.Backwards]: Pt.Previous }), { relativeTo: f.button });
    }
    se();
  }), ue = st();
  return oe.createElement(oe.Fragment, null, ue({ ourProps: ie, theirProps: h, slot: Z, defaultTag: YK, name: "Popover.Button" }), Q && !E && v && oe.createElement(Pi, { id: y, ref: f.afterButtonSentinel, features: Ii.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: ce }));
}
let ZK = "div", XK = gr.RenderStrategy | gr.Static;
function AI(e, n) {
  let r = Et(), { id: o = `headlessui-popover-backdrop-${r}`, transition: s = !1, ...u } = e, [{ popoverState: h }, f] = _g("Popover.Backdrop"), [p, v] = Ve(null), b = vt(n, v), y = Xo(), [k, _] = oc(s, p, y !== null ? (y & Qt.Open) === Qt.Open : h === 0), E = ye((I) => {
    if ($a(I.currentTarget))
      return I.preventDefault();
    f({ type: 1 });
  }), x = Re(() => ({ open: h === 0 }), [h]), D = { ref: b, id: o, "aria-hidden": !0, onClick: E, ...ic(_) };
  return st()({ ourProps: D, theirProps: u, slot: x, defaultTag: ZK, features: XK, visible: k, name: "Popover.Backdrop" });
}
let JK = "div", eY = gr.RenderStrategy | gr.Static;
function tY(e, n) {
  let r = Et(), { id: o = `headlessui-popover-panel-${r}`, focus: s = !1, anchor: u, portal: h = !1, modal: f = !1, transition: p = !1, ...v } = e, [b, y] = _g("Popover.Panel"), { close: k, isPortalled: _ } = ty("Popover.Panel"), E = `headlessui-focus-sentinel-before-${r}`, x = `headlessui-focus-sentinel-after-${r}`, D = Le(null), I = L1(u), [N, O] = F1(I), P = B1();
  I && (h = !0);
  let [S, $] = Ve(null), L = vt(D, n, I ? N : null, ye((X) => y({ type: 4, panel: X })), $), B = $i(D);
  ct(() => (y({ type: 5, panelId: o }), () => {
    y({ type: 5, panelId: null });
  }), [o, y]);
  let U = Xo(), [G, q] = oc(p, S, U !== null ? (U & Qt.Open) === Qt.Open : b.popoverState === 0);
  rg(G, b.button, () => {
    y({ type: 1 });
  });
  let Y = b.__demoMode ? !1 : f && G;
  lg(Y, B);
  let Q = ye((X) => {
    var se;
    switch (X.key) {
      case ze.Escape:
        if (b.popoverState !== 0 || !D.current || B != null && B.activeElement && !D.current.contains(B.activeElement))
          return;
        X.preventDefault(), X.stopPropagation(), y({ type: 1 }), (se = b.button) == null || se.focus();
        break;
    }
  });
  Xe(() => {
    var X;
    e.static || b.popoverState === 1 && ((X = e.unmount) == null || X) && y({ type: 4, panel: null });
  }, [b.popoverState, e.unmount, e.static, y]), Xe(() => {
    if (b.__demoMode || !s || b.popoverState !== 0 || !D.current)
      return;
    let X = B?.activeElement;
    D.current.contains(X) || $n(D.current, Pt.First);
  }, [b.__demoMode, s, D.current, b.popoverState]);
  let Z = Re(() => ({ open: b.popoverState === 0, close: k }), [b.popoverState, k]), ae = kr(I ? P() : {}, { ref: L, id: o, onKeyDown: Q, onBlur: s && b.popoverState === 0 ? (X) => {
    var se, he, de, me, we;
    let Ae = X.relatedTarget;
    Ae && D.current && ((se = D.current) != null && se.contains(Ae) || (y({ type: 1 }), ((de = (he = b.beforePanelSentinel.current) == null ? void 0 : he.contains) != null && de.call(he, Ae) || (we = (me = b.afterPanelSentinel.current) == null ? void 0 : me.contains) != null && we.call(me, Ae)) && Ae.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...v.style, ...O, "--button-width": Hf(b.button, !0).width }, ...ic(q) }), ie = G1(), pe = ye(() => {
    let X = D.current;
    if (!X)
      return;
    function se() {
      Nt(ie.current, { [Br.Forwards]: () => {
        var he;
        $n(X, Pt.First) === si.Error && ((he = b.afterPanelSentinel.current) == null || he.focus());
      }, [Br.Backwards]: () => {
        var he;
        (he = b.button) == null || he.focus({ preventScroll: !0 });
      } });
    }
    se();
  }), ce = ye(() => {
    let X = D.current;
    if (!X)
      return;
    function se() {
      Nt(ie.current, { [Br.Forwards]: () => {
        if (!b.button)
          return;
        let he = ad(), de = he.indexOf(b.button), me = he.slice(0, de + 1), we = [...he.slice(de + 1), ...me];
        for (let Ae of we.slice())
          if (Ae.dataset.headlessuiFocusGuard === "true" || S != null && S.contains(Ae)) {
            let Se = we.indexOf(Ae);
            Se !== -1 && we.splice(Se, 1);
          }
        $n(we, Pt.First, { sorted: !1 });
      }, [Br.Backwards]: () => {
        var he;
        $n(X, Pt.Previous) === si.Error && ((he = b.button) == null || he.focus());
      } });
    }
    se();
  }), ue = st();
  return oe.createElement(V1, null, oe.createElement(Cg.Provider, { value: o }, oe.createElement(Ag.Provider, { value: { close: k, isPortalled: _ } }, oe.createElement(fg, { enabled: h ? e.static || G : !1 }, G && _ && oe.createElement(Pi, { id: E, ref: b.beforePanelSentinel, features: Ii.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: pe }), ue({ ourProps: ae, theirProps: v, slot: Z, defaultTag: JK, features: eY, visible: G, name: "Popover.Panel" }), G && _ && oe.createElement(Pi, { id: x, ref: b.afterPanelSentinel, features: Ii.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: ce })))));
}
let nY = "div";
function rY(e, n) {
  let r = Le(null), o = vt(r, n), [s, u] = Ve([]), h = ye((x) => {
    u((D) => {
      let I = D.indexOf(x);
      if (I !== -1) {
        let N = D.slice();
        return N.splice(I, 1), N;
      }
      return D;
    });
  }), f = ye((x) => (u((D) => [...D, x]), () => h(x))), p = ye(() => {
    var x;
    let D = Ni(r);
    if (!D)
      return !1;
    let I = D.activeElement;
    return (x = r.current) != null && x.contains(I) ? !0 : s.some((N) => {
      var O, P;
      return ((O = D.getElementById(N.buttonId.current)) == null ? void 0 : O.contains(I)) || ((P = D.getElementById(N.panelId.current)) == null ? void 0 : P.contains(I));
    });
  }), v = ye((x) => {
    for (let D of s)
      D.buttonId.current !== x && D.close();
  }), b = Re(() => ({ registerPopover: f, unregisterPopover: h, isFocusWithinPopoverGroup: p, closeOthers: v }), [f, h, p, v]), y = Re(() => ({}), []), k = e, _ = { ref: o }, E = st();
  return oe.createElement(Yf, null, oe.createElement(ny.Provider, { value: b }, E({ ourProps: _, theirProps: k, slot: y, defaultTag: nY, name: "Popover.Group" })));
}
let iY = nt(KK), ry = nt(QK), oY = nt(AI), aY = nt(AI), iy = nt(tY), sY = nt(rY), Ms = Object.assign(iY, { Button: ry, Backdrop: aY, Overlay: oY, Panel: iy, Group: sY });
var lY = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(lY || {});
let cY = { [0](e, n) {
  let r = [...e.options, { id: n.id, element: n.element, propsRef: n.propsRef }];
  return { ...e, options: Bo(r, (o) => o.element.current) };
}, [1](e, n) {
  let r = e.options.slice(), o = e.options.findIndex((s) => s.id === n.id);
  return o === -1 ? e : (r.splice(o, 1), { ...e, options: r });
} }, oy = _t(null);
oy.displayName = "RadioGroupDataContext";
function ay(e) {
  let n = tt(oy);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ay), r;
  }
  return n;
}
let sy = _t(null);
sy.displayName = "RadioGroupActionsContext";
function ly(e) {
  let n = tt(sy);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ly), r;
  }
  return n;
}
function uY(e, n) {
  return Nt(n.type, cY, e, n);
}
let dY = "div";
function hY(e, n) {
  let r = Et(), o = Vs(), { id: s = `headlessui-radiogroup-${r}`, value: u, form: h, name: f, onChange: p, by: v, disabled: b = o || !1, defaultValue: y, ...k } = e, _ = S4(v), [E, x] = Ri(uY, { options: [] }), D = E.options, [I, N] = Hs(), [O, P] = ec(), S = Le(null), $ = vt(S, n), L = x1(y), [B, U] = C1(u, p, L), G = Re(() => D.find((se) => !se.propsRef.current.disabled), [D]), q = Re(() => D.some((se) => _(se.propsRef.current.value, B)), [D, B]), Y = ye((se) => {
    var he;
    if (b || _(se, B))
      return !1;
    let de = (he = D.find((me) => _(me.propsRef.current.value, se))) == null ? void 0 : he.propsRef.current;
    return de != null && de.disabled ? !1 : (U?.(se), !0);
  }), Q = ye((se) => {
    let he = S.current;
    if (!he)
      return;
    let de = Ni(he), me = D.filter((we) => we.propsRef.current.disabled === !1).map((we) => we.element.current);
    switch (se.key) {
      case ze.Enter:
        k4(se.currentTarget);
        break;
      case ze.ArrowLeft:
      case ze.ArrowUp:
        if (se.preventDefault(), se.stopPropagation(), $n(me, Pt.Previous | Pt.WrapAround) === si.Success) {
          let we = D.find((Ae) => Ae.element.current === de?.activeElement);
          we && Y(we.propsRef.current.value);
        }
        break;
      case ze.ArrowRight:
      case ze.ArrowDown:
        if (se.preventDefault(), se.stopPropagation(), $n(me, Pt.Next | Pt.WrapAround) === si.Success) {
          let we = D.find((Ae) => Ae.element.current === de?.activeElement);
          we && Y(we.propsRef.current.value);
        }
        break;
      case ze.Space:
        {
          se.preventDefault(), se.stopPropagation();
          let we = D.find((Ae) => Ae.element.current === de?.activeElement);
          we && Y(we.propsRef.current.value);
        }
        break;
    }
  }), Z = ye((se) => (x({ type: 0, ...se }), () => x({ type: 1, id: se.id }))), ae = Re(() => ({ value: B, firstOption: G, containsCheckedOption: q, disabled: b, compare: _, ...E }), [B, G, q, b, _, E]), ie = Re(() => ({ registerOption: Z, change: Y }), [Z, Y]), pe = { ref: $, id: s, role: "radiogroup", "aria-labelledby": I, "aria-describedby": O, onKeyDown: Q }, ce = Re(() => ({ value: B }), [B]), ue = et(() => {
    if (L !== void 0)
      return Y(L);
  }, [Y, L]), X = st();
  return oe.createElement(P, { name: "RadioGroup.Description" }, oe.createElement(N, { name: "RadioGroup.Label" }, oe.createElement(sy.Provider, { value: ie }, oe.createElement(oy.Provider, { value: ae }, f != null && oe.createElement(E1, { disabled: b, data: { [f]: B || "on" }, overrides: { type: "radio", checked: B != null }, form: h, onReset: ue }), X({ ourProps: pe, theirProps: k, slot: ce, defaultTag: dY, name: "RadioGroup" })))));
}
let fY = "div";
function pY(e, n) {
  var r;
  let o = ay("RadioGroup.Option"), s = ly("RadioGroup.Option"), u = Et(), { id: h = `headlessui-radiogroup-option-${u}`, value: f, disabled: p = o.disabled || !1, autoFocus: v = !1, ...b } = e, y = Le(null), k = vt(y, n), [_, E] = Hs(), [x, D] = ec(), I = hr({ value: f, disabled: p });
  ct(() => s.registerOption({ id: h, element: y, propsRef: I }), [h, s, y, I]);
  let N = ye((Y) => {
    var Q;
    if ($a(Y.currentTarget))
      return Y.preventDefault();
    s.change(f) && ((Q = y.current) == null || Q.focus());
  }), O = ((r = o.firstOption) == null ? void 0 : r.id) === h, { isFocusVisible: P, focusProps: S } = wo({ autoFocus: v }), { isHovered: $, hoverProps: L } = Yo({ isDisabled: p }), B = o.compare(o.value, f), U = kr({ ref: k, id: h, role: "radio", "aria-checked": B ? "true" : "false", "aria-labelledby": _, "aria-describedby": x, "aria-disabled": p ? !0 : void 0, tabIndex: (() => p ? -1 : B || !o.containsCheckedOption && O ? 0 : -1)(), onClick: p ? void 0 : N, autoFocus: v }, S, L), G = Re(() => ({ checked: B, disabled: p, active: P, hover: $, focus: P, autofocus: v }), [B, p, $, P, v]), q = st();
  return oe.createElement(D, { name: "RadioGroup.Description" }, oe.createElement(E, { name: "RadioGroup.Label" }, q({ ourProps: U, theirProps: b, slot: G, defaultTag: fY, name: "RadioGroup.Option" })));
}
let gY = "span";
function mY(e, n) {
  var r;
  let o = ay("Radio"), s = ly("Radio"), u = Et(), h = eg(), f = Vs(), { id: p = h || `headlessui-radio-${u}`, value: v, disabled: b = o.disabled || f || !1, autoFocus: y = !1, ...k } = e, _ = Le(null), E = vt(_, n), x = tc(), D = M1(), I = hr({ value: v, disabled: b });
  ct(() => s.registerOption({ id: p, element: _, propsRef: I }), [p, s, _, I]);
  let N = ye((q) => {
    var Y;
    if ($a(q.currentTarget))
      return q.preventDefault();
    s.change(v) && ((Y = _.current) == null || Y.focus());
  }), { isFocusVisible: O, focusProps: P } = wo({ autoFocus: y }), { isHovered: S, hoverProps: $ } = Yo({ isDisabled: b }), L = ((r = o.firstOption) == null ? void 0 : r.id) === p, B = o.compare(o.value, v), U = kr({ ref: E, id: p, role: "radio", "aria-checked": B ? "true" : "false", "aria-labelledby": x, "aria-describedby": D, "aria-disabled": b ? !0 : void 0, tabIndex: (() => b ? -1 : B || !o.containsCheckedOption && L ? 0 : -1)(), autoFocus: y, onClick: b ? void 0 : N }, P, $), G = Re(() => ({ checked: B, disabled: b, hover: S, focus: O, autofocus: y }), [B, b, S, O, y]);
  return st()({ ourProps: U, theirProps: k, slot: G, defaultTag: gY, name: "Radio" });
}
let vY = nt(hY), bY = nt(pY), CI = nt(mY), wY = od, yY = T1, kY = Object.assign(vY, { Option: bY, Radio: CI, Label: wY, Description: yY }), cy = _t(null);
cy.displayName = "GroupContext";
let _Y = ft;
function AY(e) {
  var n;
  let [r, o] = Ve(null), [s, u] = Hs(), [h, f] = ec(), p = Re(() => ({ switch: r, setSwitch: o }), [r, o]), v = {}, b = e, y = st();
  return oe.createElement(f, { name: "Switch.Description", value: h }, oe.createElement(u, { name: "Switch.Label", value: s, props: { htmlFor: (n = p.switch) == null ? void 0 : n.id, onClick(k) {
    r && (k.currentTarget instanceof HTMLLabelElement && k.preventDefault(), r.click(), r.focus({ preventScroll: !0 }));
  } } }, oe.createElement(cy.Provider, { value: p }, y({ ourProps: v, theirProps: b, slot: {}, defaultTag: _Y, name: "Switch.Group" }))));
}
let CY = "button";
function xY(e, n) {
  var r;
  let o = Et(), s = eg(), u = Vs(), { id: h = s || `headlessui-switch-${o}`, disabled: f = u || !1, checked: p, defaultChecked: v, onChange: b, name: y, value: k, form: _, autoFocus: E = !1, ...x } = e, D = tt(cy), [I, N] = Ve(null), O = Le(null), P = vt(O, n, D === null ? null : D.setSwitch, N), S = x1(v), [$, L] = C1(p, b, S ?? !1), B = Qo(), [U, G] = Ve(!1), q = ye(() => {
    G(!0), L?.(!$), B.nextFrame(() => {
      G(!1);
    });
  }), Y = ye((Se) => {
    if ($a(Se.currentTarget))
      return Se.preventDefault();
    Se.preventDefault(), q();
  }), Q = ye((Se) => {
    Se.key === ze.Space ? (Se.preventDefault(), q()) : Se.key === ze.Enter && k4(Se.currentTarget);
  }), Z = ye((Se) => Se.preventDefault()), ae = tc(), ie = M1(), { isFocusVisible: pe, focusProps: ce } = wo({ autoFocus: E }), { isHovered: ue, hoverProps: X } = Yo({ isDisabled: f }), { pressed: se, pressProps: he } = Jl({ disabled: f }), de = Re(() => ({ checked: $, disabled: f, hover: ue, focus: pe, active: se, autofocus: E, changing: U }), [$, ue, pe, se, f, U, E]), me = kr({ id: h, ref: P, role: "switch", type: rc(e, I), tabIndex: e.tabIndex === -1 ? 0 : (r = e.tabIndex) != null ? r : 0, "aria-checked": $, "aria-labelledby": ae, "aria-describedby": ie, disabled: f || void 0, autoFocus: E, onClick: Y, onKeyUp: Q, onKeyPress: Z }, ce, X, he), we = et(() => {
    if (S !== void 0)
      return L?.(S);
  }, [L, S]), Ae = st();
  return oe.createElement(oe.Fragment, null, y != null && oe.createElement(E1, { disabled: f, data: { [y]: k || "on" }, overrides: { type: "checkbox", checked: $ }, form: _, onReset: we }), Ae({ ourProps: me, theirProps: x, slot: de, defaultTag: CY, name: "Switch" }));
}
let EY = nt(xY), SY = AY, MY = od, TY = T1, EE = Object.assign(EY, { Group: SY, Label: MY, Description: TY });
function DY({
  onFocus: e
}) {
  let [n, r] = Ve(!0), o = pg();
  return n ? oe.createElement(Pi, {
    as: "button",
    type: "button",
    features: Ii.Focusable,
    onFocus: (s) => {
      s.preventDefault();
      let u, h = 50;
      function f() {
        if (h-- <= 0) {
          u && cancelAnimationFrame(u);
          return;
        }
        if (e()) {
          if (cancelAnimationFrame(u), !o.current)
            return;
          r(!1);
          return;
        }
        u = requestAnimationFrame(f);
      }
      u = requestAnimationFrame(f);
    }
  }) : null;
}
const xI = ne.createContext(null);
function IY() {
  return { groups: /* @__PURE__ */ new Map(), get(e, n) {
    var r;
    let o = this.groups.get(e);
    o || (o = /* @__PURE__ */ new Map(), this.groups.set(e, o));
    let s = (r = o.get(n)) != null ? r : 0;
    o.set(n, s + 1);
    let u = Array.from(o.keys()).indexOf(n);
    function h() {
      let f = o.get(n);
      f > 1 ? o.set(n, f - 1) : o.delete(n);
    }
    return [u, h];
  } };
}
function PY({ children: e }) {
  let n = ne.useRef(IY());
  return ne.createElement(xI.Provider, { value: n }, e);
}
function EI(e) {
  let n = ne.useContext(xI);
  if (!n)
    throw new Error("You must wrap your component in a <StableCollection>");
  let r = ne.useId(), [o, s] = n.current.get(e, r);
  return ne.useEffect(() => s, []), o;
}
var OY = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(OY || {}), RY = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(RY || {}), NY = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(NY || {});
let $Y = { [0](e, n) {
  var r;
  let o = Bo(e.tabs, (b) => b.current), s = Bo(e.panels, (b) => b.current), u = o.filter((b) => {
    var y;
    return !((y = b.current) != null && y.hasAttribute("disabled"));
  }), h = { ...e, tabs: o, panels: s };
  if (n.index < 0 || n.index > o.length - 1) {
    let b = Nt(Math.sign(n.index - e.selectedIndex), { [-1]: () => 1, [0]: () => Nt(Math.sign(n.index), { [-1]: () => 0, [0]: () => 0, [1]: () => 1 }), [1]: () => 0 });
    if (u.length === 0)
      return h;
    let y = Nt(b, { [0]: () => o.indexOf(u[0]), [1]: () => o.indexOf(u[u.length - 1]) });
    return { ...h, selectedIndex: y === -1 ? e.selectedIndex : y };
  }
  let f = o.slice(0, n.index), p = [...o.slice(n.index), ...f].find((b) => u.includes(b));
  if (!p)
    return h;
  let v = (r = o.indexOf(p)) != null ? r : e.selectedIndex;
  return v === -1 && (v = e.selectedIndex), { ...h, selectedIndex: v };
}, [1](e, n) {
  if (e.tabs.includes(n.tab))
    return e;
  let r = e.tabs[e.selectedIndex], o = Bo([...e.tabs, n.tab], (u) => u.current), s = e.selectedIndex;
  return e.info.current.isControlled || (s = o.indexOf(r), s === -1 && (s = e.selectedIndex)), { ...e, tabs: o, selectedIndex: s };
}, [2](e, n) {
  return { ...e, tabs: e.tabs.filter((r) => r !== n.tab) };
}, [3](e, n) {
  return e.panels.includes(n.panel) ? e : { ...e, panels: Bo([...e.panels, n.panel], (r) => r.current) };
}, [4](e, n) {
  return { ...e, panels: e.panels.filter((r) => r !== n.panel) };
} }, uy = _t(null);
uy.displayName = "TabsDataContext";
function Ul(e) {
  let n = tt(uy);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ul), r;
  }
  return n;
}
let dy = _t(null);
dy.displayName = "TabsActionsContext";
function hy(e) {
  let n = tt(dy);
  if (n === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, hy), r;
  }
  return n;
}
function LY(e, n) {
  return Nt(n.type, $Y, e, n);
}
let jY = "div";
function BY(e, n) {
  let { defaultIndex: r = 0, vertical: o = !1, manual: s = !1, onChange: u, selectedIndex: h = null, ...f } = e;
  const p = o ? "vertical" : "horizontal", v = s ? "manual" : "auto";
  let b = h !== null, y = hr({ isControlled: b }), k = vt(n), [_, E] = Ri(LY, { info: y, selectedIndex: h ?? r, tabs: [], panels: [] }), x = Re(() => ({ selectedIndex: _.selectedIndex }), [_.selectedIndex]), D = hr(u || (() => {
  })), I = hr(_.tabs), N = Re(() => ({ orientation: p, activation: v, ..._ }), [p, v, _]), O = ye((G) => (E({ type: 1, tab: G }), () => E({ type: 2, tab: G }))), P = ye((G) => (E({ type: 3, panel: G }), () => E({ type: 4, panel: G }))), S = ye((G) => {
    $.current !== G && D.current(G), b || E({ type: 0, index: G });
  }), $ = hr(b ? e.selectedIndex : _.selectedIndex), L = Re(() => ({ registerTab: O, registerPanel: P, change: S }), []);
  ct(() => {
    E({ type: 0, index: h ?? r });
  }, [h]), ct(() => {
    if ($.current === void 0 || _.tabs.length <= 0)
      return;
    let G = Bo(_.tabs, (q) => q.current);
    G.some((q, Y) => _.tabs[Y] !== q) && S(G.indexOf(_.tabs[$.current]));
  });
  let B = { ref: k }, U = st();
  return oe.createElement(PY, null, oe.createElement(dy.Provider, { value: L }, oe.createElement(uy.Provider, { value: N }, N.tabs.length <= 0 && oe.createElement(DY, { onFocus: () => {
    var G, q;
    for (let Y of I.current)
      if (((G = Y.current) == null ? void 0 : G.tabIndex) === 0)
        return (q = Y.current) == null || q.focus(), !0;
    return !1;
  } }), U({ ourProps: B, theirProps: f, slot: x, defaultTag: jY, name: "Tabs" }))));
}
let FY = "div";
function zY(e, n) {
  let { orientation: r, selectedIndex: o } = Ul("Tab.List"), s = vt(n), u = Re(() => ({ selectedIndex: o }), [o]), h = e, f = { ref: s, role: "tablist", "aria-orientation": r };
  return st()({ ourProps: f, theirProps: h, slot: u, defaultTag: FY, name: "Tabs.List" });
}
let VY = "button";
function HY(e, n) {
  var r, o;
  let s = Et(), { id: u = `headlessui-tabs-tab-${s}`, disabled: h = !1, autoFocus: f = !1, ...p } = e, { orientation: v, activation: b, selectedIndex: y, tabs: k, panels: _ } = Ul("Tab"), E = hy("Tab"), x = Ul("Tab"), [D, I] = Ve(null), N = Le(null), O = vt(N, n, I);
  ct(() => E.registerTab(N), [E, N]);
  let P = EI("tabs"), S = k.indexOf(N);
  S === -1 && (S = P);
  let $ = S === y, L = ye((X) => {
    var se;
    let he = X();
    if (he === si.Success && b === "auto") {
      let de = (se = Ni(N)) == null ? void 0 : se.activeElement, me = x.tabs.findIndex((we) => we.current === de);
      me !== -1 && E.change(me);
    }
    return he;
  }), B = ye((X) => {
    let se = k.map((he) => he.current).filter(Boolean);
    if (X.key === ze.Space || X.key === ze.Enter) {
      X.preventDefault(), X.stopPropagation(), E.change(S);
      return;
    }
    switch (X.key) {
      case ze.Home:
      case ze.PageUp:
        return X.preventDefault(), X.stopPropagation(), L(() => $n(se, Pt.First));
      case ze.End:
      case ze.PageDown:
        return X.preventDefault(), X.stopPropagation(), L(() => $n(se, Pt.Last));
    }
    if (L(() => Nt(v, { vertical() {
      return X.key === ze.ArrowUp ? $n(se, Pt.Previous | Pt.WrapAround) : X.key === ze.ArrowDown ? $n(se, Pt.Next | Pt.WrapAround) : si.Error;
    }, horizontal() {
      return X.key === ze.ArrowLeft ? $n(se, Pt.Previous | Pt.WrapAround) : X.key === ze.ArrowRight ? $n(se, Pt.Next | Pt.WrapAround) : si.Error;
    } })) === si.Success)
      return X.preventDefault();
  }), U = Le(!1), G = ye(() => {
    var X;
    U.current || (U.current = !0, (X = N.current) == null || X.focus({ preventScroll: !0 }), E.change(S), id(() => {
      U.current = !1;
    }));
  }), q = ye((X) => {
    X.preventDefault();
  }), { isFocusVisible: Y, focusProps: Q } = wo({ autoFocus: f }), { isHovered: Z, hoverProps: ae } = Yo({ isDisabled: h }), { pressed: ie, pressProps: pe } = Jl({ disabled: h }), ce = Re(() => ({ selected: $, hover: Z, active: ie, focus: Y, autofocus: f, disabled: h }), [$, Z, Y, ie, f, h]), ue = kr({ ref: O, onKeyDown: B, onMouseDown: q, onClick: G, id: u, role: "tab", type: rc(e, D), "aria-controls": (o = (r = _[S]) == null ? void 0 : r.current) == null ? void 0 : o.id, "aria-selected": $, tabIndex: $ ? 0 : -1, disabled: h || void 0, autoFocus: f }, Q, ae, pe);
  return st()({ ourProps: ue, theirProps: p, slot: ce, defaultTag: VY, name: "Tabs.Tab" });
}
let UY = "div";
function WY(e, n) {
  let { selectedIndex: r } = Ul("Tab.Panels"), o = vt(n), s = Re(() => ({ selectedIndex: r }), [r]), u = e, h = { ref: o };
  return st()({ ourProps: h, theirProps: u, slot: s, defaultTag: UY, name: "Tabs.Panels" });
}
let GY = "div", qY = gr.RenderStrategy | gr.Static;
function KY(e, n) {
  var r, o, s, u;
  let h = Et(), { id: f = `headlessui-tabs-panel-${h}`, tabIndex: p = 0, ...v } = e, { selectedIndex: b, tabs: y, panels: k } = Ul("Tab.Panel"), _ = hy("Tab.Panel"), E = Le(null), x = vt(E, n);
  ct(() => _.registerPanel(E), [_, E]);
  let D = EI("panels"), I = k.indexOf(E);
  I === -1 && (I = D);
  let N = I === b, { isFocusVisible: O, focusProps: P } = wo(), S = Re(() => ({ selected: N, focus: O }), [N, O]), $ = kr({ ref: x, id: f, role: "tabpanel", "aria-labelledby": (o = (r = y[I]) == null ? void 0 : r.current) == null ? void 0 : o.id, tabIndex: N ? p : -1 }, P), L = st();
  return !N && ((s = v.unmount) == null || s) && !((u = v.static) != null && u) ? oe.createElement(Pi, { "aria-hidden": "true", ...$ }) : L({ ourProps: $, theirProps: v, slot: S, defaultTag: GY, features: qY, visible: N, name: "Tabs.Panel" });
}
let YY = nt(HY), SI = nt(BY), MI = nt(zY), TI = nt(WY), DI = nt(KY), QY = Object.assign(YY, { Group: SI, List: MI, Panels: TI, Panel: DI });
function ZY() {
  let e = Le(!0);
  return Xe(() => (e.current = !1, () => {
    e.current = !0;
  }), []), e.current;
}
function II() {
  return ZY();
}
function PI({
  as: e,
  ...n
}, r) {
  return /* @__PURE__ */ M(rr, {
    ref: r,
    as: e || ft,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95",
    ...n
  });
}
PI.displayName = "Appear";
const $De = nt(PI);
function OI({
  as: e,
  goingBack: n,
  ...r
}, o) {
  return /* @__PURE__ */ M(rr, {
    ref: o,
    as: e || ft,
    className: "divide-y divide-gray-200 bg-white",
    enter: "transform transition ease-in-out duration-300 sm:duration-500 absolute inset-0",
    enterFrom: Ce(n ? "-translate-x-full" : "translate-x-full"),
    enterTo: "translate-x-0",
    leave: "transform transition ease-in-out duration-300 sm:duration-500 absolute inset-0",
    leaveFrom: "translate-x-0",
    leaveTo: Ce(n ? "translate-x-full" : "-translate-x-full"),
    ...r
  });
}
OI.displayName = "Slide";
const LDe = nt(OI);
function XY(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var Vr = XY;
function pf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pf = function(r) {
    return typeof r;
  } : pf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, pf(e);
}
var JY = ["viewBox", "children"], eQ = ["aria-activedescendant", "aria-atomic", "aria-autocomplete", "aria-busy", "aria-checked", "aria-colcount", "aria-colindex", "aria-colspan", "aria-controls", "aria-current", "aria-describedby", "aria-details", "aria-disabled", "aria-errormessage", "aria-expanded", "aria-flowto", "aria-haspopup", "aria-hidden", "aria-invalid", "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-level", "aria-live", "aria-modal", "aria-multiline", "aria-multiselectable", "aria-orientation", "aria-owns", "aria-placeholder", "aria-posinset", "aria-pressed", "aria-readonly", "aria-relevant", "aria-required", "aria-roledescription", "aria-rowcount", "aria-rowindex", "aria-rowspan", "aria-selected", "aria-setsize", "aria-sort", "aria-valuemax", "aria-valuemin", "aria-valuenow", "aria-valuetext", "className", "color", "height", "id", "lang", "max", "media", "method", "min", "name", "style", "target", "type", "width", "role", "tabIndex", "accentHeight", "accumulate", "additive", "alignmentBaseline", "allowReorder", "alphabetic", "amplitude", "arabicForm", "ascent", "attributeName", "attributeType", "autoReverse", "azimuth", "baseFrequency", "baselineShift", "baseProfile", "bbox", "begin", "bias", "by", "calcMode", "capHeight", "clip", "clipPath", "clipPathUnits", "clipRule", "colorInterpolation", "colorInterpolationFilters", "colorProfile", "colorRendering", "contentScriptType", "contentStyleType", "cursor", "cx", "cy", "d", "decelerate", "descent", "diffuseConstant", "direction", "display", "divisor", "dominantBaseline", "dur", "dx", "dy", "edgeMode", "elevation", "enableBackground", "end", "exponent", "externalResourcesRequired", "fill", "fillOpacity", "fillRule", "filter", "filterRes", "filterUnits", "floodColor", "floodOpacity", "focusable", "fontFamily", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontWeight", "format", "from", "fx", "fy", "g1", "g2", "glyphName", "glyphOrientationHorizontal", "glyphOrientationVertical", "glyphRef", "gradientTransform", "gradientUnits", "hanging", "horizAdvX", "horizOriginX", "href", "ideographic", "imageRendering", "in2", "in", "intercept", "k1", "k2", "k3", "k4", "k", "kernelMatrix", "kernelUnitLength", "kerning", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "letterSpacing", "lightingColor", "limitingConeAngle", "local", "markerEnd", "markerHeight", "markerMid", "markerStart", "markerUnits", "markerWidth", "mask", "maskContentUnits", "maskUnits", "mathematical", "mode", "numOctaves", "offset", "opacity", "operator", "order", "orient", "orientation", "origin", "overflow", "overlinePosition", "overlineThickness", "paintOrder", "panose1", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointerEvents", "points", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "r", "radius", "refX", "refY", "renderingIntent", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "restart", "result", "rotate", "rx", "ry", "seed", "shapeRendering", "slope", "spacing", "specularConstant", "specularExponent", "speed", "spreadMethod", "startOffset", "stdDeviation", "stemh", "stemv", "stitchTiles", "stopColor", "stopOpacity", "strikethroughPosition", "strikethroughThickness", "string", "stroke", "strokeDasharray", "strokeDashoffset", "strokeLinecap", "strokeLinejoin", "strokeMiterlimit", "strokeOpacity", "strokeWidth", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textAnchor", "textDecoration", "textLength", "textRendering", "to", "transform", "u1", "u2", "underlinePosition", "underlineThickness", "unicode", "unicodeBidi", "unicodeRange", "unitsPerEm", "vAlphabetic", "values", "vectorEffect", "version", "vertAdvY", "vertOriginX", "vertOriginY", "vHanging", "vIdeographic", "viewTarget", "visibility", "vMathematical", "widths", "wordSpacing", "writingMode", "x1", "x2", "x", "xChannelSelector", "xHeight", "xlinkActuate", "xlinkArcrole", "xlinkHref", "xlinkRole", "xlinkShow", "xlinkTitle", "xlinkType", "xmlBase", "xmlLang", "xmlns", "xmlnsXlink", "xmlSpace", "y1", "y2", "y", "yChannelSelector", "z", "zoomAndPan", "ref", "key", "angle"], fy = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Ye = function(n, r, o) {
  if (!n || typeof n == "function" || typeof n == "boolean")
    return null;
  var s = n;
  if (/* @__PURE__ */ Ho(n) && (s = n.props), !Vr(s))
    return null;
  var u = {};
  return Object.keys(s).forEach(function(h) {
    (eQ.includes(h) || o && JY.includes(h) || r && fy.includes(h)) && (u[h] = s[h]);
  }), u;
}, Qf = function(n, r) {
  if (!n || typeof n == "function" || typeof n == "boolean")
    return null;
  var o = n;
  if (/* @__PURE__ */ Ho(n) && (o = n.props), !Vr(o))
    return null;
  var s = {};
  return Object.keys(o).forEach(function(u) {
    fy.includes(u) && (s[u] = r || function(h) {
      return o[u](o, h);
    });
  }), s;
}, tQ = function(n, r, o) {
  return function(s) {
    return n(r, o, s), null;
  };
}, Ia = function(n, r, o) {
  if (!Vr(n) || pf(n) !== "object")
    return null;
  var s = null;
  return Object.keys(n).forEach(function(u) {
    var h = n[u];
    fy.includes(u) && typeof h == "function" && (s || (s = {}), s[u] = tQ(h, r, o));
  }), s;
};
function nQ(e, n) {
  if (e == null)
    return {};
  var r = rQ(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function rQ(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Rb(e) {
  var n = e.children, r = e.width, o = e.height, s = e.viewBox, u = e.className, h = e.style, f = nQ(e, ["children", "width", "height", "viewBox", "className", "style"]), p = s || {
    width: r,
    height: o,
    x: 0,
    y: 0
  }, v = Ce("recharts-surface", u);
  return /* @__PURE__ */ K("svg", {
    ...Ye(f, !0, !0),
    className: v,
    width: r,
    height: o,
    style: h,
    viewBox: "".concat(p.x, " ").concat(p.y, " ").concat(p.width, " ").concat(p.height),
    version: "1.1",
    children: [/* @__PURE__ */ M("title", {
      children: e.title
    }), /* @__PURE__ */ M("desc", {
      children: e.desc
    }), n]
  });
}
function iQ(e, n) {
  if (e == null)
    return {};
  var r = oQ(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function oQ(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
var mt = /* @__PURE__ */ oe.forwardRef(function(e, n) {
  var r = e.children, o = e.className, s = iQ(e, ["children", "className"]), u = Ce("recharts-layer", o);
  return /* @__PURE__ */ M("g", {
    className: u,
    ...Ye(s, !0),
    ref: n,
    children: r
  });
}), aQ = typeof ai == "object" && ai && ai.Object === Object && ai, RI = aQ, sQ = RI, lQ = typeof self == "object" && self && self.Object === Object && self, cQ = sQ || lQ || Function("return this")(), yo = cQ, uQ = yo, dQ = uQ.Symbol, hd = dQ, SE = hd, NI = Object.prototype, hQ = NI.hasOwnProperty, fQ = NI.toString, Cu = SE ? SE.toStringTag : void 0;
function pQ(e) {
  var n = hQ.call(e, Cu), r = e[Cu];
  try {
    e[Cu] = void 0;
    var o = !0;
  } catch {
  }
  var s = fQ.call(e);
  return o && (n ? e[Cu] = r : delete e[Cu]), s;
}
var gQ = pQ, mQ = Object.prototype, vQ = mQ.toString;
function bQ(e) {
  return vQ.call(e);
}
var wQ = bQ, ME = hd, yQ = gQ, kQ = wQ, _Q = "[object Null]", AQ = "[object Undefined]", TE = ME ? ME.toStringTag : void 0;
function CQ(e) {
  return e == null ? e === void 0 ? AQ : _Q : TE && TE in Object(e) ? yQ(e) : kQ(e);
}
var Jo = CQ, xQ = Jo, EQ = Vr, SQ = "[object AsyncFunction]", MQ = "[object Function]", TQ = "[object GeneratorFunction]", DQ = "[object Proxy]";
function IQ(e) {
  if (!EQ(e))
    return !1;
  var n = xQ(e);
  return n == MQ || n == TQ || n == SQ || n == DQ;
}
var qe = IQ;
function PQ() {
  this.__data__ = [], this.size = 0;
}
var OQ = PQ;
function RQ(e, n) {
  return e === n || e !== e && n !== n;
}
var py = RQ, NQ = py;
function $Q(e, n) {
  for (var r = e.length; r--; )
    if (NQ(e[r][0], n))
      return r;
  return -1;
}
var xg = $Q, LQ = xg, jQ = Array.prototype, BQ = jQ.splice;
function FQ(e) {
  var n = this.__data__, r = LQ(n, e);
  if (r < 0)
    return !1;
  var o = n.length - 1;
  return r == o ? n.pop() : BQ.call(n, r, 1), --this.size, !0;
}
var zQ = FQ, VQ = xg;
function HQ(e) {
  var n = this.__data__, r = VQ(n, e);
  return r < 0 ? void 0 : n[r][1];
}
var UQ = HQ, WQ = xg;
function GQ(e) {
  return WQ(this.__data__, e) > -1;
}
var qQ = GQ, KQ = xg;
function YQ(e, n) {
  var r = this.__data__, o = KQ(r, e);
  return o < 0 ? (++this.size, r.push([e, n])) : r[o][1] = n, this;
}
var QQ = YQ, ZQ = OQ, XQ = zQ, JQ = UQ, eZ = qQ, tZ = QQ;
function uc(e) {
  var n = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++n < r; ) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}
uc.prototype.clear = ZQ;
uc.prototype.delete = XQ;
uc.prototype.get = JQ;
uc.prototype.has = eZ;
uc.prototype.set = tZ;
var Eg = uc, nZ = Eg;
function rZ() {
  this.__data__ = new nZ(), this.size = 0;
}
var iZ = rZ;
function oZ(e) {
  var n = this.__data__, r = n.delete(e);
  return this.size = n.size, r;
}
var aZ = oZ;
function sZ(e) {
  return this.__data__.get(e);
}
var lZ = sZ;
function cZ(e) {
  return this.__data__.has(e);
}
var uZ = cZ, dZ = yo, hZ = dZ["__core-js_shared__"], fZ = hZ, _v = fZ, DE = function() {
  var e = /[^.]+$/.exec(_v && _v.keys && _v.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function pZ(e) {
  return !!DE && DE in e;
}
var gZ = pZ, mZ = Function.prototype, vZ = mZ.toString;
function bZ(e) {
  if (e != null) {
    try {
      return vZ.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var $I = bZ, wZ = qe, yZ = gZ, kZ = Vr, _Z = $I, AZ = /[\\^$.*+?()[\]{}|]/g, CZ = /^\[object .+?Constructor\]$/, xZ = Function.prototype, EZ = Object.prototype, SZ = xZ.toString, MZ = EZ.hasOwnProperty, TZ = RegExp(
  "^" + SZ.call(MZ).replace(AZ, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function DZ(e) {
  if (!kZ(e) || yZ(e))
    return !1;
  var n = wZ(e) ? TZ : CZ;
  return n.test(_Z(e));
}
var IZ = DZ;
function PZ(e, n) {
  return e?.[n];
}
var OZ = PZ, RZ = IZ, NZ = OZ;
function $Z(e, n) {
  var r = NZ(e, n);
  return RZ(r) ? r : void 0;
}
var Us = $Z, LZ = Us, jZ = yo, BZ = LZ(jZ, "Map"), gy = BZ, FZ = Us, zZ = FZ(Object, "create"), Sg = zZ, IE = Sg;
function VZ() {
  this.__data__ = IE ? IE(null) : {}, this.size = 0;
}
var HZ = VZ;
function UZ(e) {
  var n = this.has(e) && delete this.__data__[e];
  return this.size -= n ? 1 : 0, n;
}
var WZ = UZ, GZ = Sg, qZ = "__lodash_hash_undefined__", KZ = Object.prototype, YZ = KZ.hasOwnProperty;
function QZ(e) {
  var n = this.__data__;
  if (GZ) {
    var r = n[e];
    return r === qZ ? void 0 : r;
  }
  return YZ.call(n, e) ? n[e] : void 0;
}
var ZZ = QZ, XZ = Sg, JZ = Object.prototype, eX = JZ.hasOwnProperty;
function tX(e) {
  var n = this.__data__;
  return XZ ? n[e] !== void 0 : eX.call(n, e);
}
var nX = tX, rX = Sg, iX = "__lodash_hash_undefined__";
function oX(e, n) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = rX && n === void 0 ? iX : n, this;
}
var aX = oX, sX = HZ, lX = WZ, cX = ZZ, uX = nX, dX = aX;
function dc(e) {
  var n = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++n < r; ) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}
dc.prototype.clear = sX;
dc.prototype.delete = lX;
dc.prototype.get = cX;
dc.prototype.has = uX;
dc.prototype.set = dX;
var hX = dc, PE = hX, fX = Eg, pX = gy;
function gX() {
  this.size = 0, this.__data__ = {
    hash: new PE(),
    map: new (pX || fX)(),
    string: new PE()
  };
}
var mX = gX;
function vX(e) {
  var n = typeof e;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
}
var bX = vX, wX = bX;
function yX(e, n) {
  var r = e.__data__;
  return wX(n) ? r[typeof n == "string" ? "string" : "hash"] : r.map;
}
var Mg = yX, kX = Mg;
function _X(e) {
  var n = kX(this, e).delete(e);
  return this.size -= n ? 1 : 0, n;
}
var AX = _X, CX = Mg;
function xX(e) {
  return CX(this, e).get(e);
}
var EX = xX, SX = Mg;
function MX(e) {
  return SX(this, e).has(e);
}
var TX = MX, DX = Mg;
function IX(e, n) {
  var r = DX(this, e), o = r.size;
  return r.set(e, n), this.size += r.size == o ? 0 : 1, this;
}
var PX = IX, OX = mX, RX = AX, NX = EX, $X = TX, LX = PX;
function hc(e) {
  var n = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++n < r; ) {
    var o = e[n];
    this.set(o[0], o[1]);
  }
}
hc.prototype.clear = OX;
hc.prototype.delete = RX;
hc.prototype.get = NX;
hc.prototype.has = $X;
hc.prototype.set = LX;
var my = hc, jX = Eg, BX = gy, FX = my, zX = 200;
function VX(e, n) {
  var r = this.__data__;
  if (r instanceof jX) {
    var o = r.__data__;
    if (!BX || o.length < zX - 1)
      return o.push([e, n]), this.size = ++r.size, this;
    r = this.__data__ = new FX(o);
  }
  return r.set(e, n), this.size = r.size, this;
}
var HX = VX, UX = Eg, WX = iZ, GX = aZ, qX = lZ, KX = uZ, YX = HX;
function fc(e) {
  var n = this.__data__ = new UX(e);
  this.size = n.size;
}
fc.prototype.clear = WX;
fc.prototype.delete = GX;
fc.prototype.get = qX;
fc.prototype.has = KX;
fc.prototype.set = YX;
var LI = fc, QX = "__lodash_hash_undefined__";
function ZX(e) {
  return this.__data__.set(e, QX), this;
}
var XX = ZX;
function JX(e) {
  return this.__data__.has(e);
}
var eJ = JX, tJ = my, nJ = XX, rJ = eJ;
function Zf(e) {
  var n = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new tJ(); ++n < r; )
    this.add(e[n]);
}
Zf.prototype.add = Zf.prototype.push = nJ;
Zf.prototype.has = rJ;
var jI = Zf;
function iJ(e, n) {
  for (var r = -1, o = e == null ? 0 : e.length; ++r < o; )
    if (n(e[r], r, e))
      return !0;
  return !1;
}
var BI = iJ;
function oJ(e, n) {
  return e.has(n);
}
var FI = oJ, aJ = jI, sJ = BI, lJ = FI, cJ = 1, uJ = 2;
function dJ(e, n, r, o, s, u) {
  var h = r & cJ, f = e.length, p = n.length;
  if (f != p && !(h && p > f))
    return !1;
  var v = u.get(e), b = u.get(n);
  if (v && b)
    return v == n && b == e;
  var y = -1, k = !0, _ = r & uJ ? new aJ() : void 0;
  for (u.set(e, n), u.set(n, e); ++y < f; ) {
    var E = e[y], x = n[y];
    if (o)
      var D = h ? o(x, E, y, n, e, u) : o(E, x, y, e, n, u);
    if (D !== void 0) {
      if (D)
        continue;
      k = !1;
      break;
    }
    if (_) {
      if (!sJ(n, function(I, N) {
        if (!lJ(_, N) && (E === I || s(E, I, r, o, u)))
          return _.push(N);
      })) {
        k = !1;
        break;
      }
    } else if (!(E === x || s(E, x, r, o, u))) {
      k = !1;
      break;
    }
  }
  return u.delete(e), u.delete(n), k;
}
var zI = dJ, hJ = yo, fJ = hJ.Uint8Array, pJ = fJ;
function gJ(e) {
  var n = -1, r = Array(e.size);
  return e.forEach(function(o, s) {
    r[++n] = [s, o];
  }), r;
}
var mJ = gJ;
function vJ(e) {
  var n = -1, r = Array(e.size);
  return e.forEach(function(o) {
    r[++n] = o;
  }), r;
}
var vy = vJ, OE = hd, RE = pJ, bJ = py, wJ = zI, yJ = mJ, kJ = vy, _J = 1, AJ = 2, CJ = "[object Boolean]", xJ = "[object Date]", EJ = "[object Error]", SJ = "[object Map]", MJ = "[object Number]", TJ = "[object RegExp]", DJ = "[object Set]", IJ = "[object String]", PJ = "[object Symbol]", OJ = "[object ArrayBuffer]", RJ = "[object DataView]", NE = OE ? OE.prototype : void 0, Av = NE ? NE.valueOf : void 0;
function NJ(e, n, r, o, s, u, h) {
  switch (r) {
    case RJ:
      if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
        return !1;
      e = e.buffer, n = n.buffer;
    case OJ:
      return !(e.byteLength != n.byteLength || !u(new RE(e), new RE(n)));
    case CJ:
    case xJ:
    case MJ:
      return bJ(+e, +n);
    case EJ:
      return e.name == n.name && e.message == n.message;
    case TJ:
    case IJ:
      return e == n + "";
    case SJ:
      var f = yJ;
    case DJ:
      var p = o & _J;
      if (f || (f = kJ), e.size != n.size && !p)
        return !1;
      var v = h.get(e);
      if (v)
        return v == n;
      o |= AJ, h.set(e, n);
      var b = wJ(f(e), f(n), o, s, u, h);
      return h.delete(e), b;
    case PJ:
      if (Av)
        return Av.call(e) == Av.call(n);
  }
  return !1;
}
var $J = NJ;
function LJ(e, n) {
  for (var r = -1, o = n.length, s = e.length; ++r < o; )
    e[s + r] = n[r];
  return e;
}
var VI = LJ, jJ = Array.isArray, Tt = jJ, BJ = VI, FJ = Tt;
function zJ(e, n, r) {
  var o = n(e);
  return FJ(e) ? o : BJ(o, r(e));
}
var VJ = zJ;
function HJ(e, n) {
  for (var r = -1, o = e == null ? 0 : e.length, s = 0, u = []; ++r < o; ) {
    var h = e[r];
    n(h, r, e) && (u[s++] = h);
  }
  return u;
}
var UJ = HJ;
function WJ() {
  return [];
}
var GJ = WJ, qJ = UJ, KJ = GJ, YJ = Object.prototype, QJ = YJ.propertyIsEnumerable, $E = Object.getOwnPropertySymbols, ZJ = $E ? function(e) {
  return e == null ? [] : (e = Object(e), qJ($E(e), function(n) {
    return QJ.call(e, n);
  }));
} : KJ, XJ = ZJ;
function JJ(e, n) {
  for (var r = -1, o = Array(e); ++r < e; )
    o[r] = n(r);
  return o;
}
var eee = JJ;
function tee(e) {
  return e != null && typeof e == "object";
}
var ea = tee, nee = Jo, ree = ea, iee = "[object Arguments]";
function oee(e) {
  return ree(e) && nee(e) == iee;
}
var aee = oee, LE = aee, see = ea, HI = Object.prototype, lee = HI.hasOwnProperty, cee = HI.propertyIsEnumerable, uee = LE(function() {
  return arguments;
}()) ? LE : function(e) {
  return see(e) && lee.call(e, "callee") && !cee.call(e, "callee");
}, by = uee, Xf = { exports: {} };
function dee() {
  return !1;
}
var hee = dee;
(function(e, n) {
  var r = yo, o = hee, s = n && !n.nodeType && n, u = s && !0 && e && !e.nodeType && e, h = u && u.exports === s, f = h ? r.Buffer : void 0, p = f ? f.isBuffer : void 0, v = p || o;
  e.exports = v;
})(Xf, Xf.exports);
var fee = 9007199254740991, pee = /^(?:0|[1-9]\d*)$/;
function gee(e, n) {
  var r = typeof e;
  return n = n ?? fee, !!n && (r == "number" || r != "symbol" && pee.test(e)) && e > -1 && e % 1 == 0 && e < n;
}
var wy = gee, mee = 9007199254740991;
function vee(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= mee;
}
var yy = vee, bee = Jo, wee = yy, yee = ea, kee = "[object Arguments]", _ee = "[object Array]", Aee = "[object Boolean]", Cee = "[object Date]", xee = "[object Error]", Eee = "[object Function]", See = "[object Map]", Mee = "[object Number]", Tee = "[object Object]", Dee = "[object RegExp]", Iee = "[object Set]", Pee = "[object String]", Oee = "[object WeakMap]", Ree = "[object ArrayBuffer]", Nee = "[object DataView]", $ee = "[object Float32Array]", Lee = "[object Float64Array]", jee = "[object Int8Array]", Bee = "[object Int16Array]", Fee = "[object Int32Array]", zee = "[object Uint8Array]", Vee = "[object Uint8ClampedArray]", Hee = "[object Uint16Array]", Uee = "[object Uint32Array]", pn = {};
pn[$ee] = pn[Lee] = pn[jee] = pn[Bee] = pn[Fee] = pn[zee] = pn[Vee] = pn[Hee] = pn[Uee] = !0;
pn[kee] = pn[_ee] = pn[Ree] = pn[Aee] = pn[Nee] = pn[Cee] = pn[xee] = pn[Eee] = pn[See] = pn[Mee] = pn[Tee] = pn[Dee] = pn[Iee] = pn[Pee] = pn[Oee] = !1;
function Wee(e) {
  return yee(e) && wee(e.length) && !!pn[bee(e)];
}
var Gee = Wee;
function qee(e) {
  return function(n) {
    return e(n);
  };
}
var UI = qee, Nb = { exports: {} };
(function(e, n) {
  var r = RI, o = n && !n.nodeType && n, s = o && !0 && e && !e.nodeType && e, u = s && s.exports === o, h = u && r.process, f = function() {
    try {
      var p = s && s.require && s.require("util").types;
      return p || h && h.binding && h.binding("util");
    } catch {
    }
  }();
  e.exports = f;
})(Nb, Nb.exports);
var Kee = Gee, Yee = UI, jE = Nb.exports, BE = jE && jE.isTypedArray, Qee = BE ? Yee(BE) : Kee, WI = Qee, Zee = eee, Xee = by, Jee = Tt, ete = Xf.exports, tte = wy, nte = WI, rte = Object.prototype, ite = rte.hasOwnProperty;
function ote(e, n) {
  var r = Jee(e), o = !r && Xee(e), s = !r && !o && ete(e), u = !r && !o && !s && nte(e), h = r || o || s || u, f = h ? Zee(e.length, String) : [], p = f.length;
  for (var v in e)
    (n || ite.call(e, v)) && !(h && (v == "length" || s && (v == "offset" || v == "parent") || u && (v == "buffer" || v == "byteLength" || v == "byteOffset") || tte(v, p))) && f.push(v);
  return f;
}
var ate = ote, ste = Object.prototype;
function lte(e) {
  var n = e && e.constructor, r = typeof n == "function" && n.prototype || ste;
  return e === r;
}
var cte = lte;
function ute(e, n) {
  return function(r) {
    return e(n(r));
  };
}
var GI = ute, dte = GI, hte = dte(Object.keys, Object), fte = hte, pte = cte, gte = fte, mte = Object.prototype, vte = mte.hasOwnProperty;
function bte(e) {
  if (!pte(e))
    return gte(e);
  var n = [];
  for (var r in Object(e))
    vte.call(e, r) && r != "constructor" && n.push(r);
  return n;
}
var wte = bte, yte = qe, kte = yy;
function _te(e) {
  return e != null && kte(e.length) && !yte(e);
}
var fd = _te, Ate = ate, Cte = wte, xte = fd;
function Ete(e) {
  return xte(e) ? Ate(e) : Cte(e);
}
var Tg = Ete, Ste = VJ, Mte = XJ, Tte = Tg;
function Dte(e) {
  return Ste(e, Tte, Mte);
}
var Ite = Dte, FE = Ite, Pte = 1, Ote = Object.prototype, Rte = Ote.hasOwnProperty;
function Nte(e, n, r, o, s, u) {
  var h = r & Pte, f = FE(e), p = f.length, v = FE(n), b = v.length;
  if (p != b && !h)
    return !1;
  for (var y = p; y--; ) {
    var k = f[y];
    if (!(h ? k in n : Rte.call(n, k)))
      return !1;
  }
  var _ = u.get(e), E = u.get(n);
  if (_ && E)
    return _ == n && E == e;
  var x = !0;
  u.set(e, n), u.set(n, e);
  for (var D = h; ++y < p; ) {
    k = f[y];
    var I = e[k], N = n[k];
    if (o)
      var O = h ? o(N, I, k, n, e, u) : o(I, N, k, e, n, u);
    if (!(O === void 0 ? I === N || s(I, N, r, o, u) : O)) {
      x = !1;
      break;
    }
    D || (D = k == "constructor");
  }
  if (x && !D) {
    var P = e.constructor, S = n.constructor;
    P != S && "constructor" in e && "constructor" in n && !(typeof P == "function" && P instanceof P && typeof S == "function" && S instanceof S) && (x = !1);
  }
  return u.delete(e), u.delete(n), x;
}
var $te = Nte, Lte = Us, jte = yo, Bte = Lte(jte, "DataView"), Fte = Bte, zte = Us, Vte = yo, Hte = zte(Vte, "Promise"), Ute = Hte, Wte = Us, Gte = yo, qte = Wte(Gte, "Set"), qI = qte, Kte = Us, Yte = yo, Qte = Kte(Yte, "WeakMap"), Zte = Qte, $b = Fte, Lb = gy, jb = Ute, Bb = qI, Fb = Zte, KI = Jo, pc = $I, zE = "[object Map]", Xte = "[object Object]", VE = "[object Promise]", HE = "[object Set]", UE = "[object WeakMap]", WE = "[object DataView]", Jte = pc($b), ene = pc(Lb), tne = pc(jb), nne = pc(Bb), rne = pc(Fb), gs = KI;
($b && gs(new $b(new ArrayBuffer(1))) != WE || Lb && gs(new Lb()) != zE || jb && gs(jb.resolve()) != VE || Bb && gs(new Bb()) != HE || Fb && gs(new Fb()) != UE) && (gs = function(e) {
  var n = KI(e), r = n == Xte ? e.constructor : void 0, o = r ? pc(r) : "";
  if (o)
    switch (o) {
      case Jte:
        return WE;
      case ene:
        return zE;
      case tne:
        return VE;
      case nne:
        return HE;
      case rne:
        return UE;
    }
  return n;
});
var ine = gs, Cv = LI, one = zI, ane = $J, sne = $te, GE = ine, qE = Tt, KE = Xf.exports, lne = WI, cne = 1, YE = "[object Arguments]", QE = "[object Array]", Yh = "[object Object]", une = Object.prototype, ZE = une.hasOwnProperty;
function dne(e, n, r, o, s, u) {
  var h = qE(e), f = qE(n), p = h ? QE : GE(e), v = f ? QE : GE(n);
  p = p == YE ? Yh : p, v = v == YE ? Yh : v;
  var b = p == Yh, y = v == Yh, k = p == v;
  if (k && KE(e)) {
    if (!KE(n))
      return !1;
    h = !0, b = !1;
  }
  if (k && !b)
    return u || (u = new Cv()), h || lne(e) ? one(e, n, r, o, s, u) : ane(e, n, p, r, o, s, u);
  if (!(r & cne)) {
    var _ = b && ZE.call(e, "__wrapped__"), E = y && ZE.call(n, "__wrapped__");
    if (_ || E) {
      var x = _ ? e.value() : e, D = E ? n.value() : n;
      return u || (u = new Cv()), s(x, D, r, o, u);
    }
  }
  return k ? (u || (u = new Cv()), sne(e, n, r, o, s, u)) : !1;
}
var hne = dne, fne = hne, XE = ea;
function YI(e, n, r, o, s) {
  return e === n ? !0 : e == null || n == null || !XE(e) && !XE(n) ? e !== e && n !== n : fne(e, n, r, o, YI, s);
}
var ky = YI, pne = LI, gne = ky, mne = 1, vne = 2;
function bne(e, n, r, o) {
  var s = r.length, u = s, h = !o;
  if (e == null)
    return !u;
  for (e = Object(e); s--; ) {
    var f = r[s];
    if (h && f[2] ? f[1] !== e[f[0]] : !(f[0] in e))
      return !1;
  }
  for (; ++s < u; ) {
    f = r[s];
    var p = f[0], v = e[p], b = f[1];
    if (h && f[2]) {
      if (v === void 0 && !(p in e))
        return !1;
    } else {
      var y = new pne();
      if (o)
        var k = o(v, b, p, e, n, y);
      if (!(k === void 0 ? gne(b, v, mne | vne, o, y) : k))
        return !1;
    }
  }
  return !0;
}
var wne = bne, yne = Vr;
function kne(e) {
  return e === e && !yne(e);
}
var QI = kne, _ne = QI, Ane = Tg;
function Cne(e) {
  for (var n = Ane(e), r = n.length; r--; ) {
    var o = n[r], s = e[o];
    n[r] = [o, s, _ne(s)];
  }
  return n;
}
var xne = Cne;
function Ene(e, n) {
  return function(r) {
    return r == null ? !1 : r[e] === n && (n !== void 0 || e in Object(r));
  };
}
var ZI = Ene, Sne = wne, Mne = xne, Tne = ZI;
function Dne(e) {
  var n = Mne(e);
  return n.length == 1 && n[0][2] ? Tne(n[0][0], n[0][1]) : function(r) {
    return r === e || Sne(r, e, n);
  };
}
var Ine = Dne, Pne = Jo, One = ea, Rne = "[object Symbol]";
function Nne(e) {
  return typeof e == "symbol" || One(e) && Pne(e) == Rne;
}
var gc = Nne, $ne = Tt, Lne = gc, jne = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Bne = /^\w*$/;
function Fne(e, n) {
  if ($ne(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Lne(e) ? !0 : Bne.test(e) || !jne.test(e) || n != null && e in Object(n);
}
var _y = Fne, XI = my, zne = "Expected a function";
function Ay(e, n) {
  if (typeof e != "function" || n != null && typeof n != "function")
    throw new TypeError(zne);
  var r = function() {
    var o = arguments, s = n ? n.apply(this, o) : o[0], u = r.cache;
    if (u.has(s))
      return u.get(s);
    var h = e.apply(this, o);
    return r.cache = u.set(s, h) || u, h;
  };
  return r.cache = new (Ay.Cache || XI)(), r;
}
Ay.Cache = XI;
var Vne = Ay, Hne = Vne, Une = 500;
function Wne(e) {
  var n = Hne(e, function(o) {
    return r.size === Une && r.clear(), o;
  }), r = n.cache;
  return n;
}
var Gne = Wne, qne = Gne, Kne = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Yne = /\\(\\)?/g, Qne = qne(function(e) {
  var n = [];
  return e.charCodeAt(0) === 46 && n.push(""), e.replace(Kne, function(r, o, s, u) {
    n.push(s ? u.replace(Yne, "$1") : o || r);
  }), n;
}), Zne = Qne;
function Xne(e, n) {
  for (var r = -1, o = e == null ? 0 : e.length, s = Array(o); ++r < o; )
    s[r] = n(e[r], r, e);
  return s;
}
var Cy = Xne, JE = hd, Jne = Cy, ere = Tt, tre = gc, nre = 1 / 0, eS = JE ? JE.prototype : void 0, tS = eS ? eS.toString : void 0;
function JI(e) {
  if (typeof e == "string")
    return e;
  if (ere(e))
    return Jne(e, JI) + "";
  if (tre(e))
    return tS ? tS.call(e) : "";
  var n = e + "";
  return n == "0" && 1 / e == -nre ? "-0" : n;
}
var rre = JI, ire = rre;
function ore(e) {
  return e == null ? "" : ire(e);
}
var e3 = ore, are = Tt, sre = _y, lre = Zne, cre = e3;
function ure(e, n) {
  return are(e) ? e : sre(e, n) ? [e] : lre(cre(e));
}
var t3 = ure, dre = gc, hre = 1 / 0;
function fre(e) {
  if (typeof e == "string" || dre(e))
    return e;
  var n = e + "";
  return n == "0" && 1 / e == -hre ? "-0" : n;
}
var Dg = fre, pre = t3, gre = Dg;
function mre(e, n) {
  n = pre(n, e);
  for (var r = 0, o = n.length; e != null && r < o; )
    e = e[gre(n[r++])];
  return r && r == o ? e : void 0;
}
var xy = mre, vre = xy;
function bre(e, n, r) {
  var o = e == null ? void 0 : vre(e, n);
  return o === void 0 ? r : o;
}
var Hn = bre;
function wre(e, n) {
  return e != null && n in Object(e);
}
var yre = wre, kre = t3, _re = by, Are = Tt, Cre = wy, xre = yy, Ere = Dg;
function Sre(e, n, r) {
  n = kre(n, e);
  for (var o = -1, s = n.length, u = !1; ++o < s; ) {
    var h = Ere(n[o]);
    if (!(u = e != null && r(e, h)))
      break;
    e = e[h];
  }
  return u || ++o != s ? u : (s = e == null ? 0 : e.length, !!s && xre(s) && Cre(h, s) && (Are(e) || _re(e)));
}
var Mre = Sre, Tre = yre, Dre = Mre;
function Ire(e, n) {
  return e != null && Dre(e, n, Tre);
}
var Pre = Ire, Ore = ky, Rre = Hn, Nre = Pre, $re = _y, Lre = QI, jre = ZI, Bre = Dg, Fre = 1, zre = 2;
function Vre(e, n) {
  return $re(e) && Lre(n) ? jre(Bre(e), n) : function(r) {
    var o = Rre(r, e);
    return o === void 0 && o === n ? Nre(r, e) : Ore(n, o, Fre | zre);
  };
}
var Hre = Vre;
function Ure(e) {
  return e;
}
var mc = Ure;
function Wre(e) {
  return function(n) {
    return n?.[e];
  };
}
var Gre = Wre, qre = xy;
function Kre(e) {
  return function(n) {
    return qre(n, e);
  };
}
var Yre = Kre, Qre = Gre, Zre = Yre, Xre = _y, Jre = Dg;
function eie(e) {
  return Xre(e) ? Qre(Jre(e)) : Zre(e);
}
var tie = eie, nie = Ine, rie = Hre, iie = mc, oie = Tt, aie = tie;
function sie(e) {
  return typeof e == "function" ? e : e == null ? iie : typeof e == "object" ? oie(e) ? rie(e[0], e[1]) : nie(e) : aie(e);
}
var ko = sie;
function lie(e, n, r, o) {
  for (var s = e.length, u = r + (o ? 1 : -1); o ? u-- : ++u < s; )
    if (n(e[u], u, e))
      return u;
  return -1;
}
var n3 = lie;
function cie(e) {
  return e !== e;
}
var uie = cie;
function die(e, n, r) {
  for (var o = r - 1, s = e.length; ++o < s; )
    if (e[o] === n)
      return o;
  return -1;
}
var hie = die, fie = n3, pie = uie, gie = hie;
function mie(e, n, r) {
  return n === n ? gie(e, n, r) : fie(e, pie, r);
}
var vie = mie, bie = vie;
function wie(e, n) {
  var r = e == null ? 0 : e.length;
  return !!r && bie(e, n, 0) > -1;
}
var yie = wie;
function kie(e, n, r) {
  for (var o = -1, s = e == null ? 0 : e.length; ++o < s; )
    if (r(n, e[o]))
      return !0;
  return !1;
}
var _ie = kie;
function Aie() {
}
var Cie = Aie, xv = qI, xie = Cie, Eie = vy, Sie = 1 / 0, Mie = xv && 1 / Eie(new xv([, -0]))[1] == Sie ? function(e) {
  return new xv(e);
} : xie, Tie = Mie, Die = jI, Iie = yie, Pie = _ie, Oie = FI, Rie = Tie, Nie = vy, $ie = 200;
function Lie(e, n, r) {
  var o = -1, s = Iie, u = e.length, h = !0, f = [], p = f;
  if (r)
    h = !1, s = Pie;
  else if (u >= $ie) {
    var v = n ? null : Rie(e);
    if (v)
      return Nie(v);
    h = !1, s = Oie, p = new Die();
  } else
    p = n ? [] : f;
  e:
    for (; ++o < u; ) {
      var b = e[o], y = n ? n(b) : b;
      if (b = r || b !== 0 ? b : 0, h && y === y) {
        for (var k = p.length; k--; )
          if (p[k] === y)
            continue e;
        n && p.push(y), f.push(b);
      } else
        s(p, y, r) || (p !== f && p.push(y), f.push(b));
    }
  return f;
}
var jie = Lie, Bie = ko, Fie = jie;
function zie(e, n) {
  return e && e.length ? Fie(e, Bie(n)) : [];
}
var Jf = zie;
function Vie(e, n, r) {
  var o = -1, s = e.length;
  n < 0 && (n = -n > s ? 0 : s + n), r = r > s ? s : r, r < 0 && (r += s), s = n > r ? 0 : r - n >>> 0, n >>>= 0;
  for (var u = Array(s); ++o < s; )
    u[o] = e[o + n];
  return u;
}
var Hie = Vie, Uie = Hie;
function Wie(e, n, r) {
  var o = e.length;
  return r = r === void 0 ? o : r, !n && r >= o ? e : Uie(e, n, r);
}
var Gie = Wie, qie = "\\ud800-\\udfff", Kie = "\\u0300-\\u036f", Yie = "\\ufe20-\\ufe2f", Qie = "\\u20d0-\\u20ff", Zie = Kie + Yie + Qie, Xie = "\\ufe0e\\ufe0f", Jie = "\\u200d", eoe = RegExp("[" + Jie + qie + Zie + Xie + "]");
function toe(e) {
  return eoe.test(e);
}
var r3 = toe;
function noe(e) {
  return e.split("");
}
var roe = noe, i3 = "\\ud800-\\udfff", ioe = "\\u0300-\\u036f", ooe = "\\ufe20-\\ufe2f", aoe = "\\u20d0-\\u20ff", soe = ioe + ooe + aoe, loe = "\\ufe0e\\ufe0f", coe = "[" + i3 + "]", zb = "[" + soe + "]", Vb = "\\ud83c[\\udffb-\\udfff]", uoe = "(?:" + zb + "|" + Vb + ")", o3 = "[^" + i3 + "]", a3 = "(?:\\ud83c[\\udde6-\\uddff]){2}", s3 = "[\\ud800-\\udbff][\\udc00-\\udfff]", doe = "\\u200d", l3 = uoe + "?", c3 = "[" + loe + "]?", hoe = "(?:" + doe + "(?:" + [o3, a3, s3].join("|") + ")" + c3 + l3 + ")*", foe = c3 + l3 + hoe, poe = "(?:" + [o3 + zb + "?", zb, a3, s3, coe].join("|") + ")", goe = RegExp(Vb + "(?=" + Vb + ")|" + poe + foe, "g");
function moe(e) {
  return e.match(goe) || [];
}
var voe = moe, boe = roe, woe = r3, yoe = voe;
function koe(e) {
  return woe(e) ? yoe(e) : boe(e);
}
var _oe = koe, Aoe = Gie, Coe = r3, xoe = _oe, Eoe = e3;
function Soe(e) {
  return function(n) {
    n = Eoe(n);
    var r = Coe(n) ? xoe(n) : void 0, o = r ? r[0] : n.charAt(0), s = r ? Aoe(r, 1).join("") : n.slice(1);
    return o[e]() + s;
  };
}
var Moe = Soe, Toe = Moe, Doe = Toe("toUpperCase"), Ig = Doe;
const Hb = Math.PI, Ub = 2 * Hb, ms = 1e-6, Ioe = Ub - ms;
function Wb() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}
function Pg() {
  return new Wb();
}
Wb.prototype = Pg.prototype = {
  constructor: Wb,
  moveTo: function(e, n) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +n);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(e, n) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +n);
  },
  quadraticCurveTo: function(e, n, r, o) {
    this._ += "Q" + +e + "," + +n + "," + (this._x1 = +r) + "," + (this._y1 = +o);
  },
  bezierCurveTo: function(e, n, r, o, s, u) {
    this._ += "C" + +e + "," + +n + "," + +r + "," + +o + "," + (this._x1 = +s) + "," + (this._y1 = +u);
  },
  arcTo: function(e, n, r, o, s) {
    e = +e, n = +n, r = +r, o = +o, s = +s;
    var u = this._x1, h = this._y1, f = r - e, p = o - n, v = u - e, b = h - n, y = v * v + b * b;
    if (s < 0)
      throw new Error("negative radius: " + s);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = e) + "," + (this._y1 = n);
    else if (y > ms)
      if (!(Math.abs(b * f - p * v) > ms) || !s)
        this._ += "L" + (this._x1 = e) + "," + (this._y1 = n);
      else {
        var k = r - u, _ = o - h, E = f * f + p * p, x = k * k + _ * _, D = Math.sqrt(E), I = Math.sqrt(y), N = s * Math.tan((Hb - Math.acos((E + y - x) / (2 * D * I))) / 2), O = N / I, P = N / D;
        Math.abs(O - 1) > ms && (this._ += "L" + (e + O * v) + "," + (n + O * b)), this._ += "A" + s + "," + s + ",0,0," + +(b * k > v * _) + "," + (this._x1 = e + P * f) + "," + (this._y1 = n + P * p);
      }
  },
  arc: function(e, n, r, o, s, u) {
    e = +e, n = +n, r = +r, u = !!u;
    var h = r * Math.cos(o), f = r * Math.sin(o), p = e + h, v = n + f, b = 1 ^ u, y = u ? o - s : s - o;
    if (r < 0)
      throw new Error("negative radius: " + r);
    this._x1 === null ? this._ += "M" + p + "," + v : (Math.abs(this._x1 - p) > ms || Math.abs(this._y1 - v) > ms) && (this._ += "L" + p + "," + v), r && (y < 0 && (y = y % Ub + Ub), y > Ioe ? this._ += "A" + r + "," + r + ",0,1," + b + "," + (e - h) + "," + (n - f) + "A" + r + "," + r + ",0,1," + b + "," + (this._x1 = p) + "," + (this._y1 = v) : y > ms && (this._ += "A" + r + "," + r + ",0," + +(y >= Hb) + "," + b + "," + (this._x1 = e + r * Math.cos(s)) + "," + (this._y1 = n + r * Math.sin(s))));
  },
  rect: function(e, n, r, o) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +n) + "h" + +r + "v" + +o + "h" + -r + "Z";
  },
  toString: function() {
    return this._;
  }
};
function un(e) {
  return function() {
    return e;
  };
}
var ep = Math.PI, Og = 2 * ep;
function Ey(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function u3(e) {
  this._context = e;
}
u3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, n);
        break;
    }
  }
};
function Rg(e) {
  return new u3(e);
}
function d3(e) {
  return e[0];
}
function h3(e) {
  return e[1];
}
function f3(e, n) {
  var r = un(!0), o = null, s = Rg, u = null;
  e = typeof e == "function" ? e : e === void 0 ? d3 : un(e), n = typeof n == "function" ? n : n === void 0 ? h3 : un(n);
  function h(f) {
    var p, v = (f = Ey(f)).length, b, y = !1, k;
    for (o == null && (u = s(k = Pg())), p = 0; p <= v; ++p)
      !(p < v && r(b = f[p], p, f)) === y && ((y = !y) ? u.lineStart() : u.lineEnd()), y && u.point(+e(b, p, f), +n(b, p, f));
    if (k)
      return u = null, k + "" || null;
  }
  return h.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : un(+f), h) : e;
  }, h.y = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : un(+f), h) : n;
  }, h.defined = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : un(!!f), h) : r;
  }, h.curve = function(f) {
    return arguments.length ? (s = f, o != null && (u = s(o)), h) : s;
  }, h.context = function(f) {
    return arguments.length ? (f == null ? o = u = null : u = s(o = f), h) : o;
  }, h;
}
function Qh(e, n, r) {
  var o = null, s = un(!0), u = null, h = Rg, f = null;
  e = typeof e == "function" ? e : e === void 0 ? d3 : un(+e), n = typeof n == "function" ? n : un(n === void 0 ? 0 : +n), r = typeof r == "function" ? r : r === void 0 ? h3 : un(+r);
  function p(b) {
    var y, k, _, E = (b = Ey(b)).length, x, D = !1, I, N = new Array(E), O = new Array(E);
    for (u == null && (f = h(I = Pg())), y = 0; y <= E; ++y) {
      if (!(y < E && s(x = b[y], y, b)) === D)
        if (D = !D)
          k = y, f.areaStart(), f.lineStart();
        else {
          for (f.lineEnd(), f.lineStart(), _ = y - 1; _ >= k; --_)
            f.point(N[_], O[_]);
          f.lineEnd(), f.areaEnd();
        }
      D && (N[y] = +e(x, y, b), O[y] = +n(x, y, b), f.point(o ? +o(x, y, b) : N[y], r ? +r(x, y, b) : O[y]));
    }
    if (I)
      return f = null, I + "" || null;
  }
  function v() {
    return f3().defined(s).curve(h).context(u);
  }
  return p.x = function(b) {
    return arguments.length ? (e = typeof b == "function" ? b : un(+b), o = null, p) : e;
  }, p.x0 = function(b) {
    return arguments.length ? (e = typeof b == "function" ? b : un(+b), p) : e;
  }, p.x1 = function(b) {
    return arguments.length ? (o = b == null ? null : typeof b == "function" ? b : un(+b), p) : o;
  }, p.y = function(b) {
    return arguments.length ? (n = typeof b == "function" ? b : un(+b), r = null, p) : n;
  }, p.y0 = function(b) {
    return arguments.length ? (n = typeof b == "function" ? b : un(+b), p) : n;
  }, p.y1 = function(b) {
    return arguments.length ? (r = b == null ? null : typeof b == "function" ? b : un(+b), p) : r;
  }, p.lineX0 = p.lineY0 = function() {
    return v().x(e).y(n);
  }, p.lineY1 = function() {
    return v().x(e).y(r);
  }, p.lineX1 = function() {
    return v().x(o).y(n);
  }, p.defined = function(b) {
    return arguments.length ? (s = typeof b == "function" ? b : un(!!b), p) : s;
  }, p.curve = function(b) {
    return arguments.length ? (h = b, u != null && (f = h(u)), p) : h;
  }, p.context = function(b) {
    return arguments.length ? (b == null ? u = f = null : f = h(u = b), p) : u;
  }, p;
}
const Sy = {
  draw: function(e, n) {
    var r = Math.sqrt(n / ep);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, Og);
  }
}, Poe = {
  draw: function(e, n) {
    var r = Math.sqrt(n / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
};
var p3 = Math.sqrt(1 / 3), Ooe = p3 * 2;
const Roe = {
  draw: function(e, n) {
    var r = Math.sqrt(n / Ooe), o = r * p3;
    e.moveTo(0, -r), e.lineTo(o, 0), e.lineTo(0, r), e.lineTo(-o, 0), e.closePath();
  }
};
var Noe = 0.8908130915292852, g3 = Math.sin(ep / 10) / Math.sin(7 * ep / 10), $oe = Math.sin(Og / 10) * g3, Loe = -Math.cos(Og / 10) * g3;
const joe = {
  draw: function(e, n) {
    var r = Math.sqrt(n * Noe), o = $oe * r, s = Loe * r;
    e.moveTo(0, -r), e.lineTo(o, s);
    for (var u = 1; u < 5; ++u) {
      var h = Og * u / 5, f = Math.cos(h), p = Math.sin(h);
      e.lineTo(p * r, -f * r), e.lineTo(f * o - p * s, p * o + f * s);
    }
    e.closePath();
  }
}, Boe = {
  draw: function(e, n) {
    var r = Math.sqrt(n), o = -r / 2;
    e.rect(o, o, r, r);
  }
};
var Ev = Math.sqrt(3);
const Foe = {
  draw: function(e, n) {
    var r = -Math.sqrt(n / (Ev * 3));
    e.moveTo(0, r * 2), e.lineTo(-Ev * r, -r), e.lineTo(Ev * r, -r), e.closePath();
  }
};
var Jr = -0.5, ei = Math.sqrt(3) / 2, Gb = 1 / Math.sqrt(12), zoe = (Gb / 2 + 1) * 3;
const Voe = {
  draw: function(e, n) {
    var r = Math.sqrt(n / zoe), o = r / 2, s = r * Gb, u = o, h = r * Gb + r, f = -u, p = h;
    e.moveTo(o, s), e.lineTo(u, h), e.lineTo(f, p), e.lineTo(Jr * o - ei * s, ei * o + Jr * s), e.lineTo(Jr * u - ei * h, ei * u + Jr * h), e.lineTo(Jr * f - ei * p, ei * f + Jr * p), e.lineTo(Jr * o + ei * s, Jr * s - ei * o), e.lineTo(Jr * u + ei * h, Jr * h - ei * u), e.lineTo(Jr * f + ei * p, Jr * p - ei * f), e.closePath();
  }
};
function Hoe(e, n) {
  var r = null;
  e = typeof e == "function" ? e : un(e || Sy), n = typeof n == "function" ? n : un(n === void 0 ? 64 : +n);
  function o() {
    var s;
    if (r || (r = s = Pg()), e.apply(this, arguments).draw(r, +n.apply(this, arguments)), s)
      return r = null, s + "" || null;
  }
  return o.type = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : un(s), o) : e;
  }, o.size = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : un(+s), o) : n;
  }, o.context = function(s) {
    return arguments.length ? (r = s ?? null, o) : r;
  }, o;
}
function tp() {
}
function np(e, n, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + n) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function m3(e) {
  this._context = e;
}
m3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        np(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        np(this, e, n);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = n;
  }
};
function Uoe(e) {
  return new m3(e);
}
function v3(e) {
  this._context = e;
}
v3.prototype = {
  areaStart: tp,
  areaEnd: tp,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = n;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = n;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = n, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + n) / 6);
        break;
      default:
        np(this, e, n);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = n;
  }
};
function Woe(e) {
  return new v3(e);
}
function b3(e) {
  this._context = e;
}
b3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, o = (this._y0 + 4 * this._y1 + n) / 6;
        this._line ? this._context.lineTo(r, o) : this._context.moveTo(r, o);
        break;
      case 3:
        this._point = 4;
      default:
        np(this, e, n);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = n;
  }
};
function Goe(e) {
  return new b3(e);
}
function w3(e) {
  this._context = e;
}
w3.prototype = {
  areaStart: tp,
  areaEnd: tp,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, n) {
    e = +e, n = +n, this._point ? this._context.lineTo(e, n) : (this._point = 1, this._context.moveTo(e, n));
  }
};
function qoe(e) {
  return new w3(e);
}
function nS(e) {
  return e < 0 ? -1 : 1;
}
function rS(e, n, r) {
  var o = e._x1 - e._x0, s = n - e._x1, u = (e._y1 - e._y0) / (o || s < 0 && -0), h = (r - e._y1) / (s || o < 0 && -0), f = (u * s + h * o) / (o + s);
  return (nS(u) + nS(h)) * Math.min(Math.abs(u), Math.abs(h), 0.5 * Math.abs(f)) || 0;
}
function iS(e, n) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - n) / 2 : n;
}
function Sv(e, n, r) {
  var o = e._x0, s = e._y0, u = e._x1, h = e._y1, f = (u - o) / 3;
  e._context.bezierCurveTo(o + f, s + f * n, u - f, h - f * r, u, h);
}
function rp(e) {
  this._context = e;
}
rp.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Sv(this, this._t0, iS(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, n) {
    var r = NaN;
    if (e = +e, n = +n, !(e === this._x1 && n === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Sv(this, iS(this, r = rS(this, e, n)), r);
          break;
        default:
          Sv(this, this._t0, r = rS(this, e, n));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = n, this._t0 = r;
    }
  }
};
function y3(e) {
  this._context = new k3(e);
}
(y3.prototype = Object.create(rp.prototype)).point = function(e, n) {
  rp.prototype.point.call(this, n, e);
};
function k3(e) {
  this._context = e;
}
k3.prototype = {
  moveTo: function(e, n) {
    this._context.moveTo(n, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, n) {
    this._context.lineTo(n, e);
  },
  bezierCurveTo: function(e, n, r, o, s, u) {
    this._context.bezierCurveTo(n, e, o, r, u, s);
  }
};
function Koe(e) {
  return new rp(e);
}
function Yoe(e) {
  return new y3(e);
}
function _3(e) {
  this._context = e;
}
_3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, n = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], n[0]) : this._context.moveTo(e[0], n[0]), r === 2)
        this._context.lineTo(e[1], n[1]);
      else
        for (var o = oS(e), s = oS(n), u = 0, h = 1; h < r; ++u, ++h)
          this._context.bezierCurveTo(o[0][u], s[0][u], o[1][u], s[1][u], e[h], n[h]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, n) {
    this._x.push(+e), this._y.push(+n);
  }
};
function oS(e) {
  var n, r = e.length - 1, o, s = new Array(r), u = new Array(r), h = new Array(r);
  for (s[0] = 0, u[0] = 2, h[0] = e[0] + 2 * e[1], n = 1; n < r - 1; ++n)
    s[n] = 1, u[n] = 4, h[n] = 4 * e[n] + 2 * e[n + 1];
  for (s[r - 1] = 2, u[r - 1] = 7, h[r - 1] = 8 * e[r - 1] + e[r], n = 1; n < r; ++n)
    o = s[n] / u[n - 1], u[n] -= o, h[n] -= o * h[n - 1];
  for (s[r - 1] = h[r - 1] / u[r - 1], n = r - 2; n >= 0; --n)
    s[n] = (h[n] - s[n + 1]) / u[n];
  for (u[r - 1] = (e[r] + s[r - 1]) / 2, n = 0; n < r - 1; ++n)
    u[n] = 2 * e[n + 1] - s[n + 1];
  return [s, u];
}
function Qoe(e) {
  return new _3(e);
}
function Ng(e, n) {
  this._context = e, this._t = n;
}
Ng.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, n), this._context.lineTo(e, n);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, n);
        }
        break;
      }
    }
    this._x = e, this._y = n;
  }
};
function Zoe(e) {
  return new Ng(e, 0.5);
}
function Xoe(e) {
  return new Ng(e, 0);
}
function Joe(e) {
  return new Ng(e, 1);
}
function Wl(e, n) {
  if ((h = e.length) > 1)
    for (var r = 1, o, s, u = e[n[0]], h, f = u.length; r < h; ++r)
      for (s = u, u = e[n[r]], o = 0; o < f; ++o)
        u[o][1] += u[o][0] = isNaN(s[o][1]) ? s[o][0] : s[o][1];
}
function qb(e) {
  for (var n = e.length, r = new Array(n); --n >= 0; )
    r[n] = n;
  return r;
}
function eae(e, n) {
  return e[n];
}
function tae(e) {
  const n = [];
  return n.key = e, n;
}
function nae() {
  var e = un([]), n = qb, r = Wl, o = eae;
  function s(u) {
    var h = Array.from(e.apply(this, arguments), tae), f, p = h.length, v = -1, b;
    for (const y of u)
      for (f = 0, ++v; f < p; ++f)
        (h[f][v] = [0, +o(y, h[f].key, v, u)]).data = y;
    for (f = 0, b = Ey(n(h)); f < p; ++f)
      h[b[f]].index = f;
    return r(h, b), h;
  }
  return s.keys = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : un(Array.from(u)), s) : e;
  }, s.value = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : un(+u), s) : o;
  }, s.order = function(u) {
    return arguments.length ? (n = u == null ? qb : typeof u == "function" ? u : un(Array.from(u)), s) : n;
  }, s.offset = function(u) {
    return arguments.length ? (r = u ?? Wl, s) : r;
  }, s;
}
function rae(e, n) {
  if ((o = e.length) > 0) {
    for (var r, o, s = 0, u = e[0].length, h; s < u; ++s) {
      for (h = r = 0; r < o; ++r)
        h += e[r][s][1] || 0;
      if (h)
        for (r = 0; r < o; ++r)
          e[r][s][1] /= h;
    }
    Wl(e, n);
  }
}
function iae(e, n) {
  if ((s = e.length) > 0) {
    for (var r = 0, o = e[n[0]], s, u = o.length; r < u; ++r) {
      for (var h = 0, f = 0; h < s; ++h)
        f += e[h][r][1] || 0;
      o[r][1] += o[r][0] = -f / 2;
    }
    Wl(e, n);
  }
}
function oae(e, n) {
  if (!(!((h = e.length) > 0) || !((u = (s = e[n[0]]).length) > 0))) {
    for (var r = 0, o = 1, s, u, h; o < u; ++o) {
      for (var f = 0, p = 0, v = 0; f < h; ++f) {
        for (var b = e[n[f]], y = b[o][1] || 0, k = b[o - 1][1] || 0, _ = (y - k) / 2, E = 0; E < f; ++E) {
          var x = e[n[E]], D = x[o][1] || 0, I = x[o - 1][1] || 0;
          _ += D - I;
        }
        p += y, v += _ * y;
      }
      s[o - 1][1] += s[o - 1][0] = r, p && (r -= v / p);
    }
    s[o - 1][1] += s[o - 1][0] = r, Wl(e, n);
  }
}
function gf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gf = function(r) {
    return typeof r;
  } : gf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, gf(e);
}
function aae(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function aS(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function sae(e, n, r) {
  return n && aS(e.prototype, n), r && aS(e, r), e;
}
function lae(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Kb(e, n);
}
function Kb(e, n) {
  return Kb = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Kb(e, n);
}
function cae(e) {
  var n = hae();
  return function() {
    var o = ip(e), s;
    if (n) {
      var u = ip(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return uae(this, s);
  };
}
function uae(e, n) {
  return n && (gf(n) === "object" || typeof n == "function") ? n : dae(e);
}
function dae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ip(e) {
  return ip = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ip(e);
}
var A3 = {
  symbolCircle: Sy,
  symbolCross: Poe,
  symbolDiamond: Roe,
  symbolSquare: Boe,
  symbolStar: joe,
  symbolTriangle: Foe,
  symbolWye: Voe
}, fae = Math.PI / 180, pae = function(n) {
  var r = "symbol".concat(Ig(n));
  return A3[r] || Sy;
}, gae = function(n, r, o) {
  if (r === "area")
    return n;
  switch (o) {
    case "cross":
      return 5 * n * n / 9;
    case "diamond":
      return 0.5 * n * n / Math.sqrt(3);
    case "square":
      return n * n;
    case "star": {
      var s = 18 * fae;
      return 1.25 * n * n * (Math.tan(s) - Math.tan(s * 2) * Math.pow(Math.tan(s), 2));
    }
    case "triangle":
      return Math.sqrt(3) * n * n / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * n * n / 8;
    default:
      return Math.PI * n * n / 4;
  }
}, $g = /* @__PURE__ */ function(e) {
  lae(r, e);
  var n = cae(r);
  function r() {
    return aae(this, r), n.apply(this, arguments);
  }
  return sae(r, [{
    key: "getPath",
    value: function() {
      var s = this.props, u = s.size, h = s.sizeType, f = s.type, p = pae(f), v = Hoe().type(p).size(gae(u, h, f));
      return v();
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.className, h = s.cx, f = s.cy, p = s.size;
      return h === +h && f === +f && p === +p ? /* @__PURE__ */ M("path", {
        ...Ye(this.props, !0),
        className: Ce("recharts-symbols", u),
        transform: "translate(".concat(h, ", ").concat(f, ")"),
        d: this.getPath()
      }) : null;
    }
  }]), r;
}(Ln);
$g.defaultProps = {
  type: "circle",
  size: 64,
  sizeType: "area"
};
$g.registerSymbol = function(e, n) {
  A3["symbol".concat(Ig(e))] = n;
};
function mf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mf = function(r) {
    return typeof r;
  } : mf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, mf(e);
}
function sS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function mae(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? sS(Object(r), !0).forEach(function(o) {
      Yb(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Yb(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function vae(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function lS(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function bae(e, n, r) {
  return n && lS(e.prototype, n), r && lS(e, r), e;
}
function wae(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Qb(e, n);
}
function Qb(e, n) {
  return Qb = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Qb(e, n);
}
function yae(e) {
  var n = Aae();
  return function() {
    var o = op(e), s;
    if (n) {
      var u = op(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return kae(this, s);
  };
}
function kae(e, n) {
  return n && (mf(n) === "object" || typeof n == "function") ? n : _ae(e);
}
function _ae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Aae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function op(e) {
  return op = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, op(e);
}
var ti = 32, My = /* @__PURE__ */ function(e) {
  wae(r, e);
  var n = yae(r);
  function r() {
    return vae(this, r), n.apply(this, arguments);
  }
  return bae(r, [{
    key: "renderIcon",
    value: function(s) {
      var u = this.props.inactiveColor, h = ti / 2, f = ti / 6, p = ti / 3, v = s.inactive ? u : s.color;
      if (s.type === "plainline")
        return /* @__PURE__ */ M("line", {
          strokeWidth: 4,
          fill: "none",
          stroke: v,
          strokeDasharray: s.payload.strokeDasharray,
          x1: 0,
          y1: h,
          x2: ti,
          y2: h,
          className: "recharts-legend-icon"
        });
      if (s.type === "line")
        return /* @__PURE__ */ M("path", {
          strokeWidth: 4,
          fill: "none",
          stroke: v,
          d: "M0,".concat(h, "h").concat(p, `
            A`).concat(f, ",").concat(f, ",0,1,1,").concat(2 * p, ",").concat(h, `
            H`).concat(ti, "M").concat(2 * p, ",").concat(h, `
            A`).concat(f, ",").concat(f, ",0,1,1,").concat(p, ",").concat(h),
          className: "recharts-legend-icon"
        });
      if (s.type === "rect")
        return /* @__PURE__ */ M("path", {
          stroke: "none",
          fill: v,
          d: "M0,".concat(ti / 8, "h").concat(ti, "v").concat(ti * 3 / 4, "h").concat(-ti, "z"),
          className: "recharts-legend-icon"
        });
      if (/* @__PURE__ */ oe.isValidElement(s.legendIcon)) {
        var b = mae({}, s);
        return delete b.legendIcon, /* @__PURE__ */ oe.cloneElement(s.legendIcon, b);
      }
      return /* @__PURE__ */ M($g, {
        fill: v,
        cx: h,
        cy: h,
        size: ti,
        sizeType: "diameter",
        type: s.type
      });
    }
  }, {
    key: "renderItems",
    value: function() {
      var s = this, u = this.props, h = u.payload, f = u.iconSize, p = u.layout, v = u.formatter, b = u.inactiveColor, y = {
        x: 0,
        y: 0,
        width: ti,
        height: ti
      }, k = {
        display: p === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, _ = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return h.map(function(E, x) {
        var D, I = E.formatter || v, N = Ce((D = {
          "recharts-legend-item": !0
        }, Yb(D, "legend-item-".concat(x), !0), Yb(D, "inactive", E.inactive), D));
        if (E.type === "none")
          return null;
        var O = E.inactive ? b : E.color;
        return /* @__PURE__ */ K("li", {
          className: N,
          style: k,
          ...Ia(s.props, E, x),
          children: [/* @__PURE__ */ M(Rb, {
            width: f,
            height: f,
            viewBox: y,
            style: _,
            children: s.renderIcon(E)
          }), /* @__PURE__ */ M("span", {
            className: "recharts-legend-item-text",
            style: {
              color: O
            },
            children: I ? I(E.value, E, x) : E.value
          })]
        }, "legend-item-".concat(x));
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.payload, h = s.layout, f = s.align;
      if (!u || !u.length)
        return null;
      var p = {
        padding: 0,
        margin: 0,
        textAlign: h === "horizontal" ? f : "left"
      };
      return /* @__PURE__ */ M("ul", {
        className: "recharts-default-legend",
        style: p,
        children: this.renderItems()
      });
    }
  }]), r;
}(Ln);
My.displayName = "Legend";
My.defaultProps = {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
};
var Cae = Jo, xae = ea, Eae = "[object Number]";
function Sae(e) {
  return typeof e == "number" || xae(e) && Cae(e) == Eae;
}
var C3 = Sae, Mae = C3;
function Tae(e) {
  return Mae(e) && e != +e;
}
var pd = Tae, Dae = Jo, Iae = Tt, Pae = ea, Oae = "[object String]";
function Rae(e) {
  return typeof e == "string" || !Iae(e) && Pae(e) && Dae(e) == Oae;
}
var gd = Rae, pr = function(n) {
  return n === 0 ? 0 : n > 0 ? 1 : -1;
}, Zb = function(n) {
  return gd(n) && n.indexOf("%") === n.length - 1;
}, Oe = function(n) {
  return C3(n) && !pd(n);
}, Un = function(n) {
  return Oe(n) || gd(n);
}, Nae = 0, La = function(n) {
  var r = ++Nae;
  return "".concat(n || "").concat(r);
}, Sr = function(n, r) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!Oe(n) && !gd(n))
    return o;
  var u;
  if (Zb(n)) {
    var h = n.indexOf("%");
    u = r * parseFloat(n.slice(0, h)) / 100;
  } else
    u = +n;
  return pd(u) && (u = o), s && u > r && (u = r), u;
}, ma = function(n) {
  if (!n)
    return null;
  var r = Object.keys(n);
  return r && r.length ? n[r[0]] : null;
}, $ae = function(n) {
  if (!Tt(n))
    return !1;
  for (var r = n.length, o = {}, s = 0; s < r; s++)
    if (!o[n[s]])
      o[n[s]] = !0;
    else
      return !0;
  return !1;
}, Sn = function(n, r) {
  return Oe(n) && Oe(r) ? function(o) {
    return n + o * (r - n);
  } : function() {
    return r;
  };
};
function ap(e, n, r) {
  return !e || !e.length ? null : e.find(function(o) {
    return o && (typeof n == "function" ? n(o) : Hn(o, n)) === r;
  });
}
var Lae = function(n) {
  if (!n || !n.length)
    return null;
  for (var r = n.length, o = 0, s = 0, u = 0, h = 0, f = 1 / 0, p = -1 / 0, v = 0, b = 0, y = 0; y < r; y++)
    v = n[y].cx || 0, b = n[y].cy || 0, o += v, s += b, u += v * b, h += v * v, f = Math.min(f, v), p = Math.max(p, v);
  var k = r * h !== o * o ? (r * u - o * s) / (r * h - o * o) : 0;
  return {
    xmin: f,
    xmax: p,
    a: k,
    b: (s - k * o) / r
  };
};
function vf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? vf = function(r) {
    return typeof r;
  } : vf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, vf(e);
}
function cS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Ol(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? cS(Object(r), !0).forEach(function(o) {
      jae(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function jae(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Bae(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function uS(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Fae(e, n, r) {
  return n && uS(e.prototype, n), r && uS(e, r), e;
}
function zae(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Xb(e, n);
}
function Xb(e, n) {
  return Xb = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Xb(e, n);
}
function Vae(e) {
  var n = Wae();
  return function() {
    var o = sp(e), s;
    if (n) {
      var u = sp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Hae(this, s);
  };
}
function Hae(e, n) {
  return n && (vf(n) === "object" || typeof n == "function") ? n : Uae(e);
}
function Uae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function sp(e) {
  return sp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, sp(e);
}
function Gae(e, n) {
  if (e == null)
    return {};
  var r = qae(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function qae(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Kae(e) {
  return e.value;
}
function Yae(e, n) {
  return e === !0 ? Jf(n, Kae) : qe(e) ? Jf(n, e) : n;
}
function Qae(e, n) {
  if (/* @__PURE__ */ oe.isValidElement(e))
    return /* @__PURE__ */ oe.cloneElement(e, n);
  if (qe(e))
    return /* @__PURE__ */ oe.createElement(e, n);
  n.ref;
  var r = Gae(n, ["ref"]);
  return /* @__PURE__ */ M(My, {
    ...r
  });
}
var dS = 1, Os = /* @__PURE__ */ function(e) {
  zae(r, e);
  var n = Vae(r);
  function r() {
    var o;
    Bae(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.wrapperNode = void 0, o.state = {
      boxWidth: -1,
      boxHeight: -1
    }, o;
  }
  return Fae(r, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      return this.wrapperNode && this.wrapperNode.getBoundingClientRect ? this.wrapperNode.getBoundingClientRect() : null;
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      var s = this.state, u = s.boxWidth, h = s.boxHeight;
      return u >= 0 && h >= 0 ? {
        width: u,
        height: h
      } : null;
    }
  }, {
    key: "getDefaultPosition",
    value: function(s) {
      var u = this.props, h = u.layout, f = u.align, p = u.verticalAlign, v = u.margin, b = u.chartWidth, y = u.chartHeight, k, _;
      if (!s || (s.left === void 0 || s.left === null) && (s.right === void 0 || s.right === null))
        if (f === "center" && h === "vertical") {
          var E = this.getBBoxSnapshot() || {
            width: 0
          };
          k = {
            left: ((b || 0) - E.width) / 2
          };
        } else
          k = f === "right" ? {
            right: v && v.right || 0
          } : {
            left: v && v.left || 0
          };
      if (!s || (s.top === void 0 || s.top === null) && (s.bottom === void 0 || s.bottom === null))
        if (p === "middle") {
          var x = this.getBBoxSnapshot() || {
            height: 0
          };
          _ = {
            top: ((y || 0) - x.height) / 2
          };
        } else
          _ = p === "bottom" ? {
            bottom: v && v.bottom || 0
          } : {
            top: v && v.top || 0
          };
      return Ol(Ol({}, k), _);
    }
  }, {
    key: "updateBBox",
    value: function() {
      var s = this.state, u = s.boxWidth, h = s.boxHeight, f = this.props.onBBoxUpdate;
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var p = this.wrapperNode.getBoundingClientRect();
        (Math.abs(p.width - u) > dS || Math.abs(p.height - h) > dS) && this.setState({
          boxWidth: p.width,
          boxHeight: p.height
        }, function() {
          f && f(p);
        });
      } else
        (u !== -1 || h !== -1) && this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function() {
          f && f(null);
        });
    }
  }, {
    key: "render",
    value: function() {
      var s = this, u = this.props, h = u.content, f = u.width, p = u.height, v = u.wrapperStyle, b = u.payloadUniqBy, y = u.payload, k = Ol(Ol({
        position: "absolute",
        width: f || "auto",
        height: p || "auto"
      }, this.getDefaultPosition(v)), v);
      return /* @__PURE__ */ M("div", {
        className: "recharts-legend-wrapper",
        style: k,
        ref: function(E) {
          s.wrapperNode = E;
        },
        children: Qae(h, Ol(Ol({}, this.props), {}, {
          payload: Yae(b, y)
        }))
      });
    }
  }], [{
    key: "getWithHeight",
    value: function(s, u) {
      var h = s.props.layout;
      return h === "vertical" && Oe(s.props.height) ? {
        height: s.props.height
      } : h === "horizontal" ? {
        width: s.props.width || u
      } : null;
    }
  }]), r;
}(Ln);
Os.displayName = "Legend";
Os.defaultProps = {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
};
function Zae(e) {
  return e == null;
}
var Be = Zae, Fe = { exports: {} }, Mv = { exports: {} }, Ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hS;
function Xae() {
  if (hS)
    return Ht;
  hS = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, h = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, N = e ? Symbol.for("react.scope") : 60119;
  function O(S) {
    if (typeof S == "object" && S !== null) {
      var $ = S.$$typeof;
      switch ($) {
        case n:
          switch (S = S.type, S) {
            case p:
            case v:
            case o:
            case u:
            case s:
            case y:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case f:
                case b:
                case E:
                case _:
                case h:
                  return S;
                default:
                  return $;
              }
          }
        case r:
          return $;
      }
    }
  }
  function P(S) {
    return O(S) === v;
  }
  return Ht.AsyncMode = p, Ht.ConcurrentMode = v, Ht.ContextConsumer = f, Ht.ContextProvider = h, Ht.Element = n, Ht.ForwardRef = b, Ht.Fragment = o, Ht.Lazy = E, Ht.Memo = _, Ht.Portal = r, Ht.Profiler = u, Ht.StrictMode = s, Ht.Suspense = y, Ht.isAsyncMode = function(S) {
    return P(S) || O(S) === p;
  }, Ht.isConcurrentMode = P, Ht.isContextConsumer = function(S) {
    return O(S) === f;
  }, Ht.isContextProvider = function(S) {
    return O(S) === h;
  }, Ht.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === n;
  }, Ht.isForwardRef = function(S) {
    return O(S) === b;
  }, Ht.isFragment = function(S) {
    return O(S) === o;
  }, Ht.isLazy = function(S) {
    return O(S) === E;
  }, Ht.isMemo = function(S) {
    return O(S) === _;
  }, Ht.isPortal = function(S) {
    return O(S) === r;
  }, Ht.isProfiler = function(S) {
    return O(S) === u;
  }, Ht.isStrictMode = function(S) {
    return O(S) === s;
  }, Ht.isSuspense = function(S) {
    return O(S) === y;
  }, Ht.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === o || S === v || S === u || S === s || S === y || S === k || typeof S == "object" && S !== null && (S.$$typeof === E || S.$$typeof === _ || S.$$typeof === h || S.$$typeof === f || S.$$typeof === b || S.$$typeof === D || S.$$typeof === I || S.$$typeof === N || S.$$typeof === x);
  }, Ht.typeOf = O, Ht;
}
var Ut = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fS;
function Jae() {
  return fS || (fS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, h = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, N = e ? Symbol.for("react.scope") : 60119;
    function O(J) {
      return typeof J == "string" || typeof J == "function" || J === o || J === v || J === u || J === s || J === y || J === k || typeof J == "object" && J !== null && (J.$$typeof === E || J.$$typeof === _ || J.$$typeof === h || J.$$typeof === f || J.$$typeof === b || J.$$typeof === D || J.$$typeof === I || J.$$typeof === N || J.$$typeof === x);
    }
    function P(J) {
      if (typeof J == "object" && J !== null) {
        var Ge = J.$$typeof;
        switch (Ge) {
          case n:
            var De = J.type;
            switch (De) {
              case p:
              case v:
              case o:
              case u:
              case s:
              case y:
                return De;
              default:
                var He = De && De.$$typeof;
                switch (He) {
                  case f:
                  case b:
                  case E:
                  case _:
                  case h:
                    return He;
                  default:
                    return Ge;
                }
            }
          case r:
            return Ge;
        }
      }
    }
    var S = p, $ = v, L = f, B = h, U = n, G = b, q = o, Y = E, Q = _, Z = r, ae = u, ie = s, pe = y, ce = !1;
    function ue(J) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), X(J) || P(J) === p;
    }
    function X(J) {
      return P(J) === v;
    }
    function se(J) {
      return P(J) === f;
    }
    function he(J) {
      return P(J) === h;
    }
    function de(J) {
      return typeof J == "object" && J !== null && J.$$typeof === n;
    }
    function me(J) {
      return P(J) === b;
    }
    function we(J) {
      return P(J) === o;
    }
    function Ae(J) {
      return P(J) === E;
    }
    function Se(J) {
      return P(J) === _;
    }
    function ke(J) {
      return P(J) === r;
    }
    function ge(J) {
      return P(J) === u;
    }
    function xe(J) {
      return P(J) === s;
    }
    function Te(J) {
      return P(J) === y;
    }
    Ut.AsyncMode = S, Ut.ConcurrentMode = $, Ut.ContextConsumer = L, Ut.ContextProvider = B, Ut.Element = U, Ut.ForwardRef = G, Ut.Fragment = q, Ut.Lazy = Y, Ut.Memo = Q, Ut.Portal = Z, Ut.Profiler = ae, Ut.StrictMode = ie, Ut.Suspense = pe, Ut.isAsyncMode = ue, Ut.isConcurrentMode = X, Ut.isContextConsumer = se, Ut.isContextProvider = he, Ut.isElement = de, Ut.isForwardRef = me, Ut.isFragment = we, Ut.isLazy = Ae, Ut.isMemo = Se, Ut.isPortal = ke, Ut.isProfiler = ge, Ut.isStrictMode = xe, Ut.isSuspense = Te, Ut.isValidElementType = O, Ut.typeOf = P;
  }()), Ut;
}
var pS;
function x3() {
  return pS || (pS = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = Xae() : e.exports = Jae();
  }(Mv)), Mv.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Tv, gS;
function ese() {
  if (gS)
    return Tv;
  gS = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var h = {}, f = 0; f < 10; f++)
        h["_" + String.fromCharCode(f)] = f;
      var p = Object.getOwnPropertyNames(h).map(function(b) {
        return h[b];
      });
      if (p.join("") !== "0123456789")
        return !1;
      var v = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        v[b] = b;
      }), Object.keys(Object.assign({}, v)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Tv = s() ? Object.assign : function(u, h) {
    for (var f, p = o(u), v, b = 1; b < arguments.length; b++) {
      f = Object(arguments[b]);
      for (var y in f)
        n.call(f, y) && (p[y] = f[y]);
      if (e) {
        v = e(f);
        for (var k = 0; k < v.length; k++)
          r.call(f, v[k]) && (p[v[k]] = f[v[k]]);
      }
    }
    return p;
  }, Tv;
}
var Dv, mS;
function Ty() {
  if (mS)
    return Dv;
  mS = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Dv = e, Dv;
}
var Iv, vS;
function E3() {
  return vS || (vS = 1, Iv = Function.call.bind(Object.prototype.hasOwnProperty)), Iv;
}
var Pv, bS;
function tse() {
  if (bS)
    return Pv;
  bS = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Ty(), r = {}, o = E3();
    e = function(u) {
      var h = "Warning: " + u;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {
      }
    };
  }
  function s(u, h, f, p, v) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in u)
        if (o(u, b)) {
          var y;
          try {
            if (typeof u[b] != "function") {
              var k = Error(
                (p || "React class") + ": " + f + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw k.name = "Invariant Violation", k;
            }
            y = u[b](h, b, p, f, null, n);
          } catch (E) {
            y = E;
          }
          if (y && !(y instanceof Error) && e(
            (p || "React class") + ": type specification of " + f + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in r)) {
            r[y.message] = !0;
            var _ = v ? v() : "";
            e(
              "Failed " + f + " type: " + y.message + (_ ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Pv = s, Pv;
}
var Ov, wS;
function nse() {
  if (wS)
    return Ov;
  wS = 1;
  var e = x3(), n = ese(), r = Ty(), o = E3(), s = tse(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(f) {
    var p = "Warning: " + f;
    typeof console < "u" && console.error(p);
    try {
      throw new Error(p);
    } catch {
    }
  });
  function h() {
    return null;
  }
  return Ov = function(f, p) {
    var v = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function y(X) {
      var se = X && (v && X[v] || X[b]);
      if (typeof se == "function")
        return se;
    }
    var k = "<<anonymous>>", _ = {
      array: I("array"),
      bigint: I("bigint"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: N(),
      arrayOf: O,
      element: P(),
      elementType: S(),
      instanceOf: $,
      node: G(),
      objectOf: B,
      oneOf: L,
      oneOfType: U,
      shape: Y,
      exact: Q
    };
    function E(X, se) {
      return X === se ? X !== 0 || 1 / X === 1 / se : X !== X && se !== se;
    }
    function x(X, se) {
      this.message = X, this.data = se && typeof se == "object" ? se : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function D(X) {
      if (process.env.NODE_ENV !== "production")
        var se = {}, he = 0;
      function de(we, Ae, Se, ke, ge, xe, Te) {
        if (ke = ke || k, xe = xe || Se, Te !== r) {
          if (p) {
            var J = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw J.name = "Invariant Violation", J;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ge = ke + ":" + Se;
            !se[Ge] && he < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + xe + "` prop on `" + ke + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), se[Ge] = !0, he++);
          }
        }
        return Ae[Se] == null ? we ? Ae[Se] === null ? new x("The " + ge + " `" + xe + "` is marked as required " + ("in `" + ke + "`, but its value is `null`.")) : new x("The " + ge + " `" + xe + "` is marked as required in " + ("`" + ke + "`, but its value is `undefined`.")) : null : X(Ae, Se, ke, ge, xe);
      }
      var me = de.bind(null, !1);
      return me.isRequired = de.bind(null, !0), me;
    }
    function I(X) {
      function se(he, de, me, we, Ae, Se) {
        var ke = he[de], ge = ie(ke);
        if (ge !== X) {
          var xe = pe(ke);
          return new x(
            "Invalid " + we + " `" + Ae + "` of type " + ("`" + xe + "` supplied to `" + me + "`, expected ") + ("`" + X + "`."),
            { expectedType: X }
          );
        }
        return null;
      }
      return D(se);
    }
    function N() {
      return D(h);
    }
    function O(X) {
      function se(he, de, me, we, Ae) {
        if (typeof X != "function")
          return new x("Property `" + Ae + "` of component `" + me + "` has invalid PropType notation inside arrayOf.");
        var Se = he[de];
        if (!Array.isArray(Se)) {
          var ke = ie(Se);
          return new x("Invalid " + we + " `" + Ae + "` of type " + ("`" + ke + "` supplied to `" + me + "`, expected an array."));
        }
        for (var ge = 0; ge < Se.length; ge++) {
          var xe = X(Se, ge, me, we, Ae + "[" + ge + "]", r);
          if (xe instanceof Error)
            return xe;
        }
        return null;
      }
      return D(se);
    }
    function P() {
      function X(se, he, de, me, we) {
        var Ae = se[he];
        if (!f(Ae)) {
          var Se = ie(Ae);
          return new x("Invalid " + me + " `" + we + "` of type " + ("`" + Se + "` supplied to `" + de + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(X);
    }
    function S() {
      function X(se, he, de, me, we) {
        var Ae = se[he];
        if (!e.isValidElementType(Ae)) {
          var Se = ie(Ae);
          return new x("Invalid " + me + " `" + we + "` of type " + ("`" + Se + "` supplied to `" + de + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(X);
    }
    function $(X) {
      function se(he, de, me, we, Ae) {
        if (!(he[de] instanceof X)) {
          var Se = X.name || k, ke = ue(he[de]);
          return new x("Invalid " + we + " `" + Ae + "` of type " + ("`" + ke + "` supplied to `" + me + "`, expected ") + ("instance of `" + Se + "`."));
        }
        return null;
      }
      return D(se);
    }
    function L(X) {
      if (!Array.isArray(X))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), h;
      function se(he, de, me, we, Ae) {
        for (var Se = he[de], ke = 0; ke < X.length; ke++)
          if (E(Se, X[ke]))
            return null;
        var ge = JSON.stringify(X, function(Te, J) {
          var Ge = pe(J);
          return Ge === "symbol" ? String(J) : J;
        });
        return new x("Invalid " + we + " `" + Ae + "` of value `" + String(Se) + "` " + ("supplied to `" + me + "`, expected one of " + ge + "."));
      }
      return D(se);
    }
    function B(X) {
      function se(he, de, me, we, Ae) {
        if (typeof X != "function")
          return new x("Property `" + Ae + "` of component `" + me + "` has invalid PropType notation inside objectOf.");
        var Se = he[de], ke = ie(Se);
        if (ke !== "object")
          return new x("Invalid " + we + " `" + Ae + "` of type " + ("`" + ke + "` supplied to `" + me + "`, expected an object."));
        for (var ge in Se)
          if (o(Se, ge)) {
            var xe = X(Se, ge, me, we, Ae + "." + ge, r);
            if (xe instanceof Error)
              return xe;
          }
        return null;
      }
      return D(se);
    }
    function U(X) {
      if (!Array.isArray(X))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var se = 0; se < X.length; se++) {
        var he = X[se];
        if (typeof he != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(he) + " at index " + se + "."
          ), h;
      }
      function de(me, we, Ae, Se, ke) {
        for (var ge = [], xe = 0; xe < X.length; xe++) {
          var Te = X[xe], J = Te(me, we, Ae, Se, ke, r);
          if (J == null)
            return null;
          J.data && o(J.data, "expectedType") && ge.push(J.data.expectedType);
        }
        var Ge = ge.length > 0 ? ", expected one of type [" + ge.join(", ") + "]" : "";
        return new x("Invalid " + Se + " `" + ke + "` supplied to " + ("`" + Ae + "`" + Ge + "."));
      }
      return D(de);
    }
    function G() {
      function X(se, he, de, me, we) {
        return Z(se[he]) ? null : new x("Invalid " + me + " `" + we + "` supplied to " + ("`" + de + "`, expected a ReactNode."));
      }
      return D(X);
    }
    function q(X, se, he, de, me) {
      return new x(
        (X || "React class") + ": " + se + " type `" + he + "." + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + me + "`."
      );
    }
    function Y(X) {
      function se(he, de, me, we, Ae) {
        var Se = he[de], ke = ie(Se);
        if (ke !== "object")
          return new x("Invalid " + we + " `" + Ae + "` of type `" + ke + "` " + ("supplied to `" + me + "`, expected `object`."));
        for (var ge in X) {
          var xe = X[ge];
          if (typeof xe != "function")
            return q(me, we, Ae, ge, pe(xe));
          var Te = xe(Se, ge, me, we, Ae + "." + ge, r);
          if (Te)
            return Te;
        }
        return null;
      }
      return D(se);
    }
    function Q(X) {
      function se(he, de, me, we, Ae) {
        var Se = he[de], ke = ie(Se);
        if (ke !== "object")
          return new x("Invalid " + we + " `" + Ae + "` of type `" + ke + "` " + ("supplied to `" + me + "`, expected `object`."));
        var ge = n({}, he[de], X);
        for (var xe in ge) {
          var Te = X[xe];
          if (o(X, xe) && typeof Te != "function")
            return q(me, we, Ae, xe, pe(Te));
          if (!Te)
            return new x(
              "Invalid " + we + " `" + Ae + "` key `" + xe + "` supplied to `" + me + "`.\nBad object: " + JSON.stringify(he[de], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(X), null, "  ")
            );
          var J = Te(Se, xe, me, we, Ae + "." + xe, r);
          if (J)
            return J;
        }
        return null;
      }
      return D(se);
    }
    function Z(X) {
      switch (typeof X) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !X;
        case "object":
          if (Array.isArray(X))
            return X.every(Z);
          if (X === null || f(X))
            return !0;
          var se = y(X);
          if (se) {
            var he = se.call(X), de;
            if (se !== X.entries) {
              for (; !(de = he.next()).done; )
                if (!Z(de.value))
                  return !1;
            } else
              for (; !(de = he.next()).done; ) {
                var me = de.value;
                if (me && !Z(me[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(X, se) {
      return X === "symbol" ? !0 : se ? se["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && se instanceof Symbol : !1;
    }
    function ie(X) {
      var se = typeof X;
      return Array.isArray(X) ? "array" : X instanceof RegExp ? "object" : ae(se, X) ? "symbol" : se;
    }
    function pe(X) {
      if (typeof X > "u" || X === null)
        return "" + X;
      var se = ie(X);
      if (se === "object") {
        if (X instanceof Date)
          return "date";
        if (X instanceof RegExp)
          return "regexp";
      }
      return se;
    }
    function ce(X) {
      var se = pe(X);
      switch (se) {
        case "array":
        case "object":
          return "an " + se;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + se;
        default:
          return se;
      }
    }
    function ue(X) {
      return !X.constructor || !X.constructor.name ? k : X.constructor.name;
    }
    return _.checkPropTypes = s, _.resetWarningCache = s.resetWarningCache, _.PropTypes = _, _;
  }, Ov;
}
var Rv, yS;
function rse() {
  if (yS)
    return Rv;
  yS = 1;
  var e = Ty();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, Rv = function() {
    function o(h, f, p, v, b, y) {
      if (y !== e) {
        var k = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw k.name = "Invariant Violation", k;
      }
    }
    o.isRequired = o;
    function s() {
      return o;
    }
    var u = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: s,
      element: o,
      elementType: o,
      instanceOf: s,
      node: o,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return u.PropTypes = u, u;
  }, Rv;
}
if (process.env.NODE_ENV !== "production") {
  var ise = x3(), ose = !0;
  Fe.exports = nse()(ise.isElement, ose);
} else
  Fe.exports = rse()();
var ase = typeof WeakSet == "function", kS = Object.keys;
function Dy(e, n) {
  return e === n || e !== e && n !== n;
}
function _S(e) {
  return e.constructor === Object || e.constructor == null;
}
function AS(e) {
  return !!e && typeof e.then == "function";
}
function CS(e) {
  return !!(e && e.$$typeof);
}
function sse() {
  var e = [];
  return {
    add: function(n) {
      e.push(n);
    },
    has: function(n) {
      return e.indexOf(n) !== -1;
    }
  };
}
var lse = function(e) {
  return e ? function() {
    return /* @__PURE__ */ new WeakSet();
  } : sse;
}(ase);
function S3(e) {
  return function(r) {
    var o = e || r;
    return function(u, h, f) {
      f === void 0 && (f = lse());
      var p = !!u && typeof u == "object", v = !!h && typeof h == "object";
      if (p || v) {
        var b = p && f.has(u), y = v && f.has(h);
        if (b || y)
          return b && y;
        p && f.add(u), v && f.add(h);
      }
      return o(u, h, f);
    };
  };
}
function cse(e, n, r, o) {
  var s = e.length;
  if (n.length !== s)
    return !1;
  for (; s-- > 0; )
    if (!r(e[s], n[s], o))
      return !1;
  return !0;
}
function use(e, n, r, o) {
  var s = e.size === n.size;
  if (s && e.size) {
    var u = {};
    e.forEach(function(h, f) {
      if (s) {
        var p = !1, v = 0;
        n.forEach(function(b, y) {
          !p && !u[v] && (p = r(f, y, o) && r(h, b, o), p && (u[v] = !0)), v++;
        }), s = p;
      }
    });
  }
  return s;
}
var dse = "_owner", hse = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
function xS(e, n, r, o) {
  var s = kS(e), u = s.length;
  if (kS(n).length !== u)
    return !1;
  if (u)
    for (var h = void 0; u-- > 0; ) {
      if (h = s[u], h === dse) {
        var f = CS(e), p = CS(n);
        if ((f || p) && f !== p)
          return !1;
      }
      if (!hse(n, h) || !r(e[h], n[h], o))
        return !1;
    }
  return !0;
}
function fse(e, n) {
  return e.source === n.source && e.global === n.global && e.ignoreCase === n.ignoreCase && e.multiline === n.multiline && e.unicode === n.unicode && e.sticky === n.sticky && e.lastIndex === n.lastIndex;
}
function pse(e, n, r, o) {
  var s = e.size === n.size;
  if (s && e.size) {
    var u = {};
    e.forEach(function(h) {
      if (s) {
        var f = !1, p = 0;
        n.forEach(function(v) {
          !f && !u[p] && (f = r(h, v, o), f && (u[p] = !0)), p++;
        }), s = f;
      }
    });
  }
  return s;
}
var gse = typeof Map == "function", mse = typeof Set == "function";
function Lg(e) {
  var n = typeof e == "function" ? e(r) : r;
  function r(o, s, u) {
    if (o === s)
      return !0;
    if (o && s && typeof o == "object" && typeof s == "object") {
      if (_S(o) && _S(s))
        return xS(o, s, n, u);
      var h = Array.isArray(o), f = Array.isArray(s);
      return h || f ? h === f && cse(o, s, n, u) : (h = o instanceof Date, f = s instanceof Date, h || f ? h === f && Dy(o.getTime(), s.getTime()) : (h = o instanceof RegExp, f = s instanceof RegExp, h || f ? h === f && fse(o, s) : AS(o) || AS(s) ? o === s : gse && (h = o instanceof Map, f = s instanceof Map, h || f) ? h === f && use(o, s, n, u) : mse && (h = o instanceof Set, f = s instanceof Set, h || f) ? h === f && pse(o, s, n, u) : xS(o, s, n, u)));
    }
    return o !== o && s !== s;
  }
  return r;
}
var vse = Lg();
Lg(function() {
  return Dy;
});
Lg(S3());
Lg(S3(Dy));
function ES(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, o = function s(u) {
    r < 0 && (r = u), u - r > n ? (e(u), r = -1) : requestAnimationFrame(s);
  };
  requestAnimationFrame(o);
}
function bf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? bf = function(r) {
    return typeof r;
  } : bf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, bf(e);
}
function bse(e) {
  return _se(e) || kse(e) || yse(e) || wse();
}
function wse() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yse(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return SS(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return SS(e, n);
  }
}
function SS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function kse(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function _se(e) {
  if (Array.isArray(e))
    return e;
}
function Ase() {
  var e = {}, n = function() {
    return null;
  }, r = !1, o = function s(u) {
    if (!r) {
      if (Array.isArray(u)) {
        if (!u.length)
          return;
        var h = u, f = bse(h), p = f[0], v = f.slice(1);
        if (typeof p == "number") {
          ES(s.bind(null, v), p);
          return;
        }
        s(p), ES(s.bind(null, v));
        return;
      }
      bf(u) === "object" && (e = u, n(e)), typeof u == "function" && u();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(u) {
      r = !1, o(u);
    },
    subscribe: function(u) {
      return n = u, function() {
        n = function() {
          return null;
        };
      };
    }
  };
}
function MS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Gl(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? MS(Object(r), !0).forEach(function(o) {
      lp(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function lp(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
var Cse = ["Webkit", "Moz", "O", "ms"], xse = ["-webkit-", "-moz-", "-o-", "-ms-"], Ese = ["transform", "transformOrigin", "transition"], Sse = function(n, r) {
  return [Object.keys(n), Object.keys(r)].reduce(function(o, s) {
    return o.filter(function(u) {
      return s.includes(u);
    });
  });
}, Mse = function(n) {
  return n;
}, Tse = function(n) {
  return n.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, Dse = function(n, r) {
  if (Ese.indexOf(n) === -1)
    return lp({}, n, r);
  var o = n === "transition", s = n.replace(/(\w)/, function(h) {
    return h.toUpperCase();
  }), u = r;
  return Cse.reduce(function(h, f, p) {
    return o && (u = r.replace(/(transform|transform-origin)/gim, "".concat(xse[p], "$1"))), Gl(Gl({}, h), {}, lp({}, f + s, u));
  }, {});
}, Bu = function(n, r) {
  return Object.keys(r).reduce(function(o, s) {
    return Gl(Gl({}, o), {}, lp({}, s, n(s, r[s])));
  }, {});
}, Jb = function(n) {
  return Object.keys(n).reduce(function(r, o) {
    return Gl(Gl({}, r), Dse(o, r[o]));
  }, n);
}, TS = function(n, r, o) {
  return n.map(function(s) {
    return "".concat(Tse(s), " ").concat(r, "ms ").concat(o);
  }).join(",");
}, Ise = process.env.NODE_ENV !== "production", cp = function(n, r, o, s, u, h, f, p) {
  if (Ise && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !n))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var v = [o, s, u, h, f, p], b = 0;
      console.warn(r.replace(/%s/g, function() {
        return v[b++];
      }));
    }
};
function Pse(e, n) {
  return Nse(e) || Rse(e, n) || M3(e, n) || Ose();
}
function Ose() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rse(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function Nse(e) {
  if (Array.isArray(e))
    return e;
}
function $se(e) {
  return Bse(e) || jse(e) || M3(e) || Lse();
}
function Lse() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M3(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return ew(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ew(e, n);
  }
}
function jse(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Bse(e) {
  if (Array.isArray(e))
    return ew(e);
}
function ew(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
var up = 1e-4, T3 = function(n, r) {
  return [0, 3 * n, 3 * r - 6 * n, 3 * n - 3 * r + 1];
}, D3 = function(n, r) {
  return n.map(function(o, s) {
    return o * Math.pow(r, s);
  }).reduce(function(o, s) {
    return o + s;
  });
}, DS = function(n, r) {
  return function(o) {
    var s = T3(n, r);
    return D3(s, o);
  };
}, Fse = function(n, r) {
  return function(o) {
    var s = T3(n, r), u = [].concat($se(s.map(function(h, f) {
      return h * f;
    }).slice(1)), [0]);
    return D3(u, o);
  };
}, IS = function() {
  for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var s = r[0], u = r[1], h = r[2], f = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        s = 0, u = 0, h = 1, f = 1;
        break;
      case "ease":
        s = 0.25, u = 0.1, h = 0.25, f = 1;
        break;
      case "ease-in":
        s = 0.42, u = 0, h = 1, f = 1;
        break;
      case "ease-out":
        s = 0.42, u = 0, h = 0.58, f = 1;
        break;
      case "ease-in-out":
        s = 0, u = 0, h = 0.58, f = 1;
        break;
      default: {
        var p = r[0].split("(");
        if (p[0] === "cubic-bezier" && p[1].split(")")[0].split(",").length === 4) {
          var v = p[1].split(")")[0].split(",").map(function(D) {
            return parseFloat(D);
          }), b = Pse(v, 4);
          s = b[0], u = b[1], h = b[2], f = b[3];
        } else
          cp(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  cp([s, h, u, f].every(function(D) {
    return typeof D == "number" && D >= 0 && D <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var y = DS(s, h), k = DS(u, f), _ = Fse(s, h), E = function(I) {
    return I > 1 ? 1 : I < 0 ? 0 : I;
  }, x = function(I) {
    for (var N = I > 1 ? 1 : I, O = N, P = 0; P < 8; ++P) {
      var S = y(O) - N, $ = _(O);
      if (Math.abs(S - N) < up || $ < up)
        return k(O);
      O = E(O - S / $);
    }
    return k(O);
  };
  return x.isStepper = !1, x;
}, zse = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.stiff, o = r === void 0 ? 100 : r, s = n.damping, u = s === void 0 ? 8 : s, h = n.dt, f = h === void 0 ? 17 : h, p = function(b, y, k) {
    var _ = -(b - y) * o, E = k * u, x = k + (_ - E) * f / 1e3, D = k * f / 1e3 + b;
    return Math.abs(D - y) < up && Math.abs(x) < up ? [y, 0] : [D, x];
  };
  return p.isStepper = !0, p.dt = f, p;
}, Vse = function() {
  for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var s = r[0];
  if (typeof s == "string")
    switch (s) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return IS(s);
      case "spring":
        return zse();
      default:
        if (s.split("(")[0] === "cubic-bezier")
          return IS(s);
        cp(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof s == "function" ? s : (cp(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function PS(e) {
  return Wse(e) || Use(e) || I3(e) || Hse();
}
function Hse() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Use(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Wse(e) {
  if (Array.isArray(e))
    return nw(e);
}
function OS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function lr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? OS(Object(r), !0).forEach(function(o) {
      tw(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : OS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function tw(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function Gse(e, n) {
  return Yse(e) || Kse(e, n) || I3(e, n) || qse();
}
function qse() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I3(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return nw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return nw(e, n);
  }
}
function nw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function Kse(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function Yse(e) {
  if (Array.isArray(e))
    return e;
}
var dp = function(n, r, o) {
  return n + (r - n) * o;
}, rw = function(n) {
  var r = n.from, o = n.to;
  return r !== o;
}, Qse = function e(n, r, o) {
  var s = Bu(function(u, h) {
    if (rw(h)) {
      var f = n(h.from, h.to, h.velocity), p = Gse(f, 2), v = p[0], b = p[1];
      return lr(lr({}, h), {}, {
        from: v,
        velocity: b
      });
    }
    return h;
  }, r);
  return o < 1 ? Bu(function(u, h) {
    return rw(h) ? lr(lr({}, h), {}, {
      velocity: dp(h.velocity, s[u].velocity, o),
      from: dp(h.from, s[u].from, o)
    }) : h;
  }, r) : e(n, s, o - 1);
};
const Zse = function(e, n, r, o, s) {
  var u = Sse(e, n), h = u.reduce(function(D, I) {
    return lr(lr({}, D), {}, tw({}, I, [e[I], n[I]]));
  }, {}), f = u.reduce(function(D, I) {
    return lr(lr({}, D), {}, tw({}, I, {
      from: e[I],
      velocity: 0,
      to: n[I]
    }));
  }, {}), p = -1, v, b, y = function() {
    return null;
  }, k = function() {
    return Bu(function(I, N) {
      return N.from;
    }, f);
  }, _ = function() {
    return !Object.values(f).filter(rw).length;
  }, E = function(I) {
    v || (v = I);
    var N = I - v, O = N / r.dt;
    f = Qse(r, f, O), s(lr(lr(lr({}, e), n), k())), v = I, _() || (p = requestAnimationFrame(y));
  }, x = function(I) {
    b || (b = I);
    var N = (I - b) / o, O = Bu(function(S, $) {
      return dp.apply(void 0, PS($).concat([r(N)]));
    }, h);
    if (s(lr(lr(lr({}, e), n), O)), N < 1)
      p = requestAnimationFrame(y);
    else {
      var P = Bu(function(S, $) {
        return dp.apply(void 0, PS($).concat([r(1)]));
      }, h);
      s(lr(lr(lr({}, e), n), P));
    }
  };
  return y = r.isStepper ? E : x, function() {
    return requestAnimationFrame(y), function() {
      cancelAnimationFrame(p);
    };
  };
};
function wf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? wf = function(r) {
    return typeof r;
  } : wf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, wf(e);
}
function Xse(e, n) {
  if (e == null)
    return {};
  var r = Jse(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Jse(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Nv(e) {
  return rle(e) || nle(e) || tle(e) || ele();
}
function ele() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tle(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return iw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return iw(e, n);
  }
}
function nle(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function rle(e) {
  if (Array.isArray(e))
    return iw(e);
}
function iw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function RS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Si(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? RS(Object(r), !0).forEach(function(o) {
      Ou(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : RS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Ou(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function ile(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function NS(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function ole(e, n, r) {
  return n && NS(e.prototype, n), r && NS(e, r), e;
}
function ale(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && ow(e, n);
}
function ow(e, n) {
  return ow = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, ow(e, n);
}
function sle(e) {
  var n = lle();
  return function() {
    var o = hp(e), s;
    if (n) {
      var u = hp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return aw(this, s);
  };
}
function aw(e, n) {
  return n && (wf(n) === "object" || typeof n == "function") ? n : sw(e);
}
function sw(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lle() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function hp(e) {
  return hp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hp(e);
}
var mo = /* @__PURE__ */ function(e) {
  ale(r, e);
  var n = sle(r);
  function r(o, s) {
    var u;
    ile(this, r), u = n.call(this, o, s);
    var h = u.props, f = h.isActive, p = h.attributeName, v = h.from, b = h.to, y = h.steps, k = h.children;
    if (u.handleStyleChange = u.handleStyleChange.bind(sw(u)), u.changeStyle = u.changeStyle.bind(sw(u)), !f)
      return u.state = {
        style: {}
      }, typeof k == "function" && (u.state = {
        style: b
      }), aw(u);
    if (y && y.length)
      u.state = {
        style: y[0].style
      };
    else if (v) {
      if (typeof k == "function")
        return u.state = {
          style: v
        }, aw(u);
      u.state = {
        style: p ? Ou({}, p, v) : v
      };
    } else
      u.state = {
        style: {}
      };
    return u;
  }
  return ole(r, [{
    key: "componentDidMount",
    value: function() {
      var s = this.props, u = s.isActive, h = s.canBegin;
      this.mounted = !0, !(!u || !h) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(s) {
      var u = this.props, h = u.isActive, f = u.canBegin, p = u.attributeName, v = u.shouldReAnimate;
      if (!!f) {
        if (!h) {
          var b = {
            style: p ? Ou({}, p, this.props.to) : this.props.to
          };
          this.state && this.state.style && (p && this.state.style[p] !== this.props.to || !p && this.state.style !== this.props.to) && this.setState(b);
          return;
        }
        if (!(vse(s.to, this.props.to) && s.canBegin && s.isActive)) {
          var y = !s.canBegin || !s.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var k = y || v ? this.props.from : s.to;
          if (this.state && this.state.style) {
            var _ = {
              style: p ? Ou({}, p, k) : k
            };
            (p && this.state.style[p] !== k || !p && this.state.style !== k) && this.setState(_);
          }
          this.runAnimation(Si(Si({}, this.props), {}, {
            from: k,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1, this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation();
    }
  }, {
    key: "runJSAnimation",
    value: function(s) {
      var u = this, h = s.from, f = s.to, p = s.duration, v = s.easing, b = s.begin, y = s.onAnimationEnd, k = s.onAnimationStart, _ = Zse(h, f, Vse(v), p, this.changeStyle), E = function() {
        u.stopJSAnimation = _();
      };
      this.manager.start([k, b, E, p, y]);
    }
  }, {
    key: "runStepAnimation",
    value: function(s) {
      var u = this, h = s.steps, f = s.begin, p = s.onAnimationStart, v = h[0], b = v.style, y = v.duration, k = y === void 0 ? 0 : y, _ = function(x, D, I) {
        if (I === 0)
          return x;
        var N = D.duration, O = D.easing, P = O === void 0 ? "ease" : O, S = D.style, $ = D.properties, L = D.onAnimationEnd, B = I > 0 ? h[I - 1] : D, U = $ || Object.keys(S);
        if (typeof P == "function" || P === "spring")
          return [].concat(Nv(x), [u.runJSAnimation.bind(u, {
            from: B.style,
            to: S,
            duration: N,
            easing: P
          }), N]);
        var G = TS(U, N, P), q = Si(Si(Si({}, B.style), S), {}, {
          transition: G
        });
        return [].concat(Nv(x), [q, N, L]).filter(Mse);
      };
      return this.manager.start([p].concat(Nv(h.reduce(_, [b, Math.max(k, f)])), [s.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(s) {
      this.manager || (this.manager = Ase());
      var u = s.begin, h = s.duration, f = s.attributeName, p = s.to, v = s.easing, b = s.onAnimationStart, y = s.onAnimationEnd, k = s.steps, _ = s.children, E = this.manager;
      if (this.unSubscribe = E.subscribe(this.handleStyleChange), typeof v == "function" || typeof _ == "function" || v === "spring") {
        this.runJSAnimation(s);
        return;
      }
      if (k.length > 1) {
        this.runStepAnimation(s);
        return;
      }
      var x = f ? Ou({}, f, p) : p, D = TS(Object.keys(x), h, v);
      E.start([b, u, Si(Si({}, x), {}, {
        transition: D
      }), h, y]);
    }
  }, {
    key: "handleStyleChange",
    value: function(s) {
      this.changeStyle(s);
    }
  }, {
    key: "changeStyle",
    value: function(s) {
      this.mounted && this.setState({
        style: s
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.children;
      s.begin, s.duration, s.attributeName, s.easing;
      var h = s.isActive;
      s.steps, s.from, s.to, s.canBegin, s.onAnimationEnd, s.shouldReAnimate, s.onAnimationReStart;
      var f = Xse(s, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]), p = xs.count(u), v = Jb(this.state.style);
      if (typeof u == "function")
        return u(v);
      if (!h || p === 0)
        return u;
      var b = function(k) {
        var _ = k.props, E = _.style, x = E === void 0 ? {} : E, D = _.className, I = /* @__PURE__ */ cr(k, Si(Si({}, f), {}, {
          style: Si(Si({}, x), v),
          className: D
        }));
        return I;
      };
      return p === 1 ? b(xs.only(u)) : /* @__PURE__ */ M("div", {
        children: xs.map(u, function(y) {
          return b(y);
        })
      });
    }
  }]), r;
}(Ln);
mo.displayName = "Animate";
mo.propTypes = {
  from: Fe.exports.oneOfType([Fe.exports.object, Fe.exports.string]),
  to: Fe.exports.oneOfType([Fe.exports.object, Fe.exports.string]),
  attributeName: Fe.exports.string,
  duration: Fe.exports.number,
  begin: Fe.exports.number,
  easing: Fe.exports.oneOfType([Fe.exports.string, Fe.exports.func]),
  steps: Fe.exports.arrayOf(Fe.exports.shape({
    duration: Fe.exports.number.isRequired,
    style: Fe.exports.object.isRequired,
    easing: Fe.exports.oneOfType([Fe.exports.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Fe.exports.func]),
    properties: Fe.exports.arrayOf("string"),
    onAnimationEnd: Fe.exports.func
  })),
  children: Fe.exports.oneOfType([Fe.exports.node, Fe.exports.func]),
  isActive: Fe.exports.bool,
  canBegin: Fe.exports.bool,
  onAnimationEnd: Fe.exports.func,
  shouldReAnimate: Fe.exports.bool,
  onAnimationStart: Fe.exports.func,
  onAnimationReStart: Fe.exports.func
};
mo.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Number.isFinite === void 0 && (Number.isFinite = function(e) {
  return typeof e == "number" && isFinite(e);
});
Fe.exports.object, Fe.exports.object, Fe.exports.object, Fe.exports.element;
Fe.exports.object, Fe.exports.object, Fe.exports.object, Fe.exports.oneOfType([Fe.exports.array, Fe.exports.element]), Fe.exports.any;
var $S = hd, cle = by, ule = Tt, LS = $S ? $S.isConcatSpreadable : void 0;
function dle(e) {
  return ule(e) || cle(e) || !!(LS && e && e[LS]);
}
var hle = dle, fle = VI, ple = hle;
function P3(e, n, r, o, s) {
  var u = -1, h = e.length;
  for (r || (r = ple), s || (s = []); ++u < h; ) {
    var f = e[u];
    n > 0 && r(f) ? n > 1 ? P3(f, n - 1, r, o, s) : fle(s, f) : o || (s[s.length] = f);
  }
  return s;
}
var O3 = P3;
function gle(e) {
  return function(n, r, o) {
    for (var s = -1, u = Object(n), h = o(n), f = h.length; f--; ) {
      var p = h[e ? f : ++s];
      if (r(u[p], p, u) === !1)
        break;
    }
    return n;
  };
}
var mle = gle, vle = mle, ble = vle(), wle = ble, yle = wle, kle = Tg;
function _le(e, n) {
  return e && yle(e, n, kle);
}
var R3 = _le, Ale = fd;
function Cle(e, n) {
  return function(r, o) {
    if (r == null)
      return r;
    if (!Ale(r))
      return e(r, o);
    for (var s = r.length, u = n ? s : -1, h = Object(r); (n ? u-- : ++u < s) && o(h[u], u, h) !== !1; )
      ;
    return r;
  };
}
var xle = Cle, Ele = R3, Sle = xle, Mle = Sle(Ele), Iy = Mle, Tle = Iy, Dle = fd;
function Ile(e, n) {
  var r = -1, o = Dle(e) ? Array(e.length) : [];
  return Tle(e, function(s, u, h) {
    o[++r] = n(s, u, h);
  }), o;
}
var N3 = Ile;
function Ple(e, n) {
  var r = e.length;
  for (e.sort(n); r--; )
    e[r] = e[r].value;
  return e;
}
var Ole = Ple, jS = gc;
function Rle(e, n) {
  if (e !== n) {
    var r = e !== void 0, o = e === null, s = e === e, u = jS(e), h = n !== void 0, f = n === null, p = n === n, v = jS(n);
    if (!f && !v && !u && e > n || u && h && p && !f && !v || o && h && p || !r && p || !s)
      return 1;
    if (!o && !u && !v && e < n || v && r && s && !o && !u || f && r && s || !h && s || !p)
      return -1;
  }
  return 0;
}
var Nle = Rle, $le = Nle;
function Lle(e, n, r) {
  for (var o = -1, s = e.criteria, u = n.criteria, h = s.length, f = r.length; ++o < h; ) {
    var p = $le(s[o], u[o]);
    if (p) {
      if (o >= f)
        return p;
      var v = r[o];
      return p * (v == "desc" ? -1 : 1);
    }
  }
  return e.index - n.index;
}
var jle = Lle, $v = Cy, Ble = xy, Fle = ko, zle = N3, Vle = Ole, Hle = UI, Ule = jle, Wle = mc, Gle = Tt;
function qle(e, n, r) {
  n.length ? n = $v(n, function(u) {
    return Gle(u) ? function(h) {
      return Ble(h, u.length === 1 ? u[0] : u);
    } : u;
  }) : n = [Wle];
  var o = -1;
  n = $v(n, Hle(Fle));
  var s = zle(e, function(u, h, f) {
    var p = $v(n, function(v) {
      return v(u);
    });
    return { criteria: p, index: ++o, value: u };
  });
  return Vle(s, function(u, h) {
    return Ule(u, h, r);
  });
}
var Kle = qle;
function Yle(e, n, r) {
  switch (r.length) {
    case 0:
      return e.call(n);
    case 1:
      return e.call(n, r[0]);
    case 2:
      return e.call(n, r[0], r[1]);
    case 3:
      return e.call(n, r[0], r[1], r[2]);
  }
  return e.apply(n, r);
}
var Qle = Yle, Zle = Qle, BS = Math.max;
function Xle(e, n, r) {
  return n = BS(n === void 0 ? e.length - 1 : n, 0), function() {
    for (var o = arguments, s = -1, u = BS(o.length - n, 0), h = Array(u); ++s < u; )
      h[s] = o[n + s];
    s = -1;
    for (var f = Array(n + 1); ++s < n; )
      f[s] = o[s];
    return f[n] = r(h), Zle(e, this, f);
  };
}
var Jle = Xle;
function ece(e) {
  return function() {
    return e;
  };
}
var tce = ece, nce = Us, rce = function() {
  try {
    var e = nce(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), $3 = rce, ice = tce, FS = $3, oce = mc, ace = FS ? function(e, n) {
  return FS(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ice(n),
    writable: !0
  });
} : oce, sce = ace, lce = 800, cce = 16, uce = Date.now;
function dce(e) {
  var n = 0, r = 0;
  return function() {
    var o = uce(), s = cce - (o - r);
    if (r = o, s > 0) {
      if (++n >= lce)
        return arguments[0];
    } else
      n = 0;
    return e.apply(void 0, arguments);
  };
}
var hce = dce, fce = sce, pce = hce, gce = pce(fce), mce = gce, vce = mc, bce = Jle, wce = mce;
function yce(e, n) {
  return wce(bce(e, n, vce), e + "");
}
var kce = yce, _ce = py, Ace = fd, Cce = wy, xce = Vr;
function Ece(e, n, r) {
  if (!xce(r))
    return !1;
  var o = typeof n;
  return (o == "number" ? Ace(r) && Cce(n, r.length) : o == "string" && n in r) ? _ce(r[n], e) : !1;
}
var jg = Ece, Sce = O3, Mce = Kle, Tce = kce, zS = jg, Dce = Tce(function(e, n) {
  if (e == null)
    return [];
  var r = n.length;
  return r > 1 && zS(e, n[0], n[1]) ? n = [] : r > 2 && zS(n[0], n[1], n[2]) && (n = [n[0]]), Mce(e, Sce(n, 1), []);
}), Py = Dce;
function yf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yf = function(r) {
    return typeof r;
  } : yf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, yf(e);
}
function Ice(e, n) {
  return Nce(e) || Rce(e, n) || Oce(e, n) || Pce();
}
function Pce() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oce(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return VS(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return VS(e, n);
  }
}
function VS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function Rce(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function Nce(e) {
  if (Array.isArray(e))
    return e;
}
function HS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Lv(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? HS(Object(r), !0).forEach(function(o) {
      $ce(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function $ce(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Lce(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function US(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function jce(e, n, r) {
  return n && US(e.prototype, n), r && US(e, r), e;
}
function Bce(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && lw(e, n);
}
function lw(e, n) {
  return lw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, lw(e, n);
}
function Fce(e) {
  var n = Hce();
  return function() {
    var o = fp(e), s;
    if (n) {
      var u = fp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return zce(this, s);
  };
}
function zce(e, n) {
  return n && (yf(n) === "object" || typeof n == "function") ? n : Vce(e);
}
function Vce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Hce() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function fp(e) {
  return fp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fp(e);
}
function Uce(e) {
  return Tt(e) && Un(e[0]) && Un(e[1]) ? e.join(" ~ ") : e;
}
var Oy = /* @__PURE__ */ function(e) {
  Bce(r, e);
  var n = Fce(r);
  function r() {
    return Lce(this, r), n.apply(this, arguments);
  }
  return jce(r, [{
    key: "renderContent",
    value: function() {
      var s = this.props, u = s.payload, h = s.separator, f = s.formatter, p = s.itemStyle, v = s.itemSorter;
      if (u && u.length) {
        var b = {
          padding: 0,
          margin: 0
        }, y = (v ? Py(u, v) : u).map(function(k, _) {
          if (k.type === "none")
            return null;
          var E = Lv({
            display: "block",
            paddingTop: 4,
            paddingBottom: 4,
            color: k.color || "#000"
          }, p), x = k.formatter || f || Uce, D = k.value, I = k.name;
          if (x && D != null && I != null) {
            var N = x(D, I, k, _, u);
            if (Array.isArray(N)) {
              var O = N, P = Ice(O, 2);
              D = P[0], I = P[1];
            } else
              D = N;
          }
          return /* @__PURE__ */ K("li", {
            className: "recharts-tooltip-item",
            style: E,
            children: [Un(I) ? /* @__PURE__ */ M("span", {
              className: "recharts-tooltip-item-name",
              children: I
            }) : null, Un(I) ? /* @__PURE__ */ M("span", {
              className: "recharts-tooltip-item-separator",
              children: h
            }) : null, /* @__PURE__ */ M("span", {
              className: "recharts-tooltip-item-value",
              children: D
            }), /* @__PURE__ */ M("span", {
              className: "recharts-tooltip-item-unit",
              children: k.unit || ""
            })]
          }, "tooltip-item-".concat(_));
        });
        return /* @__PURE__ */ M("ul", {
          className: "recharts-tooltip-item-list",
          style: b,
          children: y
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.wrapperClassName, h = s.contentStyle, f = s.labelClassName, p = s.labelStyle, v = s.label, b = s.labelFormatter, y = s.payload, k = Lv({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
      }, h), _ = Lv({
        margin: 0
      }, p), E = !Be(v), x = E ? v : "", D = Ce("recharts-default-tooltip", u), I = Ce("recharts-tooltip-label", f);
      return E && b && y !== void 0 && y !== null && (x = b(v, y)), /* @__PURE__ */ K("div", {
        className: D,
        style: k,
        children: [/* @__PURE__ */ M("p", {
          className: I,
          style: _,
          children: /* @__PURE__ */ oe.isValidElement(x) ? x : "".concat(x)
        }), this.renderContent()]
      });
    }
  }]), r;
}(Ln);
Oy.displayName = "DefaultTooltipContent";
Oy.defaultProps = {
  separator: " : ",
  contentStyle: {},
  itemStyle: {},
  labelStyle: {}
};
var Wce = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, ci = {
  isSsr: Wce(),
  get: function(n) {
    return ci[n];
  },
  set: function(n, r) {
    if (typeof n == "string")
      ci[n] = r;
    else {
      var o = Object.keys(n);
      o && o.length && o.forEach(function(s) {
        ci[s] = n[s];
      });
    }
  }
};
function kf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? kf = function(r) {
    return typeof r;
  } : kf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, kf(e);
}
function WS(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Ro(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? WS(Object(r), !0).forEach(function(o) {
      Ru(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : WS(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Ru(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Gce(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function GS(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function qce(e, n, r) {
  return n && GS(e.prototype, n), r && GS(e, r), e;
}
function Kce(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && cw(e, n);
}
function cw(e, n) {
  return cw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, cw(e, n);
}
function Yce(e) {
  var n = Xce();
  return function() {
    var o = pp(e), s;
    if (n) {
      var u = pp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Qce(this, s);
  };
}
function Qce(e, n) {
  return n && (kf(n) === "object" || typeof n == "function") ? n : Zce(e);
}
function Zce(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Xce() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function pp(e) {
  return pp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pp(e);
}
var xu = "recharts-tooltip-wrapper", qS = 1;
function Jce(e) {
  return e.dataKey;
}
function eue(e, n) {
  return e === !0 ? Jf(n, Jce) : qe(e) ? Jf(n, e) : n;
}
function tue(e, n) {
  return /* @__PURE__ */ oe.isValidElement(e) ? /* @__PURE__ */ oe.cloneElement(e, n) : qe(e) ? /* @__PURE__ */ oe.createElement(e, n) : /* @__PURE__ */ M(Oy, {
    ...n
  });
}
var Ca = /* @__PURE__ */ function(e) {
  Kce(r, e);
  var n = Yce(r);
  function r() {
    var o;
    Gce(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {
      boxWidth: -1,
      boxHeight: -1,
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      }
    }, o.wrapperNode = void 0, o.getTranslate = function(f) {
      var p = f.key, v = f.tooltipDimension, b = f.viewBoxDimension, y = o.props, k = y.allowEscapeViewBox, _ = y.reverseDirection, E = y.coordinate, x = y.offset, D = y.position, I = y.viewBox;
      if (D && Oe(D[p]))
        return D[p];
      var N = E[p] - v - x, O = E[p] + x;
      if (k[p])
        return _[p] ? N : O;
      if (_[p]) {
        var P = N, S = I[p];
        return P < S ? Math.max(O, I[p]) : Math.max(N, I[p]);
      } else {
        var $ = O + v, L = I[p] + b;
        return $ > L ? Math.max(N, I[p]) : Math.max(O, I[p]);
      }
    }, o;
  }
  return qce(r, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "updateBBox",
    value: function() {
      var s = this.state, u = s.boxWidth, h = s.boxHeight, f = s.dismissed;
      if (f ? (this.wrapperNode.blur(), (this.props.coordinate.x !== this.state.dismissedAtCoordinate.x || this.props.coordinate.y !== this.state.dismissedAtCoordinate.y) && this.setState({
        dismissed: !1
      })) : this.wrapperNode.focus({
        preventScroll: !0
      }), this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var p = this.wrapperNode.getBoundingClientRect();
        (Math.abs(p.width - u) > qS || Math.abs(p.height - h) > qS) && this.setState({
          boxWidth: p.width,
          boxHeight: p.height
        });
      } else
        (u !== -1 || h !== -1) && this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
    }
  }, {
    key: "render",
    value: function() {
      var s, u = this, h = this.props, f = h.payload, p = h.isAnimationActive, v = h.animationDuration, b = h.animationEasing, y = h.filterNull, k = h.payloadUniqBy, _ = eue(k, y && f && f.length ? f.filter(function(Q) {
        return !Be(Q.value);
      }) : f), E = _ && _.length, x = this.props, D = x.content, I = x.viewBox, N = x.coordinate, O = x.position, P = x.active, S = x.wrapperStyle, $ = Ro({
        pointerEvents: "none",
        visibility: !this.state.dismissed && P && E ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, S), L, B;
      if (O && Oe(O.x) && Oe(O.y))
        L = O.x, B = O.y;
      else {
        var U = this.state, G = U.boxWidth, q = U.boxHeight;
        G > 0 && q > 0 && N ? (L = this.getTranslate({
          key: "x",
          tooltipDimension: G,
          viewBoxDimension: I.width
        }), B = this.getTranslate({
          key: "y",
          tooltipDimension: q,
          viewBoxDimension: I.height
        })) : $.visibility = "hidden";
      }
      $ = Ro(Ro({}, Jb({
        transform: this.props.useTranslate3d ? "translate3d(".concat(L, "px, ").concat(B, "px, 0)") : "translate(".concat(L, "px, ").concat(B, "px)")
      })), $), p && P && ($ = Ro(Ro({}, Jb({
        transition: "transform ".concat(v, "ms ").concat(b)
      })), $));
      var Y = Ce(xu, (s = {}, Ru(s, "".concat(xu, "-right"), Oe(L) && N && Oe(N.x) && L >= N.x), Ru(s, "".concat(xu, "-left"), Oe(L) && N && Oe(N.x) && L < N.x), Ru(s, "".concat(xu, "-bottom"), Oe(B) && N && Oe(N.y) && B >= N.y), Ru(s, "".concat(xu, "-top"), Oe(B) && N && Oe(N.y) && B < N.y), s));
      return /* @__PURE__ */ M("div", {
        tabIndex: -1,
        role: "dialog",
        onKeyDown: function(Z) {
          Z.key === "Escape" && u.setState({
            dismissed: !0,
            dismissedAtCoordinate: Ro(Ro({}, u.state.dismissedAtCoordinate), {}, {
              x: u.props.coordinate.x,
              y: u.props.coordinate.y
            })
          });
        },
        className: Y,
        style: $,
        ref: function(Z) {
          u.wrapperNode = Z;
        },
        children: tue(D, Ro(Ro({}, this.props), {}, {
          payload: _
        }))
      });
    }
  }]), r;
}(Ln);
Ca.displayName = "Tooltip";
Ca.defaultProps = {
  active: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  reverseDirection: {
    x: !1,
    y: !1
  },
  offset: 10,
  viewBox: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  },
  coordinate: {
    x: 0,
    y: 0
  },
  cursorStyle: {},
  separator: " : ",
  wrapperStyle: {},
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: !0,
  trigger: "hover",
  isAnimationActive: !ci.isSsr,
  animationEasing: "ease",
  animationDuration: 400,
  filterNull: !0,
  useTranslate3d: !1
};
var nue = yo, rue = function() {
  return nue.Date.now();
}, iue = rue, oue = /\s/;
function aue(e) {
  for (var n = e.length; n-- && oue.test(e.charAt(n)); )
    ;
  return n;
}
var sue = aue, lue = sue, cue = /^\s+/;
function uue(e) {
  return e && e.slice(0, lue(e) + 1).replace(cue, "");
}
var due = uue, hue = due, KS = Vr, fue = gc, YS = 0 / 0, pue = /^[-+]0x[0-9a-f]+$/i, gue = /^0b[01]+$/i, mue = /^0o[0-7]+$/i, vue = parseInt;
function bue(e) {
  if (typeof e == "number")
    return e;
  if (fue(e))
    return YS;
  if (KS(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = KS(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = hue(e);
  var r = gue.test(e);
  return r || mue.test(e) ? vue(e.slice(2), r ? 2 : 8) : pue.test(e) ? YS : +e;
}
var L3 = bue, wue = Vr, jv = iue, QS = L3, yue = "Expected a function", kue = Math.max, _ue = Math.min;
function Aue(e, n, r) {
  var o, s, u, h, f, p, v = 0, b = !1, y = !1, k = !0;
  if (typeof e != "function")
    throw new TypeError(yue);
  n = QS(n) || 0, wue(r) && (b = !!r.leading, y = "maxWait" in r, u = y ? kue(QS(r.maxWait) || 0, n) : u, k = "trailing" in r ? !!r.trailing : k);
  function _($) {
    var L = o, B = s;
    return o = s = void 0, v = $, h = e.apply(B, L), h;
  }
  function E($) {
    return v = $, f = setTimeout(I, n), b ? _($) : h;
  }
  function x($) {
    var L = $ - p, B = $ - v, U = n - L;
    return y ? _ue(U, u - B) : U;
  }
  function D($) {
    var L = $ - p, B = $ - v;
    return p === void 0 || L >= n || L < 0 || y && B >= u;
  }
  function I() {
    var $ = jv();
    if (D($))
      return N($);
    f = setTimeout(I, x($));
  }
  function N($) {
    return f = void 0, k && o ? _($) : (o = s = void 0, h);
  }
  function O() {
    f !== void 0 && clearTimeout(f), v = 0, o = p = s = f = void 0;
  }
  function P() {
    return f === void 0 ? h : N(jv());
  }
  function S() {
    var $ = jv(), L = D($);
    if (o = arguments, s = this, p = $, L) {
      if (f === void 0)
        return E(p);
      if (y)
        return clearTimeout(f), f = setTimeout(I, n), _(p);
    }
    return f === void 0 && (f = setTimeout(I, n)), h;
  }
  return S.cancel = O, S.flush = P, S;
}
var Cue = Aue, xue = process.env.NODE_ENV !== "production", qu = function(n, r) {
  for (var o = arguments.length, s = new Array(o > 2 ? o - 2 : 0), u = 2; u < o; u++)
    s[u - 2] = arguments[u];
  if (xue && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !n))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var h = 0;
      console.warn(r.replace(/%s/g, function() {
        return s[h++];
      }));
    }
}, Bg = function(n) {
  return null;
};
Bg.displayName = "Cell";
var uw = { exports: {} }, Bv = "(".charCodeAt(0), Fv = ")".charCodeAt(0), Zh = "'".charCodeAt(0), zv = '"'.charCodeAt(0), Vv = "\\".charCodeAt(0), Xh = "/".charCodeAt(0), Hv = ",".charCodeAt(0), Uv = ":".charCodeAt(0), ZS = "*".charCodeAt(0), Eue = function(e) {
  for (var n = [], r = e, o, s, u, h, f, p, v, b = 0, y = r.charCodeAt(b), k = r.length, _ = [{ nodes: n }], E = 0, x, D = "", I = "", N = ""; b < k; )
    if (y <= 32) {
      o = b;
      do
        o += 1, y = r.charCodeAt(o);
      while (y <= 32);
      h = r.slice(b, o), u = n[n.length - 1], y === Fv && E ? N = h : u && u.type === "div" ? u.after = h : y === Hv || y === Uv || y === Xh && r.charCodeAt(o + 1) !== ZS ? I = h : n.push({
        type: "space",
        sourceIndex: b,
        value: h
      }), b = o;
    } else if (y === Zh || y === zv) {
      o = b, s = y === Zh ? "'" : '"', h = {
        type: "string",
        sourceIndex: b,
        quote: s
      };
      do
        if (f = !1, o = r.indexOf(s, o + 1), ~o)
          for (p = o; r.charCodeAt(p - 1) === Vv; )
            p -= 1, f = !f;
        else
          r += s, o = r.length - 1, h.unclosed = !0;
      while (f);
      h.value = r.slice(b + 1, o), n.push(h), b = o + 1, y = r.charCodeAt(b);
    } else if (y === Xh && r.charCodeAt(b + 1) === ZS)
      h = {
        type: "comment",
        sourceIndex: b
      }, o = r.indexOf("*/", b), o === -1 && (h.unclosed = !0, o = r.length), h.value = r.slice(b + 2, o), n.push(h), b = o + 2, y = r.charCodeAt(b);
    else if (y === Xh || y === Hv || y === Uv)
      h = r[b], n.push({
        type: "div",
        sourceIndex: b - I.length,
        value: h,
        before: I,
        after: ""
      }), I = "", b += 1, y = r.charCodeAt(b);
    else if (Bv === y) {
      o = b;
      do
        o += 1, y = r.charCodeAt(o);
      while (y <= 32);
      if (h = {
        type: "function",
        sourceIndex: b - D.length,
        value: D,
        before: r.slice(b + 1, o)
      }, b = o, D === "url" && y !== Zh && y !== zv) {
        o -= 1;
        do
          if (f = !1, o = r.indexOf(")", o + 1), ~o)
            for (p = o; r.charCodeAt(p - 1) === Vv; )
              p -= 1, f = !f;
          else
            r += ")", o = r.length - 1, h.unclosed = !0;
        while (f);
        v = o;
        do
          v -= 1, y = r.charCodeAt(v);
        while (y <= 32);
        b !== v + 1 ? h.nodes = [
          {
            type: "word",
            sourceIndex: b,
            value: r.slice(b, v + 1)
          }
        ] : h.nodes = [], h.unclosed && v + 1 !== o ? (h.after = "", h.nodes.push({
          type: "space",
          sourceIndex: v + 1,
          value: r.slice(v + 1, o)
        })) : h.after = r.slice(v + 1, o), b = o + 1, y = r.charCodeAt(b), n.push(h);
      } else
        E += 1, h.after = "", n.push(h), _.push(h), n = h.nodes = [], x = h;
      D = "";
    } else if (Fv === y && E)
      b += 1, y = r.charCodeAt(b), x.after = N, N = "", E -= 1, _.pop(), x = _[E], n = x.nodes;
    else {
      o = b;
      do
        y === Vv && (o += 1), o += 1, y = r.charCodeAt(o);
      while (o < k && !(y <= 32 || y === Zh || y === zv || y === Hv || y === Uv || y === Xh || y === Bv || y === Fv && E));
      h = r.slice(b, o), Bv === y ? D = h : n.push({
        type: "word",
        sourceIndex: b,
        value: h
      }), b = o;
    }
  for (b = _.length - 1; b; b -= 1)
    _[b].unclosed = !0;
  return _[0].nodes;
}, Sue = function e(n, r, o) {
  var s, u, h, f;
  for (s = 0, u = n.length; s < u; s += 1)
    h = n[s], o || (f = r(h, s, n)), f !== !1 && h.type === "function" && Array.isArray(h.nodes) && e(h.nodes, r, o), o && r(h, s, n);
};
function XS(e, n) {
  var r = e.type, o = e.value, s, u;
  return n && (u = n(e)) !== void 0 ? u : r === "word" || r === "space" ? o : r === "string" ? (s = e.quote || "", s + o + (e.unclosed ? "" : s)) : r === "comment" ? "/*" + o + (e.unclosed ? "" : "*/") : r === "div" ? (e.before || "") + o + (e.after || "") : Array.isArray(e.nodes) ? (s = j3(e.nodes), r !== "function" ? s : o + "(" + (e.before || "") + s + (e.after || "") + (e.unclosed ? "" : ")")) : o;
}
function j3(e, n) {
  var r, o;
  if (Array.isArray(e)) {
    for (r = "", o = e.length - 1; ~o; o -= 1)
      r = XS(e[o], n) + r;
    return r;
  }
  return XS(e, n);
}
var Mue = j3, Wv, JS;
function Tue() {
  if (JS)
    return Wv;
  JS = 1;
  var e = "-".charCodeAt(0), n = "+".charCodeAt(0), r = ".".charCodeAt(0), o = "e".charCodeAt(0), s = "E".charCodeAt(0);
  return Wv = function(u) {
    for (var h = 0, f = u.length, p = !1, v = -1, b = !1, y; h < f; ) {
      if (y = u.charCodeAt(h), y >= 48 && y <= 57)
        b = !0;
      else if (y === o || y === s) {
        if (v > -1)
          break;
        v = h;
      } else if (y === r) {
        if (p)
          break;
        p = !0;
      } else if (y === n || y === e) {
        if (h !== 0)
          break;
      } else
        break;
      h += 1;
    }
    return v + 1 === h && h--, b ? {
      number: u.slice(0, h),
      unit: u.slice(h)
    } : !1;
  }, Wv;
}
var Due = Eue, B3 = Sue, F3 = Mue;
function Pa(e) {
  return this instanceof Pa ? (this.nodes = Due(e), this) : new Pa(e);
}
Pa.prototype.toString = function() {
  return Array.isArray(this.nodes) ? F3(this.nodes) : "";
};
Pa.prototype.walk = function(e, n) {
  return B3(this.nodes, e, n), this;
};
Pa.unit = Tue();
Pa.walk = B3;
Pa.stringify = F3;
var Iue = Pa;
function Pue(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var z3 = {};
(function(e) {
  var n = function() {
    function r(k, _) {
      Object.defineProperty(this, "name", {
        enumerable: !1,
        writable: !1,
        value: "JisonParserError"
      }), k == null && (k = "???"), Object.defineProperty(this, "message", {
        enumerable: !1,
        writable: !0,
        value: k
      }), this.hash = _;
      var E;
      if (_ && _.exception instanceof Error) {
        var x = _.exception;
        this.message = x.message || k, E = x.stack;
      }
      E || (Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, this.constructor) : E = new Error(k).stack), E && Object.defineProperty(this, "stack", {
        enumerable: !1,
        writable: !1,
        value: E
      });
    }
    typeof Object.setPrototypeOf == "function" ? Object.setPrototypeOf(r.prototype, Error.prototype) : r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r.prototype.name = "JisonParserError";
    function o(k) {
      for (var _ = [], E = k.pop, x = k.rule, D = 0, I = E.length; D < I; D++)
        _.push([
          E[D],
          x[D]
        ]);
      return _;
    }
    function s(k) {
      for (var _ = {}, E = k.idx, x = k.goto, D = 0, I = E.length; D < I; D++) {
        var N = E[D];
        _[N] = x[D];
      }
      return _;
    }
    function u(k) {
      for (var _ = [], E = k.len, x = k.symbol, D = k.type, I = k.state, N = k.mode, O = k.goto, P = 0, S = E.length; P < S; P++) {
        for (var $ = E[P], L = {}, B = 0; B < $; B++) {
          var U = x.shift();
          switch (D.shift()) {
            case 2:
              L[U] = [
                N.shift(),
                O.shift()
              ];
              break;
            case 0:
              L[U] = I.shift();
              break;
            default:
              L[U] = [
                3
              ];
          }
        }
        _.push(L);
      }
      return _;
    }
    function h(k, _, E) {
      E = E || 0;
      for (var x = 0; x < _; x++)
        this.push(k), k += E;
    }
    function f(k, _) {
      for (k = this.length - k, _ += k; k < _; k++)
        this.push(this[k]);
    }
    function p(k) {
      for (var _ = [], E = 0, x = k.length; E < x; E++) {
        var D = k[E];
        typeof D == "function" ? (E++, D.apply(_, k[E])) : _.push(D);
      }
      return _;
    }
    var v = {
      trace: function() {
      },
      JisonParserError: r,
      yy: {},
      options: {
        type: "lalr",
        hasPartialLrUpgradeOnConflict: !0,
        errorRecoveryTokenDiscardCount: 3
      },
      symbols_: {
        $accept: 0,
        $end: 1,
        ADD: 3,
        ANGLE: 16,
        CHS: 22,
        COMMA: 14,
        CSS_CPROP: 13,
        CSS_VAR: 12,
        DIV: 6,
        EMS: 20,
        EOF: 1,
        EXS: 21,
        FREQ: 18,
        LENGTH: 15,
        LPAREN: 7,
        MUL: 5,
        NESTED_CALC: 9,
        NUMBER: 11,
        PERCENTAGE: 28,
        PREFIX: 10,
        REMS: 23,
        RES: 19,
        RPAREN: 8,
        SUB: 4,
        TIME: 17,
        VHS: 24,
        VMAXS: 27,
        VMINS: 26,
        VWS: 25,
        css_value: 33,
        css_variable: 32,
        error: 2,
        expression: 29,
        math_expression: 30,
        value: 31
      },
      terminals_: {
        1: "EOF",
        2: "error",
        3: "ADD",
        4: "SUB",
        5: "MUL",
        6: "DIV",
        7: "LPAREN",
        8: "RPAREN",
        9: "NESTED_CALC",
        10: "PREFIX",
        11: "NUMBER",
        12: "CSS_VAR",
        13: "CSS_CPROP",
        14: "COMMA",
        15: "LENGTH",
        16: "ANGLE",
        17: "TIME",
        18: "FREQ",
        19: "RES",
        20: "EMS",
        21: "EXS",
        22: "CHS",
        23: "REMS",
        24: "VHS",
        25: "VWS",
        26: "VMINS",
        27: "VMAXS",
        28: "PERCENTAGE"
      },
      TERROR: 2,
      EOF: 1,
      originalQuoteName: null,
      originalParseError: null,
      cleanupAfterParse: null,
      constructParseErrorInfo: null,
      yyMergeLocationInfo: null,
      __reentrant_call_depth: 0,
      __error_infos: [],
      __error_recovery_infos: [],
      quoteName: function(_) {
        return '"' + _ + '"';
      },
      getSymbolName: function(_) {
        if (this.terminals_[_])
          return this.terminals_[_];
        var E = this.symbols_;
        for (var x in E)
          if (E[x] === _)
            return x;
        return null;
      },
      describeSymbol: function(_) {
        if (_ !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[_])
          return this.terminal_descriptions_[_];
        if (_ === this.EOF)
          return "end of input";
        var E = this.getSymbolName(_);
        return E ? this.quoteName(E) : null;
      },
      collect_expected_token_set: function(_, E) {
        var x = this.TERROR, D = [], I = {};
        if (!E && this.state_descriptions_ && this.state_descriptions_[_])
          return [
            this.state_descriptions_[_]
          ];
        for (var N in this.table[_])
          if (N = +N, N !== x) {
            var O = E ? N : this.describeSymbol(N);
            O && !I[O] && (D.push(O), I[O] = !0);
          }
        return D;
      },
      productions_: o({
        pop: p([
          29,
          h,
          [30, 10],
          31,
          31,
          32,
          32,
          h,
          [33, 15]
        ]),
        rule: p([
          2,
          h,
          [3, 5],
          4,
          7,
          h,
          [1, 4],
          2,
          4,
          6,
          h,
          [1, 14],
          2
        ])
      }),
      performAction: function(_, E, x) {
        var D = this.yy;
        switch (D.parser, D.lexer, _) {
          case 0:
            this.$ = x[E - 1];
            break;
          case 1:
            return this.$ = x[E - 1], x[E - 1];
          case 2:
          case 3:
          case 4:
          case 5:
            this.$ = { type: "MathExpression", operator: x[E - 1], left: x[E - 2], right: x[E] };
            break;
          case 6:
            this.$ = x[E - 1];
            break;
          case 7:
            this.$ = { type: "Calc", value: x[E - 1] };
            break;
          case 8:
            this.$ = { type: "Calc", value: x[E - 1], prefix: x[E - 5] };
            break;
          case 9:
          case 10:
          case 11:
            this.$ = x[E];
            break;
          case 12:
            this.$ = { type: "Value", value: parseFloat(x[E]) };
            break;
          case 13:
            this.$ = { type: "Value", value: parseFloat(x[E]) * -1 };
            break;
          case 14:
            this.$ = { type: "CssVariable", value: x[E - 1] };
            break;
          case 15:
            this.$ = { type: "CssVariable", value: x[E - 3], fallback: x[E - 1] };
            break;
          case 16:
            this.$ = { type: "LengthValue", value: parseFloat(x[E]), unit: /[a-z]+/.exec(x[E])[0] };
            break;
          case 17:
            this.$ = { type: "AngleValue", value: parseFloat(x[E]), unit: /[a-z]+/.exec(x[E])[0] };
            break;
          case 18:
            this.$ = { type: "TimeValue", value: parseFloat(x[E]), unit: /[a-z]+/.exec(x[E])[0] };
            break;
          case 19:
            this.$ = { type: "FrequencyValue", value: parseFloat(x[E]), unit: /[a-z]+/.exec(x[E])[0] };
            break;
          case 20:
            this.$ = { type: "ResolutionValue", value: parseFloat(x[E]), unit: /[a-z]+/.exec(x[E])[0] };
            break;
          case 21:
            this.$ = { type: "EmValue", value: parseFloat(x[E]), unit: "em" };
            break;
          case 22:
            this.$ = { type: "ExValue", value: parseFloat(x[E]), unit: "ex" };
            break;
          case 23:
            this.$ = { type: "ChValue", value: parseFloat(x[E]), unit: "ch" };
            break;
          case 24:
            this.$ = { type: "RemValue", value: parseFloat(x[E]), unit: "rem" };
            break;
          case 25:
            this.$ = { type: "VhValue", value: parseFloat(x[E]), unit: "vh" };
            break;
          case 26:
            this.$ = { type: "VwValue", value: parseFloat(x[E]), unit: "vw" };
            break;
          case 27:
            this.$ = { type: "VminValue", value: parseFloat(x[E]), unit: "vmin" };
            break;
          case 28:
            this.$ = { type: "VmaxValue", value: parseFloat(x[E]), unit: "vmax" };
            break;
          case 29:
            this.$ = { type: "PercentageValue", value: parseFloat(x[E]), unit: "%" };
            break;
          case 30:
            var I = x[E];
            I.value *= -1, this.$ = I;
            break;
        }
      },
      table: u({
        len: p([
          24,
          1,
          5,
          23,
          1,
          18,
          h,
          [0, 3],
          1,
          h,
          [0, 16],
          h,
          [23, 4],
          f,
          [28, 3],
          0,
          0,
          16,
          1,
          6,
          6,
          h,
          [0, 3],
          5,
          1,
          2,
          f,
          [37, 3],
          f,
          [20, 3],
          5,
          0,
          0
        ]),
        symbol: p([
          4,
          7,
          9,
          11,
          12,
          h,
          [15, 19, 1],
          1,
          1,
          h,
          [3, 4, 1],
          f,
          [30, 19],
          f,
          [29, 4],
          7,
          4,
          10,
          11,
          f,
          [22, 14],
          f,
          [19, 3],
          f,
          [43, 22],
          f,
          [23, 69],
          f,
          [139, 4],
          8,
          f,
          [51, 24],
          4,
          f,
          [138, 15],
          13,
          f,
          [186, 5],
          8,
          f,
          [6, 6],
          f,
          [5, 5],
          9,
          8,
          14,
          f,
          [159, 47],
          f,
          [60, 10]
        ]),
        type: p([
          h,
          [2, 19],
          h,
          [0, 5],
          1,
          h,
          [2, 24],
          h,
          [0, 4],
          f,
          [22, 19],
          f,
          [43, 42],
          f,
          [23, 70],
          f,
          [28, 25],
          f,
          [45, 25],
          f,
          [113, 54]
        ]),
        state: p([
          1,
          2,
          8,
          6,
          7,
          30,
          f,
          [4, 3],
          33,
          37,
          f,
          [5, 3],
          38,
          f,
          [4, 3],
          39,
          f,
          [4, 3],
          40,
          f,
          [4, 3],
          42,
          f,
          [21, 4],
          50,
          f,
          [5, 3],
          51,
          f,
          [4, 3]
        ]),
        mode: p([
          h,
          [1, 179],
          h,
          [2, 3],
          f,
          [5, 5],
          f,
          [6, 4],
          h,
          [1, 57]
        ]),
        goto: p([
          5,
          3,
          4,
          24,
          h,
          [9, 15, 1],
          h,
          [25, 5, 1],
          f,
          [24, 19],
          31,
          35,
          32,
          34,
          f,
          [18, 14],
          36,
          f,
          [38, 19],
          f,
          [19, 57],
          f,
          [118, 4],
          41,
          f,
          [24, 19],
          43,
          35,
          f,
          [16, 14],
          44,
          h,
          [2, 3],
          28,
          29,
          2,
          h,
          [3, 3],
          28,
          29,
          3,
          f,
          [53, 4],
          h,
          [45, 5, 1],
          f,
          [100, 42],
          52,
          f,
          [5, 4],
          53
        ])
      }),
      defaultActions: s({
        idx: p([
          6,
          7,
          8,
          h,
          [10, 16, 1],
          33,
          34,
          39,
          40,
          41,
          45,
          47,
          52,
          53
        ]),
        goto: p([
          9,
          10,
          11,
          h,
          [16, 14, 1],
          12,
          1,
          30,
          13,
          h,
          [4, 4, 1],
          14,
          15,
          8
        ])
      }),
      parseError: function(_, E, x) {
        if (E.recoverable)
          typeof this.trace == "function" && this.trace(_), E.destroy();
        else
          throw typeof this.trace == "function" && this.trace(_), x || (x = this.JisonParserError), new x(_, E);
      },
      parse: function(_) {
        var E = this, x = new Array(128), D = new Array(128), I = new Array(128), N = this.table, O = 0, P = 0;
        this.TERROR;
        var S = this.EOF;
        this.options.errorRecoveryTokenDiscardCount | 0;
        var $ = [0, 54], L;
        this.__lexer__ ? L = this.__lexer__ : L = this.__lexer__ = Object.create(this.lexer);
        var B = {
          parseError: void 0,
          quoteName: void 0,
          lexer: void 0,
          parser: void 0,
          pre_parse: void 0,
          post_parse: void 0,
          pre_lex: void 0,
          post_lex: void 0
        };
        typeof assert != "function" || assert, this.yyGetSharedState = function() {
          return B;
        };
        function U(ke, ge) {
          for (var xe in ge)
            typeof ke[xe] > "u" && Object.prototype.hasOwnProperty.call(ge, xe) && (ke[xe] = ge[xe]);
        }
        U(B, this.yy), B.lexer = L, B.parser = this, typeof B.parseError == "function" ? this.parseError = function(ge, xe, Te) {
          return Te || (Te = this.JisonParserError), B.parseError.call(this, ge, xe, Te);
        } : this.parseError = this.originalParseError, typeof B.quoteName == "function" ? this.quoteName = function(ge) {
          return B.quoteName.call(this, ge);
        } : this.quoteName = this.originalQuoteName, this.cleanupAfterParse = function(ge, xe, Te) {
          var J;
          if (xe) {
            var Ge;
            (B.post_parse || this.post_parse) && (Ge = this.constructParseErrorInfo(null, null, null, !1)), B.post_parse && (J = B.post_parse.call(this, B, ge, Ge), typeof J < "u" && (ge = J)), this.post_parse && (J = this.post_parse.call(this, B, ge, Ge), typeof J < "u" && (ge = J)), Ge && Ge.destroy && Ge.destroy();
          }
          if (this.__reentrant_call_depth > 1)
            return ge;
          if (L.cleanupAfterLex && L.cleanupAfterLex(Te), B && (B.lexer = void 0, B.parser = void 0, L.yy === B && (L.yy = void 0)), B = void 0, this.parseError = this.originalParseError, this.quoteName = this.originalQuoteName, x.length = 0, D.length = 0, I.length = 0, O = 0, !Te) {
            for (var De = this.__error_infos.length - 1; De >= 0; De--) {
              var He = this.__error_infos[De];
              He && typeof He.destroy == "function" && He.destroy();
            }
            this.__error_infos.length = 0;
          }
          return ge;
        }, this.constructParseErrorInfo = function(ge, xe, Te, J) {
          var Ge = {
            errStr: ge,
            exception: xe,
            text: L.match,
            value: L.yytext,
            token: this.describeSymbol(P) || P,
            token_id: P,
            line: L.yylineno,
            expected: Te,
            recoverable: J,
            state: Q,
            action: Z,
            new_state: se,
            symbol_stack: x,
            state_stack: D,
            value_stack: I,
            stack_pointer: O,
            yy: B,
            lexer: L,
            parser: this,
            destroy: function() {
              var He = !!this.recoverable;
              for (var at in this)
                this.hasOwnProperty(at) && typeof at == "object" && (this[at] = void 0);
              this.recoverable = He;
            }
          };
          return this.__error_infos.push(Ge), Ge;
        };
        function G() {
          var ke = L.lex();
          return typeof ke != "number" && (ke = E.symbols_[ke] || ke), ke || S;
        }
        function q() {
          var ke = L.fastLex();
          return typeof ke != "number" && (ke = E.symbols_[ke] || ke), ke || S;
        }
        var Y = G, Q, Z, ae, ie, pe = {
          $: !0,
          _$: void 0,
          yy: B
        }, ce, ue, X, se, he = !1;
        try {
          if (this.__reentrant_call_depth++, L.setInput(_, B), typeof L.canIUse == "function") {
            var de = L.canIUse();
            de.fastLex && typeof q == "function" && (Y = q);
          }
          for (I[O] = null, D[O] = 0, x[O] = 0, ++O, this.pre_parse && this.pre_parse.call(this, B), B.pre_parse && B.pre_parse.call(this, B), se = D[O - 1]; ; ) {
            if (Q = se, this.defaultActions[Q])
              Z = 2, se = this.defaultActions[Q];
            else if (P || (P = Y()), ie = N[Q] && N[Q][P] || $, se = ie[1], Z = ie[0], !Z) {
              var me, we = this.describeSymbol(P) || P, Ae = this.collect_expected_token_set(Q);
              typeof L.yylineno == "number" ? me = "Parse error on line " + (L.yylineno + 1) + ": " : me = "Parse error: ", typeof L.showPosition == "function" && (me += `
` + L.showPosition(79 - 10, 10) + `
`), Ae.length ? me += "Expecting " + Ae.join(", ") + ", got unexpected " + we : me += "Unexpected " + we, ce = this.constructParseErrorInfo(me, null, Ae, !1), ae = this.parseError(ce.errStr, ce, this.JisonParserError), typeof ae < "u" && (he = ae);
              break;
            }
            switch (Z) {
              default:
                if (Z instanceof Array) {
                  ce = this.constructParseErrorInfo("Parse Error: multiple actions possible at state: " + Q + ", token: " + P, null, null, !1), ae = this.parseError(ce.errStr, ce, this.JisonParserError), typeof ae < "u" && (he = ae);
                  break;
                }
                ce = this.constructParseErrorInfo("Parsing halted. No viable error recovery approach available due to internal system failure.", null, null, !1), ae = this.parseError(ce.errStr, ce, this.JisonParserError), typeof ae < "u" && (he = ae);
                break;
              case 1:
                x[O] = P, I[O] = L.yytext, D[O] = se, ++O, P = 0;
                continue;
              case 2:
                if (X = this.productions_[se - 1], ue = X[1], ae = this.performAction.call(pe, se, O - 1, I), typeof ae < "u") {
                  he = ae;
                  break;
                }
                O -= ue;
                var Se = X[0];
                x[O] = Se, I[O] = pe.$, se = N[D[O - 1]][Se], D[O] = se, ++O;
                continue;
              case 3:
                O !== -2 && (he = !0, O--, typeof I[O] < "u" && (he = I[O]));
                break;
            }
            break;
          }
        } catch (ke) {
          if (ke instanceof this.JisonParserError)
            throw ke;
          if (L && typeof L.JisonLexerError == "function" && ke instanceof L.JisonLexerError)
            throw ke;
          ce = this.constructParseErrorInfo("Parsing aborted due to exception.", ke, null, !1), he = !1, ae = this.parseError(ce.errStr, ce, this.JisonParserError), typeof ae < "u" && (he = ae);
        } finally {
          he = this.cleanupAfterParse(he, !0, !0), this.__reentrant_call_depth--;
        }
        return he;
      }
    };
    v.originalParseError = v.parseError, v.originalQuoteName = v.quoteName;
    var b = function() {
      function k(E, x) {
        Object.defineProperty(this, "name", {
          enumerable: !1,
          writable: !1,
          value: "JisonLexerError"
        }), E == null && (E = "???"), Object.defineProperty(this, "message", {
          enumerable: !1,
          writable: !0,
          value: E
        }), this.hash = x;
        var D;
        if (x && x.exception instanceof Error) {
          var I = x.exception;
          this.message = I.message || E, D = I.stack;
        }
        D || (Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, this.constructor) : D = new Error(E).stack), D && Object.defineProperty(this, "stack", {
          enumerable: !1,
          writable: !1,
          value: D
        });
      }
      typeof Object.setPrototypeOf == "function" ? Object.setPrototypeOf(k.prototype, Error.prototype) : k.prototype = Object.create(Error.prototype), k.prototype.constructor = k, k.prototype.name = "JisonLexerError";
      var _ = {
        EOF: 1,
        ERROR: 2,
        __currentRuleSet__: null,
        __error_infos: [],
        __decompressed: !1,
        done: !1,
        _backtrack: !1,
        _input: "",
        _more: !1,
        _signaled_error_token: !1,
        conditionStack: [],
        match: "",
        matched: "",
        matches: !1,
        yytext: "",
        offset: 0,
        yyleng: 0,
        yylineno: 0,
        yylloc: null,
        constructLexErrorInfo: function(x, D, I) {
          if (x = "" + x, I == null && (I = !(x.indexOf(`
`) > 0 && x.indexOf("^") > 0)), this.yylloc && I) {
            if (typeof this.prettyPrintRange == "function")
              this.prettyPrintRange(this.yylloc), /\n\s*$/.test(x) || (x += `
`), x += `
  Erroneous area:
` + this.prettyPrintRange(this.yylloc);
            else if (typeof this.showPosition == "function") {
              var N = this.showPosition();
              N && (x.length && x[x.length - 1] !== `
` && N[0] !== `
` ? x += `
` + N : x += N);
            }
          }
          var O = {
            errStr: x,
            recoverable: !!D,
            text: this.match,
            token: null,
            line: this.yylineno,
            loc: this.yylloc,
            yy: this.yy,
            lexer: this,
            destroy: function() {
              var S = !!this.recoverable;
              for (var $ in this)
                this.hasOwnProperty($) && typeof $ == "object" && (this[$] = void 0);
              this.recoverable = S;
            }
          };
          return this.__error_infos.push(O), O;
        },
        parseError: function(x, D, I) {
          if (I || (I = this.JisonLexerError), this.yy) {
            if (this.yy.parser && typeof this.yy.parser.parseError == "function")
              return this.yy.parser.parseError.call(this, x, D, I) || this.ERROR;
            if (typeof this.yy.parseError == "function")
              return this.yy.parseError.call(this, x, D, I) || this.ERROR;
          }
          throw new I(x, D);
        },
        yyerror: function(x) {
          var D = "";
          this.yylloc && (D = " on line " + (this.yylineno + 1));
          var I = this.constructLexErrorInfo(
            "Lexical error" + D + ": " + x,
            this.options.lexerErrorsAreRecoverable
          ), N = Array.prototype.slice.call(arguments, 1);
          return N.length && (I.extra_error_attributes = N), this.parseError(I.errStr, I, this.JisonLexerError) || this.ERROR;
        },
        cleanupAfterLex: function(x) {
          if (this.setInput("", {}), !x) {
            for (var D = this.__error_infos.length - 1; D >= 0; D--) {
              var I = this.__error_infos[D];
              I && typeof I.destroy == "function" && I.destroy();
            }
            this.__error_infos.length = 0;
          }
          return this;
        },
        clear: function() {
          this.yytext = "", this.yyleng = 0, this.match = "", this.matches = !1, this._more = !1, this._backtrack = !1;
          var x = this.yylloc ? this.yylloc.last_column : 0;
          this.yylloc = {
            first_line: this.yylineno + 1,
            first_column: x,
            last_line: this.yylineno + 1,
            last_column: x,
            range: [this.offset, this.offset]
          };
        },
        setInput: function(x, D) {
          if (this.yy = D || this.yy || {}, !this.__decompressed) {
            for (var I = this.rules, N = 0, O = I.length; N < O; N++) {
              var P = I[N];
              typeof P == "number" && (I[N] = I[P]);
            }
            var S = this.conditions;
            for (var $ in S) {
              for (var L = S[$], B = L.rules, O = B.length, U = new Array(O + 1), G = new Array(O + 1), N = 0; N < O; N++) {
                var q = B[N], P = I[q];
                U[N + 1] = P, G[N + 1] = q;
              }
              L.rules = G, L.__rule_regexes = U, L.__rule_count = O;
            }
            this.__decompressed = !0;
          }
          return this._input = x || "", this.clear(), this._signaled_error_token = !1, this.done = !1, this.yylineno = 0, this.matched = "", this.conditionStack = ["INITIAL"], this.__currentRuleSet__ = null, this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0,
            range: [0, 0]
          }, this.offset = 0, this;
        },
        editRemainingInput: function(x, D) {
          var I = x.call(this, this._input, D);
          return typeof I != "string" ? I && (this._input = "" + I) : this._input = I, this;
        },
        input: function() {
          if (!this._input)
            return null;
          var x = this._input[0];
          this.yytext += x, this.yyleng++, this.offset++, this.match += x, this.matched += x;
          var D = 1, I = !1;
          if (x === `
`)
            I = !0;
          else if (x === "\r") {
            I = !0;
            var N = this._input[1];
            N === `
` && (D++, x += N, this.yytext += N, this.yyleng++, this.offset++, this.match += N, this.matched += N, this.yylloc.range[1]++);
          }
          return I ? (this.yylineno++, this.yylloc.last_line++, this.yylloc.last_column = 0) : this.yylloc.last_column++, this.yylloc.range[1]++, this._input = this._input.slice(D), x;
        },
        unput: function(x) {
          var D = x.length, I = x.split(/(?:\r\n?|\n)/g);
          if (this._input = x + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - D), this.yyleng = this.yytext.length, this.offset -= D, this.match = this.match.substr(0, this.match.length - D), this.matched = this.matched.substr(0, this.matched.length - D), I.length > 1) {
            this.yylineno -= I.length - 1, this.yylloc.last_line = this.yylineno + 1;
            var N = this.match, O = N.split(/(?:\r\n?|\n)/g);
            O.length === 1 && (N = this.matched, O = N.split(/(?:\r\n?|\n)/g)), this.yylloc.last_column = O[O.length - 1].length;
          } else
            this.yylloc.last_column -= D;
          return this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng, this.done = !1, this;
        },
        more: function() {
          return this._more = !0, this;
        },
        reject: function() {
          if (this.options.backtrack_lexer)
            this._backtrack = !0;
          else {
            var x = "";
            this.yylloc && (x = " on line " + (this.yylineno + 1));
            var D = this.constructLexErrorInfo(
              "Lexical error" + x + ": You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).",
              !1
            );
            this._signaled_error_token = this.parseError(D.errStr, D, this.JisonLexerError) || this.ERROR;
          }
          return this;
        },
        less: function(x) {
          return this.unput(this.match.slice(x));
        },
        pastInput: function(x, D) {
          var I = this.matched.substring(0, this.matched.length - this.match.length);
          x < 0 ? x = I.length : x || (x = 20), D < 0 ? D = I.length : D || (D = 1), I = I.substr(-x * 2 - 2);
          var N = I.replace(/\r\n|\r/g, `
`).split(`
`);
          return N = N.slice(-D), I = N.join(`
`), I.length > x && (I = "..." + I.substr(-x)), I;
        },
        upcomingInput: function(x, D) {
          var I = this.match;
          x < 0 ? x = I.length + this._input.length : x || (x = 20), D < 0 ? D = x : D || (D = 1), I.length < x * 2 + 2 && (I += this._input.substring(0, x * 2 + 2));
          var N = I.replace(/\r\n|\r/g, `
`).split(`
`);
          return N = N.slice(0, D), I = N.join(`
`), I.length > x && (I = I.substring(0, x) + "..."), I;
        },
        showPosition: function(x, D) {
          var I = this.pastInput(x).replace(/\s/g, " "), N = new Array(I.length + 1).join("-");
          return I + this.upcomingInput(D).replace(/\s/g, " ") + `
` + N + "^";
        },
        deriveLocationInfo: function(x, D, I, N) {
          var O = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0,
            range: [0, 0]
          };
          return x && (O.first_line = x.first_line | 0, O.last_line = x.last_line | 0, O.first_column = x.first_column | 0, O.last_column = x.last_column | 0, x.range && (O.range[0] = x.range[0] | 0, O.range[1] = x.range[1] | 0)), (O.first_line <= 0 || O.last_line < O.first_line) && (O.first_line <= 0 && D && (O.first_line = D.last_line | 0, O.first_column = D.last_column | 0, D.range && (O.range[0] = x.range[1] | 0)), (O.last_line <= 0 || O.last_line < O.first_line) && I && (O.last_line = I.first_line | 0, O.last_column = I.first_column | 0, I.range && (O.range[1] = x.range[0] | 0)), O.first_line <= 0 && N && (O.last_line <= 0 || N.last_line <= O.last_line) && (O.first_line = N.first_line | 0, O.first_column = N.first_column | 0, N.range && (O.range[0] = N.range[0] | 0)), O.last_line <= 0 && N && (O.first_line <= 0 || N.first_line >= O.first_line) && (O.last_line = N.last_line | 0, O.last_column = N.last_column | 0, N.range && (O.range[1] = N.range[1] | 0))), O.last_line <= 0 && (O.first_line <= 0 ? (O.first_line = this.yylloc.first_line, O.last_line = this.yylloc.last_line, O.first_column = this.yylloc.first_column, O.last_column = this.yylloc.last_column, O.range[0] = this.yylloc.range[0], O.range[1] = this.yylloc.range[1]) : (O.last_line = this.yylloc.last_line, O.last_column = this.yylloc.last_column, O.range[1] = this.yylloc.range[1])), O.first_line <= 0 && (O.first_line = O.last_line, O.first_column = 0, O.range[1] = O.range[0]), O.first_column < 0 && (O.first_column = 0), O.last_column < 0 && (O.last_column = O.first_column > 0 ? O.first_column : 80), O;
        },
        prettyPrintRange: function(x, D, I) {
          x = this.deriveLocationInfo(x, D, I);
          const N = 3, O = 1, P = 2;
          var S = this.matched + this._input, $ = S.split(`
`), L = Math.max(1, D ? D.first_line : x.first_line - N), B = Math.max(1, I ? I.last_line : x.last_line + O), U = 1 + Math.log10(B | 1) | 0, G = new Array(U).join(" "), q = [], Y = $.slice(L - 1, B + 1).map(function(pe, ce) {
            var ue = ce + L, X = (G + ue).substr(-U), se = X + ": " + pe, he = new Array(U + 1).join("^"), de = 2 + 1, me = 0;
            if (ue === x.first_line ? (de += x.first_column, me = Math.max(
              2,
              (ue === x.last_line ? x.last_column : pe.length) - x.first_column + 1
            )) : ue === x.last_line ? me = Math.max(2, x.last_column + 1) : ue > x.first_line && ue < x.last_line && (me = Math.max(2, pe.length + 1)), me) {
              var we = new Array(de).join("."), Ae = new Array(me).join("^");
              se += `
` + he + we + Ae, pe.trim().length > 0 && q.push(ce);
            }
            return se = se.replace(/\t/g, " "), se;
          });
          if (q.length > 2 * P) {
            var Q = q[P - 1] + 1, Z = q[q.length - P] - 1, ae = new Array(U + 1).join(" ") + "  (...continued...)";
            ae += `
` + new Array(U + 1).join("-") + "  (---------------)", Y.splice(Q, Z - Q + 1, ae);
          }
          return Y.join(`
`);
        },
        describeYYLLOC: function(x, D) {
          var I = x.first_line, N = x.last_line, O = x.first_column, P = x.last_column, S = N - I, $ = P - O, L;
          if (S === 0 ? (L = "line " + I + ", ", $ <= 1 ? L += "column " + O : L += "columns " + O + " .. " + P) : L = "lines " + I + "(column " + O + ") .. " + N + "(column " + P + ")", x.range && D) {
            var B = x.range[0], U = x.range[1] - 1;
            U <= B ? L += " {String Offset: " + B + "}" : L += " {String Offset range: " + B + " .. " + U + "}";
          }
          return L;
        },
        test_match: function(x, D) {
          var I, N, O, P, S;
          if (this.options.backtrack_lexer && (O = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.yylloc.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column,
              range: this.yylloc.range.slice(0)
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          }), P = x[0], S = P.length, N = P.split(/(?:\r\n?|\n)/g), N.length > 1 ? (this.yylineno += N.length - 1, this.yylloc.last_line = this.yylineno + 1, this.yylloc.last_column = N[N.length - 1].length) : this.yylloc.last_column += S, this.yytext += P, this.match += P, this.matched += P, this.matches = x, this.yyleng = this.yytext.length, this.yylloc.range[1] += S, this.offset += S, this._more = !1, this._backtrack = !1, this._input = this._input.slice(S), I = this.performAction.call(
            this,
            this.yy,
            D,
            this.conditionStack[this.conditionStack.length - 1]
          ), this.done && this._input && (this.done = !1), I)
            return I;
          if (this._backtrack) {
            for (var $ in O)
              this[$] = O[$];
            return this.__currentRuleSet__ = null, !1;
          } else if (this._signaled_error_token)
            return I = this._signaled_error_token, this._signaled_error_token = !1, I;
          return !1;
        },
        next: function() {
          if (this.done)
            return this.clear(), this.EOF;
          this._input || (this.done = !0);
          var x, D, I, N;
          this._more || this.clear();
          var O = this.__currentRuleSet__;
          if (!O && (O = this.__currentRuleSet__ = this._currentRules(), !O || !O.rules)) {
            var P = "";
            this.options.trackPosition && (P = " on line " + (this.yylineno + 1));
            var S = this.constructLexErrorInfo(
              "Internal lexer engine error" + P + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!',
              !1
            );
            return this.parseError(S.errStr, S, this.JisonLexerError) || this.ERROR;
          }
          for (var $ = O.rules, L = O.__rule_regexes, B = O.__rule_count, U = 1; U <= B; U++)
            if (I = this._input.match(L[U]), I && (!D || I[0].length > D[0].length)) {
              if (D = I, N = U, this.options.backtrack_lexer) {
                if (x = this.test_match(I, $[U]), x !== !1)
                  return x;
                if (this._backtrack) {
                  D = void 0;
                  continue;
                } else
                  return !1;
              } else if (!this.options.flex)
                break;
            }
          if (D)
            return x = this.test_match(D, $[N]), x !== !1 ? x : !1;
          if (this._input) {
            var P = "";
            this.options.trackPosition && (P = " on line " + (this.yylineno + 1));
            var S = this.constructLexErrorInfo(
              "Lexical error" + P + ": Unrecognized text.",
              this.options.lexerErrorsAreRecoverable
            ), G = this._input, q = this.topState(), Y = this.conditionStack.length;
            return x = this.parseError(S.errStr, S, this.JisonLexerError) || this.ERROR, x === this.ERROR && !this.matches && G === this._input && q === this.topState() && Y === this.conditionStack.length && this.input(), x;
          } else
            return this.done = !0, this.clear(), this.EOF;
        },
        lex: function() {
          var x;
          for (typeof this.pre_lex == "function" && (x = this.pre_lex.call(this, 0)), typeof this.options.pre_lex == "function" && (x = this.options.pre_lex.call(this, x) || x), this.yy && typeof this.yy.pre_lex == "function" && (x = this.yy.pre_lex.call(this, x) || x); !x; )
            x = this.next();
          return this.yy && typeof this.yy.post_lex == "function" && (x = this.yy.post_lex.call(this, x) || x), typeof this.options.post_lex == "function" && (x = this.options.post_lex.call(this, x) || x), typeof this.post_lex == "function" && (x = this.post_lex.call(this, x) || x), x;
        },
        fastLex: function() {
          for (var x; !x; )
            x = this.next();
          return x;
        },
        canIUse: function() {
          var x = {
            fastLex: !(typeof this.pre_lex == "function" || typeof this.options.pre_lex == "function" || this.yy && typeof this.yy.pre_lex == "function" || this.yy && typeof this.yy.post_lex == "function" || typeof this.options.post_lex == "function" || typeof this.post_lex == "function") && typeof this.fastLex == "function"
          };
          return x;
        },
        begin: function(x) {
          return this.pushState(x);
        },
        pushState: function(x) {
          return this.conditionStack.push(x), this.__currentRuleSet__ = null, this;
        },
        popState: function() {
          var x = this.conditionStack.length - 1;
          return x > 0 ? (this.__currentRuleSet__ = null, this.conditionStack.pop()) : this.conditionStack[0];
        },
        topState: function(x) {
          return x = this.conditionStack.length - 1 - Math.abs(x || 0), x >= 0 ? this.conditionStack[x] : "INITIAL";
        },
        _currentRules: function() {
          return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]] : this.conditions.INITIAL;
        },
        stateStackSize: function() {
          return this.conditionStack.length;
        },
        options: {
          trackPosition: !0
        },
        JisonLexerError: k,
        performAction: function(x, D, I) {
          switch (D) {
            case 1:
              break;
            default:
              return this.simpleCaseActionClusters[D];
          }
        },
        simpleCaseActionClusters: {
          0: 13,
          2: 5,
          3: 6,
          4: 3,
          5: 4,
          6: 15,
          7: 15,
          8: 15,
          9: 15,
          10: 15,
          11: 15,
          12: 16,
          13: 16,
          14: 16,
          15: 16,
          16: 17,
          17: 17,
          18: 18,
          19: 18,
          20: 19,
          21: 19,
          22: 19,
          23: 20,
          24: 21,
          25: 22,
          26: 23,
          27: 25,
          28: 24,
          29: 26,
          30: 27,
          31: 28,
          32: 11,
          33: 9,
          34: 12,
          35: 10,
          36: 7,
          37: 8,
          38: 14,
          39: 1
        },
        rules: [
          /^(?:(--[\d\-A-Za-z]*))/,
          /^(?:\s+)/,
          /^(?:\*)/,
          /^(?:\/)/,
          /^(?:\+)/,
          /^(?:-)/,
          /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
          /^(?:(\d+(\.\d*)?|\.\d+)%)/,
          /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
          /^(?:(calc))/,
          /^(?:(var))/,
          /^(?:([a-z]+))/,
          /^(?:\()/,
          /^(?:\))/,
          /^(?:,)/,
          /^(?:$)/
        ],
        conditions: {
          INITIAL: {
            rules: [
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30,
              31,
              32,
              33,
              34,
              35,
              36,
              37,
              38,
              39
            ],
            inclusive: !0
          }
        }
      };
      return _;
    }();
    v.lexer = b;
    function y() {
      this.yy = {};
    }
    return y.prototype = v, v.Parser = y, new y();
  }();
  typeof Pue < "u" && (e.parser = n, e.Parser = n.Parser, e.parse = function() {
    return n.parse.apply(n, arguments);
  });
})(z3);
var md = {}, dw = { exports: {} }, Gv = {
  px: {
    px: 1,
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    in: 96,
    pt: 96 / 72,
    pc: 16
  },
  cm: {
    px: 2.54 / 96,
    cm: 1,
    mm: 0.1,
    in: 2.54,
    pt: 2.54 / 72,
    pc: 2.54 / 6
  },
  mm: {
    px: 25.4 / 96,
    cm: 10,
    mm: 1,
    in: 25.4,
    pt: 25.4 / 72,
    pc: 25.4 / 6
  },
  in: {
    px: 1 / 96,
    cm: 1 / 2.54,
    mm: 1 / 25.4,
    in: 1,
    pt: 1 / 72,
    pc: 1 / 6
  },
  pt: {
    px: 0.75,
    cm: 72 / 2.54,
    mm: 72 / 25.4,
    in: 72,
    pt: 1,
    pc: 12
  },
  pc: {
    px: 6 / 96,
    cm: 6 / 2.54,
    mm: 6 / 25.4,
    in: 6,
    pt: 6 / 72,
    pc: 1
  },
  deg: {
    deg: 1,
    grad: 0.9,
    rad: 180 / Math.PI,
    turn: 360
  },
  grad: {
    deg: 400 / 360,
    grad: 1,
    rad: 200 / Math.PI,
    turn: 400
  },
  rad: {
    deg: Math.PI / 180,
    grad: Math.PI / 200,
    rad: 1,
    turn: Math.PI * 2
  },
  turn: {
    deg: 1 / 360,
    grad: 1 / 400,
    rad: 0.5 / Math.PI,
    turn: 1
  },
  s: {
    s: 1,
    ms: 1 / 1e3
  },
  ms: {
    s: 1e3,
    ms: 1
  },
  Hz: {
    Hz: 1,
    kHz: 1e3
  },
  kHz: {
    Hz: 1 / 1e3,
    kHz: 1
  },
  dpi: {
    dpi: 1,
    dpcm: 1 / 2.54,
    dppx: 1 / 96
  },
  dpcm: {
    dpi: 2.54,
    dpcm: 1,
    dppx: 2.54 / 96
  },
  dppx: {
    dpi: 96,
    dpcm: 96 / 2.54,
    dppx: 1
  }
}, Oue = function(e, n, r, o) {
  if (!Gv.hasOwnProperty(r))
    throw new Error("Cannot convert to " + r);
  if (!Gv[r].hasOwnProperty(n))
    throw new Error("Cannot convert from " + n + " to " + r);
  var s = Gv[r][n] * e;
  return o !== !1 ? (o = Math.pow(10, parseInt(o) || 5), Math.round(s * o) / o) : s;
};
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var r = Oue, o = s(r);
  function s(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function u(f, p, v) {
    switch (f.type) {
      case "LengthValue":
      case "AngleValue":
      case "TimeValue":
      case "FrequencyValue":
      case "ResolutionValue":
        return h(f, p, v);
      default:
        return { left: f, right: p };
    }
  }
  function h(f, p, v) {
    return p.type === f.type && (p = {
      type: f.type,
      value: (0, o.default)(p.value, p.unit, f.unit, v),
      unit: f.unit
    }), { left: f, right: p };
  }
  n.default = u, e.exports = n.default;
})(dw, dw.exports);
Object.defineProperty(md, "__esModule", {
  value: !0
});
md.flip = hw;
var Rue = dw.exports, qv = Nue(Rue);
function Nue(e) {
  return e && e.__esModule ? e : { default: e };
}
function dr(e, n) {
  return e.type === "MathExpression" ? Fue(e, n) : e.type === "Calc" ? dr(e.value, n) : e;
}
function eM(e, n) {
  return e.type === n.type && e.value === n.value;
}
function Er(e) {
  switch (e) {
    case "LengthValue":
    case "AngleValue":
    case "TimeValue":
    case "FrequencyValue":
    case "ResolutionValue":
    case "EmValue":
    case "ExValue":
    case "ChValue":
    case "RemValue":
    case "VhValue":
    case "VwValue":
    case "VminValue":
    case "VmaxValue":
    case "PercentageValue":
    case "Value":
      return !0;
  }
  return !1;
}
function $ue(e, n) {
  var r = (0, qv.default)(e.left, e.right, n), o = dr(r.left, n), s = dr(r.right, n);
  return o.type === "MathExpression" && s.type === "MathExpression" && (o.operator === "/" && s.operator === "*" || o.operator === "-" && s.operator === "+" || o.operator === "*" && s.operator === "/" || o.operator === "+" && s.operator === "-") && (eM(o.right, s.right) ? r = (0, qv.default)(o.left, s.left, n) : eM(o.right, s.left) && (r = (0, qv.default)(o.left, s.right, n)), o = dr(r.left, n), s = dr(r.right, n)), e.left = o, e.right = s, e;
}
function hw(e) {
  return e === "+" ? "-" : "+";
}
function fw(e) {
  return Er(e.type) ? e.value = -e.value : e.type == "MathExpression" && (e.left = fw(e.left), e.right = fw(e.right)), e;
}
function Lue(e, n) {
  var r = e, o = r.left, s = r.right, u = r.operator;
  if (o.type === "CssVariable" || s.type === "CssVariable")
    return e;
  if (s.value === 0)
    return o;
  if (o.value === 0 && u === "+")
    return s;
  if (o.value === 0 && u === "-")
    return fw(s);
  if (o.type === s.type && Er(o.type) && (e = Object.assign({}, o), u === "+" ? e.value = o.value + s.value : e.value = o.value - s.value), Er(o.type) && (s.operator === "+" || s.operator === "-") && s.type === "MathExpression") {
    if (o.type === s.left.type)
      return e = Object.assign({}, e), e.left = dr({
        type: "MathExpression",
        operator: u,
        left: o,
        right: s.left
      }, n), e.right = s.right, e.operator = u === "-" ? hw(s.operator) : s.operator, dr(e, n);
    if (o.type === s.right.type)
      return e = Object.assign({}, e), e.left = dr({
        type: "MathExpression",
        operator: u === "-" ? hw(s.operator) : s.operator,
        left: o,
        right: s.right
      }, n), e.right = s.left, dr(e, n);
  }
  if (o.type === "MathExpression" && (o.operator === "+" || o.operator === "-") && Er(s.type)) {
    if (s.type === o.left.type)
      return e = Object.assign({}, o), e.left = dr({
        type: "MathExpression",
        operator: u,
        left: o.left,
        right: s
      }, n), dr(e, n);
    if (s.type === o.right.type)
      return e = Object.assign({}, o), o.operator === "-" ? (e.right = dr({
        type: "MathExpression",
        operator: u === "-" ? "+" : "-",
        left: s,
        right: o.right
      }, n), e.operator = u === "-" ? "-" : "+") : e.right = dr({
        type: "MathExpression",
        operator: u,
        left: o.right,
        right: s
      }, n), e.right.value < 0 && (e.right.value *= -1, e.operator = e.operator === "-" ? "+" : "-"), dr(e, n);
  }
  return e;
}
function jue(e, n) {
  if (!Er(e.right.type))
    return e;
  if (e.right.type !== "Value")
    throw new Error('Cannot divide by "' + e.right.unit + '", number expected');
  if (e.right.value === 0)
    throw new Error("Cannot divide by zero");
  return e.left.type === "MathExpression" ? Er(e.left.left.type) && Er(e.left.right.type) ? (e.left.left.value /= e.right.value, e.left.right.value /= e.right.value, dr(e.left, n)) : e : Er(e.left.type) ? (e.left.value /= e.right.value, e.left) : e;
}
function Bue(e) {
  if (e.left.type === "MathExpression" && e.right.type === "Value") {
    if (Er(e.left.left.type) && Er(e.left.right.type))
      return e.left.left.value *= e.right.value, e.left.right.value *= e.right.value, e.left;
  } else {
    if (Er(e.left.type) && e.right.type === "Value")
      return e.left.value *= e.right.value, e.left;
    if (e.left.type === "Value" && e.right.type === "MathExpression") {
      if (Er(e.right.left.type) && Er(e.right.right.type))
        return e.right.left.value *= e.left.value, e.right.right.value *= e.left.value, e.right;
    } else if (e.left.type === "Value" && Er(e.right.type))
      return e.right.value *= e.left.value, e.right;
  }
  return e;
}
function Fue(e, n) {
  switch (e = $ue(e, n), e.operator) {
    case "+":
    case "-":
      return Lue(e, n);
    case "/":
      return jue(e, n);
    case "*":
      return Bue(e);
  }
  return e;
}
md.default = dr;
var pw = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = function(h, f, p) {
    var v = u(f, p);
    return f.type === "MathExpression" && (v = h + "(" + v + ")"), v;
  };
  var r = md, o = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
  };
  function s(h, f) {
    if (f !== !1) {
      var p = Math.pow(10, f);
      return Math.round(h * p) / p;
    }
    return h;
  }
  function u(h, f) {
    switch (h.type) {
      case "MathExpression": {
        var p = h.left, v = h.right, b = h.operator, y = "";
        return p.type === "MathExpression" && o[b] < o[p.operator] ? y += "(" + u(p, f) + ")" : y += u(p, f), y += " " + h.operator + " ", v.type === "MathExpression" && o[b] < o[v.operator] ? y += "(" + u(v, f) + ")" : (v.type === "MathExpression" && b === "-" && ["+", "-"].includes(v.operator) && (v.operator = (0, r.flip)(v.operator)), y += u(v, f)), y;
      }
      case "Value":
        return s(h.value, f);
      case "CssVariable":
        return h.fallback ? "var(" + h.value + ", " + u(h.fallback, f) + ")" : "var(" + h.value + ")";
      case "Calc":
        return h.prefix ? "-" + h.prefix + "-calc(" + u(h.value, f) + ")" : "calc(" + u(h.value, f) + ")";
      default:
        return s(h.value, f) + h.unit;
    }
  }
  e.exports = n.default;
})(pw, pw.exports);
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  var r = Iue, o = v(r), s = z3, u = md, h = v(u), f = pw.exports, p = v(f);
  function v(y) {
    return y && y.__esModule ? y : { default: y };
  }
  var b = /((?:\-[a-z]+\-)?calc)/;
  n.default = function(y) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    return (0, o.default)(y).walk(function(_) {
      if (!(_.type !== "function" || !b.test(_.value))) {
        var E = o.default.stringify(_.nodes);
        if (!(E.indexOf("constant") >= 0 || E.indexOf("env") >= 0)) {
          var x = s.parser.parse(E), D = (0, h.default)(x, k);
          _.type = "word", _.value = (0, p.default)(_.value, D, k);
        }
      }
    }, !0).toString();
  }, e.exports = n.default;
})(uw, uw.exports);
const Kv = /* @__PURE__ */ t4(uw.exports);
function tM(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function nM(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? tM(Object(r), !0).forEach(function(o) {
      zue(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tM(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function zue(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function rM(e) {
  return Wue(e) || Uue(e) || Hue(e) || Vue();
}
function Vue() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hue(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return gw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return gw(e, n);
  }
}
function Uue(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Wue(e) {
  if (Array.isArray(e))
    return gw(e);
}
function gw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
var Rl = {
  widthCache: {},
  cacheCount: 0
}, Gue = 2e3, que = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Kue = ["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height", "top", "left", "fontSize", "lineHeight", "padding", "margin", "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom"], iM = "recharts_measurement_span";
function Yue(e, n) {
  return Kue.indexOf(e) >= 0 && n === +n ? "".concat(n, "px") : n;
}
function Que(e) {
  var n = e.split(""), r = n.reduce(function(o, s) {
    return s === s.toUpperCase() ? [].concat(rM(o), ["-", s.toLowerCase()]) : [].concat(rM(o), [s]);
  }, []);
  return r.join("");
}
var Zue = function(n) {
  return Object.keys(n).reduce(function(r, o) {
    return "".concat(r).concat(Que(o), ":").concat(Yue(o, n[o]), ";");
  }, "");
}, ws = function(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (n == null || ci.isSsr)
    return {
      width: 0,
      height: 0
    };
  var o = "".concat(n), s = Zue(r), u = "".concat(o, "-").concat(s);
  if (Rl.widthCache[u])
    return Rl.widthCache[u];
  try {
    var h = document.getElementById(iM);
    h || (h = document.createElement("span"), h.setAttribute("id", iM), h.setAttribute("aria-hidden", "true"), document.body.appendChild(h));
    var f = nM(nM({}, que), r);
    Object.keys(f).map(function(b) {
      return h.style[b] = f[b], b;
    }), h.textContent = o;
    var p = h.getBoundingClientRect(), v = {
      width: p.width,
      height: p.height
    };
    return Rl.widthCache[u] = v, ++Rl.cacheCount > Gue && (Rl.cacheCount = 0, Rl.widthCache = {}), v;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, Xue = function(n) {
  var r = n.ownerDocument.documentElement, o = {
    top: 0,
    left: 0
  };
  return typeof n.getBoundingClientRect < "u" && (o = n.getBoundingClientRect()), {
    top: o.top + window.pageYOffset - r.clientTop,
    left: o.left + window.pageXOffset - r.clientLeft
  };
}, Jue = function(n, r) {
  return {
    chartX: Math.round(n.pageX - r.left),
    chartY: Math.round(n.pageY - r.top)
  };
};
function _f(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _f = function(r) {
    return typeof r;
  } : _f = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, _f(e);
}
function ede(e, n) {
  if (e == null)
    return {};
  var r = tde(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function tde(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function nde(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function oM(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function rde(e, n, r) {
  return n && oM(e.prototype, n), r && oM(e, r), e;
}
function ide(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && mw(e, n);
}
function mw(e, n) {
  return mw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, mw(e, n);
}
function ode(e) {
  var n = lde();
  return function() {
    var o = gp(e), s;
    if (n) {
      var u = gp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return ade(this, s);
  };
}
function ade(e, n) {
  return n && (_f(n) === "object" || typeof n == "function") ? n : sde(e);
}
function sde(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lde() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function gp(e) {
  return gp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gp(e);
}
function aM(e, n) {
  return hde(e) || dde(e, n) || ude(e, n) || cde();
}
function cde() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ude(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return sM(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return sM(e, n);
  }
}
function sM(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function dde(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function hde(e) {
  if (Array.isArray(e))
    return e;
}
function lM(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function cM(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? lM(Object(r), !0).forEach(function(o) {
      fde(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lM(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function fde(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var V3 = /[ \f\n\r\t\v\u2028\u2029]+/, H3 = function(n) {
  try {
    var r = [];
    Be(n.children) || (n.breakAll ? r = n.children.toString().split("") : r = n.children.toString().split(V3));
    var o = r.map(function(u) {
      return {
        word: u,
        width: ws(u, n.style).width
      };
    }), s = n.breakAll ? 0 : ws("\xA0", n.style).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, pde = function(n, r, o, s, u) {
  var h = Oe(n.maxLines), f = n.children, p = function() {
    var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return q.reduce(function(Y, Q) {
      var Z = Q.word, ae = Q.width, ie = Y[Y.length - 1];
      if (ie && (s == null || u || ie.width + ae + o < s))
        ie.words.push(Z), ie.width += ae + o;
      else {
        var pe = {
          words: [Z],
          width: ae
        };
        Y.push(pe);
      }
      return Y;
    }, []);
  }, v = p(r), b = function(q) {
    return q.reduce(function(Y, Q) {
      return Y.width > Q.width ? Y : Q;
    });
  };
  if (!h)
    return v;
  for (var y = "\u2026", k = function(q) {
    var Y = f.slice(0, q), Q = H3(cM(cM({}, n), {}, {
      children: Y + y
    })).wordsWithComputedWidth, Z = p(Q), ae = Z.length > n.maxLines || b(Z).width > s;
    return [ae, Z];
  }, _ = 0, E = f.length - 1, x = 0, D; _ <= E && x <= f.length - 1; ) {
    var I = Math.floor((_ + E) / 2), N = I - 1, O = k(N), P = aM(O, 2), S = P[0], $ = P[1], L = k(I), B = aM(L, 1), U = B[0];
    if (!S && !U && (_ = I + 1), S && U && (E = I - 1), !S && U) {
      D = $;
      break;
    }
    x++;
  }
  return D || v;
}, uM = function(n) {
  var r = Be(n) ? [] : n.toString().split(V3);
  return [{
    words: r
  }];
}, gde = function(n, r) {
  if ((n.width || n.scaleToFit) && !ci.isSsr) {
    var o, s;
    if (r) {
      var u = H3(n);
      if (u) {
        var h = u.wordsWithComputedWidth, f = u.spaceWidth;
        o = h, s = f;
      } else
        return uM(n.children);
      return pde(n, o, s, n.width, n.scaleToFit);
    }
  }
  return uM(n.children);
}, Oa = /* @__PURE__ */ function(e) {
  ide(r, e);
  var n = ode(r);
  function r() {
    var o;
    nde(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {}, o;
  }
  return rde(r, [{
    key: "render",
    value: function() {
      var s = this.props, u = s.dx, h = s.dy, f = s.textAnchor, p = s.verticalAnchor, v = s.scaleToFit, b = s.angle, y = s.lineHeight, k = s.capHeight, _ = s.className, E = s.breakAll, x = ede(s, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className", "breakAll"]), D = this.state.wordsByLines;
      if (!Un(x.x) || !Un(x.y))
        return null;
      var I = x.x + (Oe(u) ? u : 0), N = x.y + (Oe(h) ? h : 0), O;
      switch (p) {
        case "start":
          O = Kv("calc(".concat(k, ")"));
          break;
        case "middle":
          O = Kv("calc(".concat((D.length - 1) / 2, " * -").concat(y, " + (").concat(k, " / 2))"));
          break;
        default:
          O = Kv("calc(".concat(D.length - 1, " * -").concat(y, ")"));
          break;
      }
      var P = [];
      if (v) {
        var S = D[0].width, $ = this.props.width;
        P.push("scale(".concat((Oe($) ? $ / S : 1) / S, ")"));
      }
      return b && P.push("rotate(".concat(b, ", ").concat(I, ", ").concat(N, ")")), P.length && (x.transform = P.join(" ")), /* @__PURE__ */ M("text", {
        ...Ye(x, !0),
        x: I,
        y: N,
        className: Ce("recharts-text", _),
        textAnchor: f,
        fill: x.fill.includes("url") ? r.defaultProps.fill : x.fill,
        children: D.map(function(L, B) {
          return /* @__PURE__ */ M("tspan", {
            x: I,
            dy: B === 0 ? O : y,
            children: L.words.join(E ? "" : " ")
          }, B);
        })
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      if (s.width !== u.prevWidth || s.scaleToFit !== u.prevScaleToFit || s.children !== u.prevChildren || s.style !== u.prevStyle || s.breakAll !== u.prevBreakAll) {
        var h = s.children !== u.prevChildren || s.style !== u.prevStyle || s.breakAll !== u.prevBreakAll;
        return {
          prevWidth: s.width,
          prevScaleToFit: s.scaleToFit,
          prevChildren: s.children,
          prevStyle: s.style,
          wordsByLines: gde(s, h)
        };
      }
      return null;
    }
  }]), r;
}(w1);
Oa.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: "1em",
  capHeight: "0.71em",
  scaleToFit: !1,
  textAnchor: "start",
  verticalAnchor: "end",
  fill: "#808080"
};
var U3 = { exports: {} }, Wt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dM;
function mde() {
  if (dM)
    return Wt;
  dM = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, h = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, N = e ? Symbol.for("react.scope") : 60119;
  function O(S) {
    if (typeof S == "object" && S !== null) {
      var $ = S.$$typeof;
      switch ($) {
        case n:
          switch (S = S.type, S) {
            case p:
            case v:
            case o:
            case u:
            case s:
            case y:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case f:
                case b:
                case E:
                case _:
                case h:
                  return S;
                default:
                  return $;
              }
          }
        case r:
          return $;
      }
    }
  }
  function P(S) {
    return O(S) === v;
  }
  return Wt.AsyncMode = p, Wt.ConcurrentMode = v, Wt.ContextConsumer = f, Wt.ContextProvider = h, Wt.Element = n, Wt.ForwardRef = b, Wt.Fragment = o, Wt.Lazy = E, Wt.Memo = _, Wt.Portal = r, Wt.Profiler = u, Wt.StrictMode = s, Wt.Suspense = y, Wt.isAsyncMode = function(S) {
    return P(S) || O(S) === p;
  }, Wt.isConcurrentMode = P, Wt.isContextConsumer = function(S) {
    return O(S) === f;
  }, Wt.isContextProvider = function(S) {
    return O(S) === h;
  }, Wt.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === n;
  }, Wt.isForwardRef = function(S) {
    return O(S) === b;
  }, Wt.isFragment = function(S) {
    return O(S) === o;
  }, Wt.isLazy = function(S) {
    return O(S) === E;
  }, Wt.isMemo = function(S) {
    return O(S) === _;
  }, Wt.isPortal = function(S) {
    return O(S) === r;
  }, Wt.isProfiler = function(S) {
    return O(S) === u;
  }, Wt.isStrictMode = function(S) {
    return O(S) === s;
  }, Wt.isSuspense = function(S) {
    return O(S) === y;
  }, Wt.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === o || S === v || S === u || S === s || S === y || S === k || typeof S == "object" && S !== null && (S.$$typeof === E || S.$$typeof === _ || S.$$typeof === h || S.$$typeof === f || S.$$typeof === b || S.$$typeof === D || S.$$typeof === I || S.$$typeof === N || S.$$typeof === x);
  }, Wt.typeOf = O, Wt;
}
var Gt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hM;
function vde() {
  return hM || (hM = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, h = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, k = e ? Symbol.for("react.suspense_list") : 60120, _ = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, N = e ? Symbol.for("react.scope") : 60119;
    function O(J) {
      return typeof J == "string" || typeof J == "function" || J === o || J === v || J === u || J === s || J === y || J === k || typeof J == "object" && J !== null && (J.$$typeof === E || J.$$typeof === _ || J.$$typeof === h || J.$$typeof === f || J.$$typeof === b || J.$$typeof === D || J.$$typeof === I || J.$$typeof === N || J.$$typeof === x);
    }
    function P(J) {
      if (typeof J == "object" && J !== null) {
        var Ge = J.$$typeof;
        switch (Ge) {
          case n:
            var De = J.type;
            switch (De) {
              case p:
              case v:
              case o:
              case u:
              case s:
              case y:
                return De;
              default:
                var He = De && De.$$typeof;
                switch (He) {
                  case f:
                  case b:
                  case E:
                  case _:
                  case h:
                    return He;
                  default:
                    return Ge;
                }
            }
          case r:
            return Ge;
        }
      }
    }
    var S = p, $ = v, L = f, B = h, U = n, G = b, q = o, Y = E, Q = _, Z = r, ae = u, ie = s, pe = y, ce = !1;
    function ue(J) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), X(J) || P(J) === p;
    }
    function X(J) {
      return P(J) === v;
    }
    function se(J) {
      return P(J) === f;
    }
    function he(J) {
      return P(J) === h;
    }
    function de(J) {
      return typeof J == "object" && J !== null && J.$$typeof === n;
    }
    function me(J) {
      return P(J) === b;
    }
    function we(J) {
      return P(J) === o;
    }
    function Ae(J) {
      return P(J) === E;
    }
    function Se(J) {
      return P(J) === _;
    }
    function ke(J) {
      return P(J) === r;
    }
    function ge(J) {
      return P(J) === u;
    }
    function xe(J) {
      return P(J) === s;
    }
    function Te(J) {
      return P(J) === y;
    }
    Gt.AsyncMode = S, Gt.ConcurrentMode = $, Gt.ContextConsumer = L, Gt.ContextProvider = B, Gt.Element = U, Gt.ForwardRef = G, Gt.Fragment = q, Gt.Lazy = Y, Gt.Memo = Q, Gt.Portal = Z, Gt.Profiler = ae, Gt.StrictMode = ie, Gt.Suspense = pe, Gt.isAsyncMode = ue, Gt.isConcurrentMode = X, Gt.isContextConsumer = se, Gt.isContextProvider = he, Gt.isElement = de, Gt.isForwardRef = me, Gt.isFragment = we, Gt.isLazy = Ae, Gt.isMemo = Se, Gt.isPortal = ke, Gt.isProfiler = ge, Gt.isStrictMode = xe, Gt.isSuspense = Te, Gt.isValidElementType = O, Gt.typeOf = P;
  }()), Gt;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = mde() : e.exports = vde();
})(U3);
function Bl(e, n) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(n, r) || e[r] !== n[r]))
      return !1;
  for (var o in n)
    if ({}.hasOwnProperty.call(n, o) && !{}.hasOwnProperty.call(e, o))
      return !1;
  return !0;
}
function fM(e, n) {
  if (e == null)
    return {};
  var r = bde(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function bde(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
var pM = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Sa = function(n) {
  return typeof n == "string" ? n : n ? n.displayName || n.name || "Component" : "";
}, gM = null, Yv = null, Ry = function e(n) {
  if (n === gM && Tt(Yv))
    return Yv;
  var r = [];
  return xs.forEach(n, function(o) {
    Be(o) || (U3.exports.isFragment(o) ? r = r.concat(e(o.props.children)) : r.push(o));
  }), Yv = r, gM = n, r;
}, yr = function(n, r) {
  var o = [], s = [];
  return Tt(r) ? s = r.map(function(u) {
    return Sa(u);
  }) : s = [Sa(r)], Ry(n).forEach(function(u) {
    var h = Hn(u, "type.displayName") || Hn(u, "type.name");
    s.indexOf(h) !== -1 && o.push(u);
  }), o;
}, Fo = function(n, r) {
  var o = yr(n, r);
  return o && o[0];
}, mM = function(n) {
  if (!n || !n.props)
    return !1;
  var r = n.props, o = r.width, s = r.height;
  return !(!Oe(o) || o <= 0 || !Oe(s) || s <= 0);
}, wde = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], yde = function(n) {
  return n && n.type && gd(n.type) && wde.indexOf(n.type) >= 0;
}, W3 = function e(n, r) {
  if (n === r)
    return !0;
  var o = xs.count(n);
  if (o !== xs.count(r))
    return !1;
  if (o === 0)
    return !0;
  if (o === 1)
    return vM(Tt(n) ? n[0] : n, Tt(r) ? r[0] : r);
  for (var s = 0; s < o; s++) {
    var u = n[s], h = r[s];
    if (Tt(u) || Tt(h)) {
      if (!e(u, h))
        return !1;
    } else if (!vM(u, h))
      return !1;
  }
  return !0;
}, vM = function(n, r) {
  if (Be(n) && Be(r))
    return !0;
  if (!Be(n) && !Be(r)) {
    var o = n.props || {}, s = o.children, u = fM(o, ["children"]), h = r.props || {}, f = h.children, p = fM(h, ["children"]);
    return s && f ? Bl(u, p) && W3(s, f) : !s && !f ? Bl(u, p) : !1;
  }
  return !1;
}, bM = function(n, r) {
  var o = [], s = {};
  return Ry(n).forEach(function(u, h) {
    if (yde(u))
      o.push(u);
    else if (u) {
      var f = Sa(u.type), p = r[f] || {}, v = p.handler, b = p.once;
      if (v && (!b || !s[f])) {
        var y = v(u, f, h);
        o.push(y), s[f] = !0;
      }
    }
  }), o;
}, kde = function(n) {
  var r = n && n.type;
  return r && pM[r] ? pM[r] : null;
}, _de = function(n, r) {
  return Ry(r).indexOf(n);
}, Ade = ky;
function Cde(e, n) {
  return Ade(e, n);
}
var Rs = Cde, xde = gc;
function Ede(e, n, r) {
  for (var o = -1, s = e.length; ++o < s; ) {
    var u = e[o], h = n(u);
    if (h != null && (f === void 0 ? h === h && !xde(h) : r(h, f)))
      var f = h, p = u;
  }
  return p;
}
var Fg = Ede;
function Sde(e, n) {
  return e > n;
}
var G3 = Sde, Mde = Fg, Tde = G3, Dde = mc;
function Ide(e) {
  return e && e.length ? Mde(e, Dde, Tde) : void 0;
}
var xa = Ide;
function Pde(e, n) {
  return e < n;
}
var q3 = Pde, Ode = Fg, Rde = q3, Nde = mc;
function $de(e) {
  return e && e.length ? Ode(e, Nde, Rde) : void 0;
}
var zg = $de, Lde = Cy, jde = ko, Bde = N3, Fde = Tt;
function zde(e, n) {
  var r = Fde(e) ? Lde : Bde;
  return r(e, jde(n));
}
var Vde = zde, Hde = O3, Ude = Vde;
function Wde(e, n) {
  return Hde(Ude(e, n), 1);
}
var Gde = Wde, vc = 1e9, qde = {
  precision: 20,
  rounding: 4,
  toExpNeg: -7,
  toExpPos: 21,
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, $y, _n = !0, pi = "[DecimalError] ", Ts = pi + "Invalid argument: ", Ny = pi + "Exponent out of range: ", bc = Math.floor, vs = Math.pow, Kde = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, jr, nr = 1e7, gn = 7, K3 = 9007199254740991, mp = bc(K3 / gn), Ue = {};
Ue.absoluteValue = Ue.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Ue.comparedTo = Ue.cmp = function(e) {
  var n, r, o, s, u = this;
  if (e = new u.constructor(e), u.s !== e.s)
    return u.s || -e.s;
  if (u.e !== e.e)
    return u.e > e.e ^ u.s < 0 ? 1 : -1;
  for (o = u.d.length, s = e.d.length, n = 0, r = o < s ? o : s; n < r; ++n)
    if (u.d[n] !== e.d[n])
      return u.d[n] > e.d[n] ^ u.s < 0 ? 1 : -1;
  return o === s ? 0 : o > s ^ u.s < 0 ? 1 : -1;
};
Ue.decimalPlaces = Ue.dp = function() {
  var e = this, n = e.d.length - 1, r = (n - e.e) * gn;
  if (n = e.d[n], n)
    for (; n % 10 == 0; n /= 10)
      r--;
  return r < 0 ? 0 : r;
};
Ue.dividedBy = Ue.div = function(e) {
  return Wo(this, new this.constructor(e));
};
Ue.dividedToIntegerBy = Ue.idiv = function(e) {
  var n = this, r = n.constructor;
  return an(Wo(n, new r(e), 0, 1), r.precision);
};
Ue.equals = Ue.eq = function(e) {
  return !this.cmp(e);
};
Ue.exponent = function() {
  return jn(this);
};
Ue.greaterThan = Ue.gt = function(e) {
  return this.cmp(e) > 0;
};
Ue.greaterThanOrEqualTo = Ue.gte = function(e) {
  return this.cmp(e) >= 0;
};
Ue.isInteger = Ue.isint = function() {
  return this.e > this.d.length - 2;
};
Ue.isNegative = Ue.isneg = function() {
  return this.s < 0;
};
Ue.isPositive = Ue.ispos = function() {
  return this.s > 0;
};
Ue.isZero = function() {
  return this.s === 0;
};
Ue.lessThan = Ue.lt = function(e) {
  return this.cmp(e) < 0;
};
Ue.lessThanOrEqualTo = Ue.lte = function(e) {
  return this.cmp(e) < 1;
};
Ue.logarithm = Ue.log = function(e) {
  var n, r = this, o = r.constructor, s = o.precision, u = s + 5;
  if (e === void 0)
    e = new o(10);
  else if (e = new o(e), e.s < 1 || e.eq(jr))
    throw Error(pi + "NaN");
  if (r.s < 1)
    throw Error(pi + (r.s ? "NaN" : "-Infinity"));
  return r.eq(jr) ? new o(0) : (_n = !1, n = Wo(Ku(r, u), Ku(e, u), u), _n = !0, an(n, s));
};
Ue.minus = Ue.sub = function(e) {
  var n = this;
  return e = new n.constructor(e), n.s == e.s ? Z3(n, e) : Y3(n, (e.s = -e.s, e));
};
Ue.modulo = Ue.mod = function(e) {
  var n, r = this, o = r.constructor, s = o.precision;
  if (e = new o(e), !e.s)
    throw Error(pi + "NaN");
  return r.s ? (_n = !1, n = Wo(r, e, 0, 1).times(e), _n = !0, r.minus(n)) : an(new o(r), s);
};
Ue.naturalExponential = Ue.exp = function() {
  return Q3(this);
};
Ue.naturalLogarithm = Ue.ln = function() {
  return Ku(this);
};
Ue.negated = Ue.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Ue.plus = Ue.add = function(e) {
  var n = this;
  return e = new n.constructor(e), n.s == e.s ? Y3(n, e) : Z3(n, (e.s = -e.s, e));
};
Ue.precision = Ue.sd = function(e) {
  var n, r, o, s = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(Ts + e);
  if (n = jn(s) + 1, o = s.d.length - 1, r = o * gn + 1, o = s.d[o], o) {
    for (; o % 10 == 0; o /= 10)
      r--;
    for (o = s.d[0]; o >= 10; o /= 10)
      r++;
  }
  return e && n > r ? n : r;
};
Ue.squareRoot = Ue.sqrt = function() {
  var e, n, r, o, s, u, h, f = this, p = f.constructor;
  if (f.s < 1) {
    if (!f.s)
      return new p(0);
    throw Error(pi + "NaN");
  }
  for (e = jn(f), _n = !1, s = Math.sqrt(+f), s == 0 || s == 1 / 0 ? (n = uo(f.d), (n.length + e) % 2 == 0 && (n += "0"), s = Math.sqrt(n), e = bc((e + 1) / 2) - (e < 0 || e % 2), s == 1 / 0 ? n = "5e" + e : (n = s.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + e), o = new p(n)) : o = new p(s.toString()), r = p.precision, s = h = r + 3; ; )
    if (u = o, o = u.plus(Wo(f, u, h + 2)).times(0.5), uo(u.d).slice(0, h) === (n = uo(o.d)).slice(0, h)) {
      if (n = n.slice(h - 3, h + 1), s == h && n == "4999") {
        if (an(u, r + 1, 0), u.times(u).eq(f)) {
          o = u;
          break;
        }
      } else if (n != "9999")
        break;
      h += 4;
    }
  return _n = !0, an(o, r);
};
Ue.times = Ue.mul = function(e) {
  var n, r, o, s, u, h, f, p, v, b = this, y = b.constructor, k = b.d, _ = (e = new y(e)).d;
  if (!b.s || !e.s)
    return new y(0);
  for (e.s *= b.s, r = b.e + e.e, p = k.length, v = _.length, p < v && (u = k, k = _, _ = u, h = p, p = v, v = h), u = [], h = p + v, o = h; o--; )
    u.push(0);
  for (o = v; --o >= 0; ) {
    for (n = 0, s = p + o; s > o; )
      f = u[s] + _[o] * k[s - o - 1] + n, u[s--] = f % nr | 0, n = f / nr | 0;
    u[s] = (u[s] + n) % nr | 0;
  }
  for (; !u[--h]; )
    u.pop();
  return n ? ++r : u.shift(), e.d = u, e.e = r, _n ? an(e, y.precision) : e;
};
Ue.toDecimalPlaces = Ue.todp = function(e, n) {
  var r = this, o = r.constructor;
  return r = new o(r), e === void 0 ? r : (vo(e, 0, vc), n === void 0 ? n = o.rounding : vo(n, 0, 8), an(r, e + jn(r) + 1, n));
};
Ue.toExponential = function(e, n) {
  var r, o = this, s = o.constructor;
  return e === void 0 ? r = Ns(o, !0) : (vo(e, 0, vc), n === void 0 ? n = s.rounding : vo(n, 0, 8), o = an(new s(o), e + 1, n), r = Ns(o, !0, e + 1)), r;
};
Ue.toFixed = function(e, n) {
  var r, o, s = this, u = s.constructor;
  return e === void 0 ? Ns(s) : (vo(e, 0, vc), n === void 0 ? n = u.rounding : vo(n, 0, 8), o = an(new u(s), e + jn(s) + 1, n), r = Ns(o.abs(), !1, e + jn(o) + 1), s.isneg() && !s.isZero() ? "-" + r : r);
};
Ue.toInteger = Ue.toint = function() {
  var e = this, n = e.constructor;
  return an(new n(e), jn(e) + 1, n.rounding);
};
Ue.toNumber = function() {
  return +this;
};
Ue.toPower = Ue.pow = function(e) {
  var n, r, o, s, u, h, f = this, p = f.constructor, v = 12, b = +(e = new p(e));
  if (!e.s)
    return new p(jr);
  if (f = new p(f), !f.s) {
    if (e.s < 1)
      throw Error(pi + "Infinity");
    return f;
  }
  if (f.eq(jr))
    return f;
  if (o = p.precision, e.eq(jr))
    return an(f, o);
  if (n = e.e, r = e.d.length - 1, h = n >= r, u = f.s, h) {
    if ((r = b < 0 ? -b : b) <= K3) {
      for (s = new p(jr), n = Math.ceil(o / gn + 4), _n = !1; r % 2 && (s = s.times(f), yM(s.d, n)), r = bc(r / 2), r !== 0; )
        f = f.times(f), yM(f.d, n);
      return _n = !0, e.s < 0 ? new p(jr).div(s) : an(s, o);
    }
  } else if (u < 0)
    throw Error(pi + "NaN");
  return u = u < 0 && e.d[Math.max(n, r)] & 1 ? -1 : 1, f.s = 1, _n = !1, s = e.times(Ku(f, o + v)), _n = !0, s = Q3(s), s.s = u, s;
};
Ue.toPrecision = function(e, n) {
  var r, o, s = this, u = s.constructor;
  return e === void 0 ? (r = jn(s), o = Ns(s, r <= u.toExpNeg || r >= u.toExpPos)) : (vo(e, 1, vc), n === void 0 ? n = u.rounding : vo(n, 0, 8), s = an(new u(s), e, n), r = jn(s), o = Ns(s, e <= r || r <= u.toExpNeg, e)), o;
};
Ue.toSignificantDigits = Ue.tosd = function(e, n) {
  var r = this, o = r.constructor;
  return e === void 0 ? (e = o.precision, n = o.rounding) : (vo(e, 1, vc), n === void 0 ? n = o.rounding : vo(n, 0, 8)), an(new o(r), e, n);
};
Ue.toString = Ue.valueOf = Ue.val = Ue.toJSON = Ue[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, n = jn(e), r = e.constructor;
  return Ns(e, n <= r.toExpNeg || n >= r.toExpPos);
};
function Y3(e, n) {
  var r, o, s, u, h, f, p, v, b = e.constructor, y = b.precision;
  if (!e.s || !n.s)
    return n.s || (n = new b(e)), _n ? an(n, y) : n;
  if (p = e.d, v = n.d, h = e.e, s = n.e, p = p.slice(), u = h - s, u) {
    for (u < 0 ? (o = p, u = -u, f = v.length) : (o = v, s = h, f = p.length), h = Math.ceil(y / gn), f = h > f ? h + 1 : f + 1, u > f && (u = f, o.length = 1), o.reverse(); u--; )
      o.push(0);
    o.reverse();
  }
  for (f = p.length, u = v.length, f - u < 0 && (u = f, o = v, v = p, p = o), r = 0; u; )
    r = (p[--u] = p[u] + v[u] + r) / nr | 0, p[u] %= nr;
  for (r && (p.unshift(r), ++s), f = p.length; p[--f] == 0; )
    p.pop();
  return n.d = p, n.e = s, _n ? an(n, y) : n;
}
function vo(e, n, r) {
  if (e !== ~~e || e < n || e > r)
    throw Error(Ts + e);
}
function uo(e) {
  var n, r, o, s = e.length - 1, u = "", h = e[0];
  if (s > 0) {
    for (u += h, n = 1; n < s; n++)
      o = e[n] + "", r = gn - o.length, r && (u += ka(r)), u += o;
    h = e[n], o = h + "", r = gn - o.length, r && (u += ka(r));
  } else if (h === 0)
    return "0";
  for (; h % 10 === 0; )
    h /= 10;
  return u + h;
}
var Wo = function() {
  function e(o, s) {
    var u, h = 0, f = o.length;
    for (o = o.slice(); f--; )
      u = o[f] * s + h, o[f] = u % nr | 0, h = u / nr | 0;
    return h && o.unshift(h), o;
  }
  function n(o, s, u, h) {
    var f, p;
    if (u != h)
      p = u > h ? 1 : -1;
    else
      for (f = p = 0; f < u; f++)
        if (o[f] != s[f]) {
          p = o[f] > s[f] ? 1 : -1;
          break;
        }
    return p;
  }
  function r(o, s, u) {
    for (var h = 0; u--; )
      o[u] -= h, h = o[u] < s[u] ? 1 : 0, o[u] = h * nr + o[u] - s[u];
    for (; !o[0] && o.length > 1; )
      o.shift();
  }
  return function(o, s, u, h) {
    var f, p, v, b, y, k, _, E, x, D, I, N, O, P, S, $, L, B, U = o.constructor, G = o.s == s.s ? 1 : -1, q = o.d, Y = s.d;
    if (!o.s)
      return new U(o);
    if (!s.s)
      throw Error(pi + "Division by zero");
    for (p = o.e - s.e, L = Y.length, S = q.length, _ = new U(G), E = _.d = [], v = 0; Y[v] == (q[v] || 0); )
      ++v;
    if (Y[v] > (q[v] || 0) && --p, u == null ? N = u = U.precision : h ? N = u + (jn(o) - jn(s)) + 1 : N = u, N < 0)
      return new U(0);
    if (N = N / gn + 2 | 0, v = 0, L == 1)
      for (b = 0, Y = Y[0], N++; (v < S || b) && N--; v++)
        O = b * nr + (q[v] || 0), E[v] = O / Y | 0, b = O % Y | 0;
    else {
      for (b = nr / (Y[0] + 1) | 0, b > 1 && (Y = e(Y, b), q = e(q, b), L = Y.length, S = q.length), P = L, x = q.slice(0, L), D = x.length; D < L; )
        x[D++] = 0;
      B = Y.slice(), B.unshift(0), $ = Y[0], Y[1] >= nr / 2 && ++$;
      do
        b = 0, f = n(Y, x, L, D), f < 0 ? (I = x[0], L != D && (I = I * nr + (x[1] || 0)), b = I / $ | 0, b > 1 ? (b >= nr && (b = nr - 1), y = e(Y, b), k = y.length, D = x.length, f = n(y, x, k, D), f == 1 && (b--, r(y, L < k ? B : Y, k))) : (b == 0 && (f = b = 1), y = Y.slice()), k = y.length, k < D && y.unshift(0), r(x, y, D), f == -1 && (D = x.length, f = n(Y, x, L, D), f < 1 && (b++, r(x, L < D ? B : Y, D))), D = x.length) : f === 0 && (b++, x = [0]), E[v++] = b, f && x[0] ? x[D++] = q[P] || 0 : (x = [q[P]], D = 1);
      while ((P++ < S || x[0] !== void 0) && N--);
    }
    return E[0] || E.shift(), _.e = p, an(_, h ? u + jn(_) + 1 : u);
  };
}();
function Q3(e, n) {
  var r, o, s, u, h, f, p = 0, v = 0, b = e.constructor, y = b.precision;
  if (jn(e) > 16)
    throw Error(Ny + jn(e));
  if (!e.s)
    return new b(jr);
  for (n == null ? (_n = !1, f = y) : f = n, h = new b(0.03125); e.abs().gte(0.1); )
    e = e.times(h), v += 5;
  for (o = Math.log(vs(2, v)) / Math.LN10 * 2 + 5 | 0, f += o, r = s = u = new b(jr), b.precision = f; ; ) {
    if (s = an(s.times(e), f), r = r.times(++p), h = u.plus(Wo(s, r, f)), uo(h.d).slice(0, f) === uo(u.d).slice(0, f)) {
      for (; v--; )
        u = an(u.times(u), f);
      return b.precision = y, n == null ? (_n = !0, an(u, y)) : u;
    }
    u = h;
  }
}
function jn(e) {
  for (var n = e.e * gn, r = e.d[0]; r >= 10; r /= 10)
    n++;
  return n;
}
function Qv(e, n, r) {
  if (n > e.LN10.sd())
    throw _n = !0, r && (e.precision = r), Error(pi + "LN10 precision limit exceeded");
  return an(new e(e.LN10), n);
}
function ka(e) {
  for (var n = ""; e--; )
    n += "0";
  return n;
}
function Ku(e, n) {
  var r, o, s, u, h, f, p, v, b, y = 1, k = 10, _ = e, E = _.d, x = _.constructor, D = x.precision;
  if (_.s < 1)
    throw Error(pi + (_.s ? "NaN" : "-Infinity"));
  if (_.eq(jr))
    return new x(0);
  if (n == null ? (_n = !1, v = D) : v = n, _.eq(10))
    return n == null && (_n = !0), Qv(x, v);
  if (v += k, x.precision = v, r = uo(E), o = r.charAt(0), u = jn(_), Math.abs(u) < 15e14) {
    for (; o < 7 && o != 1 || o == 1 && r.charAt(1) > 3; )
      _ = _.times(e), r = uo(_.d), o = r.charAt(0), y++;
    u = jn(_), o > 1 ? (_ = new x("0." + r), u++) : _ = new x(o + "." + r.slice(1));
  } else
    return p = Qv(x, v + 2, D).times(u + ""), _ = Ku(new x(o + "." + r.slice(1)), v - k).plus(p), x.precision = D, n == null ? (_n = !0, an(_, D)) : _;
  for (f = h = _ = Wo(_.minus(jr), _.plus(jr), v), b = an(_.times(_), v), s = 3; ; ) {
    if (h = an(h.times(b), v), p = f.plus(Wo(h, new x(s), v)), uo(p.d).slice(0, v) === uo(f.d).slice(0, v))
      return f = f.times(2), u !== 0 && (f = f.plus(Qv(x, v + 2, D).times(u + ""))), f = Wo(f, new x(y), v), x.precision = D, n == null ? (_n = !0, an(f, D)) : f;
    f = p, s += 2;
  }
}
function wM(e, n) {
  var r, o, s;
  for ((r = n.indexOf(".")) > -1 && (n = n.replace(".", "")), (o = n.search(/e/i)) > 0 ? (r < 0 && (r = o), r += +n.slice(o + 1), n = n.substring(0, o)) : r < 0 && (r = n.length), o = 0; n.charCodeAt(o) === 48; )
    ++o;
  for (s = n.length; n.charCodeAt(s - 1) === 48; )
    --s;
  if (n = n.slice(o, s), n) {
    if (s -= o, r = r - o - 1, e.e = bc(r / gn), e.d = [], o = (r + 1) % gn, r < 0 && (o += gn), o < s) {
      for (o && e.d.push(+n.slice(0, o)), s -= gn; o < s; )
        e.d.push(+n.slice(o, o += gn));
      n = n.slice(o), o = gn - n.length;
    } else
      o -= s;
    for (; o--; )
      n += "0";
    if (e.d.push(+n), _n && (e.e > mp || e.e < -mp))
      throw Error(Ny + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function an(e, n, r) {
  var o, s, u, h, f, p, v, b, y = e.d;
  for (h = 1, u = y[0]; u >= 10; u /= 10)
    h++;
  if (o = n - h, o < 0)
    o += gn, s = n, v = y[b = 0];
  else {
    if (b = Math.ceil((o + 1) / gn), u = y.length, b >= u)
      return e;
    for (v = u = y[b], h = 1; u >= 10; u /= 10)
      h++;
    o %= gn, s = o - gn + h;
  }
  if (r !== void 0 && (u = vs(10, h - s - 1), f = v / u % 10 | 0, p = n < 0 || y[b + 1] !== void 0 || v % u, p = r < 4 ? (f || p) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : f > 5 || f == 5 && (r == 4 || p || r == 6 && (o > 0 ? s > 0 ? v / vs(10, h - s) : 0 : y[b - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), n < 1 || !y[0])
    return p ? (u = jn(e), y.length = 1, n = n - u - 1, y[0] = vs(10, (gn - n % gn) % gn), e.e = bc(-n / gn) || 0) : (y.length = 1, y[0] = e.e = e.s = 0), e;
  if (o == 0 ? (y.length = b, u = 1, b--) : (y.length = b + 1, u = vs(10, gn - o), y[b] = s > 0 ? (v / vs(10, h - s) % vs(10, s) | 0) * u : 0), p)
    for (; ; )
      if (b == 0) {
        (y[0] += u) == nr && (y[0] = 1, ++e.e);
        break;
      } else {
        if (y[b] += u, y[b] != nr)
          break;
        y[b--] = 0, u = 1;
      }
  for (o = y.length; y[--o] === 0; )
    y.pop();
  if (_n && (e.e > mp || e.e < -mp))
    throw Error(Ny + jn(e));
  return e;
}
function Z3(e, n) {
  var r, o, s, u, h, f, p, v, b, y, k = e.constructor, _ = k.precision;
  if (!e.s || !n.s)
    return n.s ? n.s = -n.s : n = new k(e), _n ? an(n, _) : n;
  if (p = e.d, y = n.d, o = n.e, v = e.e, p = p.slice(), h = v - o, h) {
    for (b = h < 0, b ? (r = p, h = -h, f = y.length) : (r = y, o = v, f = p.length), s = Math.max(Math.ceil(_ / gn), f) + 2, h > s && (h = s, r.length = 1), r.reverse(), s = h; s--; )
      r.push(0);
    r.reverse();
  } else {
    for (s = p.length, f = y.length, b = s < f, b && (f = s), s = 0; s < f; s++)
      if (p[s] != y[s]) {
        b = p[s] < y[s];
        break;
      }
    h = 0;
  }
  for (b && (r = p, p = y, y = r, n.s = -n.s), f = p.length, s = y.length - f; s > 0; --s)
    p[f++] = 0;
  for (s = y.length; s > h; ) {
    if (p[--s] < y[s]) {
      for (u = s; u && p[--u] === 0; )
        p[u] = nr - 1;
      --p[u], p[s] += nr;
    }
    p[s] -= y[s];
  }
  for (; p[--f] === 0; )
    p.pop();
  for (; p[0] === 0; p.shift())
    --o;
  return p[0] ? (n.d = p, n.e = o, _n ? an(n, _) : n) : new k(0);
}
function Ns(e, n, r) {
  var o, s = jn(e), u = uo(e.d), h = u.length;
  return n ? (r && (o = r - h) > 0 ? u = u.charAt(0) + "." + u.slice(1) + ka(o) : h > 1 && (u = u.charAt(0) + "." + u.slice(1)), u = u + (s < 0 ? "e" : "e+") + s) : s < 0 ? (u = "0." + ka(-s - 1) + u, r && (o = r - h) > 0 && (u += ka(o))) : s >= h ? (u += ka(s + 1 - h), r && (o = r - s - 1) > 0 && (u = u + "." + ka(o))) : ((o = s + 1) < h && (u = u.slice(0, o) + "." + u.slice(o)), r && (o = r - h) > 0 && (s + 1 === h && (u += "."), u += ka(o))), e.s < 0 ? "-" + u : u;
}
function yM(e, n) {
  if (e.length > n)
    return e.length = n, !0;
}
function X3(e) {
  var n, r, o;
  function s(u) {
    var h = this;
    if (!(h instanceof s))
      return new s(u);
    if (h.constructor = s, u instanceof s) {
      h.s = u.s, h.e = u.e, h.d = (u = u.d) ? u.slice() : u;
      return;
    }
    if (typeof u == "number") {
      if (u * 0 !== 0)
        throw Error(Ts + u);
      if (u > 0)
        h.s = 1;
      else if (u < 0)
        u = -u, h.s = -1;
      else {
        h.s = 0, h.e = 0, h.d = [0];
        return;
      }
      if (u === ~~u && u < 1e7) {
        h.e = 0, h.d = [u];
        return;
      }
      return wM(h, u.toString());
    } else if (typeof u != "string")
      throw Error(Ts + u);
    if (u.charCodeAt(0) === 45 ? (u = u.slice(1), h.s = -1) : h.s = 1, Kde.test(u))
      wM(h, u);
    else
      throw Error(Ts + u);
  }
  if (s.prototype = Ue, s.ROUND_UP = 0, s.ROUND_DOWN = 1, s.ROUND_CEIL = 2, s.ROUND_FLOOR = 3, s.ROUND_HALF_UP = 4, s.ROUND_HALF_DOWN = 5, s.ROUND_HALF_EVEN = 6, s.ROUND_HALF_CEIL = 7, s.ROUND_HALF_FLOOR = 8, s.clone = X3, s.config = s.set = Yde, e === void 0 && (e = {}), e)
    for (o = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], n = 0; n < o.length; )
      e.hasOwnProperty(r = o[n++]) || (e[r] = this[r]);
  return s.config(e), s;
}
function Yde(e) {
  if (!e || typeof e != "object")
    throw Error(pi + "Object expected");
  var n, r, o, s = [
    "precision",
    1,
    vc,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (n = 0; n < s.length; n += 3)
    if ((o = e[r = s[n]]) !== void 0)
      if (bc(o) === o && o >= s[n + 1] && o <= s[n + 2])
        this[r] = o;
      else
        throw Error(Ts + r + ": " + o);
  if ((o = e[r = "LN10"]) !== void 0)
    if (o == Math.LN10)
      this[r] = new this(o);
    else
      throw Error(Ts + r + ": " + o);
  return this;
}
var $y = X3(qde);
jr = new $y(1);
const tn = $y;
function Qde(e) {
  return ehe(e) || Jde(e) || Xde(e) || Zde();
}
function Zde() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xde(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return vw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return vw(e, n);
  }
}
function Jde(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function ehe(e) {
  if (Array.isArray(e))
    return vw(e);
}
function vw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
var the = function(n) {
  return n;
}, J3 = {
  "@@functional/placeholder": !0
}, eP = function(n) {
  return n === J3;
}, kM = function(n) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && eP(arguments.length <= 0 ? void 0 : arguments[0]) ? r : n.apply(void 0, arguments);
  };
}, nhe = function e(n, r) {
  return n === 1 ? r : kM(function() {
    for (var o = arguments.length, s = new Array(o), u = 0; u < o; u++)
      s[u] = arguments[u];
    var h = s.filter(function(f) {
      return f !== J3;
    }).length;
    return h >= n ? r.apply(void 0, s) : e(n - h, kM(function() {
      for (var f = arguments.length, p = new Array(f), v = 0; v < f; v++)
        p[v] = arguments[v];
      var b = s.map(function(y) {
        return eP(y) ? p.shift() : y;
      });
      return r.apply(void 0, Qde(b).concat(p));
    }));
  });
}, Vg = function(n) {
  return nhe(n.length, n);
}, bw = function(n, r) {
  for (var o = [], s = n; s < r; ++s)
    o[s - n] = s;
  return o;
}, rhe = Vg(function(e, n) {
  return Array.isArray(n) ? n.map(e) : Object.keys(n).map(function(r) {
    return n[r];
  }).map(e);
}), ihe = function() {
  for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  if (!r.length)
    return the;
  var s = r.reverse(), u = s[0], h = s.slice(1);
  return function() {
    return h.reduce(function(f, p) {
      return p(f);
    }, u.apply(void 0, arguments));
  };
}, ww = function(n) {
  return Array.isArray(n) ? n.reverse() : n.split("").reverse.join("");
}, tP = function(n) {
  var r = null, o = null;
  return function() {
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return r && u.every(function(f, p) {
      return f === r[p];
    }) || (r = u, o = n.apply(void 0, u)), o;
  };
};
function ohe(e) {
  var n;
  return e === 0 ? n = 1 : n = Math.floor(new tn(e).abs().log(10).toNumber()) + 1, n;
}
function ahe(e, n, r) {
  for (var o = new tn(e), s = 0, u = []; o.lt(n) && s < 1e5; )
    u.push(o.toNumber()), o = o.add(r), s++;
  return u;
}
var she = Vg(function(e, n, r) {
  var o = +e, s = +n;
  return o + r * (s - o);
}), lhe = Vg(function(e, n, r) {
  var o = n - +e;
  return o = o || 1 / 0, (r - e) / o;
}), che = Vg(function(e, n, r) {
  var o = n - +e;
  return o = o || 1 / 0, Math.max(0, Math.min(1, (r - e) / o));
});
const Hg = {
  rangeStep: ahe,
  getDigitCount: ohe,
  interpolateNumber: she,
  uninterpolateNumber: lhe,
  uninterpolateTruncation: che
};
function yw(e) {
  return hhe(e) || dhe(e) || nP(e) || uhe();
}
function uhe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dhe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function hhe(e) {
  if (Array.isArray(e))
    return kw(e);
}
function Yu(e, n) {
  return ghe(e) || phe(e, n) || nP(e, n) || fhe();
}
function fhe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nP(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return kw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return kw(e, n);
  }
}
function kw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function phe(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function ghe(e) {
  if (Array.isArray(e))
    return e;
}
function rP(e) {
  var n = Yu(e, 2), r = n[0], o = n[1], s = r, u = o;
  return r > o && (s = o, u = r), [s, u];
}
function iP(e, n, r) {
  if (e.lte(0))
    return new tn(0);
  var o = Hg.getDigitCount(e.toNumber()), s = new tn(10).pow(o), u = e.div(s), h = o !== 1 ? 0.05 : 0.1, f = new tn(Math.ceil(u.div(h).toNumber())).add(r).mul(h), p = f.mul(s);
  return n ? p : new tn(Math.ceil(p));
}
function mhe(e, n, r) {
  var o = 1, s = new tn(e);
  if (!s.isint() && r) {
    var u = Math.abs(e);
    u < 1 ? (o = new tn(10).pow(Hg.getDigitCount(e) - 1), s = new tn(Math.floor(s.div(o).toNumber())).mul(o)) : u > 1 && (s = new tn(Math.floor(e)));
  } else
    e === 0 ? s = new tn(Math.floor((n - 1) / 2)) : r || (s = new tn(Math.floor(e)));
  var h = Math.floor((n - 1) / 2), f = ihe(rhe(function(p) {
    return s.add(new tn(p - h).mul(o)).toNumber();
  }), bw);
  return f(0, n);
}
function oP(e, n, r, o) {
  var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((n - e) / (r - 1)))
    return {
      step: new tn(0),
      tickMin: new tn(0),
      tickMax: new tn(0)
    };
  var u = iP(new tn(n).sub(e).div(r - 1), o, s), h;
  e <= 0 && n >= 0 ? h = new tn(0) : (h = new tn(e).add(n).div(2), h = h.sub(new tn(h).mod(u)));
  var f = Math.ceil(h.sub(e).div(u).toNumber()), p = Math.ceil(new tn(n).sub(h).div(u).toNumber()), v = f + p + 1;
  return v > r ? oP(e, n, r, o, s + 1) : (v < r && (p = n > 0 ? p + (r - v) : p, f = n > 0 ? f : f + (r - v)), {
    step: u,
    tickMin: h.sub(new tn(f).mul(u)),
    tickMax: h.add(new tn(p).mul(u))
  });
}
function vhe(e) {
  var n = Yu(e, 2), r = n[0], o = n[1], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, h = Math.max(s, 2), f = rP([r, o]), p = Yu(f, 2), v = p[0], b = p[1];
  if (v === -1 / 0 || b === 1 / 0) {
    var y = b === 1 / 0 ? [v].concat(yw(bw(0, s - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(yw(bw(0, s - 1).map(function() {
      return -1 / 0;
    })), [b]);
    return r > o ? ww(y) : y;
  }
  if (v === b)
    return mhe(v, s, u);
  var k = oP(v, b, h, u), _ = k.step, E = k.tickMin, x = k.tickMax, D = Hg.rangeStep(E, x.add(new tn(0.1).mul(_)), _);
  return r > o ? ww(D) : D;
}
function bhe(e, n) {
  var r = Yu(e, 2), o = r[0], s = r[1], u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, h = rP([o, s]), f = Yu(h, 2), p = f[0], v = f[1];
  if (p === -1 / 0 || v === 1 / 0)
    return [o, s];
  if (p === v)
    return [p];
  var b = Math.max(n, 2), y = iP(new tn(v).sub(p).div(b - 1), u, 0), k = [].concat(yw(Hg.rangeStep(new tn(p), new tn(v).sub(new tn(0.99).mul(y)), y)), [v]);
  return o > s ? ww(k) : k;
}
var whe = tP(vhe), yhe = tP(bhe);
function vd(e, n) {
  return e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function Ly(e) {
  let n = e, r = e;
  e.length === 1 && (n = (h, f) => e(h) - f, r = khe(e));
  function o(h, f, p, v) {
    for (p == null && (p = 0), v == null && (v = h.length); p < v; ) {
      const b = p + v >>> 1;
      r(h[b], f) < 0 ? p = b + 1 : v = b;
    }
    return p;
  }
  function s(h, f, p, v) {
    for (p == null && (p = 0), v == null && (v = h.length); p < v; ) {
      const b = p + v >>> 1;
      r(h[b], f) > 0 ? v = b : p = b + 1;
    }
    return p;
  }
  function u(h, f, p, v) {
    p == null && (p = 0), v == null && (v = h.length);
    const b = o(h, f, p, v - 1);
    return b > p && n(h[b - 1], f) > -n(h[b], f) ? b - 1 : b;
  }
  return { left: o, center: u, right: s };
}
function khe(e) {
  return (n, r) => vd(e(n), r);
}
function aP(e) {
  return e === null ? NaN : +e;
}
function* _he(e, n) {
  if (n === void 0)
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  else {
    let r = -1;
    for (let o of e)
      (o = n(o, ++r, e)) != null && (o = +o) >= o && (yield o);
  }
}
const Ahe = Ly(vd), Che = Ahe.right;
Ly(aP).center;
const bd = Che;
var _w = Math.sqrt(50), Aw = Math.sqrt(10), Cw = Math.sqrt(2);
function xw(e, n, r) {
  var o, s = -1, u, h, f;
  if (n = +n, e = +e, r = +r, e === n && r > 0)
    return [e];
  if ((o = n < e) && (u = e, e = n, n = u), (f = sP(e, n, r)) === 0 || !isFinite(f))
    return [];
  if (f > 0) {
    let p = Math.round(e / f), v = Math.round(n / f);
    for (p * f < e && ++p, v * f > n && --v, h = new Array(u = v - p + 1); ++s < u; )
      h[s] = (p + s) * f;
  } else {
    f = -f;
    let p = Math.round(e * f), v = Math.round(n * f);
    for (p / f < e && ++p, v / f > n && --v, h = new Array(u = v - p + 1); ++s < u; )
      h[s] = (p + s) / f;
  }
  return o && h.reverse(), h;
}
function sP(e, n, r) {
  var o = (n - e) / Math.max(0, r), s = Math.floor(Math.log(o) / Math.LN10), u = o / Math.pow(10, s);
  return s >= 0 ? (u >= _w ? 10 : u >= Aw ? 5 : u >= Cw ? 2 : 1) * Math.pow(10, s) : -Math.pow(10, -s) / (u >= _w ? 10 : u >= Aw ? 5 : u >= Cw ? 2 : 1);
}
function Ew(e, n, r) {
  var o = Math.abs(n - e) / Math.max(0, r), s = Math.pow(10, Math.floor(Math.log(o) / Math.LN10)), u = o / s;
  return u >= _w ? s *= 10 : u >= Aw ? s *= 5 : u >= Cw && (s *= 2), n < e ? -s : s;
}
function _M(e, n) {
  let r;
  if (n === void 0)
    for (const o of e)
      o != null && (r < o || r === void 0 && o >= o) && (r = o);
  else {
    let o = -1;
    for (let s of e)
      (s = n(s, ++o, e)) != null && (r < s || r === void 0 && s >= s) && (r = s);
  }
  return r;
}
function AM(e, n) {
  let r;
  if (n === void 0)
    for (const o of e)
      o != null && (r > o || r === void 0 && o >= o) && (r = o);
  else {
    let o = -1;
    for (let s of e)
      (s = n(s, ++o, e)) != null && (r > s || r === void 0 && s >= s) && (r = s);
  }
  return r;
}
function lP(e, n, r = 0, o = e.length - 1, s = vd) {
  for (; o > r; ) {
    if (o - r > 600) {
      const p = o - r + 1, v = n - r + 1, b = Math.log(p), y = 0.5 * Math.exp(2 * b / 3), k = 0.5 * Math.sqrt(b * y * (p - y) / p) * (v - p / 2 < 0 ? -1 : 1), _ = Math.max(r, Math.floor(n - v * y / p + k)), E = Math.min(o, Math.floor(n + (p - v) * y / p + k));
      lP(e, n, _, E, s);
    }
    const u = e[n];
    let h = r, f = o;
    for (Eu(e, r, n), s(e[o], u) > 0 && Eu(e, r, o); h < f; ) {
      for (Eu(e, h, f), ++h, --f; s(e[h], u) < 0; )
        ++h;
      for (; s(e[f], u) > 0; )
        --f;
    }
    s(e[r], u) === 0 ? Eu(e, r, f) : (++f, Eu(e, f, o)), f <= n && (r = f + 1), n <= f && (o = f - 1);
  }
  return e;
}
function Eu(e, n, r) {
  const o = e[n];
  e[n] = e[r], e[r] = o;
}
function xhe(e, n, r) {
  if (e = Float64Array.from(_he(e, r)), !!(o = e.length)) {
    if ((n = +n) <= 0 || o < 2)
      return AM(e);
    if (n >= 1)
      return _M(e);
    var o, s = (o - 1) * n, u = Math.floor(s), h = _M(lP(e, u).subarray(0, u + 1)), f = AM(e.subarray(u + 1));
    return h + (f - h) * (s - u);
  }
}
function Ehe(e, n, r = aP) {
  if (!!(o = e.length)) {
    if ((n = +n) <= 0 || o < 2)
      return +r(e[0], 0, e);
    if (n >= 1)
      return +r(e[o - 1], o - 1, e);
    var o, s = (o - 1) * n, u = Math.floor(s), h = +r(e[u], u, e), f = +r(e[u + 1], u + 1, e);
    return h + (f - h) * (s - u);
  }
}
function She(e, n, r) {
  e = +e, n = +n, r = (s = arguments.length) < 2 ? (n = e, e = 0, 1) : s < 3 ? 1 : +r;
  for (var o = -1, s = Math.max(0, Math.ceil((n - e) / r)) | 0, u = new Array(s); ++o < s; )
    u[o] = e + o * r;
  return u;
}
function mi(e, n) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(n).domain(e);
      break;
  }
  return this;
}
function ta(e, n) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof n == "function" ? this.interpolator(n) : this.range(n);
      break;
    }
  }
  return this;
}
const Sw = Symbol("implicit");
function jy() {
  var e = /* @__PURE__ */ new Map(), n = [], r = [], o = Sw;
  function s(u) {
    var h = u + "", f = e.get(h);
    if (!f) {
      if (o !== Sw)
        return o;
      e.set(h, f = n.push(u));
    }
    return r[(f - 1) % r.length];
  }
  return s.domain = function(u) {
    if (!arguments.length)
      return n.slice();
    n = [], e = /* @__PURE__ */ new Map();
    for (const h of u) {
      const f = h + "";
      e.has(f) || e.set(f, n.push(h));
    }
    return s;
  }, s.range = function(u) {
    return arguments.length ? (r = Array.from(u), s) : r.slice();
  }, s.unknown = function(u) {
    return arguments.length ? (o = u, s) : o;
  }, s.copy = function() {
    return jy(n, r).unknown(o);
  }, mi.apply(s, arguments), s;
}
function Qu() {
  var e = jy().unknown(void 0), n = e.domain, r = e.range, o = 0, s = 1, u, h, f = !1, p = 0, v = 0, b = 0.5;
  delete e.unknown;
  function y() {
    var k = n().length, _ = s < o, E = _ ? s : o, x = _ ? o : s;
    u = (x - E) / Math.max(1, k - p + v * 2), f && (u = Math.floor(u)), E += (x - E - u * (k - p)) * b, h = u * (1 - p), f && (E = Math.round(E), h = Math.round(h));
    var D = She(k).map(function(I) {
      return E + u * I;
    });
    return r(_ ? D.reverse() : D);
  }
  return e.domain = function(k) {
    return arguments.length ? (n(k), y()) : n();
  }, e.range = function(k) {
    return arguments.length ? ([o, s] = k, o = +o, s = +s, y()) : [o, s];
  }, e.rangeRound = function(k) {
    return [o, s] = k, o = +o, s = +s, f = !0, y();
  }, e.bandwidth = function() {
    return h;
  }, e.step = function() {
    return u;
  }, e.round = function(k) {
    return arguments.length ? (f = !!k, y()) : f;
  }, e.padding = function(k) {
    return arguments.length ? (p = Math.min(1, v = +k), y()) : p;
  }, e.paddingInner = function(k) {
    return arguments.length ? (p = Math.min(1, k), y()) : p;
  }, e.paddingOuter = function(k) {
    return arguments.length ? (v = +k, y()) : v;
  }, e.align = function(k) {
    return arguments.length ? (b = Math.max(0, Math.min(1, k)), y()) : b;
  }, e.copy = function() {
    return Qu(n(), [o, s]).round(f).paddingInner(p).paddingOuter(v).align(b);
  }, mi.apply(y(), arguments);
}
function cP(e) {
  var n = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return cP(n());
  }, e;
}
function Fu() {
  return cP(Qu.apply(null, arguments).paddingInner(1));
}
function By(e, n, r) {
  e.prototype = n.prototype = r, r.constructor = e;
}
function uP(e, n) {
  var r = Object.create(e.prototype);
  for (var o in n)
    r[o] = n[o];
  return r;
}
function wd() {
}
var Zu = 0.7, vp = 1 / Zu, Fl = "\\s*([+-]?\\d+)\\s*", Xu = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", fo = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Mhe = /^#([0-9a-f]{3,8})$/, The = new RegExp("^rgb\\(" + [Fl, Fl, Fl] + "\\)$"), Dhe = new RegExp("^rgb\\(" + [fo, fo, fo] + "\\)$"), Ihe = new RegExp("^rgba\\(" + [Fl, Fl, Fl, Xu] + "\\)$"), Phe = new RegExp("^rgba\\(" + [fo, fo, fo, Xu] + "\\)$"), Ohe = new RegExp("^hsl\\(" + [Xu, fo, fo] + "\\)$"), Rhe = new RegExp("^hsla\\(" + [Xu, fo, fo, Xu] + "\\)$"), CM = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
By(wd, Ju, {
  copy: function(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: xM,
  formatHex: xM,
  formatHsl: Nhe,
  formatRgb: EM,
  toString: EM
});
function xM() {
  return this.rgb().formatHex();
}
function Nhe() {
  return dP(this).formatHsl();
}
function EM() {
  return this.rgb().formatRgb();
}
function Ju(e) {
  var n, r;
  return e = (e + "").trim().toLowerCase(), (n = Mhe.exec(e)) ? (r = n[1].length, n = parseInt(n[1], 16), r === 6 ? SM(n) : r === 3 ? new Fr(n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, (n & 15) << 4 | n & 15, 1) : r === 8 ? Jh(n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, (n & 255) / 255) : r === 4 ? Jh(n >> 12 & 15 | n >> 8 & 240, n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, ((n & 15) << 4 | n & 15) / 255) : null) : (n = The.exec(e)) ? new Fr(n[1], n[2], n[3], 1) : (n = Dhe.exec(e)) ? new Fr(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, 1) : (n = Ihe.exec(e)) ? Jh(n[1], n[2], n[3], n[4]) : (n = Phe.exec(e)) ? Jh(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, n[4]) : (n = Ohe.exec(e)) ? DM(n[1], n[2] / 100, n[3] / 100, 1) : (n = Rhe.exec(e)) ? DM(n[1], n[2] / 100, n[3] / 100, n[4]) : CM.hasOwnProperty(e) ? SM(CM[e]) : e === "transparent" ? new Fr(NaN, NaN, NaN, 0) : null;
}
function SM(e) {
  return new Fr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Jh(e, n, r, o) {
  return o <= 0 && (e = n = r = NaN), new Fr(e, n, r, o);
}
function $he(e) {
  return e instanceof wd || (e = Ju(e)), e ? (e = e.rgb(), new Fr(e.r, e.g, e.b, e.opacity)) : new Fr();
}
function Mw(e, n, r, o) {
  return arguments.length === 1 ? $he(e) : new Fr(e, n, r, o ?? 1);
}
function Fr(e, n, r, o) {
  this.r = +e, this.g = +n, this.b = +r, this.opacity = +o;
}
By(Fr, Mw, uP(wd, {
  brighter: function(e) {
    return e = e == null ? vp : Math.pow(vp, e), new Fr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Zu : Math.pow(Zu, e), new Fr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: MM,
  formatHex: MM,
  formatRgb: TM,
  toString: TM
}));
function MM() {
  return "#" + Zv(this.r) + Zv(this.g) + Zv(this.b);
}
function TM() {
  var e = this.opacity;
  return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
}
function Zv(e) {
  return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
}
function DM(e, n, r, o) {
  return o <= 0 ? e = n = r = NaN : r <= 0 || r >= 1 ? e = n = NaN : n <= 0 && (e = NaN), new co(e, n, r, o);
}
function dP(e) {
  if (e instanceof co)
    return new co(e.h, e.s, e.l, e.opacity);
  if (e instanceof wd || (e = Ju(e)), !e)
    return new co();
  if (e instanceof co)
    return e;
  e = e.rgb();
  var n = e.r / 255, r = e.g / 255, o = e.b / 255, s = Math.min(n, r, o), u = Math.max(n, r, o), h = NaN, f = u - s, p = (u + s) / 2;
  return f ? (n === u ? h = (r - o) / f + (r < o) * 6 : r === u ? h = (o - n) / f + 2 : h = (n - r) / f + 4, f /= p < 0.5 ? u + s : 2 - u - s, h *= 60) : f = p > 0 && p < 1 ? 0 : h, new co(h, f, p, e.opacity);
}
function Lhe(e, n, r, o) {
  return arguments.length === 1 ? dP(e) : new co(e, n, r, o ?? 1);
}
function co(e, n, r, o) {
  this.h = +e, this.s = +n, this.l = +r, this.opacity = +o;
}
By(co, Lhe, uP(wd, {
  brighter: function(e) {
    return e = e == null ? vp : Math.pow(vp, e), new co(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Zu : Math.pow(Zu, e), new co(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, n = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, o = r + (r < 0.5 ? r : 1 - r) * n, s = 2 * r - o;
    return new Fr(
      Xv(e >= 240 ? e - 240 : e + 120, s, o),
      Xv(e, s, o),
      Xv(e < 120 ? e + 240 : e - 120, s, o),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function Xv(e, n, r) {
  return (e < 60 ? n + (r - n) * e / 60 : e < 180 ? r : e < 240 ? n + (r - n) * (240 - e) / 60 : n) * 255;
}
const Fy = (e) => () => e;
function jhe(e, n) {
  return function(r) {
    return e + r * n;
  };
}
function Bhe(e, n, r) {
  return e = Math.pow(e, r), n = Math.pow(n, r) - e, r = 1 / r, function(o) {
    return Math.pow(e + o * n, r);
  };
}
function Fhe(e) {
  return (e = +e) == 1 ? hP : function(n, r) {
    return r - n ? Bhe(n, r, e) : Fy(isNaN(n) ? r : n);
  };
}
function hP(e, n) {
  var r = n - e;
  return r ? jhe(e, r) : Fy(isNaN(e) ? n : e);
}
const IM = function e(n) {
  var r = Fhe(n);
  function o(s, u) {
    var h = r((s = Mw(s)).r, (u = Mw(u)).r), f = r(s.g, u.g), p = r(s.b, u.b), v = hP(s.opacity, u.opacity);
    return function(b) {
      return s.r = h(b), s.g = f(b), s.b = p(b), s.opacity = v(b), s + "";
    };
  }
  return o.gamma = e, o;
}(1);
function zhe(e, n) {
  n || (n = []);
  var r = e ? Math.min(n.length, e.length) : 0, o = n.slice(), s;
  return function(u) {
    for (s = 0; s < r; ++s)
      o[s] = e[s] * (1 - u) + n[s] * u;
    return o;
  };
}
function Vhe(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Hhe(e, n) {
  var r = n ? n.length : 0, o = e ? Math.min(r, e.length) : 0, s = new Array(o), u = new Array(r), h;
  for (h = 0; h < o; ++h)
    s[h] = wc(e[h], n[h]);
  for (; h < r; ++h)
    u[h] = n[h];
  return function(f) {
    for (h = 0; h < o; ++h)
      u[h] = s[h](f);
    return u;
  };
}
function Uhe(e, n) {
  var r = new Date();
  return e = +e, n = +n, function(o) {
    return r.setTime(e * (1 - o) + n * o), r;
  };
}
function bp(e, n) {
  return e = +e, n = +n, function(r) {
    return e * (1 - r) + n * r;
  };
}
function Whe(e, n) {
  var r = {}, o = {}, s;
  (e === null || typeof e != "object") && (e = {}), (n === null || typeof n != "object") && (n = {});
  for (s in n)
    s in e ? r[s] = wc(e[s], n[s]) : o[s] = n[s];
  return function(u) {
    for (s in r)
      o[s] = r[s](u);
    return o;
  };
}
var Tw = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Jv = new RegExp(Tw.source, "g");
function Ghe(e) {
  return function() {
    return e;
  };
}
function qhe(e) {
  return function(n) {
    return e(n) + "";
  };
}
function Khe(e, n) {
  var r = Tw.lastIndex = Jv.lastIndex = 0, o, s, u, h = -1, f = [], p = [];
  for (e = e + "", n = n + ""; (o = Tw.exec(e)) && (s = Jv.exec(n)); )
    (u = s.index) > r && (u = n.slice(r, u), f[h] ? f[h] += u : f[++h] = u), (o = o[0]) === (s = s[0]) ? f[h] ? f[h] += s : f[++h] = s : (f[++h] = null, p.push({ i: h, x: bp(o, s) })), r = Jv.lastIndex;
  return r < n.length && (u = n.slice(r), f[h] ? f[h] += u : f[++h] = u), f.length < 2 ? p[0] ? qhe(p[0].x) : Ghe(n) : (n = p.length, function(v) {
    for (var b = 0, y; b < n; ++b)
      f[(y = p[b]).i] = y.x(v);
    return f.join("");
  });
}
function wc(e, n) {
  var r = typeof n, o;
  return n == null || r === "boolean" ? Fy(n) : (r === "number" ? bp : r === "string" ? (o = Ju(n)) ? (n = o, IM) : Khe : n instanceof Ju ? IM : n instanceof Date ? Uhe : Vhe(n) ? zhe : Array.isArray(n) ? Hhe : typeof n.valueOf != "function" && typeof n.toString != "function" || isNaN(n) ? Whe : bp)(e, n);
}
function zy(e, n) {
  return e = +e, n = +n, function(r) {
    return Math.round(e * (1 - r) + n * r);
  };
}
function Yhe(e, n) {
  n === void 0 && (n = e, e = wc);
  for (var r = 0, o = n.length - 1, s = n[0], u = new Array(o < 0 ? 0 : o); r < o; )
    u[r] = e(s, s = n[++r]);
  return function(h) {
    var f = Math.max(0, Math.min(o - 1, Math.floor(h *= o)));
    return u[f](h - f);
  };
}
function Qhe(e) {
  return function() {
    return e;
  };
}
function wp(e) {
  return +e;
}
var PM = [0, 1];
function wr(e) {
  return e;
}
function Dw(e, n) {
  return (n -= e = +e) ? function(r) {
    return (r - e) / n;
  } : Qhe(isNaN(n) ? NaN : 0.5);
}
function Zhe(e, n) {
  var r;
  return e > n && (r = e, e = n, n = r), function(o) {
    return Math.max(e, Math.min(n, o));
  };
}
function Xhe(e, n, r) {
  var o = e[0], s = e[1], u = n[0], h = n[1];
  return s < o ? (o = Dw(s, o), u = r(h, u)) : (o = Dw(o, s), u = r(u, h)), function(f) {
    return u(o(f));
  };
}
function Jhe(e, n, r) {
  var o = Math.min(e.length, n.length) - 1, s = new Array(o), u = new Array(o), h = -1;
  for (e[o] < e[0] && (e = e.slice().reverse(), n = n.slice().reverse()); ++h < o; )
    s[h] = Dw(e[h], e[h + 1]), u[h] = r(n[h], n[h + 1]);
  return function(f) {
    var p = bd(e, f, 1, o) - 1;
    return u[p](s[p](f));
  };
}
function yd(e, n) {
  return n.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Ug() {
  var e = PM, n = PM, r = wc, o, s, u, h = wr, f, p, v;
  function b() {
    var k = Math.min(e.length, n.length);
    return h !== wr && (h = Zhe(e[0], e[k - 1])), f = k > 2 ? Jhe : Xhe, p = v = null, y;
  }
  function y(k) {
    return k == null || isNaN(k = +k) ? u : (p || (p = f(e.map(o), n, r)))(o(h(k)));
  }
  return y.invert = function(k) {
    return h(s((v || (v = f(n, e.map(o), bp)))(k)));
  }, y.domain = function(k) {
    return arguments.length ? (e = Array.from(k, wp), b()) : e.slice();
  }, y.range = function(k) {
    return arguments.length ? (n = Array.from(k), b()) : n.slice();
  }, y.rangeRound = function(k) {
    return n = Array.from(k), r = zy, b();
  }, y.clamp = function(k) {
    return arguments.length ? (h = k ? !0 : wr, b()) : h !== wr;
  }, y.interpolate = function(k) {
    return arguments.length ? (r = k, b()) : r;
  }, y.unknown = function(k) {
    return arguments.length ? (u = k, y) : u;
  }, function(k, _) {
    return o = k, s = _, b();
  };
}
function Vy() {
  return Ug()(wr, wr);
}
function efe(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function yp(e, n) {
  if ((r = (e = n ? e.toExponential(n - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var r, o = e.slice(0, r);
  return [
    o.length > 1 ? o[0] + o.slice(2) : o,
    +e.slice(r + 1)
  ];
}
function ql(e) {
  return e = yp(Math.abs(e)), e ? e[1] : NaN;
}
function tfe(e, n) {
  return function(r, o) {
    for (var s = r.length, u = [], h = 0, f = e[0], p = 0; s > 0 && f > 0 && (p + f + 1 > o && (f = Math.max(1, o - p)), u.push(r.substring(s -= f, s + f)), !((p += f + 1) > o)); )
      f = e[h = (h + 1) % e.length];
    return u.reverse().join(n);
  };
}
function nfe(e) {
  return function(n) {
    return n.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var rfe = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function kp(e) {
  if (!(n = rfe.exec(e)))
    throw new Error("invalid format: " + e);
  var n;
  return new Hy({
    fill: n[1],
    align: n[2],
    sign: n[3],
    symbol: n[4],
    zero: n[5],
    width: n[6],
    comma: n[7],
    precision: n[8] && n[8].slice(1),
    trim: n[9],
    type: n[10]
  });
}
kp.prototype = Hy.prototype;
function Hy(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Hy.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function ife(e) {
  e:
    for (var n = e.length, r = 1, o = -1, s; r < n; ++r)
      switch (e[r]) {
        case ".":
          o = s = r;
          break;
        case "0":
          o === 0 && (o = r), s = r;
          break;
        default:
          if (!+e[r])
            break e;
          o > 0 && (o = 0);
          break;
      }
  return o > 0 ? e.slice(0, o) + e.slice(s + 1) : e;
}
var fP;
function ofe(e, n) {
  var r = yp(e, n);
  if (!r)
    return e + "";
  var o = r[0], s = r[1], u = s - (fP = Math.max(-8, Math.min(8, Math.floor(s / 3))) * 3) + 1, h = o.length;
  return u === h ? o : u > h ? o + new Array(u - h + 1).join("0") : u > 0 ? o.slice(0, u) + "." + o.slice(u) : "0." + new Array(1 - u).join("0") + yp(e, Math.max(0, n + u - 1))[0];
}
function OM(e, n) {
  var r = yp(e, n);
  if (!r)
    return e + "";
  var o = r[0], s = r[1];
  return s < 0 ? "0." + new Array(-s).join("0") + o : o.length > s + 1 ? o.slice(0, s + 1) + "." + o.slice(s + 1) : o + new Array(s - o.length + 2).join("0");
}
const RM = {
  "%": (e, n) => (e * 100).toFixed(n),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: efe,
  e: (e, n) => e.toExponential(n),
  f: (e, n) => e.toFixed(n),
  g: (e, n) => e.toPrecision(n),
  o: (e) => Math.round(e).toString(8),
  p: (e, n) => OM(e * 100, n),
  r: OM,
  s: ofe,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function NM(e) {
  return e;
}
var $M = Array.prototype.map, LM = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function afe(e) {
  var n = e.grouping === void 0 || e.thousands === void 0 ? NM : tfe($M.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", o = e.currency === void 0 ? "" : e.currency[1] + "", s = e.decimal === void 0 ? "." : e.decimal + "", u = e.numerals === void 0 ? NM : nfe($M.call(e.numerals, String)), h = e.percent === void 0 ? "%" : e.percent + "", f = e.minus === void 0 ? "\u2212" : e.minus + "", p = e.nan === void 0 ? "NaN" : e.nan + "";
  function v(y) {
    y = kp(y);
    var k = y.fill, _ = y.align, E = y.sign, x = y.symbol, D = y.zero, I = y.width, N = y.comma, O = y.precision, P = y.trim, S = y.type;
    S === "n" ? (N = !0, S = "g") : RM[S] || (O === void 0 && (O = 12), P = !0, S = "g"), (D || k === "0" && _ === "=") && (D = !0, k = "0", _ = "=");
    var $ = x === "$" ? r : x === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", L = x === "$" ? o : /[%p]/.test(S) ? h : "", B = RM[S], U = /[defgprs%]/.test(S);
    O = O === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, O)) : Math.max(0, Math.min(20, O));
    function G(q) {
      var Y = $, Q = L, Z, ae, ie;
      if (S === "c")
        Q = B(q) + Q, q = "";
      else {
        q = +q;
        var pe = q < 0 || 1 / q < 0;
        if (q = isNaN(q) ? p : B(Math.abs(q), O), P && (q = ife(q)), pe && +q == 0 && E !== "+" && (pe = !1), Y = (pe ? E === "(" ? E : f : E === "-" || E === "(" ? "" : E) + Y, Q = (S === "s" ? LM[8 + fP / 3] : "") + Q + (pe && E === "(" ? ")" : ""), U) {
          for (Z = -1, ae = q.length; ++Z < ae; )
            if (ie = q.charCodeAt(Z), 48 > ie || ie > 57) {
              Q = (ie === 46 ? s + q.slice(Z + 1) : q.slice(Z)) + Q, q = q.slice(0, Z);
              break;
            }
        }
      }
      N && !D && (q = n(q, 1 / 0));
      var ce = Y.length + q.length + Q.length, ue = ce < I ? new Array(I - ce + 1).join(k) : "";
      switch (N && D && (q = n(ue + q, ue.length ? I - Q.length : 1 / 0), ue = ""), _) {
        case "<":
          q = Y + q + Q + ue;
          break;
        case "=":
          q = Y + ue + q + Q;
          break;
        case "^":
          q = ue.slice(0, ce = ue.length >> 1) + Y + q + Q + ue.slice(ce);
          break;
        default:
          q = ue + Y + q + Q;
          break;
      }
      return u(q);
    }
    return G.toString = function() {
      return y + "";
    }, G;
  }
  function b(y, k) {
    var _ = v((y = kp(y), y.type = "f", y)), E = Math.max(-8, Math.min(8, Math.floor(ql(k) / 3))) * 3, x = Math.pow(10, -E), D = LM[8 + E / 3];
    return function(I) {
      return _(x * I) + D;
    };
  }
  return {
    format: v,
    formatPrefix: b
  };
}
var ef, Uy, pP;
sfe({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function sfe(e) {
  return ef = afe(e), Uy = ef.format, pP = ef.formatPrefix, ef;
}
function lfe(e) {
  return Math.max(0, -ql(Math.abs(e)));
}
function cfe(e, n) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ql(n) / 3))) * 3 - ql(Math.abs(e)));
}
function ufe(e, n) {
  return e = Math.abs(e), n = Math.abs(n) - e, Math.max(0, ql(n) - ql(e)) + 1;
}
function gP(e, n, r, o) {
  var s = Ew(e, n, r), u;
  switch (o = kp(o ?? ",f"), o.type) {
    case "s": {
      var h = Math.max(Math.abs(e), Math.abs(n));
      return o.precision == null && !isNaN(u = cfe(s, h)) && (o.precision = u), pP(o, h);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      o.precision == null && !isNaN(u = ufe(s, Math.max(Math.abs(e), Math.abs(n)))) && (o.precision = u - (o.type === "e"));
      break;
    }
    case "f":
    case "%": {
      o.precision == null && !isNaN(u = lfe(s)) && (o.precision = u - (o.type === "%") * 2);
      break;
    }
  }
  return Uy(o);
}
function ja(e) {
  var n = e.domain;
  return e.ticks = function(r) {
    var o = n();
    return xw(o[0], o[o.length - 1], r ?? 10);
  }, e.tickFormat = function(r, o) {
    var s = n();
    return gP(s[0], s[s.length - 1], r ?? 10, o);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var o = n(), s = 0, u = o.length - 1, h = o[s], f = o[u], p, v, b = 10;
    for (f < h && (v = h, h = f, f = v, v = s, s = u, u = v); b-- > 0; ) {
      if (v = sP(h, f, r), v === p)
        return o[s] = h, o[u] = f, n(o);
      if (v > 0)
        h = Math.floor(h / v) * v, f = Math.ceil(f / v) * v;
      else if (v < 0)
        h = Math.ceil(h * v) / v, f = Math.floor(f * v) / v;
      else
        break;
      p = v;
    }
    return e;
  }, e;
}
function _p() {
  var e = Vy();
  return e.copy = function() {
    return yd(e, _p());
  }, mi.apply(e, arguments), ja(e);
}
function mP(e) {
  var n;
  function r(o) {
    return o == null || isNaN(o = +o) ? n : o;
  }
  return r.invert = r, r.domain = r.range = function(o) {
    return arguments.length ? (e = Array.from(o, wp), r) : e.slice();
  }, r.unknown = function(o) {
    return arguments.length ? (n = o, r) : n;
  }, r.copy = function() {
    return mP(e).unknown(n);
  }, e = arguments.length ? Array.from(e, wp) : [0, 1], ja(r);
}
function vP(e, n) {
  e = e.slice();
  var r = 0, o = e.length - 1, s = e[r], u = e[o], h;
  return u < s && (h = r, r = o, o = h, h = s, s = u, u = h), e[r] = n.floor(s), e[o] = n.ceil(u), e;
}
function jM(e) {
  return Math.log(e);
}
function BM(e) {
  return Math.exp(e);
}
function dfe(e) {
  return -Math.log(-e);
}
function hfe(e) {
  return -Math.exp(-e);
}
function ffe(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function pfe(e) {
  return e === 10 ? ffe : e === Math.E ? Math.exp : function(n) {
    return Math.pow(e, n);
  };
}
function gfe(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), function(n) {
    return Math.log(n) / e;
  });
}
function FM(e) {
  return function(n) {
    return -e(-n);
  };
}
function Wy(e) {
  var n = e(jM, BM), r = n.domain, o = 10, s, u;
  function h() {
    return s = gfe(o), u = pfe(o), r()[0] < 0 ? (s = FM(s), u = FM(u), e(dfe, hfe)) : e(jM, BM), n;
  }
  return n.base = function(f) {
    return arguments.length ? (o = +f, h()) : o;
  }, n.domain = function(f) {
    return arguments.length ? (r(f), h()) : r();
  }, n.ticks = function(f) {
    var p = r(), v = p[0], b = p[p.length - 1], y;
    (y = b < v) && (k = v, v = b, b = k);
    var k = s(v), _ = s(b), E, x, D, I = f == null ? 10 : +f, N = [];
    if (!(o % 1) && _ - k < I) {
      if (k = Math.floor(k), _ = Math.ceil(_), v > 0) {
        for (; k <= _; ++k)
          for (x = 1, E = u(k); x < o; ++x)
            if (D = E * x, !(D < v)) {
              if (D > b)
                break;
              N.push(D);
            }
      } else
        for (; k <= _; ++k)
          for (x = o - 1, E = u(k); x >= 1; --x)
            if (D = E * x, !(D < v)) {
              if (D > b)
                break;
              N.push(D);
            }
      N.length * 2 < I && (N = xw(v, b, I));
    } else
      N = xw(k, _, Math.min(_ - k, I)).map(u);
    return y ? N.reverse() : N;
  }, n.tickFormat = function(f, p) {
    if (p == null && (p = o === 10 ? ".0e" : ","), typeof p != "function" && (p = Uy(p)), f === 1 / 0)
      return p;
    f == null && (f = 10);
    var v = Math.max(1, o * f / n.ticks().length);
    return function(b) {
      var y = b / u(Math.round(s(b)));
      return y * o < o - 0.5 && (y *= o), y <= v ? p(b) : "";
    };
  }, n.nice = function() {
    return r(vP(r(), {
      floor: function(f) {
        return u(Math.floor(s(f)));
      },
      ceil: function(f) {
        return u(Math.ceil(s(f)));
      }
    }));
  }, n;
}
function bP() {
  var e = Wy(Ug()).domain([1, 10]);
  return e.copy = function() {
    return yd(e, bP()).base(e.base());
  }, mi.apply(e, arguments), e;
}
function zM(e) {
  return function(n) {
    return Math.sign(n) * Math.log1p(Math.abs(n / e));
  };
}
function VM(e) {
  return function(n) {
    return Math.sign(n) * Math.expm1(Math.abs(n)) * e;
  };
}
function Gy(e) {
  var n = 1, r = e(zM(n), VM(n));
  return r.constant = function(o) {
    return arguments.length ? e(zM(n = +o), VM(n)) : n;
  }, ja(r);
}
function wP() {
  var e = Gy(Ug());
  return e.copy = function() {
    return yd(e, wP()).constant(e.constant());
  }, mi.apply(e, arguments);
}
function HM(e) {
  return function(n) {
    return n < 0 ? -Math.pow(-n, e) : Math.pow(n, e);
  };
}
function mfe(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function vfe(e) {
  return e < 0 ? -e * e : e * e;
}
function qy(e) {
  var n = e(wr, wr), r = 1;
  function o() {
    return r === 1 ? e(wr, wr) : r === 0.5 ? e(mfe, vfe) : e(HM(r), HM(1 / r));
  }
  return n.exponent = function(s) {
    return arguments.length ? (r = +s, o()) : r;
  }, ja(n);
}
function Ky() {
  var e = qy(Ug());
  return e.copy = function() {
    return yd(e, Ky()).exponent(e.exponent());
  }, mi.apply(e, arguments), e;
}
function bfe() {
  return Ky.apply(null, arguments).exponent(0.5);
}
function UM(e) {
  return Math.sign(e) * e * e;
}
function wfe(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function yP() {
  var e = Vy(), n = [0, 1], r = !1, o;
  function s(u) {
    var h = wfe(e(u));
    return isNaN(h) ? o : r ? Math.round(h) : h;
  }
  return s.invert = function(u) {
    return e.invert(UM(u));
  }, s.domain = function(u) {
    return arguments.length ? (e.domain(u), s) : e.domain();
  }, s.range = function(u) {
    return arguments.length ? (e.range((n = Array.from(u, wp)).map(UM)), s) : n.slice();
  }, s.rangeRound = function(u) {
    return s.range(u).round(!0);
  }, s.round = function(u) {
    return arguments.length ? (r = !!u, s) : r;
  }, s.clamp = function(u) {
    return arguments.length ? (e.clamp(u), s) : e.clamp();
  }, s.unknown = function(u) {
    return arguments.length ? (o = u, s) : o;
  }, s.copy = function() {
    return yP(e.domain(), n).round(r).clamp(e.clamp()).unknown(o);
  }, mi.apply(s, arguments), ja(s);
}
function kP() {
  var e = [], n = [], r = [], o;
  function s() {
    var h = 0, f = Math.max(1, n.length);
    for (r = new Array(f - 1); ++h < f; )
      r[h - 1] = Ehe(e, h / f);
    return u;
  }
  function u(h) {
    return h == null || isNaN(h = +h) ? o : n[bd(r, h)];
  }
  return u.invertExtent = function(h) {
    var f = n.indexOf(h);
    return f < 0 ? [NaN, NaN] : [
      f > 0 ? r[f - 1] : e[0],
      f < r.length ? r[f] : e[e.length - 1]
    ];
  }, u.domain = function(h) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let f of h)
      f != null && !isNaN(f = +f) && e.push(f);
    return e.sort(vd), s();
  }, u.range = function(h) {
    return arguments.length ? (n = Array.from(h), s()) : n.slice();
  }, u.unknown = function(h) {
    return arguments.length ? (o = h, u) : o;
  }, u.quantiles = function() {
    return r.slice();
  }, u.copy = function() {
    return kP().domain(e).range(n).unknown(o);
  }, mi.apply(u, arguments);
}
function _P() {
  var e = 0, n = 1, r = 1, o = [0.5], s = [0, 1], u;
  function h(p) {
    return p != null && p <= p ? s[bd(o, p, 0, r)] : u;
  }
  function f() {
    var p = -1;
    for (o = new Array(r); ++p < r; )
      o[p] = ((p + 1) * n - (p - r) * e) / (r + 1);
    return h;
  }
  return h.domain = function(p) {
    return arguments.length ? ([e, n] = p, e = +e, n = +n, f()) : [e, n];
  }, h.range = function(p) {
    return arguments.length ? (r = (s = Array.from(p)).length - 1, f()) : s.slice();
  }, h.invertExtent = function(p) {
    var v = s.indexOf(p);
    return v < 0 ? [NaN, NaN] : v < 1 ? [e, o[0]] : v >= r ? [o[r - 1], n] : [o[v - 1], o[v]];
  }, h.unknown = function(p) {
    return arguments.length && (u = p), h;
  }, h.thresholds = function() {
    return o.slice();
  }, h.copy = function() {
    return _P().domain([e, n]).range(s).unknown(u);
  }, mi.apply(ja(h), arguments);
}
function AP() {
  var e = [0.5], n = [0, 1], r, o = 1;
  function s(u) {
    return u != null && u <= u ? n[bd(e, u, 0, o)] : r;
  }
  return s.domain = function(u) {
    return arguments.length ? (e = Array.from(u), o = Math.min(e.length, n.length - 1), s) : e.slice();
  }, s.range = function(u) {
    return arguments.length ? (n = Array.from(u), o = Math.min(e.length, n.length - 1), s) : n.slice();
  }, s.invertExtent = function(u) {
    var h = n.indexOf(u);
    return [e[h - 1], e[h]];
  }, s.unknown = function(u) {
    return arguments.length ? (r = u, s) : r;
  }, s.copy = function() {
    return AP().domain(e).range(n).unknown(r);
  }, mi.apply(s, arguments);
}
var eb = new Date(), tb = new Date();
function ir(e, n, r, o) {
  function s(u) {
    return e(u = arguments.length === 0 ? new Date() : new Date(+u)), u;
  }
  return s.floor = function(u) {
    return e(u = new Date(+u)), u;
  }, s.ceil = function(u) {
    return e(u = new Date(u - 1)), n(u, 1), e(u), u;
  }, s.round = function(u) {
    var h = s(u), f = s.ceil(u);
    return u - h < f - u ? h : f;
  }, s.offset = function(u, h) {
    return n(u = new Date(+u), h == null ? 1 : Math.floor(h)), u;
  }, s.range = function(u, h, f) {
    var p = [], v;
    if (u = s.ceil(u), f = f == null ? 1 : Math.floor(f), !(u < h) || !(f > 0))
      return p;
    do
      p.push(v = new Date(+u)), n(u, f), e(u);
    while (v < u && u < h);
    return p;
  }, s.filter = function(u) {
    return ir(function(h) {
      if (h >= h)
        for (; e(h), !u(h); )
          h.setTime(h - 1);
    }, function(h, f) {
      if (h >= h)
        if (f < 0)
          for (; ++f <= 0; )
            for (; n(h, -1), !u(h); )
              ;
        else
          for (; --f >= 0; )
            for (; n(h, 1), !u(h); )
              ;
    });
  }, r && (s.count = function(u, h) {
    return eb.setTime(+u), tb.setTime(+h), e(eb), e(tb), Math.floor(r(eb, tb));
  }, s.every = function(u) {
    return u = Math.floor(u), !isFinite(u) || !(u > 0) ? null : u > 1 ? s.filter(o ? function(h) {
      return o(h) % u === 0;
    } : function(h) {
      return s.count(0, h) % u === 0;
    }) : s;
  }), s;
}
var Ap = ir(function() {
}, function(e, n) {
  e.setTime(+e + n);
}, function(e, n) {
  return n - e;
});
Ap.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? ir(function(n) {
    n.setTime(Math.floor(n / e) * e);
  }, function(n, r) {
    n.setTime(+n + r * e);
  }, function(n, r) {
    return (r - n) / e;
  }) : Ap;
};
const yfe = Ap;
Ap.range;
const zo = 1e3, li = zo * 60, Vo = li * 60, $s = Vo * 24, Yy = $s * 7, WM = $s * 30, nb = $s * 365;
var CP = ir(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, n) {
  e.setTime(+e + n * zo);
}, function(e, n) {
  return (n - e) / zo;
}, function(e) {
  return e.getUTCSeconds();
});
const Ll = CP;
CP.range;
var xP = ir(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * zo);
}, function(e, n) {
  e.setTime(+e + n * li);
}, function(e, n) {
  return (n - e) / li;
}, function(e) {
  return e.getMinutes();
});
const EP = xP;
xP.range;
var SP = ir(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * zo - e.getMinutes() * li);
}, function(e, n) {
  e.setTime(+e + n * Vo);
}, function(e, n) {
  return (n - e) / Vo;
}, function(e) {
  return e.getHours();
});
const MP = SP;
SP.range;
var TP = ir(
  (e) => e.setHours(0, 0, 0, 0),
  (e, n) => e.setDate(e.getDate() + n),
  (e, n) => (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * li) / $s,
  (e) => e.getDate() - 1
);
const Wg = TP;
TP.range;
function Ws(e) {
  return ir(function(n) {
    n.setDate(n.getDate() - (n.getDay() + 7 - e) % 7), n.setHours(0, 0, 0, 0);
  }, function(n, r) {
    n.setDate(n.getDate() + r * 7);
  }, function(n, r) {
    return (r - n - (r.getTimezoneOffset() - n.getTimezoneOffset()) * li) / Yy;
  });
}
var Gg = Ws(0), Cp = Ws(1), kfe = Ws(2), _fe = Ws(3), Kl = Ws(4), Afe = Ws(5), Cfe = Ws(6);
Gg.range;
Cp.range;
kfe.range;
_fe.range;
Kl.range;
Afe.range;
Cfe.range;
var DP = ir(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, n) {
  e.setMonth(e.getMonth() + n);
}, function(e, n) {
  return n.getMonth() - e.getMonth() + (n.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const IP = DP;
DP.range;
var Qy = ir(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, n) {
  e.setFullYear(e.getFullYear() + n);
}, function(e, n) {
  return n.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
Qy.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ir(function(n) {
    n.setFullYear(Math.floor(n.getFullYear() / e) * e), n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
  }, function(n, r) {
    n.setFullYear(n.getFullYear() + r * e);
  });
};
const Ls = Qy;
Qy.range;
var PP = ir(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, n) {
  e.setTime(+e + n * li);
}, function(e, n) {
  return (n - e) / li;
}, function(e) {
  return e.getUTCMinutes();
});
const OP = PP;
PP.range;
var RP = ir(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, n) {
  e.setTime(+e + n * Vo);
}, function(e, n) {
  return (n - e) / Vo;
}, function(e) {
  return e.getUTCHours();
});
const NP = RP;
RP.range;
var $P = ir(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, n) {
  e.setUTCDate(e.getUTCDate() + n);
}, function(e, n) {
  return (n - e) / $s;
}, function(e) {
  return e.getUTCDate() - 1;
});
const qg = $P;
$P.range;
function Gs(e) {
  return ir(function(n) {
    n.setUTCDate(n.getUTCDate() - (n.getUTCDay() + 7 - e) % 7), n.setUTCHours(0, 0, 0, 0);
  }, function(n, r) {
    n.setUTCDate(n.getUTCDate() + r * 7);
  }, function(n, r) {
    return (r - n) / Yy;
  });
}
var Kg = Gs(0), xp = Gs(1), xfe = Gs(2), Efe = Gs(3), Yl = Gs(4), Sfe = Gs(5), Mfe = Gs(6);
Kg.range;
xp.range;
xfe.range;
Efe.range;
Yl.range;
Sfe.range;
Mfe.range;
var LP = ir(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, n) {
  e.setUTCMonth(e.getUTCMonth() + n);
}, function(e, n) {
  return n.getUTCMonth() - e.getUTCMonth() + (n.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
const jP = LP;
LP.range;
var Zy = ir(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, n) {
  e.setUTCFullYear(e.getUTCFullYear() + n);
}, function(e, n) {
  return n.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
Zy.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ir(function(n) {
    n.setUTCFullYear(Math.floor(n.getUTCFullYear() / e) * e), n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  }, function(n, r) {
    n.setUTCFullYear(n.getUTCFullYear() + r * e);
  });
};
const js = Zy;
Zy.range;
function BP(e, n, r, o, s, u) {
  const h = [
    [Ll, 1, zo],
    [Ll, 5, 5 * zo],
    [Ll, 15, 15 * zo],
    [Ll, 30, 30 * zo],
    [u, 1, li],
    [u, 5, 5 * li],
    [u, 15, 15 * li],
    [u, 30, 30 * li],
    [s, 1, Vo],
    [s, 3, 3 * Vo],
    [s, 6, 6 * Vo],
    [s, 12, 12 * Vo],
    [o, 1, $s],
    [o, 2, 2 * $s],
    [r, 1, Yy],
    [n, 1, WM],
    [n, 3, 3 * WM],
    [e, 1, nb]
  ];
  function f(v, b, y) {
    const k = b < v;
    k && ([v, b] = [b, v]);
    const _ = y && typeof y.range == "function" ? y : p(v, b, y), E = _ ? _.range(v, +b + 1) : [];
    return k ? E.reverse() : E;
  }
  function p(v, b, y) {
    const k = Math.abs(b - v) / y, _ = Ly(([, , D]) => D).right(h, k);
    if (_ === h.length)
      return e.every(Ew(v / nb, b / nb, y));
    if (_ === 0)
      return yfe.every(Math.max(Ew(v, b, y), 1));
    const [E, x] = h[k / h[_ - 1][2] < h[_][2] / k ? _ - 1 : _];
    return E.every(x);
  }
  return [f, p];
}
const [Tfe, Dfe] = BP(js, jP, Kg, qg, NP, OP), [Ife, Pfe] = BP(Ls, IP, Gg, Wg, MP, EP);
function rb(e) {
  if (0 <= e.y && e.y < 100) {
    var n = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return n.setFullYear(e.y), n;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function ib(e) {
  if (0 <= e.y && e.y < 100) {
    var n = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return n.setUTCFullYear(e.y), n;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Su(e, n, r) {
  return { y: e, m: n, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function Ofe(e) {
  var n = e.dateTime, r = e.date, o = e.time, s = e.periods, u = e.days, h = e.shortDays, f = e.months, p = e.shortMonths, v = Mu(s), b = Tu(s), y = Mu(u), k = Tu(u), _ = Mu(h), E = Tu(h), x = Mu(f), D = Tu(f), I = Mu(p), N = Tu(p), O = {
    a: pe,
    A: ce,
    b: ue,
    B: X,
    c: null,
    d: ZM,
    e: ZM,
    f: npe,
    g: hpe,
    G: ppe,
    H: Jfe,
    I: epe,
    j: tpe,
    L: FP,
    m: rpe,
    M: ipe,
    p: se,
    q: he,
    Q: eT,
    s: tT,
    S: ope,
    u: ape,
    U: spe,
    V: lpe,
    w: cpe,
    W: upe,
    x: null,
    X: null,
    y: dpe,
    Y: fpe,
    Z: gpe,
    "%": JM
  }, P = {
    a: de,
    A: me,
    b: we,
    B: Ae,
    c: null,
    d: XM,
    e: XM,
    f: wpe,
    g: Tpe,
    G: Ipe,
    H: mpe,
    I: vpe,
    j: bpe,
    L: VP,
    m: ype,
    M: kpe,
    p: Se,
    q: ke,
    Q: eT,
    s: tT,
    S: _pe,
    u: Ape,
    U: Cpe,
    V: xpe,
    w: Epe,
    W: Spe,
    x: null,
    X: null,
    y: Mpe,
    Y: Dpe,
    Z: Ppe,
    "%": JM
  }, S = {
    a: G,
    A: q,
    b: Y,
    B: Q,
    c: Z,
    d: YM,
    e: YM,
    f: Yfe,
    g: KM,
    G: qM,
    H: QM,
    I: QM,
    j: Wfe,
    L: Kfe,
    m: Ufe,
    M: Gfe,
    p: U,
    q: Hfe,
    Q: Zfe,
    s: Xfe,
    S: qfe,
    u: jfe,
    U: Bfe,
    V: Ffe,
    w: Lfe,
    W: zfe,
    x: ae,
    X: ie,
    y: KM,
    Y: qM,
    Z: Vfe,
    "%": Qfe
  };
  O.x = $(r, O), O.X = $(o, O), O.c = $(n, O), P.x = $(r, P), P.X = $(o, P), P.c = $(n, P);
  function $(ge, xe) {
    return function(Te) {
      var J = [], Ge = -1, De = 0, He = ge.length, at, qt, An;
      for (Te instanceof Date || (Te = new Date(+Te)); ++Ge < He; )
        ge.charCodeAt(Ge) === 37 && (J.push(ge.slice(De, Ge)), (qt = GM[at = ge.charAt(++Ge)]) != null ? at = ge.charAt(++Ge) : qt = at === "e" ? " " : "0", (An = xe[at]) && (at = An(Te, qt)), J.push(at), De = Ge + 1);
      return J.push(ge.slice(De, Ge)), J.join("");
    };
  }
  function L(ge, xe) {
    return function(Te) {
      var J = Su(1900, void 0, 1), Ge = B(J, ge, Te += "", 0), De, He;
      if (Ge != Te.length)
        return null;
      if ("Q" in J)
        return new Date(J.Q);
      if ("s" in J)
        return new Date(J.s * 1e3 + ("L" in J ? J.L : 0));
      if (xe && !("Z" in J) && (J.Z = 0), "p" in J && (J.H = J.H % 12 + J.p * 12), J.m === void 0 && (J.m = "q" in J ? J.q : 0), "V" in J) {
        if (J.V < 1 || J.V > 53)
          return null;
        "w" in J || (J.w = 1), "Z" in J ? (De = ib(Su(J.y, 0, 1)), He = De.getUTCDay(), De = He > 4 || He === 0 ? xp.ceil(De) : xp(De), De = qg.offset(De, (J.V - 1) * 7), J.y = De.getUTCFullYear(), J.m = De.getUTCMonth(), J.d = De.getUTCDate() + (J.w + 6) % 7) : (De = rb(Su(J.y, 0, 1)), He = De.getDay(), De = He > 4 || He === 0 ? Cp.ceil(De) : Cp(De), De = Wg.offset(De, (J.V - 1) * 7), J.y = De.getFullYear(), J.m = De.getMonth(), J.d = De.getDate() + (J.w + 6) % 7);
      } else
        ("W" in J || "U" in J) && ("w" in J || (J.w = "u" in J ? J.u % 7 : "W" in J ? 1 : 0), He = "Z" in J ? ib(Su(J.y, 0, 1)).getUTCDay() : rb(Su(J.y, 0, 1)).getDay(), J.m = 0, J.d = "W" in J ? (J.w + 6) % 7 + J.W * 7 - (He + 5) % 7 : J.w + J.U * 7 - (He + 6) % 7);
      return "Z" in J ? (J.H += J.Z / 100 | 0, J.M += J.Z % 100, ib(J)) : rb(J);
    };
  }
  function B(ge, xe, Te, J) {
    for (var Ge = 0, De = xe.length, He = Te.length, at, qt; Ge < De; ) {
      if (J >= He)
        return -1;
      if (at = xe.charCodeAt(Ge++), at === 37) {
        if (at = xe.charAt(Ge++), qt = S[at in GM ? xe.charAt(Ge++) : at], !qt || (J = qt(ge, Te, J)) < 0)
          return -1;
      } else if (at != Te.charCodeAt(J++))
        return -1;
    }
    return J;
  }
  function U(ge, xe, Te) {
    var J = v.exec(xe.slice(Te));
    return J ? (ge.p = b.get(J[0].toLowerCase()), Te + J[0].length) : -1;
  }
  function G(ge, xe, Te) {
    var J = _.exec(xe.slice(Te));
    return J ? (ge.w = E.get(J[0].toLowerCase()), Te + J[0].length) : -1;
  }
  function q(ge, xe, Te) {
    var J = y.exec(xe.slice(Te));
    return J ? (ge.w = k.get(J[0].toLowerCase()), Te + J[0].length) : -1;
  }
  function Y(ge, xe, Te) {
    var J = I.exec(xe.slice(Te));
    return J ? (ge.m = N.get(J[0].toLowerCase()), Te + J[0].length) : -1;
  }
  function Q(ge, xe, Te) {
    var J = x.exec(xe.slice(Te));
    return J ? (ge.m = D.get(J[0].toLowerCase()), Te + J[0].length) : -1;
  }
  function Z(ge, xe, Te) {
    return B(ge, n, xe, Te);
  }
  function ae(ge, xe, Te) {
    return B(ge, r, xe, Te);
  }
  function ie(ge, xe, Te) {
    return B(ge, o, xe, Te);
  }
  function pe(ge) {
    return h[ge.getDay()];
  }
  function ce(ge) {
    return u[ge.getDay()];
  }
  function ue(ge) {
    return p[ge.getMonth()];
  }
  function X(ge) {
    return f[ge.getMonth()];
  }
  function se(ge) {
    return s[+(ge.getHours() >= 12)];
  }
  function he(ge) {
    return 1 + ~~(ge.getMonth() / 3);
  }
  function de(ge) {
    return h[ge.getUTCDay()];
  }
  function me(ge) {
    return u[ge.getUTCDay()];
  }
  function we(ge) {
    return p[ge.getUTCMonth()];
  }
  function Ae(ge) {
    return f[ge.getUTCMonth()];
  }
  function Se(ge) {
    return s[+(ge.getUTCHours() >= 12)];
  }
  function ke(ge) {
    return 1 + ~~(ge.getUTCMonth() / 3);
  }
  return {
    format: function(ge) {
      var xe = $(ge += "", O);
      return xe.toString = function() {
        return ge;
      }, xe;
    },
    parse: function(ge) {
      var xe = L(ge += "", !1);
      return xe.toString = function() {
        return ge;
      }, xe;
    },
    utcFormat: function(ge) {
      var xe = $(ge += "", P);
      return xe.toString = function() {
        return ge;
      }, xe;
    },
    utcParse: function(ge) {
      var xe = L(ge += "", !0);
      return xe.toString = function() {
        return ge;
      }, xe;
    }
  };
}
var GM = { "-": "", _: " ", 0: "0" }, or = /^\s*\d+/, Rfe = /^%/, Nfe = /[\\^$*+?|[\]().{}]/g;
function $t(e, n, r) {
  var o = e < 0 ? "-" : "", s = (o ? -e : e) + "", u = s.length;
  return o + (u < r ? new Array(r - u + 1).join(n) + s : s);
}
function $fe(e) {
  return e.replace(Nfe, "\\$&");
}
function Mu(e) {
  return new RegExp("^(?:" + e.map($fe).join("|") + ")", "i");
}
function Tu(e) {
  return new Map(e.map((n, r) => [n.toLowerCase(), r]));
}
function Lfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 1));
  return o ? (e.w = +o[0], r + o[0].length) : -1;
}
function jfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 1));
  return o ? (e.u = +o[0], r + o[0].length) : -1;
}
function Bfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.U = +o[0], r + o[0].length) : -1;
}
function Ffe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.V = +o[0], r + o[0].length) : -1;
}
function zfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.W = +o[0], r + o[0].length) : -1;
}
function qM(e, n, r) {
  var o = or.exec(n.slice(r, r + 4));
  return o ? (e.y = +o[0], r + o[0].length) : -1;
}
function KM(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.y = +o[0] + (+o[0] > 68 ? 1900 : 2e3), r + o[0].length) : -1;
}
function Vfe(e, n, r) {
  var o = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(r, r + 6));
  return o ? (e.Z = o[1] ? 0 : -(o[2] + (o[3] || "00")), r + o[0].length) : -1;
}
function Hfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 1));
  return o ? (e.q = o[0] * 3 - 3, r + o[0].length) : -1;
}
function Ufe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.m = o[0] - 1, r + o[0].length) : -1;
}
function YM(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.d = +o[0], r + o[0].length) : -1;
}
function Wfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 3));
  return o ? (e.m = 0, e.d = +o[0], r + o[0].length) : -1;
}
function QM(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.H = +o[0], r + o[0].length) : -1;
}
function Gfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.M = +o[0], r + o[0].length) : -1;
}
function qfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 2));
  return o ? (e.S = +o[0], r + o[0].length) : -1;
}
function Kfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 3));
  return o ? (e.L = +o[0], r + o[0].length) : -1;
}
function Yfe(e, n, r) {
  var o = or.exec(n.slice(r, r + 6));
  return o ? (e.L = Math.floor(o[0] / 1e3), r + o[0].length) : -1;
}
function Qfe(e, n, r) {
  var o = Rfe.exec(n.slice(r, r + 1));
  return o ? r + o[0].length : -1;
}
function Zfe(e, n, r) {
  var o = or.exec(n.slice(r));
  return o ? (e.Q = +o[0], r + o[0].length) : -1;
}
function Xfe(e, n, r) {
  var o = or.exec(n.slice(r));
  return o ? (e.s = +o[0], r + o[0].length) : -1;
}
function ZM(e, n) {
  return $t(e.getDate(), n, 2);
}
function Jfe(e, n) {
  return $t(e.getHours(), n, 2);
}
function epe(e, n) {
  return $t(e.getHours() % 12 || 12, n, 2);
}
function tpe(e, n) {
  return $t(1 + Wg.count(Ls(e), e), n, 3);
}
function FP(e, n) {
  return $t(e.getMilliseconds(), n, 3);
}
function npe(e, n) {
  return FP(e, n) + "000";
}
function rpe(e, n) {
  return $t(e.getMonth() + 1, n, 2);
}
function ipe(e, n) {
  return $t(e.getMinutes(), n, 2);
}
function ope(e, n) {
  return $t(e.getSeconds(), n, 2);
}
function ape(e) {
  var n = e.getDay();
  return n === 0 ? 7 : n;
}
function spe(e, n) {
  return $t(Gg.count(Ls(e) - 1, e), n, 2);
}
function zP(e) {
  var n = e.getDay();
  return n >= 4 || n === 0 ? Kl(e) : Kl.ceil(e);
}
function lpe(e, n) {
  return e = zP(e), $t(Kl.count(Ls(e), e) + (Ls(e).getDay() === 4), n, 2);
}
function cpe(e) {
  return e.getDay();
}
function upe(e, n) {
  return $t(Cp.count(Ls(e) - 1, e), n, 2);
}
function dpe(e, n) {
  return $t(e.getFullYear() % 100, n, 2);
}
function hpe(e, n) {
  return e = zP(e), $t(e.getFullYear() % 100, n, 2);
}
function fpe(e, n) {
  return $t(e.getFullYear() % 1e4, n, 4);
}
function ppe(e, n) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? Kl(e) : Kl.ceil(e), $t(e.getFullYear() % 1e4, n, 4);
}
function gpe(e) {
  var n = e.getTimezoneOffset();
  return (n > 0 ? "-" : (n *= -1, "+")) + $t(n / 60 | 0, "0", 2) + $t(n % 60, "0", 2);
}
function XM(e, n) {
  return $t(e.getUTCDate(), n, 2);
}
function mpe(e, n) {
  return $t(e.getUTCHours(), n, 2);
}
function vpe(e, n) {
  return $t(e.getUTCHours() % 12 || 12, n, 2);
}
function bpe(e, n) {
  return $t(1 + qg.count(js(e), e), n, 3);
}
function VP(e, n) {
  return $t(e.getUTCMilliseconds(), n, 3);
}
function wpe(e, n) {
  return VP(e, n) + "000";
}
function ype(e, n) {
  return $t(e.getUTCMonth() + 1, n, 2);
}
function kpe(e, n) {
  return $t(e.getUTCMinutes(), n, 2);
}
function _pe(e, n) {
  return $t(e.getUTCSeconds(), n, 2);
}
function Ape(e) {
  var n = e.getUTCDay();
  return n === 0 ? 7 : n;
}
function Cpe(e, n) {
  return $t(Kg.count(js(e) - 1, e), n, 2);
}
function HP(e) {
  var n = e.getUTCDay();
  return n >= 4 || n === 0 ? Yl(e) : Yl.ceil(e);
}
function xpe(e, n) {
  return e = HP(e), $t(Yl.count(js(e), e) + (js(e).getUTCDay() === 4), n, 2);
}
function Epe(e) {
  return e.getUTCDay();
}
function Spe(e, n) {
  return $t(xp.count(js(e) - 1, e), n, 2);
}
function Mpe(e, n) {
  return $t(e.getUTCFullYear() % 100, n, 2);
}
function Tpe(e, n) {
  return e = HP(e), $t(e.getUTCFullYear() % 100, n, 2);
}
function Dpe(e, n) {
  return $t(e.getUTCFullYear() % 1e4, n, 4);
}
function Ipe(e, n) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? Yl(e) : Yl.ceil(e), $t(e.getUTCFullYear() % 1e4, n, 4);
}
function Ppe() {
  return "+0000";
}
function JM() {
  return "%";
}
function eT(e) {
  return +e;
}
function tT(e) {
  return Math.floor(+e / 1e3);
}
var Nl, UP, WP;
Ope({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Ope(e) {
  return Nl = Ofe(e), UP = Nl.format, Nl.parse, WP = Nl.utcFormat, Nl.utcParse, Nl;
}
function Rpe(e) {
  return new Date(e);
}
function Npe(e) {
  return e instanceof Date ? +e : +new Date(+e);
}
function Xy(e, n, r, o, s, u, h, f, p, v) {
  var b = Vy(), y = b.invert, k = b.domain, _ = v(".%L"), E = v(":%S"), x = v("%I:%M"), D = v("%I %p"), I = v("%a %d"), N = v("%b %d"), O = v("%B"), P = v("%Y");
  function S($) {
    return (p($) < $ ? _ : f($) < $ ? E : h($) < $ ? x : u($) < $ ? D : o($) < $ ? s($) < $ ? I : N : r($) < $ ? O : P)($);
  }
  return b.invert = function($) {
    return new Date(y($));
  }, b.domain = function($) {
    return arguments.length ? k(Array.from($, Npe)) : k().map(Rpe);
  }, b.ticks = function($) {
    var L = k();
    return e(L[0], L[L.length - 1], $ ?? 10);
  }, b.tickFormat = function($, L) {
    return L == null ? S : v(L);
  }, b.nice = function($) {
    var L = k();
    return (!$ || typeof $.range != "function") && ($ = n(L[0], L[L.length - 1], $ ?? 10)), $ ? k(vP(L, $)) : b;
  }, b.copy = function() {
    return yd(b, Xy(e, n, r, o, s, u, h, f, p, v));
  }, b;
}
function $pe() {
  return mi.apply(Xy(Ife, Pfe, Ls, IP, Gg, Wg, MP, EP, Ll, UP).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Lpe() {
  return mi.apply(Xy(Tfe, Dfe, js, jP, Kg, qg, NP, OP, Ll, WP).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Yg() {
  var e = 0, n = 1, r, o, s, u, h = wr, f = !1, p;
  function v(y) {
    return y == null || isNaN(y = +y) ? p : h(s === 0 ? 0.5 : (y = (u(y) - r) * s, f ? Math.max(0, Math.min(1, y)) : y));
  }
  v.domain = function(y) {
    return arguments.length ? ([e, n] = y, r = u(e = +e), o = u(n = +n), s = r === o ? 0 : 1 / (o - r), v) : [e, n];
  }, v.clamp = function(y) {
    return arguments.length ? (f = !!y, v) : f;
  }, v.interpolator = function(y) {
    return arguments.length ? (h = y, v) : h;
  };
  function b(y) {
    return function(k) {
      var _, E;
      return arguments.length ? ([_, E] = k, h = y(_, E), v) : [h(0), h(1)];
    };
  }
  return v.range = b(wc), v.rangeRound = b(zy), v.unknown = function(y) {
    return arguments.length ? (p = y, v) : p;
  }, function(y) {
    return u = y, r = y(e), o = y(n), s = r === o ? 0 : 1 / (o - r), v;
  };
}
function Ba(e, n) {
  return n.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function GP() {
  var e = ja(Yg()(wr));
  return e.copy = function() {
    return Ba(e, GP());
  }, ta.apply(e, arguments);
}
function qP() {
  var e = Wy(Yg()).domain([1, 10]);
  return e.copy = function() {
    return Ba(e, qP()).base(e.base());
  }, ta.apply(e, arguments);
}
function KP() {
  var e = Gy(Yg());
  return e.copy = function() {
    return Ba(e, KP()).constant(e.constant());
  }, ta.apply(e, arguments);
}
function Jy() {
  var e = qy(Yg());
  return e.copy = function() {
    return Ba(e, Jy()).exponent(e.exponent());
  }, ta.apply(e, arguments);
}
function jpe() {
  return Jy.apply(null, arguments).exponent(0.5);
}
function YP() {
  var e = [], n = wr;
  function r(o) {
    if (o != null && !isNaN(o = +o))
      return n((bd(e, o, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of o)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(vd), r;
  }, r.interpolator = function(o) {
    return arguments.length ? (n = o, r) : n;
  }, r.range = function() {
    return e.map((o, s) => n(s / (e.length - 1)));
  }, r.quantiles = function(o) {
    return Array.from({ length: o + 1 }, (s, u) => xhe(e, u / o));
  }, r.copy = function() {
    return YP(n).domain(e);
  }, ta.apply(r, arguments);
}
function Qg() {
  var e = 0, n = 0.5, r = 1, o = 1, s, u, h, f, p, v = wr, b, y = !1, k;
  function _(x) {
    return isNaN(x = +x) ? k : (x = 0.5 + ((x = +b(x)) - u) * (o * x < o * u ? f : p), v(y ? Math.max(0, Math.min(1, x)) : x));
  }
  _.domain = function(x) {
    return arguments.length ? ([e, n, r] = x, s = b(e = +e), u = b(n = +n), h = b(r = +r), f = s === u ? 0 : 0.5 / (u - s), p = u === h ? 0 : 0.5 / (h - u), o = u < s ? -1 : 1, _) : [e, n, r];
  }, _.clamp = function(x) {
    return arguments.length ? (y = !!x, _) : y;
  }, _.interpolator = function(x) {
    return arguments.length ? (v = x, _) : v;
  };
  function E(x) {
    return function(D) {
      var I, N, O;
      return arguments.length ? ([I, N, O] = D, v = Yhe(x, [I, N, O]), _) : [v(0), v(0.5), v(1)];
    };
  }
  return _.range = E(wc), _.rangeRound = E(zy), _.unknown = function(x) {
    return arguments.length ? (k = x, _) : k;
  }, function(x) {
    return b = x, s = x(e), u = x(n), h = x(r), f = s === u ? 0 : 0.5 / (u - s), p = u === h ? 0 : 0.5 / (h - u), o = u < s ? -1 : 1, _;
  };
}
function QP() {
  var e = ja(Qg()(wr));
  return e.copy = function() {
    return Ba(e, QP());
  }, ta.apply(e, arguments);
}
function ZP() {
  var e = Wy(Qg()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Ba(e, ZP()).base(e.base());
  }, ta.apply(e, arguments);
}
function XP() {
  var e = Gy(Qg());
  return e.copy = function() {
    return Ba(e, XP()).constant(e.constant());
  }, ta.apply(e, arguments);
}
function ek() {
  var e = qy(Qg());
  return e.copy = function() {
    return Ba(e, ek()).exponent(e.exponent());
  }, ta.apply(e, arguments);
}
function Bpe() {
  return ek.apply(null, arguments).exponent(0.5);
}
const nT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Qu,
  scalePoint: Fu,
  scaleIdentity: mP,
  scaleLinear: _p,
  scaleLog: bP,
  scaleSymlog: wP,
  scaleOrdinal: jy,
  scaleImplicit: Sw,
  scalePow: Ky,
  scaleSqrt: bfe,
  scaleRadial: yP,
  scaleQuantile: kP,
  scaleQuantize: _P,
  scaleThreshold: AP,
  scaleTime: $pe,
  scaleUtc: Lpe,
  scaleSequential: GP,
  scaleSequentialLog: qP,
  scaleSequentialPow: Jy,
  scaleSequentialSqrt: jpe,
  scaleSequentialSymlog: KP,
  scaleSequentialQuantile: YP,
  scaleDiverging: QP,
  scaleDivergingLog: ZP,
  scaleDivergingPow: ek,
  scaleDivergingSqrt: Bpe,
  scaleDivergingSymlog: XP,
  tickFormat: gP
}, Symbol.toStringTag, { value: "Module" }));
function rT(e) {
  return Hpe(e) || Vpe(e) || zpe(e) || Fpe();
}
function Fpe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zpe(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return Iw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Iw(e, n);
  }
}
function Vpe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Hpe(e) {
  if (Array.isArray(e))
    return Iw(e);
}
function Iw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function iT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function br(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? iT(Object(r), !0).forEach(function(o) {
      zl(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : iT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function zl(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function mn(e, n, r) {
  return Be(e) || Be(n) ? r : Un(n) ? Hn(e, n, r) : qe(n) ? n(e) : r;
}
function Ep(e, n, r, o) {
  var s = Gde(e, function(f) {
    return mn(f, n);
  });
  if (r === "number") {
    var u = s.filter(function(f) {
      return Oe(f) || parseFloat(f);
    });
    return u.length ? [zg(u), xa(u)] : [1 / 0, -1 / 0];
  }
  var h = o ? s.filter(function(f) {
    return !Be(f);
  }) : s;
  return h.map(function(f) {
    return Un(f) || f instanceof Date ? f : "";
  });
}
var Upe = function(n) {
  var r, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], s = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0, h = -1, f = (r = o?.length) !== null && r !== void 0 ? r : 0;
  if (f > 1) {
    if (u && u.axisType === "angleAxis" && Math.abs(Math.abs(u.range[1] - u.range[0]) - 360) <= 1e-6)
      for (var p = u.range, v = 0; v < f; v++) {
        var b = v > 0 ? s[v - 1].coordinate : s[f - 1].coordinate, y = s[v].coordinate, k = v >= f - 1 ? s[0].coordinate : s[v + 1].coordinate, _ = void 0;
        if (pr(y - b) !== pr(k - y)) {
          var E = [];
          if (pr(k - y) === pr(p[1] - p[0])) {
            _ = k;
            var x = y + p[1] - p[0];
            E[0] = Math.min(x, (x + b) / 2), E[1] = Math.max(x, (x + b) / 2);
          } else {
            _ = b;
            var D = k + p[1] - p[0];
            E[0] = Math.min(y, (D + y) / 2), E[1] = Math.max(y, (D + y) / 2);
          }
          var I = [Math.min(y, (_ + y) / 2), Math.max(y, (_ + y) / 2)];
          if (n > I[0] && n <= I[1] || n >= E[0] && n <= E[1]) {
            h = s[v].index;
            break;
          }
        } else {
          var N = Math.min(b, k), O = Math.max(b, k);
          if (n > (N + y) / 2 && n <= (O + y) / 2) {
            h = s[v].index;
            break;
          }
        }
      }
    else
      for (var P = 0; P < f; P++)
        if (P === 0 && n <= (o[P].coordinate + o[P + 1].coordinate) / 2 || P > 0 && P < f - 1 && n > (o[P].coordinate + o[P - 1].coordinate) / 2 && n <= (o[P].coordinate + o[P + 1].coordinate) / 2 || P === f - 1 && n > (o[P].coordinate + o[P - 1].coordinate) / 2) {
          h = o[P].index;
          break;
        }
  } else
    h = 0;
  return h;
}, tk = function(n) {
  var r = n, o = r.type.displayName, s = n.props, u = s.stroke, h = s.fill, f;
  switch (o) {
    case "Line":
      f = u;
      break;
    case "Area":
    case "Radar":
      f = u && u !== "none" ? u : h;
      break;
    default:
      f = h;
      break;
  }
  return f;
}, JP = function(n) {
  var r = n.children, o = n.formattedGraphicalItems, s = n.legendWidth, u = n.legendContent, h = Fo(r, Os.displayName);
  if (!h)
    return null;
  var f;
  return h.props && h.props.payload ? f = h.props && h.props.payload : u === "children" ? f = (o || []).reduce(function(p, v) {
    var b = v.item, y = v.props, k = y.sectors || y.data || [];
    return p.concat(k.map(function(_) {
      return {
        type: h.props.iconType || b.props.legendType,
        value: _.name,
        color: _.fill,
        payload: _
      };
    }));
  }, []) : f = (o || []).map(function(p) {
    var v = p.item, b = v.props, y = b.dataKey, k = b.name, _ = b.legendType, E = b.hide;
    return {
      inactive: E,
      dataKey: y,
      type: h.props.iconType || _ || "square",
      color: tk(v),
      value: k || y,
      payload: v.props
    };
  }), br(br(br({}, h.props), Os.getWithHeight(h, s)), {}, {
    payload: f,
    item: h
  });
}, Wpe = function(n) {
  var r = n.barSize, o = n.stackGroups, s = o === void 0 ? {} : o;
  if (!s)
    return {};
  for (var u = {}, h = Object.keys(s), f = 0, p = h.length; f < p; f++)
    for (var v = s[h[f]].stackGroups, b = Object.keys(v), y = 0, k = b.length; y < k; y++) {
      var _ = v[b[y]], E = _.items, x = _.cateAxisId, D = E.filter(function(O) {
        return Sa(O.type).indexOf("Bar") >= 0;
      });
      if (D && D.length) {
        var I = D[0].props.barSize, N = D[0].props[x];
        u[N] || (u[N] = []), u[N].push({
          item: D[0],
          stackList: D.slice(1),
          barSize: Be(I) ? r : I
        });
      }
    }
  return u;
}, Gpe = function(n) {
  var r = n.barGap, o = n.barCategoryGap, s = n.bandSize, u = n.sizeList, h = u === void 0 ? [] : u, f = n.maxBarSize, p = h.length;
  if (p < 1)
    return null;
  var v = Sr(r, s, 0, !0), b;
  if (h[0].barSize === +h[0].barSize) {
    var y = !1, k = s / p, _ = h.reduce(function(O, P) {
      return O + P.barSize || 0;
    }, 0);
    _ += (p - 1) * v, _ >= s && (_ -= (p - 1) * v, v = 0), _ >= s && k > 0 && (y = !0, k *= 0.9, _ = p * k);
    var E = (s - _) / 2 >> 0, x = {
      offset: E - v,
      size: 0
    };
    b = h.reduce(function(O, P) {
      var S = [].concat(rT(O), [{
        item: P.item,
        position: {
          offset: x.offset + x.size + v,
          size: y ? k : P.barSize
        }
      }]);
      return x = S[S.length - 1].position, P.stackList && P.stackList.length && P.stackList.forEach(function($) {
        S.push({
          item: $,
          position: x
        });
      }), S;
    }, []);
  } else {
    var D = Sr(o, s, 0, !0);
    s - 2 * D - (p - 1) * v <= 0 && (v = 0);
    var I = (s - 2 * D - (p - 1) * v) / p;
    I > 1 && (I >>= 0);
    var N = f === +f ? Math.min(I, f) : I;
    b = h.reduce(function(O, P, S) {
      var $ = [].concat(rT(O), [{
        item: P.item,
        position: {
          offset: D + (I + v) * S + (I - N) / 2,
          size: N
        }
      }]);
      return P.stackList && P.stackList.length && P.stackList.forEach(function(L) {
        $.push({
          item: L,
          position: $[$.length - 1].position
        });
      }), $;
    }, []);
  }
  return b;
}, qpe = function(n, r, o, s) {
  var u = o.children, h = o.width, f = o.margin, p = h - (f.left || 0) - (f.right || 0), v = JP({
    children: u,
    legendWidth: p
  }), b = n;
  if (v) {
    var y = s || {}, k = v.align, _ = v.verticalAlign, E = v.layout;
    (E === "vertical" || E === "horizontal" && _ === "center") && Oe(n[k]) && (b = br(br({}, n), {}, zl({}, k, b[k] + (y.width || 0)))), (E === "horizontal" || E === "vertical" && k === "center") && Oe(n[_]) && (b = br(br({}, n), {}, zl({}, _, b[_] + (y.height || 0))));
  }
  return b;
}, Kpe = function(n, r, o) {
  return Be(r) ? !0 : n === "horizontal" ? r === "yAxis" : n === "vertical" || o === "x" ? r === "xAxis" : o === "y" ? r === "yAxis" : !0;
}, e7 = function(n, r, o, s, u) {
  var h = r.props.children, f = yr(h, "ErrorBar").filter(function(v) {
    return Kpe(s, u, v.props.direction);
  });
  if (f && f.length) {
    var p = f.map(function(v) {
      return v.props.dataKey;
    });
    return n.reduce(function(v, b) {
      var y = mn(b, o, 0), k = Tt(y) ? [zg(y), xa(y)] : [y, y], _ = p.reduce(function(E, x) {
        var D = mn(b, x, 0), I = k[0] - Math.abs(Tt(D) ? D[0] : D), N = k[1] + Math.abs(Tt(D) ? D[1] : D);
        return [Math.min(I, E[0]), Math.max(N, E[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(_[0], v[0]), Math.max(_[1], v[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, Ype = function(n, r, o, s, u) {
  var h = r.map(function(f) {
    return e7(n, f, o, u, s);
  }).filter(function(f) {
    return !Be(f);
  });
  return h && h.length ? h.reduce(function(f, p) {
    return [Math.min(f[0], p[0]), Math.max(f[1], p[1])];
  }, [1 / 0, -1 / 0]) : null;
}, t7 = function(n, r, o, s, u) {
  var h = r.map(function(p) {
    var v = p.props.dataKey;
    return o === "number" && v && e7(n, p, v, s) || Ep(n, v, o, u);
  });
  if (o === "number")
    return h.reduce(function(p, v) {
      return [Math.min(p[0], v[0]), Math.max(p[1], v[1])];
    }, [1 / 0, -1 / 0]);
  var f = {};
  return h.reduce(function(p, v) {
    for (var b = 0, y = v.length; b < y; b++)
      f[v[b]] || (f[v[b]] = !0, p.push(v[b]));
    return p;
  }, []);
}, n7 = function(n, r) {
  return n === "horizontal" && r === "xAxis" || n === "vertical" && r === "yAxis" || n === "centric" && r === "angleAxis" || n === "radial" && r === "radiusAxis";
}, oT = function(n, r, o) {
  var s, u, h = n.map(function(f) {
    return f.coordinate === r && (s = !0), f.coordinate === o && (u = !0), f.coordinate;
  });
  return s || h.push(r), u || h.push(o), h;
}, va = function(n, r, o) {
  if (!n)
    return null;
  var s = n.scale, u = n.duplicateDomain, h = n.type, f = n.range, p = n.realScaleType === "scaleBand" ? s.bandwidth() / 2 : 2, v = (r || o) && h === "category" && s.bandwidth ? s.bandwidth() / p : 0;
  return v = n.axisType === "angleAxis" ? pr(f[0] - f[1]) * 2 * v : v, r && (n.ticks || n.niceTicks) ? (n.ticks || n.niceTicks).map(function(b) {
    var y = u ? u.indexOf(b) : b;
    return {
      coordinate: s(y) + v,
      value: b,
      offset: v
    };
  }) : n.isCategorical && n.categoricalDomain ? n.categoricalDomain.map(function(b, y) {
    return {
      coordinate: s(b) + v,
      value: b,
      index: y,
      offset: v
    };
  }) : s.ticks && !o ? s.ticks(n.tickCount).map(function(b) {
    return {
      coordinate: s(b) + v,
      value: b,
      offset: v
    };
  }) : s.domain().map(function(b, y) {
    return {
      coordinate: s(b) + v,
      value: u ? u[b] : b,
      index: y,
      offset: v
    };
  });
}, tf = function(n, r, o) {
  var s;
  return qe(o) ? s = o : qe(r) && (s = r), qe(n) || s ? function(u, h, f, p) {
    qe(n) && n(u, h, f, p), qe(s) && s(u, h, f, p);
  } : null;
}, r7 = function(n, r, o) {
  var s = n.scale, u = n.type, h = n.layout, f = n.axisType;
  if (s === "auto")
    return h === "radial" && f === "radiusAxis" ? {
      scale: Qu(),
      realScaleType: "band"
    } : h === "radial" && f === "angleAxis" ? {
      scale: _p(),
      realScaleType: "linear"
    } : u === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !o) ? {
      scale: Fu(),
      realScaleType: "point"
    } : u === "category" ? {
      scale: Qu(),
      realScaleType: "band"
    } : {
      scale: _p(),
      realScaleType: "linear"
    };
  if (gd(s)) {
    var p = "scale".concat(Ig(s));
    return {
      scale: (nT[p] || Fu)(),
      realScaleType: nT[p] ? p : "point"
    };
  }
  return qe(s) ? {
    scale: s
  } : {
    scale: Fu(),
    realScaleType: "point"
  };
}, aT = 1e-4, i7 = function(n) {
  var r = n.domain();
  if (!(!r || r.length <= 2)) {
    var o = r.length, s = n.range(), u = Math.min(s[0], s[1]) - aT, h = Math.max(s[0], s[1]) + aT, f = n(r[0]), p = n(r[o - 1]);
    (f < u || f > h || p < u || p > h) && n.domain([r[0], r[o - 1]]);
  }
}, Qpe = function(n, r) {
  if (!n)
    return null;
  for (var o = 0, s = n.length; o < s; o++)
    if (n[o].item === r)
      return n[o].position;
  return null;
}, Zpe = function(n, r) {
  if (!r || r.length !== 2 || !Oe(r[0]) || !Oe(r[1]))
    return n;
  var o = Math.min(r[0], r[1]), s = Math.max(r[0], r[1]), u = [n[0], n[1]];
  return (!Oe(n[0]) || n[0] < o) && (u[0] = o), (!Oe(n[1]) || n[1] > s) && (u[1] = s), u[0] > s && (u[0] = s), u[1] < o && (u[1] = o), u;
}, Xpe = function(n) {
  var r = n.length;
  if (!(r <= 0))
    for (var o = 0, s = n[0].length; o < s; ++o)
      for (var u = 0, h = 0, f = 0; f < r; ++f) {
        var p = pd(n[f][o][1]) ? n[f][o][0] : n[f][o][1];
        p >= 0 ? (n[f][o][0] = u, n[f][o][1] = u + p, u = n[f][o][1]) : (n[f][o][0] = h, n[f][o][1] = h + p, h = n[f][o][1]);
      }
}, Jpe = function(n) {
  var r = n.length;
  if (!(r <= 0))
    for (var o = 0, s = n[0].length; o < s; ++o)
      for (var u = 0, h = 0; h < r; ++h) {
        var f = pd(n[h][o][1]) ? n[h][o][0] : n[h][o][1];
        f >= 0 ? (n[h][o][0] = u, n[h][o][1] = u + f, u = n[h][o][1]) : (n[h][o][0] = 0, n[h][o][1] = 0);
      }
}, ege = {
  sign: Xpe,
  expand: rae,
  none: Wl,
  silhouette: iae,
  wiggle: oae,
  positive: Jpe
}, tge = function(n, r, o) {
  var s = r.map(function(h) {
    return h.props.dataKey;
  }), u = nae().keys(s).value(function(h, f) {
    return +mn(h, f, 0);
  }).order(qb).offset(ege[o]);
  return u(n);
}, nge = function(n, r, o, s, u, h) {
  if (!n)
    return null;
  var f = h ? r.reverse() : r, p = f.reduce(function(v, b) {
    var y = b.props, k = y.stackId, _ = y.hide;
    if (_)
      return v;
    var E = b.props[o], x = v[E] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Un(k)) {
      var D = x.stackGroups[k] || {
        numericAxisId: o,
        cateAxisId: s,
        items: []
      };
      D.items.push(b), x.hasStack = !0, x.stackGroups[k] = D;
    } else
      x.stackGroups[La("_stackId_")] = {
        numericAxisId: o,
        cateAxisId: s,
        items: [b]
      };
    return br(br({}, v), {}, zl({}, E, x));
  }, {});
  return Object.keys(p).reduce(function(v, b) {
    var y = p[b];
    return y.hasStack && (y.stackGroups = Object.keys(y.stackGroups).reduce(function(k, _) {
      var E = y.stackGroups[_];
      return br(br({}, k), {}, zl({}, _, {
        numericAxisId: o,
        cateAxisId: s,
        items: E.items,
        stackedData: tge(n, E.items, u)
      }));
    }, {})), br(br({}, v), {}, zl({}, b, y));
  }, {});
}, rge = function(n, r) {
  return r === "number" ? [zg(n), xa(n)] : n;
}, o7 = function(n, r) {
  var o = r.realScaleType, s = r.type, u = r.tickCount, h = r.originalDomain, f = r.allowDecimals, p = o || r.scale;
  if (p !== "auto" && p !== "linear")
    return null;
  if (u && s === "number" && h && (h[0] === "auto" || h[1] === "auto")) {
    var v = n.domain();
    if (!v.length)
      return null;
    var b = whe(v, u, f);
    return n.domain(rge(b, s)), {
      niceTicks: b
    };
  }
  if (u && s === "number") {
    var y = n.domain(), k = yhe(y, u, f);
    return {
      niceTicks: k
    };
  }
  return null;
}, Ql = function(n) {
  var r = n.axis, o = n.ticks, s = n.bandSize, u = n.entry, h = n.index, f = n.dataKey;
  if (r.type === "category") {
    if (!r.allowDuplicatedCategory && r.dataKey && !Be(u[r.dataKey])) {
      var p = ap(o, "value", u[r.dataKey]);
      if (p)
        return p.coordinate + s / 2;
    }
    return o[h] ? o[h].coordinate + s / 2 : null;
  }
  var v = mn(u, Be(f) ? r.dataKey : f);
  return Be(v) ? null : r.scale(v);
}, sT = function(n) {
  var r = n.axis, o = n.ticks, s = n.offset, u = n.bandSize, h = n.entry, f = n.index;
  if (r.type === "category")
    return o[f] ? o[f].coordinate + s : null;
  var p = mn(h, r.dataKey, r.domain[f]);
  return Be(p) ? null : r.scale(p) - u / 2 + s;
}, ige = function(n) {
  var r = n.numericAxis, o = r.scale.domain();
  if (r.type === "number") {
    var s = Math.min(o[0], o[1]), u = Math.max(o[0], o[1]);
    return s <= 0 && u >= 0 ? 0 : u < 0 ? u : s;
  }
  return o[0];
}, oge = function(n, r) {
  var o = n.props.stackId;
  if (Un(o)) {
    var s = r[o];
    if (s && s.items.length) {
      for (var u = -1, h = 0, f = s.items.length; h < f; h++)
        if (s.items[h] === n) {
          u = h;
          break;
        }
      return u >= 0 ? s.stackedData[u] : null;
    }
  }
  return null;
}, age = function(n) {
  return n.reduce(function(r, o) {
    return [zg(o.concat([r[0]]).filter(Oe)), xa(o.concat([r[1]]).filter(Oe))];
  }, [1 / 0, -1 / 0]);
}, a7 = function(n, r, o) {
  return Object.keys(n).reduce(function(s, u) {
    var h = n[u], f = h.stackedData, p = f.reduce(function(v, b) {
      var y = age(b.slice(r, o + 1));
      return [Math.min(v[0], y[0]), Math.max(v[1], y[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(p[0], s[0]), Math.max(p[1], s[1])];
  }, [1 / 0, -1 / 0]).map(function(s) {
    return s === 1 / 0 || s === -1 / 0 ? 0 : s;
  });
}, lT = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, cT = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, s7 = function(n, r, o) {
  if (qe(n))
    return n(r, o);
  if (!Tt(n))
    return r;
  var s = [];
  if (Oe(n[0]))
    s[0] = o ? n[0] : Math.min(n[0], r[0]);
  else if (lT.test(n[0])) {
    var u = +lT.exec(n[0])[1];
    s[0] = r[0] - u;
  } else
    qe(n[0]) ? s[0] = n[0](r[0]) : s[0] = r[0];
  if (Oe(n[1]))
    s[1] = o ? n[1] : Math.max(n[1], r[1]);
  else if (cT.test(n[1])) {
    var h = +cT.exec(n[1])[1];
    s[1] = r[1] + h;
  } else
    qe(n[1]) ? s[1] = n[1](r[1]) : s[1] = r[1];
  return s;
}, Sp = function(n, r, o) {
  if (n && n.scale && n.scale.bandwidth) {
    var s = n.scale.bandwidth();
    if (!o || s > 0)
      return s;
  }
  if (n && r && r.length >= 2) {
    for (var u = Py(r, function(y) {
      return y.coordinate;
    }), h = 1 / 0, f = 1, p = u.length; f < p; f++) {
      var v = u[f], b = u[f - 1];
      h = Math.min((v.coordinate || 0) - (b.coordinate || 0), h);
    }
    return h === 1 / 0 ? 0 : h;
  }
  return o ? void 0 : 0;
}, uT = function(n, r, o) {
  return !n || !n.length || Rs(n, Hn(o, "type.defaultProps.domain")) ? r : n;
}, l7 = function(n, r) {
  var o = n.props, s = o.dataKey, u = o.name, h = o.unit, f = o.formatter, p = o.tooltipType, v = o.chartType;
  return br(br({}, Ye(n)), {}, {
    dataKey: s,
    unit: h,
    formatter: f,
    name: u || s,
    color: tk(n),
    value: mn(r, s),
    type: p,
    payload: r,
    chartType: v
  });
};
function dT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Lo(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? dT(Object(r), !0).forEach(function(o) {
      c7(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function c7(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function sge(e, n) {
  return dge(e) || uge(e, n) || cge(e, n) || lge();
}
function lge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cge(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return hT(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return hT(e, n);
  }
}
function hT(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function uge(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function dge(e) {
  if (Array.isArray(e))
    return e;
}
var Mp = Math.PI / 180, hge = function(n) {
  return n * 180 / Math.PI;
}, dn = function(n, r, o, s) {
  return {
    x: n + Math.cos(-Mp * s) * o,
    y: r + Math.sin(-Mp * s) * o
  };
}, u7 = function(n, r) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(n - (o.left || 0) - (o.right || 0)), Math.abs(r - (o.top || 0) - (o.bottom || 0))) / 2;
}, fge = function(n, r, o, s, u) {
  var h = n.width, f = n.height, p = n.startAngle, v = n.endAngle, b = Sr(n.cx, h, h / 2), y = Sr(n.cy, f, f / 2), k = u7(h, f, o), _ = Sr(n.innerRadius, k, 0), E = Sr(n.outerRadius, k, k * 0.8), x = Object.keys(r);
  return x.reduce(function(D, I) {
    var N = r[I], O = N.domain, P = N.reversed, S;
    if (Be(N.range))
      s === "angleAxis" ? S = [p, v] : s === "radiusAxis" && (S = [_, E]), P && (S = [S[1], S[0]]);
    else {
      S = N.range;
      var $ = S, L = sge($, 2);
      p = L[0], v = L[1];
    }
    var B = r7(N, u), U = B.realScaleType, G = B.scale;
    G.domain(O).range(S), i7(G);
    var q = o7(G, Lo(Lo({}, N), {}, {
      realScaleType: U
    })), Y = Lo(Lo(Lo({}, N), q), {}, {
      range: S,
      radius: E,
      realScaleType: U,
      scale: G,
      cx: b,
      cy: y,
      innerRadius: _,
      outerRadius: E,
      startAngle: p,
      endAngle: v
    });
    return Lo(Lo({}, D), {}, c7({}, I, Y));
  }, {});
}, pge = function(n, r) {
  var o = n.x, s = n.y, u = r.x, h = r.y;
  return Math.sqrt(Math.pow(o - u, 2) + Math.pow(s - h, 2));
}, gge = function(n, r) {
  var o = n.x, s = n.y, u = r.cx, h = r.cy, f = pge({
    x: o,
    y: s
  }, {
    x: u,
    y: h
  });
  if (f <= 0)
    return {
      radius: f
    };
  var p = (o - u) / f, v = Math.acos(p);
  return s > h && (v = 2 * Math.PI - v), {
    radius: f,
    angle: hge(v),
    angleInRadian: v
  };
}, mge = function(n) {
  var r = n.startAngle, o = n.endAngle, s = Math.floor(r / 360), u = Math.floor(o / 360), h = Math.min(s, u);
  return {
    startAngle: r - h * 360,
    endAngle: o - h * 360
  };
}, vge = function(n, r) {
  var o = r.startAngle, s = r.endAngle, u = Math.floor(o / 360), h = Math.floor(s / 360), f = Math.min(u, h);
  return n + f * 360;
}, fT = function(n, r) {
  var o = n.x, s = n.y, u = gge({
    x: o,
    y: s
  }, r), h = u.radius, f = u.angle, p = r.innerRadius, v = r.outerRadius;
  if (h < p || h > v)
    return !1;
  if (h === 0)
    return !0;
  var b = mge(r), y = b.startAngle, k = b.endAngle, _ = f, E;
  if (y <= k) {
    for (; _ > k; )
      _ -= 360;
    for (; _ < y; )
      _ += 360;
    E = _ >= y && _ <= k;
  } else {
    for (; _ > y; )
      _ -= 360;
    for (; _ < k; )
      _ += 360;
    E = _ >= k && _ <= y;
  }
  return E ? Lo(Lo({}, r), {}, {
    radius: h,
    angle: vge(_, r)
  }) : null;
};
function bge(e) {
  return _ge(e) || kge(e) || yge(e) || wge();
}
function wge() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yge(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return Pw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Pw(e, n);
  }
}
function kge(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function _ge(e) {
  if (Array.isArray(e))
    return Pw(e);
}
function Pw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function pT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function er(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? pT(Object(r), !0).forEach(function(o) {
      Age(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Age(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var Cge = function(n) {
  var r = n.value, o = n.formatter, s = Be(n.children) ? r : n.children;
  return qe(o) ? o(s) : s;
}, xge = function(n, r) {
  var o = pr(r - n), s = Math.min(Math.abs(r - n), 360);
  return o * s;
}, Ege = function(n, r, o) {
  var s = n.position, u = n.viewBox, h = n.offset, f = n.className, p = u, v = p.cx, b = p.cy, y = p.innerRadius, k = p.outerRadius, _ = p.startAngle, E = p.endAngle, x = p.clockWise, D = (y + k) / 2, I = xge(_, E), N = I >= 0 ? 1 : -1, O, P;
  s === "insideStart" ? (O = _ + N * h, P = x) : s === "insideEnd" ? (O = E - N * h, P = !x) : s === "end" && (O = E + N * h, P = x), P = I <= 0 ? P : !P;
  var S = dn(v, b, D, O), $ = dn(v, b, D, O + (P ? 1 : -1) * 359), L = "M".concat(S.x, ",").concat(S.y, `
    A`).concat(D, ",").concat(D, ",0,1,").concat(P ? 0 : 1, `,
    `).concat($.x, ",").concat($.y), B = Be(n.id) ? La("recharts-radial-line-") : n.id;
  return /* @__PURE__ */ K("text", {
    ...o,
    dominantBaseline: "central",
    className: Ce("recharts-radial-bar-label", f),
    children: [/* @__PURE__ */ M("defs", {
      children: /* @__PURE__ */ M("path", {
        id: B,
        d: L
      })
    }), /* @__PURE__ */ M("textPath", {
      xlinkHref: "#".concat(B),
      children: r
    })]
  });
}, Sge = function(n) {
  var r = n.viewBox, o = n.offset, s = n.position, u = r, h = u.cx, f = u.cy, p = u.innerRadius, v = u.outerRadius, b = u.startAngle, y = u.endAngle, k = (b + y) / 2;
  if (s === "outside") {
    var _ = dn(h, f, v + o, k), E = _.x, x = _.y;
    return {
      x: E,
      y: x,
      textAnchor: E >= h ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (s === "center")
    return {
      x: h,
      y: f,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (s === "centerTop")
    return {
      x: h,
      y: f,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (s === "centerBottom")
    return {
      x: h,
      y: f,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var D = (p + v) / 2, I = dn(h, f, D, k), N = I.x, O = I.y;
  return {
    x: N,
    y: O,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, Mge = function(n) {
  var r = n.viewBox, o = n.parentViewBox, s = n.offset, u = n.position, h = r, f = h.x, p = h.y, v = h.width, b = h.height, y = b >= 0 ? 1 : -1, k = y * s, _ = y > 0 ? "end" : "start", E = y > 0 ? "start" : "end", x = v >= 0 ? 1 : -1, D = x * s, I = x > 0 ? "end" : "start", N = x > 0 ? "start" : "end";
  if (u === "top") {
    var O = {
      x: f + v / 2,
      y: p - y * s,
      textAnchor: "middle",
      verticalAnchor: _
    };
    return er(er({}, O), o ? {
      height: Math.max(p - o.y, 0),
      width: v
    } : {});
  }
  if (u === "bottom") {
    var P = {
      x: f + v / 2,
      y: p + b + k,
      textAnchor: "middle",
      verticalAnchor: E
    };
    return er(er({}, P), o ? {
      height: Math.max(o.y + o.height - (p + b), 0),
      width: v
    } : {});
  }
  if (u === "left") {
    var S = {
      x: f - D,
      y: p + b / 2,
      textAnchor: I,
      verticalAnchor: "middle"
    };
    return er(er({}, S), o ? {
      width: Math.max(S.x - o.x, 0),
      height: b
    } : {});
  }
  if (u === "right") {
    var $ = {
      x: f + v + D,
      y: p + b / 2,
      textAnchor: N,
      verticalAnchor: "middle"
    };
    return er(er({}, $), o ? {
      width: Math.max(o.x + o.width - $.x, 0),
      height: b
    } : {});
  }
  var L = o ? {
    width: v,
    height: b
  } : {};
  return u === "insideLeft" ? er({
    x: f + D,
    y: p + b / 2,
    textAnchor: N,
    verticalAnchor: "middle"
  }, L) : u === "insideRight" ? er({
    x: f + v - D,
    y: p + b / 2,
    textAnchor: I,
    verticalAnchor: "middle"
  }, L) : u === "insideTop" ? er({
    x: f + v / 2,
    y: p + k,
    textAnchor: "middle",
    verticalAnchor: E
  }, L) : u === "insideBottom" ? er({
    x: f + v / 2,
    y: p + b - k,
    textAnchor: "middle",
    verticalAnchor: _
  }, L) : u === "insideTopLeft" ? er({
    x: f + D,
    y: p + k,
    textAnchor: N,
    verticalAnchor: E
  }, L) : u === "insideTopRight" ? er({
    x: f + v - D,
    y: p + k,
    textAnchor: I,
    verticalAnchor: E
  }, L) : u === "insideBottomLeft" ? er({
    x: f + D,
    y: p + b - k,
    textAnchor: N,
    verticalAnchor: _
  }, L) : u === "insideBottomRight" ? er({
    x: f + v - D,
    y: p + b - k,
    textAnchor: I,
    verticalAnchor: _
  }, L) : Vr(u) && (Oe(u.x) || Zb(u.x)) && (Oe(u.y) || Zb(u.y)) ? er({
    x: f + Sr(u.x, v),
    y: p + Sr(u.y, b),
    textAnchor: "end",
    verticalAnchor: "end"
  }, L) : er({
    x: f + v / 2,
    y: p + b / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, L);
}, Tge = function(n) {
  return Oe(n.cx);
};
function Vn(e) {
  var n = e.viewBox, r = e.position, o = e.value, s = e.children, u = e.content, h = e.className, f = h === void 0 ? "" : h, p = e.textBreakAll;
  if (!n || Be(o) && Be(s) && !/* @__PURE__ */ Ho(u) && !qe(u))
    return null;
  if (/* @__PURE__ */ Ho(u))
    return /* @__PURE__ */ cr(u, e);
  var v;
  if (qe(u)) {
    if (v = /* @__PURE__ */ hi(u, e), /* @__PURE__ */ Ho(v))
      return v;
  } else
    v = Cge(e);
  var b = Tge(n), y = Ye(e, !0);
  if (b && (r === "insideStart" || r === "insideEnd" || r === "end"))
    return Ege(e, v, y);
  var k = b ? Sge(e) : Mge(e);
  return /* @__PURE__ */ M(Oa, {
    className: Ce("recharts-label", f),
    ...y,
    ...k,
    breakAll: p,
    children: v
  });
}
Vn.displayName = "Label";
Vn.defaultProps = {
  offset: 5
};
var d7 = function(n) {
  var r = n.cx, o = n.cy, s = n.angle, u = n.startAngle, h = n.endAngle, f = n.r, p = n.radius, v = n.innerRadius, b = n.outerRadius, y = n.x, k = n.y, _ = n.top, E = n.left, x = n.width, D = n.height, I = n.clockWise, N = n.labelViewBox;
  if (N)
    return N;
  if (Oe(x) && Oe(D)) {
    if (Oe(y) && Oe(k))
      return {
        x: y,
        y: k,
        width: x,
        height: D
      };
    if (Oe(_) && Oe(E))
      return {
        x: _,
        y: E,
        width: x,
        height: D
      };
  }
  return Oe(y) && Oe(k) ? {
    x: y,
    y: k,
    width: 0,
    height: 0
  } : Oe(r) && Oe(o) ? {
    cx: r,
    cy: o,
    startAngle: u || s || 0,
    endAngle: h || s || 0,
    innerRadius: v || 0,
    outerRadius: b || p || f || 0,
    clockWise: I
  } : n.viewBox ? n.viewBox : {};
}, Dge = function(n, r) {
  return n ? n === !0 ? /* @__PURE__ */ M(Vn, {
    viewBox: r
  }, "label-implicit") : Un(n) ? /* @__PURE__ */ M(Vn, {
    viewBox: r,
    value: n
  }, "label-implicit") : /* @__PURE__ */ Ho(n) ? n.type === Vn ? /* @__PURE__ */ cr(n, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ M(Vn, {
    content: n,
    viewBox: r
  }, "label-implicit") : qe(n) ? /* @__PURE__ */ M(Vn, {
    content: n,
    viewBox: r
  }, "label-implicit") : Vr(n) ? /* @__PURE__ */ hi(Vn, {
    viewBox: r,
    ...n,
    key: "label-implicit"
  }) : null : null;
}, Ige = function(n, r) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!n || !n.children && o && !n.label)
    return null;
  var s = n.children, u = d7(n), h = yr(s, Vn.displayName).map(function(p, v) {
    return /* @__PURE__ */ cr(p, {
      viewBox: r || u,
      key: "label-".concat(v)
    });
  });
  if (!o)
    return h;
  var f = Dge(n.label, r || u);
  return [f].concat(bge(h));
};
Vn.parseViewBox = d7;
Vn.renderCallByParent = Ige;
function Pge(e) {
  var n = e == null ? 0 : e.length;
  return n ? e[n - 1] : void 0;
}
var Oge = Pge;
function Rge(e) {
  return jge(e) || Lge(e) || $ge(e) || Nge();
}
function Nge() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $ge(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return Ow(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ow(e, n);
  }
}
function Lge(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function jge(e) {
  if (Array.isArray(e))
    return Ow(e);
}
function Ow(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function gT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function mT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? gT(Object(r), !0).forEach(function(o) {
      Bge(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Bge(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Fge(e, n) {
  if (e == null)
    return {};
  var r = zge(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function zge(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
var Vge = {
  valueAccessor: function(n) {
    return Tt(n.value) ? Oge(n.value) : n.value;
  }
};
function ui(e) {
  var n = e.data, r = e.valueAccessor, o = e.dataKey, s = e.clockWise, u = e.id, h = e.textBreakAll, f = Fge(e, ["data", "valueAccessor", "dataKey", "clockWise", "id", "textBreakAll"]);
  return !n || !n.length ? null : /* @__PURE__ */ M(mt, {
    className: "recharts-label-list",
    children: n.map(function(p, v) {
      var b = Be(o) ? r(p, v) : mn(p && p.payload, o), y = Be(u) ? {} : {
        id: "".concat(u, "-").concat(v)
      };
      return /* @__PURE__ */ hi(Vn, {
        ...Ye(p, !0),
        ...f,
        ...y,
        parentViewBox: p.parentViewBox,
        index: v,
        value: b,
        textBreakAll: h,
        viewBox: Vn.parseViewBox(Be(s) ? p : mT(mT({}, p), {}, {
          clockWise: s
        })),
        key: "label-".concat(v)
      });
    })
  });
}
ui.displayName = "LabelList";
function Hge(e, n) {
  return e ? e === !0 ? /* @__PURE__ */ M(ui, {
    data: n
  }, "labelList-implicit") : /* @__PURE__ */ oe.isValidElement(e) || qe(e) ? /* @__PURE__ */ M(ui, {
    data: n,
    content: e
  }, "labelList-implicit") : Vr(e) ? /* @__PURE__ */ hi(ui, {
    data: n,
    ...e,
    key: "labelList-implicit"
  }) : null : null;
}
function Uge(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var o = e.children, s = yr(o, ui.displayName).map(function(h, f) {
    return /* @__PURE__ */ cr(h, {
      data: n,
      key: "labelList-".concat(f)
    });
  });
  if (!r)
    return s;
  var u = Hge(e.label, n);
  return [u].concat(Rge(s));
}
ui.renderCallByParent = Uge;
ui.defaultProps = Vge;
function Af(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Af = function(r) {
    return typeof r;
  } : Af = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Af(e);
}
function Wge(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function vT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Gge(e, n, r) {
  return n && vT(e.prototype, n), r && vT(e, r), e;
}
function qge(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Rw(e, n);
}
function Rw(e, n) {
  return Rw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Rw(e, n);
}
function Kge(e) {
  var n = Zge();
  return function() {
    var o = Tp(e), s;
    if (n) {
      var u = Tp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Yge(this, s);
  };
}
function Yge(e, n) {
  return n && (Af(n) === "object" || typeof n == "function") ? n : Qge(e);
}
function Qge(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Zge() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Tp(e) {
  return Tp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Tp(e);
}
var Xge = function(n, r) {
  var o = pr(r - n), s = Math.min(Math.abs(r - n), 359.999);
  return o * s;
}, nf = function(n) {
  var r = n.cx, o = n.cy, s = n.radius, u = n.angle, h = n.sign, f = n.isExternal, p = n.cornerRadius, v = n.cornerIsExternal, b = p * (f ? 1 : -1) + s, y = Math.asin(p / b) / Mp, k = v ? u : u + h * y, _ = dn(r, o, b, k), E = dn(r, o, s, k), x = v ? u - h * y : u, D = dn(r, o, b * Math.cos(y * Mp), x);
  return {
    center: _,
    circleTangency: E,
    lineTangency: D,
    theta: y
  };
}, h7 = function(n) {
  var r = n.cx, o = n.cy, s = n.innerRadius, u = n.outerRadius, h = n.startAngle, f = n.endAngle, p = Xge(h, f), v = h + p, b = dn(r, o, u, h), y = dn(r, o, u, v), k = "M ".concat(b.x, ",").concat(b.y, `
    A `).concat(u, ",").concat(u, `,0,
    `).concat(+(Math.abs(p) > 180), ",").concat(+(h > v), `,
    `).concat(y.x, ",").concat(y.y, `
  `);
  if (s > 0) {
    var _ = dn(r, o, s, h), E = dn(r, o, s, v);
    k += "L ".concat(E.x, ",").concat(E.y, `
            A `).concat(s, ",").concat(s, `,0,
            `).concat(+(Math.abs(p) > 180), ",").concat(+(h <= v), `,
            `).concat(_.x, ",").concat(_.y, " Z");
  } else
    k += "L ".concat(r, ",").concat(o, " Z");
  return k;
}, Jge = function(n) {
  var r = n.cx, o = n.cy, s = n.innerRadius, u = n.outerRadius, h = n.cornerRadius, f = n.forceCornerRadius, p = n.cornerIsExternal, v = n.startAngle, b = n.endAngle, y = pr(b - v), k = nf({
    cx: r,
    cy: o,
    radius: u,
    angle: v,
    sign: y,
    cornerRadius: h,
    cornerIsExternal: p
  }), _ = k.circleTangency, E = k.lineTangency, x = k.theta, D = nf({
    cx: r,
    cy: o,
    radius: u,
    angle: b,
    sign: -y,
    cornerRadius: h,
    cornerIsExternal: p
  }), I = D.circleTangency, N = D.lineTangency, O = D.theta, P = p ? Math.abs(v - b) : Math.abs(v - b) - x - O;
  if (P < 0)
    return f ? "M ".concat(E.x, ",").concat(E.y, `
        a`).concat(h, ",").concat(h, ",0,0,1,").concat(h * 2, `,0
        a`).concat(h, ",").concat(h, ",0,0,1,").concat(-h * 2, `,0
      `) : h7({
      cx: r,
      cy: o,
      innerRadius: s,
      outerRadius: u,
      startAngle: v,
      endAngle: b
    });
  var S = "M ".concat(E.x, ",").concat(E.y, `
    A`).concat(h, ",").concat(h, ",0,0,").concat(+(y < 0), ",").concat(_.x, ",").concat(_.y, `
    A`).concat(u, ",").concat(u, ",0,").concat(+(P > 180), ",").concat(+(y < 0), ",").concat(I.x, ",").concat(I.y, `
    A`).concat(h, ",").concat(h, ",0,0,").concat(+(y < 0), ",").concat(N.x, ",").concat(N.y, `
  `);
  if (s > 0) {
    var $ = nf({
      cx: r,
      cy: o,
      radius: s,
      angle: v,
      sign: y,
      isExternal: !0,
      cornerRadius: h,
      cornerIsExternal: p
    }), L = $.circleTangency, B = $.lineTangency, U = $.theta, G = nf({
      cx: r,
      cy: o,
      radius: s,
      angle: b,
      sign: -y,
      isExternal: !0,
      cornerRadius: h,
      cornerIsExternal: p
    }), q = G.circleTangency, Y = G.lineTangency, Q = G.theta, Z = p ? Math.abs(v - b) : Math.abs(v - b) - U - Q;
    if (Z < 0 && h === 0)
      return "".concat(S, "L").concat(r, ",").concat(o, "Z");
    S += "L".concat(Y.x, ",").concat(Y.y, `
      A`).concat(h, ",").concat(h, ",0,0,").concat(+(y < 0), ",").concat(q.x, ",").concat(q.y, `
      A`).concat(s, ",").concat(s, ",0,").concat(+(Z > 180), ",").concat(+(y > 0), ",").concat(L.x, ",").concat(L.y, `
      A`).concat(h, ",").concat(h, ",0,0,").concat(+(y < 0), ",").concat(B.x, ",").concat(B.y, "Z");
  } else
    S += "L".concat(r, ",").concat(o, "Z");
  return S;
}, Zl = /* @__PURE__ */ function(e) {
  qge(r, e);
  var n = Kge(r);
  function r() {
    return Wge(this, r), n.apply(this, arguments);
  }
  return Gge(r, [{
    key: "render",
    value: function() {
      var s = this.props, u = s.cx, h = s.cy, f = s.innerRadius, p = s.outerRadius, v = s.cornerRadius, b = s.forceCornerRadius, y = s.cornerIsExternal, k = s.startAngle, _ = s.endAngle, E = s.className;
      if (p < f || k === _)
        return null;
      var x = Ce("recharts-sector", E), D = p - f, I = Sr(v, D, 0, !0), N;
      return I > 0 && Math.abs(k - _) < 360 ? N = Jge({
        cx: u,
        cy: h,
        innerRadius: f,
        outerRadius: p,
        cornerRadius: Math.min(I, D / 2),
        forceCornerRadius: b,
        cornerIsExternal: y,
        startAngle: k,
        endAngle: _
      }) : N = h7({
        cx: u,
        cy: h,
        innerRadius: f,
        outerRadius: p,
        startAngle: k,
        endAngle: _
      }), /* @__PURE__ */ M("path", {
        ...Ye(this.props, !0),
        className: x,
        d: N,
        role: "img"
      });
    }
  }]), r;
}(Ln);
Zl.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
};
function Cf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Cf = function(r) {
    return typeof r;
  } : Cf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Cf(e);
}
function bT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function wT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? bT(Object(r), !0).forEach(function(o) {
      eme(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function eme(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function tme(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function yT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function nme(e, n, r) {
  return n && yT(e.prototype, n), r && yT(e, r), e;
}
function rme(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Nw(e, n);
}
function Nw(e, n) {
  return Nw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Nw(e, n);
}
function ime(e) {
  var n = sme();
  return function() {
    var o = Dp(e), s;
    if (n) {
      var u = Dp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return ome(this, s);
  };
}
function ome(e, n) {
  return n && (Cf(n) === "object" || typeof n == "function") ? n : ame(e);
}
function ame(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sme() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Dp(e) {
  return Dp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Dp(e);
}
var kT = {
  curveBasisClosed: Woe,
  curveBasisOpen: Goe,
  curveBasis: Uoe,
  curveLinearClosed: qoe,
  curveLinear: Rg,
  curveMonotoneX: Koe,
  curveMonotoneY: Yoe,
  curveNatural: Qoe,
  curveStep: Zoe,
  curveStepAfter: Joe,
  curveStepBefore: Xoe
}, rf = function(n) {
  return n.x === +n.x && n.y === +n.y;
}, Du = function(n) {
  return n.x;
}, Iu = function(n) {
  return n.y;
}, lme = function(n, r) {
  if (qe(n))
    return n;
  var o = "curve".concat(Ig(n));
  return o === "curveMonotone" && r ? kT["".concat(o).concat(r === "vertical" ? "Y" : "X")] : kT[o] || Rg;
}, Go = /* @__PURE__ */ function(e) {
  rme(r, e);
  var n = ime(r);
  function r() {
    return tme(this, r), n.apply(this, arguments);
  }
  return nme(r, [{
    key: "getPath",
    value: function() {
      var s = this.props, u = s.type, h = s.points, f = s.baseLine, p = s.layout, v = s.connectNulls, b = lme(u, p), y = v ? h.filter(function(x) {
        return rf(x);
      }) : h, k;
      if (Tt(f)) {
        var _ = v ? f.filter(function(x) {
          return rf(x);
        }) : f, E = y.map(function(x, D) {
          return wT(wT({}, x), {}, {
            base: _[D]
          });
        });
        return p === "vertical" ? k = Qh().y(Iu).x1(Du).x0(function(x) {
          return x.base.x;
        }) : k = Qh().x(Du).y1(Iu).y0(function(x) {
          return x.base.y;
        }), k.defined(rf).curve(b), k(E);
      }
      return p === "vertical" && Oe(f) ? k = Qh().y(Iu).x1(Du).x0(f) : Oe(f) ? k = Qh().x(Du).y1(Iu).y0(f) : k = f3().x(Du).y(Iu), k.defined(rf).curve(b), k(y);
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.className, h = s.points, f = s.path, p = s.pathRef;
      if ((!h || !h.length) && !f)
        return null;
      var v = h && h.length ? this.getPath() : f;
      return /* @__PURE__ */ M("path", {
        ...Ye(this.props),
        ...Qf(this.props),
        className: Ce("recharts-curve", u),
        d: v,
        ref: p
      });
    }
  }]), r;
}(Ln);
Go.defaultProps = {
  type: "linear",
  points: [],
  connectNulls: !1
};
function xf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? xf = function(r) {
    return typeof r;
  } : xf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, xf(e);
}
function cme(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function _T(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function ume(e, n, r) {
  return n && _T(e.prototype, n), r && _T(e, r), e;
}
function dme(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && $w(e, n);
}
function $w(e, n) {
  return $w = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, $w(e, n);
}
function hme(e) {
  var n = gme();
  return function() {
    var o = Ip(e), s;
    if (n) {
      var u = Ip(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return fme(this, s);
  };
}
function fme(e, n) {
  return n && (xf(n) === "object" || typeof n == "function") ? n : pme(e);
}
function pme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gme() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ip(e) {
  return Ip = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ip(e);
}
var AT = function(n, r, o, s, u) {
  var h = Math.min(Math.abs(o) / 2, Math.abs(s) / 2), f = s >= 0 ? 1 : -1, p = o >= 0 ? 1 : -1, v = s >= 0 && o >= 0 || s < 0 && o < 0 ? 1 : 0, b;
  if (h > 0 && u instanceof Array) {
    for (var y = [0, 0, 0, 0], k = 0, _ = 4; k < _; k++)
      y[k] = u[k] > h ? h : u[k];
    b = "M".concat(n, ",").concat(r + f * y[0]), y[0] > 0 && (b += "A ".concat(y[0], ",").concat(y[0], ",0,0,").concat(v, ",").concat(n + p * y[0], ",").concat(r)), b += "L ".concat(n + o - p * y[1], ",").concat(r), y[1] > 0 && (b += "A ".concat(y[1], ",").concat(y[1], ",0,0,").concat(v, `,
        `).concat(n + o, ",").concat(r + f * y[1])), b += "L ".concat(n + o, ",").concat(r + s - f * y[2]), y[2] > 0 && (b += "A ".concat(y[2], ",").concat(y[2], ",0,0,").concat(v, `,
        `).concat(n + o - p * y[2], ",").concat(r + s)), b += "L ".concat(n + p * y[3], ",").concat(r + s), y[3] > 0 && (b += "A ".concat(y[3], ",").concat(y[3], ",0,0,").concat(v, `,
        `).concat(n, ",").concat(r + s - f * y[3])), b += "Z";
  } else if (h > 0 && u === +u && u > 0) {
    var E = Math.min(h, u);
    b = "M ".concat(n, ",").concat(r + f * E, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(v, ",").concat(n + p * E, ",").concat(r, `
            L `).concat(n + o - p * E, ",").concat(r, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(v, ",").concat(n + o, ",").concat(r + f * E, `
            L `).concat(n + o, ",").concat(r + s - f * E, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(v, ",").concat(n + o - p * E, ",").concat(r + s, `
            L `).concat(n + p * E, ",").concat(r + s, `
            A `).concat(E, ",").concat(E, ",0,0,").concat(v, ",").concat(n, ",").concat(r + s - f * E, " Z");
  } else
    b = "M ".concat(n, ",").concat(r, " h ").concat(o, " v ").concat(s, " h ").concat(-o, " Z");
  return b;
}, mme = function(n, r) {
  if (!n || !r)
    return !1;
  var o = n.x, s = n.y, u = r.x, h = r.y, f = r.width, p = r.height;
  if (Math.abs(f) > 0 && Math.abs(p) > 0) {
    var v = Math.min(u, u + f), b = Math.max(u, u + f), y = Math.min(h, h + p), k = Math.max(h, h + p);
    return o >= v && o <= b && s >= y && s <= k;
  }
  return !1;
}, Zg = /* @__PURE__ */ function(e) {
  dme(r, e);
  var n = hme(r);
  function r() {
    var o;
    cme(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {
      totalLength: -1
    }, o.node = void 0, o;
  }
  return ume(r, [{
    key: "componentDidMount",
    value: function() {
      if (this.node && this.node.getTotalLength)
        try {
          var s = this.node.getTotalLength();
          s && this.setState({
            totalLength: s
          });
        } catch {
        }
    }
  }, {
    key: "render",
    value: function() {
      var s = this, u = this.props, h = u.x, f = u.y, p = u.width, v = u.height, b = u.radius, y = u.className, k = this.state.totalLength, _ = this.props, E = _.animationEasing, x = _.animationDuration, D = _.animationBegin, I = _.isAnimationActive, N = _.isUpdateAnimationActive;
      if (h !== +h || f !== +f || p !== +p || v !== +v || p === 0 || v === 0)
        return null;
      var O = Ce("recharts-rectangle", y);
      return N ? /* @__PURE__ */ M(mo, {
        canBegin: k > 0,
        from: {
          width: p,
          height: v,
          x: h,
          y: f
        },
        to: {
          width: p,
          height: v,
          x: h,
          y: f
        },
        duration: x,
        animationEasing: E,
        isActive: N,
        children: function(P) {
          var S = P.width, $ = P.height, L = P.x, B = P.y;
          return /* @__PURE__ */ M(mo, {
            canBegin: k > 0,
            from: "0px ".concat(k === -1 ? 1 : k, "px"),
            to: "".concat(k, "px 0px"),
            attributeName: "strokeDasharray",
            begin: D,
            duration: x,
            isActive: I,
            easing: E,
            children: /* @__PURE__ */ M("path", {
              ...Ye(s.props, !0),
              className: O,
              d: AT(L, B, S, $, b),
              ref: function(G) {
                s.node = G;
              }
            })
          });
        }
      }) : /* @__PURE__ */ M("path", {
        ...Ye(this.props, !0),
        className: O,
        d: AT(h, f, p, v, b)
      });
    }
  }]), r;
}(Ln);
Zg.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
function Ef(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ef = function(r) {
    return typeof r;
  } : Ef = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ef(e);
}
function vme(e, n) {
  if (e == null)
    return {};
  var r = bme(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function bme(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function wme(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function CT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function yme(e, n, r) {
  return n && CT(e.prototype, n), r && CT(e, r), e;
}
function kme(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Lw(e, n);
}
function Lw(e, n) {
  return Lw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Lw(e, n);
}
function _me(e) {
  var n = xme();
  return function() {
    var o = Pp(e), s;
    if (n) {
      var u = Pp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Ame(this, s);
  };
}
function Ame(e, n) {
  return n && (Ef(n) === "object" || typeof n == "function") ? n : Cme(e);
}
function Cme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xme() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pp(e) {
  return Pp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pp(e);
}
function xT(e) {
  return Tme(e) || Mme(e) || Sme(e) || Eme();
}
function Eme() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sme(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return jw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return jw(e, n);
  }
}
function Mme(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Tme(e) {
  if (Array.isArray(e))
    return jw(e);
}
function jw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
var ET = function(n) {
  return n && n.x === +n.x && n.y === +n.y;
}, Dme = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return n.forEach(function(o) {
    ET(o) ? r[r.length - 1].push(o) : r[r.length - 1].length > 0 && r.push([]);
  }), ET(n[0]) && r[r.length - 1].push(n[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, zu = function(n, r) {
  var o = Dme(n);
  r && (o = [o.reduce(function(u, h) {
    return [].concat(xT(u), xT(h));
  }, [])]);
  var s = o.map(function(u) {
    return u.reduce(function(h, f, p) {
      return "".concat(h).concat(p === 0 ? "M" : "L").concat(f.x, ",").concat(f.y);
    }, "");
  }).join("");
  return o.length === 1 ? "".concat(s, "Z") : s;
}, Ime = function(n, r, o) {
  var s = zu(n, o);
  return "".concat(s.slice(-1) === "Z" ? s.slice(0, -1) : s, "L").concat(zu(r.reverse(), o).slice(1));
}, Pme = /* @__PURE__ */ function(e) {
  kme(r, e);
  var n = _me(r);
  function r() {
    return wme(this, r), n.apply(this, arguments);
  }
  return yme(r, [{
    key: "render",
    value: function() {
      var s = this.props, u = s.points, h = s.className, f = s.baseLinePoints, p = s.connectNulls, v = vme(s, ["points", "className", "baseLinePoints", "connectNulls"]);
      if (!u || !u.length)
        return null;
      var b = Ce("recharts-polygon", h);
      if (f && f.length) {
        var y = v.stroke && v.stroke !== "none", k = Ime(u, f, p);
        return /* @__PURE__ */ K("g", {
          className: b,
          children: [/* @__PURE__ */ M("path", {
            ...Ye(v, !0),
            fill: k.slice(-1) === "Z" ? v.fill : "none",
            stroke: "none",
            d: k
          }), y ? /* @__PURE__ */ M("path", {
            ...Ye(v, !0),
            fill: "none",
            d: zu(u, p)
          }) : null, y ? /* @__PURE__ */ M("path", {
            ...Ye(v, !0),
            fill: "none",
            d: zu(f, p)
          }) : null]
        });
      }
      var _ = zu(u, p);
      return /* @__PURE__ */ M("path", {
        ...Ye(v, !0),
        fill: _.slice(-1) === "Z" ? v.fill : "none",
        className: b,
        d: _
      });
    }
  }]), r;
}(Ln);
function Sf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Sf = function(r) {
    return typeof r;
  } : Sf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Sf(e);
}
function Ome(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function ST(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Rme(e, n, r) {
  return n && ST(e.prototype, n), r && ST(e, r), e;
}
function Nme(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Bw(e, n);
}
function Bw(e, n) {
  return Bw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Bw(e, n);
}
function $me(e) {
  var n = Bme();
  return function() {
    var o = Op(e), s;
    if (n) {
      var u = Op(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Lme(this, s);
  };
}
function Lme(e, n) {
  return n && (Sf(n) === "object" || typeof n == "function") ? n : jme(e);
}
function jme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bme() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Op(e) {
  return Op = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Op(e);
}
var kd = /* @__PURE__ */ function(e) {
  Nme(r, e);
  var n = $me(r);
  function r() {
    return Ome(this, r), n.apply(this, arguments);
  }
  return Rme(r, [{
    key: "render",
    value: function() {
      var s = this.props, u = s.cx, h = s.cy, f = s.r, p = s.className, v = Ce("recharts-dot", p);
      return u === +u && h === +h && f === +f ? /* @__PURE__ */ M("circle", {
        ...Ye(this.props),
        ...Qf(this.props),
        className: v,
        cx: u,
        cy: h,
        r: f
      }) : null;
    }
  }]), r;
}(Ln);
function Mf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mf = function(r) {
    return typeof r;
  } : Mf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Mf(e);
}
function Fme(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function MT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function zme(e, n, r) {
  return n && MT(e.prototype, n), r && MT(e, r), e;
}
function Vme(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Fw(e, n);
}
function Fw(e, n) {
  return Fw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Fw(e, n);
}
function Hme(e) {
  var n = Gme();
  return function() {
    var o = Rp(e), s;
    if (n) {
      var u = Rp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Ume(this, s);
  };
}
function Ume(e, n) {
  return n && (Mf(n) === "object" || typeof n == "function") ? n : Wme(e);
}
function Wme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gme() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Rp(e) {
  return Rp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Rp(e);
}
var f7 = /* @__PURE__ */ function(e) {
  Vme(r, e);
  var n = Hme(r);
  function r() {
    return Fme(this, r), n.apply(this, arguments);
  }
  return zme(r, [{
    key: "render",
    value: function() {
      var s = this.props, u = s.x, h = s.y, f = s.width, p = s.height, v = s.top, b = s.left, y = s.className;
      return !Oe(u) || !Oe(h) || !Oe(f) || !Oe(p) || !Oe(v) || !Oe(b) ? null : /* @__PURE__ */ M("path", {
        ...Ye(this.props, !0),
        className: Ce("recharts-cross", y),
        d: r.getPath(u, h, f, p, v, b)
      });
    }
  }], [{
    key: "getPath",
    value: function(s, u, h, f, p, v) {
      return "M".concat(s, ",").concat(p, "v").concat(f, "M").concat(v, ",").concat(u, "h").concat(h);
    }
  }]), r;
}(Ln);
f7.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
var qme = Fg, Kme = ko, Yme = q3;
function Qme(e, n) {
  return e && e.length ? qme(e, Kme(n), Yme) : void 0;
}
var Zme = Qme, Xme = Fg, Jme = G3, e0e = ko;
function t0e(e, n) {
  return e && e.length ? Xme(e, e0e(n), Jme) : void 0;
}
var n0e = t0e;
function Tf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Tf = function(r) {
    return typeof r;
  } : Tf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Tf(e);
}
function TT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function fs(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? TT(Object(r), !0).forEach(function(o) {
      r0e(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : TT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function r0e(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function DT(e, n) {
  if (e == null)
    return {};
  var r = i0e(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function i0e(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function o0e(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function IT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function a0e(e, n, r) {
  return n && IT(e.prototype, n), r && IT(e, r), e;
}
function s0e(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && zw(e, n);
}
function zw(e, n) {
  return zw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, zw(e, n);
}
function l0e(e) {
  var n = d0e();
  return function() {
    var o = Np(e), s;
    if (n) {
      var u = Np(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return c0e(this, s);
  };
}
function c0e(e, n) {
  return n && (Tf(n) === "object" || typeof n == "function") ? n : u0e(e);
}
function u0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function d0e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Np(e) {
  return Np = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Np(e);
}
var Xg = /* @__PURE__ */ function(e) {
  s0e(r, e);
  var n = l0e(r);
  function r() {
    return o0e(this, r), n.apply(this, arguments);
  }
  return a0e(r, [{
    key: "getTickValueCoord",
    value: function(s) {
      var u = s.coordinate, h = this.props, f = h.angle, p = h.cx, v = h.cy;
      return dn(p, v, u, f);
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var s = this.props.orientation, u;
      switch (s) {
        case "left":
          u = "end";
          break;
        case "right":
          u = "start";
          break;
        default:
          u = "middle";
          break;
      }
      return u;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var s = this.props, u = s.cx, h = s.cy, f = s.angle, p = s.ticks, v = n0e(p, function(y) {
        return y.coordinate || 0;
      }), b = Zme(p, function(y) {
        return y.coordinate || 0;
      });
      return {
        cx: u,
        cy: h,
        startAngle: f,
        endAngle: f,
        innerRadius: b.coordinate || 0,
        outerRadius: v.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var s = this.props, u = s.cx, h = s.cy, f = s.angle, p = s.ticks, v = s.axisLine, b = DT(s, ["cx", "cy", "angle", "ticks", "axisLine"]), y = p.reduce(function(x, D) {
        return [Math.min(x[0], D.coordinate), Math.max(x[1], D.coordinate)];
      }, [1 / 0, -1 / 0]), k = dn(u, h, y[0], f), _ = dn(u, h, y[1], f), E = fs(fs(fs({}, Ye(b)), {}, {
        fill: "none"
      }, Ye(v)), {}, {
        x1: k.x,
        y1: k.y,
        x2: _.x,
        y2: _.y
      });
      return /* @__PURE__ */ M("line", {
        className: "recharts-polar-radius-axis-line",
        ...E
      });
    }
  }, {
    key: "renderTicks",
    value: function() {
      var s = this, u = this.props, h = u.ticks, f = u.tick, p = u.angle, v = u.tickFormatter, b = u.stroke, y = DT(u, ["ticks", "tick", "angle", "tickFormatter", "stroke"]), k = this.getTickTextAnchor(), _ = Ye(y), E = Ye(f), x = h.map(function(D, I) {
        var N = s.getTickValueCoord(D), O = fs(fs(fs(fs({
          textAnchor: k,
          transform: "rotate(".concat(90 - p, ", ").concat(N.x, ", ").concat(N.y, ")")
        }, _), {}, {
          stroke: "none",
          fill: b
        }, E), {}, {
          index: I
        }, N), {}, {
          payload: D
        });
        return /* @__PURE__ */ M(mt, {
          className: "recharts-polar-radius-axis-tick",
          ...Ia(s.props, D, I),
          children: r.renderTickItem(f, O, v ? v(D.value, I) : D.value)
        }, "tick-".concat(I));
      });
      return /* @__PURE__ */ M(mt, {
        className: "recharts-polar-radius-axis-ticks",
        children: x
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.ticks, h = s.axisLine, f = s.tick;
      return !u || !u.length ? null : /* @__PURE__ */ K(mt, {
        className: "recharts-polar-radius-axis",
        children: [h && this.renderAxisLine(), f && this.renderTicks(), Vn.renderCallByParent(this.props, this.getViewBox())]
      });
    }
  }], [{
    key: "renderTickItem",
    value: function(s, u, h) {
      var f;
      return /* @__PURE__ */ oe.isValidElement(s) ? f = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? f = s(u) : f = /* @__PURE__ */ M(Oa, {
        ...u,
        className: "recharts-polar-radius-axis-tick-value",
        children: h
      }), f;
    }
  }]), r;
}(Ln);
Xg.displayName = "PolarRadiusAxis";
Xg.axisType = "radiusAxis";
Xg.defaultProps = {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  domain: [0, "auto"],
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
};
function Df(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Df = function(r) {
    return typeof r;
  } : Df = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Df(e);
}
function PT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function ps(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? PT(Object(r), !0).forEach(function(o) {
      h0e(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : PT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function h0e(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function f0e(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function OT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function p0e(e, n, r) {
  return n && OT(e.prototype, n), r && OT(e, r), e;
}
function g0e(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Vw(e, n);
}
function Vw(e, n) {
  return Vw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Vw(e, n);
}
function m0e(e) {
  var n = w0e();
  return function() {
    var o = $p(e), s;
    if (n) {
      var u = $p(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return v0e(this, s);
  };
}
function v0e(e, n) {
  return n && (Df(n) === "object" || typeof n == "function") ? n : b0e(e);
}
function b0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function w0e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $p(e) {
  return $p = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, $p(e);
}
var y0e = Math.PI / 180, RT = 1e-5, Jg = /* @__PURE__ */ function(e) {
  g0e(r, e);
  var n = m0e(r);
  function r() {
    return f0e(this, r), n.apply(this, arguments);
  }
  return p0e(r, [{
    key: "getTickLineCoord",
    value: function(s) {
      var u = this.props, h = u.cx, f = u.cy, p = u.radius, v = u.orientation, b = u.tickSize, y = b || 8, k = dn(h, f, p, s.coordinate), _ = dn(h, f, p + (v === "inner" ? -1 : 1) * y, s.coordinate);
      return {
        x1: k.x,
        y1: k.y,
        x2: _.x,
        y2: _.y
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function(s) {
      var u = this.props.orientation, h = Math.cos(-s.coordinate * y0e), f;
      return h > RT ? f = u === "outer" ? "start" : "end" : h < -RT ? f = u === "outer" ? "end" : "start" : f = "middle", f;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var s = this.props, u = s.cx, h = s.cy, f = s.radius, p = s.axisLine, v = s.axisLineType, b = ps(ps({}, Ye(this.props)), {}, {
        fill: "none"
      }, Ye(p));
      if (v === "circle")
        return /* @__PURE__ */ M(kd, {
          className: "recharts-polar-angle-axis-line",
          ...b,
          cx: u,
          cy: h,
          r: f
        });
      var y = this.props.ticks, k = y.map(function(_) {
        return dn(u, h, f, _.coordinate);
      });
      return /* @__PURE__ */ M(Pme, {
        className: "recharts-polar-angle-axis-line",
        ...b,
        points: k
      });
    }
  }, {
    key: "renderTicks",
    value: function() {
      var s = this, u = this.props, h = u.ticks, f = u.tick, p = u.tickLine, v = u.tickFormatter, b = u.stroke, y = Ye(this.props), k = Ye(f), _ = ps(ps({}, y), {}, {
        fill: "none"
      }, Ye(p)), E = h.map(function(x, D) {
        var I = s.getTickLineCoord(x), N = s.getTickTextAnchor(x), O = ps(ps(ps({
          textAnchor: N
        }, y), {}, {
          stroke: "none",
          fill: b
        }, k), {}, {
          index: D,
          payload: x,
          x: I.x2,
          y: I.y2
        });
        return /* @__PURE__ */ K(mt, {
          className: "recharts-polar-angle-axis-tick",
          ...Ia(s.props, x, D),
          children: [p && /* @__PURE__ */ M("line", {
            className: "recharts-polar-angle-axis-tick-line",
            ..._,
            ...I
          }), f && r.renderTickItem(f, O, v ? v(x.value, D) : x.value)]
        }, "tick-".concat(D));
      });
      return /* @__PURE__ */ M(mt, {
        className: "recharts-polar-angle-axis-ticks",
        children: E
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.ticks, h = s.radius, f = s.axisLine;
      return h <= 0 || !u || !u.length ? null : /* @__PURE__ */ K(mt, {
        className: "recharts-polar-angle-axis",
        children: [f && this.renderAxisLine(), this.renderTicks()]
      });
    }
  }], [{
    key: "renderTickItem",
    value: function(s, u, h) {
      var f;
      return /* @__PURE__ */ oe.isValidElement(s) ? f = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? f = s(u) : f = /* @__PURE__ */ M(Oa, {
        ...u,
        className: "recharts-polar-angle-axis-tick-value",
        children: h
      }), f;
    }
  }]), r;
}(Ln);
Jg.displayName = "PolarAngleAxis";
Jg.axisType = "angleAxis";
Jg.defaultProps = {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  domain: [0, "auto"],
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
};
var k0e = GI, _0e = k0e(Object.getPrototypeOf, Object), A0e = _0e, C0e = Jo, x0e = A0e, E0e = ea, S0e = "[object Object]", M0e = Function.prototype, T0e = Object.prototype, p7 = M0e.toString, D0e = T0e.hasOwnProperty, I0e = p7.call(Object);
function P0e(e) {
  if (!E0e(e) || C0e(e) != S0e)
    return !1;
  var n = x0e(e);
  if (n === null)
    return !0;
  var r = D0e.call(n, "constructor") && n.constructor;
  return typeof r == "function" && r instanceof r && p7.call(r) == I0e;
}
var O0e = P0e;
function If(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? If = function(r) {
    return typeof r;
  } : If = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, If(e);
}
function NT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function kn(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? NT(Object(r), !0).forEach(function(o) {
      R0e(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : NT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function R0e(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function N0e(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function $T(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function $0e(e, n, r) {
  return n && $T(e.prototype, n), r && $T(e, r), e;
}
function L0e(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Hw(e, n);
}
function Hw(e, n) {
  return Hw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Hw(e, n);
}
function j0e(e) {
  var n = z0e();
  return function() {
    var o = Lp(e), s;
    if (n) {
      var u = Lp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return B0e(this, s);
  };
}
function B0e(e, n) {
  return n && (If(n) === "object" || typeof n == "function") ? n : F0e(e);
}
function F0e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function z0e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Lp(e) {
  return Lp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Lp(e);
}
var Ti = /* @__PURE__ */ function(e) {
  L0e(r, e);
  var n = j0e(r);
  function r(o) {
    var s;
    return N0e(this, r), s = n.call(this, o), s.pieRef = null, s.sectorRefs = [], s.state = void 0, s.id = La("recharts-pie-"), s.handleAnimationEnd = function() {
      var u = s.props.onAnimationEnd;
      s.setState({
        isAnimationFinished: !0
      }), qe(u) && u();
    }, s.handleAnimationStart = function() {
      var u = s.props.onAnimationStart;
      s.setState({
        isAnimationFinished: !1
      }), qe(u) && u();
    }, s.state = {
      isAnimationFinished: !o.isAnimationActive,
      prevIsAnimationActive: o.isAnimationActive,
      prevAnimationId: o.animationId,
      sectorToFocus: 0
    }, s;
  }
  return $0e(r, [{
    key: "isActiveIndex",
    value: function(s) {
      var u = this.props.activeIndex;
      return Array.isArray(u) ? u.indexOf(s) !== -1 : s === u;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var s = this.props.activeIndex;
      return Array.isArray(s) ? s.length !== 0 : s || s === 0;
    }
  }, {
    key: "renderLabels",
    value: function(s) {
      var u = this.props.isAnimationActive;
      if (u && !this.state.isAnimationFinished)
        return null;
      var h = this.props, f = h.label, p = h.labelLine, v = h.dataKey, b = h.valueKey, y = Ye(this.props), k = Ye(f), _ = Ye(p), E = f && f.offsetRadius || 20, x = s.map(function(D, I) {
        var N = (D.startAngle + D.endAngle) / 2, O = dn(D.cx, D.cy, D.outerRadius + E, N), P = kn(kn(kn(kn({}, y), D), {}, {
          stroke: "none"
        }, k), {}, {
          index: I,
          textAnchor: r.getTextAnchor(O.x, D.cx)
        }, O), S = kn(kn(kn(kn({}, y), D), {}, {
          fill: "none",
          stroke: D.fill
        }, _), {}, {
          index: I,
          points: [dn(D.cx, D.cy, D.outerRadius, N), O],
          key: "line"
        }), $ = v;
        return Be(v) && Be(b) ? $ = "value" : Be(v) && ($ = b), /* @__PURE__ */ K(mt, {
          children: [p && r.renderLabelLineItem(p, S), r.renderLabelItem(f, P, mn(D, $))]
        }, "label-".concat(I));
      });
      return /* @__PURE__ */ M(mt, {
        className: "recharts-pie-labels",
        children: x
      });
    }
  }, {
    key: "renderSectorsStatically",
    value: function(s) {
      var u = this, h = this.props, f = h.activeShape, p = h.blendStroke, v = h.inactiveShape;
      return s.map(function(b, y) {
        var k = v && u.hasActiveIndex() ? v : null, _ = u.isActiveIndex(y) ? f : k, E = kn(kn({}, b), {}, {
          stroke: p ? b.fill : b.stroke
        });
        return /* @__PURE__ */ hi(mt, {
          ref: function(D) {
            D && !u.sectorRefs.includes(D) && u.sectorRefs.push(D);
          },
          tabIndex: -1,
          className: "recharts-pie-sector",
          ...Ia(u.props, b, y),
          key: "sector-".concat(y)
        }, r.renderSectorItem(_, E));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var s = this, u = this.props, h = u.sectors, f = u.isAnimationActive, p = u.animationBegin, v = u.animationDuration, b = u.animationEasing, y = u.animationId, k = this.state, _ = k.prevSectors, E = k.prevIsAnimationActive;
      return /* @__PURE__ */ M(mo, {
        begin: p,
        duration: v,
        isActive: f,
        easing: b,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd,
        children: function(x) {
          var D = x.t, I = [], N = h && h[0], O = N.startAngle;
          return h.forEach(function(P, S) {
            var $ = _ && _[S], L = S > 0 ? Hn(P, "paddingAngle", 0) : 0;
            if ($) {
              var B = Sn($.endAngle - $.startAngle, P.endAngle - P.startAngle), U = kn(kn({}, P), {}, {
                startAngle: O + L,
                endAngle: O + B(D) + L
              });
              I.push(U), O = U.endAngle;
            } else {
              var G = P.endAngle, q = P.startAngle, Y = Sn(0, G - q), Q = Y(D), Z = kn(kn({}, P), {}, {
                startAngle: O + L,
                endAngle: O + Q + L
              });
              I.push(Z), O = Z.endAngle;
            }
          }), /* @__PURE__ */ M(mt, {
            children: s.renderSectorsStatically(I)
          });
        }
      }, "pie-".concat(y, "-").concat(E));
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(s) {
      var u = this;
      s.onkeydown = function(h) {
        if (!h.altKey)
          switch (h.key) {
            case "ArrowLeft": {
              var f = ++u.state.sectorToFocus % u.sectorRefs.length;
              u.sectorRefs[f].focus(), u.setState({
                sectorToFocus: f
              });
              break;
            }
            case "ArrowRight": {
              var p = --u.state.sectorToFocus < 0 ? u.sectorRefs.length - 1 : u.state.sectorToFocus % u.sectorRefs.length;
              u.sectorRefs[p].focus(), u.setState({
                sectorToFocus: p
              });
              break;
            }
            case "Escape": {
              u.sectorRefs[u.state.sectorToFocus].blur(), u.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var s = this.props, u = s.sectors, h = s.isAnimationActive, f = this.state.prevSectors;
      return h && u && u.length && (!f || !Rs(f, u)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(u);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var s = this, u = this.props, h = u.hide, f = u.sectors, p = u.className, v = u.label, b = u.cx, y = u.cy, k = u.innerRadius, _ = u.outerRadius, E = u.isAnimationActive, x = this.state.isAnimationFinished;
      if (h || !f || !f.length || !Oe(b) || !Oe(y) || !Oe(k) || !Oe(_))
        return null;
      var D = Ce("recharts-pie", p);
      return /* @__PURE__ */ K(mt, {
        tabIndex: 0,
        className: D,
        ref: function(N) {
          s.pieRef = N;
        },
        children: [this.renderSectors(), v && this.renderLabels(f), Vn.renderCallByParent(this.props, null, !1), (!E || x) && ui.renderCallByParent(this.props, f, !1)]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      return u.prevIsAnimationActive !== s.isAnimationActive ? {
        prevIsAnimationActive: s.isAnimationActive,
        prevAnimationId: s.animationId,
        curSectors: s.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : s.isAnimationActive && s.animationId !== u.prevAnimationId ? {
        prevAnimationId: s.animationId,
        curSectors: s.sectors,
        prevSectors: u.curSectors,
        isAnimationFinished: !0
      } : s.sectors !== u.curSectors ? {
        curSectors: s.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(s, u) {
      return s > u ? "start" : s < u ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(s, u) {
      return /* @__PURE__ */ oe.isValidElement(s) ? /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? s(u) : /* @__PURE__ */ M(Go, {
        ...u,
        type: "linear",
        className: "recharts-pie-label-line"
      });
    }
  }, {
    key: "renderLabelItem",
    value: function(s, u, h) {
      if (/* @__PURE__ */ oe.isValidElement(s))
        return /* @__PURE__ */ oe.cloneElement(s, u);
      var f = h;
      return qe(s) && (f = s(u), /* @__PURE__ */ oe.isValidElement(f)) ? f : /* @__PURE__ */ M(Oa, {
        ...u,
        alignmentBaseline: "middle",
        className: "recharts-pie-label-text",
        children: f
      });
    }
  }, {
    key: "renderSectorItem",
    value: function(s, u) {
      return /* @__PURE__ */ oe.isValidElement(s) ? /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? s(u) : O0e(s) ? /* @__PURE__ */ M(Zl, {
        tabIndex: -1,
        ...u,
        ...s
      }) : /* @__PURE__ */ M(Zl, {
        tabIndex: -1,
        ...u
      });
    }
  }]), r;
}(Ln);
Ti.displayName = "Pie";
Ti.defaultProps = {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !ci.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1
};
Ti.parseDeltaAngle = function(e, n) {
  var r = pr(n - e), o = Math.min(Math.abs(n - e), 360);
  return r * o;
};
Ti.getRealPieData = function(e) {
  var n = e.props, r = n.data, o = n.children, s = Ye(e.props), u = yr(o, Bg.displayName);
  return r && r.length ? r.map(function(h, f) {
    return kn(kn(kn({
      payload: h
    }, s), h), u && u[f] && u[f].props);
  }) : u && u.length ? u.map(function(h) {
    return kn(kn({}, s), h.props);
  }) : [];
};
Ti.parseCoordinateOfPie = function(e, n) {
  var r = n.top, o = n.left, s = n.width, u = n.height, h = u7(s, u), f = o + Sr(e.props.cx, s, s / 2), p = r + Sr(e.props.cy, u, u / 2), v = Sr(e.props.innerRadius, h, 0), b = Sr(e.props.outerRadius, h, h * 0.8), y = e.props.maxRadius || Math.sqrt(s * s + u * u) / 2;
  return {
    cx: f,
    cy: p,
    innerRadius: v,
    outerRadius: b,
    maxRadius: y
  };
};
Ti.getComposedData = function(e) {
  var n = e.item, r = e.offset, o = Ti.getRealPieData(n);
  if (!o || !o.length)
    return null;
  var s = n.props, u = s.cornerRadius, h = s.startAngle, f = s.endAngle, p = s.paddingAngle, v = s.dataKey, b = s.nameKey, y = s.valueKey, k = s.tooltipType, _ = Math.abs(n.props.minAngle), E = Ti.parseCoordinateOfPie(n, r), x = Ti.parseDeltaAngle(h, f), D = Math.abs(x), I = v;
  Be(v) && Be(y) ? (qu(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), I = "value") : Be(v) && (qu(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), I = y);
  var N = o.filter(function(B) {
    return mn(B, I, 0) !== 0;
  }).length, O = (D >= 360 ? N : N - 1) * p, P = D - N * _ - O, S = o.reduce(function(B, U) {
    var G = mn(U, I, 0);
    return B + (Oe(G) ? G : 0);
  }, 0), $;
  if (S > 0) {
    var L;
    $ = o.map(function(B, U) {
      var G = mn(B, I, 0), q = mn(B, b, U), Y = (Oe(G) ? G : 0) / S, Q;
      U ? Q = L.endAngle + pr(x) * p * (G !== 0 ? 1 : 0) : Q = h;
      var Z = Q + pr(x) * ((G !== 0 ? _ : 0) + Y * P), ae = (Q + Z) / 2, ie = (E.innerRadius + E.outerRadius) / 2, pe = [{
        name: q,
        value: G,
        payload: B,
        dataKey: I,
        type: k
      }], ce = dn(E.cx, E.cy, ie, ae);
      return L = kn(kn(kn({
        percent: Y,
        cornerRadius: u,
        name: q,
        tooltipPayload: pe,
        midAngle: ae,
        middleRadius: ie,
        tooltipPosition: ce
      }, B), E), {}, {
        value: mn(B, I),
        startAngle: Q,
        endAngle: Z,
        payload: B,
        paddingAngle: pr(x) * p
      }), L;
    });
  }
  return kn(kn({}, E), {}, {
    sectors: $,
    data: o
  });
};
var V0e = Math.ceil, H0e = Math.max;
function U0e(e, n, r, o) {
  for (var s = -1, u = H0e(V0e((n - e) / (r || 1)), 0), h = Array(u); u--; )
    h[o ? u : ++s] = e, e += r;
  return h;
}
var W0e = U0e, G0e = L3, LT = 1 / 0, q0e = 17976931348623157e292;
function K0e(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = G0e(e), e === LT || e === -LT) {
    var n = e < 0 ? -1 : 1;
    return n * q0e;
  }
  return e === e ? e : 0;
}
var g7 = K0e, Y0e = W0e, Q0e = jg, ob = g7;
function Z0e(e) {
  return function(n, r, o) {
    return o && typeof o != "number" && Q0e(n, r, o) && (r = o = void 0), n = ob(n), r === void 0 ? (r = n, n = 0) : r = ob(r), o = o === void 0 ? n < r ? 1 : -1 : ob(o), Y0e(n, r, o, e);
  };
}
var X0e = Z0e, J0e = X0e, eve = J0e(), jp = eve;
function jT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function BT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? jT(Object(r), !0).forEach(function(o) {
      m7(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function m7(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
var tve = ["Webkit", "Moz", "O", "ms"], nve = function(n, r) {
  if (!n)
    return null;
  var o = n.replace(/(\w)/, function(u) {
    return u.toUpperCase();
  }), s = tve.reduce(function(u, h) {
    return BT(BT({}, u), {}, m7({}, h + o, r));
  }, {});
  return s[n] = r, s;
};
function Pf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Pf = function(r) {
    return typeof r;
  } : Pf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Pf(e);
}
function FT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function ab(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? FT(Object(r), !0).forEach(function(o) {
      Uw(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : FT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Uw(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function rve(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function zT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function ive(e, n, r) {
  return n && zT(e.prototype, n), r && zT(e, r), e;
}
function ove(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Ww(e, n);
}
function Ww(e, n) {
  return Ww = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Ww(e, n);
}
function ave(e) {
  var n = lve();
  return function() {
    var o = Bp(e), s;
    if (n) {
      var u = Bp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return sve(this, s);
  };
}
function sve(e, n) {
  return n && (Pf(n) === "object" || typeof n == "function") ? n : Gw(e);
}
function Gw(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lve() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Bp(e) {
  return Bp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Bp(e);
}
var cve = function(n) {
  var r = n.data, o = n.startIndex, s = n.endIndex, u = n.x, h = n.width, f = n.travellerWidth;
  if (!r || !r.length)
    return {};
  var p = r.length, v = Fu().domain(jp(0, p)).range([u, u + h - f]), b = v.domain().map(function(y) {
    return v(y);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    startX: v(o),
    endX: v(s),
    scale: v,
    scaleValues: b
  };
}, VT = function(n) {
  return n.changedTouches && !!n.changedTouches.length;
}, Bs = /* @__PURE__ */ function(e) {
  ove(r, e);
  var n = ave(r);
  function r(o) {
    var s;
    return rve(this, r), s = n.call(this, o), s.leaveTimer = void 0, s.travellerDragStartHandlers = void 0, s.handleDrag = function(u) {
      s.leaveTimer && (clearTimeout(s.leaveTimer), s.leaveTimer = null), s.state.isTravellerMoving ? s.handleTravellerMove(u) : s.state.isSlideMoving && s.handleSlideDrag(u);
    }, s.handleTouchMove = function(u) {
      u.changedTouches != null && u.changedTouches.length > 0 && s.handleDrag(u.changedTouches[0]);
    }, s.handleDragEnd = function() {
      s.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }), s.detachDragEndListener();
    }, s.handleLeaveWrapper = function() {
      (s.state.isTravellerMoving || s.state.isSlideMoving) && (s.leaveTimer = window.setTimeout(s.handleDragEnd, s.props.leaveTimeOut));
    }, s.handleEnterSlideOrTraveller = function() {
      s.setState({
        isTextActive: !0
      });
    }, s.handleLeaveSlideOrTraveller = function() {
      s.setState({
        isTextActive: !1
      });
    }, s.handleSlideDragStart = function(u) {
      var h = VT(u) ? u.changedTouches[0] : u;
      s.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: h.pageX
      }), s.attachDragEndListener();
    }, s.travellerDragStartHandlers = {
      startX: s.handleTravellerDragStart.bind(Gw(s), "startX"),
      endX: s.handleTravellerDragStart.bind(Gw(s), "endX")
    }, s.state = {}, s;
  }
  return ive(r, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(s) {
      var u = s.startX, h = s.endX, f = this.state.scaleValues, p = this.props, v = p.gap, b = p.data, y = b.length - 1, k = Math.min(u, h), _ = Math.max(u, h), E = r.getIndexInRange(f, k), x = r.getIndexInRange(f, _);
      return {
        startIndex: E - E % v,
        endIndex: x === y ? y : x - x % v
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(s) {
      var u = this.props, h = u.data, f = u.tickFormatter, p = u.dataKey, v = mn(h[s], p, s);
      return qe(f) ? f(v, s) : v;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(s) {
      var u = this.state, h = u.slideMoveStartX, f = u.startX, p = u.endX, v = this.props, b = v.x, y = v.width, k = v.travellerWidth, _ = v.startIndex, E = v.endIndex, x = v.onChange, D = s.pageX - h;
      D > 0 ? D = Math.min(D, b + y - k - p, b + y - k - f) : D < 0 && (D = Math.max(D, b - f, b - p));
      var I = this.getIndex({
        startX: f + D,
        endX: p + D
      });
      (I.startIndex !== _ || I.endIndex !== E) && x && x(I), this.setState({
        startX: f + D,
        endX: p + D,
        slideMoveStartX: s.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(s, u) {
      var h = VT(u) ? u.changedTouches[0] : u;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: s,
        brushMoveStartX: h.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(s) {
      var u, h = this.state, f = h.brushMoveStartX, p = h.movingTravellerId, v = h.endX, b = h.startX, y = this.state[p], k = this.props, _ = k.x, E = k.width, x = k.travellerWidth, D = k.onChange, I = k.gap, N = k.data, O = {
        startX: this.state.startX,
        endX: this.state.endX
      }, P = s.pageX - f;
      P > 0 ? P = Math.min(P, _ + E - x - y) : P < 0 && (P = Math.max(P, _ - y)), O[p] = y + P;
      var S = this.getIndex(O), $ = S.startIndex, L = S.endIndex, B = function() {
        var G = N.length - 1;
        return p === "startX" && (v > b ? $ % I === 0 : L % I === 0) || v < b && L === G || p === "endX" && (v > b ? L % I === 0 : $ % I === 0) || v > b && L === G;
      };
      this.setState((u = {}, Uw(u, p, y + P), Uw(u, "brushMoveStartX", s.pageX), u), function() {
        D && B() && D(S);
      });
    }
  }, {
    key: "renderBackground",
    value: function() {
      var s = this.props, u = s.x, h = s.y, f = s.width, p = s.height, v = s.fill, b = s.stroke;
      return /* @__PURE__ */ M("rect", {
        stroke: b,
        fill: v,
        x: u,
        y: h,
        width: f,
        height: p
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var s = this.props, u = s.x, h = s.y, f = s.width, p = s.height, v = s.data, b = s.children, y = s.padding, k = xs.only(b);
      return k ? /* @__PURE__ */ oe.cloneElement(k, {
        x: u,
        y: h,
        width: f,
        height: p,
        margin: y,
        compact: !0,
        data: v
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(s, u) {
      var h = this.props, f = h.y, p = h.travellerWidth, v = h.height, b = h.traveller, y = Math.max(s, this.props.x), k = ab(ab({}, Ye(this.props)), {}, {
        x: y,
        y: f,
        width: p,
        height: v
      });
      return /* @__PURE__ */ M(mt, {
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[u],
        onTouchStart: this.travellerDragStartHandlers[u],
        style: {
          cursor: "col-resize"
        },
        children: r.renderTraveller(b, k)
      });
    }
  }, {
    key: "renderSlide",
    value: function(s, u) {
      var h = this.props, f = h.y, p = h.height, v = h.stroke, b = h.travellerWidth, y = Math.min(s, u) + b, k = Math.max(Math.abs(u - s) - b, 0);
      return /* @__PURE__ */ M("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: v,
        fillOpacity: 0.2,
        x: y,
        y: f,
        width: k,
        height: p
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var s = this.props, u = s.startIndex, h = s.endIndex, f = s.y, p = s.height, v = s.travellerWidth, b = s.stroke, y = this.state, k = y.startX, _ = y.endX, E = 5, x = {
        pointerEvents: "none",
        fill: b
      };
      return /* @__PURE__ */ K(mt, {
        className: "recharts-brush-texts",
        children: [/* @__PURE__ */ M(Oa, {
          textAnchor: "end",
          verticalAnchor: "middle",
          x: Math.min(k, _) - E,
          y: f + p / 2,
          ...x,
          children: this.getTextOfTick(u)
        }), /* @__PURE__ */ M(Oa, {
          textAnchor: "start",
          verticalAnchor: "middle",
          x: Math.max(k, _) + v + E,
          y: f + p / 2,
          ...x,
          children: this.getTextOfTick(h)
        })]
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.data, h = s.className, f = s.children, p = s.x, v = s.y, b = s.width, y = s.height, k = s.alwaysShowText, _ = this.state, E = _.startX, x = _.endX, D = _.isTextActive, I = _.isSlideMoving, N = _.isTravellerMoving;
      if (!u || !u.length || !Oe(p) || !Oe(v) || !Oe(b) || !Oe(y) || b <= 0 || y <= 0)
        return null;
      var O = Ce("recharts-brush", h), P = oe.Children.count(f) === 1, S = nve("userSelect", "none");
      return /* @__PURE__ */ K(mt, {
        className: O,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: S,
        children: [this.renderBackground(), P && this.renderPanorama(), this.renderSlide(E, x), this.renderTravellerLayer(E, "startX"), this.renderTravellerLayer(x, "endX"), (D || I || N || k) && this.renderText()]
      });
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(s) {
      var u = s.x, h = s.y, f = s.width, p = s.height, v = s.stroke, b = Math.floor(h + p / 2) - 1;
      return /* @__PURE__ */ K(bo, {
        children: [/* @__PURE__ */ M("rect", {
          x: u,
          y: h,
          width: f,
          height: p,
          fill: v,
          stroke: "none"
        }), /* @__PURE__ */ M("line", {
          x1: u + 1,
          y1: b,
          x2: u + f - 1,
          y2: b,
          fill: "none",
          stroke: "#fff"
        }), /* @__PURE__ */ M("line", {
          x1: u + 1,
          y1: b + 2,
          x2: u + f - 1,
          y2: b + 2,
          fill: "none",
          stroke: "#fff"
        })]
      });
    }
  }, {
    key: "renderTraveller",
    value: function(s, u) {
      var h;
      return /* @__PURE__ */ oe.isValidElement(s) ? h = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? h = s(u) : h = r.renderDefaultTraveller(u), h;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      var h = s.data, f = s.width, p = s.x, v = s.travellerWidth, b = s.updateId, y = s.startIndex, k = s.endIndex;
      if (h !== u.prevData || b !== u.prevUpdateId)
        return ab({
          prevData: h,
          prevTravellerWidth: v,
          prevUpdateId: b,
          prevX: p,
          prevWidth: f
        }, h && h.length ? cve({
          data: h,
          width: f,
          x: p,
          travellerWidth: v,
          startIndex: y,
          endIndex: k
        }) : {
          scale: null,
          scaleValues: null
        });
      if (u.scale && (f !== u.prevWidth || p !== u.prevX || v !== u.prevTravellerWidth)) {
        u.scale.range([p, p + f - v]);
        var _ = u.scale.domain().map(function(E) {
          return u.scale(E);
        });
        return {
          prevData: h,
          prevTravellerWidth: v,
          prevUpdateId: b,
          prevX: p,
          prevWidth: f,
          startX: u.scale(s.startIndex),
          endX: u.scale(s.endIndex),
          scaleValues: _
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(s, u) {
      for (var h = s.length, f = 0, p = h - 1; p - f > 1; ) {
        var v = Math.floor((f + p) / 2);
        s[v] > u ? p = v : f = v;
      }
      return u >= s[p] ? p : f;
    }
  }]), r;
}(Ln);
Bs.displayName = "Brush";
Bs.defaultProps = {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
};
var uve = Iy;
function dve(e, n) {
  var r;
  return uve(e, function(o, s, u) {
    return r = n(o, s, u), !r;
  }), !!r;
}
var hve = dve, fve = BI, pve = ko, gve = hve, mve = Tt, vve = jg;
function bve(e, n, r) {
  var o = mve(e) ? fve : gve;
  return r && vve(e, n, r) && (n = void 0), o(e, pve(n));
}
var wve = bve, po = function(n, r) {
  var o = n.alwaysShow, s = n.ifOverflow;
  return o && (s = "extendDomain"), s === r;
};
function yve(e, n) {
  for (var r = -1, o = e == null ? 0 : e.length; ++r < o; )
    if (!n(e[r], r, e))
      return !1;
  return !0;
}
var kve = yve, _ve = Iy;
function Ave(e, n) {
  var r = !0;
  return _ve(e, function(o, s, u) {
    return r = !!n(o, s, u), r;
  }), r;
}
var Cve = Ave, xve = kve, Eve = Cve, Sve = ko, Mve = Tt, Tve = jg;
function Dve(e, n, r) {
  var o = Mve(e) ? xve : Eve;
  return r && Tve(e, n, r) && (n = void 0), o(e, Sve(n));
}
var v7 = Dve, HT = $3;
function Ive(e, n, r) {
  n == "__proto__" && HT ? HT(e, n, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[n] = r;
}
var Pve = Ive, Ove = Pve, Rve = R3, Nve = ko;
function $ve(e, n) {
  var r = {};
  return n = Nve(n), Rve(e, function(o, s, u) {
    Ove(r, s, n(o, s, u));
  }), r;
}
var Lve = $ve;
function jve(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function UT(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Bve(e, n, r) {
  return n && UT(e.prototype, n), r && UT(e, r), e;
}
function WT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Mi(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? WT(Object(r), !0).forEach(function(o) {
      nk(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : WT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function nk(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
var b7 = function(n, r, o, s, u) {
  var h = n.width, f = n.height, p = n.layout, v = n.children, b = Object.keys(r), y = {
    left: o.left,
    leftMirror: o.left,
    right: h - o.right,
    rightMirror: h - o.right,
    top: o.top,
    topMirror: o.top,
    bottom: f - o.bottom,
    bottomMirror: f - o.bottom
  }, k = !!Fo(v, "Bar");
  return b.reduce(function(_, E) {
    var x = r[E], D = x.orientation, I = x.domain, N = x.padding, O = N === void 0 ? {} : N, P = x.mirror, S = x.reversed, $ = "".concat(D).concat(P ? "Mirror" : ""), L, B, U, G, q;
    if (x.type === "number" && (x.padding === "gap" || x.padding === "no-gap")) {
      var Y = I[1] - I[0], Q = 1 / 0, Z = x.categoricalDomain.sort();
      Z.forEach(function(me, we) {
        we > 0 && (Q = Math.min((me || 0) - (Z[we - 1] || 0), Q));
      });
      var ae = Q / Y, ie = x.layout === "vertical" ? o.height : o.width;
      if (x.padding === "gap" && (L = ae * ie / 2), x.padding === "no-gap") {
        var pe = Sr(n.barCategoryGap, ae * ie), ce = ae * ie / 2;
        L = ce - pe - (ce - pe) / ie * pe;
      }
    }
    s === "xAxis" ? B = [o.left + (O.left || 0) + (L || 0), o.left + o.width - (O.right || 0) - (L || 0)] : s === "yAxis" ? B = p === "horizontal" ? [o.top + o.height - (O.bottom || 0), o.top + (O.top || 0)] : [o.top + (O.top || 0) + (L || 0), o.top + o.height - (O.bottom || 0) - (L || 0)] : B = x.range, S && (B = [B[1], B[0]]);
    var ue = r7(x, u, k), X = ue.scale, se = ue.realScaleType;
    X.domain(I).range(B), i7(X);
    var he = o7(X, Mi(Mi({}, x), {}, {
      realScaleType: se
    }));
    s === "xAxis" ? (q = D === "top" && !P || D === "bottom" && P, U = o.left, G = y[$] - q * x.height) : s === "yAxis" && (q = D === "left" && !P || D === "right" && P, U = y[$] - q * x.width, G = o.top);
    var de = Mi(Mi(Mi({}, x), he), {}, {
      realScaleType: se,
      x: U,
      y: G,
      scale: X,
      width: s === "xAxis" ? o.width : x.width,
      height: s === "yAxis" ? o.height : x.height
    });
    return de.bandSize = Sp(de, he), !x.hide && s === "xAxis" ? y[$] += (q ? -1 : 1) * de.height : x.hide || (y[$] += (q ? -1 : 1) * de.width), Mi(Mi({}, _), {}, nk({}, E, de));
  }, {});
}, w7 = function(n, r) {
  var o = n.x, s = n.y, u = r.x, h = r.y;
  return {
    x: Math.min(o, u),
    y: Math.min(s, h),
    width: Math.abs(u - o),
    height: Math.abs(h - s)
  };
}, Fve = function(n) {
  var r = n.x1, o = n.y1, s = n.x2, u = n.y2;
  return w7({
    x: r,
    y: o
  }, {
    x: s,
    y: u
  });
}, y7 = /* @__PURE__ */ function() {
  function e(n) {
    jve(this, e), this.scale = void 0, this.scale = n;
  }
  return Bve(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = o.bandAware, u = o.position;
      if (r !== void 0) {
        if (u)
          switch (u) {
            case "start":
              return this.scale(r);
            case "middle": {
              var h = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + h;
            }
            case "end": {
              var f = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + f;
            }
            default:
              return this.scale(r);
          }
        if (s) {
          var p = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + p;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var o = this.range(), s = o[0], u = o[o.length - 1];
      return s <= u ? r >= s && r <= u : r >= u && r <= s;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]), e;
}();
y7.EPS = 1e-4;
var rk = function(n) {
  var r = Object.keys(n).reduce(function(o, s) {
    return Mi(Mi({}, o), {}, nk({}, s, y7.create(n[s])));
  }, {});
  return Mi(Mi({}, r), {}, {
    apply: function(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = u.bandAware, f = u.position;
      return Lve(s, function(p, v) {
        return r[v].apply(p, {
          bandAware: h,
          position: f
        });
      });
    },
    isInRange: function(s) {
      return v7(s, function(u, h) {
        return r[h].isInRange(u);
      });
    }
  });
};
function GT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function qT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? GT(Object(r), !0).forEach(function(o) {
      zve(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : GT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function zve(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Vve(e, n) {
  return Gve(e) || Wve(e, n) || Uve(e, n) || Hve();
}
function Hve() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uve(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return KT(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return KT(e, n);
  }
}
function KT(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function Wve(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function Gve(e) {
  if (Array.isArray(e))
    return e;
}
var qve = function(n, r) {
  var o;
  return /* @__PURE__ */ oe.isValidElement(n) ? o = /* @__PURE__ */ oe.cloneElement(n, r) : qe(n) ? o = n(r) : o = /* @__PURE__ */ M("line", {
    ...r,
    className: "recharts-reference-line-line"
  }), o;
}, Kve = function(n, r, o, s, u) {
  var h = u.viewBox, f = h.x, p = h.y, v = h.width, b = h.height, y = u.position;
  if (o) {
    var k = u.y, _ = u.yAxis.orientation, E = n.y.apply(k, {
      position: y
    });
    if (po(u, "discard") && !n.y.isInRange(E))
      return null;
    var x = [{
      x: f + v,
      y: E
    }, {
      x: f,
      y: E
    }];
    return _ === "left" ? x.reverse() : x;
  }
  if (r) {
    var D = u.x, I = u.xAxis.orientation, N = n.x.apply(D, {
      position: y
    });
    if (po(u, "discard") && !n.x.isInRange(N))
      return null;
    var O = [{
      x: N,
      y: p + b
    }, {
      x: N,
      y: p
    }];
    return I === "top" ? O.reverse() : O;
  }
  if (s) {
    var P = u.segment, S = P.map(function($) {
      return n.apply($, {
        position: y
      });
    });
    return po(u, "discard") && wve(S, function($) {
      return !n.isInRange($);
    }) ? null : S;
  }
  return null;
};
function ik(e) {
  var n = e.x, r = e.y, o = e.segment, s = e.xAxis, u = e.yAxis, h = e.shape, f = e.className, p = e.alwaysShow, v = e.clipPathId;
  qu(p === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var b = rk({
    x: s.scale,
    y: u.scale
  }), y = Un(n), k = Un(r), _ = o && o.length === 2, E = Kve(b, y, k, _, e);
  if (!E)
    return null;
  var x = Vve(E, 2), D = x[0], I = D.x, N = D.y, O = x[1], P = O.x, S = O.y, $ = po(e, "hidden") ? "url(#".concat(v, ")") : void 0, L = qT(qT({
    clipPath: $
  }, Ye(e, !0)), {}, {
    x1: I,
    y1: N,
    x2: P,
    y2: S
  });
  return /* @__PURE__ */ K(mt, {
    className: Ce("recharts-reference-line", f),
    children: [qve(h, L), Vn.renderCallByParent(e, Fve({
      x1: I,
      y1: N,
      x2: P,
      y2: S
    }))]
  });
}
ik.displayName = "ReferenceLine";
ik.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
};
function YT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function QT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? YT(Object(r), !0).forEach(function(o) {
      Yve(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : YT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Yve(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var Qve = function(n) {
  var r = n.x, o = n.y, s = n.xAxis, u = n.yAxis, h = rk({
    x: s.scale,
    y: u.scale
  }), f = h.apply({
    x: r,
    y: o
  }, {
    bandAware: !0
  });
  return po(n, "discard") && !h.isInRange(f) ? null : f;
};
function _d(e) {
  var n = e.x, r = e.y, o = e.r, s = e.alwaysShow, u = e.clipPathId, h = Un(n), f = Un(r);
  if (qu(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !h || !f)
    return null;
  var p = Qve(e);
  if (!p)
    return null;
  var v = p.x, b = p.y, y = e.shape, k = e.className, _ = po(e, "hidden") ? "url(#".concat(u, ")") : void 0, E = QT(QT({
    clipPath: _
  }, Ye(e, !0)), {}, {
    cx: v,
    cy: b
  });
  return /* @__PURE__ */ K(mt, {
    className: Ce("recharts-reference-dot", k),
    children: [_d.renderDot(y, E), Vn.renderCallByParent(e, {
      x: v - o,
      y: b - o,
      width: 2 * o,
      height: 2 * o
    })]
  });
}
_d.displayName = "ReferenceDot";
_d.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
};
_d.renderDot = function(e, n) {
  var r;
  return /* @__PURE__ */ oe.isValidElement(e) ? r = /* @__PURE__ */ oe.cloneElement(e, n) : qe(e) ? r = e(n) : r = /* @__PURE__ */ M(kd, {
    ...n,
    cx: n.cx,
    cy: n.cy,
    className: "recharts-reference-dot-dot"
  }), r;
};
function ZT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function XT(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ZT(Object(r), !0).forEach(function(o) {
      Zve(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ZT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Zve(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var Xve = function(n, r, o, s, u) {
  var h = u.x1, f = u.x2, p = u.y1, v = u.y2, b = u.xAxis, y = u.yAxis;
  if (!b || !y)
    return null;
  var k = rk({
    x: b.scale,
    y: y.scale
  }), _ = {
    x: n ? k.x.apply(h, {
      position: "start"
    }) : k.x.rangeMin,
    y: o ? k.y.apply(p, {
      position: "start"
    }) : k.y.rangeMin
  }, E = {
    x: r ? k.x.apply(f, {
      position: "end"
    }) : k.x.rangeMax,
    y: s ? k.y.apply(v, {
      position: "end"
    }) : k.y.rangeMax
  };
  return po(u, "discard") && (!k.isInRange(_) || !k.isInRange(E)) ? null : w7(_, E);
};
function Ad(e) {
  var n = e.x1, r = e.x2, o = e.y1, s = e.y2, u = e.className, h = e.alwaysShow, f = e.clipPathId;
  qu(h === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = Un(n), v = Un(r), b = Un(o), y = Un(s), k = e.shape;
  if (!p && !v && !b && !y && !k)
    return null;
  var _ = Xve(p, v, b, y, e);
  if (!_ && !k)
    return null;
  var E = po(e, "hidden") ? "url(#".concat(f, ")") : void 0;
  return /* @__PURE__ */ K(mt, {
    className: Ce("recharts-reference-area", u),
    children: [Ad.renderRect(k, XT(XT({
      clipPath: E
    }, Ye(e, !0)), _)), Vn.renderCallByParent(e, _)]
  });
}
Ad.displayName = "ReferenceArea";
Ad.defaultProps = {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
};
Ad.renderRect = function(e, n) {
  var r;
  return /* @__PURE__ */ oe.isValidElement(e) ? r = /* @__PURE__ */ oe.cloneElement(e, n) : qe(e) ? r = e(n) : r = /* @__PURE__ */ M(Zg, {
    ...n,
    className: "recharts-reference-area-rect"
  }), r;
};
function Of(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Of = function(r) {
    return typeof r;
  } : Of = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Of(e);
}
function JT(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function jt(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? JT(Object(r), !0).forEach(function(o) {
      Jve(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : JT(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Jve(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function sb(e, n) {
  if (e == null)
    return {};
  var r = ebe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function ebe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function tbe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function eD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function nbe(e, n, r) {
  return n && eD(e.prototype, n), r && eD(e, r), e;
}
function rbe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && qw(e, n);
}
function qw(e, n) {
  return qw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, qw(e, n);
}
function ibe(e) {
  var n = sbe();
  return function() {
    var o = Fp(e), s;
    if (n) {
      var u = Fp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return obe(this, s);
  };
}
function obe(e, n) {
  return n && (Of(n) === "object" || typeof n == "function") ? n : abe(e);
}
function abe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sbe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Fp(e) {
  return Fp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fp(e);
}
var ys = /* @__PURE__ */ function(e) {
  rbe(r, e);
  var n = ibe(r);
  function r(o) {
    var s;
    return tbe(this, r), s = n.call(this, o), s.layerReference = void 0, s.state = {
      fontSize: "",
      letterSpacing: ""
    }, s;
  }
  return nbe(r, [{
    key: "shouldComponentUpdate",
    value: function(s, u) {
      var h = s.viewBox, f = sb(s, ["viewBox"]), p = this.props, v = p.viewBox, b = sb(p, ["viewBox"]);
      return !Bl(h, v) || !Bl(f, b) || !Bl(u, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var s = this.layerReference;
      if (!!s) {
        var u = s.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        u && this.setState({
          fontSize: window.getComputedStyle(u).fontSize,
          letterSpacing: window.getComputedStyle(u).letterSpacing
        });
      }
    }
  }, {
    key: "getTickLineCoord",
    value: function(s) {
      var u = this.props, h = u.x, f = u.y, p = u.width, v = u.height, b = u.orientation, y = u.tickSize, k = u.mirror, _ = u.tickMargin, E, x, D, I, N, O, P = k ? -1 : 1, S = s.tickSize || y, $ = Oe(s.tickCoord) ? s.tickCoord : s.coordinate;
      switch (b) {
        case "top":
          E = x = s.coordinate, I = f + +!k * v, D = I - P * S, O = D - P * _, N = $;
          break;
        case "left":
          D = I = s.coordinate, x = h + +!k * p, E = x - P * S, N = E - P * _, O = $;
          break;
        case "right":
          D = I = s.coordinate, x = h + +k * p, E = x + P * S, N = E + P * _, O = $;
          break;
        default:
          E = x = s.coordinate, I = f + +k * v, D = I + P * S, O = D + P * _, N = $;
          break;
      }
      return {
        line: {
          x1: E,
          y1: D,
          x2: x,
          y2: I
        },
        tick: {
          x: N,
          y: O
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var s = this.props, u = s.orientation, h = s.mirror, f;
      switch (u) {
        case "left":
          f = h ? "start" : "end";
          break;
        case "right":
          f = h ? "end" : "start";
          break;
        default:
          f = "middle";
          break;
      }
      return f;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var s = this.props, u = s.orientation, h = s.mirror, f = "end";
      switch (u) {
        case "left":
        case "right":
          f = "middle";
          break;
        case "top":
          f = h ? "start" : "end";
          break;
        default:
          f = h ? "end" : "start";
          break;
      }
      return f;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var s = this.props, u = s.x, h = s.y, f = s.width, p = s.height, v = s.orientation, b = s.mirror, y = s.axisLine, k = jt(jt(jt({}, Ye(this.props)), Ye(y)), {}, {
        fill: "none"
      });
      if (v === "top" || v === "bottom") {
        var _ = +(v === "top" && !b || v === "bottom" && b);
        k = jt(jt({}, k), {}, {
          x1: u,
          y1: h + _ * p,
          x2: u + f,
          y2: h + _ * p
        });
      } else {
        var E = +(v === "left" && !b || v === "right" && b);
        k = jt(jt({}, k), {}, {
          x1: u + E * f,
          y1: h,
          x2: u + E * f,
          y2: h + p
        });
      }
      return /* @__PURE__ */ M("line", {
        ...k,
        className: Ce("recharts-cartesian-axis-line", Hn(y, "className"))
      });
    }
  }, {
    key: "renderTicks",
    value: function(s, u, h) {
      var f = this, p = this.props, v = p.tickLine, b = p.stroke, y = p.tick, k = p.tickFormatter, _ = p.unit, E = r.getTicks(jt(jt({}, this.props), {}, {
        ticks: s
      }), u, h), x = this.getTickTextAnchor(), D = this.getTickVerticalAnchor(), I = Ye(this.props), N = Ye(y), O = jt(jt({}, I), {}, {
        fill: "none"
      }, Ye(v)), P = E.map(function(S, $) {
        var L = f.getTickLineCoord(S), B = L.line, U = L.tick, G = jt(jt(jt(jt({
          textAnchor: x,
          verticalAnchor: D
        }, I), {}, {
          stroke: "none",
          fill: b
        }, N), U), {}, {
          index: $,
          payload: S,
          visibleTicksCount: E.length,
          tickFormatter: k
        });
        return /* @__PURE__ */ K(mt, {
          className: "recharts-cartesian-axis-tick",
          ...Ia(f.props, S, $),
          children: [v && /* @__PURE__ */ M("line", {
            ...O,
            ...B,
            className: Ce("recharts-cartesian-axis-tick-line", Hn(v, "className"))
          }), y && r.renderTickItem(y, G, "".concat(qe(k) ? k(S.value, $) : S.value).concat(_ || ""))]
        }, "tick-".concat($));
      });
      return /* @__PURE__ */ M("g", {
        className: "recharts-cartesian-axis-ticks",
        children: P
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this, u = this.props, h = u.axisLine, f = u.width, p = u.height, v = u.ticksGenerator, b = u.className, y = u.hide;
      if (y)
        return null;
      var k = this.props, _ = k.ticks, E = sb(k, ["ticks"]), x = _;
      return qe(v) && (x = _ && _.length > 0 ? v(this.props) : v(E)), f <= 0 || p <= 0 || !x || !x.length ? null : /* @__PURE__ */ K(mt, {
        className: Ce("recharts-cartesian-axis", b),
        ref: function(I) {
          s.layerReference = I;
        },
        children: [h && this.renderAxisLine(), this.renderTicks(x, this.state.fontSize, this.state.letterSpacing), Vn.renderCallByParent(this.props)]
      });
    }
  }], [{
    key: "getTicks",
    value: function(s, u, h) {
      var f = s.tick, p = s.ticks, v = s.viewBox, b = s.minTickGap, y = s.orientation, k = s.interval, _ = s.tickFormatter, E = s.unit;
      return !p || !p.length || !f ? [] : Oe(k) || ci.isSsr ? r.getNumberIntervalTicks(p, typeof k == "number" && Oe(k) ? k : 0) : k === "preserveStartEnd" ? r.getTicksStart({
        ticks: p,
        tickFormatter: _,
        viewBox: v,
        orientation: y,
        minTickGap: b,
        unit: E,
        fontSize: u,
        letterSpacing: h
      }, !0) : k === "preserveStart" ? r.getTicksStart({
        ticks: p,
        tickFormatter: _,
        viewBox: v,
        orientation: y,
        minTickGap: b,
        unit: E,
        fontSize: u,
        letterSpacing: h
      }) : r.getTicksEnd({
        ticks: p,
        tickFormatter: _,
        viewBox: v,
        orientation: y,
        minTickGap: b,
        unit: E,
        fontSize: u,
        letterSpacing: h
      });
    }
  }, {
    key: "getNumberIntervalTicks",
    value: function(s, u) {
      return s.filter(function(h, f) {
        return f % (u + 1) === 0;
      });
    }
  }, {
    key: "getTicksStart",
    value: function(s, u) {
      var h = s.ticks, f = s.tickFormatter, p = s.viewBox, v = s.orientation, b = s.minTickGap, y = s.unit, k = s.fontSize, _ = s.letterSpacing, E = p.x, x = p.y, D = p.width, I = p.height, N = v === "top" || v === "bottom" ? "width" : "height", O = (h || []).slice(), P = y && N === "width" ? ws(y, {
        fontSize: k,
        letterSpacing: _
      })[N] : 0, S = O.length, $ = S >= 2 ? pr(O[1].coordinate - O[0].coordinate) : 1, L, B;
      if ($ === 1 ? (L = N === "width" ? E : x, B = N === "width" ? E + D : x + I) : (L = N === "width" ? E + D : x + I, B = N === "width" ? E : x), u) {
        var U = h[S - 1], G = qe(f) ? f(U.value, S - 1) : U.value, q = ws(G, {
          fontSize: k,
          letterSpacing: _
        })[N] + P, Y = $ * (U.coordinate + $ * q / 2 - B);
        O[S - 1] = U = jt(jt({}, U), {}, {
          tickCoord: Y > 0 ? U.coordinate - Y * $ : U.coordinate
        });
        var Q = $ * (U.tickCoord - $ * q / 2 - L) >= 0 && $ * (U.tickCoord + $ * q / 2 - B) <= 0;
        Q && (B = U.tickCoord - $ * (q / 2 + b), O[S - 1] = jt(jt({}, U), {}, {
          isShow: !0
        }));
      }
      for (var Z = u ? S - 1 : S, ae = 0; ae < Z; ae++) {
        var ie = O[ae], pe = qe(f) ? f(ie.value, ae) : ie.value, ce = ws(pe, {
          fontSize: k,
          letterSpacing: _
        })[N] + P;
        if (ae === 0) {
          var ue = $ * (ie.coordinate - $ * ce / 2 - L);
          O[ae] = ie = jt(jt({}, ie), {}, {
            tickCoord: ue < 0 ? ie.coordinate - ue * $ : ie.coordinate
          });
        } else
          O[ae] = ie = jt(jt({}, ie), {}, {
            tickCoord: ie.coordinate
          });
        var X = $ * (ie.tickCoord - $ * ce / 2 - L) >= 0 && $ * (ie.tickCoord + $ * ce / 2 - B) <= 0;
        X && (L = ie.tickCoord + $ * (ce / 2 + b), O[ae] = jt(jt({}, ie), {}, {
          isShow: !0
        }));
      }
      return O.filter(function(se) {
        return se.isShow;
      });
    }
  }, {
    key: "getTicksEnd",
    value: function(s) {
      var u = s.ticks, h = s.tickFormatter, f = s.viewBox, p = s.orientation, v = s.minTickGap, b = s.unit, y = s.fontSize, k = s.letterSpacing, _ = f.x, E = f.y, x = f.width, D = f.height, I = p === "top" || p === "bottom" ? "width" : "height", N = b && I === "width" ? ws(b, {
        fontSize: y,
        letterSpacing: k
      })[I] : 0, O = (u || []).slice(), P = O.length, S = P >= 2 ? pr(O[1].coordinate - O[0].coordinate) : 1, $, L;
      S === 1 ? ($ = I === "width" ? _ : E, L = I === "width" ? _ + x : E + D) : ($ = I === "width" ? _ + x : E + D, L = I === "width" ? _ : E);
      for (var B = P - 1; B >= 0; B--) {
        var U = O[B], G = qe(h) ? h(U.value, P - B - 1) : U.value, q = ws(G, {
          fontSize: y,
          letterSpacing: k
        })[I] + N;
        if (B === P - 1) {
          var Y = S * (U.coordinate + S * q / 2 - L);
          O[B] = U = jt(jt({}, U), {}, {
            tickCoord: Y > 0 ? U.coordinate - Y * S : U.coordinate
          });
        } else
          O[B] = U = jt(jt({}, U), {}, {
            tickCoord: U.coordinate
          });
        var Q = S * (U.tickCoord - S * q / 2 - $) >= 0 && S * (U.tickCoord + S * q / 2 - L) <= 0;
        Q && (L = U.tickCoord - S * (q / 2 + v), O[B] = jt(jt({}, U), {}, {
          isShow: !0
        }));
      }
      return O.filter(function(Z) {
        return Z.isShow;
      });
    }
  }, {
    key: "renderTickItem",
    value: function(s, u, h) {
      var f;
      return /* @__PURE__ */ oe.isValidElement(s) ? f = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? f = s(u) : f = /* @__PURE__ */ M(Oa, {
        ...u,
        className: "recharts-cartesian-axis-tick-value",
        children: h
      }), f;
    }
  }]), r;
}(w1);
ys.displayName = "CartesianAxis";
ys.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  orientation: "bottom",
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
};
function Rf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Rf = function(r) {
    return typeof r;
  } : Rf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Rf(e);
}
function lbe(e, n) {
  if (e == null)
    return {};
  var r = cbe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function cbe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function tD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function of(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? tD(Object(r), !0).forEach(function(o) {
      ube(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function ube(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function dbe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function nD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function hbe(e, n, r) {
  return n && nD(e.prototype, n), r && nD(e, r), e;
}
function fbe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Kw(e, n);
}
function Kw(e, n) {
  return Kw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Kw(e, n);
}
function pbe(e) {
  var n = vbe();
  return function() {
    var o = zp(e), s;
    if (n) {
      var u = zp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return gbe(this, s);
  };
}
function gbe(e, n) {
  return n && (Rf(n) === "object" || typeof n == "function") ? n : mbe(e);
}
function mbe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vbe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zp(e) {
  return zp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zp(e);
}
var em = /* @__PURE__ */ function(e) {
  fbe(r, e);
  var n = pbe(r);
  function r() {
    return dbe(this, r), n.apply(this, arguments);
  }
  return hbe(r, [{
    key: "renderHorizontal",
    value: function(s) {
      var u = this, h = this.props, f = h.x, p = h.width, v = h.horizontal;
      if (!s || !s.length)
        return null;
      var b = s.map(function(y, k) {
        var _ = of(of({}, u.props), {}, {
          x1: f,
          y1: y,
          x2: f + p,
          y2: y,
          key: "line-".concat(k),
          index: k
        });
        return r.renderLineItem(v, _);
      });
      return /* @__PURE__ */ M("g", {
        className: "recharts-cartesian-grid-horizontal",
        children: b
      });
    }
  }, {
    key: "renderVertical",
    value: function(s) {
      var u = this, h = this.props, f = h.y, p = h.height, v = h.vertical;
      if (!s || !s.length)
        return null;
      var b = s.map(function(y, k) {
        var _ = of(of({}, u.props), {}, {
          x1: y,
          y1: f,
          x2: y,
          y2: f + p,
          key: "line-".concat(k),
          index: k
        });
        return r.renderLineItem(v, _);
      });
      return /* @__PURE__ */ M("g", {
        className: "recharts-cartesian-grid-vertical",
        children: b
      });
    }
  }, {
    key: "renderVerticalStripes",
    value: function(s) {
      var u = this.props.verticalFill;
      if (!u || !u.length)
        return null;
      var h = this.props, f = h.fillOpacity, p = h.x, v = h.y, b = h.width, y = h.height, k = s.map(function(E) {
        return Math.round(E + p - p);
      }).sort(function(E, x) {
        return E - x;
      });
      p !== k[0] && k.unshift(0);
      var _ = k.map(function(E, x) {
        var D = !k[x + 1], I = D ? p + b - E : k[x + 1] - E;
        if (I <= 0)
          return null;
        var N = x % u.length;
        return /* @__PURE__ */ M("rect", {
          x: E,
          y: v,
          width: I,
          height: y,
          stroke: "none",
          fill: u[N],
          fillOpacity: f,
          className: "recharts-cartesian-grid-bg"
        }, "react-".concat(x));
      });
      return /* @__PURE__ */ M("g", {
        className: "recharts-cartesian-gridstripes-vertical",
        children: _
      });
    }
  }, {
    key: "renderHorizontalStripes",
    value: function(s) {
      var u = this.props.horizontalFill;
      if (!u || !u.length)
        return null;
      var h = this.props, f = h.fillOpacity, p = h.x, v = h.y, b = h.width, y = h.height, k = s.map(function(E) {
        return Math.round(E + v - v);
      }).sort(function(E, x) {
        return E - x;
      });
      v !== k[0] && k.unshift(0);
      var _ = k.map(function(E, x) {
        var D = !k[x + 1], I = D ? v + y - E : k[x + 1] - E;
        if (I <= 0)
          return null;
        var N = x % u.length;
        return /* @__PURE__ */ M("rect", {
          y: E,
          x: p,
          height: I,
          width: b,
          stroke: "none",
          fill: u[N],
          fillOpacity: f,
          className: "recharts-cartesian-grid-bg"
        }, "react-".concat(x));
      });
      return /* @__PURE__ */ M("g", {
        className: "recharts-cartesian-gridstripes-horizontal",
        children: _
      });
    }
  }, {
    key: "renderBackground",
    value: function() {
      var s = this.props.fill;
      if (!s || s === "none")
        return null;
      var u = this.props, h = u.fillOpacity, f = u.x, p = u.y, v = u.width, b = u.height;
      return /* @__PURE__ */ M("rect", {
        x: f,
        y: p,
        width: v,
        height: b,
        stroke: "none",
        fill: s,
        fillOpacity: h,
        className: "recharts-cartesian-grid-bg"
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.x, h = s.y, f = s.width, p = s.height, v = s.horizontal, b = s.vertical, y = s.horizontalCoordinatesGenerator, k = s.verticalCoordinatesGenerator, _ = s.xAxis, E = s.yAxis, x = s.offset, D = s.chartWidth, I = s.chartHeight;
      if (!Oe(f) || f <= 0 || !Oe(p) || p <= 0 || !Oe(u) || u !== +u || !Oe(h) || h !== +h)
        return null;
      var N = this.props, O = N.horizontalPoints, P = N.verticalPoints;
      return (!O || !O.length) && qe(y) && (O = y({
        yAxis: E,
        width: D,
        height: I,
        offset: x
      })), (!P || !P.length) && qe(k) && (P = k({
        xAxis: _,
        width: D,
        height: I,
        offset: x
      })), /* @__PURE__ */ K("g", {
        className: "recharts-cartesian-grid",
        children: [this.renderBackground(), v && this.renderHorizontal(O), b && this.renderVertical(P), v && this.renderHorizontalStripes(O), b && this.renderVerticalStripes(P)]
      });
    }
  }], [{
    key: "renderLineItem",
    value: function(s, u) {
      var h;
      if (/* @__PURE__ */ oe.isValidElement(s))
        h = /* @__PURE__ */ oe.cloneElement(s, u);
      else if (qe(s))
        h = s(u);
      else {
        var f = u.x1, p = u.y1, v = u.x2, b = u.y2, y = u.key, k = lbe(u, ["x1", "y1", "x2", "y2", "key"]);
        h = /* @__PURE__ */ hi("line", {
          ...Ye(k),
          x1: f,
          y1: p,
          x2: v,
          y2: b,
          fill: "none",
          key: y
        });
      }
      return h;
    }
  }]), r;
}(Ln);
em.displayName = "CartesianGrid";
em.defaultProps = {
  horizontal: !0,
  vertical: !0,
  horizontalPoints: [],
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  verticalFill: [],
  horizontalFill: []
};
function bbe(e, n) {
  return _be(e) || kbe(e, n) || ybe(e, n) || wbe();
}
function wbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ybe(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return rD(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return rD(e, n);
  }
}
function rD(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function kbe(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function _be(e) {
  if (Array.isArray(e))
    return e;
}
function Abe(e, n) {
  if (e == null)
    return {};
  var r = Cbe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Cbe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Cd(e) {
  var n = e.offset, r = e.layout, o = e.width, s = e.dataKey, u = e.data, h = e.dataPointFormatter, f = e.xAxis, p = e.yAxis, v = Abe(e, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]), b = Ye(v), y = u.map(function(k, _) {
    var E = h(k, s), x = E.x, D = E.y, I = E.value, N = E.errorVal;
    if (!N)
      return null;
    var O = [], P, S;
    if (Array.isArray(N)) {
      var $ = bbe(N, 2);
      P = $[0], S = $[1];
    } else
      P = S = N;
    if (r === "vertical") {
      var L = f.scale, B = D + n, U = B + o, G = B - o, q = L(I - P), Y = L(I + S);
      O.push({
        x1: Y,
        y1: U,
        x2: Y,
        y2: G
      }), O.push({
        x1: q,
        y1: B,
        x2: Y,
        y2: B
      }), O.push({
        x1: q,
        y1: U,
        x2: q,
        y2: G
      });
    } else if (r === "horizontal") {
      var Q = p.scale, Z = x + n, ae = Z - o, ie = Z + o, pe = Q(I - P), ce = Q(I + S);
      O.push({
        x1: ae,
        y1: ce,
        x2: ie,
        y2: ce
      }), O.push({
        x1: Z,
        y1: pe,
        x2: Z,
        y2: ce
      }), O.push({
        x1: ae,
        y1: pe,
        x2: ie,
        y2: pe
      });
    }
    return /* @__PURE__ */ M(mt, {
      className: "recharts-errorBar",
      ...b,
      children: O.map(function(ue, X) {
        return /* @__PURE__ */ hi("line", {
          ...ue,
          key: "line-".concat(X)
        });
      })
    }, "bar-".concat(_));
  });
  return /* @__PURE__ */ M(mt, {
    className: "recharts-errorBars",
    children: y
  });
}
Cd.defaultProps = {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
};
Cd.displayName = "ErrorBar";
function Nf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Nf = function(r) {
    return typeof r;
  } : Nf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Nf(e);
}
function xbe(e, n) {
  if (e == null)
    return {};
  var r = Ebe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Ebe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function iD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function Rr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? iD(Object(r), !0).forEach(function(o) {
      Sbe(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : iD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Sbe(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function $l(e) {
  return Ibe(e) || Dbe(e) || Tbe(e) || Mbe();
}
function Mbe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tbe(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return Yw(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Yw(e, n);
  }
}
function Dbe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function Ibe(e) {
  if (Array.isArray(e))
    return Yw(e);
}
function Yw(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function Pbe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function oD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Obe(e, n, r) {
  return n && oD(e.prototype, n), r && oD(e, r), e;
}
function Rbe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Qw(e, n);
}
function Qw(e, n) {
  return Qw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Qw(e, n);
}
function Nbe(e) {
  var n = jbe();
  return function() {
    var o = Vp(e), s;
    if (n) {
      var u = Vp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return $be(this, s);
  };
}
function $be(e, n) {
  return n && (Nf(n) === "object" || typeof n == "function") ? n : Lbe(e);
}
function Lbe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jbe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vp(e) {
  return Vp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Vp(e);
}
var xd = /* @__PURE__ */ function(e) {
  Rbe(r, e);
  var n = Nbe(r);
  function r() {
    var o;
    Pbe(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.mainCurve = void 0, o.state = {
      isAnimationFinished: !0,
      totalLength: 0
    }, o.getStrokeDasharray = function(f, p, v) {
      for (var b = v.reduce(function(N, O) {
        return N + O;
      }), y = Math.floor(f / b), k = f % b, _ = p - f, E = [], x = 0, D = 0; ; D += v[x], ++x)
        if (D + v[x] > k) {
          E = [].concat($l(v.slice(0, x)), [k - D]);
          break;
        }
      var I = E.length % 2 === 0 ? [0, _] : [_];
      return [].concat($l(r.repeat(v, y)), $l(E), I).map(function(N) {
        return "".concat(N, "px");
      }).join(", ");
    }, o.id = La("recharts-line-"), o.pathRef = function(f) {
      o.mainCurve = f;
    }, o.handleAnimationEnd = function() {
      o.setState({
        isAnimationFinished: !0
      }), o.props.onAnimationEnd && o.props.onAnimationEnd();
    }, o.handleAnimationStart = function() {
      o.setState({
        isAnimationFinished: !1
      }), o.props.onAnimationStart && o.props.onAnimationStart();
    }, o;
  }
  return Obe(r, [{
    key: "componentDidMount",
    value: function() {
      if (!!this.props.isAnimationActive) {
        var s = this.getTotalLength();
        this.setState({
          totalLength: s
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var s = this.mainCurve;
      try {
        return s && s.getTotalLength && s.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var s = this.props, u = s.points, h = s.xAxis, f = s.yAxis, p = s.layout, v = s.children, b = yr(v, Cd.displayName);
      if (!b)
        return null;
      function y(k, _) {
        return {
          x: k.x,
          y: k.y,
          value: k.value,
          errorVal: mn(k.payload, _)
        };
      }
      return b.map(function(k, _) {
        return /* @__PURE__ */ oe.cloneElement(k, {
          key: "bar-".concat(_),
          data: u,
          xAxis: h,
          yAxis: f,
          layout: p,
          dataPointFormatter: y
        });
      });
    }
  }, {
    key: "renderDots",
    value: function(s, u) {
      var h = this.props.isAnimationActive;
      if (h && !this.state.isAnimationFinished)
        return null;
      var f = this.props, p = f.dot, v = f.points, b = f.dataKey, y = Ye(this.props), k = Ye(p, !0), _ = v.map(function(x, D) {
        var I = Rr(Rr(Rr({
          key: "dot-".concat(D),
          r: 3
        }, y), k), {}, {
          value: x.value,
          dataKey: b,
          cx: x.x,
          cy: x.y,
          index: D,
          payload: x.payload
        });
        return r.renderDotItem(p, I);
      }), E = {
        clipPath: s ? "url(#clipPath-".concat(u, ")") : null
      };
      return /* @__PURE__ */ M(mt, {
        className: "recharts-line-dots",
        ...E,
        role: "img",
        children: _
      }, "dots");
    }
  }, {
    key: "renderCurveStatically",
    value: function(s, u, h, f) {
      var p = this.props, v = p.type, b = p.layout, y = p.connectNulls;
      p.ref;
      var k = xbe(p, ["type", "layout", "connectNulls", "ref"]), _ = Rr(Rr(Rr({}, Ye(k, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: u ? "url(#clipPath-".concat(h, ")") : null,
        points: s
      }, f), {}, {
        type: v,
        layout: b,
        connectNulls: y
      });
      return /* @__PURE__ */ M(Go, {
        ..._,
        pathRef: this.pathRef
      });
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(s, u) {
      var h = this, f = this.props, p = f.points, v = f.strokeDasharray, b = f.isAnimationActive, y = f.animationBegin, k = f.animationDuration, _ = f.animationEasing, E = f.animationId, x = f.animateNewValues, D = f.width, I = f.height, N = this.state, O = N.prevPoints, P = N.totalLength;
      return /* @__PURE__ */ M(mo, {
        begin: y,
        duration: k,
        isActive: b,
        easing: _,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart,
        children: function(S) {
          var $ = S.t;
          if (O) {
            var L = O.length / p.length, B = p.map(function(Q, Z) {
              var ae = Math.floor(Z * L);
              if (O[ae]) {
                var ie = O[ae], pe = Sn(ie.x, Q.x), ce = Sn(ie.y, Q.y);
                return Rr(Rr({}, Q), {}, {
                  x: pe($),
                  y: ce($)
                });
              }
              if (x) {
                var ue = Sn(D * 2, Q.x), X = Sn(I / 2, Q.y);
                return Rr(Rr({}, Q), {}, {
                  x: ue($),
                  y: X($)
                });
              }
              return Rr(Rr({}, Q), {}, {
                x: Q.x,
                y: Q.y
              });
            });
            return h.renderCurveStatically(B, s, u);
          }
          var U = Sn(0, P), G = U($), q;
          if (v) {
            var Y = "".concat(v).split(/[,\s]+/gim).map(function(Q) {
              return parseFloat(Q);
            });
            q = h.getStrokeDasharray(G, P, Y);
          } else
            q = "".concat(G, "px ").concat(P - G, "px");
          return h.renderCurveStatically(p, s, u, {
            strokeDasharray: q
          });
        }
      }, "line-".concat(E));
    }
  }, {
    key: "renderCurve",
    value: function(s, u) {
      var h = this.props, f = h.points, p = h.isAnimationActive, v = this.state, b = v.prevPoints, y = v.totalLength;
      return p && f && f.length && (!b && y > 0 || !Rs(b, f)) ? this.renderCurveWithAnimation(s, u) : this.renderCurveStatically(f, s, u);
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.hide, h = s.dot, f = s.points, p = s.className, v = s.xAxis, b = s.yAxis, y = s.top, k = s.left, _ = s.width, E = s.height, x = s.isAnimationActive, D = s.id;
      if (u || !f || !f.length)
        return null;
      var I = this.state.isAnimationFinished, N = f.length === 1, O = Ce("recharts-line", p), P = v && v.allowDataOverflow || b && b.allowDataOverflow, S = Be(D) ? this.id : D;
      return /* @__PURE__ */ K(mt, {
        className: O,
        children: [P ? /* @__PURE__ */ M("defs", {
          children: /* @__PURE__ */ M("clipPath", {
            id: "clipPath-".concat(S),
            children: /* @__PURE__ */ M("rect", {
              x: k,
              y,
              width: _,
              height: E
            })
          })
        }) : null, !N && this.renderCurve(P, S), this.renderErrorBar(), (N || h) && this.renderDots(P, S), (!x || I) && ui.renderCallByParent(this.props, f)]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      return s.animationId !== u.prevAnimationId ? {
        prevAnimationId: s.animationId,
        curPoints: s.points,
        prevPoints: u.curPoints
      } : s.points !== u.curPoints ? {
        curPoints: s.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(s, u) {
      for (var h = s.length % 2 !== 0 ? [].concat($l(s), [0]) : s, f = [], p = 0; p < u; ++p)
        f = [].concat($l(f), $l(h));
      return f;
    }
  }, {
    key: "renderDotItem",
    value: function(s, u) {
      var h;
      if (/* @__PURE__ */ oe.isValidElement(s))
        h = /* @__PURE__ */ oe.cloneElement(s, u);
      else if (qe(s))
        h = s(u);
      else {
        var f = Ce("recharts-line-dot", s ? s.className : "");
        h = /* @__PURE__ */ M(kd, {
          ...u,
          className: f
        });
      }
      return h;
    }
  }]), r;
}(Ln);
xd.displayName = "Line";
xd.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !ci.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
};
xd.getComposedData = function(e) {
  var n = e.props, r = e.xAxis, o = e.yAxis, s = e.xAxisTicks, u = e.yAxisTicks, h = e.dataKey, f = e.bandSize, p = e.displayedData, v = e.offset, b = n.layout, y = p.map(function(k, _) {
    var E = mn(k, h);
    return b === "horizontal" ? {
      x: Ql({
        axis: r,
        ticks: s,
        bandSize: f,
        entry: k,
        index: _
      }),
      y: Be(E) ? null : o.scale(E),
      value: E,
      payload: k
    } : {
      x: Be(E) ? null : r.scale(E),
      y: Ql({
        axis: o,
        ticks: u,
        bandSize: f,
        entry: k,
        index: _
      }),
      value: E,
      payload: k
    };
  });
  return Rr({
    points: y,
    layout: b
  }, v);
};
function $f(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $f = function(r) {
    return typeof r;
  } : $f = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, $f(e);
}
function Bbe(e, n) {
  if (e == null)
    return {};
  var r = Fbe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Fbe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function aD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function ba(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? aD(Object(r), !0).forEach(function(o) {
      zbe(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : aD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function zbe(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Vbe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function sD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Hbe(e, n, r) {
  return n && sD(e.prototype, n), r && sD(e, r), e;
}
function Ube(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Zw(e, n);
}
function Zw(e, n) {
  return Zw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Zw(e, n);
}
function Wbe(e) {
  var n = Kbe();
  return function() {
    var o = Hp(e), s;
    if (n) {
      var u = Hp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Gbe(this, s);
  };
}
function Gbe(e, n) {
  return n && ($f(n) === "object" || typeof n == "function") ? n : qbe(e);
}
function qbe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Kbe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hp(e) {
  return Hp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Hp(e);
}
var Ko = /* @__PURE__ */ function(e) {
  Ube(r, e);
  var n = Wbe(r);
  function r() {
    var o;
    Vbe(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {
      isAnimationFinished: !0
    }, o.id = La("recharts-area-"), o.handleAnimationEnd = function() {
      var f = o.props.onAnimationEnd;
      o.setState({
        isAnimationFinished: !0
      }), qe(f) && f();
    }, o.handleAnimationStart = function() {
      var f = o.props.onAnimationStart;
      o.setState({
        isAnimationFinished: !1
      }), qe(f) && f();
    }, o;
  }
  return Hbe(r, [{
    key: "renderDots",
    value: function(s, u) {
      var h = this.props.isAnimationActive, f = this.state.isAnimationFinished;
      if (h && !f)
        return null;
      var p = this.props, v = p.dot, b = p.points, y = p.dataKey, k = Ye(this.props), _ = Ye(v, !0), E = b.map(function(D, I) {
        var N = ba(ba(ba({
          key: "dot-".concat(I),
          r: 3
        }, k), _), {}, {
          dataKey: y,
          cx: D.x,
          cy: D.y,
          index: I,
          value: D.value,
          payload: D.payload
        });
        return r.renderDotItem(v, N);
      }), x = {
        clipPath: s ? "url(#clipPath-".concat(u, ")") : null
      };
      return /* @__PURE__ */ M(mt, {
        className: "recharts-area-dots",
        ...x,
        children: E
      });
    }
  }, {
    key: "renderHorizontalRect",
    value: function(s) {
      var u = this.props, h = u.baseLine, f = u.points, p = u.strokeWidth, v = f[0].x, b = f[f.length - 1].x, y = s * Math.abs(v - b), k = xa(f.map(function(_) {
        return _.y || 0;
      }));
      return Oe(h) && typeof h == "number" ? k = Math.max(h, k) : h && Tt(h) && h.length && (k = Math.max(xa(h.map(function(_) {
        return _.y || 0;
      })), k)), Oe(k) ? /* @__PURE__ */ M("rect", {
        x: v < b ? v : v - y,
        y: 0,
        width: y,
        height: Math.floor(k + (p ? parseInt("".concat(p), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(s) {
      var u = this.props, h = u.baseLine, f = u.points, p = u.strokeWidth, v = f[0].y, b = f[f.length - 1].y, y = s * Math.abs(v - b), k = xa(f.map(function(_) {
        return _.x || 0;
      }));
      return Oe(h) && typeof h == "number" ? k = Math.max(h, k) : h && Tt(h) && h.length && (k = Math.max(xa(h.map(function(_) {
        return _.x || 0;
      })), k)), Oe(k) ? /* @__PURE__ */ M("rect", {
        x: 0,
        y: v < b ? v : v - y,
        width: k + (p ? parseInt("".concat(p), 10) : 1),
        height: Math.floor(y)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(s) {
      var u = this.props.layout;
      return u === "vertical" ? this.renderVerticalRect(s) : this.renderHorizontalRect(s);
    }
  }, {
    key: "renderAreaStatically",
    value: function(s, u, h, f) {
      var p = this.props, v = p.layout, b = p.type, y = p.stroke, k = p.connectNulls, _ = p.isRange;
      p.ref;
      var E = Bbe(p, ["layout", "type", "stroke", "connectNulls", "isRange", "ref"]);
      return /* @__PURE__ */ K(mt, {
        clipPath: h ? "url(#clipPath-".concat(f, ")") : null,
        children: [/* @__PURE__ */ M(Go, {
          ...Ye(E, !0),
          points: s,
          connectNulls: k,
          type: b,
          baseLine: u,
          layout: v,
          stroke: "none",
          className: "recharts-area-area"
        }), y !== "none" && /* @__PURE__ */ M(Go, {
          ...Ye(this.props),
          className: "recharts-area-curve",
          layout: v,
          type: b,
          connectNulls: k,
          fill: "none",
          points: s
        }), y !== "none" && _ && /* @__PURE__ */ M(Go, {
          ...Ye(this.props),
          className: "recharts-area-curve",
          layout: v,
          type: b,
          connectNulls: k,
          fill: "none",
          points: u
        })]
      });
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(s, u) {
      var h = this, f = this.props, p = f.points, v = f.baseLine, b = f.isAnimationActive, y = f.animationBegin, k = f.animationDuration, _ = f.animationEasing, E = f.animationId, x = this.state, D = x.prevPoints, I = x.prevBaseLine;
      return /* @__PURE__ */ M(mo, {
        begin: y,
        duration: k,
        isActive: b,
        easing: _,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart,
        children: function(N) {
          var O = N.t;
          if (D) {
            var P = D.length / p.length, S = p.map(function(U, G) {
              var q = Math.floor(G * P);
              if (D[q]) {
                var Y = D[q], Q = Sn(Y.x, U.x), Z = Sn(Y.y, U.y);
                return ba(ba({}, U), {}, {
                  x: Q(O),
                  y: Z(O)
                });
              }
              return U;
            }), $;
            if (Oe(v) && typeof v == "number") {
              var L = Sn(I, v);
              $ = L(O);
            } else if (Be(v) || pd(v)) {
              var B = Sn(I, 0);
              $ = B(O);
            } else
              $ = v.map(function(U, G) {
                var q = Math.floor(G * P);
                if (I[q]) {
                  var Y = I[q], Q = Sn(Y.x, U.x), Z = Sn(Y.y, U.y);
                  return ba(ba({}, U), {}, {
                    x: Q(O),
                    y: Z(O)
                  });
                }
                return U;
              });
            return h.renderAreaStatically(S, $, s, u);
          }
          return /* @__PURE__ */ K(mt, {
            children: [/* @__PURE__ */ M("defs", {
              children: /* @__PURE__ */ M("clipPath", {
                id: "animationClipPath-".concat(u),
                children: h.renderClipRect(O)
              })
            }), /* @__PURE__ */ M(mt, {
              clipPath: "url(#animationClipPath-".concat(u, ")"),
              children: h.renderAreaStatically(p, v, s, u)
            })]
          });
        }
      }, "area-".concat(E));
    }
  }, {
    key: "renderArea",
    value: function(s, u) {
      var h = this.props, f = h.points, p = h.baseLine, v = h.isAnimationActive, b = this.state, y = b.prevPoints, k = b.prevBaseLine, _ = b.totalLength;
      return v && f && f.length && (!y && _ > 0 || !Rs(y, f) || !Rs(k, p)) ? this.renderAreaWithAnimation(s, u) : this.renderAreaStatically(f, p, s, u);
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.hide, h = s.dot, f = s.points, p = s.className, v = s.top, b = s.left, y = s.xAxis, k = s.yAxis, _ = s.width, E = s.height, x = s.isAnimationActive, D = s.id;
      if (u || !f || !f.length)
        return null;
      var I = this.state.isAnimationFinished, N = f.length === 1, O = Ce("recharts-area", p), P = y && y.allowDataOverflow || k && k.allowDataOverflow, S = Be(D) ? this.id : D;
      return /* @__PURE__ */ K(mt, {
        className: O,
        children: [P ? /* @__PURE__ */ M("defs", {
          children: /* @__PURE__ */ M("clipPath", {
            id: "clipPath-".concat(S),
            children: /* @__PURE__ */ M("rect", {
              x: b,
              y: v,
              width: _,
              height: Math.floor(E)
            })
          })
        }) : null, N ? null : this.renderArea(P, S), (h || N) && this.renderDots(P, S), (!x || I) && ui.renderCallByParent(this.props, f)]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      return s.animationId !== u.prevAnimationId ? {
        prevAnimationId: s.animationId,
        curPoints: s.points,
        curBaseLine: s.baseLine,
        prevPoints: u.curPoints,
        prevBaseLine: u.curBaseLine
      } : s.points !== u.curPoints || s.baseLine !== u.curBaseLine ? {
        curPoints: s.points,
        curBaseLine: s.baseLine
      } : null;
    }
  }]), r;
}(Ln);
Ko.displayName = "Area";
Ko.defaultProps = {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !ci.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
};
Ko.getBaseValue = function(e, n, r, o) {
  var s = e.layout, u = n.props.baseValue;
  if (Oe(u) && typeof u == "number")
    return u;
  var h = s === "horizontal" ? o : r, f = h.scale.domain();
  if (h.type === "number") {
    var p = Math.max(f[0], f[1]), v = Math.min(f[0], f[1]);
    return u === "dataMin" ? v : u === "dataMax" || p < 0 ? p : Math.max(Math.min(f[0], f[1]), 0);
  }
  return u === "dataMin" ? f[0] : u === "dataMax" ? f[1] : f[0];
};
Ko.getComposedData = function(e) {
  var n = e.props, r = e.item, o = e.xAxis, s = e.yAxis, u = e.xAxisTicks, h = e.yAxisTicks, f = e.bandSize, p = e.dataKey, v = e.stackedData, b = e.dataStartIndex, y = e.displayedData, k = e.offset, _ = n.layout, E = v && v.length, x = Ko.getBaseValue(n, r, o, s), D = !1, I = y.map(function(O, P) {
    var S = mn(O, p), $;
    E ? $ = v[b + P] : ($ = S, Tt($) ? D = !0 : $ = [x, $]);
    var L = Be($[1]) || E && Be(S);
    return _ === "horizontal" ? {
      x: Ql({
        axis: o,
        ticks: u,
        bandSize: f,
        entry: O,
        index: P
      }),
      y: L ? null : s.scale($[1]),
      value: $,
      payload: O
    } : {
      x: L ? null : o.scale($[1]),
      y: Ql({
        axis: s,
        ticks: h,
        bandSize: f,
        entry: O,
        index: P
      }),
      value: $,
      payload: O
    };
  }), N;
  return E || D ? N = I.map(function(O) {
    return _ === "horizontal" ? {
      x: O.x,
      y: !Be(Hn(O, "value[0]")) && !Be(Hn(O, "y")) ? s.scale(Hn(O, "value[0]")) : null
    } : {
      x: Be(Hn(O, "value[0]")) ? null : o.scale(Hn(O, "value[0]")),
      y: O.y
    };
  }) : _ === "horizontal" ? N = s.scale(x) : N = o.scale(x), ba({
    points: I,
    baseLine: N,
    layout: _,
    isRange: D
  }, k);
};
Ko.renderDotItem = function(e, n) {
  var r;
  return /* @__PURE__ */ oe.isValidElement(e) ? r = /* @__PURE__ */ oe.cloneElement(e, n) : qe(e) ? r = e(n) : r = /* @__PURE__ */ M(kd, {
    ...n,
    className: "recharts-area-dot"
  }), r;
};
function Lf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Lf = function(r) {
    return typeof r;
  } : Lf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Lf(e);
}
function Ybe(e, n) {
  if (e == null)
    return {};
  var r = Qbe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Qbe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function lD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function tr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? lD(Object(r), !0).forEach(function(o) {
      Zbe(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Zbe(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Xbe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function cD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Jbe(e, n, r) {
  return n && cD(e.prototype, n), r && cD(e, r), e;
}
function ewe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Xw(e, n);
}
function Xw(e, n) {
  return Xw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Xw(e, n);
}
function twe(e) {
  var n = iwe();
  return function() {
    var o = Up(e), s;
    if (n) {
      var u = Up(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return nwe(this, s);
  };
}
function nwe(e, n) {
  return n && (Lf(n) === "object" || typeof n == "function") ? n : rwe(e);
}
function rwe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function iwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Up(e) {
  return Up = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Up(e);
}
var Ed = /* @__PURE__ */ function(e) {
  ewe(r, e);
  var n = twe(r);
  function r() {
    var o;
    Xbe(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {
      isAnimationFinished: !1
    }, o.id = La("recharts-bar-"), o.handleAnimationEnd = function() {
      var f = o.props.onAnimationEnd;
      o.setState({
        isAnimationFinished: !0
      }), f && f();
    }, o.handleAnimationStart = function() {
      var f = o.props.onAnimationStart;
      o.setState({
        isAnimationFinished: !1
      }), f && f();
    }, o;
  }
  return Jbe(r, [{
    key: "renderRectanglesStatically",
    value: function(s) {
      var u = this, h = this.props.shape, f = Ye(this.props);
      return s && s.map(function(p, v) {
        var b = tr(tr(tr({}, f), p), {}, {
          index: v
        });
        return /* @__PURE__ */ hi(mt, {
          className: "recharts-bar-rectangle",
          ...Ia(u.props, p, v),
          key: "rectangle-".concat(v),
          role: "img"
        }, r.renderRectangle(h, b));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var s = this, u = this.props, h = u.data, f = u.layout, p = u.isAnimationActive, v = u.animationBegin, b = u.animationDuration, y = u.animationEasing, k = u.animationId, _ = this.state.prevData;
      return /* @__PURE__ */ M(mo, {
        begin: v,
        duration: b,
        isActive: p,
        easing: y,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart,
        children: function(E) {
          var x = E.t, D = h.map(function(I, N) {
            var O = _ && _[N];
            if (O) {
              var P = Sn(O.x, I.x), S = Sn(O.y, I.y), $ = Sn(O.width, I.width), L = Sn(O.height, I.height);
              return tr(tr({}, I), {}, {
                x: P(x),
                y: S(x),
                width: $(x),
                height: L(x)
              });
            }
            if (f === "horizontal") {
              var B = Sn(0, I.height), U = B(x);
              return tr(tr({}, I), {}, {
                y: I.y + I.height - U,
                height: U
              });
            }
            var G = Sn(0, I.width), q = G(x);
            return tr(tr({}, I), {}, {
              width: q
            });
          });
          return /* @__PURE__ */ M(mt, {
            children: s.renderRectanglesStatically(D)
          });
        }
      }, "bar-".concat(k));
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var s = this.props, u = s.data, h = s.isAnimationActive, f = this.state.prevData;
      return h && u && u.length && (!f || !Rs(f, u)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(u);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var s = this, u = this.props.data, h = Ye(this.props.background);
      return u.map(function(f, p) {
        f.value;
        var v = f.background, b = Ybe(f, ["value", "background"]);
        if (!v)
          return null;
        var y = tr(tr(tr(tr(tr({}, b), {}, {
          fill: "#eee"
        }, v), h), Ia(s.props, f, p)), {}, {
          index: p,
          key: "background-bar-".concat(p),
          className: "recharts-bar-background-rectangle"
        });
        return r.renderRectangle(s.props.background, y);
      });
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var s = this.props, u = s.data, h = s.xAxis, f = s.yAxis, p = s.layout, v = s.children, b = yr(v, Cd.displayName);
      if (!b)
        return null;
      var y = p === "vertical" ? u[0].height / 2 : u[0].width / 2;
      function k(_, E) {
        return {
          x: _.x,
          y: _.y,
          value: _.value,
          errorVal: mn(_, E)
        };
      }
      return b.map(function(_, E) {
        return /* @__PURE__ */ oe.cloneElement(_, {
          key: "error-bar-".concat(E),
          data: u,
          xAxis: h,
          yAxis: f,
          layout: p,
          offset: y,
          dataPointFormatter: k
        });
      });
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.hide, h = s.data, f = s.className, p = s.xAxis, v = s.yAxis, b = s.left, y = s.top, k = s.width, _ = s.height, E = s.isAnimationActive, x = s.background, D = s.id;
      if (u || !h || !h.length)
        return null;
      var I = this.state.isAnimationFinished, N = Ce("recharts-bar", f), O = p && p.allowDataOverflow || v && v.allowDataOverflow, P = Be(D) ? this.id : D;
      return /* @__PURE__ */ K(mt, {
        className: N,
        children: [O ? /* @__PURE__ */ M("defs", {
          children: /* @__PURE__ */ M("clipPath", {
            id: "clipPath-".concat(P),
            children: /* @__PURE__ */ M("rect", {
              x: b,
              y,
              width: k,
              height: _
            })
          })
        }) : null, /* @__PURE__ */ K(mt, {
          className: "recharts-bar-rectangles",
          clipPath: O ? "url(#clipPath-".concat(P, ")") : null,
          children: [x ? this.renderBackground() : null, this.renderRectangles()]
        }), this.renderErrorBar(), (!E || I) && ui.renderCallByParent(this.props, h)]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      return s.animationId !== u.prevAnimationId ? {
        prevAnimationId: s.animationId,
        curData: s.data,
        prevData: u.curData
      } : s.data !== u.curData ? {
        curData: s.data
      } : null;
    }
  }, {
    key: "renderRectangle",
    value: function(s, u) {
      var h;
      return /* @__PURE__ */ oe.isValidElement(s) ? h = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? h = s(u) : h = /* @__PURE__ */ M(Zg, {
        ...u
      }), h;
    }
  }]), r;
}(Ln);
Ed.displayName = "Bar";
Ed.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  isAnimationActive: !ci.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
};
Ed.getComposedData = function(e) {
  var n = e.props, r = e.item, o = e.barPosition, s = e.bandSize, u = e.xAxis, h = e.yAxis, f = e.xAxisTicks, p = e.yAxisTicks, v = e.stackedData, b = e.dataStartIndex, y = e.displayedData, k = e.offset, _ = Qpe(o, r);
  if (!_)
    return null;
  var E = n.layout, x = r.props, D = x.dataKey, I = x.children, N = x.minPointSize, O = E === "horizontal" ? h : u, P = v ? O.scale.domain() : null, S = ige({
    numericAxis: O
  }), $ = yr(I, Bg.displayName), L = y.map(function(B, U) {
    var G, q, Y, Q, Z, ae;
    if (v ? G = Zpe(v[b + U], P) : (G = mn(B, D), Tt(G) || (G = [S, G])), E === "horizontal") {
      if (q = sT({
        axis: u,
        ticks: f,
        bandSize: s,
        offset: _.offset,
        entry: B,
        index: U
      }), Y = h.scale(G[1]), Q = _.size, Z = h.scale(G[0]) - h.scale(G[1]), ae = {
        x: q,
        y: h.y,
        width: Q,
        height: h.height
      }, Math.abs(N) > 0 && Math.abs(Z) < Math.abs(N)) {
        var ie = pr(Z || N) * (Math.abs(N) - Math.abs(Z));
        Y -= ie, Z += ie;
      }
    } else if (q = u.scale(G[0]), Y = sT({
      axis: h,
      ticks: p,
      bandSize: s,
      offset: _.offset,
      entry: B,
      index: U
    }), Q = u.scale(G[1]) - u.scale(G[0]), Z = _.size, ae = {
      x: u.x,
      y: Y,
      width: u.width,
      height: Z
    }, Math.abs(N) > 0 && Math.abs(Q) < Math.abs(N)) {
      var pe = pr(Q || N) * (Math.abs(N) - Math.abs(Q));
      Q += pe;
    }
    return tr(tr(tr({}, B), {}, {
      x: q,
      y: Y,
      width: Q,
      height: Z,
      value: v ? G : G[1],
      payload: B,
      background: ae
    }, $ && $[U] && $[U].props), {}, {
      tooltipPayload: [l7(r, B)],
      tooltipPosition: {
        x: q + Q / 2,
        y: Y + Z / 2
      }
    });
  });
  return tr({
    data: L,
    layout: E
  }, k);
};
var tm = function() {
  return null;
};
tm.displayName = "ZAxis";
tm.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
};
function jf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jf = function(r) {
    return typeof r;
  } : jf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, jf(e);
}
function uD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function ni(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? uD(Object(r), !0).forEach(function(o) {
      owe(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function owe(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function awe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function dD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function swe(e, n, r) {
  return n && dD(e.prototype, n), r && dD(e, r), e;
}
function lwe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && Jw(e, n);
}
function Jw(e, n) {
  return Jw = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, Jw(e, n);
}
function cwe(e) {
  var n = hwe();
  return function() {
    var o = Wp(e), s;
    if (n) {
      var u = Wp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return uwe(this, s);
  };
}
function uwe(e, n) {
  return n && (jf(n) === "object" || typeof n == "function") ? n : dwe(e);
}
function dwe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Wp(e) {
  return Wp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Wp(e);
}
var nm = /* @__PURE__ */ function(e) {
  lwe(r, e);
  var n = cwe(r);
  function r() {
    var o;
    awe(this, r);
    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
      u[h] = arguments[h];
    return o = n.call.apply(n, [this].concat(u)), o.state = {
      isAnimationFinished: !1
    }, o.handleAnimationEnd = function() {
      o.setState({
        isAnimationFinished: !0
      });
    }, o.handleAnimationStart = function() {
      o.setState({
        isAnimationFinished: !1
      });
    }, o.id = La("recharts-scatter-"), o;
  }
  return swe(r, [{
    key: "renderSymbolsStatically",
    value: function(s) {
      var u = this, h = this.props, f = h.shape, p = h.activeShape, v = h.activeIndex, b = Ye(this.props);
      return s.map(function(y, k) {
        var _ = ni(ni({
          key: "symbol-".concat(k)
        }, b), y);
        return /* @__PURE__ */ hi(mt, {
          className: "recharts-scatter-symbol",
          ...Ia(u.props, y, k),
          key: "symbol-".concat(k),
          role: "img"
        }, r.renderSymbolItem(v === k ? p : f, _));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var s = this, u = this.props, h = u.points, f = u.isAnimationActive, p = u.animationBegin, v = u.animationDuration, b = u.animationEasing, y = u.animationId, k = this.state.prevPoints;
      return /* @__PURE__ */ M(mo, {
        begin: p,
        duration: v,
        isActive: f,
        easing: b,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart,
        children: function(_) {
          var E = _.t, x = h.map(function(D, I) {
            var N = k && k[I];
            if (N) {
              var O = Sn(N.cx, D.cx), P = Sn(N.cy, D.cy), S = Sn(N.size, D.size);
              return ni(ni({}, D), {}, {
                cx: O(E),
                cy: P(E),
                size: S(E)
              });
            }
            var $ = Sn(0, D.size);
            return ni(ni({}, D), {}, {
              size: $(E)
            });
          });
          return /* @__PURE__ */ M(mt, {
            children: s.renderSymbolsStatically(x)
          });
        }
      }, "pie-".concat(y));
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var s = this.props, u = s.points, h = s.isAnimationActive, f = this.state.prevPoints;
      return h && u && u.length && (!f || !Rs(f, u)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(u);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var s = this.props.isAnimationActive;
      if (s && !this.state.isAnimationFinished)
        return null;
      var u = this.props, h = u.points, f = u.xAxis, p = u.yAxis, v = u.children, b = yr(v, Cd.displayName);
      if (!b)
        return null;
      function y(_, E) {
        return {
          x: _.cx,
          y: _.cy,
          value: +_.node.y,
          errorVal: mn(_, E)
        };
      }
      function k(_, E) {
        return {
          x: _.cx,
          y: _.cy,
          value: +_.node.x,
          errorVal: mn(_, E)
        };
      }
      return b.map(function(_, E) {
        var x = _.props.direction;
        return /* @__PURE__ */ oe.cloneElement(_, {
          key: E,
          data: h,
          xAxis: f,
          yAxis: p,
          layout: x === "x" ? "vertical" : "horizontal",
          dataPointFormatter: x === "x" ? k : y
        });
      });
    }
  }, {
    key: "renderLine",
    value: function() {
      var s = this.props, u = s.points, h = s.line, f = s.lineType, p = s.lineJointType, v = Ye(this.props), b = Ye(h), y, k;
      if (f === "joint")
        y = u.map(function(P) {
          return {
            x: P.cx,
            y: P.cy
          };
        });
      else if (f === "fitting") {
        var _ = Lae(u), E = _.xmin, x = _.xmax, D = _.a, I = _.b, N = function(S) {
          return D * S + I;
        };
        y = [{
          x: E,
          y: N(E)
        }, {
          x,
          y: N(x)
        }];
      }
      var O = ni(ni(ni({}, v), {}, {
        fill: "none",
        stroke: v && v.fill
      }, b), {}, {
        points: y
      });
      return /* @__PURE__ */ oe.isValidElement(h) ? k = /* @__PURE__ */ oe.cloneElement(h, O) : qe(h) ? k = h(O) : k = /* @__PURE__ */ M(Go, {
        ...O,
        type: p
      }), /* @__PURE__ */ M(mt, {
        className: "recharts-scatter-line",
        children: k
      }, "recharts-scatter-line");
    }
  }, {
    key: "render",
    value: function() {
      var s = this.props, u = s.hide, h = s.points, f = s.line, p = s.className, v = s.xAxis, b = s.yAxis, y = s.left, k = s.top, _ = s.width, E = s.height, x = s.id, D = s.isAnimationActive;
      if (u || !h || !h.length)
        return null;
      var I = this.state.isAnimationFinished, N = Ce("recharts-scatter", p), O = v && v.allowDataOverflow || b && b.allowDataOverflow, P = Be(x) ? this.id : x;
      return /* @__PURE__ */ K(mt, {
        className: N,
        clipPath: O ? "url(#clipPath-".concat(P, ")") : null,
        children: [O ? /* @__PURE__ */ M("defs", {
          children: /* @__PURE__ */ M("clipPath", {
            id: "clipPath-".concat(P),
            children: /* @__PURE__ */ M("rect", {
              x: y,
              y: k,
              width: _,
              height: E
            })
          })
        }) : null, f && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ M(mt, {
          children: this.renderSymbols()
        }, "recharts-scatter-symbols"), (!D || I) && ui.renderCallByParent(this.props, h)]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(s, u) {
      return s.animationId !== u.prevAnimationId ? {
        prevAnimationId: s.animationId,
        curPoints: s.points,
        prevPoints: u.curPoints
      } : s.points !== u.curPoints ? {
        curPoints: s.points
      } : null;
    }
  }, {
    key: "renderSymbolItem",
    value: function(s, u) {
      var h;
      return /* @__PURE__ */ oe.isValidElement(s) ? h = /* @__PURE__ */ oe.cloneElement(s, u) : qe(s) ? h = s(u) : typeof s == "string" && (h = /* @__PURE__ */ M($g, {
        ...u,
        type: s
      })), h;
    }
  }]), r;
}(Ln);
nm.displayName = "Scatter";
nm.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !ci.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
};
nm.getComposedData = function(e) {
  var n = e.xAxis, r = e.yAxis, o = e.zAxis, s = e.item, u = e.displayedData, h = e.xAxisTicks, f = e.yAxisTicks, p = e.offset, v = s.props.tooltipType, b = yr(s.props.children, Bg.displayName), y = Be(n.dataKey) ? s.props.dataKey : n.dataKey, k = Be(r.dataKey) ? s.props.dataKey : r.dataKey, _ = o && o.dataKey, E = o ? o.range : tm.defaultProps.range, x = E && E[0], D = n.scale.bandwidth ? n.scale.bandwidth() : 0, I = r.scale.bandwidth ? r.scale.bandwidth() : 0, N = u.map(function(O, P) {
    var S = mn(O, y), $ = mn(O, k), L = !Be(_) && mn(O, _) || "-", B = [{
      name: Be(n.dataKey) ? s.props.name : n.name || n.dataKey,
      unit: n.unit || "",
      value: S,
      payload: O,
      dataKey: y,
      type: v
    }, {
      name: Be(r.dataKey) ? s.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: $,
      payload: O,
      dataKey: k,
      type: v
    }];
    L !== "-" && B.push({
      name: o.name || o.dataKey,
      unit: o.unit || "",
      value: L,
      payload: O,
      dataKey: _,
      type: v
    });
    var U = Ql({
      axis: n,
      ticks: h,
      bandSize: D,
      entry: O,
      index: P,
      dataKey: y
    }), G = Ql({
      axis: r,
      ticks: f,
      bandSize: I,
      entry: O,
      index: P,
      dataKey: k
    }), q = L !== "-" ? o.scale(L) : x, Y = Math.sqrt(Math.max(q, 0) / Math.PI);
    return ni(ni({}, O), {}, {
      cx: U,
      cy: G,
      x: U - Y,
      y: G - Y,
      xAxis: n,
      yAxis: r,
      zAxis: o,
      width: 2 * Y,
      height: 2 * Y,
      size: q,
      node: {
        x: S,
        y: $,
        z: L
      },
      tooltipPayload: B,
      tooltipPosition: {
        x: U,
        y: G
      },
      payload: O
    }, b && b[P] && b[P].props);
  });
  return ni({
    points: N
  }, p);
};
var yc = function() {
  return null;
};
yc.displayName = "XAxis";
yc.defaultProps = {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  domain: [0, "auto"],
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
};
var Fs = function() {
  return null;
};
Fs.displayName = "YAxis";
Fs.defaultProps = {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  domain: [0, "auto"],
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
};
var fwe = ko, pwe = fd, gwe = Tg;
function mwe(e) {
  return function(n, r, o) {
    var s = Object(n);
    if (!pwe(n)) {
      var u = fwe(r);
      n = gwe(n), r = function(f) {
        return u(s[f], f, s);
      };
    }
    var h = e(n, r, o);
    return h > -1 ? s[u ? n[h] : h] : void 0;
  };
}
var vwe = mwe, bwe = g7;
function wwe(e) {
  var n = bwe(e), r = n % 1;
  return n === n ? r ? n - r : n : 0;
}
var ywe = wwe, kwe = n3, _we = ko, Awe = ywe, Cwe = Math.max;
function xwe(e, n, r) {
  var o = e == null ? 0 : e.length;
  if (!o)
    return -1;
  var s = r == null ? 0 : Awe(r);
  return s < 0 && (s = Cwe(o + s, 0)), kwe(e, _we(n), s);
}
var Ewe = xwe, Swe = vwe, Mwe = Ewe, Twe = Swe(Mwe), Dwe = Twe, Iwe = Cue, Pwe = Vr, Owe = "Expected a function";
function Rwe(e, n, r) {
  var o = !0, s = !0;
  if (typeof e != "function")
    throw new TypeError(Owe);
  return Pwe(r) && (o = "leading" in r ? !!r.leading : o, s = "trailing" in r ? !!r.trailing : s), Iwe(e, n, {
    leading: o,
    maxWait: n,
    trailing: s
  });
}
var Nwe = Rwe, $we = Jo, Lwe = ea, jwe = "[object Boolean]";
function Bwe(e) {
  return e === !0 || e === !1 || Lwe(e) && $we(e) == jwe;
}
var Fwe = Bwe, e1 = function(n, r, o, s, u) {
  var h = yr(n, ik.displayName), f = yr(n, _d.displayName), p = h.concat(f), v = yr(n, Ad.displayName), b = "".concat(s, "Id"), y = s[0], k = r;
  if (p.length && (k = p.reduce(function(x, D) {
    if (D.props[b] === o && po(D.props, "extendDomain") && Oe(D.props[y])) {
      var I = D.props[y];
      return [Math.min(x[0], I), Math.max(x[1], I)];
    }
    return x;
  }, k)), v.length) {
    var _ = "".concat(y, "1"), E = "".concat(y, "2");
    k = v.reduce(function(x, D) {
      if (D.props[b] === o && po(D.props, "extendDomain") && Oe(D.props[_]) && Oe(D.props[E])) {
        var I = D.props[_], N = D.props[E];
        return [Math.min(x[0], I, N), Math.max(x[1], I, N)];
      }
      return x;
    }, k);
  }
  return u && u.length && (k = u.reduce(function(x, D) {
    return Oe(D) ? [Math.min(x[0], D), Math.max(x[1], D)] : x;
  }, k)), k;
}, k7 = { exports: {} };
(function(e) {
  var n = Object.prototype.hasOwnProperty, r = "~";
  function o() {
  }
  Object.create && (o.prototype = /* @__PURE__ */ Object.create(null), new o().__proto__ || (r = !1));
  function s(p, v, b) {
    this.fn = p, this.context = v, this.once = b || !1;
  }
  function u(p, v, b, y, k) {
    if (typeof b != "function")
      throw new TypeError("The listener must be a function");
    var _ = new s(b, y || p, k), E = r ? r + v : v;
    return p._events[E] ? p._events[E].fn ? p._events[E] = [p._events[E], _] : p._events[E].push(_) : (p._events[E] = _, p._eventsCount++), p;
  }
  function h(p, v) {
    --p._eventsCount === 0 ? p._events = new o() : delete p._events[v];
  }
  function f() {
    this._events = new o(), this._eventsCount = 0;
  }
  f.prototype.eventNames = function() {
    var v = [], b, y;
    if (this._eventsCount === 0)
      return v;
    for (y in b = this._events)
      n.call(b, y) && v.push(r ? y.slice(1) : y);
    return Object.getOwnPropertySymbols ? v.concat(Object.getOwnPropertySymbols(b)) : v;
  }, f.prototype.listeners = function(v) {
    var b = r ? r + v : v, y = this._events[b];
    if (!y)
      return [];
    if (y.fn)
      return [y.fn];
    for (var k = 0, _ = y.length, E = new Array(_); k < _; k++)
      E[k] = y[k].fn;
    return E;
  }, f.prototype.listenerCount = function(v) {
    var b = r ? r + v : v, y = this._events[b];
    return y ? y.fn ? 1 : y.length : 0;
  }, f.prototype.emit = function(v, b, y, k, _, E) {
    var x = r ? r + v : v;
    if (!this._events[x])
      return !1;
    var D = this._events[x], I = arguments.length, N, O;
    if (D.fn) {
      switch (D.once && this.removeListener(v, D.fn, void 0, !0), I) {
        case 1:
          return D.fn.call(D.context), !0;
        case 2:
          return D.fn.call(D.context, b), !0;
        case 3:
          return D.fn.call(D.context, b, y), !0;
        case 4:
          return D.fn.call(D.context, b, y, k), !0;
        case 5:
          return D.fn.call(D.context, b, y, k, _), !0;
        case 6:
          return D.fn.call(D.context, b, y, k, _, E), !0;
      }
      for (O = 1, N = new Array(I - 1); O < I; O++)
        N[O - 1] = arguments[O];
      D.fn.apply(D.context, N);
    } else {
      var P = D.length, S;
      for (O = 0; O < P; O++)
        switch (D[O].once && this.removeListener(v, D[O].fn, void 0, !0), I) {
          case 1:
            D[O].fn.call(D[O].context);
            break;
          case 2:
            D[O].fn.call(D[O].context, b);
            break;
          case 3:
            D[O].fn.call(D[O].context, b, y);
            break;
          case 4:
            D[O].fn.call(D[O].context, b, y, k);
            break;
          default:
            if (!N)
              for (S = 1, N = new Array(I - 1); S < I; S++)
                N[S - 1] = arguments[S];
            D[O].fn.apply(D[O].context, N);
        }
    }
    return !0;
  }, f.prototype.on = function(v, b, y) {
    return u(this, v, b, y, !1);
  }, f.prototype.once = function(v, b, y) {
    return u(this, v, b, y, !0);
  }, f.prototype.removeListener = function(v, b, y, k) {
    var _ = r ? r + v : v;
    if (!this._events[_])
      return this;
    if (!b)
      return h(this, _), this;
    var E = this._events[_];
    if (E.fn)
      E.fn === b && (!k || E.once) && (!y || E.context === y) && h(this, _);
    else {
      for (var x = 0, D = [], I = E.length; x < I; x++)
        (E[x].fn !== b || k && !E[x].once || y && E[x].context !== y) && D.push(E[x]);
      D.length ? this._events[_] = D.length === 1 ? D[0] : D : h(this, _);
    }
    return this;
  }, f.prototype.removeAllListeners = function(v) {
    var b;
    return v ? (b = r ? r + v : v, this._events[b] && h(this, b)) : (this._events = new o(), this._eventsCount = 0), this;
  }, f.prototype.off = f.prototype.removeListener, f.prototype.addListener = f.prototype.on, f.prefixed = r, f.EventEmitter = f, e.exports = f;
})(k7);
const zwe = k7.exports;
var Nr = new zwe();
Nr.setMaxListeners && Nr.setMaxListeners(10);
var lb = "recharts.syncMouseEvents";
function Bf(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bf = function(r) {
    return typeof r;
  } : Bf = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Bf(e);
}
function hD(e, n) {
  return Uwe(e) || Hwe(e, n) || _7(e, n) || Vwe();
}
function Vwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hwe(e, n) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], o = !0, s = !1, u = void 0;
    try {
      for (var h = e[Symbol.iterator](), f; !(o = (f = h.next()).done) && (r.push(f.value), !(n && r.length === n)); o = !0)
        ;
    } catch (p) {
      s = !0, u = p;
    } finally {
      try {
        !o && h.return != null && h.return();
      } finally {
        if (s)
          throw u;
      }
    }
    return r;
  }
}
function Uwe(e) {
  if (Array.isArray(e))
    return e;
}
function fD(e, n) {
  if (e == null)
    return {};
  var r = Wwe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function Wwe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
function Gwe(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function pD(e, n) {
  for (var r = 0; r < n.length; r++) {
    var o = n[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function qwe(e, n, r) {
  return n && pD(e.prototype, n), r && pD(e, r), e;
}
function Kwe(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && t1(e, n);
}
function t1(e, n) {
  return t1 = Object.setPrototypeOf || function(o, s) {
    return o.__proto__ = s, o;
  }, t1(e, n);
}
function Ywe(e) {
  var n = Zwe();
  return function() {
    var o = Gp(e), s;
    if (n) {
      var u = Gp(this).constructor;
      s = Reflect.construct(o, arguments, u);
    } else
      s = o.apply(this, arguments);
    return Qwe(this, s);
  };
}
function Qwe(e, n) {
  return n && (Bf(n) === "object" || typeof n == "function") ? n : n1(e);
}
function n1(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Zwe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Gp(e) {
  return Gp = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Gp(e);
}
function Xl(e) {
  return e1e(e) || Jwe(e) || _7(e) || Xwe();
}
function Xwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _7(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return r1(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return r1(e, n);
  }
}
function Jwe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function e1e(e) {
  if (Array.isArray(e))
    return r1(e);
}
function r1(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function gD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function _e(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? gD(Object(r), !0).forEach(function(o) {
      $r(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function $r(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
var t1e = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, A7 = {
  x: 0,
  y: 0
}, n1e = Number.isFinite ? Number.isFinite : isFinite, mD = typeof requestAnimationFrame == "function" ? requestAnimationFrame : typeof setImmediate == "function" ? setImmediate : setTimeout, vD = typeof cancelAnimationFrame == "function" ? cancelAnimationFrame : typeof clearImmediate == "function" ? clearImmediate : clearTimeout, r1e = function(n, r) {
  return r === "horizontal" ? n.x : r === "vertical" ? n.y : r === "centric" ? n.angle : n.radius;
}, i1e = function(n, r, o, s) {
  var u = r.find(function(b) {
    return b && b.index === o;
  });
  if (u) {
    if (n === "horizontal")
      return {
        x: u.coordinate,
        y: s.y
      };
    if (n === "vertical")
      return {
        x: s.x,
        y: u.coordinate
      };
    if (n === "centric") {
      var h = u.coordinate, f = s.radius;
      return _e(_e(_e({}, s), dn(s.cx, s.cy, f, h)), {}, {
        angle: h,
        radius: f
      });
    }
    var p = u.coordinate, v = s.angle;
    return _e(_e(_e({}, s), dn(s.cx, s.cy, p, v)), {}, {
      angle: v,
      radius: p
    });
  }
  return A7;
}, rm = function(n, r, o) {
  var s = r.graphicalItems, u = r.dataStartIndex, h = r.dataEndIndex, f = (s || []).reduce(function(p, v) {
    var b = v.props.data;
    return b && b.length ? [].concat(Xl(p), Xl(b)) : p;
  }, []);
  return f && f.length > 0 ? f : o && o.props && o.props.data && o.props.data.length > 0 ? o.props.data : n && n.length && Oe(u) && Oe(h) ? n.slice(u, h + 1) : [];
}, C7 = function(n, r, o, s) {
  var u = n.graphicalItems, h = n.tooltipAxis, f = rm(r, n);
  return o < 0 || !u || !u.length || o >= f.length ? null : u.reduce(function(p, v) {
    var b = v.props.hide;
    if (b)
      return p;
    var y = v.props.data, k;
    if (h.dataKey && !h.allowDuplicatedCategory) {
      var _ = y === void 0 ? f : y;
      k = ap(_, h.dataKey, s);
    } else
      k = y && y[o] || f[o];
    return k ? [].concat(Xl(p), [l7(v, k)]) : p;
  }, []);
}, bD = function(n, r, o, s) {
  var u = s || {
    x: n.chartX,
    y: n.chartY
  }, h = r1e(u, o), f = n.orderedTooltipTicks, p = n.tooltipAxis, v = n.tooltipTicks, b = Upe(h, f, v, p);
  if (b >= 0 && v) {
    var y = v[b] && v[b].value, k = C7(n, r, b, y), _ = i1e(o, f, b, u);
    return {
      activeTooltipIndex: b,
      activeLabel: y,
      activePayload: k,
      activeCoordinate: _
    };
  }
  return null;
}, o1e = function(n, r) {
  var o = r.axes, s = r.graphicalItems, u = r.axisType, h = r.axisIdKey, f = r.stackGroups, p = r.dataStartIndex, v = r.dataEndIndex, b = n.layout, y = n.children, k = n.stackOffset, _ = n7(b, u), E = o.reduce(function(x, D) {
    var I = D.props, N = I.type, O = I.dataKey, P = I.allowDataOverflow, S = I.allowDuplicatedCategory, $ = I.scale, L = I.ticks, B = D.props[h], U = rm(n.data, {
      graphicalItems: s.filter(function(ce) {
        return ce.props[h] === B;
      }),
      dataStartIndex: p,
      dataEndIndex: v
    }), G = U.length;
    if (!x[B]) {
      var q, Y, Q;
      if (O) {
        if (q = Ep(U, O, N), N === "category" && _) {
          var Z = $ae(q);
          S && Z ? (Y = q, q = jp(0, G)) : S || (q = uT(D.props.domain, q, D).reduce(function(ce, ue) {
            return ce.indexOf(ue) >= 0 ? ce : [].concat(Xl(ce), [ue]);
          }, []));
        } else if (N === "category")
          S ? q = q.filter(function(ce) {
            return ce !== "" && !Be(ce);
          }) : q = uT(D.props.domain, q, D).reduce(function(ce, ue) {
            return ce.indexOf(ue) >= 0 || ue === "" || Be(ue) ? ce : [].concat(Xl(ce), [ue]);
          }, []);
        else if (N === "number") {
          var ae = Ype(U, s.filter(function(ce) {
            return ce.props[h] === B && !ce.props.hide;
          }), O, u, b);
          ae && (q = ae);
        }
        _ && (N === "number" || $ !== "auto") && (Q = Ep(U, O, "category"));
      } else
        _ ? q = jp(0, G) : f && f[B] && f[B].hasStack && N === "number" ? q = k === "expand" ? [0, 1] : a7(f[B].stackGroups, p, v) : q = t7(U, s.filter(function(ce) {
          return ce.props[h] === B && !ce.props.hide;
        }), N, b, !0);
      if (N === "number")
        q = e1(y, q, B, u, L), D.props.domain && (q = s7(D.props.domain, q, P));
      else if (N === "category" && D.props.domain) {
        var ie = D.props.domain, pe = q.every(function(ce) {
          return ie.indexOf(ce) >= 0;
        });
        pe && (q = ie);
      }
      return _e(_e({}, x), {}, $r({}, B, _e(_e({}, D.props), {}, {
        axisType: u,
        domain: q,
        categoricalDomain: Q,
        duplicateDomain: Y,
        originalDomain: D.props.domain,
        isCategorical: _,
        layout: b
      })));
    }
    return x;
  }, {});
  return E;
}, a1e = function(n, r) {
  var o = r.graphicalItems, s = r.Axis, u = r.axisType, h = r.axisIdKey, f = r.stackGroups, p = r.dataStartIndex, v = r.dataEndIndex, b = n.layout, y = n.children, k = rm(n.data, {
    graphicalItems: o,
    dataStartIndex: p,
    dataEndIndex: v
  }), _ = k.length, E = n7(b, u), x = -1, D = o.reduce(function(I, N) {
    var O = N.props[h];
    if (!I[O]) {
      x++;
      var P;
      return E ? P = jp(0, _) : f && f[O] && f[O].hasStack ? (P = a7(f[O].stackGroups, p, v), P = e1(y, P, O, u)) : (P = s7(s.defaultProps.domain, t7(k, o.filter(function(S) {
        return S.props[h] === O && !S.props.hide;
      }), "number", b), s.defaultProps.allowDataOverflow), P = e1(y, P, O, u)), _e(_e({}, I), {}, $r({}, O, _e(_e({
        axisType: u
      }, s.defaultProps), {}, {
        hide: !0,
        orientation: Hn(t1e, "".concat(u, ".").concat(x % 2), null),
        domain: P,
        originalDomain: s.defaultProps.domain,
        isCategorical: E,
        layout: b
      })));
    }
    return I;
  }, {});
  return D;
}, s1e = function(n, r) {
  var o = r.axisType, s = o === void 0 ? "xAxis" : o, u = r.AxisComp, h = r.graphicalItems, f = r.stackGroups, p = r.dataStartIndex, v = r.dataEndIndex, b = n.children, y = "".concat(s, "Id"), k = yr(b, u), _ = {};
  return k && k.length ? _ = o1e(n, {
    axes: k,
    graphicalItems: h,
    axisType: s,
    axisIdKey: y,
    stackGroups: f,
    dataStartIndex: p,
    dataEndIndex: v
  }) : h && h.length && (_ = a1e(n, {
    Axis: u,
    graphicalItems: h,
    axisType: s,
    axisIdKey: y,
    stackGroups: f,
    dataStartIndex: p,
    dataEndIndex: v
  })), _;
}, l1e = function(n) {
  var r = ma(n), o = va(r, !1, !0);
  return {
    tooltipTicks: o,
    orderedTooltipTicks: Py(o, function(s) {
      return s.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Sp(r, o)
  };
}, wD = function(n) {
  var r, o, s = n.children, u = n.defaultShowTooltip, h = Fo(s, Bs.displayName), f = h && h.props && h.props.startIndex || 0, p = (h == null || (r = h.props) === null || r === void 0 ? void 0 : r.endIndex) !== void 0 ? h == null || (o = h.props) === null || o === void 0 ? void 0 : o.endIndex : n.data && n.data.length - 1 || 0;
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: f,
    dataEndIndex: p,
    activeTooltipIndex: -1,
    isTooltipActive: Be(u) ? !1 : u
  };
}, c1e = function(n) {
  return !n || !n.length ? !1 : n.some(function(r) {
    var o = Sa(r && r.type);
    return o && o.indexOf("Bar") >= 0;
  });
}, yD = function(n) {
  return n === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : n === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : n === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, u1e = function(n, r) {
  var o = n.props, s = n.graphicalItems, u = n.xAxisMap, h = u === void 0 ? {} : u, f = n.yAxisMap, p = f === void 0 ? {} : f, v = o.width, b = o.height, y = o.children, k = o.margin || {}, _ = Fo(y, Bs.displayName), E = Fo(y, Os.displayName), x = Object.keys(p).reduce(function(O, P) {
    var S = p[P], $ = S.orientation;
    return !S.mirror && !S.hide ? _e(_e({}, O), {}, $r({}, $, O[$] + S.width)) : O;
  }, {
    left: k.left || 0,
    right: k.right || 0
  }), D = Object.keys(h).reduce(function(O, P) {
    var S = h[P], $ = S.orientation;
    return !S.mirror && !S.hide ? _e(_e({}, O), {}, $r({}, $, Hn(O, "".concat($)) + S.height)) : O;
  }, {
    top: k.top || 0,
    bottom: k.bottom || 0
  }), I = _e(_e({}, D), x), N = I.bottom;
  return _ && (I.bottom += _.props.height || Bs.defaultProps.height), E && r && (I = qpe(I, s, o, r)), _e(_e({
    brushBottom: N
  }, I), {}, {
    width: v - I.left - I.right,
    height: b - I.top - I.bottom
  });
}, ok = function(n) {
  var r, o, s = n.chartName, u = n.GraphicalChild, h = n.defaultTooltipEventType, f = h === void 0 ? "axis" : h, p = n.validateTooltipEventTypes, v = p === void 0 ? ["axis"] : p, b = n.axisComponents, y = n.legendContent, k = n.formatAxisMap, _ = n.defaultProps, E = function(I, N) {
    var O = N.graphicalItems, P = N.stackGroups, S = N.offset, $ = N.updateId, L = N.dataStartIndex, B = N.dataEndIndex, U = I.barSize, G = I.layout, q = I.barGap, Y = I.barCategoryGap, Q = I.maxBarSize, Z = yD(G), ae = Z.numericAxisName, ie = Z.cateAxisName, pe = c1e(O), ce = pe && Wpe({
      barSize: U,
      stackGroups: P
    }), ue = [];
    return O.forEach(function(X, se) {
      var he = rm(I.data, {
        dataStartIndex: L,
        dataEndIndex: B
      }, X), de = X.props, me = de.dataKey, we = de.maxBarSize, Ae = X.props["".concat(ae, "Id")], Se = X.props["".concat(ie, "Id")], ke = b.reduce(function(mr, _r) {
        var Mn, Pe = N["".concat(_r.axisType, "Map")], Ke = X.props["".concat(_r.axisType, "Id")], zt = Pe && Pe[Ke];
        return _e(_e({}, mr), {}, (Mn = {}, $r(Mn, _r.axisType, zt), $r(Mn, "".concat(_r.axisType, "Ticks"), va(zt)), Mn));
      }, {}), ge = ke[ie], xe = ke["".concat(ie, "Ticks")], Te = P && P[Ae] && P[Ae].hasStack && oge(X, P[Ae].stackGroups), J = Sa(X.type).indexOf("Bar") >= 0, Ge = Sp(ge, xe), De = [];
      if (J) {
        var He, at, qt = Be(we) ? Q : we, An = (He = (at = Sp(ge, xe, !0)) !== null && at !== void 0 ? at : qt) !== null && He !== void 0 ? He : 0;
        De = Gpe({
          barGap: q,
          barCategoryGap: Y,
          bandSize: An !== Ge ? An : Ge,
          sizeList: ce[Se],
          maxBarSize: qt
        }), An !== Ge && (De = De.map(function(mr) {
          return _e(_e({}, mr), {}, {
            position: _e(_e({}, mr.position), {}, {
              offset: mr.position.offset - An / 2
            })
          });
        }));
      }
      var Lt = X && X.type && X.type.getComposedData;
      if (Lt) {
        var Ft;
        ue.push({
          props: _e(_e({}, Lt(_e(_e({}, ke), {}, {
            displayedData: he,
            props: I,
            dataKey: me,
            item: X,
            bandSize: Ge,
            barPosition: De,
            offset: S,
            stackedData: Te,
            layout: G,
            dataStartIndex: L,
            dataEndIndex: B
          }))), {}, (Ft = {
            key: X.key || "item-".concat(se)
          }, $r(Ft, ae, ke[ae]), $r(Ft, ie, ke[ie]), $r(Ft, "animationId", $), Ft)),
          childIndex: _de(X, I.children),
          item: X
        });
      }
    }), ue;
  }, x = function(I, N) {
    var O = I.props, P = I.dataStartIndex, S = I.dataEndIndex, $ = I.updateId;
    if (!mM({
      props: O
    }))
      return null;
    var L = O.children, B = O.layout, U = O.stackOffset, G = O.data, q = O.reverseStackOrder, Y = yD(B), Q = Y.numericAxisName, Z = Y.cateAxisName, ae = yr(L, u), ie = nge(G, ae, "".concat(Q, "Id"), "".concat(Z, "Id"), U, q), pe = b.reduce(function(he, de) {
      var me = "".concat(de.axisType, "Map");
      return _e(_e({}, he), {}, $r({}, me, s1e(O, _e(_e({}, de), {}, {
        graphicalItems: ae,
        stackGroups: de.axisType === Q && ie,
        dataStartIndex: P,
        dataEndIndex: S
      }))));
    }, {}), ce = u1e(_e(_e({}, pe), {}, {
      props: O,
      graphicalItems: ae
    }), N?.legendBBox);
    Object.keys(pe).forEach(function(he) {
      pe[he] = k(O, pe[he], ce, he.replace("Map", ""), s);
    });
    var ue = pe["".concat(Z, "Map")], X = l1e(ue), se = E(O, _e(_e({}, pe), {}, {
      dataStartIndex: P,
      dataEndIndex: S,
      updateId: $,
      graphicalItems: ae,
      stackGroups: ie,
      offset: ce
    }));
    return _e(_e({
      formattedGraphicalItems: se,
      graphicalItems: ae,
      offset: ce,
      stackGroups: ie
    }, X), pe);
  };
  return o = r = /* @__PURE__ */ function(D) {
    Kwe(N, D);
    var I = Ywe(N);
    function N(O) {
      var P;
      return Gwe(this, N), P = I.call(this, O), P.uniqueChartId = void 0, P.clipPathId = void 0, P.legendInstance = void 0, P.deferId = void 0, P.container = void 0, P.clearDeferId = function() {
        !Be(P.deferId) && vD && vD(P.deferId), P.deferId = null;
      }, P.handleLegendBBoxUpdate = function(S) {
        if (S) {
          var $ = P.state, L = $.dataStartIndex, B = $.dataEndIndex, U = $.updateId;
          P.setState(_e({
            legendBBox: S
          }, x({
            props: P.props,
            dataStartIndex: L,
            dataEndIndex: B,
            updateId: U
          }, _e(_e({}, P.state), {}, {
            legendBBox: S
          }))));
        }
      }, P.handleReceiveSyncEvent = function(S, $, L) {
        var B = P.props.syncId;
        B === S && $ !== P.uniqueChartId && (P.clearDeferId(), P.deferId = mD && mD(P.applySyncEvent.bind(n1(P), L)));
      }, P.handleBrushChange = function(S) {
        var $ = S.startIndex, L = S.endIndex;
        if ($ !== P.state.dataStartIndex || L !== P.state.dataEndIndex) {
          var B = P.state.updateId;
          P.setState(function() {
            return _e({
              dataStartIndex: $,
              dataEndIndex: L
            }, x({
              props: P.props,
              dataStartIndex: $,
              dataEndIndex: L,
              updateId: B
            }, P.state));
          }), P.triggerSyncEvent({
            dataStartIndex: $,
            dataEndIndex: L
          });
        }
      }, P.handleMouseEnter = function(S) {
        var $ = P.props.onMouseEnter, L = P.getMouseInfo(S);
        if (L) {
          var B = _e(_e({}, L), {}, {
            isTooltipActive: !0
          });
          P.setState(B), P.triggerSyncEvent(B), qe($) && $(B, S);
        }
      }, P.triggeredAfterMouseMove = function(S) {
        var $ = P.props.onMouseMove, L = P.getMouseInfo(S), B = L ? _e(_e({}, L), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        P.setState(B), P.triggerSyncEvent(B), qe($) && $(B, S);
      }, P.handleItemMouseEnter = function(S) {
        P.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: S,
            activePayload: S.tooltipPayload,
            activeCoordinate: S.tooltipPosition || {
              x: S.cx,
              y: S.cy
            }
          };
        });
      }, P.handleItemMouseLeave = function() {
        P.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }, P.handleMouseMove = function(S) {
        S && qe(S.persist) && S.persist(), P.triggeredAfterMouseMove(S);
      }, P.handleMouseLeave = function(S) {
        var $ = P.props.onMouseLeave, L = {
          isTooltipActive: !1
        };
        P.setState(L), P.triggerSyncEvent(L), qe($) && $(L, S), P.cancelThrottledTriggerAfterMouseMove();
      }, P.handleOuterEvent = function(S) {
        var $ = kde(S), L = Hn(P.props, "".concat($));
        if ($ && qe(L)) {
          var B;
          /.*touch.*/i.test($) ? B = P.getMouseInfo(S.changedTouches[0]) : B = P.getMouseInfo(S);
          var U = L;
          U(B, S);
        }
      }, P.handleClick = function(S) {
        var $ = P.props.onClick, L = P.getMouseInfo(S);
        if (L) {
          var B = _e(_e({}, L), {}, {
            isTooltipActive: !0
          });
          P.setState(B), P.triggerSyncEvent(B), qe($) && $(B, S);
        }
      }, P.handleMouseDown = function(S) {
        var $ = P.props.onMouseDown;
        if (qe($)) {
          var L = P.getMouseInfo(S);
          $(L, S);
        }
      }, P.handleMouseUp = function(S) {
        var $ = P.props.onMouseUp;
        if (qe($)) {
          var L = P.getMouseInfo(S);
          $(L, S);
        }
      }, P.handleTouchMove = function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && P.handleMouseMove(S.changedTouches[0]);
      }, P.handleTouchStart = function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && P.handleMouseDown(S.changedTouches[0]);
      }, P.handleTouchEnd = function(S) {
        S.changedTouches != null && S.changedTouches.length > 0 && P.handleMouseUp(S.changedTouches[0]);
      }, P.verticalCoordinatesGenerator = function(S) {
        var $ = S.xAxis, L = S.width, B = S.height, U = S.offset;
        return oT(ys.getTicks(_e(_e(_e({}, ys.defaultProps), $), {}, {
          ticks: va($, !0),
          viewBox: {
            x: 0,
            y: 0,
            width: L,
            height: B
          }
        })), U.left, U.left + U.width);
      }, P.horizontalCoordinatesGenerator = function(S) {
        var $ = S.yAxis, L = S.width, B = S.height, U = S.offset;
        return oT(ys.getTicks(_e(_e(_e({}, ys.defaultProps), $), {}, {
          ticks: va($, !0),
          viewBox: {
            x: 0,
            y: 0,
            width: L,
            height: B
          }
        })), U.top, U.top + U.height);
      }, P.axesTicksGenerator = function(S) {
        return va(S, !0);
      }, P.renderCursor = function(S) {
        var $ = P.state, L = $.isTooltipActive, B = $.activeCoordinate, U = $.activePayload, G = $.offset, q = $.activeTooltipIndex, Y = P.getTooltipEventType();
        if (!S || !S.props.cursor || !L || !B || s !== "ScatterChart" && Y !== "axis")
          return null;
        var Q = P.props.layout, Z, ae = Go;
        if (s === "ScatterChart")
          Z = B, ae = f7;
        else if (s === "BarChart")
          Z = P.getCursorRectangle(), ae = Zg;
        else if (Q === "radial") {
          var ie = P.getCursorPoints(), pe = ie.cx, ce = ie.cy, ue = ie.radius, X = ie.startAngle, se = ie.endAngle;
          Z = {
            cx: pe,
            cy: ce,
            startAngle: X,
            endAngle: se,
            innerRadius: ue,
            outerRadius: ue
          }, ae = Zl;
        } else
          Z = {
            points: P.getCursorPoints()
          }, ae = Go;
        var he = S.key || "_recharts-cursor", de = _e(_e(_e(_e({
          stroke: "#ccc",
          pointerEvents: "none"
        }, G), Z), Ye(S.props.cursor)), {}, {
          payload: U,
          payloadIndex: q,
          key: he,
          className: "recharts-tooltip-cursor"
        });
        return /* @__PURE__ */ Ho(S.props.cursor) ? /* @__PURE__ */ cr(S.props.cursor, de) : /* @__PURE__ */ hi(ae, de);
      }, P.renderPolarAxis = function(S, $, L) {
        var B = Hn(S, "type.axisType"), U = Hn(P.state, "".concat(B, "Map")), G = U[S.props["".concat(B, "Id")]];
        return /* @__PURE__ */ cr(S, _e(_e({}, G), {}, {
          className: B,
          key: S.key || "".concat($, "-").concat(L),
          ticks: va(G, !0)
        }));
      }, P.renderXAxis = function(S, $, L) {
        var B = P.state.xAxisMap, U = B[S.props.xAxisId];
        return P.renderAxis(U, S, $, L);
      }, P.renderYAxis = function(S, $, L) {
        var B = P.state.yAxisMap, U = B[S.props.yAxisId];
        return P.renderAxis(U, S, $, L);
      }, P.renderGrid = function(S) {
        var $ = P.state, L = $.xAxisMap, B = $.yAxisMap, U = $.offset, G = P.props, q = G.width, Y = G.height, Q = ma(L), Z = Dwe(B, function(pe) {
          return v7(pe.domain, n1e);
        }), ae = Z || ma(B), ie = S.props || {};
        return /* @__PURE__ */ cr(S, {
          key: S.key || "grid",
          x: Oe(ie.x) ? ie.x : U.left,
          y: Oe(ie.y) ? ie.y : U.top,
          width: Oe(ie.width) ? ie.width : U.width,
          height: Oe(ie.height) ? ie.height : U.height,
          xAxis: Q,
          yAxis: ae,
          offset: U,
          chartWidth: q,
          chartHeight: Y,
          verticalCoordinatesGenerator: ie.verticalCoordinatesGenerator || P.verticalCoordinatesGenerator,
          horizontalCoordinatesGenerator: ie.horizontalCoordinatesGenerator || P.horizontalCoordinatesGenerator
        });
      }, P.renderPolarGrid = function(S) {
        var $ = S.props, L = $.radialLines, B = $.polarAngles, U = $.polarRadius, G = P.state, q = G.radiusAxisMap, Y = G.angleAxisMap, Q = ma(q), Z = ma(Y), ae = Z.cx, ie = Z.cy, pe = Z.innerRadius, ce = Z.outerRadius;
        return /* @__PURE__ */ cr(S, {
          polarAngles: Tt(B) ? B : va(Z, !0).map(function(ue) {
            return ue.coordinate;
          }),
          polarRadius: Tt(U) ? U : va(Q, !0).map(function(ue) {
            return ue.coordinate;
          }),
          cx: ae,
          cy: ie,
          innerRadius: pe,
          outerRadius: ce,
          key: S.key || "polar-grid",
          radialLines: L
        });
      }, P.renderLegend = function() {
        var S = P.state.formattedGraphicalItems, $ = P.props, L = $.children, B = $.width, U = $.height, G = P.props.margin || {}, q = B - (G.left || 0) - (G.right || 0), Y = JP({
          children: L,
          formattedGraphicalItems: S,
          legendWidth: q,
          legendContent: y
        });
        if (!Y)
          return null;
        var Q = Y.item, Z = fD(Y, ["item"]);
        return /* @__PURE__ */ cr(Q, _e(_e({}, Z), {}, {
          chartWidth: B,
          chartHeight: U,
          margin: G,
          ref: function(ie) {
            P.legendInstance = ie;
          },
          onBBoxUpdate: P.handleLegendBBoxUpdate
        }));
      }, P.renderTooltip = function() {
        var S = P.props.children, $ = Fo(S, Ca.displayName);
        if (!$)
          return null;
        var L = P.state, B = L.isTooltipActive, U = L.activeCoordinate, G = L.activePayload, q = L.activeLabel, Y = L.offset;
        return /* @__PURE__ */ cr($, {
          viewBox: _e(_e({}, Y), {}, {
            x: Y.left,
            y: Y.top
          }),
          active: B,
          label: q,
          payload: B ? G : [],
          coordinate: U
        });
      }, P.renderBrush = function(S) {
        var $ = P.props, L = $.margin, B = $.data, U = P.state, G = U.offset, q = U.dataStartIndex, Y = U.dataEndIndex, Q = U.updateId;
        return /* @__PURE__ */ cr(S, {
          key: S.key || "_recharts-brush",
          onChange: tf(P.handleBrushChange, null, S.props.onChange),
          data: B,
          x: Oe(S.props.x) ? S.props.x : G.left,
          y: Oe(S.props.y) ? S.props.y : G.top + G.height + G.brushBottom - (L.bottom || 0),
          width: Oe(S.props.width) ? S.props.width : G.width,
          startIndex: q,
          endIndex: Y,
          updateId: "brush-".concat(Q)
        });
      }, P.renderReferenceElement = function(S, $, L) {
        if (!S)
          return null;
        var B = n1(P), U = B.clipPathId, G = P.state, q = G.xAxisMap, Y = G.yAxisMap, Q = G.offset, Z = S.props, ae = Z.xAxisId, ie = Z.yAxisId;
        return /* @__PURE__ */ cr(S, {
          key: S.key || "".concat($, "-").concat(L),
          xAxis: q[ae],
          yAxis: Y[ie],
          viewBox: {
            x: Q.left,
            y: Q.top,
            width: Q.width,
            height: Q.height
          },
          clipPathId: U
        });
      }, P.renderActivePoints = function(S) {
        var $ = S.item, L = S.activePoint, B = S.basePoint, U = S.childIndex, G = S.isRange, q = [], Y = $.props.key, Q = $.item.props, Z = Q.activeDot, ae = Q.dataKey, ie = _e(_e({
          index: U,
          dataKey: ae,
          cx: L.x,
          cy: L.y,
          r: 4,
          fill: tk($.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: L.payload,
          value: L.value,
          key: "".concat(Y, "-activePoint-").concat(U)
        }, Ye(Z)), Qf(Z));
        return q.push(N.renderActiveDot(Z, ie)), B ? q.push(N.renderActiveDot(Z, _e(_e({}, ie), {}, {
          cx: B.x,
          cy: B.y,
          key: "".concat(Y, "-basePoint-").concat(U)
        }))) : G && q.push(null), q;
      }, P.renderGraphicChild = function(S, $, L) {
        var B = P.filterFormatItem(S, $, L);
        if (!B)
          return null;
        var U = P.getTooltipEventType(), G = P.state, q = G.isTooltipActive, Y = G.tooltipAxis, Q = G.activeTooltipIndex, Z = G.activeLabel, ae = P.props.children, ie = Fo(ae, Ca.displayName), pe = B.props, ce = pe.points, ue = pe.isRange, X = pe.baseLine, se = B.item.props, he = se.activeDot, de = se.hide, me = !de && q && ie && he && Q >= 0, we = {};
        U !== "axis" && ie && ie.props.trigger === "click" ? we = {
          onClick: tf(P.handleItemMouseEnter, null, S.props.onCLick)
        } : U !== "axis" && (we = {
          onMouseLeave: tf(P.handleItemMouseLeave, null, S.props.onMouseLeave),
          onMouseEnter: tf(P.handleItemMouseEnter, null, S.props.onMouseEnter)
        });
        var Ae = /* @__PURE__ */ cr(S, _e(_e({}, B.props), we));
        function Se(Te) {
          return typeof Y.dataKey == "function" ? Y.dataKey(Te.payload) : null;
        }
        if (me) {
          var ke, ge;
          if (Y.dataKey && !Y.allowDuplicatedCategory) {
            var xe = typeof Y.dataKey == "function" ? Se : "payload.".concat(Y.dataKey.toString());
            ke = ap(ce, xe, Z), ge = ue && X && ap(X, xe, Z);
          } else
            ke = ce[Q], ge = ue && X && X[Q];
          if (!Be(ke))
            return [Ae].concat(Xl(P.renderActivePoints({
              item: B,
              activePoint: ke,
              basePoint: ge,
              childIndex: Q,
              isRange: ue
            })));
        }
        return ue ? [Ae, null, null] : [Ae, null];
      }, P.renderCustomized = function(S, $, L) {
        return /* @__PURE__ */ cr(S, _e(_e({
          key: "recharts-customized-".concat(L)
        }, P.props), P.state));
      }, P.uniqueChartId = Be(O.id) ? La("recharts") : O.id, P.clipPathId = "".concat(P.uniqueChartId, "-clip"), O.throttleDelay && (P.triggeredAfterMouseMove = Nwe(P.triggeredAfterMouseMove, O.throttleDelay)), P.state = {}, P;
    }
    return qwe(N, [{
      key: "componentDidMount",
      value: function() {
        Be(this.props.syncId) || this.addListener();
      }
    }, {
      key: "componentDidUpdate",
      value: function(P) {
        Be(P.syncId) && !Be(this.props.syncId) && this.addListener(), !Be(P.syncId) && Be(this.props.syncId) && this.removeListener();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDeferId(), Be(this.props.syncId) || this.removeListener(), this.cancelThrottledTriggerAfterMouseMove();
      }
    }, {
      key: "cancelThrottledTriggerAfterMouseMove",
      value: function() {
        typeof this.triggeredAfterMouseMove.cancel == "function" && this.triggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var P = Fo(this.props.children, Ca.displayName);
        if (P && Fwe(P.props.shared)) {
          var S = P.props.shared ? "axis" : "item";
          return v.indexOf(S) >= 0 ? S : f;
        }
        return f;
      }
    }, {
      key: "getMouseInfo",
      value: function(P) {
        if (!this.container)
          return null;
        var S = Xue(this.container), $ = Jue(P, S), L = this.inRange($.chartX, $.chartY);
        if (!L)
          return null;
        var B = this.state, U = B.xAxisMap, G = B.yAxisMap, q = this.getTooltipEventType();
        if (q !== "axis" && U && G) {
          var Y = ma(U).scale, Q = ma(G).scale, Z = Y && Y.invert ? Y.invert($.chartX) : null, ae = Q && Q.invert ? Q.invert($.chartY) : null;
          return _e(_e({}, $), {}, {
            xValue: Z,
            yValue: ae
          });
        }
        var ie = bD(this.state, this.props.data, this.props.layout, L);
        return ie ? _e(_e({}, $), ie) : null;
      }
    }, {
      key: "getCursorRectangle",
      value: function() {
        var P = this.props.layout, S = this.state, $ = S.activeCoordinate, L = S.offset, B = S.tooltipAxisBandSize, U = B / 2;
        return {
          stroke: "none",
          fill: "#ccc",
          x: P === "horizontal" ? $.x - U : L.left + 0.5,
          y: P === "horizontal" ? L.top + 0.5 : $.y - U,
          width: P === "horizontal" ? B : L.width - 1,
          height: P === "horizontal" ? L.height - 1 : B
        };
      }
    }, {
      key: "getCursorPoints",
      value: function() {
        var P = this.props.layout, S = this.state, $ = S.activeCoordinate, L = S.offset, B, U, G, q;
        if (P === "horizontal")
          B = $.x, G = B, U = L.top, q = L.top + L.height;
        else if (P === "vertical")
          U = $.y, q = U, B = L.left, G = L.left + L.width;
        else if (!Be($.cx) || !Be($.cy))
          if (P === "centric") {
            var Y = $.cx, Q = $.cy, Z = $.innerRadius, ae = $.outerRadius, ie = $.angle, pe = dn(Y, Q, Z, ie), ce = dn(Y, Q, ae, ie);
            B = pe.x, U = pe.y, G = ce.x, q = ce.y;
          } else {
            var ue = $.cx, X = $.cy, se = $.radius, he = $.startAngle, de = $.endAngle, me = dn(ue, X, se, he), we = dn(ue, X, se, de);
            return {
              points: [me, we],
              cx: ue,
              cy: X,
              radius: se,
              startAngle: he,
              endAngle: de
            };
          }
        return [{
          x: B,
          y: U
        }, {
          x: G,
          y: q
        }];
      }
    }, {
      key: "inRange",
      value: function(P, S) {
        var $ = this.props.layout;
        if ($ === "horizontal" || $ === "vertical") {
          var L = this.state.offset, B = P >= L.left && P <= L.left + L.width && S >= L.top && S <= L.top + L.height;
          return B ? {
            x: P,
            y: S
          } : null;
        }
        var U = this.state, G = U.angleAxisMap, q = U.radiusAxisMap;
        if (G && q) {
          var Y = ma(G);
          return fT({
            x: P,
            y: S
          }, Y);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var P = this.props.children, S = this.getTooltipEventType(), $ = Fo(P, Ca.displayName), L = {};
        $ && S === "axis" && ($.props.trigger === "click" ? L = {
          onClick: this.handleClick
        } : L = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var B = Qf(this.props, this.handleOuterEvent);
        return _e(_e({}, B), L);
      }
    }, {
      key: "addListener",
      value: function() {
        Nr.on(lb, this.handleReceiveSyncEvent), Nr.setMaxListeners && Nr._maxListeners && Nr.setMaxListeners(Nr._maxListeners + 1);
      }
    }, {
      key: "removeListener",
      value: function() {
        Nr.removeListener(lb, this.handleReceiveSyncEvent), Nr.setMaxListeners && Nr._maxListeners && Nr.setMaxListeners(Nr._maxListeners - 1);
      }
    }, {
      key: "triggerSyncEvent",
      value: function(P) {
        var S = this.props.syncId;
        Be(S) || Nr.emit(lb, S, this.uniqueChartId, P);
      }
    }, {
      key: "applySyncEvent",
      value: function(P) {
        var S = this.props, $ = S.layout, L = S.syncMethod, B = this.state.updateId, U = P.dataStartIndex, G = P.dataEndIndex;
        if (!Be(P.dataStartIndex) || !Be(P.dataEndIndex))
          this.setState(_e({
            dataStartIndex: U,
            dataEndIndex: G
          }, x({
            props: this.props,
            dataStartIndex: U,
            dataEndIndex: G,
            updateId: B
          }, this.state)));
        else if (Be(P.activeTooltipIndex))
          this.setState(P);
        else {
          var q = P.chartX, Y = P.chartY, Q = P.activeTooltipIndex, Z = this.state, ae = Z.offset, ie = Z.tooltipTicks;
          if (!ae)
            return;
          if (typeof L == "function")
            Q = L(ie, P);
          else if (L === "value") {
            Q = -1;
            for (var pe = 0; pe < ie.length; pe++)
              if (ie[pe].value === P.activeLabel) {
                Q = pe;
                break;
              }
          }
          var ce = _e(_e({}, ae), {}, {
            x: ae.left,
            y: ae.top
          }), ue = Math.min(q, ce.x + ce.width), X = Math.min(Y, ce.y + ce.height), se = ie[Q] && ie[Q].value, he = C7(this.state, this.props.data, Q), de = ie[Q] ? {
            x: $ === "horizontal" ? ie[Q].coordinate : ue,
            y: $ === "horizontal" ? X : ie[Q].coordinate
          } : A7;
          this.setState(_e(_e({}, P), {}, {
            activeLabel: se,
            activeCoordinate: de,
            activePayload: he,
            activeTooltipIndex: Q
          }));
        }
      }
    }, {
      key: "filterFormatItem",
      value: function(P, S, $) {
        for (var L = this.state.formattedGraphicalItems, B = 0, U = L.length; B < U; B++) {
          var G = L[B];
          if (G.item === P || G.props.key === P.key || S === Sa(G.item.type) && $ === G.childIndex)
            return G;
        }
        return null;
      }
    }, {
      key: "renderAxis",
      value: function(P, S, $, L) {
        var B = this.props, U = B.width, G = B.height;
        return /* @__PURE__ */ hi(ys, {
          ...P,
          className: "recharts-".concat(P.axisType, " ").concat(P.axisType),
          key: S.key || "".concat($, "-").concat(L),
          viewBox: {
            x: 0,
            y: 0,
            width: U,
            height: G
          },
          ticksGenerator: this.axesTicksGenerator
        });
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var P = this.clipPathId, S = this.state.offset, $ = S.left, L = S.top, B = S.height, U = S.width;
        return /* @__PURE__ */ M("defs", {
          children: /* @__PURE__ */ M("clipPath", {
            id: P,
            children: /* @__PURE__ */ M("rect", {
              x: $,
              y: L,
              height: B,
              width: U
            })
          })
        });
      }
    }, {
      key: "getXScales",
      value: function() {
        var P = this.state.xAxisMap;
        return P ? Object.entries(P).reduce(function(S, $) {
          var L = hD($, 2), B = L[0], U = L[1];
          return _e(_e({}, S), {}, $r({}, B, U.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var P = this.state.yAxisMap;
        return P ? Object.entries(P).reduce(function(S, $) {
          var L = hD($, 2), B = L[0], U = L[1];
          return _e(_e({}, S), {}, $r({}, B, U.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(P) {
        var S, $;
        return (S = this.state.xAxisMap) === null || S === void 0 || ($ = S[P]) === null || $ === void 0 ? void 0 : $.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(P) {
        var S, $;
        return (S = this.state.yAxisMap) === null || S === void 0 || ($ = S[P]) === null || $ === void 0 ? void 0 : $.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(P) {
        var S = this.state.formattedGraphicalItems;
        if (S && S.length)
          for (var $ = 0, L = S.length; $ < L; $++) {
            var B = S[$], U = B.props, G = B.item, q = Sa(G.type);
            if (q === "Bar") {
              var Y = (U.data || []).find(function(Z) {
                return mme(P, Z);
              });
              if (Y)
                return {
                  graphicalItem: B,
                  payload: Y
                };
            } else if (q === "RadialBar") {
              var Q = (U.data || []).find(function(Z) {
                return fT(P, Z);
              });
              if (Q)
                return {
                  graphicalItem: B,
                  payload: Q
                };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var P = this;
        if (!mM(this))
          return null;
        var S = this.props, $ = S.children, L = S.className, B = S.width, U = S.height, G = S.style, q = S.compact, Y = S.title, Q = S.desc, Z = fD(S, ["children", "className", "width", "height", "style", "compact", "title", "desc"]), ae = Ye(Z), ie = {
          CartesianGrid: {
            handler: this.renderGrid,
            once: !0
          },
          ReferenceArea: {
            handler: this.renderReferenceElement
          },
          ReferenceLine: {
            handler: this.renderReferenceElement
          },
          ReferenceDot: {
            handler: this.renderReferenceElement
          },
          XAxis: {
            handler: this.renderXAxis
          },
          YAxis: {
            handler: this.renderYAxis
          },
          Brush: {
            handler: this.renderBrush,
            once: !0
          },
          Bar: {
            handler: this.renderGraphicChild
          },
          Line: {
            handler: this.renderGraphicChild
          },
          Area: {
            handler: this.renderGraphicChild
          },
          Radar: {
            handler: this.renderGraphicChild
          },
          RadialBar: {
            handler: this.renderGraphicChild
          },
          Scatter: {
            handler: this.renderGraphicChild
          },
          Pie: {
            handler: this.renderGraphicChild
          },
          Funnel: {
            handler: this.renderGraphicChild
          },
          Tooltip: {
            handler: this.renderCursor,
            once: !0
          },
          PolarGrid: {
            handler: this.renderPolarGrid,
            once: !0
          },
          PolarAngleAxis: {
            handler: this.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: this.renderPolarAxis
          },
          Customized: {
            handler: this.renderCustomized
          }
        };
        if (q)
          return /* @__PURE__ */ K(Rb, {
            ...ae,
            width: B,
            height: U,
            title: Y,
            desc: Q,
            children: [this.renderClipPath(), bM($, ie)]
          });
        var pe = this.parseEventsOfWrapper();
        return /* @__PURE__ */ K("div", {
          className: Ce("recharts-wrapper", L),
          style: _e({
            position: "relative",
            cursor: "default",
            width: B,
            height: U
          }, G),
          ...pe,
          ref: function(ue) {
            P.container = ue;
          },
          role: "region",
          children: [/* @__PURE__ */ K(Rb, {
            ...ae,
            width: B,
            height: U,
            title: Y,
            desc: Q,
            children: [this.renderClipPath(), bM($, ie)]
          }), this.renderLegend(), this.renderTooltip()]
        });
      }
    }]), N;
  }(w1), r.displayName = s, r.defaultProps = _e({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, _), r.getDerivedStateFromProps = function(D, I) {
    var N = D.data, O = D.children, P = D.width, S = D.height, $ = D.layout, L = D.stackOffset, B = D.margin;
    if (Be(I.updateId)) {
      var U = wD(D);
      return _e(_e(_e({}, U), {}, {
        updateId: 0
      }, x(_e(_e({
        props: D
      }, U), {}, {
        updateId: 0
      }), I)), {}, {
        prevData: N,
        prevWidth: P,
        prevHeight: S,
        prevLayout: $,
        prevStackOffset: L,
        prevMargin: B,
        prevChildren: O
      });
    }
    if (N !== I.prevData || P !== I.prevWidth || S !== I.prevHeight || $ !== I.prevLayout || L !== I.prevStackOffset || !Bl(B, I.prevMargin)) {
      var G = wD(D), q = {
        chartX: I.chartX,
        chartY: I.chartY,
        isTooltipActive: I.isTooltipActive
      }, Y = _e(_e({}, bD(I, N, $)), {}, {
        updateId: I.updateId + 1
      }), Q = _e(_e(_e({}, G), q), Y);
      return _e(_e(_e({}, Q), x(_e({
        props: D
      }, Q), I)), {}, {
        prevData: N,
        prevWidth: P,
        prevHeight: S,
        prevLayout: $,
        prevStackOffset: L,
        prevMargin: B,
        prevChildren: O
      });
    }
    if (!W3(O, I.prevChildren)) {
      var Z = !Be(N), ae = Z ? I.updateId : I.updateId + 1;
      return _e(_e({
        updateId: ae
      }, x(_e(_e({
        props: D
      }, I), {}, {
        updateId: ae
      }), I)), {}, {
        prevChildren: O
      });
    }
    return null;
  }, r.renderActiveDot = function(D, I) {
    var N;
    return /* @__PURE__ */ Ho(D) ? N = /* @__PURE__ */ cr(D, I) : qe(D) ? N = D(I) : N = /* @__PURE__ */ M(kd, {
      ...I
    }), /* @__PURE__ */ M(mt, {
      className: "recharts-active-dot",
      children: N
    }, I.key);
  }, o;
}, d1e = ok({
  chartName: "PieChart",
  GraphicalChild: Ti,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Jg
  }, {
    axisType: "radiusAxis",
    AxisComp: Xg
  }],
  formatAxisMap: fge,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), h1e = ok({
  chartName: "AreaChart",
  GraphicalChild: Ko,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: yc
  }, {
    axisType: "yAxis",
    AxisComp: Fs
  }],
  formatAxisMap: b7
}), f1e = ok({
  chartName: "ComposedChart",
  GraphicalChild: [xd, Ko, Ed, nm],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: yc
  }, {
    axisType: "yAxis",
    AxisComp: Fs
  }, {
    axisType: "zAxis",
    AxisComp: tm
  }],
  formatAxisMap: b7
});
function ak(e = 0) {
  const [n, r] = oe.useState(), o = Le(null);
  ct(() => {
    r(o.current?.getBoundingClientRect().width);
  }, [o]);
  const s = _8((u) => r(u.contentRect.width), 20);
  return ZD(o, s), [o, n || e];
}
function p1e({
  data: e,
  dataKey: n,
  width: r,
  height: o,
  fill: s,
  hasBrush: u = !1,
  yAxisTitle: h,
  nameKey: f,
  stroke: p,
  tooltipLabelFormatter: v,
  tickFormatter: b
}) {
  const [y, k] = ak();
  return /* @__PURE__ */ M("div", {
    ref: y,
    children: /* @__PURE__ */ K(h1e, {
      width: r || k,
      height: o || k / 3,
      data: e,
      margin: {
        top: 10,
        right: 30,
        left: 20,
        bottom: 0
      },
      children: [/* @__PURE__ */ M(em, {
        strokeDasharray: "3 3"
      }), /* @__PURE__ */ M(yc, {
        dataKey: f,
        tickFormatter: b,
        tickMargin: 10,
        height: 50,
        interval: "preserveStartEnd"
      }), /* @__PURE__ */ M(Fs, {
        allowDecimals: !1,
        domain: [0, "auto"],
        orientation: "left",
        label: {
          value: h,
          angle: -90,
          position: "insideLeft",
          textAnchor: "middle"
        }
      }), /* @__PURE__ */ M(Ca, {
        labelFormatter: v
      }), u && /* @__PURE__ */ M(Bs, {
        tickFormatter: b,
        dataKey: f,
        height: 30,
        stroke: p,
        width: (r || k) - 350,
        x: 165
      }), /* @__PURE__ */ M(Ko, {
        connectNulls: !0,
        type: "monotone",
        dataKey: n,
        stroke: p,
        fill: s
      })]
    })
  });
}
p1e.displayName = "AreaChart";
function g1e({
  data: e,
  dataKey: n,
  width: r,
  height: o,
  categories: s,
  hasBrush: u = !1,
  lineKey: h = "",
  lineTitle: f = "",
  brushStroke: p,
  yAxisTitle: v,
  tooltipLabelFormatter: b,
  tickFormatter: y,
  colors: k = [wa.blue[300], wa.blue[500], wa.blue[700], wa.blue[900]],
  stacked: _ = !1
}) {
  const E = (P) => k[P % k.length];
  let x = 0;
  const D = (P) => /* @__PURE__ */ M("span", {
    style: {
      color: wa.gray[500]
    },
    children: P
  }), I = () => (x += 1, x - 1), [N, O] = ak();
  return /* @__PURE__ */ M("div", {
    ref: N,
    children: /* @__PURE__ */ K(f1e, {
      width: r || O,
      height: o || O / 3,
      data: e,
      margin: {
        top: 20,
        right: 30,
        left: 20,
        bottom: 5
      },
      children: [/* @__PURE__ */ M(em, {
        strokeDasharray: "3 3"
      }), /* @__PURE__ */ M(yc, {
        dataKey: n,
        tickMargin: 10,
        tickFormatter: y,
        height: 50,
        interval: "preserveStartEnd"
      }), /* @__PURE__ */ M(Fs, {
        allowDecimals: !1,
        domain: [0, "auto"],
        yAxisId: "left",
        orientation: "left",
        label: {
          value: v,
          angle: -90,
          position: "insideLeft",
          textAnchor: "middle"
        }
      }), f && /* @__PURE__ */ M(Fs, {
        allowDecimals: !1,
        domain: [0, "auto"],
        yAxisId: "right",
        orientation: "right",
        label: {
          value: f,
          angle: -90,
          position: "insideRight",
          textAnchor: "middle"
        }
      }), /* @__PURE__ */ M(Ca, {
        labelFormatter: b
      }), /* @__PURE__ */ M(Os, {
        payload: s.map((P, S) => ({
          id: P,
          type: "square",
          value: P,
          color: k[S % k.length]
        })),
        formatter: D
      }), u && /* @__PURE__ */ M(Bs, {
        tickFormatter: y,
        dataKey: n,
        height: 30,
        stroke: p,
        width: (r || O) - 350,
        x: 165
      }), s.map((P) => /* @__PURE__ */ M(Ed, {
        maxBarSize: 50,
        dataKey: P,
        yAxisId: "left",
        fill: E(I()),
        stackId: _ ? "stack" : void 0
      }, P)), h && /* @__PURE__ */ M(xd, {
        type: "linear",
        yAxisId: "right",
        dataKey: h,
        name: f,
        strokeWidth: 2,
        stroke: wa.yellow[500],
        dot: !1,
        activeDot: {
          r: 8
        }
      })]
    })
  });
}
g1e.displayName = "ComposedChart";
const m1e = (e, n, r, o, s) => {
  const u = [];
  for (let h = 0; h * n < e.length; h += 1)
    u[h] = /* @__PURE__ */ M("tspan", {
      x: r,
      y: o,
      dx: 0,
      dy: h * s,
      children: e.substring(h * n, (h + 1) * n)
    });
  return u;
}, v1e = (e) => {
  const n = Math.PI / 180, {
    cx: r,
    cy: o,
    midAngle: s,
    innerRadius: u,
    outerRadius: h,
    startAngle: f,
    endAngle: p,
    fill: v,
    percent: b,
    value: y,
    name: k
  } = e, _ = Math.sin(-n * s), E = Math.cos(-n * s), x = r + (h + 10) * E, D = o + (h + 10) * _, I = r + (h + 30) * E, N = o + (h + 30) * _, O = I + (E >= 0 ? 1 : -1) * 22, P = N, S = E >= 0 ? "start" : "end";
  return /* @__PURE__ */ K("g", {
    children: [/* @__PURE__ */ M("text", {
      x: r,
      y: o,
      textAnchor: "middle",
      fill: v,
      children: m1e(k, 25, r, o, 18)
    }), /* @__PURE__ */ M(Zl, {
      cx: r,
      cy: o,
      innerRadius: u,
      outerRadius: h,
      startAngle: f,
      endAngle: p,
      fill: v
    }), /* @__PURE__ */ M(Zl, {
      cx: r,
      cy: o,
      startAngle: f,
      endAngle: p,
      innerRadius: h + 6,
      outerRadius: h + 10,
      fill: v
    }), /* @__PURE__ */ M("path", {
      d: `M${x},${D}L${I},${N}L${O},${P}`,
      stroke: v,
      fill: "none"
    }), /* @__PURE__ */ M("circle", {
      cx: O,
      cy: P,
      r: 2,
      fill: v,
      stroke: "none"
    }), /* @__PURE__ */ M("text", {
      x: O + (E >= 0 ? 1 : -1) * 12,
      y: P,
      textAnchor: S,
      fill: "#333",
      children: `${y}`
    }), /* @__PURE__ */ M("text", {
      x: O + (E >= 0 ? 1 : -1) * 12,
      y: P,
      dy: 18,
      textAnchor: S,
      fill: "#999",
      children: `(${(b * 100).toFixed(2)}%)`
    })]
  });
};
function b1e({
  data: e,
  width: n,
  height: r,
  dataKey: o,
  nameKey: s,
  fill: u,
  colors: h = Object.values(wa.blue).slice(4)
}) {
  const f = (E) => h[E % h.length];
  let p = 0;
  const v = (E) => /* @__PURE__ */ M("span", {
    style: {
      color: wa.gray[500]
    },
    children: E
  }), b = () => (p += 1, p - 1), [y, k] = Ve(0), _ = (E, x) => {
    k(x);
  };
  return /* @__PURE__ */ K(d1e, {
    width: n,
    height: r,
    children: [/* @__PURE__ */ M(Ti, {
      activeIndex: y,
      activeShape: v1e,
      data: e.map((E) => ({
        fill: f(b()),
        ...E
      })),
      cx: "50%",
      cy: "50%",
      innerRadius: 100,
      outerRadius: 120,
      fill: u,
      nameKey: s,
      dataKey: o,
      onMouseEnter: _
    }), /* @__PURE__ */ M(Os, {
      iconType: "square",
      formatter: v
    })]
  });
}
b1e.displayName = "PieChart";
const kD = {
  default: {
    none: "bg-beige-200 border-beige-200 text-beige-800",
    colored: "border-2",
    primary: "bg-blue-100 border-blue-100 text-blue-800",
    success: "bg-green-100 border-green-100 text-green-800",
    danger: "bg-red-100 border-red-100 text-red-800",
    warning: "bg-yellow-100 border-yellow-100 text-yellow-800",
    secondary: "bg-purple-100 border-purple-100 text-purple-800"
  },
  outlined: {
    none: "bg-white border-beige-300 text-beige-700 hover:bg-beige-100 focus:ring-gray-500",
    colored: "border-2",
    primary: "border-blue-300 text-blue-800 hover:bg-blue-100 focus:ring-blue-500",
    success: "border-green-300 text-green-700 hover:bg-green-100 focus:ring-green-500",
    danger: "border-red-300 text-red-700 hover:bg-red-100 focus:ring-red-500",
    warning: "border-yellow-300 text-yellow-700 hover:bg-yellow-100 focus:ring-yellow-500",
    secondary: "border-purple-300 text-purple-700 hover:bg-purple-100 focus:ring-purple-500"
  }
};
function w1e(e, n) {
  return `${kD[e].colored} ${kD[e][n || "none"]}`;
}
const y1e = {
  rounded: !0
}, x7 = oe.createContext({});
function Li(e) {
  const n = tt(x7);
  return y1({}, y1e, n, XD(e, ["rounded"]));
}
function jDe({
  children: e,
  ...n
}) {
  return /* @__PURE__ */ M(x7.Provider, {
    value: n,
    children: e
  });
}
function E7({
  children: e,
  intent: n,
  iconAfter: r,
  handleClick: o = void 0,
  dashed: s = !1,
  appearance: u = "default",
  iconBefore: h,
  ...f
}) {
  const {
    rounded: p
  } = Li(f), v = Ce(w1e(u, n), "inline-flex items-center px-2 text-sm font-medium", {
    "rounded-md": p
  }, {
    "border-dashed": s
  }), b = r ? /* @__PURE__ */ M("span", {
    className: "ml-2 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center",
    children: r
  }) : null, y = h ? /* @__PURE__ */ M("span", {
    className: "mr-2 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center",
    children: h
  }) : null;
  return o !== void 0 ? /* @__PURE__ */ K("button", {
    type: "button",
    onClick: o,
    className: v,
    children: [y, e, b]
  }) : /* @__PURE__ */ K("span", {
    className: v,
    children: [y, e, b]
  });
}
E7.displayName = "Badge";
var k1e = {
  prefix: "fal",
  iconName: "note",
  icon: [448, 512, [], "e1ff", "M384 64c17.7 0 32 14.3 32 32V304H320c-26.5 0-48 21.5-48 48v96H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H384zm18.7 272L304 434.7V352c0-8.8 7.2-16 16-16h82.7zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H277.5c17 0 33.3-6.7 45.3-18.7L429.3 354.7c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm64 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, _1e = {
  prefix: "fal",
  iconName: "message-question",
  icon: [512, 512, [], "e1e3", "M256 280c-11.04 0-20 8.953-20 20C236 311 244.1 320 256 320s20-8.955 20-20C276 288.1 267 280 256 280zM448 0H64C28.75 0 0 28.75 0 63.1v287.1C0 387.2 28.75 415.1 64 415.1h96v83.1c0 9.838 11.03 15.5 19.12 9.649L304 415.1H448c35.25 0 64-28.75 64-63.1V63.1C512 28.75 483.3 0 448 0zM480 352c0 17.6-14.4 32-32 32h-144.1c-6.928 0-13.67 2.248-19.21 6.406L192 460v-60c0-8.838-7.164-16-16-16H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32V352zM278.1 96H229.7C200.1 96 176 120.1 176 149.6c0 8.844 7.156 16 16 16s16-7.156 16-16C208 137.7 217.7 128 229.7 128h48.47C292.4 128 304 139.6 304 153.9c0 9.875-5.469 18.75-14.53 23.27L248.6 198.3C243.3 201.1 240 206.6 240 212.5V240C240 248.8 247.2 256 256 256s16-7.156 16-16V222.3l32-16.61c19.75-9.875 32-29.76 32-51.82C336 121.9 310 96 278.1 96z"]
}, A1e = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 304c8.844 0 16-7.156 16-16V128c0-8.844-7.156-16-16-16S240 119.2 240 128v160C240 296.8 247.2 304 256 304zM256 344c-13.25 0-24 10.75-24 24s10.75 24 24 24s24-10.75 24-24S269.3 344 256 344z"]
}, C1e = A1e, x1e = {
  prefix: "fal",
  iconName: "stopwatch",
  icon: [448, 512, [9201], "f2f2", "M240 320C240 328.8 232.8 336 223.1 336C215.2 336 207.1 328.8 207.1 320V208C207.1 199.2 215.2 192 223.1 192C232.8 192 240 199.2 240 208V320zM127.1 16C127.1 7.164 135.2 0 143.1 0H304C312.8 0 320 7.164 320 16C320 24.84 312.8 32 304 32H240V96.61C289.4 100.4 333.1 121.4 367.7 153.6L404.7 116.7C410.9 110.4 421.1 110.4 427.3 116.7C433.6 122.9 433.6 133.1 427.3 139.3L389.1 177.5C416 212.6 432 256.4 432 304C432 418.9 338.9 512 224 512C109.1 512 16 418.9 16 304C16 194.5 100.6 104.8 208 96.61V32H144C135.2 32 128 24.84 128 16H127.1zM223.1 480C321.2 480 400 401.2 400 304C400 206.8 321.2 128 223.1 128C126.8 128 47.1 206.8 47.1 304C47.1 401.2 126.8 480 223.1 480z"]
}, E1e = {
  prefix: "fal",
  iconName: "hourglass",
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M368 0C376.8 0 384 7.164 384 16C384 24.84 376.8 32 368 32H352V76.67C352 108.3 341.6 139 322.4 164.1L252.1 256L322.4 347.9C341.6 372.1 352 403.7 352 435.3V480H368C376.8 480 384 487.2 384 496C384 504.8 376.8 512 368 512H16C7.164 512 0 504.8 0 496C0 487.2 7.164 480 16 480H32V435.3C32 403.7 42.41 372.1 61.61 347.9L131.9 256L61.61 164.1C42.41 139 32 108.3 32 76.67V32H16C7.164 32 0 24.84 0 16C0 7.164 7.164 0 16 0L368 0zM320 32H64V76.67C64 101.3 72.09 125.2 87.03 144.7L164.7 246.3C169.1 252 169.1 259.1 164.7 265.7L87.03 367.3C72.09 386.8 64 410.7 64 435.3V480H320V435.3C320 410.7 311.9 386.8 296.1 367.3L219.3 265.7C214.9 259.1 214.9 252 219.3 246.3L296.1 144.7C311.9 125.2 320 101.3 320 76.67V32z"]
}, S1e = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 184c13.25 0 24-10.74 24-24c0-13.25-10.75-24-24-24S232 146.7 232 160C232 173.3 242.7 184 256 184zM304 352h-32V240C272 231.2 264.8 224 256 224H224C215.2 224 208 231.2 208 240S215.2 256 224 256h16v96h-32C199.2 352 192 359.2 192 368C192 376.8 199.2 384 208 384h96c8.836 0 16-7.164 16-16C320 359.2 312.8 352 304 352z"]
}, M1e = S1e, T1e = {
  prefix: "fal",
  iconName: "timer",
  icon: [512, 512, [], "e29e", "M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 202.7 16.28 153.2 44.15 112.2C49.12 104.9 59.07 103 66.37 108C73.68 112.1 75.58 122.9 70.61 130.2C46.24 166.1 32 209.4 32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 137.7 388.2 40.77 272 32.56V112C272 120.8 264.8 128 256 128C247.2 128 240 120.8 240 112V16C240 7.164 247.2 0 256 0C397.4 0 512 114.6 512 256V256zM267.3 244.7C273.6 250.9 273.6 261.1 267.3 267.3C261.1 273.6 250.9 273.6 244.7 267.3L148.7 171.3C142.4 165.1 142.4 154.9 148.7 148.7C154.9 142.4 165.1 142.4 171.3 148.7L267.3 244.7z"]
}, D1e = {
  prefix: "fal",
  iconName: "arrows-up-down-left-right",
  icon: [512, 512, ["arrows"], "f047", "M512 255.1c0 4.094-1.562 8.222-4.688 11.35l-80 80C424.2 350.4 420.1 352 416 352c-9.139 0-16-7.473-16-16c0-4.094 1.562-8.188 4.688-11.31L457.4 272H272v185.4l52.69-52.69C327.8 401.6 331.9 400 336 400c9.139 0 16 7.473 16 16c0 4.094-1.562 8.188-4.688 11.31l-80 80C264.2 510.4 260.1 512 256 512s-8.188-1.562-11.31-4.688l-80-80C161.6 424.2 160 420.1 160 416c0-8.527 6.865-16 16-16c4.094 0 8.188 1.562 11.31 4.688L240 457.4V272H54.63l52.69 52.69C110.4 327.8 112 331.9 112 336C112 344.5 105.1 352 96 352c-4.094 0-8.188-1.562-11.31-4.688l-80-80C1.563 264.2 0 260.1 0 255.1s1.562-8.153 4.688-11.28l80-80C87.81 161.6 91.91 160 96 160c9.139 0 16 7.473 16 16c0 4.094-1.562 8.188-4.688 11.31L54.63 240H240V54.63L187.3 107.3C184.2 110.4 180.1 112 176 112C166.9 112 160 104.5 160 96c0-4.094 1.562-8.188 4.688-11.31l80-80C247.8 1.562 251.9 0 256 0s8.188 1.562 11.31 4.688l80 80C350.4 87.81 352 91.91 352 96c0 8.527-6.865 16-16 16c-4.094 0-8.188-1.562-11.31-4.688L272 54.63V240h185.4l-52.69-52.69C401.6 184.2 400 180.1 400 176C400 167.5 406.9 160 416 160c4.094 0 8.188 1.562 11.31 4.688l80 80C510.4 247.8 512 251.9 512 255.1z"]
};
function I1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v4.59L7.3 9.24a.75.75 0 00-1.1 1.02l3.25 3.5a.75.75 0 001.1 0l3.25-3.5a.75.75 0 10-1.1-1.02l-1.95 2.1V6.75z",
      clipRule: "evenodd"
    })]
  });
}
const P1e = ne.forwardRef(I1e), O1e = P1e;
function R1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M6.28 5.22a.75.75 0 00-1.06 1.06l7.22 7.22H6.75a.75.75 0 000 1.5h7.5a.747.747 0 00.75-.75v-7.5a.75.75 0 00-1.5 0v5.69L6.28 5.22z"
    })]
  });
}
const N1e = ne.forwardRef(R1e), $1e = N1e;
function L1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z",
      clipRule: "evenodd"
    })]
  });
}
const j1e = ne.forwardRef(L1e), B1e = j1e;
function F1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z",
      clipRule: "evenodd"
    })]
  });
}
const z1e = ne.forwardRef(F1e), V1e = z1e;
function H1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z",
      clipRule: "evenodd"
    })]
  });
}
const U1e = ne.forwardRef(H1e), W1e = U1e;
function G1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3 4.25A2.25 2.25 0 015.25 2h5.5A2.25 2.25 0 0113 4.25v2a.75.75 0 01-1.5 0v-2a.75.75 0 00-.75-.75h-5.5a.75.75 0 00-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 00.75-.75v-2a.75.75 0 011.5 0v2A2.25 2.25 0 0110.75 18h-5.5A2.25 2.25 0 013 15.75V4.25z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M6 10a.75.75 0 01.75-.75h9.546l-1.048-.943a.75.75 0 111.004-1.114l2.5 2.25a.75.75 0 010 1.114l-2.5 2.25a.75.75 0 11-1.004-1.114l1.048-.943H6.75A.75.75 0 016 10z",
      clipRule: "evenodd"
    })]
  });
}
const q1e = ne.forwardRef(G1e), K1e = q1e;
function Y1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-4.75a.75.75 0 001.5 0V8.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0L6.2 9.74a.75.75 0 101.1 1.02l1.95-2.1v4.59z",
      clipRule: "evenodd"
    })]
  });
}
const Q1e = ne.forwardRef(Y1e), Z1e = Q1e;
function X1e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z",
      clipRule: "evenodd"
    })]
  });
}
const J1e = ne.forwardRef(X1e), eye = J1e;
function tye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z",
      clipRule: "evenodd"
    })]
  });
}
const nye = ne.forwardRef(tye), rye = nye;
function iye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.793 2.232a.75.75 0 01-.025 1.06L3.622 7.25h10.003a5.375 5.375 0 010 10.75H10.75a.75.75 0 010-1.5h2.875a3.875 3.875 0 000-7.75H3.622l4.146 3.957a.75.75 0 01-1.036 1.085l-5.5-5.25a.75.75 0 010-1.085l5.5-5.25a.75.75 0 011.06.025z",
      clipRule: "evenodd"
    })]
  });
}
const oye = ne.forwardRef(iye), aye = oye;
function sye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2.24 6.8a.75.75 0 001.06-.04l1.95-2.1v8.59a.75.75 0 001.5 0V4.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0L2.2 5.74a.75.75 0 00.04 1.06zm8 6.4a.75.75 0 00-.04 1.06l3.25 3.5a.75.75 0 001.1 0l3.25-3.5a.75.75 0 10-1.1-1.02l-1.95 2.1V6.75a.75.75 0 00-1.5 0v8.59l-1.95-2.1a.75.75 0 00-1.06-.04z",
      clipRule: "evenodd"
    })]
  });
}
const lye = ne.forwardRef(sye), cye = lye;
function uye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.22 3.22A.75.75 0 017.75 3h9A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17h-9a.75.75 0 01-.53-.22L.97 10.53a.75.75 0 010-1.06l6.25-6.25zm3.06 4a.75.75 0 10-1.06 1.06L10.94 10l-1.72 1.72a.75.75 0 101.06 1.06L12 11.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L12 8.94l-1.72-1.72z",
      clipRule: "evenodd"
    })]
  });
}
const dye = ne.forwardRef(uye), hye = dye;
function fye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M1 4a1 1 0 011-1h16a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V4zm12 4a3 3 0 11-6 0 3 3 0 016 0zM4 9a1 1 0 100-2 1 1 0 000 2zm13-1a1 1 0 11-2 0 1 1 0 012 0zM1.75 14.5a.75.75 0 000 1.5c4.417 0 8.693.603 12.749 1.73 1.111.309 2.251-.512 2.251-1.696v-.784a.75.75 0 00-1.5 0v.784a.272.272 0 01-.35.25A49.043 49.043 0 001.75 14.5z",
      clipRule: "evenodd"
    })]
  });
}
const pye = ne.forwardRef(fye), gye = pye;
function mye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const vye = ne.forwardRef(mye), bye = vye;
function wye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 2a6 6 0 00-6 6c0 1.887-.454 3.665-1.257 5.234a.75.75 0 00.515 1.076 32.91 32.91 0 003.256.508 3.5 3.5 0 006.972 0 32.903 32.903 0 003.256-.508.75.75 0 00.515-1.076A11.448 11.448 0 0116 8a6 6 0 00-6-6zM8.05 14.943a33.54 33.54 0 003.9 0 2 2 0 01-3.9 0z",
      clipRule: "evenodd"
    })]
  });
}
const yye = ne.forwardRef(wye), kye = yye;
function _ye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M6 3.75A2.75 2.75 0 018.75 1h2.5A2.75 2.75 0 0114 3.75v.443c.572.055 1.14.122 1.706.2C17.053 4.582 18 5.75 18 7.07v3.469c0 1.126-.694 2.191-1.83 2.54-1.952.599-4.024.921-6.17.921s-4.219-.322-6.17-.921C2.694 12.73 2 11.665 2 10.539V7.07c0-1.321.947-2.489 2.294-2.676A41.047 41.047 0 016 4.193V3.75zm6.5 0v.325a41.622 41.622 0 00-5 0V3.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25zM10 10a1 1 0 00-1 1v.01a1 1 0 001 1h.01a1 1 0 001-1V11a1 1 0 00-1-1H10z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      d: "M3 15.055v-.684c.126.053.255.1.39.142 2.092.642 4.313.987 6.61.987 2.297 0 4.518-.345 6.61-.987.135-.041.264-.089.39-.142v.684c0 1.347-.985 2.53-2.363 2.686a41.454 41.454 0 01-9.274 0C3.985 17.585 3 16.402 3 15.055z"
    })]
  });
}
const Aye = ne.forwardRef(_ye), Cye = Aye;
function xye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M4 16.5v-13h-.25a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5H16v13h.25a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-3.5a.75.75 0 010-1.5H4zm3-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM7.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z",
      clipRule: "evenodd"
    })]
  });
}
const Eye = ne.forwardRef(xye), Sye = Eye;
function Mye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z",
      clipRule: "evenodd"
    })]
  });
}
const Tye = ne.forwardRef(Mye), Dye = Tye;
function Iye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M15.5 2A1.5 1.5 0 0014 3.5v13a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0016.5 2h-1zM9.5 6A1.5 1.5 0 008 7.5v9A1.5 1.5 0 009.5 18h1a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0010.5 6h-1zM3.5 10A1.5 1.5 0 002 11.5v5A1.5 1.5 0 003.5 18h1A1.5 1.5 0 006 16.5v-5A1.5 1.5 0 004.5 10h-1z"
    })]
  });
}
const Pye = ne.forwardRef(Iye), Oye = Pye;
function Rye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z"
    }), /* @__PURE__ */ M("path", {
      d: "M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z"
    })]
  });
}
const Nye = ne.forwardRef(Rye), $ye = Nye;
function Lye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
      clipRule: "evenodd"
    })]
  });
}
const jye = ne.forwardRef(Lye), Bye = jye;
function Fye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
      clipRule: "evenodd"
    })]
  });
}
const zye = ne.forwardRef(Fye), Vye = zye;
function Hye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const Uye = ne.forwardRef(Hye), Wye = Uye;
function Gye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z",
      clipRule: "evenodd"
    })]
  });
}
const qye = ne.forwardRef(Gye), Kye = qye;
function Yye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
      clipRule: "evenodd"
    })]
  });
}
const Qye = ne.forwardRef(Yye), Zye = Qye;
function Xye({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const Jye = ne.forwardRef(Xye), eke = Jye;
function tke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z",
      clipRule: "evenodd"
    })]
  });
}
const nke = ne.forwardRef(tke), rke = nke;
function ike({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M18 5.25a2.25 2.25 0 00-2.012-2.238A2.25 2.25 0 0013.75 1h-1.5a2.25 2.25 0 00-2.238 2.012c-.875.092-1.6.686-1.884 1.488H11A2.5 2.5 0 0113.5 7v7h2.25A2.25 2.25 0 0018 11.75v-6.5zM12.25 2.5a.75.75 0 00-.75.75v.25h3v-.25a.75.75 0 00-.75-.75h-1.5z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3 6a1 1 0 00-1 1v10a1 1 0 001 1h8a1 1 0 001-1V7a1 1 0 00-1-1H3zm6.874 4.166a.75.75 0 10-1.248-.832l-2.493 3.739-.853-.853a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.154-.114l3-4.5z",
      clipRule: "evenodd"
    })]
  });
}
const oke = ne.forwardRef(ike), ake = oke;
function ske({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M15.988 3.012A2.25 2.25 0 0118 5.25v6.5A2.25 2.25 0 0115.75 14H13.5V7A2.5 2.5 0 0011 4.5H8.128a2.252 2.252 0 011.884-1.488A2.25 2.25 0 0112.25 1h1.5a2.25 2.25 0 012.238 2.012zM11.5 3.25a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75v.25h-3v-.25z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2 7a1 1 0 011-1h8a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V7zm2 3.25a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zm0 3.5a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const lke = ne.forwardRef(ske), cke = lke;
function uke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z",
      clipRule: "evenodd"
    })]
  });
}
const dke = ne.forwardRef(uke), hke = dke;
function fke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.84 1.804A1 1 0 018.82 1h2.36a1 1 0 01.98.804l.331 1.652a6.993 6.993 0 011.929 1.115l1.598-.54a1 1 0 011.186.447l1.18 2.044a1 1 0 01-.205 1.251l-1.267 1.113a7.047 7.047 0 010 2.228l1.267 1.113a1 1 0 01.206 1.25l-1.18 2.045a1 1 0 01-1.187.447l-1.598-.54a6.993 6.993 0 01-1.929 1.115l-.33 1.652a1 1 0 01-.98.804H8.82a1 1 0 01-.98-.804l-.331-1.652a6.993 6.993 0 01-1.929-1.115l-1.598.54a1 1 0 01-1.186-.447l-1.18-2.044a1 1 0 01.205-1.251l1.267-1.114a7.05 7.05 0 010-2.227L1.821 7.773a1 1 0 01-.206-1.25l1.18-2.045a1 1 0 011.187-.447l1.598.54A6.993 6.993 0 017.51 3.456l.33-1.652zM10 13a3 3 0 100-6 3 3 0 000 6z",
      clipRule: "evenodd"
    })]
  });
}
const pke = ne.forwardRef(fke), gke = pke;
function mke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M4.5 2A1.5 1.5 0 003 3.5v13A1.5 1.5 0 004.5 18h11a1.5 1.5 0 001.5-1.5V7.621a1.5 1.5 0 00-.44-1.06l-4.12-4.122A1.5 1.5 0 0011.378 2H4.5zm2.25 8.5a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5zm0 3a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z",
      clipRule: "evenodd"
    })]
  });
}
const vke = ne.forwardRef(mke), bke = vke;
function wke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M3 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM15.5 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
    })]
  });
}
const yke = ne.forwardRef(wke), kke = yke;
function _ke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
    })]
  });
}
const Ake = ne.forwardRef(_ke), Cke = Ake;
function xke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z"
    }), /* @__PURE__ */ M("path", {
      d: "M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z"
    })]
  });
}
const Eke = ne.forwardRef(xke), Ske = Eke;
function Mke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z",
      clipRule: "evenodd"
    })]
  });
}
const Tke = ne.forwardRef(Mke), Dke = Tke;
function Ike({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
      clipRule: "evenodd"
    })]
  });
}
const Pke = ne.forwardRef(Ike), Oke = Pke;
function Rke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z",
      clipRule: "evenodd"
    })]
  });
}
const Nke = ne.forwardRef(Rke), $ke = Nke;
function Lke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M14 6a2.5 2.5 0 00-4-3 2.5 2.5 0 00-4 3H3.25C2.56 6 2 6.56 2 7.25v.5C2 8.44 2.56 9 3.25 9h6V6h1.5v3h6C17.44 9 18 8.44 18 7.75v-.5C18 6.56 17.44 6 16.75 6H14zm-1-1.5a1 1 0 01-1 1h-1v-1a1 1 0 112 0zm-6 0a1 1 0 001 1h1v-1a1 1 0 00-2 0z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      d: "M9.25 10.5H3v4.75A2.75 2.75 0 005.75 18h3.5v-7.5zM10.75 18v-7.5H17v4.75A2.75 2.75 0 0114.25 18h-3.5z"
    })]
  });
}
const jke = ne.forwardRef(Lke), Bke = jke;
function Fke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-1.503.204A6.5 6.5 0 117.95 3.83L6.927 5.62a1.453 1.453 0 001.91 2.02l.175-.087a.5.5 0 01.224-.053h.146a.5.5 0 01.447.724l-.028.055a.4.4 0 01-.357.221h-.502a2.26 2.26 0 00-1.88 1.006l-.044.066a2.099 2.099 0 001.085 3.156.58.58 0 01.397.547v1.05a1.175 1.175 0 002.093.734l1.611-2.014c.192-.24.296-.536.296-.842 0-.316.128-.624.353-.85a1.363 1.363 0 00.173-1.716l-.464-.696a.369.369 0 01.527-.499l.343.257c.316.237.738.275 1.091.098a.586.586 0 01.677.11l1.297 1.297z",
      clipRule: "evenodd"
    })]
  });
}
const zke = ne.forwardRef(Fke), Vke = zke;
function Hke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z",
      clipRule: "evenodd"
    })]
  });
}
const Uke = ne.forwardRef(Hke), Wke = Uke;
function Gke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
      clipRule: "evenodd"
    })]
  });
}
const qke = ne.forwardRef(Gke), Kke = qke;
function Yke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.965 4.904l9.131 9.131a6.5 6.5 0 00-9.131-9.131zm8.07 10.192L4.904 5.965a6.5 6.5 0 009.131 9.131zM4.343 4.343a8 8 0 1111.314 11.314A8 8 0 014.343 4.343z",
      clipRule: "evenodd"
    })]
  });
}
const Qke = ne.forwardRef(Yke), Zke = Qke;
function Xke({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M3.105 2.289a.75.75 0 00-.826.95l1.414 4.925A1.5 1.5 0 005.135 9.25h6.115a.75.75 0 010 1.5H5.135a1.5 1.5 0 00-1.442 1.086l-1.414 4.926a.75.75 0 00.826.95 28.896 28.896 0 0015.293-7.154.75.75 0 000-1.115A28.897 28.897 0 003.105 2.289z"
    })]
  });
}
const Jke = ne.forwardRef(Xke), e_e = Jke;
function t_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z"
    }), /* @__PURE__ */ M("path", {
      d: "M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z"
    })]
  });
}
const n_e = ne.forwardRef(t_e), r_e = n_e;
function i_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z"
    })]
  });
}
const o_e = ne.forwardRef(i_e), a_e = o_e;
function s_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z",
      clipRule: "evenodd"
    })]
  });
}
const l_e = ne.forwardRef(s_e), c_e = l_e;
function u_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z",
      clipRule: "evenodd"
    })]
  });
}
const d_e = ne.forwardRef(u_e), h_e = d_e;
function f_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
    })]
  });
}
const p_e = ne.forwardRef(f_e), g_e = p_e;
function m_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z",
      clipRule: "evenodd"
    })]
  });
}
const v_e = ne.forwardRef(m_e), b_e = v_e;
function w_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M13 4.5a2.5 2.5 0 11.702 1.737L6.97 9.604a2.518 2.518 0 010 .792l6.733 3.367a2.5 2.5 0 11-.671 1.341l-6.733-3.367a2.5 2.5 0 110-3.475l6.733-3.366A2.52 2.52 0 0113 4.5z"
    })]
  });
}
const y_e = ne.forwardRef(w_e), k_e = y_e;
function __e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z",
      clipRule: "evenodd"
    })]
  });
}
const A_e = ne.forwardRef(__e), C_e = A_e;
function x_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"
    })]
  });
}
const E_e = ne.forwardRef(x_e), S_e = E_e;
function M_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z"
    })]
  });
}
const T_e = ne.forwardRef(M_e), D_e = T_e;
function I_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
    })]
  });
}
const P_e = ne.forwardRef(I_e), O_e = P_e;
function R_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-.53 14.03a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V8.25a.75.75 0 00-1.5 0v5.69l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3z",
      clipRule: "evenodd"
    })]
  });
}
const N_e = ne.forwardRef(R_e), $_e = N_e;
function L_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3.97 3.97a.75.75 0 011.06 0l13.72 13.72V8.25a.75.75 0 011.5 0V19.5a.75.75 0 01-.75.75H8.25a.75.75 0 010-1.5h9.44L3.97 5.03a.75.75 0 010-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const j_e = ne.forwardRef(L_e), B_e = j_e;
function F_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 2.25a.75.75 0 01.75.75v16.19l6.22-6.22a.75.75 0 111.06 1.06l-7.5 7.5a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 111.06-1.06l6.22 6.22V3a.75.75 0 01.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const z_e = ne.forwardRef(F_e), V_e = z_e;
function H_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.28 7.72a.75.75 0 010 1.06l-2.47 2.47H21a.75.75 0 010 1.5H4.81l2.47 2.47a.75.75 0 11-1.06 1.06l-3.75-3.75a.75.75 0 010-1.06l3.75-3.75a.75.75 0 011.06 0z",
      clipRule: "evenodd"
    })]
  });
}
const U_e = ne.forwardRef(H_e), W_e = U_e;
function G_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M16.72 7.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 010 1.06l-3.75 3.75a.75.75 0 11-1.06-1.06l2.47-2.47H3a.75.75 0 010-1.5h16.19l-2.47-2.47a.75.75 0 010-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const q_e = ne.forwardRef(G_e), K_e = q_e;
function Y_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const Q_e = ne.forwardRef(Y_e), Z_e = Q_e;
function X_e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.53 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v5.69a.75.75 0 001.5 0v-5.69l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
      clipRule: "evenodd"
    })]
  });
}
const J_e = ne.forwardRef(X_e), eAe = J_e;
function tAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M8.25 3.75H19.5a.75.75 0 01.75.75v11.25a.75.75 0 01-1.5 0V6.31L5.03 20.03a.75.75 0 01-1.06-1.06L17.69 5.25H8.25a.75.75 0 010-1.5z",
      clipRule: "evenodd"
    })]
  });
}
const nAe = ne.forwardRef(tAe), rAe = nAe;
function iAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M11.47 2.47a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06l-6.22-6.22V21a.75.75 0 01-1.5 0V4.81l-6.22 6.22a.75.75 0 11-1.06-1.06l7.5-7.5z",
      clipRule: "evenodd"
    })]
  });
}
const oAe = ne.forwardRef(iAe), aAe = oAe;
function sAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M9.53 2.47a.75.75 0 010 1.06L4.81 8.25H15a6.75 6.75 0 010 13.5h-3a.75.75 0 010-1.5h3a5.25 5.25 0 100-10.5H4.81l4.72 4.72a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06l6-6a.75.75 0 011.06 0z",
      clipRule: "evenodd"
    })]
  });
}
const lAe = ne.forwardRef(sAe), cAe = lAe;
function uAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M6.97 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06L8.25 4.81V16.5a.75.75 0 01-1.5 0V4.81L3.53 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zm9.53 4.28a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V7.5a.75.75 0 01.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const dAe = ne.forwardRef(uAe), hAe = dAe;
function fAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2.515 10.674a1.875 1.875 0 000 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 003-3V6.75a3 3 0 00-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374zM12.53 9.22a.75.75 0 10-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 101.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 101.06-1.06L15.31 12l1.72-1.72a.75.75 0 10-1.06-1.06l-1.72 1.72-1.72-1.72z",
      clipRule: "evenodd"
    })]
  });
}
const pAe = ne.forwardRef(fAe), gAe = pAe;
function mAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M12 7.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 14.625v-9.75zM8.25 9.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM18.75 9a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-.008zM4.5 9.75A.75.75 0 015.25 9h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V9.75z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      d: "M2.25 18a.75.75 0 000 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 00-.75-.75H2.25z"
    })]
  });
}
const vAe = ne.forwardRef(mAe), bAe = vAe;
function wAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const yAe = ne.forwardRef(wAe), kAe = yAe;
function _Ae({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z",
      clipRule: "evenodd"
    })]
  });
}
const AAe = ne.forwardRef(_Ae), CAe = AAe;
function xAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      d: "M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z"
    })]
  });
}
const EAe = ne.forwardRef(xAe), SAe = EAe;
function MAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M4.5 2.25a.75.75 0 000 1.5v16.5h-.75a.75.75 0 000 1.5h16.5a.75.75 0 000-1.5h-.75V3.75a.75.75 0 000-1.5h-15zM9 6a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H9zm-.75 3.75A.75.75 0 019 9h1.5a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM9 12a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H9zm3.75-5.25A.75.75 0 0113.5 6H15a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM13.5 9a.75.75 0 000 1.5H15A.75.75 0 0015 9h-1.5zm-.75 3.75a.75.75 0 01.75-.75H15a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zM9 19.5v-2.25a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v2.25a.75.75 0 01-.75.75h-4.5A.75.75 0 019 19.5z",
      clipRule: "evenodd"
    })]
  });
}
const TAe = ne.forwardRef(MAe), DAe = TAe;
function IAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M6.75 2.25A.75.75 0 017.5 3v1.5h9V3A.75.75 0 0118 3v1.5h.75a3 3 0 013 3v11.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V7.5a3 3 0 013-3H6V3a.75.75 0 01.75-.75zm13.5 9a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5z",
      clipRule: "evenodd"
    })]
  });
}
const PAe = ne.forwardRef(IAe), OAe = PAe;
function RAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z"
    })]
  });
}
const NAe = ne.forwardRef(RAe), $Ae = NAe;
function LAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M4.913 2.658c2.075-.27 4.19-.408 6.337-.408 2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 00-1.032-.211 50.89 50.89 0 00-8.42 0c-2.358.196-4.04 2.19-4.04 4.434v4.286a4.47 4.47 0 002.433 3.984L7.28 21.53A.75.75 0 016 21v-4.03a48.527 48.527 0 01-1.087-.128C2.905 16.58 1.5 14.833 1.5 12.862V6.638c0-1.97 1.405-3.718 3.413-3.979z"
    }), /* @__PURE__ */ M("path", {
      d: "M15.75 7.5c-1.376 0-2.739.057-4.086.169C10.124 7.797 9 9.103 9 10.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 001.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.433 2.67-2.94v-4.286c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0015.75 7.5z"
    })]
  });
}
const jAe = ne.forwardRef(LAe), BAe = jAe;
function FAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z",
      clipRule: "evenodd"
    })]
  });
}
const zAe = ne.forwardRef(FAe), VAe = zAe;
function HAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
      clipRule: "evenodd"
    })]
  });
}
const UAe = ne.forwardRef(HAe), WAe = UAe;
function GAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
      clipRule: "evenodd"
    })]
  });
}
const qAe = ne.forwardRef(GAe), KAe = qAe;
function YAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z",
      clipRule: "evenodd"
    })]
  });
}
const QAe = ne.forwardRef(YAe), ZAe = QAe;
function XAe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z",
      clipRule: "evenodd"
    })]
  });
}
const JAe = ne.forwardRef(XAe), eCe = JAe;
function tCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M11.47 4.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 01-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 01-1.06-1.06l3.75-3.75zm-3.75 9.75a.75.75 0 011.06 0L12 17.69l3.22-3.22a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 010-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const nCe = ne.forwardRef(tCe), rCe = nCe;
function iCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z",
      clipRule: "evenodd"
    })]
  });
}
const oCe = ne.forwardRef(iCe), aCe = oCe;
function sCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zm9.586 4.594a.75.75 0 00-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.116-.062l3-3.75z",
      clipRule: "evenodd"
    })]
  });
}
const lCe = ne.forwardRef(sCe), cCe = lCe;
function uCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zM6 12a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V12zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM6 15a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V15zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM6 18a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H6.75a.75.75 0 01-.75-.75V18zm2.25 0a.75.75 0 01.75-.75h3.75a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const dCe = ne.forwardRef(uCe), hCe = dCe;
function fCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10.5 3.75a6 6 0 00-5.98 6.496A5.25 5.25 0 006.75 20.25H18a4.5 4.5 0 002.206-8.423 3.75 3.75 0 00-4.133-4.303A6.001 6.001 0 0010.5 3.75zm2.03 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v4.94a.75.75 0 001.5 0v-4.94l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
      clipRule: "evenodd"
    })]
  });
}
const pCe = ne.forwardRef(fCe), gCe = pCe;
function mCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z",
      clipRule: "evenodd"
    })]
  });
}
const vCe = ne.forwardRef(mCe), bCe = vCe;
function wCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z",
      clipRule: "evenodd"
    }), /* @__PURE__ */ M("path", {
      d: "M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z"
    })]
  });
}
const yCe = ne.forwardRef(wCe), kCe = yCe;
function _Ce({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M4.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm6 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
      clipRule: "evenodd"
    })]
  });
}
const ACe = ne.forwardRef(_Ce), CCe = ACe;
function xCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
      clipRule: "evenodd"
    })]
  });
}
const ECe = ne.forwardRef(xCe), SCe = ECe;
function MCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"
    }), /* @__PURE__ */ M("path", {
      d: "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"
    })]
  });
}
const TCe = ne.forwardRef(MCe), DCe = TCe;
function ICe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
      clipRule: "evenodd"
    })]
  });
}
const PCe = ne.forwardRef(ICe), OCe = PCe;
function RCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M12 15a3 3 0 100-6 3 3 0 000 6z"
    }), /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
      clipRule: "evenodd"
    })]
  });
}
const NCe = ne.forwardRef(RCe), $Ce = NCe;
function LCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M3.792 2.938A49.069 49.069 0 0112 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 011.541 1.836v1.044a3 3 0 01-.879 2.121l-6.182 6.182a1.5 1.5 0 00-.439 1.061v2.927a3 3 0 01-1.658 2.684l-1.757.878A.75.75 0 019.75 21v-5.818a1.5 1.5 0 00-.44-1.06L3.13 7.938a3 3 0 01-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836z",
      clipRule: "evenodd"
    })]
  });
}
const jCe = ne.forwardRef(LCe), BCe = jCe;
function FCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M9.375 3a1.875 1.875 0 000 3.75h1.875v4.5H3.375A1.875 1.875 0 011.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0112 2.753a3.375 3.375 0 015.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 10-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3zM11.25 12.75H3v6.75a2.25 2.25 0 002.25 2.25h6v-9zM12.75 12.75v9h6.75a2.25 2.25 0 002.25-2.25v-6.75h-9z"
    })]
  });
}
const zCe = ne.forwardRef(FCe), VCe = zCe;
function HCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM8.547 4.505a8.25 8.25 0 1011.672 8.214l-.46-.46a2.252 2.252 0 01-.422-.586l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 01-1.384-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.279-2.132z",
      clipRule: "evenodd"
    })]
  });
}
const UCe = ne.forwardRef(HCe), WCe = UCe;
function GCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z"
    }), /* @__PURE__ */ M("path", {
      d: "M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z"
    })]
  });
}
const qCe = ne.forwardRef(GCe), KCe = qCe;
function YCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z",
      clipRule: "evenodd"
    })]
  });
}
const QCe = ne.forwardRef(YCe), ZCe = QCe;
function XCe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M6.72 5.66l11.62 11.62A8.25 8.25 0 006.72 5.66zm10.56 12.68L5.66 6.72a8.25 8.25 0 0011.62 11.62zM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788z",
      clipRule: "evenodd"
    })]
  });
}
const JCe = ne.forwardRef(XCe), e2e = JCe;
function t2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"
    })]
  });
}
const n2e = ne.forwardRef(t2e), r2e = n2e;
function i2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z"
    }), /* @__PURE__ */ M("path", {
      d: "M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z"
    })]
  });
}
const o2e = ne.forwardRef(i2e), a2e = o2e;
function s2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z"
    })]
  });
}
const l2e = ne.forwardRef(s2e), c2e = l2e;
function u2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z",
      clipRule: "evenodd"
    })]
  });
}
const d2e = ne.forwardRef(u2e), h2e = d2e;
function f2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z",
      clipRule: "evenodd"
    })]
  });
}
const p2e = ne.forwardRef(f2e), g2e = p2e;
function m2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z",
      clipRule: "evenodd"
    })]
  });
}
const v2e = ne.forwardRef(m2e), b2e = v2e;
function w2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 01-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 01-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 01-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584zM12 18a.75.75 0 100-1.5.75.75 0 000 1.5z",
      clipRule: "evenodd"
    })]
  });
}
const y2e = ne.forwardRef(w2e), k2e = y2e;
function _2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M15.75 4.5a3 3 0 11.825 2.066l-8.421 4.679a3.002 3.002 0 010 1.51l8.421 4.679a3 3 0 11-.729 1.31l-8.421-4.678a3 3 0 110-4.132l8.421-4.679a3 3 0 01-.096-.755z",
      clipRule: "evenodd"
    })]
  });
}
const A2e = ne.forwardRef(_2e), C2e = A2e;
function x2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z",
      clipRule: "evenodd"
    })]
  });
}
const E2e = ne.forwardRef(x2e), S2e = E2e;
function M2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z",
      clipRule: "evenodd"
    })]
  });
}
const T2e = ne.forwardRef(M2e), D2e = T2e;
function I2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      d: "M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z"
    })]
  });
}
const P2e = ne.forwardRef(I2e), O2e = P2e;
function R2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      fillRule: "evenodd",
      d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
      clipRule: "evenodd"
    })]
  });
}
const N2e = ne.forwardRef(R2e), $2e = N2e;
function L2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })]
  });
}
const j2e = ne.forwardRef(L2e), B2e = j2e;
function F2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.5 4.5l15 15m0 0V8.25m0 11.25H8.25"
    })]
  });
}
const z2e = ne.forwardRef(F2e), V2e = z2e;
function H2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
    })]
  });
}
const U2e = ne.forwardRef(H2e), W2e = U2e;
function G2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
    })]
  });
}
const q2e = ne.forwardRef(G2e), K2e = q2e;
function Y2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
    })]
  });
}
const Q2e = ne.forwardRef(Y2e), Z2e = Q2e;
function X2e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
    })]
  });
}
const J2e = ne.forwardRef(X2e), exe = J2e;
function txe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })]
  });
}
const nxe = ne.forwardRef(txe), rxe = nxe;
function ixe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
    })]
  });
}
const oxe = ne.forwardRef(ixe), axe = oxe;
function sxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
    })]
  });
}
const lxe = ne.forwardRef(sxe), cxe = lxe;
function uxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
    })]
  });
}
const dxe = ne.forwardRef(uxe), hxe = dxe;
function fxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
    })]
  });
}
const pxe = ne.forwardRef(fxe), gxe = pxe;
function mxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"
    })]
  });
}
const vxe = ne.forwardRef(mxe), bxe = vxe;
function wxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
    })]
  });
}
const yxe = ne.forwardRef(wxe), kxe = yxe;
function _xe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    })]
  });
}
const Axe = ne.forwardRef(_xe), Cxe = Axe;
function xxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
    })]
  });
}
const Exe = ne.forwardRef(xxe), Sxe = Exe;
function Mxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
    })]
  });
}
const Txe = ne.forwardRef(Mxe), Dxe = Txe;
function Ixe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
    })]
  });
}
const Pxe = ne.forwardRef(Ixe), Oxe = Pxe;
function Rxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
    })]
  });
}
const Nxe = ne.forwardRef(Rxe), $xe = Nxe;
function Lxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
    })]
  });
}
const jxe = ne.forwardRef(Lxe), Bxe = jxe;
function Fxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    })]
  });
}
const zxe = ne.forwardRef(Fxe), Vxe = zxe;
function Hxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })]
  });
}
const Uxe = ne.forwardRef(Hxe), Wxe = Uxe;
function Gxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.5 12.75l6 6 9-13.5"
    })]
  });
}
const qxe = ne.forwardRef(Gxe), Kxe = qxe;
function Yxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
    })]
  });
}
const Qxe = ne.forwardRef(Yxe), Zxe = Qxe;
function Xxe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15.75 19.5L8.25 12l7.5-7.5"
    })]
  });
}
const Jxe = ne.forwardRef(Xxe), e5e = Jxe;
function t5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.25 4.5l7.5 7.5-7.5 7.5"
    })]
  });
}
const n5e = ne.forwardRef(t5e), r5e = n5e;
function i5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    })]
  });
}
const o5e = ne.forwardRef(i5e), a5e = o5e;
function s5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M4.5 15.75l7.5-7.5 7.5 7.5"
    })]
  });
}
const l5e = ne.forwardRef(s5e), c5e = l5e;
function u5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75"
    })]
  });
}
const d5e = ne.forwardRef(u5e), h5e = d5e;
function f5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
    })]
  });
}
const p5e = ne.forwardRef(f5e), g5e = p5e;
function m5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
    })]
  });
}
const v5e = ne.forwardRef(m5e), b5e = v5e;
function w5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
    }), /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    })]
  });
}
const y5e = ne.forwardRef(w5e), k5e = y5e;
function _5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    })]
  });
}
const A5e = ne.forwardRef(_5e), C5e = A5e;
function x5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
    })]
  });
}
const E5e = ne.forwardRef(x5e), S5e = E5e;
function M5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
    })]
  });
}
const T5e = ne.forwardRef(M5e), D5e = T5e;
function I5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
    })]
  });
}
const P5e = ne.forwardRef(I5e), O5e = P5e;
function R5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
    })]
  });
}
const N5e = ne.forwardRef(R5e), $5e = N5e;
function L5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
    }), /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    })]
  });
}
const j5e = ne.forwardRef(L5e), B5e = j5e;
function F5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
    })]
  });
}
const z5e = ne.forwardRef(F5e), V5e = z5e;
function H5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
    })]
  });
}
const U5e = ne.forwardRef(H5e), W5e = U5e;
function G5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525"
    })]
  });
}
const q5e = ne.forwardRef(G5e), K5e = q5e;
function Y5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
    })]
  });
}
const Q5e = ne.forwardRef(Y5e), Z5e = Q5e;
function X5e({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
    })]
  });
}
const J5e = ne.forwardRef(X5e), eEe = J5e;
function tEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
    })]
  });
}
const nEe = ne.forwardRef(tEe), rEe = nEe;
function iEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
    })]
  });
}
const oEe = ne.forwardRef(iEe), aEe = oEe;
function sEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
    })]
  });
}
const lEe = ne.forwardRef(sEe), cEe = lEe;
function uEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
    })]
  });
}
const dEe = ne.forwardRef(uEe), hEe = dEe;
function fEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
    })]
  });
}
const pEe = ne.forwardRef(fEe), gEe = pEe;
function mEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    })]
  });
}
const vEe = ne.forwardRef(mEe), bEe = vEe;
function wEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M12 4.5v15m7.5-7.5h-15"
    })]
  });
}
const yEe = ne.forwardRef(wEe), kEe = yEe;
function _Ee({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
    })]
  });
}
const AEe = ne.forwardRef(_Ee), CEe = AEe;
function xEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
    })]
  });
}
const EEe = ne.forwardRef(xEe), SEe = EEe;
function MEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    })]
  });
}
const TEe = ne.forwardRef(MEe), DEe = TEe;
function IEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
    })]
  });
}
const PEe = ne.forwardRef(IEe), OEe = PEe;
function REe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    })]
  });
}
const NEe = ne.forwardRef(REe), $Ee = NEe;
function LEe({
  title: e,
  titleId: n,
  ...r
}, o) {
  return /* @__PURE__ */ K("svg", {
    ...Object.assign({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      "aria-hidden": "true",
      ref: o,
      "aria-labelledby": n
    }, r),
    children: [e ? /* @__PURE__ */ M("title", {
      id: n,
      children: e
    }) : null, /* @__PURE__ */ M("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 18L18 6M6 6l12 12"
    })]
  });
}
const jEe = ne.forwardRef(LEe), BEe = jEe;
var FEe = {
  prefix: "fad",
  iconName: "empty-set",
  icon: [512, 512, [8709, 216], "f656", ["M96 256c0-88.22 71.78-160 160-160c32.56 0 62.8 9.889 88.09 26.66l45.84-45.84C352.5 48.82 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.82 96.54 44.82 133.9l45.84-45.84C105.9 318.8 96 288.6 96 256zM435.2 122.1l-45.84 45.84C406.1 193.2 416 223.4 416 256c0 88.22-71.78 160-160 160c-32.56 0-62.8-9.889-88.09-26.66l-45.84 45.84C159.5 463.2 205.7 480 256 480c123.7 0 224-100.3 224-224C480 205.7 463.2 159.5 435.2 122.1z", "M502.6 9.375c-12.5-12.5-32.75-12.5-45.25 0l-448 448c-12.5 12.5-12.5 32.75 0 45.25C15.63 508.9 23.81 512 32 512s16.38-3.125 22.62-9.375l448-448C515.1 42.13 515.1 21.88 502.6 9.375z"]]
};
const S7 = oe.createContext({}), zEe = {
  variant: "outline",
  className: void 0
};
function VEe(e) {
  const n = tt(S7);
  return y1({}, zEe, n, XD(e, ["variant", "className"]));
}
function M7({
  children: e,
  variant: n,
  className: r
}) {
  const o = Re(() => ({
    variant: n,
    className: r
  }), [n, r]);
  return /* @__PURE__ */ M(S7.Provider, {
    value: o,
    children: e
  });
}
M7.displayName = "Icon.Group";
function Ze(e, n, r, o) {
  const s = {
    mini: e,
    solid: n,
    outline: r
  };
  function u(h) {
    const {
      variant: f,
      className: p
    } = VEe(h), b = !(p || "").match(/\b(h-\d)|(w-\d)/g), y = s[f];
    return /* @__PURE__ */ M(y, {
      className: Ce({
        "w-6 h-6": b
      }, p)
    });
  }
  return u.displayName = `Icon.${o}`, u;
}
const HEe = oe.createContext({});
function UEe() {
  return { solid: void 0, fixedWidth: void 0, ...tt(HEe) };
}
function WEe(e) {
  switch (e) {
    case "primary":
      return "text-blue-400";
    case "success":
      return "text-green-400";
    case "danger":
      return "text-red-400";
    case "warning":
      return "text-yellow-400";
    default:
      return;
  }
}
function GEe({
  icon: e,
  iconSolid: n,
  intent: r,
  solid: o,
  fixedWidth: s,
  ...u
}) {
  const h = UEe(), {
    solid: f,
    fixedWidth: p
  } = y1({}, h, {
    solid: o,
    fixedWidth: s
  });
  return /* @__PURE__ */ M("span", {
    className: WEe(r),
    children: /* @__PURE__ */ M(S8, {
      icon: f && n ? n : e,
      fixedWidth: p,
      ...u
    })
  });
}
function No(e, n) {
  return function(o) {
    return /* @__PURE__ */ M(GEe, {
      icon: e,
      iconSolid: n,
      ...o
    });
  };
}
const Bt = {
  Group: M7,
  Add: Ze(g_e, b2e, kEe, "Add"),
  Calendar: Ze(Dye, OAe, $xe, "Calendar"),
  Warning: Ze(
    Dke,
    OCe,
    $5e,
    "Warning"
  ),
  ExclamationCircle: No(C1e),
  Check: Ze(Vye, WAe, Kxe, "Check"),
  Caret: Ze(Wye, KAe, Zxe, "Caret"),
  ChevronUp: Ze(rke, aCe, c5e, "ChevronUp"),
  X: Ze(O_e, $2e, BEe, "X"),
  Previous: Ze(Kye, ZAe, e5e, "Previous"),
  Next: Ze(Zye, eCe, r5e, "Next"),
  LongRightArrow: Ze(
    W1e,
    K_e,
    Z2e,
    "LongRightArrow"
  ),
  LongLeftArrow: Ze(
    V1e,
    W_e,
    K2e,
    "LongLeftArrow"
  ),
  CheckCircle: Ze(Bye, VAe, Wxe, "CheckCircle"),
  Gift: Ze(Bke, VCe, W5e, "Gift"),
  ChartBar: Ze(Oye, $Ae, Bxe, "ChartBar"),
  Home: Ze(Wke, KCe, Z5e, "Home"),
  DocumentText: Ze(bke, kCe, C5e, "DocumentText"),
  ChatBubbleLeftRight: Ze(
    $ye,
    BAe,
    Vxe,
    "ChatBubbleLeftRight"
  ),
  Users: Ze(D_e, O2e, $Ee, "Users"),
  Share: Ze(k_e, C2e, SEe, "Share"),
  Eye: Ze(Oke, $Ce, B5e, "Eye"),
  Info: No(M1e),
  TrendingUp: Ze(eye, rAe, axe, "TrendingUp"),
  TrendingDown: Ze(
    $1e,
    B_e,
    V2e,
    "TrendingDown"
  ),
  Logout: Ze(
    K1e,
    Z_e,
    exe,
    "Logout"
  ),
  Settings: Ze(gke, bCe, k5e, "Settings"),
  User: Ze(S_e, D2e, OEe, "User"),
  Bell: Ze(kye, CAe, Sxe, "Bell"),
  QuestionCircle: Ze(
    b_e,
    k2e,
    CEe,
    "QuestionCircle"
  ),
  PlusCircle: Ze(h_e, g2e, bEe, "PlusCircle"),
  Sort: Ze(cye, hAe, gxe, "Sort"),
  Filter: Ze($ke, BCe, V5e, "Filter"),
  Bars: Ze(bye, kAe, Cxe, "Bars"),
  MessageQuestion: No(_1e),
  DragHandle: No(D1e),
  Image: Ze(c_e, h2e, gEe, "Image"),
  Upload: Ze(hke, gCe, b5e, "Upload"),
  Download: Ze(
    O1e,
    $_e,
    B2e,
    "Download"
  ),
  Pencil: Ze(a_e, c2e, hEe, "Pencil"),
  PencilSquare: Ze(r_e, a2e, cEe, "PencilSquare"),
  Send: Ze(e_e, r2e, aEe, "Send"),
  ClipboardCheck: Ze(
    ake,
    cCe,
    h5e,
    "Clipboard"
  ),
  ClipboardList: Ze(
    cke,
    hCe,
    g5e,
    "ClipboardList"
  ),
  Banknotes: Ze(gye, bAe, kxe, "Banknotes"),
  Globe: Ze(
    Vke,
    WCe,
    K5e,
    "Globe"
  ),
  Trash: Ze(C_e, S2e, DEe, "Trash"),
  Search: Ze(Kke, ZCe, eEe, "Search"),
  EllipsisHorizontal: Ze(
    kke,
    CCe,
    S5e,
    "EllipsisHorizontal"
  ),
  EllipsisVertical: Ze(
    Cke,
    SCe,
    D5e,
    "EllipsisVertical"
  ),
  Envelope: Ze(Ske, DCe, O5e, "Envelope"),
  BriefCase: Ze(Cye, SAe, Dxe, "BriefCase"),
  BuildingOffice: Ze(
    Sye,
    DAe,
    Oxe,
    "BuildingOffice"
  ),
  ArrowUpCircle: Ze(
    Z1e,
    eAe,
    rxe,
    "ArrowUpCircle"
  ),
  Timer: No(T1e),
  Stopwatch: No(x1e),
  BanIcon: Ze(Zke, e2e, rEe, "Ban"),
  Hourglass: No(E1e),
  Rewind: Ze(aye, cAe, hxe, "Rewind"),
  Backspace: Ze(hye, gAe, bxe, "Backspace"),
  ChevronUpDown: Ze(
    eke,
    rCe,
    a5e,
    "ChevronUpDown"
  ),
  ArrowUp: Ze(rye, aAe, cxe, "ArrowUp"),
  ArrowDown: Ze(B1e, V_e, W2e, "ArrowDown"),
  Note: No(k1e),
  EmptySet: No(FEe)
};
function qEe(e) {
  switch (e) {
    case "auto":
      return "justify-self-auto";
    case "stretch":
      return "justify-self-stretch";
    case "start":
      return "justify-self-start";
    case "center":
      return "justify-self-center";
    case "end":
      return "justify-self-end";
    default:
      return "";
  }
}
function KEe(e) {
  switch (e) {
    case "auto":
      return "self-auto";
    case "stretch":
      return "self-stretch";
    case "start":
      return "self-start";
    case "center":
      return "self-center";
    case "end":
      return "self-end";
    case "baseline":
      return "self-baseline";
    default:
      return "";
  }
}
function YEe(e) {
  switch (e) {
    case "stretch":
      return "justify-items-stretch";
    case "start":
      return "justify-items-start";
    case "center":
      return "justify-items-center";
    case "end":
      return "justify-items-end";
    default:
      return "";
  }
}
function QEe(e) {
  switch (e) {
    case "stretch":
      return "items-stretch";
    case "start":
      return "items-start";
    case "center":
      return "items-center";
    case "end":
      return "items-end";
    case "baseline":
      return "items-baseline";
    default:
      return "";
  }
}
function ZEe(e) {
  switch (e) {
    case "sm":
      return "sm:grid";
    case "md":
      return "md:grid";
    case "lg":
      return "lg:grid";
    case "xl":
      return "xl:grid";
    case "2xl":
      return "2xl:grid";
    default:
      return "";
  }
}
function XEe(e) {
  switch (e) {
    case 1:
      return "grid-cols-1";
    case 2:
      return "grid-cols-2";
    case 3:
      return "grid-cols-3";
    case 4:
      return "grid-cols-4";
    case 5:
      return "grid-cols-5";
    case 6:
      return "grid-cols-6";
    case 7:
      return "grid-cols-7";
    case 8:
      return "grid-cols-8";
    case 9:
      return "grid-cols-9";
    case 10:
      return "grid-cols-10";
    case 11:
      return "grid-cols-11";
    case 12:
      return "grid-cols-12";
    default:
      return "grid-cols-none";
  }
}
function i1({
  justify: e = "auto",
  align: n = "auto",
  children: r
}) {
  return /* @__PURE__ */ M("div", {
    className: Ce(qEe(e), KEe(n)),
    children: r
  });
}
function T7(e) {
  return typeof e == "function" || typeof e == "string";
}
function qo(e, n) {
  const r = T7(n) ? n : n.accessor, o = typeof r == "function" ? r(e) : A8(e, r);
  switch (typeof o) {
    case "string":
      return o;
    case "number":
      return o.toString();
    default:
      return;
  }
}
function ri(e, n) {
  return !T7(n) && n.renderer ? n.renderer(e) : qo(e, n);
}
let af = 0;
function JEe() {
  const e = Date.now();
  return af = e > af ? e : af + 1, af.toString(36);
}
function eSe(e) {
  switch (e) {
    case "start":
      return "items-start";
    case "end":
      return "items-end";
    case "center":
      return "items-center";
    case "baseline":
      return "items-baseline";
    case "stretch":
      return "items-stretch";
    default:
      throw new Error("unsupported `align` value");
  }
}
function D7(e) {
  switch (e) {
    case 0:
      return "gap-0";
    case 1:
      return "gap-1";
    case 2:
    case !0:
      return "gap-2";
    case 4:
      return "gap-4";
    case 6:
      return "gap-6";
    case "1px":
      return "gap-px";
    default:
      throw new Error("unsupported `gap` value");
  }
}
function tSe(e) {
  return !!(e && typeof e == "object");
}
function nSe(e) {
  return typeof e.type == "string" ? e.type : e.type.name;
}
function _D(e) {
  return tSe(e) && nSe(e) === i1.name ? e : e ? /* @__PURE__ */ M(i1, {
    children: e
  }) : null;
}
function I7({
  children: e,
  cols: n = "auto",
  breakpoint: r = "sm",
  justifyItems: o = "start",
  alignItems: s = "center",
  gap: u = 0,
  divide: h = !1
}) {
  const f = Array.isArray(e) ? e.length : 1;
  return /* @__PURE__ */ M("div", {
    className: Ce({
      "divide-y divide-gray-200 md:divide-y-0 md:divide-x": h
    }, ZEe(r), XEe(n === "auto" ? f : n), YEe(o), QEe(s), D7(u)),
    children: Array.isArray(e) ? e.map((p) => _D(p)) : _D(e)
  });
}
I7.Column = i1;
const rSe = (e) => {
  switch (e) {
    case "decrease":
      return /* @__PURE__ */ M(Bt.TrendingDown, {});
    case "increase":
      return /* @__PURE__ */ M(Bt.TrendingUp, {});
    default:
      return null;
  }
}, iSe = (e) => {
  switch (e) {
    case "decrease":
      return "danger";
    case "increase":
      return "success";
    default:
      return "primary";
  }
}, oSe = (e) => /* @__PURE__ */ M(E7, {
  intent: iSe(e.changeType),
  iconAfter: rSe(e.changeType),
  rounded: !1,
  children: e.change
});
function aSe({
  items: e,
  title: n
}) {
  return /* @__PURE__ */ K("div", {
    className: "border-t border-b border-gray-300",
    children: [n && /* @__PURE__ */ M("h3", {
      className: "text-lg font-medium leading-6 text-gray-900",
      children: n
    }), /* @__PURE__ */ M(I7, {
      cols: e.length,
      divide: !0,
      justifyItems: "stretch",
      breakpoint: "md",
      children: e.map((r) => /* @__PURE__ */ K("div", {
        className: "px-4 py-5 sm:p-6",
        children: [/* @__PURE__ */ M("dt", {
          className: "text-base font-normal text-gray-900",
          children: r.title
        }), /* @__PURE__ */ K("dd", {
          className: "mt-1 flex items-baseline justify-between md:block lg:flex",
          children: [/* @__PURE__ */ M("div", {
            className: "flex items-baseline text-2xl font-semibold text-blue-800",
            children: r.value
          }), oSe(r)]
        })]
      }, r.title))
    })]
  });
}
aSe.displayName = "StatsGrid";
const sSe = {
  none: "bg-gray-50 text-gray-700",
  colored: "border-transparent",
  primary: "bg-blue-100 text-blue-700",
  success: "bg-green-100 text-green-700",
  danger: "bg-red-100 text-red-700",
  warning: "bg-yellow-100 text-yellow-500"
};
function lSe(e) {
  return `${sSe[e || "none"]}`;
}
function sk({
  children: e,
  intent: n
}) {
  return /* @__PURE__ */ M("div", {
    className: Ce("flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white", lSe(n)),
    children: e
  });
}
sk.displayName = "TimelineIcon";
function P7({
  items: e,
  id: n,
  icon: r,
  primary: o,
  secondary: s
}) {
  return /* @__PURE__ */ M("div", {
    className: "flow-root",
    children: /* @__PURE__ */ M("ul", {
      className: "-mb-8",
      children: e.map((u, h) => /* @__PURE__ */ M("li", {
        children: /* @__PURE__ */ K("div", {
          className: "relative pb-8",
          children: [h !== e.length - 1 ? /* @__PURE__ */ M("span", {
            className: "absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200",
            "aria-hidden": "true"
          }) : null, /* @__PURE__ */ K("div", {
            className: "relative flex items-start space-x-3",
            children: [/* @__PURE__ */ M("div", {
              children: /* @__PURE__ */ M("div", {
                className: "relative px-1",
                children: r ? ri(u, r) : /* @__PURE__ */ M(sk, {})
              })
            }), /* @__PURE__ */ K("div", {
              className: "min-w-0 flex-1 py-1",
              children: [ri(u, o), /* @__PURE__ */ M("p", {
                className: "mt-0.5 text-sm text-gray-500",
                children: ri(u, s)
              })]
            })]
          })]
        })
      }, qo(u, n)))
    })
  });
}
P7.Icon = sk;
P7.displayName = "Timeline";
function cSe({
  children: e,
  content: n,
  placement: r,
  disabled: o = !1,
  show: s
}) {
  return /* @__PURE__ */ M(M8, {
    placement: r,
    content: n,
    delay: [450, 0],
    animation: "shift-away-subtle",
    inertia: !0,
    disabled: !n || o,
    visible: s,
    children: e
  });
}
cSe.displayName = "Tooltip";
function uSe(e) {
  if (!(!e || e.trim() === ""))
    return e.replace(/\s+/, " ").split(" ").slice(0, 2).map((n) => n && n[0].toUpperCase()).join("");
}
function dSe(e) {
  switch (e) {
    case 6:
      return "w-6 h-6";
    case 8:
      return "w-8 h-8";
    case 10:
      return "w-10 h-10";
    case 12:
      return "w-12 h-12";
    case 14:
      return "w-14 h-14";
    default:
      throw new Error("size not supported");
  }
}
function hSe(e, n, r, o) {
  return e && !r ? /* @__PURE__ */ M("img", {
    className: "object-cover",
    src: e,
    alt: n ? `Avatar of ${n}` : "Avatar",
    onError: o
  }) : n ? /* @__PURE__ */ M("span", {
    className: "text-xs font-medium leading-none text-white",
    children: uSe(n)
  }) : /* @__PURE__ */ M("svg", {
    className: "h-full w-full text-gray-300",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ M("path", {
      d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
    })
  });
}
function BDe({
  shape: e = "round",
  size: n = 8,
  src: r
}) {
  const [o, s] = Ve(!1);
  Xe(() => {
    s(!1);
  }, [r]);
  const u = () => {
    s(!0);
  };
  return /* @__PURE__ */ M("span", {
    className: Ce("inline-block overflow-hidden bg-gray-100", dSe(n), {
      "rounded-full": e === "round"
    }),
    children: hSe(r, void 0, o, u)
  });
}
const AD = () => typeof window < "u" ? window.innerWidth <= 768 : !1;
function fSe() {
  const [e, n] = Ve(AD());
  return Xe(() => {
    const r = () => {
      n(AD());
    };
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }, []), e;
}
const Sd = oe.createContext(void 0);
function pSe() {
  const e = tt(Sd);
  return [e !== void 0, e || {}];
}
function O7({
  children: e,
  onClick: n,
  ...r
}) {
  const o = ye((s) => {
    n && (s.key === ze.Space || s.key === ze.Enter) && n(s);
  });
  return /* @__PURE__ */ M(Sd.Provider, {
    value: r,
    children: /* @__PURE__ */ M("div", {
      role: "presentation",
      className: Ce("relative z-0 inline-flex", {
        "shadow-sm": r?.appearance !== "minimal"
      }),
      onClick: n,
      onKeyDown: o,
      children: e
    })
  });
}
O7.displayName = "Button.Group";
function R7() {
  return /* @__PURE__ */ M("svg", {
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    className: "animate-spin-slow",
    focusable: !1,
    role: "img",
    style: {
      height: "1em"
    },
    children: /* @__PURE__ */ M("circle", {
      cx: "75",
      cy: "75",
      r: "60",
      className: "animate-stroke",
      style: {
        strokeDashoffset: 600,
        strokeDasharray: 300,
        strokeWidth: 10,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        stroke: "currentcolor",
        fill: "transparent"
      }
    })
  });
}
R7.displayName = "Spinner.Inline";
function N7({
  size: e = 32,
  color: n = "currentColor"
}) {
  return /* @__PURE__ */ M("div", {
    className: "animate-spin-slow m-auto",
    style: {
      width: e,
      height: e
    },
    children: /* @__PURE__ */ M("svg", {
      x: "0px",
      y: "0px",
      viewBox: "0 0 150 150",
      children: /* @__PURE__ */ M("circle", {
        cx: "75",
        cy: "75",
        r: "60",
        className: "animate-stroke",
        style: {
          strokeDashoffset: 600,
          strokeDasharray: 300,
          strokeWidth: 16,
          strokeMiterlimit: 10,
          strokeLinecap: "round",
          stroke: n,
          fill: "transparent"
        }
      })
    })
  });
}
N7.displayName = "Spinner";
const gSe = Object.assign(N7, {
  Inline: R7
});
function CD() {
  return /* @__PURE__ */ M("span", {
    className: "flex w-5 h-5",
    children: /* @__PURE__ */ M(gSe, {
      size: 16
    })
  });
}
const xD = {
  default: {
    none: "text-gray-700 border-gray-300 bg-gray-50 hover:bg-gray-200 focus:ring-gray-500",
    colored: "text-white border-transparent",
    primary: "bg-blue-800 hover:bg-blue-900 focus:ring-blue-500",
    success: "bg-green-600 hover:bg-green-700 focus:ring-green-500",
    danger: "bg-red-600 hover:bg-red-700 focus:ring-red-500",
    warning: "bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500"
  },
  light: {
    none: "text-gray-700 border-gray-300 bg-gray-50 hover:bg-gray-200 focus:ring-gray-500",
    colored: "border-transparent",
    primary: "bg-blue-200 text-blue-800 hover:bg-blue-300 focus:ring-blue-500",
    success: "bg-green-200 text-green-700 hover:bg-green-300 focus:ring-green-500",
    danger: "bg-red-200 text-red-700 hover:bg-red-300 focus:ring-red-500",
    warning: "bg-yellow-200 text-yellow-700 hover:bg-yellow-300 focus:ring-yellow-500"
  },
  outlined: {
    none: "bg-white border-gray-300 text-gray-700 hover:bg-gray-200 focus:ring-gray-500",
    colored: "bg-white",
    primary: "border-blue-300 text-blue-800 hover:bg-blue-100 focus:ring-blue-500",
    success: "border-green-300 text-green-700 hover:bg-green-100 focus:ring-green-500",
    danger: "border-red-300 text-red-700 hover:bg-red-100 focus:ring-red-500",
    warning: "border-yellow-300 text-yellow-700 hover:bg-yellow-100 focus:ring-yellow-500"
  },
  minimal: {
    none: "bg-transparent border-transparent text-gray-700 hover:bg-gray-200 focus:ring-gray-500",
    colored: "bg-transparent border-transparent",
    primary: "text-blue-800 hover:bg-blue-100 focus:ring-blue-500",
    success: "text-green-700 hover:bg-green-100 focus:ring-green-500",
    danger: "text-red-700 hover:bg-red-100 focus:ring-red-500",
    warning: "text-yellow-700 hover:bg-yellow-100 focus:ring-yellow-500"
  }
};
function mSe(e, n) {
  return `${n ? xD[e].colored : ""} ${xD[e][n || "none"]}`;
}
const vSe = {
  small: !1,
  intent: void 0,
  appearance: "default",
  disabled: !1,
  narrow: !1
}, di = nt(({
  small: e,
  intent: n,
  appearance: r,
  disabled: o,
  narrow: s,
  onClick: u,
  submit: h = !1,
  children: f,
  iconBefore: p,
  iconAfter: v,
  shrink: b = !1,
  fill: y = !1,
  loading: k = !1,
  ..._
}, E) => {
  const [x, D] = pSe(), {
    rounded: I
  } = Li(_), {
    small: N,
    intent: O,
    appearance: P,
    disabled: S,
    narrow: $
  } = {
    ...vSe,
    ...D,
    ...Object.fromEntries(Object.entries({
      small: e,
      intent: n,
      appearance: r,
      disabled: o,
      narrow: s
    }).filter(([, G]) => G !== void 0))
  }, L = fSe(), B = p || k && !v ? /* @__PURE__ */ M("span", {
    className: "inline-block",
    children: k ? /* @__PURE__ */ M(CD, {}) : p
  }) : null, U = v ? /* @__PURE__ */ M("span", {
    className: "inline-block",
    children: k && !p ? /* @__PURE__ */ M(CD, {}) : v
  }) : null;
  return /* @__PURE__ */ M(Bt.Group, {
    variant: "mini",
    className: N ? "w-4 h-4" : "h-5 w-5",
    children: /* @__PURE__ */ K("button", {
      ref: E,
      type: h ? "submit" : "button",
      className: Ce(
        y ? "flex w-full" : "inline-flex",
        "items-center gap-x-2 border",
        "focus:outline-none focus:ring-2 focus:ring-offset-2",
        {
          "relative z-0 focus:z-10 [&:not(:first-child)]:-ml-px": x
        },
        mSe(P, O),
        {
          "opacity-60 cursor-not-allowed": S
        },
        {
          "shadow-sm": P !== "minimal" && !x
        },
        $ ? "px-3" : "px-4",
        N ? "py-1.5 text-xs" : "py-2 text-sm",
        {
          rounded: I && !x
        },
        {
          "first:rounded-l last:rounded-r": I && x
        }
      ),
      onClick: u,
      disabled: S,
      ..._,
      children: [B, f && /* @__PURE__ */ M("span", {
        className: Ce("flex-grow text-left", {
          "sr-only": L && b
        }),
        children: f
      }), U]
    })
  });
});
di.displayName = "Button";
function bSe({
  children: e,
  multiple: n = !1,
  onFileSelect: r,
  ...o
}) {
  const s = Le(null), u = () => {
    s.current?.click();
  }, h = et((f) => {
    if (r && f.target.files) {
      const p = {
        ...f.target.files
      };
      r(p);
    }
    s.current && (s.current.value = "");
  }, [r]);
  return /* @__PURE__ */ K(di, {
    ...o,
    onClick: u,
    children: [e, /* @__PURE__ */ M("input", {
      type: "file",
      className: "hidden",
      ref: s,
      multiple: n,
      onChange: h
    })]
  });
}
const wSe = Object.assign(di, { Group: O7, FileSelect: bSe }), lk = oe.createContext({ inSection: !1, padded: !1 });
function ck(e, n = !0) {
  const r = tt(lk);
  if (r.inSection !== n)
    throw new Error(`Composition error:
<${e} /> ${n ? "needs to" : "cannot"} be wrapped in <Dropbox.Section />`);
  return r;
}
const $7 = "Dropdown.Button", L7 = oe.forwardRef(({
  children: e,
  type: n = "button",
  iconBefore: r,
  ...o
}, s) => {
  const {
    padded: u
  } = ck($7);
  return /* @__PURE__ */ M(J1, {
    children: ({
      focus: h
    }) => /* @__PURE__ */ K("button", {
      type: n,
      ref: s,
      className: Ce("w-full", "group/dropdown-item flex items-center px-4 py-2 text-sm", h ? "bg-gray-100 text-gray-900" : "text-gray-700", {
        "ml-6": u && !r
      }),
      ...o,
      children: [r, /* @__PURE__ */ M("span", {
        className: "truncate",
        children: e
      })]
    })
  });
});
L7.displayName = $7;
const j7 = "Dropdown.Link", B7 = oe.forwardRef(({
  children: e,
  iconBefore: n,
  ...r
}, o) => {
  const {
    padded: s
  } = ck(j7);
  return /* @__PURE__ */ M(J1, {
    children: ({
      focus: u
    }) => /* @__PURE__ */ K("a", {
      ref: o,
      className: Ce(
        "cursor-pointer",
        "group/dropdown-item flex items-center px-4 py-2 text-sm",
        u ? "bg-gray-100 text-gray-900" : "text-gray-700",
        {
          "ml-6": s && !n
        }
      ),
      ...r,
      children: [n && /* @__PURE__ */ M("div", {
        className: "flex-shrink-0",
        children: n
      }), /* @__PURE__ */ M("span", {
        className: "truncate flex-1",
        children: e
      })]
    })
  });
});
B7.displayName = j7;
function F7({
  children: e,
  padded: n,
  title: r
}) {
  const o = ck("Section", !1), s = Re(() => ({
    inSection: !0,
    padded: n === void 0 ? o.padded : n
  }), [n, o.padded]);
  return /* @__PURE__ */ M("div", {
    className: "py-1",
    children: /* @__PURE__ */ K(lk.Provider, {
      value: s,
      children: [r && /* @__PURE__ */ M("h4", {
        className: "px-4 py-1 text-xs text-gray-500",
        children: r
      }), e]
    })
  });
}
F7.displayName = "Dropdown.Section";
function z7({
  control: e,
  children: n,
  padded: r = !1,
  fullWidth: o = !1,
  ...s
}) {
  const u = Re(() => ({
    inSection: !1,
    padded: r
  }), [r]), {
    rounded: h
  } = Li(s);
  return /* @__PURE__ */ M(lk.Provider, {
    value: u,
    children: /* @__PURE__ */ K(zK, {
      as: "div",
      className: Ce("relative", {
        "inline-block text-left": !o
      }),
      children: [/* @__PURE__ */ M(yI, {
        as: "div",
        children: e
      }), /* @__PURE__ */ M(kI, {
        transition: !0,
        anchor: "bottom start",
        className: Ce("max-w-xs origin-top-right", "z-10", "divide-y divide-gray-100 bg-white shadow-lg", "transition duration-100 ease-out [--anchor-gap:8px] focus:outline-none", "ring-1 ring-black ring-opacity-5 focus:outline-none", "data-[closed]:scale-95 data-[closed]:opacity-0", {
          "rounded-md": h
        }),
        children: /* @__PURE__ */ M(Bt.Group, {
          variant: "mini",
          className: "mr-3 text-gray-400 group-hover/dropdown-item:text-gray-500",
          children: n
        })
      })]
    })
  });
}
z7.displayName = "Dropdown";
const cb = Object.assign(z7, {
  Button: L7,
  Link: B7,
  Section: F7
}), V7 = _t("primary");
function ySe() {
  return tt(V7);
}
function kSe(e) {
  switch (e) {
    case "success":
      return "hover:text-green-600";
    case "danger":
      return "hover:text-red-600";
    case "warning":
      return "hover:text-yellow-600";
    case "primary":
      return "hover:text-blue-600";
    default:
      return "hover:text-gray-600";
  }
}
const _Se = oe.forwardRef(({
  ...e
}, n) => {
  const r = ySe();
  return /* @__PURE__ */ M("a", {
    ...e,
    ref: n,
    className: Ce(e.className, "text-inherit font-medium underline", kSe(r)),
    children: e.children
  });
});
function ASe(e) {
  switch (e) {
    case "success":
      return ["bg-green-50", "border-green-400", "text-green-400", "text-green-700"];
    case "danger":
      return ["bg-red-50", "border-red-400", "text-red-400", "text-red-700"];
    case "warning":
      return ["bg-yellow-50", "border-yellow-400", "text-yellow-400", "text-yellow-700"];
    case "primary":
      return ["bg-blue-50", "border-blue-400", "text-blue-400", "text-blue-700"];
    default:
      return ["bg-white", "border-gray-400", "text-gray-400", "text-gray-700"];
  }
}
function CSe({
  children: e,
  icon: n,
  intent: r,
  accent: o = !1,
  dismissible: s = !1,
  onDismiss: u,
  ...h
}) {
  const [f, p, v, b] = ASe(r), {
    rounded: y
  } = Li(h), [k, _] = Ve(!1), E = () => {
    u && u(), _(!0);
  };
  return /* @__PURE__ */ M(V7.Provider, {
    value: r,
    children: /* @__PURE__ */ M(rr, {
      as: "div",
      className: Ce("p-4", f, p, {
        shadow: !r
      }, {
        rounded: y
      }),
      leave: "transition-opacity ease-in-out duration-300",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0",
      show: !k,
      children: /* @__PURE__ */ K("div", {
        className: "flex",
        children: [n && /* @__PURE__ */ M("div", {
          className: Ce("flex-shrink-0", v),
          children: n
        }), /* @__PURE__ */ M("div", {
          className: "ml-3",
          children: /* @__PURE__ */ M("p", {
            className: Ce("text-sm", b),
            children: e
          })
        }), s && /* @__PURE__ */ M("div", {
          className: "ml-auto pl-3",
          children: /* @__PURE__ */ M("div", {
            className: "-mx-1.5 -my-1.5",
            children: /* @__PURE__ */ M(di, {
              intent: r,
              iconBefore: /* @__PURE__ */ M(Bt.X, {}),
              appearance: "minimal",
              onClick: E
            })
          })
        })]
      })
    })
  });
}
CSe.Link = _Se;
function xSe(e, n = !0) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    const r = new Error().stack;
    let o = "";
    r && (o = r.replace(/^Error\s+/, ""), [, o] = o.split(`
`), o = o.replace(/^\s+at /, ""), o = o.replace(/ \(.+\)$/, ""), o = o.replace(/@.+/, ""), o += ":"), (n ? console.warn : console.info)(
      `%c[nalgoo-ui]%c %c${o}%c ${e}`,
      "background: #222; color: #fff;",
      "",
      "font-weight: bold",
      ""
    );
  }
}
const ESe = "en", H7 = oe.createContext(void 0);
function SSe() {
  let e = tt(H7);
  return e || (xSe("consider warping your app in  <Localization /> provider", !1), e = ESe), {
    locale: e
  };
}
function FDe({
  children: e,
  locale: n
}) {
  return /* @__PURE__ */ M(H7.Provider, {
    value: n,
    children: e
  });
}
function MSe(e, n, r) {
  const o = Math.abs(m8(e, n));
  return v8(e, n, {
    locale: r,
    unit: o > 0 && o < 12 ? "month" : void 0
  });
}
function ED(e, n) {
  return b8(e, {}, {
    locale: n
  });
}
function zDe({
  date: e,
  update: n = 5,
  fullDateAfter: r
}) {
  const [o, s] = Ve(new Date()), {
    locale: u
  } = SSe();
  if (Xe(() => {
    if (n) {
      const f = setInterval(() => {
        s(new Date());
      }, n * 1e3);
      return () => {
        clearInterval(f);
      };
    }
  }, [n]), !e)
    return null;
  const h = r && (Xp(e, p8(o, r)) || Vl(e, g8(o, r)));
  return /* @__PURE__ */ M("time", {
    dateTime: YD(e, {
      representation: "date"
    }),
    title: h ? void 0 : ED(e, u),
    children: h ? ED(e, u) : MSe(e, o, u)
  });
}
function TSe(e) {
  switch (e) {
    case 1:
      return "line-clamp-1";
    case 2:
      return "line-clamp-2";
    case 3:
      return "line-clamp-3";
    case 4:
      return "line-clamp-4";
    case 5:
      return "line-clamp-5";
    default:
      throw new Error("Not supported");
  }
}
function DSe({
  children: e,
  lines: n = 2
}) {
  return /* @__PURE__ */ M("p", {
    className: n ? TSe(n) : "line-clamp-none",
    children: e
  });
}
DSe.displayName = "LineClamp";
function qs({
  children: e,
  ...n
}) {
  return /* @__PURE__ */ M("label", {
    className: "block text-sm font-medium text-gray-700",
    ...n,
    children: e
  });
}
function ISe(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Ff(e, n) {
  if (typeof n == "function")
    return n(e);
  if (ISe(e, n))
    return e[n];
}
function o1(e, n, r) {
  const o = Ff(e, n);
  return r ? r(o, e) : o;
}
function SD(e, n = !1) {
  const r = e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return n ? r.toLowerCase() : r;
}
function PSe({
  children: e,
  value: n
}) {
  return /* @__PURE__ */ M(lI, {
    value: n,
    className: ({
      focus: r
    }) => Ce("relative cursor-pointer select-none py-2 pl-3 pr-9", r ? "bg-blue-600 text-white" : "text-gray-900"),
    children: ({
      focus: r,
      selected: o
    }) => /* @__PURE__ */ K(bo, {
      children: [/* @__PURE__ */ M("span", {
        className: Ce("block truncate", o && "font-semibold"),
        children: e
      }), /* @__PURE__ */ M("span", {
        className: Ce("absolute inset-y-0 right-0 flex items-center pr-4", r ? "text-white" : "text-blue-600"),
        children: o && /* @__PURE__ */ M(Bt.Check, {
          "aria-hidden": "true"
        })
      })]
    })
  });
}
function ub(e, n) {
  const r = II();
  Xe(() => {
    if (!r)
      return e();
  }, n);
}
function Md(e = {}, ...n) {
  return Ce(
    "block w-full sm:text-sm shadow-sm",
    "focus-within:outline-none",
    "focus-within:ring-1",
    { "placeholder-gray-400": !e.invalid },
    {
      "border-gray-300 focus-within:border-blue-500 focus-within:ring-blue-500": !e.invalid && !e.required && !e.selected
    },
    {
      "border-blue-300 focus-within:border-blue-500 focus-within:ring-blue-500": !e.invalid && !e.required && e.selected
    },
    {
      "border-yellow-300 focus-within:border-yellow-500 focus-within:ring-yellow-500": e.required && !e.invalid
    },
    {
      "border-red-300 text-red-900 placeholder-red-300 focus-within:ring-red-500 focus-within:border-red-500": e.invalid
    },
    e.disabled ? "cursor-not-allowed bg-gray-100" : "bg-white",
    n
  );
}
function db(e) {
  return Array.isArray(e) && e.length === 0 ? !0 : e == null;
}
function OSe(e, n) {
  return n === !0 ? e : e.find(() => !0);
}
function RSe(e, n, r, o) {
  return Array.isArray(e) ? e.reduce((s, u) => (s.length > 0 && s.push(o), s.push(o1(u, n, r)), s), []) : o1(e, n, r);
}
function NSe(e, n, r, o) {
  return n === !0 ? /* @__PURE__ */ M(kE, {
    value: e,
    onChange: r,
    multiple: !0,
    children: o
  }) : /* @__PURE__ */ M(kE, {
    value: e,
    onChange: r,
    children: o
  });
}
function VDe({
  label: e,
  items: n,
  accessor: r,
  idAccessor: o,
  selectedAccessor: s = "selected",
  optionRenderer: u,
  itemRenderer: h,
  onChange: f,
  emptyResults: p = "No results",
  placeholder: v = "Select",
  searchInputPlaceholder: b = "Find\u2026",
  separator: y = ", ",
  multiple: k,
  disabled: _,
  required: E,
  invalid: x,
  clearable: D,
  ...I
}) {
  const {
    rounded: N
  } = Li(I), O = Re(() => {
    const Q = [];
    return n.map((Z) => {
      const ae = Ff(Z, r);
      let ie;
      if (o) {
        const ce = Ff(Z, o);
        if (!ce)
          throw new Error("Identifier needs to be number or non-empty string");
        ie = ce;
      } else {
        if (ae == null)
          throw new Error(`Value of item is ${typeof ae} and it cannot be used as identifier, consider using idAccessor`);
        if (ae === "")
          throw new Error("Value of item is empty string and it cannot be used as identifier, consider using idAccessor");
        ie = ae;
      }
      if (Q.includes(ie))
        throw new Error("Duplicate identifier");
      Q.push(ie);
      const pe = ae ? SD(ae.toString(), !0) : "";
      return {
        item: Z,
        id: ie,
        value: pe
      };
    });
  }, [n, r, o]), P = Re(() => {
    const Q = O.map((Z) => Z.item).filter((Z) => Ff(Z, s));
    return OSe(Q, k);
  }, [O, k, s]), [S, $] = Ve(P);
  ub(() => {
    $(P);
  }, [O]), ub(() => {
    $((Q) => k ? db(Q) ? [] : [Q] : Array.isArray(Q) ? Q.find(() => !0) : void 0);
  }, [k]);
  const [L, B] = Ve(""), U = Re(() => {
    const Q = SD(L, !0).split(/[\s,;]+/).filter((Z) => Z !== "");
    return Q.length === 0 ? O : O.filter((Z) => Q.every((ae) => Z.value.includes(ae)));
  }, [O, L]), G = et((Q) => {
    $(!k && Q === S ? void 0 : Q);
  }, [k, S]);
  ub(() => {
    f && f(S);
  }, [S]);
  const q = (Q) => {
    B(Q.target.value);
  }, Y = et((Q) => {
    Q.stopPropagation(), _ || G(void 0);
  }, [G, _]);
  return NSe(S, k, G, /* @__PURE__ */ K(wI, {
    children: [/* @__PURE__ */ M(qs, {
      children: e
    }), /* @__PURE__ */ K("div", {
      className: "mt-1 relative",
      children: [/* @__PURE__ */ M(oI, {
        as: "div",
        children: /* @__PURE__ */ K("button", {
          type: "button",
          className: Ce("flex w-full items-center gap-x-2", "px-4 py-2 text-sm border shadow-sm", "focus:ring-1 focus:ring-blue-500", _ ? "bg-gray-100 text-gray-700" : "bg-white", Md({
            required: E,
            invalid: x,
            disabled: _
          }).replace("block", ""), {
            rounded: N
          }),
          children: [/* @__PURE__ */ M("span", {
            className: "flex-1 text-left min-w-0",
            children: db(S) ? v : RSe(S, r, h, y)
          }), D && !db(S) && /* @__PURE__ */ M("span", {
            "aria-hidden": "true",
            className: Ce("flex-0 flex items-center cursor-pointer", "focus:outline-none text-gray-500 hover:text-gray-700", {
              "pointer-events-none": _
            }),
            onClick: Y,
            children: /* @__PURE__ */ M(Bt.X, {
              "aria-hidden": "true",
              className: "h-4 w-4"
            })
          }), /* @__PURE__ */ M("span", {
            className: "flex-0",
            children: /* @__PURE__ */ M(Bt.Caret, {
              className: "h-4 w-4"
            })
          })]
        })
      }), /* @__PURE__ */ K(rr, {
        as: "div",
        enter: "ease-in-out duration-50",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        className: Ce("absolute max-w-full z-20 mt-1 bg-white shadow-lg text-base shadow-lg", "ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", {
          rounded: N
        }),
        children: [/* @__PURE__ */ M(aI, {
          className: Ce("border-0 w-full px-3 py-2 sm:text-sm focus:ring-0", "outline-none border-b border-gray-200 placeholder-gray-400", {
            rounded: N
          }),
          placeholder: b,
          onChange: q,
          displayValue: () => L
        }, "please-stay"), /* @__PURE__ */ M(
          sI,
          {
            className: Ce("absolute z-10 mt-1 max-h-60 w-full overflow-y-auto bg-white py-1", "text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", {
              rounded: N
            }),
            children: U.length === 0 ? /* @__PURE__ */ M("div", {
              className: "py-2 px-3 text-gray-700",
              children: p
            }) : U.map((Q) => /* @__PURE__ */ M(PSe, {
              value: Q.item,
              children: o1(Q.item, r, u)
            }, Q.id))
          }
        )]
      })]
    })]
  }));
}
const $Se = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set || ((e) => {
  (void 0).value = e;
}), LSe = _t(void 0);
function U7(e) {
  return tt(LSe) || e;
}
const ed = oe.forwardRef(({
  onChange: e = void 0,
  invalid: n = !1,
  disabled: r = !1,
  required: o = !1,
  selected: s = !1,
  small: u = !1,
  clearable: h = !1,
  type: f = "text",
  iconBefore: p,
  iconAfter: v,
  id: b,
  onClearButtonClick: y,
  ...k
}, _) => {
  const E = U7(b), {
    rounded: x
  } = Li(k), [D, I] = Ve(!(k.value || k.defaultValue)), N = Le(null), O = vt(_, N), P = ($) => {
    e && e($), I($.target.value === "");
  }, S = ($) => {
    const L = new Event("input", {
      bubbles: !0
    });
    y && y($, L) === !1 || N.current && ($Se.call(N.current, ""), N.current.dispatchEvent(L));
  };
  return /* @__PURE__ */ K("div", {
    className: Ce("relative border px-3", {
      "text-xs sm:text-xs": u
    }, "flex gap-x-2 items-center", Md({
      invalid: n,
      disabled: r,
      required: o,
      selected: s
    }, {
      "border-blue-500": s
    }, {
      "text-xs sm:text-xs": u
    }, " read-only:text-gray-700 ", {
      rounded: x
    })),
    children: [p && /* @__PURE__ */ M("div", {
      "aria-hidden": "true",
      className: "shrink-0 text-gray-400 flex items-center pointer-events-none",
      children: p
    }), /* @__PURE__ */ M("input", {
      ...k,
      id: E,
      type: f,
      className: Ce("block bg-transparent min-w-0 w-full grow px-0", u ? "text-xs" : "text-sm", "border-0 outline-none focus:ring-0 focus:outline focus:outline-none", n ? "placeholder-red-300" : "placeholder-gray-400", {
        "text-red-900": n
      }),
      disabled: r,
      ref: O,
      onChange: P
    }), h && !D && !r && /* @__PURE__ */ K("button", {
      tabIndex: -1,
      type: "button",
      className: "shrink-0 flex items-center rounded-full p-1 rounded my-1 cursor-pointer focus:outline-none text-gray-500 hover:text-gray-700 hover:bg-gray-100",
      onClick: S,
      children: [/* @__PURE__ */ M("span", {
        className: "sr-only",
        children: "Clear input"
      }), /* @__PURE__ */ M(Bt.X, {
        className: "h-4 w-4",
        "aria-hidden": "true"
      })]
    }), n && /* @__PURE__ */ M("div", {
      className: "shrink-0 flex items-center pointer-events-none",
      children: /* @__PURE__ */ M(Bt.ExclamationCircle, {
        className: "h-5 w-5 text-red-500",
        "aria-hidden": "true"
      })
    }), v && /* @__PURE__ */ M("div", {
      "aria-hidden": "true",
      className: "shrink-0 text-gray-400 flex items-center pointer-events-none",
      children: v
    })]
  });
});
function W7(e) {
  return e ? `${e.hours}:${e.minutes.toString().padStart(2, "0")}` : "";
}
const jSe = /^\s*(?<hours>[1-2]?[0-9])(?<separator>[^0-9])?(?<minutes1>[0-5]?)(?<minutes2>[0-9])?/;
function BSe(e) {
  const n = jSe.exec(e);
  if (!n || !n.groups)
    return {
      time: void 0,
      inputValue: e,
      selectionValue: ""
    };
  const r = parseInt(n.groups.hours, 10), o = n.groups.minutes1 ? parseInt(n.groups.minutes1, 10) * 10 : 0, s = n.groups.minutes2 ? parseInt(n.groups.minutes2, 10) : 0, u = o + s, h = {
    hours: r,
    minutes: u
  }, f = `${n.groups.hours || ""}${r > 2 || n.groups.separator ? ":" : ""}${n.groups.minutes1 || ""}${n.groups.minutes2 || ""}`, p = n.groups.minutes2 ? "" : `${!n.groups.minutes1 && r <= 2 && !n.groups.separator ? ":" : ""}${n.groups.minutes1 ? "0" : "00"}`;
  return {
    time: h,
    inputValue: f,
    selectionValue: p
  };
}
const G7 = (e) => ({
  value: e,
  lastGoodValue: e,
  inputValue: W7(e),
  selectionValue: void 0,
  open: !1,
  skipOnChangeHandler: !0
}), FSe = (e, n) => {
  switch (n.type) {
    case 0:
      return {
        ...e,
        open: !0
      };
    case 1:
      return e.value?.hours === n.initialValue?.hours && e.value?.minutes === n.initialValue?.minutes ? e : G7(n.initialValue);
    case 2: {
      const {
        inputValue: r
      } = e, {
        inputValue: o
      } = n;
      if (o === "")
        return {
          ...e,
          value: void 0,
          lastGoodValue: void 0,
          inputValue: "",
          selectionValue: ""
        };
      const {
        time: s,
        inputValue: u,
        selectionValue: h
      } = BSe(o), f = o.length === 1 && r.length !== 2 && !r.endsWith(":") || o.startsWith(r) && o.length === r.length + 1;
      return {
        ...e,
        value: s,
        lastGoodValue: s,
        inputValue: u,
        selectionValue: f ? h : ""
      };
    }
    case 3:
      return {
        ...e,
        skipOnChangeHandler: !1
      };
    default:
      throw new Error();
  }
};
function zSe({
  initialValue: e,
  onChange: n,
  invalid: r = !1,
  disabled: o = !1,
  required: s = !1
}) {
  const [u, h] = Ri(FSe, e, G7), {
    value: f,
    inputValue: p,
    selectionValue: v,
    skipOnChangeHandler: b
  } = u, y = Le(null);
  return Xe(() => {
    h({
      type: 1,
      initialValue: e
    });
  }, [e]), Xe(() => {
    if (b) {
      h({
        type: 3
      });
      return;
    }
    n && n(f);
  }, [n, b, f]), Xe(() => {
    y.current && (y.current.value = p, v && y?.current?.setRangeText(v, p.length, p.length, "select"));
  }, [p, v, n, b, f]), /* @__PURE__ */ M(ed, {
    onInput: (E) => {
      h({
        type: 2,
        inputValue: E.target.value
      });
    },
    onBlur: () => {
      y.current && (y.current.value = W7(f));
    },
    onKeyDown: (E) => {
      E.key === ":" && y.current?.value.includes(":") && (E.preventDefault(), E.stopPropagation());
    },
    ref: y,
    defaultValue: p,
    invalid: r,
    disabled: o,
    required: s
  });
}
function VSe(e, n, r, o) {
  return n && Xp(e, n) || r && Vl(e, r) ? !1 : o;
}
function q7({
  calendars: e,
  getBackProps: n,
  getForwardProps: r,
  getDateProps: o,
  minSelectableDate: s,
  maxSelectableDate: u,
  inRange: h
}) {
  const {
    formatDate: f,
    weekStartsOn: p,
    date: {
      day: v
    }
  } = s4();
  return e.length ? /* @__PURE__ */ M("div", {
    className: "flex gap-x-6",
    children: e.map((b, y) => {
      const k = new Date(b.year, b.month);
      return /* @__PURE__ */ K("div", {
        className: "w-screen -mx-4 sm:mx-0 sm:w-72",
        children: [/* @__PURE__ */ K("div", {
          className: "flex items-center text-center text-gray-900 relative",
          children: [y === 0 && /* @__PURE__ */ M("span", {
            className: "absolute left-0",
            children: /* @__PURE__ */ M(di, {
              appearance: "minimal",
              ...n({
                calendars: e
              }),
              children: /* @__PURE__ */ M(Bt.Previous, {})
            })
          }), /* @__PURE__ */ M("div", {
            className: "flex-auto font-semibold",
            children: f(k, "LLLL yyyy")
          }), y + 1 === e.length && /* @__PURE__ */ M("span", {
            className: "absolute right-0",
            children: /* @__PURE__ */ M(di, {
              appearance: "minimal",
              ...r({
                calendars: e
              }),
              children: /* @__PURE__ */ M(Bt.Next, {})
            })
          })]
        }), /* @__PURE__ */ M("div", {
          className: "mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500",
          children: [...Array(7).keys()].map((_) => {
            const E = (_ + p) % 7;
            return /* @__PURE__ */ M("div", {
              children: v(E)
            }, E);
          })
        }), /* @__PURE__ */ M("div", {
          className: "mt-2 grid grid-cols-7 text-sm",
          children: b.weeks.map((_, E) => _.map((x, D) => {
            const I = `${b.year}${b.month}${E}${D}`;
            if (!x)
              return /* @__PURE__ */ M("div", {
                className: "bg-transparent"
              }, I);
            const {
              date: N,
              selected: O,
              selectable: P,
              today: S
            } = x, $ = h && h(N) || O, L = VSe(N, s, u, P);
            return /* @__PURE__ */ M("div", {
              className: Ce("py-px"),
              children: /* @__PURE__ */ M("button", {
                type: "button",
                className: Ce(L ? "cursor-hand" : "cursor-not-allowed", {
                  "text-gray-600": !$ && !S && L
                }, {
                  "text-gray-400": !$ && !S && !L
                }, {
                  "hover:bg-gray-100": !$ && !S
                }, {
                  "font-bold hover:bg-red-100": !$ && S
                }, {
                  "text-blue-600": !$ && S && L
                }, {
                  "text-red-400": !$ && S && !L
                }, {
                  "font-bold text-white": $
                }, {
                  "bg-gray-900": $ && !S
                }, {
                  "bg-blue-500 hover:bg-blue-600": $ && S
                }, {
                  "focus:ring-red-300": S
                }, ($ || S) && "font-semibold", "mx-auto flex h-8 w-8", "items-center justify-center rounded-full"),
                ...o({
                  dateObj: x
                }),
                disabled: !L,
                children: /* @__PURE__ */ M("time", {
                  dateTime: `${N.getFullYear()}-${N.getMonth()}-${N.getDate()}`,
                  children: N.getDate()
                })
              })
            }, I);
          }))
        })]
      }, YD(k, {
        representation: "date"
      }));
    })
  }) : null;
}
function jo(e) {
  return QD(e, {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });
}
function HSe(e, n, r) {
  return n && Vl(jo(n), jo(e)) ? n : r && Xp(jo(r), jo(e)) ? r : e;
}
function USe({
  initialValue: e,
  onChange: n,
  minDate: r,
  maxDate: o,
  dateFormat: s,
  weekStartsOn: u = 1,
  invalid: h = !1,
  disabled: f = !1,
  required: p = !1,
  ...v
}) {
  if (r && o && Vl(r, o))
    throw Error("minDate is greater than maxDate");
  const b = et((Y) => N5(Y) ? _s(Y, s) : "", [s]), y = (Y) => w8(Y.replaceAll(/\s+/g, ""), s.replaceAll(/\s+/g, "")) ? KD(Y.replaceAll(/\s+/g, ""), s.replaceAll(/\s+/g, ""), new Date()) : new Date(NaN), [k, _] = Ve(e), [E, x] = Ve(e ? b(HSe(e, r, o)) : ""), D = Le(!0);
  Xe(() => {
    D.current || (_(e), x(e ? b(e) : ""));
  }, [e, b]), Xe(() => {
    D.current || x(k ? b(k) : "");
  }, [s, k, b]), Xe(() => {
    D.current = !1;
  }, []);
  const I = Le(null), N = e4({
    selected: k,
    minDate: r ? jo(r) : void 0,
    maxDate: o,
    onDateSelected: (Y) => {
      _(Y.date), x(b(Y.date)), n && n(jo(Y.date)), I.current?.focus({
        preventScroll: !0
      });
    },
    firstDayOfWeek: u,
    showOutsideDays: !0
  }), O = (Y) => {
    x(Y.target.value);
    const Q = y(Y.target.value);
    let Z = N5(Q) ? jo(Q) : void 0;
    Z && r && Vl(jo(r), Z) && (Z = void 0), Z && o && Xp(jo(o), Z) && (Z = void 0), _(Q), n && n(Z);
  }, P = () => {
    k && b(k) !== E && x(b(k));
  }, [S, $] = ak(), L = !!(h && $ > 190), B = Le(null), [U, G] = Ve("left"), q = () => {
    const Y = B.current?.getBoundingClientRect();
    Y && (Y.right > (window.innerWidth || document.documentElement.clientWidth) ? G("right") : Y.left < 0 && G("left"));
  };
  return /* @__PURE__ */ M(Ms, {
    className: "relative",
    children: ({
      open: Y
    }) => /* @__PURE__ */ K(bo, {
      children: [/* @__PURE__ */ M("div", {
        className: "relative shadow-sm",
        ref: S,
        children: /* @__PURE__ */ M("div", {
          className: "relative",
          children: /* @__PURE__ */ M(Ms.Button, {
            ...v,
            as: ed,
            className: Md({
              invalid: h,
              disabled: f,
              required: p
            }, {
              "pr-10": L
            }),
            onChange: O,
            disabled: f,
            required: p,
            invalid: h,
            onFocus: (Q) => Q.target.select(),
            onBlur: P,
            ref: I,
            value: E,
            autoComplete: "off"
          })
        })
      }), /* @__PURE__ */ M(Ms.Panel, {
        ref: B,
        className: Ce("absolute z-10 mt-1 pb-1", {
          "left-0": U === "left"
        }, {
          "right-0": U === "right"
        }),
        children: /* @__PURE__ */ M(rr, {
          as: ft,
          show: Y,
          enter: "ease-in-out duration-50",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          beforeEnter: q,
          children: /* @__PURE__ */ M("div", {
            className: "z-20 bg-white shadow-lg p-2 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
            children: /* @__PURE__ */ M(q7, {
              ...N
            })
          })
        })
      })]
    })
  });
}
function WSe({
  ...e
}) {
  const {
    dateFormat: n,
    weekStartsOn: r
  } = s4();
  return /* @__PURE__ */ M(USe, {
    ...e,
    dateFormat: n,
    weekStartsOn: r
  });
}
function MD(e) {
  return e ? {
    hours: y8(e),
    minutes: k8(e)
  } : void 0;
}
function HDe({
  label: e,
  initialValue: n,
  onChange: r,
  required: o,
  disabled: s,
  invalid: u,
  minDate: h,
  maxDate: f,
  withTime: p = !1
}) {
  const [v, b] = Ve(() => MD(n)), [y, k] = Ve(v), [_, E] = Ve(n), x = Le(!0);
  Xe(() => {
    x.current || r && r(p ? _ && y ? QD(_, {
      seconds: 0,
      ...y
    }) : void 0 : _ || void 0);
  }, [y, _, r, p]), Xe(() => {
    x.current || b(MD(n));
  }, [n]), Xe(() => {
    x.current && (x.current = !1);
  }, []);
  const D = Et();
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M(qs, {
      htmlFor: D,
      children: e
    }), /* @__PURE__ */ K("div", {
      className: "grid grid-cols-3 gap-4 mt-1",
      children: [/* @__PURE__ */ M("div", {
        className: Ce(p ? "col-span-2" : "col-span-3"),
        children: /* @__PURE__ */ M(WSe, {
          id: D,
          onChange: E,
          initialValue: n,
          required: o,
          disabled: s,
          invalid: u,
          minDate: h,
          maxDate: f
        })
      }), p && /* @__PURE__ */ M("div", {
        children: /* @__PURE__ */ M(zSe, {
          onChange: k,
          required: o,
          disabled: s,
          initialValue: v,
          invalid: u
        })
      })]
    })]
  });
}
const GSe = oe.forwardRef(({
  children: e,
  header: n,
  footer: r,
  sidebar: o
}, s) => /* @__PURE__ */ M("div", {
  className: "bg-white max-w-full max-h-full overflow-auto shadow ring-1 ring-black ring-opacity-5",
  ref: s,
  children: /* @__PURE__ */ K("div", {
    className: "flex flex-col-reverse md:flex-row-reverse",
    children: [/* @__PURE__ */ K("div", {
      className: "flex flex-col",
      children: [n && /* @__PURE__ */ M("div", {
        className: "px-4 py-5 sm:px-6 border-b border-gray-200",
        children: n
      }), /* @__PURE__ */ M("div", {
        className: "flex-grow px-4 py-5 sm:p-6",
        children: e
      }), r && /* @__PURE__ */ M("div", {
        className: "bg-gray-50 px-4 py-4 sm:px-6 flex sm:flex-row-reverse gap-x-3",
        children: r
      })]
    }), o && /* @__PURE__ */ M("div", {
      className: "bg-gray-100 p-3",
      children: o
    })]
  })
}));
function qSe({
  href: e = "#",
  onClick: n,
  current: r,
  icon: o,
  badge: s,
  children: u
}) {
  return /* @__PURE__ */ K("a", {
    href: e,
    onClick: n,
    className: Ce(r ? "bg-gray-200 text-gray-900" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900", "flex items-center px-3 py-2 text-sm font-medium"),
    "aria-current": r ? "page" : void 0,
    children: [o && /* @__PURE__ */ M("span", {
      className: Ce(r ? "text-gray-500" : "text-gray-400", "flex-shrink-0 -ml-1 mr-3"),
      children: o
    }), /* @__PURE__ */ M("span", {
      className: "truncate",
      children: u
    }), s && /* @__PURE__ */ M("span", {
      className: Ce(r ? "bg-gray-50" : "bg-gray-200 text-gray-600", "ml-auto inline-block py-0.5 px-3 text-xs rounded-full"),
      children: s
    })]
  });
}
function KSe({
  children: e,
  items: n,
  srLabel: r
}) {
  return /* @__PURE__ */ M("nav", {
    className: "space-y-1",
    "aria-label": r,
    children: e || n
  });
}
const a1 = Object.assign(KSe, {
  Item: qSe
}), TD = zs(({
  onBeforeClick: e,
  onClick: n,
  ...r
}, o) => /* @__PURE__ */ M(di, {
  ...r,
  onClick: (u) => {
    e && e() === !1 || n && n(u);
  },
  ref: o
}));
function YSe(e) {
  return Re(() => e === void 0 ? void 0 : e.map((n) => ({
    key: JEe(),
    value: n
  })), [e]);
}
const DD = () => {
  if (typeof window > "u")
    return "2xl";
  switch (!0) {
    case window.innerWidth < 640:
      return "xs";
    case window.innerWidth < 768:
      return "sm";
    case window.innerWidth < 1024:
      return "md";
    case window.innerWidth < 1280:
      return "lg";
    case window.innerWidth < 1536:
      return "xl";
    default:
      return "2xl";
  }
};
function QSe() {
  const [e, n] = Ve(DD());
  return Xe(() => {
    const r = () => {
      n(DD());
    };
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }, []), e;
}
const ZSe = ({
  initialValue: e,
  dateFormat: n
}) => ({
  start: e?.start,
  end: e?.end,
  selectingEnd: !1,
  dateFormat: n,
  displayedValue: e,
  offset: 0
}), XSe = (e, n) => {
  switch (n.type) {
    case 2:
      return {
        ...e,
        selectingEnd: n.which === "end"
      };
    case 1: {
      const {
        value: r
      } = n;
      return {
        ...e,
        start: r?.start,
        end: r?.end,
        displayedValue: r
      };
    }
    case 0: {
      const {
        selectingEnd: r,
        start: o,
        end: s
      } = e, {
        value: u
      } = n;
      let h = s;
      return r ? h = u : (!s || Vl(u, s)) && (h = void 0), {
        ...e,
        start: r ? o : u,
        end: h,
        selectingEnd: !r
      };
    }
    case 3:
      return {
        ...e,
        offset: n.offset
      };
    case 4:
      return {
        ...e,
        offset: 0,
        selectingEnd: !1,
        start: e.displayedValue?.start,
        end: e.displayedValue?.end
      };
    default:
      throw new Error("unknown action");
  }
};
function UDe({
  label: e,
  initialValue: n,
  minDate: r,
  maxDate: o,
  onChange: s,
  presets: u,
  dateFormat: h,
  notSelectedPlaceholder: f = "Not selected",
  applyButtonLabel: p = "Apply",
  clearButtonLabel: v = "Clear"
}) {
  const [{
    start: b,
    end: y,
    selectingEnd: k,
    displayedValue: _,
    offset: E
  }, x] = Ri(XSe, {
    initialValue: n,
    dateFormat: h
  }, ZSe), D = QSe(), I = (B) => {
    B === void 0 && _ === void 0 || B && _ && $5(B.start, _.start) && $5(B.end, _.end) || (x({
      type: 1,
      value: B
    }), s && s(B));
  }, N = e4({
    monthsToDisplay: D === "xs" ? 1 : D === "sm" || D === "md" ? 2 : 3,
    selected: [b, y].filter(Boolean),
    onDateSelected: (B) => {
      x({
        type: 0,
        value: B.date
      });
    },
    minDate: r,
    maxDate: o,
    date: n?.start || new Date(),
    onOffsetChanged(B) {
      x({
        type: 3,
        offset: B
      });
    },
    offset: E
  }), O = YSe(u), P = () => {
    I(void 0);
  }, S = (B) => {
    const U = typeof B.start == "function" ? B.start() : B.start, G = typeof B.end == "function" ? B.end() : B.end;
    I({
      start: U,
      end: G
    });
  }, $ = () => {
    b && y && I({
      start: b,
      end: y
    });
  }, L = (B) => {
    x({
      type: 2,
      which: B
    });
  };
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M(qs, {
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "mt-1",
      children: /* @__PURE__ */ M(Ms, {
        children: ({
          open: B,
          close: U
        }) => (Xe(() => {
          B || x({
            type: 4
          });
        }, [B]), /* @__PURE__ */ K(bo, {
          children: [/* @__PURE__ */ M(ry, {
            className: "block w-full",
            children: /* @__PURE__ */ M(di, {
              iconBefore: /* @__PURE__ */ M(Bt.Calendar, {}),
              iconAfter: /* @__PURE__ */ M(Bt.Caret, {}),
              appearance: "outlined",
              narrow: !0,
              fill: !0,
              children: _ ? [_s(_.start, h), /* @__PURE__ */ M(Bt.LongRightArrow, {
                className: "text-gray-500 mx-1 inline-block"
              }, "icon"), _s(_.end, h)] : f
            })
          }), /* @__PURE__ */ M(iy, {
            transition: !0,
            anchor: "bottom start",
            className: "z-20 pb-1 transition duration-200 ease-in-out [--anchor-gap:4px] data-[closed]:-translate-y-1 data-[closed]:opacity-0",
            children: /* @__PURE__ */ M(GSe, {
              header: /* @__PURE__ */ K("div", {
                className: "flex items-center flex-grow",
                children: [/* @__PURE__ */ M(ed, {
                  value: b ? _s(b, h) : "",
                  selected: !k,
                  onFocus: () => L("start"),
                  readOnly: !0
                }), /* @__PURE__ */ M(Bt.LongRightArrow, {
                  className: "text-gray-500 mx-2"
                }), /* @__PURE__ */ M(ed, {
                  value: y ? _s(y, h) : "",
                  selected: k,
                  onFocus: () => L("end"),
                  readOnly: !0
                })]
              }),
              footer: /* @__PURE__ */ K("div", {
                className: "-my-2 flex sm:flex-row-reverse gap-x-3",
                children: [/* @__PURE__ */ M(Ms.Button, {
                  as: TD,
                  intent: "primary",
                  appearance: "minimal",
                  onBeforeClick: $,
                  disabled: !b || !y,
                  children: p
                }), /* @__PURE__ */ M(Ms.Button, {
                  as: TD,
                  appearance: "minimal",
                  onBeforeClick: P,
                  children: v
                })]
              }),
              sidebar: O && /* @__PURE__ */ M(a1, {
                srLabel: "Presets",
                items: O.map((G) => /* @__PURE__ */ M(a1.Item, {
                  onClick: (q) => {
                    q.preventDefault(), S(G.value), U();
                  },
                  children: G.value.label
                }, G.key))
              }),
              children: /* @__PURE__ */ M(O8, {
                locale: "sk",
                children: /* @__PURE__ */ M("div", {
                  className: "sm:flex sm:gap-x-4",
                  children: /* @__PURE__ */ M(
                    q7,
                    {
                      ...N,
                      inRange: (G) => b && y ? G >= b && G <= y : !1,
                      minSelectableDate: k ? b : void 0
                    }
                  )
                })
              })
            })
          })]
        }))
      })
    })]
  });
}
function WDe({
  children: e
}) {
  return /* @__PURE__ */ M("div", {
    className: "flex flex-col gap-4",
    children: e
  });
}
function uk({
  indeterminate: e,
  ...n
}) {
  const r = oe.useRef(null);
  return oe.useEffect(() => {
    typeof e == "boolean" && (r.current.indeterminate = !n.checked && e);
  }, [r, e, n.checked]), /* @__PURE__ */ M("input", {
    type: "checkbox",
    ref: r,
    className: "absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 sm:left-6 cursor-pointer",
    ...n
  });
}
uk.displayName = "Checkbox";
function GDe({
  label: e,
  items: n,
  onChange: r,
  valueAccessor: o = "value",
  labelAccessor: s = "label",
  value: u,
  disabled: h = !1,
  ...f
}) {
  const {
    rounded: p
  } = Li(f);
  return /* @__PURE__ */ K(kY, {
    value: u,
    onChange: (b) => {
      r && r(b);
    },
    disabled: h,
    children: [/* @__PURE__ */ M(qs, {
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "bg-white rounded-md -space-x-px flex flex-row w-full shadow-sm mt-1",
      children: n && n.map((b) => /* @__PURE__ */ M(CI, {
        value: qo(b, o),
        className: ({
          checked: y,
          focus: k
        }) => Ce(k ? "ring-blue-500" : "", y ? "border-blue-300" : "border-gray-300", "group relative border px-3 py-2 flex cursor-pointer focus:outline-none", "flex-1 flex-shrink justify-center", {
          "cursor-not-allowed opacity-70": h
        }, {
          "bg-blue-50": !h && y
        }, {
          "bg-gray-100": h && !y
        }, {
          "bg-blue-100": h && y
        }, {
          "first:rounded-l last:rounded-r": p
        }),
        children: /* @__PURE__ */ M(od, {
          className: Ce("group-data-[checked]:text-blue-900 text-gray-900", "block text-sm font-medium"),
          children: ri(b, s)
        })
      }, qo(b, o)))
    })]
  });
}
function JSe({
  children: e,
  ...n
}) {
  return /* @__PURE__ */ M("option", {
    ...n,
    children: e
  });
}
function eMe(e, n) {
  const [r, o] = oe.useState();
  return ct(() => {
    o(e.current?.getBoundingClientRect().width);
  }), ZD(e, (s) => {
    o(s.contentRect.width);
  }), r != null && r < n;
}
const tMe = oe.forwardRef(({
  children: e = null,
  invalid: n = !1,
  disabled: r = !1,
  required: o = !1,
  ...s
}, u) => {
  const {
    rounded: h
  } = Li(s), f = Le(null), p = eMe(f, 250), v = vt(u, f);
  return /* @__PURE__ */ K("div", {
    className: "relative rounded-md shadow-sm",
    children: [/* @__PURE__ */ M("select", {
      className: Ce(Md({
        invalid: n,
        disabled: r,
        required: o
      }), {
        rounded: h
      }, {
        "pr-14": !!n && !p
      }),
      disabled: r,
      ref: v,
      ...s,
      children: e
    }), n && !p && /* @__PURE__ */ M("div", {
      className: "absolute inset-y-0 right-6 pr-3 flex items-center pointer-events-none",
      children: /* @__PURE__ */ M(Bt.Warning, {
        className: "h-5 w-5 text-red-500",
        "aria-hidden": "true"
      })
    })]
  });
}), ID = Object.assign(tMe, {
  Option: JSe
}), qDe = oe.forwardRef(({
  label: e,
  name: n,
  data: r,
  labelAccessor: o = "label",
  valueAccessor: s = "value",
  ...u
}, h) => {
  const f = Et();
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M(qs, {
      htmlFor: f,
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "mt-1",
      children: /* @__PURE__ */ M(ID, {
        ...u,
        ref: h,
        id: f,
        name: n,
        children: r.map((p) => /* @__PURE__ */ M(ID.Option, {
          value: qo(p, s),
          children: ri(p, o)
        }, qo(p, s)))
      })
    })]
  });
}), nMe = zs(({
  invalid: e = !1,
  disabled: n = !1,
  required: r = !1,
  id: o,
  ...s
}, u) => {
  const {
    rounded: h
  } = Li(s), f = U7(o);
  return /* @__PURE__ */ K("div", {
    className: `relative ${h && "rounded-md"} shadow-sm`,
    children: [/* @__PURE__ */ M(T8, {
      ...s,
      ref: u,
      id: f,
      className: Md({
        invalid: e,
        disabled: n,
        required: r
      }, {
        "pr-10": e,
        rounded: h
      }),
      disabled: n,
      minRows: 3
    }), e && /* @__PURE__ */ M("div", {
      className: "absolute inset-y-0 right-0 pr-3 flex items-start pt-2 pointer-events-none",
      children: /* @__PURE__ */ M(Bt.ExclamationCircle, {
        className: "h-5 w-5 text-red-500",
        "aria-hidden": "true"
      })
    })]
  });
});
function KDe({
  label: e,
  name: n,
  onChange: r,
  ...o
}) {
  const s = Et();
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M(qs, {
      htmlFor: s,
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "mt-1",
      children: /* @__PURE__ */ M(nMe, {
        id: s,
        onChange: (h) => {
          r && r(h.target.value || void 0);
        },
        ...o
      })
    })]
  });
}
const YDe = oe.forwardRef(({
  label: e,
  name: n,
  onChange: r,
  onInputChange: o,
  error: s,
  invalid: u,
  ...h
}, f) => {
  const p = Et();
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M(qs, {
      htmlFor: p,
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "mt-1",
      children: /* @__PURE__ */ M(ed, {
        ...h,
        id: p,
        onChange: o ? (b) => {
          o && o(b.target.value || void 0);
        } : r,
        ref: f,
        name: n,
        invalid: !!s || u
      })
    }), s && /* @__PURE__ */ M("p", {
      className: "mt-2 text-sm text-red-600",
      children: s
    })]
  });
});
function QDe({
  value: e = !1,
  onChange: n,
  label: r,
  disabled: o = !1
}) {
  return /* @__PURE__ */ M(wI, {
    children: /* @__PURE__ */ K(EE.Group, {
      as: "div",
      className: "flex items-center",
      children: [/* @__PURE__ */ M(EE, {
        checked: e,
        onChange: n,
        disabled: o,
        className: Ce(
          {
            "bg-blue-800": e
          },
          {
            "bg-gray-300": !e
          },
          {
            "cursor-pointer": !o
          },
          {
            "bg-opacity-60 cursor-not-allowed opacity-60": o
          },
          "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-800"
        ),
        children: /* @__PURE__ */ M("span", {
          "aria-hidden": "true",
          className: Ce(
            e ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
          )
        })
      }), /* @__PURE__ */ M(od, {
        as: "span",
        className: "ml-3",
        children: /* @__PURE__ */ M("span", {
          className: Ce(
            "text-sm font-medium text-gray-700",
            {
              "opacity-60": o
            }
          ),
          children: r
        })
      })]
    })
  });
}
function hb({
  children: e,
  width: n = "100%"
}) {
  return /* @__PURE__ */ M("span", {
    className: Ce("animate-pulse", {
      "inline-block bg-gray-200 rounded": !e
    }),
    style: e ? {} : {
      width: n,
      height: "0.95em"
    },
    children: e
  });
}
function kc(e, n, r, o) {
  function s(u) {
    return u instanceof r ? u : new r(function(h) {
      h(u);
    });
  }
  return new (r || (r = Promise))(function(u, h) {
    function f(b) {
      try {
        v(o.next(b));
      } catch (y) {
        h(y);
      }
    }
    function p(b) {
      try {
        v(o.throw(b));
      } catch (y) {
        h(y);
      }
    }
    function v(b) {
      b.done ? u(b.value) : s(b.value).then(f, p);
    }
    v((o = o.apply(e, n || [])).next());
  });
}
function _c(e, n) {
  var r = { label: 0, sent: function() {
    if (u[0] & 1)
      throw u[1];
    return u[1];
  }, trys: [], ops: [] }, o, s, u, h;
  return h = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
    return this;
  }), h;
  function f(v) {
    return function(b) {
      return p([v, b]);
    };
  }
  function p(v) {
    if (o)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (o = 1, s && (u = v[0] & 2 ? s.return : v[0] ? s.throw || ((u = s.return) && u.call(s), 0) : s.next) && !(u = u.call(s, v[1])).done)
          return u;
        switch (s = 0, u && (v = [v[0] & 2, u.value]), v[0]) {
          case 0:
          case 1:
            u = v;
            break;
          case 4:
            return r.label++, { value: v[1], done: !1 };
          case 5:
            r.label++, s = v[1], v = [0];
            continue;
          case 7:
            v = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (u = r.trys, !(u = u.length > 0 && u[u.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              r = 0;
              continue;
            }
            if (v[0] === 3 && (!u || v[1] > u[0] && v[1] < u[3])) {
              r.label = v[1];
              break;
            }
            if (v[0] === 6 && r.label < u[1]) {
              r.label = u[1], u = v;
              break;
            }
            if (u && r.label < u[2]) {
              r.label = u[2], r.ops.push(v);
              break;
            }
            u[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        v = n.call(e, r);
      } catch (b) {
        v = [6, b], s = 0;
      } finally {
        o = u = 0;
      }
    if (v[0] & 5)
      throw v[1];
    return { value: v[0] ? v[1] : void 0, done: !0 };
  }
}
function PD(e, n) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var o = r.call(e), s, u = [], h;
  try {
    for (; (n === void 0 || n-- > 0) && !(s = o.next()).done; )
      u.push(s.value);
  } catch (f) {
    h = { error: f };
  } finally {
    try {
      s && !s.done && (r = o.return) && r.call(o);
    } finally {
      if (h)
        throw h.error;
    }
  }
  return u;
}
function OD(e, n, r) {
  if (r || arguments.length === 2)
    for (var o = 0, s = n.length, u; o < s; o++)
      (u || !(o in n)) && (u || (u = Array.prototype.slice.call(n, 0, o)), u[o] = n[o]);
  return e.concat(u || Array.prototype.slice.call(n));
}
var rMe = /* @__PURE__ */ new Map([
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Td(e, n) {
  var r = iMe(e);
  if (typeof r.path != "string") {
    var o = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof n == "string" ? n : typeof o == "string" && o.length > 0 ? o : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function iMe(e) {
  var n = e.name, r = n && n.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var o = n.split(".").pop().toLowerCase(), s = rMe.get(o);
    s && Object.defineProperty(e, "type", {
      value: s,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var oMe = [
  ".DS_Store",
  "Thumbs.db"
];
function aMe(e) {
  return kc(this, void 0, void 0, function() {
    return _c(this, function(n) {
      return qp(e) && sMe(e.dataTransfer) ? [2, dMe(e.dataTransfer, e.type)] : lMe(e) ? [2, cMe(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, uMe(e)] : [2, []];
    });
  });
}
function sMe(e) {
  return qp(e);
}
function lMe(e) {
  return qp(e) && qp(e.target);
}
function qp(e) {
  return typeof e == "object" && e !== null;
}
function cMe(e) {
  return s1(e.target.files).map(function(n) {
    return Td(n);
  });
}
function uMe(e) {
  return kc(this, void 0, void 0, function() {
    var n;
    return _c(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(o) {
            return o.getFile();
          }))];
        case 1:
          return n = r.sent(), [2, n.map(function(o) {
            return Td(o);
          })];
      }
    });
  });
}
function dMe(e, n) {
  return kc(this, void 0, void 0, function() {
    var r, o;
    return _c(this, function(s) {
      switch (s.label) {
        case 0:
          return e.items ? (r = s1(e.items).filter(function(u) {
            return u.kind === "file";
          }), n !== "drop" ? [2, r] : [4, Promise.all(r.map(hMe))]) : [3, 2];
        case 1:
          return o = s.sent(), [2, RD(K7(o))];
        case 2:
          return [2, RD(s1(e.files).map(function(u) {
            return Td(u);
          }))];
      }
    });
  });
}
function RD(e) {
  return e.filter(function(n) {
    return oMe.indexOf(n.name) === -1;
  });
}
function s1(e) {
  if (e === null)
    return [];
  for (var n = [], r = 0; r < e.length; r++) {
    var o = e[r];
    n.push(o);
  }
  return n;
}
function hMe(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return ND(e);
  var n = e.webkitGetAsEntry();
  return n && n.isDirectory ? Y7(n) : ND(e);
}
function K7(e) {
  return e.reduce(function(n, r) {
    return OD(OD([], PD(n), !1), PD(Array.isArray(r) ? K7(r) : [r]), !1);
  }, []);
}
function ND(e) {
  var n = e.getAsFile();
  if (!n)
    return Promise.reject("".concat(e, " is not a File"));
  var r = Td(n);
  return Promise.resolve(r);
}
function fMe(e) {
  return kc(this, void 0, void 0, function() {
    return _c(this, function(n) {
      return [2, e.isDirectory ? Y7(e) : pMe(e)];
    });
  });
}
function Y7(e) {
  var n = e.createReader();
  return new Promise(function(r, o) {
    var s = [];
    function u() {
      var h = this;
      n.readEntries(function(f) {
        return kc(h, void 0, void 0, function() {
          var p, v, b;
          return _c(this, function(y) {
            switch (y.label) {
              case 0:
                if (f.length)
                  return [3, 5];
                y.label = 1;
              case 1:
                return y.trys.push([1, 3, , 4]), [4, Promise.all(s)];
              case 2:
                return p = y.sent(), r(p), [3, 4];
              case 3:
                return v = y.sent(), o(v), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                b = Promise.all(f.map(fMe)), s.push(b), u(), y.label = 6;
              case 6:
                return [2];
            }
          });
        });
      }, function(f) {
        o(f);
      });
    }
    u();
  });
}
function pMe(e) {
  return kc(this, void 0, void 0, function() {
    return _c(this, function(n) {
      return [2, new Promise(function(r, o) {
        e.file(function(s) {
          var u = Td(s, e.fullPath);
          r(u);
        }, function(s) {
          o(s);
        });
      })];
    });
  });
}
var gMe = function(e, n) {
  if (e && n) {
    var r = Array.isArray(n) ? n : n.split(","), o = e.name || "", s = (e.type || "").toLowerCase(), u = s.replace(/\/.*$/, "");
    return r.some(function(h) {
      var f = h.trim().toLowerCase();
      return f.charAt(0) === "." ? o.toLowerCase().endsWith(f) : f.endsWith("/*") ? u === f.replace(/\/.*$/, "") : s === f;
    });
  }
  return !0;
};
function $D(e) {
  return bMe(e) || vMe(e) || Z7(e) || mMe();
}
function mMe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vMe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function bMe(e) {
  if (Array.isArray(e))
    return l1(e);
}
function LD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function jD(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? LD(Object(r), !0).forEach(function(o) {
      Q7(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : LD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function Q7(e, n, r) {
  return n in e ? Object.defineProperty(e, n, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = r, e;
}
function td(e, n) {
  return kMe(e) || yMe(e, n) || Z7(e, n) || wMe();
}
function wMe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z7(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return l1(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return l1(e, n);
  }
}
function l1(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function yMe(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var o = [], s = !0, u = !1, h, f;
    try {
      for (r = r.call(e); !(s = (h = r.next()).done) && (o.push(h.value), !(n && o.length === n)); s = !0)
        ;
    } catch (p) {
      u = !0, f = p;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (u)
          throw f;
      }
    }
    return o;
  }
}
function kMe(e) {
  if (Array.isArray(e))
    return e;
}
var _Me = "file-invalid-type", AMe = "file-too-large", CMe = "file-too-small", xMe = "too-many-files", EMe = function(n) {
  n = Array.isArray(n) && n.length === 1 ? n[0] : n;
  var r = Array.isArray(n) ? "one of ".concat(n.join(", ")) : n;
  return {
    code: _Me,
    message: "File type must be ".concat(r)
  };
}, BD = function(n) {
  return {
    code: AMe,
    message: "File is larger than ".concat(n, " ").concat(n === 1 ? "byte" : "bytes")
  };
}, FD = function(n) {
  return {
    code: CMe,
    message: "File is smaller than ".concat(n, " ").concat(n === 1 ? "byte" : "bytes")
  };
}, SMe = {
  code: xMe,
  message: "Too many files"
};
function X7(e, n) {
  var r = e.type === "application/x-moz-file" || gMe(e, n);
  return [r, r ? null : EMe(n)];
}
function J7(e, n, r) {
  if (ks(e.size))
    if (ks(n) && ks(r)) {
      if (e.size > r)
        return [!1, BD(r)];
      if (e.size < n)
        return [!1, FD(n)];
    } else {
      if (ks(n) && e.size < n)
        return [!1, FD(n)];
      if (ks(r) && e.size > r)
        return [!1, BD(r)];
    }
  return [!0, null];
}
function ks(e) {
  return e != null;
}
function MMe(e) {
  var n = e.files, r = e.accept, o = e.minSize, s = e.maxSize, u = e.multiple, h = e.maxFiles, f = e.validator;
  return !u && n.length > 1 || u && h >= 1 && n.length > h ? !1 : n.every(function(p) {
    var v = X7(p, r), b = td(v, 1), y = b[0], k = J7(p, o, s), _ = td(k, 1), E = _[0], x = f ? f(p) : null;
    return y && E && !x;
  });
}
function Kp(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function sf(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(n) {
    return n === "Files" || n === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function zD(e) {
  e.preventDefault();
}
function TMe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function DMe(e) {
  return e.indexOf("Edge/") !== -1;
}
function IMe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return TMe(e) || DMe(e);
}
function so() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return function(o) {
    for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), h = 1; h < s; h++)
      u[h - 1] = arguments[h];
    return n.some(function(f) {
      return !Kp(o) && f && f.apply(void 0, [o].concat(u)), Kp(o);
    });
  };
}
function PMe() {
  return "showOpenFilePicker" in window;
}
function OMe(e) {
  if (ks(e)) {
    var n = Object.entries(e).filter(function(r) {
      var o = td(r, 2), s = o[0], u = o[1], h = !0;
      return eO(s) || (console.warn('Skipped "'.concat(s, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), h = !1), (!Array.isArray(u) || !u.every(tO)) && (console.warn('Skipped "'.concat(s, '" because an invalid file extension was provided.')), h = !1), h;
    }).reduce(function(r, o) {
      var s = td(o, 2), u = s[0], h = s[1];
      return jD(jD({}, r), {}, Q7({}, u, h));
    }, {});
    return [{
      description: "Files",
      accept: n
    }];
  }
  return e;
}
function RMe(e) {
  if (ks(e))
    return Object.entries(e).reduce(function(n, r) {
      var o = td(r, 2), s = o[0], u = o[1];
      return [].concat($D(n), [s], $D(u));
    }, []).filter(function(n) {
      return eO(n) || tO(n);
    }).join(",");
}
function NMe(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function $Me(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function eO(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function tO(e) {
  return /^.*\.[\w]+$/.test(e);
}
var LMe = ["children"], jMe = ["open"], BMe = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], FMe = ["refKey", "onChange", "onClick"];
function zMe(e) {
  return UMe(e) || HMe(e) || nO(e) || VMe();
}
function VMe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HMe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function UMe(e) {
  if (Array.isArray(e))
    return c1(e);
}
function fb(e, n) {
  return qMe(e) || GMe(e, n) || nO(e, n) || WMe();
}
function WMe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nO(e, n) {
  if (!!e) {
    if (typeof e == "string")
      return c1(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return c1(e, n);
  }
}
function c1(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, o = new Array(n); r < n; r++)
    o[r] = e[r];
  return o;
}
function GMe(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var o = [], s = !0, u = !1, h, f;
    try {
      for (r = r.call(e); !(s = (h = r.next()).done) && (o.push(h.value), !(n && o.length === n)); s = !0)
        ;
    } catch (p) {
      u = !0, f = p;
    } finally {
      try {
        !s && r.return != null && r.return();
      } finally {
        if (u)
          throw f;
      }
    }
    return o;
  }
}
function qMe(e) {
  if (Array.isArray(e))
    return e;
}
function VD(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function En(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = arguments[n] != null ? arguments[n] : {};
    n % 2 ? VD(Object(r), !0).forEach(function(o) {
      u1(e, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : VD(Object(r)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return e;
}
function u1(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function Yp(e, n) {
  if (e == null)
    return {};
  var r = KMe(e, n), o, s;
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (s = 0; s < u.length; s++)
      o = u[s], !(n.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, o) || (r[o] = e[o]));
  }
  return r;
}
function KMe(e, n) {
  if (e == null)
    return {};
  var r = {}, o = Object.keys(e), s, u;
  for (u = 0; u < o.length; u++)
    s = o[u], !(n.indexOf(s) >= 0) && (r[s] = e[s]);
  return r;
}
var dk = /* @__PURE__ */ zs(function(e, n) {
  var r = e.children, o = Yp(e, LMe), s = iO(o), u = s.open, h = Yp(s, jMe);
  return f8(n, function() {
    return {
      open: u
    };
  }, [u]), /* @__PURE__ */ M(ft, {
    children: r(En(En({}, h), {}, {
      open: u
    }))
  });
});
dk.displayName = "Dropzone";
var rO = {
  disabled: !1,
  getFilesFromEvent: aMe,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
dk.defaultProps = rO;
dk.propTypes = {
  children: Fe.exports.func,
  accept: Fe.exports.objectOf(Fe.exports.arrayOf(Fe.exports.string)),
  multiple: Fe.exports.bool,
  preventDropOnDocument: Fe.exports.bool,
  noClick: Fe.exports.bool,
  noKeyboard: Fe.exports.bool,
  noDrag: Fe.exports.bool,
  noDragEventsBubbling: Fe.exports.bool,
  minSize: Fe.exports.number,
  maxSize: Fe.exports.number,
  maxFiles: Fe.exports.number,
  disabled: Fe.exports.bool,
  getFilesFromEvent: Fe.exports.func,
  onFileDialogCancel: Fe.exports.func,
  onFileDialogOpen: Fe.exports.func,
  useFsAccessApi: Fe.exports.bool,
  autoFocus: Fe.exports.bool,
  onDragEnter: Fe.exports.func,
  onDragLeave: Fe.exports.func,
  onDragOver: Fe.exports.func,
  onDrop: Fe.exports.func,
  onDropAccepted: Fe.exports.func,
  onDropRejected: Fe.exports.func,
  onError: Fe.exports.func,
  validator: Fe.exports.func
};
var d1 = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function iO() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = En(En({}, rO), e), r = n.accept, o = n.disabled, s = n.getFilesFromEvent, u = n.maxSize, h = n.minSize, f = n.multiple, p = n.maxFiles, v = n.onDragEnter, b = n.onDragLeave, y = n.onDragOver, k = n.onDrop, _ = n.onDropAccepted, E = n.onDropRejected, x = n.onFileDialogCancel, D = n.onFileDialogOpen, I = n.useFsAccessApi, N = n.autoFocus, O = n.preventDropOnDocument, P = n.noClick, S = n.noKeyboard, $ = n.noDrag, L = n.noDragEventsBubbling, B = n.onError, U = n.validator, G = Re(function() {
    return RMe(r);
  }, [r]), q = Re(function() {
    return OMe(r);
  }, [r]), Y = Re(function() {
    return typeof D == "function" ? D : HD;
  }, [D]), Q = Re(function() {
    return typeof x == "function" ? x : HD;
  }, [x]), Z = Le(null), ae = Le(null), ie = Ri(YMe, d1), pe = fb(ie, 2), ce = pe[0], ue = pe[1], X = ce.isFocused, se = ce.isFileDialogActive, he = Le(typeof window < "u" && window.isSecureContext && I && PMe()), de = function() {
    !he.current && se && setTimeout(function() {
      if (ae.current) {
        var Ke = ae.current.files;
        Ke.length || (ue({
          type: "closeDialog"
        }), Q());
      }
    }, 300);
  };
  Xe(function() {
    return window.addEventListener("focus", de, !1), function() {
      window.removeEventListener("focus", de, !1);
    };
  }, [ae, se, Q, he]);
  var me = Le([]), we = function(Ke) {
    Z.current && Z.current.contains(Ke.target) || (Ke.preventDefault(), me.current = []);
  };
  Xe(function() {
    return O && (document.addEventListener("dragover", zD, !1), document.addEventListener("drop", we, !1)), function() {
      O && (document.removeEventListener("dragover", zD), document.removeEventListener("drop", we));
    };
  }, [Z, O]), Xe(function() {
    return !o && N && Z.current && Z.current.focus(), function() {
    };
  }, [Z, N, o]);
  var Ae = et(function(Pe) {
    B ? B(Pe) : console.error(Pe);
  }, [B]), Se = et(function(Pe) {
    Pe.preventDefault(), Pe.persist(), Ft(Pe), me.current = [].concat(zMe(me.current), [Pe.target]), sf(Pe) && Promise.resolve(s(Pe)).then(function(Ke) {
      if (!(Kp(Pe) && !L)) {
        var zt = Ke.length, nn = zt > 0 && MMe({
          files: Ke,
          accept: G,
          minSize: h,
          maxSize: u,
          multiple: f,
          maxFiles: p,
          validator: U
        }), Cn = zt > 0 && !nn;
        ue({
          isDragAccept: nn,
          isDragReject: Cn,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), v && v(Pe);
      }
    }).catch(function(Ke) {
      return Ae(Ke);
    });
  }, [s, v, Ae, L, G, h, u, f, p, U]), ke = et(function(Pe) {
    Pe.preventDefault(), Pe.persist(), Ft(Pe);
    var Ke = sf(Pe);
    if (Ke && Pe.dataTransfer)
      try {
        Pe.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Ke && y && y(Pe), !1;
  }, [y, L]), ge = et(function(Pe) {
    Pe.preventDefault(), Pe.persist(), Ft(Pe);
    var Ke = me.current.filter(function(nn) {
      return Z.current && Z.current.contains(nn);
    }), zt = Ke.indexOf(Pe.target);
    zt !== -1 && Ke.splice(zt, 1), me.current = Ke, !(Ke.length > 0) && (ue({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), sf(Pe) && b && b(Pe));
  }, [Z, b, L]), xe = et(function(Pe, Ke) {
    var zt = [], nn = [];
    Pe.forEach(function(Cn) {
      var Hr = X7(Cn, G), Mr = fb(Hr, 2), vi = Mr[0], ji = Mr[1], Tn = J7(Cn, h, u), Zt = fb(Tn, 2), vn = Zt[0], Bi = Zt[1], Fi = U ? U(Cn) : null;
      if (vi && vn && !Fi)
        zt.push(Cn);
      else {
        var zi = [ji, Bi];
        Fi && (zi = zi.concat(Fi)), nn.push({
          file: Cn,
          errors: zi.filter(function(bi) {
            return bi;
          })
        });
      }
    }), (!f && zt.length > 1 || f && p >= 1 && zt.length > p) && (zt.forEach(function(Cn) {
      nn.push({
        file: Cn,
        errors: [SMe]
      });
    }), zt.splice(0)), ue({
      acceptedFiles: zt,
      fileRejections: nn,
      type: "setFiles"
    }), k && k(zt, nn, Ke), nn.length > 0 && E && E(nn, Ke), zt.length > 0 && _ && _(zt, Ke);
  }, [ue, f, G, h, u, p, k, _, E, U]), Te = et(function(Pe) {
    Pe.preventDefault(), Pe.persist(), Ft(Pe), me.current = [], sf(Pe) && Promise.resolve(s(Pe)).then(function(Ke) {
      Kp(Pe) && !L || xe(Ke, Pe);
    }).catch(function(Ke) {
      return Ae(Ke);
    }), ue({
      type: "reset"
    });
  }, [s, xe, Ae, L]), J = et(function() {
    if (he.current) {
      ue({
        type: "openDialog"
      }), Y();
      var Pe = {
        multiple: f,
        types: q
      };
      window.showOpenFilePicker(Pe).then(function(Ke) {
        return s(Ke);
      }).then(function(Ke) {
        xe(Ke, null), ue({
          type: "closeDialog"
        });
      }).catch(function(Ke) {
        NMe(Ke) ? (Q(Ke), ue({
          type: "closeDialog"
        })) : $Me(Ke) ? (he.current = !1, ae.current ? (ae.current.value = null, ae.current.click()) : Ae(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Ae(Ke);
      });
      return;
    }
    ae.current && (ue({
      type: "openDialog"
    }), Y(), ae.current.value = null, ae.current.click());
  }, [ue, Y, Q, I, xe, Ae, q, f]), Ge = et(function(Pe) {
    !Z.current || !Z.current.isEqualNode(Pe.target) || (Pe.key === " " || Pe.key === "Enter" || Pe.keyCode === 32 || Pe.keyCode === 13) && (Pe.preventDefault(), J());
  }, [Z, J]), De = et(function() {
    ue({
      type: "focus"
    });
  }, []), He = et(function() {
    ue({
      type: "blur"
    });
  }, []), at = et(function() {
    P || (IMe() ? setTimeout(J, 0) : J());
  }, [P, J]), qt = function(Ke) {
    return o ? null : Ke;
  }, An = function(Ke) {
    return S ? null : qt(Ke);
  }, Lt = function(Ke) {
    return $ ? null : qt(Ke);
  }, Ft = function(Ke) {
    L && Ke.stopPropagation();
  }, mr = Re(function() {
    return function() {
      var Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ke = Pe.refKey, zt = Ke === void 0 ? "ref" : Ke, nn = Pe.role, Cn = Pe.onKeyDown, Hr = Pe.onFocus, Mr = Pe.onBlur, vi = Pe.onClick, ji = Pe.onDragEnter, Tn = Pe.onDragOver, Zt = Pe.onDragLeave, vn = Pe.onDrop, Bi = Yp(Pe, BMe);
      return En(En(u1({
        onKeyDown: An(so(Cn, Ge)),
        onFocus: An(so(Hr, De)),
        onBlur: An(so(Mr, He)),
        onClick: qt(so(vi, at)),
        onDragEnter: Lt(so(ji, Se)),
        onDragOver: Lt(so(Tn, ke)),
        onDragLeave: Lt(so(Zt, ge)),
        onDrop: Lt(so(vn, Te)),
        role: typeof nn == "string" && nn !== "" ? nn : "presentation"
      }, zt, Z), !o && !S ? {
        tabIndex: 0
      } : {}), Bi);
    };
  }, [Z, Ge, De, He, at, Se, ke, ge, Te, S, $, o]), _r = et(function(Pe) {
    Pe.stopPropagation();
  }, []), Mn = Re(function() {
    return function() {
      var Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ke = Pe.refKey, zt = Ke === void 0 ? "ref" : Ke, nn = Pe.onChange, Cn = Pe.onClick, Hr = Yp(Pe, FMe), Mr = u1({
        accept: G,
        multiple: f,
        type: "file",
        style: {
          display: "none"
        },
        onChange: qt(so(nn, Te)),
        onClick: qt(so(Cn, _r)),
        tabIndex: -1
      }, zt, ae);
      return En(En({}, Mr), Hr);
    };
  }, [ae, r, f, Te, o]);
  return En(En({}, ce), {}, {
    isFocused: X && !o,
    getRootProps: mr,
    getInputProps: Mn,
    rootRef: Z,
    inputRef: ae,
    open: qt(J)
  });
}
function YMe(e, n) {
  switch (n.type) {
    case "focus":
      return En(En({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return En(En({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return En(En({}, d1), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return En(En({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return En(En({}, e), {}, {
        isDragActive: n.isDragActive,
        isDragAccept: n.isDragAccept,
        isDragReject: n.isDragReject
      });
    case "setFiles":
      return En(En({}, e), {}, {
        acceptedFiles: n.acceptedFiles,
        fileRejections: n.fileRejections
      });
    case "reset":
      return En({}, d1);
    default:
      return e;
  }
}
function HD() {
}
const QMe = "flex justify-center h-32 border-2 items-center rounded-md border-gray-300 border-dashed cursor-pointer", ZMe = "border-blue-800", XMe = "border-green-600", JMe = "border-red-600";
function eTe(e) {
  switch (e) {
    case "any":
      return;
    case "image":
      return {
        "image/*": []
      };
    default:
      return {
        [e]: []
      };
  }
}
function tTe({
  onDrop: e,
  children: n,
  accept: r = "any",
  multiple: o = !1
}) {
  const {
    getRootProps: s,
    getInputProps: u,
    isFocused: h,
    isDragAccept: f,
    isDragReject: p
  } = iO({
    accept: eTe(r),
    multiple: o,
    onDrop: e
  }), v = Re(() => Ce(QMe, h ? ZMe : "", f ? XMe : "", p ? JMe : ""), [h, f, p]);
  return /* @__PURE__ */ K("div", {
    ...s({
      className: v
    }),
    children: [/* @__PURE__ */ M("input", {
      ...u()
    }), n]
  });
}
tTe.displayName = "Dropzone";
function oO({
  children: e,
  id: n,
  ...r
}, o) {
  const s = `nalgoo-ui-radio-${Et()}`, u = n || s;
  return /* @__PURE__ */ K("div", {
    className: "flex items-center",
    children: [/* @__PURE__ */ M("input", {
      ...r,
      ref: o,
      id: u,
      type: "radio",
      className: "h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600 peer disabled:text-gray-300"
    }), /* @__PURE__ */ M("label", {
      htmlFor: u,
      className: "ml-3 block text-sm font-medium leading-6 text-gray-900 peer-disabled:text-gray-400",
      children: e
    })]
  });
}
oO.displayName = "RadioGroup2.Input";
const nTe = zs(oO);
function aO({
  children: e,
  disabled: n,
  legend: r,
  ...o
}, s) {
  return /* @__PURE__ */ K("fieldset", {
    ...o,
    ref: s,
    className: "void",
    disabled: n,
    children: [r && /* @__PURE__ */ M("legend", {
      className: "sr-only",
      children: r
    }), /* @__PURE__ */ M("div", {
      className: "space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0",
      children: e
    })]
  });
}
aO.displayName = "RadioGroup2";
const rTe = zs(aO), ZDe = Object.assign(rTe, {
  Input: nTe
});
var h1 = { exports: {} };
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function(e, n) {
  (function(r, o) {
    e.exports = o(oe);
  })(self, (r) => (() => {
    var o = { 703: (f, p, v) => {
      var b = v(414);
      function y() {
      }
      function k() {
      }
      k.resetWarningCache = y, f.exports = function() {
        function _(D, I, N, O, P, S) {
          if (S !== b) {
            var $ = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw $.name = "Invariant Violation", $;
          }
        }
        function E() {
          return _;
        }
        _.isRequired = _;
        var x = { array: _, bigint: _, bool: _, func: _, number: _, object: _, string: _, symbol: _, any: _, arrayOf: E, element: _, elementType: _, instanceOf: E, node: _, objectOf: E, oneOf: E, oneOfType: E, shape: E, exact: E, checkPropTypes: k, resetWarningCache: y };
        return x.PropTypes = x, x;
      };
    }, 697: (f, p, v) => {
      f.exports = v(703)();
    }, 414: (f) => {
      f.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, 787: (f) => {
      f.exports = r;
    } }, s = {};
    function u(f) {
      var p = s[f];
      if (p !== void 0)
        return p.exports;
      var v = s[f] = { exports: {} };
      return o[f](v, v.exports, u), v.exports;
    }
    u.n = (f) => {
      var p = f && f.__esModule ? () => f.default : () => f;
      return u.d(p, { a: p }), p;
    }, u.d = (f, p) => {
      for (var v in p)
        u.o(p, v) && !u.o(f, v) && Object.defineProperty(f, v, { enumerable: !0, get: p[v] });
    }, u.o = (f, p) => Object.prototype.hasOwnProperty.call(f, p), u.r = (f) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(f, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(f, "__esModule", { value: !0 });
    };
    var h = {};
    return (() => {
      u.r(h), u.d(h, { CKEditor: () => So, CKEditorContext: () => ll });
      var f = u(787), p = u.n(f), v = u(697), b = u.n(v);
      const y = function(z) {
        var H = typeof z;
        return z != null && (H == "object" || H == "function");
      }, k = typeof ai == "object" && ai && ai.Object === Object && ai;
      var _ = typeof self == "object" && self && self.Object === Object && self;
      const E = k || _ || Function("return this")(), x = function() {
        return E.Date.now();
      };
      var D = /\s/;
      const I = function(z) {
        for (var H = z.length; H-- && D.test(z.charAt(H)); )
          ;
        return H;
      };
      var N = /^\s+/;
      const O = function(z) {
        return z && z.slice(0, I(z) + 1).replace(N, "");
      }, P = E.Symbol;
      var S = Object.prototype, $ = S.hasOwnProperty, L = S.toString, B = P ? P.toStringTag : void 0;
      const U = function(z) {
        var H = $.call(z, B), te = z[B];
        try {
          z[B] = void 0;
          var fe = !0;
        } catch {
        }
        var We = L.call(z);
        return fe && (H ? z[B] = te : delete z[B]), We;
      };
      var G = Object.prototype.toString;
      const q = function(z) {
        return G.call(z);
      };
      var Y = P ? P.toStringTag : void 0;
      const Q = function(z) {
        return z == null ? z === void 0 ? "[object Undefined]" : "[object Null]" : Y && Y in Object(z) ? U(z) : q(z);
      }, Z = function(z) {
        return z != null && typeof z == "object";
      }, ae = function(z) {
        return typeof z == "symbol" || Z(z) && Q(z) == "[object Symbol]";
      };
      var ie = /^[-+]0x[0-9a-f]+$/i, pe = /^0b[01]+$/i, ce = /^0o[0-7]+$/i, ue = parseInt;
      const X = function(z) {
        if (typeof z == "number")
          return z;
        if (ae(z))
          return NaN;
        if (y(z)) {
          var H = typeof z.valueOf == "function" ? z.valueOf() : z;
          z = y(H) ? H + "" : H;
        }
        if (typeof z != "string")
          return z === 0 ? z : +z;
        z = O(z);
        var te = pe.test(z);
        return te || ce.test(z) ? ue(z.slice(2), te ? 2 : 8) : ie.test(z) ? NaN : +z;
      };
      var se = Math.max, he = Math.min;
      const de = function(z, H, te) {
        var fe, We, ot, lt, dt, wn, yn = 0, Ya = !1, Yi = !1, Ir = !0;
        if (typeof z != "function")
          throw new TypeError("Expected a function");
        function Dt(qn) {
          var Kn = fe, Mo = We;
          return fe = We = void 0, yn = qn, lt = z.apply(Mo, Kn);
        }
        function oa(qn) {
          return yn = qn, dt = setTimeout(Bn, H), Ya ? Dt(qn) : lt;
        }
        function aa(qn) {
          var Kn = qn - wn;
          return wn === void 0 || Kn >= H || Kn < 0 || Yi && qn - yn >= ot;
        }
        function Bn() {
          var qn = x();
          if (aa(qn))
            return qr(qn);
          dt = setTimeout(Bn, function(Kn) {
            var Mo = H - (Kn - wn);
            return Yi ? he(Mo, ot - (Kn - yn)) : Mo;
          }(qn));
        }
        function qr(qn) {
          return dt = void 0, Ir && fe ? Dt(qn) : (fe = We = void 0, lt);
        }
        function ul() {
          var qn = x(), Kn = aa(qn);
          if (fe = arguments, We = this, wn = qn, Kn) {
            if (dt === void 0)
              return oa(wn);
            if (Yi)
              return clearTimeout(dt), dt = setTimeout(Bn, H), Dt(wn);
          }
          return dt === void 0 && (dt = setTimeout(Bn, H)), lt;
        }
        return H = X(H) || 0, y(te) && (Ya = !!te.leading, ot = (Yi = "maxWait" in te) ? se(X(te.maxWait) || 0, H) : ot, Ir = "trailing" in te ? !!te.trailing : Ir), ul.cancel = function() {
          dt !== void 0 && clearTimeout(dt), yn = 0, fe = wn = We = dt = void 0;
        }, ul.flush = function() {
          return dt === void 0 ? lt : qr(x());
        }, ul;
      }, me = function(z, H, te) {
        var fe = !0, We = !0;
        if (typeof z != "function")
          throw new TypeError("Expected a function");
        return y(te) && (fe = "leading" in te ? !!te.leading : fe, We = "trailing" in te ? !!te.trailing : We), de(z, H, { leading: fe, maxWait: H, trailing: We });
      }, we = function() {
        this.__data__ = [], this.size = 0;
      }, Ae = function(z, H) {
        return z === H || z != z && H != H;
      }, Se = function(z, H) {
        for (var te = z.length; te--; )
          if (Ae(z[te][0], H))
            return te;
        return -1;
      };
      var ke = Array.prototype.splice;
      const ge = function(z) {
        var H = this.__data__, te = Se(H, z);
        return !(te < 0) && (te == H.length - 1 ? H.pop() : ke.call(H, te, 1), --this.size, !0);
      }, xe = function(z) {
        var H = this.__data__, te = Se(H, z);
        return te < 0 ? void 0 : H[te][1];
      }, Te = function(z) {
        return Se(this.__data__, z) > -1;
      }, J = function(z, H) {
        var te = this.__data__, fe = Se(te, z);
        return fe < 0 ? (++this.size, te.push([z, H])) : te[fe][1] = H, this;
      };
      function Ge(z) {
        var H = -1, te = z == null ? 0 : z.length;
        for (this.clear(); ++H < te; ) {
          var fe = z[H];
          this.set(fe[0], fe[1]);
        }
      }
      Ge.prototype.clear = we, Ge.prototype.delete = ge, Ge.prototype.get = xe, Ge.prototype.has = Te, Ge.prototype.set = J;
      const De = Ge, He = function() {
        this.__data__ = new De(), this.size = 0;
      }, at = function(z) {
        var H = this.__data__, te = H.delete(z);
        return this.size = H.size, te;
      }, qt = function(z) {
        return this.__data__.get(z);
      }, An = function(z) {
        return this.__data__.has(z);
      }, Lt = function(z) {
        if (!y(z))
          return !1;
        var H = Q(z);
        return H == "[object Function]" || H == "[object GeneratorFunction]" || H == "[object AsyncFunction]" || H == "[object Proxy]";
      }, Ft = E["__core-js_shared__"];
      var mr = function() {
        var z = /[^.]+$/.exec(Ft && Ft.keys && Ft.keys.IE_PROTO || "");
        return z ? "Symbol(src)_1." + z : "";
      }();
      const _r = function(z) {
        return !!mr && mr in z;
      };
      var Mn = Function.prototype.toString;
      const Pe = function(z) {
        if (z != null) {
          try {
            return Mn.call(z);
          } catch {
          }
          try {
            return z + "";
          } catch {
          }
        }
        return "";
      };
      var Ke = /^\[object .+?Constructor\]$/, zt = Function.prototype, nn = Object.prototype, Cn = zt.toString, Hr = nn.hasOwnProperty, Mr = RegExp("^" + Cn.call(Hr).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      const vi = function(z) {
        return !(!y(z) || _r(z)) && (Lt(z) ? Mr : Ke).test(Pe(z));
      }, ji = function(z, H) {
        return z?.[H];
      }, Tn = function(z, H) {
        var te = ji(z, H);
        return vi(te) ? te : void 0;
      }, Zt = Tn(E, "Map"), vn = Tn(Object, "create"), Bi = function() {
        this.__data__ = vn ? vn(null) : {}, this.size = 0;
      }, Fi = function(z) {
        var H = this.has(z) && delete this.__data__[z];
        return this.size -= H ? 1 : 0, H;
      };
      var zi = Object.prototype.hasOwnProperty;
      const bi = function(z) {
        var H = this.__data__;
        if (vn) {
          var te = H[z];
          return te === "__lodash_hash_undefined__" ? void 0 : te;
        }
        return zi.call(H, z) ? H[z] : void 0;
      };
      var Ks = Object.prototype.hasOwnProperty;
      const Vi = function(z) {
        var H = this.__data__;
        return vn ? H[z] !== void 0 : Ks.call(H, z);
      }, na = function(z, H) {
        var te = this.__data__;
        return this.size += this.has(z) ? 0 : 1, te[z] = vn && H === void 0 ? "__lodash_hash_undefined__" : H, this;
      };
      function Ur(z) {
        var H = -1, te = z == null ? 0 : z.length;
        for (this.clear(); ++H < te; ) {
          var fe = z[H];
          this.set(fe[0], fe[1]);
        }
      }
      Ur.prototype.clear = Bi, Ur.prototype.delete = Fi, Ur.prototype.get = bi, Ur.prototype.has = Vi, Ur.prototype.set = na;
      const Fa = Ur, Wn = function() {
        this.size = 0, this.__data__ = { hash: new Fa(), map: new (Zt || De)(), string: new Fa() };
      }, Ys = function(z) {
        var H = typeof z;
        return H == "string" || H == "number" || H == "symbol" || H == "boolean" ? z !== "__proto__" : z === null;
      }, Wr = function(z, H) {
        var te = z.__data__;
        return Ys(H) ? te[typeof H == "string" ? "string" : "hash"] : te.map;
      }, _o = function(z) {
        var H = Wr(this, z).delete(z);
        return this.size -= H ? 1 : 0, H;
      }, Qs = function(z) {
        return Wr(this, z).get(z);
      }, Cc = function(z) {
        return Wr(this, z).has(z);
      }, xc = function(z, H) {
        var te = Wr(this, z), fe = te.size;
        return te.set(z, H), this.size += te.size == fe ? 0 : 1, this;
      };
      function wi(z) {
        var H = -1, te = z == null ? 0 : z.length;
        for (this.clear(); ++H < te; ) {
          var fe = z[H];
          this.set(fe[0], fe[1]);
        }
      }
      wi.prototype.clear = Wn, wi.prototype.delete = _o, wi.prototype.get = Qs, wi.prototype.has = Cc, wi.prototype.set = xc;
      const Ec = wi, Hi = function(z, H) {
        var te = this.__data__;
        if (te instanceof De) {
          var fe = te.__data__;
          if (!Zt || fe.length < 199)
            return fe.push([z, H]), this.size = ++te.size, this;
          te = this.__data__ = new Ec(fe);
        }
        return te.set(z, H), this.size = te.size, this;
      };
      function Tr(z) {
        var H = this.__data__ = new De(z);
        this.size = H.size;
      }
      Tr.prototype.clear = He, Tr.prototype.delete = at, Tr.prototype.get = qt, Tr.prototype.has = An, Tr.prototype.set = Hi;
      const Sc = Tr, re = function(z, H) {
        for (var te = -1, fe = z == null ? 0 : z.length; ++te < fe && H(z[te], te, z) !== !1; )
          ;
        return z;
      }, Me = function() {
        try {
          var z = Tn(Object, "defineProperty");
          return z({}, "", {}), z;
        } catch {
        }
      }(), je = function(z, H, te) {
        H == "__proto__" && Me ? Me(z, H, { configurable: !0, enumerable: !0, value: te, writable: !0 }) : z[H] = te;
      };
      var Qe = Object.prototype.hasOwnProperty;
      const bt = function(z, H, te) {
        var fe = z[H];
        Qe.call(z, H) && Ae(fe, te) && (te !== void 0 || H in z) || je(z, H, te);
      }, Ct = function(z, H, te, fe) {
        var We = !te;
        te || (te = {});
        for (var ot = -1, lt = H.length; ++ot < lt; ) {
          var dt = H[ot], wn = fe ? fe(te[dt], z[dt], dt, te, z) : void 0;
          wn === void 0 && (wn = z[dt]), We ? je(te, dt, wn) : bt(te, dt, wn);
        }
        return te;
      }, wt = function(z, H) {
        for (var te = -1, fe = Array(z); ++te < z; )
          fe[te] = H(te);
        return fe;
      }, ht = function(z) {
        return Z(z) && Q(z) == "[object Arguments]";
      };
      var ln = Object.prototype, hn = ln.hasOwnProperty, bn = ln.propertyIsEnumerable;
      const ur = ht(function() {
        return arguments;
      }()) ? ht : function(z) {
        return Z(z) && hn.call(z, "callee") && !bn.call(z, "callee");
      }, Gr = Array.isArray, Zs = function() {
        return !1;
      };
      var Ar = n && !n.nodeType && n, Dd = Ar && !0 && e && !e.nodeType && e, Id = Dd && Dd.exports === Ar ? E.Buffer : void 0;
      const Ui = (Id ? Id.isBuffer : void 0) || Zs;
      var za = /^(?:0|[1-9]\d*)$/;
      const Va = function(z, H) {
        var te = typeof z;
        return !!(H = H ?? 9007199254740991) && (te == "number" || te != "symbol" && za.test(z)) && z > -1 && z % 1 == 0 && z < H;
      }, Pd = function(z) {
        return typeof z == "number" && z > -1 && z % 1 == 0 && z <= 9007199254740991;
      };
      var rn = {};
      rn["[object Float32Array]"] = rn["[object Float64Array]"] = rn["[object Int8Array]"] = rn["[object Int16Array]"] = rn["[object Int32Array]"] = rn["[object Uint8Array]"] = rn["[object Uint8ClampedArray]"] = rn["[object Uint16Array]"] = rn["[object Uint32Array]"] = !0, rn["[object Arguments]"] = rn["[object Array]"] = rn["[object ArrayBuffer]"] = rn["[object Boolean]"] = rn["[object DataView]"] = rn["[object Date]"] = rn["[object Error]"] = rn["[object Function]"] = rn["[object Map]"] = rn["[object Number]"] = rn["[object Object]"] = rn["[object RegExp]"] = rn["[object Set]"] = rn["[object String]"] = rn["[object WeakMap]"] = !1;
      const om = function(z) {
        return Z(z) && Pd(z.length) && !!rn[Q(z)];
      }, Mc = function(z) {
        return function(H) {
          return z(H);
        };
      };
      var Od = n && !n.nodeType && n, Ha = Od && !0 && e && !e.nodeType && e, Tc = Ha && Ha.exports === Od && k.process;
      const Dr = function() {
        try {
          var z = Ha && Ha.require && Ha.require("util").types;
          return z || Tc && Tc.binding && Tc.binding("util");
        } catch {
        }
      }();
      var Dc = Dr && Dr.isTypedArray;
      const am = Dc ? Mc(Dc) : om;
      var sm = Object.prototype.hasOwnProperty;
      const Ua = function(z, H) {
        var te = Gr(z), fe = !te && ur(z), We = !te && !fe && Ui(z), ot = !te && !fe && !We && am(z), lt = te || fe || We || ot, dt = lt ? wt(z.length, String) : [], wn = dt.length;
        for (var yn in z)
          !H && !sm.call(z, yn) || lt && (yn == "length" || We && (yn == "offset" || yn == "parent") || ot && (yn == "buffer" || yn == "byteLength" || yn == "byteOffset") || Va(yn, wn)) || dt.push(yn);
        return dt;
      };
      var lm = Object.prototype;
      const Ic = function(z) {
        var H = z && z.constructor;
        return z === (typeof H == "function" && H.prototype || lm);
      }, Rd = function(z, H) {
        return function(te) {
          return z(H(te));
        };
      }, cm = Rd(Object.keys, Object);
      var ra = Object.prototype.hasOwnProperty;
      const Xs = function(z) {
        if (!Ic(z))
          return cm(z);
        var H = [];
        for (var te in Object(z))
          ra.call(z, te) && te != "constructor" && H.push(te);
        return H;
      }, Nd = function(z) {
        return z != null && Pd(z.length) && !Lt(z);
      }, Wi = function(z) {
        return Nd(z) ? Ua(z) : Xs(z);
      }, Wa = function(z, H) {
        return z && Ct(H, Wi(H), z);
      }, um = function(z) {
        var H = [];
        if (z != null)
          for (var te in Object(z))
            H.push(te);
        return H;
      };
      var Js = Object.prototype.hasOwnProperty;
      const Pc = function(z) {
        if (!y(z))
          return um(z);
        var H = Ic(z), te = [];
        for (var fe in z)
          (fe != "constructor" || !H && Js.call(z, fe)) && te.push(fe);
        return te;
      }, Oc = function(z) {
        return Nd(z) ? Ua(z, !0) : Pc(z);
      }, Rc = function(z, H) {
        return z && Ct(H, Oc(H), z);
      };
      var Ao = n && !n.nodeType && n, $d = Ao && !0 && e && !e.nodeType && e, Nc = $d && $d.exports === Ao ? E.Buffer : void 0, $c = Nc ? Nc.allocUnsafe : void 0;
      const dm = function(z, H) {
        if (H)
          return z.slice();
        var te = z.length, fe = $c ? $c(te) : new z.constructor(te);
        return z.copy(fe), fe;
      }, hm = function(z, H) {
        var te = -1, fe = z.length;
        for (H || (H = Array(fe)); ++te < fe; )
          H[te] = z[te];
        return H;
      }, Lc = function(z, H) {
        for (var te = -1, fe = z == null ? 0 : z.length, We = 0, ot = []; ++te < fe; ) {
          var lt = z[te];
          H(lt, te, z) && (ot[We++] = lt);
        }
        return ot;
      }, Ld = function() {
        return [];
      };
      var jd = Object.prototype.propertyIsEnumerable, jc = Object.getOwnPropertySymbols;
      const el = jc ? function(z) {
        return z == null ? [] : (z = Object(z), Lc(jc(z), function(H) {
          return jd.call(z, H);
        }));
      } : Ld, Ga = function(z, H) {
        return Ct(z, el(z), H);
      }, Bd = function(z, H) {
        for (var te = -1, fe = H.length, We = z.length; ++te < fe; )
          z[We + te] = H[te];
        return z;
      }, qa = Rd(Object.getPrototypeOf, Object), Bc = Object.getOwnPropertySymbols ? function(z) {
        for (var H = []; z; )
          Bd(H, el(z)), z = qa(z);
        return H;
      } : Ld, on = function(z, H) {
        return Ct(z, Bc(z), H);
      }, Fd = function(z, H, te) {
        var fe = H(z);
        return Gr(z) ? fe : Bd(fe, te(z));
      }, Fc = function(z) {
        return Fd(z, Wi, el);
      }, zd = function(z) {
        return Fd(z, Oc, Bc);
      }, Co = Tn(E, "DataView"), Ka = Tn(E, "Promise"), Gi = Tn(E, "Set"), tl = Tn(E, "WeakMap");
      var nl = "[object Map]", Vd = "[object Promise]", zc = "[object Set]", Hd = "[object WeakMap]", rl = "[object DataView]", fm = Pe(Co), pm = Pe(Zt), gm = Pe(Ka), il = Pe(Gi), Vc = Pe(tl), xo = Q;
      (Co && xo(new Co(new ArrayBuffer(1))) != rl || Zt && xo(new Zt()) != nl || Ka && xo(Ka.resolve()) != Vd || Gi && xo(new Gi()) != zc || tl && xo(new tl()) != Hd) && (xo = function(z) {
        var H = Q(z), te = H == "[object Object]" ? z.constructor : void 0, fe = te ? Pe(te) : "";
        if (fe)
          switch (fe) {
            case fm:
              return rl;
            case pm:
              return nl;
            case gm:
              return Vd;
            case il:
              return zc;
            case Vc:
              return Hd;
          }
        return H;
      });
      const Hc = xo;
      var mm = Object.prototype.hasOwnProperty;
      const vm = function(z) {
        var H = z.length, te = new z.constructor(H);
        return H && typeof z[0] == "string" && mm.call(z, "index") && (te.index = z.index, te.input = z.input), te;
      }, Eo = E.Uint8Array, Uc = function(z) {
        var H = new z.constructor(z.byteLength);
        return new Eo(H).set(new Eo(z)), H;
      }, Ud = function(z, H) {
        var te = H ? Uc(z.buffer) : z.buffer;
        return new z.constructor(te, z.byteOffset, z.byteLength);
      };
      var Wd = /\w*$/;
      const Gd = function(z) {
        var H = new z.constructor(z.source, Wd.exec(z));
        return H.lastIndex = z.lastIndex, H;
      };
      var Wc = P ? P.prototype : void 0, Gc = Wc ? Wc.valueOf : void 0;
      const qd = function(z) {
        return Gc ? Object(Gc.call(z)) : {};
      }, bm = function(z, H) {
        var te = H ? Uc(z.buffer) : z.buffer;
        return new z.constructor(te, z.byteOffset, z.length);
      }, Kd = function(z, H, te) {
        var fe = z.constructor;
        switch (H) {
          case "[object ArrayBuffer]":
            return Uc(z);
          case "[object Boolean]":
          case "[object Date]":
            return new fe(+z);
          case "[object DataView]":
            return Ud(z, te);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return bm(z, te);
          case "[object Map]":
          case "[object Set]":
            return new fe();
          case "[object Number]":
          case "[object String]":
            return new fe(z);
          case "[object RegExp]":
            return Gd(z);
          case "[object Symbol]":
            return qd(z);
        }
      };
      var Yd = Object.create;
      const Qd = function() {
        function z() {
        }
        return function(H) {
          if (!y(H))
            return {};
          if (Yd)
            return Yd(H);
          z.prototype = H;
          var te = new z();
          return z.prototype = void 0, te;
        };
      }(), qc = function(z) {
        return typeof z.constructor != "function" || Ic(z) ? {} : Qd(qa(z));
      }, wm = function(z) {
        return Z(z) && Hc(z) == "[object Map]";
      };
      var Kc = Dr && Dr.isMap;
      const Zd = Kc ? Mc(Kc) : wm, ym = function(z) {
        return Z(z) && Hc(z) == "[object Set]";
      };
      var Yc = Dr && Dr.isSet;
      const Qc = Yc ? Mc(Yc) : ym;
      var Xd = "[object Arguments]", ol = "[object Function]", al = "[object Object]", Vt = {};
      Vt[Xd] = Vt["[object Array]"] = Vt["[object ArrayBuffer]"] = Vt["[object DataView]"] = Vt["[object Boolean]"] = Vt["[object Date]"] = Vt["[object Float32Array]"] = Vt["[object Float64Array]"] = Vt["[object Int8Array]"] = Vt["[object Int16Array]"] = Vt["[object Int32Array]"] = Vt["[object Map]"] = Vt["[object Number]"] = Vt[al] = Vt["[object RegExp]"] = Vt["[object Set]"] = Vt["[object String]"] = Vt["[object Symbol]"] = Vt["[object Uint8Array]"] = Vt["[object Uint8ClampedArray]"] = Vt["[object Uint16Array]"] = Vt["[object Uint32Array]"] = !0, Vt["[object Error]"] = Vt[ol] = Vt["[object WeakMap]"] = !1;
      const Zc = function z(H, te, fe, We, ot, lt) {
        var dt, wn = 1 & te, yn = 2 & te, Ya = 4 & te;
        if (fe && (dt = ot ? fe(H, We, ot, lt) : fe(H)), dt !== void 0)
          return dt;
        if (!y(H))
          return H;
        var Yi = Gr(H);
        if (Yi) {
          if (dt = vm(H), !wn)
            return hm(H, dt);
        } else {
          var Ir = Hc(H), Dt = Ir == ol || Ir == "[object GeneratorFunction]";
          if (Ui(H))
            return dm(H, wn);
          if (Ir == al || Ir == Xd || Dt && !ot) {
            if (dt = yn || Dt ? {} : qc(H), !wn)
              return yn ? on(H, Rc(dt, H)) : Ga(H, Wa(dt, H));
          } else {
            if (!Vt[Ir])
              return ot ? H : {};
            dt = Kd(H, Ir, wn);
          }
        }
        lt || (lt = new Sc());
        var oa = lt.get(H);
        if (oa)
          return oa;
        lt.set(H, dt), Qc(H) ? H.forEach(function(Bn) {
          dt.add(z(Bn, te, fe, Bn, H, lt));
        }) : Zd(H) && H.forEach(function(Bn, qr) {
          dt.set(qr, z(Bn, te, fe, qr, H, lt));
        });
        var aa = Yi ? void 0 : (Ya ? yn ? zd : Fc : yn ? Oc : Wi)(H);
        return re(aa || H, function(Bn, qr) {
          aa && (Bn = H[qr = Bn]), bt(dt, qr, z(Bn, te, fe, qr, H, lt));
        }), dt;
      }, Jd = function(z, H) {
        return Zc(z, 5, H = typeof H == "function" ? H : void 0);
      };
      var eh = Function.prototype, th = Object.prototype, Xc = eh.toString, nh = th.hasOwnProperty, km = Xc.call(Object);
      const _m = function(z) {
        if (!Z(z) || Q(z) != "[object Object]")
          return !1;
        var H = qa(z);
        if (H === null)
          return !0;
        var te = nh.call(H, "constructor") && H.constructor;
        return typeof te == "function" && te instanceof te && Xc.call(te) == km;
      }, Am = function(z) {
        return Z(z) && z.nodeType === 1 && !_m(z);
      };
      function Jc(z, H = /* @__PURE__ */ new Set()) {
        const te = [z], fe = /* @__PURE__ */ new Set();
        let We = 0;
        for (; te.length > We; ) {
          const ot = te[We++];
          if (!(fe.has(ot) || Cm(ot) || H.has(ot)))
            if (fe.add(ot), ot[Symbol.iterator])
              try {
                for (const lt of ot)
                  te.push(lt);
              } catch {
              }
            else
              for (const lt in ot)
                lt !== "defaultValue" && te.push(ot[lt]);
        }
        return fe;
      }
      function Cm(z) {
        const H = Object.prototype.toString.call(z), te = typeof z;
        return te === "number" || te === "boolean" || te === "string" || te === "symbol" || te === "function" || H === "[object Date]" || H === "[object RegExp]" || H === "[object Module]" || z == null || z._watchdogExcluded === !0 || z instanceof EventTarget || z instanceof Event;
      }
      function qi(z, H, te = /* @__PURE__ */ new Set()) {
        if (z === H && typeof (fe = z) == "object" && fe !== null)
          return !0;
        var fe;
        const We = Jc(z, te), ot = Jc(H, te);
        for (const lt of We)
          if (ot.has(lt))
            return !0;
        return !1;
      }
      class ia {
        constructor(H) {
          if (this.crashes = [], this.state = "initializing", this._crashNumberLimit = typeof H.crashNumberLimit == "number" ? H.crashNumberLimit : 3, this._now = Date.now, this._minimumNonErrorTimePeriod = typeof H.minimumNonErrorTimePeriod == "number" ? H.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = (te) => {
            const fe = te.error || te.reason;
            fe instanceof Error && this._handleError(fe, te);
          }, this._listeners = {}, !this._restart)
            throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
        }
        setCreator(H) {
          this._creator = H;
        }
        setDestructor(H) {
          this._destructor = H;
        }
        destroy() {
          this._stopErrorHandling(), this._listeners = {};
        }
        on(H, te) {
          this._listeners[H] || (this._listeners[H] = []), this._listeners[H].push(te);
        }
        off(H, te) {
          this._listeners[H] = this._listeners[H].filter((fe) => fe !== te);
        }
        _fire(H, ...te) {
          const fe = this._listeners[H] || [];
          for (const We of fe)
            We.apply(this, [null, ...te]);
        }
        _startErrorHandling() {
          window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
        }
        _stopErrorHandling() {
          window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
        }
        _handleError(H, te) {
          if (this._shouldReactToError(H)) {
            this.crashes.push({ message: H.message, stack: H.stack, filename: te.filename, lineno: te.lineno, colno: te.colno, date: this._now() });
            const fe = this._shouldRestart();
            this.state = "crashed", this._fire("stateChange"), this._fire("error", { error: H, causesRestart: fe }), fe ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
          }
        }
        _shouldReactToError(H) {
          return H.is && H.is("CKEditorError") && H.context !== void 0 && H.context !== null && this.state === "ready" && this._isErrorComingFromThisItem(H);
        }
        _shouldRestart() {
          return this.crashes.length <= this._crashNumberLimit ? !0 : (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
        }
      }
      class rh extends ia {
        constructor(H, te = {}) {
          super(te), this._editor = null, this._throttledSave = me(this._save.bind(this), typeof te.saveInterval == "number" ? te.saveInterval : 5e3), this._creator = (fe, We) => H.create(fe, We), this._destructor = (fe) => fe.destroy();
        }
        get editor() {
          return this._editor;
        }
        get _item() {
          return this._editor;
        }
        _restart() {
          return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch((H) => {
            console.error("An error happened during the editor destroying.", H);
          }).then(() => {
            if (typeof this._elementOrData == "string")
              return this.create(this._data, this._config, this._config.context);
            {
              const H = Object.assign({}, this._config, { initialData: this._data });
              return this.create(this._elementOrData, H, H.context);
            }
          }).then(() => {
            this._fire("restart");
          });
        }
        create(H = this._elementOrData, te = this._config, fe) {
          return Promise.resolve().then(() => (super._startErrorHandling(), this._elementOrData = H, this._config = this._cloneEditorConfiguration(te) || {}, this._config.context = fe, this._creator(H, this._config))).then((We) => {
            this._editor = We, We.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = We.model.document.version, this._data = this._getData(), this.state = "ready", this._fire("stateChange");
          });
        }
        destroy() {
          return Promise.resolve().then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
        }
        _destroy() {
          return Promise.resolve().then(() => {
            this._stopErrorHandling(), this._throttledSave.flush();
            const H = this._editor;
            return this._editor = null, H.model.document.off("change:data", this._throttledSave), this._destructor(H);
          });
        }
        _save() {
          const H = this._editor.model.document.version;
          try {
            this._data = this._getData(), this._lastDocumentVersion = H;
          } catch (te) {
            console.error(te, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
          }
        }
        _setExcludedProperties(H) {
          this._excludedProps = H;
        }
        _getData() {
          const H = {};
          for (const te of this._editor.model.document.getRootNames())
            H[te] = this._editor.data.get({ rootName: te });
          return H;
        }
        _isErrorComingFromThisItem(H) {
          return qi(this._editor, H.context, this._excludedProps);
        }
        _cloneEditorConfiguration(H) {
          return Jd(H, (te, fe) => Am(te) || fe === "context" ? te : void 0);
        }
      }
      const Gn = new Array(256).fill("").map((z, H) => ("0" + H.toString(16)).slice(-2)), Ki = Symbol("MainQueueId");
      class sl extends ia {
        constructor(H, te = {}) {
          super(te), this._watchdogs = /* @__PURE__ */ new Map(), this._watchdogConfig = te, this._context = null, this._contextProps = /* @__PURE__ */ new Set(), this._actionQueues = new xm(), this._creator = (fe) => H.create(fe), this._destructor = (fe) => fe.destroy(), this._actionQueues.onEmpty(() => {
            this.state === "initializing" && (this.state = "ready", this._fire("stateChange"));
          });
        }
        get context() {
          return this._context;
        }
        create(H = {}) {
          return this._actionQueues.enqueue(Ki, () => (this._contextConfig = H, this._create()));
        }
        getItem(H) {
          return this._getWatchdog(H)._item;
        }
        getItemState(H) {
          return this._getWatchdog(H).state;
        }
        add(H) {
          const te = ih(H);
          return Promise.all(te.map((fe) => this._actionQueues.enqueue(fe.id, () => {
            if (this.state === "destroyed")
              throw new Error("Cannot add items to destroyed watchdog.");
            if (!this._context)
              throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
            let We;
            if (this._watchdogs.has(fe.id))
              throw new Error(`Item with the given id is already added: '${fe.id}'.`);
            if (fe.type === "editor")
              return We = new rh(this._watchdogConfig), We.setCreator(fe.creator), We._setExcludedProperties(this._contextProps), fe.destructor && We.setDestructor(fe.destructor), this._watchdogs.set(fe.id, We), We.on("error", (ot, { error: lt, causesRestart: dt }) => {
                this._fire("itemError", { itemId: fe.id, error: lt }), dt && this._actionQueues.enqueue(fe.id, () => new Promise((wn) => {
                  We.on("restart", function yn() {
                    We.off("restart", yn), this._fire("itemRestart", { itemId: fe.id }), wn();
                  }.bind(this));
                }));
              }), We.create(fe.sourceElementOrData, fe.config, this._context);
            throw new Error(`Not supported item type: '${fe.type}'.`);
          })));
        }
        remove(H) {
          const te = ih(H);
          return Promise.all(te.map((fe) => this._actionQueues.enqueue(fe, () => {
            const We = this._getWatchdog(fe);
            return this._watchdogs.delete(fe), We.destroy();
          })));
        }
        destroy() {
          return this._actionQueues.enqueue(Ki, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
        }
        _restart() {
          return this._actionQueues.enqueue(Ki, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch((H) => {
            console.error("An error happened during destroying the context or items.", H);
          }).then(() => this._create()).then(() => this._fire("restart"))));
        }
        _create() {
          return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then((H) => (this._context = H, this._contextProps = Jc(this._context), Promise.all(Array.from(this._watchdogs.values()).map((te) => (te._setExcludedProperties(this._contextProps), te.create(void 0, void 0, this._context))))));
        }
        _destroy() {
          return Promise.resolve().then(() => {
            this._stopErrorHandling();
            const H = this._context;
            return this._context = null, this._contextProps = /* @__PURE__ */ new Set(), Promise.all(Array.from(this._watchdogs.values()).map((te) => te.destroy())).then(() => this._destructor(H));
          });
        }
        _getWatchdog(H) {
          const te = this._watchdogs.get(H);
          if (!te)
            throw new Error(`Item with the given id was not registered: ${H}.`);
          return te;
        }
        _isErrorComingFromThisItem(H) {
          for (const te of this._watchdogs.values())
            if (te._isErrorComingFromThisItem(H))
              return !1;
          return qi(this._context, H.context);
        }
      }
      class xm {
        constructor() {
          this._onEmptyCallbacks = [], this._queues = /* @__PURE__ */ new Map(), this._actions = /* @__PURE__ */ new WeakMap(), this._lastActionId = 0, this._activeActions = 0;
        }
        onEmpty(H) {
          this._onEmptyCallbacks.push(H);
        }
        enqueue(H, te) {
          const fe = H === Ki;
          this._activeActions++, this._queues.get(H) || this._queues.set(H, Promise.resolve());
          const We = (fe ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(Ki), this._queues.get(H)])).then(te), ot = We.catch(() => {
          });
          return this._queues.set(H, ot), We.finally(() => {
            this._activeActions--, this._queues.get(H) === ot && this._activeActions === 0 && this._onEmptyCallbacks.forEach((lt) => lt());
          });
        }
      }
      function ih(z) {
        return Array.isArray(z) ? z : [z];
      }
      const oh = p().createContext("contextWatchdog");
      class ll extends p().Component {
        constructor(H, te) {
          super(H, te), this.contextWatchdog = null, this.props.isLayoutReady && this._initializeContextWatchdog(this.props.config);
        }
        async shouldComponentUpdate(H) {
          return H.id !== this.props.id && (this.contextWatchdog && await this.contextWatchdog.destroy(), await this._initializeContextWatchdog(H.config)), H.isLayoutReady && !this.contextWatchdog ? (await this._initializeContextWatchdog(H.config), !0) : this.props.children !== H.children;
        }
        render() {
          return p().createElement(oh.Provider, { value: this.contextWatchdog }, this.props.children);
        }
        async componentWillUnmount() {
          await this._destroyContext();
        }
        async _initializeContextWatchdog(H) {
          this.contextWatchdog = new sl(this.props.context), this.contextWatchdog.on("error", (te, fe) => {
            this.props.onError(fe.error, { phase: "runtime", willContextRestart: fe.causesRestart });
          }), this.contextWatchdog.on("stateChange", () => {
            this.contextWatchdog.state === "ready" && this.props.onReady && this.props.onReady(this.contextWatchdog.context);
          }), await this.contextWatchdog.create(H).catch((te) => {
            this.props.onError(te, { phase: "initialization", willContextRestart: !1 });
          });
        }
        async _destroyContext() {
          this.contextWatchdog && (await this.contextWatchdog.destroy(), this.contextWatchdog = null);
        }
      }
      ll.defaultProps = { isLayoutReady: !0, onError: (z, H) => console.error(z, H) }, ll.propTypes = { id: b().string, isLayoutReady: b().bool, context: b().func, config: b().object, onReady: b().func, onError: b().func };
      const cl = "Lock from React integration (@ckeditor/ckeditor5-react)";
      class So extends p().Component {
        constructor(H) {
          super(H), this.editorDestructionInProgress = null, this.domContainer = p().createRef(), this.watchdog = null;
          const { CKEDITOR_VERSION: te } = window;
          if (te) {
            const [fe] = te.split(".").map(Number);
            fe < 34 && console.warn("The <CKEditor> component requires using CKEditor 5 in version 34 or higher.");
          } else
            console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
        }
        get editor() {
          return this.watchdog ? this.watchdog.editor : null;
        }
        shouldComponentUpdate(H) {
          return !!this.editor && (H.id !== this.props.id || (this._shouldUpdateEditor(H) && this.editor.setData(H.data), "disabled" in H && (H.disabled ? this.editor.enableReadOnlyMode(cl) : this.editor.disableReadOnlyMode(cl)), !1));
        }
        async componentDidMount() {
          await this._initializeEditor();
        }
        async componentDidUpdate() {
          await this._destroyEditor(), await this._initializeEditor();
        }
        async componentWillUnmount() {
          await this._destroyEditor();
        }
        render() {
          return p().createElement("div", { ref: this.domContainer });
        }
        async _initializeEditor() {
          await this.editorDestructionInProgress, this.watchdog || (this.context instanceof sl ? this.watchdog = new ah(this.context) : this.watchdog = new So._EditorWatchdog(this.props.editor), this.watchdog.setCreator((H, te) => this._createEditor(H, te)), this.watchdog.on("error", (H, { error: te, causesRestart: fe }) => {
            this.props.onError(te, { phase: "runtime", willEditorRestart: fe });
          }), await this.watchdog.create(this.domContainer.current, this._getConfig()).catch((H) => this.props.onError(H, { phase: "initialization", willEditorRestart: !1 })));
        }
        _createEditor(H, te) {
          return this.props.editor.create(H, te).then((fe) => {
            "disabled" in this.props && this.props.disabled && fe.enableReadOnlyMode(cl);
            const We = fe.model.document, ot = fe.editing.view.document;
            return We.on("change:data", (lt) => {
              this.props.onChange && this.props.onChange(lt, fe);
            }), ot.on("focus", (lt) => {
              this.props.onFocus && this.props.onFocus(lt, fe);
            }), ot.on("blur", (lt) => {
              this.props.onBlur && this.props.onBlur(lt, fe);
            }), setTimeout(() => {
              this.props.onReady && this.props.onReady(fe);
            }), fe;
          });
        }
        async _destroyEditor() {
          this.editorDestructionInProgress = new Promise((H) => {
            this.watchdog ? this.watchdog.destroy().then(() => {
              this.watchdog = null, H();
            }) : H();
          });
        }
        _shouldUpdateEditor(H) {
          return this.props.data !== H.data && this.editor.getData() !== H.data;
        }
        _getConfig() {
          return this.props.data && this.props.config.initialData && console.warn("Editor data should be provided either using `config.initialData` or `data` properties. The config property is over the data value and the first one will be used when specified both."), { ...this.props.config, initialData: this.props.config.initialData || this.props.data || "" };
        }
      }
      class ah {
        constructor(H) {
          this._contextWatchdog = H, this._id = function() {
            const te = 4294967296 * Math.random() >>> 0, fe = 4294967296 * Math.random() >>> 0, We = 4294967296 * Math.random() >>> 0, ot = 4294967296 * Math.random() >>> 0;
            return "e" + Gn[te >> 0 & 255] + Gn[te >> 8 & 255] + Gn[te >> 16 & 255] + Gn[te >> 24 & 255] + Gn[fe >> 0 & 255] + Gn[fe >> 8 & 255] + Gn[fe >> 16 & 255] + Gn[fe >> 24 & 255] + Gn[We >> 0 & 255] + Gn[We >> 8 & 255] + Gn[We >> 16 & 255] + Gn[We >> 24 & 255] + Gn[ot >> 0 & 255] + Gn[ot >> 8 & 255] + Gn[ot >> 16 & 255] + Gn[ot >> 24 & 255];
          }();
        }
        setCreator(H) {
          this._creator = H;
        }
        create(H, te) {
          return this._contextWatchdog.add({ sourceElementOrData: H, config: te, creator: this._creator, id: this._id, type: "editor" });
        }
        on(H, te) {
          this._contextWatchdog.on("itemError", (fe, { itemId: We, causesRestart: ot, error: lt }) => {
            We === this._id && te(null, { error: lt, causesRestart: ot });
          });
        }
        destroy() {
          return Promise.resolve();
        }
        get editor() {
          return this._contextWatchdog.getItem(this._id);
        }
      }
      So.contextType = oh, So.propTypes = { editor: b().func.isRequired, data: b().string, config: b().object, onChange: b().func, onReady: b().func, onFocus: b().func, onBlur: b().func, onError: b().func, disabled: b().bool, onInit: (z, H) => {
        if (z[H])
          return new Error('The "onInit" property is not supported anymore by the CKEditor component. Use the "onReady" property instead.');
      } }, So.defaultProps = { config: {}, onError: (z, H) => console.error(z, H) }, So._EditorWatchdog = rh;
    })(), h;
  })());
})(h1, h1.exports);
var f1 = { exports: {} };
(function(e, n) {
  (function(r) {
    const o = r.en = r.en || {};
    o.dictionary = Object.assign(o.dictionary || {}, { "%0 of %1": "%0 of %1", Aquamarine: "Aquamarine", Black: "Black", "Block quote": "Block quote", Blue: "Blue", Bold: "Bold", "Break text": "Break text", "Bulleted List": "Bulleted List", Cancel: "Cancel", "Cannot determine a category for the uploaded file.": "Cannot determine a category for the uploaded file.", "Cannot upload file:": "Cannot upload file:", "Caption for image: %0": "Caption for image: %0", "Caption for the image": "Caption for the image", "Centered image": "Centered image", "Change image text alternative": "Change image text alternative", "Choose heading": "Choose heading", Column: "Column", "Could not insert image at the current position.": "Could not insert image at the current position.", "Could not obtain resized image URL.": "Could not obtain resized image URL.", "Decrease indent": "Decrease indent", "Delete column": "Delete column", "Delete row": "Delete row", "Dim grey": "Dim grey", Downloadable: "Downloadable", "Dropdown toolbar": "Dropdown toolbar", "Edit block": "Edit block", "Edit link": "Edit link", "Editor block content toolbar": "Editor block content toolbar", "Editor contextual toolbar": "Editor contextual toolbar", "Editor editing area: %0": "Editor editing area: %0", "Editor toolbar": "Editor toolbar", "Enter image caption": "Enter image caption", "Full size image": "Full size image", Green: "Green", Grey: "Grey", "Header column": "Header column", "Header row": "Header row", Heading: "Heading", "Heading 1": "Heading 1", "Heading 2": "Heading 2", "Heading 3": "Heading 3", "Heading 4": "Heading 4", "Heading 5": "Heading 5", "Heading 6": "Heading 6", "Image toolbar": "Image toolbar", "image widget": "image widget", "In line": "In line", "Increase indent": "Increase indent", "Insert column left": "Insert column left", "Insert column right": "Insert column right", "Insert image": "Insert image", "Insert image or file": "Insert image or file", "Insert media": "Insert media", "Insert paragraph after block": "Insert paragraph after block", "Insert paragraph before block": "Insert paragraph before block", "Insert row above": "Insert row above", "Insert row below": "Insert row below", "Insert table": "Insert table", "Inserting image failed": "Inserting image failed", Italic: "Italic", "Left aligned image": "Left aligned image", "Light blue": "Light blue", "Light green": "Light green", "Light grey": "Light grey", Link: "Link", "Link URL": "Link URL", "Media URL": "Media URL", "media widget": "media widget", "Merge cell down": "Merge cell down", "Merge cell left": "Merge cell left", "Merge cell right": "Merge cell right", "Merge cell up": "Merge cell up", "Merge cells": "Merge cells", Next: "Next", "Numbered List": "Numbered List", "Open file manager": "Open file manager", "Open in a new tab": "Open in a new tab", "Open link in new tab": "Open link in new tab", "Open media in new tab": "Open media in new tab", Orange: "Orange", Paragraph: "Paragraph", "Paste the media URL in the input.": "Paste the media URL in the input.", "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget", Previous: "Previous", Purple: "Purple", Red: "Red", Redo: "Redo", "Rich Text Editor": "Rich Text Editor", "Right aligned image": "Right aligned image", Row: "Row", Save: "Save", "Select all": "Select all", "Select column": "Select column", "Select row": "Select row", "Selecting resized image failed": "Selecting resized image failed", "Show more items": "Show more items", "Side image": "Side image", "Split cell horizontally": "Split cell horizontally", "Split cell vertically": "Split cell vertically", "Table toolbar": "Table toolbar", "Text alternative": "Text alternative", "The URL must not be empty.": "The URL must not be empty.", "This link has no URL": "This link has no URL", "This media URL is not supported.": "This media URL is not supported.", "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.", "Toggle caption off": "Toggle caption off", "Toggle caption on": "Toggle caption on", Turquoise: "Turquoise", Undo: "Undo", Unlink: "Unlink", "Upload failed": "Upload failed", "Upload in progress": "Upload in progress", White: "White", "Widget toolbar": "Widget toolbar", "Wrap text": "Wrap text", Yellow: "Yellow" });
  })(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function(r, o) {
    e.exports = o();
  }(self, () => (() => {
    var r = { 3062: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", { version: 3, sources: ["webpack://./../ckeditor5-block-quote/theme/blockquote.css"], names: [], mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-content blockquote {
	/* See #12 */
	overflow: hidden;

	/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */
	padding-right: 1.5em;
	padding-left: 1.5em;

	margin-left: 0;
	margin-right: 0;
	font-style: italic;
	border-left: solid 5px hsl(0, 0%, 80%);
}

.ck-content[dir="rtl"] blockquote {
	border-left: 0;
	border-right: solid 5px hsl(0, 0%, 80%);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 903: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}', "", { version: 3, sources: ["webpack://./../ckeditor5-clipboard/theme/clipboard.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"], names: [], mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-editor__editable {
	/*
	 * Vertical drop target (in text).
	 */
	& .ck.ck-clipboard-drop-target-position {
		display: inline;
		position: relative;
		pointer-events: none;

		& span {
			position: absolute;
			width: 0;
		}
	}

	/*
	 * Styles of the widget being dragged (its preview).
	 */
	& .ck-widget:-webkit-drag {
		& > .ck-widget__selection-handle {
			display: none;
		}

		& > .ck-widget__type-around {
			display: none;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-clipboard-drop-target-dot-width: 12px;
	--ck-clipboard-drop-target-dot-height: 8px;
	--ck-clipboard-drop-target-color: var(--ck-color-focus-border)
}

.ck.ck-editor__editable {
	/*
	 * Vertical drop target (in text).
	 */
	& .ck.ck-clipboard-drop-target-position {
		& span {
			bottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));
			top: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));
			border: 1px solid var(--ck-clipboard-drop-target-color);
			background: var(--ck-clipboard-drop-target-color);
			margin-left: -1px;

			/* The triangle above the marker */
			&::after {
				content: "";
				width: 0;
				height: 0;

				display: block;
				position: absolute;
				left: 50%;
				top: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);

				transform: translateX(-50%);
				border-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;
				border-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));
				border-style: solid;
			}
		}
	}

	/*
	// Horizontal drop target (between blocks).
	& .ck.ck-clipboard-drop-target-position {
		display: block;
		position: relative;
		width: 100%;
		height: 0;
		margin: 0;
		text-align: initial;

		& .ck-clipboard-drop-target__line {
			position: absolute;
			width: 100%;
			height: 0;
			border: 1px solid var(--ck-clipboard-drop-target-color);
			margin-top: -1px;

			&::before {
				content: "";
				width: 0;
				height: 0;

				display: block;
				position: absolute;
				left: calc(-1 * var(--ck-clipboard-drop-target-dot-size));
				top: 0;

				transform: translateY(-50%);
				border-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);
				border-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));
				border-style: solid;
			}

			&::after {
				content: "";
				width: 0;
				height: 0;

				display: block;
				position: absolute;
				right: calc(-1 * var(--ck-clipboard-drop-target-dot-size));
				top: 0;

				transform: translateY(-50%);
				border-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;
				border-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;
				border-style: solid;
			}
		}
	}
	*/

	/*
	 * Styles of the widget that it a drop target.
	 */
	& .ck-widget.ck-clipboard-drop-target-range {
		outline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;
	}

	/*
	 * Styles of the widget being dragged (its preview).
	 */
	& .ck-widget:-webkit-drag {
		zoom: 0.6;
		outline: none !important;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3143: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", { version: 3, sources: ["webpack://./../ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-editor {
	/* All the elements within \`.ck-editor\` are positioned relatively to it.
	 If any element needs to be positioned with respect to the <body>, etc.,
	 it must land outside of the \`.ck-editor\` in DOM. */
	position: relative;

	& .ck-editor__top .ck-sticky-panel .ck-toolbar {
		/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */
		z-index: var(--ck-z-modal);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../mixins/_rounded.css";

.ck.ck-editor__top {
	& .ck-sticky-panel {
		& .ck-toolbar {
			@mixin ck-rounded-corners {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			border-bottom-width: 0;
		}

		& .ck-sticky-panel__content_sticky .ck-toolbar {
			border-bottom-width: 1px;

			@mixin ck-rounded-corners {
				border-radius: 0;
			}
		}
	}
}

/* Note: Use ck-editor__main to make sure these styles don't apply to other editor types */
.ck.ck-editor__main > .ck-editor__editable {
	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */
	background: var(--ck-color-base-background);

	@mixin ck-rounded-corners {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}

	&:not(.ck-focused) {
		border-color: var(--ck-color-base-border);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4717: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}", "", { version: 3, sources: ["webpack://./../ckeditor5-engine/theme/placeholder.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"], names: [], mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* See ckeditor/ckeditor5#936. */
.ck.ck-placeholder,
.ck .ck-placeholder {
	position: relative;

	&::before {
		position: absolute;
		left: 0;
		right: 0;
		content: attr(data-placeholder);

		/* See ckeditor/ckeditor5#469. */
		pointer-events: none;
	}
}

/* See ckeditor/ckeditor5#1987. */
.ck.ck-read-only .ck-placeholder {
	&::before {
		display: none;
	}
}

/*
 * Rules for the \`ck-placeholder\` are loaded before the rules for \`ck-reset_all\` in the base CKEditor 5 DLL build.
 * This fix overwrites the incorrectly set \`position: static\` from \`ck-reset_all\`.
 * See https://github.com/ckeditor/ckeditor5/issues/11418.
 */
.ck.ck-reset_all .ck-placeholder {
	position: relative;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* See ckeditor/ckeditor5#936. */
.ck.ck-placeholder, .ck .ck-placeholder {
	&::before {
		cursor: text;
		color: var(--ck-color-engine-placeholder-text);
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 9315: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-engine/theme/renderer.css"], names: [], mappings: "AAMA,qDACC,YACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* Elements marked by the Renderer as hidden should be invisible in the editor. */
.ck.ck-editor__editable span[data-ck-unsafe-element] {
	display: none;
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 8733: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", { version: 3, sources: ["webpack://./../ckeditor5-heading/theme/heading.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"], names: [], mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-heading_heading1 {
	font-size: 20px;
}

.ck.ck-heading_heading2 {
	font-size: 17px;
}

.ck.ck-heading_heading3 {
	font-size: 14px;
}

.ck[class*="ck-heading_heading"] {
	font-weight: bold;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* Resize dropdown's button label. */
.ck.ck-dropdown.ck-heading-dropdown {
	& .ck-dropdown__button .ck-button__label {
		width: 8em;
	}

	& .ck-dropdown__panel .ck-list__item {
		min-width: 18em;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3508: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/image.css"], names: [], mappings: "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBAuBD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-content {
	& .image {
		display: table;
		clear: both;
		text-align: center;

		/* Make sure there is some space between the content and the image. Center image by default. */
		/* The first value should be equal to --ck-spacing-large variable if used in the editor context
	 	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */
		margin: 0.9em auto;

		/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */
		min-width: 50px;

		& img {
			/* Prevent unnecessary margins caused by line-height (see #44). */
			display: block;

			/* Center the image if its width is smaller than the content's width. */
			margin: 0 auto;

			/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */
			max-width: 100%;

			/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */
			min-width: 100%
		}
	}

	& .image-inline {
		/*
		 * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).
		 * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.
		 * This strange behavior does not happen with inline-flex.
		 */
		display: inline-flex;

		/* While being resized, don't allow the image to exceed the width of the editing root. */
		max-width: 100%;

		/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */
		align-items: flex-start;

		/* When the picture is present it must act as a flex container to let the img resize properly */
		& picture {
			display: flex;
		}

		/* When the picture is present, it must act like a resizable img. */
		& picture,
		& img {
			/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */
			flex-grow: 1;
			flex-shrink: 1;

			/* Prevents overflowing the editing root boundaries when an inline image is very wide. */
			max-width: 100%;
		}
	}
}

.ck.ck-editor__editable {
	/*
	 * Inhertit the content styles padding of the <figcaption> in case the integration overrides \`text-align: center\`
	 * of \`.image\` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native
	 * caret does, and not at the edge of <figcaption>.
	 */
	& .image > figcaption.ck-placeholder::before {
		padding-left: inherit;
		padding-right: inherit;

		/*
		 * Make sure the image caption placeholder doesn't overflow the placeholder area.
		 * See https://github.com/ckeditor/ckeditor5/issues/9162.
		 */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}


	/*
	 * Make sure the selected inline image always stays on top of its siblings.
	 * See https://github.com/ckeditor/ckeditor5/issues/9108.
	 */
	& .image.ck-widget_selected {
		z-index: 1;
	}

	& .image-inline.ck-widget_selected {
		z-index: 1;

		/*
		 * Make sure the native browser selection style is not displayed.
		 * Inline image widgets have their own styles for the selected state and
		 * leaving this up to the browser is asking for a visual collision.
		 */
		& ::selection {
			display: none;
		}
	}

	/* The inline image nested in the table should have its original size if not resized.
	See https://github.com/ckeditor/ckeditor5/issues/9117. */
	& td,
	& th {
		& .image-inline img {
			max-width: none;
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 2640: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imagecaption.css"], names: [], mappings: "AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAMD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-image-caption-background: hsl(0, 0%, 97%);
	--ck-color-image-caption-text: hsl(0, 0%, 20%);
	--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);
}

/* Content styles */
.ck-content .image > figcaption {
	display: table-caption;
	caption-side: bottom;
	word-break: break-word;
	color: var(--ck-color-image-caption-text);
	background-color: var(--ck-color-image-caption-background);
	padding: .6em;
	font-size: .75em;
	outline-offset: -1px;
}

/* Editing styles */
.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {
	animation: ck-image-caption-highlight .6s ease-out;
}

@keyframes ck-image-caption-highlight {
	0% {
		background-color: var(--ck-color-image-caption-highligted-background);
	}

	100% {
		background-color: var(--ck-color-image-caption-background);
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 5083: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imagestyle.css"], names: [], mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-image-style-spacing: 1.5em;
	--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
}

.ck-content {
	/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback
	confirming successful application of the style if image width exceeds the editor's size.
	See https://github.com/ckeditor/ckeditor5/issues/9342 */
	& .image-style-block-align-left,
	& .image-style-block-align-right {
		max-width: calc(100% - var(--ck-image-style-spacing));
	}

	/* Allows displaying multiple floating images in the same line.
	See https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */
	& .image-style-align-left,
	& .image-style-align-right {
		clear: none;
	}

	& .image-style-side {
		float: right;
		margin-left: var(--ck-image-style-spacing);
		max-width: 50%;
	}

	& .image-style-align-left {
		float: left;
		margin-right: var(--ck-image-style-spacing);
	}

	& .image-style-align-center {
		margin-left: auto;
		margin-right: auto;
	}

	& .image-style-align-right {
		float: right;
		margin-left: var(--ck-image-style-spacing);
	}

	& .image-style-block-align-right {
		margin-right: 0;
		margin-left: auto;
	}

	& .image-style-block-align-left {
		margin-left: 0;
		margin-right: auto;
	}

	/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */
	& p + .image-style-align-left,
	& p + .image-style-align-right,
	& p + .image-style-side {
		margin-top: 0;
	}

	& .image-inline {
		&.image-style-align-left,
		&.image-style-align-right {
			margin-top: var(--ck-inline-image-style-spacing);
			margin-bottom: var(--ck-inline-image-style-spacing);
		}

		&.image-style-align-left {
			margin-right: var(--ck-inline-image-style-spacing);
		}

		&.image-style-align-right {
			margin-left: var(--ck-inline-image-style-spacing);
		}
	}
}

.ck.ck-splitbutton {
	/* The button should display as a regular drop-down if the action button
	is forced to fire the same action as the arrow button. */
	&.ck-splitbutton_flatten {
		&:hover,
		&.ck-splitbutton_open {
			& > .ck-splitbutton__action:not(.ck-disabled),
			& > .ck-splitbutton__arrow:not(.ck-disabled),
			& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {
				background-color: var(--ck-color-button-on-background);

				&::after {
					display: none;
				}
			}
		}

		&.ck-splitbutton_open:hover {
			& > .ck-splitbutton__action:not(.ck-disabled),
			& > .ck-splitbutton__arrow:not(.ck-disabled),
			& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {
				background-color: var(--ck-color-button-on-hover-background);
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4036: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}', "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadicon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"], names: [], mappings: "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFA0BD,CAtBC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-image-upload-complete-icon {
	display: block;
	position: absolute;

	/*
	 * Smaller images should have the icon closer to the border.
	 * Match the icon position with the linked image indicator brought by the link image feature.
	 */
	top: min(var(--ck-spacing-medium), 6%);
	right: min(var(--ck-spacing-medium), 6%);
	border-radius: 50%;
	z-index: 1;

	&::after {
		content: "";
		position: absolute;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-image-upload-icon: hsl(0, 0%, 100%);
	--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);

	/* Match the icon size with the linked image indicator brought by the link image feature. */
	--ck-image-upload-icon-size: 20;
	--ck-image-upload-icon-width: 2px;
	--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);
}

.ck-image-upload-complete-icon {
	opacity: 0;
	background: var(--ck-color-image-upload-icon-background);
	animation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;
	animation-fill-mode: forwards, forwards;
	animation-duration: 500ms, 500ms;

	/* To make animation scalable. */
	font-size: calc(1px * var(--ck-image-upload-icon-size));

	/* Hide completed upload icon after 3 seconds. */
	animation-delay: 0ms, 3000ms;

	/*
	 * Use CSS math to simulate container queries.
	 * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things
	 */
	overflow: hidden;
	width: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));
	height: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));

	/* This is check icon element made from border-width mixed with animations. */
	&::after {
		/* Because of border transformation we need to "hard code" left position. */
		left: 25%;

		top: 50%;
		opacity: 0;
		height: 0;
		width: 0;

		transform: scaleX(-1) rotate(135deg);
		transform-origin: left top;
		border-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);
		border-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);

		animation-name: ck-upload-complete-icon-check;
		animation-duration: 500ms;
		animation-delay: 500ms;
		animation-fill-mode: forwards;

		/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */
		box-sizing: border-box;
	}
}

@keyframes ck-upload-complete-icon-show {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@keyframes ck-upload-complete-icon-hide {
	from {
		opacity: 1;
	}

	to {
		opacity: 0;
	}
}

@keyframes ck-upload-complete-icon-check {
	0% {
		opacity: 1;
		width: 0;
		height: 0;
	}
	33% {
		width: 0.3em;
		height: 0;
	}
	100% {
		opacity: 1;
		width: 0.3em;
		height: 0.45em;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3773: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadloader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"], names: [], mappings: "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-upload-placeholder-loader {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0;
	left: 0;

	&::before {
		content: '';
		position: relative;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);
	--ck-upload-placeholder-loader-size: 32px;
	--ck-upload-placeholder-image-aspect-ratio: 2.8;
}

.ck .ck-image-upload-placeholder {
	/* We need to control the full width of the SVG gray background. */
	width: 100%;
	margin: 0;

	&.image-inline {
		width: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );
	}

	& img {
		/*
		 * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.
		 * There's nothing special about this number except that it should make the image placeholder look like
		 * a real image during this short period after the upload started and before the image was read from the
		 * file system (and a rich preview was loaded).
		 */
		aspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);
	}
}

.ck .ck-upload-placeholder-loader {
	width: 100%;
	height: 100%;

	&::before {
		width: var(--ck-upload-placeholder-loader-size);
		height: var(--ck-upload-placeholder-loader-size);
		border-radius: 50%;
		border-top: 3px solid var(--ck-color-upload-placeholder-loader);
		border-right: 2px solid transparent;
		animation: ck-upload-placeholder-loader 1s linear infinite;
	}
}

@keyframes ck-upload-placeholder-loader {
	to {
		transform: rotate( 360deg );
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3689: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadprogress.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"], names: [], mappings: "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBACD,CAID,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-editor__editable {
	& .image,
	& .image-inline {
		position: relative;
	}

	/* Upload progress bar. */
	& .image .ck-progress-bar,
	& .image-inline .ck-progress-bar {
		position: absolute;
		top: 0;
		left: 0;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-editor__editable {
	& .image,
	& .image-inline {
		/* Showing animation. */
		&.ck-appear {
			animation: fadeIn 700ms;
		}
	}

	/* Upload progress bar. */
	& .image .ck-progress-bar,
	& .image-inline .ck-progress-bar {
		height: 2px;
		width: 0;
		background: var(--ck-color-upload-bar-background);
		transition: width 100ms;
	}
}

@keyframes fadeIn {
	from { opacity: 0; }
	to   { opacity: 1; }
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 1905: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/textalternativeform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"], names: [], mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-text-alternative-form {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;

	& .ck-labeled-field-view {
		display: inline-block;
	}

	& .ck-label {
		display: none;
	}

	@mixin ck-media-phone {
		flex-wrap: wrap;

		& .ck-labeled-field-view {
			flex-basis: 100%;
		}

		& .ck-button {
			flex-basis: 50%;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@define-mixin ck-media-phone {
	@media screen and (max-width: 600px) {
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 9773: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/link.css"], names: [], mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* Class added to span element surrounding currently selected link. */
.ck .ck-link_selected {
	background: var(--ck-color-link-selected-background);

	/* Give linked inline images some outline to let the user know they are also part of the link. */
	& span.image-inline {
		outline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);
	}
}

/*
 * Classes used by the "fake visual selection" displayed in the content when an input
 * in the link UI has focus (the browser does not render the native selection in this state).
 */
.ck .ck-fake-link-selection {
	background: var(--ck-color-link-fake-selection);
}

/* A collapsed fake visual selection. */
.ck .ck-fake-link-selection_collapsed {
	height: 100%;
	border-right: 1px solid var(--ck-color-base-text);
	margin-right: -1px;
	outline: solid 1px hsla(0, 0%, 100%, .5);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 2347: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", { version: 3, sources: ["webpack://./../ckeditor5-link/theme/linkactions.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"], names: [], mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-link-actions {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;

	& .ck-link-actions__preview {
		display: inline-block;

		& .ck-button__label {
			overflow: hidden;
		}
	}

	@mixin ck-media-phone {
		flex-wrap: wrap;

		& .ck-link-actions__preview {
			flex-basis: 100%;
		}

		& .ck-button:not(.ck-link-actions__preview) {
			flex-basis: 50%;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@define-mixin ck-media-phone {
	@media screen and (max-width: 600px) {
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";
@import "../mixins/_focus.css";
@import "../mixins/_shadow.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-link-actions {
	& .ck-button.ck-link-actions__preview {
		padding-left: 0;
		padding-right: 0;

		& .ck-button__label {
			padding: 0 var(--ck-spacing-medium);
			color: var(--ck-color-link-default);
			text-overflow: ellipsis;
			cursor: pointer;

			/* Match the box model of the link editor form's input so the balloon
			does not change width when moving between actions and the form. */
			max-width: var(--ck-input-width);
			min-width: 3em;
			text-align: center;

			&:hover {
				text-decoration: underline;
			}
		}

		&,
		&:hover,
		&:focus,
		&:active {
			background: none;
		}

		&:active {
			box-shadow: none;
		}

		&:focus {
			& .ck-button__label {
				text-decoration: underline;
			}
		}
	}

	@mixin ck-dir ltr {
		& .ck-button:not(:first-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-dir rtl {
		& .ck-button:not(:last-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-media-phone {
		& .ck-button.ck-link-actions__preview {
			margin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;

			& .ck-button__label {
				min-width: 0;
				max-width: 100%;
			}
		}

		& .ck-button:not(.ck-link-actions__preview) {
			@mixin ck-dir ltr {
				margin-left: 0;
			}

			@mixin ck-dir rtl {
				margin-left: 0;
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 7754: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-link/theme/linkform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"], names: [], mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-link-form {
	display: flex;

	& .ck-label {
		display: none;
	}

	@mixin ck-media-phone {
		flex-wrap: wrap;

		& .ck-labeled-field-view {
			flex-basis: 100%;
		}

		& .ck-button {
			flex-basis: 50%;
		}
	}
}

/*
 * Style link form differently when manual decorators are available.
 * See: https://github.com/ckeditor/ckeditor5-link/issues/186.
 */
.ck.ck-link-form_layout-vertical {
	display: block;

	/*
	 * Whether the form is in the responsive mode or not, if there are decorator buttons
	 * keep the top margin of action buttons medium.
	 */
	& .ck-button {
		&.ck-button-save,
		&.ck-button-cancel {
			margin-top: var(--ck-spacing-medium);
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@define-mixin ck-media-phone {
	@media screen and (max-width: 600px) {
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

/*
 * Style link form differently when manual decorators are available.
 * See: https://github.com/ckeditor/ckeditor5-link/issues/186.
 */
.ck.ck-link-form_layout-vertical {
	padding: 0;
	min-width: var(--ck-input-width);

	& .ck-labeled-field-view {
		margin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);

		& .ck-input-text {
			min-width: 0;
			width: 100%;
		}
	}

	& > .ck-button {
		padding: var(--ck-spacing-standard);
		margin: 0;
		width: 50%;
		border-radius: 0;

		&:not(:focus) {
			border-top: 1px solid var(--ck-color-base-border);
		}

		@mixin ck-dir ltr {
			margin-left: 0;
		}

		@mixin ck-dir rtl {
			margin-left: 0;

			&:last-of-type {
				border-right: 1px solid var(--ck-color-base-border);
			}
		}
	}

	/* Using additional \`.ck\` class for stronger CSS specificity than \`.ck.ck-link-form > :not(:first-child)\`. */
	& .ck.ck-list {
		margin: var(--ck-spacing-standard) var(--ck-spacing-large);

		& .ck-button.ck-switchbutton {
			padding: 0;
			width: 100%;

			&:hover {
				background: none;
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4652: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembed.css"], names: [], mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-content .media {
	/* Don't allow floated content overlap the media.
	https://github.com/ckeditor/ckeditor5-media-embed/issues/53 */
	clear: both;

	/* Make sure there is some space between the content and the media. */
	/* The first value should be equal to --ck-spacing-large variable if used in the editor context
	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */
	margin: 0.9em 0;

	/* Make sure media is not overriden with Bootstrap default \`flex\` value.
	See: https://github.com/ckeditor/ckeditor5/issues/1373. */
	display: block;

	/* Give the media some minimal width in the content to prevent them
	from being "squashed" in tight spaces, e.g. in table cells (#44) */
	min-width: 15em;
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 7442: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"], names: [], mappings: "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wiCACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-media__wrapper {
	& .ck-media__placeholder {
		display: flex;
		flex-direction: column;
		align-items: center;

		& .ck-media__placeholder__url {
			/* Otherwise the URL will overflow when the content is very narrow. */
			max-width: 100%;

			position: relative;

			& .ck-media__placeholder__url__text {
				overflow: hidden;
				display: block;
			}
		}
	}

	&[data-oembed-url*="twitter.com"],
	&[data-oembed-url*="google.com/maps"],
	&[data-oembed-url*="goo.gl/maps"],
	&[data-oembed-url*="maps.google.com"],
	&[data-oembed-url*="maps.app.goo.gl"],
	&[data-oembed-url*="facebook.com"],
	&[data-oembed-url*="instagram.com"] {
		& .ck-media__placeholder__icon * {
			display: none;
		}
	}
}

/* Disable all mouse interaction as long as the editor is not read\u2013only.
   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */
.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {
	pointer-events: none;
}

/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).
   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */
.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {
	pointer-events: none;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-media-embed-placeholder-icon-size: 3em;

	--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);
	--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);
}

.ck-media__wrapper {
	margin: 0 auto;

	& .ck-media__placeholder {
		padding: calc( 3 * var(--ck-spacing-standard) );
		background: var(--ck-color-base-foreground);

		& .ck-media__placeholder__icon {
			min-width: var(--ck-media-embed-placeholder-icon-size);
			height: var(--ck-media-embed-placeholder-icon-size);
			margin-bottom: var(--ck-spacing-large);
			background-position: center;
			background-size: cover;

			& .ck-icon {
				width: 100%;
				height: 100%;
			}
		}

		& .ck-media__placeholder__url__text {
			color: var(--ck-color-media-embed-placeholder-url-text);
			white-space: nowrap;
			text-align: center;
			font-style: italic;
			text-overflow: ellipsis;

			&:hover {
				color: var(--ck-color-media-embed-placeholder-url-text-hover);
				cursor: pointer;
				text-decoration: underline;
			}
		}
	}

	&[data-oembed-url*="open.spotify.com"] {
		max-width: 300px;
		max-height: 380px;
	}

	&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,
	&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,
	&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,
	&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {
		background-image: url(data:image/svg+xml;base64,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);
	}

	&[data-oembed-url*="facebook.com"] .ck-media__placeholder {
		background: hsl(220, 46%, 48%);

		& .ck-media__placeholder__icon {
			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);
		}

		& .ck-media__placeholder__url__text {
			color: hsl(220, 100%, 90%);

			&:hover {
				color: hsl(0, 0%, 100%);
			}
		}
	}

	&[data-oembed-url*="instagram.com"] .ck-media__placeholder {
		background: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));

		& .ck-media__placeholder__icon {
			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI1MDRweCIgaGVpZ2h0PSI1MDRweCIgdmlld0JveD0iMCAwIDUwNCA1MDQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+Z2x5cGgtbG9nb19NYXkyMDE2PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMSIgcG9pbnRzPSIwIDAuMTU5IDUwMy44NDEgMC4xNTkgNTAzLjg0MSA1MDMuOTQgMCA1MDMuOTQiPjwvcG9seWdvbj4gICAgPC9kZWZzPiAgICA8ZyBpZD0iZ2x5cGgtbG9nb19NYXkyMDE2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJHcm91cC0zIj4gICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+ICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+ICAgICAgICAgICAgPC9tYXNrPiAgICAgICAgICAgIDxnIGlkPSJDbGlwLTIiPjwvZz4gICAgICAgICAgICA8cGF0aCBkPSJNMjUxLjkyMSwwLjE1OSBDMTgzLjUwMywwLjE1OSAxNzQuOTI0LDAuNDQ5IDE0OC4wNTQsMS42NzUgQzEyMS4yNCwyLjg5OCAxMDIuOTI3LDcuMTU3IDg2LjkwMywxMy4zODUgQzcwLjMzNywxOS44MjIgNTYuMjg4LDI4LjQzNiA0Mi4yODIsNDIuNDQxIEMyOC4yNzcsNTYuNDQ3IDE5LjY2Myw3MC40OTYgMTMuMjI2LDg3LjA2MiBDNi45OTgsMTAzLjA4NiAyLjczOSwxMjEuMzk5IDEuNTE2LDE0OC4yMTMgQzAuMjksMTc1LjA4MyAwLDE4My42NjIgMCwyNTIuMDggQzAsMzIwLjQ5NyAwLjI5LDMyOS4wNzYgMS41MTYsMzU1Ljk0NiBDMi43MzksMzgyLjc2IDYuOTk4LDQwMS4wNzMgMTMuMjI2LDQxNy4wOTcgQzE5LjY2Myw0MzMuNjYzIDI4LjI3Nyw0NDcuNzEyIDQyLjI4Miw0NjEuNzE4IEM1Ni4yODgsNDc1LjcyMyA3MC4zMzcsNDg0LjMzNyA4Ni45MDMsNDkwLjc3NSBDMTAyLjkyNyw0OTcuMDAyIDEyMS4yNCw1MDEuMjYxIDE0OC4wNTQsNTAyLjQ4NCBDMTc0LjkyNCw1MDMuNzEgMTgzLjUwMyw1MDQgMjUxLjkyMSw1MDQgQzMyMC4zMzgsNTA0IDMyOC45MTcsNTAzLjcxIDM1NS43ODcsNTAyLjQ4NCBDMzgyLjYwMSw1MDEuMjYxIDQwMC45MTQsNDk3LjAwMiA0MTYuOTM4LDQ5MC43NzUgQzQzMy41MDQsNDg0LjMzNyA0NDcuNTUzLDQ3NS43MjMgNDYxLjU1OSw0NjEuNzE4IEM0NzUuNTY0LDQ0Ny43MTIgNDg0LjE3OCw0MzMuNjYzIDQ5MC42MTYsNDE3LjA5NyBDNDk2Ljg0Myw0MDEuMDczIDUwMS4xMDIsMzgyLjc2IDUwMi4zMjUsMzU1Ljk0NiBDNTAzLjU1MSwzMjkuMDc2IDUwMy44NDEsMzIwLjQ5NyA1MDMuODQxLDI1Mi4wOCBDNTAzLjg0MSwxODMuNjYyIDUwMy41NTEsMTc1LjA4MyA1MDIuMzI1LDE0OC4yMTMgQzUwMS4xMDIsMTIxLjM5OSA0OTYuODQzLDEwMy4wODYgNDkwLjYxNiw4Ny4wNjIgQzQ4NC4xNzgsNzAuNDk2IDQ3NS41NjQsNTYuNDQ3IDQ2MS41NTksNDIuNDQxIEM0NDcuNTUzLDI4LjQzNiA0MzMuNTA0LDE5LjgyMiA0MTYuOTM4LDEzLjM4NSBDNDAwLjkxNCw3LjE1NyAzODIuNjAxLDIuODk4IDM1NS43ODcsMS42NzUgQzMyOC45MTcsMC40NDkgMzIwLjMzOCwwLjE1OSAyNTEuOTIxLDAuMTU5IFogTTI1MS45MjEsNDUuNTUgQzMxOS4xODYsNDUuNTUgMzI3LjE1NCw0NS44MDcgMzUzLjcxOCw0Ny4wMTkgQzM3OC4yOCw0OC4xMzkgMzkxLjYxOSw1Mi4yNDMgNDAwLjQ5Niw1NS42OTMgQzQxMi4yNTUsNjAuMjYzIDQyMC42NDcsNjUuNzIyIDQyOS40NjIsNzQuNTM4IEM0MzguMjc4LDgzLjM1MyA0NDMuNzM3LDkxLjc0NSA0NDguMzA3LDEwMy41MDQgQzQ1MS43NTcsMTEyLjM4MSA0NTUuODYxLDEyNS43MiA0NTYuOTgxLDE1MC4yODIgQzQ1OC4xOTMsMTc2Ljg0NiA0NTguNDUsMTg0LjgxNCA0NTguNDUsMjUyLjA4IEM0NTguNDUsMzE5LjM0NSA0NTguMTkzLDMyNy4zMTMgNDU2Ljk4MSwzNTMuODc3IEM0NTUuODYxLDM3OC40MzkgNDUxLjc1NywzOTEuNzc4IDQ0OC4zMDcsNDAwLjY1NSBDNDQzLjczNyw0MTIuNDE0IDQzOC4yNzgsNDIwLjgwNiA0MjkuNDYyLDQyOS42MjEgQzQyMC42NDcsNDM4LjQzNyA0MTIuMjU1LDQ0My44OTYgNDAwLjQ5Niw0NDguNDY2IEMzOTEuNjE5LDQ1MS45MTYgMzc4LjI4LDQ1Ni4wMiAzNTMuNzE4LDQ1Ny4xNCBDMzI3LjE1OCw0NTguMzUyIDMxOS4xOTEsNDU4LjYwOSAyNTEuOTIxLDQ1OC42MDkgQzE4NC42NSw0NTguNjA5IDE3Ni42ODQsNDU4LjM1MiAxNTAuMTIzLDQ1Ny4xNCBDMTI1LjU2MSw0NTYuMDIgMTEyLjIyMiw0NTEuOTE2IDEwMy4zNDUsNDQ4LjQ2NiBDOTEuNTg2LDQ0My44OTYgODMuMTk0LDQzOC40MzcgNzQuMzc5LDQyOS42MjEgQzY1LjU2NCw0MjAuODA2IDYwLjEwNCw0MTIuNDE0IDU1LjUzNCw0MDAuNjU1IEM1Mi4wODQsMzkxLjc3OCA0Ny45OCwzNzguNDM5IDQ2Ljg2LDM1My44NzcgQzQ1LjY0OCwzMjcuMzEzIDQ1LjM5MSwzMTkuMzQ1IDQ1LjM5MSwyNTIuMDggQzQ1LjM5MSwxODQuODE0IDQ1LjY0OCwxNzYuODQ2IDQ2Ljg2LDE1MC4yODIgQzQ3Ljk4LDEyNS43MiA1Mi4wODQsMTEyLjM4MSA1NS41MzQsMTAzLjUwNCBDNjAuMTA0LDkxLjc0NSA2NS41NjMsODMuMzUzIDc0LjM3OSw3NC41MzggQzgzLjE5NCw2NS43MjIgOTEuNTg2LDYwLjI2MyAxMDMuMzQ1LDU1LjY5MyBDMTEyLjIyMiw1Mi4yNDMgMTI1LjU2MSw0OC4xMzkgMTUwLjEyMyw0Ny4wMTkgQzE3Ni42ODcsNDUuODA3IDE4NC42NTUsNDUuNTUgMjUxLjkyMSw0NS41NSBaIiBpZD0iRmlsbC0xIiBmaWxsPSIjRkZGRkZGIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgICAgIDxwYXRoIGQ9Ik0yNTEuOTIxLDMzNi4wNTMgQzIwNS41NDMsMzM2LjA1MyAxNjcuOTQ3LDI5OC40NTcgMTY3Ljk0NywyNTIuMDggQzE2Ny45NDcsMjA1LjcwMiAyMDUuNTQzLDE2OC4xMDYgMjUxLjkyMSwxNjguMTA2IEMyOTguMjk4LDE2OC4xMDYgMzM1Ljg5NCwyMDUuNzAyIDMzNS44OTQsMjUyLjA4IEMzMzUuODk0LDI5OC40NTcgMjk4LjI5OCwzMzYuMDUzIDI1MS45MjEsMzM2LjA1MyBaIE0yNTEuOTIxLDEyMi43MTUgQzE4MC40NzQsMTIyLjcxNSAxMjIuNTU2LDE4MC42MzMgMTIyLjU1NiwyNTIuMDggQzEyMi41NTYsMzIzLjUyNiAxODAuNDc0LDM4MS40NDQgMjUxLjkyMSwzODEuNDQ0IEMzMjMuMzY3LDM4MS40NDQgMzgxLjI4NSwzMjMuNTI2IDM4MS4yODUsMjUyLjA4IEMzODEuMjg1LDE4MC42MzMgMzIzLjM2NywxMjIuNzE1IDI1MS45MjEsMTIyLjcxNSBaIiBpZD0iRmlsbC00IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgICAgICA8cGF0aCBkPSJNNDE2LjYyNywxMTcuNjA0IEM0MTYuNjI3LDEzNC4zIDQwMy4wOTIsMTQ3LjgzNCAzODYuMzk2LDE0Ny44MzQgQzM2OS43MDEsMTQ3LjgzNCAzNTYuMTY2LDEzNC4zIDM1Ni4xNjYsMTE3LjYwNCBDMzU2LjE2NiwxMDAuOTA4IDM2OS43MDEsODcuMzczIDM4Ni4zOTYsODcuMzczIEM0MDMuMDkyLDg3LjM3MyA0MTYuNjI3LDEwMC45MDggNDE2LjYyNywxMTcuNjA0IiBpZD0iRmlsbC01IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgIDwvZz48L3N2Zz4=);
		}

		/* stylelint-disable-next-line no-descending-specificity */
		& .ck-media__placeholder__url__text {
			color: hsl(302, 100%, 94%);

			&:hover {
				color: hsl(0, 0%, 100%);
			}
		}
	}

	&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {
		/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */
		background: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );

		& .ck-media__placeholder__icon {
			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);
		}

		& .ck-media__placeholder__url__text {
			color: hsl(201, 100%, 86%);

			&:hover {
				color: hsl(0, 0%, 100%);
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 9292: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"], names: [], mappings: "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-media-form {
	display: flex;
	align-items: flex-start;
	flex-direction: row;
	flex-wrap: nowrap;

	& .ck-labeled-field-view {
		display: inline-block;
	}

	& .ck-label {
		display: none;
	}

	@mixin ck-media-phone {
		flex-wrap: wrap;

		& .ck-labeled-field-view {
			flex-basis: 100%;
		}

		& .ck-button {
			flex-basis: 50%;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@define-mixin ck-media-phone {
	@media screen and (max-width: 600px) {
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 1613: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/inserttable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"], names: [], mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAUD,CARC,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-insert-table-dropdown__grid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-insert-table-dropdown-padding: 10px;
	--ck-insert-table-dropdown-box-height: 11px;
	--ck-insert-table-dropdown-box-width: 12px;
	--ck-insert-table-dropdown-box-margin: 1px;
}

.ck .ck-insert-table-dropdown__grid {
	/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */
	width: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);
	padding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;
}

.ck .ck-insert-table-dropdown__label,
.ck[dir=rtl] .ck-insert-table-dropdown__label {
	text-align: center;
}

.ck .ck-insert-table-dropdown-grid-box {
	min-width: var(--ck-insert-table-dropdown-box-width);
	min-height: var(--ck-insert-table-dropdown-box-height);
	margin: var(--ck-insert-table-dropdown-box-margin);
	border: 1px solid var(--ck-color-base-border);
	border-radius: 1px;
	outline: none;
	transition: none;

	&:focus {
		box-shadow: none;
	}

	&.ck-on {
		border-color: var(--ck-color-focus-border);
		background: var(--ck-color-focus-outer-shadow);
	}
}

`], sourceRoot: "" }]);
      const _ = k;
    }, 6306: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/table.css"], names: [], mappings: "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-content .table {
	/* Give the table widget some air and center it horizontally */
	/* The first value should be equal to --ck-spacing-large variable if used in the editor context
	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */
	margin: 0.9em auto;
	display: table;

	& table {
		/* The table cells should have slight borders */
		border-collapse: collapse;
		border-spacing: 0;

		/* Table width and height are set on the parent <figure>. Make sure the table inside stretches
		to the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */
		width: 100%;
		height: 100%;

		/* The outer border of the table should be slightly darker than the inner lines.
		Also see https://github.com/ckeditor/ckeditor5-table/issues/50. */
		border: 1px double hsl(0, 0%, 70%);

		& td,
		& th {
			min-width: 2em;
			padding: .4em;

			/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it's not necessary here.
			However, the border is a content style, so it should use .ck-content (so it works outside the editor).
			Hence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */
			border: 1px solid hsl(0, 0%, 75%);
		}

		& th {
			font-weight: bold;
			background: hsla(0, 0%, 0%, 5%);
		}
	}
}

/* Text alignment of the table header should match the editor settings and override the native browser styling,
when content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */
.ck-content[dir="rtl"] .table th {
	text-align: right;
}

.ck-content[dir="ltr"] .table th {
	text-align: left;
}

.ck-editor__editable .ck-table-bogus-paragraph {
	/*
	 * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.
	 * See https://github.com/ckeditor/ckeditor5/issues/6062.
	 */
	display: inline-block;

	/*
	 * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.
	 * See https://github.com/ckeditor/ckeditor5/issues/9117.
	 */
	width: 100%;
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3881: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-color-table-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"], names: [], mappings: "AAKA,MACC,6DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-table-focused-cell-background: hsla(212, 90%, 80%, .3);
}

.ck-widget.table {
	& td,
	& th {
		&.ck-editor__nested-editable.ck-editor__nested-editable_focused,
		&.ck-editor__nested-editable:focus {
			/* A very slight background to highlight the focused cell */
			background: var(--ck-color-table-focused-cell-background);

			/* Fixes the problem where surrounding cells cover the focused cell's border.
			It does not fix the problem in all places but the UX is improved.
			See https://github.com/ckeditor/ckeditor5-table/issues/29. */
			border-style: none;
			outline: 1px solid var(--ck-color-focus-border);
			outline-offset: -1px; /* progressive enhancement - no IE support */
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 6945: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"], names: [], mappings: "AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);
}

.ck.ck-editor__editable .table table {
	& td.ck-editor__editable_selected,
	& th.ck-editor__editable_selected {
		position: relative;
		caret-color: transparent;
		outline: unset;
		box-shadow: unset;

		/* https://github.com/ckeditor/ckeditor5/issues/6446 */
		&:after {
			content: '';
			pointer-events: none;
			background-color: var(--ck-table-selected-cell-background);
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}

		& ::selection,
		&:focus {
			background-color: transparent;
		}

		/*
		 * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.
		 * See https://github.com/ckeditor/ckeditor5/issues/9491.
		 */
		& .ck-widget {
			outline: unset;

			& > .ck-widget__selection-handle {
				display: none;
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4906: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;justify-content:left;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/button/button.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AAOA,6BAMC,kBAAmB,CADnB,mBAAoB,CAEpB,oBAAqB,CAHrB,iBAAkB,CCFlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDkBD,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEjBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../mixins/_unselectable.css";

.ck.ck-button,
a.ck.ck-button {
	@mixin ck-unselectable;

	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: left;

	& .ck-button__label {
		display: none;
	}

	&.ck-button_with-text {
		& .ck-button__label {
			display: inline-block;
		}
	}

	/* Center the icon horizontally in a button without text. */
	&:not(.ck-button_with-text)  {
		justify-content: center;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Makes element unselectable.
 */
@define-mixin ck-unselectable {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_focus.css";
@import "../../../mixins/_shadow.css";
@import "../../../mixins/_disabled.css";
@import "../../../mixins/_rounded.css";
@import "../../mixins/_button.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

.ck.ck-button,
a.ck.ck-button {
	@mixin ck-button-colors --ck-color-button-default;
	@mixin ck-rounded-corners;

	white-space: nowrap;
	cursor: default;
	vertical-align: middle;
	padding: var(--ck-spacing-tiny);
	text-align: center;

	/* A very important piece of styling. Go to variable declaration to learn more. */
	min-width: var(--ck-ui-component-min-height);
	min-height: var(--ck-ui-component-min-height);

	/* Normalize the height of the line. Removing this will break consistent height
	among text and text-less buttons (with icons). */
	line-height: 1;

	/* Enable font size inheritance, which allows fluid UI scaling. */
	font-size: inherit;

	/* Avoid flickering when the foucs border shows up. */
	border: 1px solid transparent;

	/* Apply some smooth transition to the box-shadow and border. */
	transition: box-shadow .2s ease-in-out, border .2s ease-in-out;

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */
	-webkit-appearance: none;

	&:active,
	&:focus {
		@mixin ck-focus-ring;
		@mixin ck-box-shadow var(--ck-focus-outer-shadow);
	}

	/* Allow icon coloring using the text "color" property. */
	& .ck-button__icon {
		& use,
		& use * {
			color: inherit;
		}
	}

	& .ck-button__label {
		/* Enable font size inheritance, which allows fluid UI scaling. */
		font-size: inherit;
		font-weight: inherit;
		color: inherit;
		cursor: inherit;

		/* Must be consistent with .ck-icon's vertical align. Otherwise, buttons with and
		without labels (but with icons) have different sizes in Chrome */
		vertical-align: middle;

		@mixin ck-dir ltr {
			text-align: left;
		}

		@mixin ck-dir rtl {
			text-align: right;
		}
	}

	& .ck-button__keystroke {
		color: inherit;

		@mixin ck-dir ltr {
			margin-left: var(--ck-spacing-large);
		}

		@mixin ck-dir rtl {
			margin-right: var(--ck-spacing-large);
		}

		font-weight: bold;
		opacity: .7;
	}

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */
	&.ck-disabled {
		&:active,
		&:focus {
			/* The disabled button should have a slightly less visible shadow when focused. */
			@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);
		}

		& .ck-button__icon {
			@mixin ck-disabled;
		}

		/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */
		& .ck-button__label {
			@mixin ck-disabled;
		}

		& .ck-button__keystroke {
			opacity: .3;
		}
	}

	&.ck-button_with-text {
		padding: var(--ck-spacing-tiny) var(--ck-spacing-standard);

		/* stylelint-disable-next-line no-descending-specificity */
		& .ck-button__icon {
			@mixin ck-dir ltr {
				margin-left: calc(-1 * var(--ck-spacing-small));
				margin-right: var(--ck-spacing-small);
			}

			@mixin ck-dir rtl {
				margin-right: calc(-1 * var(--ck-spacing-small));
				margin-left: var(--ck-spacing-small);
			}
		}
	}

	&.ck-button_with-keystroke {
		/* stylelint-disable-next-line no-descending-specificity */
		& .ck-button__label {
			flex-grow: 1;
		}
	}

	/* A style of the button which is currently on, e.g. its feature is active. */
	&.ck-on {
		@mixin ck-button-colors --ck-color-button-on;

		color: var(--ck-color-button-on-color);
	}

	&.ck-button-save {
		color: var(--ck-color-button-save);
	}

	&.ck-button-cancel {
		color: var(--ck-color-button-cancel);
	}
}

/* A style of the button which handles the primary action. */
.ck.ck-button-action,
a.ck.ck-button-action {
	@mixin ck-button-colors --ck-color-button-action;

	color: var(--ck-color-button-action-text);
}

.ck.ck-button-bold,
a.ck.ck-button-bold {
	font-weight: bold;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements a button of given background color.
 *
 * @param {String} $background - Background color of the button.
 * @param {String} $border - Border color of the button.
 */
@define-mixin ck-button-colors $prefix {
	background: var($(prefix)-background);

	&:not(.ck-disabled) {
		&:hover {
			background: var($(prefix)-hover-background);
		}

		&:active {
			background: var($(prefix)-active-background);
		}
	}

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */
	&.ck-disabled {
		background: var($(prefix)-disabled-background);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A visual style of focused element's border.
 */
@define-mixin ck-focus-ring {
	/* Disable native outline. */
	outline: none;
	border: var(--ck-focus-ring)
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A class which indicates that an element holding it is disabled.
 */
@define-mixin ck-disabled {
	opacity: var(--ck-disabled-opacity);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 5332: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eD4EA,CAxCA,yIChCC,qCDwED,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2ECxDD,eDmEC,CAXA,6LCpDA,qCAAsC,CDsDpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEhFA,kCFkFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-button.ck-switchbutton {
	& .ck-button__toggle {
		display: block;

		& .ck-button__toggle__inner {
			display: block;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_disabled.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature
of the component, floating\u2013point numbers have been used which, for the default font size
(see: --ck-font-size-base), will generate simple integers. */
:root {
	/* 34px at 13px font-size */
	--ck-switch-button-toggle-width: 2.6153846154em;
	/* 14px at 13px font-size */
	--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);
	--ck-switch-button-translation: calc(
		var(--ck-switch-button-toggle-width) -
		var(--ck-switch-button-toggle-inner-size) -
		2px /* Border */
	);
	--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);
}

.ck.ck-button.ck-switchbutton {
	/* Unlike a regular button, the switch button text color and background should never change.
	 * Changing toggle switch (background, outline) is enough to carry the information about the
	 * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)
	 */
	&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {
		color: inherit;
		background: transparent;
	}

	& .ck-button__label {
		@mixin ck-dir ltr {
			/* Separate the label from the switch */
			margin-right: calc(2 * var(--ck-spacing-large));
		}

		@mixin ck-dir rtl {
			/* Separate the label from the switch */
			margin-left: calc(2 * var(--ck-spacing-large));
		}
	}

	& .ck-button__toggle {
		@mixin ck-rounded-corners;

		@mixin ck-dir ltr {
			/* Make sure the toggle is always to the right as far as possible. */
			margin-left: auto;
		}

		@mixin ck-dir rtl {
			/* Make sure the toggle is always to the left as far as possible. */
			margin-right: auto;
		}

		/* Apply some smooth transition to the box-shadow and border. */
		/* Gently animate the background color of the toggle switch */
		transition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;
		border: 1px solid transparent;
		width: var(--ck-switch-button-toggle-width);
		background: var(--ck-color-switch-button-off-background);

		& .ck-button__toggle__inner {
			@mixin ck-rounded-corners {
				border-radius: calc(.5 * var(--ck-border-radius));
			}

			width: var(--ck-switch-button-toggle-inner-size);
			height: var(--ck-switch-button-toggle-inner-size);
			background: var(--ck-color-switch-button-inner-background);

			/* Gently animate the inner part of the toggle switch */
			transition: all 300ms ease;
		}

		&:hover {
			background: var(--ck-color-switch-button-off-hover-background);

			& .ck-button__toggle__inner {
				box-shadow: var(--ck-switch-button-inner-hover-shadow);
			}
		}
	}

	&.ck-disabled .ck-button__toggle {
		@mixin ck-disabled;
	}

	/* Overriding default .ck-button:focus styles + an outline around the toogle */
	&:focus {
		border-color: transparent;
		outline: none;
		box-shadow: none;

		& .ck-button__toggle {
			box-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);
			outline-offset: 1px;
			outline: var(--ck-focus-ring);
		}
	}

	/* stylelint-disable-next-line no-descending-specificity */
	&.ck-on {
		& .ck-button__toggle {
			background: var(--ck-color-switch-button-on-background);

			&:hover {
				background: var(--ck-color-switch-button-on-hover-background);
			}

			& .ck-button__toggle__inner {
				/*
				* Move the toggle switch to the right. It will be animated.
				*/
				@mixin ck-dir ltr {
					transform: translateX( var( --ck-switch-button-translation ) );
				}

				@mixin ck-dir rtl {
					transform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );
				}
			}
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A class which indicates that an element holding it is disabled.
 */
@define-mixin ck-disabled {
	opacity: var(--ck-disabled-opacity);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 6781: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"], names: [], mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-color-grid {
	display: grid;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

:root {
	--ck-color-grid-tile-size: 24px;

	/* Not using global colors here because these may change but some colors in a pallette
	 * require special treatment. For instance, this ensures no matter what the UI text color is,
	 * the check icon will look good on the black color tile. */
	--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);
}

.ck.ck-color-grid {
	grid-gap: 5px;
	padding: 8px;
}

.ck.ck-color-grid__tile {
	width: var(--ck-color-grid-tile-size);
	height: var(--ck-color-grid-tile-size);
	min-width: var(--ck-color-grid-tile-size);
	min-height: var(--ck-color-grid-tile-size);
	padding: 0;
	transition: .2s ease box-shadow;
	border: 0;

	&.ck-disabled {
		cursor: unset;
		transition: unset;
	}

	&.ck-color-table__color-tile_bordered {
		box-shadow: 0 0 0 1px var(--ck-color-base-border);
	}

	& .ck.ck-icon {
		display: none;
		color: var(--ck-color-color-grid-check-icon);
	}

	&.ck-on {
		box-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);

		& .ck.ck-icon {
			display: block;
		}
	}

	&.ck-on,
	&:focus:not( .ck-disabled ),
	&:hover:not( .ck-disabled ) {
		/* Disable the default .ck-button's border ring. */
		border: 0;
	}

	&:focus:not( .ck-disabled ),
	&:hover:not( .ck-disabled ) {
		box-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);
	}
}

.ck.ck-color-grid__label {
	padding: 0 var(--ck-spacing-standard);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 5485: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-dropdown-max-width: 75vw;
}

.ck.ck-dropdown {
	display: inline-block;
	position: relative;

	& .ck-dropdown__arrow {
		pointer-events: none;
		z-index: var(--ck-z-default);
	}

	/* Dropdown button should span horizontally, e.g. in vertical toolbars */
	& .ck-button.ck-dropdown__button {
		width: 100%;
	}

	& .ck-dropdown__panel {
		display: none;
		z-index: var(--ck-z-modal);
		max-width: var(--ck-dropdown-max-width);

		position: absolute;

		&.ck-dropdown__panel-visible {
			display: inline-block;
		}

		&.ck-dropdown__panel_ne,
		&.ck-dropdown__panel_nw,
		&.ck-dropdown__panel_n,
		&.ck-dropdown__panel_nmw,
		&.ck-dropdown__panel_nme {
			bottom: 100%;
		}

		&.ck-dropdown__panel_se,
		&.ck-dropdown__panel_sw,
		&.ck-dropdown__panel_smw,
		&.ck-dropdown__panel_sme,
		&.ck-dropdown__panel_s {
			/*
			 * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.
			 * See https://github.com/ckeditor/ckeditor5/issues/1053.
			 */
			top: 100%;
			bottom: auto;
		}

		&.ck-dropdown__panel_ne,
		&.ck-dropdown__panel_se {
			left: 0px;
		}

		&.ck-dropdown__panel_nw,
		&.ck-dropdown__panel_sw {
			right: 0px;
		}

		&.ck-dropdown__panel_s,
		&.ck-dropdown__panel_n {
			/* Positioning panels relative to the center of the button */
			left: 50%;
			transform: translateX(-50%);
		}

		&.ck-dropdown__panel_nmw,
		&.ck-dropdown__panel_smw {
			/* Positioning panels relative to the middle-west of the button */
			left: 75%;
			transform: translateX(-75%);
		}

		&.ck-dropdown__panel_nme,
		&.ck-dropdown__panel_sme {
			/* Positioning panels relative to the middle-east of the button */
			left: 25%;
			transform: translateX(-25%);
		}
	}
}

/*
 * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.
 * See https://github.com/ckeditor/ckeditor5/issues/7874
 */
.ck.ck-toolbar .ck-dropdown__panel {
	z-index: calc( var(--ck-z-modal) + 1 );
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_disabled.css";
@import "../../../mixins/_shadow.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

:root {
	--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));
}

.ck.ck-dropdown {
	/* Enable font size inheritance, which allows fluid UI scaling. */
	font-size: inherit;

	& .ck-dropdown__arrow {
		width: var(--ck-dropdown-arrow-size);
	}

	@mixin ck-dir ltr {
		& .ck-dropdown__arrow {
			right: var(--ck-spacing-standard);

			/* A space to accommodate the triangle. */
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-dir rtl {
		& .ck-dropdown__arrow {
			left: var(--ck-spacing-standard);

			/* A space to accommodate the triangle. */
			margin-right: var(--ck-spacing-small);
		}
	}

	&.ck-disabled .ck-dropdown__arrow {
		@mixin ck-disabled;
	}

	& .ck-button.ck-dropdown__button {
		@mixin ck-dir ltr {
			&:not(.ck-button_with-text) {
				/* Make sure dropdowns with just an icon have the right inner spacing */
				padding-left: var(--ck-spacing-small);
			}
		}

		@mixin ck-dir rtl {
			&:not(.ck-button_with-text) {
				/* Make sure dropdowns with just an icon have the right inner spacing */
				padding-right: var(--ck-spacing-small);
			}
		}

		/* #23 */
		& .ck-button__label {
			width: 7em;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */
		&.ck-disabled .ck-button__label {
			@mixin ck-disabled;
		}

		/* https://github.com/ckeditor/ckeditor5/issues/816 */
		&.ck-on {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		&.ck-dropdown__button_label-width_auto .ck-button__label {
			width: auto;
		}

		/* https://github.com/ckeditor/ckeditor5/issues/8699 */
		&.ck-off:active,
		&.ck-on:active {
			box-shadow: none;
			
			&:focus {
				@mixin ck-box-shadow var(--ck-focus-outer-shadow);
			}
		}
	}
}

.ck.ck-dropdown__panel {
	@mixin ck-rounded-corners;
	@mixin ck-drop-shadow;

	background: var(--ck-color-dropdown-panel-background);
	border: 1px solid var(--ck-color-dropdown-panel-border);
	bottom: 0;

	/* Make sure the panel is at least as wide as the drop-down's button. */
	min-width: 100%;

	/* Disabled corner border radius to be consistent with the .dropdown__button
	https://github.com/ckeditor/ckeditor5/issues/816 */
	&.ck-dropdown__panel_se {
		border-top-left-radius: 0;
	}

	&.ck-dropdown__panel_sw {
		border-top-right-radius: 0;
	}

	&.ck-dropdown__panel_ne {
		border-bottom-left-radius: 0;
	}

	&.ck-dropdown__panel_nw {
		border-bottom-right-radius: 0;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A class which indicates that an element holding it is disabled.
 */
@define-mixin ck-disabled {
	opacity: var(--ck-disabled-opacity);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3949: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

.ck.ck-dropdown .ck-dropdown__panel .ck-list {
	/* Disabled radius of top-left border to be consistent with .dropdown__button
	https://github.com/ckeditor/ckeditor5/issues/816 */
	@mixin ck-rounded-corners {
		border-top-left-radius: 0;
	}

	/* Make sure the button belonging to the first/last child of the list goes well with the
	border radius of the entire panel. */
	& .ck-list__item {
		&:first-child .ck-button {
			@mixin ck-rounded-corners {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
		}

		&:last-child .ck-button {
			@mixin ck-rounded-corners {
				border-top-left-radius: 0;
				border-top-right-radius: 0;
			}
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 7686: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-splitbutton {
	/* Enable font size inheritance, which allows fluid UI scaling. */
	font-size: inherit;

	& .ck-splitbutton__action:focus {
		z-index: calc(var(--ck-z-default) + 1);
	}
}

`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

:root {
	--ck-color-split-button-hover-background: hsl(0, 0%, 92%);
	--ck-color-split-button-hover-border: hsl(0, 0%, 70%);
}

.ck.ck-splitbutton {
	/*
	 * Note: ck-rounded and ck-dir mixins don't go together (because they both use @nest).
	 */
	&:hover > .ck-splitbutton__action,
	&.ck-splitbutton_open > .ck-splitbutton__action {
		@nest [dir="ltr"] & {
			/* Don't round the action button on the right side */
			border-top-right-radius: unset;
			border-bottom-right-radius: unset;
		}

		@nest [dir="rtl"] & {
			/* Don't round the action button on the left side */
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
		}
	}

	& > .ck-splitbutton__arrow {
		/* It's a text-less button and since the icon is positioned absolutely in such situation,
		it must get some arbitrary min-width. */
		min-width: unset;

		@nest [dir="ltr"] & {
			/* Don't round the arrow button on the left side */
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
		}

		@nest [dir="rtl"] & {
			/* Don't round the arrow button on the right side */
			border-top-right-radius: unset;
			border-bottom-right-radius: unset;
		}

		& svg {
			width: var(--ck-dropdown-arrow-size);
		}
	}

	/* Make sure the divider stretches 100% height of the button
	https://github.com/ckeditor/ckeditor5/issues/10936 */
	& > .ck-splitbutton__arrow:not(:focus) {
		border-top-width: 0px;
		border-bottom-width: 0px;
	}

	/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling
	as a whole. The background of both buttons should stand out and there should be a visual
	separation between both buttons. */
	&.ck-splitbutton_open,
	&:hover {
		/* When the split button hovered as a whole, not as individual buttons. */
		& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {
			background: var(--ck-color-split-button-hover-background);
		}

		/* Splitbutton separator needs to be set with the ::after pseudoselector
		to display properly the borders on focus */
		& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
			content: '';
			position: absolute;
			width: 1px;
			height: 100%;
			background-color: var(--ck-color-split-button-hover-border);
		}

		/* Make sure the divider between the buttons looks fine when the button is focused */
		& > .ck-splitbutton__arrow:focus::after {
			--ck-color-split-button-hover-border: var(--ck-color-focus-border);
		}

		@nest [dir="ltr"] & {
			& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
				left: -1px;
			}
		}

		@nest [dir="rtl"] & {
			& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
				right: -1px;
			}
		}
	}

	/* Don't round the bottom left and right corners of the buttons when "open"
	https://github.com/ckeditor/ckeditor5/issues/816 */
	&.ck-splitbutton_open {
		@mixin ck-rounded-corners {
			& > .ck-splitbutton__action {
				border-bottom-left-radius: 0;
			}

			& > .ck-splitbutton__arrow {
				border-bottom-right-radius: 0;
			}
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 7339: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"], names: [], mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-toolbar-dropdown-max-width: 60vw;
}

.ck.ck-toolbar-dropdown > .ck-dropdown__panel {
	/* https://github.com/ckeditor/ckeditor5/issues/5586 */
	width: max-content;
	max-width: var(--ck-toolbar-dropdown-max-width);

	& .ck-button {
		&:focus {
			z-index: calc(var(--ck-z-default) + 1);
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-toolbar-dropdown .ck-toolbar {
	border: 0;
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 9688: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_disabled.css";
@import "../../../mixins/_shadow.css";
@import "../../../mixins/_focus.css";
@import "../../mixins/_button.css";

:root {
	--ck-color-editable-blur-selection: hsl(0, 0%, 85%);
}

.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
	@mixin ck-rounded-corners;

	&.ck-focused {
		@mixin ck-focus-ring;
		@mixin ck-box-shadow var(--ck-inner-shadow);
	}
}

.ck.ck-editor__editable_inline {
	overflow: auto;
	padding: 0 var(--ck-spacing-standard);
	border: 1px solid transparent;

	&[dir="ltr"] {
		text-align: left;
	}

	&[dir="rtl"] {
		text-align: right;
	}

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */
	& > *:first-child {
		margin-top: var(--ck-spacing-large);
	}

	/* https://github.com/ckeditor/ckeditor5/issues/847 */
	& > *:last-child {
		/*
		 * This value should match with the default margins of the block elements (like .media or .image)
		 * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).
		 */
		margin-bottom: var(--ck-spacing-large);
	}

	/* https://github.com/ckeditor/ckeditor5/issues/6517 */
	&.ck-blurred ::selection {
		background: var(--ck-color-editable-blur-selection);
	}
}

/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */
.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {
	&::after {
		border-bottom-color: var(--ck-color-base-foreground);
	}
}

.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {
	&::after {
		border-top-color: var(--ck-color-base-foreground);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A visual style of focused element's border.
 */
@define-mixin ck-focus-ring {
	/* Disable native outline. */
	outline: none;
	border: var(--ck-focus-ring)
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 8847: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"], names: [], mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BACD,CCNA,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAQD,CAHC,4CACC,eACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-form__header {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-form-header-height: 38px;
}

.ck.ck-form__header {
	padding: var(--ck-spacing-small) var(--ck-spacing-large);
	height: var(--ck-form-header-height);
	line-height: var(--ck-form-header-height);
	border-bottom: 1px solid var(--ck-color-base-border);

	& .ck-form__header__label {
		font-weight: bold;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 6574: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/icon/icon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"], names: [], mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-icon {
	vertical-align: middle;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));
}

.ck.ck-icon {
	width: var(--ck-icon-size);
	height: var(--ck-icon-size);

	/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */
	font-size: .8333350694em;

	/* Inherit cursor style (#5). */
	cursor: inherit;

	/* This will prevent blurry icons on Firefox. See #340. */
	will-change: transform;

	& * {
		/* Inherit cursor style (#5). */
		cursor: inherit;
	}

	/* Allows dynamic coloring of an icon by inheriting its color from the parent. */
	&.ck-icon_inherit-color {
		color: inherit;

		& * {
			color: inherit;

			&:not([fill]) {
				/* Needed by FF. */
				fill: currentColor;
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4879: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_focus.css";
@import "../../../mixins/_shadow.css";

:root {
	--ck-input-width: 18em;

	/* Backward compatibility. */
	--ck-input-text-width: var(--ck-input-width);
}

.ck.ck-input {
	@mixin ck-rounded-corners;

	background: var(--ck-color-input-background);
	border: 1px solid var(--ck-color-input-border);
	padding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);
	min-width: var(--ck-input-width);

	/* This is important to stay of the same height as surrounding buttons */
	min-height: var(--ck-ui-component-min-height);

	/* Apply some smooth transition to the box-shadow and border. */
	transition: box-shadow .1s ease-in-out, border .1s ease-in-out;

	&:focus {
		@mixin ck-focus-ring;
		@mixin ck-box-shadow var(--ck-focus-outer-shadow);
	}

	&[readonly] {
		border: 1px solid var(--ck-color-input-disabled-border);
		background: var(--ck-color-input-disabled-background);
		color: var(--ck-color-input-disabled-text);

		&:focus {
			/* The read-only input should have a slightly less visible shadow when focused. */
			@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);
		}
	}

	&.ck-error {
		border-color: var(--ck-color-input-error-border);
		animation: ck-input-shake .3s ease both;

		&:focus {
			@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);
		}
	}
}

@keyframes ck-input-shake {
	20% {
		transform: translateX(-2px);
	}

	40% {
		transform: translateX(2px);
	}

	60% {
		transform: translateX(-1px);
	}

	80% {
		transform: translateX(1px);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A visual style of focused element's border.
 */
@define-mixin ck-focus-ring {
	/* Disable native outline. */
	outline: none;
	border: var(--ck-focus-ring)
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3662: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/label/label.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"], names: [], mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-label {
	display: block;
}

.ck.ck-voice-label {
	display: none;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-label {
	font-weight: bold;
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 2577: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eD8GD,CAzGA,2FCDE,qCD0GF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAiBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAP9C,mBAAoB,CAYpB,sBAAuB,CARvB,6DAA+D,CAH/D,oBAAqB,CAgBrB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,+HAYF,CAfA,oUAOE,wIAQF,CAfA,gTAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-labeled-field-view {
	& > .ck.ck-labeled-field-view__input-wrapper {
		display: flex;
		position: relative;
	}

	& .ck.ck-label {
		display: block;
		position: absolute;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";
@import "../../../mixins/_rounded.css";

:root {
	--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);
	--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);
	--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);
	--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));
	--ck-color-labeled-field-label-background: var(--ck-color-base-background);
}

.ck.ck-labeled-field-view {
	@mixin ck-rounded-corners;

	& > .ck.ck-labeled-field-view__input-wrapper {
		width: 100%;

		& > .ck.ck-label {
			top: 0px;

			@mixin ck-dir ltr {
				left: 0px;
			}

			@mixin ck-dir rtl {
				right: 0px;
			}

			pointer-events: none;
			transform-origin: 0 0;

			/* By default, display the label scaled down above the field. */
			transform: translate(var(--ck-spacing-medium), -6px) scale(.75);

			background: var(--ck-color-labeled-field-label-background);
			padding: 0 calc(.5 * var(--ck-font-size-tiny));
			line-height: initial;
			font-weight: normal;

			/* Prevent overflow when the label is longer than the input */
			text-overflow: ellipsis;
			overflow: hidden;

			max-width: 100%;

			transition:
				transform var(--ck-labeled-field-view-transition),
				padding var(--ck-labeled-field-view-transition),
				background var(--ck-labeled-field-view-transition);
		}
	}

	&.ck-error {
		& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
			color: var(--ck-color-base-error);
		}

		& .ck-input:not([readonly]) + .ck.ck-label {
			color: var(--ck-color-base-error);
		}
	}

	& .ck-labeled-field-view__status {
		font-size: var(--ck-font-size-small);
		margin-top: var(--ck-spacing-small);

		/* Let the info wrap to the next line to avoid stretching the layout horizontally.
		The status could be very long. */
		white-space: normal;

		&.ck-labeled-field-view__status_error {
			color: var(--ck-color-base-error);
		}
	}

	/* Disabled fields and fields that have no focus should fade out. */
	&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
		color: var(--ck-color-input-disabled-text);
	}

	/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */
	/* stylelint-disable-next-line no-descending-specificity */
	&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
		@mixin ck-dir ltr {
			transform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);
		}

		@mixin ck-dir rtl {
			transform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);
		}

		/* Compensate for the default translate position. */
		max-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));

		background: transparent;
		padding: 0;
	}

	/*------ DropdownView integration ----------------------------------------------------------------------------------- */

	/* Make sure dropdown' background color in any of dropdown's state does not collide with labeled field. */
	& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {
		background: transparent;
	}

	/* When the dropdown is "empty", the labeled field label replaces its label. */
	&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {
		opacity: 0;
	}

	/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {
		max-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 1046: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;padding:calc(var(--ck-line-height-base)*.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*.4*var(--ck-font-size-base));text-align:left;width:100%}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/list/list.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAIC,eAAgB,CAHhB,gBAAiB,CAQjB,iIAEiE,CARjE,eAAgB,CADhB,UAwCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../mixins/_unselectable.css";

.ck.ck-list {
	@mixin ck-unselectable;

	display: flex;
	flex-direction: column;

	& .ck-list__item,
	& .ck-list__separator {
		display: block;
	}

	/* Make sure that whatever child of the list item gets focus, it remains on the
	top. Thanks to that, styles like box-shadow, outline, etc. are not masked by
	adjacent list items. */
	& .ck-list__item > *:focus {
		position: relative;
		z-index: var(--ck-z-default);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Makes element unselectable.
 */
@define-mixin ck-unselectable {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_disabled.css";
@import "../../../mixins/_rounded.css";
@import "../../../mixins/_shadow.css";

.ck.ck-list {
	@mixin ck-rounded-corners;

	list-style-type: none;
	background: var(--ck-color-list-background);
}

.ck.ck-list__item {
	cursor: default;
	min-width: 12em;

	& .ck-button {
		min-height: unset;
		width: 100%;
		text-align: left;
		border-radius: 0;

		/* List items should have the same height. Use absolute units to make sure it is so
		   because e.g. different heading styles may have different height
		   https://github.com/ckeditor/ckeditor5-heading/issues/63 */
		padding:
			calc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))
			calc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));

		& .ck-button__label {
			/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */
			line-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));
		}

		&:active {
			box-shadow: none;
		}

		&.ck-on {
			background: var(--ck-color-list-button-on-background);
			color: var(--ck-color-list-button-on-text);

			&:active {
				box-shadow: none;
			}

			&:hover:not(.ck-disabled) {
				background: var(--ck-color-list-button-on-background-focus);
			}

			&:focus:not(.ck-switchbutton):not(.ck-disabled) {
				border-color: var(--ck-color-base-background);
			}
		}

		&:hover:not(.ck-disabled) {
			background: var(--ck-color-list-button-hover-background);
		}
	}

	/* It's unnecessary to change the background/text of a switch toggle; it has different ways
	of conveying its state (like the switcher) */
	& .ck-switchbutton {
		&.ck-on {
			background: var(--ck-color-list-background);
			color: inherit;

			&:hover:not(.ck-disabled) {
				background: var(--ck-color-list-button-hover-background);
				color: inherit;
			}
		}
	}
}

.ck.ck-list__separator {
	height: 1px;
	width: 100%;
	background: var(--ck-color-base-border);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 8793: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	/* Make sure the balloon arrow does not float over its children. */
	--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);
}

.ck.ck-balloon-panel {
	display: none;
	position: absolute;

	z-index: var(--ck-z-modal);

	&.ck-balloon-panel_with-arrow {
		&::before,
		&::after {
			content: "";
			position: absolute;
		}

		&::before {
			z-index: var(--ck-balloon-panel-arrow-z-index);
		}

		&::after {
			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);
		}
	}

	&[class*="arrow_n"] {
		&::before {
			z-index: var(--ck-balloon-panel-arrow-z-index);
		}

		&::after {
			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);
		}
	}

	&[class*="arrow_s"] {
		&::before {
			z-index: var(--ck-balloon-panel-arrow-z-index);
		}

		&::after {
			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);
		}
	}

	&.ck-balloon-panel_visible {
		display: block;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_shadow.css";

:root {
	--ck-balloon-border-width: 1px;
	--ck-balloon-arrow-offset: 2px;
	--ck-balloon-arrow-height: 10px;
	--ck-balloon-arrow-half-width: 8px;
	--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);
}

.ck.ck-balloon-panel {
	@mixin ck-rounded-corners;
	@mixin ck-drop-shadow;

	min-height: 15px;

	background: var(--ck-color-panel-background);
	border: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);

	&.ck-balloon-panel_with-arrow {
		&::before,
		&::after {
			width: 0;
			height: 0;
			border-style: solid;
		}
	}

	&[class*="arrow_n"] {
		&::before,
		&::after {
			border-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);
		}

		&::before {
			border-color: transparent transparent var(--ck-color-panel-border) transparent;
			margin-top: calc( -1 * var(--ck-balloon-border-width) );
		}

		&::after {
			border-color: transparent transparent var(--ck-color-panel-background) transparent;
			margin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );
		}
	}

	&[class*="arrow_s"] {
		&::before,
		&::after {
			border-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);
		}

		&::before {
			border-color: var(--ck-color-panel-border) transparent transparent;
			filter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));
			margin-bottom: calc( -1 * var(--ck-balloon-border-width) );
		}

		&::after {
			border-color: var(--ck-color-panel-background) transparent transparent transparent;
			margin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );
		}
	}

	&[class*="arrow_e"] {
		&::before,
		&::after {
			border-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);
		}

		&::before {
			border-color: transparent transparent transparent var(--ck-color-panel-border);
			margin-right: calc( -1 * var(--ck-balloon-border-width) );
		}

		&::after {
			border-color: transparent transparent transparent var(--ck-color-panel-background);
			margin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );
		}
	}

	&[class*="arrow_w"] {
		&::before,
		&::after {
			border-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;
		}

		&::before {
			border-color: transparent var(--ck-color-panel-border) transparent transparent;
			margin-left: calc( -1 * var(--ck-balloon-border-width) );
		}

		&::after {
			border-color: transparent var(--ck-color-panel-background) transparent transparent;
			margin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );
		}
	}

	&.ck-balloon-panel_arrow_n {
		&::before,
		&::after {
			left: 50%;
			margin-left: calc(-1 * var(--ck-balloon-arrow-half-width));
			top: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_nw {
		&::before,
		&::after {
			left: calc(2 * var(--ck-balloon-arrow-half-width));
			top: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_ne {
		&::before,
		&::after {
			right: calc(2 * var(--ck-balloon-arrow-half-width));
			top: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_s {
		&::before,
		&::after {
			left: 50%;
			margin-left: calc(-1 * var(--ck-balloon-arrow-half-width));
			bottom: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_sw {
		&::before,
		&::after {
			left: calc(2 * var(--ck-balloon-arrow-half-width));
			bottom: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_se {
		&::before,
		&::after {
			right: calc(2 * var(--ck-balloon-arrow-half-width));
			bottom: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_sme {
		&::before,
		&::after {
			right: 25%;
			margin-right: calc(2 * var(--ck-balloon-arrow-half-width));
			bottom: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_smw {
		&::before,
		&::after {
			left: 25%;
			margin-left: calc(2 * var(--ck-balloon-arrow-half-width));
			bottom: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_nme {
		&::before,
		&::after {
			right: 25%;
			margin-right: calc(2 * var(--ck-balloon-arrow-half-width));
			top: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_nmw {
		&::before,
		&::after {
			left: 25%;
			margin-left: calc(2 * var(--ck-balloon-arrow-half-width));
			top: calc(-1 * var(--ck-balloon-arrow-height));
		}
	}

	&.ck-balloon-panel_arrow_e {
		&::before,
		&::after {
			right: calc(-1 * var(--ck-balloon-arrow-height));
			margin-top: calc(-1 * var(--ck-balloon-arrow-half-width));
			top: 50%;
		}
	}

	&.ck-balloon-panel_arrow_w {
		&::before,
		&::after {
			left: calc(-1 * var(--ck-balloon-arrow-height));
			margin-top: calc(-1 * var(--ck-balloon-arrow-half-width));
			top: 50%;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4650: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"], names: [], mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-balloon-rotator__navigation {
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Buttons inside a toolbar should be centered when rotator bar is wider.
 * See: https://github.com/ckeditor/ckeditor5-ui/issues/495
 */
.ck .ck-balloon-rotator__content .ck-toolbar {
	justify-content: center;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-balloon-rotator__navigation {
	background: var(--ck-color-toolbar-background);
	border-bottom: 1px solid var(--ck-color-toolbar-border);
	padding: 0 var(--ck-spacing-small);

	/* Let's keep similar appearance to \`ck-toolbar\`. */
	& > * {
		margin-right: var(--ck-spacing-small);
		margin-top: var(--ck-spacing-small);
		margin-bottom: var(--ck-spacing-small);
	}

	/* Gives counter more breath than buttons. */
	& .ck-balloon-rotator__counter {
		margin-right: var(--ck-spacing-standard);

		/* We need to use smaller margin because of previous button's right margin. */
		margin-left: var(--ck-spacing-small);
	}
}

.ck .ck-balloon-rotator__content {

	/* Disable default annotation shadow inside rotator with fake panels. */
	& .ck.ck-annotation-wrapper {
		box-shadow: none;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 7676: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-fake-panel {
	position: absolute;

	/* Fake panels should be placed under main balloon content. */
	z-index: calc(var(--ck-z-modal) - 1);
}

.ck .ck-fake-panel div {
	position: absolute;
}

.ck .ck-fake-panel div:nth-child( 1 ) {
	z-index: 2;
}

.ck .ck-fake-panel div:nth-child( 2 ) {
	z-index: 1;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_shadow.css";

:root {
	--ck-balloon-fake-panel-offset-horizontal: 6px;
	--ck-balloon-fake-panel-offset-vertical: 6px;
}

/* Let's use \`.ck-balloon-panel\` appearance. See: balloonpanel.css. */
.ck .ck-fake-panel div {
	@mixin ck-drop-shadow;

	min-height: 15px;

	background: var(--ck-color-panel-background);
	border: 1px solid var(--ck-color-panel-border);
	border-radius: var(--ck-border-radius);

	width: 100%;
	height: 100%;
}

.ck .ck-fake-panel div:nth-child( 1 ) {
	margin-left: var(--ck-balloon-fake-panel-offset-horizontal);
	margin-top: var(--ck-balloon-fake-panel-offset-vertical);
}

.ck .ck-fake-panel div:nth-child( 2 ) {
	margin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);
	margin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);
}
.ck .ck-fake-panel div:nth-child( 3 ) {
	margin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);
	margin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);
}

/* If balloon is positioned above element, we need to move fake panel to the top. */
.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,
.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,
.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {
	--ck-balloon-fake-panel-offset-vertical: -6px;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 5868: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-sticky-panel {
	& .ck-sticky-panel__content_sticky {
		z-index: var(--ck-z-modal); /* #315 */
		position: fixed;
		top: 0;
	}

	& .ck-sticky-panel__content_sticky_bottom-limit {
		top: auto;
		position: absolute;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_shadow.css";

.ck.ck-sticky-panel {
	& .ck-sticky-panel__content_sticky {
		@mixin ck-drop-shadow;

		border-width: 0 1px 1px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 6764: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"], names: [], mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck-vertical-form .ck-button {
	&::after {
		content: "";
		width: 0;
		position: absolute;
		right: -1px;
		top: -1px;
		bottom: -1px;
		z-index: 1;
	}

	&:focus::after {
		display: none;
	}
}

.ck.ck-responsive-form {
	@mixin ck-media-phone {
		& .ck-button {
			&::after {
				content: "";
				width: 0;
				position: absolute;
				right: -1px;
				top: -1px;
				bottom: -1px;
				z-index: 1;
			}

			&:focus::after {
				display: none;
			}
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@define-mixin ck-media-phone {
	@media screen and (max-width: 600px) {
		@mixin-content;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

.ck-vertical-form > .ck-button:nth-last-child(2)::after {
	border-right: 1px solid var(--ck-color-base-border);
}

.ck.ck-responsive-form {
	padding: var(--ck-spacing-large);

	&:focus {
		/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */
		outline: none;
	}

	@mixin ck-dir ltr {
		& > :not(:first-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-dir rtl {
		& > :not(:last-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-media-phone {
		padding: 0;
		width: calc(.8 * var(--ck-input-width));

		& .ck-labeled-field-view {
			margin: var(--ck-spacing-large) var(--ck-spacing-large) 0;

			& .ck-input-text {
				min-width: 0;
				width: 100%;
			}

			/* Let the long error messages wrap in the narrow form. */
			& .ck-labeled-field-view__error {
				white-space: normal;
			}
		}

		/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */
		& > .ck-button:nth-last-child(2) {
			&::after {
				border-right: 1px solid var(--ck-color-base-border);
			}
		}

		& > .ck-button:nth-last-child(1),
		& > .ck-button:nth-last-child(2) {
			padding: var(--ck-spacing-standard);
			margin-top: var(--ck-spacing-large);
			border-radius: 0;

			&:not(:focus) {
				border-top: 1px solid var(--ck-color-base-border);
			}

			@mixin ck-dir ltr {
				margin-left: 0;
			}

			@mixin ck-dir rtl {
				margin-left: 0;

				&:last-of-type {
					border-right: 1px solid var(--ck-color-base-border);
				}
			}
		}
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 9695: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"], names: [], mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-block-toolbar-button {
	position: absolute;
	z-index: var(--ck-z-default);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-block-toolbar-button: var(--ck-color-text);
	--ck-block-toolbar-button-size: var(--ck-font-size-normal);
}

.ck.ck-block-toolbar-button {
	color: var(--ck-color-block-toolbar-button);
	font-size: var(--ck-block-toolbar-size);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 5542: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDoGD,CAvGA,qECOE,qCDgGF,CAvGA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAmGD,CAhGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAjGF,qCAqGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../mixins/_unselectable.css";

.ck.ck-toolbar {
	@mixin ck-unselectable;

	display: flex;
	flex-flow: row nowrap;
	align-items: center;

	& > .ck-toolbar__items {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		flex-grow: 1;

	}

	& .ck.ck-toolbar__separator {
		display: inline-block;

		/*
		 * A leading or trailing separator makes no sense (separates from nothing on one side).
		 * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and
		 * moved to another toolbar in the dropdown.
		 */
		&:first-child,
		&:last-child {
			display: none;
		}
	}

	& .ck-toolbar__line-break {
		flex-basis: 100%;
	}

	&.ck-toolbar_grouping > .ck-toolbar__items {
		flex-wrap: nowrap;
	}

	&.ck-toolbar_vertical > .ck-toolbar__items {
		flex-direction: column;
	}

	&.ck-toolbar_floating > .ck-toolbar__items {
		flex-wrap: nowrap;
	}

	& > .ck.ck-toolbar__grouped-dropdown {
		& > .ck-dropdown__button .ck-dropdown__arrow {
			display: none;
		}
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Makes element unselectable.
 */
@define-mixin ck-unselectable {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

.ck.ck-toolbar {
	@mixin ck-rounded-corners;

	background: var(--ck-color-toolbar-background);
	padding: 0 var(--ck-spacing-small);
	border: 1px solid var(--ck-color-toolbar-border);

	& .ck.ck-toolbar__separator {
		align-self: stretch;
		width: 1px;
		min-width: 1px;
		background: var(--ck-color-toolbar-border);

		/*
		 * These margins make the separators look better in balloon toolbars (when aligned with the "tip").
		 * See https://github.com/ckeditor/ckeditor5/issues/7493.
		 */
		margin-top: var(--ck-spacing-small);
		margin-bottom: var(--ck-spacing-small);
	}

	& .ck-toolbar__line-break {
		height: 0;
	}

	& > .ck-toolbar__items {
		& > *:not(.ck-toolbar__line-break) {
			/* (#11) Separate toolbar items. */
			margin-right: var(--ck-spacing-small);
		}

		/* Don't display a separator after an empty items container, for instance,
		when all items were grouped */
		&:empty + .ck.ck-toolbar__separator {
			display: none;
		}
	}

	& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),
	& > .ck.ck-toolbar__grouped-dropdown {
		/* Make sure items wrapped to the next line have v-spacing */
		margin-top: var(--ck-spacing-small);
		margin-bottom: var(--ck-spacing-small);
	}

	&.ck-toolbar_vertical {
		/* Items in a vertical toolbar span the entire width. */
		padding: 0;

		/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */
		& > .ck-toolbar__items > .ck {
			/* Items in a vertical toolbar should span the horizontal space. */
			width: 100%;

			/* Items in a vertical toolbar should have no margin. */
			margin: 0;

			/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */
			border-radius: 0;
		}
	}

	&.ck-toolbar_compact {
		/* No spacing around items. */
		padding: 0;

		& > .ck-toolbar__items > * {
			/* Compact toolbar items have no spacing between them. */
			margin: 0;

			/* "Middle" children should have no rounded corners. */
			&:not(:first-child):not(:last-child) {
				border-radius: 0;
			}
		}
	}

	& > .ck.ck-toolbar__grouped-dropdown {
		/*
		 * Dropdown button has asymmetric padding to fit the arrow.
		 * This button has no arrow so let's revert that padding back to normal.
		 */
		& > .ck.ck-button.ck-dropdown__button {
			padding-left: var(--ck-spacing-tiny);
		}
	}

	/* A drop-down containing the nested toolbar with configured items. */
	& .ck-toolbar__nested-toolbar-dropdown {
		/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */
		& > .ck-dropdown__panel {
			min-width: auto;
		}

		& > .ck-button > .ck-button__label {
			max-width: 7em;
			width: auto;
		}
	}

	@nest .ck-toolbar-container & {
		border: 0;
	}
}

/* stylelint-disable */

/*
 * Styles for RTL toolbars.
 *
 * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"
 * because its parent is not controlled by the editor framework.
 */
[dir="rtl"] .ck.ck-toolbar,
.ck.ck-toolbar[dir="rtl"] {
	& > .ck-toolbar__items > .ck {
		margin-right: 0;
	}

	&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {
		/* (#11) Separate toolbar items. */
		margin-left: var(--ck-spacing-small);
	}

	& > .ck-toolbar__items > .ck:last-child {
		margin-left: 0;
	}

	&.ck-toolbar_compact > .ck-toolbar__items > .ck {
		/* No rounded corners on the right side of the first child. */
		&:first-child {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		/* No rounded corners on the left side of the last child. */
		&:last-child {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}

	/* Separate the the separator form the grouping dropdown when some items are grouped. */
	& > .ck.ck-toolbar__separator {
		margin-left: var(--ck-spacing-small);
	}

	/* Some spacing between the items and the separator before the grouped items dropdown. */
	&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {
		margin-left: var(--ck-spacing-small);
	}
}

/*
 * Styles for LTR toolbars.
 *
 * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"
 * because its parent is not controlled by the editor framework.
 */
[dir="ltr"] .ck.ck-toolbar,
.ck.ck-toolbar[dir="ltr"] {
	& > .ck-toolbar__items > .ck:last-child {
		margin-right: 0;
	}

	&.ck-toolbar_compact > .ck-toolbar__items > .ck {
		/* No rounded corners on the right side of the first child. */
		&:first-child {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}

		/* No rounded corners on the left side of the last child. */
		&:last-child {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}
	}

	/* Separate the the separator form the grouping dropdown when some items are grouped. */
	& > .ck.ck-toolbar__separator {
		margin-right: var(--ck-spacing-small);
	}

	/* Some spacing between the items and the separator before the grouped items dropdown. */
	&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {
		margin-right: var(--ck-spacing-small);
	}
}

/* stylelint-enable */
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Implements rounded corner interface for .ck-rounded-corners class.
 *
 * @see $ck-border-radius
 */
@define-mixin ck-rounded-corners {
	border-radius: 0;

	@nest .ck-rounded-corners &,
	&.ck-rounded-corners {
		border-radius: var(--ck-border-radius);
		@mixin-content;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3332: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css"], names: [], mappings: "AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDPnC,mBAAoB,CAEpB,qCACD,CCMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAbD,gCAgBC,eAMD,CAHC,uCACC,YACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-balloon-panel.ck-tooltip {
	/* Keep tooltips transparent for any interactions. */
	pointer-events: none;

	z-index: calc( var(--ck-z-modal) + 100 );
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

.ck.ck-balloon-panel.ck-tooltip {
	--ck-balloon-border-width: 0px;
	--ck-balloon-arrow-offset: 0px;
	--ck-balloon-arrow-half-width: 4px;
	--ck-balloon-arrow-height: 4px;
	--ck-color-panel-background: var(--ck-color-tooltip-background);

	padding: 0 var(--ck-spacing-medium);

	& .ck-tooltip__text {
		font-size: .9em;
		line-height: 1.5;
		color: var(--ck-color-tooltip-text);
	}

	/* Reset balloon panel styles */
	box-shadow: none;

	/* Hide the default shadow of the .ck-balloon-panel tip */
	&::before {
		display: none;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4793: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/globals/_hidden.css", "webpack://./../ckeditor5-ui/theme/globals/_reset.css", "webpack://./../ckeditor5-ui/theme/globals/_zindex.css", "webpack://./../ckeditor5-ui/theme/globals/_transition.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"], names: [], mappings: "AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAwD,CCvGxD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJuGD,CIjGA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A class which hides an element in DOM.
 */
.ck-hidden {
	/* Override selector specificity. Otherwise, all elements with some display
	style defined will override this one, which is not a desired result. */
	display: none !important;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck.ck-reset,
.ck.ck-reset_all,
.ck-reset_all *:not(.ck-reset_all-excluded *) {
	box-sizing: border-box;
	width: auto;
	height: auto;
	position: static;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-z-default: 1;
	--ck-z-modal: calc( var(--ck-z-default) + 999 );
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A class that disables all transitions of the element and its children.
 */
.ck-transitions-disabled,
.ck-transitions-disabled * {
	transition: none !important;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-base-foreground: 								hsl(0, 0%, 98%);
	--ck-color-base-background: 								hsl(0, 0%, 100%);
	--ck-color-base-border: 									hsl(220, 6%, 81%);
	--ck-color-base-action: 									hsl(104, 50.2%, 42.5%);
	--ck-color-base-focus: 										hsl(209, 92%, 70%);
	--ck-color-base-text: 										hsl(0, 0%, 20%);
	--ck-color-base-active: 									hsl(218.1, 100%, 58%);
	--ck-color-base-active-focus:								hsl(218.2, 100%, 52.5%);
	--ck-color-base-error:										hsl(15, 100%, 43%);

	/* -- Generic colors ------------------------------------------------------------------------ */

	--ck-color-focus-border-coordinates: 						218, 81.8%, 56.9%;
	--ck-color-focus-border: 									hsl(var(--ck-color-focus-border-coordinates));
	--ck-color-focus-outer-shadow:								hsl(212.4, 89.3%, 89%);
	--ck-color-focus-disabled-shadow:							hsla(209, 90%, 72%,.3);
	--ck-color-focus-error-shadow:								hsla(9,100%,56%,.3);
	--ck-color-text: 											var(--ck-color-base-text);
	--ck-color-shadow-drop: 									hsla(0, 0%, 0%, 0.15);
	--ck-color-shadow-drop-active:								hsla(0, 0%, 0%, 0.2);
	--ck-color-shadow-inner: 									hsla(0, 0%, 0%, 0.1);

	/* -- Buttons ------------------------------------------------------------------------------- */

	--ck-color-button-default-background: 						transparent;
	--ck-color-button-default-hover-background: 				hsl(0, 0%, 94.1%);
	--ck-color-button-default-active-background: 				hsl(0, 0%, 94.1%);
	--ck-color-button-default-disabled-background: 				transparent;

	--ck-color-button-on-background: 							hsl(212, 100%, 97.1%);
	--ck-color-button-on-hover-background: 						hsl(211.7, 100%, 92.9%);
	--ck-color-button-on-active-background: 					hsl(211.7, 100%, 92.9%);
	--ck-color-button-on-disabled-background: 					hsl(211, 15%, 95%);
	--ck-color-button-on-color:									hsl(218.1, 100%, 58%);


	--ck-color-button-action-background: 						var(--ck-color-base-action);
	--ck-color-button-action-hover-background: 					hsl(104, 53.2%, 40.2%);
	--ck-color-button-action-active-background: 				hsl(104, 53.2%, 40.2%);
	--ck-color-button-action-disabled-background: 				hsl(104, 44%, 58%);
	--ck-color-button-action-text: 								var(--ck-color-base-background);

	--ck-color-button-save: 									hsl(120, 100%, 27%);
	--ck-color-button-cancel: 									hsl(15, 100%, 43%);

	--ck-color-switch-button-off-background:					hsl(0, 0%, 57.6%);
	--ck-color-switch-button-off-hover-background:				hsl(0, 0%, 49%);
	--ck-color-switch-button-on-background:						var(--ck-color-button-action-background);
	--ck-color-switch-button-on-hover-background:				hsl(104, 53.2%, 40.2%);
	--ck-color-switch-button-inner-background:					var(--ck-color-base-background);
	--ck-color-switch-button-inner-shadow:						hsla(0, 0%, 0%, 0.1);

	/* -- Dropdown ------------------------------------------------------------------------------ */

	--ck-color-dropdown-panel-background: 						var(--ck-color-base-background);
	--ck-color-dropdown-panel-border: 							var(--ck-color-base-border);

	/* -- Input --------------------------------------------------------------------------------- */

	--ck-color-input-background: 								var(--ck-color-base-background);
	--ck-color-input-border: 									var(--ck-color-base-border);
	--ck-color-input-error-border:								var(--ck-color-base-error);
	--ck-color-input-text: 										var(--ck-color-base-text);
	--ck-color-input-disabled-background: 						hsl(0, 0%, 95%);
	--ck-color-input-disabled-border: 							var(--ck-color-base-border);
	--ck-color-input-disabled-text: 							hsl(0, 0%, 46%);

	/* -- List ---------------------------------------------------------------------------------- */

	--ck-color-list-background: 								var(--ck-color-base-background);
	--ck-color-list-button-hover-background: 					var(--ck-color-button-default-hover-background);
	--ck-color-list-button-on-background: 						var(--ck-color-button-on-color);
	--ck-color-list-button-on-background-focus: 				var(--ck-color-button-on-color);
	--ck-color-list-button-on-text:								var(--ck-color-base-background);

	/* -- Panel --------------------------------------------------------------------------------- */

	--ck-color-panel-background: 								var(--ck-color-base-background);
	--ck-color-panel-border: 									var(--ck-color-base-border);

	/* -- Toolbar ------------------------------------------------------------------------------- */

	--ck-color-toolbar-background: 								var(--ck-color-base-background);
	--ck-color-toolbar-border: 									var(--ck-color-base-border);

	/* -- Tooltip ------------------------------------------------------------------------------- */

	--ck-color-tooltip-background: 								var(--ck-color-base-text);
	--ck-color-tooltip-text: 									var(--ck-color-base-background);

	/* -- Engine -------------------------------------------------------------------------------- */

	--ck-color-engine-placeholder-text: 						hsl(0, 0%, 44%);

	/* -- Upload -------------------------------------------------------------------------------- */

	--ck-color-upload-bar-background:		 					hsl(209, 92%, 70%);

	/* -- Link -------------------------------------------------------------------------------- */

	--ck-color-link-default:									hsl(240, 100%, 47%);
	--ck-color-link-selected-background:						hsla(201, 100%, 56%, 0.1);
	--ck-color-link-fake-selection:								hsla(201, 100%, 56%, 0.3);

	/* -- Search result highlight ---------------------------------------------------------------- */

	--ck-color-highlight-background:							hsl(60, 100%, 50%)
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	/**
	 * An opacity value of disabled UI item.
	 */
	--ck-disabled-opacity: .5;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	/**
	 * The geometry of the of focused element's outer shadow.
	 */
	--ck-focus-outer-shadow-geometry: 0 0 0 3px;

	/**
	 * A visual style of focused element's outer shadow.
	 */
	--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);

	/**
	 * A visual style of focused element's outer shadow (when disabled).
	 */
	--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);

	/**
	 * A visual style of focused element's outer shadow (when has errors).
	 */
	--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);

	/**
	 * A visual style of focused element's border or outline.
	 */
	--ck-focus-ring: 1px solid var(--ck-color-focus-border);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-font-size-base: 13px;
	--ck-line-height-base: 1.84615;
	--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;

	--ck-font-size-tiny: 0.7em;
	--ck-font-size-small: 0.75em;
	--ck-font-size-normal: 1em;
	--ck-font-size-big: 1.4em;
	--ck-font-size-large: 1.8em;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	/* This is super-important. This is **manually** adjusted so a button without an icon
	is never smaller than a button with icon, additionally making sure that text-less buttons
	are perfect squares. The value is also shared by other components which should stay "in-line"
	with buttons. */
	--ck-ui-component-min-height: 2.3em;
}

/**
 * Resets an element, ignoring its children.
 */
.ck.ck-reset,
.ck.ck-reset_all,
.ck-reset_all *:not(.ck-reset_all-excluded *) {
	/* Do not include inheritable rules here. */
	margin: 0;
	padding: 0;
	border: 0;
	background: transparent;
	text-decoration: none;
	vertical-align: middle;
	transition: none;

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */
	word-wrap: break-word;
}

/**
 * Resets an element AND its children.
 */
.ck.ck-reset_all,
.ck-reset_all *:not(.ck-reset_all-excluded *) {
	/* These are rule inherited by all children elements. */
	border-collapse: collapse;
	font: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);
	color: var(--ck-color-text);
	text-align: left;
	white-space: nowrap;
	cursor: auto;
	float: none;
}

.ck-reset_all {
	& .ck-rtl *:not(.ck-reset_all-excluded *) {
		text-align: right;
	}

	& iframe:not(.ck-reset_all-excluded *) {
		/* For IE */
		vertical-align: inherit;
	}

	& textarea:not(.ck-reset_all-excluded *) {
		white-space: pre-wrap;
	}

	& textarea:not(.ck-reset_all-excluded *),
	& input[type="text"]:not(.ck-reset_all-excluded *),
	& input[type="password"]:not(.ck-reset_all-excluded *) {
		cursor: text;
	}

	& textarea[disabled]:not(.ck-reset_all-excluded *),
	& input[type="text"][disabled]:not(.ck-reset_all-excluded *),
	& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {
		cursor: default;
	}

	& fieldset:not(.ck-reset_all-excluded *) {
		padding: 10px;
		border: 2px groove hsl(255, 7%, 88%);
	}

	& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {
		/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */
		padding: 0;
		border: 0
	}
}

/**
 * Default UI rules for RTL languages.
 */
.ck[dir="rtl"],
.ck[dir="rtl"] .ck {
	text-align: right;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * Default border-radius value.
 */
:root{
	--ck-border-radius: 2px;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	/**
	 * A visual style of element's inner shadow (i.e. input).
	 */
	--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;

	/**
	 * A visual style of element's drop shadow (i.e. panel).
	 */
	--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);

	/**
	 * A visual style of element's active shadow (i.e. comment or suggestion).
	 */
	--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-spacing-unit: 						0.6em;
	--ck-spacing-large: 					calc(var(--ck-spacing-unit) * 1.5);
	--ck-spacing-standard: 					var(--ck-spacing-unit);
	--ck-spacing-medium: 					calc(var(--ck-spacing-unit) * 0.8);
	--ck-spacing-small: 					calc(var(--ck-spacing-unit) * 0.5);
	--ck-spacing-tiny: 						calc(var(--ck-spacing-unit) * 0.3);
	--ck-spacing-extra-tiny: 				calc(var(--ck-spacing-unit) * 0.16);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 3488: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widget.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-color-resizer: var(--ck-color-focus-border);
	--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);
	--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);

	--ck-resizer-border-radius: var(--ck-border-radius);
	--ck-resizer-tooltip-offset: 10px;
	--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);
}

.ck .ck-widget {
	/* This is neccessary for type around UI to be positioned properly. */
	position: relative;
}

.ck .ck-widget.ck-widget_with-selection-handle {
	/* Make the widget wrapper a relative positioning container for the drag handle. */
	position: relative;

	& .ck-widget__selection-handle {
		position: absolute;

		& .ck-icon {
			/* Make sure the icon in not a subject to font-size or line-height to avoid
			unnecessary spacing around it. */
			display: block;
		}
	}

	/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */
	&:hover > .ck-widget__selection-handle {
		visibility: visible;
	}

	/* Show the selection handle when the widget is selected, but not for nested widgets. */
	&.ck-widget_selected > .ck-widget__selection-handle {
		visibility: visible;
	}
}

.ck .ck-size-view {
	background: var(--ck-color-resizer-tooltip-background);
	color: var(--ck-color-resizer-tooltip-text);
	border: 1px solid var(--ck-color-resizer-tooltip-text);
	border-radius: var(--ck-resizer-border-radius);
	font-size: var(--ck-font-size-tiny);
	display: block;
	padding: 0 var(--ck-spacing-small);
	height: var(--ck-resizer-tooltip-height);
	line-height: var(--ck-resizer-tooltip-height);

	&.ck-orientation-top-left,
	&.ck-orientation-top-right,
	&.ck-orientation-bottom-right,
	&.ck-orientation-bottom-left,
	&.ck-orientation-above-center {
		position: absolute;
	}

	&.ck-orientation-top-left {
		top: var(--ck-resizer-tooltip-offset);
		left: var(--ck-resizer-tooltip-offset);
	}

	&.ck-orientation-top-right {
		top: var(--ck-resizer-tooltip-offset);
		right: var(--ck-resizer-tooltip-offset);
	}

	&.ck-orientation-bottom-right {
		bottom: var(--ck-resizer-tooltip-offset);
		right: var(--ck-resizer-tooltip-offset);
	}

	&.ck-orientation-bottom-left {
		bottom: var(--ck-resizer-tooltip-offset);
		left: var(--ck-resizer-tooltip-offset);
	}

	/* Class applied if the widget is too small to contain the size label */
	&.ck-orientation-above-center {
		top: calc(var(--ck-resizer-tooltip-height) * -1);
		left: 50%;
		transform: translate(-50%);
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../mixins/_focus.css";
@import "../mixins/_shadow.css";

:root {
	--ck-widget-outline-thickness: 3px;
	--ck-widget-handler-icon-size: 16px;
	--ck-widget-handler-animation-duration: 200ms;
	--ck-widget-handler-animation-curve: ease;

	--ck-color-widget-blurred-border: hsl(0, 0%, 87%);
	--ck-color-widget-hover-border: hsl(43, 100%, 62%);
	--ck-color-widget-editable-focus-background: var(--ck-color-base-background);
	--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);
}

.ck .ck-widget {
	outline-width: var(--ck-widget-outline-thickness);
	outline-style: solid;
	outline-color: transparent;
	transition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);

	&.ck-widget_selected,
	&.ck-widget_selected:hover {
		outline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);
	}

	&:hover {
		outline-color: var(--ck-color-widget-hover-border);
	}
}

.ck .ck-editor__nested-editable {
	border: 1px solid transparent;

	/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.
	These styles show a different border for a blink of an eye, so \`:focus\` need to have same styles applied. */
	&.ck-editor__nested-editable_focused,
	&:focus {
		@mixin ck-focus-ring;
		@mixin ck-box-shadow var(--ck-inner-shadow);

		background-color: var(--ck-color-widget-editable-focus-background);
	}
}

.ck .ck-widget.ck-widget_with-selection-handle {
	& .ck-widget__selection-handle {
		padding: 4px;
		box-sizing: border-box;

		/* Background and opacity will be animated as the handler shows up or the widget gets selected. */
		background-color: transparent;
		opacity: 0;

		/* Transition:
		   * background-color for the .ck-widget_selected state change,
		   * visibility for hiding the handler,
		   * opacity for the proper look of the icon when the handler disappears. */
		transition:
			background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),
			visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),
			opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);

		/* Make only top corners round. */
		border-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;

		/* Place the drag handler outside the widget wrapper. */
		transform: translateY(-100%);
		left: calc(0px - var(--ck-widget-outline-thickness));
		top: 0;

		& .ck-icon {
			/* Make sure the dimensions of the icon are independent of the fon-size of the content. */
			width: var(--ck-widget-handler-icon-size);
			height: var(--ck-widget-handler-icon-size);
			color: var(--ck-color-widget-drag-handler-icon-color);

			/* The "selected" part of the icon is invisible by default */
			& .ck-icon__selected-indicator {
				opacity: 0;

				/* Note: The animation is longer on purpose. Simply feels better. */
				transition: opacity 300ms var(--ck-widget-handler-animation-curve);
			}
		}

		/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */
		&:hover .ck-icon .ck-icon__selected-indicator {
			opacity: 1;
		}
	}

	/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */
	&:hover > .ck-widget__selection-handle {
		opacity: 1;
		background-color: var(--ck-color-widget-hover-border);
	}

	/* Show the selection handler when the widget is selected, but not for nested widgets. */
	&.ck-widget_selected,
	&.ck-widget_selected:hover {
		& > .ck-widget__selection-handle {
			opacity: 1;
			background-color: var(--ck-color-focus-border);

			/* When the widget is selected, notify the user using the proper look of the icon. */
			& .ck-icon .ck-icon__selected-indicator {
				opacity: 1;
			}
		}
	}
}

/* In a RTL environment, align the selection handler to the right side of the widget */
/* stylelint-disable-next-line no-descending-specificity */
.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {
	left: auto;
	right: calc(0px - var(--ck-widget-outline-thickness));
}

/* https://github.com/ckeditor/ckeditor5/issues/6415 */
.ck.ck-editor__editable.ck-read-only .ck-widget {
	/* Prevent the :hover outline from showing up because of the used outline-color transition. */
	transition: none;

	&:not(.ck-widget_selected) {
		/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.
		 * See: https://github.com/ckeditor/ckeditor5/issues/1261
		 *
		 * Leave the unit because this custom property is used in calc() by other features.
		 * See: https://github.com/ckeditor/ckeditor5/issues/6775
		 */
		--ck-widget-outline-thickness: 0px;
	}

	&.ck-widget_with-selection-handle {
		& .ck-widget__selection-handle,
		& .ck-widget__selection-handle:hover {
			background: var(--ck-color-widget-blurred-border);
		}
	}
}

/* Style the widget when it's selected but the editable it belongs to lost focus. */
/* stylelint-disable-next-line no-descending-specificity */
.ck.ck-editor__editable.ck-blurred .ck-widget {
	&.ck-widget_selected,
	&.ck-widget_selected:hover {
		outline-color: var(--ck-color-widget-blurred-border);

		&.ck-widget_with-selection-handle {
			& > .ck-widget__selection-handle,
			& > .ck-widget__selection-handle:hover {
				background: var(--ck-color-widget-blurred-border);
			}
		}
	}
}

.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,
.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {
	/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.
	In fact, anything with overflow: hidden.
	https://github.com/ckeditor/ckeditor5-block-quote/issues/28
	https://github.com/ckeditor/ckeditor5-widget/issues/44
	https://github.com/ckeditor/ckeditor5-widget/issues/66 */
	margin-top: calc(1em + var(--ck-widget-handler-icon-size));
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A visual style of focused element's border.
 */
@define-mixin ck-focus-ring {
	/* Disable native outline. */
	outline: none;
	border: var(--ck-focus-ring)
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * A helper to combine multiple shadows.
 */
@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {
	box-shadow: $shadowA, $shadowB;
}

/**
 * Gives an element a drop shadow so it looks like a floating panel.
 */
@define-mixin ck-drop-shadow {
	@mixin ck-box-shadow var(--ck-drop-shadow);
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 8506: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widgetresize.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"], names: [], mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-widget_with-resizer {
	/* Make the widget wrapper a relative positioning container for the drag handle. */
	position: relative;
}

.ck .ck-widget__resizer {
	display: none;
	position: absolute;

	/* The wrapper itself should not interfere with the pointer device, only the handles should. */
	pointer-events: none;

	left: 0;
	top: 0;
}

.ck-focused .ck-widget_with-resizer.ck-widget_selected {
	& > .ck-widget__resizer {
		display: block;
	}
}

.ck .ck-widget__resizer__handle {
	position: absolute;

	/* Resizers are the only UI elements that should interfere with a pointer device. */
	pointer-events: all;

	&.ck-widget__resizer__handle-top-left,
	&.ck-widget__resizer__handle-bottom-right {
		cursor: nwse-resize;
	}

	&.ck-widget__resizer__handle-top-right,
	&.ck-widget__resizer__handle-bottom-left {
		cursor: nesw-resize;
	}
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-resizer-size: 10px;

	/* Set the resizer with a 50% offset. */
	--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);
	--ck-resizer-border-width: 1px;
}

.ck .ck-widget__resizer {
	outline: 1px solid var(--ck-color-resizer);
}

.ck .ck-widget__resizer__handle {
	width: var(--ck-resizer-size);
	height: var(--ck-resizer-size);
	background: var(--ck-color-focus-border);
	border: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);
	border-radius: var(--ck-resizer-border-radius);

	&.ck-widget__resizer__handle-top-left {
		top: var(--ck-resizer-offset);
		left: var(--ck-resizer-offset);
	}

	&.ck-widget__resizer__handle-top-right {
		top: var(--ck-resizer-offset);
		right: var(--ck-resizer-offset);
	}

	&.ck-widget__resizer__handle-bottom-right {
		bottom: var(--ck-resizer-offset);
		right: var(--ck-resizer-offset);
	}

	&.ck-widget__resizer__handle-bottom-left {
		bottom: var(--ck-resizer-offset);
		left: var(--ck-resizer-offset);
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 4921: (h, f, p) => {
      p.d(f, { Z: () => _ });
      var v = p(1799), b = p.n(v), y = p(2609), k = p.n(y)()(b());
      k.push([h.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widgettypearound.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"], names: [], mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-widget {
	/*
	 * Styles of the type around buttons
	 */
	& .ck-widget__type-around__button {
		display: block;
		position: absolute;
		overflow: hidden;
		z-index: var(--ck-z-default);

		& svg {
			position: absolute;
			top: 50%;
			left: 50%;
			z-index: calc(var(--ck-z-default) + 2);
		}

		&.ck-widget__type-around__button_before {
			/* Place it in the middle of the outline */
			top: calc(-0.5 * var(--ck-widget-outline-thickness));
			left: min(10%, 30px);

			transform: translateY(-50%);
		}

		&.ck-widget__type-around__button_after {
			/* Place it in the middle of the outline */
			bottom: calc(-0.5 * var(--ck-widget-outline-thickness));
			right: min(10%, 30px);

			transform: translateY(50%);
		}
	}

	/*
	 * Styles for the buttons when:
	 * - the widget is selected,
	 * - or the button is being hovered (regardless of the widget state).
	 */
	&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,
	& > .ck-widget__type-around > .ck-widget__type-around__button:hover {
		&::after {
			content: "";
			display: block;
			position: absolute;
			top: 1px;
			left: 1px;
			z-index: calc(var(--ck-z-default) + 1);
		}
	}

	/*
	 * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.
	 */
	& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		display: none;
		position: absolute;
		left: 0;
		right: 0;
	}

	/*
	 * When the widget is hovered the "fake caret" would normally be narrower than the
	 * extra outline displayed around the widget. Let's extend the "fake caret" to match
	 * the full width of the widget.
	 */
	&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		left: calc( -1 * var(--ck-widget-outline-thickness) );
		right: calc( -1 * var(--ck-widget-outline-thickness) );
	}

	/*
	 * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).
	 */
	&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		top: calc( -1 * var(--ck-widget-outline-thickness) - 1px );
		display: block;
	}

	/*
	 * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).
	 */
	&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		bottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );
		display: block;
	}
}

/*
 * Integration with the read-only mode of the editor.
 */
.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {
	display: none;
}

/*
 * Integration with the restricted editing mode (feature) of the editor.
 */
.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {
	display: none;
}

/*
 * Integration with the #isEnabled property of the WidgetTypeAround plugin.
 */
.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {
	display: none;
}
`, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-widget-type-around-button-size: 20px;
	--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);
	--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);
	--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);
	--ck-color-widget-type-around-button-radar-start-alpha: 0;
	--ck-color-widget-type-around-button-radar-end-alpha: .3;
	--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);
}

@define-mixin ck-widget-type-around-button-visible {
	opacity: 1;
	pointer-events: auto;
}

@define-mixin ck-widget-type-around-button-hidden {
	opacity: 0;
	pointer-events: none;
}

.ck .ck-widget {
	/*
	 * Styles of the type around buttons
	 */
	& .ck-widget__type-around__button {
		width: var(--ck-widget-type-around-button-size);
		height: var(--ck-widget-type-around-button-size);
		background: var(--ck-color-widget-type-around-button);
		border-radius: 100px;
		transition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);

		@mixin ck-widget-type-around-button-hidden;

		& svg {
			width: 10px;
			height: 8px;
			transform: translate(-50%,-50%);
			transition: transform .5s ease;
			margin-top: 1px;

			& * {
				stroke-dasharray: 10;
				stroke-dashoffset: 0;

				fill: none;
				stroke: var(--ck-color-widget-type-around-button-icon);
				stroke-width: 1.5px;
				stroke-linecap: round;
				stroke-linejoin: round;
			}

			& line {
				stroke-dasharray: 7;
			}
		}

		&:hover {
			/*
			 * Display the "sonar" around the button when hovered.
			 */
			animation: ck-widget-type-around-button-sonar 1s ease infinite;

			/*
			 * Animate active button's icon.
			 */
			& svg {
				& polyline {
					animation: ck-widget-type-around-arrow-dash 2s linear;
				}

				& line {
					animation: ck-widget-type-around-arrow-tip-dash 2s linear;
				}
			}
		}
	}

	/*
	 * Show type around buttons when the widget gets selected or being hovered.
	 */
	&.ck-widget_selected,
	&:hover {
		& > .ck-widget__type-around > .ck-widget__type-around__button {
			@mixin ck-widget-type-around-button-visible;
		}
	}

	/*
	 * Styles for the buttons when the widget is NOT selected (but the buttons are visible
	 * and still can be hovered).
	 */
	&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {
		background: var(--ck-color-widget-type-around-button-hover);
	}

	/*
	 * Styles for the buttons when:
	 * - the widget is selected,
	 * - or the button is being hovered (regardless of the widget state).
	 */
	&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,
	& > .ck-widget__type-around > .ck-widget__type-around__button:hover {
		background: var(--ck-color-widget-type-around-button-active);

		&::after {
			width: calc(var(--ck-widget-type-around-button-size) - 2px);
			height: calc(var(--ck-widget-type-around-button-size) - 2px);
			border-radius: 100px;
			background: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);
		}
	}

	/*
	 * Styles for the "before" button when the widget has a selection handle. Because some space
	 * is consumed by the handle, the button must be moved slightly to the right to let it breathe.
	 */
	&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {
		margin-left: 20px;
	}

	/*
	 * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.
	 */
	& .ck-widget__type-around__fake-caret {
		pointer-events: none;
		height: 1px;
		animation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;

		/*
		 * The semi-transparent-outline+background combo improves the contrast
		 * when the background underneath the fake caret is dark.
		 */
		outline: solid 1px hsla(0, 0%, 100%, .5);
		background: var(--ck-color-base-text);
	}

	/*
	 * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).
	 * Despite the widget being physically selected in the model, its outline should disappear.
	 */
	&.ck-widget_selected {
		&.ck-widget_type-around_show-fake-caret_before,
		&.ck-widget_type-around_show-fake-caret_after {
			outline-color: transparent;
		}
	}

	&.ck-widget_type-around_show-fake-caret_before,
	&.ck-widget_type-around_show-fake-caret_after {
		/*
		 * When the "fake caret" is visible we simulate that the widget is not selected
		 * (despite being physically selected), so the outline color should be for the
		 * unselected widget.
		 */
		&.ck-widget_selected:hover {
			outline-color: var(--ck-color-widget-hover-border);
		}

		/*
		 * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).
		 * In this state, the type around buttons would collide with the fake carets so they should disappear.
		 */
		& > .ck-widget__type-around > .ck-widget__type-around__button {
			@mixin ck-widget-type-around-button-hidden;
		}

		/*
		 * Fake horizontal caret integration with the selection handle. When the caret is visible, simply
		 * hide the handle because it intersects with the caret (and does not make much sense anyway).
		 */
		&.ck-widget_with-selection-handle {
			&.ck-widget_selected,
			&.ck-widget_selected:hover {
				& > .ck-widget__selection-handle {
					opacity: 0
				}
			}
		}

		/*
		 * Fake horizontal caret integration with the resize UI. When the caret is visible, simply
		 * hide the resize UI because it creates too much noise. It can be visible when the user
		 * hovers the widget, though.
		 */
		&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {
			opacity: 0
		}
	}
}

/*
 * Styles for the "before" button when the widget has a selection handle in an RTL environment.
 * The selection handler is aligned to the right side of the widget so there is no need to create
 * additional space for it next to the "before" button.
 */
.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {
	margin-left: 0;
	margin-right: 20px;
}

/*
 * Hide type around buttons when the widget is selected as a child of a selected
 * nested editable (e.g. mulit-cell table selection).
 *
 * See https://github.com/ckeditor/ckeditor5/issues/7263.
 */
.ck-editor__nested-editable.ck-editor__editable_selected {
	& .ck-widget {
		&.ck-widget_selected,
		&:hover {
			& > .ck-widget__type-around > .ck-widget__type-around__button {
				@mixin ck-widget-type-around-button-hidden;
			}
		}
	}
}

/*
 * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).
 */
.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {
	background: var(--ck-color-widget-type-around-button-blurred-editable);

	& svg * {
		stroke: hsl(0,0%,60%);
	}
}

@keyframes ck-widget-type-around-arrow-dash {
	0% {
		stroke-dashoffset: 10;
	}
	20%, 100% {
		stroke-dashoffset: 0;
	}
}

@keyframes ck-widget-type-around-arrow-tip-dash {
	0%, 20% {
		stroke-dashoffset: 7;
	}
	40%, 100% {
		stroke-dashoffset: 0;
	}
}

@keyframes ck-widget-type-around-button-sonar {
	0% {
		box-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));
	}
	50% {
		box-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));
	}
	100% {
		box-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));
	}
}

@keyframes ck-widget-type-around-fake-caret-pulse {
	0% {
		opacity: 1;
	}
	49% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	99% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
`], sourceRoot: "" }]);
      const _ = k;
    }, 2609: (h) => {
      h.exports = function(f) {
        var p = [];
        return p.toString = function() {
          return this.map(function(v) {
            var b = f(v);
            return v[2] ? "@media ".concat(v[2], " {").concat(b, "}") : b;
          }).join("");
        }, p.i = function(v, b, y) {
          typeof v == "string" && (v = [[null, v, ""]]);
          var k = {};
          if (y)
            for (var _ = 0; _ < this.length; _++) {
              var E = this[_][0];
              E != null && (k[E] = !0);
            }
          for (var x = 0; x < v.length; x++) {
            var D = [].concat(v[x]);
            y && k[D[0]] || (b && (D[2] ? D[2] = "".concat(b, " and ").concat(D[2]) : D[2] = b), p.push(D));
          }
        }, p;
      };
    }, 1799: (h) => {
      function f(v, b) {
        return function(y) {
          if (Array.isArray(y))
            return y;
        }(v) || function(y, k) {
          var _ = y && (typeof Symbol < "u" && y[Symbol.iterator] || y["@@iterator"]);
          if (_ != null) {
            var E, x, D = [], I = !0, N = !1;
            try {
              for (_ = _.call(y); !(I = (E = _.next()).done) && (D.push(E.value), !k || D.length !== k); I = !0)
                ;
            } catch (O) {
              N = !0, x = O;
            } finally {
              try {
                I || _.return == null || _.return();
              } finally {
                if (N)
                  throw x;
              }
            }
            return D;
          }
        }(v, b) || function(y, k) {
          if (!!y) {
            if (typeof y == "string")
              return p(y, k);
            var _ = Object.prototype.toString.call(y).slice(8, -1);
            if (_ === "Object" && y.constructor && (_ = y.constructor.name), _ === "Map" || _ === "Set")
              return Array.from(y);
            if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
              return p(y, k);
          }
        }(v, b) || function() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }();
      }
      function p(v, b) {
        (b == null || b > v.length) && (b = v.length);
        for (var y = 0, k = new Array(b); y < b; y++)
          k[y] = v[y];
        return k;
      }
      h.exports = function(v) {
        var b = f(v, 4), y = b[1], k = b[3];
        if (!k)
          return y;
        if (typeof btoa == "function") {
          var _ = btoa(unescape(encodeURIComponent(JSON.stringify(k)))), E = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(_), x = "/*# ".concat(E, " */"), D = k.sources.map(function(I) {
            return "/*# sourceURL=".concat(k.sourceRoot || "").concat(I, " */");
          });
          return [y].concat(D).concat([x]).join(`
`);
        }
        return [y].join(`
`);
      };
    }, 6062: (h, f, p) => {
      var v, b = function() {
        return v === void 0 && (v = Boolean(window && document && document.all && !window.atob)), v;
      }, y = function() {
        var L = {};
        return function(B) {
          if (L[B] === void 0) {
            var U = document.querySelector(B);
            if (window.HTMLIFrameElement && U instanceof window.HTMLIFrameElement)
              try {
                U = U.contentDocument.head;
              } catch {
                U = null;
              }
            L[B] = U;
          }
          return L[B];
        };
      }(), k = [];
      function _(L) {
        for (var B = -1, U = 0; U < k.length; U++)
          if (k[U].identifier === L) {
            B = U;
            break;
          }
        return B;
      }
      function E(L, B) {
        for (var U = {}, G = [], q = 0; q < L.length; q++) {
          var Y = L[q], Q = B.base ? Y[0] + B.base : Y[0], Z = U[Q] || 0, ae = "".concat(Q, " ").concat(Z);
          U[Q] = Z + 1;
          var ie = _(ae), pe = { css: Y[1], media: Y[2], sourceMap: Y[3] };
          ie !== -1 ? (k[ie].references++, k[ie].updater(pe)) : k.push({ identifier: ae, updater: $(pe, B), references: 1 }), G.push(ae);
        }
        return G;
      }
      function x(L) {
        var B = document.createElement("style"), U = L.attributes || {};
        if (U.nonce === void 0) {
          var G = p.nc;
          G && (U.nonce = G);
        }
        if (Object.keys(U).forEach(function(Y) {
          B.setAttribute(Y, U[Y]);
        }), typeof L.insert == "function")
          L.insert(B);
        else {
          var q = y(L.insert || "head");
          if (!q)
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          q.appendChild(B);
        }
        return B;
      }
      var D, I = (D = [], function(L, B) {
        return D[L] = B, D.filter(Boolean).join(`
`);
      });
      function N(L, B, U, G) {
        var q = U ? "" : G.media ? "@media ".concat(G.media, " {").concat(G.css, "}") : G.css;
        if (L.styleSheet)
          L.styleSheet.cssText = I(B, q);
        else {
          var Y = document.createTextNode(q), Q = L.childNodes;
          Q[B] && L.removeChild(Q[B]), Q.length ? L.insertBefore(Y, Q[B]) : L.appendChild(Y);
        }
      }
      function O(L, B, U) {
        var G = U.css, q = U.media, Y = U.sourceMap;
        if (q ? L.setAttribute("media", q) : L.removeAttribute("media"), Y && typeof btoa < "u" && (G += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(Y)))), " */")), L.styleSheet)
          L.styleSheet.cssText = G;
        else {
          for (; L.firstChild; )
            L.removeChild(L.firstChild);
          L.appendChild(document.createTextNode(G));
        }
      }
      var P = null, S = 0;
      function $(L, B) {
        var U, G, q;
        if (B.singleton) {
          var Y = S++;
          U = P || (P = x(B)), G = N.bind(null, U, Y, !1), q = N.bind(null, U, Y, !0);
        } else
          U = x(B), G = O.bind(null, U, B), q = function() {
            (function(Q) {
              if (Q.parentNode === null)
                return !1;
              Q.parentNode.removeChild(Q);
            })(U);
          };
        return G(L), function(Q) {
          if (Q) {
            if (Q.css === L.css && Q.media === L.media && Q.sourceMap === L.sourceMap)
              return;
            G(L = Q);
          } else
            q();
        };
      }
      h.exports = function(L, B) {
        (B = B || {}).singleton || typeof B.singleton == "boolean" || (B.singleton = b());
        var U = E(L = L || [], B);
        return function(G) {
          if (G = G || [], Object.prototype.toString.call(G) === "[object Array]") {
            for (var q = 0; q < U.length; q++) {
              var Y = _(U[q]);
              k[Y].references--;
            }
            for (var Q = E(G, B), Z = 0; Z < U.length; Z++) {
              var ae = _(U[Z]);
              k[ae].references === 0 && (k[ae].updater(), k.splice(ae, 1));
            }
            U = Q;
          }
        };
      };
    } }, o = {};
    function s(h) {
      var f = o[h];
      if (f !== void 0)
        return f.exports;
      var p = o[h] = { id: h, exports: {} };
      return r[h](p, p.exports, s), p.exports;
    }
    s.n = (h) => {
      var f = h && h.__esModule ? () => h.default : () => h;
      return s.d(f, { a: f }), f;
    }, s.d = (h, f) => {
      for (var p in f)
        s.o(f, p) && !s.o(h, p) && Object.defineProperty(h, p, { enumerable: !0, get: f[p] });
    }, s.g = function() {
      if (typeof globalThis == "object")
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object")
          return window;
      }
    }(), s.o = (h, f) => Object.prototype.hasOwnProperty.call(h, f), s.nc = void 0;
    var u = {};
    return (() => {
      s.d(u, { default: () => sv });
      const h = function() {
        try {
          return navigator.userAgent.toLowerCase();
        } catch {
          return "";
        }
      }(), f = { isMac: v(h), isWindows: function(c) {
        return c.indexOf("windows") > -1;
      }(h), isGecko: function(c) {
        return !!c.match(/gecko\/\d+/);
      }(h), isSafari: function(c) {
        return c.indexOf(" applewebkit/") > -1 && c.indexOf("chrome") === -1;
      }(h), isiOS: function(c) {
        return !!c.match(/iphone|ipad/i) || v(c) && navigator.maxTouchPoints > 0;
      }(h), isAndroid: function(c) {
        return c.indexOf("android") > -1;
      }(h), isBlink: function(c) {
        return c.indexOf("chrome/") > -1 && c.indexOf("edge/") < 0;
      }(h), features: { isRegExpUnicodePropertySupported: function() {
        let c = !1;
        try {
          c = "\u0107".search(new RegExp("[\\p{L}]", "u")) === 0;
        } catch {
        }
        return c;
      }() } }, p = f;
      function v(c) {
        return c.indexOf("macintosh") > -1;
      }
      function b(c, t, i, a) {
        i = i || function(w, A) {
          return w === A;
        };
        const l = Array.isArray(c) ? c : Array.prototype.slice.call(c), d = Array.isArray(t) ? t : Array.prototype.slice.call(t), g = function(w, A, C) {
          const T = y(w, A, C);
          if (T === -1)
            return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
          const R = k(w, T), j = k(A, T), F = y(R, j, C), V = w.length - F, W = A.length - F;
          return { firstIndex: T, lastIndexOld: V, lastIndexNew: W };
        }(l, d, i);
        return a ? function(w, A) {
          const { firstIndex: C, lastIndexOld: T, lastIndexNew: R } = w;
          if (C === -1)
            return Array(A).fill("equal");
          let j = [];
          return C > 0 && (j = j.concat(Array(C).fill("equal"))), R - C > 0 && (j = j.concat(Array(R - C).fill("insert"))), T - C > 0 && (j = j.concat(Array(T - C).fill("delete"))), R < A && (j = j.concat(Array(A - R).fill("equal"))), j;
        }(g, d.length) : function(w, A) {
          const C = [], { firstIndex: T, lastIndexOld: R, lastIndexNew: j } = A;
          return j - T > 0 && C.push({ index: T, type: "insert", values: w.slice(T, j) }), R - T > 0 && C.push({ index: T + (j - T), type: "delete", howMany: R - T }), C;
        }(d, g);
      }
      function y(c, t, i) {
        for (let a = 0; a < Math.max(c.length, t.length); a++)
          if (c[a] === void 0 || t[a] === void 0 || !i(c[a], t[a]))
            return a;
        return -1;
      }
      function k(c, t) {
        return c.slice(t).reverse();
      }
      function _(c, t, i) {
        i = i || function(V, W) {
          return V === W;
        };
        const a = c.length, l = t.length;
        if (a > 200 || l > 200 || a + l > 300)
          return _.fastDiff(c, t, i, !0);
        let d, g;
        if (l < a) {
          const V = c;
          c = t, t = V, d = "delete", g = "insert";
        } else
          d = "insert", g = "delete";
        const m = c.length, w = t.length, A = w - m, C = {}, T = {};
        function R(V) {
          const W = (T[V - 1] !== void 0 ? T[V - 1] : -1) + 1, ee = T[V + 1] !== void 0 ? T[V + 1] : -1, le = W > ee ? -1 : 1;
          C[V + le] && (C[V] = C[V + le].slice(0)), C[V] || (C[V] = []), C[V].push(W > ee ? d : g);
          let be = Math.max(W, ee), Ne = be - V;
          for (; Ne < m && be < w && i(c[Ne], t[be]); )
            Ne++, be++, C[V].push("equal");
          return be;
        }
        let j, F = 0;
        do {
          for (j = -F; j < A; j++)
            T[j] = R(j);
          for (j = A + F; j > A; j--)
            T[j] = R(j);
          T[A] = R(A), F++;
        } while (T[A] !== w);
        return C[A].slice(1);
      }
      function E(c, ...t) {
        t.forEach((i) => {
          const a = Object.getOwnPropertyNames(i), l = Object.getOwnPropertySymbols(i);
          a.concat(l).forEach((d) => {
            if (d in c.prototype || typeof i == "function" && (d == "length" || d == "name" || d == "prototype"))
              return;
            const g = Object.getOwnPropertyDescriptor(i, d);
            g.enumerable = !1, Object.defineProperty(c.prototype, d, g);
          });
        });
      }
      _.fastDiff = b;
      const x = function() {
        return function c() {
          c.called = !0;
        };
      };
      class D {
        constructor(t, i) {
          this.source = t, this.name = i, this.path = [], this.stop = x(), this.off = x();
        }
      }
      const I = new Array(256).fill("").map((c, t) => ("0" + t.toString(16)).slice(-2));
      function N() {
        const c = 4294967296 * Math.random() >>> 0, t = 4294967296 * Math.random() >>> 0, i = 4294967296 * Math.random() >>> 0, a = 4294967296 * Math.random() >>> 0;
        return "e" + I[c >> 0 & 255] + I[c >> 8 & 255] + I[c >> 16 & 255] + I[c >> 24 & 255] + I[t >> 0 & 255] + I[t >> 8 & 255] + I[t >> 16 & 255] + I[t >> 24 & 255] + I[i >> 0 & 255] + I[i >> 8 & 255] + I[i >> 16 & 255] + I[i >> 24 & 255] + I[a >> 0 & 255] + I[a >> 8 & 255] + I[a >> 16 & 255] + I[a >> 24 & 255];
      }
      const O = { get(c = "normal") {
        return typeof c != "number" ? this[c] || this.normal : c;
      }, highest: 1e5, high: 1e3, normal: 0, low: -1e3, lowest: -1e5 };
      function P(c, t) {
        const i = O.get(t.priority);
        for (let a = 0; a < c.length; a++)
          if (O.get(c[a].priority) < i)
            return void c.splice(a, 0, t);
        c.push(t);
      }
      class S extends Error {
        constructor(t, i, a) {
          super(function(l, d) {
            const g = /* @__PURE__ */ new WeakSet(), m = (C, T) => {
              if (typeof T == "object" && T !== null) {
                if (g.has(T))
                  return `[object ${T.constructor.name}]`;
                g.add(T);
              }
              return T;
            }, w = d ? ` ${JSON.stringify(d, m)}` : "", A = B(l);
            return l + w + A;
          }(t, a)), this.name = "CKEditorError", this.context = i, this.data = a;
        }
        is(t) {
          return t === "CKEditorError";
        }
        static rethrowUnexpectedError(t, i) {
          if (t.is && t.is("CKEditorError"))
            throw t;
          const a = new S(t.message, i);
          throw a.stack = t.stack, a;
        }
      }
      function $(c, t) {
        console.warn(...U(c, t));
      }
      function L(c, t) {
        console.error(...U(c, t));
      }
      function B(c) {
        return `
Read more: https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html#error-${c}`;
      }
      function U(c, t) {
        const i = B(c);
        return t ? [c, t, i] : [c, i];
      }
      const G = "35.4.0", q = typeof window == "object" ? window : s.g;
      if (q.CKEDITOR_VERSION)
        throw new S("ckeditor-duplicated-modules", null);
      q.CKEDITOR_VERSION = G;
      const Y = Symbol("listeningTo"), Q = Symbol("emitterId"), Z = Symbol("delegations"), ae = ie(Object);
      function ie(c) {
        return c ? class extends c {
          on(t, i, a) {
            this.listenTo(this, t, i, a);
          }
          once(t, i, a) {
            let l = !1;
            this.listenTo(this, t, (d, ...g) => {
              l || (l = !0, d.off(), i.call(this, d, ...g));
            }, a);
          }
          off(t, i) {
            this.stopListening(this, t, i);
          }
          listenTo(t, i, a, l = {}) {
            let d, g;
            this[Y] || (this[Y] = {});
            const m = this[Y];
            ce(t) || pe(t);
            const w = ce(t);
            (d = m[w]) || (d = m[w] = { emitter: t, callbacks: {} }), (g = d.callbacks[i]) || (g = d.callbacks[i] = []), g.push(a), function(A, C, T, R, j) {
              C._addEventListener ? C._addEventListener(T, R, j) : A._addEventListener.call(C, T, R, j);
            }(this, t, i, a, l);
          }
          stopListening(t, i, a) {
            const l = this[Y];
            let d = t && ce(t);
            const g = l && d ? l[d] : void 0, m = g && i ? g.callbacks[i] : void 0;
            if (!(!l || t && !g || i && !m))
              if (a)
                de(this, t, i, a), m.indexOf(a) !== -1 && (m.length === 1 ? delete g.callbacks[i] : de(this, t, i, a));
              else if (m) {
                for (; a = m.pop(); )
                  de(this, t, i, a);
                delete g.callbacks[i];
              } else if (g) {
                for (i in g.callbacks)
                  this.stopListening(t, i);
                delete l[d];
              } else {
                for (d in l)
                  this.stopListening(l[d].emitter);
                delete this[Y];
              }
          }
          fire(t, ...i) {
            try {
              const a = t instanceof D ? t : new D(this, t), l = a.name;
              let d = se(this, l);
              if (a.path.push(this), d) {
                const m = [a, ...i];
                d = Array.from(d);
                for (let w = 0; w < d.length && (d[w].callback.apply(this, m), a.off.called && (delete a.off.called, this._removeEventListener(l, d[w].callback)), !a.stop.called); w++)
                  ;
              }
              const g = this[Z];
              if (g) {
                const m = g.get(l), w = g.get("*");
                m && he(m, a, i), w && he(w, a, i);
              }
              return a.return;
            } catch (a) {
              S.rethrowUnexpectedError(a, this);
            }
          }
          delegate(...t) {
            return { to: (i, a) => {
              this[Z] || (this[Z] = /* @__PURE__ */ new Map()), t.forEach((l) => {
                const d = this[Z].get(l);
                d ? d.set(i, a) : this[Z].set(l, /* @__PURE__ */ new Map([[i, a]]));
              });
            } };
          }
          stopDelegating(t, i) {
            if (this[Z])
              if (t)
                if (i) {
                  const a = this[Z].get(t);
                  a && a.delete(i);
                } else
                  this[Z].delete(t);
              else
                this[Z].clear();
          }
          _addEventListener(t, i, a) {
            (function(g, m) {
              const w = ue(g);
              if (w[m])
                return;
              let A = m, C = null;
              const T = [];
              for (; A !== "" && !w[A]; )
                w[A] = { callbacks: [], childEvents: [] }, T.push(w[A]), C && w[A].childEvents.push(C), C = A, A = A.substr(0, A.lastIndexOf(":"));
              if (A !== "") {
                for (const R of T)
                  R.callbacks = w[A].callbacks.slice();
                w[A].childEvents.push(C);
              }
            })(this, t);
            const l = X(this, t), d = { callback: i, priority: O.get(a.priority) };
            for (const g of l)
              P(g, d);
          }
          _removeEventListener(t, i) {
            const a = X(this, t);
            for (const l of a)
              for (let d = 0; d < l.length; d++)
                l[d].callback == i && (l.splice(d, 1), d--);
          }
        } : ae;
      }
      function pe(c, t) {
        c[Q] || (c[Q] = t || N());
      }
      function ce(c) {
        return c[Q];
      }
      function ue(c) {
        return c._events || Object.defineProperty(c, "_events", { value: {} }), c._events;
      }
      function X(c, t) {
        const i = ue(c)[t];
        if (!i)
          return [];
        let a = [i.callbacks];
        for (let l = 0; l < i.childEvents.length; l++) {
          const d = X(c, i.childEvents[l]);
          a = a.concat(d);
        }
        return a;
      }
      function se(c, t) {
        let i;
        return c._events && (i = c._events[t]) && i.callbacks.length ? i.callbacks : t.indexOf(":") > -1 ? se(c, t.substr(0, t.lastIndexOf(":"))) : null;
      }
      function he(c, t, i) {
        for (let [a, l] of c) {
          l ? typeof l == "function" && (l = l(t.name)) : l = t.name;
          const d = new D(t.source, l);
          d.path = [...t.path], a.fire(d, ...i);
        }
      }
      function de(c, t, i, a) {
        t._removeEventListener ? t._removeEventListener(i, a) : c._removeEventListener.call(t, i, a);
      }
      ["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((c) => {
        ie[c] = ae.prototype[c];
      });
      const me = function(c) {
        var t = typeof c;
        return c != null && (t == "object" || t == "function");
      }, we = Symbol("observableProperties"), Ae = Symbol("boundObservables"), Se = Symbol("boundProperties"), ke = Symbol("decoratedMethods"), ge = Symbol("decoratedOriginal"), xe = Te(ie());
      function Te(c) {
        return c ? class extends c {
          set(t, i) {
            if (me(t))
              return void Object.keys(t).forEach((l) => {
                this.set(l, t[l]);
              }, this);
            J(this);
            const a = this[we];
            if (t in this && !a.has(t))
              throw new S("observable-set-cannot-override", this);
            Object.defineProperty(this, t, { enumerable: !0, configurable: !0, get: () => a.get(t), set(l) {
              const d = a.get(t);
              let g = this.fire(`set:${t}`, t, l, d);
              g === void 0 && (g = l), d === g && a.has(t) || (a.set(t, g), this.fire(`change:${t}`, t, g, d));
            } }), this[t] = i;
          }
          bind(...t) {
            if (!t.length || !He(t))
              throw new S("observable-bind-wrong-properties", this);
            if (new Set(t).size !== t.length)
              throw new S("observable-bind-duplicate-properties", this);
            J(this);
            const i = this[Se];
            t.forEach((l) => {
              if (i.has(l))
                throw new S("observable-bind-rebind", this);
            });
            const a = /* @__PURE__ */ new Map();
            return t.forEach((l) => {
              const d = { property: l, to: [] };
              i.set(l, d), a.set(l, d);
            }), { to: Ge, toMany: De, _observable: this, _bindProperties: t, _to: [], _bindings: a };
          }
          unbind(...t) {
            if (!this[we])
              return;
            const i = this[Se], a = this[Ae];
            if (t.length) {
              if (!He(t))
                throw new S("observable-unbind-wrong-properties", this);
              t.forEach((l) => {
                const d = i.get(l);
                d && (d.to.forEach(([g, m]) => {
                  const w = a.get(g), A = w[m];
                  A.delete(d), A.size || delete w[m], Object.keys(w).length || (a.delete(g), this.stopListening(g, "change"));
                }), i.delete(l));
              });
            } else
              a.forEach((l, d) => {
                this.stopListening(d, "change");
              }), a.clear(), i.clear();
          }
          decorate(t) {
            J(this);
            const i = this[t];
            if (!i)
              throw new S("observablemixin-cannot-decorate-undefined", this, { object: this, methodName: t });
            this.on(t, (a, l) => {
              a.return = i.apply(this, l);
            }), this[t] = function(...a) {
              return this.fire(t, a);
            }, this[t][ge] = i, this[ke] || (this[ke] = []), this[ke].push(t);
          }
          stopListening(t, i, a) {
            if (!t && this[ke]) {
              for (const l of this[ke])
                this[l] = this[l][ge];
              delete this[ke];
            }
            super.stopListening(t, i, a);
          }
        } : xe;
      }
      function J(c) {
        c[we] || (Object.defineProperty(c, we, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(c, Ae, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(c, Se, { value: /* @__PURE__ */ new Map() }));
      }
      function Ge(...c) {
        const t = function(...d) {
          if (!d.length)
            throw new S("observable-bind-to-parse-error", null);
          const g = { to: [] };
          let m;
          return typeof d[d.length - 1] == "function" && (g.callback = d.pop()), d.forEach((w) => {
            if (typeof w == "string")
              m.properties.push(w);
            else {
              if (typeof w != "object")
                throw new S("observable-bind-to-parse-error", null);
              m = { observable: w, properties: [] }, g.to.push(m);
            }
          }), g;
        }(...c), i = Array.from(this._bindings.keys()), a = i.length;
        if (!t.callback && t.to.length > 1)
          throw new S("observable-bind-to-no-callback", this);
        if (a > 1 && t.callback)
          throw new S("observable-bind-to-extra-callback", this);
        var l;
        t.to.forEach((d) => {
          if (d.properties.length && d.properties.length !== a)
            throw new S("observable-bind-to-properties-length", this);
          d.properties.length || (d.properties = this._bindProperties);
        }), this._to = t.to, t.callback && (this._bindings.get(i[0]).callback = t.callback), l = this._observable, this._to.forEach((d) => {
          const g = l[Ae];
          let m;
          g.get(d.observable) || l.listenTo(d.observable, "change", (w, A) => {
            m = g.get(d.observable)[A], m && m.forEach((C) => {
              at(l, C.property);
            });
          });
        }), function(d) {
          let g;
          d._bindings.forEach((m, w) => {
            d._to.forEach((A) => {
              g = A.properties[m.callback ? 0 : d._bindProperties.indexOf(w)], m.to.push([A.observable, g]), function(C, T, R, j) {
                const F = C[Ae], V = F.get(R), W = V || {};
                W[j] || (W[j] = /* @__PURE__ */ new Set()), W[j].add(T), V || F.set(R, W);
              }(d._observable, m, A.observable, g);
            });
          });
        }(this), this._bindProperties.forEach((d) => {
          at(this._observable, d);
        });
      }
      function De(c, t, i) {
        if (this._bindings.size > 1)
          throw new S("observable-bind-to-many-not-one-binding", this);
        this.to(...function(a, l) {
          const d = a.map((g) => [g, l]);
          return Array.prototype.concat.apply([], d);
        }(c, t), i);
      }
      function He(c) {
        return c.every((t) => typeof t == "string");
      }
      function at(c, t) {
        const i = c[Se].get(t);
        let a;
        i.callback ? a = i.callback.apply(c, i.to.map((l) => l[0][l[1]])) : (a = i.to[0], a = a[0][a[1]]), Object.prototype.hasOwnProperty.call(c, t) ? c[t] = a : c.set(t, a);
      }
      ["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((c) => {
        Te[c] = xe.prototype[c];
      });
      class qt {
        constructor() {
          this._replacedElements = [];
        }
        replace(t, i) {
          this._replacedElements.push({ element: t, newElement: i }), t.style.display = "none", i && t.parentNode.insertBefore(i, t.nextSibling);
        }
        restore() {
          this._replacedElements.forEach(({ element: t, newElement: i }) => {
            t.style.display = "", i && i.remove();
          }), this._replacedElements = [];
        }
      }
      function An(c) {
        let t = 0;
        for (const i of c)
          t++;
        return t;
      }
      function Lt(c, t) {
        const i = Math.min(c.length, t.length);
        for (let a = 0; a < i; a++)
          if (c[a] != t[a])
            return a;
        return c.length == t.length ? "same" : c.length < t.length ? "prefix" : "extension";
      }
      function Ft(c) {
        return !(!c || !c[Symbol.iterator]);
      }
      const mr = typeof ai == "object" && ai && ai.Object === Object && ai;
      var _r = typeof self == "object" && self && self.Object === Object && self;
      const Mn = mr || _r || Function("return this")(), Pe = Mn.Symbol;
      var Ke = Object.prototype, zt = Ke.hasOwnProperty, nn = Ke.toString, Cn = Pe ? Pe.toStringTag : void 0;
      const Hr = function(c) {
        var t = zt.call(c, Cn), i = c[Cn];
        try {
          c[Cn] = void 0;
          var a = !0;
        } catch {
        }
        var l = nn.call(c);
        return a && (t ? c[Cn] = i : delete c[Cn]), l;
      };
      var Mr = Object.prototype.toString;
      const vi = function(c) {
        return Mr.call(c);
      };
      var ji = Pe ? Pe.toStringTag : void 0;
      const Tn = function(c) {
        return c == null ? c === void 0 ? "[object Undefined]" : "[object Null]" : ji && ji in Object(c) ? Hr(c) : vi(c);
      }, Zt = Array.isArray, vn = function(c) {
        return c != null && typeof c == "object";
      }, Bi = function(c) {
        return typeof c == "string" || !Zt(c) && vn(c) && Tn(c) == "[object String]";
      };
      function Fi(c, t, i = {}, a = []) {
        const l = i && i.xmlns, d = l ? c.createElementNS(l, t) : c.createElement(t);
        for (const g in i)
          d.setAttribute(g, i[g]);
        !Bi(a) && Ft(a) || (a = [a]);
        for (let g of a)
          Bi(g) && (g = c.createTextNode(g)), d.appendChild(g);
        return d;
      }
      const zi = function(c, t) {
        return function(i) {
          return c(t(i));
        };
      }, bi = zi(Object.getPrototypeOf, Object);
      var Ks = Function.prototype, Vi = Object.prototype, na = Ks.toString, Ur = Vi.hasOwnProperty, Fa = na.call(Object);
      const Wn = function(c) {
        if (!vn(c) || Tn(c) != "[object Object]")
          return !1;
        var t = bi(c);
        if (t === null)
          return !0;
        var i = Ur.call(t, "constructor") && t.constructor;
        return typeof i == "function" && i instanceof i && na.call(i) == Fa;
      }, Ys = function() {
        this.__data__ = [], this.size = 0;
      }, Wr = function(c, t) {
        return c === t || c != c && t != t;
      }, _o = function(c, t) {
        for (var i = c.length; i--; )
          if (Wr(c[i][0], t))
            return i;
        return -1;
      };
      var Qs = Array.prototype.splice;
      const Cc = function(c) {
        var t = this.__data__, i = _o(t, c);
        return !(i < 0) && (i == t.length - 1 ? t.pop() : Qs.call(t, i, 1), --this.size, !0);
      }, xc = function(c) {
        var t = this.__data__, i = _o(t, c);
        return i < 0 ? void 0 : t[i][1];
      }, wi = function(c) {
        return _o(this.__data__, c) > -1;
      }, Ec = function(c, t) {
        var i = this.__data__, a = _o(i, c);
        return a < 0 ? (++this.size, i.push([c, t])) : i[a][1] = t, this;
      };
      function Hi(c) {
        var t = -1, i = c == null ? 0 : c.length;
        for (this.clear(); ++t < i; ) {
          var a = c[t];
          this.set(a[0], a[1]);
        }
      }
      Hi.prototype.clear = Ys, Hi.prototype.delete = Cc, Hi.prototype.get = xc, Hi.prototype.has = wi, Hi.prototype.set = Ec;
      const Tr = Hi, Sc = function() {
        this.__data__ = new Tr(), this.size = 0;
      }, re = function(c) {
        var t = this.__data__, i = t.delete(c);
        return this.size = t.size, i;
      }, Me = function(c) {
        return this.__data__.get(c);
      }, je = function(c) {
        return this.__data__.has(c);
      }, Qe = function(c) {
        if (!me(c))
          return !1;
        var t = Tn(c);
        return t == "[object Function]" || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
      }, bt = Mn["__core-js_shared__"];
      var Ct = function() {
        var c = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }();
      const wt = function(c) {
        return !!Ct && Ct in c;
      };
      var ht = Function.prototype.toString;
      const ln = function(c) {
        if (c != null) {
          try {
            return ht.call(c);
          } catch {
          }
          try {
            return c + "";
          } catch {
          }
        }
        return "";
      };
      var hn = /^\[object .+?Constructor\]$/, bn = Function.prototype, ur = Object.prototype, Gr = bn.toString, Zs = ur.hasOwnProperty, Ar = RegExp("^" + Gr.call(Zs).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      const Dd = function(c) {
        return !(!me(c) || wt(c)) && (Qe(c) ? Ar : hn).test(ln(c));
      }, Id = function(c, t) {
        return c?.[t];
      }, Ui = function(c, t) {
        var i = Id(c, t);
        return Dd(i) ? i : void 0;
      }, za = Ui(Mn, "Map"), Va = Ui(Object, "create"), Pd = function() {
        this.__data__ = Va ? Va(null) : {}, this.size = 0;
      }, rn = function(c) {
        var t = this.has(c) && delete this.__data__[c];
        return this.size -= t ? 1 : 0, t;
      };
      var om = Object.prototype.hasOwnProperty;
      const Mc = function(c) {
        var t = this.__data__;
        if (Va) {
          var i = t[c];
          return i === "__lodash_hash_undefined__" ? void 0 : i;
        }
        return om.call(t, c) ? t[c] : void 0;
      };
      var Od = Object.prototype.hasOwnProperty;
      const Ha = function(c) {
        var t = this.__data__;
        return Va ? t[c] !== void 0 : Od.call(t, c);
      }, Tc = function(c, t) {
        var i = this.__data__;
        return this.size += this.has(c) ? 0 : 1, i[c] = Va && t === void 0 ? "__lodash_hash_undefined__" : t, this;
      };
      function Dr(c) {
        var t = -1, i = c == null ? 0 : c.length;
        for (this.clear(); ++t < i; ) {
          var a = c[t];
          this.set(a[0], a[1]);
        }
      }
      Dr.prototype.clear = Pd, Dr.prototype.delete = rn, Dr.prototype.get = Mc, Dr.prototype.has = Ha, Dr.prototype.set = Tc;
      const Dc = Dr, am = function() {
        this.size = 0, this.__data__ = { hash: new Dc(), map: new (za || Tr)(), string: new Dc() };
      }, sm = function(c) {
        var t = typeof c;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? c !== "__proto__" : c === null;
      }, Ua = function(c, t) {
        var i = c.__data__;
        return sm(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
      }, lm = function(c) {
        var t = Ua(this, c).delete(c);
        return this.size -= t ? 1 : 0, t;
      }, Ic = function(c) {
        return Ua(this, c).get(c);
      }, Rd = function(c) {
        return Ua(this, c).has(c);
      }, cm = function(c, t) {
        var i = Ua(this, c), a = i.size;
        return i.set(c, t), this.size += i.size == a ? 0 : 1, this;
      };
      function ra(c) {
        var t = -1, i = c == null ? 0 : c.length;
        for (this.clear(); ++t < i; ) {
          var a = c[t];
          this.set(a[0], a[1]);
        }
      }
      ra.prototype.clear = am, ra.prototype.delete = lm, ra.prototype.get = Ic, ra.prototype.has = Rd, ra.prototype.set = cm;
      const Xs = ra, Nd = function(c, t) {
        var i = this.__data__;
        if (i instanceof Tr) {
          var a = i.__data__;
          if (!za || a.length < 199)
            return a.push([c, t]), this.size = ++i.size, this;
          i = this.__data__ = new Xs(a);
        }
        return i.set(c, t), this.size = i.size, this;
      };
      function Wi(c) {
        var t = this.__data__ = new Tr(c);
        this.size = t.size;
      }
      Wi.prototype.clear = Sc, Wi.prototype.delete = re, Wi.prototype.get = Me, Wi.prototype.has = je, Wi.prototype.set = Nd;
      const Wa = Wi, um = function(c, t) {
        for (var i = -1, a = c == null ? 0 : c.length; ++i < a && t(c[i], i, c) !== !1; )
          ;
        return c;
      }, Js = function() {
        try {
          var c = Ui(Object, "defineProperty");
          return c({}, "", {}), c;
        } catch {
        }
      }(), Pc = function(c, t, i) {
        t == "__proto__" && Js ? Js(c, t, { configurable: !0, enumerable: !0, value: i, writable: !0 }) : c[t] = i;
      };
      var Oc = Object.prototype.hasOwnProperty;
      const Rc = function(c, t, i) {
        var a = c[t];
        Oc.call(c, t) && Wr(a, i) && (i !== void 0 || t in c) || Pc(c, t, i);
      }, Ao = function(c, t, i, a) {
        var l = !i;
        i || (i = {});
        for (var d = -1, g = t.length; ++d < g; ) {
          var m = t[d], w = a ? a(i[m], c[m], m, i, c) : void 0;
          w === void 0 && (w = c[m]), l ? Pc(i, m, w) : Rc(i, m, w);
        }
        return i;
      }, $d = function(c, t) {
        for (var i = -1, a = Array(c); ++i < c; )
          a[i] = t(i);
        return a;
      }, Nc = function(c) {
        return vn(c) && Tn(c) == "[object Arguments]";
      };
      var $c = Object.prototype, dm = $c.hasOwnProperty, hm = $c.propertyIsEnumerable;
      const Lc = Nc(function() {
        return arguments;
      }()) ? Nc : function(c) {
        return vn(c) && dm.call(c, "callee") && !hm.call(c, "callee");
      }, Ld = function() {
        return !1;
      };
      var jd = n && !n.nodeType && n, jc = jd && !0 && e && !e.nodeType && e, el = jc && jc.exports === jd ? Mn.Buffer : void 0;
      const Ga = (el ? el.isBuffer : void 0) || Ld;
      var Bd = /^(?:0|[1-9]\d*)$/;
      const qa = function(c, t) {
        var i = typeof c;
        return !!(t = t ?? 9007199254740991) && (i == "number" || i != "symbol" && Bd.test(c)) && c > -1 && c % 1 == 0 && c < t;
      }, Bc = function(c) {
        return typeof c == "number" && c > -1 && c % 1 == 0 && c <= 9007199254740991;
      };
      var on = {};
      on["[object Float32Array]"] = on["[object Float64Array]"] = on["[object Int8Array]"] = on["[object Int16Array]"] = on["[object Int32Array]"] = on["[object Uint8Array]"] = on["[object Uint8ClampedArray]"] = on["[object Uint16Array]"] = on["[object Uint32Array]"] = !0, on["[object Arguments]"] = on["[object Array]"] = on["[object ArrayBuffer]"] = on["[object Boolean]"] = on["[object DataView]"] = on["[object Date]"] = on["[object Error]"] = on["[object Function]"] = on["[object Map]"] = on["[object Number]"] = on["[object Object]"] = on["[object RegExp]"] = on["[object Set]"] = on["[object String]"] = on["[object WeakMap]"] = !1;
      const Fd = function(c) {
        return vn(c) && Bc(c.length) && !!on[Tn(c)];
      }, Fc = function(c) {
        return function(t) {
          return c(t);
        };
      };
      var zd = n && !n.nodeType && n, Co = zd && !0 && e && !e.nodeType && e, Ka = Co && Co.exports === zd && mr.process;
      const Gi = function() {
        try {
          var c = Co && Co.require && Co.require("util").types;
          return c || Ka && Ka.binding && Ka.binding("util");
        } catch {
        }
      }();
      var tl = Gi && Gi.isTypedArray;
      const nl = tl ? Fc(tl) : Fd;
      var Vd = Object.prototype.hasOwnProperty;
      const zc = function(c, t) {
        var i = Zt(c), a = !i && Lc(c), l = !i && !a && Ga(c), d = !i && !a && !l && nl(c), g = i || a || l || d, m = g ? $d(c.length, String) : [], w = m.length;
        for (var A in c)
          !t && !Vd.call(c, A) || g && (A == "length" || l && (A == "offset" || A == "parent") || d && (A == "buffer" || A == "byteLength" || A == "byteOffset") || qa(A, w)) || m.push(A);
        return m;
      };
      var Hd = Object.prototype;
      const rl = function(c) {
        var t = c && c.constructor;
        return c === (typeof t == "function" && t.prototype || Hd);
      }, fm = zi(Object.keys, Object);
      var pm = Object.prototype.hasOwnProperty;
      const gm = function(c) {
        if (!rl(c))
          return fm(c);
        var t = [];
        for (var i in Object(c))
          pm.call(c, i) && i != "constructor" && t.push(i);
        return t;
      }, il = function(c) {
        return c != null && Bc(c.length) && !Qe(c);
      }, Vc = function(c) {
        return il(c) ? zc(c) : gm(c);
      }, xo = function(c, t) {
        return c && Ao(t, Vc(t), c);
      }, Hc = function(c) {
        var t = [];
        if (c != null)
          for (var i in Object(c))
            t.push(i);
        return t;
      };
      var mm = Object.prototype.hasOwnProperty;
      const vm = function(c) {
        if (!me(c))
          return Hc(c);
        var t = rl(c), i = [];
        for (var a in c)
          (a != "constructor" || !t && mm.call(c, a)) && i.push(a);
        return i;
      }, Eo = function(c) {
        return il(c) ? zc(c, !0) : vm(c);
      }, Uc = function(c, t) {
        return c && Ao(t, Eo(t), c);
      };
      var Ud = n && !n.nodeType && n, Wd = Ud && !0 && e && !e.nodeType && e, Gd = Wd && Wd.exports === Ud ? Mn.Buffer : void 0, Wc = Gd ? Gd.allocUnsafe : void 0;
      const Gc = function(c, t) {
        if (t)
          return c.slice();
        var i = c.length, a = Wc ? Wc(i) : new c.constructor(i);
        return c.copy(a), a;
      }, qd = function(c, t) {
        var i = -1, a = c.length;
        for (t || (t = Array(a)); ++i < a; )
          t[i] = c[i];
        return t;
      }, bm = function(c, t) {
        for (var i = -1, a = c == null ? 0 : c.length, l = 0, d = []; ++i < a; ) {
          var g = c[i];
          t(g, i, c) && (d[l++] = g);
        }
        return d;
      }, Kd = function() {
        return [];
      };
      var Yd = Object.prototype.propertyIsEnumerable, Qd = Object.getOwnPropertySymbols;
      const qc = Qd ? function(c) {
        return c == null ? [] : (c = Object(c), bm(Qd(c), function(t) {
          return Yd.call(c, t);
        }));
      } : Kd, wm = function(c, t) {
        return Ao(c, qc(c), t);
      }, Kc = function(c, t) {
        for (var i = -1, a = t.length, l = c.length; ++i < a; )
          c[l + i] = t[i];
        return c;
      }, Zd = Object.getOwnPropertySymbols ? function(c) {
        for (var t = []; c; )
          Kc(t, qc(c)), c = bi(c);
        return t;
      } : Kd, ym = function(c, t) {
        return Ao(c, Zd(c), t);
      }, Yc = function(c, t, i) {
        var a = t(c);
        return Zt(c) ? a : Kc(a, i(c));
      }, Qc = function(c) {
        return Yc(c, Vc, qc);
      }, Xd = function(c) {
        return Yc(c, Eo, Zd);
      }, ol = Ui(Mn, "DataView"), al = Ui(Mn, "Promise"), Vt = Ui(Mn, "Set"), Zc = Ui(Mn, "WeakMap");
      var Jd = "[object Map]", eh = "[object Promise]", th = "[object Set]", Xc = "[object WeakMap]", nh = "[object DataView]", km = ln(ol), _m = ln(za), Am = ln(al), Jc = ln(Vt), Cm = ln(Zc), qi = Tn;
      (ol && qi(new ol(new ArrayBuffer(1))) != nh || za && qi(new za()) != Jd || al && qi(al.resolve()) != eh || Vt && qi(new Vt()) != th || Zc && qi(new Zc()) != Xc) && (qi = function(c) {
        var t = Tn(c), i = t == "[object Object]" ? c.constructor : void 0, a = i ? ln(i) : "";
        if (a)
          switch (a) {
            case km:
              return nh;
            case _m:
              return Jd;
            case Am:
              return eh;
            case Jc:
              return th;
            case Cm:
              return Xc;
          }
        return t;
      });
      const ia = qi;
      var rh = Object.prototype.hasOwnProperty;
      const Gn = function(c) {
        var t = c.length, i = new c.constructor(t);
        return t && typeof c[0] == "string" && rh.call(c, "index") && (i.index = c.index, i.input = c.input), i;
      }, Ki = Mn.Uint8Array, sl = function(c) {
        var t = new c.constructor(c.byteLength);
        return new Ki(t).set(new Ki(c)), t;
      }, xm = function(c, t) {
        var i = t ? sl(c.buffer) : c.buffer;
        return new c.constructor(i, c.byteOffset, c.byteLength);
      };
      var ih = /\w*$/;
      const oh = function(c) {
        var t = new c.constructor(c.source, ih.exec(c));
        return t.lastIndex = c.lastIndex, t;
      };
      var ll = Pe ? Pe.prototype : void 0, cl = ll ? ll.valueOf : void 0;
      const So = function(c) {
        return cl ? Object(cl.call(c)) : {};
      }, ah = function(c, t) {
        var i = t ? sl(c.buffer) : c.buffer;
        return new c.constructor(i, c.byteOffset, c.length);
      }, z = function(c, t, i) {
        var a = c.constructor;
        switch (t) {
          case "[object ArrayBuffer]":
            return sl(c);
          case "[object Boolean]":
          case "[object Date]":
            return new a(+c);
          case "[object DataView]":
            return xm(c, i);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return ah(c, i);
          case "[object Map]":
          case "[object Set]":
            return new a();
          case "[object Number]":
          case "[object String]":
            return new a(c);
          case "[object RegExp]":
            return oh(c);
          case "[object Symbol]":
            return So(c);
        }
      };
      var H = Object.create;
      const te = function() {
        function c() {
        }
        return function(t) {
          if (!me(t))
            return {};
          if (H)
            return H(t);
          c.prototype = t;
          var i = new c();
          return c.prototype = void 0, i;
        };
      }(), fe = function(c) {
        return typeof c.constructor != "function" || rl(c) ? {} : te(bi(c));
      }, We = function(c) {
        return vn(c) && ia(c) == "[object Map]";
      };
      var ot = Gi && Gi.isMap;
      const lt = ot ? Fc(ot) : We, dt = function(c) {
        return vn(c) && ia(c) == "[object Set]";
      };
      var wn = Gi && Gi.isSet;
      const yn = wn ? Fc(wn) : dt;
      var Ya = "[object Arguments]", Yi = "[object Function]", Ir = "[object Object]", Dt = {};
      Dt[Ya] = Dt["[object Array]"] = Dt["[object ArrayBuffer]"] = Dt["[object DataView]"] = Dt["[object Boolean]"] = Dt["[object Date]"] = Dt["[object Float32Array]"] = Dt["[object Float64Array]"] = Dt["[object Int8Array]"] = Dt["[object Int16Array]"] = Dt["[object Int32Array]"] = Dt["[object Map]"] = Dt["[object Number]"] = Dt[Ir] = Dt["[object RegExp]"] = Dt["[object Set]"] = Dt["[object String]"] = Dt["[object Symbol]"] = Dt["[object Uint8Array]"] = Dt["[object Uint8ClampedArray]"] = Dt["[object Uint16Array]"] = Dt["[object Uint32Array]"] = !0, Dt["[object Error]"] = Dt[Yi] = Dt["[object WeakMap]"] = !1;
      const oa = function c(t, i, a, l, d, g) {
        var m, w = 1 & i, A = 2 & i, C = 4 & i;
        if (a && (m = d ? a(t, l, d, g) : a(t)), m !== void 0)
          return m;
        if (!me(t))
          return t;
        var T = Zt(t);
        if (T) {
          if (m = Gn(t), !w)
            return qd(t, m);
        } else {
          var R = ia(t), j = R == Yi || R == "[object GeneratorFunction]";
          if (Ga(t))
            return Gc(t, w);
          if (R == Ir || R == Ya || j && !d) {
            if (m = A || j ? {} : fe(t), !w)
              return A ? ym(t, Uc(m, t)) : wm(t, xo(m, t));
          } else {
            if (!Dt[R])
              return d ? t : {};
            m = z(t, R, w);
          }
        }
        g || (g = new Wa());
        var F = g.get(t);
        if (F)
          return F;
        g.set(t, m), yn(t) ? t.forEach(function(W) {
          m.add(c(W, i, a, W, t, g));
        }) : lt(t) && t.forEach(function(W, ee) {
          m.set(ee, c(W, i, a, ee, t, g));
        });
        var V = T ? void 0 : (C ? A ? Xd : Qc : A ? Eo : Vc)(t);
        return um(V || t, function(W, ee) {
          V && (W = t[ee = W]), Rc(m, ee, c(W, i, a, ee, t, g));
        }), m;
      }, aa = function(c, t) {
        return oa(c, 5, t = typeof t == "function" ? t : void 0);
      }, Bn = function(c) {
        return vn(c) && c.nodeType === 1 && !Wn(c);
      };
      class qr {
        constructor(t, i) {
          this._config = {}, i && this.define(ul(i)), t && this._setObjectToTarget(this._config, t);
        }
        set(t, i) {
          this._setToTarget(this._config, t, i);
        }
        define(t, i) {
          this._setToTarget(this._config, t, i, !0);
        }
        get(t) {
          return this._getFromSource(this._config, t);
        }
        *names() {
          for (const t of Object.keys(this._config))
            yield t;
        }
        _setToTarget(t, i, a, l = !1) {
          if (Wn(i))
            return void this._setObjectToTarget(t, i, l);
          const d = i.split(".");
          i = d.pop();
          for (const g of d)
            Wn(t[g]) || (t[g] = {}), t = t[g];
          if (Wn(a))
            return Wn(t[i]) || (t[i] = {}), t = t[i], void this._setObjectToTarget(t, a, l);
          l && t[i] !== void 0 || (t[i] = a);
        }
        _getFromSource(t, i) {
          const a = i.split(".");
          i = a.pop();
          for (const l of a) {
            if (!Wn(t[l])) {
              t = null;
              break;
            }
            t = t[l];
          }
          return t ? ul(t[i]) : void 0;
        }
        _setObjectToTarget(t, i, a) {
          Object.keys(i).forEach((l) => {
            this._setToTarget(t, l, i[l], a);
          });
        }
      }
      function ul(c) {
        return aa(c, qn);
      }
      function qn(c) {
        return Bn(c) ? c : void 0;
      }
      function Kn(c) {
        if (c) {
          if (c.defaultView)
            return c instanceof c.defaultView.Document;
          if (c.ownerDocument && c.ownerDocument.defaultView)
            return c instanceof c.ownerDocument.defaultView.Node;
        }
        return !1;
      }
      function Mo(c) {
        const t = Object.prototype.toString.apply(c);
        return t == "[object Window]" || t == "[object global]";
      }
      const mk = Qa(ie());
      function Qa(c) {
        return c ? class extends c {
          listenTo(t, i, a, l = {}) {
            if (Kn(t) || Mo(t)) {
              const d = { capture: !!l.useCapture, passive: !!l.usePassive }, g = this._getProxyEmitter(t, d) || new $O(t, d);
              this.listenTo(g, i, a, l);
            } else
              super.listenTo(t, i, a, l);
          }
          stopListening(t, i, a) {
            if (Kn(t) || Mo(t)) {
              const l = this._getAllProxyEmitters(t);
              for (const d of l)
                this.stopListening(d, i, a);
            } else
              super.stopListening(t, i, a);
          }
          _getProxyEmitter(t, i) {
            return function(a, l) {
              const d = a[Y];
              return d && d[l] ? d[l].emitter : null;
            }(this, vk(t, i));
          }
          _getAllProxyEmitters(t) {
            return [{ capture: !1, passive: !1 }, { capture: !1, passive: !0 }, { capture: !0, passive: !1 }, { capture: !0, passive: !0 }].map((i) => this._getProxyEmitter(t, i)).filter((i) => !!i);
          }
        } : mk;
      }
      ["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((c) => {
        Qa[c] = mk.prototype[c];
      });
      class $O extends ie() {
        constructor(t, i) {
          super(), pe(this, vk(t, i)), this._domNode = t, this._options = i;
        }
        attach(t) {
          if (this._domListeners && this._domListeners[t])
            return;
          const i = this._createDomListener(t);
          this._domNode.addEventListener(t, i, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
        }
        detach(t) {
          let i;
          !this._domListeners[t] || (i = this._events[t]) && i.callbacks.length || this._domListeners[t].removeListener();
        }
        _addEventListener(t, i, a) {
          this.attach(t), ie().prototype._addEventListener.call(this, t, i, a);
        }
        _removeEventListener(t, i) {
          ie().prototype._removeEventListener.call(this, t, i), this.detach(t);
        }
        _createDomListener(t) {
          const i = (a) => {
            this.fire(t, a);
          };
          return i.removeListener = () => {
            this._domNode.removeEventListener(t, i, this._options), delete this._domListeners[t];
          }, i;
        }
      }
      function vk(c, t) {
        let i = function(a) {
          return a["data-ck-expando"] || (a["data-ck-expando"] = N());
        }(c);
        for (const a of Object.keys(t).sort())
          t[a] && (i += "-" + a);
        return i;
      }
      let Em;
      try {
        Em = { window, document };
      } catch {
        Em = { window: {}, document: {} };
      }
      const yt = Em;
      function bk(c) {
        const t = [];
        let i = c;
        for (; i && i.nodeType != Node.DOCUMENT_NODE; )
          t.unshift(i), i = i.parentNode;
        return t;
      }
      function Dn(c) {
        return Object.prototype.toString.call(c) == "[object Text]";
      }
      function sh(c) {
        return Object.prototype.toString.apply(c) == "[object Range]";
      }
      function wk(c) {
        const t = c.ownerDocument.defaultView.getComputedStyle(c);
        return { top: parseInt(t.borderTopWidth, 10), right: parseInt(t.borderRightWidth, 10), bottom: parseInt(t.borderBottomWidth, 10), left: parseInt(t.borderLeftWidth, 10) };
      }
      const yk = ["top", "right", "bottom", "left", "width", "height"];
      class In {
        constructor(t) {
          const i = sh(t);
          if (Object.defineProperty(this, "_source", { value: t._source || t, writable: !0, enumerable: !1 }), _k(t) || i)
            if (i) {
              const a = In.getDomRangeRects(t);
              lh(this, In.getBoundingRect(a));
            } else
              lh(this, t.getBoundingClientRect());
          else if (Mo(t)) {
            const { innerWidth: a, innerHeight: l } = t;
            lh(this, { top: 0, right: a, bottom: l, left: 0, width: a, height: l });
          } else
            lh(this, t);
        }
        clone() {
          return new In(this);
        }
        moveTo(t, i) {
          return this.top = i, this.right = t + this.width, this.bottom = i + this.height, this.left = t, this;
        }
        moveBy(t, i) {
          return this.top += i, this.right += t, this.left += t, this.bottom += i, this;
        }
        getIntersection(t) {
          const i = { top: Math.max(this.top, t.top), right: Math.min(this.right, t.right), bottom: Math.min(this.bottom, t.bottom), left: Math.max(this.left, t.left), width: 0, height: 0 };
          return i.width = i.right - i.left, i.height = i.bottom - i.top, i.width < 0 || i.height < 0 ? null : new In(i);
        }
        getIntersectionArea(t) {
          const i = this.getIntersection(t);
          return i ? i.getArea() : 0;
        }
        getArea() {
          return this.width * this.height;
        }
        getVisible() {
          const t = this._source;
          let i = this.clone();
          if (!kk(t)) {
            let a = t.parentNode || t.commonAncestorContainer;
            for (; a && !kk(a); ) {
              const l = new In(a), d = i.getIntersection(l);
              if (!d)
                return null;
              d.getArea() < i.getArea() && (i = d), a = a.parentNode;
            }
          }
          return i;
        }
        isEqual(t) {
          for (const i of yk)
            if (this[i] !== t[i])
              return !1;
          return !0;
        }
        contains(t) {
          const i = this.getIntersection(t);
          return !(!i || !i.isEqual(t));
        }
        excludeScrollbarsAndBorders() {
          const t = this._source;
          let i, a, l;
          if (Mo(t))
            i = t.innerWidth - t.document.documentElement.clientWidth, a = t.innerHeight - t.document.documentElement.clientHeight, l = t.getComputedStyle(t.document.documentElement).direction;
          else {
            const d = wk(t);
            i = t.offsetWidth - t.clientWidth - d.left - d.right, a = t.offsetHeight - t.clientHeight - d.top - d.bottom, l = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += d.left, this.top += d.top, this.right -= d.right, this.bottom -= d.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
          }
          return this.width -= i, l === "ltr" ? this.right -= i : this.left += i, this.height -= a, this.bottom -= a, this;
        }
        static getDomRangeRects(t) {
          const i = [], a = Array.from(t.getClientRects());
          if (a.length)
            for (const l of a)
              i.push(new In(l));
          else {
            let l = t.startContainer;
            Dn(l) && (l = l.parentNode);
            const d = new In(l.getBoundingClientRect());
            d.right = d.left, d.width = 0, i.push(d);
          }
          return i;
        }
        static getBoundingRect(t) {
          const i = { left: Number.POSITIVE_INFINITY, top: Number.POSITIVE_INFINITY, right: Number.NEGATIVE_INFINITY, bottom: Number.NEGATIVE_INFINITY, width: 0, height: 0 };
          let a = 0;
          for (const l of t)
            a++, i.left = Math.min(i.left, l.left), i.top = Math.min(i.top, l.top), i.right = Math.max(i.right, l.right), i.bottom = Math.max(i.bottom, l.bottom);
          return a == 0 ? null : (i.width = i.right - i.left, i.height = i.bottom - i.top, new In(i));
        }
      }
      function lh(c, t) {
        for (const i of yk)
          c[i] = t[i];
      }
      function kk(c) {
        return !!_k(c) && c === c.ownerDocument.body;
      }
      function _k(c) {
        return c !== null && typeof c == "object" && c.nodeType === 1 && typeof c.getBoundingClientRect == "function";
      }
      class fn {
        constructor(t, i) {
          fn._observerInstance || fn._createObserver(), this._element = t, this._callback = i, fn._addElementCallback(t, i), fn._observerInstance.observe(t);
        }
        destroy() {
          fn._deleteElementCallback(this._element, this._callback);
        }
        static _addElementCallback(t, i) {
          fn._elementCallbacks || (fn._elementCallbacks = /* @__PURE__ */ new Map());
          let a = fn._elementCallbacks.get(t);
          a || (a = /* @__PURE__ */ new Set(), fn._elementCallbacks.set(t, a)), a.add(i);
        }
        static _deleteElementCallback(t, i) {
          const a = fn._getElementCallbacks(t);
          a && (a.delete(i), a.size || (fn._elementCallbacks.delete(t), fn._observerInstance.unobserve(t))), fn._elementCallbacks && !fn._elementCallbacks.size && (fn._observerInstance = null, fn._elementCallbacks = null);
        }
        static _getElementCallbacks(t) {
          return fn._elementCallbacks ? fn._elementCallbacks.get(t) : null;
        }
        static _createObserver() {
          fn._observerInstance = new yt.window.ResizeObserver((t) => {
            for (const i of t) {
              const a = fn._getElementCallbacks(i.target);
              if (a)
                for (const l of a)
                  l(i);
            }
          });
        }
      }
      function LO(c, t) {
        c instanceof HTMLTextAreaElement && (c.value = t), c.innerHTML = t;
      }
      function Sm(c) {
        return (t) => t + c;
      }
      function ch(c) {
        let t = 0;
        for (; c.previousSibling; )
          c = c.previousSibling, t++;
        return t;
      }
      function Ak(c, t, i) {
        c.insertBefore(i, c.childNodes[t] || null);
      }
      function dl(c) {
        return c && c.nodeType === Node.COMMENT_NODE;
      }
      function Za(c) {
        return !!(c && c.getClientRects && c.getClientRects().length);
      }
      function Ck({ element: c, target: t, positions: i, limiter: a, fitInViewport: l, viewportOffsetConfig: d }) {
        Qe(t) && (t = t()), Qe(a) && (a = a());
        const g = function(R) {
          return R && R.parentNode ? R.offsetParent === yt.document.body ? null : R.offsetParent : null;
        }(c), m = new In(c), w = new In(t);
        let A;
        const C = l && function(R) {
          R = Object.assign({ top: 0, bottom: 0, left: 0, right: 0 }, R);
          const j = new In(yt.window);
          return j.top += R.top, j.height -= R.top, j.bottom -= R.bottom, j.height -= R.bottom, j;
        }(d) || null, T = { targetRect: w, elementRect: m, positionedElementAncestor: g, viewportRect: C };
        if (a || l) {
          const R = a && new In(a).getVisible();
          Object.assign(T, { limiterRect: R, viewportRect: C }), A = function(j, F) {
            const { elementRect: V } = F, W = V.getArea(), ee = j.map((Ne) => new Mm(Ne, F)).filter((Ne) => !!Ne.name);
            let le = 0, be = null;
            for (const Ne of ee) {
              const { limiterIntersectionArea: Je, viewportIntersectionArea: Mt } = Ne;
              if (Je === W)
                return Ne;
              const Rt = Mt ** 2 + Je ** 2;
              Rt > le && (le = Rt, be = Ne);
            }
            return be;
          }(i, T) || new Mm(i[0], T);
        } else
          A = new Mm(i[0], T);
        return A;
      }
      function xk(c) {
        const { scrollX: t, scrollY: i } = yt.window;
        return c.clone().moveBy(t, i);
      }
      fn._observerInstance = null, fn._elementCallbacks = null;
      class Mm {
        constructor(t, i) {
          const a = t(i.targetRect, i.elementRect, i.viewportRect);
          if (!a)
            return;
          const { left: l, top: d, name: g, config: m } = a;
          this.name = g, this.config = m, this._positioningFunctionCorrdinates = { left: l, top: d }, this._options = i;
        }
        get left() {
          return this._absoluteRect.left;
        }
        get top() {
          return this._absoluteRect.top;
        }
        get limiterIntersectionArea() {
          const t = this._options.limiterRect;
          if (t) {
            const i = this._options.viewportRect;
            if (!i)
              return t.getIntersectionArea(this._rect);
            {
              const a = t.getIntersection(i);
              if (a)
                return a.getIntersectionArea(this._rect);
            }
          }
          return 0;
        }
        get viewportIntersectionArea() {
          const t = this._options.viewportRect;
          return t ? t.getIntersectionArea(this._rect) : 0;
        }
        get _rect() {
          return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCorrdinates.left, this._positioningFunctionCorrdinates.top)), this._cachedRect;
        }
        get _absoluteRect() {
          return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = xk(this._rect), this._options.positionedElementAncestor && function(t, i) {
            const a = xk(new In(i)), l = wk(i);
            let d = 0, g = 0;
            d -= a.left, g -= a.top, d += i.scrollLeft, g += i.scrollTop, d -= l.left, g -= l.top, t.moveBy(d, g);
          }(this._cachedAbsoluteRect, this._options.positionedElementAncestor)), this._cachedAbsoluteRect;
        }
      }
      function Ek(c) {
        const t = c.parentNode;
        t && t.removeChild(c);
      }
      function jO(c, t, i) {
        const a = t.clone().moveBy(0, i), l = t.clone().moveBy(0, -i), d = new In(c).excludeScrollbarsAndBorders();
        if (![l, a].every((g) => d.contains(g))) {
          let { scrollX: g, scrollY: m } = c;
          Mk(l, d) ? m -= d.top - t.top + i : Sk(a, d) && (m += t.bottom - d.bottom + i), Tk(t, d) ? g -= d.left - t.left + i : Dk(t, d) && (g += t.right - d.right + i), c.scrollTo(g, m);
        }
      }
      function BO(c, t) {
        const i = Tm(c);
        let a, l;
        for (; c != i.document.body; )
          l = t(), a = new In(c).excludeScrollbarsAndBorders(), a.contains(l) || (Mk(l, a) ? c.scrollTop -= a.top - l.top : Sk(l, a) && (c.scrollTop += l.bottom - a.bottom), Tk(l, a) ? c.scrollLeft -= a.left - l.left : Dk(l, a) && (c.scrollLeft += l.right - a.right)), c = c.parentNode;
      }
      function Sk(c, t) {
        return c.bottom > t.bottom;
      }
      function Mk(c, t) {
        return c.top < t.top;
      }
      function Tk(c, t) {
        return c.left < t.left;
      }
      function Dk(c, t) {
        return c.right > t.right;
      }
      function Tm(c) {
        return sh(c) ? c.startContainer.ownerDocument.defaultView : c.ownerDocument.defaultView;
      }
      function FO(c) {
        if (sh(c)) {
          let t = c.commonAncestorContainer;
          return Dn(t) && (t = t.parentNode), t;
        }
        return c.parentNode;
      }
      function Ik(c, t) {
        const i = Tm(c), a = new In(c);
        if (i === t)
          return a;
        {
          let l = i;
          for (; l != t; ) {
            const d = l.frameElement, g = new In(d).excludeScrollbarsAndBorders();
            a.moveBy(g.left, g.top), l = l.parent;
          }
        }
        return a;
      }
      const zO = { ctrl: "\u2303", cmd: "\u2318", alt: "\u2325", shift: "\u21E7" }, VO = { ctrl: "Ctrl+", alt: "Alt+", shift: "Shift+" }, St = function() {
        const c = { arrowleft: 37, arrowup: 38, arrowright: 39, arrowdown: 40, backspace: 8, delete: 46, enter: 13, space: 32, esc: 27, tab: 9, ctrl: 1114112, shift: 2228224, alt: 4456448, cmd: 8912896 };
        for (let t = 65; t <= 90; t++)
          c[String.fromCharCode(t).toLowerCase()] = t;
        for (let t = 48; t <= 57; t++)
          c[t - 48] = t;
        for (let t = 112; t <= 123; t++)
          c["f" + (t - 111)] = t;
        for (const t of "`-=[];',./\\")
          c[t] = t.charCodeAt(0);
        return c;
      }(), HO = Object.fromEntries(Object.entries(St).map(([c, t]) => [t, c.charAt(0).toUpperCase() + c.slice(1)]));
      function hl(c) {
        let t;
        if (typeof c == "string") {
          if (t = St[c.toLowerCase()], !t)
            throw new S("keyboard-unknown-key", null, { key: c });
        } else
          t = c.keyCode + (c.altKey ? St.alt : 0) + (c.ctrlKey ? St.ctrl : 0) + (c.shiftKey ? St.shift : 0) + (c.metaKey ? St.cmd : 0);
        return t;
      }
      function Dm(c) {
        return typeof c == "string" && (c = function(t) {
          return t.split("+").map((i) => i.trim());
        }(c)), c.map((t) => typeof t == "string" ? function(i) {
          if (i.endsWith("!"))
            return hl(i.slice(0, -1));
          const a = hl(i);
          return p.isMac && a == St.ctrl ? St.cmd : a;
        }(t) : t).reduce((t, i) => i + t, 0);
      }
      function Pk(c) {
        let t = Dm(c);
        return Object.entries(p.isMac ? zO : VO).reduce((i, [a, l]) => ((t & St[a]) != 0 && (t &= ~St[a], i += l), i), "") + (t ? HO[t] : "");
      }
      function Im(c, t) {
        const i = t === "ltr";
        switch (c) {
          case St.arrowleft:
            return i ? "left" : "right";
          case St.arrowright:
            return i ? "right" : "left";
          case St.arrowup:
            return "up";
          case St.arrowdown:
            return "down";
        }
      }
      function Yn(c) {
        return Array.isArray(c) ? c : [c];
      }
      function UO(c, t, i = 1) {
        if (typeof i != "number")
          throw new S("translation-service-quantity-not-a-number", null, { quantity: i });
        const a = Object.keys(yt.window.CKEDITOR_TRANSLATIONS).length;
        a === 1 && (c = Object.keys(yt.window.CKEDITOR_TRANSLATIONS)[0]);
        const l = t.id || t.string;
        if (a === 0 || !function(w, A) {
          return !!yt.window.CKEDITOR_TRANSLATIONS[w] && !!yt.window.CKEDITOR_TRANSLATIONS[w].dictionary[A];
        }(c, l))
          return i !== 1 ? t.plural : t.string;
        const d = yt.window.CKEDITOR_TRANSLATIONS[c].dictionary, g = yt.window.CKEDITOR_TRANSLATIONS[c].getPluralForm || ((w) => w === 1 ? 0 : 1), m = d[l];
        return typeof m == "string" ? m : m[Number(g(i))];
      }
      yt.window.CKEDITOR_TRANSLATIONS || (yt.window.CKEDITOR_TRANSLATIONS = {});
      const WO = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
      function Ok(c) {
        return WO.includes(c) ? "rtl" : "ltr";
      }
      class GO {
        constructor({ uiLanguage: t = "en", contentLanguage: i } = {}) {
          this.uiLanguage = t, this.contentLanguage = i || this.uiLanguage, this.uiLanguageDirection = Ok(this.uiLanguage), this.contentLanguageDirection = Ok(this.contentLanguage), this.t = (a, l) => this._t(a, l);
        }
        get language() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
        _t(t, i = []) {
          i = Yn(i), typeof t == "string" && (t = { string: t });
          const a = t.plural ? i[0] : 1;
          return function(l, d) {
            return l.replace(/%(\d+)/g, (g, m) => m < d.length ? d[m] : g);
          }(UO(this.uiLanguage, t, a), i);
        }
      }
      class yi extends ie() {
        constructor(t = {}, i = {}) {
          super();
          const a = Ft(t);
          if (a || (i = t), this._items = [], this._itemMap = /* @__PURE__ */ new Map(), this._idProperty = i.idProperty || "id", this._bindToExternalToInternalMap = /* @__PURE__ */ new WeakMap(), this._bindToInternalToExternalMap = /* @__PURE__ */ new WeakMap(), this._skippedIndexesFromExternal = [], a)
            for (const l of t)
              this._items.push(l), this._itemMap.set(this._getItemIdBeforeAdding(l), l);
        }
        get length() {
          return this._items.length;
        }
        get first() {
          return this._items[0] || null;
        }
        get last() {
          return this._items[this.length - 1] || null;
        }
        add(t, i) {
          return this.addMany([t], i);
        }
        addMany(t, i) {
          if (i === void 0)
            i = this._items.length;
          else if (i > this._items.length || i < 0)
            throw new S("collection-add-item-invalid-index", this);
          let a = 0;
          for (const l of t) {
            const d = this._getItemIdBeforeAdding(l), g = i + a;
            this._items.splice(g, 0, l), this._itemMap.set(d, l), this.fire("add", l, g), a++;
          }
          return this.fire("change", { added: t, removed: [], index: i }), this;
        }
        get(t) {
          let i;
          if (typeof t == "string")
            i = this._itemMap.get(t);
          else {
            if (typeof t != "number")
              throw new S("collection-get-invalid-arg", this);
            i = this._items[t];
          }
          return i || null;
        }
        has(t) {
          if (typeof t == "string")
            return this._itemMap.has(t);
          {
            const i = t[this._idProperty];
            return i && this._itemMap.has(i);
          }
        }
        getIndex(t) {
          let i;
          return i = typeof t == "string" ? this._itemMap.get(t) : t, i ? this._items.indexOf(i) : -1;
        }
        remove(t) {
          const [i, a] = this._remove(t);
          return this.fire("change", { added: [], removed: [i], index: a }), i;
        }
        map(t, i) {
          return this._items.map(t, i);
        }
        find(t, i) {
          return this._items.find(t, i);
        }
        filter(t, i) {
          return this._items.filter(t, i);
        }
        clear() {
          this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
          const t = Array.from(this._items);
          for (; this.length; )
            this._remove(0);
          this.fire("change", { added: [], removed: t, index: 0 });
        }
        bindTo(t) {
          if (this._bindToCollection)
            throw new S("collection-bind-to-rebind", this);
          return this._bindToCollection = t, { as: (i) => {
            this._setUpBindToBinding((a) => new i(a));
          }, using: (i) => {
            typeof i == "function" ? this._setUpBindToBinding(i) : this._setUpBindToBinding((a) => a[i]);
          } };
        }
        _setUpBindToBinding(t) {
          const i = this._bindToCollection, a = (l, d, g) => {
            const m = i._bindToCollection == this, w = i._bindToInternalToExternalMap.get(d);
            if (m && w)
              this._bindToExternalToInternalMap.set(d, w), this._bindToInternalToExternalMap.set(w, d);
            else {
              const A = t(d);
              if (!A)
                return void this._skippedIndexesFromExternal.push(g);
              let C = g;
              for (const T of this._skippedIndexesFromExternal)
                g > T && C--;
              for (const T of i._skippedIndexesFromExternal)
                C >= T && C++;
              this._bindToExternalToInternalMap.set(d, A), this._bindToInternalToExternalMap.set(A, d), this.add(A, C);
              for (let T = 0; T < i._skippedIndexesFromExternal.length; T++)
                C <= i._skippedIndexesFromExternal[T] && i._skippedIndexesFromExternal[T]++;
            }
          };
          for (const l of i)
            a(0, l, i.getIndex(l));
          this.listenTo(i, "add", a), this.listenTo(i, "remove", (l, d, g) => {
            const m = this._bindToExternalToInternalMap.get(d);
            m && this.remove(m), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((w, A) => (g < A && w.push(A - 1), g > A && w.push(A), w), []);
          });
        }
        _getItemIdBeforeAdding(t) {
          const i = this._idProperty;
          let a;
          if (i in t) {
            if (a = t[i], typeof a != "string")
              throw new S("collection-add-invalid-id", this);
            if (this.get(a))
              throw new S("collection-add-item-already-exists", this);
          } else
            t[i] = a = N();
          return a;
        }
        _remove(t) {
          let i, a, l, d = !1;
          const g = this._idProperty;
          if (typeof t == "string" ? (a = t, l = this._itemMap.get(a), d = !l, l && (i = this._items.indexOf(l))) : typeof t == "number" ? (i = t, l = this._items[i], d = !l, l && (a = l[g])) : (l = t, a = l[g], i = this._items.indexOf(l), d = i == -1 || !this._itemMap.get(a)), d)
            throw new S("collection-remove-404", this);
          this._items.splice(i, 1), this._itemMap.delete(a);
          const m = this._bindToInternalToExternalMap.get(l);
          return this._bindToInternalToExternalMap.delete(l), this._bindToExternalToInternalMap.delete(m), this.fire("remove", l, i), [l, i];
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
      }
      function Fn(c) {
        const t = c.next();
        return t.done ? null : t.value;
      }
      class Kr extends Qa(Te()) {
        constructor() {
          super(), this._elements = /* @__PURE__ */ new Set(), this._nextEventLoopTimeout = null, this.set("isFocused", !1), this.set("focusedElement", null);
        }
        add(t) {
          if (this._elements.has(t))
            throw new S("focustracker-add-element-already-exist", this);
          this.listenTo(t, "focus", () => this._focus(t), { useCapture: !0 }), this.listenTo(t, "blur", () => this._blur(), { useCapture: !0 }), this._elements.add(t);
        }
        remove(t) {
          t === this.focusedElement && this._blur(), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
        }
        destroy() {
          this.stopListening();
        }
        _focus(t) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
        }
        _blur() {
          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
            this.focusedElement = null, this.isFocused = !1;
          }, 0);
        }
      }
      class Qi {
        constructor() {
          this._listener = new (Qa())();
        }
        listenTo(t) {
          this._listener.listenTo(t, "keydown", (i, a) => {
            this._listener.fire("_keydown:" + hl(a), a);
          });
        }
        set(t, i, a = {}) {
          const l = Dm(t), d = a.priority;
          this._listener.listenTo(this._listener, "_keydown:" + l, (g, m) => {
            i(m, () => {
              m.preventDefault(), m.stopPropagation(), g.stop();
            }), g.return = !0;
          }, { priority: d });
        }
        press(t) {
          return !!this._listener.fire("_keydown:" + hl(t), t);
        }
        destroy() {
          this._listener.stopListening();
        }
      }
      function Zi(c) {
        return Ft(c) ? new Map(c) : function(t) {
          const i = /* @__PURE__ */ new Map();
          for (const a in t)
            i.set(a, t[a]);
          return i;
        }(c);
      }
      function Rk(c, t) {
        return !!(i = c.charAt(t - 1)) && i.length == 1 && /[\ud800-\udbff]/.test(i) && function(a) {
          return !!a && a.length == 1 && /[\udc00-\udfff]/.test(a);
        }(c.charAt(t));
        var i;
      }
      function Nk(c, t) {
        return !!(i = c.charAt(t)) && i.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(i);
        var i;
      }
      const qO = function() {
        const c = /\p{Regional_Indicator}{2}/u.source, t = "(?:" + [/\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u, /\p{Emoji}\u{FE0F}?\u{20E3}/u, /\p{Emoji}\u{FE0F}/u, /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u].map((i) => i.source).join("|") + ")";
        return new RegExp(`${c}|${t}(?:\u200D${t})*`, "ug");
      }();
      function KO(c, t) {
        const i = String(c).matchAll(qO);
        return Array.from(i).some((a) => a.index < t && t < a.index + a[0].length);
      }
      class Ie extends Te() {
        constructor(t) {
          super(), this.editor = t, this.set("isEnabled", !0), this._disableStack = /* @__PURE__ */ new Set();
        }
        forceDisabled(t) {
          this._disableStack.add(t), this._disableStack.size == 1 && (this.on("set:isEnabled", $k, { priority: "highest" }), this.isEnabled = !1);
        }
        clearForceDisabled(t) {
          this._disableStack.delete(t), this._disableStack.size == 0 && (this.off("set:isEnabled", $k), this.isEnabled = !0);
        }
        destroy() {
          this.stopListening();
        }
        static get isContextPlugin() {
          return !1;
        }
      }
      function $k(c) {
        c.return = !1, c.stop();
      }
      class kt extends Te() {
        constructor(t) {
          super(), this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._affectsData = !0, this._disableStack = /* @__PURE__ */ new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
            this.refresh();
          }), this.on("execute", (i) => {
            this.isEnabled || i.stop();
          }, { priority: "high" }), this.listenTo(t, "change:isReadOnly", (i, a, l) => {
            l && this.affectsData ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
          });
        }
        get affectsData() {
          return this._affectsData;
        }
        set affectsData(t) {
          this._affectsData = t;
        }
        refresh() {
          this.isEnabled = !0;
        }
        forceDisabled(t) {
          this._disableStack.add(t), this._disableStack.size == 1 && (this.on("set:isEnabled", Lk, { priority: "highest" }), this.isEnabled = !1);
        }
        clearForceDisabled(t) {
          this._disableStack.delete(t), this._disableStack.size == 0 && (this.off("set:isEnabled", Lk), this.refresh());
        }
        execute(...t) {
        }
        destroy() {
          this.stopListening();
        }
      }
      function Lk(c) {
        c.return = !1, c.stop();
      }
      class jk extends kt {
        constructor(t) {
          super(t), this._childCommandsDefinitions = [];
        }
        refresh() {
        }
        execute(...t) {
          const i = this._getFirstEnabledCommand();
          return !!i && i.execute(t);
        }
        registerChildCommand(t, i = {}) {
          P(this._childCommandsDefinitions, { command: t, priority: i.priority || "normal" }), t.on("change:isEnabled", () => this._checkEnabled()), this._checkEnabled();
        }
        _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
        _getFirstEnabledCommand() {
          const t = this._childCommandsDefinitions.find(({ command: i }) => i.isEnabled);
          return t && t.command;
        }
      }
      class Bk extends ie() {
        constructor(t, i = [], a = []) {
          super(), this._context = t, this._plugins = /* @__PURE__ */ new Map(), this._availablePlugins = /* @__PURE__ */ new Map();
          for (const l of i)
            l.pluginName && this._availablePlugins.set(l.pluginName, l);
          this._contextPlugins = /* @__PURE__ */ new Map();
          for (const [l, d] of a)
            this._contextPlugins.set(l, d), this._contextPlugins.set(d, l), l.pluginName && this._availablePlugins.set(l.pluginName, l);
        }
        *[Symbol.iterator]() {
          for (const t of this._plugins)
            typeof t[0] == "function" && (yield t);
        }
        get(t) {
          const i = this._plugins.get(t);
          if (!i) {
            let a = t;
            throw typeof t == "function" && (a = t.pluginName || t.name), new S("plugincollection-plugin-not-loaded", this._context, { plugin: a });
          }
          return i;
        }
        has(t) {
          return this._plugins.has(t);
        }
        init(t, i = [], a = []) {
          const l = this, d = this._context;
          (function F(V, W = /* @__PURE__ */ new Set()) {
            V.forEach((ee) => {
              w(ee) && (W.has(ee) || (W.add(ee), ee.pluginName && !l._availablePlugins.has(ee.pluginName) && l._availablePlugins.set(ee.pluginName, ee), ee.requires && F(ee.requires, W)));
            });
          })(t), R(t);
          const g = [...function F(V, W = /* @__PURE__ */ new Set()) {
            return V.map((ee) => w(ee) ? ee : l._availablePlugins.get(ee)).reduce((ee, le) => W.has(le) ? ee : (W.add(le), le.requires && (R(le.requires, le), F(le.requires, W).forEach((be) => ee.add(be))), ee.add(le)), /* @__PURE__ */ new Set());
          }(t.filter((F) => !C(F, i)))];
          (function(F, V) {
            for (const W of V) {
              if (typeof W != "function")
                throw new S("plugincollection-replace-plugin-invalid-type", null, { pluginItem: W });
              const ee = W.pluginName;
              if (!ee)
                throw new S("plugincollection-replace-plugin-missing-name", null, { pluginItem: W });
              if (W.requires && W.requires.length)
                throw new S("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, { pluginName: ee });
              const le = l._availablePlugins.get(ee);
              if (!le)
                throw new S("plugincollection-plugin-for-replacing-not-exist", null, { pluginName: ee });
              const be = F.indexOf(le);
              if (be === -1) {
                if (l._contextPlugins.has(le))
                  return;
                throw new S("plugincollection-plugin-for-replacing-not-loaded", null, { pluginName: ee });
              }
              if (le.requires && le.requires.length)
                throw new S("plugincollection-replaced-plugin-cannot-have-dependencies", null, { pluginName: ee });
              F.splice(be, 1, W), l._availablePlugins.set(ee, W);
            }
          })(g, a);
          const m = function(F) {
            return F.map((V) => {
              let W = l._contextPlugins.get(V);
              return W = W || new V(d), l._add(V, W), W;
            });
          }(g);
          return j(m, "init").then(() => j(m, "afterInit")).then(() => m);
          function w(F) {
            return typeof F == "function";
          }
          function A(F) {
            return w(F) && F.isContextPlugin;
          }
          function C(F, V) {
            return V.some((W) => W === F || T(F) === W || T(W) === F);
          }
          function T(F) {
            return w(F) ? F.pluginName || F.name : F;
          }
          function R(F, V = null) {
            F.map((W) => w(W) ? W : l._availablePlugins.get(W) || W).forEach((W) => {
              (function(ee, le) {
                if (!w(ee))
                  throw le ? new S("plugincollection-soft-required", d, { missingPlugin: ee, requiredBy: T(le) }) : new S("plugincollection-plugin-not-found", d, { plugin: ee });
              })(W, V), function(ee, le) {
                if (!!A(le) && !A(ee))
                  throw new S("plugincollection-context-required", d, { plugin: T(ee), requiredBy: T(le) });
              }(W, V), function(ee, le) {
                if (!!le && !!C(ee, i))
                  throw new S("plugincollection-required", d, { plugin: T(ee), requiredBy: T(le) });
              }(W, V);
            });
          }
          function j(F, V) {
            return F.reduce((W, ee) => ee[V] ? l._contextPlugins.has(ee) ? W : W.then(ee[V].bind(ee)) : W, Promise.resolve());
          }
        }
        destroy() {
          const t = [];
          for (const [, i] of this)
            typeof i.destroy != "function" || this._contextPlugins.has(i) || t.push(i.destroy());
          return Promise.all(t);
        }
        _add(t, i) {
          this._plugins.set(t, i);
          const a = t.pluginName;
          if (a) {
            if (this._plugins.has(a))
              throw new S("plugincollection-plugin-name-conflict", null, { pluginName: a, plugin1: this._plugins.get(a).constructor, plugin2: t });
            this._plugins.set(a, i);
          }
        }
      }
      class YO {
        constructor(t) {
          this.config = new qr(t, this.constructor.defaultConfig);
          const i = this.constructor.builtinPlugins;
          this.config.define("plugins", i), this.plugins = new Bk(this, i);
          const a = this.config.get("language") || {};
          this.locale = new GO({ uiLanguage: typeof a == "string" ? a : a.ui, contentLanguage: this.config.get("language.content") }), this.t = this.locale.t, this.editors = new yi(), this._contextOwner = null;
        }
        initPlugins() {
          const t = this.config.get("plugins") || [], i = this.config.get("substitutePlugins") || [];
          for (const a of t.concat(i)) {
            if (typeof a != "function")
              throw new S("context-initplugins-constructor-only", null, { Plugin: a });
            if (a.isContextPlugin !== !0)
              throw new S("context-initplugins-invalid-plugin", null, { Plugin: a });
          }
          return this.plugins.init(t, [], i);
        }
        destroy() {
          return Promise.all(Array.from(this.editors, (t) => t.destroy())).then(() => this.plugins.destroy());
        }
        _addEditor(t, i) {
          if (this._contextOwner)
            throw new S("context-addeditor-private-context");
          this.editors.add(t), i && (this._contextOwner = t);
        }
        _removeEditor(t) {
          return this.editors.has(t) && this.editors.remove(t), this._contextOwner === t ? this.destroy() : Promise.resolve();
        }
        _getEditorConfig() {
          const t = {};
          for (const i of this.config.names())
            ["plugins", "removePlugins", "extraPlugins"].includes(i) || (t[i] = this.config.get(i));
          return t;
        }
        static create(t) {
          return new Promise((i) => {
            const a = new this(t);
            i(a.initPlugins().then(() => a));
          });
        }
      }
      class uh extends Te() {
        constructor(t) {
          super(), this.context = t;
        }
        destroy() {
          this.stopListening();
        }
        static get isContextPlugin() {
          return !0;
        }
      }
      var QO = s(6062), rt = s.n(QO), Fk = s(4717), ZO = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Fk.Z, ZO), Fk.Z.locals;
      const dh = /* @__PURE__ */ new WeakMap();
      function zk(c) {
        const { view: t, element: i, text: a, isDirectHost: l = !0, keepOnFocus: d = !1 } = c, g = t.document;
        dh.has(g) || (dh.set(g, /* @__PURE__ */ new Map()), g.registerPostFixer((m) => Pm(g, m)), g.on("change:isComposing", () => {
          t.change((m) => Pm(g, m));
        }, { priority: "high" })), dh.get(g).set(i, { text: a, isDirectHost: l, keepOnFocus: d, hostElement: l ? i : null }), t.change((m) => Pm(g, m));
      }
      function XO(c, t) {
        return !!t.hasClass("ck-placeholder") && (c.removeClass("ck-placeholder", t), !0);
      }
      function Pm(c, t) {
        const i = dh.get(c), a = [];
        let l = !1;
        for (const [d, g] of i)
          g.isDirectHost && (a.push(d), Vk(t, d, g) && (l = !0));
        for (const [d, g] of i) {
          if (g.isDirectHost)
            continue;
          const m = JO(d);
          m && (a.includes(m) || (g.hostElement = m, Vk(t, d, g) && (l = !0)));
        }
        return l;
      }
      function Vk(c, t, i) {
        const { text: a, isDirectHost: l, hostElement: d } = i;
        let g = !1;
        return d.getAttribute("data-placeholder") !== a && (c.setAttribute("data-placeholder", a, d), g = !0), (l || t.childCount == 1) && function(m, w) {
          if (!m.isAttached() || Array.from(m.getChildren()).some((R) => !R.is("uiElement")))
            return !1;
          const C = m.document, T = C.selection.anchor;
          return !(C.isComposing && T && T.parent === m || !w && C.isFocused && (!T || T.parent === m));
        }(d, i.keepOnFocus) ? function(m, w) {
          return !w.hasClass("ck-placeholder") && (m.addClass("ck-placeholder", w), !0);
        }(c, d) && (g = !0) : XO(c, d) && (g = !0), g;
      }
      function JO(c) {
        if (c.childCount) {
          const t = c.getChild(0);
          if (t.is("element") && !t.is("uiElement") && !t.is("attributeElement"))
            return t;
        }
        return null;
      }
      class Xa {
        is() {
          throw new Error("is() method is abstract");
        }
      }
      const Hk = function(c) {
        return oa(c, 4);
      };
      class Ja extends ie(Xa) {
        constructor(t) {
          super(), this.document = t, this.parent = null;
        }
        get index() {
          let t;
          if (!this.parent)
            return null;
          if ((t = this.parent.getChildIndex(this)) == -1)
            throw new S("view-node-not-found-in-parent", this);
          return t;
        }
        get nextSibling() {
          const t = this.index;
          return t !== null && this.parent.getChild(t + 1) || null;
        }
        get previousSibling() {
          const t = this.index;
          return t !== null && this.parent.getChild(t - 1) || null;
        }
        get root() {
          let t = this;
          for (; t.parent; )
            t = t.parent;
          return t;
        }
        isAttached() {
          return this.root.is("rootElement");
        }
        getPath() {
          const t = [];
          let i = this;
          for (; i.parent; )
            t.unshift(i.index), i = i.parent;
          return t;
        }
        getAncestors(t = {}) {
          const i = [];
          let a = t.includeSelf ? this : this.parent;
          for (; a; )
            i[t.parentFirst ? "push" : "unshift"](a), a = a.parent;
          return i;
        }
        getCommonAncestor(t, i = {}) {
          const a = this.getAncestors(i), l = t.getAncestors(i);
          let d = 0;
          for (; a[d] == l[d] && a[d]; )
            d++;
          return d === 0 ? null : a[d - 1];
        }
        isBefore(t) {
          if (this == t || this.root !== t.root)
            return !1;
          const i = this.getPath(), a = t.getPath(), l = Lt(i, a);
          switch (l) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return i[l] < a[l];
          }
        }
        isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _fireChange(t, i) {
          this.fire(`change:${t}`, i), this.parent && this.parent._fireChange(t, i);
        }
        toJSON() {
          const t = Hk(this);
          return delete t.parent, t;
        }
      }
      Ja.prototype.is = function(c) {
        return c === "node" || c === "view:node";
      };
      class Xt extends Ja {
        constructor(t, i) {
          super(t), this._textData = i;
        }
        get data() {
          return this._textData;
        }
        get _data() {
          return this.data;
        }
        set _data(t) {
          this._fireChange("text", this), this._textData = t;
        }
        isSimilar(t) {
          return t instanceof Xt && (this === t || this.data === t.data);
        }
        _clone() {
          return new Xt(this.document, this.data);
        }
      }
      Xt.prototype.is = function(c) {
        return c === "$text" || c === "view:$text" || c === "text" || c === "view:text" || c === "node" || c === "view:node";
      };
      class Xi extends Xa {
        constructor(t, i, a) {
          if (super(), this.textNode = t, i < 0 || i > t.data.length)
            throw new S("view-textproxy-wrong-offsetintext", this);
          if (a < 0 || i + a > t.data.length)
            throw new S("view-textproxy-wrong-length", this);
          this.data = t.data.substring(i, i + a), this.offsetInText = i;
        }
        get offsetSize() {
          return this.data.length;
        }
        get isPartial() {
          return this.data.length !== this.textNode.data.length;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        get document() {
          return this.textNode.document;
        }
        getAncestors(t = {}) {
          const i = [];
          let a = t.includeSelf ? this.textNode : this.parent;
          for (; a !== null; )
            i[t.parentFirst ? "push" : "unshift"](a), a = a.parent;
          return i;
        }
      }
      Xi.prototype.is = function(c) {
        return c === "$textProxy" || c === "view:$textProxy" || c === "textProxy" || c === "view:textProxy";
      };
      class Ji {
        constructor(...t) {
          this._patterns = [], this.add(...t);
        }
        add(...t) {
          for (let i of t)
            (typeof i == "string" || i instanceof RegExp) && (i = { name: i }), this._patterns.push(i);
        }
        match(...t) {
          for (const i of t)
            for (const a of this._patterns) {
              const l = Uk(i, a);
              if (l)
                return { element: i, pattern: a, match: l };
            }
          return null;
        }
        matchAll(...t) {
          const i = [];
          for (const a of t)
            for (const l of this._patterns) {
              const d = Uk(a, l);
              d && i.push({ element: a, pattern: l, match: d });
            }
          return i.length > 0 ? i : null;
        }
        getElementName() {
          if (this._patterns.length !== 1)
            return null;
          const t = this._patterns[0], i = t.name;
          return typeof t == "function" || !i || i instanceof RegExp ? null : i;
        }
      }
      function Uk(c, t) {
        if (typeof t == "function")
          return t(c);
        const i = {};
        return t.name && (i.name = function(a, l) {
          return a instanceof RegExp ? !!l.match(a) : a === l;
        }(t.name, c.name), !i.name) || t.attributes && (i.attributes = function(a, l) {
          const d = new Set(l.getAttributeKeys());
          return Wn(a) ? (a.style !== void 0 && $("matcher-pattern-deprecated-attributes-style-key", a), a.class !== void 0 && $("matcher-pattern-deprecated-attributes-class-key", a)) : (d.delete("style"), d.delete("class")), Om(a, d, (g) => l.getAttribute(g));
        }(t.attributes, c), !i.attributes) || t.classes && (i.classes = function(a, l) {
          return Om(a, l.getClassNames(), () => {
          });
        }(t.classes, c), !i.classes) || t.styles && (i.styles = function(a, l) {
          return Om(a, l.getStyleNames(!0), (d) => l.getStyle(d));
        }(t.styles, c), !i.styles) ? null : i;
      }
      function Om(c, t, i) {
        const a = function(g) {
          return Array.isArray(g) ? g.map((m) => Wn(m) ? (m.key !== void 0 && m.value !== void 0 || $("matcher-pattern-missing-key-or-value", m), [m.key, m.value]) : [m, !0]) : Wn(g) ? Object.entries(g) : [[g, !0]];
        }(c), l = Array.from(t), d = [];
        if (a.forEach(([g, m]) => {
          l.forEach((w) => {
            (function(A, C) {
              return A === !0 || A === C || A instanceof RegExp && C.match(A);
            })(g, w) && function(A, C, T) {
              if (A === !0)
                return !0;
              const R = T(C);
              return A === R || A instanceof RegExp && !!String(R).match(A);
            }(m, w, i) && d.push(w);
          });
        }), a.length && !(d.length < a.length))
          return d;
      }
      const hh = function(c) {
        return typeof c == "symbol" || vn(c) && Tn(c) == "[object Symbol]";
      };
      var eR = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, tR = /^\w*$/;
      const nR = function(c, t) {
        if (Zt(c))
          return !1;
        var i = typeof c;
        return !(i != "number" && i != "symbol" && i != "boolean" && c != null && !hh(c)) || tR.test(c) || !eR.test(c) || t != null && c in Object(t);
      };
      function Rm(c, t) {
        if (typeof c != "function" || t != null && typeof t != "function")
          throw new TypeError("Expected a function");
        var i = function() {
          var a = arguments, l = t ? t.apply(this, a) : a[0], d = i.cache;
          if (d.has(l))
            return d.get(l);
          var g = c.apply(this, a);
          return i.cache = d.set(l, g) || d, g;
        };
        return i.cache = new (Rm.Cache || Xs)(), i;
      }
      Rm.Cache = Xs;
      const rR = Rm;
      var iR = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, oR = /\\(\\)?/g, aR = function(c) {
        var t = rR(c, function(a) {
          return i.size === 500 && i.clear(), a;
        }), i = t.cache;
        return t;
      }(function(c) {
        var t = [];
        return c.charCodeAt(0) === 46 && t.push(""), c.replace(iR, function(i, a, l, d) {
          t.push(l ? d.replace(oR, "$1") : a || i);
        }), t;
      });
      const sR = aR, lR = function(c, t) {
        for (var i = -1, a = c == null ? 0 : c.length, l = Array(a); ++i < a; )
          l[i] = t(c[i], i, c);
        return l;
      };
      var Wk = Pe ? Pe.prototype : void 0, Gk = Wk ? Wk.toString : void 0;
      const cR = function c(t) {
        if (typeof t == "string")
          return t;
        if (Zt(t))
          return lR(t, c) + "";
        if (hh(t))
          return Gk ? Gk.call(t) : "";
        var i = t + "";
        return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
      }, Nm = function(c) {
        return c == null ? "" : cR(c);
      }, $m = function(c, t) {
        return Zt(c) ? c : nR(c, t) ? [c] : sR(Nm(c));
      }, uR = function(c) {
        var t = c == null ? 0 : c.length;
        return t ? c[t - 1] : void 0;
      }, Lm = function(c) {
        if (typeof c == "string" || hh(c))
          return c;
        var t = c + "";
        return t == "0" && 1 / c == -1 / 0 ? "-0" : t;
      }, qk = function(c, t) {
        for (var i = 0, a = (t = $m(t, c)).length; c != null && i < a; )
          c = c[Lm(t[i++])];
        return i && i == a ? c : void 0;
      }, Kk = function(c, t, i) {
        var a = -1, l = c.length;
        t < 0 && (t = -t > l ? 0 : l + t), (i = i > l ? l : i) < 0 && (i += l), l = t > i ? 0 : i - t >>> 0, t >>>= 0;
        for (var d = Array(l); ++a < l; )
          d[a] = c[a + t];
        return d;
      }, dR = function(c, t) {
        return t.length < 2 ? c : qk(c, Kk(t, 0, -1));
      }, hR = function(c, t) {
        return t = $m(t, c), (c = dR(c, t)) == null || delete c[Lm(uR(t))];
      }, fR = function(c, t) {
        return c == null || hR(c, t);
      }, fh = function(c, t, i) {
        var a = c == null ? void 0 : qk(c, t);
        return a === void 0 ? i : a;
      }, jm = function(c, t, i) {
        (i !== void 0 && !Wr(c[t], i) || i === void 0 && !(t in c)) && Pc(c, t, i);
      }, pR = function(c) {
        return function(t, i, a) {
          for (var l = -1, d = Object(t), g = a(t), m = g.length; m--; ) {
            var w = g[c ? m : ++l];
            if (i(d[w], w, d) === !1)
              break;
          }
          return t;
        };
      }(), gR = function(c) {
        return vn(c) && il(c);
      }, Bm = function(c, t) {
        if ((t !== "constructor" || typeof c[t] != "function") && t != "__proto__")
          return c[t];
      }, mR = function(c) {
        return Ao(c, Eo(c));
      }, vR = function(c, t, i, a, l, d, g) {
        var m = Bm(c, i), w = Bm(t, i), A = g.get(w);
        if (A)
          jm(c, i, A);
        else {
          var C = d ? d(m, w, i + "", c, t, g) : void 0, T = C === void 0;
          if (T) {
            var R = Zt(w), j = !R && Ga(w), F = !R && !j && nl(w);
            C = w, R || j || F ? Zt(m) ? C = m : gR(m) ? C = qd(m) : j ? (T = !1, C = Gc(w, !0)) : F ? (T = !1, C = ah(w, !0)) : C = [] : Wn(w) || Lc(w) ? (C = m, Lc(m) ? C = mR(m) : me(m) && !Qe(m) || (C = fe(w))) : T = !1;
          }
          T && (g.set(w, C), l(C, w, a, d, g), g.delete(w)), jm(c, i, C);
        }
      }, bR = function c(t, i, a, l, d) {
        t !== i && pR(i, function(g, m) {
          if (d || (d = new Wa()), me(g))
            vR(t, i, m, a, c, l, d);
          else {
            var w = l ? l(Bm(t, m), g, m + "", t, i, d) : void 0;
            w === void 0 && (w = g), jm(t, m, w);
          }
        }, Eo);
      }, es = function(c) {
        return c;
      }, wR = function(c, t, i) {
        switch (i.length) {
          case 0:
            return c.call(t);
          case 1:
            return c.call(t, i[0]);
          case 2:
            return c.call(t, i[0], i[1]);
          case 3:
            return c.call(t, i[0], i[1], i[2]);
        }
        return c.apply(t, i);
      };
      var Yk = Math.max;
      const yR = function(c, t, i) {
        return t = Yk(t === void 0 ? c.length - 1 : t, 0), function() {
          for (var a = arguments, l = -1, d = Yk(a.length - t, 0), g = Array(d); ++l < d; )
            g[l] = a[t + l];
          l = -1;
          for (var m = Array(t + 1); ++l < t; )
            m[l] = a[l];
          return m[t] = i(g), wR(c, this, m);
        };
      }, kR = function(c) {
        return function() {
          return c;
        };
      }, _R = Js ? function(c, t) {
        return Js(c, "toString", { configurable: !0, enumerable: !1, value: kR(t), writable: !0 });
      } : es;
      var AR = Date.now;
      const CR = function(c) {
        var t = 0, i = 0;
        return function() {
          var a = AR(), l = 16 - (a - i);
          if (i = a, l > 0) {
            if (++t >= 800)
              return arguments[0];
          } else
            t = 0;
          return c.apply(void 0, arguments);
        };
      }(_R), xR = function(c, t) {
        return CR(yR(c, t, es), c + "");
      }, ER = function(c, t, i) {
        if (!me(i))
          return !1;
        var a = typeof t;
        return !!(a == "number" ? il(i) && qa(t, i.length) : a == "string" && t in i) && Wr(i[t], c);
      }, Qk = function(c) {
        return xR(function(t, i) {
          var a = -1, l = i.length, d = l > 1 ? i[l - 1] : void 0, g = l > 2 ? i[2] : void 0;
          for (d = c.length > 3 && typeof d == "function" ? (l--, d) : void 0, g && ER(i[0], i[1], g) && (d = l < 3 ? void 0 : d, l = 1), t = Object(t); ++a < l; ) {
            var m = i[a];
            m && c(t, m, a, d);
          }
          return t;
        });
      }, Zk = Qk(function(c, t, i) {
        bR(c, t, i);
      }), SR = function(c, t, i, a) {
        if (!me(c))
          return c;
        for (var l = -1, d = (t = $m(t, c)).length, g = d - 1, m = c; m != null && ++l < d; ) {
          var w = Lm(t[l]), A = i;
          if (w === "__proto__" || w === "constructor" || w === "prototype")
            return c;
          if (l != g) {
            var C = m[w];
            (A = a ? a(C, w, m) : void 0) === void 0 && (A = me(C) ? C : qa(t[l + 1]) ? [] : {});
          }
          Rc(m, w, A), m = m[w];
        }
        return c;
      }, MR = function(c, t, i) {
        return c == null ? c : SR(c, t, i);
      };
      class TR {
        constructor(t) {
          this._styles = {}, this._styleProcessor = t;
        }
        get isEmpty() {
          const t = Object.entries(this._styles);
          return !Array.from(t).length;
        }
        get size() {
          return this.isEmpty ? 0 : this.getStyleNames().length;
        }
        setTo(t) {
          this.clear();
          const i = Array.from(function(a) {
            let l = null, d = 0, g = 0, m = null;
            const w = /* @__PURE__ */ new Map();
            if (a === "")
              return w;
            a.charAt(a.length - 1) != ";" && (a += ";");
            for (let A = 0; A < a.length; A++) {
              const C = a.charAt(A);
              if (l === null)
                switch (C) {
                  case ":":
                    m || (m = a.substr(d, A - d), g = A + 1);
                    break;
                  case '"':
                  case "'":
                    l = C;
                    break;
                  case ";": {
                    const T = a.substr(g, A - g);
                    m && w.set(m.trim(), T.trim()), m = null, d = A + 1;
                    break;
                  }
                }
              else
                C === l && (l = null);
            }
            return w;
          }(t).entries());
          for (const [a, l] of i)
            this._styleProcessor.toNormalizedForm(a, l, this._styles);
        }
        has(t) {
          if (this.isEmpty)
            return !1;
          const i = this._styleProcessor.getReducedForm(t, this._styles).find(([a]) => a === t);
          return Array.isArray(i);
        }
        set(t, i) {
          if (me(t))
            for (const [a, l] of Object.entries(t))
              this._styleProcessor.toNormalizedForm(a, l, this._styles);
          else
            this._styleProcessor.toNormalizedForm(t, i, this._styles);
        }
        remove(t) {
          const i = Fm(t);
          fR(this._styles, i), delete this._styles[t], this._cleanEmptyObjectsOnPath(i);
        }
        getNormalized(t) {
          return this._styleProcessor.getNormalized(t, this._styles);
        }
        toString() {
          return this.isEmpty ? "" : this._getStylesEntries().map((t) => t.join(":")).sort().join(";") + ";";
        }
        getAsString(t) {
          if (this.isEmpty)
            return;
          if (this._styles[t] && !me(this._styles[t]))
            return this._styles[t];
          const i = this._styleProcessor.getReducedForm(t, this._styles).find(([a]) => a === t);
          return Array.isArray(i) ? i[1] : void 0;
        }
        getStyleNames(t = !1) {
          return this.isEmpty ? [] : t ? this._styleProcessor.getStyleNames(this._styles) : this._getStylesEntries().map(([i]) => i);
        }
        clear() {
          this._styles = {};
        }
        _getStylesEntries() {
          const t = [], i = Object.keys(this._styles);
          for (const a of i)
            t.push(...this._styleProcessor.getReducedForm(a, this._styles));
          return t;
        }
        _cleanEmptyObjectsOnPath(t) {
          const i = t.split(".");
          if (!(i.length > 1))
            return;
          const a = i.splice(0, i.length - 1).join("."), l = fh(this._styles, a);
          !l || !Array.from(Object.keys(l)).length && this.remove(a);
        }
      }
      class DR {
        constructor() {
          this._normalizers = /* @__PURE__ */ new Map(), this._extractors = /* @__PURE__ */ new Map(), this._reducers = /* @__PURE__ */ new Map(), this._consumables = /* @__PURE__ */ new Map();
        }
        toNormalizedForm(t, i, a) {
          if (me(i))
            zm(a, Fm(t), i);
          else if (this._normalizers.has(t)) {
            const l = this._normalizers.get(t), { path: d, value: g } = l(i);
            zm(a, d, g);
          } else
            zm(a, t, i);
        }
        getNormalized(t, i) {
          if (!t)
            return Zk({}, i);
          if (i[t] !== void 0)
            return i[t];
          if (this._extractors.has(t)) {
            const a = this._extractors.get(t);
            if (typeof a == "string")
              return fh(i, a);
            const l = a(t, i);
            if (l)
              return l;
          }
          return fh(i, Fm(t));
        }
        getReducedForm(t, i) {
          const a = this.getNormalized(t, i);
          return a === void 0 ? [] : this._reducers.has(t) ? this._reducers.get(t)(a) : [[t, a]];
        }
        getStyleNames(t) {
          const i = Array.from(this._consumables.keys()).filter((l) => {
            const d = this.getNormalized(l, t);
            return d && typeof d == "object" ? Object.keys(d).length : d;
          }), a = /* @__PURE__ */ new Set([...i, ...Object.keys(t)]);
          return Array.from(a.values());
        }
        getRelatedStyles(t) {
          return this._consumables.get(t) || [];
        }
        setNormalizer(t, i) {
          this._normalizers.set(t, i);
        }
        setExtractor(t, i) {
          this._extractors.set(t, i);
        }
        setReducer(t, i) {
          this._reducers.set(t, i);
        }
        setStyleRelation(t, i) {
          this._mapStyleNames(t, i);
          for (const a of i)
            this._mapStyleNames(a, [t]);
        }
        _mapStyleNames(t, i) {
          this._consumables.has(t) || this._consumables.set(t, []), this._consumables.get(t).push(...i);
        }
      }
      function Fm(c) {
        return c.replace("-", ".");
      }
      function zm(c, t, i) {
        let a = i;
        me(i) && (a = Zk({}, fh(c, t), i)), MR(c, t, a);
      }
      class Pr extends Ja {
        constructor(t, i, a, l) {
          if (super(t), this.name = i, this._attrs = function(d) {
            const g = Zi(d);
            for (const [m, w] of g)
              w === null ? g.delete(m) : typeof w != "string" && g.set(m, String(w));
            return g;
          }(a), this._children = [], l && this._insertChild(0, l), this._classes = /* @__PURE__ */ new Set(), this._attrs.has("class")) {
            const d = this._attrs.get("class");
            Xk(this._classes, d), this._attrs.delete("class");
          }
          this._styles = new TR(this.document.stylesProcessor), this._attrs.has("style") && (this._styles.setTo(this._attrs.get("style")), this._attrs.delete("style")), this._customProperties = /* @__PURE__ */ new Map(), this._unsafeAttributesToRender = [];
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this._children.length === 0;
        }
        getChild(t) {
          return this._children[t];
        }
        getChildIndex(t) {
          return this._children.indexOf(t);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        *getAttributeKeys() {
          this._classes.size > 0 && (yield "class"), this._styles.isEmpty || (yield "style"), yield* this._attrs.keys();
        }
        *getAttributes() {
          yield* this._attrs.entries(), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.isEmpty || (yield ["style", this.getAttribute("style")]);
        }
        getAttribute(t) {
          if (t == "class")
            return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
          if (t == "style") {
            const i = this._styles.toString();
            return i == "" ? void 0 : i;
          }
          return this._attrs.get(t);
        }
        hasAttribute(t) {
          return t == "class" ? this._classes.size > 0 : t == "style" ? !this._styles.isEmpty : this._attrs.has(t);
        }
        isSimilar(t) {
          if (!(t instanceof Pr))
            return !1;
          if (this === t)
            return !0;
          if (this.name != t.name || this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size)
            return !1;
          for (const [i, a] of this._attrs)
            if (!t._attrs.has(i) || t._attrs.get(i) !== a)
              return !1;
          for (const i of this._classes)
            if (!t._classes.has(i))
              return !1;
          for (const i of this._styles.getStyleNames())
            if (!t._styles.has(i) || t._styles.getAsString(i) !== this._styles.getAsString(i))
              return !1;
          return !0;
        }
        hasClass(...t) {
          for (const i of t)
            if (!this._classes.has(i))
              return !1;
          return !0;
        }
        getClassNames() {
          return this._classes.keys();
        }
        getStyle(t) {
          return this._styles.getAsString(t);
        }
        getNormalizedStyle(t) {
          return this._styles.getNormalized(t);
        }
        getStyleNames(t) {
          return this._styles.getStyleNames(t);
        }
        hasStyle(...t) {
          for (const i of t)
            if (!this._styles.has(i))
              return !1;
          return !0;
        }
        findAncestor(...t) {
          const i = new Ji(...t);
          let a = this.parent;
          for (; a && !a.is("documentFragment"); ) {
            if (i.match(a))
              return a;
            a = a.parent;
          }
          return null;
        }
        getCustomProperty(t) {
          return this._customProperties.get(t);
        }
        *getCustomProperties() {
          yield* this._customProperties.entries();
        }
        getIdentity() {
          const t = Array.from(this._classes).sort().join(","), i = this._styles.toString(), a = Array.from(this._attrs).map((l) => `${l[0]}="${l[1]}"`).sort().join(" ");
          return this.name + (t == "" ? "" : ` class="${t}"`) + (i ? ` style="${i}"` : "") + (a == "" ? "" : ` ${a}`);
        }
        shouldRenderUnsafeAttribute(t) {
          return this._unsafeAttributesToRender.includes(t);
        }
        _clone(t = !1) {
          const i = [];
          if (t)
            for (const l of this.getChildren())
              i.push(l._clone(t));
          const a = new this.constructor(this.document, this.name, this._attrs, i);
          return a._classes = new Set(this._classes), a._styles.set(this._styles.getNormalized()), a._customProperties = new Map(this._customProperties), a.getFillerOffset = this.getFillerOffset, a._unsafeAttributesToRender = this._unsafeAttributesToRender, a;
        }
        _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
        _insertChild(t, i) {
          this._fireChange("children", this);
          let a = 0;
          const l = function(d, g) {
            return typeof g == "string" ? [new Xt(d, g)] : (Ft(g) || (g = [g]), Array.from(g).map((m) => typeof m == "string" ? new Xt(d, m) : m instanceof Xi ? new Xt(d, m.data) : m));
          }(this.document, i);
          for (const d of l)
            d.parent !== null && d._remove(), d.parent = this, d.document = this.document, this._children.splice(t, 0, d), t++, a++;
          return a;
        }
        _removeChildren(t, i = 1) {
          this._fireChange("children", this);
          for (let a = t; a < t + i; a++)
            this._children[a].parent = null;
          return this._children.splice(t, i);
        }
        _setAttribute(t, i) {
          i = String(i), this._fireChange("attributes", this), t == "class" ? Xk(this._classes, i) : t == "style" ? this._styles.setTo(i) : this._attrs.set(t, i);
        }
        _removeAttribute(t) {
          return this._fireChange("attributes", this), t == "class" ? this._classes.size > 0 && (this._classes.clear(), !0) : t == "style" ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(t);
        }
        _addClass(t) {
          this._fireChange("attributes", this);
          for (const i of Yn(t))
            this._classes.add(i);
        }
        _removeClass(t) {
          this._fireChange("attributes", this);
          for (const i of Yn(t))
            this._classes.delete(i);
        }
        _setStyle(t, i) {
          this._fireChange("attributes", this), Wn(t) ? this._styles.set(t) : this._styles.set(t, i);
        }
        _removeStyle(t) {
          this._fireChange("attributes", this);
          for (const i of Yn(t))
            this._styles.remove(i);
        }
        _setCustomProperty(t, i) {
          this._customProperties.set(t, i);
        }
        _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }
      function Xk(c, t) {
        const i = t.split(/\s+/);
        c.clear(), i.forEach((a) => c.add(a));
      }
      Pr.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "element" || c === "view:element") : c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class eu extends Pr {
        constructor(...t) {
          super(...t), this.getFillerOffset = Jk;
        }
      }
      function Jk() {
        const c = [...this.getChildren()], t = c[this.childCount - 1];
        if (t && t.is("element", "br"))
          return this.childCount;
        for (const i of c)
          if (!i.is("uiElement"))
            return null;
        return this.childCount;
      }
      eu.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element") : c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class ph extends Te(eu) {
        constructor(...t) {
          super(...t);
          const i = t[0];
          this.set("isReadOnly", !1), this.set("isFocused", !1), this.bind("isReadOnly").to(i), this.bind("isFocused").to(i, "isFocused", (a) => a && i.selection.editableElement == this), this.listenTo(i.selection, "change", () => {
            this.isFocused = i.isFocused && i.selection.editableElement == this;
          });
        }
        destroy() {
          this.stopListening();
        }
      }
      ph.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "editableElement" || c === "view:editableElement" || c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element") : c === "editableElement" || c === "view:editableElement" || c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      const e_ = Symbol("rootName");
      class t_ extends ph {
        constructor(t, i) {
          super(t, i), this.rootName = "main";
        }
        get rootName() {
          return this.getCustomProperty(e_);
        }
        set rootName(t) {
          this._setCustomProperty(e_, t);
        }
        set _name(t) {
          this.name = t;
        }
      }
      t_.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "rootElement" || c === "view:rootElement" || c === "editableElement" || c === "view:editableElement" || c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element") : c === "rootElement" || c === "view:rootElement" || c === "editableElement" || c === "view:editableElement" || c === "containerElement" || c === "view:containerElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class ts {
        constructor(t = {}) {
          if (!t.boundaries && !t.startPosition)
            throw new S("view-tree-walker-no-start-position", null);
          if (t.direction && t.direction != "forward" && t.direction != "backward")
            throw new S("view-tree-walker-unknown-direction", t.startPosition, { direction: t.direction });
          this.boundaries = t.boundaries || null, t.startPosition ? this.position = $e._createAt(t.startPosition) : this.position = $e._createAt(t.boundaries[t.direction == "backward" ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(t) {
          let i, a, l;
          do
            l = this.position, { done: i, value: a } = this.next();
          while (!i && t(a));
          i || (this.position = l);
        }
        next() {
          return this.direction == "forward" ? this._next() : this._previous();
        }
        _next() {
          let t = this.position.clone();
          const i = this.position, a = t.parent;
          if (a.parent === null && t.offset === a.childCount)
            return { done: !0, value: void 0 };
          if (a === this._boundaryEndParent && t.offset == this.boundaries.end.offset)
            return { done: !0, value: void 0 };
          let l;
          if (a instanceof Xt) {
            if (t.isAtEnd)
              return this.position = $e._createAfter(a), this._next();
            l = a.data[t.offset];
          } else
            l = a.getChild(t.offset);
          if (l instanceof Pr)
            return this.shallow ? t.offset++ : t = new $e(l, 0), this.position = t, this._formatReturnValue("elementStart", l, i, t, 1);
          if (l instanceof Xt) {
            if (this.singleCharacters)
              return t = new $e(l, 0), this.position = t, this._next();
            {
              let d, g = l.data.length;
              return l == this._boundaryEndParent ? (g = this.boundaries.end.offset, d = new Xi(l, 0, g), t = $e._createAfter(d)) : (d = new Xi(l, 0, l.data.length), t.offset++), this.position = t, this._formatReturnValue("text", d, i, t, g);
            }
          }
          if (typeof l == "string") {
            let d;
            this.singleCharacters ? d = 1 : d = (a === this._boundaryEndParent ? this.boundaries.end.offset : a.data.length) - t.offset;
            const g = new Xi(a, t.offset, d);
            return t.offset += d, this.position = t, this._formatReturnValue("text", g, i, t, d);
          }
          return t = $e._createAfter(a), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", a, i, t);
        }
        _previous() {
          let t = this.position.clone();
          const i = this.position, a = t.parent;
          if (a.parent === null && t.offset === 0)
            return { done: !0, value: void 0 };
          if (a == this._boundaryStartParent && t.offset == this.boundaries.start.offset)
            return { done: !0, value: void 0 };
          let l;
          if (a instanceof Xt) {
            if (t.isAtStart)
              return this.position = $e._createBefore(a), this._previous();
            l = a.data[t.offset - 1];
          } else
            l = a.getChild(t.offset - 1);
          if (l instanceof Pr)
            return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", l, i, t, 1)) : (t = new $e(l, l.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", l, i, t));
          if (l instanceof Xt) {
            if (this.singleCharacters)
              return t = new $e(l, l.data.length), this.position = t, this._previous();
            {
              let d, g = l.data.length;
              if (l == this._boundaryStartParent) {
                const m = this.boundaries.start.offset;
                d = new Xi(l, m, l.data.length - m), g = d.data.length, t = $e._createBefore(d);
              } else
                d = new Xi(l, 0, l.data.length), t.offset--;
              return this.position = t, this._formatReturnValue("text", d, i, t, g);
            }
          }
          if (typeof l == "string") {
            let d;
            if (this.singleCharacters)
              d = 1;
            else {
              const m = a === this._boundaryStartParent ? this.boundaries.start.offset : 0;
              d = t.offset - m;
            }
            t.offset -= d;
            const g = new Xi(a, t.offset, d);
            return this.position = t, this._formatReturnValue("text", g, i, t, d);
          }
          return t = $e._createBefore(a), this.position = t, this._formatReturnValue("elementStart", a, i, t, 1);
        }
        _formatReturnValue(t, i, a, l, d) {
          return i instanceof Xi && (i.offsetInText + i.data.length == i.textNode.data.length && (this.direction != "forward" || this.boundaries && this.boundaries.end.isEqual(this.position) ? a = $e._createAfter(i.textNode) : (l = $e._createAfter(i.textNode), this.position = l)), i.offsetInText === 0 && (this.direction != "backward" || this.boundaries && this.boundaries.start.isEqual(this.position) ? a = $e._createBefore(i.textNode) : (l = $e._createBefore(i.textNode), this.position = l))), { done: !1, value: { type: t, item: i, previousPosition: a, nextPosition: l, length: d } };
        }
      }
      class $e extends Xa {
        constructor(t, i) {
          super(), this.parent = t, this.offset = i;
        }
        get nodeAfter() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
        }
        get nodeBefore() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
        get root() {
          return this.parent.root;
        }
        get editableElement() {
          let t = this.parent;
          for (; !(t instanceof ph); ) {
            if (!t.parent)
              return null;
            t = t.parent;
          }
          return t;
        }
        getShiftedBy(t) {
          const i = $e._createAt(this), a = i.offset + t;
          return i.offset = a < 0 ? 0 : a, i;
        }
        getLastMatchingPosition(t, i = {}) {
          i.startPosition = this;
          const a = new ts(i);
          return a.skip(t), a.position;
        }
        getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({ includeSelf: !0 });
        }
        getCommonAncestor(t) {
          const i = this.getAncestors(), a = t.getAncestors();
          let l = 0;
          for (; i[l] == a[l] && i[l]; )
            l++;
          return l === 0 ? null : i[l - 1];
        }
        isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
        isBefore(t) {
          return this.compareWith(t) == "before";
        }
        isAfter(t) {
          return this.compareWith(t) == "after";
        }
        compareWith(t) {
          if (this.root !== t.root)
            return "different";
          if (this.isEqual(t))
            return "same";
          const i = this.parent.is("node") ? this.parent.getPath() : [], a = t.parent.is("node") ? t.parent.getPath() : [];
          i.push(this.offset), a.push(t.offset);
          const l = Lt(i, a);
          switch (l) {
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return i[l] < a[l] ? "before" : "after";
          }
        }
        getWalker(t = {}) {
          return t.startPosition = this, new ts(t);
        }
        clone() {
          return new $e(this.parent, this.offset);
        }
        static _createAt(t, i) {
          if (t instanceof $e)
            return new this(t.parent, t.offset);
          {
            const a = t;
            if (i == "end")
              i = a.is("$text") ? a.data.length : a.childCount;
            else {
              if (i == "before")
                return this._createBefore(a);
              if (i == "after")
                return this._createAfter(a);
              if (i !== 0 && !i)
                throw new S("view-createpositionat-offset-required", a);
            }
            return new $e(a, i);
          }
        }
        static _createAfter(t) {
          if (t.is("$textProxy"))
            return new $e(t.textNode, t.offsetInText + t.data.length);
          if (!t.parent)
            throw new S("view-position-after-root", t, { root: t });
          return new $e(t.parent, t.index + 1);
        }
        static _createBefore(t) {
          if (t.is("$textProxy"))
            return new $e(t.textNode, t.offsetInText);
          if (!t.parent)
            throw new S("view-position-before-root", t, { root: t });
          return new $e(t.parent, t.index);
        }
      }
      $e.prototype.is = function(c) {
        return c === "position" || c === "view:position";
      };
      class it extends Xa {
        constructor(t, i = null) {
          super(), this.start = t.clone(), this.end = i ? i.clone() : t.clone();
        }
        *[Symbol.iterator]() {
          yield* new ts({ boundaries: this, ignoreElementEnd: !0 });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          return this.start.parent === this.end.parent;
        }
        get root() {
          return this.start.root;
        }
        getEnlarged() {
          let t = this.start.getLastMatchingPosition(gh, { direction: "backward" }), i = this.end.getLastMatchingPosition(gh);
          return t.parent.is("$text") && t.isAtStart && (t = $e._createBefore(t.parent)), i.parent.is("$text") && i.isAtEnd && (i = $e._createAfter(i.parent)), new it(t, i);
        }
        getTrimmed() {
          let t = this.start.getLastMatchingPosition(gh);
          if (t.isAfter(this.end) || t.isEqual(this.end))
            return new it(t, t);
          let i = this.end.getLastMatchingPosition(gh, { direction: "backward" });
          const a = t.nodeAfter, l = i.nodeBefore;
          return a && a.is("$text") && (t = new $e(a, 0)), l && l.is("$text") && (i = new $e(l, l.data.length)), new it(t, i);
        }
        isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
        containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
        containsRange(t, i = !1) {
          t.isCollapsed && (i = !1);
          const a = this.containsPosition(t.start) || i && this.start.isEqual(t.start), l = this.containsPosition(t.end) || i && this.end.isEqual(t.end);
          return a && l;
        }
        getDifference(t) {
          const i = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && i.push(new it(this.start, t.start)), this.containsPosition(t.end) && i.push(new it(t.end, this.end))) : i.push(this.clone()), i;
        }
        getIntersection(t) {
          if (this.isIntersecting(t)) {
            let i = this.start, a = this.end;
            return this.containsPosition(t.start) && (i = t.start), this.containsPosition(t.end) && (a = t.end), new it(i, a);
          }
          return null;
        }
        getWalker(t = {}) {
          return t.boundaries = this, new ts(t);
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        getContainedElement() {
          if (this.isCollapsed)
            return null;
          let t = this.start.nodeAfter, i = this.end.nodeBefore;
          return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (i = this.end.parent.previousSibling), t && t.is("element") && t === i ? t : null;
        }
        clone() {
          return new it(this.start, this.end);
        }
        *getItems(t = {}) {
          t.boundaries = this, t.ignoreElementEnd = !0;
          const i = new ts(t);
          for (const a of i)
            yield a.item;
        }
        *getPositions(t = {}) {
          t.boundaries = this;
          const i = new ts(t);
          yield i.position;
          for (const a of i)
            yield a.nextPosition;
        }
        isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
        static _createFromParentsAndOffsets(t, i, a, l) {
          return new this(new $e(t, i), new $e(a, l));
        }
        static _createFromPositionAndShift(t, i) {
          const a = t, l = t.getShiftedBy(i);
          return i > 0 ? new this(a, l) : new this(l, a);
        }
        static _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
        static _createOn(t) {
          const i = t.is("$textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift($e._createBefore(t), i);
        }
      }
      function gh(c) {
        return !(!c.item.is("attributeElement") && !c.item.is("uiElement"));
      }
      it.prototype.is = function(c) {
        return c === "range" || c === "view:range";
      };
      class eo extends ie(Xa) {
        constructor(...t) {
          super(), this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", t.length && this.setTo(...t);
        }
        get isFake() {
          return this._isFake;
        }
        get fakeSelectionLabel() {
          return this._fakeSelectionLabel;
        }
        get anchor() {
          if (!this._ranges.length)
            return null;
          const t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.end : t.start).clone();
        }
        get focus() {
          if (!this._ranges.length)
            return null;
          const t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.start : t.end).clone();
        }
        get isCollapsed() {
          return this.rangeCount === 1 && this._ranges[0].isCollapsed;
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        get editableElement() {
          return this.anchor ? this.anchor.editableElement : null;
        }
        *getRanges() {
          for (const t of this._ranges)
            yield t.clone();
        }
        getFirstRange() {
          let t = null;
          for (const i of this._ranges)
            t && !i.start.isBefore(t.start) || (t = i);
          return t ? t.clone() : null;
        }
        getLastRange() {
          let t = null;
          for (const i of this._ranges)
            t && !i.end.isAfter(t.end) || (t = i);
          return t ? t.clone() : null;
        }
        getFirstPosition() {
          const t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
        getLastPosition() {
          const t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
        isEqual(t) {
          if (this.isFake != t.isFake || this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel || this.rangeCount != t.rangeCount)
            return !1;
          if (this.rangeCount === 0)
            return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
            return !1;
          for (const i of this._ranges) {
            let a = !1;
            for (const l of t._ranges)
              if (i.isEqual(l)) {
                a = !0;
                break;
              }
            if (!a)
              return !1;
          }
          return !0;
        }
        isSimilar(t) {
          if (this.isBackward != t.isBackward)
            return !1;
          const i = An(this.getRanges());
          if (i != An(t.getRanges()))
            return !1;
          if (i == 0)
            return !0;
          for (let a of this.getRanges()) {
            a = a.getTrimmed();
            let l = !1;
            for (let d of t.getRanges())
              if (d = d.getTrimmed(), a.start.isEqual(d.start) && a.end.isEqual(d.end)) {
                l = !0;
                break;
              }
            if (!l)
              return !1;
          }
          return !0;
        }
        getSelectedElement() {
          return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
        }
        setTo(...t) {
          let [i, a, l] = t;
          if (typeof a == "object" && (l = a, a = void 0), i === null)
            this._setRanges([]), this._setFakeOptions(l);
          else if (i instanceof eo || i instanceof Vm)
            this._setRanges(i.getRanges(), i.isBackward), this._setFakeOptions({ fake: i.isFake, label: i.fakeSelectionLabel });
          else if (i instanceof it)
            this._setRanges([i], l && l.backward), this._setFakeOptions(l);
          else if (i instanceof $e)
            this._setRanges([new it(i)]), this._setFakeOptions(l);
          else if (i instanceof Ja) {
            const d = !!l && !!l.backward;
            let g;
            if (a === void 0)
              throw new S("view-selection-setto-required-second-parameter", this);
            g = a == "in" ? it._createIn(i) : a == "on" ? it._createOn(i) : new it($e._createAt(i, a)), this._setRanges([g], d), this._setFakeOptions(l);
          } else {
            if (!Ft(i))
              throw new S("view-selection-setto-not-selectable", this);
            this._setRanges(i, l && l.backward), this._setFakeOptions(l);
          }
          this.fire("change");
        }
        setFocus(t, i) {
          if (this.anchor === null)
            throw new S("view-selection-setfocus-no-ranges", this);
          const a = $e._createAt(t, i);
          if (a.compareWith(this.focus) == "same")
            return;
          const l = this.anchor;
          this._ranges.pop(), a.compareWith(l) == "before" ? this._addRange(new it(a, l), !0) : this._addRange(new it(l, a)), this.fire("change");
        }
        _setRanges(t, i = !1) {
          t = Array.from(t), this._ranges = [];
          for (const a of t)
            this._addRange(a);
          this._lastRangeBackward = !!i;
        }
        _setFakeOptions(t = {}) {
          this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
        }
        _addRange(t, i = !1) {
          if (!(t instanceof it))
            throw new S("view-selection-add-range-not-range", this);
          this._pushRange(t), this._lastRangeBackward = !!i;
        }
        _pushRange(t) {
          for (const i of this._ranges)
            if (t.isIntersecting(i))
              throw new S("view-selection-range-intersects", this, { addedRange: t, intersectingRange: i });
          this._ranges.push(new it(t.start, t.end));
        }
      }
      eo.prototype.is = function(c) {
        return c === "selection" || c === "view:selection";
      };
      class Vm extends ie(Xa) {
        constructor(...t) {
          super(), this._selection = new eo(), this._selection.delegate("change").to(this), t.length && this._selection.setTo(...t);
        }
        get isFake() {
          return this._selection.isFake;
        }
        get fakeSelectionLabel() {
          return this._selection.fakeSelectionLabel;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get editableElement() {
          return this._selection.editableElement;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        *getRanges() {
          yield* this._selection.getRanges();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        isEqual(t) {
          return this._selection.isEqual(t);
        }
        isSimilar(t) {
          return this._selection.isSimilar(t);
        }
        _setTo(...t) {
          this._selection.setTo(...t);
        }
        _setFocus(t, i) {
          this._selection.setFocus(t, i);
        }
      }
      Vm.prototype.is = function(c) {
        return c === "selection" || c == "documentSelection" || c == "view:selection" || c == "view:documentSelection";
      };
      class fl extends D {
        constructor(t, i, a) {
          super(t, i), this.startRange = a, this._eventPhase = "none", this._currentTarget = null;
        }
        get eventPhase() {
          return this._eventPhase;
        }
        get currentTarget() {
          return this._currentTarget;
        }
      }
      const Hm = Symbol("bubbling contexts");
      function Um(c) {
        return class extends c {
          fire(t, ...i) {
            try {
              const a = t instanceof D ? t : new D(this, t), l = Wm(this);
              if (!l.size)
                return;
              if (tu(a, "capturing", this), pl(l, "$capture", a, ...i))
                return a.return;
              const d = a.startRange || this.selection.getFirstRange(), g = d ? d.getContainedElement() : null, m = !!g && Boolean(n_(l, g));
              let w = g || function(A) {
                if (!A)
                  return null;
                const C = A.start.parent, T = A.end.parent, R = C.getPath(), j = T.getPath();
                return R.length > j.length ? C : T;
              }(d);
              if (tu(a, "atTarget", w), !m) {
                if (pl(l, "$text", a, ...i))
                  return a.return;
                tu(a, "bubbling", w);
              }
              for (; w; ) {
                if (w.is("rootElement")) {
                  if (pl(l, "$root", a, ...i))
                    return a.return;
                } else if (w.is("element") && pl(l, w.name, a, ...i))
                  return a.return;
                if (pl(l, w, a, ...i))
                  return a.return;
                w = w.parent, tu(a, "bubbling", w);
              }
              return tu(a, "bubbling", this), pl(l, "$document", a, ...i), a.return;
            } catch (a) {
              S.rethrowUnexpectedError(a, this);
            }
          }
          _addEventListener(t, i, a) {
            const l = Yn(a.context || "$document"), d = Wm(this);
            for (const g of l) {
              let m = d.get(g);
              m || (m = new (ie())(), d.set(g, m)), this.listenTo(m, t, i, a);
            }
          }
          _removeEventListener(t, i) {
            const a = Wm(this);
            for (const l of a.values())
              this.stopListening(l, t, i);
          }
        };
      }
      {
        const c = Um(Object);
        ["fire", "_addEventListener", "_removeEventListener"].forEach((t) => {
          Um[t] = c.prototype[t];
        });
      }
      function tu(c, t, i) {
        c instanceof fl && (c._eventPhase = t, c._currentTarget = i);
      }
      function pl(c, t, i, ...a) {
        const l = typeof t == "string" ? c.get(t) : n_(c, t);
        return !!l && (l.fire(i, ...a), i.stop.called);
      }
      function n_(c, t) {
        for (const [i, a] of c)
          if (typeof i == "function" && i(t))
            return a;
        return null;
      }
      function Wm(c) {
        return c[Hm] || (c[Hm] = /* @__PURE__ */ new Map()), c[Hm];
      }
      class mh extends Um(Te()) {
        constructor(t) {
          super(), this.selection = new Vm(), this.roots = new yi({ idProperty: "rootName" }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("_isFocusChanging", !1), this.set("isSelecting", !1), this.set("isComposing", !1), this._postFixers = /* @__PURE__ */ new Set();
        }
        getRoot(t = "main") {
          return this.roots.get(t);
        }
        registerPostFixer(t) {
          this._postFixers.add(t);
        }
        destroy() {
          this.roots.map((t) => t.destroy()), this.stopListening();
        }
        _callPostFixers(t) {
          let i = !1;
          do
            for (const a of this._postFixers)
              if (i = a(t), i)
                break;
          while (i);
        }
      }
      class ns extends Pr {
        constructor(...t) {
          super(...t), this.getFillerOffset = IR, this._priority = 10, this._id = null, this._clonesGroup = null;
        }
        get priority() {
          return this._priority;
        }
        get id() {
          return this._id;
        }
        getElementsWithSameId() {
          if (this.id === null)
            throw new S("attribute-element-get-elements-with-same-id-no-id", this);
          return new Set(this._clonesGroup);
        }
        isSimilar(t) {
          return this.id !== null || t.id !== null ? this.id === t.id : super.isSimilar(t) && this.priority == t.priority;
        }
        _clone(t = !1) {
          const i = super._clone(t);
          return i._priority = this._priority, i._id = this._id, i;
        }
      }
      function IR() {
        if (Gm(this))
          return null;
        let c = this.parent;
        for (; c && c.is("attributeElement"); ) {
          if (Gm(c) > 1)
            return null;
          c = c.parent;
        }
        return !c || Gm(c) > 1 ? null : this.childCount;
      }
      function Gm(c) {
        return Array.from(c.getChildren()).filter((t) => !t.is("uiElement")).length;
      }
      ns.DEFAULT_PRIORITY = 10, ns.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "attributeElement" || c === "view:attributeElement" || c === "element" || c === "view:element") : c === "attributeElement" || c === "view:attributeElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class qm extends Pr {
        constructor(t, i, a, l) {
          super(t, i, a, l), this.getFillerOffset = PR;
        }
        _insertChild(t, i) {
          if (i && (i instanceof Ja || Array.from(i).length > 0))
            throw new S("view-emptyelement-cannot-add", [this, i]);
          return 0;
        }
      }
      function PR() {
        return null;
      }
      qm.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "emptyElement" || c === "view:emptyElement" || c === "element" || c === "view:element") : c === "emptyElement" || c === "view:emptyElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class vh extends Pr {
        constructor(...t) {
          super(...t), this.getFillerOffset = RR;
        }
        _insertChild(t, i) {
          if (i && (i instanceof Ja || Array.from(i).length > 0))
            throw new S("view-uielement-cannot-add", [this, i]);
          return 0;
        }
        render(t, i) {
          return this.toDomElement(t);
        }
        toDomElement(t) {
          const i = t.createElement(this.name);
          for (const a of this.getAttributeKeys())
            i.setAttribute(a, this.getAttribute(a));
          return i;
        }
      }
      function OR(c) {
        c.document.on("arrowKey", (t, i) => function(a, l, d) {
          if (l.keyCode == St.arrowright) {
            const g = l.domTarget.ownerDocument.defaultView.getSelection(), m = g.rangeCount == 1 && g.getRangeAt(0).collapsed;
            if (m || l.shiftKey) {
              const w = g.focusNode, A = g.focusOffset, C = d.domPositionToView(w, A);
              if (C === null)
                return;
              let T = !1;
              const R = C.getLastMatchingPosition((j) => (j.item.is("uiElement") && (T = !0), !(!j.item.is("uiElement") && !j.item.is("attributeElement"))));
              if (T) {
                const j = d.viewPositionToDom(R);
                m ? g.collapse(j.parent, j.offset) : g.extend(j.parent, j.offset);
              }
            }
          }
        }(0, i, c.domConverter), { priority: "low" });
      }
      function RR() {
        return null;
      }
      vh.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "uiElement" || c === "view:uiElement" || c === "element" || c === "view:element") : c === "uiElement" || c === "view:uiElement" || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class Km extends Pr {
        constructor(...t) {
          super(...t), this.getFillerOffset = NR;
        }
        _insertChild(t, i) {
          if (i && (i instanceof Ja || Array.from(i).length > 0))
            throw new S("view-rawelement-cannot-add", [this, i]);
          return 0;
        }
        render() {
        }
      }
      function NR() {
        return null;
      }
      Km.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "rawElement" || c === "view:rawElement" || c === "element" || c === "view:element") : c === "rawElement" || c === "view:rawElement" || c === this.name || c === "view:" + this.name || c === "element" || c === "view:element" || c === "node" || c === "view:node";
      };
      class rs extends ie(Xa) {
        constructor(t, i) {
          super(), this.document = t, this._children = [], i && this._insertChild(0, i);
        }
        [Symbol.iterator]() {
          return this._children[Symbol.iterator]();
        }
        get childCount() {
          return this._children.length;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
        getChild(t) {
          return this._children[t];
        }
        getChildIndex(t) {
          return this._children.indexOf(t);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        _insertChild(t, i) {
          this._fireChange("children", this);
          let a = 0;
          const l = function(d, g) {
            return typeof g == "string" ? [new Xt(d, g)] : (Ft(g) || (g = [g]), Array.from(g).map((m) => typeof m == "string" ? new Xt(d, m) : m instanceof Xi ? new Xt(d, m.data) : m));
          }(this.document, i);
          for (const d of l)
            d.parent !== null && d._remove(), d.parent = this, this._children.splice(t, 0, d), t++, a++;
          return a;
        }
        _removeChildren(t, i = 1) {
          this._fireChange("children", this);
          for (let a = t; a < t + i; a++)
            this._children[a].parent = null;
          return this._children.splice(t, i);
        }
        _fireChange(t, i) {
          this.fire("change:" + t, i);
        }
      }
      rs.prototype.is = function(c) {
        return c === "documentFragment" || c === "view:documentFragment";
      };
      class r_ {
        constructor(t) {
          this.document = t, this._cloneGroups = /* @__PURE__ */ new Map(), this._slotFactory = null;
        }
        setSelection(...t) {
          this.document.selection._setTo(...t);
        }
        setSelectionFocus(...t) {
          this.document.selection._setFocus(...t);
        }
        createDocumentFragment(t) {
          return new rs(this.document, t);
        }
        createText(t) {
          return new Xt(this.document, t);
        }
        createAttributeElement(t, i, a = {}) {
          const l = new ns(this.document, t, i);
          return typeof a.priority == "number" && (l._priority = a.priority), a.id && (l._id = a.id), a.renderUnsafeAttributes && l._unsafeAttributesToRender.push(...a.renderUnsafeAttributes), l;
        }
        createContainerElement(t, i, a = {}, l = {}) {
          let d = null;
          Wn(a) ? l = a : d = a;
          const g = new eu(this.document, t, i, d);
          return l.renderUnsafeAttributes && g._unsafeAttributesToRender.push(...l.renderUnsafeAttributes), g;
        }
        createEditableElement(t, i, a = {}) {
          const l = new ph(this.document, t, i);
          return a.renderUnsafeAttributes && l._unsafeAttributesToRender.push(...a.renderUnsafeAttributes), l;
        }
        createEmptyElement(t, i, a = {}) {
          const l = new qm(this.document, t, i);
          return a.renderUnsafeAttributes && l._unsafeAttributesToRender.push(...a.renderUnsafeAttributes), l;
        }
        createUIElement(t, i, a) {
          const l = new vh(this.document, t, i);
          return a && (l.render = a), l;
        }
        createRawElement(t, i, a, l = {}) {
          const d = new Km(this.document, t, i);
          return a && (d.render = a), l.renderUnsafeAttributes && d._unsafeAttributesToRender.push(...l.renderUnsafeAttributes), d;
        }
        setAttribute(t, i, a) {
          a._setAttribute(t, i);
        }
        removeAttribute(t, i) {
          i._removeAttribute(t);
        }
        addClass(t, i) {
          i._addClass(t);
        }
        removeClass(t, i) {
          i._removeClass(t);
        }
        setStyle(t, i, a) {
          Wn(t) && a === void 0 ? i._setStyle(t) : a._setStyle(t, i);
        }
        removeStyle(t, i) {
          i._removeStyle(t);
        }
        setCustomProperty(t, i, a) {
          a._setCustomProperty(t, i);
        }
        removeCustomProperty(t, i) {
          return i._removeCustomProperty(t);
        }
        breakAttributes(t) {
          return t instanceof $e ? this._breakAttributes(t) : this._breakAttributesRange(t);
        }
        breakContainer(t) {
          const i = t.parent;
          if (!i.is("containerElement"))
            throw new S("view-writer-break-non-container-element", this.document);
          if (!i.parent)
            throw new S("view-writer-break-root", this.document);
          if (t.isAtStart)
            return $e._createBefore(i);
          if (!t.isAtEnd) {
            const a = i._clone(!1);
            this.insert($e._createAfter(i), a);
            const l = new it(t, $e._createAt(i, "end")), d = new $e(a, 0);
            this.move(l, d);
          }
          return $e._createAfter(i);
        }
        mergeAttributes(t) {
          const i = t.offset, a = t.parent;
          if (a.is("$text"))
            return t;
          if (a.is("attributeElement") && a.childCount === 0) {
            const g = a.parent, m = a.index;
            return a._remove(), this._removeFromClonedElementsGroup(a), this.mergeAttributes(new $e(g, m));
          }
          const l = a.getChild(i - 1), d = a.getChild(i);
          if (!l || !d)
            return t;
          if (l.is("$text") && d.is("$text"))
            return o_(l, d);
          if (l.is("attributeElement") && d.is("attributeElement") && l.isSimilar(d)) {
            const g = l.childCount;
            return l._appendChild(d.getChildren()), d._remove(), this._removeFromClonedElementsGroup(d), this.mergeAttributes(new $e(l, g));
          }
          return t;
        }
        mergeContainers(t) {
          const i = t.nodeBefore, a = t.nodeAfter;
          if (!(i && a && i.is("containerElement") && a.is("containerElement")))
            throw new S("view-writer-merge-containers-invalid-position", this.document);
          const l = i.getChild(i.childCount - 1), d = l instanceof Xt ? $e._createAt(l, "end") : $e._createAt(i, "end");
          return this.move(it._createIn(a), $e._createAt(i, "end")), this.remove(it._createOn(a)), d;
        }
        insert(t, i) {
          a_(i = Ft(i) ? [...i] : [i], this.document);
          const a = i.reduce((g, m) => {
            const w = g[g.length - 1], A = !m.is("uiElement");
            return w && w.breakAttributes == A ? w.nodes.push(m) : g.push({ breakAttributes: A, nodes: [m] }), g;
          }, []);
          let l = null, d = t;
          for (const { nodes: g, breakAttributes: m } of a) {
            const w = this._insertNodes(d, g, m);
            l || (l = w.start), d = w.end;
          }
          return l ? new it(l, d) : new it(t);
        }
        remove(t) {
          const i = t instanceof it ? t : it._createOn(t);
          if (nu(i, this.document), i.isCollapsed)
            return new rs(this.document);
          const { start: a, end: l } = this._breakAttributesRange(i, !0), d = a.parent, g = l.offset - a.offset, m = d._removeChildren(a.offset, g);
          for (const A of m)
            this._removeFromClonedElementsGroup(A);
          const w = this.mergeAttributes(a);
          return i.start = w, i.end = w.clone(), new rs(this.document, m);
        }
        clear(t, i) {
          nu(t, this.document);
          const a = t.getWalker({ direction: "backward", ignoreElementEnd: !0 });
          for (const l of a) {
            const d = l.item;
            let g;
            if (d.is("element") && i.isSimilar(d))
              g = it._createOn(d);
            else if (!l.nextPosition.isAfter(t.start) && d.is("$textProxy")) {
              const m = d.getAncestors().find((w) => w.is("element") && i.isSimilar(w));
              m && (g = it._createIn(m));
            }
            g && (g.end.isAfter(t.end) && (g.end = t.end), g.start.isBefore(t.start) && (g.start = t.start), this.remove(g));
          }
        }
        move(t, i) {
          let a;
          if (i.isAfter(t.end)) {
            const l = (i = this._breakAttributes(i, !0)).parent, d = l.childCount;
            t = this._breakAttributesRange(t, !0), a = this.remove(t), i.offset += l.childCount - d;
          } else
            a = this.remove(t);
          return this.insert(i, a);
        }
        wrap(t, i) {
          if (!(i instanceof ns))
            throw new S("view-writer-wrap-invalid-attribute", this.document);
          if (nu(t, this.document), t.isCollapsed) {
            let l = t.start;
            l.parent.is("element") && (a = l.parent, !Array.from(a.getChildren()).some((g) => !g.is("uiElement"))) && (l = l.getLastMatchingPosition((g) => g.item.is("uiElement"))), l = this._wrapPosition(l, i);
            const d = this.document.selection;
            return d.isCollapsed && d.getFirstPosition().isEqual(t.start) && this.setSelection(l), new it(l);
          }
          return this._wrapRange(t, i);
          var a;
        }
        unwrap(t, i) {
          if (!(i instanceof ns))
            throw new S("view-writer-unwrap-invalid-attribute", this.document);
          if (nu(t, this.document), t.isCollapsed)
            return t;
          const { start: a, end: l } = this._breakAttributesRange(t, !0), d = a.parent, g = this._unwrapChildren(d, a.offset, l.offset, i), m = this.mergeAttributes(g.start);
          m.isEqual(g.start) || g.end.offset--;
          const w = this.mergeAttributes(g.end);
          return new it(m, w);
        }
        rename(t, i) {
          const a = new eu(this.document, t, i.getAttributes());
          return this.insert($e._createAfter(i), a), this.move(it._createIn(i), $e._createAt(a, 0)), this.remove(it._createOn(i)), a;
        }
        clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
        createPositionAt(t, i) {
          return $e._createAt(t, i);
        }
        createPositionAfter(t) {
          return $e._createAfter(t);
        }
        createPositionBefore(t) {
          return $e._createBefore(t);
        }
        createRange(...t) {
          return new it(...t);
        }
        createRangeOn(t) {
          return it._createOn(t);
        }
        createRangeIn(t) {
          return it._createIn(t);
        }
        createSelection(...t) {
          return new eo(...t);
        }
        createSlot(t) {
          if (!this._slotFactory)
            throw new S("view-writer-invalid-create-slot-context", this.document);
          return this._slotFactory(this, t);
        }
        _registerSlotFactory(t) {
          this._slotFactory = t;
        }
        _clearSlotFactory() {
          this._slotFactory = null;
        }
        _insertNodes(t, i, a) {
          let l, d;
          if (l = a ? Ym(t) : t.parent.is("$text") ? t.parent.parent : t.parent, !l)
            throw new S("view-writer-invalid-position-container", this.document);
          d = a ? this._breakAttributes(t, !0) : t.parent.is("$text") ? Qm(t) : t;
          const g = l._insertChild(d.offset, i);
          for (const C of i)
            this._addToClonedElementsGroup(C);
          const m = d.getShiftedBy(g), w = this.mergeAttributes(d);
          w.isEqual(d) || m.offset--;
          const A = this.mergeAttributes(m);
          return new it(w, A);
        }
        _wrapChildren(t, i, a, l) {
          let d = i;
          const g = [];
          for (; d < a; ) {
            const w = t.getChild(d), A = w.is("$text"), C = w.is("attributeElement");
            if (C && this._wrapAttributeElement(l, w))
              g.push(new $e(t, d));
            else if (A || !C || $R(l, w)) {
              const T = l._clone();
              w._remove(), T._appendChild(w), t._insertChild(d, T), this._addToClonedElementsGroup(T), g.push(new $e(t, d));
            } else
              this._wrapChildren(w, 0, w.childCount, l);
            d++;
          }
          let m = 0;
          for (const w of g)
            w.offset -= m, w.offset != i && (this.mergeAttributes(w).isEqual(w) || (m++, a--));
          return it._createFromParentsAndOffsets(t, i, t, a);
        }
        _unwrapChildren(t, i, a, l) {
          let d = i;
          const g = [];
          for (; d < a; ) {
            const w = t.getChild(d);
            if (w.is("attributeElement"))
              if (w.isSimilar(l)) {
                const A = w.getChildren(), C = w.childCount;
                w._remove(), t._insertChild(d, A), this._removeFromClonedElementsGroup(w), g.push(new $e(t, d), new $e(t, d + C)), d += C, a += C - 1;
              } else
                this._unwrapAttributeElement(l, w) ? (g.push(new $e(t, d), new $e(t, d + 1)), d++) : (this._unwrapChildren(w, 0, w.childCount, l), d++);
            else
              d++;
          }
          let m = 0;
          for (const w of g)
            w.offset -= m, !(w.offset == i || w.offset == a) && (this.mergeAttributes(w).isEqual(w) || (m++, a--));
          return it._createFromParentsAndOffsets(t, i, t, a);
        }
        _wrapRange(t, i) {
          const { start: a, end: l } = this._breakAttributesRange(t, !0), d = a.parent, g = this._wrapChildren(d, a.offset, l.offset, i), m = this.mergeAttributes(g.start);
          m.isEqual(g.start) || g.end.offset--;
          const w = this.mergeAttributes(g.end);
          return new it(m, w);
        }
        _wrapPosition(t, i) {
          if (i.isSimilar(t.parent))
            return i_(t.clone());
          t.parent.is("$text") && (t = Qm(t));
          const a = this.createAttributeElement("_wrapPosition-fake-element");
          a._priority = Number.POSITIVE_INFINITY, a.isSimilar = () => !1, t.parent._insertChild(t.offset, a);
          const l = new it(t, t.getShiftedBy(1));
          this.wrap(l, i);
          const d = new $e(a.parent, a.index);
          a._remove();
          const g = d.nodeBefore, m = d.nodeAfter;
          return g instanceof Xt && m instanceof Xt ? o_(g, m) : i_(d);
        }
        _wrapAttributeElement(t, i) {
          if (!s_(t, i) || t.name !== i.name || t.priority !== i.priority)
            return !1;
          for (const a of t.getAttributeKeys())
            if (a !== "class" && a !== "style" && i.hasAttribute(a) && i.getAttribute(a) !== t.getAttribute(a))
              return !1;
          for (const a of t.getStyleNames())
            if (i.hasStyle(a) && i.getStyle(a) !== t.getStyle(a))
              return !1;
          for (const a of t.getAttributeKeys())
            a !== "class" && a !== "style" && (i.hasAttribute(a) || this.setAttribute(a, t.getAttribute(a), i));
          for (const a of t.getStyleNames())
            i.hasStyle(a) || this.setStyle(a, t.getStyle(a), i);
          for (const a of t.getClassNames())
            i.hasClass(a) || this.addClass(a, i);
          return !0;
        }
        _unwrapAttributeElement(t, i) {
          if (!s_(t, i) || t.name !== i.name || t.priority !== i.priority)
            return !1;
          for (const a of t.getAttributeKeys())
            if (a !== "class" && a !== "style" && (!i.hasAttribute(a) || i.getAttribute(a) !== t.getAttribute(a)))
              return !1;
          if (!i.hasClass(...t.getClassNames()))
            return !1;
          for (const a of t.getStyleNames())
            if (!i.hasStyle(a) || i.getStyle(a) !== t.getStyle(a))
              return !1;
          for (const a of t.getAttributeKeys())
            a !== "class" && a !== "style" && this.removeAttribute(a, i);
          return this.removeClass(Array.from(t.getClassNames()), i), this.removeStyle(Array.from(t.getStyleNames()), i), !0;
        }
        _breakAttributesRange(t, i = !1) {
          const a = t.start, l = t.end;
          if (nu(t, this.document), t.isCollapsed) {
            const w = this._breakAttributes(t.start, i);
            return new it(w, w);
          }
          const d = this._breakAttributes(l, i), g = d.parent.childCount, m = this._breakAttributes(a, i);
          return d.offset += d.parent.childCount - g, new it(m, d);
        }
        _breakAttributes(t, i = !1) {
          const a = t.offset, l = t.parent;
          if (t.parent.is("emptyElement"))
            throw new S("view-writer-cannot-break-empty-element", this.document);
          if (t.parent.is("uiElement"))
            throw new S("view-writer-cannot-break-ui-element", this.document);
          if (t.parent.is("rawElement"))
            throw new S("view-writer-cannot-break-raw-element", this.document);
          if (!i && l.is("$text") && Zm(l.parent) || Zm(l))
            return t.clone();
          if (l.is("$text"))
            return this._breakAttributes(Qm(t), i);
          if (a == l.childCount) {
            const d = new $e(l.parent, l.index + 1);
            return this._breakAttributes(d, i);
          }
          if (a === 0) {
            const d = new $e(l.parent, l.index);
            return this._breakAttributes(d, i);
          }
          {
            const d = l.index + 1, g = l._clone();
            l.parent._insertChild(d, g), this._addToClonedElementsGroup(g);
            const m = l.childCount - a, w = l._removeChildren(a, m);
            g._appendChild(w);
            const A = new $e(l.parent, d);
            return this._breakAttributes(A, i);
          }
        }
        _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement"))
            return;
          if (t.is("element"))
            for (const l of t.getChildren())
              this._addToClonedElementsGroup(l);
          const i = t.id;
          if (!i)
            return;
          let a = this._cloneGroups.get(i);
          a || (a = /* @__PURE__ */ new Set(), this._cloneGroups.set(i, a)), a.add(t), t._clonesGroup = a;
        }
        _removeFromClonedElementsGroup(t) {
          if (t.is("element"))
            for (const l of t.getChildren())
              this._removeFromClonedElementsGroup(l);
          const i = t.id;
          if (!i)
            return;
          const a = this._cloneGroups.get(i);
          a && a.delete(t);
        }
      }
      function Ym(c) {
        let t = c.parent;
        for (; !Zm(t); ) {
          if (!t)
            return;
          t = t.parent;
        }
        return t;
      }
      function $R(c, t) {
        return c.priority < t.priority || !(c.priority > t.priority) && c.getIdentity() < t.getIdentity();
      }
      function i_(c) {
        const t = c.nodeBefore;
        if (t && t.is("$text"))
          return new $e(t, t.data.length);
        const i = c.nodeAfter;
        return i && i.is("$text") ? new $e(i, 0) : c;
      }
      function Qm(c) {
        if (c.offset == c.parent.data.length)
          return new $e(c.parent.parent, c.parent.index + 1);
        if (c.offset === 0)
          return new $e(c.parent.parent, c.parent.index);
        const t = c.parent.data.slice(c.offset);
        return c.parent._data = c.parent.data.slice(0, c.offset), c.parent.parent._insertChild(c.parent.index + 1, new Xt(c.root.document, t)), new $e(c.parent.parent, c.parent.index + 1);
      }
      function o_(c, t) {
        const i = c.data.length;
        return c._data += t.data, t._remove(), new $e(c, i);
      }
      const LR = [Xt, ns, eu, qm, Km, vh];
      function a_(c, t) {
        for (const i of c) {
          if (!LR.some((a) => i instanceof a))
            throw new S("view-writer-insert-invalid-node-type", t);
          i.is("$text") || a_(i.getChildren(), t);
        }
      }
      function Zm(c) {
        return c && (c.is("containerElement") || c.is("documentFragment"));
      }
      function nu(c, t) {
        const i = Ym(c.start), a = Ym(c.end);
        if (!i || !a || i !== a)
          throw new S("view-writer-invalid-range-container", t);
      }
      function s_(c, t) {
        return c.id === null && t.id === null;
      }
      const l_ = (c) => c.createTextNode("\xA0"), c_ = (c) => {
        const t = c.createElement("span");
        return t.dataset.ckeFiller = "true", t.innerText = "\xA0", t;
      }, u_ = (c) => {
        const t = c.createElement("br");
        return t.dataset.ckeFiller = "true", t;
      }, bh = "\u2060".repeat(7);
      function Or(c) {
        return Dn(c) && c.data.substr(0, 7) === bh;
      }
      function ru(c) {
        return c.data.length == 7 && Or(c);
      }
      function d_(c) {
        return Or(c) ? c.data.slice(7) : c.data;
      }
      function jR(c, t) {
        if (t.keyCode == St.arrowleft) {
          const i = t.domTarget.ownerDocument.defaultView.getSelection();
          if (i.rangeCount == 1 && i.getRangeAt(0).collapsed) {
            const a = i.getRangeAt(0).startContainer, l = i.getRangeAt(0).startOffset;
            Or(a) && l <= 7 && i.collapse(a, 0);
          }
        }
      }
      var h_ = s(9315), BR = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(h_.Z, BR), h_.Z.locals;
      class FR extends Te() {
        constructor(t, i) {
          super(), this.domDocuments = /* @__PURE__ */ new Set(), this.domConverter = t, this.markedAttributes = /* @__PURE__ */ new Set(), this.markedChildren = /* @__PURE__ */ new Set(), this.markedTexts = /* @__PURE__ */ new Set(), this.selection = i, this.set("isFocused", !1), this.set("_isFocusChanging", !1), this.set("isSelecting", !1), p.isBlink && !p.isAndroid && this.on("change:isSelecting", () => {
            this.isSelecting || this.render();
          }), this.set("isComposing", !1), this.on("change:isComposing", () => {
            this.isComposing || this.render();
          }), this._inlineFiller = null, this._fakeSelectionContainer = null;
        }
        markToSync(t, i) {
          if (t === "text")
            this.domConverter.mapViewToDom(i.parent) && this.markedTexts.add(i);
          else {
            if (!this.domConverter.mapViewToDom(i))
              return;
            if (t === "attributes")
              this.markedAttributes.add(i);
            else {
              if (t !== "children")
                throw new S("view-renderer-unknown-type", this);
              this.markedChildren.add(i);
            }
          }
        }
        render() {
          if (this.isComposing && !p.isAndroid)
            return;
          let t = null;
          const i = !(p.isBlink && !p.isAndroid) || !this.isSelecting;
          for (const a of this.markedChildren)
            this._updateChildrenMappings(a);
          i ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t = this.domConverter.domPositionToView(this._inlineFiller), t && t.parent.is("$text") && (t = $e._createBefore(t.parent)));
          for (const a of this.markedAttributes)
            this._updateAttrs(a);
          for (const a of this.markedChildren)
            this._updateChildren(a, { inlineFillerPosition: t });
          for (const a of this.markedTexts)
            !this.markedChildren.has(a.parent) && this.domConverter.mapViewToDom(a.parent) && this._updateText(a, { inlineFillerPosition: t });
          if (i)
            if (t) {
              const a = this.domConverter.viewPositionToDom(t), l = a.parent.ownerDocument;
              Or(a.parent) ? this._inlineFiller = a.parent : this._inlineFiller = f_(l, a.parent, a.offset);
            } else
              this._inlineFiller = null;
          this._updateFocus(), this._updateSelection(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
        _updateChildrenMappings(t) {
          if (!this.domConverter.mapViewToDom(t))
            return;
          const i = Array.from(this.domConverter.mapViewToDom(t).childNodes), a = Array.from(this.domConverter.viewChildrenToDom(t, { withChildren: !1 })), l = this._diffNodeLists(i, a), d = this._findReplaceActions(l, i, a);
          if (d.indexOf("replace") !== -1) {
            const g = { equal: 0, insert: 0, delete: 0 };
            for (const m of d)
              if (m === "replace") {
                const w = g.equal + g.insert, A = g.equal + g.delete, C = t.getChild(w);
                !C || C.is("uiElement") || C.is("rawElement") || this._updateElementMappings(C, i[A]), Ek(a[w]), g.equal++;
              } else
                g[m]++;
          }
        }
        _updateElementMappings(t, i) {
          this.domConverter.unbindDomElement(i), this.domConverter.bindElements(i, t), this.markedChildren.add(t), this.markedAttributes.add(t);
        }
        _getInlineFillerPosition() {
          const t = this.selection.getFirstPosition();
          return t.parent.is("$text") ? $e._createBefore(t.parent) : t;
        }
        _isSelectionInInlineFiller() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
            return !1;
          const t = this.selection.getFirstPosition(), i = this.domConverter.viewPositionToDom(t);
          return !!(i && Dn(i.parent) && Or(i.parent));
        }
        _removeInlineFiller() {
          const t = this._inlineFiller;
          if (!Or(t))
            throw new S("view-renderer-filler-was-lost", this);
          ru(t) ? t.remove() : t.data = t.data.substr(7), this._inlineFiller = null;
        }
        _needsInlineFillerAtSelection() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed)
            return !1;
          const t = this.selection.getFirstPosition(), i = t.parent, a = t.offset;
          if (!this.domConverter.mapViewToDom(i.root) || !i.is("element") || !function(g) {
            if (g.getAttribute("contenteditable") == "false")
              return !1;
            const m = g.findAncestor((w) => w.hasAttribute("contenteditable"));
            return !m || m.getAttribute("contenteditable") == "true";
          }(i) || a === i.getFillerOffset())
            return !1;
          const l = t.nodeBefore, d = t.nodeAfter;
          return !(l instanceof Xt || d instanceof Xt) && (!p.isAndroid || !l && !d);
        }
        _updateText(t, i) {
          const a = this.domConverter.findCorrespondingDomText(t);
          let l = this.domConverter.viewToDom(t).data;
          const d = i.inlineFillerPosition;
          d && d.parent == t.parent && d.offset == t.index && (l = bh + l), m_(a, l);
        }
        _updateAttrs(t) {
          const i = this.domConverter.mapViewToDom(t);
          if (!i)
            return;
          const a = Array.from(i.attributes).map((d) => d.name), l = t.getAttributeKeys();
          for (const d of l)
            this.domConverter.setDomElementAttribute(i, d, t.getAttribute(d), t);
          for (const d of a)
            t.hasAttribute(d) || this.domConverter.removeDomElementAttribute(i, d);
        }
        _updateChildren(t, i) {
          const a = this.domConverter.mapViewToDom(t);
          if (!a)
            return;
          if (p.isAndroid) {
            let T = null;
            for (const R of Array.from(a.childNodes)) {
              if (T && Dn(T) && Dn(R)) {
                a.normalize();
                break;
              }
              T = R;
            }
          }
          const l = i.inlineFillerPosition, d = a.childNodes, g = Array.from(this.domConverter.viewChildrenToDom(t, { bind: !0 }));
          l && l.parent === t && f_(a.ownerDocument, g, l.offset);
          const m = this._diffNodeLists(d, g), w = p.isAndroid ? this._findReplaceActions(m, d, g, { replaceText: !0 }) : m;
          let A = 0;
          const C = /* @__PURE__ */ new Set();
          for (const T of w)
            T === "delete" ? (C.add(d[A]), Ek(d[A])) : T !== "equal" && T !== "replace" || A++;
          A = 0;
          for (const T of w)
            T === "insert" ? (Ak(a, A, g[A]), A++) : T === "replace" ? (m_(d[A], g[A].data), A++) : T === "equal" && (this._markDescendantTextToSync(this.domConverter.domToView(g[A])), A++);
          for (const T of C)
            T.parentNode || this.domConverter.unbindDomElement(T);
        }
        _diffNodeLists(t, i) {
          return t = function(a, l) {
            const d = Array.from(a);
            return d.length == 0 || !l || d[d.length - 1] == l && d.pop(), d;
          }(t, this._fakeSelectionContainer), _(t, i, zR.bind(null, this.domConverter));
        }
        _findReplaceActions(t, i, a, l = {}) {
          if (t.indexOf("insert") === -1 || t.indexOf("delete") === -1)
            return t;
          let d = [], g = [], m = [];
          const w = { equal: 0, insert: 0, delete: 0 };
          for (const A of t)
            A === "insert" ? m.push(a[w.equal + w.insert]) : A === "delete" ? g.push(i[w.equal + w.delete]) : (d = d.concat(_(g, m, l.replaceText ? g_ : p_).map((C) => C === "equal" ? "replace" : C)), d.push("equal"), g = [], m = []), w[A]++;
          return d.concat(_(g, m, l.replaceText ? g_ : p_).map((A) => A === "equal" ? "replace" : A));
        }
        _markDescendantTextToSync(t) {
          if (t) {
            if (t.is("$text"))
              this.markedTexts.add(t);
            else if (t.is("element"))
              for (const i of t.getChildren())
                this._markDescendantTextToSync(i);
          }
        }
        _updateSelection() {
          if (p.isBlink && !p.isAndroid && this.isSelecting && !this.markedChildren.size || this._isFocusChanging)
            return;
          if (this.selection.rangeCount === 0)
            return this._removeDomSelection(), void this._removeFakeSelection();
          const t = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(t)) : this.isComposing && p.isAndroid || this._updateDomSelection(t));
        }
        _updateFakeSelection(t) {
          const i = t.ownerDocument;
          this._fakeSelectionContainer || (this._fakeSelectionContainer = function(g) {
            const m = g.createElement("div");
            return m.className = "ck-fake-selection-container", Object.assign(m.style, { position: "fixed", top: 0, left: "-9999px", width: "42px" }), m.textContent = "\xA0", m;
          }(i));
          const a = this._fakeSelectionContainer;
          if (this.domConverter.bindFakeSelection(a, this.selection), !this._fakeSelectionNeedsUpdate(t))
            return;
          a.parentElement && a.parentElement == t || t.appendChild(a), a.textContent = this.selection.fakeSelectionLabel || "\xA0";
          const l = i.getSelection(), d = i.createRange();
          l.removeAllRanges(), d.selectNodeContents(a), l.addRange(d);
        }
        _updateDomSelection(t) {
          const i = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(i))
            return;
          const a = this.domConverter.viewPositionToDom(this.selection.anchor), l = this.domConverter.viewPositionToDom(this.selection.focus);
          i.collapse(a.parent, a.offset), i.extend(l.parent, l.offset), p.isGecko && function(d, g) {
            const m = d.parent;
            if (m.nodeType != Node.ELEMENT_NODE || d.offset != m.childNodes.length - 1)
              return;
            const w = m.childNodes[d.offset];
            w && w.tagName == "BR" && g.addRange(g.getRangeAt(0));
          }(l, i);
        }
        _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t))
            return !0;
          const i = t && this.domConverter.domSelectionToView(t);
          return (!i || !this.selection.isEqual(i)) && !(!this.selection.isCollapsed && this.selection.isSimilar(i));
        }
        _fakeSelectionNeedsUpdate(t) {
          const i = this._fakeSelectionContainer, a = t.ownerDocument.getSelection();
          return !i || i.parentElement !== t || a.anchorNode !== i && !i.contains(a.anchorNode) || i.textContent !== this.selection.fakeSelectionLabel;
        }
        _removeDomSelection() {
          for (const t of this.domDocuments) {
            const i = t.getSelection();
            if (i.rangeCount) {
              const a = t.activeElement, l = this.domConverter.mapDomToView(a);
              a && l && i.removeAllRanges();
            }
          }
        }
        _removeFakeSelection() {
          const t = this._fakeSelectionContainer;
          t && t.remove();
        }
        _updateFocus() {
          if (this.isFocused) {
            const t = this.selection.editableElement;
            t && this.domConverter.focus(t);
          }
        }
      }
      function f_(c, t, i) {
        const a = t instanceof Array ? t : t.childNodes, l = a[i];
        if (Dn(l))
          return l.data = bh + l.data, l;
        {
          const d = c.createTextNode(bh);
          return Array.isArray(t) ? a.splice(i, 0, d) : Ak(t, i, d), d;
        }
      }
      function p_(c, t) {
        return Kn(c) && Kn(t) && !Dn(c) && !Dn(t) && !dl(c) && !dl(t) && c.tagName.toLowerCase() === t.tagName.toLowerCase();
      }
      function g_(c, t) {
        return Kn(c) && Kn(t) && Dn(c) && Dn(t);
      }
      function zR(c, t, i) {
        return t === i || (Dn(t) && Dn(i) ? t.data === i.data : !(!c.isBlockFiller(t) || !c.isBlockFiller(i)));
      }
      function m_(c, t) {
        const i = c.data;
        if (i == t)
          return;
        const a = b(i, t);
        for (const l of a)
          l.type === "insert" ? c.insertData(l.index, l.values.join("")) : c.deleteData(l.index, l.howMany);
      }
      const VR = u_(yt.document), HR = l_(yt.document), UR = c_(yt.document), wh = "data-ck-unsafe-attribute-", v_ = "data-ck-unsafe-element";
      class yh {
        constructor(t, i = {}) {
          this.document = t, this.renderingMode = i.renderingMode || "editing", this.blockFillerMode = i.blockFillerMode || (this.renderingMode === "editing" ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = this.renderingMode === "editing" ? yt.document : yt.document.implementation.createHTMLDocument(""), this._domToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToDomMapping = /* @__PURE__ */ new WeakMap(), this._fakeSelectionMapping = /* @__PURE__ */ new WeakMap(), this._rawContentElementMatcher = new Ji(), this._encounteredRawContentDomNodes = /* @__PURE__ */ new WeakSet();
        }
        bindFakeSelection(t, i) {
          this._fakeSelectionMapping.set(t, new eo(i));
        }
        fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
        bindElements(t, i) {
          this._domToViewMapping.set(t, i), this._viewToDomMapping.set(i, t);
        }
        unbindDomElement(t) {
          const i = this._domToViewMapping.get(t);
          if (i) {
            this._domToViewMapping.delete(t), this._viewToDomMapping.delete(i);
            for (const a of Array.from(t.children))
              this.unbindDomElement(a);
          }
        }
        bindDocumentFragments(t, i) {
          this._domToViewMapping.set(t, i), this._viewToDomMapping.set(i, t);
        }
        shouldRenderAttribute(t, i, a) {
          return this.renderingMode === "data" || !(t = t.toLowerCase()).startsWith("on") && (t !== "srcdoc" || !i.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && (a === "img" && (t === "src" || t === "srcset") || a === "source" && t === "srcset" || !i.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
        }
        setContentOf(t, i) {
          if (this.renderingMode === "data")
            return void (t.innerHTML = i);
          const a = new DOMParser().parseFromString(i, "text/html"), l = a.createDocumentFragment(), d = a.body.childNodes;
          for (; d.length > 0; )
            l.appendChild(d[0]);
          const g = a.createTreeWalker(l, NodeFilter.SHOW_ELEMENT), m = [];
          let w;
          for (; w = g.nextNode(); )
            m.push(w);
          for (const A of m) {
            for (const T of A.getAttributeNames())
              this.setDomElementAttribute(A, T, A.getAttribute(T));
            const C = A.tagName.toLowerCase();
            this._shouldRenameElement(C) && (y_(C), A.replaceWith(this._createReplacementDomElement(C, A)));
          }
          for (; t.firstChild; )
            t.firstChild.remove();
          t.append(l);
        }
        viewToDom(t, i = {}) {
          if (t.is("$text")) {
            const a = this._processDataFromViewText(t);
            return this._domDocument.createTextNode(a);
          }
          {
            if (this.mapViewToDom(t))
              return this.mapViewToDom(t);
            let a;
            if (t.is("documentFragment"))
              a = this._domDocument.createDocumentFragment(), i.bind && this.bindDocumentFragments(a, t);
            else {
              if (t.is("uiElement"))
                return a = t.name === "$comment" ? this._domDocument.createComment(t.getCustomProperty("$rawContent")) : t.render(this._domDocument, this), i.bind && this.bindElements(a, t), a;
              this._shouldRenameElement(t.name) ? (y_(t.name), a = this._createReplacementDomElement(t.name)) : a = t.hasAttribute("xmlns") ? this._domDocument.createElementNS(t.getAttribute("xmlns"), t.name) : this._domDocument.createElement(t.name), t.is("rawElement") && t.render(a, this), i.bind && this.bindElements(a, t);
              for (const l of t.getAttributeKeys())
                this.setDomElementAttribute(a, l, t.getAttribute(l), t);
            }
            if (i.withChildren !== !1)
              for (const l of this.viewChildrenToDom(t, i))
                a.appendChild(l);
            return a;
          }
        }
        setDomElementAttribute(t, i, a, l) {
          const d = this.shouldRenderAttribute(i, a, t.tagName.toLowerCase()) || l && l.shouldRenderUnsafeAttribute(i);
          d || $("domconverter-unsafe-attribute-detected", { domElement: t, key: i, value: a }), t.hasAttribute(i) && !d ? t.removeAttribute(i) : t.hasAttribute(wh + i) && d && t.removeAttribute(wh + i), t.setAttribute(d ? i : wh + i, a);
        }
        removeDomElementAttribute(t, i) {
          i != v_ && (t.removeAttribute(i), t.removeAttribute(wh + i));
        }
        *viewChildrenToDom(t, i = {}) {
          const a = t.getFillerOffset && t.getFillerOffset();
          let l = 0;
          for (const d of t.getChildren()) {
            a === l && (yield this._getBlockFiller());
            const g = d.is("element") && d.getCustomProperty("dataPipeline:transparentRendering");
            g && this.renderingMode == "data" ? yield* this.viewChildrenToDom(d, i) : (g && $("domconverter-transparent-rendering-unsupported-in-editing-pipeline", { viewElement: d }), yield this.viewToDom(d, i)), l++;
          }
          a === l && (yield this._getBlockFiller());
        }
        viewRangeToDom(t) {
          const i = this.viewPositionToDom(t.start), a = this.viewPositionToDom(t.end), l = this._domDocument.createRange();
          return l.setStart(i.parent, i.offset), l.setEnd(a.parent, a.offset), l;
        }
        viewPositionToDom(t) {
          const i = t.parent;
          if (i.is("$text")) {
            const a = this.findCorrespondingDomText(i);
            if (!a)
              return null;
            let l = t.offset;
            return Or(a) && (l += 7), { parent: a, offset: l };
          }
          {
            let a, l, d;
            if (t.offset === 0) {
              if (a = this.mapViewToDom(i), !a)
                return null;
              d = a.childNodes[0];
            } else {
              const g = t.nodeBefore;
              if (l = g.is("$text") ? this.findCorrespondingDomText(g) : this.mapViewToDom(g), !l)
                return null;
              a = l.parentNode, d = l.nextSibling;
            }
            return Dn(d) && Or(d) ? { parent: d, offset: 7 } : { parent: a, offset: l ? ch(l) + 1 : 0 };
          }
        }
        domToView(t, i = {}) {
          if (this.isBlockFiller(t))
            return null;
          const a = this.getHostViewElement(t);
          if (a)
            return a;
          if (dl(t) && i.skipComments)
            return null;
          if (Dn(t)) {
            if (ru(t))
              return null;
            {
              const l = this._processDataFromDomText(t);
              return l === "" ? null : new Xt(this.document, l);
            }
          }
          {
            if (this.mapDomToView(t))
              return this.mapDomToView(t);
            let l;
            if (this.isDocumentFragment(t))
              l = new rs(this.document), i.bind && this.bindDocumentFragments(t, l);
            else {
              l = this._createViewElement(t, i), i.bind && this.bindElements(t, l);
              const d = t.attributes;
              if (d)
                for (let g = d.length, m = 0; m < g; m++)
                  l._setAttribute(d[m].name, d[m].value);
              if (this._isViewElementWithRawContent(l, i) || dl(t)) {
                const g = dl(t) ? t.data : t.innerHTML;
                return l._setCustomProperty("$rawContent", g), this._encounteredRawContentDomNodes.add(t), l;
              }
            }
            if (i.withChildren !== !1)
              for (const d of this.domChildrenToView(t, i))
                l._appendChild(d);
            return l;
          }
        }
        *domChildrenToView(t, i) {
          for (let a = 0; a < t.childNodes.length; a++) {
            const l = t.childNodes[a], d = this.domToView(l, i);
            d !== null && (yield d);
          }
        }
        domSelectionToView(t) {
          if (t.rangeCount === 1) {
            let l = t.getRangeAt(0).startContainer;
            Dn(l) && (l = l.parentNode);
            const d = this.fakeSelectionToView(l);
            if (d)
              return d;
          }
          const i = this.isDomSelectionBackward(t), a = [];
          for (let l = 0; l < t.rangeCount; l++) {
            const d = t.getRangeAt(l), g = this.domRangeToView(d);
            g && a.push(g);
          }
          return new eo(a, { backward: i });
        }
        domRangeToView(t) {
          const i = this.domPositionToView(t.startContainer, t.startOffset), a = this.domPositionToView(t.endContainer, t.endOffset);
          return i && a ? new it(i, a) : null;
        }
        domPositionToView(t, i = 0) {
          if (this.isBlockFiller(t))
            return this.domPositionToView(t.parentNode, ch(t));
          const a = this.mapDomToView(t);
          if (a && (a.is("uiElement") || a.is("rawElement")))
            return $e._createBefore(a);
          if (Dn(t)) {
            if (ru(t))
              return this.domPositionToView(t.parentNode, ch(t));
            const l = this.findCorrespondingViewText(t);
            let d = i;
            return l ? (Or(t) && (d -= 7, d = d < 0 ? 0 : d), new $e(l, d)) : null;
          }
          if (i === 0) {
            const l = this.mapDomToView(t);
            if (l)
              return new $e(l, 0);
          } else {
            const l = t.childNodes[i - 1];
            if (Dn(l) && ru(l))
              return this.domPositionToView(l.parentNode, ch(l));
            const d = Dn(l) ? this.findCorrespondingViewText(l) : this.mapDomToView(l);
            if (d && d.parent)
              return new $e(d.parent, d.index + 1);
          }
          return null;
        }
        mapDomToView(t) {
          return this.getHostViewElement(t) || this._domToViewMapping.get(t);
        }
        findCorrespondingViewText(t) {
          if (ru(t))
            return null;
          const i = this.getHostViewElement(t);
          if (i)
            return i;
          const a = t.previousSibling;
          if (a) {
            if (!this.isElement(a))
              return null;
            const l = this.mapDomToView(a);
            if (l) {
              const d = l.nextSibling;
              return d instanceof Xt ? d : null;
            }
          } else {
            const l = this.mapDomToView(t.parentNode);
            if (l) {
              const d = l.getChild(0);
              return d instanceof Xt ? d : null;
            }
          }
          return null;
        }
        mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
        findCorrespondingDomText(t) {
          const i = t.previousSibling;
          return i && this.mapViewToDom(i) ? this.mapViewToDom(i).nextSibling : !i && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
        }
        focus(t) {
          const i = this.mapViewToDom(t);
          if (i && i.ownerDocument.activeElement !== i) {
            const { scrollX: a, scrollY: l } = yt.window, d = [];
            b_(i, (g) => {
              const { scrollLeft: m, scrollTop: w } = g;
              d.push([m, w]);
            }), i.focus(), b_(i, (g) => {
              const [m, w] = d.shift();
              g.scrollLeft = m, g.scrollTop = w;
            }), yt.window.scrollTo(a, l);
          }
        }
        isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
        isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
        isBlockFiller(t) {
          return this.blockFillerMode == "br" ? t.isEqualNode(VR) : !(t.tagName !== "BR" || !w_(t, this.blockElements) || t.parentNode.childNodes.length !== 1) || t.isEqualNode(UR) || function(i, a) {
            return i.isEqualNode(HR) && w_(i, a) && i.parentNode.childNodes.length === 1;
          }(t, this.blockElements);
        }
        isDomSelectionBackward(t) {
          if (t.isCollapsed)
            return !1;
          const i = this._domDocument.createRange();
          try {
            i.setStart(t.anchorNode, t.anchorOffset), i.setEnd(t.focusNode, t.focusOffset);
          } catch {
            return !1;
          }
          const a = i.collapsed;
          return i.detach(), a;
        }
        getHostViewElement(t) {
          const i = bk(t);
          for (i.pop(); i.length; ) {
            const a = i.pop(), l = this._domToViewMapping.get(a);
            if (l && (l.is("uiElement") || l.is("rawElement")))
              return l;
          }
          return null;
        }
        isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
        registerRawContentMatcher(t) {
          this._rawContentElementMatcher.add(t);
        }
        _getBlockFiller() {
          switch (this.blockFillerMode) {
            case "nbsp":
              return l_(this._domDocument);
            case "markedNbsp":
              return c_(this._domDocument);
            case "br":
              return u_(this._domDocument);
          }
        }
        _isDomSelectionPositionCorrect(t, i) {
          if (Dn(t) && Or(t) && i < 7 || this.isElement(t) && Or(t.childNodes[i]))
            return !1;
          const a = this.mapDomToView(t);
          return !a || !a.is("uiElement") && !a.is("rawElement");
        }
        _processDataFromViewText(t) {
          let i = t.data;
          if (t.getAncestors().some((a) => this.preElements.includes(a.name)))
            return i;
          if (i.charAt(0) == " ") {
            const a = this._getTouchingInlineViewNode(t, !1);
            !(a && a.is("$textProxy") && this._nodeEndsWithSpace(a)) && a || (i = "\xA0" + i.substr(1));
          }
          if (i.charAt(i.length - 1) == " ") {
            const a = this._getTouchingInlineViewNode(t, !0), l = a && a.is("$textProxy") && a.data.charAt(0) == " ";
            i.charAt(i.length - 2) != " " && a && !l || (i = i.substr(0, i.length - 1) + "\xA0");
          }
          return i.replace(/ {2}/g, " \xA0");
        }
        _nodeEndsWithSpace(t) {
          if (t.getAncestors().some((a) => this.preElements.includes(a.name)))
            return !1;
          const i = this._processDataFromViewText(t);
          return i.charAt(i.length - 1) == " ";
        }
        _processDataFromDomText(t) {
          let i = t.data;
          if (function(A, C) {
            return bk(A).some((R) => R.tagName && C.includes(R.tagName.toLowerCase()));
          }(t, this.preElements))
            return d_(t);
          i = i.replace(/[ \n\t\r]{1,}/g, " ");
          const a = this._getTouchingInlineDomNode(t, !1), l = this._getTouchingInlineDomNode(t, !0), d = this._checkShouldLeftTrimDomText(t, a), g = this._checkShouldRightTrimDomText(t, l);
          d && (i = i.replace(/^ /, "")), g && (i = i.replace(/ $/, "")), i = d_(new Text(i)), i = i.replace(/ \u00A0/g, "  ");
          const m = l && this.isElement(l) && l.tagName != "BR", w = l && Dn(l) && l.data.charAt(0) == " ";
          return (/( |\u00A0)\u00A0$/.test(i) || !l || m || w) && (i = i.replace(/\u00A0$/, " ")), (d || a && this.isElement(a) && a.tagName != "BR") && (i = i.replace(/^\u00A0/, " ")), i;
        }
        _checkShouldLeftTrimDomText(t, i) {
          return !i || (this.isElement(i) ? i.tagName === "BR" : !this._encounteredRawContentDomNodes.has(t.previousSibling) && /[^\S\u00A0]/.test(i.data.charAt(i.data.length - 1)));
        }
        _checkShouldRightTrimDomText(t, i) {
          return !i && !Or(t);
        }
        _getTouchingInlineViewNode(t, i) {
          const a = new ts({ startPosition: i ? $e._createAfter(t) : $e._createBefore(t), direction: i ? "forward" : "backward" });
          for (const l of a) {
            if (l.item.is("element") && this.inlineObjectElements.includes(l.item.name))
              return l.item;
            if (l.item.is("containerElement") || l.item.is("element", "br"))
              return null;
            if (l.item.is("$textProxy"))
              return l.item;
          }
          return null;
        }
        _getTouchingInlineDomNode(t, i) {
          if (!t.parentNode)
            return null;
          const a = i ? "firstChild" : "lastChild", l = i ? "nextSibling" : "previousSibling";
          let d = !0, g = t;
          do
            if (!d && g[a] ? g = g[a] : g[l] ? (g = g[l], d = !1) : (g = g.parentNode, d = !0), !g || this._isBlockElement(g))
              return null;
          while (!Dn(g) && g.tagName != "BR" && !this._isInlineObjectElement(g));
          return g;
        }
        _isBlockElement(t) {
          return this.isElement(t) && this.blockElements.includes(t.tagName.toLowerCase());
        }
        _isInlineObjectElement(t) {
          return this.isElement(t) && this.inlineObjectElements.includes(t.tagName.toLowerCase());
        }
        _createViewElement(t, i) {
          if (dl(t))
            return new vh(this.document, "$comment");
          const a = i.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
          return new Pr(this.document, a);
        }
        _isViewElementWithRawContent(t, i) {
          return i.withChildren !== !1 && !!this._rawContentElementMatcher.match(t);
        }
        _shouldRenameElement(t) {
          const i = t.toLowerCase();
          return this.renderingMode === "editing" && this.unsafeElements.includes(i);
        }
        _createReplacementDomElement(t, i) {
          const a = this._domDocument.createElement("span");
          if (a.setAttribute(v_, t), i) {
            for (; i.firstChild; )
              a.appendChild(i.firstChild);
            for (const l of i.getAttributeNames())
              a.setAttribute(l, i.getAttribute(l));
          }
          return a;
        }
      }
      function b_(c, t) {
        let i = c;
        for (; i; )
          t(i), i = i.parentElement;
      }
      function w_(c, t) {
        const i = c.parentNode;
        return !!i && !!i.tagName && t.includes(i.tagName.toLowerCase());
      }
      function y_(c) {
        c === "script" && $("domconverter-unsafe-script-element-detected"), c === "style" && $("domconverter-unsafe-style-element-detected");
      }
      class to extends Qa() {
        constructor(t) {
          super(), this.view = t, this.document = t.document, this.isEnabled = !1;
        }
        enable() {
          this.isEnabled = !0;
        }
        disable() {
          this.isEnabled = !1;
        }
        destroy() {
          this.disable(), this.stopListening();
        }
        checkShouldIgnoreEventFromTarget(t) {
          return t && t.nodeType === 3 && (t = t.parentNode), !(!t || t.nodeType !== 1) && t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
        }
      }
      const k_ = Qk(function(c, t) {
        Ao(t, Eo(t), c);
      });
      class gl {
        constructor(t, i, a) {
          this.view = t, this.document = t.document, this.domEvent = i, this.domTarget = i.target, k_(this, a);
        }
        get target() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
        preventDefault() {
          this.domEvent.preventDefault();
        }
        stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }
      class sa extends to {
        constructor(t) {
          super(t), this.useCapture = !1;
        }
        observe(t) {
          (typeof this.domEventType == "string" ? [this.domEventType] : this.domEventType).forEach((i) => {
            this.listenTo(t, i, (a, l) => {
              this.isEnabled && !this.checkShouldIgnoreEventFromTarget(l.target) && this.onDomEvent(l);
            }, { useCapture: this.useCapture });
          });
        }
        fire(t, i, a) {
          this.isEnabled && this.document.fire(t, new gl(this.view, i, a));
        }
      }
      class WR extends sa {
        constructor(t) {
          super(t), this.domEventType = ["keydown", "keyup"];
        }
        onDomEvent(t) {
          const i = { keyCode: t.keyCode, altKey: t.altKey, ctrlKey: t.ctrlKey, shiftKey: t.shiftKey, metaKey: t.metaKey, get keystroke() {
            return hl(this);
          } };
          this.fire(t.type, t, i);
        }
      }
      const Xm = function() {
        return Mn.Date.now();
      };
      var GR = /\s/;
      const qR = function(c) {
        for (var t = c.length; t-- && GR.test(c.charAt(t)); )
          ;
        return t;
      };
      var KR = /^\s+/;
      const YR = function(c) {
        return c && c.slice(0, qR(c) + 1).replace(KR, "");
      };
      var QR = /^[-+]0x[0-9a-f]+$/i, ZR = /^0b[01]+$/i, XR = /^0o[0-7]+$/i, JR = parseInt;
      const __ = function(c) {
        if (typeof c == "number")
          return c;
        if (hh(c))
          return NaN;
        if (me(c)) {
          var t = typeof c.valueOf == "function" ? c.valueOf() : c;
          c = me(t) ? t + "" : t;
        }
        if (typeof c != "string")
          return c === 0 ? c : +c;
        c = YR(c);
        var i = ZR.test(c);
        return i || XR.test(c) ? JR(c.slice(2), i ? 2 : 8) : QR.test(c) ? NaN : +c;
      };
      var eN = Math.max, tN = Math.min;
      const iu = function(c, t, i) {
        var a, l, d, g, m, w, A = 0, C = !1, T = !1, R = !0;
        if (typeof c != "function")
          throw new TypeError("Expected a function");
        function j(be) {
          var Ne = a, Je = l;
          return a = l = void 0, A = be, g = c.apply(Je, Ne);
        }
        function F(be) {
          return A = be, m = setTimeout(W, t), C ? j(be) : g;
        }
        function V(be) {
          var Ne = be - w;
          return w === void 0 || Ne >= t || Ne < 0 || T && be - A >= d;
        }
        function W() {
          var be = Xm();
          if (V(be))
            return ee(be);
          m = setTimeout(W, function(Ne) {
            var Je = t - (Ne - w);
            return T ? tN(Je, d - (Ne - A)) : Je;
          }(be));
        }
        function ee(be) {
          return m = void 0, R && a ? j(be) : (a = l = void 0, g);
        }
        function le() {
          var be = Xm(), Ne = V(be);
          if (a = arguments, l = this, w = be, Ne) {
            if (m === void 0)
              return F(w);
            if (T)
              return clearTimeout(m), m = setTimeout(W, t), j(w);
          }
          return m === void 0 && (m = setTimeout(W, t)), g;
        }
        return t = __(t) || 0, me(i) && (C = !!i.leading, d = (T = "maxWait" in i) ? eN(__(i.maxWait) || 0, t) : d, R = "trailing" in i ? !!i.trailing : R), le.cancel = function() {
          m !== void 0 && clearTimeout(m), A = 0, a = w = l = m = void 0;
        }, le.flush = function() {
          return m === void 0 ? g : ee(Xm());
        }, le;
      };
      class nN extends to {
        constructor(t) {
          super(t), this._fireSelectionChangeDoneDebounced = iu((i) => {
            this.document.fire("selectionChangeDone", i);
          }, 200);
        }
        observe() {
          const t = this.document;
          t.on("arrowKey", (i, a) => {
            t.selection.isFake && this.isEnabled && a.preventDefault();
          }, { context: "$capture" }), t.on("arrowKey", (i, a) => {
            t.selection.isFake && this.isEnabled && this._handleSelectionMove(a.keyCode);
          }, { priority: "lowest" });
        }
        destroy() {
          super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
        }
        _handleSelectionMove(t) {
          const i = this.document.selection, a = new eo(i.getRanges(), { backward: i.isBackward, fake: !1 });
          t != St.arrowleft && t != St.arrowup || a.setTo(a.getFirstPosition()), t != St.arrowright && t != St.arrowdown || a.setTo(a.getLastPosition());
          const l = { oldSelection: i, newSelection: a, domSelection: null };
          this.document.fire("selectionChange", l), this._fireSelectionChangeDoneDebounced(l);
        }
      }
      const rN = function(c) {
        return this.__data__.set(c, "__lodash_hash_undefined__"), this;
      }, iN = function(c) {
        return this.__data__.has(c);
      };
      function kh(c) {
        var t = -1, i = c == null ? 0 : c.length;
        for (this.__data__ = new Xs(); ++t < i; )
          this.add(c[t]);
      }
      kh.prototype.add = kh.prototype.push = rN, kh.prototype.has = iN;
      const oN = kh, aN = function(c, t) {
        for (var i = -1, a = c == null ? 0 : c.length; ++i < a; )
          if (t(c[i], i, c))
            return !0;
        return !1;
      }, sN = function(c, t) {
        return c.has(t);
      }, A_ = function(c, t, i, a, l, d) {
        var g = 1 & i, m = c.length, w = t.length;
        if (m != w && !(g && w > m))
          return !1;
        var A = d.get(c), C = d.get(t);
        if (A && C)
          return A == t && C == c;
        var T = -1, R = !0, j = 2 & i ? new oN() : void 0;
        for (d.set(c, t), d.set(t, c); ++T < m; ) {
          var F = c[T], V = t[T];
          if (a)
            var W = g ? a(V, F, T, t, c, d) : a(F, V, T, c, t, d);
          if (W !== void 0) {
            if (W)
              continue;
            R = !1;
            break;
          }
          if (j) {
            if (!aN(t, function(ee, le) {
              if (!sN(j, le) && (F === ee || l(F, ee, i, a, d)))
                return j.push(le);
            })) {
              R = !1;
              break;
            }
          } else if (F !== V && !l(F, V, i, a, d)) {
            R = !1;
            break;
          }
        }
        return d.delete(c), d.delete(t), R;
      }, lN = function(c) {
        var t = -1, i = Array(c.size);
        return c.forEach(function(a, l) {
          i[++t] = [l, a];
        }), i;
      }, cN = function(c) {
        var t = -1, i = Array(c.size);
        return c.forEach(function(a) {
          i[++t] = a;
        }), i;
      };
      var C_ = Pe ? Pe.prototype : void 0, Jm = C_ ? C_.valueOf : void 0;
      const uN = function(c, t, i, a, l, d, g) {
        switch (i) {
          case "[object DataView]":
            if (c.byteLength != t.byteLength || c.byteOffset != t.byteOffset)
              return !1;
            c = c.buffer, t = t.buffer;
          case "[object ArrayBuffer]":
            return !(c.byteLength != t.byteLength || !d(new Ki(c), new Ki(t)));
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return Wr(+c, +t);
          case "[object Error]":
            return c.name == t.name && c.message == t.message;
          case "[object RegExp]":
          case "[object String]":
            return c == t + "";
          case "[object Map]":
            var m = lN;
          case "[object Set]":
            var w = 1 & a;
            if (m || (m = cN), c.size != t.size && !w)
              return !1;
            var A = g.get(c);
            if (A)
              return A == t;
            a |= 2, g.set(c, t);
            var C = A_(m(c), m(t), a, l, d, g);
            return g.delete(c), C;
          case "[object Symbol]":
            if (Jm)
              return Jm.call(c) == Jm.call(t);
        }
        return !1;
      };
      var dN = Object.prototype.hasOwnProperty;
      const hN = function(c, t, i, a, l, d) {
        var g = 1 & i, m = Qc(c), w = m.length;
        if (w != Qc(t).length && !g)
          return !1;
        for (var A = w; A--; ) {
          var C = m[A];
          if (!(g ? C in t : dN.call(t, C)))
            return !1;
        }
        var T = d.get(c), R = d.get(t);
        if (T && R)
          return T == t && R == c;
        var j = !0;
        d.set(c, t), d.set(t, c);
        for (var F = g; ++A < w; ) {
          var V = c[C = m[A]], W = t[C];
          if (a)
            var ee = g ? a(W, V, C, t, c, d) : a(V, W, C, c, t, d);
          if (!(ee === void 0 ? V === W || l(V, W, i, a, d) : ee)) {
            j = !1;
            break;
          }
          F || (F = C == "constructor");
        }
        if (j && !F) {
          var le = c.constructor, be = t.constructor;
          le == be || !("constructor" in c) || !("constructor" in t) || typeof le == "function" && le instanceof le && typeof be == "function" && be instanceof be || (j = !1);
        }
        return d.delete(c), d.delete(t), j;
      };
      var x_ = "[object Arguments]", E_ = "[object Array]", _h = "[object Object]", S_ = Object.prototype.hasOwnProperty;
      const fN = function(c, t, i, a, l, d) {
        var g = Zt(c), m = Zt(t), w = g ? E_ : ia(c), A = m ? E_ : ia(t), C = (w = w == x_ ? _h : w) == _h, T = (A = A == x_ ? _h : A) == _h, R = w == A;
        if (R && Ga(c)) {
          if (!Ga(t))
            return !1;
          g = !0, C = !1;
        }
        if (R && !C)
          return d || (d = new Wa()), g || nl(c) ? A_(c, t, i, a, l, d) : uN(c, t, w, i, a, l, d);
        if (!(1 & i)) {
          var j = C && S_.call(c, "__wrapped__"), F = T && S_.call(t, "__wrapped__");
          if (j || F) {
            var V = j ? c.value() : c, W = F ? t.value() : t;
            return d || (d = new Wa()), l(V, W, i, a, d);
          }
        }
        return !!R && (d || (d = new Wa()), hN(c, t, i, a, l, d));
      }, M_ = function c(t, i, a, l, d) {
        return t === i || (t == null || i == null || !vn(t) && !vn(i) ? t != t && i != i : fN(t, i, a, l, c, d));
      }, pN = function(c, t, i) {
        var a = (i = typeof i == "function" ? i : void 0) ? i(c, t) : void 0;
        return a === void 0 ? M_(c, t, void 0, i) : !!a;
      };
      class T_ extends to {
        constructor(t) {
          super(t), this._config = { childList: !0, characterData: !0, subtree: !0 }, this.domConverter = t.domConverter, this.renderer = t._renderer, this._domElements = [], this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
        }
        flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
        observe(t) {
          this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
        }
        enable() {
          super.enable();
          for (const t of this._domElements)
            this._mutationObserver.observe(t, this._config);
        }
        disable() {
          super.disable(), this._mutationObserver.disconnect();
        }
        destroy() {
          super.destroy(), this._mutationObserver.disconnect();
        }
        _onMutations(t) {
          if (t.length === 0)
            return;
          const i = this.domConverter, a = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
          for (const g of t) {
            const m = i.mapDomToView(g.target);
            m && (m.is("uiElement") || m.is("rawElement") || g.type !== "childList" || this._isBogusBrMutation(g) || l.add(m));
          }
          for (const g of t) {
            const m = i.mapDomToView(g.target);
            if ((!m || !m.is("uiElement") && !m.is("rawElement")) && g.type === "characterData") {
              const w = i.findCorrespondingViewText(g.target);
              w && !l.has(w.parent) ? a.add(w) : !w && Or(g.target) && l.add(i.mapDomToView(g.target.parentNode));
            }
          }
          let d = !1;
          for (const g of a)
            d = !0, this.renderer.markToSync("text", g);
          for (const g of l) {
            const m = i.mapViewToDom(g), w = Array.from(g.getChildren()), A = Array.from(i.domChildrenToView(m, { withChildren: !1 }));
            pN(w, A, gN) || (d = !0, this.renderer.markToSync("children", g));
          }
          d && this.view.forceRender();
        }
        _isBogusBrMutation(t) {
          let i = null;
          return t.nextSibling === null && t.removedNodes.length === 0 && t.addedNodes.length == 1 && (i = this.domConverter.domToView(t.addedNodes[0], { withChildren: !1 })), i && i.is("element", "br");
        }
      }
      function gN(c, t) {
        if (!Array.isArray(c))
          return c === t || !(!c.is("$text") || !t.is("$text")) && c.data === t.data;
      }
      class mN extends to {
        constructor(t) {
          super(t), this.mutationObserver = t.getObserver(T_), this.selection = this.document.selection, this.domConverter = t.domConverter, this._documents = /* @__PURE__ */ new WeakSet(), this._fireSelectionChangeDoneDebounced = iu((i) => {
            this.document.fire("selectionChangeDone", i);
          }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = iu(() => this.document.isSelecting = !1, 5e3), this._loopbackCounter = 0;
        }
        observe(t) {
          const i = t.ownerDocument, a = () => {
            this.document.isSelecting && (this._handleSelectionChange(null, i), this.document.isSelecting = !1, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
          };
          this.listenTo(t, "selectstart", () => {
            this.document.isSelecting = !0, this._documentIsSelectingInactivityTimeoutDebounced();
          }, { priority: "highest" }), this.listenTo(t, "keydown", a, { priority: "highest", useCapture: !0 }), this.listenTo(t, "keyup", a, { priority: "highest", useCapture: !0 }), this._documents.has(i) || (this.listenTo(i, "mouseup", a, { priority: "highest", useCapture: !0 }), this.listenTo(i, "selectionchange", (l, d) => {
            this.document.isComposing && !p.isAndroid || (this._handleSelectionChange(d, i), this._documentIsSelectingInactivityTimeoutDebounced());
          }), this._documents.add(i));
        }
        destroy() {
          super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
        }
        _handleSelectionChange(t, i) {
          if (!this.isEnabled)
            return;
          const a = i.defaultView.getSelection();
          if (this.checkShouldIgnoreEventFromTarget(a.anchorNode))
            return;
          this.mutationObserver.flush();
          const l = this.domConverter.domSelectionToView(a);
          if (l.rangeCount != 0) {
            if (this.view.hasDomSelection = !0, !(this.selection.isEqual(l) && this.domConverter.isDomSelectionCorrect(a) || ++this._loopbackCounter > 60))
              if (this.selection.isSimilar(l))
                this.view.forceRender();
              else {
                const d = { oldSelection: this.selection, newSelection: l, domSelection: a };
                this.document._isFocusChanging = !1, this.document.fire("selectionChange", d), this._fireSelectionChangeDoneDebounced(d);
              }
          } else
            this.view.hasDomSelection = !1;
        }
        _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }
      class vN extends sa {
        constructor(t) {
          super(t), this.domEventType = ["focus", "blur"], this.useCapture = !0;
          const i = this.document;
          i.on("focus", () => {
            i.isFocused = !0, i._isFocusChanging = !0, this._renderTimeoutId = setTimeout(() => {
              i._isFocusChanging = !1, t.change(() => {
              });
            }, 50);
          }), i.on("blur", (a, l) => {
            const d = i.selection.editableElement;
            d !== null && d !== l.target || (i.isFocused = !1, t.change(() => {
            }));
          });
        }
        onDomEvent(t) {
          this.fire(t.type, t);
        }
        destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
        }
      }
      class bN extends sa {
        constructor(t) {
          super(t), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
          const i = this.document;
          i.on("compositionstart", () => {
            i.isComposing = !0;
          }, { priority: "low" }), i.on("compositionend", () => {
            i.isComposing = !1;
          }, { priority: "low" });
        }
        onDomEvent(t) {
          this.fire(t.type, t, { data: t.data });
        }
      }
      class D_ {
        constructor(t) {
          this.files = function(i) {
            const a = Array.from(i.files || []), l = Array.from(i.items || []);
            return a.length ? a : l.filter((d) => d.kind === "file").map((d) => d.getAsFile());
          }(t), this._native = t;
        }
        get types() {
          return this._native.types;
        }
        getData(t) {
          return this._native.getData(t);
        }
        setData(t, i) {
          this._native.setData(t, i);
        }
        set effectAllowed(t) {
          this._native.effectAllowed = t;
        }
        get effectAllowed() {
          return this._native.effectAllowed;
        }
        set dropEffect(t) {
          this._native.dropEffect = t;
        }
        get dropEffect() {
          return this._native.dropEffect;
        }
        get isCanceled() {
          return this._native.dropEffect == "none" || !!this._native.mozUserCancelled;
        }
      }
      class wN extends sa {
        constructor(t) {
          super(t), this.domEventType = ["beforeinput"];
        }
        onDomEvent(t) {
          const i = t.getTargetRanges(), a = this.view, l = a.document;
          let d = null, g = null, m = [];
          if (t.dataTransfer && (d = new D_(t.dataTransfer)), t.data !== null ? g = t.data : d && (g = d.getData("text/plain")), l.selection.isFake)
            m = Array.from(l.selection.getRanges());
          else if (i.length)
            m = i.map((w) => a.domConverter.domRangeToView(w));
          else if (p.isAndroid) {
            const w = t.target.ownerDocument.defaultView.getSelection();
            m = Array.from(a.domConverter.domSelectionToView(w).getRanges());
          }
          if (p.isAndroid && t.inputType == "insertCompositionText" && g && g.endsWith(`
`))
            this.fire(t.type, t, { inputType: "insertParagraph", targetRanges: [a.createRange(m[0].end)] });
          else if (t.inputType == "insertText" && g && g.includes(`
`)) {
            const w = g.split(/\n{1,2}/g);
            let A = m;
            for (let C = 0; C < w.length; C++) {
              const T = w[C];
              T != "" && (this.fire(t.type, t, { data: T, dataTransfer: d, targetRanges: A, inputType: t.inputType, isComposing: t.isComposing }), A = [l.selection.getFirstRange()]), C + 1 < w.length && (this.fire(t.type, t, { inputType: "insertParagraph", targetRanges: A }), A = [l.selection.getFirstRange()]);
            }
          } else
            this.fire(t.type, t, { data: g, dataTransfer: d, targetRanges: m, inputType: t.inputType, isComposing: t.isComposing });
        }
      }
      class yN extends to {
        constructor(t) {
          super(t), this.document.on("keydown", (i, a) => {
            if (this.isEnabled && ((l = a.keyCode) == St.arrowright || l == St.arrowleft || l == St.arrowup || l == St.arrowdown)) {
              const d = new fl(this.document, "arrowKey", this.document.selection.getFirstRange());
              this.document.fire(d, a), d.stop.called && i.stop();
            }
            var l;
          });
        }
        observe() {
        }
      }
      class kN extends to {
        constructor(t) {
          super(t);
          const i = this.document;
          i.on("keydown", (a, l) => {
            if (!this.isEnabled || l.keyCode != St.tab || l.ctrlKey)
              return;
            const d = new fl(i, "tab", i.selection.getFirstRange());
            i.fire(d, l), d.stop.called && a.stop();
          });
        }
        observe() {
        }
      }
      class _N extends Te() {
        constructor(t) {
          super(), this.document = new mh(t), this.domConverter = new yh(this.document), this.domRoots = /* @__PURE__ */ new Map(), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new FR(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing", "_isFocusChanging").to(this.document, "isFocused", "isSelecting", "isComposing", "_isFocusChanging"), this._initialDomRootAttributes = /* @__PURE__ */ new WeakMap(), this._observers = /* @__PURE__ */ new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new r_(this.document), this.addObserver(T_), this.addObserver(mN), this.addObserver(vN), this.addObserver(WR), this.addObserver(nN), this.addObserver(bN), this.addObserver(yN), this.addObserver(wN), this.addObserver(kN), this.document.on("arrowKey", jR, { priority: "low" }), OR(this), this.on("render", () => {
            this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = !1;
          }), this.listenTo(this.document.selection, "change", () => {
            this._hasChangedSinceTheLastRendering = !0;
          }), this.listenTo(this.document, "change:isFocused", () => {
            this._hasChangedSinceTheLastRendering = !0;
          });
        }
        attachDomRoot(t, i = "main") {
          const a = this.document.getRoot(i);
          a._name = t.tagName.toLowerCase();
          const l = {};
          for (const { name: g, value: m } of Array.from(t.attributes))
            l[g] = m, g === "class" ? this._writer.addClass(m.split(" "), a) : this._writer.setAttribute(g, m, a);
          this._initialDomRootAttributes.set(t, l);
          const d = () => {
            this._writer.setAttribute("contenteditable", (!a.isReadOnly).toString(), a), a.isReadOnly ? this._writer.addClass("ck-read-only", a) : this._writer.removeClass("ck-read-only", a);
          };
          d(), this.domRoots.set(i, t), this.domConverter.bindElements(t, a), this._renderer.markToSync("children", a), this._renderer.markToSync("attributes", a), this._renderer.domDocuments.add(t.ownerDocument), a.on("change:children", (g, m) => this._renderer.markToSync("children", m)), a.on("change:attributes", (g, m) => this._renderer.markToSync("attributes", m)), a.on("change:text", (g, m) => this._renderer.markToSync("text", m)), a.on("change:isReadOnly", () => this.change(d)), a.on("change", () => {
            this._hasChangedSinceTheLastRendering = !0;
          });
          for (const g of this._observers.values())
            g.observe(t, i);
        }
        detachDomRoot(t) {
          const i = this.domRoots.get(t);
          Array.from(i.attributes).forEach(({ name: l }) => i.removeAttribute(l));
          const a = this._initialDomRootAttributes.get(i);
          for (const l in a)
            i.setAttribute(l, a[l]);
          this.domRoots.delete(t), this.domConverter.unbindDomElement(i);
        }
        getDomRoot(t = "main") {
          return this.domRoots.get(t);
        }
        addObserver(t) {
          let i = this._observers.get(t);
          if (i)
            return i;
          i = new t(this), this._observers.set(t, i);
          for (const [a, l] of this.domRoots)
            i.observe(l, a);
          return i.enable(), i;
        }
        getObserver(t) {
          return this._observers.get(t);
        }
        disableObservers() {
          for (const t of this._observers.values())
            t.disable();
        }
        enableObservers() {
          for (const t of this._observers.values())
            t.enable();
        }
        scrollToTheSelection() {
          const t = this.document.selection.getFirstRange();
          t && function({ target: i, viewportOffset: a = 0 }) {
            const l = Tm(i);
            let d = l, g = null;
            for (; d; ) {
              let m;
              m = FO(d == l ? i : g), BO(m, () => Ik(i, d));
              const w = Ik(i, d);
              if (jO(d, w, a), d.parent != d) {
                if (g = d.frameElement, d = d.parent, !g)
                  return;
              } else
                d = null;
            }
          }({ target: this.domConverter.viewRangeToDom(t), viewportOffset: 20 });
        }
        focus() {
          if (!this.document.isFocused) {
            const t = this.document.selection.editableElement;
            t && (this.domConverter.focus(t), this.forceRender());
          }
        }
        change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress)
            throw new S("cannot-change-view-tree", this);
          try {
            if (this._ongoingChange)
              return t(this._writer);
            this._ongoingChange = !0;
            const i = t(this._writer);
            return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), i;
          } catch (i) {
            S.rethrowUnexpectedError(i, this);
          }
        }
        forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.document._isFocusChanging = !1, this.change(() => {
          });
        }
        destroy() {
          for (const t of this._observers.values())
            t.destroy();
          this.document.destroy(), this.stopListening();
        }
        createPositionAt(t, i) {
          return $e._createAt(t, i);
        }
        createPositionAfter(t) {
          return $e._createAfter(t);
        }
        createPositionBefore(t) {
          return $e._createBefore(t);
        }
        createRange(...t) {
          return new it(...t);
        }
        createRangeOn(t) {
          return it._createOn(t);
        }
        createRangeIn(t) {
          return it._createIn(t);
        }
        createSelection(...t) {
          return new eo(...t);
        }
        _disableRendering(t) {
          this._renderingDisabled = t, t == 0 && this.change(() => {
          });
        }
        _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }
      class la {
        is() {
          throw new Error("is() method is abstract");
        }
      }
      class ca extends la {
        constructor(t) {
          super(), this.parent = null, this._attrs = Zi(t);
        }
        get document() {
          return null;
        }
        get index() {
          let t;
          if (!this.parent)
            return null;
          if ((t = this.parent.getChildIndex(this)) === null)
            throw new S("model-node-not-found-in-parent", this);
          return t;
        }
        get startOffset() {
          let t;
          if (!this.parent)
            return null;
          if ((t = this.parent.getChildStartOffset(this)) === null)
            throw new S("model-node-not-found-in-parent", this);
          return t;
        }
        get offsetSize() {
          return 1;
        }
        get endOffset() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
        get nextSibling() {
          const t = this.index;
          return t !== null && this.parent.getChild(t + 1) || null;
        }
        get previousSibling() {
          const t = this.index;
          return t !== null && this.parent.getChild(t - 1) || null;
        }
        get root() {
          let t = this;
          for (; t.parent; )
            t = t.parent;
          return t;
        }
        isAttached() {
          return this.root.is("rootElement");
        }
        getPath() {
          const t = [];
          let i = this;
          for (; i.parent; )
            t.unshift(i.startOffset), i = i.parent;
          return t;
        }
        getAncestors(t = {}) {
          const i = [];
          let a = t.includeSelf ? this : this.parent;
          for (; a; )
            i[t.parentFirst ? "push" : "unshift"](a), a = a.parent;
          return i;
        }
        getCommonAncestor(t, i = {}) {
          const a = this.getAncestors(i), l = t.getAncestors(i);
          let d = 0;
          for (; a[d] == l[d] && a[d]; )
            d++;
          return d === 0 ? null : a[d - 1];
        }
        isBefore(t) {
          if (this == t || this.root !== t.root)
            return !1;
          const i = this.getPath(), a = t.getPath(), l = Lt(i, a);
          switch (l) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return i[l] < a[l];
          }
        }
        isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
        hasAttribute(t) {
          return this._attrs.has(t);
        }
        getAttribute(t) {
          return this._attrs.get(t);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        toJSON() {
          const t = {};
          return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce((i, a) => (i[a[0]] = a[1], i), {})), t;
        }
        _clone(t) {
          return new ca(this._attrs);
        }
        _remove() {
          this.parent._removeChildren(this.index);
        }
        _setAttribute(t, i) {
          this._attrs.set(t, i);
        }
        _setAttributesTo(t) {
          this._attrs = Zi(t);
        }
        _removeAttribute(t) {
          return this._attrs.delete(t);
        }
        _clearAttributes() {
          this._attrs.clear();
        }
      }
      ca.prototype.is = function(c) {
        return c === "node" || c === "model:node";
      };
      class ou {
        constructor(t) {
          this._nodes = [], t && this._insertNodes(0, t);
        }
        [Symbol.iterator]() {
          return this._nodes[Symbol.iterator]();
        }
        get length() {
          return this._nodes.length;
        }
        get maxOffset() {
          return this._nodes.reduce((t, i) => t + i.offsetSize, 0);
        }
        getNode(t) {
          return this._nodes[t] || null;
        }
        getNodeIndex(t) {
          const i = this._nodes.indexOf(t);
          return i == -1 ? null : i;
        }
        getNodeStartOffset(t) {
          const i = this.getNodeIndex(t);
          return i === null ? null : this._nodes.slice(0, i).reduce((a, l) => a + l.offsetSize, 0);
        }
        indexToOffset(t) {
          if (t == this._nodes.length)
            return this.maxOffset;
          const i = this._nodes[t];
          if (!i)
            throw new S("model-nodelist-index-out-of-bounds", this);
          return this.getNodeStartOffset(i);
        }
        offsetToIndex(t) {
          let i = 0;
          for (const a of this._nodes) {
            if (t >= i && t < i + a.offsetSize)
              return this.getNodeIndex(a);
            i += a.offsetSize;
          }
          if (i != t)
            throw new S("model-nodelist-offset-out-of-bounds", this, { offset: t, nodeList: this });
          return this.length;
        }
        _insertNodes(t, i) {
          for (const a of i)
            if (!(a instanceof ca))
              throw new S("model-nodelist-insertnodes-not-node", this);
          this._nodes = function(a, l, d, g) {
            if (Math.max(l.length, a.length) > 1e4)
              return a.slice(0, d).concat(l).concat(a.slice(d + g, a.length));
            {
              const m = Array.from(a);
              return m.splice(d, g, ...l), m;
            }
          }(this._nodes, Array.from(i), t, 0);
        }
        _removeNodes(t, i = 1) {
          return this._nodes.splice(t, i);
        }
        toJSON() {
          return this._nodes.map((t) => t.toJSON());
        }
      }
      class Jt extends ca {
        constructor(t, i) {
          super(i), this._data = t || "";
        }
        get offsetSize() {
          return this.data.length;
        }
        get data() {
          return this._data;
        }
        toJSON() {
          const t = super.toJSON();
          return t.data = this.data, t;
        }
        _clone() {
          return new Jt(this.data, this.getAttributes());
        }
        static fromJSON(t) {
          return new Jt(t.data, t.attributes);
        }
      }
      Jt.prototype.is = function(c) {
        return c === "$text" || c === "model:$text" || c === "text" || c === "model:text" || c === "node" || c === "model:node";
      };
      class ki extends la {
        constructor(t, i, a) {
          if (super(), this.textNode = t, i < 0 || i > t.offsetSize)
            throw new S("model-textproxy-wrong-offsetintext", this);
          if (a < 0 || i + a > t.offsetSize)
            throw new S("model-textproxy-wrong-length", this);
          this.data = t.data.substring(i, i + a), this.offsetInText = i;
        }
        get startOffset() {
          return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
        }
        get offsetSize() {
          return this.data.length;
        }
        get endOffset() {
          return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
        }
        get isPartial() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
        get parent() {
          return this.textNode.parent;
        }
        get root() {
          return this.textNode.root;
        }
        getPath() {
          const t = this.textNode.getPath();
          return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
        }
        getAncestors(t = {}) {
          const i = [];
          let a = t.includeSelf ? this : this.parent;
          for (; a; )
            i[t.parentFirst ? "push" : "unshift"](a), a = a.parent;
          return i;
        }
        hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
        getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
        getAttributes() {
          return this.textNode.getAttributes();
        }
        getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }
      ki.prototype.is = function(c) {
        return c === "$textProxy" || c === "model:$textProxy" || c === "textProxy" || c === "model:textProxy";
      };
      class Kt extends ca {
        constructor(t, i, a) {
          super(i), this.name = t, this._children = new ou(), a && this._insertChild(0, a);
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        getChild(t) {
          return this._children.getNode(t);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
        getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
        offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
        getNodeByPath(t) {
          let i = this;
          for (const a of t)
            i = i.getChild(i.offsetToIndex(a));
          return i;
        }
        findAncestor(t, i = {}) {
          let a = i.includeSelf ? this : this.parent;
          for (; a; ) {
            if (a.name === t)
              return a;
            a = a.parent;
          }
          return null;
        }
        toJSON() {
          const t = super.toJSON();
          if (t.name = this.name, this._children.length > 0) {
            t.children = [];
            for (const i of this._children)
              t.children.push(i.toJSON());
          }
          return t;
        }
        _clone(t = !1) {
          const i = t ? Array.from(this._children).map((a) => a._clone(!0)) : void 0;
          return new Kt(this.name, this.getAttributes(), i);
        }
        _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
        _insertChild(t, i) {
          const a = function(l) {
            return typeof l == "string" ? [new Jt(l)] : (Ft(l) || (l = [l]), Array.from(l).map((d) => typeof d == "string" ? new Jt(d) : d instanceof ki ? new Jt(d.data, d.getAttributes()) : d));
          }(i);
          for (const l of a)
            l.parent !== null && l._remove(), l.parent = this;
          this._children._insertNodes(t, a);
        }
        _removeChildren(t, i = 1) {
          const a = this._children._removeNodes(t, i);
          for (const l of a)
            l.parent = null;
          return a;
        }
        static fromJSON(t) {
          let i;
          if (t.children) {
            i = [];
            for (const a of t.children)
              a.name ? i.push(Kt.fromJSON(a)) : i.push(Jt.fromJSON(a));
          }
          return new Kt(t.name, t.attributes, i);
        }
      }
      Kt.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "element" || c === "model:element") : c === "element" || c === "model:element" || c === "node" || c === "model:node";
      };
      class no {
        constructor(t = {}) {
          if (!t.boundaries && !t.startPosition)
            throw new S("model-tree-walker-no-start-position", null);
          const i = t.direction || "forward";
          if (i != "forward" && i != "backward")
            throw new S("model-tree-walker-unknown-direction", t, { direction: i });
          this.direction = i, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = Ee._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
        }
        [Symbol.iterator]() {
          return this;
        }
        skip(t) {
          let i, a, l, d;
          do
            l = this.position, d = this._visitedParent, { done: i, value: a } = this.next();
          while (!i && t(a));
          i || (this.position = l, this._visitedParent = d);
        }
        next() {
          return this.direction == "forward" ? this._next() : this._previous();
        }
        _next() {
          const t = this.position, i = this.position.clone(), a = this._visitedParent;
          if (a.parent === null && i.offset === a.maxOffset)
            return { done: !0, value: void 0 };
          if (a === this._boundaryEndParent && i.offset == this.boundaries.end.offset)
            return { done: !0, value: void 0 };
          const l = au(i, a), d = l || I_(i, a, l);
          if (d instanceof Kt)
            return this.shallow ? i.offset++ : (i.path.push(0), this._visitedParent = d), this.position = i, is("elementStart", d, t, i, 1);
          if (d instanceof Jt) {
            let g;
            if (this.singleCharacters)
              g = 1;
            else {
              let A = d.endOffset;
              this._boundaryEndParent == a && this.boundaries.end.offset < A && (A = this.boundaries.end.offset), g = A - i.offset;
            }
            const m = i.offset - d.startOffset, w = new ki(d, m, g);
            return i.offset += g, this.position = i, is("text", w, t, i, g);
          }
          return i.path.pop(), i.offset++, this.position = i, this._visitedParent = a.parent, this.ignoreElementEnd ? this._next() : is("elementEnd", a, t, i);
        }
        _previous() {
          const t = this.position, i = this.position.clone(), a = this._visitedParent;
          if (a.parent === null && i.offset === 0)
            return { done: !0, value: void 0 };
          if (a == this._boundaryStartParent && i.offset == this.boundaries.start.offset)
            return { done: !0, value: void 0 };
          const l = i.parent, d = au(i, l), g = d || P_(i, l, d);
          if (g instanceof Kt)
            return i.offset--, this.shallow ? (this.position = i, is("elementStart", g, t, i, 1)) : (i.path.push(g.maxOffset), this.position = i, this._visitedParent = g, this.ignoreElementEnd ? this._previous() : is("elementEnd", g, t, i));
          if (g instanceof Jt) {
            let m;
            if (this.singleCharacters)
              m = 1;
            else {
              let C = g.startOffset;
              this._boundaryStartParent == a && this.boundaries.start.offset > C && (C = this.boundaries.start.offset), m = i.offset - C;
            }
            const w = i.offset - g.startOffset, A = new ki(g, w - m, m);
            return i.offset -= m, this.position = i, is("text", A, t, i, m);
          }
          return i.path.pop(), this.position = i, this._visitedParent = a.parent, is("elementStart", a, t, i, 1);
        }
      }
      function is(c, t, i, a, l) {
        return { done: !1, value: { type: c, item: t, previousPosition: i, nextPosition: a, length: l } };
      }
      class Ee extends la {
        constructor(t, i, a = "toNone") {
          if (super(), !t.is("element") && !t.is("documentFragment"))
            throw new S("model-position-root-invalid", t);
          if (!(i instanceof Array) || i.length === 0)
            throw new S("model-position-path-incorrect-format", t, { path: i });
          t.is("rootElement") ? i = i.slice() : (i = [...t.getPath(), ...i], t = t.root), this.root = t, this.path = i, this.stickiness = a;
        }
        get offset() {
          return this.path[this.path.length - 1];
        }
        set offset(t) {
          this.path[this.path.length - 1] = t;
        }
        get parent() {
          let t = this.root;
          for (let i = 0; i < this.path.length - 1; i++)
            if (t = t.getChild(t.offsetToIndex(this.path[i])), !t)
              throw new S("model-position-path-incorrect", this, { position: this });
          if (t.is("$text"))
            throw new S("model-position-path-incorrect", this, { position: this });
          return t;
        }
        get index() {
          return this.parent.offsetToIndex(this.offset);
        }
        get textNode() {
          return au(this, this.parent);
        }
        get nodeAfter() {
          const t = this.parent;
          return I_(this, t, au(this, t));
        }
        get nodeBefore() {
          const t = this.parent;
          return P_(this, t, au(this, t));
        }
        get isAtStart() {
          return this.offset === 0;
        }
        get isAtEnd() {
          return this.offset == this.parent.maxOffset;
        }
        compareWith(t) {
          if (this.root != t.root)
            return "different";
          const i = Lt(this.path, t.path);
          switch (i) {
            case "same":
              return "same";
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return this.path[i] < t.path[i] ? "before" : "after";
          }
        }
        getLastMatchingPosition(t, i = {}) {
          i.startPosition = this;
          const a = new no(i);
          return a.skip(t), a.position;
        }
        getParentPath() {
          return this.path.slice(0, -1);
        }
        getAncestors() {
          const t = this.parent;
          return t.is("documentFragment") ? [t] : t.getAncestors({ includeSelf: !0 });
        }
        findAncestor(t) {
          const i = this.parent;
          return i.is("element") ? i.findAncestor(t, { includeSelf: !0 }) : null;
        }
        getCommonPath(t) {
          if (this.root != t.root)
            return [];
          const i = Lt(this.path, t.path), a = typeof i == "string" ? Math.min(this.path.length, t.path.length) : i;
          return this.path.slice(0, a);
        }
        getCommonAncestor(t) {
          const i = this.getAncestors(), a = t.getAncestors();
          let l = 0;
          for (; i[l] == a[l] && i[l]; )
            l++;
          return l === 0 ? null : i[l - 1];
        }
        getShiftedBy(t) {
          const i = this.clone(), a = i.offset + t;
          return i.offset = a < 0 ? 0 : a, i;
        }
        isAfter(t) {
          return this.compareWith(t) == "after";
        }
        isBefore(t) {
          return this.compareWith(t) == "before";
        }
        isEqual(t) {
          return this.compareWith(t) == "same";
        }
        isTouching(t) {
          if (this.root !== t.root)
            return !1;
          const i = Math.min(this.path.length, t.path.length);
          for (let a = 0; a < i; a++) {
            const l = this.path[a] - t.path[a];
            if (l < -1 || l > 1)
              return !1;
            if (l === 1)
              return O_(t, this, a);
            if (l === -1)
              return O_(this, t, a);
          }
          return this.path.length === t.path.length || (this.path.length > t.path.length ? e0(this.path, i) : e0(t.path, i));
        }
        hasSameParentAs(t) {
          return this.root !== t.root ? !1 : Lt(this.getParentPath(), t.getParentPath()) == "same";
        }
        getTransformedByOperation(t) {
          let i;
          switch (t.type) {
            case "insert":
              i = this._getTransformedByInsertOperation(t);
              break;
            case "move":
            case "remove":
            case "reinsert":
              i = this._getTransformedByMoveOperation(t);
              break;
            case "split":
              i = this._getTransformedBySplitOperation(t);
              break;
            case "merge":
              i = this._getTransformedByMergeOperation(t);
              break;
            default:
              i = Ee._createAt(this);
          }
          return i;
        }
        _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
        _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
        _getTransformedBySplitOperation(t) {
          const i = t.movedRange;
          return i.containsPosition(this) || i.start.isEqual(this) && this.stickiness == "toNext" ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
        }
        _getTransformedByMergeOperation(t) {
          const i = t.movedRange;
          let a;
          return i.containsPosition(this) || i.start.isEqual(this) ? (a = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (a = a._getTransformedByDeletion(t.deletionPosition, 1))) : a = this.isEqual(t.deletionPosition) ? Ee._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), a;
        }
        _getTransformedByDeletion(t, i) {
          const a = Ee._createAt(this);
          if (this.root != t.root)
            return a;
          if (Lt(t.getParentPath(), this.getParentPath()) == "same") {
            if (t.offset < this.offset) {
              if (t.offset + i > this.offset)
                return null;
              a.offset -= i;
            }
          } else if (Lt(t.getParentPath(), this.getParentPath()) == "prefix") {
            const l = t.path.length - 1;
            if (t.offset <= this.path[l]) {
              if (t.offset + i > this.path[l])
                return null;
              a.path[l] -= i;
            }
          }
          return a;
        }
        _getTransformedByInsertion(t, i) {
          const a = Ee._createAt(this);
          if (this.root != t.root)
            return a;
          if (Lt(t.getParentPath(), this.getParentPath()) == "same")
            (t.offset < this.offset || t.offset == this.offset && this.stickiness != "toPrevious") && (a.offset += i);
          else if (Lt(t.getParentPath(), this.getParentPath()) == "prefix") {
            const l = t.path.length - 1;
            t.offset <= this.path[l] && (a.path[l] += i);
          }
          return a;
        }
        _getTransformedByMove(t, i, a) {
          if (i = i._getTransformedByDeletion(t, a), t.isEqual(i))
            return Ee._createAt(this);
          const l = this._getTransformedByDeletion(t, a);
          return l === null || t.isEqual(this) && this.stickiness == "toNext" || t.getShiftedBy(a).isEqual(this) && this.stickiness == "toPrevious" ? this._getCombined(t, i) : l._getTransformedByInsertion(i, a);
        }
        _getCombined(t, i) {
          const a = t.path.length - 1, l = Ee._createAt(i);
          return l.stickiness = this.stickiness, l.offset = l.offset + this.path[a] - t.offset, l.path = [...l.path, ...this.path.slice(a + 1)], l;
        }
        toJSON() {
          return { root: this.root.toJSON(), path: Array.from(this.path), stickiness: this.stickiness };
        }
        clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
        static _createAt(t, i, a = "toNone") {
          if (t instanceof Ee)
            return new Ee(t.root, t.path, t.stickiness);
          {
            const l = t;
            if (i == "end")
              i = l.maxOffset;
            else {
              if (i == "before")
                return this._createBefore(l, a);
              if (i == "after")
                return this._createAfter(l, a);
              if (i !== 0 && !i)
                throw new S("model-createpositionat-offset-required", [this, t]);
            }
            if (!l.is("element") && !l.is("documentFragment"))
              throw new S("model-position-parent-incorrect", [this, t]);
            const d = l.getPath();
            return d.push(i), new this(l.root, d, a);
          }
        }
        static _createAfter(t, i) {
          if (!t.parent)
            throw new S("model-position-after-root", [this, t], { root: t });
          return this._createAt(t.parent, t.endOffset, i);
        }
        static _createBefore(t, i) {
          if (!t.parent)
            throw new S("model-position-before-root", t, { root: t });
          return this._createAt(t.parent, t.startOffset, i);
        }
        static fromJSON(t, i) {
          if (t.root === "$graveyard") {
            const a = new Ee(i.graveyard, t.path);
            return a.stickiness = t.stickiness, a;
          }
          if (!i.getRoot(t.root))
            throw new S("model-position-fromjson-no-root", i, { rootName: t.root });
          return new Ee(i.getRoot(t.root), t.path, t.stickiness);
        }
      }
      function au(c, t) {
        const i = t.getChild(t.offsetToIndex(c.offset));
        return i && i.is("$text") && i.startOffset < c.offset ? i : null;
      }
      function I_(c, t, i) {
        return i !== null ? null : t.getChild(t.offsetToIndex(c.offset));
      }
      function P_(c, t, i) {
        return i !== null ? null : t.getChild(t.offsetToIndex(c.offset) - 1);
      }
      function O_(c, t, i) {
        return i + 1 !== c.path.length && !!e0(t.path, i + 1) && !!function(a, l) {
          let d = a.parent, g = a.path.length - 1, m = 0;
          for (; g >= l; ) {
            if (a.path[g] + m !== d.maxOffset)
              return !1;
            m = 1, g--, d = d.parent;
          }
          return !0;
        }(c, i + 1);
      }
      function e0(c, t) {
        for (; t < c.length; ) {
          if (c[t] !== 0)
            return !1;
          t++;
        }
        return !0;
      }
      Ee.prototype.is = function(c) {
        return c === "position" || c === "model:position";
      };
      class ve extends la {
        constructor(t, i) {
          super(), this.start = Ee._createAt(t), this.end = i ? Ee._createAt(i) : Ee._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
        }
        *[Symbol.iterator]() {
          yield* new no({ boundaries: this, ignoreElementEnd: !0 });
        }
        get isCollapsed() {
          return this.start.isEqual(this.end);
        }
        get isFlat() {
          return Lt(this.start.getParentPath(), this.end.getParentPath()) == "same";
        }
        get root() {
          return this.start.root;
        }
        containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
        containsRange(t, i = !1) {
          t.isCollapsed && (i = !1);
          const a = this.containsPosition(t.start) || i && this.start.isEqual(t.start), l = this.containsPosition(t.end) || i && this.end.isEqual(t.end);
          return a && l;
        }
        containsItem(t) {
          const i = Ee._createBefore(t);
          return this.containsPosition(i) || this.start.isEqual(i);
        }
        isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
        isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
        getDifference(t) {
          const i = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && i.push(new ve(this.start, t.start)), this.containsPosition(t.end) && i.push(new ve(t.end, this.end))) : i.push(new ve(this.start, this.end)), i;
        }
        getIntersection(t) {
          if (this.isIntersecting(t)) {
            let i = this.start, a = this.end;
            return this.containsPosition(t.start) && (i = t.start), this.containsPosition(t.end) && (a = t.end), new ve(i, a);
          }
          return null;
        }
        getJoined(t, i = !1) {
          let a = this.isIntersecting(t);
          if (a || (a = this.start.isBefore(t.start) ? i ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : i ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !a)
            return null;
          let l = this.start, d = this.end;
          return t.start.isBefore(l) && (l = t.start), t.end.isAfter(d) && (d = t.end), new ve(l, d);
        }
        getMinimalFlatRanges() {
          const t = [], i = this.start.getCommonPath(this.end).length, a = Ee._createAt(this.start);
          let l = a.parent;
          for (; a.path.length > i + 1; ) {
            const d = l.maxOffset - a.offset;
            d !== 0 && t.push(new ve(a, a.getShiftedBy(d))), a.path = a.path.slice(0, -1), a.offset++, l = l.parent;
          }
          for (; a.path.length <= this.end.path.length; ) {
            const d = this.end.path[a.path.length - 1], g = d - a.offset;
            g !== 0 && t.push(new ve(a, a.getShiftedBy(g))), a.offset = d, a.path.push(0);
          }
          return t;
        }
        getWalker(t = {}) {
          return t.boundaries = this, new no(t);
        }
        *getItems(t = {}) {
          t.boundaries = this, t.ignoreElementEnd = !0;
          const i = new no(t);
          for (const a of i)
            yield a.item;
        }
        *getPositions(t = {}) {
          t.boundaries = this;
          const i = new no(t);
          yield i.position;
          for (const a of i)
            yield a.nextPosition;
        }
        getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);
            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);
            case "split":
              return [this._getTransformedBySplitOperation(t)];
            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }
          return [new ve(this.start, this.end)];
        }
        getTransformedByOperations(t) {
          const i = [new ve(this.start, this.end)];
          for (const a of t)
            for (let l = 0; l < i.length; l++) {
              const d = i[l].getTransformedByOperation(a);
              i.splice(l, 1, ...d), l += d.length - 1;
            }
          for (let a = 0; a < i.length; a++) {
            const l = i[a];
            for (let d = a + 1; d < i.length; d++) {
              const g = i[d];
              (l.containsRange(g) || g.containsRange(l) || l.isEqual(g)) && i.splice(d, 1);
            }
          }
          return i;
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
        getContainedElement() {
          if (this.isCollapsed)
            return null;
          const t = this.start.nodeAfter, i = this.end.nodeBefore;
          return t && t.is("element") && t === i ? t : null;
        }
        toJSON() {
          return { start: this.start.toJSON(), end: this.end.toJSON() };
        }
        clone() {
          return new this.constructor(this.start, this.end);
        }
        _getTransformedByInsertOperation(t, i = !1) {
          return this._getTransformedByInsertion(t.position, t.howMany, i);
        }
        _getTransformedByMoveOperation(t, i = !1) {
          const a = t.sourcePosition, l = t.howMany, d = t.targetPosition;
          return this._getTransformedByMove(a, d, l, i);
        }
        _getTransformedBySplitOperation(t) {
          const i = this.start._getTransformedBySplitOperation(t);
          let a = this.end._getTransformedBySplitOperation(t);
          return this.end.isEqual(t.insertionPosition) && (a = this.end.getShiftedBy(1)), i.root != a.root && (a = this.end.getShiftedBy(-1)), new ve(i, a);
        }
        _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition))
            return new ve(this.start);
          let i = this.start._getTransformedByMergeOperation(t), a = this.end._getTransformedByMergeOperation(t);
          return i.root != a.root && (a = this.end.getShiftedBy(-1)), i.isAfter(a) ? (t.sourcePosition.isBefore(t.targetPosition) ? (i = Ee._createAt(a), i.offset = 0) : (t.deletionPosition.isEqual(i) || (a = t.deletionPosition), i = t.targetPosition), new ve(i, a)) : new ve(i, a);
        }
        _getTransformedByInsertion(t, i, a = !1) {
          if (a && this.containsPosition(t))
            return [new ve(this.start, t), new ve(t.getShiftedBy(i), this.end._getTransformedByInsertion(t, i))];
          {
            const l = new ve(this.start, this.end);
            return l.start = l.start._getTransformedByInsertion(t, i), l.end = l.end._getTransformedByInsertion(t, i), [l];
          }
        }
        _getTransformedByMove(t, i, a, l = !1) {
          if (this.isCollapsed) {
            const T = this.start._getTransformedByMove(t, i, a);
            return [new ve(T)];
          }
          const d = ve._createFromPositionAndShift(t, a), g = i._getTransformedByDeletion(t, a);
          if (this.containsPosition(i) && !l && (d.containsPosition(this.start) || d.containsPosition(this.end))) {
            const T = this.start._getTransformedByMove(t, i, a), R = this.end._getTransformedByMove(t, i, a);
            return [new ve(T, R)];
          }
          let m;
          const w = this.getDifference(d);
          let A = null;
          const C = this.getIntersection(d);
          if (w.length == 1 ? A = new ve(w[0].start._getTransformedByDeletion(t, a), w[0].end._getTransformedByDeletion(t, a)) : w.length == 2 && (A = new ve(this.start, this.end._getTransformedByDeletion(t, a))), m = A ? A._getTransformedByInsertion(g, a, C !== null || l) : [], C) {
            const T = new ve(C.start._getCombined(d.start, g), C.end._getCombined(d.start, g));
            m.length == 2 ? m.splice(1, 0, T) : m.push(T);
          }
          return m;
        }
        _getTransformedByDeletion(t, i) {
          let a = this.start._getTransformedByDeletion(t, i), l = this.end._getTransformedByDeletion(t, i);
          return a == null && l == null ? null : (a == null && (a = t), l == null && (l = t), new ve(a, l));
        }
        static _createFromPositionAndShift(t, i) {
          const a = t, l = t.getShiftedBy(i);
          return i > 0 ? new this(a, l) : new this(l, a);
        }
        static _createIn(t) {
          return new this(Ee._createAt(t, 0), Ee._createAt(t, t.maxOffset));
        }
        static _createOn(t) {
          return this._createFromPositionAndShift(Ee._createBefore(t), t.offsetSize);
        }
        static _createFromRanges(t) {
          if (t.length === 0)
            throw new S("range-create-from-ranges-empty-array", null);
          if (t.length == 1)
            return t[0].clone();
          const i = t[0];
          t.sort((d, g) => d.start.isAfter(g.start) ? 1 : -1);
          const a = t.indexOf(i), l = new this(i.start, i.end);
          if (a > 0)
            for (let d = a - 1; t[d].end.isEqual(l.start); d++)
              l.start = Ee._createAt(t[d].start);
          for (let d = a + 1; d < t.length && t[d].start.isEqual(l.end); d++)
            l.end = Ee._createAt(t[d].end);
          return l;
        }
        static fromJSON(t, i) {
          return new this(Ee.fromJSON(t.start, i), Ee.fromJSON(t.end, i));
        }
      }
      ve.prototype.is = function(c) {
        return c === "range" || c === "model:range";
      };
      class R_ extends ie() {
        constructor() {
          super(), this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelLengthCallbacks = /* @__PURE__ */ new Map(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._deferredBindingRemovals = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this.on("modelToViewPosition", (t, i) => {
            if (i.viewPosition)
              return;
            const a = this._modelToViewMapping.get(i.modelPosition.parent);
            if (!a)
              throw new S("mapping-model-position-view-parent-not-found", this, { modelPosition: i.modelPosition });
            i.viewPosition = this.findPositionIn(a, i.modelPosition.offset);
          }, { priority: "low" }), this.on("viewToModelPosition", (t, i) => {
            if (i.modelPosition)
              return;
            const a = this.findMappedViewAncestor(i.viewPosition), l = this._viewToModelMapping.get(a), d = this._toModelOffset(i.viewPosition.parent, i.viewPosition.offset, a);
            i.modelPosition = Ee._createAt(l, d);
          }, { priority: "low" });
        }
        bindElements(t, i) {
          this._modelToViewMapping.set(t, i), this._viewToModelMapping.set(i, t);
        }
        unbindViewElement(t, i = {}) {
          const a = this.toModelElement(t);
          if (this._elementToMarkerNames.has(t))
            for (const l of this._elementToMarkerNames.get(t))
              this._unboundMarkerNames.add(l);
          i.defer ? this._deferredBindingRemovals.set(t, t.root) : (this._viewToModelMapping.delete(t), this._modelToViewMapping.get(a) == t && this._modelToViewMapping.delete(a));
        }
        unbindModelElement(t) {
          const i = this.toViewElement(t);
          this._modelToViewMapping.delete(t), this._viewToModelMapping.get(i) == t && this._viewToModelMapping.delete(i);
        }
        bindElementToMarker(t, i) {
          const a = this._markerNameToElements.get(i) || /* @__PURE__ */ new Set();
          a.add(t);
          const l = this._elementToMarkerNames.get(t) || /* @__PURE__ */ new Set();
          l.add(i), this._markerNameToElements.set(i, a), this._elementToMarkerNames.set(t, l);
        }
        unbindElementFromMarkerName(t, i) {
          const a = this._markerNameToElements.get(i);
          a && (a.delete(t), a.size == 0 && this._markerNameToElements.delete(i));
          const l = this._elementToMarkerNames.get(t);
          l && (l.delete(i), l.size == 0 && this._elementToMarkerNames.delete(t));
        }
        flushUnboundMarkerNames() {
          const t = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), t;
        }
        flushDeferredBindings() {
          for (const [t, i] of this._deferredBindingRemovals)
            t.root == i && this.unbindViewElement(t);
          this._deferredBindingRemovals = /* @__PURE__ */ new Map();
        }
        clearBindings() {
          this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this._deferredBindingRemovals = /* @__PURE__ */ new Map();
        }
        toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
        toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
        toModelRange(t) {
          return new ve(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
        toViewRange(t) {
          return new it(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
        toModelPosition(t) {
          const i = { viewPosition: t, mapper: this };
          return this.fire("viewToModelPosition", i), i.modelPosition;
        }
        toViewPosition(t, i = {}) {
          const a = { modelPosition: t, mapper: this, isPhantom: i.isPhantom };
          return this.fire("modelToViewPosition", a), a.viewPosition;
        }
        markerNameToElements(t) {
          const i = this._markerNameToElements.get(t);
          if (!i)
            return null;
          const a = /* @__PURE__ */ new Set();
          for (const l of i)
            if (l.is("attributeElement"))
              for (const d of l.getElementsWithSameId())
                a.add(d);
            else
              a.add(l);
          return a;
        }
        registerViewToModelLength(t, i) {
          this._viewToModelLengthCallbacks.set(t, i);
        }
        findMappedViewAncestor(t) {
          let i = t.parent;
          for (; !this._viewToModelMapping.has(i); )
            i = i.parent;
          return i;
        }
        _toModelOffset(t, i, a) {
          if (a != t)
            return this._toModelOffset(t.parent, t.index, a) + this._toModelOffset(t, i, t);
          if (t.is("$text"))
            return i;
          let l = 0;
          for (let d = 0; d < i; d++)
            l += this.getModelLength(t.getChild(d));
          return l;
        }
        getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name))
            return this._viewToModelLengthCallbacks.get(t.name)(t);
          if (this._viewToModelMapping.has(t))
            return 1;
          if (t.is("$text"))
            return t.data.length;
          if (t.is("uiElement"))
            return 0;
          {
            let i = 0;
            for (const a of t.getChildren())
              i += this.getModelLength(a);
            return i;
          }
        }
        findPositionIn(t, i) {
          let a, l = 0, d = 0, g = 0;
          if (t.is("$text"))
            return new $e(t, i);
          for (; d < i; )
            a = t.getChild(g), l = this.getModelLength(a), d += l, g++;
          return d == i ? this._moveViewPositionToTextNode(new $e(t, g)) : this.findPositionIn(a, i - (d - l));
        }
        _moveViewPositionToTextNode(t) {
          const i = t.nodeBefore, a = t.nodeAfter;
          return i instanceof Xt ? new $e(i, i.data.length) : a instanceof Xt ? new $e(a, 0) : t;
        }
      }
      class AN {
        constructor() {
          this._consumable = /* @__PURE__ */ new Map(), this._textProxyRegistry = /* @__PURE__ */ new Map();
        }
        add(t, i) {
          i = Ah(i), t instanceof ki && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, /* @__PURE__ */ new Map()), this._consumable.get(t).set(i, !0);
        }
        consume(t, i) {
          return i = Ah(i), t instanceof ki && (t = this._getSymbolForTextProxy(t)), !!this.test(t, i) && (this._consumable.get(t).set(i, !1), !0);
        }
        test(t, i) {
          i = Ah(i), t instanceof ki && (t = this._getSymbolForTextProxy(t));
          const a = this._consumable.get(t);
          if (a === void 0)
            return null;
          const l = a.get(i);
          return l === void 0 ? null : l;
        }
        revert(t, i) {
          i = Ah(i), t instanceof ki && (t = this._getSymbolForTextProxy(t));
          const a = this.test(t, i);
          return a === !1 ? (this._consumable.get(t).set(i, !0), !0) : a !== !0 && null;
        }
        verifyAllConsumed(t) {
          const i = [];
          for (const [a, l] of this._consumable)
            for (const [d, g] of l) {
              const m = d.split(":")[0];
              g && t == m && i.push({ event: d, item: a.name || a.description });
            }
          if (i.length)
            throw new S("conversion-model-consumable-not-consumed", null, { items: i });
        }
        _getSymbolForTextProxy(t) {
          let i = null;
          const a = this._textProxyRegistry.get(t.startOffset);
          if (a) {
            const l = a.get(t.endOffset);
            l && (i = l.get(t.parent));
          }
          return i || (i = this._addSymbolForTextProxy(t)), i;
        }
        _addSymbolForTextProxy(t) {
          const i = t.startOffset, a = t.endOffset, l = t.parent, d = Symbol("$textProxy:" + t.data);
          let g, m;
          return g = this._textProxyRegistry.get(i), g || (g = /* @__PURE__ */ new Map(), this._textProxyRegistry.set(i, g)), m = g.get(a), m || (m = /* @__PURE__ */ new Map(), g.set(a, m)), m.set(l, d), d;
        }
      }
      function Ah(c) {
        const t = c.split(":");
        return t[0] == "insert" ? t[0] : t[0] == "addMarker" || t[0] == "removeMarker" ? c : t.length > 1 ? t[0] + ":" + t[1] : t[0];
      }
      class N_ extends ie() {
        constructor(t) {
          super(), this._conversionApi = { dispatcher: this, ...t }, this._firedEventsMap = /* @__PURE__ */ new WeakMap();
        }
        convertChanges(t, i, a) {
          const l = this._createConversionApi(a, t.getRefreshedItems());
          for (const g of t.getMarkersToRemove())
            this._convertMarkerRemove(g.name, g.range, l);
          const d = this._reduceChanges(t.getChanges());
          for (const g of d)
            g.type === "insert" ? this._convertInsert(ve._createFromPositionAndShift(g.position, g.length), l) : g.type === "reinsert" ? this._convertReinsert(ve._createFromPositionAndShift(g.position, g.length), l) : g.type === "remove" ? this._convertRemove(g.position, g.length, g.name, l) : this._convertAttribute(g.range, g.attributeKey, g.attributeOldValue, g.attributeNewValue, l);
          for (const g of l.mapper.flushUnboundMarkerNames()) {
            const m = i.get(g).getRange();
            this._convertMarkerRemove(g, m, l), this._convertMarkerAdd(g, m, l);
          }
          for (const g of t.getMarkersToAdd())
            this._convertMarkerAdd(g.name, g.range, l);
          l.mapper.flushDeferredBindings(), l.consumable.verifyAllConsumed("insert");
        }
        convert(t, i, a, l = {}) {
          const d = this._createConversionApi(a, void 0, l);
          this._convertInsert(t, d);
          for (const [g, m] of i)
            this._convertMarkerAdd(g, m, d);
          d.consumable.verifyAllConsumed("insert");
        }
        convertSelection(t, i, a) {
          const l = Array.from(i.getMarkersAtPosition(t.getFirstPosition())), d = this._createConversionApi(a);
          if (this._addConsumablesForSelection(d.consumable, t, l), this.fire("selection", { selection: t }, d), t.isCollapsed) {
            for (const g of l) {
              const m = g.getRange();
              if (!CN(t.getFirstPosition(), g, d.mapper))
                continue;
              const w = { item: t, markerName: g.name, markerRange: m };
              d.consumable.test(t, "addMarker:" + g.name) && this.fire(`addMarker:${g.name}`, w, d);
            }
            for (const g of t.getAttributeKeys()) {
              const m = { item: t, range: t.getFirstRange(), attributeKey: g, attributeOldValue: null, attributeNewValue: t.getAttribute(g) };
              d.consumable.test(t, "attribute:" + m.attributeKey) && this.fire(`attribute:${m.attributeKey}:$text`, m, d);
            }
          }
        }
        _convertInsert(t, i, a = {}) {
          a.doNotAddConsumables || this._addConsumablesForInsert(i.consumable, Array.from(t));
          for (const l of Array.from(t.getWalker({ shallow: !0 })).map($_))
            this._testAndFire("insert", l, i);
        }
        _convertRemove(t, i, a, l) {
          this.fire(`remove:${a}`, { position: t, length: i }, l);
        }
        _convertAttribute(t, i, a, l, d) {
          this._addConsumablesForRange(d.consumable, t, `attribute:${i}`);
          for (const g of t) {
            const m = { item: g.item, range: ve._createFromPositionAndShift(g.previousPosition, g.length), attributeKey: i, attributeOldValue: a, attributeNewValue: l };
            this._testAndFire(`attribute:${i}`, m, d);
          }
        }
        _convertReinsert(t, i) {
          const a = Array.from(t.getWalker({ shallow: !0 }));
          this._addConsumablesForInsert(i.consumable, a);
          for (const l of a.map($_))
            this._testAndFire("insert", { ...l, reconversion: !0 }, i);
        }
        _convertMarkerAdd(t, i, a) {
          if (i.root.rootName == "$graveyard")
            return;
          const l = `addMarker:${t}`;
          if (a.consumable.add(i, l), this.fire(l, { markerName: t, markerRange: i }, a), a.consumable.consume(i, l)) {
            this._addConsumablesForRange(a.consumable, i, l);
            for (const d of i.getItems()) {
              if (!a.consumable.test(d, l))
                continue;
              const g = { item: d, range: ve._createOn(d), markerName: t, markerRange: i };
              this.fire(l, g, a);
            }
          }
        }
        _convertMarkerRemove(t, i, a) {
          i.root.rootName != "$graveyard" && this.fire(`removeMarker:${t}`, { markerName: t, markerRange: i }, a);
        }
        _reduceChanges(t) {
          const i = { changes: t };
          return this.fire("reduceChanges", i), i.changes;
        }
        _addConsumablesForInsert(t, i) {
          for (const a of i) {
            const l = a.item;
            if (t.test(l, "insert") === null) {
              t.add(l, "insert");
              for (const d of l.getAttributeKeys())
                t.add(l, "attribute:" + d);
            }
          }
          return t;
        }
        _addConsumablesForRange(t, i, a) {
          for (const l of i.getItems())
            t.add(l, a);
          return t;
        }
        _addConsumablesForSelection(t, i, a) {
          t.add(i, "selection");
          for (const l of a)
            t.add(i, "addMarker:" + l.name);
          for (const l of i.getAttributeKeys())
            t.add(i, "attribute:" + l);
          return t;
        }
        _testAndFire(t, i, a) {
          const l = function(w, A) {
            const C = A.item.is("element") ? A.item.name : "$text";
            return `${w}:${C}`;
          }(t, i), d = i.item.is("$textProxy") ? a.consumable._getSymbolForTextProxy(i.item) : i.item, g = this._firedEventsMap.get(a), m = g.get(d);
          if (m) {
            if (m.has(l))
              return;
            m.add(l);
          } else
            g.set(d, /* @__PURE__ */ new Set([l]));
          this.fire(l, i, a);
        }
        _testAndFireAddAttributes(t, i) {
          const a = { item: t, range: ve._createOn(t) };
          for (const l of a.item.getAttributeKeys())
            a.attributeKey = l, a.attributeOldValue = null, a.attributeNewValue = a.item.getAttribute(l), this._testAndFire(`attribute:${l}`, a, i);
        }
        _createConversionApi(t, i = /* @__PURE__ */ new Set(), a = {}) {
          const l = { ...this._conversionApi, consumable: new AN(), writer: t, options: a, convertItem: (d) => this._convertInsert(ve._createOn(d), l), convertChildren: (d) => this._convertInsert(ve._createIn(d), l, { doNotAddConsumables: !0 }), convertAttributes: (d) => this._testAndFireAddAttributes(d, l), canReuseView: (d) => !i.has(l.mapper.toModelElement(d)) };
          return this._firedEventsMap.set(l, /* @__PURE__ */ new Map()), l;
        }
      }
      function CN(c, t, i) {
        const a = t.getRange(), l = Array.from(c.getAncestors());
        return l.shift(), l.reverse(), !l.some((d) => {
          if (a.containsItem(d))
            return !!i.toViewElement(d).getCustomProperty("addHighlight");
        });
      }
      function $_(c) {
        return { item: c.item, range: ve._createFromPositionAndShift(c.previousPosition, c.length) };
      }
      class ro extends ie(la) {
        constructor(...t) {
          super(), this._lastRangeBackward = !1, this._ranges = [], this._attrs = /* @__PURE__ */ new Map(), t.length && this.setTo(...t);
        }
        get anchor() {
          if (this._ranges.length > 0) {
            const t = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? t.end : t.start;
          }
          return null;
        }
        get focus() {
          if (this._ranges.length > 0) {
            const t = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? t.start : t.end;
          }
          return null;
        }
        get isCollapsed() {
          return this._ranges.length === 1 && this._ranges[0].isCollapsed;
        }
        get rangeCount() {
          return this._ranges.length;
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
        isEqual(t) {
          if (this.rangeCount != t.rangeCount)
            return !1;
          if (this.rangeCount === 0)
            return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus))
            return !1;
          for (const i of this._ranges) {
            let a = !1;
            for (const l of t._ranges)
              if (i.isEqual(l)) {
                a = !0;
                break;
              }
            if (!a)
              return !1;
          }
          return !0;
        }
        *getRanges() {
          for (const t of this._ranges)
            yield new ve(t.start, t.end);
        }
        getFirstRange() {
          let t = null;
          for (const i of this._ranges)
            t && !i.start.isBefore(t.start) || (t = i);
          return t ? new ve(t.start, t.end) : null;
        }
        getLastRange() {
          let t = null;
          for (const i of this._ranges)
            t && !i.end.isAfter(t.end) || (t = i);
          return t ? new ve(t.start, t.end) : null;
        }
        getFirstPosition() {
          const t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
        getLastPosition() {
          const t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
        setTo(...t) {
          let [i, a, l] = t;
          if (typeof a == "object" && (l = a, a = void 0), i === null)
            this._setRanges([]);
          else if (i instanceof ro)
            this._setRanges(i.getRanges(), i.isBackward);
          else if (i && typeof i.getRanges == "function")
            this._setRanges(i.getRanges(), i.isBackward);
          else if (i instanceof ve)
            this._setRanges([i], !!l && !!l.backward);
          else if (i instanceof Ee)
            this._setRanges([new ve(i)]);
          else if (i instanceof ca) {
            const d = !!l && !!l.backward;
            let g;
            if (a == "in")
              g = ve._createIn(i);
            else if (a == "on")
              g = ve._createOn(i);
            else {
              if (a === void 0)
                throw new S("model-selection-setto-required-second-parameter", [this, i]);
              g = new ve(Ee._createAt(i, a));
            }
            this._setRanges([g], d);
          } else {
            if (!Ft(i))
              throw new S("model-selection-setto-not-selectable", [this, i]);
            this._setRanges(i, l && !!l.backward);
          }
        }
        _setRanges(t, i = !1) {
          const a = Array.from(t), l = a.some((d) => {
            if (!(d instanceof ve))
              throw new S("model-selection-set-ranges-not-range", [this, t]);
            return this._ranges.every((g) => !g.isEqual(d));
          });
          (a.length !== this._ranges.length || l) && (this._replaceAllRanges(a), this._lastRangeBackward = !!i, this.fire("change:range", { directChange: !0 }));
        }
        setFocus(t, i) {
          if (this.anchor === null)
            throw new S("model-selection-setfocus-no-ranges", [this, t]);
          const a = Ee._createAt(t, i);
          if (a.compareWith(this.focus) == "same")
            return;
          const l = this.anchor;
          this._ranges.length && this._popRange(), a.compareWith(l) == "before" ? (this._pushRange(new ve(a, l)), this._lastRangeBackward = !0) : (this._pushRange(new ve(l, a)), this._lastRangeBackward = !1), this.fire("change:range", { directChange: !0 });
        }
        getAttribute(t) {
          return this._attrs.get(t);
        }
        getAttributes() {
          return this._attrs.entries();
        }
        getAttributeKeys() {
          return this._attrs.keys();
        }
        hasAttribute(t) {
          return this._attrs.has(t);
        }
        removeAttribute(t) {
          this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", { attributeKeys: [t], directChange: !0 }));
        }
        setAttribute(t, i) {
          this.getAttribute(t) !== i && (this._attrs.set(t, i), this.fire("change:attribute", { attributeKeys: [t], directChange: !0 }));
        }
        getSelectedElement() {
          return this.rangeCount !== 1 ? null : this.getFirstRange().getContainedElement();
        }
        *getSelectedBlocks() {
          const t = /* @__PURE__ */ new WeakSet();
          for (const i of this.getRanges()) {
            const a = j_(i.start, t);
            a && t0(a, i) && (yield a);
            for (const d of i.getWalker()) {
              const g = d.item;
              d.type == "elementEnd" && xN(g, t, i) && (yield g);
            }
            const l = j_(i.end, t);
            l && !i.end.isTouching(Ee._createAt(l, 0)) && t0(l, i) && (yield l);
          }
        }
        containsEntireContent(t = this.anchor.root) {
          const i = Ee._createAt(t, 0), a = Ee._createAt(t, "end");
          return i.isTouching(this.getFirstPosition()) && a.isTouching(this.getLastPosition());
        }
        _pushRange(t) {
          this._checkRange(t), this._ranges.push(new ve(t.start, t.end));
        }
        _checkRange(t) {
          for (let i = 0; i < this._ranges.length; i++)
            if (t.isIntersecting(this._ranges[i]))
              throw new S("model-selection-range-intersects", [this, t], { addedRange: t, intersectingRange: this._ranges[i] });
        }
        _replaceAllRanges(t) {
          this._removeAllRanges();
          for (const i of t)
            this._pushRange(i);
        }
        _removeAllRanges() {
          for (; this._ranges.length > 0; )
            this._popRange();
        }
        _popRange() {
          this._ranges.pop();
        }
      }
      function L_(c, t) {
        return !t.has(c) && (t.add(c), c.root.document.model.schema.isBlock(c) && !!c.parent);
      }
      function xN(c, t, i) {
        return L_(c, t) && t0(c, i);
      }
      function j_(c, t) {
        const i = c.parent.root.document.model.schema, a = c.parent.getAncestors({ parentFirst: !0, includeSelf: !0 });
        let l = !1;
        const d = a.find((g) => !l && (l = i.isLimit(g), !l && L_(g, t)));
        return a.forEach((g) => t.add(g)), d;
      }
      function t0(c, t) {
        const i = function(a) {
          const l = a.root.document.model.schema;
          let d = a.parent;
          for (; d; ) {
            if (l.isBlock(d))
              return d;
            d = d.parent;
          }
        }(c);
        return i ? !t.containsRange(ve._createOn(i), !0) : !0;
      }
      ro.prototype.is = function(c) {
        return c === "selection" || c === "model:selection";
      };
      class _i extends ie(ve) {
        constructor(t, i) {
          super(t, i), EN.call(this);
        }
        detach() {
          this.stopListening();
        }
        toRange() {
          return new ve(this.start, this.end);
        }
        static fromRange(t) {
          return new _i(t.start, t.end);
        }
      }
      function EN() {
        this.listenTo(this.root.document.model, "applyOperation", (c, t) => {
          const i = t[0];
          i.isDocumentOperation && SN.call(this, i);
        }, { priority: "low" });
      }
      function SN(c) {
        const t = this.getTransformedByOperation(c), i = ve._createFromRanges(t), a = !i.isEqual(this), l = function(g, m) {
          switch (m.type) {
            case "insert":
              return g.containsPosition(m.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return g.containsPosition(m.sourcePosition) || g.start.isEqual(m.sourcePosition) || g.containsPosition(m.targetPosition);
            case "split":
              return g.containsPosition(m.splitPosition) || g.containsPosition(m.insertionPosition);
          }
          return !1;
        }(this, c);
        let d = null;
        if (a) {
          i.root.rootName == "$graveyard" && (d = c.type == "remove" ? c.sourcePosition : c.deletionPosition);
          const g = this.toRange();
          this.start = i.start, this.end = i.end, this.fire("change:range", g, { deletionPosition: d });
        } else
          l && this.fire("change:content", this.toRange(), { deletionPosition: d });
      }
      _i.prototype.is = function(c) {
        return c === "liveRange" || c === "model:liveRange" || c == "range" || c === "model:range";
      };
      const su = "selection:";
      class Yr extends ie(la) {
        constructor(t) {
          super(), this._selection = new MN(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
        }
        get isCollapsed() {
          return this._selection.isCollapsed;
        }
        get anchor() {
          return this._selection.anchor;
        }
        get focus() {
          return this._selection.focus;
        }
        get rangeCount() {
          return this._selection.rangeCount;
        }
        get hasOwnRange() {
          return this._selection.hasOwnRange;
        }
        get isBackward() {
          return this._selection.isBackward;
        }
        get isGravityOverridden() {
          return this._selection.isGravityOverridden;
        }
        get markers() {
          return this._selection.markers;
        }
        get _ranges() {
          return this._selection._ranges;
        }
        getRanges() {
          return this._selection.getRanges();
        }
        getFirstPosition() {
          return this._selection.getFirstPosition();
        }
        getLastPosition() {
          return this._selection.getLastPosition();
        }
        getFirstRange() {
          return this._selection.getFirstRange();
        }
        getLastRange() {
          return this._selection.getLastRange();
        }
        getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
        getSelectedElement() {
          return this._selection.getSelectedElement();
        }
        containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
        destroy() {
          this._selection.destroy();
        }
        getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
        getAttributes() {
          return this._selection.getAttributes();
        }
        getAttribute(t) {
          return this._selection.getAttribute(t);
        }
        hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
        refresh() {
          this._selection.updateMarkers(), this._selection._updateAttributes(!1);
        }
        observeMarkers(t) {
          this._selection.observeMarkers(t);
        }
        _setFocus(t, i) {
          this._selection.setFocus(t, i);
        }
        _setTo(...t) {
          this._selection.setTo(...t);
        }
        _setAttribute(t, i) {
          this._selection.setAttribute(t, i);
        }
        _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
        _getStoredAttributes() {
          return this._selection.getStoredAttributes();
        }
        _overrideGravity() {
          return this._selection.overrideGravity();
        }
        _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
        static _getStoreAttributeKey(t) {
          return su + t;
        }
        static _isStoreAttributeKey(t) {
          return t.startsWith(su);
        }
      }
      Yr.prototype.is = function(c) {
        return c === "selection" || c == "model:selection" || c == "documentSelection" || c == "model:documentSelection";
      };
      class MN extends ro {
        constructor(t) {
          super(), this.markers = new yi({ idProperty: "name" }), this._model = t.model, this._document = t, this._attributePriority = /* @__PURE__ */ new Map(), this._selectionRestorePosition = null, this._hasChangedRange = !1, this._overriddenGravityRegister = /* @__PURE__ */ new Set(), this._observedMarkers = /* @__PURE__ */ new Set(), this.listenTo(this._model, "applyOperation", (i, a) => {
            const l = a[0];
            l.isDocumentOperation && l.type != "marker" && l.type != "rename" && l.type != "noop" && (this._ranges.length == 0 && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = !1, this.fire("change:range", { directChange: !1 })));
          }, { priority: "lowest" }), this.on("change:range", () => {
            this._validateSelectionRanges(this.getRanges());
          }), this.listenTo(this._model.markers, "update", (i, a, l, d) => {
            this._updateMarker(a, d);
          }), this.listenTo(this._document, "change", (i, a) => {
            (function(l, d) {
              const g = l.document.differ;
              for (const m of g.getChanges()) {
                if (m.type != "insert")
                  continue;
                const w = m.position.parent;
                m.length === w.maxOffset && l.enqueueChange(d, (A) => {
                  const C = Array.from(w.getAttributeKeys()).filter((T) => T.startsWith(su));
                  for (const T of C)
                    A.removeAttribute(T, w);
                });
              }
            })(this._model, a);
          });
        }
        get isCollapsed() {
          return this._ranges.length === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
        }
        get anchor() {
          return super.anchor || this._document._getDefaultRange().start;
        }
        get focus() {
          return super.focus || this._document._getDefaultRange().end;
        }
        get rangeCount() {
          return this._ranges.length ? this._ranges.length : 1;
        }
        get hasOwnRange() {
          return this._ranges.length > 0;
        }
        get isGravityOverridden() {
          return !!this._overriddenGravityRegister.size;
        }
        destroy() {
          for (let t = 0; t < this._ranges.length; t++)
            this._ranges[t].detach();
          this.stopListening();
        }
        *getRanges() {
          this._ranges.length ? yield* super.getRanges() : yield this._document._getDefaultRange();
        }
        getFirstRange() {
          return super.getFirstRange() || this._document._getDefaultRange();
        }
        getLastRange() {
          return super.getLastRange() || this._document._getDefaultRange();
        }
        setTo(...t) {
          super.setTo(...t), this._updateAttributes(!0), this.updateMarkers();
        }
        setFocus(t, i) {
          super.setFocus(t, i), this._updateAttributes(!0), this.updateMarkers();
        }
        setAttribute(t, i) {
          if (this._setAttribute(t, i)) {
            const a = [t];
            this.fire("change:attribute", { attributeKeys: a, directChange: !0 });
          }
        }
        removeAttribute(t) {
          if (this._removeAttribute(t)) {
            const i = [t];
            this.fire("change:attribute", { attributeKeys: i, directChange: !0 });
          }
        }
        overrideGravity() {
          const t = N();
          return this._overriddenGravityRegister.add(t), this._overriddenGravityRegister.size === 1 && this._updateAttributes(!0), t;
        }
        restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t))
            throw new S("document-selection-gravity-wrong-restore", this, { uid: t });
          this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
        }
        observeMarkers(t) {
          this._observedMarkers.add(t), this.updateMarkers();
        }
        _replaceAllRanges(t) {
          this._validateSelectionRanges(t), super._replaceAllRanges(t);
        }
        _popRange() {
          this._ranges.pop().detach();
        }
        _pushRange(t) {
          const i = this._prepareRange(t);
          i && this._ranges.push(i);
        }
        _validateSelectionRanges(t) {
          for (const i of t)
            if (!this._document._validateSelectionRange(i))
              throw new S("document-selection-wrong-position", this, { range: i });
        }
        _prepareRange(t) {
          if (this._checkRange(t), t.root == this._document.graveyard)
            return;
          const i = _i.fromRange(t);
          return i.on("change:range", (a, l, d) => {
            if (this._hasChangedRange = !0, i.root == this._document.graveyard) {
              this._selectionRestorePosition = d.deletionPosition;
              const g = this._ranges.indexOf(i);
              this._ranges.splice(g, 1), i.detach();
            }
          }), i;
        }
        updateMarkers() {
          if (!this._observedMarkers.size)
            return;
          const t = [];
          let i = !1;
          for (const l of this._model.markers) {
            const d = l.name.split(":", 1)[0];
            if (!this._observedMarkers.has(d))
              continue;
            const g = l.getRange();
            for (const m of this.getRanges())
              g.containsRange(m, !m.isCollapsed) && t.push(l);
          }
          const a = Array.from(this.markers);
          for (const l of t)
            this.markers.has(l) || (this.markers.add(l), i = !0);
          for (const l of Array.from(this.markers))
            t.includes(l) || (this.markers.remove(l), i = !0);
          i && this.fire("change:marker", { oldMarkers: a, directChange: !1 });
        }
        _updateMarker(t, i) {
          const a = t.name.split(":", 1)[0];
          if (!this._observedMarkers.has(a))
            return;
          let l = !1;
          const d = Array.from(this.markers), g = this.markers.has(t);
          if (i) {
            let m = !1;
            for (const w of this.getRanges())
              if (i.containsRange(w, !w.isCollapsed)) {
                m = !0;
                break;
              }
            m && !g ? (this.markers.add(t), l = !0) : !m && g && (this.markers.remove(t), l = !0);
          } else
            g && (this.markers.remove(t), l = !0);
          l && this.fire("change:marker", { oldMarkers: d, directChange: !1 });
        }
        _updateAttributes(t) {
          const i = Zi(this._getSurroundingAttributes()), a = Zi(this.getAttributes());
          if (t)
            this._attributePriority = /* @__PURE__ */ new Map(), this._attrs = /* @__PURE__ */ new Map();
          else
            for (const [d, g] of this._attributePriority)
              g == "low" && (this._attrs.delete(d), this._attributePriority.delete(d));
          this._setAttributesTo(i);
          const l = [];
          for (const [d, g] of this.getAttributes())
            a.has(d) && a.get(d) === g || l.push(d);
          for (const [d] of a)
            this.hasAttribute(d) || l.push(d);
          l.length > 0 && this.fire("change:attribute", { attributeKeys: l, directChange: !1 });
        }
        _setAttribute(t, i, a = !0) {
          const l = a ? "normal" : "low";
          return l == "low" && this._attributePriority.get(t) == "normal" ? !1 : super.getAttribute(t) !== i && (this._attrs.set(t, i), this._attributePriority.set(t, l), !0);
        }
        _removeAttribute(t, i = !0) {
          const a = i ? "normal" : "low";
          return (a != "low" || this._attributePriority.get(t) != "normal") && (this._attributePriority.set(t, a), !!super.hasAttribute(t) && (this._attrs.delete(t), !0));
        }
        _setAttributesTo(t) {
          const i = /* @__PURE__ */ new Set();
          for (const [a, l] of this.getAttributes())
            t.get(a) !== l && this._removeAttribute(a, !1);
          for (const [a, l] of t)
            this._setAttribute(a, l, !1) && i.add(a);
          return i;
        }
        *getStoredAttributes() {
          const t = this.getFirstPosition().parent;
          if (this.isCollapsed && t.isEmpty)
            for (const i of t.getAttributeKeys())
              i.startsWith(su) && (yield [i.substr(su.length), t.getAttribute(i)]);
        }
        _getSurroundingAttributes() {
          const t = this.getFirstPosition(), i = this._model.schema;
          let a = null;
          if (this.isCollapsed) {
            const l = t.textNode ? t.textNode : t.nodeBefore, d = t.textNode ? t.textNode : t.nodeAfter;
            if (this.isGravityOverridden || (a = Ch(l)), a || (a = Ch(d)), !this.isGravityOverridden && !a) {
              let g = l;
              for (; g && !i.isInline(g) && !a; )
                g = g.previousSibling, a = Ch(g);
            }
            if (!a) {
              let g = d;
              for (; g && !i.isInline(g) && !a; )
                g = g.nextSibling, a = Ch(g);
            }
            a || (a = this.getStoredAttributes());
          } else {
            const l = this.getFirstRange();
            for (const d of l) {
              if (d.item.is("element") && i.isObject(d.item))
                break;
              if (d.type == "text") {
                a = d.item.getAttributes();
                break;
              }
            }
          }
          return a;
        }
        _fixGraveyardSelection(t) {
          const i = this._model.schema.getNearestSelectionRange(t);
          i && this._pushRange(i);
        }
      }
      function Ch(c) {
        return c instanceof ki || c instanceof Jt ? c.getAttributes() : null;
      }
      class B_ {
        constructor(t) {
          this._dispatchers = t;
        }
        add(t) {
          for (const i of this._dispatchers)
            t(i);
          return this;
        }
      }
      const os = function(c) {
        return oa(c, 5);
      };
      class TN extends B_ {
        elementToElement(t) {
          return this.add(function(i) {
            const a = V_(i.model), l = lu(i.view, "container");
            return a.attributes.length && (a.children = !0), (d) => {
              d.on(`insert:${a.name}`, function(g, m = IN) {
                return (w, A, C) => {
                  if (!m(A.item, C.consumable, { preflight: !0 }))
                    return;
                  const T = g(A.item, C, A);
                  if (!T)
                    return;
                  m(A.item, C.consumable);
                  const R = C.mapper.toViewPosition(A.range.start);
                  C.mapper.bindElements(A.item, T), C.writer.insert(R, T), C.convertAttributes(A.item), q_(T, A.item.getChildren(), C, { reconversion: A.reconversion });
                };
              }(l, G_(a)), { priority: i.converterPriority || "normal" }), (a.children || a.attributes.length) && d.on("reduceChanges", W_(a), { priority: "low" });
            };
          }(t));
        }
        elementToStructure(t) {
          return this.add(function(i) {
            const a = V_(i.model), l = lu(i.view, "container");
            return a.children = !0, (d) => {
              if (d._conversionApi.schema.checkChild(a.name, "$text"))
                throw new S("conversion-element-to-structure-disallowed-text", d, { elementName: a.name });
              var g, m;
              d.on(`insert:${a.name}`, (g = l, m = G_(a), (w, A, C) => {
                if (!m(A.item, C.consumable, { preflight: !0 }))
                  return;
                const T = /* @__PURE__ */ new Map();
                C.writer._registerSlotFactory(function(F, V, W) {
                  return (ee, le = "children") => {
                    const be = ee.createContainerElement("$slot");
                    let Ne = null;
                    if (le === "children")
                      Ne = Array.from(F.getChildren());
                    else {
                      if (typeof le != "function")
                        throw new S("conversion-slot-mode-unknown", W.dispatcher, { modeOrFilter: le });
                      Ne = Array.from(F.getChildren()).filter((Je) => le(Je));
                    }
                    return V.set(be, Ne), be;
                  };
                }(A.item, T, C));
                const R = g(A.item, C, A);
                if (C.writer._clearSlotFactory(), !R)
                  return;
                (function(F, V, W) {
                  const ee = Array.from(V.values()).flat(), le = new Set(ee);
                  if (le.size != ee.length)
                    throw new S("conversion-slot-filter-overlap", W.dispatcher, { element: F });
                  if (le.size != F.childCount)
                    throw new S("conversion-slot-filter-incomplete", W.dispatcher, { element: F });
                })(A.item, T, C), m(A.item, C.consumable);
                const j = C.mapper.toViewPosition(A.range.start);
                C.mapper.bindElements(A.item, R), C.writer.insert(j, R), C.convertAttributes(A.item), function(F, V, W, ee) {
                  W.mapper.on("modelToViewPosition", Ne, { priority: "highest" });
                  let le = null, be = null;
                  for ([le, be] of V)
                    q_(F, be, W, ee), W.writer.move(W.writer.createRangeIn(le), W.writer.createPositionBefore(le)), W.writer.remove(le);
                  function Ne(Je, Mt) {
                    const Rt = Mt.modelPosition.nodeAfter, zn = be.indexOf(Rt);
                    zn < 0 || (Mt.viewPosition = Mt.mapper.findPositionIn(le, zn));
                  }
                  W.mapper.off("modelToViewPosition", Ne);
                }(R, T, C, { reconversion: A.reconversion });
              }), { priority: i.converterPriority || "normal" }), d.on("reduceChanges", W_(a), { priority: "low" });
            };
          }(t));
        }
        attributeToElement(t) {
          return this.add(function(i) {
            i = os(i);
            let a = i.model;
            typeof a == "string" && (a = { key: a });
            let l = `attribute:${a.key}`;
            if (a.name && (l += ":" + a.name), a.values)
              for (const g of a.values)
                i.view[g] = lu(i.view[g], "attribute");
            else
              i.view = lu(i.view, "attribute");
            const d = H_(i);
            return (g) => {
              g.on(l, function(m) {
                return (w, A, C) => {
                  if (!C.consumable.test(A.item, w.name))
                    return;
                  const T = m(A.attributeOldValue, C, A), R = m(A.attributeNewValue, C, A);
                  if (!T && !R)
                    return;
                  C.consumable.consume(A.item, w.name);
                  const j = C.writer, F = j.document.selection;
                  if (A.item instanceof ro || A.item instanceof Yr)
                    j.wrap(F.getFirstRange(), R);
                  else {
                    let V = C.mapper.toViewRange(A.range);
                    A.attributeOldValue !== null && T && (V = j.unwrap(V, T)), A.attributeNewValue !== null && R && j.wrap(V, R);
                  }
                };
              }(d), { priority: i.converterPriority || "normal" });
            };
          }(t));
        }
        attributeToAttribute(t) {
          return this.add(function(i) {
            i = os(i);
            let a = i.model;
            typeof a == "string" && (a = { key: a });
            let l = `attribute:${a.key}`;
            if (a.name && (l += ":" + a.name), a.values)
              for (const g of a.values)
                i.view[g] = U_(i.view[g]);
            else
              i.view = U_(i.view);
            const d = H_(i);
            return (g) => {
              var m;
              g.on(l, (m = d, (w, A, C) => {
                if (!C.consumable.test(A.item, w.name))
                  return;
                const T = m(A.attributeOldValue, C, A), R = m(A.attributeNewValue, C, A);
                if (!T && !R)
                  return;
                C.consumable.consume(A.item, w.name);
                const j = C.mapper.toViewElement(A.item), F = C.writer;
                if (!j)
                  throw new S("conversion-attribute-to-attribute-on-text", C.dispatcher, A);
                if (A.attributeOldValue !== null && T)
                  if (T.key == "class") {
                    const V = Yn(T.value);
                    for (const W of V)
                      F.removeClass(W, j);
                  } else if (T.key == "style") {
                    const V = Object.keys(T.value);
                    for (const W of V)
                      F.removeStyle(W, j);
                  } else
                    F.removeAttribute(T.key, j);
                if (A.attributeNewValue !== null && R)
                  if (R.key == "class") {
                    const V = Yn(R.value);
                    for (const W of V)
                      F.addClass(W, j);
                  } else if (R.key == "style") {
                    const V = Object.keys(R.value);
                    for (const W of V)
                      F.setStyle(W, R.value[W], j);
                  } else
                    F.setAttribute(R.key, R.value, j);
              }), { priority: i.converterPriority || "normal" });
            };
          }(t));
        }
        markerToElement(t) {
          return this.add(function(i) {
            const a = lu(i.view, "ui");
            return (l) => {
              var d;
              l.on(`addMarker:${i.model}`, (d = a, (g, m, w) => {
                m.isOpening = !0;
                const A = d(m, w);
                m.isOpening = !1;
                const C = d(m, w);
                if (!A || !C)
                  return;
                const T = m.markerRange;
                if (T.isCollapsed && !w.consumable.consume(T, g.name))
                  return;
                for (const F of T)
                  if (!w.consumable.consume(F.item, g.name))
                    return;
                const R = w.mapper, j = w.writer;
                j.insert(R.toViewPosition(T.start), A), w.mapper.bindElementToMarker(A, m.markerName), T.isCollapsed || (j.insert(R.toViewPosition(T.end), C), w.mapper.bindElementToMarker(C, m.markerName)), g.stop();
              }), { priority: i.converterPriority || "normal" }), l.on(`removeMarker:${i.model}`, (g, m, w) => {
                const A = w.mapper.markerNameToElements(m.markerName);
                if (A) {
                  for (const C of A)
                    w.mapper.unbindElementFromMarkerName(C, m.markerName), w.writer.clear(w.writer.createRangeOn(C), C);
                  w.writer.clearClonedElementsGroup(m.markerName), g.stop();
                }
              }, { priority: i.converterPriority || "normal" });
            };
          }(t));
        }
        markerToHighlight(t) {
          return this.add(function(i) {
            return (a) => {
              var l;
              a.on(`addMarker:${i.model}`, (l = i.view, (d, g, m) => {
                if (!g.item || !(g.item instanceof ro || g.item instanceof Yr || g.item.is("$textProxy")))
                  return;
                const w = n0(l, g, m);
                if (!w || !m.consumable.consume(g.item, d.name))
                  return;
                const A = m.writer, C = F_(A, w), T = A.document.selection;
                if (g.item instanceof ro || g.item instanceof Yr)
                  A.wrap(T.getFirstRange(), C);
                else {
                  const R = m.mapper.toViewRange(g.range), j = A.wrap(R, C);
                  for (const F of j.getItems())
                    if (F.is("attributeElement") && F.isSimilar(C)) {
                      m.mapper.bindElementToMarker(F, g.markerName);
                      break;
                    }
                }
              }), { priority: i.converterPriority || "normal" }), a.on(`addMarker:${i.model}`, function(d) {
                return (g, m, w) => {
                  if (!m.item || !(m.item instanceof Kt))
                    return;
                  const A = n0(d, m, w);
                  if (!A || !w.consumable.test(m.item, g.name))
                    return;
                  const C = w.mapper.toViewElement(m.item);
                  if (C && C.getCustomProperty("addHighlight")) {
                    w.consumable.consume(m.item, g.name);
                    for (const T of ve._createIn(m.item))
                      w.consumable.consume(T.item, g.name);
                    C.getCustomProperty("addHighlight")(C, A, w.writer), w.mapper.bindElementToMarker(C, m.markerName);
                  }
                };
              }(i.view), { priority: i.converterPriority || "normal" }), a.on(`removeMarker:${i.model}`, function(d) {
                return (g, m, w) => {
                  if (m.markerRange.isCollapsed)
                    return;
                  const A = n0(d, m, w);
                  if (!A)
                    return;
                  const C = F_(w.writer, A), T = w.mapper.markerNameToElements(m.markerName);
                  if (T) {
                    for (const R of T)
                      w.mapper.unbindElementFromMarkerName(R, m.markerName), R.is("attributeElement") ? w.writer.unwrap(w.writer.createRangeOn(R), C) : R.getCustomProperty("removeHighlight")(R, A.id, w.writer);
                    w.writer.clearClonedElementsGroup(m.markerName), g.stop();
                  }
                };
              }(i.view), { priority: i.converterPriority || "normal" });
            };
          }(t));
        }
        markerToData(t) {
          return this.add(function(i) {
            i = os(i);
            const a = i.model;
            let l = i.view;
            return l || (l = (d) => ({ group: a, name: d.substr(i.model.length + 1) })), (d) => {
              var g;
              d.on(`addMarker:${a}`, (g = l, (m, w, A) => {
                const C = g(w.markerName, A);
                if (!C)
                  return;
                const T = w.markerRange;
                A.consumable.consume(T, m.name) && (z_(T, !1, A, w, C), z_(T, !0, A, w, C), m.stop());
              }), { priority: i.converterPriority || "normal" }), d.on(`removeMarker:${a}`, function(m) {
                return (w, A, C) => {
                  const T = m(A.markerName, C);
                  if (!T)
                    return;
                  const R = C.mapper.markerNameToElements(A.markerName);
                  if (R) {
                    for (const F of R)
                      C.mapper.unbindElementFromMarkerName(F, A.markerName), F.is("containerElement") ? (j(`data-${T.group}-start-before`, F), j(`data-${T.group}-start-after`, F), j(`data-${T.group}-end-before`, F), j(`data-${T.group}-end-after`, F)) : C.writer.clear(C.writer.createRangeOn(F), F);
                    C.writer.clearClonedElementsGroup(A.markerName), w.stop();
                  }
                  function j(F, V) {
                    if (V.hasAttribute(F)) {
                      const W = new Set(V.getAttribute(F).split(","));
                      W.delete(T.name), W.size == 0 ? C.writer.removeAttribute(F, V) : C.writer.setAttribute(F, Array.from(W).join(","), V);
                    }
                  }
                };
              }(l), { priority: i.converterPriority || "normal" });
            };
          }(t));
        }
      }
      function F_(c, t) {
        const i = c.createAttributeElement("span", t.attributes);
        return t.classes && i._addClass(t.classes), typeof t.priority == "number" && (i._priority = t.priority), i._id = t.id, i;
      }
      function z_(c, t, i, a, l) {
        const d = t ? c.start : c.end, g = d.nodeAfter && d.nodeAfter.is("element") ? d.nodeAfter : null, m = d.nodeBefore && d.nodeBefore.is("element") ? d.nodeBefore : null;
        if (g || m) {
          let w, A;
          t && g || !t && !m ? (w = g, A = !0) : (w = m, A = !1);
          const C = i.mapper.toViewElement(w);
          if (C)
            return void function(T, R, j, F, V, W) {
              const ee = `data-${W.group}-${R ? "start" : "end"}-${j ? "before" : "after"}`, le = T.hasAttribute(ee) ? T.getAttribute(ee).split(",") : [];
              le.unshift(W.name), F.writer.setAttribute(ee, le.join(","), T), F.mapper.bindElementToMarker(T, V.markerName);
            }(C, t, A, i, a, l);
        }
        (function(w, A, C, T, R) {
          const j = `${R.group}-${A ? "start" : "end"}`, F = R.name ? { name: R.name } : null, V = C.writer.createUIElement(j, F);
          C.writer.insert(w, V), C.mapper.bindElementToMarker(V, T.markerName);
        })(i.mapper.toViewPosition(d), t, i, a, l);
      }
      function V_(c) {
        return typeof c == "string" && (c = { name: c }), c.attributes ? Array.isArray(c.attributes) || (c.attributes = [c.attributes]) : c.attributes = [], c.children = !!c.children, c;
      }
      function lu(c, t) {
        return typeof c == "function" ? c : (i, a) => function(l, d, g) {
          typeof l == "string" && (l = { name: l });
          let m;
          const w = d.writer, A = Object.assign({}, l.attributes);
          if (g == "container")
            m = w.createContainerElement(l.name, A);
          else if (g == "attribute") {
            const C = { priority: l.priority || ns.DEFAULT_PRIORITY };
            m = w.createAttributeElement(l.name, A, C);
          } else
            m = w.createUIElement(l.name, A);
          if (l.styles) {
            const C = Object.keys(l.styles);
            for (const T of C)
              w.setStyle(T, l.styles[T], m);
          }
          if (l.classes) {
            const C = l.classes;
            if (typeof C == "string")
              w.addClass(C, m);
            else
              for (const T of C)
                w.addClass(T, m);
          }
          return m;
        }(c, a, t);
      }
      function H_(c) {
        return c.model.values ? (t, i, a) => {
          const l = c.view[t];
          return l ? l(t, i, a) : null;
        } : c.view;
      }
      function U_(c) {
        return typeof c == "string" ? (t) => ({ key: c, value: t }) : typeof c == "object" ? c.value ? () => c : (t) => ({ key: c.key, value: t }) : c;
      }
      function n0(c, t, i) {
        const a = typeof c == "function" ? c(t, i) : c;
        return a ? (a.priority || (a.priority = 10), a.id || (a.id = t.markerName), a) : null;
      }
      function W_(c) {
        const t = function(i) {
          return (a, l) => {
            if (!a.is("element", i.name))
              return !1;
            if (l.type == "attribute") {
              if (i.attributes.includes(l.attributeKey))
                return !0;
            } else if (i.children)
              return !0;
            return !1;
          };
        }(c);
        return (i, a) => {
          const l = [];
          a.reconvertedElements || (a.reconvertedElements = /* @__PURE__ */ new Set());
          for (const d of a.changes) {
            const g = d.type == "attribute" ? d.range.start.nodeAfter : d.position.parent;
            if (g && t(g, d)) {
              if (!a.reconvertedElements.has(g)) {
                a.reconvertedElements.add(g);
                const m = Ee._createBefore(g);
                l.push({ type: "remove", name: g.name, position: m, length: 1 }, { type: "reinsert", name: g.name, position: m, length: 1 });
              }
            } else
              l.push(d);
          }
          a.changes = l;
        };
      }
      function G_(c) {
        return (t, i, a = {}) => {
          const l = ["insert"];
          for (const d of c.attributes)
            t.hasAttribute(d) && l.push(`attribute:${d}`);
          return !!l.every((d) => i.test(t, d)) && (a.preflight || l.forEach((d) => i.consume(t, d)), !0);
        };
      }
      function q_(c, t, i, a) {
        for (const l of t)
          DN(c.root, l, i, a) || i.convertItem(l);
      }
      function DN(c, t, i, a) {
        const { writer: l, mapper: d } = i;
        if (!a.reconversion)
          return !1;
        const g = d.toViewElement(t);
        return !(!g || g.root == c) && !!i.canReuseView(g) && (l.move(l.createRangeOn(g), d.toViewPosition(Ee._createBefore(t))), !0);
      }
      function IN(c, t, { preflight: i } = {}) {
        return i ? t.test(c, "insert") : t.consume(c, "insert");
      }
      function K_(c) {
        const { schema: t, document: i } = c.model;
        for (const a of i.getRootNames()) {
          const l = i.getRoot(a);
          if (l.isEmpty && !t.checkChild(l, "$text") && t.checkChild(l, "paragraph"))
            return c.insertElement("paragraph", l), !0;
        }
        return !1;
      }
      function Y_(c, t, i) {
        const a = i.createContext(c);
        return !!i.checkChild(a, "paragraph") && !!i.checkChild(a.push("paragraph"), t);
      }
      function Q_(c, t) {
        const i = t.createElement("paragraph");
        return t.insert(i, c), t.createPositionAt(i, 0);
      }
      class PN extends B_ {
        elementToElement(t) {
          return this.add(Z_(t));
        }
        elementToAttribute(t) {
          return this.add(function(i) {
            i = os(i), X_(i);
            const a = J_(i, !1), l = r0(i.view), d = l ? `element:${l}` : "element";
            return (g) => {
              g.on(d, a, { priority: i.converterPriority || "low" });
            };
          }(t));
        }
        attributeToAttribute(t) {
          return this.add(function(i) {
            i = os(i);
            let a = null;
            (typeof i.view == "string" || i.view.key) && (a = function(d) {
              typeof d.view == "string" && (d.view = { key: d.view });
              const g = d.view.key;
              let m;
              return g == "class" || g == "style" ? m = { [g == "class" ? "classes" : "styles"]: d.view.value } : m = { attributes: { [g]: d.view.value === void 0 ? /[\s\S]*/ : d.view.value } }, d.view.name && (m.name = d.view.name), d.view = m, g;
            }(i)), X_(i, a);
            const l = J_(i, !0);
            return (d) => {
              d.on("element", l, { priority: i.converterPriority || "low" });
            };
          }(t));
        }
        elementToMarker(t) {
          return this.add(function(i) {
            const a = function(l) {
              return (d, g) => {
                const m = typeof l == "string" ? l : l(d, g);
                return g.writer.createElement("$marker", { "data-name": m });
              };
            }(i.model);
            return Z_({ ...i, model: a });
          }(t));
        }
        dataToMarker(t) {
          return this.add(function(i) {
            i = os(i), i.model || (i.model = (g) => g ? i.view + ":" + g : i.view);
            const a = { view: i.view, model: i.model }, l = i0(eA(a, "start")), d = i0(eA(a, "end"));
            return (g) => {
              g.on(`element:${i.view}-start`, l, { priority: i.converterPriority || "normal" }), g.on(`element:${i.view}-end`, d, { priority: i.converterPriority || "normal" });
              const m = O.get("low"), w = O.get("highest"), A = O.get(i.converterPriority) / w;
              g.on("element", function(C) {
                return (T, R, j) => {
                  const F = `data-${C.view}`;
                  function V(W, ee) {
                    for (const le of ee) {
                      const be = C.model(le, j), Ne = j.writer.createElement("$marker", { "data-name": be });
                      j.writer.insert(Ne, W), R.modelCursor.isEqual(W) ? R.modelCursor = R.modelCursor.getShiftedBy(1) : R.modelCursor = R.modelCursor._getTransformedByInsertion(W, 1), R.modelRange = R.modelRange._getTransformedByInsertion(W, 1)[0];
                    }
                  }
                  (j.consumable.test(R.viewItem, { attributes: F + "-end-after" }) || j.consumable.test(R.viewItem, { attributes: F + "-start-after" }) || j.consumable.test(R.viewItem, { attributes: F + "-end-before" }) || j.consumable.test(R.viewItem, { attributes: F + "-start-before" })) && (R.modelRange || Object.assign(R, j.convertChildren(R.viewItem, R.modelCursor)), j.consumable.consume(R.viewItem, { attributes: F + "-end-after" }) && V(R.modelRange.end, R.viewItem.getAttribute(F + "-end-after").split(",")), j.consumable.consume(R.viewItem, { attributes: F + "-start-after" }) && V(R.modelRange.end, R.viewItem.getAttribute(F + "-start-after").split(",")), j.consumable.consume(R.viewItem, { attributes: F + "-end-before" }) && V(R.modelRange.start, R.viewItem.getAttribute(F + "-end-before").split(",")), j.consumable.consume(R.viewItem, { attributes: F + "-start-before" }) && V(R.modelRange.start, R.viewItem.getAttribute(F + "-start-before").split(",")));
                };
              }(a), { priority: m + A });
            };
          }(t));
        }
      }
      function Z_(c) {
        const t = i0(c = os(c)), i = r0(c.view), a = i ? `element:${i}` : "element";
        return (l) => {
          l.on(a, t, { priority: c.converterPriority || "normal" });
        };
      }
      function r0(c) {
        return typeof c == "string" ? c : typeof c == "object" && typeof c.name == "string" ? c.name : null;
      }
      function i0(c) {
        const t = new Ji(c.view);
        return (i, a, l) => {
          const d = t.match(a.viewItem);
          if (!d)
            return;
          const g = d.match;
          if (g.name = !0, !l.consumable.test(a.viewItem, g))
            return;
          const m = function(w, A, C) {
            return w instanceof Function ? w(A, C) : C.writer.createElement(w);
          }(c.model, a.viewItem, l);
          m && l.safeInsert(m, a.modelCursor) && (l.consumable.consume(a.viewItem, g), l.convertChildren(a.viewItem, m), l.updateConversionResult(m, a));
        };
      }
      function X_(c, t = null) {
        const i = t === null || ((d) => d.getAttribute(t)), a = typeof c.model != "object" ? c.model : c.model.key, l = typeof c.model != "object" || c.model.value === void 0 ? i : c.model.value;
        c.model = { key: a, value: l };
      }
      function J_(c, t) {
        const i = new Ji(c.view);
        return (a, l, d) => {
          if (!l.modelRange && t)
            return;
          const g = i.match(l.viewItem);
          if (!g || (function(C, T) {
            const R = typeof C == "function" ? C(T) : C;
            return typeof R == "object" && !r0(R) ? !1 : !R.classes && !R.attributes && !R.styles;
          }(c.view, l.viewItem) ? g.match.name = !0 : delete g.match.name, !d.consumable.test(l.viewItem, g.match)))
            return;
          const m = c.model.key, w = typeof c.model.value == "function" ? c.model.value(l.viewItem, d) : c.model.value;
          if (w === null)
            return;
          l.modelRange || Object.assign(l, d.convertChildren(l.viewItem, l.modelCursor)), function(C, T, R, j) {
            let F = !1;
            for (const V of Array.from(C.getItems({ shallow: R })))
              j.schema.checkAttribute(V, T.key) && (F = !0, V.hasAttribute(T.key) || j.writer.setAttribute(T.key, T.value, V));
            return F;
          }(l.modelRange, { key: m, value: w }, t, d) && (d.consumable.test(l.viewItem, { name: !0 }) && (g.match.name = !0), d.consumable.consume(l.viewItem, g.match));
        };
      }
      function eA(c, t) {
        return { view: `${c.view}-${t}`, model: (i, a) => {
          const l = i.getAttribute("name"), d = c.model(l, a);
          return a.writer.createElement("$marker", { "data-name": d });
        } };
      }
      class ON extends Te() {
        constructor(t, i) {
          super(), this.model = t, this.view = new _N(i), this.mapper = new R_(), this.downcastDispatcher = new N_({ mapper: this.mapper, schema: t.schema });
          const a = this.model.document, l = a.selection, d = this.model.markers;
          this.listenTo(this.model, "_beforeChanges", () => {
            this.view._disableRendering(!0);
          }, { priority: "highest" }), this.listenTo(this.model, "_afterChanges", () => {
            this.view._disableRendering(!1);
          }, { priority: "lowest" }), this.listenTo(a, "change", () => {
            this.view.change((g) => {
              this.downcastDispatcher.convertChanges(a.differ, d, g), this.downcastDispatcher.convertSelection(l, d, g);
            });
          }, { priority: "low" }), this.listenTo(this.view.document, "selectionChange", function(g, m) {
            return (w, A) => {
              const C = A.newSelection, T = [];
              for (const j of C.getRanges())
                T.push(m.toModelRange(j));
              const R = g.createSelection(T, { backward: C.isBackward });
              R.isEqual(g.document.selection) || g.change((j) => {
                j.setSelection(R);
              });
            };
          }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", (g, m, w) => {
            if (!w.consumable.consume(m.item, g.name))
              return;
            const A = w.writer, C = w.mapper.toViewPosition(m.range.start), T = A.createText(m.item.data);
            A.insert(C, T);
          }, { priority: "lowest" }), this.downcastDispatcher.on("insert", (g, m, w) => {
            w.convertAttributes(m.item), m.reconversion || !m.item.is("element") || m.item.isEmpty || w.convertChildren(m.item);
          }, { priority: "lowest" }), this.downcastDispatcher.on("remove", (g, m, w) => {
            const A = w.mapper.toViewPosition(m.position), C = m.position.getShiftedBy(m.length), T = w.mapper.toViewPosition(C, { isPhantom: !0 }), R = w.writer.createRange(A, T), j = w.writer.remove(R.getTrimmed());
            for (const F of w.writer.createRangeIn(j).getItems())
              w.mapper.unbindViewElement(F, { defer: !0 });
          }, { priority: "low" }), this.downcastDispatcher.on("selection", (g, m, w) => {
            const A = w.writer, C = A.document.selection;
            for (const T of C.getRanges())
              T.isCollapsed && T.end.parent.isAttached() && w.writer.mergeAttributes(T.start);
            A.setSelection(null);
          }, { priority: "high" }), this.downcastDispatcher.on("selection", (g, m, w) => {
            const A = m.selection;
            if (A.isCollapsed || !w.consumable.consume(A, "selection"))
              return;
            const C = [];
            for (const T of A.getRanges())
              C.push(w.mapper.toViewRange(T));
            w.writer.setSelection(C, { backward: A.isBackward });
          }, { priority: "low" }), this.downcastDispatcher.on("selection", (g, m, w) => {
            const A = m.selection;
            if (!A.isCollapsed || !w.consumable.consume(A, "selection"))
              return;
            const C = w.writer, T = A.getFirstPosition(), R = w.mapper.toViewPosition(T), j = C.breakAttributes(R);
            C.setSelection(j);
          }, { priority: "low" }), this.view.document.roots.bindTo(this.model.document.roots).using((g) => {
            if (g.rootName == "$graveyard")
              return null;
            const m = new t_(this.view.document, g.name);
            return m.rootName = g.rootName, this.mapper.bindElements(g, m), m;
          });
        }
        destroy() {
          this.view.destroy(), this.stopListening();
        }
        reconvertMarker(t) {
          const i = typeof t == "string" ? t : t.name, a = this.model.markers.get(i);
          if (!a)
            throw new S("editingcontroller-reconvertmarker-marker-not-exist", this, { markerName: i });
          this.model.change(() => {
            this.model.markers._refresh(a);
          });
        }
        reconvertItem(t) {
          this.model.change(() => {
            this.model.document.differ._refreshItem(t);
          });
        }
      }
      class cu {
        constructor() {
          this._consumables = /* @__PURE__ */ new Map();
        }
        add(t, i) {
          let a;
          t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? a = this._consumables.get(t) : (a = new RN(t), this._consumables.set(t, a)), a.add(i));
        }
        test(t, i) {
          const a = this._consumables.get(t);
          return a === void 0 ? null : t.is("$text") || t.is("documentFragment") ? a : a.test(i);
        }
        consume(t, i) {
          return !!this.test(t, i) && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(i), !0);
        }
        revert(t, i) {
          const a = this._consumables.get(t);
          a !== void 0 && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : a.revert(i));
        }
        static consumablesFromElement(t) {
          const i = { element: t, name: !0, attributes: [], classes: [], styles: [] }, a = t.getAttributeKeys();
          for (const g of a)
            g != "style" && g != "class" && i.attributes.push(g);
          const l = t.getClassNames();
          for (const g of l)
            i.classes.push(g);
          const d = t.getStyleNames();
          for (const g of d)
            i.styles.push(g);
          return i;
        }
        static createFrom(t, i) {
          if (i || (i = new cu()), t.is("$text"))
            return i.add(t), i;
          t.is("element") && i.add(t, cu.consumablesFromElement(t)), t.is("documentFragment") && i.add(t);
          for (const a of t.getChildren())
            i = cu.createFrom(a, i);
          return i;
        }
      }
      const xh = ["attributes", "classes", "styles"];
      class RN {
        constructor(t) {
          this.element = t, this._canConsumeName = null, this._consumables = { attributes: /* @__PURE__ */ new Map(), styles: /* @__PURE__ */ new Map(), classes: /* @__PURE__ */ new Map() };
        }
        add(t) {
          t.name && (this._canConsumeName = !0);
          for (const i of xh)
            i in t && this._add(i, t[i]);
        }
        test(t) {
          if (t.name && !this._canConsumeName)
            return this._canConsumeName;
          for (const i of xh)
            if (i in t) {
              const a = this._test(i, t[i]);
              if (a !== !0)
                return a;
            }
          return !0;
        }
        consume(t) {
          t.name && (this._canConsumeName = !1);
          for (const i of xh)
            i in t && this._consume(i, t[i]);
        }
        revert(t) {
          t.name && (this._canConsumeName = !0);
          for (const i of xh)
            i in t && this._revert(i, t[i]);
        }
        _add(t, i) {
          const a = Zt(i) ? i : [i], l = this._consumables[t];
          for (const d of a) {
            if (t === "attributes" && (d === "class" || d === "style"))
              throw new S("viewconsumable-invalid-attribute", this);
            if (l.set(d, !0), t === "styles")
              for (const g of this.element.document.stylesProcessor.getRelatedStyles(d))
                l.set(g, !0);
          }
        }
        _test(t, i) {
          const a = Zt(i) ? i : [i], l = this._consumables[t];
          for (const d of a)
            if (t !== "attributes" || d !== "class" && d !== "style") {
              const g = l.get(d);
              if (g === void 0)
                return null;
              if (!g)
                return !1;
            } else {
              const g = d == "class" ? "classes" : "styles", m = this._test(g, [...this._consumables[g].keys()]);
              if (m !== !0)
                return m;
            }
          return !0;
        }
        _consume(t, i) {
          const a = Zt(i) ? i : [i], l = this._consumables[t];
          for (const d of a)
            if (t !== "attributes" || d !== "class" && d !== "style") {
              if (l.set(d, !1), t == "styles")
                for (const g of this.element.document.stylesProcessor.getRelatedStyles(d))
                  l.set(g, !1);
            } else {
              const g = d == "class" ? "classes" : "styles";
              this._consume(g, [...this._consumables[g].keys()]);
            }
        }
        _revert(t, i) {
          const a = Zt(i) ? i : [i], l = this._consumables[t];
          for (const d of a)
            if (t !== "attributes" || d !== "class" && d !== "style")
              l.get(d) === !1 && l.set(d, !0);
            else {
              const g = d == "class" ? "classes" : "styles";
              this._revert(g, [...this._consumables[g].keys()]);
            }
        }
      }
      class NN extends Te() {
        constructor() {
          super(), this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (t, i) => {
            i[0] = new as(i[0]);
          }, { priority: "highest" }), this.on("checkChild", (t, i) => {
            i[0] = new as(i[0]), i[1] = this.getDefinition(i[1]);
          }, { priority: "highest" });
        }
        register(t, i) {
          if (this._sourceDefinitions[t])
            throw new S("schema-cannot-register-item-twice", this, { itemName: t });
          this._sourceDefinitions[t] = [Object.assign({}, i)], this._clearCache();
        }
        extend(t, i) {
          if (!this._sourceDefinitions[t])
            throw new S("schema-cannot-extend-missing-item", this, { itemName: t });
          this._sourceDefinitions[t].push(Object.assign({}, i)), this._clearCache();
        }
        getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
        getDefinition(t) {
          let i;
          return i = typeof t == "string" ? t : "is" in t && (t.is("$text") || t.is("$textProxy")) ? "$text" : t.name, this.getDefinitions()[i];
        }
        isRegistered(t) {
          return !!this.getDefinition(t);
        }
        isBlock(t) {
          const i = this.getDefinition(t);
          return !(!i || !i.isBlock);
        }
        isLimit(t) {
          const i = this.getDefinition(t);
          return !!i && !(!i.isLimit && !i.isObject);
        }
        isObject(t) {
          const i = this.getDefinition(t);
          return !!i && !!(i.isObject || i.isLimit && i.isSelectable && i.isContent);
        }
        isInline(t) {
          const i = this.getDefinition(t);
          return !(!i || !i.isInline);
        }
        isSelectable(t) {
          const i = this.getDefinition(t);
          return !!i && !(!i.isSelectable && !i.isObject);
        }
        isContent(t) {
          const i = this.getDefinition(t);
          return !!i && !(!i.isContent && !i.isObject);
        }
        checkChild(t, i) {
          return !!i && this._checkContextMatch(i, t);
        }
        checkAttribute(t, i) {
          const a = this.getDefinition(t.last);
          return !!a && a.allowAttributes.includes(i);
        }
        checkMerge(t, i) {
          if (t instanceof Ee) {
            const a = t.nodeBefore, l = t.nodeAfter;
            if (!(a instanceof Kt))
              throw new S("schema-check-merge-no-element-before", this);
            if (!(l instanceof Kt))
              throw new S("schema-check-merge-no-element-after", this);
            return this.checkMerge(a, l);
          }
          for (const a of i.getChildren())
            if (!this.checkChild(t, a))
              return !1;
          return !0;
        }
        addChildCheck(t) {
          this.on("checkChild", (i, [a, l]) => {
            if (!l)
              return;
            const d = t(a, l);
            typeof d == "boolean" && (i.stop(), i.return = d);
          }, { priority: "high" });
        }
        addAttributeCheck(t) {
          this.on("checkAttribute", (i, [a, l]) => {
            const d = t(a, l);
            typeof d == "boolean" && (i.stop(), i.return = d);
          }, { priority: "high" });
        }
        setAttributeProperties(t, i) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), i);
        }
        getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
        getLimitElement(t) {
          let i;
          for (t instanceof Ee ? i = t.parent : i = (t instanceof ve ? [t] : Array.from(t.getRanges())).reduce((a, l) => {
            const d = l.getCommonAncestor();
            return a ? a.getCommonAncestor(d, { includeSelf: !0 }) : d;
          }, null); !this.isLimit(i) && i.parent; )
            i = i.parent;
          return i;
        }
        checkAttributeInSelection(t, i) {
          if (t.isCollapsed) {
            const a = [...t.getFirstPosition().getAncestors(), new Jt("", t.getAttributes())];
            return this.checkAttribute(a, i);
          }
          {
            const a = t.getRanges();
            for (const l of a)
              for (const d of l)
                if (this.checkAttribute(d.item, i))
                  return !0;
          }
          return !1;
        }
        *getValidRanges(t, i) {
          t = function* (a) {
            for (const l of a)
              yield* l.getMinimalFlatRanges();
          }(t);
          for (const a of t)
            yield* this._getValidRangesForRange(a, i);
        }
        getNearestSelectionRange(t, i = "both") {
          if (this.checkChild(t, "$text"))
            return new ve(t);
          let a, l;
          const d = t.getAncestors().reverse().find((g) => this.isLimit(g)) || t.root;
          i != "both" && i != "backward" || (a = new no({ boundaries: ve._createIn(d), startPosition: t, direction: "backward" })), i != "both" && i != "forward" || (l = new no({ boundaries: ve._createIn(d), startPosition: t }));
          for (const g of function* (m, w) {
            let A = !1;
            for (; !A; ) {
              if (A = !0, m) {
                const C = m.next();
                C.done || (A = !1, yield { walker: m, value: C.value });
              }
              if (w) {
                const C = w.next();
                C.done || (A = !1, yield { walker: w, value: C.value });
              }
            }
          }(a, l)) {
            const m = g.walker == a ? "elementEnd" : "elementStart", w = g.value;
            if (w.type == m && this.isObject(w.item))
              return ve._createOn(w.item);
            if (this.checkChild(w.nextPosition, "$text"))
              return new ve(w.nextPosition);
          }
          return null;
        }
        findAllowedParent(t, i) {
          let a = t.parent;
          for (; a; ) {
            if (this.checkChild(a, i))
              return a;
            if (this.isLimit(a))
              return null;
            a = a.parent;
          }
          return null;
        }
        setAllowedAttributes(t, i, a) {
          const l = a.model;
          for (const [d, g] of Object.entries(i))
            l.schema.checkAttribute(t, d) && a.setAttribute(d, g, t);
        }
        removeDisallowedAttributes(t, i) {
          for (const a of t)
            if (a.is("$text"))
              tA(this, a, i);
            else {
              const l = ve._createIn(a).getPositions();
              for (const d of l)
                tA(this, d.nodeBefore || d.parent, i);
            }
        }
        getAttributesWithProperty(t, i, a) {
          const l = {};
          for (const [d, g] of t.getAttributes()) {
            const m = this.getAttributeProperties(d);
            m[i] !== void 0 && (a !== void 0 && a !== m[i] || (l[d] = g));
          }
          return l;
        }
        createContext(t) {
          return new as(t);
        }
        _clearCache() {
          this._compiledDefinitions = null;
        }
        _compile() {
          const t = {}, i = this._sourceDefinitions, a = Object.keys(i);
          for (const l of a)
            t[l] = $N(i[l], l);
          for (const l of a)
            LN(t, l);
          for (const l of a)
            jN(t, l);
          for (const l of a)
            BN(t, l);
          for (const l of a)
            FN(t, l), zN(t, l);
          for (const l of a)
            VN(t, l), HN(t, l), UN(t, l);
          this._compiledDefinitions = t;
        }
        _checkContextMatch(t, i, a = i.length - 1) {
          const l = i.getItem(a);
          if (t.allowIn.includes(l.name)) {
            if (a == 0)
              return !0;
            {
              const d = this.getDefinition(l);
              return this._checkContextMatch(d, i, a - 1);
            }
          }
          return !1;
        }
        *_getValidRangesForRange(t, i) {
          let a = t.start, l = t.start;
          for (const d of t.getItems({ shallow: !0 }))
            d.is("element") && (yield* this._getValidRangesForRange(ve._createIn(d), i)), this.checkAttribute(d, i) || (a.isEqual(l) || (yield new ve(a, l)), a = Ee._createAfter(d)), l = Ee._createAfter(d);
          a.isEqual(l) || (yield new ve(a, l));
        }
      }
      class as {
        constructor(t) {
          if (t instanceof as)
            return t;
          let i;
          i = typeof t == "string" ? [t] : Array.isArray(t) ? t : t.getAncestors({ includeSelf: !0 }), this._items = i.map(GN);
        }
        get length() {
          return this._items.length;
        }
        get last() {
          return this._items[this._items.length - 1];
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]();
        }
        push(t) {
          const i = new as([t]);
          return i._items = [...this._items, ...i._items], i;
        }
        getItem(t) {
          return this._items[t];
        }
        *getNames() {
          yield* this._items.map((t) => t.name);
        }
        endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
        startsWith(t) {
          return Array.from(this.getNames()).join(" ").startsWith(t);
        }
      }
      function $N(c, t) {
        const i = { name: t, allowIn: [], allowContentOf: [], allowWhere: [], allowAttributes: [], allowAttributesOf: [], allowChildren: [], inheritTypesFrom: [] };
        return function(a, l) {
          for (const d of a) {
            const g = Object.keys(d).filter((m) => m.startsWith("is"));
            for (const m of g)
              l[m] = !!d[m];
          }
        }(c, i), ss(c, i, "allowIn"), ss(c, i, "allowContentOf"), ss(c, i, "allowWhere"), ss(c, i, "allowAttributes"), ss(c, i, "allowAttributesOf"), ss(c, i, "allowChildren"), ss(c, i, "inheritTypesFrom"), function(a, l) {
          for (const d of a) {
            const g = d.inheritAllFrom;
            g && (l.allowContentOf.push(g), l.allowWhere.push(g), l.allowAttributesOf.push(g), l.inheritTypesFrom.push(g));
          }
        }(c, i), i;
      }
      function LN(c, t) {
        const i = c[t];
        for (const a of i.allowChildren) {
          const l = c[a];
          l && l.allowIn.push(t);
        }
        i.allowChildren.length = 0;
      }
      function jN(c, t) {
        for (const i of c[t].allowContentOf)
          c[i] && WN(c, i).forEach((a) => {
            a.allowIn.push(t);
          });
        delete c[t].allowContentOf;
      }
      function BN(c, t) {
        for (const i of c[t].allowWhere) {
          const a = c[i];
          if (a) {
            const l = a.allowIn;
            c[t].allowIn.push(...l);
          }
        }
        delete c[t].allowWhere;
      }
      function FN(c, t) {
        for (const i of c[t].allowAttributesOf) {
          const a = c[i];
          if (a) {
            const l = a.allowAttributes;
            c[t].allowAttributes.push(...l);
          }
        }
        delete c[t].allowAttributesOf;
      }
      function zN(c, t) {
        const i = c[t];
        for (const a of i.inheritTypesFrom) {
          const l = c[a];
          if (l) {
            const d = Object.keys(l).filter((g) => g.startsWith("is"));
            for (const g of d)
              g in i || (i[g] = l[g]);
          }
        }
        delete i.inheritTypesFrom;
      }
      function VN(c, t) {
        const i = c[t], a = i.allowIn.filter((l) => c[l]);
        i.allowIn = Array.from(new Set(a));
      }
      function HN(c, t) {
        const i = c[t];
        for (const a of i.allowIn)
          c[a].allowChildren.push(t);
      }
      function UN(c, t) {
        const i = c[t];
        i.allowAttributes = Array.from(new Set(i.allowAttributes));
      }
      function ss(c, t, i) {
        for (const a of c) {
          const l = a[i];
          typeof l == "string" ? t[i].push(l) : Array.isArray(l) && t[i].push(...l);
        }
      }
      function WN(c, t) {
        const i = c[t];
        return (a = c, Object.keys(a).map((l) => a[l])).filter((l) => l.allowIn.includes(i.name));
        var a;
      }
      function GN(c) {
        return typeof c == "string" || c.is("documentFragment") ? { name: typeof c == "string" ? c : "$documentFragment", *getAttributeKeys() {
        }, getAttribute() {
        } } : { name: c.is("element") ? c.name : "$text", *getAttributeKeys() {
          yield* c.getAttributeKeys();
        }, getAttribute: (t) => c.getAttribute(t) };
      }
      function tA(c, t, i) {
        for (const a of t.getAttributeKeys())
          c.checkAttribute(t, a) || i.removeAttribute(a, t);
      }
      class qN extends ie() {
        constructor(t) {
          super(), this._splitParts = /* @__PURE__ */ new Map(), this._cursorParents = /* @__PURE__ */ new Map(), this._modelCursor = null, this._emptyElementsToKeep = /* @__PURE__ */ new Set(), this.conversionApi = { ...t, consumable: null, writer: null, store: null, convertItem: (i, a) => this._convertItem(i, a), convertChildren: (i, a) => this._convertChildren(i, a), safeInsert: (i, a) => this._safeInsert(i, a), updateConversionResult: (i, a) => this._updateConversionResult(i, a), splitToAllowedParent: (i, a) => this._splitToAllowedParent(i, a), getSplitParts: (i) => this._getSplitParts(i), keepEmptyElement: (i) => this._keepEmptyElement(i) };
        }
        convert(t, i, a = ["$root"]) {
          this.fire("viewCleanup", t), this._modelCursor = function(g, m) {
            let w;
            for (const A of new as(g)) {
              const C = {};
              for (const R of A.getAttributeKeys())
                C[R] = A.getAttribute(R);
              const T = m.createElement(A.name, C);
              w && m.insert(T, w), w = Ee._createAt(T, 0);
            }
            return w;
          }(a, i), this.conversionApi.writer = i, this.conversionApi.consumable = cu.createFrom(t), this.conversionApi.store = {};
          const { modelRange: l } = this._convertItem(t, this._modelCursor), d = i.createDocumentFragment();
          if (l) {
            this._removeEmptyElements();
            for (const g of Array.from(this._modelCursor.parent.getChildren()))
              i.append(g, d);
            d.markers = function(g, m) {
              const w = /* @__PURE__ */ new Set(), A = /* @__PURE__ */ new Map(), C = ve._createIn(g).getItems();
              for (const T of C)
                T.is("element", "$marker") && w.add(T);
              for (const T of w) {
                const R = T.getAttribute("data-name"), j = m.createPositionBefore(T);
                A.has(R) ? A.get(R).end = j.clone() : A.set(R, new ve(j.clone())), m.remove(T);
              }
              return A;
            }(d, i);
          }
          return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, d;
        }
        _convertItem(t, i) {
          const a = { viewItem: t, modelCursor: i, modelRange: null };
          if (t.is("element") ? this.fire(`element:${t.name}`, a, this.conversionApi) : t.is("$text") ? this.fire("text", a, this.conversionApi) : this.fire("documentFragment", a, this.conversionApi), a.modelRange && !(a.modelRange instanceof ve))
            throw new S("view-conversion-dispatcher-incorrect-result", this);
          return { modelRange: a.modelRange, modelCursor: a.modelCursor };
        }
        _convertChildren(t, i) {
          let a = i.is("position") ? i : Ee._createAt(i, 0);
          const l = new ve(a);
          for (const d of Array.from(t.getChildren())) {
            const g = this._convertItem(d, a);
            g.modelRange instanceof ve && (l.end = g.modelRange.end, a = g.modelCursor);
          }
          return { modelRange: l, modelCursor: a };
        }
        _safeInsert(t, i) {
          const a = this._splitToAllowedParent(t, i);
          return !!a && (this.conversionApi.writer.insert(t, a.position), !0);
        }
        _updateConversionResult(t, i) {
          const a = this._getSplitParts(t), l = this.conversionApi.writer;
          i.modelRange || (i.modelRange = l.createRange(l.createPositionBefore(t), l.createPositionAfter(a[a.length - 1])));
          const d = this._cursorParents.get(t);
          i.modelCursor = d ? l.createPositionAt(d, 0) : i.modelRange.end;
        }
        _splitToAllowedParent(t, i) {
          const { schema: a, writer: l } = this.conversionApi;
          let d = a.findAllowedParent(i, t);
          if (d) {
            if (d === i.parent)
              return { position: i };
            this._modelCursor.parent.getAncestors().includes(d) && (d = null);
          }
          if (!d)
            return Y_(i, t, a) ? { position: Q_(i, l) } : null;
          const g = this.conversionApi.writer.split(i, d), m = [];
          for (const A of g.range.getWalker())
            if (A.type == "elementEnd")
              m.push(A.item);
            else {
              const C = m.pop(), T = A.item;
              this._registerSplitPair(C, T);
            }
          const w = g.range.end.parent;
          return this._cursorParents.set(t, w), { position: g.position, cursorParent: w };
        }
        _registerSplitPair(t, i) {
          this._splitParts.has(t) || this._splitParts.set(t, [t]);
          const a = this._splitParts.get(t);
          this._splitParts.set(i, a), a.push(i);
        }
        _getSplitParts(t) {
          let i;
          return i = this._splitParts.has(t) ? this._splitParts.get(t) : [t], i;
        }
        _keepEmptyElement(t) {
          this._emptyElementsToKeep.add(t);
        }
        _removeEmptyElements() {
          let t = !1;
          for (const i of this._splitParts.keys())
            i.isEmpty && !this._emptyElementsToKeep.has(i) && (this.conversionApi.writer.remove(i), this._splitParts.delete(i), t = !0);
          t && this._removeEmptyElements();
        }
      }
      class KN {
        getHtml(t) {
          const i = document.implementation.createHTMLDocument("").createElement("div");
          return i.appendChild(t), i.innerHTML;
        }
      }
      class YN {
        constructor(t) {
          this.skipComments = !0, this.domParser = new DOMParser(), this.domConverter = new yh(t, { renderingMode: "data" }), this.htmlWriter = new KN();
        }
        toData(t) {
          const i = this.domConverter.viewToDom(t);
          return this.htmlWriter.getHtml(i);
        }
        toView(t) {
          const i = this._toDom(t);
          return this.domConverter.domToView(i, { skipComments: this.skipComments });
        }
        registerRawContentMatcher(t) {
          this.domConverter.registerRawContentMatcher(t);
        }
        useFillerType(t) {
          this.domConverter.blockFillerMode = t == "marked" ? "markedNbsp" : "nbsp";
        }
        _toDom(t) {
          t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (t = `<body>${t}</body>`);
          const i = this.domParser.parseFromString(t, "text/html"), a = i.createDocumentFragment(), l = i.body.childNodes;
          for (; l.length > 0; )
            a.appendChild(l[0]);
          return a;
        }
      }
      class QN extends ie() {
        constructor(t, i) {
          super(), this.model = t, this.mapper = new R_(), this.downcastDispatcher = new N_({ mapper: this.mapper, schema: t.schema }), this.downcastDispatcher.on("insert:$text", (a, l, d) => {
            if (!d.consumable.consume(l.item, a.name))
              return;
            const g = d.writer, m = d.mapper.toViewPosition(l.range.start), w = g.createText(l.item.data);
            g.insert(m, w);
          }, { priority: "lowest" }), this.downcastDispatcher.on("insert", (a, l, d) => {
            d.convertAttributes(l.item), l.reconversion || !l.item.is("element") || l.item.isEmpty || d.convertChildren(l.item);
          }, { priority: "lowest" }), this.upcastDispatcher = new qN({ schema: t.schema }), this.viewDocument = new mh(i), this.stylesProcessor = i, this.htmlProcessor = new YN(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new r_(this.viewDocument), this.upcastDispatcher.on("text", (a, l, { schema: d, consumable: g, writer: m }) => {
            let w = l.modelCursor;
            if (!g.test(l.viewItem))
              return;
            if (!d.checkChild(w, "$text")) {
              if (!Y_(w, "$text", d) || l.viewItem.data.trim().length == 0)
                return;
              w = Q_(w, m);
            }
            g.consume(l.viewItem);
            const A = m.createText(l.viewItem.data);
            m.insert(A, w), l.modelRange = m.createRange(w, w.getShiftedBy(A.offsetSize)), l.modelCursor = l.modelRange.end;
          }, { priority: "lowest" }), this.upcastDispatcher.on("element", (a, l, d) => {
            if (!l.modelRange && d.consumable.consume(l.viewItem, { name: !0 })) {
              const { modelRange: g, modelCursor: m } = d.convertChildren(l.viewItem, l.modelCursor);
              l.modelRange = g, l.modelCursor = m;
            }
          }, { priority: "lowest" }), this.upcastDispatcher.on("documentFragment", (a, l, d) => {
            if (!l.modelRange && d.consumable.consume(l.viewItem, { name: !0 })) {
              const { modelRange: g, modelCursor: m } = d.convertChildren(l.viewItem, l.modelCursor);
              l.modelRange = g, l.modelCursor = m;
            }
          }, { priority: "lowest" }), Te().prototype.decorate.call(this, "init"), Te().prototype.decorate.call(this, "set"), Te().prototype.decorate.call(this, "get"), this.on("init", () => {
            this.fire("ready");
          }, { priority: "lowest" }), this.on("ready", () => {
            this.model.enqueueChange({ isUndoable: !1 }, K_);
          }, { priority: "lowest" });
        }
        get(t = {}) {
          const { rootName: i = "main", trim: a = "empty" } = t;
          if (!this._checkIfRootsExists([i]))
            throw new S("datacontroller-get-non-existent-root", this);
          const l = this.model.document.getRoot(i);
          return a !== "empty" || this.model.hasContent(l, { ignoreWhitespaces: !0 }) ? this.stringify(l, t) : "";
        }
        stringify(t, i = {}) {
          const a = this.toView(t, i);
          return this.processor.toData(a);
        }
        toView(t, i = {}) {
          const a = this.viewDocument, l = this._viewWriter;
          this.mapper.clearBindings();
          const d = ve._createIn(t), g = new rs(a);
          this.mapper.bindElements(t, g);
          const m = t.is("documentFragment") ? t.markers : function(w) {
            const A = [], C = w.root.document;
            if (!C)
              return /* @__PURE__ */ new Map();
            const T = ve._createIn(w);
            for (const R of C.model.markers) {
              const j = R.getRange(), F = j.isCollapsed, V = j.start.isEqual(T.start) || j.end.isEqual(T.end);
              if (F && V)
                A.push([R.name, j]);
              else {
                const W = T.getIntersection(j);
                W && A.push([R.name, W]);
              }
            }
            return A.sort(([R, j], [F, V]) => {
              if (j.end.compareWith(V.start) !== "after")
                return 1;
              if (j.start.compareWith(V.end) !== "before")
                return -1;
              switch (j.start.compareWith(V.start)) {
                case "before":
                  return 1;
                case "after":
                  return -1;
                default:
                  switch (j.end.compareWith(V.end)) {
                    case "before":
                      return 1;
                    case "after":
                      return -1;
                    default:
                      return F.localeCompare(R);
                  }
              }
            }), new Map(A);
          }(t);
          return this.downcastDispatcher.convert(d, m, l, i), g;
        }
        init(t) {
          if (this.model.document.version)
            throw new S("datacontroller-init-document-not-empty", this);
          let i = {};
          if (typeof t == "string" ? i.main = t : i = t, !this._checkIfRootsExists(Object.keys(i)))
            throw new S("datacontroller-init-non-existent-root", this);
          return this.model.enqueueChange({ isUndoable: !1 }, (a) => {
            for (const l of Object.keys(i)) {
              const d = this.model.document.getRoot(l);
              a.insert(this.parse(i[l], d), d, 0);
            }
          }), Promise.resolve();
        }
        set(t, i = {}) {
          let a = {};
          if (typeof t == "string" ? a.main = t : a = t, !this._checkIfRootsExists(Object.keys(a)))
            throw new S("datacontroller-set-non-existent-root", this);
          this.model.enqueueChange(i.batchType || {}, (l) => {
            l.setSelection(null), l.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
            for (const d of Object.keys(a)) {
              const g = this.model.document.getRoot(d);
              l.remove(l.createRangeIn(g)), l.insert(this.parse(a[d], g), g, 0);
            }
          });
        }
        parse(t, i = "$root") {
          const a = this.processor.toView(t);
          return this.toModel(a, i);
        }
        toModel(t, i = "$root") {
          return this.model.change((a) => this.upcastDispatcher.convert(t, a, i));
        }
        addStyleProcessorRules(t) {
          t(this.stylesProcessor);
        }
        registerRawContentMatcher(t) {
          this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
        }
        destroy() {
          this.stopListening();
        }
        _checkIfRootsExists(t) {
          for (const i of t)
            if (!this.model.document.getRootNames().includes(i))
              return !1;
          return !0;
        }
      }
      class ZN {
        constructor(t, i) {
          this._helpers = /* @__PURE__ */ new Map(), this._downcast = Yn(t), this._createConversionHelpers({ name: "downcast", dispatchers: this._downcast, isDowncast: !0 }), this._upcast = Yn(i), this._createConversionHelpers({ name: "upcast", dispatchers: this._upcast, isDowncast: !1 });
        }
        addAlias(t, i) {
          const a = this._downcast.includes(i);
          if (!this._upcast.includes(i) && !a)
            throw new S("conversion-add-alias-dispatcher-not-registered", this);
          this._createConversionHelpers({ name: t, dispatchers: [i], isDowncast: a });
        }
        for(t) {
          if (!this._helpers.has(t))
            throw new S("conversion-for-unknown-group", this);
          return this._helpers.get(t);
        }
        elementToElement(t) {
          this.for("downcast").elementToElement(t);
          for (const { model: i, view: a } of o0(t))
            this.for("upcast").elementToElement({ model: i, view: a, converterPriority: t.converterPriority });
        }
        attributeToElement(t) {
          this.for("downcast").attributeToElement(t);
          for (const { model: i, view: a } of o0(t))
            this.for("upcast").elementToAttribute({ view: a, model: i, converterPriority: t.converterPriority });
        }
        attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);
          for (const { model: i, view: a } of o0(t))
            this.for("upcast").attributeToAttribute({ view: a, model: i });
        }
        _createConversionHelpers({ name: t, dispatchers: i, isDowncast: a }) {
          if (this._helpers.has(t))
            throw new S("conversion-group-exists", this);
          const l = a ? new TN(i) : new PN(i);
          this._helpers.set(t, l);
        }
      }
      function* o0(c) {
        if (c.model.values)
          for (const t of c.model.values) {
            const i = { key: c.model.key, value: t }, a = c.view[t], l = c.upcastAlso ? c.upcastAlso[t] : void 0;
            yield* nA(i, a, l);
          }
        else
          yield* nA(c.model, c.view, c.upcastAlso);
      }
      function* nA(c, t, i) {
        if (yield { model: c, view: t }, i)
          for (const a of Yn(i))
            yield { model: c, view: a };
      }
      class Qr {
        constructor(t) {
          this.baseVersion = t, this.isDocumentOperation = this.baseVersion !== null, this.batch = null;
        }
        _validate() {
        }
        toJSON() {
          const t = Object.assign({}, this);
          return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
        }
        static get className() {
          return "Operation";
        }
        static fromJSON(t, i) {
          return new this(t.baseVersion);
        }
      }
      function a0(c, t) {
        const i = iA(t), a = i.reduce((g, m) => g + m.offsetSize, 0), l = c.parent;
        hu(c);
        const d = c.index;
        return l._insertChild(d, i), du(l, d + i.length), du(l, d), new ve(c, c.getShiftedBy(a));
      }
      function rA(c) {
        if (!c.isFlat)
          throw new S("operation-utils-remove-range-not-flat", this);
        const t = c.start.parent;
        hu(c.start), hu(c.end);
        const i = t._removeChildren(c.start.index, c.end.index - c.start.index);
        return du(t, c.start.index), i;
      }
      function uu(c, t) {
        if (!c.isFlat)
          throw new S("operation-utils-move-range-not-flat", this);
        const i = rA(c);
        return a0(t = t._getTransformedByDeletion(c.start, c.end.offset - c.start.offset), i);
      }
      function iA(c) {
        const t = [];
        (function i(a) {
          if (typeof a == "string")
            t.push(new Jt(a));
          else if (a instanceof ki)
            t.push(new Jt(a.data, a.getAttributes()));
          else if (a instanceof ca)
            t.push(a);
          else if (Ft(a))
            for (const l of a)
              i(l);
        })(c);
        for (let i = 1; i < t.length; i++) {
          const a = t[i], l = t[i - 1];
          a instanceof Jt && l instanceof Jt && oA(a, l) && (t.splice(i - 1, 2, new Jt(l.data + a.data, l.getAttributes())), i--);
        }
        return t;
      }
      function du(c, t) {
        const i = c.getChild(t - 1), a = c.getChild(t);
        if (i && a && i.is("$text") && a.is("$text") && oA(i, a)) {
          const l = new Jt(i.data + a.data, i.getAttributes());
          c._removeChildren(t - 1, 2), c._insertChild(t - 1, l);
        }
      }
      function hu(c) {
        const t = c.textNode, i = c.parent;
        if (t) {
          const a = c.offset - t.startOffset, l = t.index;
          i._removeChildren(l, 1);
          const d = new Jt(t.data.substr(0, a), t.getAttributes()), g = new Jt(t.data.substr(a), t.getAttributes());
          i._insertChild(l, [d, g]);
        }
      }
      function oA(c, t) {
        const i = c.getAttributes(), a = t.getAttributes();
        for (const l of i) {
          if (l[1] !== t.getAttribute(l[0]))
            return !1;
          a.next();
        }
        return a.next().done;
      }
      class Ot extends Qr {
        constructor(t, i, a, l) {
          super(l), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = i, this.targetPosition = a.clone(), this.targetPosition.stickiness = "toNone";
        }
        get type() {
          return this.targetPosition.root.rootName == "$graveyard" ? "remove" : this.sourcePosition.root.rootName == "$graveyard" ? "reinsert" : "move";
        }
        clone() {
          return new Ot(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
        getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
        getReversed() {
          const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
          return new Ot(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
        _validate() {
          const t = this.sourcePosition.parent, i = this.targetPosition.parent, a = this.sourcePosition.offset, l = this.targetPosition.offset;
          if (a + this.howMany > t.maxOffset)
            throw new S("move-operation-nodes-do-not-exist", this);
          if (t === i && a < l && l < a + this.howMany)
            throw new S("move-operation-range-into-itself", this);
          if (this.sourcePosition.root == this.targetPosition.root && Lt(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
            const d = this.sourcePosition.path.length - 1;
            if (this.targetPosition.path[d] >= a && this.targetPosition.path[d] < a + this.howMany)
              throw new S("move-operation-node-into-itself", this);
          }
        }
        _execute() {
          uu(ve._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
        toJSON() {
          const t = super.toJSON();
          return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
        }
        static get className() {
          return "MoveOperation";
        }
        static fromJSON(t, i) {
          const a = Ee.fromJSON(t.sourcePosition, i), l = Ee.fromJSON(t.targetPosition, i);
          return new this(a, t.howMany, l, t.baseVersion);
        }
      }
      class Qn extends Qr {
        constructor(t, i, a) {
          super(a), this.position = t.clone(), this.position.stickiness = "toNone", this.nodes = new ou(iA(i)), this.shouldReceiveAttributes = !1;
        }
        get type() {
          return "insert";
        }
        get howMany() {
          return this.nodes.maxOffset;
        }
        clone() {
          const t = new ou([...this.nodes].map((a) => a._clone(!0))), i = new Qn(this.position, t, this.baseVersion);
          return i.shouldReceiveAttributes = this.shouldReceiveAttributes, i;
        }
        getReversed() {
          const t = this.position.root.document.graveyard, i = new Ee(t, [0]);
          return new Ot(this.position, this.nodes.maxOffset, i, this.baseVersion + 1);
        }
        _validate() {
          const t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset)
            throw new S("insert-operation-position-invalid", this);
        }
        _execute() {
          const t = this.nodes;
          this.nodes = new ou([...t].map((i) => i._clone(!0))), a0(this.position, t);
        }
        toJSON() {
          const t = super.toJSON();
          return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
        }
        static get className() {
          return "InsertOperation";
        }
        static fromJSON(t, i) {
          const a = [];
          for (const d of t.nodes)
            d.name ? a.push(Kt.fromJSON(d)) : a.push(Jt.fromJSON(d));
          const l = new Qn(Ee.fromJSON(t.position, i), a, t.baseVersion);
          return l.shouldReceiveAttributes = t.shouldReceiveAttributes, l;
        }
      }
      class Cr extends Qr {
        constructor(t, i, a, l, d, g) {
          super(g), this.name = t, this.oldRange = i ? i.clone() : null, this.newRange = a ? a.clone() : null, this.affectsData = d, this._markers = l;
        }
        get type() {
          return "marker";
        }
        clone() {
          return new Cr(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
        getReversed() {
          return new Cr(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
        _execute() {
          this.newRange ? this._markers._set(this.name, this.newRange, !0, this.affectsData) : this._markers._remove(this.name);
        }
        toJSON() {
          const t = super.toJSON();
          return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
        }
        static get className() {
          return "MarkerOperation";
        }
        static fromJSON(t, i) {
          return new Cr(t.name, t.oldRange ? ve.fromJSON(t.oldRange, i) : null, t.newRange ? ve.fromJSON(t.newRange, i) : null, i.model.markers, t.affectsData, t.baseVersion);
        }
      }
      const aA = function(c, t) {
        return M_(c, t);
      };
      class Rn extends Qr {
        constructor(t, i, a, l, d) {
          super(d), this.range = t.clone(), this.key = i, this.oldValue = a === void 0 ? null : a, this.newValue = l === void 0 ? null : l;
        }
        get type() {
          return this.oldValue === null ? "addAttribute" : this.newValue === null ? "removeAttribute" : "changeAttribute";
        }
        clone() {
          return new Rn(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
        getReversed() {
          return new Rn(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
        toJSON() {
          const t = super.toJSON();
          return t.range = this.range.toJSON(), t;
        }
        _validate() {
          if (!this.range.isFlat)
            throw new S("attribute-operation-range-not-flat", this);
          for (const t of this.range.getItems({ shallow: !0 })) {
            if (this.oldValue !== null && !aA(t.getAttribute(this.key), this.oldValue))
              throw new S("attribute-operation-wrong-old-value", this, { item: t, key: this.key, value: this.oldValue });
            if (this.oldValue === null && this.newValue !== null && t.hasAttribute(this.key))
              throw new S("attribute-operation-attribute-exists", this, { node: t, key: this.key });
          }
        }
        _execute() {
          aA(this.oldValue, this.newValue) || function(t, i, a) {
            hu(t.start), hu(t.end);
            for (const l of t.getItems({ shallow: !0 })) {
              const d = l.is("$textProxy") ? l.textNode : l;
              a !== null ? d._setAttribute(i, a) : d._removeAttribute(i), du(d.parent, d.index);
            }
            du(t.end.parent, t.end.index);
          }(this.range, this.key, this.newValue);
        }
        static get className() {
          return "AttributeOperation";
        }
        static fromJSON(t, i) {
          return new Rn(ve.fromJSON(t.range, i), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }
      class Zn extends Qr {
        get type() {
          return "noop";
        }
        clone() {
          return new Zn(this.baseVersion);
        }
        getReversed() {
          return new Zn(this.baseVersion + 1);
        }
        _execute() {
        }
        static get className() {
          return "NoOperation";
        }
      }
      class xr extends Qr {
        constructor(t, i, a, l) {
          super(l), this.position = t, this.position.stickiness = "toNext", this.oldName = i, this.newName = a;
        }
        get type() {
          return "rename";
        }
        clone() {
          return new xr(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
        getReversed() {
          return new xr(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
        _validate() {
          const t = this.position.nodeAfter;
          if (!(t instanceof Kt))
            throw new S("rename-operation-wrong-position", this);
          if (t.name !== this.oldName)
            throw new S("rename-operation-wrong-name", this);
        }
        _execute() {
          this.position.nodeAfter.name = this.newName;
        }
        toJSON() {
          const t = super.toJSON();
          return t.position = this.position.toJSON(), t;
        }
        static get className() {
          return "RenameOperation";
        }
        static fromJSON(t, i) {
          return new xr(Ee.fromJSON(t.position, i), t.oldName, t.newName, t.baseVersion);
        }
      }
      class To extends Qr {
        constructor(t, i, a, l, d) {
          super(d), this.root = t, this.key = i, this.oldValue = a, this.newValue = l;
        }
        get type() {
          return this.oldValue === null ? "addRootAttribute" : this.newValue === null ? "removeRootAttribute" : "changeRootAttribute";
        }
        clone() {
          return new To(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
        getReversed() {
          return new To(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
        _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment"))
            throw new S("rootattribute-operation-not-a-root", this, { root: this.root, key: this.key });
          if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue)
            throw new S("rootattribute-operation-wrong-old-value", this, { root: this.root, key: this.key });
          if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key))
            throw new S("rootattribute-operation-attribute-exists", this, { root: this.root, key: this.key });
        }
        _execute() {
          this.newValue !== null ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
        toJSON() {
          const t = super.toJSON();
          return t.root = this.root.toJSON(), t;
        }
        static get className() {
          return "RootAttributeOperation";
        }
        static fromJSON(t, i) {
          if (!i.getRoot(t.root))
            throw new S("rootattribute-operation-fromjson-no-root", this, { rootName: t.root });
          return new To(i.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }
      class Pn extends Qr {
        constructor(t, i, a, l, d) {
          super(d), this.sourcePosition = t.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = i, this.targetPosition = a.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = l.clone();
        }
        get type() {
          return "merge";
        }
        get deletionPosition() {
          return new Ee(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
        get movedRange() {
          const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ve(this.sourcePosition, t);
        }
        clone() {
          return new Pn(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
        getReversed() {
          const t = this.targetPosition._getTransformedByMergeOperation(this), i = this.sourcePosition.path.slice(0, -1), a = new Ee(this.sourcePosition.root, i)._getTransformedByMergeOperation(this);
          return new en(t, this.howMany, a, this.graveyardPosition, this.baseVersion + 1);
        }
        _validate() {
          const t = this.sourcePosition.parent, i = this.targetPosition.parent;
          if (!t.parent)
            throw new S("merge-operation-source-position-invalid", this);
          if (!i.parent)
            throw new S("merge-operation-target-position-invalid", this);
          if (this.howMany != t.maxOffset)
            throw new S("merge-operation-how-many-invalid", this);
        }
        _execute() {
          const t = this.sourcePosition.parent;
          uu(ve._createIn(t), this.targetPosition), uu(ve._createOn(t), this.graveyardPosition);
        }
        toJSON() {
          const t = super.toJSON();
          return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
        }
        static get className() {
          return "MergeOperation";
        }
        static fromJSON(t, i) {
          const a = Ee.fromJSON(t.sourcePosition, i), l = Ee.fromJSON(t.targetPosition, i), d = Ee.fromJSON(t.graveyardPosition, i);
          return new this(a, t.howMany, l, d, t.baseVersion);
        }
      }
      class en extends Qr {
        constructor(t, i, a, l, d) {
          super(d), this.splitPosition = t.clone(), this.splitPosition.stickiness = "toNext", this.howMany = i, this.insertionPosition = a, this.graveyardPosition = l ? l.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
        }
        get type() {
          return "split";
        }
        get moveTargetPosition() {
          const t = this.insertionPosition.path.slice();
          return t.push(0), new Ee(this.insertionPosition.root, t);
        }
        get movedRange() {
          const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ve(this.splitPosition, t);
        }
        clone() {
          return new en(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
        }
        getReversed() {
          const t = this.splitPosition.root.document.graveyard, i = new Ee(t, [0]);
          return new Pn(this.moveTargetPosition, this.howMany, this.splitPosition, i, this.baseVersion + 1);
        }
        _validate() {
          const t = this.splitPosition.parent, i = this.splitPosition.offset;
          if (!t || t.maxOffset < i)
            throw new S("split-operation-position-invalid", this);
          if (!t.parent)
            throw new S("split-operation-split-in-root", this);
          if (this.howMany != t.maxOffset - this.splitPosition.offset)
            throw new S("split-operation-how-many-invalid", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
            throw new S("split-operation-graveyard-position-invalid", this);
        }
        _execute() {
          const t = this.splitPosition.parent;
          if (this.graveyardPosition)
            uu(ve._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
          else {
            const i = t._clone();
            a0(this.insertionPosition, i);
          }
          uu(new ve(Ee._createAt(t, this.splitPosition.offset), Ee._createAt(t, t.maxOffset)), this.moveTargetPosition);
        }
        toJSON() {
          const t = super.toJSON();
          return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
        }
        static get className() {
          return "SplitOperation";
        }
        static getInsertionPosition(t) {
          const i = t.path.slice(0, -1);
          return i[i.length - 1]++, new Ee(t.root, i, "toPrevious");
        }
        static fromJSON(t, i) {
          const a = Ee.fromJSON(t.splitPosition, i), l = Ee.fromJSON(t.insertionPosition, i), d = t.graveyardPosition ? Ee.fromJSON(t.graveyardPosition, i) : null;
          return new this(a, t.howMany, l, d, t.baseVersion);
        }
      }
      const Ai = {};
      Ai[Rn.className] = Rn, Ai[Qn.className] = Qn, Ai[Cr.className] = Cr, Ai[Ot.className] = Ot, Ai[Zn.className] = Zn, Ai[Qr.className] = Qr, Ai[xr.className] = xr, Ai[To.className] = To, Ai[en.className] = en, Ai[Pn.className] = Pn;
      class XN {
        static fromJSON(t, i) {
          return Ai[t.__className].fromJSON(t, i);
        }
      }
      const s0 = /* @__PURE__ */ new Map();
      function It(c, t, i) {
        let a = s0.get(c);
        a || (a = /* @__PURE__ */ new Map(), s0.set(c, a)), a.set(t, i);
      }
      function JN(c) {
        return [c];
      }
      function sA(c, t, i = {}) {
        const a = function(l, d) {
          const g = s0.get(l);
          return g && g.has(d) ? g.get(d) : JN;
        }(c.constructor, t.constructor);
        try {
          return a(c = c.clone(), t, i);
        } catch (l) {
          throw l;
        }
      }
      function e6(c, t, i) {
        c = c.slice(), t = t.slice();
        const a = new t6(i.document, i.useRelations, i.forceWeakRemove);
        a.setOriginalOperations(c), a.setOriginalOperations(t);
        const l = a.originalOperations;
        if (c.length == 0 || t.length == 0)
          return { operationsA: c, operationsB: t, originalOperations: l };
        const d = /* @__PURE__ */ new WeakMap();
        for (const w of c)
          d.set(w, 0);
        const g = { nextBaseVersionA: c[c.length - 1].baseVersion + 1, nextBaseVersionB: t[t.length - 1].baseVersion + 1, originalOperationsACount: c.length, originalOperationsBCount: t.length };
        let m = 0;
        for (; m < c.length; ) {
          const w = c[m], A = d.get(w);
          if (A == t.length) {
            m++;
            continue;
          }
          const C = t[A], T = sA(w, C, a.getContext(w, C, !0)), R = sA(C, w, a.getContext(C, w, !1));
          a.updateRelation(w, C), a.setOriginalOperations(T, w), a.setOriginalOperations(R, C);
          for (const j of T)
            d.set(j, A + R.length);
          c.splice(m, 1, ...T), t.splice(A, 1, ...R);
        }
        if (i.padWithNoOps) {
          const w = c.length - g.originalOperationsACount, A = t.length - g.originalOperationsBCount;
          cA(c, A - w), cA(t, w - A);
        }
        return lA(c, g.nextBaseVersionB), lA(t, g.nextBaseVersionA), { operationsA: c, operationsB: t, originalOperations: l };
      }
      class t6 {
        constructor(t, i, a = !1) {
          this.originalOperations = /* @__PURE__ */ new Map(), this._history = t.history, this._useRelations = i, this._forceWeakRemove = !!a, this._relations = /* @__PURE__ */ new Map();
        }
        setOriginalOperations(t, i = null) {
          const a = i ? this.originalOperations.get(i) : null;
          for (const l of t)
            this.originalOperations.set(l, a || l);
        }
        updateRelation(t, i) {
          if (t instanceof Ot)
            i instanceof Pn ? t.targetPosition.isEqual(i.sourcePosition) || i.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, i, "insertAtSource") : t.targetPosition.isEqual(i.deletionPosition) ? this._setRelation(t, i, "insertBetween") : t.targetPosition.isAfter(i.sourcePosition) && this._setRelation(t, i, "moveTargetAfter") : i instanceof Ot && (t.targetPosition.isEqual(i.sourcePosition) || t.targetPosition.isBefore(i.sourcePosition) ? this._setRelation(t, i, "insertBefore") : this._setRelation(t, i, "insertAfter"));
          else if (t instanceof en) {
            if (i instanceof Pn)
              t.splitPosition.isBefore(i.sourcePosition) && this._setRelation(t, i, "splitBefore");
            else if (i instanceof Ot)
              if (t.splitPosition.isEqual(i.sourcePosition) || t.splitPosition.isBefore(i.sourcePosition))
                this._setRelation(t, i, "splitBefore");
              else {
                const a = ve._createFromPositionAndShift(i.sourcePosition, i.howMany);
                if (t.splitPosition.hasSameParentAs(i.sourcePosition) && a.containsPosition(t.splitPosition)) {
                  const l = a.end.offset - t.splitPosition.offset, d = t.splitPosition.offset - a.start.offset;
                  this._setRelation(t, i, { howMany: l, offset: d });
                }
              }
          } else if (t instanceof Pn)
            i instanceof Pn ? (t.targetPosition.isEqual(i.sourcePosition) || this._setRelation(t, i, "mergeTargetNotMoved"), t.sourcePosition.isEqual(i.targetPosition) && this._setRelation(t, i, "mergeSourceNotMoved"), t.sourcePosition.isEqual(i.sourcePosition) && this._setRelation(t, i, "mergeSameElement")) : i instanceof en && t.sourcePosition.isEqual(i.splitPosition) && this._setRelation(t, i, "splitAtSource");
          else if (t instanceof Cr) {
            const a = t.newRange;
            if (!a)
              return;
            if (i instanceof Ot) {
              const l = ve._createFromPositionAndShift(i.sourcePosition, i.howMany), d = l.containsPosition(a.start) || l.start.isEqual(a.start), g = l.containsPosition(a.end) || l.end.isEqual(a.end);
              !d && !g || l.containsRange(a) || this._setRelation(t, i, { side: d ? "left" : "right", path: d ? a.start.path.slice() : a.end.path.slice() });
            } else if (i instanceof Pn) {
              const l = a.start.isEqual(i.targetPosition), d = a.start.isEqual(i.deletionPosition), g = a.end.isEqual(i.deletionPosition), m = a.end.isEqual(i.sourcePosition);
              (l || d || g || m) && this._setRelation(t, i, { wasInLeftElement: l, wasStartBeforeMergedElement: d, wasEndBeforeMergedElement: g, wasInRightElement: m });
            }
          }
        }
        getContext(t, i, a) {
          return { aIsStrong: a, aWasUndone: this._wasUndone(t), bWasUndone: this._wasUndone(i), abRelation: this._useRelations ? this._getRelation(t, i) : null, baRelation: this._useRelations ? this._getRelation(i, t) : null, forceWeakRemove: this._forceWeakRemove };
        }
        _wasUndone(t) {
          const i = this.originalOperations.get(t);
          return i.wasUndone || this._history.isUndoneOperation(i);
        }
        _getRelation(t, i) {
          const a = this.originalOperations.get(i), l = this._history.getUndoneOperation(a);
          if (!l)
            return null;
          const d = this.originalOperations.get(t), g = this._relations.get(d);
          return g && g.get(l) || null;
        }
        _setRelation(t, i, a) {
          const l = this.originalOperations.get(t), d = this.originalOperations.get(i);
          let g = this._relations.get(l);
          g || (g = /* @__PURE__ */ new Map(), this._relations.set(l, g)), g.set(d, a);
        }
      }
      function lA(c, t) {
        for (const i of c)
          i.baseVersion = t++;
      }
      function cA(c, t) {
        for (let i = 0; i < t; i++)
          c.push(new Zn(0));
      }
      function uA(c, t, i) {
        const a = c.nodes.getNode(0).getAttribute(t);
        if (a == i)
          return null;
        const l = new ve(c.position, c.position.getShiftedBy(c.howMany));
        return new Rn(l, t, a, i, 0);
      }
      function dA(c, t) {
        return c.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany) === null;
      }
      function ml(c, t) {
        const i = [];
        for (let a = 0; a < c.length; a++) {
          const l = c[a], d = new Ot(l.start, l.end.offset - l.start.offset, t, 0);
          i.push(d);
          for (let g = a + 1; g < c.length; g++)
            c[g] = c[g]._getTransformedByMove(d.sourcePosition, d.targetPosition, d.howMany)[0];
          t = t._getTransformedByMove(d.sourcePosition, d.targetPosition, d.howMany);
        }
        return i;
      }
      It(Rn, Rn, (c, t, i) => {
        if (c.key === t.key && c.range.start.hasSameParentAs(t.range.start)) {
          const a = c.range.getDifference(t.range).map((d) => new Rn(d, c.key, c.oldValue, c.newValue, 0)), l = c.range.getIntersection(t.range);
          return l && i.aIsStrong && a.push(new Rn(l, t.key, t.newValue, c.newValue, 0)), a.length == 0 ? [new Zn(0)] : a;
        }
        return [c];
      }), It(Rn, Qn, (c, t) => {
        if (c.range.start.hasSameParentAs(t.position) && c.range.containsPosition(t.position)) {
          const i = c.range._getTransformedByInsertion(t.position, t.howMany, !t.shouldReceiveAttributes).map((a) => new Rn(a, c.key, c.oldValue, c.newValue, c.baseVersion));
          if (t.shouldReceiveAttributes) {
            const a = uA(t, c.key, c.oldValue);
            a && i.unshift(a);
          }
          return i;
        }
        return c.range = c.range._getTransformedByInsertion(t.position, t.howMany, !1)[0], [c];
      }), It(Rn, Pn, (c, t) => {
        const i = [];
        c.range.start.hasSameParentAs(t.deletionPosition) && (c.range.containsPosition(t.deletionPosition) || c.range.start.isEqual(t.deletionPosition)) && i.push(ve._createFromPositionAndShift(t.graveyardPosition, 1));
        const a = c.range._getTransformedByMergeOperation(t);
        return a.isCollapsed || i.push(a), i.map((l) => new Rn(l, c.key, c.oldValue, c.newValue, c.baseVersion));
      }), It(Rn, Ot, (c, t) => function(a, l) {
        const d = ve._createFromPositionAndShift(l.sourcePosition, l.howMany);
        let g = null, m = [];
        d.containsRange(a, !0) ? g = a : a.start.hasSameParentAs(d.start) ? (m = a.getDifference(d), g = a.getIntersection(d)) : m = [a];
        const w = [];
        for (let A of m) {
          A = A._getTransformedByDeletion(l.sourcePosition, l.howMany);
          const C = l.getMovedRangeStart(), T = A.start.hasSameParentAs(C), R = A._getTransformedByInsertion(C, l.howMany, T);
          w.push(...R);
        }
        return g && w.push(g._getTransformedByMove(l.sourcePosition, l.targetPosition, l.howMany, !1)[0]), w;
      }(c.range, t).map((a) => new Rn(a, c.key, c.oldValue, c.newValue, c.baseVersion))), It(Rn, en, (c, t) => {
        if (c.range.end.isEqual(t.insertionPosition))
          return t.graveyardPosition || c.range.end.offset++, [c];
        if (c.range.start.hasSameParentAs(t.splitPosition) && c.range.containsPosition(t.splitPosition)) {
          const i = c.clone();
          return i.range = new ve(t.moveTargetPosition.clone(), c.range.end._getCombined(t.splitPosition, t.moveTargetPosition)), c.range.end = t.splitPosition.clone(), c.range.end.stickiness = "toPrevious", [c, i];
        }
        return c.range = c.range._getTransformedBySplitOperation(t), [c];
      }), It(Qn, Rn, (c, t) => {
        const i = [c];
        if (c.shouldReceiveAttributes && c.position.hasSameParentAs(t.range.start) && t.range.containsPosition(c.position)) {
          const a = uA(c, t.key, t.newValue);
          a && i.push(a);
        }
        return i;
      }), It(Qn, Qn, (c, t, i) => (c.position.isEqual(t.position) && i.aIsStrong || (c.position = c.position._getTransformedByInsertOperation(t)), [c])), It(Qn, Ot, (c, t) => (c.position = c.position._getTransformedByMoveOperation(t), [c])), It(Qn, en, (c, t) => (c.position = c.position._getTransformedBySplitOperation(t), [c])), It(Qn, Pn, (c, t) => (c.position = c.position._getTransformedByMergeOperation(t), [c])), It(Cr, Qn, (c, t) => (c.oldRange && (c.oldRange = c.oldRange._getTransformedByInsertOperation(t)[0]), c.newRange && (c.newRange = c.newRange._getTransformedByInsertOperation(t)[0]), [c])), It(Cr, Cr, (c, t, i) => {
        if (c.name == t.name) {
          if (!i.aIsStrong)
            return [new Zn(0)];
          c.oldRange = t.newRange ? t.newRange.clone() : null;
        }
        return [c];
      }), It(Cr, Pn, (c, t) => (c.oldRange && (c.oldRange = c.oldRange._getTransformedByMergeOperation(t)), c.newRange && (c.newRange = c.newRange._getTransformedByMergeOperation(t)), [c])), It(Cr, Ot, (c, t, i) => {
        if (c.oldRange && (c.oldRange = ve._createFromRanges(c.oldRange._getTransformedByMoveOperation(t))), c.newRange) {
          if (i.abRelation) {
            const a = ve._createFromRanges(c.newRange._getTransformedByMoveOperation(t));
            if (i.abRelation.side == "left" && t.targetPosition.isEqual(c.newRange.start))
              return c.newRange.end = a.end, c.newRange.start.path = i.abRelation.path, [c];
            if (i.abRelation.side == "right" && t.targetPosition.isEqual(c.newRange.end))
              return c.newRange.start = a.start, c.newRange.end.path = i.abRelation.path, [c];
          }
          c.newRange = ve._createFromRanges(c.newRange._getTransformedByMoveOperation(t));
        }
        return [c];
      }), It(Cr, en, (c, t, i) => {
        if (c.oldRange && (c.oldRange = c.oldRange._getTransformedBySplitOperation(t)), c.newRange) {
          if (i.abRelation) {
            const a = c.newRange._getTransformedBySplitOperation(t);
            return c.newRange.start.isEqual(t.splitPosition) && i.abRelation.wasStartBeforeMergedElement ? c.newRange.start = Ee._createAt(t.insertionPosition) : c.newRange.start.isEqual(t.splitPosition) && !i.abRelation.wasInLeftElement && (c.newRange.start = Ee._createAt(t.moveTargetPosition)), c.newRange.end.isEqual(t.splitPosition) && i.abRelation.wasInRightElement ? c.newRange.end = Ee._createAt(t.moveTargetPosition) : c.newRange.end.isEqual(t.splitPosition) && i.abRelation.wasEndBeforeMergedElement ? c.newRange.end = Ee._createAt(t.insertionPosition) : c.newRange.end = a.end, [c];
          }
          c.newRange = c.newRange._getTransformedBySplitOperation(t);
        }
        return [c];
      }), It(Pn, Qn, (c, t) => (c.sourcePosition.hasSameParentAs(t.position) && (c.howMany += t.howMany), c.sourcePosition = c.sourcePosition._getTransformedByInsertOperation(t), c.targetPosition = c.targetPosition._getTransformedByInsertOperation(t), [c])), It(Pn, Pn, (c, t, i) => {
        if (c.sourcePosition.isEqual(t.sourcePosition) && c.targetPosition.isEqual(t.targetPosition)) {
          if (i.bWasUndone) {
            const a = t.graveyardPosition.path.slice();
            return a.push(0), c.sourcePosition = new Ee(t.graveyardPosition.root, a), c.howMany = 0, [c];
          }
          return [new Zn(0)];
        }
        if (c.sourcePosition.isEqual(t.sourcePosition) && !c.targetPosition.isEqual(t.targetPosition) && !i.bWasUndone && i.abRelation != "splitAtSource") {
          const a = c.targetPosition.root.rootName == "$graveyard", l = t.targetPosition.root.rootName == "$graveyard";
          if (l && !a || !(a && !l) && i.aIsStrong) {
            const d = t.targetPosition._getTransformedByMergeOperation(t), g = c.targetPosition._getTransformedByMergeOperation(t);
            return [new Ot(d, c.howMany, g, 0)];
          }
          return [new Zn(0)];
        }
        return c.sourcePosition.hasSameParentAs(t.targetPosition) && (c.howMany += t.howMany), c.sourcePosition = c.sourcePosition._getTransformedByMergeOperation(t), c.targetPosition = c.targetPosition._getTransformedByMergeOperation(t), c.graveyardPosition.isEqual(t.graveyardPosition) && i.aIsStrong || (c.graveyardPosition = c.graveyardPosition._getTransformedByMergeOperation(t)), [c];
      }), It(Pn, Ot, (c, t, i) => {
        const a = ve._createFromPositionAndShift(t.sourcePosition, t.howMany);
        return t.type == "remove" && !i.bWasUndone && !i.forceWeakRemove && c.deletionPosition.hasSameParentAs(t.sourcePosition) && a.containsPosition(c.sourcePosition) ? [new Zn(0)] : (c.sourcePosition.hasSameParentAs(t.targetPosition) && (c.howMany += t.howMany), c.sourcePosition.hasSameParentAs(t.sourcePosition) && (c.howMany -= t.howMany), c.sourcePosition = c.sourcePosition._getTransformedByMoveOperation(t), c.targetPosition = c.targetPosition._getTransformedByMoveOperation(t), c.graveyardPosition.isEqual(t.targetPosition) || (c.graveyardPosition = c.graveyardPosition._getTransformedByMoveOperation(t)), [c]);
      }), It(Pn, en, (c, t, i) => {
        if (t.graveyardPosition && (c.graveyardPosition = c.graveyardPosition._getTransformedByDeletion(t.graveyardPosition, 1), c.deletionPosition.isEqual(t.graveyardPosition) && (c.howMany = t.howMany)), c.targetPosition.isEqual(t.splitPosition)) {
          const a = t.howMany != 0, l = t.graveyardPosition && c.deletionPosition.isEqual(t.graveyardPosition);
          if (a || l || i.abRelation == "mergeTargetNotMoved")
            return c.sourcePosition = c.sourcePosition._getTransformedBySplitOperation(t), [c];
        }
        if (c.sourcePosition.isEqual(t.splitPosition)) {
          if (i.abRelation == "mergeSourceNotMoved")
            return c.howMany = 0, c.targetPosition = c.targetPosition._getTransformedBySplitOperation(t), [c];
          if (i.abRelation == "mergeSameElement" || c.sourcePosition.offset > 0)
            return c.sourcePosition = t.moveTargetPosition.clone(), c.targetPosition = c.targetPosition._getTransformedBySplitOperation(t), [c];
        }
        return c.sourcePosition.hasSameParentAs(t.splitPosition) && (c.howMany = t.splitPosition.offset), c.sourcePosition = c.sourcePosition._getTransformedBySplitOperation(t), c.targetPosition = c.targetPosition._getTransformedBySplitOperation(t), [c];
      }), It(Ot, Qn, (c, t) => {
        const i = ve._createFromPositionAndShift(c.sourcePosition, c.howMany)._getTransformedByInsertOperation(t, !1)[0];
        return c.sourcePosition = i.start, c.howMany = i.end.offset - i.start.offset, c.targetPosition.isEqual(t.position) || (c.targetPosition = c.targetPosition._getTransformedByInsertOperation(t)), [c];
      }), It(Ot, Ot, (c, t, i) => {
        const a = ve._createFromPositionAndShift(c.sourcePosition, c.howMany), l = ve._createFromPositionAndShift(t.sourcePosition, t.howMany);
        let d, g = i.aIsStrong, m = !i.aIsStrong;
        if (i.abRelation == "insertBefore" || i.baRelation == "insertAfter" ? m = !0 : i.abRelation != "insertAfter" && i.baRelation != "insertBefore" || (m = !1), d = c.targetPosition.isEqual(t.targetPosition) && m ? c.targetPosition._getTransformedByDeletion(t.sourcePosition, t.howMany) : c.targetPosition._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), dA(c, t) && dA(t, c))
          return [t.getReversed()];
        if (a.containsPosition(t.targetPosition) && a.containsRange(l, !0))
          return a.start = a.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), a.end = a.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), ml([a], d);
        if (l.containsPosition(c.targetPosition) && l.containsRange(a, !0))
          return a.start = a.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), a.end = a.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), ml([a], d);
        const w = Lt(c.sourcePosition.getParentPath(), t.sourcePosition.getParentPath());
        if (w == "prefix" || w == "extension")
          return a.start = a.start._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), a.end = a.end._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany), ml([a], d);
        c.type != "remove" || t.type == "remove" || i.aWasUndone || i.forceWeakRemove ? c.type == "remove" || t.type != "remove" || i.bWasUndone || i.forceWeakRemove || (g = !1) : g = !0;
        const A = [], C = a.getDifference(l);
        for (const R of C) {
          R.start = R.start._getTransformedByDeletion(t.sourcePosition, t.howMany), R.end = R.end._getTransformedByDeletion(t.sourcePosition, t.howMany);
          const j = Lt(R.start.getParentPath(), t.getMovedRangeStart().getParentPath()) == "same", F = R._getTransformedByInsertion(t.getMovedRangeStart(), t.howMany, j);
          A.push(...F);
        }
        const T = a.getIntersection(l);
        return T !== null && g && (T.start = T.start._getCombined(t.sourcePosition, t.getMovedRangeStart()), T.end = T.end._getCombined(t.sourcePosition, t.getMovedRangeStart()), A.length === 0 ? A.push(T) : A.length == 1 ? l.start.isBefore(a.start) || l.start.isEqual(a.start) ? A.unshift(T) : A.push(T) : A.splice(1, 0, T)), A.length === 0 ? [new Zn(c.baseVersion)] : ml(A, d);
      }), It(Ot, en, (c, t, i) => {
        let a = c.targetPosition.clone();
        c.targetPosition.isEqual(t.insertionPosition) && t.graveyardPosition && i.abRelation != "moveTargetAfter" || (a = c.targetPosition._getTransformedBySplitOperation(t));
        const l = ve._createFromPositionAndShift(c.sourcePosition, c.howMany);
        if (l.end.isEqual(t.insertionPosition))
          return t.graveyardPosition || c.howMany++, c.targetPosition = a, [c];
        if (l.start.hasSameParentAs(t.splitPosition) && l.containsPosition(t.splitPosition)) {
          let g = new ve(t.splitPosition, l.end);
          return g = g._getTransformedBySplitOperation(t), ml([new ve(l.start, t.splitPosition), g], a);
        }
        c.targetPosition.isEqual(t.splitPosition) && i.abRelation == "insertAtSource" && (a = t.moveTargetPosition), c.targetPosition.isEqual(t.insertionPosition) && i.abRelation == "insertBetween" && (a = c.targetPosition);
        const d = [l._getTransformedBySplitOperation(t)];
        if (t.graveyardPosition) {
          const g = l.start.isEqual(t.graveyardPosition) || l.containsPosition(t.graveyardPosition);
          c.howMany > 1 && g && !i.aWasUndone && d.push(ve._createFromPositionAndShift(t.insertionPosition, 1));
        }
        return ml(d, a);
      }), It(Ot, Pn, (c, t, i) => {
        const a = ve._createFromPositionAndShift(c.sourcePosition, c.howMany);
        if (t.deletionPosition.hasSameParentAs(c.sourcePosition) && a.containsPosition(t.sourcePosition)) {
          if (c.type != "remove" || i.forceWeakRemove) {
            if (c.howMany == 1)
              return i.bWasUndone ? (c.sourcePosition = t.graveyardPosition.clone(), c.targetPosition = c.targetPosition._getTransformedByMergeOperation(t), [c]) : [new Zn(0)];
          } else if (!i.aWasUndone) {
            const d = [];
            let g = t.graveyardPosition.clone(), m = t.targetPosition._getTransformedByMergeOperation(t);
            c.howMany > 1 && (d.push(new Ot(c.sourcePosition, c.howMany - 1, c.targetPosition, 0)), g = g._getTransformedByMove(c.sourcePosition, c.targetPosition, c.howMany - 1), m = m._getTransformedByMove(c.sourcePosition, c.targetPosition, c.howMany - 1));
            const w = t.deletionPosition._getCombined(c.sourcePosition, c.targetPosition), A = new Ot(g, 1, w, 0), C = A.getMovedRangeStart().path.slice();
            C.push(0);
            const T = new Ee(A.targetPosition.root, C);
            m = m._getTransformedByMove(g, w, 1);
            const R = new Ot(m, t.howMany, T, 0);
            return d.push(A), d.push(R), d;
          }
        }
        const l = ve._createFromPositionAndShift(c.sourcePosition, c.howMany)._getTransformedByMergeOperation(t);
        return c.sourcePosition = l.start, c.howMany = l.end.offset - l.start.offset, c.targetPosition = c.targetPosition._getTransformedByMergeOperation(t), [c];
      }), It(xr, Qn, (c, t) => (c.position = c.position._getTransformedByInsertOperation(t), [c])), It(xr, Pn, (c, t) => c.position.isEqual(t.deletionPosition) ? (c.position = t.graveyardPosition.clone(), c.position.stickiness = "toNext", [c]) : (c.position = c.position._getTransformedByMergeOperation(t), [c])), It(xr, Ot, (c, t) => (c.position = c.position._getTransformedByMoveOperation(t), [c])), It(xr, xr, (c, t, i) => {
        if (c.position.isEqual(t.position)) {
          if (!i.aIsStrong)
            return [new Zn(0)];
          c.oldName = t.newName;
        }
        return [c];
      }), It(xr, en, (c, t) => {
        if (Lt(c.position.path, t.splitPosition.getParentPath()) == "same" && !t.graveyardPosition) {
          const i = new xr(c.position.getShiftedBy(1), c.oldName, c.newName, 0);
          return [c, i];
        }
        return c.position = c.position._getTransformedBySplitOperation(t), [c];
      }), It(To, To, (c, t, i) => {
        if (c.root === t.root && c.key === t.key) {
          if (!i.aIsStrong || c.newValue === t.newValue)
            return [new Zn(0)];
          c.oldValue = t.newValue;
        }
        return [c];
      }), It(en, Qn, (c, t) => (c.splitPosition.hasSameParentAs(t.position) && c.splitPosition.offset < t.position.offset && (c.howMany += t.howMany), c.splitPosition = c.splitPosition._getTransformedByInsertOperation(t), c.insertionPosition = c.insertionPosition._getTransformedByInsertOperation(t), [c])), It(en, Pn, (c, t, i) => {
        if (!c.graveyardPosition && !i.bWasUndone && c.splitPosition.hasSameParentAs(t.sourcePosition)) {
          const a = t.graveyardPosition.path.slice();
          a.push(0);
          const l = new Ee(t.graveyardPosition.root, a), d = en.getInsertionPosition(new Ee(t.graveyardPosition.root, a)), g = new en(l, 0, d, null, 0);
          return c.splitPosition = c.splitPosition._getTransformedByMergeOperation(t), c.insertionPosition = en.getInsertionPosition(c.splitPosition), c.graveyardPosition = g.insertionPosition.clone(), c.graveyardPosition.stickiness = "toNext", [g, c];
        }
        return c.splitPosition.hasSameParentAs(t.deletionPosition) && !c.splitPosition.isAfter(t.deletionPosition) && c.howMany--, c.splitPosition.hasSameParentAs(t.targetPosition) && (c.howMany += t.howMany), c.splitPosition = c.splitPosition._getTransformedByMergeOperation(t), c.insertionPosition = en.getInsertionPosition(c.splitPosition), c.graveyardPosition && (c.graveyardPosition = c.graveyardPosition._getTransformedByMergeOperation(t)), [c];
      }), It(en, Ot, (c, t, i) => {
        const a = ve._createFromPositionAndShift(t.sourcePosition, t.howMany);
        if (c.graveyardPosition) {
          const d = a.start.isEqual(c.graveyardPosition) || a.containsPosition(c.graveyardPosition);
          if (!i.bWasUndone && d) {
            const g = c.splitPosition._getTransformedByMoveOperation(t), m = c.graveyardPosition._getTransformedByMoveOperation(t), w = m.path.slice();
            w.push(0);
            const A = new Ee(m.root, w);
            return [new Ot(g, c.howMany, A, 0)];
          }
          c.graveyardPosition = c.graveyardPosition._getTransformedByMoveOperation(t);
        }
        const l = c.splitPosition.isEqual(t.targetPosition);
        if (l && (i.baRelation == "insertAtSource" || i.abRelation == "splitBefore"))
          return c.howMany += t.howMany, c.splitPosition = c.splitPosition._getTransformedByDeletion(t.sourcePosition, t.howMany), c.insertionPosition = en.getInsertionPosition(c.splitPosition), [c];
        if (l && i.abRelation && i.abRelation.howMany) {
          const { howMany: d, offset: g } = i.abRelation;
          return c.howMany += d, c.splitPosition = c.splitPosition.getShiftedBy(g), [c];
        }
        if (c.splitPosition.hasSameParentAs(t.sourcePosition) && a.containsPosition(c.splitPosition)) {
          const d = t.howMany - (c.splitPosition.offset - t.sourcePosition.offset);
          return c.howMany -= d, c.splitPosition.hasSameParentAs(t.targetPosition) && c.splitPosition.offset < t.targetPosition.offset && (c.howMany += t.howMany), c.splitPosition = t.sourcePosition.clone(), c.insertionPosition = en.getInsertionPosition(c.splitPosition), [c];
        }
        return t.sourcePosition.isEqual(t.targetPosition) || (c.splitPosition.hasSameParentAs(t.sourcePosition) && c.splitPosition.offset <= t.sourcePosition.offset && (c.howMany -= t.howMany), c.splitPosition.hasSameParentAs(t.targetPosition) && c.splitPosition.offset < t.targetPosition.offset && (c.howMany += t.howMany)), c.splitPosition.stickiness = "toNone", c.splitPosition = c.splitPosition._getTransformedByMoveOperation(t), c.splitPosition.stickiness = "toNext", c.graveyardPosition ? c.insertionPosition = c.insertionPosition._getTransformedByMoveOperation(t) : c.insertionPosition = en.getInsertionPosition(c.splitPosition), [c];
      }), It(en, en, (c, t, i) => {
        if (c.splitPosition.isEqual(t.splitPosition)) {
          if (!c.graveyardPosition && !t.graveyardPosition)
            return [new Zn(0)];
          if (c.graveyardPosition && t.graveyardPosition && c.graveyardPosition.isEqual(t.graveyardPosition))
            return [new Zn(0)];
          if (i.abRelation == "splitBefore")
            return c.howMany = 0, c.graveyardPosition = c.graveyardPosition._getTransformedBySplitOperation(t), [c];
        }
        if (c.graveyardPosition && t.graveyardPosition && c.graveyardPosition.isEqual(t.graveyardPosition)) {
          const a = c.splitPosition.root.rootName == "$graveyard", l = t.splitPosition.root.rootName == "$graveyard";
          if (l && !a || !(a && !l) && i.aIsStrong) {
            const d = [];
            return t.howMany && d.push(new Ot(t.moveTargetPosition, t.howMany, t.splitPosition, 0)), c.howMany && d.push(new Ot(c.splitPosition, c.howMany, c.moveTargetPosition, 0)), d;
          }
          return [new Zn(0)];
        }
        if (c.graveyardPosition && (c.graveyardPosition = c.graveyardPosition._getTransformedBySplitOperation(t)), c.splitPosition.isEqual(t.insertionPosition) && i.abRelation == "splitBefore")
          return c.howMany++, [c];
        if (t.splitPosition.isEqual(c.insertionPosition) && i.baRelation == "splitBefore") {
          const a = t.insertionPosition.path.slice();
          a.push(0);
          const l = new Ee(t.insertionPosition.root, a);
          return [c, new Ot(c.insertionPosition, 1, l, 0)];
        }
        return c.splitPosition.hasSameParentAs(t.splitPosition) && c.splitPosition.offset < t.splitPosition.offset && (c.howMany -= t.howMany), c.splitPosition = c.splitPosition._getTransformedBySplitOperation(t), c.insertionPosition = en.getInsertionPosition(c.splitPosition), [c];
      });
      class ar extends ie(Ee) {
        constructor(t, i, a = "toNone") {
          if (super(t, i, a), !this.root.is("rootElement"))
            throw new S("model-liveposition-root-not-rootelement", t);
          n6.call(this);
        }
        detach() {
          this.stopListening();
        }
        toPosition() {
          return new Ee(this.root, this.path.slice(), this.stickiness);
        }
        static fromPosition(t, i) {
          return new this(t.root, t.path.slice(), i || t.stickiness);
        }
      }
      function n6() {
        this.listenTo(this.root.document.model, "applyOperation", (c, t) => {
          const i = t[0];
          i.isDocumentOperation && r6.call(this, i);
        }, { priority: "low" });
      }
      function r6(c) {
        const t = this.getTransformedByOperation(c);
        if (!this.isEqual(t)) {
          const i = this.toPosition();
          this.path = t.path, this.root = t.root, this.fire("change", i);
        }
      }
      ar.prototype.is = function(c) {
        return c === "livePosition" || c === "model:livePosition" || c == "position" || c === "model:position";
      };
      class vl {
        constructor(t = {}) {
          typeof t == "string" && (t = t === "transparent" ? { isUndoable: !1 } : {}, $("batch-constructor-deprecated-string-type"));
          const { isUndoable: i = !0, isLocal: a = !0, isUndo: l = !1, isTyping: d = !1 } = t;
          this.operations = [], this.isUndoable = i, this.isLocal = a, this.isUndo = l, this.isTyping = d;
        }
        get type() {
          return $("batch-type-deprecated"), "default";
        }
        get baseVersion() {
          for (const t of this.operations)
            if (t.baseVersion !== null)
              return t.baseVersion;
          return null;
        }
        addOperation(t) {
          return t.batch = this, this.operations.push(t), t;
        }
      }
      class i6 {
        constructor(t) {
          this._markerCollection = t, this._changesInElement = /* @__PURE__ */ new Map(), this._elementSnapshots = /* @__PURE__ */ new Map(), this._changedMarkers = /* @__PURE__ */ new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = /* @__PURE__ */ new Set();
        }
        get isEmpty() {
          return this._changesInElement.size == 0 && this._changedMarkers.size == 0;
        }
        bufferOperation(t) {
          const i = t;
          switch (i.type) {
            case "insert":
              if (this._isInInsertedElement(i.position.parent))
                return;
              this._markInsert(i.position.parent, i.position.offset, i.nodes.maxOffset);
              break;
            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              for (const a of i.range.getItems({ shallow: !0 }))
                this._isInInsertedElement(a.parent) || this._markAttribute(a);
              break;
            case "remove":
            case "move":
            case "reinsert": {
              if (i.sourcePosition.isEqual(i.targetPosition) || i.sourcePosition.getShiftedBy(i.howMany).isEqual(i.targetPosition))
                return;
              const a = this._isInInsertedElement(i.sourcePosition.parent), l = this._isInInsertedElement(i.targetPosition.parent);
              a || this._markRemove(i.sourcePosition.parent, i.sourcePosition.offset, i.howMany), l || this._markInsert(i.targetPosition.parent, i.getMovedRangeStart().offset, i.howMany);
              break;
            }
            case "rename": {
              if (this._isInInsertedElement(i.position.parent))
                return;
              this._markRemove(i.position.parent, i.position.offset, 1), this._markInsert(i.position.parent, i.position.offset, 1);
              const a = ve._createFromPositionAndShift(i.position, 1);
              for (const l of this._markerCollection.getMarkersIntersectingRange(a)) {
                const d = l.getData();
                this.bufferMarkerChange(l.name, d, d);
              }
              break;
            }
            case "split": {
              const a = i.splitPosition.parent;
              this._isInInsertedElement(a) || this._markRemove(a, i.splitPosition.offset, i.howMany), this._isInInsertedElement(i.insertionPosition.parent) || this._markInsert(i.insertionPosition.parent, i.insertionPosition.offset, 1), i.graveyardPosition && this._markRemove(i.graveyardPosition.parent, i.graveyardPosition.offset, 1);
              break;
            }
            case "merge": {
              const a = i.sourcePosition.parent;
              this._isInInsertedElement(a.parent) || this._markRemove(a.parent, a.startOffset, 1);
              const l = i.graveyardPosition.parent;
              this._markInsert(l, i.graveyardPosition.offset, 1);
              const d = i.targetPosition.parent;
              this._isInInsertedElement(d) || this._markInsert(d, i.targetPosition.offset, a.maxOffset);
              break;
            }
          }
          this._cachedChanges = null;
        }
        bufferMarkerChange(t, i, a) {
          const l = this._changedMarkers.get(t);
          l ? (l.newMarkerData = a, l.oldMarkerData.range == null && a.range == null && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, { newMarkerData: a, oldMarkerData: i });
        }
        getMarkersToRemove() {
          const t = [];
          for (const [i, a] of this._changedMarkers)
            a.oldMarkerData.range != null && t.push({ name: i, range: a.oldMarkerData.range });
          return t;
        }
        getMarkersToAdd() {
          const t = [];
          for (const [i, a] of this._changedMarkers)
            a.newMarkerData.range != null && t.push({ name: i, range: a.newMarkerData.range });
          return t;
        }
        getChangedMarkers() {
          return Array.from(this._changedMarkers).map(([t, i]) => ({ name: t, data: { oldRange: i.oldMarkerData.range, newRange: i.newMarkerData.range } }));
        }
        hasDataChanges() {
          if (this._changesInElement.size > 0)
            return !0;
          for (const { newMarkerData: t, oldMarkerData: i } of this._changedMarkers.values()) {
            if (t.affectsData !== i.affectsData)
              return !0;
            if (t.affectsData) {
              const a = t.range && !i.range, l = !t.range && i.range, d = t.range && i.range && !t.range.isEqual(i.range);
              if (a || l || d)
                return !0;
            }
          }
          return !1;
        }
        getChanges(t = {}) {
          if (this._cachedChanges)
            return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          let i = [];
          for (const a of this._changesInElement.keys()) {
            const l = this._changesInElement.get(a).sort((C, T) => C.offset === T.offset ? C.type != T.type ? C.type == "remove" ? -1 : 1 : 0 : C.offset < T.offset ? -1 : 1), d = this._elementSnapshots.get(a), g = hA(a.getChildren()), m = o6(d.length, l);
            let w = 0, A = 0;
            for (const C of m)
              if (C === "i")
                i.push(this._getInsertDiff(a, w, g[w])), w++;
              else if (C === "r")
                i.push(this._getRemoveDiff(a, w, d[A])), A++;
              else if (C === "a") {
                const T = g[w].attributes, R = d[A].attributes;
                let j;
                if (g[w].name == "$text")
                  j = new ve(Ee._createAt(a, w), Ee._createAt(a, w + 1));
                else {
                  const F = a.offsetToIndex(w);
                  j = new ve(Ee._createAt(a, w), Ee._createAt(a.getChild(F), 0));
                }
                i.push(...this._getAttributesDiff(j, R, T)), w++, A++;
              } else
                w++, A++;
          }
          i.sort((a, l) => a.position.root != l.position.root ? a.position.root.rootName < l.position.root.rootName ? -1 : 1 : a.position.isEqual(l.position) ? a.changeCount - l.changeCount : a.position.isBefore(l.position) ? -1 : 1);
          for (let a = 1, l = 0; a < i.length; a++) {
            const d = i[l], g = i[a], m = d.type == "remove" && g.type == "remove" && d.name == "$text" && g.name == "$text" && d.position.isEqual(g.position), w = d.type == "insert" && g.type == "insert" && d.name == "$text" && g.name == "$text" && d.position.parent == g.position.parent && d.position.offset + d.length == g.position.offset, A = d.type == "attribute" && g.type == "attribute" && d.position.parent == g.position.parent && d.range.isFlat && g.range.isFlat && d.position.offset + d.length == g.position.offset && d.attributeKey == g.attributeKey && d.attributeOldValue == g.attributeOldValue && d.attributeNewValue == g.attributeNewValue;
            m || w || A ? (d.length++, A && (d.range.end = d.range.end.getShiftedBy(1)), i[a] = null) : l = a;
          }
          i = i.filter((a) => a);
          for (const a of i)
            delete a.changeCount, a.type == "attribute" && (delete a.position, delete a.length);
          return this._changeCount = 0, this._cachedChangesWithGraveyard = i, this._cachedChanges = i.filter(a6), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
        }
        getRefreshedItems() {
          return new Set(this._refreshedItems);
        }
        reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._refreshedItems = /* @__PURE__ */ new Set(), this._cachedChanges = null;
        }
        _refreshItem(t) {
          if (this._isInInsertedElement(t.parent))
            return;
          this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize), this._refreshedItems.add(t);
          const i = ve._createOn(t);
          for (const a of this._markerCollection.getMarkersIntersectingRange(i)) {
            const l = a.getData();
            this.bufferMarkerChange(a.name, l, l);
          }
          this._cachedChanges = null;
        }
        _markInsert(t, i, a) {
          const l = { type: "insert", offset: i, howMany: a, count: this._changeCount++ };
          this._markChange(t, l);
        }
        _markRemove(t, i, a) {
          const l = { type: "remove", offset: i, howMany: a, count: this._changeCount++ };
          this._markChange(t, l), this._removeAllNestedChanges(t, i, a);
        }
        _markAttribute(t) {
          const i = { type: "attribute", offset: t.startOffset, howMany: t.offsetSize, count: this._changeCount++ };
          this._markChange(t.parent, i);
        }
        _markChange(t, i) {
          this._makeSnapshot(t);
          const a = this._getChangesForElement(t);
          this._handleChange(i, a), a.push(i);
          for (let l = 0; l < a.length; l++)
            a[l].howMany < 1 && (a.splice(l, 1), l--);
        }
        _getChangesForElement(t) {
          let i;
          return this._changesInElement.has(t) ? i = this._changesInElement.get(t) : (i = [], this._changesInElement.set(t, i)), i;
        }
        _makeSnapshot(t) {
          this._elementSnapshots.has(t) || this._elementSnapshots.set(t, hA(t.getChildren()));
        }
        _handleChange(t, i) {
          t.nodesToHandle = t.howMany;
          for (const a of i) {
            const l = t.offset + t.howMany, d = a.offset + a.howMany;
            if (t.type == "insert" && (a.type == "insert" && (t.offset <= a.offset ? a.offset += t.howMany : t.offset < d && (a.howMany += t.nodesToHandle, t.nodesToHandle = 0)), a.type == "remove" && t.offset < a.offset && (a.offset += t.howMany), a.type == "attribute")) {
              if (t.offset <= a.offset)
                a.offset += t.howMany;
              else if (t.offset < d) {
                const g = a.howMany;
                a.howMany = t.offset - a.offset, i.unshift({ type: "attribute", offset: l, howMany: g - a.howMany, count: this._changeCount++ });
              }
            }
            if (t.type == "remove") {
              if (a.type == "insert") {
                if (l <= a.offset)
                  a.offset -= t.howMany;
                else if (l <= d)
                  if (t.offset < a.offset) {
                    const g = l - a.offset;
                    a.offset = t.offset, a.howMany -= g, t.nodesToHandle -= g;
                  } else
                    a.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                else if (t.offset <= a.offset)
                  t.nodesToHandle -= a.howMany, a.howMany = 0;
                else if (t.offset < d) {
                  const g = d - t.offset;
                  a.howMany -= g, t.nodesToHandle -= g;
                }
              }
              if (a.type == "remove" && (l <= a.offset ? a.offset -= t.howMany : t.offset < a.offset && (t.nodesToHandle += a.howMany, a.howMany = 0)), a.type == "attribute") {
                if (l <= a.offset)
                  a.offset -= t.howMany;
                else if (t.offset < a.offset) {
                  const g = l - a.offset;
                  a.offset = t.offset, a.howMany -= g;
                } else if (t.offset < d)
                  if (l <= d) {
                    const g = a.howMany;
                    a.howMany = t.offset - a.offset;
                    const m = g - a.howMany - t.nodesToHandle;
                    i.unshift({ type: "attribute", offset: t.offset, howMany: m, count: this._changeCount++ });
                  } else
                    a.howMany -= d - t.offset;
              }
            }
            if (t.type == "attribute") {
              if (a.type == "insert")
                if (t.offset < a.offset && l > a.offset) {
                  if (l > d) {
                    const g = { type: "attribute", offset: d, howMany: l - d, count: this._changeCount++ };
                    this._handleChange(g, i), i.push(g);
                  }
                  t.nodesToHandle = a.offset - t.offset, t.howMany = t.nodesToHandle;
                } else
                  t.offset >= a.offset && t.offset < d && (l > d ? (t.nodesToHandle = l - d, t.offset = d) : t.nodesToHandle = 0);
              if (a.type == "remove" && t.offset < a.offset && l > a.offset) {
                const g = { type: "attribute", offset: a.offset, howMany: l - a.offset, count: this._changeCount++ };
                this._handleChange(g, i), i.push(g), t.nodesToHandle = a.offset - t.offset, t.howMany = t.nodesToHandle;
              }
              a.type == "attribute" && (t.offset >= a.offset && l <= d ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= a.offset && l >= d && (a.howMany = 0));
            }
          }
          t.howMany = t.nodesToHandle, delete t.nodesToHandle;
        }
        _getInsertDiff(t, i, a) {
          return { type: "insert", position: Ee._createAt(t, i), name: a.name, attributes: new Map(a.attributes), length: 1, changeCount: this._changeCount++ };
        }
        _getRemoveDiff(t, i, a) {
          return { type: "remove", position: Ee._createAt(t, i), name: a.name, attributes: new Map(a.attributes), length: 1, changeCount: this._changeCount++ };
        }
        _getAttributesDiff(t, i, a) {
          const l = [];
          a = new Map(a);
          for (const [d, g] of i) {
            const m = a.has(d) ? a.get(d) : null;
            m !== g && l.push({ type: "attribute", position: t.start, range: t.clone(), length: 1, attributeKey: d, attributeOldValue: g, attributeNewValue: m, changeCount: this._changeCount++ }), a.delete(d);
          }
          for (const [d, g] of a)
            l.push({ type: "attribute", position: t.start, range: t.clone(), length: 1, attributeKey: d, attributeOldValue: null, attributeNewValue: g, changeCount: this._changeCount++ });
          return l;
        }
        _isInInsertedElement(t) {
          const i = t.parent;
          if (!i)
            return !1;
          const a = this._changesInElement.get(i), l = t.startOffset;
          if (a) {
            for (const d of a)
              if (d.type == "insert" && l >= d.offset && l < d.offset + d.howMany)
                return !0;
          }
          return this._isInInsertedElement(i);
        }
        _removeAllNestedChanges(t, i, a) {
          const l = new ve(Ee._createAt(t, i), Ee._createAt(t, i + a));
          for (const d of l.getItems({ shallow: !0 }))
            d.is("element") && (this._elementSnapshots.delete(d), this._changesInElement.delete(d), this._removeAllNestedChanges(d, 0, d.maxOffset));
        }
      }
      function hA(c) {
        const t = [];
        for (const i of c)
          if (i.is("$text"))
            for (let a = 0; a < i.data.length; a++)
              t.push({ name: "$text", attributes: new Map(i.getAttributes()) });
          else
            t.push({ name: i.name, attributes: new Map(i.getAttributes()) });
        return t;
      }
      function o6(c, t) {
        const i = [];
        let a = 0, l = 0;
        for (const d of t) {
          if (d.offset > a) {
            for (let g = 0; g < d.offset - a; g++)
              i.push("e");
            l += d.offset - a;
          }
          if (d.type == "insert") {
            for (let g = 0; g < d.howMany; g++)
              i.push("i");
            a = d.offset + d.howMany;
          } else if (d.type == "remove") {
            for (let g = 0; g < d.howMany; g++)
              i.push("r");
            a = d.offset, l += d.howMany;
          } else
            i.push(..."a".repeat(d.howMany).split("")), a = d.offset + d.howMany, l += d.howMany;
        }
        if (l < c)
          for (let d = 0; d < c - l - a; d++)
            i.push("e");
        return i;
      }
      function a6(c) {
        const t = "position" in c && c.position.root.rootName == "$graveyard", i = "range" in c && c.range.root.rootName == "$graveyard";
        return !t && !i;
      }
      class s6 {
        constructor() {
          this._operations = [], this._undoPairs = /* @__PURE__ */ new Map(), this._undoneOperations = /* @__PURE__ */ new Set(), this._baseVersionToOperationIndex = /* @__PURE__ */ new Map(), this._version = 0, this._gaps = /* @__PURE__ */ new Map();
        }
        get version() {
          return this._version;
        }
        set version(t) {
          this._operations.length && t > this._version + 1 && this._gaps.set(this._version, t), this._version = t;
        }
        get lastOperation() {
          return this._operations[this._operations.length - 1];
        }
        addOperation(t) {
          if (t.baseVersion !== this.version)
            throw new S("model-document-history-addoperation-incorrect-version", this, { operation: t, historyVersion: this.version });
          this._operations.push(t), this._version++, this._baseVersionToOperationIndex.set(t.baseVersion, this._operations.length - 1);
        }
        getOperations(t, i = this.version) {
          if (!this._operations.length)
            return [];
          const a = this._operations[0];
          t === void 0 && (t = a.baseVersion);
          let l = i - 1;
          for (const [m, w] of this._gaps)
            t > m && t < w && (t = w), l > m && l < w && (l = m - 1);
          if (l < a.baseVersion || t > this.lastOperation.baseVersion)
            return [];
          let d = this._baseVersionToOperationIndex.get(t);
          d === void 0 && (d = 0);
          let g = this._baseVersionToOperationIndex.get(l);
          return g === void 0 && (g = this._operations.length - 1), this._operations.slice(d, g + 1);
        }
        getOperation(t) {
          const i = this._baseVersionToOperationIndex.get(t);
          if (i !== void 0)
            return this._operations[i];
        }
        setOperationAsUndone(t, i) {
          this._undoPairs.set(i, t), this._undoneOperations.add(t);
        }
        isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
        isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
        getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
        reset() {
          this._version = 0, this._undoPairs = /* @__PURE__ */ new Map(), this._operations = [], this._undoneOperations = /* @__PURE__ */ new Set(), this._gaps = /* @__PURE__ */ new Map(), this._baseVersionToOperationIndex = /* @__PURE__ */ new Map();
        }
      }
      class Eh extends Kt {
        constructor(t, i, a = "main") {
          super(i), this._document = t, this.rootName = a;
        }
        get document() {
          return this._document;
        }
        toJSON() {
          return this.rootName;
        }
      }
      Eh.prototype.is = function(c, t) {
        return t ? t === this.name && (c === "rootElement" || c === "model:rootElement" || c === "element" || c === "model:element") : c === "rootElement" || c === "model:rootElement" || c === "element" || c === "model:element" || c === "node" || c === "model:node";
      };
      const l0 = "$graveyard";
      class l6 extends ie() {
        constructor(t) {
          super(), this.model = t, this.history = new s6(), this.selection = new Yr(this), this.roots = new yi({ idProperty: "rootName" }), this.differ = new i6(t.markers), this._postFixers = /* @__PURE__ */ new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", l0), this.listenTo(t, "applyOperation", (i, a) => {
            const l = a[0];
            l.isDocumentOperation && this.differ.bufferOperation(l);
          }, { priority: "high" }), this.listenTo(t, "applyOperation", (i, a) => {
            const l = a[0];
            l.isDocumentOperation && this.history.addOperation(l);
          }, { priority: "low" }), this.listenTo(this.selection, "change", () => {
            this._hasSelectionChangedFromTheLastChangeBlock = !0;
          }), this.listenTo(t.markers, "update", (i, a, l, d, g) => {
            const m = { ...a.getData(), range: d };
            this.differ.bufferMarkerChange(a.name, g, m), l === null && a.on("change", (w, A) => {
              const C = a.getData();
              this.differ.bufferMarkerChange(a.name, { ...C, range: A }, C);
            });
          });
        }
        get version() {
          return this.history.version;
        }
        set version(t) {
          this.history.version = t;
        }
        get graveyard() {
          return this.getRoot(l0);
        }
        createRoot(t = "$root", i = "main") {
          if (this.roots.get(i))
            throw new S("model-document-createroot-name-exists", this, { name: i });
          const a = new Eh(this, t, i);
          return this.roots.add(a), a;
        }
        destroy() {
          this.selection.destroy(), this.stopListening();
        }
        getRoot(t = "main") {
          return this.roots.get(t);
        }
        getRootNames() {
          return Array.from(this.roots, (t) => t.rootName).filter((t) => t != l0);
        }
        registerPostFixer(t) {
          this._postFixers.add(t);
        }
        toJSON() {
          const t = Hk(this);
          return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
        }
        _handleChangeBlock(t) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
        _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
        _getDefaultRoot() {
          for (const t of this.roots)
            if (t !== this.graveyard)
              return t;
          return this.graveyard;
        }
        _getDefaultRange() {
          const t = this._getDefaultRoot(), i = this.model, a = i.schema, l = i.createPositionFromPath(t, [0]);
          return a.getNearestSelectionRange(l) || i.createRange(l);
        }
        _validateSelectionRange(t) {
          return fA(t.start) && fA(t.end);
        }
        _callPostFixers(t) {
          let i = !1;
          do
            for (const a of this._postFixers)
              if (this.selection.refresh(), i = a(t), i)
                break;
          while (i);
        }
      }
      function fA(c) {
        const t = c.textNode;
        if (t) {
          const i = t.data, a = c.offset - t.startOffset;
          return !Rk(i, a) && !Nk(i, a);
        }
        return !0;
      }
      class c6 extends ie() {
        constructor() {
          super(), this._markers = /* @__PURE__ */ new Map();
        }
        [Symbol.iterator]() {
          return this._markers.values();
        }
        has(t) {
          const i = t instanceof bl ? t.name : t;
          return this._markers.has(i);
        }
        get(t) {
          return this._markers.get(t) || null;
        }
        _set(t, i, a = !1, l = !1) {
          const d = t instanceof bl ? t.name : t;
          if (d.includes(","))
            throw new S("markercollection-incorrect-marker-name", this);
          const g = this._markers.get(d);
          if (g) {
            const A = g.getData(), C = g.getRange();
            let T = !1;
            return C.isEqual(i) || (g._attachLiveRange(_i.fromRange(i)), T = !0), a != g.managedUsingOperations && (g._managedUsingOperations = a, T = !0), typeof l == "boolean" && l != g.affectsData && (g._affectsData = l, T = !0), T && this.fire(`update:${d}`, g, C, i, A), g;
          }
          const m = _i.fromRange(i), w = new bl(d, m, a, l);
          return this._markers.set(d, w), this.fire(`update:${d}`, w, null, i, { ...w.getData(), range: null }), w;
        }
        _remove(t) {
          const i = t instanceof bl ? t.name : t, a = this._markers.get(i);
          return !!a && (this._markers.delete(i), this.fire(`update:${i}`, a, a.getRange(), null, a.getData()), this._destroyMarker(a), !0);
        }
        _refresh(t) {
          const i = t instanceof bl ? t.name : t, a = this._markers.get(i);
          if (!a)
            throw new S("markercollection-refresh-marker-not-exists", this);
          const l = a.getRange();
          this.fire(`update:${i}`, a, l, l, a.getData());
        }
        *getMarkersAtPosition(t) {
          for (const i of this)
            i.getRange().containsPosition(t) && (yield i);
        }
        *getMarkersIntersectingRange(t) {
          for (const i of this)
            i.getRange().getIntersection(t) !== null && (yield i);
        }
        destroy() {
          for (const t of this._markers.values())
            this._destroyMarker(t);
          this._markers = null, this.stopListening();
        }
        *getMarkersGroup(t) {
          for (const i of this._markers.values())
            i.name.startsWith(t + ":") && (yield i);
        }
        _destroyMarker(t) {
          t.stopListening(), t._detachLiveRange();
        }
      }
      class bl extends ie(la) {
        constructor(t, i, a, l) {
          super(), this.name = t, this._liveRange = this._attachLiveRange(i), this._managedUsingOperations = a, this._affectsData = l;
        }
        get managedUsingOperations() {
          if (!this._liveRange)
            throw new S("marker-destroyed", this);
          return this._managedUsingOperations;
        }
        get affectsData() {
          if (!this._liveRange)
            throw new S("marker-destroyed", this);
          return this._affectsData;
        }
        getData() {
          return { range: this.getRange(), affectsData: this.affectsData, managedUsingOperations: this.managedUsingOperations };
        }
        getStart() {
          if (!this._liveRange)
            throw new S("marker-destroyed", this);
          return this._liveRange.start.clone();
        }
        getEnd() {
          if (!this._liveRange)
            throw new S("marker-destroyed", this);
          return this._liveRange.end.clone();
        }
        getRange() {
          if (!this._liveRange)
            throw new S("marker-destroyed", this);
          return this._liveRange.toRange();
        }
        _attachLiveRange(t) {
          return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
        }
        _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }
      bl.prototype.is = function(c) {
        return c === "marker" || c === "model:marker";
      };
      class u6 extends Qr {
        constructor(t, i) {
          super(null), this.sourcePosition = t.clone(), this.howMany = i;
        }
        get type() {
          return "detach";
        }
        toJSON() {
          const t = super.toJSON();
          return t.sourcePosition = this.sourcePosition.toJSON(), t;
        }
        _validate() {
          if (this.sourcePosition.root.document)
            throw new S("detach-operation-on-document-node", this);
        }
        _execute() {
          rA(ve._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
        static get className() {
          return "DetachOperation";
        }
      }
      class Do extends la {
        constructor(t) {
          super(), this.markers = /* @__PURE__ */ new Map(), this._children = new ou(), t && this._insertChild(0, t);
        }
        [Symbol.iterator]() {
          return this.getChildren();
        }
        get childCount() {
          return this._children.length;
        }
        get maxOffset() {
          return this._children.maxOffset;
        }
        get isEmpty() {
          return this.childCount === 0;
        }
        get nextSibling() {
          return null;
        }
        get previousSibling() {
          return null;
        }
        get root() {
          return this;
        }
        get parent() {
          return null;
        }
        get document() {
          return null;
        }
        getAncestors() {
          return [];
        }
        getChild(t) {
          return this._children.getNode(t);
        }
        getChildren() {
          return this._children[Symbol.iterator]();
        }
        getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
        getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
        getPath() {
          return [];
        }
        getNodeByPath(t) {
          let i = this;
          for (const a of t)
            i = i.getChild(i.offsetToIndex(a));
          return i;
        }
        offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
        toJSON() {
          const t = [];
          for (const i of this._children)
            t.push(i.toJSON());
          return t;
        }
        static fromJSON(t) {
          const i = [];
          for (const a of t)
            a.name ? i.push(Kt.fromJSON(a)) : i.push(Jt.fromJSON(a));
          return new Do(i);
        }
        _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
        _insertChild(t, i) {
          const a = function(l) {
            return typeof l == "string" ? [new Jt(l)] : (Ft(l) || (l = [l]), Array.from(l).map((d) => typeof d == "string" ? new Jt(d) : d instanceof ki ? new Jt(d.data, d.getAttributes()) : d));
          }(i);
          for (const l of a)
            l.parent !== null && l._remove(), l.parent = this;
          this._children._insertNodes(t, a);
        }
        _removeChildren(t, i = 1) {
          const a = this._children._removeNodes(t, i);
          for (const l of a)
            l.parent = null;
          return a;
        }
      }
      Do.prototype.is = function(c) {
        return c === "documentFragment" || c === "model:documentFragment";
      };
      class d6 {
        constructor(t, i) {
          this.model = t, this.batch = i;
        }
        createText(t, i) {
          return new Jt(t, i);
        }
        createElement(t, i) {
          return new Kt(t, i);
        }
        createDocumentFragment() {
          return new Do();
        }
        cloneElement(t, i = !0) {
          return t._clone(i);
        }
        insert(t, i, a = 0) {
          if (this._assertWriterUsedCorrectly(), t instanceof Jt && t.data == "")
            return;
          const l = Ee._createAt(i, a);
          if (t.parent) {
            if (mA(t.root, l.root))
              return void this.move(ve._createOn(t), l);
            if (t.root.document)
              throw new S("model-writer-insert-forbidden-move", this);
            this.remove(t);
          }
          const d = l.root.document ? l.root.document.version : null, g = new Qn(l, t, d);
          if (t instanceof Jt && (g.shouldReceiveAttributes = !0), this.batch.addOperation(g), this.model.applyOperation(g), t instanceof Do)
            for (const [m, w] of t.markers) {
              const A = Ee._createAt(w.root, 0), C = { range: new ve(w.start._getCombined(A, l), w.end._getCombined(A, l)), usingOperation: !0, affectsData: !0 };
              this.model.markers.has(m) ? this.updateMarker(m, C) : this.addMarker(m, C);
            }
        }
        insertText(t, i, a, l) {
          i instanceof Do || i instanceof Kt || i instanceof Ee ? this.insert(this.createText(t), i, a) : this.insert(this.createText(t, i), a, l);
        }
        insertElement(t, i, a, l) {
          i instanceof Do || i instanceof Kt || i instanceof Ee ? this.insert(this.createElement(t), i, a) : this.insert(this.createElement(t, i), a, l);
        }
        append(t, i) {
          this.insert(t, i, "end");
        }
        appendText(t, i, a) {
          i instanceof Do || i instanceof Kt ? this.insert(this.createText(t), i, "end") : this.insert(this.createText(t, i), a, "end");
        }
        appendElement(t, i, a) {
          i instanceof Do || i instanceof Kt ? this.insert(this.createElement(t), i, "end") : this.insert(this.createElement(t, i), a, "end");
        }
        setAttribute(t, i, a) {
          if (this._assertWriterUsedCorrectly(), a instanceof ve) {
            const l = a.getMinimalFlatRanges();
            for (const d of l)
              pA(this, t, i, d);
          } else
            gA(this, t, i, a);
        }
        setAttributes(t, i) {
          for (const [a, l] of Zi(t))
            this.setAttribute(a, l, i);
        }
        removeAttribute(t, i) {
          if (this._assertWriterUsedCorrectly(), i instanceof ve) {
            const a = i.getMinimalFlatRanges();
            for (const l of a)
              pA(this, t, null, l);
          } else
            gA(this, t, null, i);
        }
        clearAttributes(t) {
          this._assertWriterUsedCorrectly();
          const i = (a) => {
            for (const l of a.getAttributeKeys())
              this.removeAttribute(l, a);
          };
          if (t instanceof ve)
            for (const a of t.getItems())
              i(a);
          else
            i(t);
        }
        move(t, i, a) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof ve))
            throw new S("writer-move-invalid-range", this);
          if (!t.isFlat)
            throw new S("writer-move-range-not-flat", this);
          const l = Ee._createAt(i, a);
          if (l.isEqual(t.start))
            return;
          if (this._addOperationForAffectedMarkers("move", t), !mA(t.root, l.root))
            throw new S("writer-move-different-document", this);
          const d = t.root.document ? t.root.document.version : null, g = new Ot(t.start, t.end.offset - t.start.offset, l, d);
          this.batch.addOperation(g), this.model.applyOperation(g);
        }
        remove(t) {
          this._assertWriterUsedCorrectly();
          const i = (t instanceof ve ? t : ve._createOn(t)).getMinimalFlatRanges().reverse();
          for (const a of i)
            this._addOperationForAffectedMarkers("move", a), h6(a.start, a.end.offset - a.start.offset, this.batch, this.model);
        }
        merge(t) {
          this._assertWriterUsedCorrectly();
          const i = t.nodeBefore, a = t.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", t), !(i instanceof Kt))
            throw new S("writer-merge-no-element-before", this);
          if (!(a instanceof Kt))
            throw new S("writer-merge-no-element-after", this);
          t.root.document ? this._merge(t) : this._mergeDetached(t);
        }
        createPositionFromPath(t, i, a) {
          return this.model.createPositionFromPath(t, i, a);
        }
        createPositionAt(t, i) {
          return this.model.createPositionAt(t, i);
        }
        createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
        createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
        createRange(t, i) {
          return this.model.createRange(t, i);
        }
        createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
        createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
        createSelection(...t) {
          return this.model.createSelection(...t);
        }
        _mergeDetached(t) {
          const i = t.nodeBefore, a = t.nodeAfter;
          this.move(ve._createIn(a), Ee._createAt(i, "end")), this.remove(a);
        }
        _merge(t) {
          const i = Ee._createAt(t.nodeBefore, "end"), a = Ee._createAt(t.nodeAfter, 0), l = t.root.document.graveyard, d = new Ee(l, [0]), g = t.root.document.version, m = new Pn(a, t.nodeAfter.maxOffset, i, d, g);
          this.batch.addOperation(m), this.model.applyOperation(m);
        }
        rename(t, i) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Kt))
            throw new S("writer-rename-not-element-instance", this);
          const a = t.root.document ? t.root.document.version : null, l = new xr(Ee._createBefore(t), t.name, i, a);
          this.batch.addOperation(l), this.model.applyOperation(l);
        }
        split(t, i) {
          this._assertWriterUsedCorrectly();
          let a, l, d = t.parent;
          if (!d.parent)
            throw new S("writer-split-element-no-parent", this);
          if (i || (i = d.parent), !t.parent.getAncestors({ includeSelf: !0 }).includes(i))
            throw new S("writer-split-invalid-limit-element", this);
          do {
            const g = d.root.document ? d.root.document.version : null, m = d.maxOffset - t.offset, w = en.getInsertionPosition(t), A = new en(t, m, w, null, g);
            this.batch.addOperation(A), this.model.applyOperation(A), a || l || (a = d, l = t.parent.nextSibling), d = (t = this.createPositionAfter(t.parent)).parent;
          } while (d !== i);
          return { position: t, range: new ve(Ee._createAt(a, "end"), Ee._createAt(l, 0)) };
        }
        wrap(t, i) {
          if (this._assertWriterUsedCorrectly(), !t.isFlat)
            throw new S("writer-wrap-range-not-flat", this);
          const a = i instanceof Kt ? i : new Kt(i);
          if (a.childCount > 0)
            throw new S("writer-wrap-element-not-empty", this);
          if (a.parent !== null)
            throw new S("writer-wrap-element-attached", this);
          this.insert(a, t.start);
          const l = new ve(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(l, Ee._createAt(a, 0));
        }
        unwrap(t) {
          if (this._assertWriterUsedCorrectly(), t.parent === null)
            throw new S("writer-unwrap-element-no-parent", this);
          this.move(ve._createIn(t), this.createPositionAfter(t)), this.remove(t);
        }
        addMarker(t, i) {
          if (this._assertWriterUsedCorrectly(), !i || typeof i.usingOperation != "boolean")
            throw new S("writer-addmarker-no-usingoperation", this);
          const a = i.usingOperation, l = i.range, d = i.affectsData !== void 0 && i.affectsData;
          if (this.model.markers.has(t))
            throw new S("writer-addmarker-marker-exists", this);
          if (!l)
            throw new S("writer-addmarker-no-range", this);
          return a ? (fu(this, t, null, l, d), this.model.markers.get(t)) : this.model.markers._set(t, l, a, d);
        }
        updateMarker(t, i) {
          this._assertWriterUsedCorrectly();
          const a = typeof t == "string" ? t : t.name, l = this.model.markers.get(a);
          if (!l)
            throw new S("writer-updatemarker-marker-not-exists", this);
          if (!i)
            return $("writer-updatemarker-reconvert-using-editingcontroller", { markerName: a }), void this.model.markers._refresh(l);
          const d = typeof i.usingOperation == "boolean", g = typeof i.affectsData == "boolean", m = g ? i.affectsData : l.affectsData;
          if (!d && !i.range && !g)
            throw new S("writer-updatemarker-wrong-options", this);
          const w = l.getRange(), A = i.range ? i.range : w;
          d && i.usingOperation !== l.managedUsingOperations ? i.usingOperation ? fu(this, a, null, A, m) : (fu(this, a, w, null, m), this.model.markers._set(a, A, void 0, m)) : l.managedUsingOperations ? fu(this, a, w, A, m) : this.model.markers._set(a, A, void 0, m);
        }
        removeMarker(t) {
          this._assertWriterUsedCorrectly();
          const i = typeof t == "string" ? t : t.name;
          if (!this.model.markers.has(i))
            throw new S("writer-removemarker-no-marker", this);
          const a = this.model.markers.get(i);
          if (!a.managedUsingOperations)
            return void this.model.markers._remove(i);
          fu(this, i, a.getRange(), null, a.affectsData);
        }
        setSelection(...t) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...t);
        }
        setSelectionFocus(t, i) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, i);
        }
        setSelectionAttribute(t, i) {
          if (this._assertWriterUsedCorrectly(), typeof t == "string")
            this._setSelectionAttribute(t, i);
          else
            for (const [a, l] of Zi(t))
              this._setSelectionAttribute(a, l);
        }
        removeSelectionAttribute(t) {
          if (this._assertWriterUsedCorrectly(), typeof t == "string")
            this._removeSelectionAttribute(t);
          else
            for (const i of t)
              this._removeSelectionAttribute(i);
        }
        overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
        restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
        _setSelectionAttribute(t, i) {
          const a = this.model.document.selection;
          if (a.isCollapsed && a.anchor.parent.isEmpty) {
            const l = Yr._getStoreAttributeKey(t);
            this.setAttribute(l, i, a.anchor.parent);
          }
          a._setAttribute(t, i);
        }
        _removeSelectionAttribute(t) {
          const i = this.model.document.selection;
          if (i.isCollapsed && i.anchor.parent.isEmpty) {
            const a = Yr._getStoreAttributeKey(t);
            this.removeAttribute(a, i.anchor.parent);
          }
          i._removeAttribute(t);
        }
        _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this)
            throw new S("writer-incorrect-use", this);
        }
        _addOperationForAffectedMarkers(t, i) {
          for (const a of this.model.markers) {
            if (!a.managedUsingOperations)
              continue;
            const l = a.getRange();
            let d = !1;
            if (t === "move") {
              const g = i;
              d = g.containsPosition(l.start) || g.start.isEqual(l.start) || g.containsPosition(l.end) || g.end.isEqual(l.end);
            } else {
              const g = i, m = g.nodeBefore, w = g.nodeAfter, A = l.start.parent == m && l.start.isAtEnd, C = l.end.parent == w && l.end.offset == 0, T = l.end.nodeAfter == w, R = l.start.nodeAfter == w;
              d = A || C || T || R;
            }
            d && this.updateMarker(a.name, { range: l });
          }
        }
      }
      function pA(c, t, i, a) {
        const l = c.model, d = l.document;
        let g, m, w, A = a.start;
        for (const T of a.getWalker({ shallow: !0 }))
          w = T.item.getAttribute(t), g && m != w && (m != i && C(), A = g), g = T.nextPosition, m = w;
        function C() {
          const T = new ve(A, g), R = T.root.document ? d.version : null, j = new Rn(T, t, m, i, R);
          c.batch.addOperation(j), l.applyOperation(j);
        }
        g instanceof Ee && g != A && m != i && C();
      }
      function gA(c, t, i, a) {
        const l = c.model, d = l.document, g = a.getAttribute(t);
        let m, w;
        if (g != i) {
          if (a.root === a) {
            const A = a.document ? d.version : null;
            w = new To(a, t, g, i, A);
          } else {
            m = new ve(Ee._createBefore(a), c.createPositionAfter(a));
            const A = m.root.document ? d.version : null;
            w = new Rn(m, t, g, i, A);
          }
          c.batch.addOperation(w), l.applyOperation(w);
        }
      }
      function fu(c, t, i, a, l) {
        const d = c.model, g = d.document, m = new Cr(t, i, a, d.markers, !!l, g.version);
        c.batch.addOperation(m), d.applyOperation(m);
      }
      function h6(c, t, i, a) {
        let l;
        if (c.root.document) {
          const d = a.document, g = new Ee(d.graveyard, [0]);
          l = new Ot(c, t, g, d.version);
        } else
          l = new u6(c, t);
        i.addOperation(l), a.applyOperation(l);
      }
      function mA(c, t) {
        return c === t || c instanceof Eh && t instanceof Eh;
      }
      function f6(c) {
        c.document.registerPostFixer((t) => function(i, a) {
          const l = a.document.selection, d = a.schema, g = [];
          let m = !1;
          for (const w of l.getRanges()) {
            const A = p6(w, d);
            A && !A.isEqual(w) ? (g.push(A), m = !0) : g.push(w);
          }
          return m && i.setSelection(function(w) {
            const A = [...w], C = /* @__PURE__ */ new Set();
            let T = 1;
            for (; T < A.length; ) {
              const R = A[T], j = A.slice(0, T);
              for (const [F, V] of j.entries())
                if (!C.has(F)) {
                  if (R.isEqual(V))
                    C.add(F);
                  else if (R.isIntersecting(V)) {
                    C.add(F), C.add(T);
                    const W = R.getJoined(V);
                    A.push(W);
                  }
                }
              T++;
            }
            return A.filter((R, j) => !C.has(j));
          }(g), { backward: l.isBackward }), !1;
        }(t, c));
      }
      function p6(c, t) {
        return c.isCollapsed ? function(i, a) {
          const l = i.start, d = a.getNearestSelectionRange(l);
          if (!d) {
            const m = l.getAncestors().reverse().find((w) => a.isObject(w));
            return m ? ve._createOn(m) : null;
          }
          if (!d.isCollapsed)
            return d;
          const g = d.start;
          return l.isEqual(g) ? null : new ve(g);
        }(c, t) : function(i, a) {
          const { start: l, end: d } = i, g = a.checkChild(l, "$text"), m = a.checkChild(d, "$text"), w = a.getLimitElement(l), A = a.getLimitElement(d);
          if (w === A) {
            if (g && m)
              return null;
            if (function(R, j, F) {
              const V = R.nodeAfter && !F.isLimit(R.nodeAfter) || F.checkChild(R, "$text"), W = j.nodeBefore && !F.isLimit(j.nodeBefore) || F.checkChild(j, "$text");
              return V || W;
            }(l, d, a)) {
              const R = l.nodeAfter && a.isSelectable(l.nodeAfter) ? null : a.getNearestSelectionRange(l, "forward"), j = d.nodeBefore && a.isSelectable(d.nodeBefore) ? null : a.getNearestSelectionRange(d, "backward"), F = R ? R.start : l, V = j ? j.end : d;
              return new ve(F, V);
            }
          }
          const C = w && !w.is("rootElement"), T = A && !A.is("rootElement");
          if (C || T) {
            const R = l.nodeAfter && d.nodeBefore && l.nodeAfter.parent === d.nodeBefore.parent, j = C && (!R || !bA(l.nodeAfter, a)), F = T && (!R || !bA(d.nodeBefore, a));
            let V = l, W = d;
            return j && (V = Ee._createBefore(vA(w, a))), F && (W = Ee._createAfter(vA(A, a))), new ve(V, W);
          }
          return null;
        }(c, t);
      }
      function vA(c, t) {
        let i = c, a = i;
        for (; t.isLimit(a) && a.parent; )
          i = a, a = a.parent;
        return i;
      }
      function bA(c, t) {
        return c && t.isSelectable(c);
      }
      function g6(c, t, i = {}) {
        if (t.isCollapsed)
          return;
        const a = t.getFirstRange();
        if (a.root.rootName == "$graveyard")
          return;
        const l = c.schema;
        c.change((d) => {
          if (!i.doNotResetEntireContent && function(A, C) {
            const T = A.getLimitElement(C);
            if (!C.containsEntireContent(T))
              return !1;
            const R = C.getFirstRange();
            return R.start.parent == R.end.parent ? !1 : A.checkChild(T, "paragraph");
          }(l, t))
            return void function(A, C) {
              const T = A.model.schema.getLimitElement(C);
              A.remove(A.createRangeIn(T)), kA(A, A.createPositionAt(T, 0), C);
            }(d, t);
          const g = {};
          if (!i.doNotAutoparagraph) {
            const A = t.getSelectedElement();
            A && Object.assign(g, l.getAttributesWithProperty(A, "copyOnReplace", !0));
          }
          const [m, w] = function(A) {
            const C = A.root.document.model, T = A.start;
            let R = A.end;
            if (C.hasContent(A, { ignoreMarkers: !0 })) {
              const j = function(F) {
                const V = F.parent, W = V.root.document.model.schema, ee = V.getAncestors({ parentFirst: !0, includeSelf: !0 });
                for (const le of ee) {
                  if (W.isLimit(le))
                    return null;
                  if (W.isBlock(le))
                    return le;
                }
              }(R);
              if (j && R.isTouching(C.createPositionAt(j, 0))) {
                const F = C.createSelection(A);
                C.modifySelection(F, { direction: "backward" });
                const V = F.getLastPosition(), W = C.createRange(V, R);
                C.hasContent(W, { ignoreMarkers: !0 }) || (R = V);
              }
            }
            return [ar.fromPosition(T, "toPrevious"), ar.fromPosition(R, "toNext")];
          }(a);
          m.isTouching(w) || d.remove(d.createRange(m, w)), i.leaveUnmerged || (function(A, C, T) {
            const R = A.model;
            if (!c0(A.model.schema, C, T))
              return;
            const [j, F] = function(V, W) {
              const ee = V.getAncestors(), le = W.getAncestors();
              let be = 0;
              for (; ee[be] && ee[be] == le[be]; )
                be++;
              return [ee[be], le[be]];
            }(C, T);
            !j || !F || (!R.hasContent(j, { ignoreMarkers: !0 }) && R.hasContent(F, { ignoreMarkers: !0 }) ? yA(A, C, T, j.parent) : wA(A, C, T, j.parent));
          }(d, m, w), l.removeDisallowedAttributes(m.parent.getChildren(), d)), _A(d, t, m), !i.doNotAutoparagraph && function(A, C) {
            const T = A.checkChild(C, "$text"), R = A.checkChild(C, "paragraph");
            return !T && R;
          }(l, m) && kA(d, m, t, g), m.detach(), w.detach();
        });
      }
      function wA(c, t, i, a) {
        const l = t.parent, d = i.parent;
        if (l != a && d != a) {
          for (t = c.createPositionAfter(l), (i = c.createPositionBefore(d)).isEqual(t) || c.insert(d, t), c.merge(t); i.parent.isEmpty; ) {
            const g = i.parent;
            i = c.createPositionBefore(g), c.remove(g);
          }
          c0(c.model.schema, t, i) && wA(c, t, i, a);
        }
      }
      function yA(c, t, i, a) {
        const l = t.parent, d = i.parent;
        if (l != a && d != a) {
          for (t = c.createPositionAfter(l), (i = c.createPositionBefore(d)).isEqual(t) || c.insert(l, i); t.parent.isEmpty; ) {
            const g = t.parent;
            t = c.createPositionBefore(g), c.remove(g);
          }
          i = c.createPositionBefore(d), function(g, m) {
            const w = m.nodeBefore, A = m.nodeAfter;
            w.name != A.name && g.rename(w, A.name), g.clearAttributes(w), g.setAttributes(Object.fromEntries(A.getAttributes()), w), g.merge(m);
          }(c, i), c0(c.model.schema, t, i) && yA(c, t, i, a);
        }
      }
      function c0(c, t, i) {
        const a = t.parent, l = i.parent;
        return a != l && !c.isLimit(a) && !c.isLimit(l) && function(d, g, m) {
          const w = new ve(d, g);
          for (const A of w.getWalker())
            if (m.isLimit(A.item))
              return !1;
          return !0;
        }(t, i, c);
      }
      function kA(c, t, i, a = {}) {
        const l = c.createElement("paragraph");
        c.model.schema.setAllowedAttributes(l, a, c), c.insert(l, t), _A(c, i, c.createPositionAt(l, 0));
      }
      function _A(c, t, i) {
        t instanceof Yr ? c.setSelection(i) : t.setTo(i);
      }
      function AA(c, t) {
        const i = [];
        Array.from(c.getItems({ direction: "backward" })).map((a) => t.createRangeOn(a)).filter((a) => (a.start.isAfter(c.start) || a.start.isEqual(c.start)) && (a.end.isBefore(c.end) || a.end.isEqual(c.end))).forEach((a) => {
          i.push(a.start.parent), t.remove(a);
        }), i.forEach((a) => {
          let l = a;
          for (; l.parent && l.isEmpty; ) {
            const d = t.createRangeOn(l);
            l = l.parent, t.remove(d);
          }
        });
      }
      class m6 {
        constructor(t, i, a) {
          this.model = t, this.writer = i, this.position = a, this.canMergeWith = /* @__PURE__ */ new Set([this.position.parent]), this.schema = t.schema, this._documentFragment = i.createDocumentFragment(), this._documentFragmentPosition = i.createPositionAt(this._documentFragment, 0), this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
        }
        handleNodes(t) {
          for (const i of Array.from(t))
            this._handleNode(i);
          this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
        _updateLastNodeFromAutoParagraph(t) {
          const i = this.writer.createPositionAfter(this._lastNode), a = this.writer.createPositionAfter(t);
          if (a.isAfter(i)) {
            if (this._lastNode = t, this.position.parent != t || !this.position.isAtEnd)
              throw new S("insertcontent-invalid-insertion-position", this);
            this.position = a, this._setAffectedBoundaries(this.position);
          }
        }
        getSelectionRange() {
          return this._nodeToSelect ? ve._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
        getAffectedRange() {
          return this._affectedStart ? new ve(this._affectedStart, this._affectedEnd) : null;
        }
        destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
        _handleNode(t) {
          if (this.schema.isObject(t))
            return void this._handleObject(t);
          let i = this._checkAndAutoParagraphToAllowedPosition(t);
          i || (i = this._checkAndSplitToAllowedPosition(t), i) ? (this._appendToFragment(t), this._firstNode || (this._firstNode = t), this._lastNode = t) : this._handleDisallowedNode(t);
        }
        _insertPartialFragment() {
          if (this._documentFragment.isEmpty)
            return;
          const t = ar.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t.toPosition(), t.detach();
        }
        _handleObject(t) {
          this._checkAndSplitToAllowedPosition(t) ? this._appendToFragment(t) : this._tryAutoparagraphing(t);
        }
        _handleDisallowedNode(t) {
          t.is("element") ? this.handleNodes(t.getChildren()) : this._tryAutoparagraphing(t);
        }
        _appendToFragment(t) {
          if (!this.schema.checkChild(this.position, t))
            throw new S("insertcontent-wrong-position", this, { node: t, position: this.position });
          this.writer.insert(t, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = t : this._nodeToSelect = null, this._filterAttributesOf.push(t);
        }
        _setAffectedBoundaries(t) {
          this._affectedStart || (this._affectedStart = ar.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = ar.fromPosition(t, "toNext"));
        }
        _mergeOnLeft() {
          const t = this._firstNode;
          if (!(t instanceof Kt) || !this._canMergeLeft(t))
            return;
          const i = ar._createBefore(t);
          i.stickiness = "toNext";
          const a = ar.fromPosition(this.position, "toNext");
          this._affectedStart.isEqual(i) && (this._affectedStart.detach(), this._affectedStart = ar._createAt(i.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = i.nodeBefore, this._lastNode = i.nodeBefore), this.writer.merge(i), i.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = ar._createAt(i.nodeBefore, "end", "toNext")), this.position = a.toPosition(), a.detach(), this._filterAttributesOf.push(this.position.parent), i.detach();
        }
        _mergeOnRight() {
          const t = this._lastNode;
          if (!(t instanceof Kt) || !this._canMergeRight(t))
            return;
          const i = ar._createAfter(t);
          if (i.stickiness = "toNext", !this.position.isEqual(i))
            throw new S("insertcontent-invalid-insertion-position", this);
          this.position = Ee._createAt(i.nodeBefore, "end");
          const a = ar.fromPosition(this.position, "toPrevious");
          this._affectedEnd.isEqual(i) && (this._affectedEnd.detach(), this._affectedEnd = ar._createAt(i.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = i.nodeBefore, this._lastNode = i.nodeBefore), this.writer.merge(i), i.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = ar._createAt(i.nodeBefore, 0, "toPrevious")), this.position = a.toPosition(), a.detach(), this._filterAttributesOf.push(this.position.parent), i.detach();
        }
        _canMergeLeft(t) {
          const i = t.previousSibling;
          return i instanceof Kt && this.canMergeWith.has(i) && this.model.schema.checkMerge(i, t);
        }
        _canMergeRight(t) {
          const i = t.nextSibling;
          return i instanceof Kt && this.canMergeWith.has(i) && this.model.schema.checkMerge(t, i);
        }
        _tryAutoparagraphing(t) {
          const i = this.writer.createElement("paragraph");
          this._getAllowedIn(this.position.parent, i) && this.schema.checkChild(i, t) && (i._appendChild(t), this._handleNode(i));
        }
        _checkAndAutoParagraphToAllowedPosition(t) {
          if (this.schema.checkChild(this.position.parent, t))
            return !0;
          if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t))
            return !1;
          this._insertPartialFragment();
          const i = this.writer.createElement("paragraph");
          return this.writer.insert(i, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = i, this.position = this.writer.createPositionAt(i, 0), !0;
        }
        _checkAndSplitToAllowedPosition(t) {
          const i = this._getAllowedIn(this.position.parent, t);
          if (!i)
            return !1;
          for (i != this.position.parent && this._insertPartialFragment(); i != this.position.parent; )
            if (this.position.isAtStart) {
              const a = this.position.parent;
              this.position = this.writer.createPositionBefore(a), a.isEmpty && a.parent === i && this.writer.remove(a);
            } else if (this.position.isAtEnd)
              this.position = this.writer.createPositionAfter(this.position.parent);
            else {
              const a = this.writer.createPositionAfter(this.position.parent);
              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = a, this.canMergeWith.add(this.position.nodeAfter);
            }
          return !0;
        }
        _getAllowedIn(t, i) {
          return this.schema.checkChild(t, i) ? t : this.schema.isLimit(t) ? null : this._getAllowedIn(t.parent, i);
        }
      }
      function CA(c, t, i = "auto") {
        const a = c.getSelectedElement();
        if (a && t.schema.isObject(a) && !t.schema.isInline(a))
          return i == "before" || i == "after" ? t.createRange(t.createPositionAt(a, i)) : t.createRangeOn(a);
        const l = Fn(c.getSelectedBlocks());
        if (!l)
          return t.createRange(c.focus);
        if (l.isEmpty)
          return t.createRange(t.createPositionAt(l, 0));
        const d = t.createPositionAfter(l);
        return c.focus.isTouching(d) ? t.createRange(d) : t.createRange(t.createPositionBefore(l));
      }
      function v6(c, t, i, a, l = {}) {
        if (!c.schema.isObject(t))
          throw new S("insertobject-element-not-an-object", c, { object: t });
        let d;
        d = i ? i instanceof ro || i instanceof Yr ? i : c.createSelection(i, a) : c.document.selection;
        let g = d;
        l.findOptimalPosition && c.schema.isBlock(t) && (g = c.createSelection(CA(d, c, l.findOptimalPosition)));
        const m = Fn(d.getSelectedBlocks()), w = {};
        return m && Object.assign(w, c.schema.getAttributesWithProperty(m, "copyOnReplace", !0)), c.change((A) => {
          g.isCollapsed || c.deleteContent(g, { doNotAutoparagraph: !0 });
          let C = t;
          const T = g.anchor.parent;
          !c.schema.checkChild(T, t) && c.schema.checkChild(T, "paragraph") && c.schema.checkChild("paragraph", t) && (C = A.createElement("paragraph"), A.insert(t, C)), c.schema.setAllowedAttributes(C, w, A);
          const R = c.insertContent(C, g);
          return R.isCollapsed || l.setSelection && function(j, F, V, W) {
            const ee = j.model;
            if (V == "on")
              return void j.setSelection(F, "on");
            if (V != "after")
              throw new S("insertobject-invalid-place-parameter-value", ee);
            let le = F.nextSibling;
            if (ee.schema.isInline(F))
              return void j.setSelection(F, "after");
            !(le && ee.schema.checkChild(le, "$text")) && ee.schema.checkChild(F.parent, "paragraph") && (le = j.createElement("paragraph"), ee.schema.setAllowedAttributes(le, W, j), ee.insertContent(le, j.createPositionAfter(F))), le && j.setSelection(le, 0);
          }(A, t, l.setSelection, w), R;
        });
      }
      function b6(c, t) {
        const { isForward: i, walker: a, unit: l, schema: d, treatEmojiAsSingleUnit: g } = c, { type: m, item: w, nextPosition: A } = t;
        if (m == "text")
          return c.unit === "word" ? function(C, T) {
            let R = C.position.textNode;
            for (R || (R = T ? C.position.nodeAfter : C.position.nodeBefore); R && R.is("$text"); ) {
              const j = C.position.offset - R.startOffset;
              if (k6(R, j, T))
                R = T ? C.position.nodeAfter : C.position.nodeBefore;
              else {
                if (y6(R.data, j, T))
                  break;
                C.next();
              }
            }
            return C.position;
          }(a, i) : function(C, T, R) {
            const j = C.position.textNode;
            if (j) {
              const F = j.data;
              let V = C.position.offset - j.startOffset;
              for (; Rk(F, V) || T == "character" && Nk(F, V) || R && KO(F, V); )
                C.next(), V = C.position.offset - j.startOffset;
            }
            return C.position;
          }(a, l, g);
        if (m == (i ? "elementStart" : "elementEnd")) {
          if (d.isSelectable(w))
            return Ee._createAt(w, i ? "after" : "before");
          if (d.checkChild(A, "$text"))
            return A;
        } else {
          if (d.isLimit(w))
            return void a.skip(() => !0);
          if (d.checkChild(A, "$text"))
            return A;
        }
      }
      function w6(c, t) {
        const i = c.root, a = Ee._createAt(i, t ? "end" : 0);
        return t ? new ve(c, a) : new ve(a, c);
      }
      function y6(c, t, i) {
        const a = t + (i ? 0 : -1);
        return ' ,.?!:;"-()'.includes(c.charAt(a));
      }
      function k6(c, t, i) {
        return t === (i ? c.offsetSize : 0);
      }
      class _6 extends Te() {
        constructor() {
          super(), this.markers = new c6(), this.document = new l6(this), this.schema = new NN(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "insertObject", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach((t) => this.decorate(t)), this.on("applyOperation", (t, i) => {
            i[0]._validate();
          }, { priority: "highest" }), this.schema.register("$root", { isLimit: !0 }), this.schema.register("$container", { allowIn: ["$root", "$container"] }), this.schema.register("$block", { allowIn: ["$root", "$container"], isBlock: !0 }), this.schema.register("$blockObject", { allowWhere: "$block", isBlock: !0, isObject: !0 }), this.schema.register("$inlineObject", { allowWhere: "$text", allowAttributesOf: "$text", isInline: !0, isObject: !0 }), this.schema.register("$text", { allowIn: "$block", isInline: !0, isContent: !0 }), this.schema.register("$clipboardHolder", { allowContentOf: "$root", allowChildren: "$text", isLimit: !0 }), this.schema.register("$documentFragment", { allowContentOf: "$root", allowChildren: "$text", isLimit: !0 }), this.schema.register("$marker"), this.schema.addChildCheck((t, i) => {
            if (i.name === "$marker")
              return !0;
          }), f6(this), this.document.registerPostFixer(K_);
        }
        change(t) {
          try {
            return this._pendingChanges.length === 0 ? (this._pendingChanges.push({ batch: new vl(), callback: t }), this._runPendingChanges()[0]) : t(this._currentWriter);
          } catch (i) {
            S.rethrowUnexpectedError(i, this);
          }
        }
        enqueueChange(t, i) {
          try {
            t ? typeof t == "function" ? (i = t, t = new vl()) : t instanceof vl || (t = new vl(t)) : t = new vl(), this._pendingChanges.push({ batch: t, callback: i }), this._pendingChanges.length == 1 && this._runPendingChanges();
          } catch (a) {
            S.rethrowUnexpectedError(a, this);
          }
        }
        applyOperation(t) {
          t._execute();
        }
        insertContent(t, i, a) {
          return function(l, d, g, m) {
            return l.change((w) => {
              let A;
              A = g ? g instanceof ro || g instanceof Yr ? g : w.createSelection(g, m) : l.document.selection, A.isCollapsed || l.deleteContent(A, { doNotAutoparagraph: !0 });
              const C = new m6(l, w, A.anchor), T = [];
              let R;
              if (d.is("documentFragment")) {
                if (d.markers.size) {
                  const V = [];
                  for (const [W, ee] of d.markers) {
                    const { start: le, end: be } = ee, Ne = le.isEqual(be);
                    V.push({ position: le, name: W, isCollapsed: Ne }, { position: be, name: W, isCollapsed: Ne });
                  }
                  V.sort(({ position: W }, { position: ee }) => W.isBefore(ee) ? 1 : -1);
                  for (const { position: W, name: ee, isCollapsed: le } of V) {
                    let be = null, Ne = null;
                    const Je = W.parent === d && W.isAtStart, Mt = W.parent === d && W.isAtEnd;
                    Je || Mt ? le && (Ne = Je ? "start" : "end") : (be = w.createElement("$marker"), w.insert(be, W)), T.push({ name: ee, element: be, collapsed: Ne });
                  }
                }
                R = d.getChildren();
              } else
                R = [d];
              C.handleNodes(R);
              let j = C.getSelectionRange();
              if (d.is("documentFragment") && T.length) {
                const V = j ? _i.fromRange(j) : null, W = {};
                for (let ee = T.length - 1; ee >= 0; ee--) {
                  const { name: le, element: be, collapsed: Ne } = T[ee], Je = !W[le];
                  if (Je && (W[le] = []), be) {
                    const Mt = w.createPositionAt(be, "before");
                    W[le].push(Mt), w.remove(be);
                  } else {
                    const Mt = C.getAffectedRange();
                    if (!Mt) {
                      Ne && W[le].push(C.position);
                      continue;
                    }
                    Ne ? W[le].push(Mt[Ne]) : W[le].push(Je ? Mt.start : Mt.end);
                  }
                }
                for (const [ee, [le, be]] of Object.entries(W))
                  le && be && le.root === be.root && w.addMarker(ee, { usingOperation: !0, affectsData: !0, range: new ve(le, be) });
                V && (j = V.toRange(), V.detach());
              }
              j && (A instanceof Yr ? w.setSelection(j) : A.setTo(j));
              const F = C.getAffectedRange() || l.createRange(A.anchor);
              return C.destroy(), F;
            });
          }(this, t, i, a);
        }
        insertObject(t, i, a, l) {
          return v6(this, t, i, a, l);
        }
        deleteContent(t, i) {
          g6(this, t, i);
        }
        modifySelection(t, i) {
          (function(a, l, d = {}) {
            const g = a.schema, m = d.direction != "backward", w = d.unit ? d.unit : "character", A = !!d.treatEmojiAsSingleUnit, C = l.focus, T = new no({ boundaries: w6(C, m), singleCharacters: !0, direction: m ? "forward" : "backward" }), R = { walker: T, schema: g, isForward: m, unit: w, treatEmojiAsSingleUnit: A };
            let j;
            for (; j = T.next(); ) {
              if (j.done)
                return;
              const F = b6(R, j.value);
              if (F)
                return void (l instanceof Yr ? a.change((V) => {
                  V.setSelectionFocus(F);
                }) : l.setFocus(F));
            }
          })(this, t, i);
        }
        getSelectedContent(t) {
          return function(i, a) {
            return i.change((l) => {
              const d = l.createDocumentFragment(), g = a.getFirstRange();
              if (!g || g.isCollapsed)
                return d;
              const m = g.start.root, w = g.start.getCommonPath(g.end), A = m.getNodeByPath(w);
              let C;
              C = g.start.parent == g.end.parent ? g : l.createRange(l.createPositionAt(A, g.start.path[w.length]), l.createPositionAt(A, g.end.path[w.length] + 1));
              const T = C.end.offset - C.start.offset;
              for (const R of C.getItems({ shallow: !0 }))
                R.is("$textProxy") ? l.appendText(R.data, R.getAttributes(), d) : l.append(l.cloneElement(R, !0), d);
              if (C != g) {
                const R = g._getTransformedByMove(C.start, l.createPositionAt(d, 0), T)[0], j = l.createRange(l.createPositionAt(d, 0), R.start);
                AA(l.createRange(R.end, l.createPositionAt(d, "end")), l), AA(j, l);
              }
              return d;
            });
          }(this, t);
        }
        hasContent(t, i = {}) {
          const a = t instanceof ve ? t : ve._createIn(t);
          if (a.isCollapsed)
            return !1;
          const { ignoreWhitespaces: l = !1, ignoreMarkers: d = !1 } = i;
          if (!d) {
            for (const g of this.markers.getMarkersIntersectingRange(a))
              if (g.affectsData)
                return !0;
          }
          for (const g of a.getItems())
            if (this.schema.isContent(g) && (!g.is("$textProxy") || !l || g.data.search(/\S/) !== -1))
              return !0;
          return !1;
        }
        createPositionFromPath(t, i, a) {
          return new Ee(t, i, a);
        }
        createPositionAt(t, i) {
          return Ee._createAt(t, i);
        }
        createPositionAfter(t) {
          return Ee._createAfter(t);
        }
        createPositionBefore(t) {
          return Ee._createBefore(t);
        }
        createRange(t, i) {
          return new ve(t, i);
        }
        createRangeIn(t) {
          return ve._createIn(t);
        }
        createRangeOn(t) {
          return ve._createOn(t);
        }
        createSelection(...t) {
          return new ro(...t);
        }
        createBatch(t) {
          return new vl(t);
        }
        createOperationFromJSON(t) {
          return XN.fromJSON(t, this.document);
        }
        destroy() {
          this.document.destroy(), this.stopListening();
        }
        _runPendingChanges() {
          const t = [];
          this.fire("_beforeChanges");
          try {
            for (; this._pendingChanges.length; ) {
              const i = this._pendingChanges[0].batch;
              this._currentWriter = new d6(this, i);
              const a = this._pendingChanges[0].callback(this._currentWriter);
              t.push(a), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
            }
          } finally {
            this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
          }
          return t;
        }
      }
      class A6 extends sa {
        constructor(t) {
          super(t), this.domEventType = "click";
        }
        onDomEvent(t) {
          this.fire(t.type, t);
        }
      }
      class u0 extends sa {
        constructor(t) {
          super(t), this.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
        }
        onDomEvent(t) {
          this.fire(t.type, t);
        }
      }
      class wl {
        constructor(t) {
          this.document = t;
        }
        createDocumentFragment(t) {
          return new rs(this.document, t);
        }
        createElement(t, i, a) {
          return new Pr(this.document, t, i, a);
        }
        createText(t) {
          return new Xt(this.document, t);
        }
        clone(t, i = !1) {
          return t._clone(i);
        }
        appendChild(t, i) {
          return i._appendChild(t);
        }
        insertChild(t, i, a) {
          return a._insertChild(t, i);
        }
        removeChildren(t, i, a) {
          return a._removeChildren(t, i);
        }
        remove(t) {
          const i = t.parent;
          return i ? this.removeChildren(i.getChildIndex(t), 1, i) : [];
        }
        replace(t, i) {
          const a = t.parent;
          if (a) {
            const l = a.getChildIndex(t);
            return this.removeChildren(l, 1, a), this.insertChild(l, i, a), !0;
          }
          return !1;
        }
        unwrapElement(t) {
          const i = t.parent;
          if (i) {
            const a = i.getChildIndex(t);
            this.remove(t), this.insertChild(a, t.getChildren(), i);
          }
        }
        rename(t, i) {
          const a = new Pr(this.document, t, i.getAttributes(), i.getChildren());
          return this.replace(i, a) ? a : null;
        }
        setAttribute(t, i, a) {
          a._setAttribute(t, i);
        }
        removeAttribute(t, i) {
          i._removeAttribute(t);
        }
        addClass(t, i) {
          i._addClass(t);
        }
        removeClass(t, i) {
          i._removeClass(t);
        }
        setStyle(t, i, a) {
          Wn(t) && a === void 0 ? i._setStyle(t) : a._setStyle(t, i);
        }
        removeStyle(t, i) {
          i._removeStyle(t);
        }
        setCustomProperty(t, i, a) {
          a._setCustomProperty(t, i);
        }
        removeCustomProperty(t, i) {
          return i._removeCustomProperty(t);
        }
        createPositionAt(t, i) {
          return $e._createAt(t, i);
        }
        createPositionAfter(t) {
          return $e._createAfter(t);
        }
        createPositionBefore(t) {
          return $e._createBefore(t);
        }
        createRange(t, i) {
          return new it(t, i);
        }
        createRangeOn(t) {
          return it._createOn(t);
        }
        createRangeIn(t) {
          return it._createIn(t);
        }
        createSelection(...t) {
          return new eo(...t);
        }
      }
      class C6 {
        constructor() {
          this._commands = /* @__PURE__ */ new Map();
        }
        add(t, i) {
          this._commands.set(t, i);
        }
        get(t) {
          return this._commands.get(t);
        }
        execute(t, ...i) {
          const a = this.get(t);
          if (!a)
            throw new S("commandcollection-command-not-found", this, { commandName: t });
          return a.execute(...i);
        }
        *names() {
          yield* this._commands.keys();
        }
        *commands() {
          yield* this._commands.values();
        }
        [Symbol.iterator]() {
          return this._commands[Symbol.iterator]();
        }
        destroy() {
          for (const t of this.commands())
            t.destroy();
        }
      }
      class x6 extends Qi {
        constructor(t) {
          super(), this.editor = t;
        }
        set(t, i, a = {}) {
          if (typeof i == "string") {
            const l = i;
            i = (d, g) => {
              this.editor.execute(l), g();
            };
          }
          super.set(t, i, a);
        }
      }
      class E6 extends Te() {
        constructor(t = {}) {
          super();
          const i = this.constructor, a = t.language || i.defaultConfig && i.defaultConfig.language;
          this._context = t.context || new YO({ language: a }), this._context._addEditor(this, !t.context);
          const l = Array.from(i.builtinPlugins || []);
          this.config = new qr(t, i.defaultConfig), this.config.define("plugins", l), this.config.define(this._context._getEditorConfig()), this.plugins = new Bk(this, l, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = /* @__PURE__ */ new Set(), this.commands = new C6(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", { priority: "high" }), this.once("destroy", () => this.state = "destroyed", { priority: "high" }), this.model = new _6();
          const d = new DR();
          this.data = new QN(this.model, d), this.editing = new ON(this.model, d), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new ZN([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new x6(this), this.keystrokes.listenTo(this.editing.view.document);
        }
        get isReadOnly() {
          return this._readOnlyLocks.size > 0;
        }
        set isReadOnly(t) {
          throw new S("editor-isreadonly-has-no-setter");
        }
        enableReadOnlyMode(t) {
          if (typeof t != "string" && typeof t != "symbol")
            throw new S("editor-read-only-lock-id-invalid", null, { lockId: t });
          this._readOnlyLocks.has(t) || (this._readOnlyLocks.add(t), this._readOnlyLocks.size === 1 && this.fire("change:isReadOnly", "isReadOnly", !0, !1));
        }
        disableReadOnlyMode(t) {
          if (typeof t != "string" && typeof t != "symbol")
            throw new S("editor-read-only-lock-id-invalid", null, { lockId: t });
          this._readOnlyLocks.has(t) && (this._readOnlyLocks.delete(t), this._readOnlyLocks.size === 0 && this.fire("change:isReadOnly", "isReadOnly", !1, !0));
        }
        initPlugins() {
          const t = this.config, i = t.get("plugins"), a = t.get("removePlugins") || [], l = t.get("extraPlugins") || [], d = t.get("substitutePlugins") || [];
          return this.plugins.init(i.concat(l), a, d);
        }
        destroy() {
          let t = Promise.resolve();
          return this.state == "initializing" && (t = new Promise((i) => this.once("ready", i))), t.then(() => {
            this.fire("destroy"), this.stopListening(), this.commands.destroy();
          }).then(() => this.plugins.destroy()).then(() => {
            this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
          }).then(() => this._context._removeEditor(this));
        }
        execute(t, ...i) {
          try {
            return this.commands.execute(t, ...i);
          } catch (a) {
            S.rethrowUnexpectedError(a, this);
          }
        }
        focus() {
          this.editing.view.focus();
        }
      }
      class S6 {
        constructor(t) {
          this.editor = t, this._components = /* @__PURE__ */ new Map();
        }
        *names() {
          for (const t of this._components.values())
            yield t.originalName;
        }
        add(t, i) {
          this._components.set(d0(t), { callback: i, originalName: t });
        }
        create(t) {
          if (!this.has(t))
            throw new S("componentfactory-item-missing", this, { name: t });
          return this._components.get(d0(t)).callback(this.editor.locale);
        }
        has(t) {
          return this._components.has(d0(t));
        }
      }
      function d0(c) {
        return String(c).toLowerCase();
      }
      class ls extends yi {
        constructor(t = []) {
          super(t, { idProperty: "viewUid" }), this.on("add", (i, a, l) => {
            this._renderViewIntoCollectionParent(a, l);
          }), this.on("remove", (i, a) => {
            a.element && this._parentElement && a.element.remove();
          }), this._parentElement = null;
        }
        destroy() {
          this.map((t) => t.destroy());
        }
        setParent(t) {
          this._parentElement = t;
          for (const i of this)
            this._renderViewIntoCollectionParent(i);
        }
        delegate(...t) {
          if (!t.length || !t.every((i) => typeof i == "string"))
            throw new S("ui-viewcollection-delegate-wrong-events", this);
          return { to: (i) => {
            for (const a of this)
              for (const l of t)
                a.delegate(l).to(i);
            this.on("add", (a, l) => {
              for (const d of t)
                l.delegate(d).to(i);
            }), this.on("remove", (a, l) => {
              for (const d of t)
                l.stopDelegating(d, i);
            });
          } };
        }
        _renderViewIntoCollectionParent(t, i) {
          t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[i]);
        }
      }
      class Ci extends ie() {
        constructor(t) {
          super(), Object.assign(this, MA(SA(t))), this._isRendered = !1, this._revertData = null;
        }
        render() {
          const t = this._renderNode({ intoFragment: !0 });
          return this._isRendered = !0, t;
        }
        apply(t) {
          return this._revertData = { children: [], bindings: [], attributes: {} }, this._renderNode({ node: t, intoFragment: !1, isApplying: !0, revertData: this._revertData }), t;
        }
        revert(t) {
          if (!this._revertData)
            throw new S("ui-template-revert-not-applied", [this, t]);
          this._revertTemplateFromNode(t, this._revertData);
        }
        *getViews() {
          yield* function* t(i) {
            if (i.children)
              for (const a of i.children)
                Mh(a) ? yield a : h0(a) && (yield* t(a));
          }(this);
        }
        static bind(t, i) {
          return { to: (a, l) => new M6({ eventNameOrFunction: a, attribute: a, observable: t, emitter: i, callback: l }), if: (a, l, d) => new xA({ observable: t, emitter: i, attribute: a, valueIfTrue: l, callback: d }) };
        }
        static extend(t, i) {
          if (t._isRendered)
            throw new S("template-extend-render", [this, t]);
          PA(t, MA(SA(i)));
        }
        _renderNode(t) {
          let i;
          if (i = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, i)
            throw new S("ui-template-wrong-syntax", this);
          return this.text ? this._renderText(t) : this._renderElement(t);
        }
        _renderElement(t) {
          let i = t.node;
          return i || (i = t.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), i;
        }
        _renderText(t) {
          let i = t.node;
          return i ? t.revertData.text = i.textContent : i = t.node = document.createTextNode(""), Sh(this.text) ? this._bindToObservable({ schema: this.text, updater: T6(i), data: t }) : i.textContent = this.text.join(""), i;
        }
        _renderAttributes(t) {
          if (!this.attributes)
            return;
          const i = t.node, a = t.revertData;
          for (const l in this.attributes) {
            const d = i.getAttribute(l), g = this.attributes[l];
            a && (a.attributes[l] = d);
            const m = OA(g) ? g[0].ns : null;
            if (Sh(g)) {
              const w = OA(g) ? g[0].value : g;
              a && RA(l) && w.unshift(d), this._bindToObservable({ schema: w, updater: D6(i, l, m), data: t });
            } else if (l == "style" && typeof g[0] != "string")
              this._renderStyleAttribute(g[0], t);
            else {
              a && d && RA(l) && g.unshift(d);
              const w = g.map((A) => A && A.value || A).reduce((A, C) => A.concat(C), []).reduce(DA, "");
              yl(w) || i.setAttributeNS(m, l, w);
            }
          }
        }
        _renderStyleAttribute(t, i) {
          const a = i.node;
          for (const l in t) {
            const d = t[l];
            Sh(d) ? this._bindToObservable({ schema: [d], updater: I6(a, l), data: i }) : a.style[l] = d;
          }
        }
        _renderElementChildren(t) {
          const i = t.node, a = t.intoFragment ? document.createDocumentFragment() : i, l = t.isApplying;
          let d = 0;
          for (const g of this.children)
            if (f0(g)) {
              if (!l) {
                g.setParent(i);
                for (const m of g)
                  a.appendChild(m.element);
              }
            } else if (Mh(g))
              l || (g.isRendered || g.render(), a.appendChild(g.element));
            else if (Kn(g))
              a.appendChild(g);
            else if (l) {
              const m = { children: [], bindings: [], attributes: {} };
              t.revertData.children.push(m), g._renderNode({ intoFragment: !1, node: a.childNodes[d++], isApplying: !0, revertData: m });
            } else
              a.appendChild(g.render());
          t.intoFragment && i.appendChild(a);
        }
        _setUpListeners(t) {
          if (this.eventListeners)
            for (const i in this.eventListeners) {
              const a = this.eventListeners[i].map((l) => {
                const [d, g] = i.split("@");
                return l.activateDomEventListener(d, g, t);
              });
              t.revertData && t.revertData.bindings.push(a);
            }
        }
        _bindToObservable({ schema: t, updater: i, data: a }) {
          const l = a.revertData;
          EA(t, i, a);
          const d = t.filter((g) => !yl(g)).filter((g) => g.observable).map((g) => g.activateAttributeListener(t, i, a));
          l && l.bindings.push(d);
        }
        _revertTemplateFromNode(t, i) {
          for (const l of i.bindings)
            for (const d of l)
              d();
          if (i.text)
            return void (t.textContent = i.text);
          const a = t;
          for (const l in i.attributes) {
            const d = i.attributes[l];
            d === null ? a.removeAttribute(l) : a.setAttribute(l, d);
          }
          for (let l = 0; l < i.children.length; ++l)
            this._revertTemplateFromNode(a.childNodes[l], i.children[l]);
        }
      }
      class pu {
        constructor(t) {
          this.attribute = t.attribute, this.observable = t.observable, this.emitter = t.emitter, this.callback = t.callback;
        }
        getValue(t) {
          const i = this.observable[this.attribute];
          return this.callback ? this.callback(i, t) : i;
        }
        activateAttributeListener(t, i, a) {
          const l = () => EA(t, i, a);
          return this.emitter.listenTo(this.observable, `change:${this.attribute}`, l), () => {
            this.emitter.stopListening(this.observable, `change:${this.attribute}`, l);
          };
        }
      }
      class M6 extends pu {
        constructor(t) {
          super(t), this.eventNameOrFunction = t.eventNameOrFunction;
        }
        activateDomEventListener(t, i, a) {
          const l = (d, g) => {
            i && !g.target.matches(i) || (typeof this.eventNameOrFunction == "function" ? this.eventNameOrFunction(g) : this.observable.fire(this.eventNameOrFunction, g));
          };
          return this.emitter.listenTo(a.node, t, l), () => {
            this.emitter.stopListening(a.node, t, l);
          };
        }
      }
      class xA extends pu {
        constructor(t) {
          super(t), this.valueIfTrue = t.valueIfTrue;
        }
        getValue(t) {
          return !yl(super.getValue(t)) && (this.valueIfTrue || !0);
        }
      }
      function Sh(c) {
        return !!c && (c.value && (c = c.value), Array.isArray(c) ? c.some(Sh) : c instanceof pu);
      }
      function EA(c, t, { node: i }) {
        const a = function(d, g) {
          return d.map((m) => m instanceof pu ? m.getValue(g) : m);
        }(c, i);
        let l;
        l = c.length == 1 && c[0] instanceof xA ? a[0] : a.reduce(DA, ""), yl(l) ? t.remove() : t.set(l);
      }
      function T6(c) {
        return { set(t) {
          c.textContent = t;
        }, remove() {
          c.textContent = "";
        } };
      }
      function D6(c, t, i) {
        return { set(a) {
          c.setAttributeNS(i, t, a);
        }, remove() {
          c.removeAttributeNS(i, t);
        } };
      }
      function I6(c, t) {
        return { set(i) {
          c.style[t] = i;
        }, remove() {
          c.style[t] = null;
        } };
      }
      function SA(c) {
        return aa(c, (t) => {
          if (t && (t instanceof pu || h0(t) || Mh(t) || f0(t)))
            return t;
        });
      }
      function MA(c) {
        if (typeof c == "string" ? c = function(t) {
          return { text: [t] };
        }(c) : c.text && function(t) {
          t.text = Yn(t.text);
        }(c), c.on && (c.eventListeners = function(t) {
          for (const i in t)
            TA(t, i);
          return t;
        }(c.on), delete c.on), !c.text) {
          c.attributes && function(i) {
            for (const a in i)
              i[a].value && (i[a].value = Yn(i[a].value)), TA(i, a);
          }(c.attributes);
          const t = [];
          if (c.children)
            if (f0(c.children))
              t.push(c.children);
            else
              for (const i of c.children)
                h0(i) || Mh(i) || Kn(i) ? t.push(i) : t.push(new Ci(i));
          c.children = t;
        }
        return c;
      }
      function TA(c, t) {
        c[t] = Yn(c[t]);
      }
      function DA(c, t) {
        return yl(t) ? c : yl(c) ? t : `${c} ${t}`;
      }
      function IA(c, t) {
        for (const i in t)
          c[i] ? c[i].push(...t[i]) : c[i] = t[i];
      }
      function PA(c, t) {
        if (t.attributes && (c.attributes || (c.attributes = {}), IA(c.attributes, t.attributes)), t.eventListeners && (c.eventListeners || (c.eventListeners = {}), IA(c.eventListeners, t.eventListeners)), t.text && c.text.push(...t.text), t.children && t.children.length) {
          if (c.children.length != t.children.length)
            throw new S("ui-template-extend-children-mismatch", c);
          let i = 0;
          for (const a of t.children)
            PA(c.children[i++], a);
        }
      }
      function yl(c) {
        return !c && c !== 0;
      }
      function Mh(c) {
        return c instanceof At;
      }
      function h0(c) {
        return c instanceof Ci;
      }
      function f0(c) {
        return c instanceof ls;
      }
      function OA(c) {
        return me(c[0]) && c[0].ns;
      }
      function RA(c) {
        return c == "class" || c == "style";
      }
      var NA = s(4793), P6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(NA.Z, P6), NA.Z.locals;
      class At extends Qa(Te()) {
        constructor(t) {
          super(), this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new yi(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (i, a) => {
            a.locale = t, a.t = t && t.t;
          }), this.decorate("render");
        }
        get bindTemplate() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Ci.bind(this, this);
        }
        createCollection(t) {
          const i = new ls(t);
          return this._viewCollections.add(i), i;
        }
        registerChild(t) {
          Ft(t) || (t = [t]);
          for (const i of t)
            this._unboundChildren.add(i);
        }
        deregisterChild(t) {
          Ft(t) || (t = [t]);
          for (const i of t)
            this._unboundChildren.remove(i);
        }
        setTemplate(t) {
          this.template = new Ci(t);
        }
        extendTemplate(t) {
          Ci.extend(this.template, t);
        }
        render() {
          if (this.isRendered)
            throw new S("ui-view-render-already-rendered", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
        destroy() {
          this.stopListening(), this._viewCollections.map((t) => t.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }
      var $A = s(8793), O6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()($A.Z, O6), $A.Z.locals;
      const LA = Sm("px"), jA = yt.document.body;
      class vr extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", !1), this.set("withArrow", !0), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-panel", i.to("position", (a) => `ck-balloon-panel_${a}`), i.if("isVisible", "ck-balloon-panel_visible"), i.if("withArrow", "ck-balloon-panel_with-arrow"), i.to("class")], style: { top: i.to("top", LA), left: i.to("left", LA) } }, children: this.content });
        }
        show() {
          this.isVisible = !0;
        }
        hide() {
          this.isVisible = !1;
        }
        attachTo(t) {
          this.show();
          const i = vr.defaultPositions, a = Object.assign({}, { element: this.element, positions: [i.southArrowNorth, i.southArrowNorthMiddleWest, i.southArrowNorthMiddleEast, i.southArrowNorthWest, i.southArrowNorthEast, i.northArrowSouth, i.northArrowSouthMiddleWest, i.northArrowSouthMiddleEast, i.northArrowSouthWest, i.northArrowSouthEast, i.viewportStickyNorth], limiter: jA, fitInViewport: !0 }, t), l = vr._getOptimalPosition(a), d = parseInt(l.left), g = parseInt(l.top), m = l.name, w = l.config || {}, { withArrow: A = !0 } = w;
          this.top = g, this.left = d, this.position = m, this.withArrow = A;
        }
        pin(t) {
          this.unpin(), this._pinWhenIsVisibleCallback = () => {
            this.isVisible ? this._startPinning(t) : this._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
        unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
        _startPinning(t) {
          this.attachTo(t);
          const i = p0(t.target), a = t.limiter ? p0(t.limiter) : jA;
          this.listenTo(yt.document, "scroll", (l, d) => {
            const g = d.target, m = i && g.contains(i), w = a && g.contains(a);
            !m && !w && i && a || this.attachTo(t);
          }, { useCapture: !0 }), this.listenTo(yt.window, "resize", () => {
            this.attachTo(t);
          });
        }
        _stopPinning() {
          this.stopListening(yt.document, "scroll"), this.stopListening(yt.window, "resize");
        }
      }
      function p0(c) {
        return Bn(c) ? c : sh(c) ? c.commonAncestorContainer : typeof c == "function" ? p0(c()) : null;
      }
      function BA(c = {}) {
        const { sideOffset: t = vr.arrowSideOffset, heightOffset: i = vr.arrowHeightOffset, stickyVerticalOffset: a = vr.stickyVerticalOffset, config: l } = c;
        return { northWestArrowSouthWest: (m, w) => ({ top: d(m, w), left: m.left - t, name: "arrow_sw", ...l && { config: l } }), northWestArrowSouthMiddleWest: (m, w) => ({ top: d(m, w), left: m.left - 0.25 * w.width - t, name: "arrow_smw", ...l && { config: l } }), northWestArrowSouth: (m, w) => ({ top: d(m, w), left: m.left - w.width / 2, name: "arrow_s", ...l && { config: l } }), northWestArrowSouthMiddleEast: (m, w) => ({ top: d(m, w), left: m.left - 0.75 * w.width + t, name: "arrow_sme", ...l && { config: l } }), northWestArrowSouthEast: (m, w) => ({ top: d(m, w), left: m.left - w.width + t, name: "arrow_se", ...l && { config: l } }), northArrowSouthWest: (m, w) => ({ top: d(m, w), left: m.left + m.width / 2 - t, name: "arrow_sw", ...l && { config: l } }), northArrowSouthMiddleWest: (m, w) => ({ top: d(m, w), left: m.left + m.width / 2 - 0.25 * w.width - t, name: "arrow_smw", ...l && { config: l } }), northArrowSouth: (m, w) => ({ top: d(m, w), left: m.left + m.width / 2 - w.width / 2, name: "arrow_s", ...l && { config: l } }), northArrowSouthMiddleEast: (m, w) => ({ top: d(m, w), left: m.left + m.width / 2 - 0.75 * w.width + t, name: "arrow_sme", ...l && { config: l } }), northArrowSouthEast: (m, w) => ({ top: d(m, w), left: m.left + m.width / 2 - w.width + t, name: "arrow_se", ...l && { config: l } }), northEastArrowSouthWest: (m, w) => ({ top: d(m, w), left: m.right - t, name: "arrow_sw", ...l && { config: l } }), northEastArrowSouthMiddleWest: (m, w) => ({ top: d(m, w), left: m.right - 0.25 * w.width - t, name: "arrow_smw", ...l && { config: l } }), northEastArrowSouth: (m, w) => ({ top: d(m, w), left: m.right - w.width / 2, name: "arrow_s", ...l && { config: l } }), northEastArrowSouthMiddleEast: (m, w) => ({ top: d(m, w), left: m.right - 0.75 * w.width + t, name: "arrow_sme", ...l && { config: l } }), northEastArrowSouthEast: (m, w) => ({ top: d(m, w), left: m.right - w.width + t, name: "arrow_se", ...l && { config: l } }), southWestArrowNorthWest: (m) => ({ top: g(m), left: m.left - t, name: "arrow_nw", ...l && { config: l } }), southWestArrowNorthMiddleWest: (m, w) => ({ top: g(m), left: m.left - 0.25 * w.width - t, name: "arrow_nmw", ...l && { config: l } }), southWestArrowNorth: (m, w) => ({ top: g(m), left: m.left - w.width / 2, name: "arrow_n", ...l && { config: l } }), southWestArrowNorthMiddleEast: (m, w) => ({ top: g(m), left: m.left - 0.75 * w.width + t, name: "arrow_nme", ...l && { config: l } }), southWestArrowNorthEast: (m, w) => ({ top: g(m), left: m.left - w.width + t, name: "arrow_ne", ...l && { config: l } }), southArrowNorthWest: (m) => ({ top: g(m), left: m.left + m.width / 2 - t, name: "arrow_nw", ...l && { config: l } }), southArrowNorthMiddleWest: (m, w) => ({ top: g(m), left: m.left + m.width / 2 - 0.25 * w.width - t, name: "arrow_nmw", ...l && { config: l } }), southArrowNorth: (m, w) => ({ top: g(m), left: m.left + m.width / 2 - w.width / 2, name: "arrow_n", ...l && { config: l } }), southArrowNorthMiddleEast: (m, w) => ({ top: g(m), left: m.left + m.width / 2 - 0.75 * w.width + t, name: "arrow_nme", ...l && { config: l } }), southArrowNorthEast: (m, w) => ({ top: g(m), left: m.left + m.width / 2 - w.width + t, name: "arrow_ne", ...l && { config: l } }), southEastArrowNorthWest: (m) => ({ top: g(m), left: m.right - t, name: "arrow_nw", ...l && { config: l } }), southEastArrowNorthMiddleWest: (m, w) => ({ top: g(m), left: m.right - 0.25 * w.width - t, name: "arrow_nmw", ...l && { config: l } }), southEastArrowNorth: (m, w) => ({ top: g(m), left: m.right - w.width / 2, name: "arrow_n", ...l && { config: l } }), southEastArrowNorthMiddleEast: (m, w) => ({ top: g(m), left: m.right - 0.75 * w.width + t, name: "arrow_nme", ...l && { config: l } }), southEastArrowNorthEast: (m, w) => ({ top: g(m), left: m.right - w.width + t, name: "arrow_ne", ...l && { config: l } }), westArrowEast: (m, w) => ({ top: m.top + m.height / 2 - w.height / 2, left: m.left - w.width - i, name: "arrow_e", ...l && { config: l } }), eastArrowWest: (m, w) => ({ top: m.top + m.height / 2 - w.height / 2, left: m.right + i, name: "arrow_w", ...l && { config: l } }), viewportStickyNorth: (m, w, A) => m.getIntersection(A) ? { top: A.top + a, left: m.left + m.width / 2 - w.width / 2, name: "arrowless", config: { withArrow: !1, ...l } } : null };
        function d(m, w) {
          return m.top - w.height - i;
        }
        function g(m) {
          return m.bottom + i;
        }
      }
      vr.arrowSideOffset = 25, vr.arrowHeightOffset = 10, vr.stickyVerticalOffset = 20, vr._getOptimalPosition = Ck, vr.defaultPositions = BA();
      var FA = s(3332), R6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(FA.Z, R6), FA.Z.locals;
      const zA = "ck-tooltip";
      class Xn extends Qa() {
        constructor(t) {
          if (super(), Xn._editors.add(t), Xn._instance)
            return Xn._instance;
          Xn._instance = this, this.tooltipTextView = new At(t.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-tooltip__text"] }, children: [{ text: this.tooltipTextView.bindTemplate.to("text") }] }), this.balloonPanelView = new vr(t.locale), this.balloonPanelView.class = zA, this.balloonPanelView.content.add(this.tooltipTextView), this._resizeObserver = null, this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._pinTooltipDebounced = iu(this._pinTooltip, 600), this.listenTo(yt.document, "mouseenter", this._onEnterOrFocus.bind(this), { useCapture: !0 }), this.listenTo(yt.document, "mouseleave", this._onLeaveOrBlur.bind(this), { useCapture: !0 }), this.listenTo(yt.document, "focus", this._onEnterOrFocus.bind(this), { useCapture: !0 }), this.listenTo(yt.document, "blur", this._onLeaveOrBlur.bind(this), { useCapture: !0 }), this.listenTo(yt.document, "scroll", this._onScroll.bind(this), { useCapture: !0 }), this._watchdogExcluded = !0;
        }
        destroy(t) {
          const i = t.ui.view && t.ui.view.body;
          Xn._editors.delete(t), this.stopListening(t.ui), i && i.has(this.balloonPanelView) && i.remove(this.balloonPanelView), Xn._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), Xn._instance = null);
        }
        static getPositioningFunctions(t) {
          const i = Xn.defaultBalloonPositions;
          return { s: [i.southArrowNorth, i.southArrowNorthEast, i.southArrowNorthWest], n: [i.northArrowSouth], e: [i.eastArrowWest], w: [i.westArrowEast], sw: [i.southArrowNorthEast], se: [i.southArrowNorthWest] }[t];
        }
        _onEnterOrFocus(t, { target: i }) {
          const a = g0(i);
          var l;
          a && a !== this._currentElementWithTooltip && (this._unpinTooltip(), this._pinTooltipDebounced(a, { text: (l = a).dataset.ckeTooltipText, position: l.dataset.ckeTooltipPosition || "s", cssClass: l.dataset.ckeTooltipClass || "" }));
        }
        _onLeaveOrBlur(t, { target: i, relatedTarget: a }) {
          if (t.name === "mouseleave") {
            if (!Bn(i) || this._currentElementWithTooltip && i !== this._currentElementWithTooltip)
              return;
            const l = g0(i), d = g0(a);
            l && l !== d && this._unpinTooltip();
          } else {
            if (this._currentElementWithTooltip && i !== this._currentElementWithTooltip)
              return;
            this._unpinTooltip();
          }
        }
        _onScroll(t, { target: i }) {
          this._currentElementWithTooltip && (i.contains(this.balloonPanelView.element) && i.contains(this._currentElementWithTooltip) || this._unpinTooltip());
        }
        _pinTooltip(t, { text: i, position: a, cssClass: l }) {
          const d = Fn(Xn._editors.values()).ui.view.body;
          d.has(this.balloonPanelView) || d.add(this.balloonPanelView), this.tooltipTextView.text = i, this.balloonPanelView.pin({ target: t, positions: Xn.getPositioningFunctions(a) }), this._resizeObserver = new fn(t, () => {
            Za(t) || this._unpinTooltip();
          }), this.balloonPanelView.class = [zA, l].filter((g) => g).join(" ");
          for (const g of Xn._editors)
            this.listenTo(g.ui, "update", this._updateTooltipPosition.bind(this), { priority: "low" });
          this._currentElementWithTooltip = t, this._currentTooltipPosition = a;
        }
        _unpinTooltip() {
          this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
          for (const t of Xn._editors)
            this.stopListening(t.ui, "update");
          this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver && this._resizeObserver.destroy();
        }
        _updateTooltipPosition() {
          Za(this._currentElementWithTooltip) ? this.balloonPanelView.pin({ target: this._currentElementWithTooltip, positions: Xn.getPositioningFunctions(this._currentTooltipPosition) }) : this._unpinTooltip();
        }
      }
      function g0(c) {
        return Bn(c) ? c.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
      }
      Xn.defaultBalloonPositions = BA({ heightOffset: 5, sideOffset: 13 }), Xn._editors = /* @__PURE__ */ new Set(), Xn._instance = null;
      class N6 extends Te() {
        constructor(t) {
          super(), this.editor = t, this.componentFactory = new S6(t), this.focusTracker = new Kr(), this.tooltipManager = new Xn(t), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.isReady = !1, this.once("ready", () => {
            this.isReady = !0;
          }), this._editableElementsMap = /* @__PURE__ */ new Map(), this._focusableToolbarDefinitions = [], this.listenTo(t.editing.view.document, "layoutChanged", () => this.update()), this._initFocusTracking();
        }
        get element() {
          return null;
        }
        update() {
          this.fire("update");
        }
        destroy() {
          this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor);
          for (const t of this._editableElementsMap.values())
            t.ckeditorInstance = null;
          this._editableElementsMap = /* @__PURE__ */ new Map(), this._focusableToolbarDefinitions = [];
        }
        setEditableElement(t, i) {
          this._editableElementsMap.set(t, i), i.ckeditorInstance || (i.ckeditorInstance = this.editor), this.focusTracker.add(i);
          const a = () => {
            this.editor.editing.view.getDomRoot(t) || this.editor.keystrokes.listenTo(i);
          };
          this.isReady ? a() : this.once("ready", a);
        }
        getEditableElement(t = "main") {
          return this._editableElementsMap.get(t);
        }
        getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
        addToolbar(t, i = {}) {
          t.isRendered ? (this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element)) : t.once("render", () => {
            this.focusTracker.add(t.element), this.editor.keystrokes.listenTo(t.element);
          }), this._focusableToolbarDefinitions.push({ toolbarView: t, options: i });
        }
        get _editableElements() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", { editorUI: this }), this._editableElementsMap;
        }
        _readViewportOffsetFromConfig() {
          const t = this.editor, i = t.config.get("ui.viewportOffset");
          if (i)
            return i;
          const a = t.config.get("toolbar.viewportTopOffset");
          return a ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), { top: a }) : { top: 0 };
        }
        _initFocusTracking() {
          const t = this.editor, i = t.editing.view;
          let a, l;
          t.keystrokes.set("Alt+F10", (d, g) => {
            const m = this.focusTracker.focusedElement;
            Array.from(this._editableElementsMap.values()).includes(m) && !Array.from(i.domRoots.values()).includes(m) && (a = m);
            const w = this._getCurrentFocusedToolbarDefinition();
            w && l || (l = this._getFocusableCandidateToolbarDefinitions());
            for (let A = 0; A < l.length; A++) {
              const C = l.shift();
              if (l.push(C), C !== w && this._focusFocusableCandidateToolbar(C)) {
                w && w.options.afterBlur && w.options.afterBlur();
                break;
              }
            }
            g();
          }), t.keystrokes.set("Esc", (d, g) => {
            const m = this._getCurrentFocusedToolbarDefinition();
            m && (a ? (a.focus(), a = null) : t.editing.view.focus(), m.options.afterBlur && m.options.afterBlur(), g());
          });
        }
        _getFocusableCandidateToolbarDefinitions() {
          const t = [];
          for (const i of this._focusableToolbarDefinitions) {
            const { toolbarView: a, options: l } = i;
            (Za(a.element) || l.beforeFocus) && t.push(i);
          }
          return t.sort((i, a) => VA(i) - VA(a)), t;
        }
        _getCurrentFocusedToolbarDefinition() {
          for (const t of this._focusableToolbarDefinitions)
            if (t.toolbarView.element && t.toolbarView.element.contains(this.focusTracker.focusedElement))
              return t;
          return null;
        }
        _focusFocusableCandidateToolbar(t) {
          const { toolbarView: i, options: { beforeFocus: a } } = t;
          return a && a(), !!Za(i.element) && (i.focus(), !0);
        }
      }
      function VA(c) {
        const { toolbarView: t, options: i } = c;
        let a = 10;
        return Za(t.element) && a--, i.isContextual && a--, a;
      }
      function Th(c) {
        return class extends c {
          setData(t) {
            this.data.set(t);
          }
          getData(t) {
            return this.data.get(t);
          }
        };
      }
      {
        const c = Th(Object);
        Th.setData = c.prototype.setData, Th.getData = c.prototype.getData;
      }
      function m0(c) {
        return class extends c {
          updateSourceElement(t = this.data.get()) {
            if (!this.sourceElement)
              throw new S("editor-missing-sourceelement", this);
            const i = this.config.get("updateSourceElementOnDestroy"), a = this.sourceElement instanceof HTMLTextAreaElement;
            LO(this.sourceElement, i || a ? t : "");
          }
        };
      }
      m0.updateSourceElement = m0(Object).prototype.updateSourceElement;
      class HA extends uh {
        static get pluginName() {
          return "PendingActions";
        }
        init() {
          this.set("hasAny", !1), this._actions = new yi({ idProperty: "_id" }), this._actions.delegate("add", "remove").to(this);
        }
        add(t) {
          if (typeof t != "string")
            throw new S("pendingactions-add-invalid-message", this);
          const i = new (Te())();
          return i.set("message", t), this._actions.add(i), this.hasAny = !0, i;
        }
        remove(t) {
          this._actions.remove(t), this.hasAny = !!this._actions.length;
        }
        get first() {
          return this._actions.get(0);
        }
        [Symbol.iterator]() {
          return this._actions[Symbol.iterator]();
        }
      }
      const Nn = { bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>', cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>', caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>', check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>', cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>', eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>', image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>', lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>', importExport: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path clip-rule="evenodd" d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>', paragraph: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>', plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>', text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path clip-rule="evenodd" d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>', alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>', alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>', alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>', alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>', alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>', alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>', objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>', objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>', objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>', objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>', objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>', objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>', objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>', pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>', pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>', quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>', threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>' };
      function v0({ emitter: c, activator: t, callback: i, contextElements: a }) {
        c.listenTo(document, "mousedown", (l, d) => {
          if (!t())
            return;
          const g = typeof d.composedPath == "function" ? d.composedPath() : [];
          for (const m of a)
            if (m.contains(d.target) || g.includes(m))
              return;
          i();
        });
      }
      function b0(c) {
        const t = c;
        t.set("_isCssTransitionsDisabled", !1), t.disableCssTransitions = () => {
          t._isCssTransitionsDisabled = !0;
        }, t.enableCssTransitions = () => {
          t._isCssTransitionsDisabled = !1;
        }, t.extendTemplate({ attributes: { class: [t.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")] } });
      }
      function w0({ view: c }) {
        c.listenTo(c.element, "submit", (t, i) => {
          i.preventDefault(), c.fire("submit");
        }, { useCapture: !0 });
      }
      class $6 extends ls {
        constructor(t, i = []) {
          super(i), this.locale = t;
        }
        attachToDom() {
          this._bodyCollectionContainer = new Ci({ tag: "div", attributes: { class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"], dir: this.locale.uiLanguageDirection }, children: this }).render();
          let t = document.querySelector(".ck-body-wrapper");
          t || (t = Fi(document, "div", { class: "ck-body-wrapper" }), document.body.appendChild(t)), t.appendChild(this._bodyCollectionContainer);
        }
        detachFromDom() {
          super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
          const t = document.querySelector(".ck-body-wrapper");
          t && t.childElementCount == 0 && t.remove();
        }
      }
      var UA = s(6574), L6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(UA.Z, L6), UA.Z.locals;
      class cs extends At {
        constructor() {
          super();
          const t = this.bindTemplate;
          this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", !0), this.setTemplate({ tag: "svg", ns: "http://www.w3.org/2000/svg", attributes: { class: ["ck", "ck-icon", "ck-reset_all-excluded", t.if("isColorInherited", "ck-icon_inherit-color")], viewBox: t.to("viewBox") } });
        }
        render() {
          super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
            this._updateXMLContent(), this._colorFillPaths();
          }), this.on("change:fillColor", () => {
            this._colorFillPaths();
          });
        }
        _updateXMLContent() {
          if (this.content) {
            const t = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"), i = t.getAttribute("viewBox");
            i && (this.viewBox = i);
            for (const { name: a, value: l } of Array.from(t.attributes))
              cs.presentationalAttributeNames.includes(a) && this.element.setAttribute(a, l);
            for (; this.element.firstChild; )
              this.element.removeChild(this.element.firstChild);
            for (; t.childNodes.length > 0; )
              this.element.appendChild(t.childNodes[0]);
          }
        }
        _colorFillPaths() {
          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach((t) => {
            t.style.fill = this.fillColor;
          });
        }
      }
      cs.presentationalAttributeNames = ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"];
      var WA = s(4906), j6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(WA.Z, j6), WA.Z.locals;
      class cn extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate, a = N();
          this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isVisible", !0), this.set("isToggleable", !1), this.set("keystroke", void 0), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.set("withKeystroke", !1), this.children = this.createCollection(), this.labelView = this._createLabelView(a), this.iconView = new cs(), this.iconView.extendTemplate({ attributes: { class: "ck-button__icon" } }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
          const l = { tag: "button", attributes: { class: ["ck", "ck-button", i.to("class"), i.if("isEnabled", "ck-disabled", (d) => !d), i.if("isVisible", "ck-hidden", (d) => !d), i.to("isOn", (d) => d ? "ck-on" : "ck-off"), i.if("withText", "ck-button_with-text"), i.if("withKeystroke", "ck-button_with-keystroke")], type: i.to("type", (d) => d || "button"), tabindex: i.to("tabindex"), "aria-labelledby": `ck-editor__aria-label_${a}`, "aria-disabled": i.if("isEnabled", !0, (d) => !d), "aria-pressed": i.to("isOn", (d) => !!this.isToggleable && String(!!d)), "data-cke-tooltip-text": i.to("_tooltipString"), "data-cke-tooltip-position": i.to("tooltipPosition") }, children: this.children, on: { click: i.to((d) => {
            this.isEnabled ? this.fire("execute") : d.preventDefault();
          }) } };
          p.isSafari && (l.on.mousedown = i.to((d) => {
            this.focus(), d.preventDefault();
          })), this.setTemplate(l);
        }
        render() {
          super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
        }
        focus() {
          this.element.focus();
        }
        _createLabelView(t) {
          const i = new At(), a = this.bindTemplate;
          return i.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__label"], style: a.to("labelStyle"), id: `ck-editor__aria-label_${t}` }, children: [{ text: this.bindTemplate.to("label") }] }), i;
        }
        _createKeystrokeView() {
          const t = new At();
          return t.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__keystroke"] }, children: [{ text: this.bindTemplate.to("keystroke", (i) => Pk(i)) }] }), t;
        }
        _getTooltipString(t, i, a) {
          return t ? typeof t == "string" ? t : (a && (a = Pk(a)), t instanceof Function ? t(i, a) : `${i}${a ? ` (${a})` : ""}`) : "";
        }
      }
      var GA = s(5332), B6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(GA.Z, B6), GA.Z.locals;
      class Dh extends cn {
        constructor(t) {
          super(t), this.isToggleable = !0, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({ attributes: { class: "ck-switchbutton" } });
        }
        render() {
          super.render(), this.children.add(this.toggleSwitchView);
        }
        _createToggleView() {
          const t = new At();
          return t.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__toggle"] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-button__toggle__inner"] } }] }), t;
        }
      }
      var qA = s(6781), F6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(qA.Z, F6), qA.Z.locals;
      const KA = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
      class z6 extends cn {
        constructor(t) {
          super(t), this.arrowView = this._createArrowView(), this.extendTemplate({ attributes: { "aria-haspopup": !0, "aria-expanded": this.bindTemplate.to("isOn", (i) => String(i)) } }), this.delegate("execute").to(this, "open");
        }
        render() {
          super.render(), this.children.add(this.arrowView);
        }
        _createArrowView() {
          const t = new cs();
          return t.content = KA, t.extendTemplate({ attributes: { class: "ck-dropdown__arrow" } }), t;
        }
      }
      var YA = s(7686), V6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(YA.Z, V6), YA.Z.locals;
      class y0 extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", !0), this.set("isOn", !1), this.set("isToggleable", !1), this.set("isVisible", !0), this.set("keystroke", void 0), this.set("withKeystroke", !1), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", !1), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", !1), this.children = this.createCollection(), this.actionView = this._createActionView(), this.arrowView = this._createArrowView(), this.keystrokes = new Qi(), this.focusTracker = new Kr(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-splitbutton", i.to("class"), i.if("isVisible", "ck-hidden", (a) => !a), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")] }, children: this.children });
        }
        render() {
          super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (t, i) => {
            this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), i());
          }), this.keystrokes.set("arrowleft", (t, i) => {
            this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), i());
          });
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        focus() {
          this.actionView.focus();
        }
        _createActionView() {
          const t = new cn();
          return t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({ attributes: { class: "ck-splitbutton__action" } }), t.delegate("execute").to(this), t;
        }
        _createArrowView() {
          const t = new cn(), i = t.bindTemplate;
          return t.icon = KA, t.extendTemplate({ attributes: { class: ["ck-splitbutton__arrow"], "data-cke-tooltip-disabled": i.to("isOn"), "aria-haspopup": !0, "aria-expanded": i.to("isOn", (a) => String(a)) } }), t.bind("isEnabled").to(this), t.bind("label").to(this), t.bind("tooltip").to(this), t.delegate("execute").to(this, "open"), t;
        }
      }
      class H6 extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.set("isVisible", !1), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-dropdown__panel", i.to("position", (a) => `ck-dropdown__panel_${a}`), i.if("isVisible", "ck-dropdown__panel-visible")] }, children: this.children, on: { selectstart: i.to((a) => a.preventDefault()) } });
        }
        focus() {
          if (this.children.length) {
            const t = this.children.first;
            typeof t.focus == "function" ? t.focus() : $("ui-dropdown-panel-focus-child-missing-focus", { childView: this.children.first, dropdownPanel: this });
          }
        }
        focusLast() {
          if (this.children.length) {
            const t = this.children.last;
            typeof t.focusLast == "function" ? t.focusLast() : t.focus();
          }
        }
      }
      var QA = s(5485), U6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(QA.Z, U6), QA.Z.locals;
      class kl extends At {
        constructor(t, i, a) {
          super(t);
          const l = this.bindTemplate;
          this.buttonView = i, this.panelView = a, this.set("isOpen", !1), this.set("isEnabled", !0), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.keystrokes = new Qi(), this.focusTracker = new Kr(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-dropdown", l.to("class"), l.if("isEnabled", "ck-disabled", (d) => !d)], id: l.to("id"), "aria-describedby": l.to("ariaDescribedById") }, children: [i, a] }), i.extendTemplate({ attributes: { class: ["ck-dropdown__button"], "data-cke-tooltip-disabled": l.to("isOpen") } });
        }
        render() {
          super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
            this.isOpen = !this.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", (i, a, l) => {
            l && (this.panelPosition === "auto" ? this.panelView.position = kl._getOptimalPosition({ element: this.panelView.element, target: this.buttonView.element, fitInViewport: !0, positions: this._panelPositions }).name : this.panelView.position = this.panelPosition);
          }), this.keystrokes.listenTo(this.element);
          const t = (i, a) => {
            this.isOpen && (this.isOpen = !1, a());
          };
          this.keystrokes.set("arrowdown", (i, a) => {
            this.buttonView.isEnabled && !this.isOpen && (this.isOpen = !0, a());
          }), this.keystrokes.set("arrowright", (i, a) => {
            this.isOpen && a();
          }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
        }
        focus() {
          this.buttonView.focus();
        }
        get _panelPositions() {
          const { south: t, north: i, southEast: a, southWest: l, northEast: d, northWest: g, southMiddleEast: m, southMiddleWest: w, northMiddleEast: A, northMiddleWest: C } = kl.defaultPanelPositions;
          return this.locale.uiLanguageDirection !== "rtl" ? [a, l, m, w, t, d, g, A, C, i] : [l, a, w, m, t, g, d, C, A, i];
        }
      }
      kl.defaultPanelPositions = { south: (c, t) => ({ top: c.bottom, left: c.left - (t.width - c.width) / 2, name: "s" }), southEast: (c) => ({ top: c.bottom, left: c.left, name: "se" }), southWest: (c, t) => ({ top: c.bottom, left: c.left - t.width + c.width, name: "sw" }), southMiddleEast: (c, t) => ({ top: c.bottom, left: c.left - (t.width - c.width) / 4, name: "sme" }), southMiddleWest: (c, t) => ({ top: c.bottom, left: c.left - 3 * (t.width - c.width) / 4, name: "smw" }), north: (c, t) => ({ top: c.top - t.height, left: c.left - (t.width - c.width) / 2, name: "n" }), northEast: (c, t) => ({ top: c.top - t.height, left: c.left, name: "ne" }), northWest: (c, t) => ({ top: c.top - t.height, left: c.left - t.width + c.width, name: "nw" }), northMiddleEast: (c, t) => ({ top: c.top - t.height, left: c.left - (t.width - c.width) / 4, name: "nme" }), northMiddleWest: (c, t) => ({ top: c.top - t.height, left: c.left - 3 * (t.width - c.width) / 4, name: "nmw" }) }, kl._getOptimalPosition = Ck;
      class _l {
        constructor(t) {
          if (this.focusables = t.focusables, this.focusTracker = t.focusTracker, this.keystrokeHandler = t.keystrokeHandler, this.actions = t.actions, t.actions && t.keystrokeHandler)
            for (const i in t.actions) {
              let a = t.actions[i];
              typeof a == "string" && (a = [a]);
              for (const l of a)
                t.keystrokeHandler.set(l, (d, g) => {
                  this[i](), g();
                });
            }
        }
        get first() {
          return this.focusables.find(k0) || null;
        }
        get last() {
          return this.focusables.filter(k0).slice(-1)[0] || null;
        }
        get next() {
          return this._getFocusableItem(1);
        }
        get previous() {
          return this._getFocusableItem(-1);
        }
        get current() {
          let t = null;
          return this.focusTracker.focusedElement === null ? null : (this.focusables.find((i, a) => {
            const l = i.element === this.focusTracker.focusedElement;
            return l && (t = a), l;
          }), t);
        }
        focusFirst() {
          this._focus(this.first);
        }
        focusLast() {
          this._focus(this.last);
        }
        focusNext() {
          this._focus(this.next);
        }
        focusPrevious() {
          this._focus(this.previous);
        }
        _focus(t) {
          t && t.focus();
        }
        _getFocusableItem(t) {
          const i = this.current, a = this.focusables.length;
          if (!a)
            return null;
          if (i === null)
            return this[t === 1 ? "first" : "last"];
          let l = (i + a + t) % a;
          do {
            const d = this.focusables.get(l);
            if (k0(d))
              return d;
            l = (l + a + t) % a;
          } while (l !== i);
          return null;
        }
      }
      function k0(c) {
        return !(!c.focus || !Za(c.element));
      }
      class ZA extends At {
        constructor(t) {
          super(t), this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__separator"] } });
        }
      }
      class W6 extends At {
        constructor(t) {
          super(t), this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__line-break"] } });
        }
      }
      function XA(c) {
        return Array.isArray(c) ? { items: c, removeItems: [] } : c ? Object.assign({ items: [], removeItems: [] }, c) : { items: [], removeItems: [] };
      }
      var JA = s(5542), G6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(JA.Z, G6), JA.Z.locals;
      const { threeVerticalDots: eC } = Nn, q6 = { alignLeft: Nn.alignLeft, bold: Nn.bold, importExport: Nn.importExport, paragraph: Nn.paragraph, plus: Nn.plus, text: Nn.text, threeVerticalDots: Nn.threeVerticalDots };
      class _0 extends At {
        constructor(t, i) {
          super(t);
          const a = this.bindTemplate, l = this.t;
          this.options = i || {}, this.set("ariaLabel", l("Editor toolbar")), this.set("maxWidth", "auto"), this.items = this.createCollection(), this.focusTracker = new Kr(), this.keystrokes = new Qi(), this.set("class", void 0), this.set("isCompact", !1), this.itemsView = new K6(t), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
          const d = t.uiLanguageDirection === "rtl";
          this._focusCycler = new _l({ focusables: this.focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: [d ? "arrowright" : "arrowleft", "arrowup"], focusNext: [d ? "arrowleft" : "arrowright", "arrowdown"] } });
          const g = ["ck", "ck-toolbar", a.to("class"), a.if("isCompact", "ck-toolbar_compact")];
          var m;
          this.options.shouldGroupWhenFull && this.options.isFloating && g.push("ck-toolbar_floating"), this.setTemplate({ tag: "div", attributes: { class: g, role: "toolbar", "aria-label": a.to("ariaLabel"), style: { maxWidth: a.to("maxWidth") } }, children: this.children, on: { mousedown: (m = this, m.bindTemplate.to((w) => {
            w.target === m.element && w.preventDefault();
          })) } }), this._behavior = this.options.shouldGroupWhenFull ? new Q6(this) : new Y6(this);
        }
        render() {
          super.render();
          for (const t of this.items)
            this.focusTracker.add(t.element);
          this.items.on("add", (t, i) => {
            this.focusTracker.add(i.element);
          }), this.items.on("remove", (t, i) => {
            this.focusTracker.remove(i.element);
          }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
        }
        destroy() {
          return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
        fillFromConfig(t, i, a) {
          const l = XA(t), d = a || l.removeItems, g = this._cleanItemsConfiguration(l.items, i, d).map((m) => me(m) ? this._createNestedToolbarDropdown(m, i, d) : m === "|" ? new ZA() : m === "-" ? new W6() : i.create(m)).filter((m) => !!m);
          this.items.addMany(g);
        }
        _cleanItemsConfiguration(t, i, a) {
          const l = t.filter((d, g, m) => d === "|" || a.indexOf(d) === -1 && (d === "-" ? !this.options.shouldGroupWhenFull || ($("toolbarview-line-break-ignored-when-grouping-items", m), !1) : !(!me(d) && !i.has(d)) || ($("toolbarview-item-unavailable", { item: d }), !1)));
          return this._cleanSeparatorsAndLineBreaks(l);
        }
        _cleanSeparatorsAndLineBreaks(t) {
          const i = (g) => g !== "-" && g !== "|", a = t.length, l = t.findIndex(i);
          if (l === -1)
            return [];
          const d = a - t.slice().reverse().findIndex(i);
          return t.slice(l, d).filter((g, m, w) => i(g) ? !0 : !(m > 0 && w[m - 1] === g));
        }
        _createNestedToolbarDropdown(t, i, a) {
          let { label: l, icon: d, items: g, tooltip: m = !0, withText: w = !1 } = t;
          if (g = this._cleanItemsConfiguration(g, i, a), !g.length)
            return null;
          const A = ua(this.locale);
          return l || $("toolbarview-nested-toolbar-dropdown-missing-label", t), A.class = "ck-toolbar__nested-toolbar-dropdown", A.buttonView.set({ label: l, tooltip: m, withText: !!w }), d !== !1 ? A.buttonView.icon = q6[d] || d || eC : A.buttonView.withText = !0, A0(A, []), A.toolbarView.fillFromConfig(g, i, a), A;
        }
      }
      class K6 extends At {
        constructor(t) {
          super(t), this.children = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-toolbar__items"] }, children: this.children });
        }
      }
      class Y6 {
        constructor(t) {
          const i = t.bindTemplate;
          t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using((a) => a), t.focusables.bindTo(t.items).using((a) => a), t.extendTemplate({ attributes: { class: [i.if("isVertical", "ck-toolbar_vertical")] } });
        }
        render() {
        }
        destroy() {
        }
      }
      class Q6 {
        constructor(t) {
          this.view = t, this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, t.itemsView.children.bindTo(this.ungroupedItems).using((i) => i), this.ungroupedItems.on("change", this._updateFocusCycleableItems.bind(this)), t.children.on("change", this._updateFocusCycleableItems.bind(this)), t.items.on("change", (i, a) => {
            const l = a.index, d = Array.from(a.added);
            for (const g of a.removed)
              l >= this.ungroupedItems.length ? this.groupedItems.remove(g) : this.ungroupedItems.remove(g);
            for (let g = l; g < l + d.length; g++) {
              const m = d[g - l];
              g > this.ungroupedItems.length ? this.groupedItems.add(m, g - this.ungroupedItems.length) : this.ungroupedItems.add(m, g);
            }
            this._updateGrouping();
          }), t.extendTemplate({ attributes: { class: ["ck-toolbar_grouping"] } });
        }
        render(t) {
          this.viewElement = t.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t);
        }
        destroy() {
          this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
        }
        _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement))
            return;
          if (!Za(this.viewElement))
            return void (this.shouldUpdateGroupingOnNextResize = !0);
          const t = this.groupedItems.length;
          let i;
          for (; this._areItemsOverflowing; )
            this._groupLastItem(), i = !0;
          if (!i && this.groupedItems.length) {
            for (; this.groupedItems.length && !this._areItemsOverflowing; )
              this._ungroupFirstItem();
            this._areItemsOverflowing && this._groupLastItem();
          }
          this.groupedItems.length !== t && this.view.fire("groupedItemsUpdate");
        }
        get _areItemsOverflowing() {
          if (!this.ungroupedItems.length)
            return !1;
          const t = this.viewElement, i = this.viewLocale.uiLanguageDirection, a = new In(t.lastChild), l = new In(t);
          if (!this.cachedPadding) {
            const d = yt.window.getComputedStyle(t), g = i === "ltr" ? "paddingRight" : "paddingLeft";
            this.cachedPadding = Number.parseInt(d[g]);
          }
          return i === "ltr" ? a.right > l.right - this.cachedPadding : a.left < l.left + this.cachedPadding;
        }
        _enableGroupingOnResize() {
          let t;
          this.resizeObserver = new fn(this.viewElement, (i) => {
            t && t === i.contentRect.width && !this.shouldUpdateGroupingOnNextResize || (this.shouldUpdateGroupingOnNextResize = !1, this._updateGrouping(), t = i.contentRect.width);
          }), this._updateGrouping();
        }
        _enableGroupingOnMaxWidthChange(t) {
          t.on("change:maxWidth", () => {
            this._updateGrouping();
          });
        }
        _groupLastItem() {
          this.groupedItems.length || (this.viewChildren.add(new ZA()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
        }
        _ungroupFirstItem() {
          this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
        }
        _createGroupedItemsDropdown() {
          const t = this.viewLocale, i = t.t, a = ua(t);
          return a.class = "ck-toolbar__grouped-dropdown", a.panelPosition = t.uiLanguageDirection === "ltr" ? "sw" : "se", A0(a, []), a.buttonView.set({ label: i("Show more items"), tooltip: !0, tooltipPosition: t.uiLanguageDirection === "rtl" ? "se" : "sw", icon: eC }), a.toolbarView.items.bindTo(this.groupedItems).using((l) => l), a;
        }
        _updateFocusCycleableItems() {
          this.viewFocusables.clear(), this.ungroupedItems.map((t) => {
            this.viewFocusables.add(t);
          }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
        }
      }
      var tC = s(1046), Z6 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(tC.Z, Z6), tC.Z.locals;
      class X6 extends At {
        constructor(t) {
          super(t), this.items = this.createCollection(), this.focusTracker = new Kr(), this.keystrokes = new Qi(), this._focusCycler = new _l({ focusables: this.items, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowup", focusNext: "arrowdown" } }), this.setTemplate({ tag: "ul", attributes: { class: ["ck", "ck-reset", "ck-list"] }, children: this.items });
        }
        render() {
          super.render();
          for (const t of this.items)
            this.focusTracker.add(t.element);
          this.items.on("add", (t, i) => {
            this.focusTracker.add(i.element);
          }), this.items.on("remove", (t, i) => {
            this.focusTracker.remove(i.element);
          }), this.keystrokes.listenTo(this.element);
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        focusLast() {
          this._focusCycler.focusLast();
        }
      }
      class nC extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.set("isVisible", !0), this.children = this.createCollection(), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__item", i.if("isVisible", "ck-hidden", (a) => !a)] }, children: this.children });
        }
        focus() {
          this.children.first.focus();
        }
      }
      class J6 extends At {
        constructor(t) {
          super(t), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__separator"] } });
        }
      }
      var rC = s(7339), e$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(rC.Z, e$), rC.Z.locals;
      var iC = s(3949), t$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(iC.Z, t$), iC.Z.locals;
      function ua(c, t = z6) {
        const i = new t(c), a = new H6(c), l = new kl(c, i, a);
        return i.bind("isEnabled").to(l), i instanceof y0 ? i.arrowView.bind("isOn").to(l, "isOpen") : i.bind("isOn").to(l, "isOpen"), function(d) {
          (function(g) {
            g.on("render", () => {
              v0({ emitter: g, activator: () => g.isOpen, callback: () => {
                g.isOpen = !1;
              }, contextElements: [g.element] });
            });
          })(d), function(g) {
            g.on("execute", (m) => {
              m.source instanceof Dh || (g.isOpen = !1);
            });
          }(d), function(g) {
            g.focusTracker.on("change:isFocused", (m, w, A) => {
              g.isOpen && !A && (g.isOpen = !1);
            });
          }(d), function(g) {
            g.keystrokes.set("arrowdown", (m, w) => {
              g.isOpen && (g.panelView.focus(), w());
            }), g.keystrokes.set("arrowup", (m, w) => {
              g.isOpen && (g.panelView.focusLast(), w());
            });
          }(d), function(g) {
            g.on("change:isOpen", (m, w, A) => {
              A || g.panelView.element.contains(yt.document.activeElement) && g.buttonView.focus();
            });
          }(d), function(g) {
            g.on("change:isOpen", (m, w, A) => {
              A && g.panelView.focus();
            }, { priority: "low" });
          }(d);
        }(l), l;
      }
      function A0(c, t, i = {}) {
        const a = c.locale, l = a.t, d = c.toolbarView = new _0(a);
        d.set("ariaLabel", l("Dropdown toolbar")), c.extendTemplate({ attributes: { class: ["ck-toolbar-dropdown"] } }), t.map((g) => d.items.add(g)), i.enableActiveItemFocusOnDropdownOpen && aC(c, () => d.items.find((g) => g.isOn)), c.panelView.children.add(d), d.items.delegate("execute").to(c);
      }
      function oC(c, t) {
        const i = c.locale, a = c.listView = new X6(i);
        a.items.bindTo(t).using((l) => {
          if (l.type === "separator")
            return new J6(i);
          if (l.type === "button" || l.type === "switchbutton") {
            const d = new nC(i);
            let g;
            return g = l.type === "button" ? new cn(i) : new Dh(i), g.bind(...Object.keys(l.model)).to(l.model), g.delegate("execute").to(d), d.children.add(g), d;
          }
          return null;
        }), c.panelView.children.add(a), a.items.delegate("execute").to(c), aC(c, () => a.items.find((l) => l instanceof nC && l.children.first.isOn));
      }
      function aC(c, t) {
        c.on("change:isOpen", () => {
          if (!c.isOpen)
            return;
          const i = t();
          i && (typeof i.focus == "function" ? i.focus() : $("ui-dropdown-focus-child-on-open-child-missing-focus", { view: i }));
        }, { priority: O.low - 10 });
      }
      var sC = s(9688), n$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(sC.Z, n$), sC.Z.locals;
      class r$ extends At {
        constructor(t) {
          super(t), this.body = new $6(t);
        }
        render() {
          super.render(), this.body.attachToDom();
        }
        destroy() {
          return this.body.detachFromDom(), super.destroy();
        }
      }
      var lC = s(3662), i$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(lC.Z, i$), lC.Z.locals;
      class cC extends At {
        constructor(t) {
          super(t), this.set("text", void 0), this.set("for", void 0), this.id = `ck-editor__label_${N()}`;
          const i = this.bindTemplate;
          this.setTemplate({ tag: "label", attributes: { class: ["ck", "ck-label"], id: this.id, for: i.to("for") }, children: [{ text: i.to("text") }] });
        }
      }
      class o$ extends r$ {
        constructor(t) {
          super(t), this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"], role: "application", dir: t.uiLanguageDirection, lang: t.uiLanguage, "aria-labelledby": this._voiceLabelView.id }, children: [this._voiceLabelView, { tag: "div", attributes: { class: ["ck", "ck-editor__top", "ck-reset_all"], role: "presentation" }, children: this.top }, { tag: "div", attributes: { class: ["ck", "ck-editor__main"], role: "presentation" }, children: this.main }] });
        }
        _createVoiceLabel() {
          const t = this.t, i = new cC();
          return i.text = t("Rich Text Editor"), i.extendTemplate({ attributes: { class: "ck-voice-label" } }), i;
        }
      }
      class a$ extends At {
        constructor(t, i, a) {
          super(t), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"], lang: t.contentLanguage, dir: t.contentLanguageDirection } }), this.name = null, this.set("isFocused", !1), this._editableElement = a, this._hasExternalElement = !!this._editableElement, this._editingView = i;
        }
        render() {
          super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
        }
        destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
        }
        _updateIsFocusedClasses() {
          const t = this._editingView;
          function i(a) {
            t.change((l) => {
              const d = t.document.getRoot(a.name);
              l.addClass(a.isFocused ? "ck-focused" : "ck-blurred", d), l.removeClass(a.isFocused ? "ck-blurred" : "ck-focused", d);
            });
          }
          t.isRenderingInProgress ? function a(l) {
            t.once("change:isRenderingInProgress", (d, g, m) => {
              m ? a(l) : i(l);
            });
          }(this) : i(this);
        }
      }
      class s$ extends a$ {
        constructor(t, i, a, l = {}) {
          super(t, i, a);
          const d = t.t;
          this.extendTemplate({ attributes: { role: "textbox", class: "ck-editor__editable_inline" } }), this._generateLabel = l.label || (() => d("Editor editing area: %0", this.name));
        }
        render() {
          super.render();
          const t = this._editingView;
          t.change((i) => {
            const a = t.document.getRoot(this.name);
            i.setAttribute("aria-label", this._generateLabel(this), a);
          });
        }
      }
      var uC = s(8847), l$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(uC.Z, l$), uC.Z.locals;
      var dC = s(4879), c$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(dC.Z, c$), dC.Z.locals;
      class u$ extends At {
        constructor(t) {
          super(t), this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("isReadOnly", !1), this.set("hasError", !1), this.set("ariaDescribedById", void 0), this.focusTracker = new Kr(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", !0), this.set("inputMode", "text");
          const i = this.bindTemplate;
          this.setTemplate({ tag: "input", attributes: { class: ["ck", "ck-input", i.if("isFocused", "ck-input_focused"), i.if("isEmpty", "ck-input-text_empty"), i.if("hasError", "ck-error")], id: i.to("id"), placeholder: i.to("placeholder"), readonly: i.to("isReadOnly"), inputmode: i.to("inputMode"), "aria-invalid": i.if("hasError", !0), "aria-describedby": i.to("ariaDescribedById") }, on: { input: i.to((...a) => {
            this.fire("input", ...a), this._updateIsEmpty();
          }), change: i.to(this._updateIsEmpty.bind(this)) } });
        }
        render() {
          super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (t, i, a) => {
            this._setDomElementValue(a), this._updateIsEmpty();
          });
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy();
        }
        select() {
          this.element.select();
        }
        focus() {
          this.element.focus();
        }
        _updateIsEmpty() {
          this.isEmpty = !this.element.value;
        }
        _setDomElementValue(t) {
          this.element.value = t || t === 0 ? t : "";
        }
      }
      class d$ extends u$ {
        constructor(t) {
          super(t), this.extendTemplate({ attributes: { type: "text", class: ["ck-input-text"] } });
        }
      }
      var hC = s(2577), h$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(hC.Z, h$), hC.Z.locals;
      class C0 extends At {
        constructor(t, i) {
          super(t);
          const a = `ck-labeled-field-view-${N()}`, l = `ck-labeled-field-view-status-${N()}`;
          this.fieldView = i(this, a, l), this.set("label", void 0), this.set("isEnabled", !0), this.set("isEmpty", !0), this.set("isFocused", !1), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(a), this.statusView = this._createStatusView(l), this.fieldWrapperChildren = this.createCollection([this.fieldView, this.labelView]), this.bind("_statusText").to(this, "errorText", this, "infoText", (g, m) => g || m);
          const d = this.bindTemplate;
          this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view", d.to("class"), d.if("isEnabled", "ck-disabled", (g) => !g), d.if("isEmpty", "ck-labeled-field-view_empty"), d.if("isFocused", "ck-labeled-field-view_focused"), d.if("placeholder", "ck-labeled-field-view_placeholder"), d.if("errorText", "ck-error")] }, children: [{ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__input-wrapper"] }, children: this.fieldWrapperChildren }, this.statusView] });
        }
        _createLabelView(t) {
          const i = new cC(this.locale);
          return i.for = t, i.bind("text").to(this, "label"), i;
        }
        _createStatusView(t) {
          const i = new At(this.locale), a = this.bindTemplate;
          return i.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__status", a.if("errorText", "ck-labeled-field-view__status_error"), a.if("_statusText", "ck-hidden", (l) => !l)], id: t, role: a.if("errorText", "alert") }, children: [{ text: a.to("_statusText") }] }), i;
        }
        focus() {
          this.fieldView.focus();
        }
      }
      function x0(c, t, i) {
        const a = new d$(c.locale);
        return a.set({ id: t, ariaDescribedById: i }), a.bind("isReadOnly").to(c, "isEnabled", (l) => !l), a.bind("hasError").to(c, "errorText", (l) => !!l), a.on("input", () => {
          c.errorText = null;
        }), c.bind("isEmpty", "isFocused", "placeholder").to(a), a;
      }
      class E0 extends uh {
        static get pluginName() {
          return "Notification";
        }
        init() {
          this.on("show:warning", (t, i) => {
            window.alert(i.message);
          }, { priority: "lowest" });
        }
        showSuccess(t, i = {}) {
          this._showNotification({ message: t, type: "success", namespace: i.namespace, title: i.title });
        }
        showInfo(t, i = {}) {
          this._showNotification({ message: t, type: "info", namespace: i.namespace, title: i.title });
        }
        showWarning(t, i = {}) {
          this._showNotification({ message: t, type: "warning", namespace: i.namespace, title: i.title });
        }
        _showNotification(t) {
          const i = t.namespace ? `show:${t.type}:${t.namespace}` : `show:${t.type}`;
          this.fire(i, { message: t.message, type: t.type, title: t.title || "" });
        }
      }
      class fC extends Te() {
        constructor(t, i) {
          super(), i && k_(this, i), t && this.set(t);
        }
      }
      var pC = s(4650), f$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(pC.Z, f$), pC.Z.locals;
      var gC = s(7676), p$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(gC.Z, p$), gC.Z.locals;
      const Ih = Sm("px");
      class Ph extends Ie {
        static get pluginName() {
          return "ContextualBalloon";
        }
        constructor(t) {
          super(t), this.positionLimiter = () => {
            const i = this.editor.editing.view, a = i.document.selection.editableElement;
            return a ? i.domConverter.mapViewToDom(a.root) : null;
          }, this.set("visibleView", null), this.view = new vr(t.locale), t.ui.view.body.add(this.view), t.ui.focusTracker.add(this.view.element), this._viewToStack = /* @__PURE__ */ new Map(), this._idToStack = /* @__PURE__ */ new Map(), this.set("_numberOfStacks", 0), this.set("_singleViewMode", !1), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
        }
        destroy() {
          super.destroy(), this.view.destroy(), this._rotatorView.destroy(), this._fakePanelsView.destroy();
        }
        hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
        add(t) {
          if (this.hasView(t.view))
            throw new S("contextualballoon-add-view-exist", [this, t]);
          const i = t.stackId || "main";
          if (!this._idToStack.has(i))
            return this._idToStack.set(i, /* @__PURE__ */ new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(i)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(i));
          const a = this._idToStack.get(i);
          t.singleViewMode && this.showStack(i), a.set(t.view, t), this._viewToStack.set(t.view, a), a === this._visibleStack && this._showView(t);
        }
        remove(t) {
          if (!this.hasView(t))
            throw new S("contextualballoon-remove-view-not-exist", [this, t]);
          const i = this._viewToStack.get(t);
          this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (i.size === 1 ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(i.values())[i.size - 2])), i.size === 1 ? (this._idToStack.delete(this._getStackId(i)), this._numberOfStacks = this._idToStack.size) : i.delete(t), this._viewToStack.delete(t);
        }
        updatePosition(t) {
          t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
        showStack(t) {
          this.visibleStack = t;
          const i = this._idToStack.get(t);
          if (!i)
            throw new S("contextualballoon-showstack-stack-not-exist", this);
          this._visibleStack !== i && this._showView(Array.from(i.values()).pop());
        }
        get _visibleStack() {
          return this._viewToStack.get(this.visibleView);
        }
        _getStackId(t) {
          return Array.from(this._idToStack.entries()).find((i) => i[1] === t)[0];
        }
        _showNextStack() {
          const t = Array.from(this._idToStack.values());
          let i = t.indexOf(this._visibleStack) + 1;
          t[i] || (i = 0), this.showStack(this._getStackId(t[i]));
        }
        _showPrevStack() {
          const t = Array.from(this._idToStack.values());
          let i = t.indexOf(this._visibleStack) - 1;
          t[i] || (i = t.length - 1), this.showStack(this._getStackId(t[i]));
        }
        _createRotatorView() {
          const t = new g$(this.editor.locale), i = this.editor.locale.t;
          return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (a, l) => !l && a > 1), t.on("change:isNavigationVisible", () => this.updatePosition(), { priority: "low" }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (a, l) => {
            if (l < 2)
              return "";
            const d = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
            return i("%0 of %1", [d, l]);
          }), t.buttonNextView.on("execute", () => {
            t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
          }), t.buttonPrevView.on("execute", () => {
            t.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
          }), t;
        }
        _createFakePanelsView() {
          const t = new m$(this.editor.locale, this.view);
          return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (i, a) => !a && i >= 2 ? Math.min(i - 1, 2) : 0), t.listenTo(this.view, "change:top", () => t.updatePosition()), t.listenTo(this.view, "change:left", () => t.updatePosition()), this.editor.ui.view.body.add(t), t;
        }
        _showView({ view: t, balloonClassName: i = "", withArrow: a = !0, singleViewMode: l = !1 }) {
          this.view.class = i, this.view.withArrow = a, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), l && (this._singleViewMode = !0);
        }
        _getBalloonPosition() {
          let t = Array.from(this._visibleStack.values()).pop().position;
          return t && (t.limiter || (t = Object.assign({}, t, { limiter: this.positionLimiter })), t = Object.assign({}, t, { viewportOffsetConfig: this.editor.ui.viewportOffset })), t;
        }
      }
      class g$ extends At {
        constructor(t) {
          super(t);
          const i = t.t, a = this.bindTemplate;
          this.set("isNavigationVisible", !0), this.focusTracker = new Kr(), this.buttonPrevView = this._createButtonView(i("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), this.buttonNextView = this._createButtonView(i("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-rotator"], "z-index": "-1" }, children: [{ tag: "div", attributes: { class: ["ck-balloon-rotator__navigation", a.to("isNavigationVisible", (l) => l ? "" : "ck-hidden")] }, children: [this.buttonPrevView, { tag: "span", attributes: { class: ["ck-balloon-rotator__counter"] }, children: [{ text: a.to("counter") }] }, this.buttonNextView] }, { tag: "div", attributes: { class: "ck-balloon-rotator__content" }, children: this.content }] });
        }
        render() {
          super.render(), this.focusTracker.add(this.element);
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy();
        }
        showView(t) {
          this.hideView(), this.content.add(t);
        }
        hideView() {
          this.content.clear();
        }
        _createButtonView(t, i) {
          const a = new cn(this.locale);
          return a.set({ label: t, icon: i, tooltip: !0 }), a;
        }
      }
      class m$ extends At {
        constructor(t, i) {
          super(t);
          const a = this.bindTemplate;
          this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = i, this.setTemplate({ tag: "div", attributes: { class: ["ck-fake-panel", a.to("numberOfPanels", (l) => l ? "" : "ck-hidden")], style: { top: a.to("top", Ih), left: a.to("left", Ih), width: a.to("width", Ih), height: a.to("height", Ih) } }, children: this.content }), this.on("change:numberOfPanels", (l, d, g, m) => {
            g > m ? this._addPanels(g - m) : this._removePanels(m - g), this.updatePosition();
          });
        }
        _addPanels(t) {
          for (; t--; ) {
            const i = new At();
            i.setTemplate({ tag: "div" }), this.content.add(i), this.registerChild(i);
          }
        }
        _removePanels(t) {
          for (; t--; ) {
            const i = this.content.last;
            this.content.remove(i), this.deregisterChild(i), i.destroy();
          }
        }
        updatePosition() {
          if (this.numberOfPanels) {
            const { top: t, left: i } = this._balloonPanelView, { width: a, height: l } = new In(this._balloonPanelView.element);
            Object.assign(this, { top: t, left: i, width: a, height: l });
          }
        }
      }
      var mC = s(5868), v$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(mC.Z, v$), mC.Z.locals;
      const gu = Sm("px");
      class b$ extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.set("isActive", !1), this.set("isSticky", !1), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheLimiter", !1), this.set("_hasViewportTopOffset", !1), this.content = this.createCollection(), this._contentPanelPlaceholder = new Ci({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__placeholder"], style: { display: i.to("isSticky", (a) => a ? "block" : "none"), height: i.to("isSticky", (a) => a ? gu(this._panelRect.height) : null) } } }).render(), this._contentPanel = new Ci({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__content", i.if("isSticky", "ck-sticky-panel__content_sticky"), i.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")], style: { width: i.to("isSticky", (a) => a ? gu(this._contentPanelPlaceholder.getBoundingClientRect().width) : null), top: i.to("_hasViewportTopOffset", (a) => a ? gu(this.viewportTopOffset) : null), bottom: i.to("_isStickyToTheLimiter", (a) => a ? gu(this.limiterBottomOffset) : null), marginLeft: i.to("_marginLeft") } }, children: this.content }).render(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel"] }, children: [this._contentPanelPlaceholder, this._contentPanel] });
        }
        render() {
          super.render(), this._checkIfShouldBeSticky(), this.listenTo(yt.window, "scroll", () => {
            this._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", () => {
            this._checkIfShouldBeSticky();
          });
        }
        _checkIfShouldBeSticky() {
          const t = this._panelRect = this._contentPanel.getBoundingClientRect();
          let i;
          this.limiterElement ? (i = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && i.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < i.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = i.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : gu(-yt.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }
      var vC = s(9695), w$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(vC.Z, w$), vC.Z.locals;
      class y$ extends N6 {
        constructor(t, i) {
          super(t), this.view = i, this._toolbarConfig = XA(t.config.get("toolbar")), this._elementReplacer = new qt();
        }
        get element() {
          return this.view.element;
        }
        init(t) {
          const i = this.editor, a = this.view, l = i.editing.view, d = a.editable, g = l.document.getRoot();
          d.name = g.rootName, a.render();
          const m = d.element;
          this.setEditableElement(d.name, m), a.editable.bind("isFocused").to(this.focusTracker), l.attachDomRoot(m), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
        destroy() {
          super.destroy();
          const t = this.view, i = this.editor.editing.view;
          this._elementReplacer.restore(), i.detachDomRoot(t.editable.name), t.destroy();
        }
        _initToolbar() {
          const t = this.view;
          t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({ top: i }) => i || 0), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t.toolbar);
        }
        _initPlaceholder() {
          const t = this.editor, i = t.editing.view, a = i.document.getRoot(), l = t.sourceElement, d = t.config.get("placeholder") || l && l.tagName.toLowerCase() === "textarea" && l.getAttribute("placeholder");
          d && zk({ view: i, element: a, text: d, isDirectHost: !1, keepOnFocus: !0 });
        }
      }
      var bC = s(3143), k$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(bC.Z, k$), bC.Z.locals;
      class _$ extends o$ {
        constructor(t, i, a = {}) {
          super(t), this.stickyPanel = new b$(t), this.toolbar = new _0(t, { shouldGroupWhenFull: a.shouldToolbarGroupWhenFull }), this.editable = new s$(t, i);
        }
        render() {
          super.render(), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }
      class A$ extends Th(m0(E6)) {
        constructor(t, i = {}) {
          if (!Oh(t) && i.initialData !== void 0)
            throw new S("editor-create-initial-data", null);
          super(i), this.config.get("initialData") === void 0 && this.config.set("initialData", function(d) {
            return Oh(d) ? (g = d, g instanceof HTMLTextAreaElement ? g.value : g.innerHTML) : d;
            var g;
          }(t)), Oh(t) && (this.sourceElement = t), this.model.document.createRoot();
          const a = !this.config.get("toolbar.shouldNotGroupWhenFull"), l = new _$(this.locale, this.editing.view, { shouldToolbarGroupWhenFull: a });
          this.ui = new y$(this, l), function(d) {
            if (!Qe(d.updateSourceElement))
              throw new S("attachtoform-missing-elementapi-interface", d);
            const g = d.sourceElement;
            if (function(m) {
              return !!m && m.tagName.toLowerCase() === "textarea";
            }(g) && g.form) {
              let m;
              const w = g.form, A = () => d.updateSourceElement();
              Qe(w.submit) && (m = w.submit, w.submit = () => {
                A(), m.apply(w);
              }), w.addEventListener("submit", A), d.on("destroy", () => {
                w.removeEventListener("submit", A), m && (w.submit = m);
              });
            }
          }(this);
        }
        destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
        }
        static create(t, i = {}) {
          return new Promise((a) => {
            const l = new this(t, i);
            a(l.initPlugins().then(() => l.ui.init(Oh(t) ? t : null)).then(() => l.data.init(l.config.get("initialData"))).then(() => l.fire("ready")).then(() => l));
          });
        }
      }
      function Oh(c) {
        return Bn(c);
      }
      class S0 extends sa {
        constructor(t) {
          super(t);
          const i = this.document;
          function a(l) {
            return (d, g) => {
              g.preventDefault();
              const m = g.dropRange ? [g.dropRange] : null, w = new D(i, l);
              i.fire(w, { dataTransfer: g.dataTransfer, method: d.name, targetRanges: m, target: g.target }), w.stop.called && g.stopPropagation();
            };
          }
          this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"], this.listenTo(i, "paste", a("clipboardInput"), { priority: "low" }), this.listenTo(i, "drop", a("clipboardInput"), { priority: "low" }), this.listenTo(i, "dragover", a("dragging"), { priority: "low" });
        }
        onDomEvent(t) {
          const i = { dataTransfer: new D_("clipboardData" in t ? t.clipboardData : t.dataTransfer) };
          t.type != "drop" && t.type != "dragover" || (i.dropRange = function(a, l) {
            const d = l.target.ownerDocument, g = l.clientX, m = l.clientY;
            let w;
            return d.caretRangeFromPoint && d.caretRangeFromPoint(g, m) ? w = d.caretRangeFromPoint(g, m) : l.rangeParent && (w = d.createRange(), w.setStart(l.rangeParent, l.rangeOffset), w.collapse(!0)), w ? a.domConverter.domRangeToView(w) : null;
          }(this.view, t)), this.fire(t.type, t, i);
        }
      }
      const wC = ["figcaption", "li"];
      function yC(c) {
        let t = "";
        if (c.is("$text") || c.is("$textProxy"))
          t = c.data;
        else if (c.is("element", "img") && c.hasAttribute("alt"))
          t = c.getAttribute("alt");
        else if (c.is("element", "br"))
          t = `
`;
        else {
          let i = null;
          for (const a of c.getChildren()) {
            const l = yC(a);
            i && (i.is("containerElement") || a.is("containerElement")) && (wC.includes(i.name) || wC.includes(a.name) ? t += `
` : t += `

`), t += l, i = a;
          }
        }
        return t;
      }
      class io extends Ie {
        static get pluginName() {
          return "ClipboardPipeline";
        }
        init() {
          this.editor.editing.view.addObserver(S0), this._setupPasteDrop(), this._setupCopyCut();
        }
        _setupPasteDrop() {
          const t = this.editor, i = t.model, a = t.editing.view, l = a.document;
          this.listenTo(l, "clipboardInput", (d) => {
            t.isReadOnly && d.stop();
          }, { priority: "highest" }), this.listenTo(l, "clipboardInput", (d, g) => {
            const m = g.dataTransfer;
            let w;
            if (g.content)
              w = g.content;
            else {
              let T = "";
              m.getData("text/html") ? T = function(R) {
                return R.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (j, F) => F.length == 1 ? " " : F).replace(/<!--[\s\S]*?-->/g, "");
              }(m.getData("text/html")) : m.getData("text/plain") && (((A = (A = m.getData("text/plain")).replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || A.includes("<br>")) && (A = `<p>${A}</p>`), T = A), w = this.editor.data.htmlProcessor.toView(T);
            }
            var A;
            const C = new D(this, "inputTransformation");
            this.fire(C, { content: w, dataTransfer: m, targetRanges: g.targetRanges, method: g.method }), C.stop.called && d.stop(), a.scrollToTheSelection();
          }, { priority: "low" }), this.listenTo(this, "inputTransformation", (d, g) => {
            if (g.content.isEmpty)
              return;
            const m = this.editor.data.toModel(g.content, "$clipboardHolder");
            m.childCount != 0 && (d.stop(), i.change(() => {
              this.fire("contentInsertion", { content: m, method: g.method, dataTransfer: g.dataTransfer, targetRanges: g.targetRanges });
            }));
          }, { priority: "low" }), this.listenTo(this, "contentInsertion", (d, g) => {
            g.resultRange = i.insertContent(g.content);
          }, { priority: "low" });
        }
        _setupCopyCut() {
          const t = this.editor, i = t.model.document, a = t.editing.view.document, l = (d, g) => {
            const m = g.dataTransfer;
            g.preventDefault();
            const w = t.data.toView(t.model.getSelectedContent(i.selection));
            a.fire("clipboardOutput", { dataTransfer: m, content: w, method: d.name });
          };
          this.listenTo(a, "copy", l, { priority: "low" }), this.listenTo(a, "cut", (d, g) => {
            t.isReadOnly ? g.preventDefault() : l(d, g);
          }, { priority: "low" }), this.listenTo(a, "clipboardOutput", (d, g) => {
            g.content.isEmpty || (g.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(g.content)), g.dataTransfer.setData("text/plain", yC(g.content))), g.method == "cut" && t.model.deleteContent(i.selection);
          }, { priority: "low" });
        }
      }
      class kC {
        constructor(t, i = 20) {
          this._batch = null, this.model = t, this._size = 0, this.limit = i, this._isLocked = !1, this._changeCallback = (a, l) => {
            l.isLocal && l.isUndoable && l !== this._batch && this._reset(!0);
          }, this._selectionChangeCallback = () => {
            this._reset();
          }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
        }
        get batch() {
          return this._batch || (this._batch = this.model.createBatch({ isTyping: !0 })), this._batch;
        }
        get size() {
          return this._size;
        }
        input(t) {
          this._size += t, this._size >= this.limit && this._reset(!0);
        }
        get isLocked() {
          return this._isLocked;
        }
        lock() {
          this._isLocked = !0;
        }
        unlock() {
          this._isLocked = !1;
        }
        destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
        _reset(t = !1) {
          this.isLocked && !t || (this._batch = null, this._size = 0);
        }
      }
      class C$ extends kt {
        constructor(t, i) {
          super(t), this._buffer = new kC(t.model, i);
        }
        get buffer() {
          return this._buffer;
        }
        destroy() {
          super.destroy(), this._buffer.destroy();
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.document, l = t.text || "", d = l.length;
          let g = a.selection;
          t.selection ? g = t.selection : t.range && (g = i.createSelection(t.range));
          const m = t.resultRange;
          i.enqueueChange(this._buffer.batch, (w) => {
            this._buffer.lock(), i.deleteContent(g), l && i.insertContent(w.createText(l, a.selection.getAttributes()), g), m ? w.setSelection(m) : g.is("documentSelection") || w.setSelection(g), this._buffer.unlock(), this._buffer.input(d);
          });
        }
      }
      const _C = ["insertText", "insertReplacementText"];
      class x$ extends to {
        constructor(t) {
          super(t), p.isAndroid && _C.push("insertCompositionText");
          const i = t.document;
          i.on("beforeinput", (a, l) => {
            if (!this.isEnabled)
              return;
            const { data: d, targetRanges: g, inputType: m, domEvent: w } = l;
            if (!_C.includes(m))
              return;
            const A = new D(i, "insertText");
            i.fire(A, new gl(t, w, { text: d, selection: t.createSelection(g) })), A.stop.called && a.stop();
          }), i.on("compositionend", (a, { data: l, domEvent: d }) => {
            this.isEnabled && !p.isAndroid && l && i.fire("insertText", new gl(t, d, { text: l, selection: i.selection }));
          }, { priority: "lowest" });
        }
        observe() {
        }
      }
      class AC extends Ie {
        static get pluginName() {
          return "Input";
        }
        init() {
          const t = this.editor, i = t.model, a = t.editing.view, l = i.document.selection;
          a.addObserver(x$);
          const d = new C$(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("insertText", d), t.commands.add("input", d), this.listenTo(a.document, "insertText", (g, m) => {
            a.document.isComposing || m.preventDefault();
            const { text: w, selection: A, resultRange: C } = m, T = Array.from(A.getRanges()).map((F) => t.editing.mapper.toModelRange(F));
            let R = w;
            if (p.isAndroid) {
              const F = Array.from(T[0].getItems()).reduce((V, W) => V + (W.is("$textProxy") ? W.data : ""), "");
              F && (F.length <= R.length ? R.startsWith(F) && (R = R.substring(F.length), T[0].start = T[0].start.getShiftedBy(F.length)) : F.startsWith(R) && (T[0].start = T[0].start.getShiftedBy(R.length), R = ""));
            }
            const j = { text: R, selection: i.createSelection(T) };
            C && (j.resultRange = t.editing.mapper.toModelRange(C)), t.execute("insertText", j);
          }), p.isAndroid ? this.listenTo(a.document, "keydown", (g, m) => {
            !l.isCollapsed && m.keyCode == 229 && a.document.isComposing && CC(i, d);
          }) : this.listenTo(a.document, "compositionstart", () => {
            l.isCollapsed || CC(i, d);
          });
        }
      }
      function CC(c, t) {
        if (!t.isEnabled)
          return;
        const i = t.buffer;
        i.lock(), c.enqueueChange(i.batch, () => {
          c.deleteContent(c.document.selection);
        }), i.unlock();
      }
      class xC extends kt {
        constructor(t, i) {
          super(t), this.direction = i, this._buffer = new kC(t.model, t.config.get("typing.undoStep"));
        }
        get buffer() {
          return this._buffer;
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.document;
          i.enqueueChange(this._buffer.batch, (l) => {
            this._buffer.lock();
            const d = l.createSelection(t.selection || a.selection), g = t.sequence || 1, m = d.isCollapsed;
            if (d.isCollapsed && i.modifySelection(d, { direction: this.direction, unit: t.unit, treatEmojiAsSingleUnit: !0 }), this._shouldEntireContentBeReplacedWithParagraph(g))
              return void this._replaceEntireContentWithParagraph(l);
            if (this._shouldReplaceFirstBlockWithParagraph(d, g))
              return void this.editor.execute("paragraph", { selection: d });
            if (d.isCollapsed)
              return;
            let w = 0;
            d.getFirstRange().getMinimalFlatRanges().forEach((A) => {
              w += An(A.getWalker({ singleCharacters: !0, ignoreElementEnd: !0, shallow: !0 }));
            }), i.deleteContent(d, { doNotResetEntireContent: m, direction: this.direction }), this._buffer.input(w), l.setSelection(d), this._buffer.unlock();
          });
        }
        _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1)
            return !1;
          const i = this.editor.model, a = i.document.selection, l = i.schema.getLimitElement(a);
          if (!(a.isCollapsed && a.containsEntireContent(l)) || !i.schema.checkChild(l, "paragraph"))
            return !1;
          const d = l.getChild(0);
          return !d || !d.is("element", "paragraph");
        }
        _replaceEntireContentWithParagraph(t) {
          const i = this.editor.model, a = i.document.selection, l = i.schema.getLimitElement(a), d = t.createElement("paragraph");
          t.remove(t.createRangeIn(l)), t.insert(d, l), t.setSelection(d, 0);
        }
        _shouldReplaceFirstBlockWithParagraph(t, i) {
          const a = this.editor.model;
          if (i > 1 || this.direction != "backward" || !t.isCollapsed)
            return !1;
          const l = t.getFirstPosition(), d = a.schema.getLimitElement(l), g = d.getChild(0);
          return l.parent == g && !!t.containsEntireContent(g) && !!a.schema.checkChild(d, "paragraph") && g.name != "paragraph";
        }
      }
      const EC = "word", da = "selection", Al = "backward", mu = "forward", SC = { deleteContent: { unit: da, direction: Al }, deleteContentBackward: { unit: "codePoint", direction: Al }, deleteWordBackward: { unit: EC, direction: Al }, deleteHardLineBackward: { unit: da, direction: Al }, deleteSoftLineBackward: { unit: da, direction: Al }, deleteContentForward: { unit: "character", direction: mu }, deleteWordForward: { unit: EC, direction: mu }, deleteHardLineForward: { unit: da, direction: mu }, deleteSoftLineForward: { unit: da, direction: mu } };
      class E$ extends to {
        constructor(t) {
          super(t);
          const i = t.document;
          let a = 0;
          i.on("keydown", () => {
            a++;
          }), i.on("keyup", () => {
            a = 0;
          }), i.on("beforeinput", (l, d) => {
            if (!this.isEnabled)
              return;
            const { targetRanges: g, domEvent: m, inputType: w } = d, A = SC[w];
            if (!A)
              return;
            const C = { direction: A.direction, unit: A.unit, sequence: a };
            C.unit == da && (C.selectionToRemove = t.createSelection(g[0])), p.isAndroid && w === "deleteContentBackward" && (C.sequence = 1, g.length != 1 || g[0].start.parent == g[0].end.parent && g[0].start.offset + 1 == g[0].end.offset || (C.unit = da, C.selectionToRemove = t.createSelection(g)));
            const T = new fl(i, "delete", g[0]);
            i.fire(T, new gl(t, m, C)), T.stop.called && l.stop();
          }), p.isBlink && function(l) {
            const d = l.view, g = d.document;
            let m = null, w = !1;
            function A(T) {
              return T == St.backspace || T == St.delete;
            }
            function C(T) {
              return T == St.backspace ? Al : mu;
            }
            g.on("keydown", (T, { keyCode: R }) => {
              m = R, w = !1;
            }), g.on("keyup", (T, { keyCode: R, domEvent: j }) => {
              const F = g.selection, V = l.isEnabled && R == m && A(R) && !F.isCollapsed && !w;
              if (m = null, V) {
                const W = F.getFirstRange(), ee = new fl(g, "delete", W), le = { unit: da, direction: C(R), selectionToRemove: F };
                g.fire(ee, new gl(d, j, le));
              }
            }), g.on("beforeinput", (T, { inputType: R }) => {
              const j = SC[R];
              A(m) && j && j.direction == C(m) && (w = !0);
            }, { priority: "high" }), g.on("beforeinput", (T, { inputType: R, data: j }) => {
              m == St.delete && R == "insertText" && j == "\x7F" && T.stop();
            }, { priority: "high" });
          }(this);
        }
        observe() {
        }
      }
      class ha extends Ie {
        static get pluginName() {
          return "Delete";
        }
        init() {
          const t = this.editor, i = t.editing.view, a = i.document, l = t.model.document;
          i.addObserver(E$), this._undoOnBackspace = !1;
          const d = new xC(t, "forward");
          t.commands.add("deleteForward", d), t.commands.add("forwardDelete", d), t.commands.add("delete", new xC(t, "backward")), this.listenTo(a, "delete", (g, m) => {
            a.isComposing || m.preventDefault();
            const { direction: w, sequence: A, selectionToRemove: C, unit: T } = m, R = w === "forward" ? "deleteForward" : "delete", j = { sequence: A };
            if (T == "selection") {
              const F = Array.from(C.getRanges()).map((V) => t.editing.mapper.toModelRange(V));
              j.selection = t.model.createSelection(F);
            } else
              j.unit = T;
            t.execute(R, j), i.scrollToTheSelection();
          }, { priority: "low" }), this.editor.plugins.has("UndoEditing") && (this.listenTo(a, "delete", (g, m) => {
            this._undoOnBackspace && m.direction == "backward" && m.sequence == 1 && m.unit == "codePoint" && (this._undoOnBackspace = !1, t.execute("undo"), m.preventDefault(), g.stop());
          }, { context: "$capture" }), this.listenTo(l, "change", () => {
            this._undoOnBackspace = !1;
          }));
        }
        requestUndoOnBackspace() {
          this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
        }
      }
      class S$ extends Ie {
        static get requires() {
          return [AC, ha];
        }
        static get pluginName() {
          return "Typing";
        }
      }
      function MC(c, t) {
        let i = c.start;
        return { text: Array.from(c.getItems()).reduce((a, l) => l.is("$text") || l.is("$textProxy") ? a + l.data : (i = t.createPositionAfter(l), ""), ""), range: t.createRange(i, c.end) };
      }
      class TC extends Te() {
        constructor(t, i) {
          super(), this.model = t, this.testCallback = i, this._hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", () => {
            this.isEnabled ? this._startListening() : (this.stopListening(t.document.selection), this.stopListening(t.document));
          }), this._startListening();
        }
        get hasMatch() {
          return this._hasMatch;
        }
        _startListening() {
          const t = this.model.document;
          this.listenTo(t.selection, "change:range", (i, { directChange: a }) => {
            a && (t.selection.isCollapsed ? this._evaluateTextBeforeSelection("selection") : this.hasMatch && (this.fire("unmatched"), this._hasMatch = !1));
          }), this.listenTo(t, "change:data", (i, a) => {
            !a.isUndo && a.isLocal && this._evaluateTextBeforeSelection("data", { batch: a });
          });
        }
        _evaluateTextBeforeSelection(t, i = {}) {
          const a = this.model, l = a.document.selection, d = a.createRange(a.createPositionAt(l.focus.parent, 0), l.focus), { text: g, range: m } = MC(d, a), w = this.testCallback(g);
          if (!w && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!w, w) {
            const A = Object.assign(i, { text: g, range: m });
            typeof w == "object" && Object.assign(A, w), this.fire(`matched:${t}`, A);
          }
        }
      }
      class DC extends Ie {
        static get pluginName() {
          return "TwoStepCaretMovement";
        }
        constructor(t) {
          super(t), this.attributes = /* @__PURE__ */ new Set(), this._overrideUid = null;
        }
        init() {
          const t = this.editor, i = t.model, a = t.editing.view, l = t.locale, d = i.document.selection;
          this.listenTo(a.document, "arrowKey", (g, m) => {
            if (!d.isCollapsed || m.shiftKey || m.altKey || m.ctrlKey)
              return;
            const w = m.keyCode == St.arrowright, A = m.keyCode == St.arrowleft;
            if (!w && !A)
              return;
            const C = l.contentLanguageDirection;
            let T = !1;
            T = C === "ltr" && w || C === "rtl" && A ? this._handleForwardMovement(m) : this._handleBackwardMovement(m), T === !0 && g.stop();
          }, { context: "$text", priority: "highest" }), this._isNextGravityRestorationSkipped = !1, this.listenTo(d, "change:range", (g, m) => {
            this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = !1 : this._isGravityOverridden && (!m.directChange && Nh(d.getFirstPosition(), this.attributes) || this._restoreGravity());
          });
        }
        registerAttribute(t) {
          this.attributes.add(t);
        }
        _handleForwardMovement(t) {
          const i = this.attributes, a = this.editor.model.document.selection, l = a.getFirstPosition();
          return !this._isGravityOverridden && (!l.isAtStart || !M0(a, i)) && !!Nh(l, i) && (Rh(t), this._overrideGravity(), !0);
        }
        _handleBackwardMovement(t) {
          const i = this.attributes, a = this.editor.model, l = a.document.selection, d = l.getFirstPosition();
          return this._isGravityOverridden ? (Rh(t), this._restoreGravity(), T0(a, i, d), !0) : d.isAtStart ? !!M0(l, i) && (Rh(t), T0(a, i, d), !0) : !!function(g, m) {
            const w = g.getShiftedBy(-1);
            return Nh(w, m);
          }(d, i) && (d.isAtEnd && !M0(l, i) && Nh(d, i) ? (Rh(t), T0(a, i, d), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1));
        }
        get _isGravityOverridden() {
          return !!this._overrideUid;
        }
        _overrideGravity() {
          this._overrideUid = this.editor.model.change((t) => t.overrideSelectionGravity());
        }
        _restoreGravity() {
          this.editor.model.change((t) => {
            t.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
          });
        }
      }
      function M0(c, t) {
        for (const i of t)
          if (c.hasAttribute(i))
            return !0;
        return !1;
      }
      function T0(c, t, i) {
        const a = i.nodeBefore;
        c.change((l) => {
          a ? l.setSelectionAttribute(a.getAttributes()) : l.removeSelectionAttribute(t);
        });
      }
      function Rh(c) {
        c.preventDefault();
      }
      function Nh(c, t) {
        const { nodeBefore: i, nodeAfter: a } = c;
        for (const l of t) {
          const d = i ? i.getAttribute(l) : void 0;
          if ((a ? a.getAttribute(l) : void 0) !== d)
            return !0;
        }
        return !1;
      }
      var IC = /[\\^$.*+?()[\]{}|]/g, M$ = RegExp(IC.source);
      const T$ = function(c) {
        return (c = Nm(c)) && M$.test(c) ? c.replace(IC, "\\$&") : c;
      }, PC = { copyright: { from: "(c)", to: "\xA9" }, registeredTrademark: { from: "(r)", to: "\xAE" }, trademark: { from: "(tm)", to: "\u2122" }, oneHalf: { from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i, to: [null, "\xBD", null] }, oneThird: { from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i, to: [null, "\u2153", null] }, twoThirds: { from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i, to: [null, "\u2154", null] }, oneForth: { from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i, to: [null, "\xBC", null] }, threeQuarters: { from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i, to: [null, "\xBE", null] }, lessThanOrEqual: { from: "<=", to: "\u2264" }, greaterThanOrEqual: { from: ">=", to: "\u2265" }, notEqual: { from: "!=", to: "\u2260" }, arrowLeft: { from: "<-", to: "\u2190" }, arrowRight: { from: "->", to: "\u2192" }, horizontalEllipsis: { from: "...", to: "\u2026" }, enDash: { from: /(^| )(--)( )$/, to: [null, "\u2013", null] }, emDash: { from: /(^| )(---)( )$/, to: [null, "\u2014", null] }, quotesPrimary: { from: Cl('"'), to: [null, "\u201C", null, "\u201D"] }, quotesSecondary: { from: Cl("'"), to: [null, "\u2018", null, "\u2019"] }, quotesPrimaryEnGb: { from: Cl("'"), to: [null, "\u2018", null, "\u2019"] }, quotesSecondaryEnGb: { from: Cl('"'), to: [null, "\u201C", null, "\u201D"] }, quotesPrimaryPl: { from: Cl('"'), to: [null, "\u201E", null, "\u201D"] }, quotesSecondaryPl: { from: Cl("'"), to: [null, "\u201A", null, "\u2019"] } }, OC = { symbols: ["copyright", "registeredTrademark", "trademark"], mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"], typography: ["horizontalEllipsis", "enDash", "emDash"], quotes: ["quotesPrimary", "quotesSecondary"] }, D$ = ["symbols", "mathematical", "typography", "quotes"];
      function I$(c) {
        return typeof c == "string" ? new RegExp(`(${T$(c)})$`) : c;
      }
      function P$(c) {
        return typeof c == "string" ? () => [c] : c instanceof Array ? () => c : c;
      }
      function O$(c) {
        return (c.textNode ? c.textNode : c.nodeAfter).getAttributes();
      }
      function Cl(c) {
        return new RegExp(`(^|\\s)(${c})([^${c}]*)(${c})$`);
      }
      function xl(c, t, i, a) {
        return a.createRange(RC(c, t, i, !0, a), RC(c, t, i, !1, a));
      }
      function RC(c, t, i, a, l) {
        let d = c.textNode || (a ? c.nodeBefore : c.nodeAfter), g = null;
        for (; d && d.getAttribute(t) == i; )
          g = d, d = a ? d.previousSibling : d.nextSibling;
        return g ? l.createPositionAt(g, a ? "before" : "after") : c;
      }
      function* NC(c, t) {
        for (const i of t)
          i && c.getAttributeProperties(i[0]).copyOnEnter && (yield i);
      }
      class R$ extends kt {
        execute() {
          this.editor.model.change((t) => {
            this.enterBlock(t), this.fire("afterExecute", { writer: t });
          });
        }
        enterBlock(t) {
          const i = this.editor.model, a = i.document.selection, l = i.schema, d = a.isCollapsed, g = a.getFirstRange(), m = g.start.parent, w = g.end.parent;
          if (l.isLimit(m) || l.isLimit(w))
            return d || m != w || i.deleteContent(a), !1;
          if (d) {
            const A = NC(t.model.schema, a.getAttributes());
            return $C(t, g.start), t.setSelectionAttribute(A), !0;
          }
          {
            const A = !(g.start.isAtStart && g.end.isAtEnd), C = m == w;
            if (i.deleteContent(a, { leaveUnmerged: A }), A) {
              if (C)
                return $C(t, a.focus), !0;
              t.setSelection(w, 0);
            }
          }
          return !1;
        }
      }
      function $C(c, t) {
        c.split(t), c.setSelection(t.parent.nextSibling, 0);
      }
      const N$ = { insertParagraph: { isSoft: !1 }, insertLineBreak: { isSoft: !0 } };
      class LC extends to {
        constructor(t) {
          super(t);
          const i = this.document;
          i.on("beforeinput", (a, l) => {
            if (!this.isEnabled)
              return;
            const d = l.domEvent, g = N$[l.inputType];
            if (!g)
              return;
            const m = new fl(i, "enter", l.targetRanges[0]);
            i.fire(m, new gl(t, d, { isSoft: g.isSoft })), m.stop.called && a.stop();
          });
        }
        observe() {
        }
      }
      class $h extends Ie {
        static get pluginName() {
          return "Enter";
        }
        init() {
          const t = this.editor, i = t.editing.view, a = i.document;
          i.addObserver(LC), t.commands.add("enter", new R$(t)), this.listenTo(a, "enter", (l, d) => {
            a.isComposing || d.preventDefault(), d.isSoft || (t.execute("enter"), i.scrollToTheSelection());
          }, { priority: "low" });
        }
      }
      class $$ extends kt {
        execute() {
          const t = this.editor.model, i = t.document;
          t.change((a) => {
            (function(l, d, g) {
              const m = g.isCollapsed, w = g.getFirstRange(), A = w.start.parent, C = w.end.parent, T = A == C;
              if (m) {
                const R = NC(l.schema, g.getAttributes());
                jC(l, d, w.end), d.removeSelectionAttribute(g.getAttributeKeys()), d.setSelectionAttribute(R);
              } else {
                const R = !(w.start.isAtStart && w.end.isAtEnd);
                l.deleteContent(g, { leaveUnmerged: R }), T ? jC(l, d, g.focus) : R && d.setSelection(C, 0);
              }
            })(t, a, i.selection), this.fire("afterExecute", { writer: a });
          });
        }
        refresh() {
          const t = this.editor.model, i = t.document;
          this.isEnabled = function(a, l) {
            if (l.rangeCount > 1)
              return !1;
            const d = l.anchor;
            if (!d || !a.checkChild(d, "softBreak"))
              return !1;
            const g = l.getFirstRange(), m = g.start.parent, w = g.end.parent;
            return !((D0(m, a) || D0(w, a)) && m !== w);
          }(t.schema, i.selection);
        }
      }
      function jC(c, t, i) {
        const a = t.createElement("softBreak");
        c.insertContent(a, i), t.setSelection(a, "after");
      }
      function D0(c, t) {
        return !c.is("rootElement") && (t.isLimit(c) || D0(c.parent, t));
      }
      class L$ extends Ie {
        static get pluginName() {
          return "ShiftEnter";
        }
        init() {
          const t = this.editor, i = t.model.schema, a = t.conversion, l = t.editing.view, d = l.document;
          i.register("softBreak", { allowWhere: "$text", isInline: !0 }), a.for("upcast").elementToElement({ model: "softBreak", view: "br" }), a.for("downcast").elementToElement({ model: "softBreak", view: (g, { writer: m }) => m.createEmptyElement("br") }), l.addObserver(LC), t.commands.add("shiftEnter", new $$(t)), this.listenTo(d, "enter", (g, m) => {
            d.isComposing || m.preventDefault(), m.isSoft && (t.execute("shiftEnter"), l.scrollToTheSelection());
          }, { priority: "low" });
        }
      }
      class j$ extends ie() {
        constructor() {
          super(), this._stack = [];
        }
        add(t, i) {
          const a = this._stack, l = a[0];
          this._insertDescriptor(t);
          const d = a[0];
          l === d || I0(l, d) || this.fire("change:top", { oldDescriptor: l, newDescriptor: d, writer: i });
        }
        remove(t, i) {
          const a = this._stack, l = a[0];
          this._removeDescriptor(t);
          const d = a[0];
          l === d || I0(l, d) || this.fire("change:top", { oldDescriptor: l, newDescriptor: d, writer: i });
        }
        _insertDescriptor(t) {
          const i = this._stack, a = i.findIndex((d) => d.id === t.id);
          if (I0(t, i[a]))
            return;
          a > -1 && i.splice(a, 1);
          let l = 0;
          for (; i[l] && B$(i[l], t); )
            l++;
          i.splice(l, 0, t);
        }
        _removeDescriptor(t) {
          const i = this._stack, a = i.findIndex((l) => l.id === t);
          a > -1 && i.splice(a, 1);
        }
      }
      function I0(c, t) {
        return c && t && c.priority == t.priority && Lh(c.classes) == Lh(t.classes);
      }
      function B$(c, t) {
        return c.priority > t.priority || !(c.priority < t.priority) && Lh(c.classes) > Lh(t.classes);
      }
      function Lh(c) {
        return Array.isArray(c) ? c.sort().join(",") : c;
      }
      const F$ = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>', BC = "ck-widget_selected";
      function xn(c) {
        return !!c.is("element") && !!c.getCustomProperty("widget");
      }
      function P0(c, t, i = {}) {
        if (!c.is("containerElement"))
          throw new S("widget-to-widget-wrong-element-type", null, { element: c });
        return t.setAttribute("contenteditable", "false", c), t.addClass("ck-widget", c), t.setCustomProperty("widget", !0, c), c.getFillerOffset = H$, t.setCustomProperty("widgetLabel", [], c), i.label && function(a, l) {
          a.getCustomProperty("widgetLabel").push(l);
        }(c, i.label), i.hasSelectionHandle && function(a, l) {
          const d = l.createUIElement("div", { class: "ck ck-widget__selection-handle" }, function(g) {
            const m = this.toDomElement(g), w = new cs();
            return w.set("content", F$), w.render(), m.appendChild(w.element), m;
          });
          l.insert(l.createPositionAt(a, 0), d), l.addClass(["ck-widget_with-selection-handle"], a);
        }(c, t), FC(c, t), c;
      }
      function z$(c, t, i) {
        if (t.classes && i.addClass(Yn(t.classes), c), t.attributes)
          for (const a in t.attributes)
            i.setAttribute(a, t.attributes[a], c);
      }
      function V$(c, t, i) {
        if (t.classes && i.removeClass(Yn(t.classes), c), t.attributes)
          for (const a in t.attributes)
            i.removeAttribute(a, c);
      }
      function FC(c, t, i = z$, a = V$) {
        const l = new j$();
        l.on("change:top", (d, g) => {
          g.oldDescriptor && a(c, g.oldDescriptor, g.writer), g.newDescriptor && i(c, g.newDescriptor, g.writer);
        }), t.setCustomProperty("addHighlight", (d, g, m) => l.add(g, m), c), t.setCustomProperty("removeHighlight", (d, g, m) => l.remove(g, m), c);
      }
      function zC(c, t, i = {}) {
        return t.addClass(["ck-editor__editable", "ck-editor__nested-editable"], c), t.setAttribute("role", "textbox", c), i.label && t.setAttribute("aria-label", i.label, c), t.setAttribute("contenteditable", c.isReadOnly ? "false" : "true", c), c.on("change:isReadOnly", (a, l, d) => {
          t.setAttribute("contenteditable", d ? "false" : "true", c);
        }), c.on("change:isFocused", (a, l, d) => {
          d ? t.addClass("ck-editor__nested-editable_focused", c) : t.removeClass("ck-editor__nested-editable_focused", c);
        }), FC(c, t), c;
      }
      function VC(c, t) {
        const i = c.getSelectedElement();
        if (i) {
          const a = fa(c);
          if (a)
            return t.createRange(t.createPositionAt(i, a));
        }
        return CA(c, t);
      }
      function H$() {
        return null;
      }
      const Io = "widget-type-around";
      function us(c, t, i) {
        return !!c && xn(c) && !i.isInline(t);
      }
      function fa(c) {
        return c.getAttribute(Io);
      }
      var HC = s(4921), U$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(HC.Z, U$), HC.Z.locals;
      const UC = ["before", "after"], W$ = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild, WC = "ck-widget__type-around_disabled";
      class G$ extends Ie {
        static get pluginName() {
          return "WidgetTypeAround";
        }
        static get requires() {
          return [$h, ha];
        }
        constructor(t) {
          super(t), this._currentFakeCaretModelElement = null;
        }
        init() {
          const t = this.editor, i = t.editing.view;
          this.on("change:isEnabled", (a, l, d) => {
            i.change((g) => {
              for (const m of i.document.roots)
                d ? g.removeClass(WC, m) : g.addClass(WC, m);
            }), d || t.model.change((g) => {
              g.removeSelectionAttribute(Io);
            });
          }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
        }
        destroy() {
          super.destroy(), this._currentFakeCaretModelElement = null;
        }
        _insertParagraph(t, i) {
          const a = this.editor, l = a.editing.view, d = a.model.schema.getAttributesWithProperty(t, "copyOnReplace", !0);
          a.execute("insertParagraph", { position: a.model.createPositionAt(t, i), attributes: d }), l.focus(), l.scrollToTheSelection();
        }
        _listenToIfEnabled(t, i, a, l) {
          this.listenTo(t, i, (...d) => {
            this.isEnabled && a(...d);
          }, l);
        }
        _insertParagraphAccordingToFakeCaretPosition() {
          const t = this.editor.model.document.selection, i = fa(t);
          if (!i)
            return !1;
          const a = t.getSelectedElement();
          return this._insertParagraph(a, i), !0;
        }
        _enableTypeAroundUIInjection() {
          const t = this.editor, i = t.model.schema, a = t.locale.t, l = { before: a("Insert paragraph before block"), after: a("Insert paragraph after block") };
          t.editing.downcastDispatcher.on("insert", (d, g, m) => {
            const w = m.mapper.toViewElement(g.item);
            w && us(w, g.item, i) && (function(A, C, T) {
              const R = A.createUIElement("div", { class: "ck ck-reset_all ck-widget__type-around" }, function(j) {
                const F = this.toDomElement(j);
                return function(V, W) {
                  for (const ee of UC) {
                    const le = new Ci({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__button", `ck-widget__type-around__button_${ee}`], title: W[ee], "aria-hidden": "true" }, children: [V.ownerDocument.importNode(W$, !0)] });
                    V.appendChild(le.render());
                  }
                }(F, C), function(V) {
                  const W = new Ci({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__fake-caret"] } });
                  V.appendChild(W.render());
                }(F), F;
              });
              A.insert(A.createPositionAt(T, "end"), R);
            }(m.writer, l, w), w.getCustomProperty("widgetLabel").push(() => this.isEnabled ? a("Press Enter to type after or press Shift + Enter to type before the widget") : ""));
          }, { priority: "low" });
        }
        _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          const t = this.editor, i = t.model, a = i.document.selection, l = i.schema, d = t.editing.view;
          function g(m) {
            return `ck-widget_type-around_show-fake-caret_${m}`;
          }
          this._listenToIfEnabled(d.document, "arrowKey", (m, w) => {
            this._handleArrowKeyPress(m, w);
          }, { context: [xn, "$text"], priority: "high" }), this._listenToIfEnabled(a, "change:range", (m, w) => {
            w.directChange && t.model.change((A) => {
              A.removeSelectionAttribute(Io);
            });
          }), this._listenToIfEnabled(i.document, "change:data", () => {
            const m = a.getSelectedElement();
            m && us(t.editing.mapper.toViewElement(m), m, l) || t.model.change((w) => {
              w.removeSelectionAttribute(Io);
            });
          }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", (m, w, A) => {
            const C = A.writer;
            if (this._currentFakeCaretModelElement) {
              const F = A.mapper.toViewElement(this._currentFakeCaretModelElement);
              F && (C.removeClass(UC.map(g), F), this._currentFakeCaretModelElement = null);
            }
            const T = w.selection.getSelectedElement();
            if (!T)
              return;
            const R = A.mapper.toViewElement(T);
            if (!us(R, T, l))
              return;
            const j = fa(w.selection);
            j && (C.addClass(g(j), R), this._currentFakeCaretModelElement = T);
          }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", (m, w, A) => {
            A || t.model.change((C) => {
              C.removeSelectionAttribute(Io);
            });
          });
        }
        _handleArrowKeyPress(t, i) {
          const a = this.editor, l = a.model, d = l.document.selection, g = l.schema, m = a.editing.view, w = function(T, R) {
            const j = Im(T, R);
            return j === "down" || j === "right";
          }(i.keyCode, a.locale.contentLanguageDirection), A = m.document.selection.getSelectedElement();
          let C;
          us(A, a.editing.mapper.toModelElement(A), g) ? C = this._handleArrowKeyPressOnSelectedWidget(w) : d.isCollapsed ? C = this._handleArrowKeyPressWhenSelectionNextToAWidget(w) : i.shiftKey || (C = this._handleArrowKeyPressWhenNonCollapsedSelection(w)), C && (i.preventDefault(), t.stop());
        }
        _handleArrowKeyPressOnSelectedWidget(t) {
          const i = this.editor.model, a = fa(i.document.selection);
          return i.change((l) => a ? a !== (t ? "after" : "before") ? (l.removeSelectionAttribute(Io), !0) : !1 : (l.setSelectionAttribute(Io, t ? "after" : "before"), !0));
        }
        _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
          const i = this.editor, a = i.model, l = a.schema, d = i.plugins.get("Widget"), g = d._getObjectElementNextToSelection(t);
          return !!us(i.editing.mapper.toViewElement(g), g, l) && (a.change((m) => {
            d._setSelectionOverElement(g), m.setSelectionAttribute(Io, t ? "before" : "after");
          }), !0);
        }
        _handleArrowKeyPressWhenNonCollapsedSelection(t) {
          const i = this.editor, a = i.model, l = a.schema, d = i.editing.mapper, g = a.document.selection, m = t ? g.getLastPosition().nodeBefore : g.getFirstPosition().nodeAfter;
          return !!us(d.toViewElement(m), m, l) && (a.change((w) => {
            w.setSelection(m, "on"), w.setSelectionAttribute(Io, t ? "after" : "before");
          }), !0);
        }
        _enableInsertingParagraphsOnButtonClick() {
          const t = this.editor, i = t.editing.view;
          this._listenToIfEnabled(i.document, "mousedown", (a, l) => {
            const d = l.domTarget.closest(".ck-widget__type-around__button");
            if (!d)
              return;
            const g = function(A) {
              return A.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }(d), m = function(A, C) {
              const T = A.closest(".ck-widget");
              return C.mapDomToView(T);
            }(d, i.domConverter), w = t.editing.mapper.toModelElement(m);
            this._insertParagraph(w, g), l.preventDefault(), a.stop();
          });
        }
        _enableInsertingParagraphsOnEnterKeypress() {
          const t = this.editor, i = t.model.document.selection, a = t.editing.view;
          this._listenToIfEnabled(a.document, "enter", (l, d) => {
            if (l.eventPhase != "atTarget")
              return;
            const g = i.getSelectedElement(), m = t.editing.mapper.toViewElement(g), w = t.model.schema;
            let A;
            this._insertParagraphAccordingToFakeCaretPosition() ? A = !0 : us(m, g, w) && (this._insertParagraph(g, d.isSoft ? "before" : "after"), A = !0), A && (d.preventDefault(), l.stop());
          }, { context: xn });
        }
        _enableInsertingParagraphsOnTypingKeystroke() {
          const t = this.editor.editing.view.document;
          this._listenToIfEnabled(t, "insertText", (i, a) => {
            this._insertParagraphAccordingToFakeCaretPosition() && (a.selection = t.selection);
          }, { priority: "high" }), p.isAndroid ? this._listenToIfEnabled(t, "keydown", (i, a) => {
            a.keyCode == 229 && this._insertParagraphAccordingToFakeCaretPosition();
          }) : this._listenToIfEnabled(t, "compositionstart", () => {
            this._insertParagraphAccordingToFakeCaretPosition();
          }, { priority: "high" });
        }
        _enableDeleteIntegration() {
          const t = this.editor, i = t.editing.view, a = t.model, l = a.schema;
          this._listenToIfEnabled(i.document, "delete", (d, g) => {
            if (d.eventPhase != "atTarget")
              return;
            const m = fa(a.document.selection);
            if (!m)
              return;
            const w = g.direction, A = a.document.selection.getSelectedElement(), C = w == "forward";
            if (m === "before" === C)
              t.execute("delete", { selection: a.createSelection(A, "on") });
            else {
              const T = l.getNearestSelectionRange(a.createPositionAt(A, m), w);
              if (T)
                if (T.isCollapsed) {
                  const R = a.createSelection(T.start);
                  if (a.modifySelection(R, { direction: w }), R.focus.isEqual(T.start)) {
                    const j = function(F, V) {
                      let W = V;
                      for (const ee of V.getAncestors({ parentFirst: !0 })) {
                        if (ee.childCount > 1 || F.isLimit(ee))
                          break;
                        W = ee;
                      }
                      return W;
                    }(l, T.start.parent);
                    a.deleteContent(a.createSelection(j, "on"), { doNotAutoparagraph: !0 });
                  } else
                    a.change((j) => {
                      j.setSelection(T), t.execute(C ? "deleteForward" : "delete");
                    });
                } else
                  a.change((R) => {
                    R.setSelection(T), t.execute(C ? "deleteForward" : "delete");
                  });
            }
            g.preventDefault(), d.stop();
          }, { context: xn });
        }
        _enableInsertContentIntegration() {
          const t = this.editor, i = this.editor.model, a = i.document.selection;
          this._listenToIfEnabled(t.model, "insertContent", (l, [d, g]) => {
            if (g && !g.is("documentSelection"))
              return;
            const m = fa(a);
            return m ? (l.stop(), i.change((w) => {
              const A = a.getSelectedElement(), C = i.createPositionAt(A, m), T = w.createSelection(C), R = i.insertContent(d, T);
              return w.setSelection(T), R;
            })) : void 0;
          }, { priority: "high" });
        }
        _enableInsertObjectIntegration() {
          const t = this.editor, i = this.editor.model.document.selection;
          this._listenToIfEnabled(t.model, "insertObject", (a, l) => {
            const [, d, , g = {}] = l;
            if (d && !d.is("documentSelection"))
              return;
            const m = fa(i);
            m && (g.findOptimalPosition = m, l[3] = g);
          }, { priority: "high" });
        }
        _enableDeleteContentIntegration() {
          const t = this.editor, i = this.editor.model.document.selection;
          this._listenToIfEnabled(t.model, "deleteContent", (a, [l]) => {
            l && !l.is("documentSelection") || fa(i) && a.stop();
          }, { priority: "high" });
        }
      }
      function q$(c) {
        const t = c.model;
        return (i, a) => {
          const l = a.keyCode == St.arrowup, d = a.keyCode == St.arrowdown, g = a.shiftKey, m = t.document.selection;
          if (!l && !d)
            return;
          const w = d;
          if (g && function(C, T) {
            return !C.isCollapsed && C.isBackward == T;
          }(m, w))
            return;
          const A = function(C, T, R) {
            const j = C.model;
            if (R) {
              const F = T.isCollapsed ? T.focus : T.getLastPosition(), V = GC(j, F, "forward");
              if (!V)
                return null;
              const W = j.createRange(F, V), ee = qC(j.schema, W, "backward");
              return ee ? j.createRange(F, ee) : null;
            }
            {
              const F = T.isCollapsed ? T.focus : T.getFirstPosition(), V = GC(j, F, "backward");
              if (!V)
                return null;
              const W = j.createRange(V, F), ee = qC(j.schema, W, "forward");
              return ee ? j.createRange(ee, F) : null;
            }
          }(c, m, w);
          if (A) {
            if (A.isCollapsed && (m.isCollapsed || g))
              return;
            (A.isCollapsed || function(C, T, R) {
              const j = C.model, F = C.view.domConverter;
              if (R) {
                const be = j.createSelection(T.start);
                j.modifySelection(be), be.focus.isAtEnd || T.start.isEqual(be.focus) || (T = j.createRange(be.focus, T.end));
              }
              const V = C.mapper.toViewRange(T), W = F.viewRangeToDom(V), ee = In.getDomRangeRects(W);
              let le;
              for (const be of ee)
                if (le !== void 0) {
                  if (Math.round(be.top) >= le)
                    return !1;
                  le = Math.max(le, Math.round(be.bottom));
                } else
                  le = Math.round(be.bottom);
              return !0;
            }(c, A, w)) && (t.change((C) => {
              const T = w ? A.end : A.start;
              if (g) {
                const R = t.createSelection(m.anchor);
                R.setFocus(T), C.setSelection(R);
              } else
                C.setSelection(T);
            }), i.stop(), a.preventDefault(), a.stopPropagation());
          }
        };
      }
      function GC(c, t, i) {
        const a = c.schema, l = c.createRangeIn(t.root), d = i == "forward" ? "elementStart" : "elementEnd";
        for (const { previousPosition: g, item: m, type: w } of l.getWalker({ startPosition: t, direction: i })) {
          if (a.isLimit(m) && !a.isInline(m))
            return g;
          if (w == d && a.isBlock(m))
            return null;
        }
        return null;
      }
      function qC(c, t, i) {
        const a = i == "backward" ? t.end : t.start;
        if (c.checkChild(a, "$text"))
          return a;
        for (const { nextPosition: l } of t.getWalker({ direction: i }))
          if (c.checkChild(l, "$text"))
            return l;
        return null;
      }
      var KC = s(3488), K$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(KC.Z, K$), KC.Z.locals;
      class vu extends Ie {
        static get pluginName() {
          return "Widget";
        }
        static get requires() {
          return [G$, ha];
        }
        init() {
          const t = this.editor, i = t.editing.view, a = i.document;
          this._previouslySelected = /* @__PURE__ */ new Set(), this.editor.editing.downcastDispatcher.on("selection", (l, d, g) => {
            const m = g.writer, w = d.selection;
            if (w.isCollapsed)
              return;
            const A = w.getSelectedElement();
            if (!A)
              return;
            const C = t.editing.mapper.toViewElement(A);
            var T;
            xn(C) && g.consumable.consume(w, "selection") && m.setSelection(m.createRangeOn(C), { fake: !0, label: (T = C, T.getCustomProperty("widgetLabel").reduce((R, j) => typeof j == "function" ? R ? R + ". " + j() : j() : R ? R + ". " + j : j, "")) });
          }), this.editor.editing.downcastDispatcher.on("selection", (l, d, g) => {
            this._clearPreviouslySelectedWidgets(g.writer);
            const m = g.writer, w = m.document.selection;
            let A = null;
            for (const C of w.getRanges())
              for (const T of C) {
                const R = T.item;
                xn(R) && !Y$(R, A) && (m.addClass(BC, R), this._previouslySelected.add(R), A = R);
              }
          }, { priority: "low" }), i.addObserver(u0), this.listenTo(a, "mousedown", (...l) => this._onMousedown(...l)), this.listenTo(a, "arrowKey", (...l) => {
            this._handleSelectionChangeOnArrowKeyPress(...l);
          }, { context: [xn, "$text"] }), this.listenTo(a, "arrowKey", (...l) => {
            this._preventDefaultOnArrowKeyPress(...l);
          }, { context: "$root" }), this.listenTo(a, "arrowKey", q$(this.editor.editing), { context: "$text" }), this.listenTo(a, "delete", (l, d) => {
            this._handleDelete(d.direction == "forward") && (d.preventDefault(), l.stop());
          }, { context: "$root" });
        }
        _onMousedown(t, i) {
          const a = this.editor, l = a.editing.view, d = l.document;
          let g = i.target;
          if (function(w) {
            let A = w;
            for (; A; ) {
              if (A.is("editableElement") && !A.is("rootElement"))
                return !0;
              if (xn(A))
                return !1;
              A = A.parent;
            }
            return !1;
          }(g)) {
            if ((p.isSafari || p.isGecko) && i.domEvent.detail >= 3) {
              const w = a.editing.mapper, A = g.is("attributeElement") ? g.findAncestor((T) => !T.is("attributeElement")) : g, C = w.toModelElement(A);
              i.preventDefault(), this.editor.model.change((T) => {
                T.setSelection(C, "in");
              });
            }
            return;
          }
          if (!xn(g) && (g = g.findAncestor(xn), !g))
            return;
          p.isAndroid && i.preventDefault(), d.isFocused || l.focus();
          const m = a.editing.mapper.toModelElement(g);
          this._setSelectionOverElement(m);
        }
        _handleSelectionChangeOnArrowKeyPress(t, i) {
          const a = i.keyCode, l = this.editor.model, d = l.schema, g = l.document.selection, m = g.getSelectedElement(), w = Im(a, this.editor.locale.contentLanguageDirection), A = w == "down" || w == "right", C = w == "up" || w == "down";
          if (m && d.isObject(m)) {
            const R = A ? g.getLastPosition() : g.getFirstPosition(), j = d.getNearestSelectionRange(R, A ? "forward" : "backward");
            return void (j && (l.change((F) => {
              F.setSelection(j);
            }), i.preventDefault(), t.stop()));
          }
          if (!g.isCollapsed && !i.shiftKey) {
            const R = g.getFirstPosition(), j = g.getLastPosition(), F = R.nodeAfter, V = j.nodeBefore;
            return void ((F && d.isObject(F) || V && d.isObject(V)) && (l.change((W) => {
              W.setSelection(A ? j : R);
            }), i.preventDefault(), t.stop()));
          }
          if (!g.isCollapsed)
            return;
          const T = this._getObjectElementNextToSelection(A);
          if (T && d.isObject(T)) {
            if (d.isInline(T) && C)
              return;
            this._setSelectionOverElement(T), i.preventDefault(), t.stop();
          }
        }
        _preventDefaultOnArrowKeyPress(t, i) {
          const a = this.editor.model, l = a.schema, d = a.document.selection.getSelectedElement();
          d && l.isObject(d) && (i.preventDefault(), t.stop());
        }
        _handleDelete(t) {
          if (this.editor.isReadOnly)
            return;
          const i = this.editor.model.document.selection;
          if (!i.isCollapsed)
            return;
          const a = this._getObjectElementNextToSelection(t);
          return a ? (this.editor.model.change((l) => {
            let d = i.anchor.parent;
            for (; d.isEmpty; ) {
              const g = d;
              d = g.parent, l.remove(g);
            }
            this._setSelectionOverElement(a);
          }), !0) : void 0;
        }
        _setSelectionOverElement(t) {
          this.editor.model.change((i) => {
            i.setSelection(i.createRangeOn(t));
          });
        }
        _getObjectElementNextToSelection(t) {
          const i = this.editor.model, a = i.schema, l = i.document.selection, d = i.createSelection(l);
          if (i.modifySelection(d, { direction: t ? "forward" : "backward" }), d.isEqual(l))
            return null;
          const g = t ? d.focus.nodeBefore : d.focus.nodeAfter;
          return g && a.isObject(g) ? g : null;
        }
        _clearPreviouslySelectedWidgets(t) {
          for (const i of this._previouslySelected)
            t.removeClass(BC, i);
          this._previouslySelected.clear();
        }
      }
      function Y$(c, t) {
        return !!t && Array.from(c.getAncestors()).includes(t);
      }
      class jh extends Ie {
        static get requires() {
          return [Ph];
        }
        static get pluginName() {
          return "WidgetToolbarRepository";
        }
        init() {
          const t = this.editor;
          if (t.plugins.has("BalloonToolbar")) {
            const i = t.plugins.get("BalloonToolbar");
            this.listenTo(i, "show", (a) => {
              (function(l) {
                const d = l.getSelectedElement();
                return !(!d || !xn(d));
              })(t.editing.view.document.selection) && a.stop();
            }, { priority: "high" });
          }
          this._toolbarDefinitions = /* @__PURE__ */ new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", () => {
            this._updateToolbarsVisibility();
          }), this.listenTo(t.ui, "update", () => {
            this._updateToolbarsVisibility();
          }), this.listenTo(t.ui.focusTracker, "change:isFocused", () => {
            this._updateToolbarsVisibility();
          }, { priority: "low" });
        }
        destroy() {
          super.destroy();
          for (const t of this._toolbarDefinitions.values())
            t.view.destroy();
        }
        register(t, { ariaLabel: i, items: a, getRelatedElement: l, balloonClassName: d = "ck-toolbar-container" }) {
          if (!a.length)
            return void $("widget-toolbar-no-items", { toolbarId: t });
          const g = this.editor, m = g.t, w = new _0(g.locale);
          if (w.ariaLabel = i || m("Widget toolbar"), this._toolbarDefinitions.has(t))
            throw new S("widget-toolbar-duplicated", this, { toolbarId: t });
          w.fillFromConfig(a, g.ui.componentFactory);
          const A = { view: w, getRelatedElement: l, balloonClassName: d };
          g.ui.addToolbar(w, { isContextual: !0, beforeFocus: () => {
            const C = l(g.editing.view.document.selection);
            C && this._showToolbar(A, C);
          }, afterBlur: () => {
            this._hideToolbar(A);
          } }), this._toolbarDefinitions.set(t, A);
        }
        _updateToolbarsVisibility() {
          let t = 0, i = null, a = null;
          for (const l of this._toolbarDefinitions.values()) {
            const d = l.getRelatedElement(this.editor.editing.view.document.selection);
            if (this.isEnabled && d)
              if (this.editor.ui.focusTracker.isFocused) {
                const g = d.getAncestors().length;
                g > t && (t = g, i = d, a = l);
              } else
                this._isToolbarVisible(l) && this._hideToolbar(l);
            else
              this._isToolbarInBalloon(l) && this._hideToolbar(l);
          }
          a && this._showToolbar(a, i);
        }
        _hideToolbar(t) {
          this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
        }
        _showToolbar(t, i) {
          this._isToolbarVisible(t) ? YC(this.editor, i) : this._isToolbarInBalloon(t) || (this._balloon.add({ view: t.view, position: QC(this.editor, i), balloonClassName: t.balloonClassName }), this.listenTo(this._balloon, "change:visibleView", () => {
            for (const a of this._toolbarDefinitions.values())
              if (this._isToolbarVisible(a)) {
                const l = a.getRelatedElement(this.editor.editing.view.document.selection);
                YC(this.editor, l);
              }
          }));
        }
        _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
        _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }
      function YC(c, t) {
        const i = c.plugins.get("ContextualBalloon"), a = QC(c, t);
        i.updatePosition(a);
      }
      function QC(c, t) {
        const i = c.editing.view, a = vr.defaultPositions;
        return { target: i.domConverter.mapViewToDom(t), positions: [a.northArrowSouth, a.northArrowSouthWest, a.northArrowSouthEast, a.southArrowNorth, a.southArrowNorthWest, a.southArrowNorthEast, a.viewportStickyNorth] };
      }
      var ZC = s(8506), Q$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(ZC.Z, Q$), ZC.Z.locals;
      const Z$ = function(c, t, i) {
        var a = !0, l = !0;
        if (typeof c != "function")
          throw new TypeError("Expected a function");
        return me(i) && (a = "leading" in i ? !!i.leading : a, l = "trailing" in i ? !!i.trailing : l), iu(c, t, { leading: a, maxWait: t, trailing: l });
      };
      var XC = s(903), X$ = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(XC.Z, X$), XC.Z.locals;
      class J$ extends Ie {
        static get pluginName() {
          return "DragDrop";
        }
        static get requires() {
          return [io, vu];
        }
        init() {
          const t = this.editor, i = t.editing.view;
          this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, this._updateDropMarkerThrottled = Z$((a) => this._updateDropMarker(a), 40), this._removeDropMarkerDelayed = t2(() => this._removeDropMarker(), 40), this._clearDraggableAttributesDelayed = t2(() => this._clearDraggableAttributes(), 40), i.addObserver(S0), i.addObserver(u0), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDropMarker(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", (a, l, d) => {
            d ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
          }), this.on("change:isEnabled", (a, l, d) => {
            d || this._finalizeDragging(!1);
          }), p.isAndroid && this.forceDisabled("noAndroidSupport");
        }
        destroy() {
          return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._updateDropMarkerThrottled.cancel(), this._removeDropMarkerDelayed.cancel(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
        }
        _setupDragging() {
          const t = this.editor, i = t.model, a = i.document, l = t.editing.view, d = l.document;
          this.listenTo(d, "dragstart", (g, m) => {
            const w = a.selection;
            if (m.target && m.target.is("editableElement"))
              return void m.preventDefault();
            const A = m.target ? n2(m.target) : null;
            if (A) {
              const R = t.editing.mapper.toModelElement(A);
              this._draggedRange = _i.fromRange(i.createRangeOn(R)), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
            } else if (!d.selection.isCollapsed) {
              const R = d.selection.getSelectedElement();
              R && xn(R) || (this._draggedRange = _i.fromRange(w.getFirstRange()));
            }
            if (!this._draggedRange)
              return void m.preventDefault();
            this._draggingUid = N(), m.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", m.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
            const C = i.createSelection(this._draggedRange.toRange()), T = t.data.toView(i.getSelectedContent(C));
            d.fire("clipboardOutput", { dataTransfer: m.dataTransfer, content: T, method: "dragstart" }), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
          }, { priority: "low" }), this.listenTo(d, "dragend", (g, m) => {
            this._finalizeDragging(!m.dataTransfer.isCanceled && m.dataTransfer.dropEffect == "move");
          }, { priority: "low" }), this.listenTo(d, "dragenter", () => {
            this.isEnabled && l.focus();
          }), this.listenTo(d, "dragleave", () => {
            this._removeDropMarkerDelayed();
          }), this.listenTo(d, "dragging", (g, m) => {
            if (!this.isEnabled)
              return void (m.dataTransfer.dropEffect = "none");
            this._removeDropMarkerDelayed.cancel();
            const w = JC(t, m.targetRanges, m.target);
            this._draggedRange || (m.dataTransfer.dropEffect = "copy"), p.isGecko || (m.dataTransfer.effectAllowed == "copy" ? m.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(m.dataTransfer.effectAllowed) && (m.dataTransfer.dropEffect = "move")), w && this._updateDropMarkerThrottled(w);
          }, { priority: "low" });
        }
        _setupClipboardInputIntegration() {
          const t = this.editor, i = t.editing.view.document;
          this.listenTo(i, "clipboardInput", (a, l) => {
            if (l.method != "drop")
              return;
            const d = JC(t, l.targetRanges, l.target);
            if (this._removeDropMarker(), !d)
              return this._finalizeDragging(!1), void a.stop();
            if (this._draggedRange && this._draggingUid != l.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = ""), e2(l.dataTransfer) == "move" && this._draggedRange && this._draggedRange.containsRange(d, !0))
              return this._finalizeDragging(!1), void a.stop();
            l.targetRanges = [t.editing.mapper.toViewRange(d)];
          }, { priority: "high" });
        }
        _setupContentInsertionIntegration() {
          const t = this.editor.plugins.get(io);
          t.on("contentInsertion", (i, a) => {
            if (!this.isEnabled || a.method !== "drop")
              return;
            const l = a.targetRanges.map((d) => this.editor.editing.mapper.toModelRange(d));
            this.editor.model.change((d) => d.setSelection(l));
          }, { priority: "high" }), t.on("contentInsertion", (i, a) => {
            if (!this.isEnabled || a.method !== "drop")
              return;
            const l = e2(a.dataTransfer) == "move", d = !a.resultRange || !a.resultRange.isCollapsed;
            this._finalizeDragging(d && l);
          }, { priority: "lowest" });
        }
        _setupDraggableAttributeHandling() {
          const t = this.editor, i = t.editing.view, a = i.document;
          this.listenTo(a, "mousedown", (l, d) => {
            if (p.isAndroid || !d)
              return;
            this._clearDraggableAttributesDelayed.cancel();
            let g = n2(d.target);
            if (p.isBlink && !t.isReadOnly && !g && !a.selection.isCollapsed) {
              const m = a.selection.getSelectedElement();
              m && xn(m) || (g = a.selection.editableElement);
            }
            g && (i.change((m) => {
              m.setAttribute("draggable", "true", g);
            }), this._draggableElement = t.editing.mapper.toModelElement(g));
          }), this.listenTo(a, "mouseup", () => {
            p.isAndroid || this._clearDraggableAttributesDelayed();
          });
        }
        _clearDraggableAttributes() {
          const t = this.editor.editing;
          t.view.change((i) => {
            this._draggableElement && this._draggableElement.root.rootName != "$graveyard" && i.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
          });
        }
        _setupDropMarker() {
          const t = this.editor;
          t.conversion.for("editingDowncast").markerToHighlight({ model: "drop-target", view: { classes: ["ck-clipboard-drop-target-range"] } }), t.conversion.for("editingDowncast").markerToElement({ model: "drop-target", view: (i, { writer: a }) => {
            if (t.model.schema.checkChild(i.markerRange.start, "$text"))
              return a.createUIElement("span", { class: "ck ck-clipboard-drop-target-position" }, function(l) {
                const d = this.toDomElement(l);
                return d.append("\u2060", l.createElement("span"), "\u2060"), d;
              });
          } });
        }
        _updateDropMarker(t) {
          const i = this.editor, a = i.model.markers;
          i.model.change((l) => {
            a.has("drop-target") ? a.get("drop-target").getRange().isEqual(t) || l.updateMarker("drop-target", { range: t }) : l.addMarker("drop-target", { range: t, usingOperation: !1, affectsData: !1 });
          });
        }
        _removeDropMarker() {
          const t = this.editor.model;
          this._removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), t.markers.has("drop-target") && t.change((i) => {
            i.removeMarker("drop-target");
          });
        }
        _finalizeDragging(t) {
          const i = this.editor, a = i.model;
          this._removeDropMarker(), this._clearDraggableAttributes(), i.plugins.has("WidgetToolbarRepository") && i.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._draggedRange && (t && this.isEnabled && a.deleteContent(a.createSelection(this._draggedRange), { doNotAutoparagraph: !0 }), this._draggedRange.detach(), this._draggedRange = null);
        }
      }
      function JC(c, t, i) {
        const a = c.model, l = c.editing.mapper;
        let d = null;
        const g = t ? t[0].start : null;
        if (i.is("uiElement") && (i = i.parent), d = function(A, C) {
          const T = A.model, R = A.editing.mapper;
          if (xn(C))
            return T.createRangeOn(R.toModelElement(C));
          if (!C.is("editableElement")) {
            const j = C.findAncestor((F) => xn(F) || F.is("editableElement"));
            if (xn(j))
              return T.createRangeOn(R.toModelElement(j));
          }
          return null;
        }(c, i), d)
          return d;
        const m = function(A, C) {
          const T = A.editing.mapper, R = A.editing.view, j = T.toModelElement(C);
          if (j)
            return j;
          const F = R.createPositionBefore(C), V = T.findMappedViewAncestor(F);
          return T.toModelElement(V);
        }(c, i), w = g ? l.toModelPosition(g) : null;
        return w ? (d = function(A, C, T) {
          const R = A.model;
          if (!R.schema.checkChild(T, "$block"))
            return null;
          const j = R.createPositionAt(T, 0), F = C.path.slice(0, j.path.length), V = R.createPositionFromPath(C.root, F), W = V.nodeAfter;
          return W && R.schema.isObject(W) ? R.createRangeOn(W) : null;
        }(c, w, m), d || (d = a.schema.getNearestSelectionRange(w, p.isGecko ? "forward" : "backward"), d || function(A, C) {
          const T = A.model;
          let R = C;
          for (; R; ) {
            if (T.schema.isObject(R))
              return T.createRangeOn(R);
            R = R.parent;
          }
          return null;
        }(c, w.parent))) : function(A, C) {
          const T = A.model, R = T.schema, j = T.createPositionAt(C, 0);
          return R.getNearestSelectionRange(j, "forward");
        }(c, m);
      }
      function e2(c) {
        return p.isGecko ? c.dropEffect : ["all", "copyMove"].includes(c.effectAllowed) ? "move" : "copy";
      }
      function t2(c, t) {
        let i;
        function a(...l) {
          a.cancel(), i = setTimeout(() => c(...l), t);
        }
        return a.cancel = () => {
          clearTimeout(i);
        }, a;
      }
      function n2(c) {
        if (c.is("editableElement"))
          return null;
        if (c.hasClass("ck-widget__selection-handle"))
          return c.findAncestor(xn);
        if (xn(c))
          return c;
        const t = c.findAncestor((i) => xn(i) || i.is("editableElement"));
        return xn(t) ? t : null;
      }
      class eL extends Ie {
        static get pluginName() {
          return "PastePlainText";
        }
        static get requires() {
          return [io];
        }
        init() {
          const t = this.editor, i = t.model, a = t.editing.view, l = a.document, d = i.document.selection;
          let g = !1;
          a.addObserver(S0), this.listenTo(l, "keydown", (m, w) => {
            g = w.shiftKey;
          }), t.plugins.get(io).on("contentInsertion", (m, w) => {
            (g || function(A, C) {
              if (A.childCount > 1)
                return !1;
              const T = A.getChild(0);
              return C.isObject(T) ? !1 : Array.from(T.getAttributeKeys()).length == 0;
            }(w.content, i.schema)) && i.change((A) => {
              const C = Array.from(d.getAttributes()).filter(([R]) => i.schema.getAttributeProperties(R).isFormatting);
              d.isCollapsed || i.deleteContent(d, { doNotAutoparagraph: !0 }), C.push(...d.getAttributes());
              const T = A.createRangeIn(w.content);
              for (const R of T.getItems())
                R.is("$textProxy") && A.setAttributes(C, R);
            });
          });
        }
      }
      class r2 extends Ie {
        static get pluginName() {
          return "Clipboard";
        }
        static get requires() {
          return [io, J$, eL];
        }
      }
      class tL extends kt {
        constructor(t) {
          super(t), this.affectsData = !1;
        }
        execute() {
          const t = this.editor.model, i = t.document.selection;
          let a = t.schema.getLimitElement(i);
          if (i.containsEntireContent(a) || !i2(t.schema, a))
            do
              if (a = a.parent, !a)
                return;
            while (!i2(t.schema, a));
          t.change((l) => {
            l.setSelection(a, "in");
          });
        }
      }
      function i2(c, t) {
        return c.isLimit(t) && (c.checkChild(t, "$text") || c.checkChild(t, "paragraph"));
      }
      const nL = Dm("Ctrl+A");
      class rL extends Ie {
        static get pluginName() {
          return "SelectAllEditing";
        }
        init() {
          const t = this.editor, i = t.editing.view.document;
          t.commands.add("selectAll", new tL(t)), this.listenTo(i, "keydown", (a, l) => {
            hl(l) === nL && (t.execute("selectAll"), l.preventDefault());
          });
        }
      }
      class iL extends Ie {
        static get pluginName() {
          return "SelectAllUI";
        }
        init() {
          const t = this.editor;
          t.ui.componentFactory.add("selectAll", (i) => {
            const a = t.commands.get("selectAll"), l = new cn(i), d = i.t;
            return l.set({ label: d("Select all"), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>', keystroke: "Ctrl+A", tooltip: !0 }), l.bind("isEnabled").to(a, "isEnabled"), this.listenTo(l, "execute", () => {
              t.execute("selectAll"), t.editing.view.focus();
            }), l;
          });
        }
      }
      class oL extends Ie {
        static get requires() {
          return [rL, iL];
        }
        static get pluginName() {
          return "SelectAll";
        }
      }
      class o2 extends kt {
        constructor(t) {
          super(t), this._stack = [], this._createdBatches = /* @__PURE__ */ new WeakSet(), this.refresh(), this.listenTo(t.data, "set", (i, a) => {
            a[1] = { ...a[1] };
            const l = a[1];
            l.batchType || (l.batchType = { isUndoable: !1 });
          }, { priority: "high" }), this.listenTo(t.data, "set", (i, a) => {
            a[1].batchType.isUndoable || this.clearStack();
          });
        }
        refresh() {
          this.isEnabled = this._stack.length > 0;
        }
        addBatch(t) {
          const i = this.editor.model.document.selection, a = { ranges: i.hasOwnRange ? Array.from(i.getRanges()) : [], isBackward: i.isBackward };
          this._stack.push({ batch: t, selection: a }), this.refresh();
        }
        clearStack() {
          this._stack = [], this.refresh();
        }
        _restoreSelection(t, i, a) {
          const l = this.editor.model, d = l.document, g = [], m = t.map((A) => A.getTransformedByOperations(a)), w = m.flat();
          for (const A of m) {
            const C = A.filter((T) => T.root != d.graveyard).filter((T) => !sL(T, w));
            C.length && (aL(C), g.push(C[0]));
          }
          g.length && l.change((A) => {
            A.setSelection(g, { backward: i });
          });
        }
        _undo(t, i) {
          const a = this.editor.model, l = a.document;
          this._createdBatches.add(i);
          const d = t.operations.slice().filter((g) => g.isDocumentOperation);
          d.reverse();
          for (const g of d) {
            const m = g.baseVersion + 1, w = Array.from(l.history.getOperations(m)), A = e6([g.getReversed()], w, { useRelations: !0, document: this.editor.model.document, padWithNoOps: !1, forceWeakRemove: !0 }).operationsA;
            for (const C of A)
              i.addOperation(C), a.applyOperation(C), l.history.setOperationAsUndone(g, C);
          }
        }
      }
      function aL(c) {
        c.sort((t, i) => t.start.isBefore(i.start) ? -1 : 1);
        for (let t = 1; t < c.length; t++) {
          const i = c[t - 1].getJoined(c[t], !0);
          i && (t--, c.splice(t, 2, i));
        }
      }
      function sL(c, t) {
        return t.some((i) => i !== c && i.containsRange(c, !0));
      }
      class lL extends o2 {
        execute(t = null) {
          const i = t ? this._stack.findIndex((d) => d.batch == t) : this._stack.length - 1, a = this._stack.splice(i, 1)[0], l = this.editor.model.createBatch({ isUndo: !0 });
          this.editor.model.enqueueChange(l, () => {
            this._undo(a.batch, l);
            const d = this.editor.model.document.history.getOperations(a.batch.baseVersion);
            this._restoreSelection(a.selection.ranges, a.selection.isBackward, d), this.fire("revert", a.batch, l);
          }), this.refresh();
        }
      }
      class cL extends o2 {
        execute() {
          const t = this._stack.pop(), i = this.editor.model.createBatch({ isUndo: !0 });
          this.editor.model.enqueueChange(i, () => {
            const a = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1, l = this.editor.model.document.history.getOperations(a);
            this._restoreSelection(t.selection.ranges, t.selection.isBackward, l), this._undo(t.batch, i);
          }), this.refresh();
        }
      }
      class uL extends Ie {
        static get pluginName() {
          return "UndoEditing";
        }
        constructor(t) {
          super(t), this._batchRegistry = /* @__PURE__ */ new WeakSet();
        }
        init() {
          const t = this.editor;
          this._undoCommand = new lL(t), this._redoCommand = new cL(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", (i, a) => {
            const l = a[0];
            if (!l.isDocumentOperation)
              return;
            const d = l.batch, g = this._redoCommand._createdBatches.has(d), m = this._undoCommand._createdBatches.has(d);
            this._batchRegistry.has(d) || (this._batchRegistry.add(d), d.isUndoable && (g ? this._undoCommand.addBatch(d) : m || (this._undoCommand.addBatch(d), this._redoCommand.clearStack())));
          }, { priority: "highest" }), this.listenTo(this._undoCommand, "revert", (i, a, l) => {
            this._redoCommand.addBatch(l);
          }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }
      const a2 = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>', s2 = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
      class dL extends Ie {
        static get pluginName() {
          return "UndoUI";
        }
        init() {
          const t = this.editor, i = t.locale, a = t.t, l = i.uiLanguageDirection == "ltr" ? a2 : s2, d = i.uiLanguageDirection == "ltr" ? s2 : a2;
          this._addButton("undo", a("Undo"), "CTRL+Z", l), this._addButton("redo", a("Redo"), "CTRL+Y", d);
        }
        _addButton(t, i, a, l) {
          const d = this.editor;
          d.ui.componentFactory.add(t, (g) => {
            const m = d.commands.get(t), w = new cn(g);
            return w.set({ label: i, icon: l, keystroke: a, tooltip: !0 }), w.bind("isEnabled").to(m, "isEnabled"), this.listenTo(w, "execute", () => {
              d.execute(t), d.editing.view.focus();
            }), w;
          });
        }
      }
      class l2 extends Ie {
        static get requires() {
          return [uL, dL];
        }
        static get pluginName() {
          return "Undo";
        }
      }
      class hL extends Te() {
        constructor() {
          super();
          const t = new window.FileReader();
          this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = (i) => {
            this.loaded = i.loaded;
          };
        }
        get error() {
          return this._reader.error;
        }
        get data() {
          return this._data;
        }
        read(t) {
          const i = this._reader;
          return this.total = t.size, new Promise((a, l) => {
            i.onload = () => {
              const d = i.result;
              this._data = d, a(d);
            }, i.onerror = () => {
              l("error");
            }, i.onabort = () => {
              l("aborted");
            }, this._reader.readAsDataURL(t);
          });
        }
        abort() {
          this._reader.abort();
        }
      }
      class xi extends Ie {
        static get pluginName() {
          return "FileRepository";
        }
        static get requires() {
          return [HA];
        }
        init() {
          this.loaders = new yi(), this.loaders.on("change", () => this._updatePendingAction()), this._loadersMap = /* @__PURE__ */ new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t, i) => i ? t / i * 100 : 0);
        }
        getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
        createLoader(t) {
          if (!this.createUploadAdapter)
            return $("filerepository-no-upload-adapter"), null;
          const i = new c2(Promise.resolve(t), this.createUploadAdapter);
          return this.loaders.add(i), this._loadersMap.set(t, i), t instanceof Promise && i.file.then((a) => {
            this._loadersMap.set(a, i);
          }).catch(() => {
          }), i.on("change:uploaded", () => {
            let a = 0;
            for (const l of this.loaders)
              a += l.uploaded;
            this.uploaded = a;
          }), i.on("change:uploadTotal", () => {
            let a = 0;
            for (const l of this.loaders)
              l.uploadTotal && (a += l.uploadTotal);
            this.uploadTotal = a;
          }), i;
        }
        destroyLoader(t) {
          const i = t instanceof c2 ? t : this.getLoader(t);
          i._destroy(), this.loaders.remove(i), this._loadersMap.forEach((a, l) => {
            a === i && this._loadersMap.delete(l);
          });
        }
        _updatePendingAction() {
          const t = this.editor.plugins.get(HA);
          if (this.loaders.length) {
            if (!this._pendingAction) {
              const i = this.editor.t, a = (l) => `${i("Upload in progress")} ${parseInt(l)}%.`;
              this._pendingAction = t.add(a(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", a);
            }
          } else
            t.remove(this._pendingAction), this._pendingAction = null;
        }
      }
      class c2 extends Te() {
        constructor(t, i) {
          super(), this.id = N(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = i(this), this._reader = new hL(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (a, l) => l ? a / l * 100 : 0), this.set("uploadResponse", null);
        }
        get file() {
          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then((t) => this._filePromiseWrapper ? t : null) : Promise.resolve(null);
        }
        get data() {
          return this._reader.data;
        }
        read() {
          if (this.status != "idle")
            throw new S("filerepository-read-wrong-status", this);
          return this.status = "reading", this.file.then((t) => this._reader.read(t)).then((t) => {
            if (this.status !== "reading")
              throw this.status;
            return this.status = "idle", t;
          }).catch((t) => {
            throw t === "aborted" ? (this.status = "aborted", "aborted") : (this.status = "error", this._reader.error ? this._reader.error : t);
          });
        }
        upload() {
          if (this.status != "idle")
            throw new S("filerepository-upload-wrong-status", this);
          return this.status = "uploading", this.file.then(() => this._adapter.upload()).then((t) => (this.uploadResponse = t, this.status = "idle", t)).catch((t) => {
            throw this.status === "aborted" ? "aborted" : (this.status = "error", t);
          });
        }
        abort() {
          const t = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? t == "reading" ? this._reader.abort() : t == "uploading" && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(() => {
          }), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
        }
        _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
        _createFilePromiseWrapper(t) {
          const i = {};
          return i.promise = new Promise((a, l) => {
            i.rejecter = l, i.isFulfilled = !1, t.then((d) => {
              i.isFulfilled = !0, a(d);
            }).catch((d) => {
              i.isFulfilled = !0, l(d);
            });
          }), i;
        }
      }
      class fL extends At {
        constructor(t) {
          super(t), this.buttonView = new cn(t), this._fileInputView = new pL(t), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.setTemplate({ tag: "span", attributes: { class: "ck-file-dialog-button" }, children: [this.buttonView, this._fileInputView] }), this.buttonView.on("execute", () => {
            this._fileInputView.open();
          });
        }
        focus() {
          this.buttonView.focus();
        }
      }
      class pL extends At {
        constructor(t) {
          super(t), this.set("acceptedType", void 0), this.set("allowMultipleFiles", !1);
          const i = this.bindTemplate;
          this.setTemplate({ tag: "input", attributes: { class: ["ck-hidden"], type: "file", tabindex: "-1", accept: i.to("acceptedType"), multiple: i.to("allowMultipleFiles") }, on: { change: i.to(() => {
            this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
          }) } });
        }
        open() {
          this.element.click();
        }
      }
      const u2 = "ckCsrfToken", d2 = "abcdefghijklmnopqrstuvwxyz0123456789";
      function gL() {
        let c = function(a) {
          a = a.toLowerCase();
          const l = document.cookie.split(";");
          for (const d of l) {
            const g = d.split("=");
            if (decodeURIComponent(g[0].trim().toLowerCase()) === a)
              return decodeURIComponent(g[1]);
          }
          return null;
        }(u2);
        var t, i;
        return c && c.length == 40 || (c = function(a) {
          let l = "";
          const d = new Uint8Array(a);
          window.crypto.getRandomValues(d);
          for (let g = 0; g < d.length; g++) {
            const m = d2.charAt(d[g] % d2.length);
            l += Math.random() > 0.5 ? m.toUpperCase() : m;
          }
          return l;
        }(40), t = u2, i = c, document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(i) + ";path=/"), c;
      }
      class mL {
        constructor(t, i, a) {
          this.loader = t, this.url = i, this.t = a;
        }
        upload() {
          return this.loader.file.then((t) => new Promise((i, a) => {
            this._initRequest(), this._initListeners(i, a, t), this._sendRequest(t);
          }));
        }
        abort() {
          this.xhr && this.xhr.abort();
        }
        _initRequest() {
          const t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.url, !0), t.responseType = "json";
        }
        _initListeners(t, i, a) {
          const l = this.xhr, d = this.loader, g = (0, this.t)("Cannot upload file:") + ` ${a.name}.`;
          l.addEventListener("error", () => i(g)), l.addEventListener("abort", () => i()), l.addEventListener("load", () => {
            const m = l.response;
            if (!m || !m.uploaded)
              return i(m && m.error && m.error.message ? m.error.message : g);
            t({ default: m.url });
          }), l.upload && l.upload.addEventListener("progress", (m) => {
            m.lengthComputable && (d.uploadTotal = m.total, d.uploaded = m.loaded);
          });
        }
        _sendRequest(t) {
          const i = new FormData();
          i.append("upload", t), i.append("ckCsrfToken", gL()), this.xhr.send(i);
        }
      }
      function pa(c, t, i, a) {
        let l, d = null;
        typeof a == "function" ? l = a : (d = c.commands.get(a), l = () => {
          c.execute(a);
        }), c.model.document.on("change:data", (g, m) => {
          if (d && !d.isEnabled || !t.isEnabled)
            return;
          const w = Fn(c.model.document.selection.getRanges());
          if (!w.isCollapsed || m.isUndo || !m.isLocal)
            return;
          const A = Array.from(c.model.document.differ.getChanges()), C = A[0];
          if (A.length != 1 || C.type !== "insert" || C.name != "$text" || C.length != 1)
            return;
          const T = C.position.parent;
          if (T.is("element", "codeBlock") || T.is("element", "listItem") && typeof a != "function" && !["numberedList", "bulletedList", "todoList"].includes(a) || d && d.value === !0)
            return;
          const R = T.getChild(0), j = c.model.createRangeOn(R);
          if (!j.containsRange(w) && !w.end.isEqual(j.end))
            return;
          const F = i.exec(R.data.substr(0, w.end.offset));
          F && c.model.enqueueChange((V) => {
            const W = V.createPositionAt(T, 0), ee = V.createPositionAt(T, F[0].length), le = new _i(W, ee);
            if (l({ match: F }) !== !1) {
              V.remove(le);
              const be = c.model.document.selection.getFirstRange(), Ne = V.createRangeIn(T);
              !T.isEmpty || Ne.isEqual(be) || Ne.containsRange(be, !0) || V.remove(T);
            }
            le.detach(), c.model.enqueueChange(() => {
              c.plugins.get("Delete").requestUndoOnBackspace();
            });
          });
        });
      }
      function El(c, t, i, a) {
        let l, d;
        i instanceof RegExp ? l = i : d = i, d = d || ((g) => {
          let m;
          const w = [], A = [];
          for (; (m = l.exec(g)) !== null && !(m && m.length < 4); ) {
            let { index: C, 1: T, 2: R, 3: j } = m;
            const F = T + R + j;
            C += m[0].length - F.length;
            const V = [C, C + T.length], W = [C + T.length + R.length, C + T.length + R.length + j.length];
            w.push(V), w.push(W), A.push([C + T.length, C + T.length + R.length]);
          }
          return { remove: w, format: A };
        }), c.model.document.on("change:data", (g, m) => {
          if (m.isUndo || !m.isLocal || !t.isEnabled)
            return;
          const w = c.model, A = w.document.selection;
          if (!A.isCollapsed)
            return;
          const C = Array.from(w.document.differ.getChanges()), T = C[0];
          if (C.length != 1 || T.type !== "insert" || T.name != "$text" || T.length != 1)
            return;
          const R = A.focus, j = R.parent, { text: F, range: V } = function(be, Ne) {
            let Je = be.start;
            return { text: Array.from(be.getItems()).reduce((Rt, zn) => !zn.is("$text") && !zn.is("$textProxy") || zn.getAttribute("code") ? (Je = Ne.createPositionAfter(zn), "") : Rt + zn.data, ""), range: Ne.createRange(Je, be.end) };
          }(w.createRange(w.createPositionAt(j, 0), R), w), W = d(F), ee = h2(V.start, W.format, w), le = h2(V.start, W.remove, w);
          ee.length && le.length && w.enqueueChange((be) => {
            if (a(be, ee) !== !1) {
              for (const Ne of le.reverse())
                be.remove(Ne);
              w.enqueueChange(() => {
                c.plugins.get("Delete").requestUndoOnBackspace();
              });
            }
          });
        });
      }
      function h2(c, t, i) {
        return t.filter((a) => a[0] !== void 0 && a[1] !== void 0).map((a) => i.createRange(c.getShiftedBy(a[0]), c.getShiftedBy(a[1])));
      }
      function Bh(c, t) {
        return (i, a) => {
          if (!c.commands.get(t).isEnabled)
            return !1;
          const l = c.model.schema.getValidRanges(a, t);
          for (const d of l)
            i.setAttribute(t, !0, d);
          i.removeSelectionAttribute(t);
        };
      }
      class f2 extends kt {
        constructor(t, i) {
          super(t), this.attributeKey = i;
        }
        refresh() {
          const t = this.editor.model, i = t.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(i.selection, this.attributeKey);
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.document.selection, l = t.forceValue === void 0 ? !this.value : t.forceValue;
          i.change((d) => {
            if (a.isCollapsed)
              l ? d.setSelectionAttribute(this.attributeKey, !0) : d.removeSelectionAttribute(this.attributeKey);
            else {
              const g = i.schema.getValidRanges(a.getRanges(), this.attributeKey);
              for (const m of g)
                l ? d.setAttribute(this.attributeKey, l, m) : d.removeAttribute(this.attributeKey, m);
            }
          });
        }
        _getValueFromFirstAllowedNode() {
          const t = this.editor.model, i = t.schema, a = t.document.selection;
          if (a.isCollapsed)
            return a.hasAttribute(this.attributeKey);
          for (const l of a.getRanges())
            for (const d of l.getItems())
              if (i.checkAttribute(d, this.attributeKey))
                return d.hasAttribute(this.attributeKey);
          return !1;
        }
      }
      const Sl = "bold";
      class vL extends Ie {
        static get pluginName() {
          return "BoldEditing";
        }
        init() {
          const t = this.editor;
          t.model.schema.extend("$text", { allowAttributes: Sl }), t.model.schema.setAttributeProperties(Sl, { isFormatting: !0, copyOnEnter: !0 }), t.conversion.attributeToElement({ model: Sl, view: "strong", upcastAlso: ["b", (i) => {
            const a = i.getStyle("font-weight");
            return a ? a == "bold" || Number(a) >= 600 ? { name: !0, styles: ["font-weight"] } : void 0 : null;
          }] }), t.commands.add(Sl, new f2(t, Sl)), t.keystrokes.set("CTRL+B", Sl);
        }
      }
      const O0 = "bold";
      class bL extends Ie {
        static get pluginName() {
          return "BoldUI";
        }
        init() {
          const t = this.editor, i = t.t;
          t.ui.componentFactory.add(O0, (a) => {
            const l = t.commands.get(O0), d = new cn(a);
            return d.set({ label: i("Bold"), icon: Nn.bold, keystroke: "CTRL+B", tooltip: !0, isToggleable: !0 }), d.bind("isOn", "isEnabled").to(l, "value", "isEnabled"), this.listenTo(d, "execute", () => {
              t.execute(O0), t.editing.view.focus();
            }), d;
          });
        }
      }
      const Ml = "italic";
      class wL extends Ie {
        static get pluginName() {
          return "ItalicEditing";
        }
        init() {
          const t = this.editor;
          t.model.schema.extend("$text", { allowAttributes: Ml }), t.model.schema.setAttributeProperties(Ml, { isFormatting: !0, copyOnEnter: !0 }), t.conversion.attributeToElement({ model: Ml, view: "i", upcastAlso: ["em", { styles: { "font-style": "italic" } }] }), t.commands.add(Ml, new f2(t, Ml)), t.keystrokes.set("CTRL+I", Ml);
        }
      }
      const R0 = "italic";
      class yL extends Ie {
        static get pluginName() {
          return "ItalicUI";
        }
        init() {
          const t = this.editor, i = t.t;
          t.ui.componentFactory.add(R0, (a) => {
            const l = t.commands.get(R0), d = new cn(a);
            return d.set({ label: i("Italic"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>', keystroke: "CTRL+I", tooltip: !0, isToggleable: !0 }), d.bind("isOn", "isEnabled").to(l, "value", "isEnabled"), this.listenTo(d, "execute", () => {
              t.execute(R0), t.editing.view.focus();
            }), d;
          });
        }
      }
      class kL extends kt {
        refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.schema, l = i.document.selection, d = Array.from(l.getSelectedBlocks()), g = t.forceValue === void 0 ? !this.value : t.forceValue;
          i.change((m) => {
            if (g) {
              const w = d.filter((A) => Fh(A) || g2(a, A));
              this._applyQuote(m, w);
            } else
              this._removeQuote(m, d.filter(Fh));
          });
        }
        _getValue() {
          const t = Fn(this.editor.model.document.selection.getSelectedBlocks());
          return !(!t || !Fh(t));
        }
        _checkEnabled() {
          if (this.value)
            return !0;
          const t = this.editor.model.document.selection, i = this.editor.model.schema, a = Fn(t.getSelectedBlocks());
          return !!a && g2(i, a);
        }
        _removeQuote(t, i) {
          p2(t, i).reverse().forEach((a) => {
            if (a.start.isAtStart && a.end.isAtEnd)
              return void t.unwrap(a.start.parent);
            if (a.start.isAtStart) {
              const d = t.createPositionBefore(a.start.parent);
              return void t.move(a, d);
            }
            a.end.isAtEnd || t.split(a.end);
            const l = t.createPositionAfter(a.end.parent);
            t.move(a, l);
          });
        }
        _applyQuote(t, i) {
          const a = [];
          p2(t, i).reverse().forEach((l) => {
            let d = Fh(l.start);
            d || (d = t.createElement("blockQuote"), t.wrap(l, d)), a.push(d);
          }), a.reverse().reduce((l, d) => l.nextSibling == d ? (t.merge(t.createPositionAfter(l)), l) : d);
        }
      }
      function Fh(c) {
        return c.parent.name == "blockQuote" ? c.parent : null;
      }
      function p2(c, t) {
        let i, a = 0;
        const l = [];
        for (; a < t.length; ) {
          const d = t[a], g = t[a + 1];
          i || (i = c.createPositionBefore(d)), g && d.nextSibling == g || (l.push(c.createRange(i, c.createPositionAfter(d))), i = null), a++;
        }
        return l;
      }
      function g2(c, t) {
        const i = c.checkChild(t.parent, "blockQuote"), a = c.checkChild(["$root", "blockQuote"], t);
        return i && a;
      }
      class _L extends Ie {
        static get pluginName() {
          return "BlockQuoteEditing";
        }
        static get requires() {
          return [$h, ha];
        }
        init() {
          const t = this.editor, i = t.model.schema;
          t.commands.add("blockQuote", new kL(t)), i.register("blockQuote", { inheritAllFrom: "$container" }), t.conversion.elementToElement({ model: "blockQuote", view: "blockquote" }), t.model.document.registerPostFixer((g) => {
            const m = t.model.document.differ.getChanges();
            for (const w of m)
              if (w.type == "insert") {
                const A = w.position.nodeAfter;
                if (!A)
                  continue;
                if (A.is("element", "blockQuote") && A.isEmpty)
                  return g.remove(A), !0;
                if (A.is("element", "blockQuote") && !i.checkChild(w.position, A))
                  return g.unwrap(A), !0;
                if (A.is("element")) {
                  const C = g.createRangeIn(A);
                  for (const T of C.getItems())
                    if (T.is("element", "blockQuote") && !i.checkChild(g.createPositionBefore(T), T))
                      return g.unwrap(T), !0;
                }
              } else if (w.type == "remove") {
                const A = w.position.parent;
                if (A.is("element", "blockQuote") && A.isEmpty)
                  return g.remove(A), !0;
              }
            return !1;
          });
          const a = this.editor.editing.view.document, l = t.model.document.selection, d = t.commands.get("blockQuote");
          this.listenTo(a, "enter", (g, m) => {
            !l.isCollapsed || !d.value || l.getLastPosition().parent.isEmpty && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), m.preventDefault(), g.stop());
          }, { context: "blockquote" }), this.listenTo(a, "delete", (g, m) => {
            if (m.direction != "backward" || !l.isCollapsed || !d.value)
              return;
            const w = l.getLastPosition().parent;
            w.isEmpty && !w.previousSibling && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), m.preventDefault(), g.stop());
          }, { context: "blockquote" });
        }
      }
      var m2 = s(3062), AL = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(m2.Z, AL), m2.Z.locals;
      class CL extends Ie {
        static get pluginName() {
          return "BlockQuoteUI";
        }
        init() {
          const t = this.editor, i = t.t;
          t.ui.componentFactory.add("blockQuote", (a) => {
            const l = t.commands.get("blockQuote"), d = new cn(a);
            return d.set({ label: i("Block quote"), icon: Nn.quote, tooltip: !0, isToggleable: !0 }), d.bind("isOn", "isEnabled").to(l, "value", "isEnabled"), this.listenTo(d, "execute", () => {
              t.execute("blockQuote"), t.editing.view.focus();
            }), d;
          });
        }
      }
      class xL extends Ie {
        static get pluginName() {
          return "CKBoxUI";
        }
        afterInit() {
          const t = this.editor;
          if (!t.commands.get("ckbox"))
            return;
          const i = t.t;
          t.ui.componentFactory.add("ckbox", (a) => {
            const l = t.commands.get("ckbox"), d = new cn(a);
            return d.set({ label: i("Open file manager"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>', tooltip: !0 }), d.bind("isOn", "isEnabled").to(l, "value", "isEnabled"), d.on("execute", () => {
              t.execute("ckbox");
            }), d;
          });
        }
      }
      function v2({ token: c, id: t, origin: i, width: a, extension: l }) {
        const d = b2(c), g = function(w) {
          const A = [10 * w / 100, 80], C = Math.floor(Math.max(...A)), T = [Math.min(w, 4e3)];
          let R = T[0];
          for (; R - C >= C; )
            R -= C, T.unshift(R);
          return T;
        }(a), m = function(w) {
          return w === "bmp" || w === "tiff" || w === "jpg" ? "jpeg" : w;
        }(l);
        return { imageFallbackUrl: w2({ environmentId: d, id: t, origin: i, width: a, extension: m }), imageSources: [{ srcset: g.map((w) => `${w2({ environmentId: d, id: t, origin: i, width: w, extension: "webp" })} ${w}w`).join(","), sizes: `(max-width: ${a}px) 100vw, ${a}px`, type: "image/webp" }] };
      }
      function b2(c) {
        const [, t] = c.value.split(".");
        return JSON.parse(atob(t)).aud;
      }
      function w2({ environmentId: c, id: t, origin: i, width: a, extension: l }) {
        return new URL(`${c}/assets/${t}/images/${a}.${l}`, i).toString();
      }
      class EL extends kt {
        constructor(t) {
          super(t), this._chosenAssets = /* @__PURE__ */ new Set(), this._wrapper = null, this._initListeners();
        }
        refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
        execute() {
          this.fire("ckbox:open");
        }
        _getValue() {
          return this._wrapper !== null;
        }
        _checkEnabled() {
          const t = this.editor.commands.get("insertImage"), i = this.editor.commands.get("link");
          return !(!t.isEnabled && !i.isEnabled);
        }
        _prepareOptions() {
          const t = this.editor.config.get("ckbox");
          return { theme: t.theme, language: t.language, tokenUrl: t.tokenUrl, serviceOrigin: t.serviceOrigin, assetsOrigin: t.assetsOrigin, dialog: { onClose: () => this.fire("ckbox:close") }, assets: { onChoose: (i) => this.fire("ckbox:choose", i) } };
        }
        _initListeners() {
          const t = this.editor, i = t.model, a = !t.config.get("ckbox.ignoreDataId");
          this.on("ckbox", () => {
            this.refresh();
          }, { priority: "low" }), this.on("ckbox:open", () => {
            this.isEnabled && !this.value && (this._wrapper = Fi(document, "div", { class: "ck ckbox-wrapper" }), document.body.appendChild(this._wrapper), window.CKBox.mount(this._wrapper, this._prepareOptions()));
          }), this.on("ckbox:close", () => {
            this.value && (this._wrapper.remove(), this._wrapper = null);
          }), this.on("ckbox:choose", (l, d) => {
            if (!this.isEnabled)
              return;
            const g = t.commands.get("insertImage"), m = t.commands.get("link"), w = t.plugins.get("CKBoxEditing"), A = function({ assets: C, origin: T, token: R, isImageAllowed: j, isLinkAllowed: F }) {
              return C.map((V) => ({ id: V.data.id, type: y2(V) ? "image" : "link", attributes: SL(V, R, T) })).filter((V) => V.type === "image" ? j : F);
            }({ assets: d, origin: t.config.get("ckbox.assetsOrigin"), token: w.getToken(), isImageAllowed: g.isEnabled, isLinkAllowed: m.isEnabled });
            A.length !== 0 && i.change((C) => {
              for (const T of A) {
                const R = T === A[A.length - 1];
                this._insertAsset(T, R, C), a && (setTimeout(() => this._chosenAssets.delete(T), 1e3), this._chosenAssets.add(T));
              }
            });
          }), this.listenTo(t, "destroy", () => {
            this.fire("ckbox:close"), this._chosenAssets.clear();
          });
        }
        _insertAsset(t, i, a) {
          const l = this.editor.model.document.selection;
          a.removeSelectionAttribute("linkHref"), t.type === "image" ? this._insertImage(t) : this._insertLink(t, a), i || a.setSelection(l.getLastPosition());
        }
        _insertImage(t) {
          const i = this.editor, { imageFallbackUrl: a, imageSources: l, imageTextAlternative: d } = t.attributes;
          i.execute("insertImage", { source: { src: a, sources: l, alt: d } });
        }
        _insertLink(t, i) {
          const a = this.editor, l = a.model, d = l.document.selection, { linkName: g, linkHref: m } = t.attributes;
          if (d.isCollapsed) {
            const w = Zi(d.getAttributes()), A = i.createText(g, w), C = l.insertContent(A);
            i.setSelection(C);
          }
          a.execute("link", m);
        }
      }
      function SL(c, t, i) {
        if (y2(c)) {
          const { imageFallbackUrl: a, imageSources: l } = v2({ token: t, origin: i, id: c.data.id, width: c.data.metadata.width, extension: c.data.extension });
          return { imageFallbackUrl: a, imageSources: l, imageTextAlternative: c.data.metadata.description || "" };
        }
        return { linkName: c.data.name, linkHref: ML(c, t, i) };
      }
      function y2(c) {
        const t = c.data.metadata;
        return !!t && t.width && t.height;
      }
      function ML(c, t, i) {
        const a = b2(t), l = new URL(`${a}/assets/${c.data.id}/file`, i);
        return l.searchParams.set("download", "true"), l.toString();
      }
      class TL extends Ie {
        static get requires() {
          return ["ImageUploadEditing", "ImageUploadProgress", xi, N0];
        }
        static get pluginName() {
          return "CKBoxUploadAdapter";
        }
        async afterInit() {
          const t = this.editor, i = !!t.config.get("ckbox"), a = !!window.CKBox;
          if (!i && !a)
            return;
          const l = t.plugins.get(xi), d = t.plugins.get(N0);
          l.createUploadAdapter = (w) => new DL(w, d.getToken(), t);
          const g = !t.config.get("ckbox.ignoreDataId"), m = t.plugins.get("ImageUploadEditing");
          g && m.on("uploadComplete", (w, { imageElement: A, data: C }) => {
            t.model.change((T) => {
              T.setAttribute("ckboxImageId", C.ckboxImageId, A);
            });
          });
        }
      }
      class DL {
        constructor(t, i, a) {
          this.loader = t, this.token = i, this.editor = a, this.controller = new AbortController(), this.serviceOrigin = a.config.get("ckbox.serviceOrigin"), this.assetsOrigin = a.config.get("ckbox.assetsOrigin");
        }
        async getAvailableCategories(t = 0) {
          const i = new URL("categories", this.serviceOrigin);
          return i.searchParams.set("limit", 50 .toString()), i.searchParams.set("offset", t.toString()), this._sendHttpRequest({ url: i }).then(async (a) => {
            if (a.totalCount - (t + 50) > 0) {
              const l = await this.getAvailableCategories(t + 50);
              return [...a.items, ...l];
            }
            return a.items;
          }).catch(() => {
            this.controller.signal.throwIfAborted(), L("ckbox-fetch-category-http-error");
          });
        }
        async getCategoryIdForFile(t) {
          const i = k2(t.name), a = await this.getAvailableCategories();
          if (!a)
            return null;
          const l = this.editor.config.get("ckbox.defaultUploadCategories");
          if (l) {
            const g = Object.keys(l).find((m) => l[m].includes(i));
            if (g) {
              const m = a.find((w) => w.id === g || w.name === g);
              return m ? m.id : null;
            }
          }
          const d = a.find((g) => g.extensions.includes(i));
          return d ? d.id : null;
        }
        async upload() {
          const t = this.editor.t, i = t("Cannot determine a category for the uploaded file."), a = await this.loader.file, l = await this.getCategoryIdForFile(a);
          if (!l)
            return Promise.reject(i);
          const d = new URL("assets", this.serviceOrigin), g = new FormData();
          g.append("categoryId", l), g.append("file", a);
          const m = { method: "POST", url: d, data: g, onUploadProgress: (w) => {
            w.lengthComputable && (this.loader.uploadTotal = w.total, this.loader.uploaded = w.loaded);
          } };
          return this._sendHttpRequest(m).then(async (w) => {
            const A = await this._getImageWidth(), C = k2(a.name), T = v2({ token: this.token, id: w.id, origin: this.assetsOrigin, width: A, extension: C });
            return { ckboxImageId: w.id, default: T.imageFallbackUrl, sources: T.imageSources };
          }).catch(() => {
            const w = t("Cannot upload file:") + ` ${a.name}.`;
            return Promise.reject(w);
          });
        }
        abort() {
          this.controller.abort();
        }
        _sendHttpRequest(t) {
          const { url: i, data: a, onUploadProgress: l } = t, d = t.method || "GET", g = this.controller.signal, m = new XMLHttpRequest();
          m.open(d, i.toString(), !0), m.setRequestHeader("Authorization", this.token.value), m.setRequestHeader("CKBox-Version", "CKEditor 5"), m.responseType = "json";
          const w = () => {
            m.abort();
          };
          return new Promise((A, C) => {
            g.addEventListener("abort", w), m.addEventListener("loadstart", () => {
              g.addEventListener("abort", w);
            }), m.addEventListener("loadend", () => {
              g.removeEventListener("abort", w);
            }), m.addEventListener("error", () => {
              C();
            }), m.addEventListener("abort", () => {
              C();
            }), m.addEventListener("load", async () => {
              const T = m.response;
              return !T || T.statusCode >= 400 ? C(T && T.message) : A(T);
            }), l && m.upload.addEventListener("progress", (T) => {
              l(T);
            }), m.send(a);
          });
        }
        _getImageWidth() {
          return new Promise((t) => {
            const i = new Image();
            i.onload = () => {
              URL.revokeObjectURL(i.src), t(i.width);
            }, i.src = this.loader.data;
          });
        }
      }
      function k2(c) {
        return c.match(/\.(?<ext>[^.]+)$/).groups.ext;
      }
      class N0 extends Ie {
        static get pluginName() {
          return "CKBoxEditing";
        }
        static get requires() {
          return ["CloudServices", "LinkEditing", "PictureEditing", TL];
        }
        async init() {
          const t = this.editor, i = !!t.config.get("ckbox"), a = !!window.CKBox;
          if (!i && !a)
            return;
          this._initConfig();
          const l = t.plugins.get("CloudServicesCore"), d = t.config.get("ckbox.tokenUrl"), g = t.config.get("cloudServices.tokenUrl");
          this._token = d === g ? t.plugins.get("CloudServices").token : await l.createToken(d).init(), t.config.get("ckbox.ignoreDataId") || (this._initSchema(), this._initConversion(), this._initFixers()), a && t.commands.add("ckbox", new EL(t));
        }
        getToken() {
          return this._token;
        }
        _initConfig() {
          const t = this.editor;
          if (t.config.define("ckbox", { serviceOrigin: "https://api.ckbox.io", assetsOrigin: "https://ckbox.cloud", defaultUploadCategories: null, ignoreDataId: !1, language: t.locale.uiLanguage, theme: "default", tokenUrl: t.config.get("cloudServices.tokenUrl") }), !t.config.get("ckbox.tokenUrl"))
            throw new S("ckbox-plugin-missing-token-url", this);
          t.plugins.has("ImageBlockEditing") || t.plugins.has("ImageInlineEditing") || L("ckbox-plugin-image-feature-missing", t);
        }
        _initSchema() {
          const t = this.editor.model.schema;
          t.extend("$text", { allowAttributes: "ckboxLinkId" }), t.isRegistered("imageBlock") && t.extend("imageBlock", { allowAttributes: ["ckboxImageId", "ckboxLinkId"] }), t.isRegistered("imageInline") && t.extend("imageInline", { allowAttributes: ["ckboxImageId", "ckboxLinkId"] }), t.addAttributeCheck((i, a) => {
            if (!i.last.getAttribute("linkHref") && a === "ckboxLinkId")
              return !1;
          });
        }
        _initConversion() {
          const t = this.editor;
          t.conversion.for("downcast").add((i) => {
            i.on("attribute:ckboxLinkId:imageBlock", (a, l, d) => {
              const { writer: g, mapper: m, consumable: w } = d;
              if (!w.consume(l.item, a.name))
                return;
              const A = [...m.toViewElement(l.item).getChildren()].find((C) => C.name === "a");
              A && (l.item.hasAttribute("ckboxLinkId") ? g.setAttribute("data-ckbox-resource-id", l.item.getAttribute("ckboxLinkId"), A) : g.removeAttribute("data-ckbox-resource-id", A));
            }, { priority: "low" }), i.on("attribute:ckboxLinkId", (a, l, d) => {
              const { writer: g, mapper: m, consumable: w } = d;
              if (w.consume(l.item, a.name)) {
                if (l.attributeOldValue) {
                  const A = _2(g, l.attributeOldValue);
                  g.unwrap(m.toViewRange(l.range), A);
                }
                if (l.attributeNewValue) {
                  const A = _2(g, l.attributeNewValue);
                  if (l.item.is("selection")) {
                    const C = g.document.selection;
                    g.wrap(C.getFirstRange(), A);
                  } else
                    g.wrap(m.toViewRange(l.range), A);
                }
              }
            }, { priority: "low" });
          }), t.conversion.for("upcast").add((i) => {
            i.on("element:a", (a, l, d) => {
              const { writer: g, consumable: m } = d;
              if (!l.viewItem.getAttribute("href") || !m.consume(l.viewItem, { attributes: ["data-ckbox-resource-id"] }))
                return;
              const w = l.viewItem.getAttribute("data-ckbox-resource-id");
              if (w)
                if (l.modelRange)
                  for (let A of l.modelRange.getItems())
                    A.is("$textProxy") && (A = A.textNode), PL(A) && g.setAttribute("ckboxLinkId", w, A);
                else {
                  const A = l.modelCursor.nodeBefore || l.modelCursor.parent;
                  g.setAttribute("ckboxLinkId", w, A);
                }
            }, { priority: "low" });
          }), t.conversion.for("downcast").attributeToAttribute({ model: "ckboxImageId", view: "data-ckbox-resource-id" }), t.conversion.for("upcast").elementToAttribute({ model: { key: "ckboxImageId", value: (i) => i.getAttribute("data-ckbox-resource-id") }, view: { attributes: { "data-ckbox-resource-id": /[\s\S]+/ } } });
        }
        _initFixers() {
          const t = this.editor, i = t.model, a = i.document.selection;
          i.document.registerPostFixer(function(l) {
            return (d) => {
              let g = !1;
              const m = l.model, w = l.commands.get("ckbox");
              if (!w)
                return g;
              for (const A of m.document.differ.getChanges()) {
                if (A.type !== "insert" && A.type !== "attribute")
                  continue;
                const C = A.type === "insert" ? new ve(A.position, A.position.getShiftedBy(A.length)) : A.range, T = A.type === "attribute" && A.attributeKey === "linkHref" && A.attributeNewValue === null;
                for (const R of C.getItems()) {
                  if (T && R.hasAttribute("ckboxLinkId")) {
                    d.removeAttribute("ckboxLinkId", R), g = !0;
                    continue;
                  }
                  const j = IL(R, w._chosenAssets);
                  for (const F of j) {
                    const V = F.type === "image" ? "ckboxImageId" : "ckboxLinkId";
                    F.id !== R.getAttribute(V) && (d.setAttribute(V, F.id, R), g = !0);
                  }
                }
              }
              return g;
            };
          }(t)), i.document.registerPostFixer(function(l) {
            return (d) => {
              !l.hasAttribute("linkHref") && l.hasAttribute("ckboxLinkId") && d.removeSelectionAttribute("ckboxLinkId");
            };
          }(a));
        }
      }
      function IL(c, t) {
        const i = c.is("element", "imageInline") || c.is("element", "imageBlock"), a = c.hasAttribute("linkHref");
        return [...t].filter((l) => l.type === "image" && i ? l.attributes.imageFallbackUrl === c.getAttribute("src") : l.type === "link" && a ? l.attributes.linkHref === c.getAttribute("linkHref") : void 0);
      }
      function _2(c, t) {
        const i = c.createAttributeElement("a", { "data-ckbox-resource-id": t }, { priority: 5 });
        return c.setCustomProperty("link", !0, i), i;
      }
      function PL(c) {
        return !!c.is("$text") || !(!c.is("element", "imageInline") && !c.is("element", "imageBlock"));
      }
      class OL extends Ie {
        static get pluginName() {
          return "CKFinderUI";
        }
        init() {
          const t = this.editor, i = t.ui.componentFactory, a = t.t;
          i.add("ckfinder", (l) => {
            const d = t.commands.get("ckfinder"), g = new cn(l);
            return g.set({ label: a("Insert image or file"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>', tooltip: !0 }), g.bind("isEnabled").to(d), g.on("execute", () => {
              t.execute("ckfinder"), t.editing.view.focus();
            }), g;
          });
        }
      }
      class RL extends kt {
        constructor(t) {
          super(t), this.stopListening(this.editor.model.document, "change"), this.listenTo(this.editor.model.document, "change", () => this.refresh(), { priority: "low" });
        }
        refresh() {
          const t = this.editor.commands.get("insertImage"), i = this.editor.commands.get("link");
          this.isEnabled = t.isEnabled || i.isEnabled;
        }
        execute() {
          const t = this.editor, i = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if (i != "popup" && i != "modal")
            throw new S("ckfinder-unknown-openermethod", t);
          const a = this.editor.config.get("ckfinder.options") || {};
          a.chooseFiles = !0;
          const l = a.onInit;
          a.language || (a.language = t.locale.uiLanguage), a.onInit = (d) => {
            l && l(d), d.on("files:choose", (g) => {
              const m = g.data.files.toArray(), w = m.filter((T) => !T.isImage()), A = m.filter((T) => T.isImage());
              for (const T of w)
                t.execute("link", T.getUrl());
              const C = [];
              for (const T of A) {
                const R = T.getUrl();
                C.push(R || d.request("file:getProxyUrl", { file: T }));
              }
              C.length && A2(t, C);
            }), d.on("file:choose:resizedImage", (g) => {
              const m = g.data.resizedUrl;
              if (m)
                A2(t, [m]);
              else {
                const w = t.plugins.get("Notification"), A = t.locale.t;
                w.showWarning(A("Could not obtain resized image URL."), { title: A("Selecting resized image failed"), namespace: "ckfinder" });
              }
            });
          }, window.CKFinder[i](a);
        }
      }
      function A2(c, t) {
        if (c.commands.get("insertImage").isEnabled)
          c.execute("insertImage", { source: t });
        else {
          const i = c.plugins.get("Notification"), a = c.locale.t;
          i.showWarning(a("Could not insert image at the current position."), { title: a("Inserting image failed"), namespace: "ckfinder" });
        }
      }
      class NL extends Ie {
        static get pluginName() {
          return "CKFinderEditing";
        }
        static get requires() {
          return [E0, "LinkEditing"];
        }
        init() {
          const t = this.editor;
          if (!t.plugins.has("ImageBlockEditing") && !t.plugins.has("ImageInlineEditing"))
            throw new S("ckfinder-missing-image-plugin", t);
          t.commands.add("ckfinder", new RL(t));
        }
      }
      class $L extends Ie {
        static get pluginName() {
          return "CloudServicesUploadAdapter";
        }
        static get requires() {
          return ["CloudServices", xi];
        }
        init() {
          const t = this.editor, i = t.plugins.get("CloudServices"), a = i.token, l = i.uploadUrl;
          a && (this._uploadGateway = t.plugins.get("CloudServicesCore").createUploadGateway(a, l), t.plugins.get(xi).createUploadAdapter = (d) => new LL(this._uploadGateway, d));
        }
      }
      class LL {
        constructor(t, i) {
          this.uploadGateway = t, this.loader = i;
        }
        upload() {
          return this.loader.file.then((t) => (this.fileUploader = this.uploadGateway.upload(t), this.fileUploader.on("progress", (i, a) => {
            this.loader.uploadTotal = a.total, this.loader.uploaded = a.uploaded;
          }), this.fileUploader.send()));
        }
        abort() {
          this.fileUploader.abort();
        }
      }
      class jL extends kt {
        refresh() {
          const t = this.editor.model, i = Fn(t.document.selection.getSelectedBlocks());
          this.value = !!i && i.is("element", "paragraph"), this.isEnabled = !!i && C2(i, t.schema);
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.document;
          i.change((l) => {
            const d = (t.selection || a.selection).getSelectedBlocks();
            for (const g of d)
              !g.is("element", "paragraph") && C2(g, i.schema) && l.rename(g, "paragraph");
          });
        }
      }
      function C2(c, t) {
        return t.checkChild(c.parent, "paragraph") && !t.isObject(c);
      }
      class BL extends kt {
        execute(t) {
          const i = this.editor.model, a = t.attributes;
          let l = t.position;
          i.change((d) => {
            const g = d.createElement("paragraph");
            if (a && i.schema.setAllowedAttributes(g, a, d), !i.schema.checkChild(l.parent, g)) {
              const m = i.schema.findAllowedParent(l, g);
              if (!m)
                return;
              l = d.split(l, m).position;
            }
            i.insertContent(g, l), d.setSelection(g, "in");
          });
        }
      }
      class bu extends Ie {
        static get pluginName() {
          return "Paragraph";
        }
        init() {
          const t = this.editor, i = t.model;
          t.commands.add("paragraph", new jL(t)), t.commands.add("insertParagraph", new BL(t)), i.schema.register("paragraph", { inheritAllFrom: "$block" }), t.conversion.elementToElement({ model: "paragraph", view: "p" }), t.conversion.for("upcast").elementToElement({ model: (a, { writer: l }) => bu.paragraphLikeElements.has(a.name) ? a.isEmpty ? null : l.createElement("paragraph") : null, view: /.+/, converterPriority: "low" });
        }
      }
      bu.paragraphLikeElements = /* @__PURE__ */ new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
      class FL extends kt {
        constructor(t, i) {
          super(t), this.modelElements = i;
        }
        refresh() {
          const t = Fn(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some((i) => x2(t, i, this.editor.model.schema));
        }
        execute(t) {
          const i = this.editor.model, a = i.document, l = t.value;
          i.change((d) => {
            const g = Array.from(a.selection.getSelectedBlocks()).filter((m) => x2(m, l, i.schema));
            for (const m of g)
              m.is("element", l) || d.rename(m, l);
          });
        }
      }
      function x2(c, t, i) {
        return i.checkChild(c.parent, t) && !i.isObject(c);
      }
      const $0 = "paragraph";
      class zL extends Ie {
        static get pluginName() {
          return "HeadingEditing";
        }
        constructor(t) {
          super(t), t.config.define("heading", { options: [{ model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" }, { model: "heading1", view: "h2", title: "Heading 1", class: "ck-heading_heading1" }, { model: "heading2", view: "h3", title: "Heading 2", class: "ck-heading_heading2" }, { model: "heading3", view: "h4", title: "Heading 3", class: "ck-heading_heading3" }] });
        }
        static get requires() {
          return [bu];
        }
        init() {
          const t = this.editor, i = t.config.get("heading.options"), a = [];
          for (const l of i)
            l.model !== $0 && (t.model.schema.register(l.model, { inheritAllFrom: "$block" }), t.conversion.elementToElement(l), a.push(l.model));
          this._addDefaultH1Conversion(t), t.commands.add("heading", new FL(t, a));
        }
        afterInit() {
          const t = this.editor, i = t.commands.get("enter"), a = t.config.get("heading.options");
          i && this.listenTo(i, "afterExecute", (l, d) => {
            const g = t.model.document.selection.getFirstPosition().parent;
            a.some((m) => g.is("element", m.model)) && !g.is("element", $0) && g.childCount === 0 && d.writer.rename(g, $0);
          });
        }
        _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({ model: "heading1", view: "h1", converterPriority: O.get("low") + 1 });
        }
      }
      var E2 = s(8733), VL = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(E2.Z, VL), E2.Z.locals;
      class HL extends Ie {
        static get pluginName() {
          return "HeadingUI";
        }
        init() {
          const t = this.editor, i = t.t, a = function(g) {
            const m = g.t, w = { Paragraph: m("Paragraph"), "Heading 1": m("Heading 1"), "Heading 2": m("Heading 2"), "Heading 3": m("Heading 3"), "Heading 4": m("Heading 4"), "Heading 5": m("Heading 5"), "Heading 6": m("Heading 6") };
            return g.config.get("heading.options").map((A) => {
              const C = w[A.title];
              return C && C != A.title && (A.title = C), A;
            });
          }(t), l = i("Choose heading"), d = i("Heading");
          t.ui.componentFactory.add("heading", (g) => {
            const m = {}, w = new yi(), A = t.commands.get("heading"), C = t.commands.get("paragraph"), T = [A];
            for (const j of a) {
              const F = { type: "button", model: new fC({ label: j.title, class: j.class, withText: !0 }) };
              j.model === "paragraph" ? (F.model.bind("isOn").to(C, "value"), F.model.set("commandName", "paragraph"), T.push(C)) : (F.model.bind("isOn").to(A, "value", (V) => V === j.model), F.model.set({ commandName: "heading", commandValue: j.model })), w.add(F), m[j.model] = j.title;
            }
            const R = ua(g);
            return oC(R, w), R.buttonView.set({ isOn: !1, withText: !0, tooltip: d }), R.extendTemplate({ attributes: { class: ["ck-heading-dropdown"] } }), R.bind("isEnabled").toMany(T, "isEnabled", (...j) => j.some((F) => F)), R.buttonView.bind("label").to(A, "value", C, "value", (j, F) => {
              const V = j || F && "paragraph";
              return m[V] ? m[V] : l;
            }), this.listenTo(R, "execute", (j) => {
              t.execute(j.source.commandName, j.source.commandValue ? { value: j.source.commandValue } : void 0), t.editing.view.focus();
            }), R;
          });
        }
      }
      class UL extends kt {
        refresh() {
          const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!t, this.isEnabled && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
        }
        execute(t) {
          const i = this.editor, a = i.plugins.get("ImageUtils"), l = i.model, d = a.getClosestSelectedImageElement(l.document.selection);
          l.change((g) => {
            g.setAttribute("alt", t.newValue, d);
          });
        }
      }
      function S2(c) {
        return c.createContainerElement("figure", { class: "image" }, [c.createEmptyElement("img"), c.createSlot()]);
      }
      function M2(c, t) {
        const i = c.plugins.get("ImageUtils"), a = c.plugins.has("ImageInlineEditing") && c.plugins.has("ImageBlockEditing");
        return (d) => i.isInlineImageView(d) ? a && (d.getStyle("display") == "block" || d.findAncestor(i.isBlockImageView) ? "imageBlock" : "imageInline") !== t ? null : l(d) : null;
        function l(d) {
          const g = { name: !0 };
          return d.hasAttribute("src") && (g.attributes = ["src"]), g;
        }
      }
      function L0(c, t) {
        const i = Fn(t.getSelectedBlocks());
        return !i || c.isObject(i) || i.isEmpty && i.name != "listItem" ? "imageBlock" : "imageInline";
      }
      class Ei extends Ie {
        static get pluginName() {
          return "ImageUtils";
        }
        isImage(t) {
          return this.isInlineImage(t) || this.isBlockImage(t);
        }
        isInlineImageView(t) {
          return !!t && t.is("element", "img");
        }
        isBlockImageView(t) {
          return !!t && t.is("element", "figure") && t.hasClass("image");
        }
        insertImage(t = {}, i = null, a = null) {
          const l = this.editor, d = l.model, g = d.document.selection;
          a = T2(l, i || g, a), t = { ...Object.fromEntries(g.getAttributes()), ...t };
          for (const m in t)
            d.schema.checkAttribute(a, m) || delete t[m];
          return d.change((m) => {
            const w = m.createElement(a, t);
            return d.insertObject(w, i, null, { setSelection: "on", findOptimalPosition: !i && a != "imageInline" }), w.parent ? w : null;
          });
        }
        getClosestSelectedImageWidget(t) {
          const i = t.getFirstPosition();
          if (!i)
            return null;
          const a = t.getSelectedElement();
          if (a && this.isImageWidget(a))
            return a;
          let l = i.parent;
          for (; l; ) {
            if (l.is("element") && this.isImageWidget(l))
              return l;
            l = l.parent;
          }
          return null;
        }
        getClosestSelectedImageElement(t) {
          const i = t.getSelectedElement();
          return this.isImage(i) ? i : t.getFirstPosition().findAncestor("imageBlock");
        }
        isImageAllowed() {
          const t = this.editor.model.document.selection;
          return function(i, a) {
            if (T2(i, a) == "imageBlock") {
              const d = function(g, m) {
                const w = VC(g, m), A = w.start.parent;
                return A.isEmpty && !A.is("element", "$root") ? A.parent : A;
              }(a, i.model);
              if (i.model.schema.checkChild(d, "imageBlock"))
                return !0;
            } else if (i.model.schema.checkChild(a.focus, "imageInline"))
              return !0;
            return !1;
          }(this.editor, t) && function(i) {
            return [...i.focus.getAncestors()].every((a) => !a.is("element", "imageBlock"));
          }(t);
        }
        toImageWidget(t, i, a) {
          return i.setCustomProperty("image", !0, t), P0(t, i, { label: () => {
            const l = this.findViewImgElement(t).getAttribute("alt");
            return l ? `${l} ${a}` : a;
          } });
        }
        isImageWidget(t) {
          return !!t.getCustomProperty("image") && xn(t);
        }
        isBlockImage(t) {
          return !!t && t.is("element", "imageBlock");
        }
        isInlineImage(t) {
          return !!t && t.is("element", "imageInline");
        }
        findViewImgElement(t) {
          if (this.isInlineImageView(t))
            return t;
          const i = this.editor.editing.view;
          for (const { item: a } of i.createRangeIn(t))
            if (this.isInlineImageView(a))
              return a;
        }
      }
      function T2(c, t, i) {
        const a = c.model.schema, l = c.config.get("image.insert.type");
        return c.plugins.has("ImageBlockEditing") ? c.plugins.has("ImageInlineEditing") ? i || (l === "inline" ? "imageInline" : l === "block" ? "imageBlock" : t.is("selection") ? L0(a, t) : a.checkChild(t, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
      }
      class WL extends Ie {
        static get requires() {
          return [Ei];
        }
        static get pluginName() {
          return "ImageTextAlternativeEditing";
        }
        init() {
          this.editor.commands.add("imageTextAlternative", new UL(this.editor));
        }
      }
      var D2 = s(1905), GL = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(D2.Z, GL), D2.Z.locals;
      var I2 = s(6764), qL = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(I2.Z, qL), I2.Z.locals;
      class KL extends At {
        constructor(t) {
          super(t);
          const i = this.locale.t;
          this.focusTracker = new Kr(), this.keystrokes = new Qi(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(i("Save"), Nn.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(i("Cancel"), Nn.cancel, "ck-button-cancel", "cancel"), this._focusables = new ls(), this._focusCycler = new _l({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-text-alternative-form", "ck-responsive-form"], tabindex: "-1" }, children: [this.labeledInput, this.saveButtonView, this.cancelButtonView] }), b0(this);
        }
        render() {
          super.render(), this.keystrokes.listenTo(this.element), w0({ view: this }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach((t) => {
            this._focusables.add(t), this.focusTracker.add(t.element);
          });
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        _createButton(t, i, a, l) {
          const d = new cn(this.locale);
          return d.set({ label: t, icon: i, tooltip: !0 }), d.extendTemplate({ attributes: { class: a } }), l && d.delegate("execute").to(this, l), d;
        }
        _createLabeledInputView() {
          const t = this.locale.t, i = new C0(this.locale, x0);
          return i.label = t("Text alternative"), i;
        }
      }
      function P2(c) {
        const t = c.editing.view, i = vr.defaultPositions, a = c.plugins.get("ImageUtils");
        return { target: t.domConverter.mapViewToDom(a.getClosestSelectedImageWidget(t.document.selection)), positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast, i.viewportStickyNorth] };
      }
      class YL extends Ie {
        static get requires() {
          return [Ph];
        }
        static get pluginName() {
          return "ImageTextAlternativeUI";
        }
        init() {
          this._createButton(), this._createForm();
        }
        destroy() {
          super.destroy(), this._form.destroy();
        }
        _createButton() {
          const t = this.editor, i = t.t;
          t.ui.componentFactory.add("imageTextAlternative", (a) => {
            const l = t.commands.get("imageTextAlternative"), d = new cn(a);
            return d.set({ label: i("Change image text alternative"), icon: Nn.lowVision, tooltip: !0 }), d.bind("isEnabled").to(l, "isEnabled"), d.bind("isOn").to(l, "value", (g) => !!g), this.listenTo(d, "execute", () => {
              this._showForm();
            }), d;
          });
        }
        _createForm() {
          const t = this.editor, i = t.editing.view.document, a = t.plugins.get("ImageUtils");
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new KL(t.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
            t.execute("imageTextAlternative", { newValue: this._form.labeledInput.fieldView.element.value }), this._hideForm(!0);
          }), this.listenTo(this._form, "cancel", () => {
            this._hideForm(!0);
          }), this._form.keystrokes.set("Esc", (l, d) => {
            this._hideForm(!0), d();
          }), this.listenTo(t.ui, "update", () => {
            a.getClosestSelectedImageWidget(i.selection) ? this._isVisible && function(l) {
              const d = l.plugins.get("ContextualBalloon");
              if (l.plugins.get("ImageUtils").getClosestSelectedImageWidget(l.editing.view.document.selection)) {
                const g = P2(l);
                d.updatePosition(g);
              }
            }(t) : this._hideForm(!0);
          }), v0({ emitter: this._form, activator: () => this._isVisible, contextElements: [this._balloon.view.element], callback: () => this._hideForm() });
        }
        _showForm() {
          if (this._isVisible)
            return;
          const t = this.editor, i = t.commands.get("imageTextAlternative"), a = this._form.labeledInput;
          this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({ view: this._form, position: P2(t) }), a.fieldView.value = a.fieldView.element.value = i.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
        }
        _hideForm(t) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
        }
        get _isVisible() {
          return this._balloon.visibleView === this._form;
        }
        get _isInBalloon() {
          return this._balloon.hasView(this._form);
        }
      }
      class O2 extends Ie {
        static get requires() {
          return [WL, YL];
        }
        static get pluginName() {
          return "ImageTextAlternative";
        }
      }
      function R2(c, t) {
        return (a) => {
          a.on(`attribute:srcset:${t}`, i);
        };
        function i(a, l, d) {
          if (!d.consumable.consume(l.item, a.name))
            return;
          const g = d.writer, m = d.mapper.toViewElement(l.item), w = c.findViewImgElement(m);
          if (l.attributeNewValue === null) {
            const A = l.attributeOldValue;
            A.data && (g.removeAttribute("srcset", w), g.removeAttribute("sizes", w), A.width && g.removeAttribute("width", w));
          } else {
            const A = l.attributeNewValue;
            A.data && (g.setAttribute("srcset", A.data, w), g.setAttribute("sizes", "100vw", w), A.width && g.setAttribute("width", A.width, w));
          }
        }
      }
      function zh(c, t, i) {
        return (l) => {
          l.on(`attribute:${i}:${t}`, a);
        };
        function a(l, d, g) {
          if (!g.consumable.consume(d.item, l.name))
            return;
          const m = g.writer, w = g.mapper.toViewElement(d.item), A = c.findViewImgElement(w);
          m.setAttribute(d.attributeKey, d.attributeNewValue || "", A);
        }
      }
      class QL extends to {
        observe(t) {
          this.listenTo(t, "load", (i, a) => {
            const l = a.target;
            this.checkShouldIgnoreEventFromTarget(l) || l.tagName == "IMG" && this._fireEvents(a);
          }, { useCapture: !0 });
        }
        _fireEvents(t) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
        }
      }
      class ZL extends kt {
        constructor(t) {
          super(t);
          const i = t.config.get("image.insert.type");
          t.plugins.has("ImageBlockEditing") || i === "block" && $("image-block-plugin-required"), t.plugins.has("ImageInlineEditing") || i === "inline" && $("image-inline-plugin-required");
        }
        refresh() {
          this.isEnabled = this.editor.plugins.get("ImageUtils").isImageAllowed();
        }
        execute(t) {
          const i = Yn(t.source), a = this.editor.model.document.selection, l = this.editor.plugins.get("ImageUtils"), d = Object.fromEntries(a.getAttributes());
          i.forEach((g, m) => {
            const w = a.getSelectedElement();
            if (typeof g == "string" && (g = { src: g }), m && w && l.isImage(w)) {
              const A = this.editor.model.createPositionAfter(w);
              l.insertImage({ ...g, ...d }, A);
            } else
              l.insertImage({ ...g, ...d });
          });
        }
      }
      class j0 extends Ie {
        static get requires() {
          return [Ei];
        }
        static get pluginName() {
          return "ImageEditing";
        }
        init() {
          const t = this.editor, i = t.conversion;
          t.editing.view.addObserver(QL), i.for("upcast").attributeToAttribute({ view: { name: "img", key: "alt" }, model: "alt" }).attributeToAttribute({ view: { name: "img", key: "srcset" }, model: { key: "srcset", value: (l) => {
            const d = { data: l.getAttribute("srcset") };
            return l.hasAttribute("width") && (d.width = l.getAttribute("width")), d;
          } } });
          const a = new ZL(t);
          t.commands.add("insertImage", a), t.commands.add("imageInsert", a);
        }
      }
      class N2 extends kt {
        constructor(t, i) {
          super(t), this._modelElementName = i;
        }
        refresh() {
          const t = this.editor.plugins.get("ImageUtils"), i = t.getClosestSelectedImageElement(this.editor.model.document.selection);
          this._modelElementName === "imageBlock" ? this.isEnabled = t.isInlineImage(i) : this.isEnabled = t.isBlockImage(i);
        }
        execute() {
          const t = this.editor, i = this.editor.model, a = t.plugins.get("ImageUtils"), l = a.getClosestSelectedImageElement(i.document.selection), d = Object.fromEntries(l.getAttributes());
          return d.src || d.uploadId ? i.change((g) => {
            const m = Array.from(i.markers).filter((C) => C.getRange().containsItem(l)), w = a.insertImage(d, i.createSelection(l, "on"), this._modelElementName);
            if (!w)
              return null;
            const A = g.createRangeOn(w);
            for (const C of m) {
              const T = C.getRange(), R = T.root.rootName != "$graveyard" ? T.getJoined(A, !0) : A;
              g.updateMarker(C, { range: R });
            }
            return { oldElement: l, newElement: w };
          }) : null;
        }
      }
      class $2 extends Ie {
        static get requires() {
          return [j0, Ei, io];
        }
        static get pluginName() {
          return "ImageBlockEditing";
        }
        init() {
          const t = this.editor;
          t.model.schema.register("imageBlock", { inheritAllFrom: "$blockObject", allowAttributes: ["alt", "src", "srcset"] }), this._setupConversion(), t.plugins.has("ImageInlineEditing") && (t.commands.add("imageTypeBlock", new N2(this.editor, "imageBlock")), this._setupClipboardIntegration());
        }
        _setupConversion() {
          const t = this.editor, i = t.t, a = t.conversion, l = t.plugins.get("ImageUtils");
          a.for("dataDowncast").elementToStructure({ model: "imageBlock", view: (d, { writer: g }) => S2(g) }), a.for("editingDowncast").elementToStructure({ model: "imageBlock", view: (d, { writer: g }) => l.toImageWidget(S2(g), g, i("image widget")) }), a.for("downcast").add(zh(l, "imageBlock", "src")).add(zh(l, "imageBlock", "alt")).add(R2(l, "imageBlock")), a.for("upcast").elementToElement({ view: M2(t, "imageBlock"), model: (d, { writer: g }) => g.createElement("imageBlock", d.hasAttribute("src") ? { src: d.getAttribute("src") } : null) }).add(function(d) {
            return (m) => {
              m.on("element:figure", g);
            };
            function g(m, w, A) {
              if (!A.consumable.test(w.viewItem, { name: !0, classes: "image" }))
                return;
              const C = d.findViewImgElement(w.viewItem);
              if (!C || !A.consumable.test(C, { name: !0 }))
                return;
              A.consumable.consume(w.viewItem, { name: !0, classes: "image" });
              const T = Fn(A.convertItem(C, w.modelCursor).modelRange.getItems());
              T ? (A.convertChildren(w.viewItem, T), A.updateConversionResult(T, w)) : A.consumable.revert(w.viewItem, { name: !0, classes: "image" });
            }
          }(l));
        }
        _setupClipboardIntegration() {
          const t = this.editor, i = t.model, a = t.editing.view, l = t.plugins.get("ImageUtils");
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", (d, g) => {
            const m = Array.from(g.content.getChildren());
            let w;
            if (!m.every(l.isInlineImageView))
              return;
            w = g.targetRanges ? t.editing.mapper.toModelRange(g.targetRanges[0]) : i.document.selection.getFirstRange();
            const A = i.createSelection(w);
            if (L0(i.schema, A) === "imageBlock") {
              const C = new wl(a.document), T = m.map((R) => C.createElement("figure", { class: "image" }, R));
              g.content = C.createDocumentFragment(T);
            }
          });
        }
      }
      var L2 = s(3508), XL = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(L2.Z, XL), L2.Z.locals;
      class JL extends Ie {
        static get requires() {
          return [$2, vu, O2];
        }
        static get pluginName() {
          return "ImageBlock";
        }
      }
      class ej extends Ie {
        static get requires() {
          return [j0, Ei, io];
        }
        static get pluginName() {
          return "ImageInlineEditing";
        }
        init() {
          const t = this.editor, i = t.model.schema;
          i.register("imageInline", { inheritAllFrom: "$inlineObject", allowAttributes: ["alt", "src", "srcset"] }), i.addChildCheck((a, l) => {
            if (a.endsWith("caption") && l.name === "imageInline")
              return !1;
          }), this._setupConversion(), t.plugins.has("ImageBlockEditing") && (t.commands.add("imageTypeInline", new N2(this.editor, "imageInline")), this._setupClipboardIntegration());
        }
        _setupConversion() {
          const t = this.editor, i = t.t, a = t.conversion, l = t.plugins.get("ImageUtils");
          a.for("dataDowncast").elementToElement({ model: "imageInline", view: (d, { writer: g }) => g.createEmptyElement("img") }), a.for("editingDowncast").elementToStructure({ model: "imageInline", view: (d, { writer: g }) => l.toImageWidget(function(m) {
            return m.createContainerElement("span", { class: "image-inline" }, m.createEmptyElement("img"));
          }(g), g, i("image widget")) }), a.for("downcast").add(zh(l, "imageInline", "src")).add(zh(l, "imageInline", "alt")).add(R2(l, "imageInline")), a.for("upcast").elementToElement({ view: M2(t, "imageInline"), model: (d, { writer: g }) => g.createElement("imageInline", d.hasAttribute("src") ? { src: d.getAttribute("src") } : null) });
        }
        _setupClipboardIntegration() {
          const t = this.editor, i = t.model, a = t.editing.view, l = t.plugins.get("ImageUtils");
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", (d, g) => {
            const m = Array.from(g.content.getChildren());
            let w;
            if (!m.every(l.isBlockImageView))
              return;
            w = g.targetRanges ? t.editing.mapper.toModelRange(g.targetRanges[0]) : i.document.selection.getFirstRange();
            const A = i.createSelection(w);
            if (L0(i.schema, A) === "imageInline") {
              const C = new wl(a.document), T = m.map((R) => R.childCount === 1 ? (Array.from(R.getAttributes()).forEach((j) => C.setAttribute(...j, l.findViewImgElement(R))), R.getChild(0)) : R);
              g.content = C.createDocumentFragment(T);
            }
          });
        }
      }
      class tj extends Ie {
        static get requires() {
          return [ej, vu, O2];
        }
        static get pluginName() {
          return "ImageInline";
        }
      }
      class nj extends kt {
        refresh() {
          const t = this.editor, i = t.plugins.get("ImageCaptionUtils");
          if (!t.plugins.has($2))
            return this.isEnabled = !1, void (this.value = !1);
          const a = t.model.document.selection, l = a.getSelectedElement();
          if (!l) {
            const d = i.getCaptionFromModelSelection(a);
            return this.isEnabled = !!d, void (this.value = !!d);
          }
          this.isEnabled = this.editor.plugins.get("ImageUtils").isImage(l), this.isEnabled ? this.value = !!i.getCaptionFromImageModelElement(l) : this.value = !1;
        }
        execute(t = {}) {
          const { focusCaptionOnShow: i } = t;
          this.editor.model.change((a) => {
            this.value ? this._hideImageCaption(a) : this._showImageCaption(a, i);
          });
        }
        _showImageCaption(t, i) {
          const a = this.editor.model.document.selection, l = this.editor.plugins.get("ImageCaptionEditing");
          let d = a.getSelectedElement();
          const g = l._getSavedCaption(d);
          this.editor.plugins.get("ImageUtils").isInlineImage(d) && (this.editor.execute("imageTypeBlock"), d = a.getSelectedElement());
          const m = g || t.createElement("caption");
          t.append(m, d), i && t.setSelection(m, "in");
        }
        _hideImageCaption(t) {
          const i = this.editor, a = i.model.document.selection, l = i.plugins.get("ImageCaptionEditing"), d = i.plugins.get("ImageCaptionUtils");
          let g, m = a.getSelectedElement();
          m ? g = d.getCaptionFromImageModelElement(m) : (g = d.getCaptionFromModelSelection(a), m = g.parent), l._saveCaption(m, g), t.setSelection(m, "on"), t.remove(g);
        }
      }
      class j2 extends Ie {
        static get pluginName() {
          return "ImageCaptionUtils";
        }
        static get requires() {
          return [Ei];
        }
        getCaptionFromImageModelElement(t) {
          for (const i of t.getChildren())
            if (i && i.is("element", "caption"))
              return i;
          return null;
        }
        getCaptionFromModelSelection(t) {
          const i = this.editor.plugins.get("ImageUtils"), a = t.getFirstPosition().findAncestor("caption");
          return a && i.isBlockImage(a.parent) ? a : null;
        }
        matchImageCaptionViewElement(t) {
          const i = this.editor.plugins.get("ImageUtils");
          return t.name == "figcaption" && i.isBlockImageView(t.parent) ? { name: !0 } : null;
        }
      }
      class rj extends Ie {
        static get requires() {
          return [Ei, j2];
        }
        static get pluginName() {
          return "ImageCaptionEditing";
        }
        constructor(t) {
          super(t), this._savedCaptionsMap = /* @__PURE__ */ new WeakMap();
        }
        init() {
          const t = this.editor, i = t.model.schema;
          i.isRegistered("caption") ? i.extend("caption", { allowIn: "imageBlock" }) : i.register("caption", { allowIn: "imageBlock", allowContentOf: "$block", isLimit: !0 }), t.commands.add("toggleImageCaption", new nj(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration(), this._registerCaptionReconversion();
        }
        _setupConversion() {
          const t = this.editor, i = t.editing.view, a = t.plugins.get("ImageUtils"), l = t.plugins.get("ImageCaptionUtils"), d = t.t;
          t.conversion.for("upcast").elementToElement({ view: (g) => l.matchImageCaptionViewElement(g), model: "caption" }), t.conversion.for("dataDowncast").elementToElement({ model: "caption", view: (g, { writer: m }) => a.isBlockImage(g.parent) ? m.createContainerElement("figcaption") : null }), t.conversion.for("editingDowncast").elementToElement({ model: "caption", view: (g, { writer: m }) => {
            if (!a.isBlockImage(g.parent))
              return null;
            const w = m.createEditableElement("figcaption");
            m.setCustomProperty("imageCaption", !0, w), zk({ view: i, element: w, text: d("Enter image caption"), keepOnFocus: !0 });
            const A = g.parent.getAttribute("alt");
            return zC(w, m, { label: A ? d("Caption for image: %0", [A]) : d("Caption for the image") });
          } });
        }
        _setupImageTypeCommandsIntegration() {
          const t = this.editor, i = t.plugins.get("ImageUtils"), a = t.plugins.get("ImageCaptionUtils"), l = t.commands.get("imageTypeInline"), d = t.commands.get("imageTypeBlock"), g = (m) => {
            if (!m.return)
              return;
            const { oldElement: w, newElement: A } = m.return;
            if (!w)
              return;
            if (i.isBlockImage(w)) {
              const T = a.getCaptionFromImageModelElement(w);
              if (T)
                return void this._saveCaption(A, T);
            }
            const C = this._getSavedCaption(w);
            C && this._saveCaption(A, C);
          };
          l && this.listenTo(l, "execute", g, { priority: "low" }), d && this.listenTo(d, "execute", g, { priority: "low" });
        }
        _getSavedCaption(t) {
          const i = this._savedCaptionsMap.get(t);
          return i ? Kt.fromJSON(i) : null;
        }
        _saveCaption(t, i) {
          this._savedCaptionsMap.set(t, i.toJSON());
        }
        _registerCaptionReconversion() {
          const t = this.editor, i = t.model, a = t.plugins.get("ImageUtils"), l = t.plugins.get("ImageCaptionUtils");
          i.document.on("change:data", () => {
            const d = i.document.differ.getChanges();
            for (const g of d) {
              if (g.attributeKey !== "alt")
                continue;
              const m = g.range.start.nodeAfter;
              if (a.isBlockImage(m)) {
                const w = l.getCaptionFromImageModelElement(m);
                if (!w)
                  return;
                t.editing.reconvertItem(w);
              }
            }
          });
        }
      }
      class ij extends Ie {
        static get requires() {
          return [j2];
        }
        static get pluginName() {
          return "ImageCaptionUI";
        }
        init() {
          const t = this.editor, i = t.editing.view, a = t.plugins.get("ImageCaptionUtils"), l = t.t;
          t.ui.componentFactory.add("toggleImageCaption", (d) => {
            const g = t.commands.get("toggleImageCaption"), m = new cn(d);
            return m.set({ icon: Nn.caption, tooltip: !0, isToggleable: !0 }), m.bind("isOn", "isEnabled").to(g, "value", "isEnabled"), m.bind("label").to(g, "value", (w) => l(w ? "Toggle caption off" : "Toggle caption on")), this.listenTo(m, "execute", () => {
              t.execute("toggleImageCaption", { focusCaptionOnShow: !0 });
              const w = a.getCaptionFromModelSelection(t.model.document.selection);
              if (w) {
                const A = t.editing.mapper.toViewElement(w);
                i.scrollToTheSelection(), i.change((C) => {
                  C.addClass("image__caption_highlighted", A);
                });
              }
              t.editing.view.focus();
            }), m;
          });
        }
      }
      var B2 = s(2640), oj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(B2.Z, oj), B2.Z.locals;
      class aj extends kt {
        constructor(t, i) {
          super(t), this._defaultStyles = { imageBlock: !1, imageInline: !1 }, this._styles = new Map(i.map((a) => {
            if (a.isDefault)
              for (const l of a.modelElements)
                this._defaultStyles[l] = a.name;
            return [a.name, a];
          }));
        }
        refresh() {
          const t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!t, this.isEnabled ? t.hasAttribute("imageStyle") ? this.value = t.getAttribute("imageStyle") : this.value = this._defaultStyles[t.name] : this.value = !1;
        }
        execute(t = {}) {
          const i = this.editor, a = i.model, l = i.plugins.get("ImageUtils");
          a.change((d) => {
            const g = t.value;
            let m = l.getClosestSelectedImageElement(a.document.selection);
            g && this.shouldConvertImageType(g, m) && (this.editor.execute(l.isBlockImage(m) ? "imageTypeInline" : "imageTypeBlock"), m = l.getClosestSelectedImageElement(a.document.selection)), !g || this._styles.get(g).isDefault ? d.removeAttribute("imageStyle", m) : d.setAttribute("imageStyle", g, m);
          });
        }
        shouldConvertImageType(t, i) {
          return !this._styles.get(t).modelElements.includes(i.name);
        }
      }
      const { objectFullWidth: sj, objectInline: F2, objectLeft: z2, objectRight: B0, objectCenter: F0, objectBlockLeft: V2, objectBlockRight: H2 } = Nn, Vh = { get inline() {
        return { name: "inline", title: "In line", icon: F2, modelElements: ["imageInline"], isDefault: !0 };
      }, get alignLeft() {
        return { name: "alignLeft", title: "Left aligned image", icon: z2, modelElements: ["imageBlock", "imageInline"], className: "image-style-align-left" };
      }, get alignBlockLeft() {
        return { name: "alignBlockLeft", title: "Left aligned image", icon: V2, modelElements: ["imageBlock"], className: "image-style-block-align-left" };
      }, get alignCenter() {
        return { name: "alignCenter", title: "Centered image", icon: F0, modelElements: ["imageBlock"], className: "image-style-align-center" };
      }, get alignRight() {
        return { name: "alignRight", title: "Right aligned image", icon: B0, modelElements: ["imageBlock", "imageInline"], className: "image-style-align-right" };
      }, get alignBlockRight() {
        return { name: "alignBlockRight", title: "Right aligned image", icon: H2, modelElements: ["imageBlock"], className: "image-style-block-align-right" };
      }, get block() {
        return { name: "block", title: "Centered image", icon: F0, modelElements: ["imageBlock"], isDefault: !0 };
      }, get side() {
        return { name: "side", title: "Side image", icon: B0, modelElements: ["imageBlock"], className: "image-style-side" };
      } }, U2 = { full: sj, left: V2, right: H2, center: F0, inlineLeft: z2, inlineRight: B0, inline: F2 }, W2 = [{ name: "imageStyle:wrapText", title: "Wrap text", defaultItem: "imageStyle:alignLeft", items: ["imageStyle:alignLeft", "imageStyle:alignRight"] }, { name: "imageStyle:breakText", title: "Break text", defaultItem: "imageStyle:block", items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"] }];
      function G2(c) {
        $("image-style-configuration-definition-invalid", c);
      }
      const z0 = { normalizeStyles: function(c) {
        return (c.configuredStyles.options || []).map((t) => function(i) {
          return i = typeof i == "string" ? Vh[i] ? { ...Vh[i] } : { name: i } : function(a, l) {
            const d = { ...l };
            for (const g in a)
              Object.prototype.hasOwnProperty.call(l, g) || (d[g] = a[g]);
            return d;
          }(Vh[i.name], i), typeof i.icon == "string" && (i.icon = U2[i.icon] || i.icon), i;
        }(t)).filter((t) => function(i, { isBlockPluginLoaded: a, isInlinePluginLoaded: l }) {
          const { modelElements: d, name: g } = i;
          if (!(d && d.length && g))
            return G2({ style: i }), !1;
          {
            const m = [a ? "imageBlock" : null, l ? "imageInline" : null];
            if (!d.some((w) => m.includes(w)))
              return $("image-style-missing-dependency", { style: i, missingPlugins: d.map((w) => w === "imageBlock" ? "ImageBlockEditing" : "ImageInlineEditing") }), !1;
          }
          return !0;
        }(t, c));
      }, getDefaultStylesConfiguration: function(c, t) {
        return c && t ? { options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"] } : c ? { options: ["block", "side"] } : t ? { options: ["inline", "alignLeft", "alignRight"] } : {};
      }, getDefaultDropdownDefinitions: function(c) {
        return c.has("ImageBlockEditing") && c.has("ImageInlineEditing") ? [...W2] : [];
      }, warnInvalidStyle: G2, DEFAULT_OPTIONS: Vh, DEFAULT_ICONS: U2, DEFAULT_DROPDOWN_DEFINITIONS: W2 };
      function q2(c, t) {
        for (const i of t)
          if (i.name === c)
            return i;
      }
      class K2 extends Ie {
        static get pluginName() {
          return "ImageStyleEditing";
        }
        static get requires() {
          return [Ei];
        }
        init() {
          const { normalizeStyles: t, getDefaultStylesConfiguration: i } = z0, a = this.editor, l = a.plugins.has("ImageBlockEditing"), d = a.plugins.has("ImageInlineEditing");
          a.config.define("image.styles", i(l, d)), this.normalizedStyles = t({ configuredStyles: a.config.get("image.styles"), isBlockPluginLoaded: l, isInlinePluginLoaded: d }), this._setupConversion(l, d), this._setupPostFixer(), a.commands.add("imageStyle", new aj(a, this.normalizedStyles));
        }
        _setupConversion(t, i) {
          const a = this.editor, l = a.model.schema, d = (g = this.normalizedStyles, (w, A, C) => {
            if (!C.consumable.consume(A.item, w.name))
              return;
            const T = q2(A.attributeNewValue, g), R = q2(A.attributeOldValue, g), j = C.mapper.toViewElement(A.item), F = C.writer;
            R && F.removeClass(R.className, j), T && F.addClass(T.className, j);
          });
          var g;
          const m = function(w) {
            const A = { imageInline: w.filter((C) => !C.isDefault && C.modelElements.includes("imageInline")), imageBlock: w.filter((C) => !C.isDefault && C.modelElements.includes("imageBlock")) };
            return (C, T, R) => {
              if (!T.modelRange)
                return;
              const j = T.viewItem, F = Fn(T.modelRange.getItems());
              if (F && R.schema.checkAttribute(F, "imageStyle"))
                for (const V of A[F.name])
                  R.consumable.consume(j, { classes: V.className }) && R.writer.setAttribute("imageStyle", V.name, F);
            };
          }(this.normalizedStyles);
          a.editing.downcastDispatcher.on("attribute:imageStyle", d), a.data.downcastDispatcher.on("attribute:imageStyle", d), t && (l.extend("imageBlock", { allowAttributes: "imageStyle" }), a.data.upcastDispatcher.on("element:figure", m, { priority: "low" })), i && (l.extend("imageInline", { allowAttributes: "imageStyle" }), a.data.upcastDispatcher.on("element:img", m, { priority: "low" }));
        }
        _setupPostFixer() {
          const t = this.editor, i = t.model.document, a = t.plugins.get(Ei), l = new Map(this.normalizedStyles.map((d) => [d.name, d]));
          i.registerPostFixer((d) => {
            let g = !1;
            for (const m of i.differ.getChanges())
              if (m.type == "insert" || m.type == "attribute" && m.attributeKey == "imageStyle") {
                let w = m.type == "insert" ? m.position.nodeAfter : m.range.start.nodeAfter;
                if (w && w.is("element", "paragraph") && w.childCount > 0 && (w = w.getChild(0)), !a.isImage(w))
                  continue;
                const A = w.getAttribute("imageStyle");
                if (!A)
                  continue;
                const C = l.get(A);
                C && C.modelElements.includes(w.name) || (d.removeAttribute("imageStyle", w), g = !0);
              }
            return g;
          });
        }
      }
      var Y2 = s(5083), lj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Y2.Z, lj), Y2.Z.locals;
      class cj extends Ie {
        static get requires() {
          return [K2];
        }
        static get pluginName() {
          return "ImageStyleUI";
        }
        get localizedDefaultStylesTitles() {
          const t = this.editor.t;
          return { "Wrap text": t("Wrap text"), "Break text": t("Break text"), "In line": t("In line"), "Full size image": t("Full size image"), "Side image": t("Side image"), "Left aligned image": t("Left aligned image"), "Centered image": t("Centered image"), "Right aligned image": t("Right aligned image") };
        }
        init() {
          const t = this.editor.plugins, i = this.editor.config.get("image.toolbar") || [], a = Q2(t.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
          for (const d of a)
            this._createButton(d);
          const l = Q2([...i.filter(me), ...z0.getDefaultDropdownDefinitions(t)], this.localizedDefaultStylesTitles);
          for (const d of l)
            this._createDropdown(d, a);
        }
        _createDropdown(t, i) {
          const a = this.editor.ui.componentFactory;
          a.add(t.name, (l) => {
            let d;
            const { defaultItem: g, items: m, title: w } = t, A = m.filter((j) => i.find(({ name: F }) => Z2(F) === j)).map((j) => {
              const F = a.create(j);
              return j === g && (d = F), F;
            });
            m.length !== A.length && z0.warnInvalidStyle({ dropdown: t });
            const C = ua(l, y0), T = C.buttonView, R = T.arrowView;
            return A0(C, A, { enableActiveItemFocusOnDropdownOpen: !0 }), T.set({ label: X2(w, d.label), class: null, tooltip: !0 }), R.unbind("label"), R.set({ label: w }), T.bind("icon").toMany(A, "isOn", (...j) => {
              const F = j.findIndex(es);
              return F < 0 ? d.icon : A[F].icon;
            }), T.bind("label").toMany(A, "isOn", (...j) => {
              const F = j.findIndex(es);
              return X2(w, F < 0 ? d.label : A[F].label);
            }), T.bind("isOn").toMany(A, "isOn", (...j) => j.some(es)), T.bind("class").toMany(A, "isOn", (...j) => j.some(es) ? "ck-splitbutton_flatten" : null), T.on("execute", () => {
              A.some(({ isOn: j }) => j) ? C.isOpen = !C.isOpen : d.fire("execute");
            }), C.bind("isEnabled").toMany(A, "isEnabled", (...j) => j.some(es)), this.listenTo(C, "execute", () => {
              this.editor.editing.view.focus();
            }), C;
          });
        }
        _createButton(t) {
          const i = t.name;
          this.editor.ui.componentFactory.add(Z2(i), (a) => {
            const l = this.editor.commands.get("imageStyle"), d = new cn(a);
            return d.set({ label: t.title, icon: t.icon, tooltip: !0, isToggleable: !0 }), d.bind("isEnabled").to(l, "isEnabled"), d.bind("isOn").to(l, "value", (g) => g === i), d.on("execute", this._executeCommand.bind(this, i)), d;
          });
        }
        _executeCommand(t) {
          this.editor.execute("imageStyle", { value: t }), this.editor.editing.view.focus();
        }
      }
      function Q2(c, t) {
        for (const i of c)
          t[i.title] && (i.title = t[i.title]);
        return c;
      }
      function Z2(c) {
        return `imageStyle:${c}`;
      }
      function X2(c, t) {
        return (c ? c + ": " : "") + t;
      }
      function J2(c) {
        const t = c.map((i) => i.replace("+", "\\+"));
        return new RegExp(`^image\\/(${t.join("|")})$`);
      }
      function uj(c) {
        return new Promise((t, i) => {
          const a = c.getAttribute("src");
          fetch(a).then((l) => l.blob()).then((l) => {
            const d = ex(l, a), g = d.replace("image/", ""), m = new File([l], `image.${g}`, { type: d });
            t(m);
          }).catch((l) => l && l.name === "TypeError" ? function(d) {
            return function(g) {
              return new Promise((m, w) => {
                const A = yt.document.createElement("img");
                A.addEventListener("load", () => {
                  const C = yt.document.createElement("canvas");
                  C.width = A.width, C.height = A.height, C.getContext("2d").drawImage(A, 0, 0), C.toBlob((T) => T ? m(T) : w());
                }), A.addEventListener("error", () => w()), A.src = g;
              });
            }(d).then((g) => {
              const m = ex(g, d), w = m.replace("image/", "");
              return new File([g], `image.${w}`, { type: m });
            });
          }(a).then(t).catch(i) : i(l));
        });
      }
      function ex(c, t) {
        return c.type ? c.type : t.match(/data:(image\/\w+);base64/) ? t.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
      }
      class dj extends Ie {
        static get pluginName() {
          return "ImageUploadUI";
        }
        init() {
          const t = this.editor, i = t.t, a = (l) => {
            const d = new fL(l), g = t.commands.get("uploadImage"), m = t.config.get("image.upload.types"), w = J2(m);
            return d.set({ acceptedType: m.map((A) => `image/${A}`).join(","), allowMultipleFiles: !0 }), d.buttonView.set({ label: i("Insert image"), icon: Nn.image, tooltip: !0 }), d.buttonView.bind("isEnabled").to(g), d.on("done", (A, C) => {
              const T = Array.from(C).filter((R) => w.test(R.type));
              T.length && (t.execute("uploadImage", { file: T }), t.editing.view.focus());
            }), d;
          };
          t.ui.componentFactory.add("uploadImage", a), t.ui.componentFactory.add("imageUpload", a);
        }
      }
      var tx = s(3689), hj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(tx.Z, hj), tx.Z.locals;
      var nx = s(4036), fj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(nx.Z, fj), nx.Z.locals;
      var rx = s(3773), pj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(rx.Z, pj), rx.Z.locals;
      class gj extends Ie {
        static get pluginName() {
          return "ImageUploadProgress";
        }
        constructor(t) {
          super(t), this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        }
        init() {
          const t = this.editor;
          t.plugins.has("ImageBlockEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", (...i) => this.uploadStatusChange(...i)), t.plugins.has("ImageInlineEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", (...i) => this.uploadStatusChange(...i));
        }
        uploadStatusChange(t, i, a) {
          const l = this.editor, d = i.item, g = d.getAttribute("uploadId");
          if (!a.consumable.consume(i.item, t.name))
            return;
          const m = l.plugins.get("ImageUtils"), w = l.plugins.get(xi), A = g ? i.attributeNewValue : null, C = this.placeholder, T = l.editing.mapper.toViewElement(d), R = a.writer;
          if (A == "reading")
            return ix(T, R), void ox(m, C, T, R);
          if (A == "uploading") {
            const j = w.loaders.get(g);
            return ix(T, R), void (j ? (ax(T, R), function(F, V, W, ee) {
              const le = function(be) {
                const Ne = be.createUIElement("div", { class: "ck-progress-bar" });
                return be.setCustomProperty("progressBar", !0, Ne), Ne;
              }(V);
              V.insert(V.createPositionAt(F, "end"), le), W.on("change:uploadedPercent", (be, Ne, Je) => {
                ee.change((Mt) => {
                  Mt.setStyle("width", Je + "%", le);
                });
              });
            }(T, R, j, l.editing.view), function(F, V, W, ee) {
              if (ee.data) {
                const le = F.findViewImgElement(V);
                W.setAttribute("src", ee.data, le);
              }
            }(m, T, R, j)) : ox(m, C, T, R));
          }
          A == "complete" && w.loaders.get(g) && function(j, F, V) {
            const W = F.createUIElement("div", { class: "ck-image-upload-complete-icon" });
            F.insert(F.createPositionAt(j, "end"), W), setTimeout(() => {
              V.change((ee) => ee.remove(ee.createRangeOn(W)));
            }, 3e3);
          }(T, R, l.editing.view), function(j, F) {
            lx(j, F, "progressBar");
          }(T, R), ax(T, R), function(j, F) {
            F.removeClass("ck-appear", j);
          }(T, R);
        }
      }
      function ix(c, t) {
        c.hasClass("ck-appear") || t.addClass("ck-appear", c);
      }
      function ox(c, t, i, a) {
        i.hasClass("ck-image-upload-placeholder") || a.addClass("ck-image-upload-placeholder", i);
        const l = c.findViewImgElement(i);
        l.getAttribute("src") !== t && a.setAttribute("src", t, l), sx(i, "placeholder") || a.insert(a.createPositionAfter(l), function(d) {
          const g = d.createUIElement("div", { class: "ck-upload-placeholder-loader" });
          return d.setCustomProperty("placeholder", !0, g), g;
        }(a));
      }
      function ax(c, t) {
        c.hasClass("ck-image-upload-placeholder") && t.removeClass("ck-image-upload-placeholder", c), lx(c, t, "placeholder");
      }
      function sx(c, t) {
        for (const i of c.getChildren())
          if (i.getCustomProperty(t))
            return i;
      }
      function lx(c, t, i) {
        const a = sx(c, i);
        a && t.remove(t.createRangeOn(a));
      }
      class mj extends kt {
        refresh() {
          const t = this.editor, i = t.plugins.get("ImageUtils"), a = t.model.document.selection.getSelectedElement();
          this.isEnabled = i.isImageAllowed() || i.isImage(a);
        }
        execute(t) {
          const i = Yn(t.file), a = this.editor.model.document.selection, l = this.editor.plugins.get("ImageUtils"), d = Object.fromEntries(a.getAttributes());
          i.forEach((g, m) => {
            const w = a.getSelectedElement();
            if (m && w && l.isImage(w)) {
              const A = this.editor.model.createPositionAfter(w);
              this._uploadImage(g, d, A);
            } else
              this._uploadImage(g, d);
          });
        }
        _uploadImage(t, i, a) {
          const l = this.editor, d = l.plugins.get(xi).createLoader(t), g = l.plugins.get("ImageUtils");
          d && g.insertImage({ ...i, uploadId: d.id }, a);
        }
      }
      class vj extends Ie {
        static get requires() {
          return [xi, E0, io, Ei];
        }
        static get pluginName() {
          return "ImageUploadEditing";
        }
        constructor(t) {
          super(t), t.config.define("image", { upload: { types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"] } }), this._uploadImageElements = /* @__PURE__ */ new Map();
        }
        init() {
          const t = this.editor, i = t.model.document, a = t.conversion, l = t.plugins.get(xi), d = t.plugins.get("ImageUtils"), g = J2(t.config.get("image.upload.types")), m = new mj(t);
          t.commands.add("uploadImage", m), t.commands.add("imageUpload", m), a.for("upcast").attributeToAttribute({ view: { name: "img", key: "uploadId" }, model: "uploadId" }), this.listenTo(t.editing.view.document, "clipboardInput", (w, A) => {
            if (C = A.dataTransfer, Array.from(C.types).includes("text/html") && C.getData("text/html") !== "")
              return;
            var C;
            const T = Array.from(A.dataTransfer.files).filter((R) => !!R && g.test(R.type));
            T.length && (w.stop(), t.model.change((R) => {
              A.targetRanges && R.setSelection(A.targetRanges.map((j) => t.editing.mapper.toModelRange(j))), t.model.enqueueChange(() => {
                t.execute("uploadImage", { file: T });
              });
            }));
          }), this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", (w, A) => {
            const C = Array.from(t.editing.view.createRangeIn(A.content)).filter((R) => function(j, F) {
              return !(!j.isInlineImageView(F) || !F.getAttribute("src")) && (F.getAttribute("src").match(/^data:image\/\w+;base64,/g) || F.getAttribute("src").match(/^blob:/g));
            }(d, R.item) && !R.item.getAttribute("uploadProcessed")).map((R) => ({ promise: uj(R.item), imageElement: R.item }));
            if (!C.length)
              return;
            const T = new wl(t.editing.view.document);
            for (const R of C) {
              T.setAttribute("uploadProcessed", !0, R.imageElement);
              const j = l.createLoader(R.promise);
              j && (T.setAttribute("src", "", R.imageElement), T.setAttribute("uploadId", j.id, R.imageElement));
            }
          }), t.editing.view.document.on("dragover", (w, A) => {
            A.preventDefault();
          }), i.on("change", () => {
            const w = i.differ.getChanges({ includeChangesInGraveyard: !0 }).reverse(), A = /* @__PURE__ */ new Set();
            for (const C of w)
              if (C.type == "insert" && C.name != "$text") {
                const T = C.position.nodeAfter, R = C.position.root.rootName == "$graveyard";
                for (const j of bj(t, T)) {
                  const F = j.getAttribute("uploadId");
                  if (!F)
                    continue;
                  const V = l.loaders.get(F);
                  V && (R ? A.has(F) || V.abort() : (A.add(F), this._uploadImageElements.set(F, j), V.status == "idle" && this._readAndUpload(V)));
                }
              }
          }), this.on("uploadComplete", (w, { imageElement: A, data: C }) => {
            const T = C.urls ? C.urls : C;
            this.editor.model.change((R) => {
              R.setAttribute("src", T.default, A), this._parseAndSetSrcsetAttributeOnImage(T, A, R);
            });
          }, { priority: "low" });
        }
        afterInit() {
          const t = this.editor.model.schema;
          this.editor.plugins.has("ImageBlockEditing") && t.extend("imageBlock", { allowAttributes: ["uploadId", "uploadStatus"] }), this.editor.plugins.has("ImageInlineEditing") && t.extend("imageInline", { allowAttributes: ["uploadId", "uploadStatus"] });
        }
        _readAndUpload(t) {
          const i = this.editor, a = i.model, l = i.locale.t, d = i.plugins.get(xi), g = i.plugins.get(E0), m = i.plugins.get("ImageUtils"), w = this._uploadImageElements;
          return a.enqueueChange({ isUndoable: !1 }, (C) => {
            C.setAttribute("uploadStatus", "reading", w.get(t.id));
          }), t.read().then(() => {
            const C = t.upload(), T = w.get(t.id);
            if (p.isSafari) {
              const R = i.editing.mapper.toViewElement(T), j = m.findViewImgElement(R);
              i.editing.view.once("render", () => {
                if (!j.parent)
                  return;
                const F = i.editing.view.domConverter.mapViewToDom(j.parent);
                if (!F)
                  return;
                const V = F.style.display;
                F.style.display = "none", F._ckHack = F.offsetHeight, F.style.display = V;
              });
            }
            return a.enqueueChange({ isUndoable: !1 }, (R) => {
              R.setAttribute("uploadStatus", "uploading", T);
            }), C;
          }).then((C) => {
            a.enqueueChange({ isUndoable: !1 }, (T) => {
              const R = w.get(t.id);
              T.setAttribute("uploadStatus", "complete", R), this.fire("uploadComplete", { data: C, imageElement: R });
            }), A();
          }).catch((C) => {
            if (t.status !== "error" && t.status !== "aborted")
              throw C;
            t.status == "error" && C && g.showWarning(C, { title: l("Upload failed"), namespace: "upload" }), a.enqueueChange({ isUndoable: !1 }, (T) => {
              T.remove(w.get(t.id));
            }), A();
          });
          function A() {
            a.enqueueChange({ isUndoable: !1 }, (C) => {
              const T = w.get(t.id);
              C.removeAttribute("uploadId", T), C.removeAttribute("uploadStatus", T), w.delete(t.id);
            }), d.destroyLoader(t);
          }
        }
        _parseAndSetSrcsetAttributeOnImage(t, i, a) {
          let l = 0;
          const d = Object.keys(t).filter((g) => {
            const m = parseInt(g, 10);
            if (!isNaN(m))
              return l = Math.max(l, m), !0;
          }).map((g) => `${t[g]} ${g}w`).join(", ");
          d != "" && a.setAttribute("srcset", { data: d, width: l }, i);
        }
      }
      function bj(c, t) {
        const i = c.plugins.get("ImageUtils");
        return Array.from(c.model.createRangeOn(t)).filter((a) => i.isImage(a.item)).map((a) => a.item);
      }
      class wj extends Ie {
        static get pluginName() {
          return "IndentEditing";
        }
        init() {
          const t = this.editor;
          t.commands.add("indent", new jk(t)), t.commands.add("outdent", new jk(t));
        }
      }
      const cx = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>', ux = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
      class yj extends Ie {
        static get pluginName() {
          return "IndentUI";
        }
        init() {
          const t = this.editor, i = t.locale, a = t.t, l = i.uiLanguageDirection == "ltr" ? cx : ux, d = i.uiLanguageDirection == "ltr" ? ux : cx;
          this._defineButton("indent", a("Increase indent"), l), this._defineButton("outdent", a("Decrease indent"), d);
        }
        _defineButton(t, i, a) {
          const l = this.editor;
          l.ui.componentFactory.add(t, (d) => {
            const g = l.commands.get(t), m = new cn(d);
            return m.set({ label: i, icon: a, tooltip: !0 }), m.bind("isOn", "isEnabled").to(g, "value", "isEnabled"), this.listenTo(m, "execute", () => {
              l.execute(t), l.editing.view.focus();
            }), m;
          });
        }
      }
      class kj {
        constructor() {
          this._definitions = /* @__PURE__ */ new Set();
        }
        get length() {
          return this._definitions.size;
        }
        add(t) {
          Array.isArray(t) ? t.forEach((i) => this._definitions.add(i)) : this._definitions.add(t);
        }
        getDispatcher() {
          return (t) => {
            t.on("attribute:linkHref", (i, a, l) => {
              if (!l.consumable.test(a.item, "attribute:linkHref") || !a.item.is("selection") && !l.schema.isInline(a.item))
                return;
              const d = l.writer, g = d.document.selection;
              for (const m of this._definitions) {
                const w = d.createAttributeElement("a", m.attributes, { priority: 5 });
                m.classes && d.addClass(m.classes, w);
                for (const A in m.styles)
                  d.setStyle(A, m.styles[A], w);
                d.setCustomProperty("link", !0, w), m.callback(a.attributeNewValue) ? a.item.is("selection") ? d.wrap(g.getFirstRange(), w) : d.wrap(l.mapper.toViewRange(a.range), w) : d.unwrap(l.mapper.toViewRange(a.range), w);
              }
            }, { priority: "high" });
          };
        }
        getDispatcherForLinkedImage() {
          return (t) => {
            t.on("attribute:linkHref:imageBlock", (i, a, { writer: l, mapper: d }) => {
              const g = d.toViewElement(a.item), m = Array.from(g.getChildren()).find((w) => w.name === "a");
              for (const w of this._definitions) {
                const A = Zi(w.attributes);
                if (w.callback(a.attributeNewValue)) {
                  for (const [C, T] of A)
                    C === "class" ? l.addClass(T, m) : l.setAttribute(C, T, m);
                  w.classes && l.addClass(w.classes, m);
                  for (const C in w.styles)
                    l.setStyle(C, w.styles[C], m);
                } else {
                  for (const [C, T] of A)
                    C === "class" ? l.removeClass(T, m) : l.removeAttribute(C, m);
                  w.classes && l.removeClass(w.classes, m);
                  for (const C in w.styles)
                    l.removeStyle(C, m);
                }
              }
            });
          };
        }
      }
      const _j = function(c, t, i) {
        var a = c.length;
        return i = i === void 0 ? a : i, !t && i >= a ? c : Kk(c, t, i);
      };
      var Aj = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
      const dx = function(c) {
        return Aj.test(c);
      }, Cj = function(c) {
        return c.split("");
      };
      var hx = "\\ud800-\\udfff", xj = "[" + hx + "]", V0 = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", H0 = "\\ud83c[\\udffb-\\udfff]", fx = "[^" + hx + "]", px = "(?:\\ud83c[\\udde6-\\uddff]){2}", gx = "[\\ud800-\\udbff][\\udc00-\\udfff]", mx = "(?:" + V0 + "|" + H0 + ")?", vx = "[\\ufe0e\\ufe0f]?", Ej = vx + mx + ("(?:\\u200d(?:" + [fx, px, gx].join("|") + ")" + vx + mx + ")*"), Sj = "(?:" + [fx + V0 + "?", V0, px, gx, xj].join("|") + ")", Mj = RegExp(H0 + "(?=" + H0 + ")|" + Sj + Ej, "g");
      const Tj = function(c) {
        return c.match(Mj) || [];
      }, Dj = function(c) {
        return dx(c) ? Tj(c) : Cj(c);
      }, Ij = function(c) {
        return function(t) {
          t = Nm(t);
          var i = dx(t) ? Dj(t) : void 0, a = i ? i[0] : t.charAt(0), l = i ? _j(i, 1).join("") : t.slice(1);
          return a[c]() + l;
        };
      }("toUpperCase"), Pj = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, Oj = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i, Rj = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i, Nj = /^((\w+:(\/{2,})?)|(\W))/i, U0 = "Ctrl+K";
      function bx(c, { writer: t }) {
        const i = t.createAttributeElement("a", { href: c }, { priority: 5 });
        return t.setCustomProperty("link", !0, i), i;
      }
      function wx(c) {
        return function(t) {
          return t.replace(Pj, "").match(Oj);
        }(c = String(c)) ? c : "#";
      }
      function W0(c, t) {
        return !!c && t.checkAttribute(c.name, "linkHref");
      }
      function yx(c, t) {
        const i = (a = c, Rj.test(a) ? "mailto:" : t);
        var a;
        const l = !!i && !kx(c);
        return c && l ? i + c : c;
      }
      function kx(c) {
        return Nj.test(c);
      }
      function _x(c) {
        window.open(c, "_blank", "noopener");
      }
      class $j extends kt {
        constructor(t) {
          super(t), this.manualDecorators = new yi(), this.automaticDecorators = new kj();
        }
        restoreManualDecoratorStates() {
          for (const t of this.manualDecorators)
            t.value = this._getDecoratorStateFromModel(t.id);
        }
        refresh() {
          const t = this.editor.model, i = t.document.selection, a = i.getSelectedElement() || Fn(i.getSelectedBlocks());
          W0(a, t.schema) ? (this.value = a.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(a, "linkHref")) : (this.value = i.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(i, "linkHref"));
          for (const l of this.manualDecorators)
            l.value = this._getDecoratorStateFromModel(l.id);
        }
        execute(t, i = {}) {
          const a = this.editor.model, l = a.document.selection, d = [], g = [];
          for (const m in i)
            i[m] ? d.push(m) : g.push(m);
          a.change((m) => {
            if (l.isCollapsed) {
              const w = l.getFirstPosition();
              if (l.hasAttribute("linkHref")) {
                const A = xl(w, "linkHref", l.getAttribute("linkHref"), a);
                m.setAttribute("linkHref", t, A), d.forEach((C) => {
                  m.setAttribute(C, !0, A);
                }), g.forEach((C) => {
                  m.removeAttribute(C, A);
                }), m.setSelection(m.createPositionAfter(A.end.nodeBefore));
              } else if (t !== "") {
                const A = Zi(l.getAttributes());
                A.set("linkHref", t), d.forEach((T) => {
                  A.set(T, !0);
                });
                const { end: C } = a.insertContent(m.createText(t, A), w);
                m.setSelection(C);
              }
              ["linkHref", ...d, ...g].forEach((A) => {
                m.removeSelectionAttribute(A);
              });
            } else {
              const w = a.schema.getValidRanges(l.getRanges(), "linkHref"), A = [];
              for (const T of l.getSelectedBlocks())
                a.schema.checkAttribute(T, "linkHref") && A.push(m.createRangeOn(T));
              const C = A.slice();
              for (const T of w)
                this._isRangeToUpdate(T, A) && C.push(T);
              for (const T of C)
                m.setAttribute("linkHref", t, T), d.forEach((R) => {
                  m.setAttribute(R, !0, T);
                }), g.forEach((R) => {
                  m.removeAttribute(R, T);
                });
            }
          });
        }
        _getDecoratorStateFromModel(t) {
          const i = this.editor.model, a = i.document.selection, l = a.getSelectedElement();
          return W0(l, i.schema) ? l.getAttribute(t) : a.getAttribute(t);
        }
        _isRangeToUpdate(t, i) {
          for (const a of i)
            if (a.containsRange(t))
              return !1;
          return !0;
        }
      }
      class Lj extends kt {
        refresh() {
          const t = this.editor.model, i = t.document.selection, a = i.getSelectedElement();
          W0(a, t.schema) ? this.isEnabled = t.schema.checkAttribute(a, "linkHref") : this.isEnabled = t.schema.checkAttributeInSelection(i, "linkHref");
        }
        execute() {
          const t = this.editor, i = this.editor.model, a = i.document.selection, l = t.commands.get("link");
          i.change((d) => {
            const g = a.isCollapsed ? [xl(a.getFirstPosition(), "linkHref", a.getAttribute("linkHref"), i)] : i.schema.getValidRanges(a.getRanges(), "linkHref");
            for (const m of g)
              if (d.removeAttribute("linkHref", m), l)
                for (const w of l.manualDecorators)
                  d.removeAttribute(w.id, m);
          });
        }
      }
      class Ax {
        constructor({ id: t, label: i, attributes: a, classes: l, styles: d, defaultValue: g }) {
          this.id = t, this.set("value"), this.defaultValue = g, this.label = i, this.attributes = a, this.classes = l, this.styles = d;
        }
        _createPattern() {
          return { attributes: this.attributes, classes: this.classes, styles: this.styles };
        }
      }
      E(Ax, Te);
      var Cx = s(9773), jj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Cx.Z, jj), Cx.Z.locals;
      const xx = "automatic", Bj = /^(https?:)?\/\//;
      class Fj extends Ie {
        static get pluginName() {
          return "LinkEditing";
        }
        static get requires() {
          return [DC, AC, io];
        }
        constructor(t) {
          super(t), t.config.define("link", { addTargetToExternalLinks: !1 });
        }
        init() {
          const t = this.editor;
          t.model.schema.extend("$text", { allowAttributes: "linkHref" }), t.conversion.for("dataDowncast").attributeToElement({ model: "linkHref", view: bx }), t.conversion.for("editingDowncast").attributeToElement({ model: "linkHref", view: (a, l) => bx(wx(a), l) }), t.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: { href: !0 } }, model: { key: "linkHref", value: (a) => a.getAttribute("href") } }), t.commands.add("link", new $j(t)), t.commands.add("unlink", new Lj(t));
          const i = function(a, l) {
            const d = { "Open in a new tab": a("Open in a new tab"), Downloadable: a("Downloadable") };
            return l.forEach((g) => (g.label && d[g.label] && (g.label = d[g.label]), g)), l;
          }(t.t, function(a) {
            const l = [];
            if (a)
              for (const [d, g] of Object.entries(a)) {
                const m = Object.assign({}, g, { id: `link${Ij(d)}` });
                l.push(m);
              }
            return l;
          }(t.config.get("link.decorators")));
          this._enableAutomaticDecorators(i.filter((a) => a.mode === xx)), this._enableManualDecorators(i.filter((a) => a.mode === "manual")), t.plugins.get(DC).registerAttribute("linkHref"), function(a, l, d, g) {
            const m = a.editing.view, w = /* @__PURE__ */ new Set();
            m.document.registerPostFixer((A) => {
              const C = a.model.document.selection;
              let T = !1;
              if (C.hasAttribute(l)) {
                const R = xl(C.getFirstPosition(), l, C.getAttribute(l), a.model), j = a.editing.mapper.toViewRange(R);
                for (const F of j.getItems())
                  F.is("element", d) && !F.hasClass(g) && (A.addClass(g, F), w.add(F), T = !0);
              }
              return T;
            }), a.conversion.for("editingDowncast").add((A) => {
              function C() {
                m.change((T) => {
                  for (const R of w.values())
                    T.removeClass(g, R), w.delete(R);
                });
              }
              A.on("insert", C, { priority: "highest" }), A.on("remove", C, { priority: "highest" }), A.on("attribute", C, { priority: "highest" }), A.on("selection", C, { priority: "highest" });
            });
          }(t, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableInsertContentSelectionAttributesFixer(), this._enableClickingAfterLink(), this._enableTypingOverLink(), this._handleDeleteContentAfterLink();
        }
        _enableAutomaticDecorators(t) {
          const i = this.editor, a = i.commands.get("link").automaticDecorators;
          i.config.get("link.addTargetToExternalLinks") && a.add({ id: "linkIsExternal", mode: xx, callback: (l) => Bj.test(l), attributes: { target: "_blank", rel: "noopener noreferrer" } }), a.add(t), a.length && i.conversion.for("downcast").add(a.getDispatcher());
        }
        _enableManualDecorators(t) {
          if (!t.length)
            return;
          const i = this.editor, a = i.commands.get("link").manualDecorators;
          t.forEach((l) => {
            i.model.schema.extend("$text", { allowAttributes: l.id }), l = new Ax(l), a.add(l), i.conversion.for("downcast").attributeToElement({ model: l.id, view: (d, { writer: g, schema: m }, { item: w }) => {
              if ((w.is("selection") || m.isInline(w)) && d) {
                const A = g.createAttributeElement("a", l.attributes, { priority: 5 });
                l.classes && g.addClass(l.classes, A);
                for (const C in l.styles)
                  g.setStyle(C, l.styles[C], A);
                return g.setCustomProperty("link", !0, A), A;
              }
            } }), i.conversion.for("upcast").elementToAttribute({ view: { name: "a", ...l._createPattern() }, model: { key: l.id } });
          });
        }
        _enableLinkOpen() {
          const t = this.editor, i = t.editing.view.document;
          this.listenTo(i, "click", (a, l) => {
            if (!(p.isMac ? l.domEvent.metaKey : l.domEvent.ctrlKey))
              return;
            let d = l.domTarget;
            if (d.tagName.toLowerCase() != "a" && (d = d.closest("a")), !d)
              return;
            const g = d.getAttribute("href");
            g && (a.stop(), l.preventDefault(), _x(g));
          }, { context: "$capture" }), this.listenTo(i, "keydown", (a, l) => {
            const d = t.commands.get("link").value;
            d && l.keyCode === St.enter && l.altKey && (a.stop(), _x(d));
          });
        }
        _enableInsertContentSelectionAttributesFixer() {
          const t = this.editor.model, i = t.document.selection;
          this.listenTo(t, "insertContent", () => {
            const a = i.anchor.nodeBefore, l = i.anchor.nodeAfter;
            i.hasAttribute("linkHref") && a && a.hasAttribute("linkHref") && (l && l.hasAttribute("linkHref") || t.change((d) => {
              G0(d, q0(t.schema));
            }));
          }, { priority: "low" });
        }
        _enableClickingAfterLink() {
          const t = this.editor, i = t.model;
          t.editing.view.addObserver(u0);
          let a = !1;
          this.listenTo(t.editing.view.document, "mousedown", () => {
            a = !0;
          }), this.listenTo(t.editing.view.document, "selectionChange", () => {
            if (!a)
              return;
            a = !1;
            const l = i.document.selection;
            if (!l.isCollapsed || !l.hasAttribute("linkHref"))
              return;
            const d = l.getFirstPosition(), g = xl(d, "linkHref", l.getAttribute("linkHref"), i);
            (d.isTouching(g.start) || d.isTouching(g.end)) && i.change((m) => {
              G0(m, q0(i.schema));
            });
          });
        }
        _enableTypingOverLink() {
          const t = this.editor, i = t.editing.view;
          let a, l;
          this.listenTo(i.document, "delete", () => {
            l = !0;
          }, { priority: "high" }), this.listenTo(t.model, "deleteContent", () => {
            const d = t.model.document.selection;
            d.isCollapsed || (l ? l = !1 : Ex(t) && function(g) {
              const m = g.document.selection, w = m.getFirstPosition(), A = m.getLastPosition(), C = w.nodeAfter;
              if (!C || !C.is("$text") || !C.hasAttribute("linkHref"))
                return !1;
              const T = A.textNode || A.nodeBefore;
              return C === T ? !0 : xl(w, "linkHref", C.getAttribute("linkHref"), g).containsRange(g.createRange(w, A), !0);
            }(t.model) && (a = d.getAttributes()));
          }, { priority: "high" }), this.listenTo(t.model, "insertContent", (d, [g]) => {
            l = !1, Ex(t) && a && (t.model.change((m) => {
              for (const [w, A] of a)
                m.setAttribute(w, A, g);
            }), a = null);
          }, { priority: "high" });
        }
        _handleDeleteContentAfterLink() {
          const t = this.editor, i = t.model, a = i.document.selection, l = t.editing.view;
          let d = !1, g = !1;
          this.listenTo(l.document, "delete", (m, w) => {
            g = w.direction === "backward";
          }, { priority: "high" }), this.listenTo(i, "deleteContent", () => {
            d = !1;
            const m = a.getFirstPosition(), w = a.getAttribute("linkHref");
            if (!w)
              return;
            const A = xl(m, "linkHref", w, i);
            d = A.containsPosition(m) || A.end.isEqual(m);
          }, { priority: "high" }), this.listenTo(i, "deleteContent", () => {
            g && (g = !1, d || t.model.enqueueChange((m) => {
              G0(m, q0(i.schema));
            }));
          }, { priority: "low" });
        }
      }
      function G0(c, t) {
        c.removeSelectionAttribute("linkHref");
        for (const i of t)
          c.removeSelectionAttribute(i);
      }
      function Ex(c) {
        return c.model.change((t) => t.batch).isTyping;
      }
      function q0(c) {
        return c.getDefinition("$text").allowAttributes.filter((t) => t.startsWith("link"));
      }
      var Sx = s(7754), zj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Sx.Z, zj), Sx.Z.locals;
      class Vj extends At {
        constructor(t, i) {
          super(t);
          const a = t.t;
          this.focusTracker = new Kr(), this.keystrokes = new Qi(), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(a("Save"), Nn.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(a("Cancel"), Nn.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(i), this.children = this._createFormChildren(i.manualDecorators), this._focusables = new ls(), this._focusCycler = new _l({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } });
          const l = ["ck", "ck-link-form", "ck-responsive-form"];
          i.manualDecorators.length && l.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({ tag: "form", attributes: { class: l, tabindex: "-1" }, children: this.children }), b0(this);
        }
        getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce((t, i) => (t[i.name] = i.isOn, t), {});
        }
        render() {
          super.render(), w0({ view: this }), [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach((t) => {
            this._focusables.add(t), this.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createUrlInput() {
          const t = this.locale.t, i = new C0(this.locale, x0);
          return i.label = t("Link URL"), i;
        }
        _createButton(t, i, a, l) {
          const d = new cn(this.locale);
          return d.set({ label: t, icon: i, tooltip: !0 }), d.extendTemplate({ attributes: { class: a } }), l && d.delegate("execute").to(this, l), d;
        }
        _createManualDecoratorSwitches(t) {
          const i = this.createCollection();
          for (const a of t.manualDecorators) {
            const l = new Dh(this.locale);
            l.set({ name: a.id, label: a.label, withText: !0 }), l.bind("isOn").toMany([a, t], "value", (d, g) => g === void 0 && d === void 0 ? a.defaultValue : d), l.on("execute", () => {
              a.set("value", !l.isOn);
            }), i.add(l);
          }
          return i;
        }
        _createFormChildren(t) {
          const i = this.createCollection();
          if (i.add(this.urlInputView), t.length) {
            const a = new At();
            a.setTemplate({ tag: "ul", children: this._manualDecoratorSwitches.map((l) => ({ tag: "li", children: [l], attributes: { class: ["ck", "ck-list__item"] } })), attributes: { class: ["ck", "ck-reset", "ck-list"] } }), i.add(a);
          }
          return i.add(this.saveButtonView), i.add(this.cancelButtonView), i;
        }
      }
      var Mx = s(2347), Hj = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Mx.Z, Hj), Mx.Z.locals;
      class Uj extends At {
        constructor(t) {
          super(t);
          const i = t.t;
          this.focusTracker = new Kr(), this.keystrokes = new Qi(), this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(i("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), this.editButtonView = this._createButton(i("Edit link"), Nn.pencil, "edit"), this.set("href"), this._focusables = new ls(), this._focusCycler = new _l({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-link-actions", "ck-responsive-form"], tabindex: "-1" }, children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView] });
        }
        render() {
          super.render(), [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach((t) => {
            this._focusables.add(t), this.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        _createButton(t, i, a) {
          const l = new cn(this.locale);
          return l.set({ label: t, icon: i, tooltip: !0 }), l.delegate("execute").to(this, a), l;
        }
        _createPreviewButton() {
          const t = new cn(this.locale), i = this.bindTemplate, a = this.t;
          return t.set({ withText: !0, tooltip: a("Open link in new tab") }), t.extendTemplate({ attributes: { class: ["ck", "ck-link-actions__preview"], href: i.to("href", (l) => l && wx(l)), target: "_blank", rel: "noopener noreferrer" } }), t.bind("label").to(this, "href", (l) => l || a("This link has no URL")), t.bind("isEnabled").to(this, "href", (l) => !!l), t.template.tag = "a", t.template.eventListeners = {}, t;
        }
      }
      const oo = "link-ui";
      class Wj extends Ie {
        static get requires() {
          return [Ph];
        }
        static get pluginName() {
          return "LinkUI";
        }
        init() {
          const t = this.editor;
          t.editing.view.addObserver(A6), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(Ph), this._createToolbarLinkButton(), this._enableUserBalloonInteractions(), t.conversion.for("editingDowncast").markerToHighlight({ model: oo, view: { classes: ["ck-fake-link-selection"] } }), t.conversion.for("editingDowncast").markerToElement({ model: oo, view: { name: "span", classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"] } });
        }
        destroy() {
          super.destroy(), this.formView.destroy();
        }
        _createActionsView() {
          const t = this.editor, i = new Uj(t.locale), a = t.commands.get("link"), l = t.commands.get("unlink");
          return i.bind("href").to(a, "value"), i.editButtonView.bind("isEnabled").to(a), i.unlinkButtonView.bind("isEnabled").to(l), this.listenTo(i, "edit", () => {
            this._addFormView();
          }), this.listenTo(i, "unlink", () => {
            t.execute("unlink"), this._hideUI();
          }), i.keystrokes.set("Esc", (d, g) => {
            this._hideUI(), g();
          }), i.keystrokes.set(U0, (d, g) => {
            this._addFormView(), g();
          }), i;
        }
        _createFormView() {
          const t = this.editor, i = t.commands.get("link"), a = t.config.get("link.defaultProtocol"), l = new Vj(t.locale, i);
          return l.urlInputView.fieldView.bind("value").to(i, "value"), l.urlInputView.bind("isReadOnly").to(i, "isEnabled", (d) => !d), l.saveButtonView.bind("isEnabled").to(i), this.listenTo(l, "submit", () => {
            const { value: d } = l.urlInputView.fieldView.element, g = yx(d, a);
            t.execute("link", g, l.getDecoratorSwitchesState()), this._closeFormView();
          }), this.listenTo(l, "cancel", () => {
            this._closeFormView();
          }), l.keystrokes.set("Esc", (d, g) => {
            this._closeFormView(), g();
          }), l;
        }
        _createToolbarLinkButton() {
          const t = this.editor, i = t.commands.get("link"), a = t.t;
          t.keystrokes.set(U0, (l, d) => {
            d(), i.isEnabled && this._showUI(!0);
          }), t.ui.componentFactory.add("link", (l) => {
            const d = new cn(l);
            return d.isEnabled = !0, d.label = a("Link"), d.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>', d.keystroke = U0, d.tooltip = !0, d.isToggleable = !0, d.bind("isEnabled").to(i, "isEnabled"), d.bind("isOn").to(i, "value", (g) => !!g), this.listenTo(d, "execute", () => this._showUI(!0)), d;
          });
        }
        _enableUserBalloonInteractions() {
          const t = this.editor.editing.view.document;
          this.listenTo(t, "click", () => {
            this._getSelectedLinkElement() && this._showUI();
          }), this.editor.keystrokes.set("Tab", (i, a) => {
            this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), a());
          }, { priority: "high" }), this.editor.keystrokes.set("Esc", (i, a) => {
            this._isUIVisible && (this._hideUI(), a());
          }), v0({ emitter: this.formView, activator: () => this._isUIInPanel, contextElements: [this._balloon.view.element], callback: () => this._hideUI() });
        }
        _addActionsView() {
          this._areActionsInPanel || this._balloon.add({ view: this.actionsView, position: this._getBalloonPositionData() });
        }
        _addFormView() {
          if (this._isFormInPanel)
            return;
          const t = this.editor.commands.get("link");
          this.formView.disableCssTransitions(), this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() }), this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions(), this.formView.urlInputView.fieldView.element.value = t.value || "";
        }
        _closeFormView() {
          const t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates(), t.value !== void 0 ? this._removeFormView() : this._hideUI();
        }
        _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
        }
        _showUI(t = !1) {
          this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
        }
        _hideUI() {
          if (!this._isUIInPanel)
            return;
          const t = this.editor;
          this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
        }
        _startUpdatingUI() {
          const t = this.editor, i = t.editing.view.document;
          let a = this._getSelectedLinkElement(), l = g();
          const d = () => {
            const m = this._getSelectedLinkElement(), w = g();
            a && !m || !a && w !== l ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), a = m, l = w;
          };
          function g() {
            return i.selection.focus.getAncestors().reverse().find((m) => m.is("element"));
          }
          this.listenTo(t.ui, "update", d), this.listenTo(this._balloon, "change:visibleView", d);
        }
        get _isFormInPanel() {
          return this._balloon.hasView(this.formView);
        }
        get _areActionsInPanel() {
          return this._balloon.hasView(this.actionsView);
        }
        get _areActionsVisible() {
          return this._balloon.visibleView === this.actionsView;
        }
        get _isUIInPanel() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
        get _isUIVisible() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
        _getBalloonPositionData() {
          const t = this.editor.editing.view, i = this.editor.model, a = t.document;
          let l = null;
          if (i.markers.has(oo)) {
            const d = Array.from(this.editor.editing.mapper.markerNameToElements(oo)), g = t.createRange(t.createPositionBefore(d[0]), t.createPositionAfter(d[d.length - 1]));
            l = t.domConverter.viewRangeToDom(g);
          } else
            l = () => {
              const d = this._getSelectedLinkElement();
              return d ? t.domConverter.mapViewToDom(d) : t.domConverter.viewRangeToDom(a.selection.getFirstRange());
            };
          return { target: l };
        }
        _getSelectedLinkElement() {
          const t = this.editor.editing.view, i = t.document.selection, a = i.getSelectedElement();
          if (i.isCollapsed || a && xn(a))
            return K0(i.getFirstPosition());
          {
            const l = i.getFirstRange().getTrimmed(), d = K0(l.start), g = K0(l.end);
            return d && d == g && t.createRangeIn(d).getTrimmed().isEqual(l) ? d : null;
          }
        }
        _showFakeVisualSelection() {
          const t = this.editor.model;
          t.change((i) => {
            const a = t.document.selection.getFirstRange();
            if (t.markers.has(oo))
              i.updateMarker(oo, { range: a });
            else if (a.start.isAtEnd) {
              const l = a.start.getLastMatchingPosition(({ item: d }) => !t.schema.isContent(d), { boundaries: a });
              i.addMarker(oo, { usingOperation: !1, affectsData: !1, range: i.createRange(l, a.end) });
            } else
              i.addMarker(oo, { usingOperation: !1, affectsData: !1, range: a });
          });
        }
        _hideFakeVisualSelection() {
          const t = this.editor.model;
          t.markers.has(oo) && t.change((i) => {
            i.removeMarker(oo);
          });
        }
      }
      function K0(c) {
        return c.getAncestors().find((t) => {
          return (i = t).is("attributeElement") && !!i.getCustomProperty("link");
          var i;
        });
      }
      const Gj = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
      class qj extends Ie {
        static get requires() {
          return [ha];
        }
        static get pluginName() {
          return "AutoLink";
        }
        init() {
          const t = this.editor.model.document.selection;
          t.on("change:range", () => {
            this.isEnabled = !t.anchor.parent.is("element", "codeBlock");
          }), this._enableTypingHandling();
        }
        afterInit() {
          this._enableEnterHandling(), this._enableShiftEnterHandling();
        }
        _enableTypingHandling() {
          const t = this.editor, i = new TC(t.model, (a) => {
            if (!function(d) {
              return d.length > 4 && d[d.length - 1] === " " && d[d.length - 2] !== " ";
            }(a))
              return;
            const l = Tx(a.substr(0, a.length - 1));
            return l ? { url: l } : void 0;
          });
          i.on("matched:data", (a, l) => {
            const { batch: d, range: g, url: m } = l;
            if (!d.isTyping)
              return;
            const w = g.end.getShiftedBy(-1), A = w.getShiftedBy(-m.length), C = t.model.createRange(A, w);
            this._applyAutoLink(m, C);
          }), i.bind("isEnabled").to(this);
        }
        _enableEnterHandling() {
          const t = this.editor, i = t.model, a = t.commands.get("enter");
          a && a.on("execute", () => {
            const l = i.document.selection.getFirstPosition();
            if (!l.parent.previousSibling)
              return;
            const d = i.createRangeIn(l.parent.previousSibling);
            this._checkAndApplyAutoLinkOnRange(d);
          });
        }
        _enableShiftEnterHandling() {
          const t = this.editor, i = t.model, a = t.commands.get("shiftEnter");
          a && a.on("execute", () => {
            const l = i.document.selection.getFirstPosition(), d = i.createRange(i.createPositionAt(l.parent, 0), l.getShiftedBy(-1));
            this._checkAndApplyAutoLinkOnRange(d);
          });
        }
        _checkAndApplyAutoLinkOnRange(t) {
          const i = this.editor.model, { text: a, range: l } = MC(t, i), d = Tx(a);
          if (d) {
            const g = i.createRange(l.end.getShiftedBy(-d.length), l.end);
            this._applyAutoLink(d, g);
          }
        }
        _applyAutoLink(t, i) {
          const a = this.editor.model, l = yx(t, this.editor.config.get("link.defaultProtocol"));
          this.isEnabled && function(d, g) {
            return g.schema.checkAttributeInSelection(g.createSelection(d), "linkHref");
          }(i, a) && kx(l) && !function(d) {
            const g = d.start.nodeAfter;
            return g && g.hasAttribute("linkHref");
          }(i) && this._persistAutoLink(l, i);
        }
        _persistAutoLink(t, i) {
          const a = this.editor.model, l = this.editor.plugins.get("Delete");
          a.enqueueChange((d) => {
            d.setAttribute("linkHref", t, i), a.enqueueChange(() => {
              l.requestUndoOnBackspace();
            });
          });
        }
      }
      function Tx(c) {
        const t = Gj.exec(c);
        return t ? t[2] : null;
      }
      class Dx extends kt {
        constructor(t, i) {
          super(t), this.type = i;
        }
        refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
        execute(t = {}) {
          const i = this.editor.model, a = i.document, l = Array.from(a.selection.getSelectedBlocks()).filter((g) => Px(g, i.schema)), d = t.forceValue !== void 0 ? !t.forceValue : this.value;
          i.change((g) => {
            if (d) {
              let m = l[l.length - 1].nextSibling, w = Number.POSITIVE_INFINITY, A = [];
              for (; m && m.name == "listItem" && m.getAttribute("listIndent") !== 0; ) {
                const C = m.getAttribute("listIndent");
                C < w && (w = C);
                const T = C - w;
                A.push({ element: m, listIndent: T }), m = m.nextSibling;
              }
              A = A.reverse();
              for (const C of A)
                g.setAttribute("listIndent", C.listIndent, C.element);
            }
            if (!d) {
              let m = Number.POSITIVE_INFINITY;
              for (const w of l)
                w.is("element", "listItem") && w.getAttribute("listIndent") < m && (m = w.getAttribute("listIndent"));
              m = m === 0 ? 1 : m, Ix(l, !0, m), Ix(l, !1, m);
            }
            for (const m of l.reverse())
              d && m.name == "listItem" ? g.rename(m, "paragraph") : d || m.name == "listItem" ? d || m.name != "listItem" || m.getAttribute("listType") == this.type || g.setAttribute("listType", this.type, m) : (g.setAttributes({ listType: this.type, listIndent: 0 }, m), g.rename(m, "listItem"));
            this.fire("_executeCleanup", l);
          });
        }
        _getValue() {
          const t = Fn(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type;
        }
        _checkEnabled() {
          if (this.value)
            return !0;
          const t = this.editor.model.document.selection, i = this.editor.model.schema, a = Fn(t.getSelectedBlocks());
          return !!a && Px(a, i);
        }
      }
      function Ix(c, t, i) {
        const a = t ? c[0] : c[c.length - 1];
        if (a.is("element", "listItem")) {
          let l = a[t ? "previousSibling" : "nextSibling"], d = a.getAttribute("listIndent");
          for (; l && l.is("element", "listItem") && l.getAttribute("listIndent") >= i; )
            d > l.getAttribute("listIndent") && (d = l.getAttribute("listIndent")), l.getAttribute("listIndent") == d && c[t ? "unshift" : "push"](l), l = l[t ? "previousSibling" : "nextSibling"];
        }
      }
      function Px(c, t) {
        return t.checkChild(c.parent, "listItem") && !t.isObject(c);
      }
      class Ox extends kt {
        constructor(t, i) {
          super(t), this._indentBy = i == "forward" ? 1 : -1;
        }
        refresh() {
          this.isEnabled = this._checkEnabled();
        }
        execute() {
          const t = this.editor.model, i = t.document;
          let a = Array.from(i.selection.getSelectedBlocks());
          t.change((l) => {
            const d = a[a.length - 1];
            let g = d.nextSibling;
            for (; g && g.name == "listItem" && g.getAttribute("listIndent") > d.getAttribute("listIndent"); )
              a.push(g), g = g.nextSibling;
            this._indentBy < 0 && (a = a.reverse());
            for (const m of a) {
              const w = m.getAttribute("listIndent") + this._indentBy;
              w < 0 ? l.rename(m, "paragraph") : l.setAttribute("listIndent", w, m);
            }
            this.fire("_executeCleanup", a);
          });
        }
        _checkEnabled() {
          const t = Fn(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("element", "listItem"))
            return !1;
          if (this._indentBy > 0) {
            const i = t.getAttribute("listIndent"), a = t.getAttribute("listType");
            let l = t.previousSibling;
            for (; l && l.is("element", "listItem") && l.getAttribute("listIndent") >= i; ) {
              if (l.getAttribute("listIndent") == i)
                return l.getAttribute("listType") == a;
              l = l.previousSibling;
            }
            return !1;
          }
          return !0;
        }
      }
      function Kj(c, t) {
        const i = t.mapper, a = t.writer, l = c.getAttribute("listType") == "numbered" ? "ol" : "ul", d = function(m) {
          const w = m.createContainerElement("li");
          return w.getFillerOffset = Zj, w;
        }(a), g = a.createContainerElement(l, null);
        return a.insert(a.createPositionAt(g, 0), d), i.bindElements(c, d), d;
      }
      function Rx(c, t, i, a) {
        const l = t.parent, d = i.mapper, g = i.writer;
        let m = d.toViewPosition(a.createPositionBefore(c));
        const w = $x(c.previousSibling, { sameIndent: !0, smallerIndent: !0, listIndent: c.getAttribute("listIndent") }), A = c.previousSibling;
        if (w && w.getAttribute("listIndent") == c.getAttribute("listIndent")) {
          const C = d.toViewElement(w);
          m = g.breakContainer(g.createPositionAfter(C));
        } else if (A && A.name == "listItem") {
          m = d.toViewPosition(a.createPositionAt(A, "end"));
          const C = d.findMappedViewAncestor(m), T = function(R) {
            for (const j of R.getChildren())
              if (j.name == "ul" || j.name == "ol")
                return j;
            return null;
          }(C);
          m = T ? g.createPositionBefore(T) : g.createPositionAt(C, "end");
        } else
          m = d.toViewPosition(a.createPositionBefore(c));
        if (m = Nx(m), g.insert(m, l), A && A.name == "listItem") {
          const C = d.toViewElement(A), T = g.createRange(g.createPositionAt(C, 0), m).getWalker({ ignoreElementEnd: !0 });
          for (const R of T)
            if (R.item.is("element", "li")) {
              const j = g.breakContainer(g.createPositionBefore(R.item)), F = R.item.parent, V = g.createPositionAt(t, "end");
              Zr(g, V.nodeBefore, V.nodeAfter), g.move(g.createRangeOn(F), V), T.position = j;
            }
        } else {
          const C = l.nextSibling;
          if (C && (C.is("element", "ul") || C.is("element", "ol"))) {
            let T = null;
            for (const R of C.getChildren()) {
              const j = d.toModelElement(R);
              if (!(j && j.getAttribute("listIndent") > c.getAttribute("listIndent")))
                break;
              T = R;
            }
            T && (g.breakContainer(g.createPositionAfter(T)), g.move(g.createRangeOn(T.parent), g.createPositionAt(t, "end")));
          }
        }
        Zr(g, l, l.nextSibling), Zr(g, l.previousSibling, l);
      }
      function Zr(c, t, i) {
        return !t || !i || t.name != "ul" && t.name != "ol" || t.name != i.name || t.getAttribute("class") !== i.getAttribute("class") ? null : c.mergeContainers(c.createPositionAfter(t));
      }
      function Nx(c) {
        return c.getLastMatchingPosition((t) => t.item.is("uiElement"));
      }
      function $x(c, t) {
        const i = !!t.sameIndent, a = !!t.smallerIndent, l = t.listIndent;
        let d = c;
        for (; d && d.name == "listItem"; ) {
          const g = d.getAttribute("listIndent");
          if (i && l == g || a && l > g)
            return d;
          d = t.direction === "forward" ? d.nextSibling : d.previousSibling;
        }
        return null;
      }
      function Lx(c, t, i, a) {
        c.ui.componentFactory.add(t, (l) => {
          const d = c.commands.get(t), g = new cn(l);
          return g.set({ label: i, icon: a, tooltip: !0, isToggleable: !0 }), g.bind("isOn", "isEnabled").to(d, "value", "isEnabled"), g.on("execute", () => {
            c.execute(t), c.editing.view.focus();
          }), g;
        });
      }
      function Y0(c, t) {
        const i = [], a = c.parent, l = { ignoreElementEnd: !1, startPosition: c, shallow: !0, direction: t }, d = a.getAttribute("listIndent"), g = [...new no(l)].filter((m) => m.item.is("element")).map((m) => m.item);
        for (const m of g) {
          if (!m.is("element", "listItem") || m.getAttribute("listIndent") < d)
            break;
          if (!(m.getAttribute("listIndent") > d)) {
            if (m.getAttribute("listType") !== a.getAttribute("listType") || m.getAttribute("listStyle") !== a.getAttribute("listStyle") || m.getAttribute("listReversed") !== a.getAttribute("listReversed") || m.getAttribute("listStart") !== a.getAttribute("listStart"))
              break;
            t === "backward" ? i.unshift(m) : i.push(m);
          }
        }
        return i;
      }
      const Yj = ["disc", "circle", "square"], Qj = ["decimal", "decimal-leading-zero", "lower-roman", "upper-roman", "lower-latin", "upper-latin"];
      function Zj() {
        const c = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol");
        return this.isEmpty || c ? 0 : Jk.call(this);
      }
      class Xj extends Ie {
        static get pluginName() {
          return "ListUtils";
        }
        getListTypeFromListStyleType(t) {
          return function(i) {
            return Yj.includes(i) ? "bulleted" : Qj.includes(i) ? "numbered" : null;
          }(t);
        }
        getSelectedListItems(t) {
          return function(i) {
            let a = [...i.document.selection.getSelectedBlocks()].filter((l) => l.is("element", "listItem")).map((l) => {
              const d = i.change((g) => g.createPositionAt(l, 0));
              return [...Y0(d, "backward"), ...Y0(d, "forward")];
            }).flat();
            return a = [...new Set(a)], a;
          }(t);
        }
        getSiblingNodes(t, i) {
          return Y0(t, i);
        }
      }
      function jx(c) {
        return (t, i, a) => {
          const l = a.consumable;
          if (!l.test(i.item, "insert") || !l.test(i.item, "attribute:listType") || !l.test(i.item, "attribute:listIndent"))
            return;
          l.consume(i.item, "insert"), l.consume(i.item, "attribute:listType"), l.consume(i.item, "attribute:listIndent");
          const d = i.item;
          Rx(d, Kj(d, a), a, c);
        };
      }
      function Jj(c, t, i) {
        if (!i.consumable.test(t.item, c.name))
          return;
        const a = i.mapper.toViewElement(t.item), l = i.writer;
        l.breakContainer(l.createPositionBefore(a)), l.breakContainer(l.createPositionAfter(a));
        const d = a.parent, g = t.attributeNewValue == "numbered" ? "ol" : "ul";
        l.rename(g, d);
      }
      function eB(c, t, i) {
        i.consumable.consume(t.item, c.name);
        const a = i.mapper.toViewElement(t.item).parent, l = i.writer;
        Zr(l, a, a.nextSibling), Zr(l, a.previousSibling, a);
      }
      function Bx(c, t, i) {
        if (i.consumable.test(t.item, c.name) && t.item.name != "listItem") {
          let a = i.mapper.toViewPosition(t.range.start);
          const l = i.writer, d = [];
          for (; (a.parent.name == "ul" || a.parent.name == "ol") && (a = l.breakContainer(a), a.parent.name == "li"); ) {
            const g = a, m = l.createPositionAt(a.parent, "end");
            if (!g.isEqual(m)) {
              const w = l.remove(l.createRange(g, m));
              d.push(w);
            }
            a = l.createPositionAfter(a.parent);
          }
          if (d.length > 0) {
            for (let g = 0; g < d.length; g++) {
              const m = a.nodeBefore;
              if (a = l.insert(a, d[g]).end, g > 0) {
                const w = Zr(l, m, m.nextSibling);
                w && w.parent == m && a.offset--;
              }
            }
            Zr(l, a.nodeBefore, a.nodeAfter);
          }
        }
      }
      function tB(c, t, i) {
        const a = i.mapper.toViewPosition(t.position), l = a.nodeBefore, d = a.nodeAfter;
        Zr(i.writer, l, d);
      }
      function nB(c, t, i) {
        if (i.consumable.consume(t.viewItem, { name: !0 })) {
          const a = i.writer, l = a.createElement("listItem"), d = function(w) {
            let A = 0, C = w.parent;
            for (; C; ) {
              if (C.is("element", "li"))
                A++;
              else {
                const T = C.previousSibling;
                T && T.is("element", "li") && A++;
              }
              C = C.parent;
            }
            return A;
          }(t.viewItem);
          a.setAttribute("listIndent", d, l);
          const g = t.viewItem.parent && t.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
          if (a.setAttribute("listType", g, l), !i.safeInsert(l, t.modelCursor))
            return;
          const m = function(w, A, C) {
            const { writer: T, schema: R } = C;
            let j = T.createPositionAfter(w);
            for (const F of A)
              if (F.name == "ul" || F.name == "ol")
                j = C.convertItem(F, j).modelCursor;
              else {
                const V = C.convertItem(F, T.createPositionAt(w, "end")), W = V.modelRange.start.nodeAfter;
                W && W.is("element") && !R.checkChild(w, W.name) && (w = V.modelCursor.parent.is("element", "listItem") ? V.modelCursor.parent : oB(V.modelCursor), j = T.createPositionAfter(w));
              }
            return j;
          }(l, t.viewItem.getChildren(), i);
          t.modelRange = a.createRange(t.modelCursor, m), i.updateConversionResult(l, t);
        }
      }
      function Fx(c, t, i) {
        if (i.consumable.test(t.viewItem, { name: !0 })) {
          const a = Array.from(t.viewItem.getChildren());
          for (const l of a)
            !(l.is("element", "li") || Tl(l)) && l._remove();
        }
      }
      function rB(c, t, i) {
        if (i.consumable.test(t.viewItem, { name: !0 })) {
          if (t.viewItem.childCount === 0)
            return;
          const a = [...t.viewItem.getChildren()];
          let l = !1;
          for (const d of a)
            l && !Tl(d) && d._remove(), Tl(d) && (l = !0);
        }
      }
      function zx(c) {
        return (t, i) => {
          if (i.isPhantom)
            return;
          const a = i.modelPosition.nodeBefore;
          if (a && a.is("element", "listItem")) {
            const l = i.mapper.toViewElement(a), d = l.getAncestors().find(Tl), g = c.createPositionAt(l, 0).getWalker();
            for (const m of g) {
              if (m.type == "elementStart" && m.item.is("element", "li")) {
                i.viewPosition = m.previousPosition;
                break;
              }
              if (m.type == "elementEnd" && m.item == d) {
                i.viewPosition = m.nextPosition;
                break;
              }
            }
          }
        };
      }
      function iB(c, [t, i, a]) {
        let l, d = t.is("documentFragment") ? t.getChild(0) : t;
        if (l = i ? this.createSelection(i, a) : this.document.selection, d && d.is("element", "listItem")) {
          const g = l.getFirstPosition();
          let m = null;
          if (g.parent.is("element", "listItem") ? m = g.parent : g.nodeBefore && g.nodeBefore.is("element", "listItem") && (m = g.nodeBefore), m) {
            const w = m.getAttribute("listIndent");
            if (w > 0)
              for (; d && d.is("element", "listItem"); )
                d._setAttribute("listIndent", d.getAttribute("listIndent") + w), d = d.nextSibling;
          }
        }
      }
      function oB(c) {
        const t = new no({ startPosition: c });
        let i;
        do
          i = t.next();
        while (!i.value.item.is("element", "listItem"));
        return i.value.item;
      }
      function Vx(c, t, i, a, l, d) {
        const g = $x(t.nodeBefore, { sameIndent: !0, smallerIndent: !0, listIndent: c, foo: "b" }), m = l.mapper, w = l.writer, A = g ? g.getAttribute("listIndent") : null;
        let C;
        if (g)
          if (A == c) {
            const T = m.toViewElement(g).parent;
            C = w.createPositionAfter(T);
          } else {
            const T = d.createPositionAt(g, "end");
            C = m.toViewPosition(T);
          }
        else
          C = i;
        C = Nx(C);
        for (const T of [...a.getChildren()])
          Tl(T) && (C = w.move(w.createRangeOn(T), C).end, Zr(w, T, T.nextSibling), Zr(w, T.previousSibling, T));
      }
      function Tl(c) {
        return c.is("element", "ol") || c.is("element", "ul");
      }
      class aB extends Ie {
        static get pluginName() {
          return "ListEditing";
        }
        static get requires() {
          return [$h, ha, Xj];
        }
        init() {
          const t = this.editor;
          t.model.schema.register("listItem", { inheritAllFrom: "$block", allowAttributes: ["listType", "listIndent"] });
          const i = t.data, a = t.editing;
          var l;
          t.model.document.registerPostFixer((g) => function(m, w) {
            const A = m.document.differ.getChanges(), C = /* @__PURE__ */ new Map();
            let T = !1;
            for (const V of A)
              if (V.type == "insert" && V.name == "listItem")
                R(V.position);
              else if (V.type == "insert" && V.name != "listItem") {
                if (V.name != "$text") {
                  const W = V.position.nodeAfter;
                  W.hasAttribute("listIndent") && (w.removeAttribute("listIndent", W), T = !0), W.hasAttribute("listType") && (w.removeAttribute("listType", W), T = !0), W.hasAttribute("listStyle") && (w.removeAttribute("listStyle", W), T = !0), W.hasAttribute("listReversed") && (w.removeAttribute("listReversed", W), T = !0), W.hasAttribute("listStart") && (w.removeAttribute("listStart", W), T = !0);
                  for (const ee of Array.from(m.createRangeIn(W)).filter((le) => le.item.is("element", "listItem")))
                    R(ee.previousPosition);
                }
                R(V.position.getShiftedBy(V.length));
              } else
                V.type == "remove" && V.name == "listItem" ? R(V.position) : (V.type == "attribute" && V.attributeKey == "listIndent" || V.type == "attribute" && V.attributeKey == "listType") && R(V.range.start);
            for (const V of C.values())
              j(V), F(V);
            return T;
            function R(V) {
              const W = V.nodeBefore;
              if (W && W.is("element", "listItem")) {
                let ee = W;
                if (C.has(ee))
                  return;
                for (let le = ee.previousSibling; le && le.is("element", "listItem"); le = ee.previousSibling)
                  if (ee = le, C.has(ee))
                    return;
                C.set(W, ee);
              } else {
                const ee = V.nodeAfter;
                ee && ee.is("element", "listItem") && C.set(ee, ee);
              }
            }
            function j(V) {
              let W = 0, ee = null;
              for (; V && V.is("element", "listItem"); ) {
                const le = V.getAttribute("listIndent");
                if (le > W) {
                  let be;
                  ee === null ? (ee = le - W, be = W) : (ee > le && (ee = le), be = le - ee), w.setAttribute("listIndent", be, V), T = !0;
                } else
                  ee = null, W = V.getAttribute("listIndent") + 1;
                V = V.nextSibling;
              }
            }
            function F(V) {
              let W = [], ee = null;
              for (; V && V.is("element", "listItem"); ) {
                const le = V.getAttribute("listIndent");
                if (ee && ee.getAttribute("listIndent") > le && (W = W.slice(0, le + 1)), le != 0)
                  if (W[le]) {
                    const be = W[le];
                    V.getAttribute("listType") != be && (w.setAttribute("listType", be, V), T = !0);
                  } else
                    W[le] = V.getAttribute("listType");
                ee = V, V = V.nextSibling;
              }
            }
          }(t.model, g)), a.mapper.registerViewToModelLength("li", Q0), i.mapper.registerViewToModelLength("li", Q0), a.mapper.on("modelToViewPosition", zx(a.view)), a.mapper.on("viewToModelPosition", (l = t.model, (g, m) => {
            const w = m.viewPosition, A = w.parent, C = m.mapper;
            if (A.name == "ul" || A.name == "ol") {
              if (w.isAtEnd) {
                const T = C.toModelElement(w.nodeBefore), R = C.getModelLength(w.nodeBefore);
                m.modelPosition = l.createPositionBefore(T).getShiftedBy(R);
              } else {
                const T = C.toModelElement(w.nodeAfter);
                m.modelPosition = l.createPositionBefore(T);
              }
              g.stop();
            } else if (A.name == "li" && w.nodeBefore && (w.nodeBefore.name == "ul" || w.nodeBefore.name == "ol")) {
              const T = C.toModelElement(A);
              let R = 1, j = w.nodeBefore;
              for (; j && Tl(j); )
                R += C.getModelLength(j), j = j.previousSibling;
              m.modelPosition = l.createPositionBefore(T).getShiftedBy(R), g.stop();
            }
          })), i.mapper.on("modelToViewPosition", zx(a.view)), t.conversion.for("editingDowncast").add((g) => {
            g.on("insert", Bx, { priority: "high" }), g.on("insert:listItem", jx(t.model)), g.on("attribute:listType:listItem", Jj, { priority: "high" }), g.on("attribute:listType:listItem", eB, { priority: "low" }), g.on("attribute:listIndent:listItem", function(m) {
              return (w, A, C) => {
                if (!C.consumable.consume(A.item, "attribute:listIndent"))
                  return;
                const T = C.mapper.toViewElement(A.item), R = C.writer;
                R.breakContainer(R.createPositionBefore(T)), R.breakContainer(R.createPositionAfter(T));
                const j = T.parent, F = j.previousSibling, V = R.createRangeOn(j);
                R.remove(V), F && F.nextSibling && Zr(R, F, F.nextSibling), Vx(A.attributeOldValue + 1, A.range.start, V.start, T, C, m), Rx(A.item, T, C, m);
                for (const W of A.item.getChildren())
                  C.consumable.consume(W, "insert");
              };
            }(t.model)), g.on("remove:listItem", function(m) {
              return (w, A, C) => {
                const T = C.mapper.toViewPosition(A.position).getLastMatchingPosition((ee) => !ee.item.is("element", "li")).nodeAfter, R = C.writer;
                R.breakContainer(R.createPositionBefore(T)), R.breakContainer(R.createPositionAfter(T));
                const j = T.parent, F = j.previousSibling, V = R.createRangeOn(j), W = R.remove(V);
                F && F.nextSibling && Zr(R, F, F.nextSibling), Vx(C.mapper.toModelElement(T).getAttribute("listIndent") + 1, A.position, V.start, T, C, m);
                for (const ee of R.createRangeIn(W).getItems())
                  C.mapper.unbindViewElement(ee);
                w.stop();
              };
            }(t.model)), g.on("remove", tB, { priority: "low" });
          }), t.conversion.for("dataDowncast").add((g) => {
            g.on("insert", Bx, { priority: "high" }), g.on("insert:listItem", jx(t.model));
          }), t.conversion.for("upcast").add((g) => {
            g.on("element:ul", Fx, { priority: "high" }), g.on("element:ol", Fx, { priority: "high" }), g.on("element:li", rB, { priority: "high" }), g.on("element:li", nB);
          }), t.model.on("insertContent", iB, { priority: "high" }), t.commands.add("numberedList", new Dx(t, "numbered")), t.commands.add("bulletedList", new Dx(t, "bulleted")), t.commands.add("indentList", new Ox(t, "forward")), t.commands.add("outdentList", new Ox(t, "backward"));
          const d = a.view.document;
          this.listenTo(d, "enter", (g, m) => {
            const w = this.editor.model.document, A = w.selection.getLastPosition().parent;
            w.selection.isCollapsed && A.name == "listItem" && A.isEmpty && (this.editor.execute("outdentList"), m.preventDefault(), g.stop());
          }, { context: "li" }), this.listenTo(d, "delete", (g, m) => {
            if (m.direction !== "backward")
              return;
            const w = this.editor.model.document.selection;
            if (!w.isCollapsed)
              return;
            const A = w.getFirstPosition();
            if (!A.isAtStart)
              return;
            const C = A.parent;
            C.name === "listItem" && (C.previousSibling && C.previousSibling.name === "listItem" || (this.editor.execute("outdentList"), m.preventDefault(), g.stop()));
          }, { context: "li" }), this.listenTo(t.editing.view.document, "tab", (g, m) => {
            const w = m.shiftKey ? "outdentList" : "indentList";
            this.editor.commands.get(w).isEnabled && (t.execute(w), m.stopPropagation(), m.preventDefault(), g.stop());
          }, { context: "li" });
        }
        afterInit() {
          const t = this.editor.commands, i = t.get("indent"), a = t.get("outdent");
          i && i.registerChildCommand(t.get("indentList")), a && a.registerChildCommand(t.get("outdentList"));
        }
      }
      function Q0(c) {
        let t = 1;
        for (const i of c.getChildren())
          if (i.name == "ul" || i.name == "ol")
            for (const a of i.getChildren())
              t += Q0(a);
        return t;
      }
      class sB extends Ie {
        static get pluginName() {
          return "ListUI";
        }
        init() {
          const t = this.editor.t;
          Lx(this.editor, "numberedList", t("Numbered List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'), Lx(this.editor, "bulletedList", t("Bulleted List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>');
        }
      }
      function Hx(c, t) {
        return (a) => {
          a.on("attribute:url:media", i);
        };
        function i(a, l, d) {
          if (!d.consumable.consume(l.item, a.name))
            return;
          const g = l.attributeNewValue, m = d.writer, w = d.mapper.toViewElement(l.item), A = [...w.getChildren()].find((T) => T.getCustomProperty("media-content"));
          m.remove(A);
          const C = c.getMediaViewElement(m, g, t);
          m.insert(m.createPositionAt(w, 0), C);
        }
      }
      function Ux(c, t, i, a) {
        return c.createContainerElement("figure", { class: "media" }, [t.getMediaViewElement(c, i, a), c.createSlot()]);
      }
      function Wx(c) {
        const t = c.getSelectedElement();
        return t && t.is("element", "media") ? t : null;
      }
      function Gx(c, t, i, a) {
        c.change((l) => {
          const d = l.createElement("media", { url: t });
          c.insertObject(d, i, null, { setSelection: "on", findOptimalPosition: a });
        });
      }
      class lB extends kt {
        refresh() {
          const t = this.editor.model, i = t.document.selection, a = Wx(i);
          this.value = a ? a.getAttribute("url") : null, this.isEnabled = function(l) {
            const d = l.getSelectedElement();
            return !!d && d.name === "media";
          }(i) || function(l, d) {
            let m = VC(l, d).start.parent;
            return m.isEmpty && !d.schema.isLimit(m) && (m = m.parent), d.schema.checkChild(m, "media");
          }(i, t);
        }
        execute(t) {
          const i = this.editor.model, a = i.document.selection, l = Wx(a);
          l ? i.change((d) => {
            d.setAttribute("url", t, l);
          }) : Gx(i, t, a, !0);
        }
      }
      class cB {
        constructor(t, i) {
          const a = i.providers, l = i.extraProviders || [], d = new Set(i.removeProviders), g = a.concat(l).filter((m) => {
            const w = m.name;
            return w ? !d.has(w) : ($("media-embed-no-provider-name", { provider: m }), !1);
          });
          this.locale = t, this.providerDefinitions = g;
        }
        hasMedia(t) {
          return !!this._getMedia(t);
        }
        getMediaViewElement(t, i, a) {
          return this._getMedia(i).getViewElement(t, a);
        }
        _getMedia(t) {
          if (!t)
            return new qx(this.locale);
          t = t.trim();
          for (const i of this.providerDefinitions) {
            const a = i.html, l = Yn(i.url);
            for (const d of l) {
              const g = this._getUrlMatches(t, d);
              if (g)
                return new qx(this.locale, t, g, a);
            }
          }
          return null;
        }
        _getUrlMatches(t, i) {
          let a = t.match(i);
          if (a)
            return a;
          let l = t.replace(/^https?:\/\//, "");
          return a = l.match(i), a || (l = l.replace(/^www\./, ""), a = l.match(i), a || null);
        }
      }
      class qx {
        constructor(t, i, a, l) {
          this.url = this._getValidUrl(i), this._locale = t, this._match = a, this._previewRenderer = l;
        }
        getViewElement(t, i) {
          const a = {};
          let l;
          if (i.renderForEditingView || i.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (a["data-oembed-url"] = this.url), i.renderForEditingView && (a.class = "ck-media__wrapper");
            const d = this._getPreviewHtml(i);
            l = t.createRawElement("div", a, (g, m) => {
              m.setContentOf(g, d);
            });
          } else
            this.url && (a.url = this.url), l = t.createEmptyElement(i.elementName, a);
          return t.setCustomProperty("media-content", !0, l), l;
        }
        _getPreviewHtml(t) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
        _getPlaceholderHtml() {
          const t = new cs(), i = this._locale.t;
          return t.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t.viewBox = "0 0 64 42", new Ci({ tag: "div", attributes: { class: "ck ck-reset_all ck-media__placeholder" }, children: [{ tag: "div", attributes: { class: "ck-media__placeholder__icon" }, children: [t] }, { tag: "a", attributes: { class: "ck-media__placeholder__url", target: "_blank", rel: "noopener noreferrer", href: this.url, "data-cke-tooltip-text": i("Open media in new tab") }, children: [{ tag: "span", attributes: { class: "ck-media__placeholder__url__text" }, children: [this.url] }] }] }).render().outerHTML;
        }
        _getValidUrl(t) {
          return t ? t.match(/^https?/) ? t : "https://" + t : null;
        }
      }
      var Kx = s(7442), uB = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Kx.Z, uB), Kx.Z.locals;
      class Hh extends Ie {
        static get pluginName() {
          return "MediaEmbedEditing";
        }
        constructor(t) {
          super(t), t.config.define("mediaEmbed", { elementName: "oembed", providers: [{ name: "dailymotion", url: /^dailymotion\.com\/video\/(\w+)/, html: (i) => `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${i[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>` }, { name: "spotify", url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/], html: (i) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${i[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>` }, { name: "youtube", url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/, /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/, /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/], html: (i) => {
            const a = i[1], l = i[2];
            return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${a}${l ? `?start=${l}` : ""}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
          } }, { name: "vimeo", url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/], html: (i) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${i[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>` }, { name: "instagram", url: /^instagram\.com\/p\/(\w+)/ }, { name: "twitter", url: /^twitter\.com/ }, { name: "googleMaps", url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/] }, { name: "flickr", url: /^flickr\.com/ }, { name: "facebook", url: /^facebook\.com/ }] }), this.registry = new cB(t.locale, t.config.get("mediaEmbed"));
        }
        init() {
          const t = this.editor, i = t.model.schema, a = t.t, l = t.conversion, d = t.config.get("mediaEmbed.previewsInData"), g = t.config.get("mediaEmbed.elementName"), m = this.registry;
          t.commands.add("mediaEmbed", new lB(t)), i.register("media", { inheritAllFrom: "$blockObject", allowAttributes: ["url"] }), l.for("dataDowncast").elementToStructure({ model: "media", view: (w, { writer: A }) => {
            const C = w.getAttribute("url");
            return Ux(A, m, C, { elementName: g, renderMediaPreview: C && d });
          } }), l.for("dataDowncast").add(Hx(m, { elementName: g, renderMediaPreview: d })), l.for("editingDowncast").elementToStructure({ model: "media", view: (w, { writer: A }) => {
            const C = w.getAttribute("url");
            return function(T, R, j) {
              return R.setCustomProperty("media", !0, T), P0(T, R, { label: j });
            }(Ux(A, m, C, { elementName: g, renderForEditingView: !0 }), A, a("media widget"));
          } }), l.for("editingDowncast").add(Hx(m, { elementName: g, renderForEditingView: !0 })), l.for("upcast").elementToElement({ view: (w) => ["oembed", g].includes(w.name) && w.getAttribute("url") ? { name: !0 } : null, model: (w, { writer: A }) => {
            const C = w.getAttribute("url");
            if (m.hasMedia(C))
              return A.createElement("media", { url: C });
          } }).elementToElement({ view: { name: "div", attributes: { "data-oembed-url": !0 } }, model: (w, { writer: A }) => {
            const C = w.getAttribute("data-oembed-url");
            if (m.hasMedia(C))
              return A.createElement("media", { url: C });
          } }).add((w) => {
            w.on("element:figure", function(A, C, T) {
              if (!T.consumable.consume(C.viewItem, { name: !0, classes: "media" }))
                return;
              const { modelRange: R, modelCursor: j } = T.convertChildren(C.viewItem, C.modelCursor);
              C.modelRange = R, C.modelCursor = j, Fn(R.getItems()) || T.consumable.revert(C.viewItem, { name: !0, classes: "media" });
            });
          });
        }
      }
      const dB = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
      class hB extends Ie {
        static get requires() {
          return [r2, ha, l2];
        }
        static get pluginName() {
          return "AutoMediaEmbed";
        }
        constructor(t) {
          super(t), this._timeoutId = null, this._positionToInsert = null;
        }
        init() {
          const t = this.editor, i = t.model.document;
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", () => {
            const a = i.selection.getFirstRange(), l = ar.fromPosition(a.start);
            l.stickiness = "toPrevious";
            const d = ar.fromPosition(a.end);
            d.stickiness = "toNext", i.once("change:data", () => {
              this._embedMediaBetweenPositions(l, d), l.detach(), d.detach();
            }, { priority: "high" });
          }), t.commands.get("undo").on("execute", () => {
            this._timeoutId && (yt.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
          }, { priority: "high" });
        }
        _embedMediaBetweenPositions(t, i) {
          const a = this.editor, l = a.plugins.get(Hh).registry, d = new _i(t, i), g = d.getWalker({ ignoreElementEnd: !0 });
          let m = "";
          for (const w of g)
            w.item.is("$textProxy") && (m += w.item.data);
          if (m = m.trim(), !m.match(dB) || !l.hasMedia(m))
            return void d.detach();
          a.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = ar.fromPosition(t), this._timeoutId = yt.window.setTimeout(() => {
            a.model.change((w) => {
              let A;
              this._timeoutId = null, w.remove(d), d.detach(), this._positionToInsert.root.rootName !== "$graveyard" && (A = this._positionToInsert), Gx(a.model, m, A, !1), this._positionToInsert.detach(), this._positionToInsert = null;
            }), a.plugins.get("Delete").requestUndoOnBackspace();
          }, 100)) : d.detach();
        }
      }
      var Yx = s(9292), fB = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Yx.Z, fB), Yx.Z.locals;
      class pB extends At {
        constructor(t, i) {
          super(i);
          const a = i.t;
          this.focusTracker = new Kr(), this.keystrokes = new Qi(), this.set("mediaURLInputValue", ""), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(a("Save"), Nn.check, "ck-button-save"), this.saveButtonView.type = "submit", this.saveButtonView.bind("isEnabled").to(this, "mediaURLInputValue", (l) => !!l), this.cancelButtonView = this._createButton(a("Cancel"), Nn.cancel, "ck-button-cancel", "cancel"), this._focusables = new ls(), this._focusCycler = new _l({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this._validators = t, this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-media-form", "ck-responsive-form"], tabindex: "-1" }, children: [this.urlInputView, this.saveButtonView, this.cancelButtonView] }), b0(this);
        }
        render() {
          super.render(), w0({ view: this }), [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach((i) => {
            this._focusables.add(i), this.focusTracker.add(i.element);
          }), this.keystrokes.listenTo(this.element);
          const t = (i) => i.stopPropagation();
          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", (i, a) => {
            a.stopPropagation();
          }, { priority: "high" });
        }
        destroy() {
          super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
        focus() {
          this._focusCycler.focusFirst();
        }
        get url() {
          return this.urlInputView.fieldView.element.value.trim();
        }
        set url(t) {
          this.urlInputView.fieldView.element.value = t.trim();
        }
        isValid() {
          this.resetFormStatus();
          for (const t of this._validators) {
            const i = t(this);
            if (i)
              return this.urlInputView.errorText = i, !1;
          }
          return !0;
        }
        resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
        _createUrlInput() {
          const t = this.locale.t, i = new C0(this.locale, x0), a = i.fieldView;
          return this._urlInputViewInfoDefault = t("Paste the media URL in the input."), this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster."), i.label = t("Media URL"), i.infoText = this._urlInputViewInfoDefault, a.on("input", () => {
            i.infoText = a.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault, this.mediaURLInputValue = a.element.value.trim();
          }), i;
        }
        _createButton(t, i, a, l) {
          const d = new cn(this.locale);
          return d.set({ label: t, icon: i, tooltip: !0 }), d.extendTemplate({ attributes: { class: a } }), l && d.delegate("execute").to(this, l), d;
        }
      }
      class gB extends Ie {
        static get requires() {
          return [Hh];
        }
        static get pluginName() {
          return "MediaEmbedUI";
        }
        init() {
          const t = this.editor, i = t.commands.get("mediaEmbed"), a = t.plugins.get(Hh).registry;
          t.ui.componentFactory.add("mediaEmbed", (l) => {
            const d = ua(l), g = new pB(function(m, w) {
              return [(A) => {
                if (!A.url.length)
                  return m("The URL must not be empty.");
              }, (A) => {
                if (!w.hasMedia(A.url))
                  return m("This media URL is not supported.");
              }];
            }(t.t, a), t.locale);
            return this._setUpDropdown(d, g, i, t), this._setUpForm(d, g, i), d;
          });
        }
        _setUpDropdown(t, i, a) {
          const l = this.editor, d = l.t, g = t.buttonView;
          t.bind("isEnabled").to(a), t.panelView.children.add(i), g.set({ label: d("Insert media"), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>', tooltip: !0 }), g.on("open", () => {
            i.disableCssTransitions(), i.url = a.value || "", i.urlInputView.fieldView.select(), i.enableCssTransitions();
          }, { priority: "low" }), t.on("submit", () => {
            i.isValid() && (l.execute("mediaEmbed", i.url), l.editing.view.focus());
          }), t.on("change:isOpen", () => i.resetFormStatus()), t.on("cancel", () => {
            l.editing.view.focus();
          });
        }
        _setUpForm(t, i, a) {
          i.delegate("submit", "cancel").to(t), i.urlInputView.bind("value").to(a, "value"), i.urlInputView.bind("isReadOnly").to(a, "isEnabled", (l) => !l);
        }
      }
      var Qx = s(4652), mB = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(Qx.Z, mB), Qx.Z.locals;
      function Zx(c, t, i, { blockElements: a, inlineObjectElements: l }) {
        let d = i.createPositionAt(c, t == "forward" ? "after" : "before");
        return d = d.getLastMatchingPosition(({ item: g }) => g.is("element") && !a.includes(g.name) && !l.includes(g.name), { direction: t }), t == "forward" ? d.nodeAfter : d.nodeBefore;
      }
      function Xx(c, t) {
        return !!c && c.is("element") && t.includes(c.name);
      }
      function vB(c, t) {
        if (!c.childCount)
          return;
        const i = new wl(c.document), a = function(g, m) {
          const w = m.createRangeIn(g), A = new Ji({ name: /^p|h\d+$/, styles: { "mso-list": /.*/ } }), C = [];
          for (const T of w)
            if (T.type === "elementStart" && A.match(T.item)) {
              const R = wB(T.item);
              C.push({ element: T.item, id: R.id, order: R.order, indent: R.indent });
            }
          return C;
        }(c, i);
        if (!a.length)
          return;
        let l = null, d = 1;
        a.forEach((g, m) => {
          const w = function(F, V) {
            if (!F)
              return !0;
            if (F.id !== V.id)
              return V.indent - F.indent != 1;
            const W = V.element.previousSibling;
            if (!W)
              return !0;
            return ee = W, !(ee.is("element", "ol") || ee.is("element", "ul"));
            var ee;
          }(a[m - 1], g), A = w ? null : a[m - 1], C = (R = g, (T = A) ? R.indent - T.indent : R.indent - 1);
          var T, R;
          if (w && (l = null, d = 1), !l || C !== 0) {
            const F = function(V, W) {
              const ee = new RegExp(`@list l${V.id}:level${V.indent}\\s*({[^}]*)`, "gi"), le = /mso-level-number-format:([^;]{0,100});/gi, be = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi, Ne = ee.exec(W);
              let Je = "decimal", Mt = "ol", Rt = null;
              if (Ne && Ne[1]) {
                const zn = le.exec(Ne[1]);
                if (zn && zn[1] && (Je = zn[1].trim(), Mt = Je !== "bullet" && Je !== "image" ? "ol" : "ul"), Je === "bullet") {
                  const Jn = function(Il) {
                    const ao = function(Po) {
                      if (Po.getChild(0).is("$text"))
                        return null;
                      for (const Oo of Po.getChildren()) {
                        if (!Oo.is("element", "span"))
                          continue;
                        const Pl = Oo.getChild(0);
                        return Pl.is("$text") ? Pl : Pl.getChild(0);
                      }
                    }(Il);
                    if (!ao)
                      return null;
                    const Xr = ao._data;
                    return Xr === "o" ? "circle" : Xr === "\xB7" ? "disc" : Xr === "\xA7" ? "square" : null;
                  }(V.element);
                  Jn && (Je = Jn);
                } else {
                  const Jn = be.exec(Ne[1]);
                  Jn && Jn[1] && (Rt = parseInt(Jn[1]));
                }
              }
              return { type: Mt, startIndex: Rt, style: bB(Je) };
            }(g, t);
            if (l) {
              if (g.indent > d) {
                const V = l.getChild(l.childCount - 1), W = V.getChild(V.childCount - 1);
                l = Jx(F, W, i), d += 1;
              } else if (g.indent < d) {
                const V = d - g.indent;
                l = function(W, ee) {
                  const le = W.getAncestors({ parentFirst: !0 });
                  let be = null, Ne = 0;
                  for (const Je of le)
                    if (Je.name !== "ul" && Je.name !== "ol" || Ne++, Ne === ee) {
                      be = Je;
                      break;
                    }
                  return be;
                }(l, V), d = parseInt(g.indent);
              }
            } else
              l = Jx(F, g.element, i);
            g.indent <= d && (l.is("element", F.type) || (l = i.rename(F.type, l)));
          }
          const j = function(F, V) {
            return function(W, ee) {
              const le = new Ji({ name: "span", styles: { "mso-list": "Ignore" } }), be = ee.createRangeIn(W);
              for (const Ne of be)
                Ne.type === "elementStart" && le.match(Ne.item) && ee.remove(Ne.item);
            }(F, V), V.rename("li", F);
          }(g.element, i);
          i.appendChild(j, l);
        });
      }
      function bB(c) {
        if (c.startsWith("arabic-leading-zero"))
          return "decimal-leading-zero";
        switch (c) {
          case "alpha-upper":
            return "upper-alpha";
          case "alpha-lower":
            return "lower-alpha";
          case "roman-upper":
            return "upper-roman";
          case "roman-lower":
            return "lower-roman";
          case "circle":
          case "disc":
          case "square":
            return c;
          default:
            return null;
        }
      }
      function Jx(c, t, i) {
        const a = t.parent, l = i.createElement(c.type), d = a.getChildIndex(t) + 1;
        return i.insertChild(d, l, a), c.style && i.setStyle("list-style-type", c.style, l), c.startIndex && c.startIndex > 1 && i.setAttribute("start", c.startIndex, l), l;
      }
      function wB(c) {
        const t = {}, i = c.getStyle("mso-list");
        if (i) {
          const a = i.match(/(^|\s{1,100})l(\d+)/i), l = i.match(/\s{0,100}lfo(\d+)/i), d = i.match(/\s{0,100}level(\d+)/i);
          a && l && d && (t.id = a[2], t.order = l[1], t.indent = d[1]);
        }
        return t;
      }
      const yB = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
      class kB {
        constructor(t) {
          this.document = t;
        }
        isActive(t) {
          return yB.test(t);
        }
        execute(t) {
          const i = new wl(this.document), { body: a } = t._parsedData;
          (function(l, d) {
            for (const g of l.getChildren())
              if (g.is("element", "b") && g.getStyle("font-weight") === "normal") {
                const m = l.getChildIndex(g);
                d.remove(g), d.insertChild(m, g.getChildren(), l);
              }
          })(a, i), function(l, d) {
            for (const g of d.createRangeIn(l)) {
              const m = g.item;
              if (m.is("element", "li")) {
                const w = m.getChild(0);
                w && w.is("element", "p") && d.unwrapElement(w);
              }
            }
          }(a, i), function(l, d) {
            const g = new mh(d.document.stylesProcessor), m = new yh(g, { renderingMode: "data" }), w = m.blockElements, A = m.inlineObjectElements, C = [];
            for (const T of d.createRangeIn(l)) {
              const R = T.item;
              if (R.is("element", "br")) {
                const j = Zx(R, "forward", d, { blockElements: w, inlineObjectElements: A }), F = Zx(R, "backward", d, { blockElements: w, inlineObjectElements: A }), V = Xx(j, w);
                (Xx(F, w) || V) && C.push(R);
              }
            }
            for (const T of C)
              T.hasClass("Apple-interchange-newline") ? d.remove(T) : d.replace(T, d.createElement("p"));
          }(a, i), t.content = a;
        }
      }
      function _B(c, t) {
        if (!c.childCount)
          return;
        const i = new wl(), a = function(d, g) {
          const m = g.createRangeIn(d), w = new Ji({ name: /v:(.+)/ }), A = [];
          for (const C of m) {
            if (C.type != "elementStart")
              continue;
            const T = C.item, R = T.previousSibling && T.previousSibling.name || null;
            w.match(T) && T.getAttribute("o:gfxdata") && R !== "v:shapetype" && A.push(C.item.getAttribute("id"));
          }
          return A;
        }(c, i);
        (function(d, g, m) {
          const w = m.createRangeIn(g), A = new Ji({ name: "img" }), C = [];
          for (const T of w)
            if (A.match(T.item)) {
              const R = T.item, j = R.getAttribute("v:shapes") ? R.getAttribute("v:shapes").split(" ") : [];
              j.length && j.every((F) => d.indexOf(F) > -1) ? C.push(R) : R.getAttribute("src") || C.push(R);
            }
          for (const T of C)
            m.remove(T);
        })(a, c, i), function(d, g) {
          const m = g.createRangeIn(d), w = new Ji({ name: /v:(.+)/ }), A = [];
          for (const C of m)
            C.type == "elementStart" && w.match(C.item) && A.push(C.item);
          for (const C of A)
            g.remove(C);
        }(c, i);
        const l = function(d, g) {
          const m = g.createRangeIn(d), w = new Ji({ name: "img" }), A = [];
          for (const C of m)
            w.match(C.item) && C.item.getAttribute("src").startsWith("file://") && A.push(C.item);
          return A;
        }(c, i);
        l.length && function(d, g, m) {
          if (d.length === g.length)
            for (let w = 0; w < d.length; w++) {
              const A = `data:${g[w].type};base64,${AB(g[w].hex)}`;
              m.setAttribute("src", A, d[w]);
            }
        }(l, function(d) {
          if (!d)
            return [];
          const g = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/, m = new RegExp("(?:(" + g.source + "))([\\da-fA-F\\s]+)\\}", "g"), w = d.match(m), A = [];
          if (w)
            for (const C of w) {
              let T = !1;
              C.includes("\\pngblip") ? T = "image/png" : C.includes("\\jpegblip") && (T = "image/jpeg"), T && A.push({ hex: C.replace(g, "").replace(/[^\da-fA-F]/g, ""), type: T });
            }
          return A;
        }(t), i);
      }
      function AB(c) {
        return btoa(c.match(/\w{2}/g).map((t) => String.fromCharCode(parseInt(t, 16))).join(""));
      }
      const CB = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i, xB = /xmlns:o="urn:schemas-microsoft-com/i;
      class EB {
        constructor(t) {
          this.document = t;
        }
        isActive(t) {
          return CB.test(t) || xB.test(t);
        }
        execute(t) {
          const { body: i, stylesString: a } = t._parsedData;
          vB(i, a), _B(i, t.dataTransfer.getData("text/rtf")), t.content = i;
        }
      }
      function e5(c) {
        return c.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, i) => i.length === 1 ? " " : Array(i.length + 1).join("\xA0 ").substr(0, i.length));
      }
      function SB(c, t) {
        const i = new DOMParser(), a = function(w) {
          return e5(e5(w)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, "\xA0</").replace(/ <o:p><\/o:p>/g, "\xA0<o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function(w) {
          const A = "</body>", C = "</html>", T = w.indexOf(A);
          if (T < 0)
            return w;
          const R = w.indexOf(C, T + A.length);
          return w.substring(0, T + A.length) + (R >= 0 ? w.substring(R) : "");
        }(c = c.replace(/<!--\[if gte vml 1]>/g, ""))), l = i.parseFromString(a, "text/html");
        (function(w) {
          w.querySelectorAll("span[style*=spacerun]").forEach((A) => {
            const C = A.innerText.length || 0;
            A.innerText = Array(C + 1).join("\xA0 ").substr(0, C);
          });
        })(l);
        const d = l.body.innerHTML, g = function(w, A) {
          const C = new mh(A), T = new yh(C, { renderingMode: "data" }), R = w.createDocumentFragment(), j = w.body.childNodes;
          for (; j.length > 0; )
            R.appendChild(j[0]);
          return T.domToView(R, { skipComments: !0 });
        }(l, t), m = function(w) {
          const A = [], C = [], T = Array.from(w.getElementsByTagName("style"));
          for (const R of T)
            R.sheet && R.sheet.cssRules && R.sheet.cssRules.length && (A.push(R.sheet), C.push(R.innerHTML));
          return { styles: A, stylesString: C.join(" ") };
        }(l);
        return { body: g, bodyString: d, styles: m.styles, stylesString: m.stylesString };
      }
      function On(c, t, i, a, l = 1) {
        t > l ? a.setAttribute(c, t, i) : a.removeAttribute(c, i);
      }
      function ds(c, t, i = {}) {
        const a = c.createElement("tableCell", i);
        return c.insertElement("paragraph", a), c.insert(a, t), a;
      }
      function Z0(c, t) {
        const i = t.parent.parent, a = parseInt(i.getAttribute("headingColumns") || 0), { column: l } = c.getCellLocation(t);
        return !!a && l < a;
      }
      function MB() {
        return (c) => {
          c.on("element:table", (t, i, a) => {
            const l = i.viewItem;
            if (!a.consumable.test(l, { name: !0 }))
              return;
            const { rows: d, headingRows: g, headingColumns: m } = function(C) {
              const T = { headingRows: 0, headingColumns: 0 }, R = [], j = [];
              let F;
              for (const V of Array.from(C.getChildren()))
                if (V.name === "tbody" || V.name === "thead" || V.name === "tfoot") {
                  V.name !== "thead" || F || (F = V);
                  const W = Array.from(V.getChildren()).filter((ee) => ee.is("element", "tr"));
                  for (const ee of W)
                    if (ee.parent.name === "thead" && ee.parent === F)
                      T.headingRows++, R.push(ee);
                    else {
                      j.push(ee);
                      const le = TB(ee);
                      le > T.headingColumns && (T.headingColumns = le);
                    }
                }
              return T.rows = [...R, ...j], T;
            }(l), w = {};
            m && (w.headingColumns = m), g && (w.headingRows = g);
            const A = a.writer.createElement("table", w);
            if (a.safeInsert(A, i.modelCursor)) {
              if (a.consumable.consume(l, { name: !0 }), d.forEach((C) => a.convertItem(C, a.writer.createPositionAt(A, "end"))), a.convertChildren(l, a.writer.createPositionAt(A, "end")), A.isEmpty) {
                const C = a.writer.createElement("tableRow");
                a.writer.insert(C, a.writer.createPositionAt(A, "end")), ds(a.writer, a.writer.createPositionAt(C, "end"));
              }
              a.updateConversionResult(A, i);
            }
          });
        };
      }
      function t5(c) {
        return (t) => {
          t.on(`element:${c}`, (i, a, l) => {
            if (a.modelRange && a.viewItem.isEmpty) {
              const d = a.modelRange.start.nodeAfter, g = l.writer.createPositionAt(d, 0);
              l.writer.insertElement("paragraph", g);
            }
          }, { priority: "low" });
        };
      }
      function TB(c) {
        let t = 0, i = 0;
        const a = Array.from(c.getChildren()).filter((l) => l.name === "th" || l.name === "td");
        for (; i < a.length && a[i].name === "th"; ) {
          const l = a[i];
          t += parseInt(l.getAttribute("colspan") || 1), i++;
        }
        return t;
      }
      class Yt {
        constructor(t, i = {}) {
          this._table = t, this._startRow = i.row !== void 0 ? i.row : i.startRow || 0, this._endRow = i.row !== void 0 ? i.row : i.endRow, this._startColumn = i.column !== void 0 ? i.column : i.startColumn || 0, this._endColumn = i.column !== void 0 ? i.column : i.endColumn, this._includeAllSlots = !!i.includeAllSlots, this._skipRows = /* @__PURE__ */ new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = /* @__PURE__ */ new Map(), this._nextCellAtColumn = -1;
        }
        [Symbol.iterator]() {
          return this;
        }
        next() {
          const t = this._table.getChild(this._rowIndex);
          if (!t || this._isOverEndRow())
            return { done: !0 };
          if (!t.is("element", "tableRow"))
            return this._rowIndex++, this.next();
          if (this._isOverEndColumn())
            return this._advanceToNextRow();
          let i = null;
          const a = this._getSpanned();
          if (a)
            this._includeAllSlots && !this._shouldSkipSlot() && (i = this._formatOutValue(a.cell, a.row, a.column));
          else {
            const l = t.getChild(this._cellIndex);
            if (!l)
              return this._advanceToNextRow();
            const d = parseInt(l.getAttribute("colspan") || 1), g = parseInt(l.getAttribute("rowspan") || 1);
            (d > 1 || g > 1) && this._recordSpans(l, g, d), this._shouldSkipSlot() || (i = this._formatOutValue(l)), this._nextCellAtColumn = this._column + d;
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, i || this.next();
        }
        skipRow(t) {
          this._skipRows.add(t);
        }
        _advanceToNextRow() {
          return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
        }
        _isOverEndRow() {
          return this._endRow !== void 0 && this._row > this._endRow;
        }
        _isOverEndColumn() {
          return this._endColumn !== void 0 && this._column > this._endColumn;
        }
        _formatOutValue(t, i = this._row, a = this._column) {
          return { done: !1, value: new DB(this, t, i, a) };
        }
        _shouldSkipSlot() {
          const t = this._skipRows.has(this._row), i = this._row < this._startRow, a = this._column < this._startColumn, l = this._endColumn !== void 0 && this._column > this._endColumn;
          return t || i || a || l;
        }
        _getSpanned() {
          const t = this._spannedCells.get(this._row);
          return t && t.get(this._column) || null;
        }
        _recordSpans(t, i, a) {
          const l = { cell: t, row: this._row, column: this._column };
          for (let d = this._row; d < this._row + i; d++)
            for (let g = this._column; g < this._column + a; g++)
              d == this._row && g == this._column || this._markSpannedCell(d, g, l);
        }
        _markSpannedCell(t, i, a) {
          this._spannedCells.has(t) || this._spannedCells.set(t, /* @__PURE__ */ new Map()), this._spannedCells.get(t).set(i, a);
        }
      }
      class DB {
        constructor(t, i, a, l) {
          this.cell = i, this.row = t._row, this.column = t._column, this.cellAnchorRow = a, this.cellAnchorColumn = l, this._cellIndex = t._cellIndex, this._rowIndex = t._rowIndex, this._table = t._table;
        }
        get isAnchor() {
          return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
        }
        get cellWidth() {
          return parseInt(this.cell.getAttribute("colspan") || 1);
        }
        get cellHeight() {
          return parseInt(this.cell.getAttribute("rowspan") || 1);
        }
        get rowIndex() {
          return this._rowIndex;
        }
        getPositionBefore() {
          return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
        }
      }
      function n5(c, t = {}) {
        return (i, { writer: a }) => {
          const l = i.getAttribute("headingRows") || 0, d = [];
          l > 0 && d.push(a.createContainerElement("thead", null, a.createSlot((m) => m.is("element", "tableRow") && m.index < l))), l < c.getRows(i) && d.push(a.createContainerElement("tbody", null, a.createSlot((m) => m.is("element", "tableRow") && m.index >= l)));
          const g = a.createContainerElement("figure", { class: "table" }, [a.createContainerElement("table", null, d), a.createSlot((m) => !m.is("element", "tableRow"))]);
          return t.asWidget ? function(m, w) {
            return w.setCustomProperty("table", !0, m), P0(m, w, { hasSelectionHandle: !0 });
          }(g, a) : g;
        };
      }
      function r5(c = {}) {
        return (t, { writer: i }) => {
          const a = t.parent, l = a.parent, d = l.getChildIndex(a), g = new Yt(l, { row: d }), m = l.getAttribute("headingRows") || 0, w = l.getAttribute("headingColumns") || 0;
          for (const A of g)
            if (A.cell == t) {
              const C = A.row < m || A.column < w ? "th" : "td";
              return c.asWidget ? zC(i.createEditableElement(C), i) : i.createContainerElement(C);
            }
        };
      }
      function i5(c = {}) {
        return (t, { writer: i, consumable: a, mapper: l }) => {
          if (t.parent.is("element", "tableCell") && o5(t))
            return c.asWidget ? i.createContainerElement("span", { class: "ck-table-bogus-paragraph" }) : (a.consume(t, "insert"), void l.bindElements(t, l.toViewElement(t.parent)));
        };
      }
      function o5(c) {
        return c.parent.childCount == 1 && ![...c.getAttributeKeys()].length;
      }
      class IB extends kt {
        refresh() {
          const t = this.editor.model, i = t.document.selection, a = t.schema;
          this.isEnabled = function(l, d) {
            const g = l.getFirstPosition().parent, m = g === g.root ? g : g.parent;
            return d.checkChild(m, "table");
          }(i, a);
        }
        execute(t = {}) {
          const i = this.editor.model, a = this.editor.plugins.get("TableUtils"), l = this.editor.config.get("table"), d = l.defaultHeadings.rows, g = l.defaultHeadings.columns;
          t.headingRows === void 0 && d && (t.headingRows = d), t.headingColumns === void 0 && g && (t.headingColumns = g), i.change((m) => {
            const w = a.createTable(m, t);
            i.insertObject(w, null, null, { findOptimalPosition: "auto" }), m.setSelection(m.createPositionAt(w.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }
      class a5 extends kt {
        constructor(t, i = {}) {
          super(t), this.order = i.order || "below";
        }
        refresh() {
          const t = this.editor.model.document.selection, i = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
          this.isEnabled = i;
        }
        execute() {
          const t = this.editor, i = t.model.document.selection, a = t.plugins.get("TableUtils"), l = this.order === "above", d = a.getSelectionAffectedTableCells(i), g = a.getRowIndexes(d), m = l ? g.first : g.last, w = d[0].findAncestor("table");
          a.insertRows(w, { at: l ? m : m + 1, copyStructureFromAbove: !l });
        }
      }
      class s5 extends kt {
        constructor(t, i = {}) {
          super(t), this.order = i.order || "right";
        }
        refresh() {
          const t = this.editor.model.document.selection, i = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t).length;
          this.isEnabled = i;
        }
        execute() {
          const t = this.editor, i = t.model.document.selection, a = t.plugins.get("TableUtils"), l = this.order === "left", d = a.getSelectionAffectedTableCells(i), g = a.getColumnIndexes(d), m = l ? g.first : g.last, w = d[0].findAncestor("table");
          a.insertColumns(w, { columns: 1, at: l ? m : m + 1 });
        }
      }
      class l5 extends kt {
        constructor(t, i = {}) {
          super(t), this.direction = i.direction || "horizontally";
        }
        refresh() {
          const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
          this.isEnabled = t.length === 1;
        }
        execute() {
          const t = this.editor.plugins.get("TableUtils"), i = t.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
          this.direction === "horizontally" ? t.splitCellHorizontally(i, 2) : t.splitCellVertically(i, 2);
        }
      }
      function c5(c, t, i) {
        const { startRow: a, startColumn: l, endRow: d, endColumn: g } = t, m = i.createElement("table"), w = d - a + 1;
        for (let C = 0; C < w; C++)
          i.insertElement("tableRow", m, "end");
        const A = [...new Yt(c, { startRow: a, endRow: d, startColumn: l, endColumn: g, includeAllSlots: !0 })];
        for (const { row: C, column: T, cell: R, isAnchor: j, cellAnchorRow: F, cellAnchorColumn: V } of A) {
          const W = C - a, ee = m.getChild(W);
          if (j) {
            const le = i.cloneElement(R);
            i.append(le, ee), p5(le, C, T, d, g, i);
          } else
            (F < a || V < l) && ds(i, i.createPositionAt(ee, "end"));
        }
        return function(C, T, R, j, F) {
          const V = parseInt(T.getAttribute("headingRows") || 0);
          V > 0 && On("headingRows", V - R, C, F, 0);
          const W = parseInt(T.getAttribute("headingColumns") || 0);
          W > 0 && On("headingColumns", W - j, C, F, 0);
        }(m, c, a, l, i), m;
      }
      function u5(c, t, i = 0) {
        const a = [], l = new Yt(c, { startRow: i, endRow: t - 1 });
        for (const d of l) {
          const { row: g, cellHeight: m } = d;
          g < t && t <= g + m - 1 && a.push(d);
        }
        return a;
      }
      function d5(c, t, i) {
        const a = c.parent, l = a.parent, d = a.index, g = t - d, m = {}, w = parseInt(c.getAttribute("rowspan")) - g;
        w > 1 && (m.rowspan = w);
        const A = parseInt(c.getAttribute("colspan") || 1);
        A > 1 && (m.colspan = A);
        const C = d + g, T = [...new Yt(l, { startRow: d, endRow: C, includeAllSlots: !0 })];
        let R, j = null;
        for (const F of T) {
          const { row: V, column: W, cell: ee } = F;
          ee === c && R === void 0 && (R = W), R !== void 0 && R === W && V === C && (j = ds(i, F.getPositionBefore(), m));
        }
        return On("rowspan", g, c, i), j;
      }
      function h5(c, t) {
        const i = [], a = new Yt(c);
        for (const l of a) {
          const { column: d, cellWidth: g } = l;
          d < t && t <= d + g - 1 && i.push(l);
        }
        return i;
      }
      function f5(c, t, i, a) {
        const l = i - t, d = {}, g = parseInt(c.getAttribute("colspan")) - l;
        g > 1 && (d.colspan = g);
        const m = parseInt(c.getAttribute("rowspan") || 1);
        m > 1 && (d.rowspan = m);
        const w = ds(a, a.createPositionAfter(c), d);
        return On("colspan", l, c, a), w;
      }
      function p5(c, t, i, a, l, d) {
        const g = parseInt(c.getAttribute("colspan") || 1), m = parseInt(c.getAttribute("rowspan") || 1);
        i + g - 1 > l && On("colspan", l - i + 1, c, d, 1), t + m - 1 > a && On("rowspan", a - t + 1, c, d, 1);
      }
      function X0(c, t) {
        const i = t.getColumns(c), a = new Array(i).fill(0);
        for (const { column: d } of new Yt(c))
          a[d]++;
        const l = a.reduce((d, g, m) => g ? d : [...d, m], []);
        if (l.length > 0) {
          const d = l[l.length - 1];
          return t.removeColumns(c, { at: d }), !0;
        }
        return !1;
      }
      function J0(c, t) {
        const i = [], a = t.getRows(c);
        for (let l = 0; l < a; l++)
          c.getChild(l).isEmpty && i.push(l);
        if (i.length > 0) {
          const l = i[i.length - 1];
          return t.removeRows(c, { at: l }), !0;
        }
        return !1;
      }
      function ev(c, t) {
        X0(c, t) || J0(c, t);
      }
      function g5(c, t) {
        const i = Array.from(new Yt(c, { startColumn: t.firstColumn, endColumn: t.lastColumn, row: t.lastRow }));
        if (i.every(({ cellHeight: l }) => l === 1))
          return t.lastRow;
        const a = i[0].cellHeight - 1;
        return t.lastRow + a;
      }
      function m5(c, t) {
        const i = Array.from(new Yt(c, { startRow: t.firstRow, endRow: t.lastRow, column: t.lastColumn }));
        if (i.every(({ cellWidth: l }) => l === 1))
          return t.lastColumn;
        const a = i[0].cellWidth - 1;
        return t.lastColumn + a;
      }
      class Uh extends kt {
        constructor(t, i) {
          super(t), this.direction = i.direction, this.isHorizontal = this.direction == "right" || this.direction == "left";
        }
        refresh() {
          const t = this._getMergeableCell();
          this.value = t, this.isEnabled = !!t;
        }
        execute() {
          const t = this.editor.model, i = t.document, a = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(i.selection)[0], l = this.value, d = this.direction;
          t.change((g) => {
            const m = d == "right" || d == "down", w = m ? a : l, A = m ? l : a, C = A.parent;
            (function(V, W, ee) {
              v5(V) || (v5(W) && ee.remove(ee.createRangeIn(W)), ee.move(ee.createRangeIn(V), ee.createPositionAt(W, "end"))), ee.remove(V);
            })(A, w, g);
            const T = this.isHorizontal ? "colspan" : "rowspan", R = parseInt(a.getAttribute(T) || 1), j = parseInt(l.getAttribute(T) || 1);
            g.setAttribute(T, R + j, w), g.setSelection(g.createRangeIn(w));
            const F = this.editor.plugins.get("TableUtils");
            ev(C.findAncestor("table"), F);
          });
        }
        _getMergeableCell() {
          const t = this.editor.model.document, i = this.editor.plugins.get("TableUtils"), a = i.getTableCellsContainingSelection(t.selection)[0];
          if (!a)
            return;
          const l = this.isHorizontal ? function(m, w, A) {
            const C = m.parent, T = C.parent, R = w == "right" ? m.nextSibling : m.previousSibling, j = (T.getAttribute("headingColumns") || 0) > 0;
            if (!R)
              return;
            const F = w == "right" ? m : R, V = w == "right" ? R : m, { column: W } = A.getCellLocation(F), { column: ee } = A.getCellLocation(V), le = parseInt(F.getAttribute("colspan") || 1), be = Z0(A, F), Ne = Z0(A, V);
            if (!(j && be != Ne))
              return W + le === ee ? R : void 0;
          }(a, this.direction, i) : function(m, w, A) {
            const C = m.parent, T = C.parent, R = T.getChildIndex(C);
            if (w == "down" && R === A.getRows(T) - 1 || w == "up" && R === 0)
              return;
            const j = parseInt(m.getAttribute("rowspan") || 1), F = T.getAttribute("headingRows") || 0, V = w == "down" && R + j === F, W = w == "up" && R === F;
            if (F && (V || W))
              return;
            const ee = parseInt(m.getAttribute("rowspan") || 1), le = w == "down" ? R + ee : R, be = [...new Yt(T, { endRow: le })], Ne = be.find((Rt) => Rt.cell === m), Je = Ne.column, Mt = be.find(({ row: Rt, cellHeight: zn, column: Jn }) => Jn === Je && (w == "down" ? Rt === le : le === Rt + zn));
            return Mt && Mt.cell;
          }(a, this.direction, i);
          if (!l)
            return;
          const d = this.isHorizontal ? "rowspan" : "colspan", g = parseInt(a.getAttribute(d) || 1);
          return parseInt(l.getAttribute(d) || 1) === g ? l : void 0;
        }
      }
      function v5(c) {
        return c.childCount == 1 && c.getChild(0).is("element", "paragraph") && c.getChild(0).isEmpty;
      }
      class PB extends kt {
        refresh() {
          const t = this.editor.plugins.get("TableUtils"), i = t.getSelectionAffectedTableCells(this.editor.model.document.selection), a = i[0];
          if (a) {
            const l = a.findAncestor("table"), d = this.editor.plugins.get("TableUtils").getRows(l) - 1, g = t.getRowIndexes(i), m = g.first === 0 && g.last === d;
            this.isEnabled = !m;
          } else
            this.isEnabled = !1;
        }
        execute() {
          const t = this.editor.model, i = this.editor.plugins.get("TableUtils"), a = i.getSelectionAffectedTableCells(t.document.selection), l = i.getRowIndexes(a), d = a[0], g = d.findAncestor("table"), m = i.getCellLocation(d).column;
          t.change((w) => {
            const A = l.last - l.first + 1;
            i.removeRows(g, { at: l.first, rows: A });
            const C = function(T, R, j, F) {
              const V = T.getChild(Math.min(R, F - 1));
              let W = V.getChild(0), ee = 0;
              for (const le of V.getChildren()) {
                if (ee > j)
                  return W;
                W = le, ee += parseInt(le.getAttribute("colspan") || 1);
              }
              return W;
            }(g, l.first, m, i.getRows(g));
            w.setSelection(w.createPositionAt(C, 0));
          });
        }
      }
      class OB extends kt {
        refresh() {
          const t = this.editor.plugins.get("TableUtils"), i = t.getSelectionAffectedTableCells(this.editor.model.document.selection), a = i[0];
          if (a) {
            const l = a.findAncestor("table"), d = t.getColumns(l), { first: g, last: m } = t.getColumnIndexes(i);
            this.isEnabled = m - g < d - 1;
          } else
            this.isEnabled = !1;
        }
        execute() {
          const t = this.editor.plugins.get("TableUtils"), [i, a] = function(w, A) {
            const C = A.getSelectionAffectedTableCells(w), T = C[0], R = C.pop(), j = [T, R];
            return T.isBefore(R) ? j : j.reverse();
          }(this.editor.model.document.selection, t), l = i.parent.parent, d = [...new Yt(l)], g = { first: d.find((w) => w.cell === i).column, last: d.find((w) => w.cell === a).column }, m = function(w, A, C, T) {
            return parseInt(C.getAttribute("colspan") || 1) > 1 ? C : A.previousSibling || C.nextSibling ? C.nextSibling || A.previousSibling : T.first ? w.reverse().find(({ column: j }) => j < T.first).cell : w.reverse().find(({ column: j }) => j > T.last).cell;
          }(d, i, a, g);
          this.editor.model.change((w) => {
            const A = g.last - g.first + 1;
            this.editor.plugins.get("TableUtils").removeColumns(l, { at: g.first, columns: A }), w.setSelection(w.createPositionAt(m, 0));
          });
        }
      }
      class RB extends kt {
        refresh() {
          const t = this.editor.plugins.get("TableUtils"), i = this.editor.model, a = t.getSelectionAffectedTableCells(i.document.selection), l = a.length > 0;
          this.isEnabled = l, this.value = l && a.every((d) => this._isInHeading(d, d.parent.parent));
        }
        execute(t = {}) {
          if (t.forceValue === this.value)
            return;
          const i = this.editor.plugins.get("TableUtils"), a = this.editor.model, l = i.getSelectionAffectedTableCells(a.document.selection), d = l[0].findAncestor("table"), { first: g, last: m } = i.getRowIndexes(l), w = this.value ? g : m + 1, A = d.getAttribute("headingRows") || 0;
          a.change((C) => {
            if (w) {
              const T = u5(d, w, w > A ? A : 0);
              for (const { cell: R } of T)
                d5(R, w, C);
            }
            On("headingRows", w, d, C, 0);
          });
        }
        _isInHeading(t, i) {
          const a = parseInt(i.getAttribute("headingRows") || 0);
          return !!a && t.parent.index < a;
        }
      }
      class NB extends kt {
        refresh() {
          const t = this.editor.model, i = this.editor.plugins.get("TableUtils"), a = i.getSelectionAffectedTableCells(t.document.selection), l = a.length > 0;
          this.isEnabled = l, this.value = l && a.every((d) => Z0(i, d));
        }
        execute(t = {}) {
          if (t.forceValue === this.value)
            return;
          const i = this.editor.plugins.get("TableUtils"), a = this.editor.model, l = i.getSelectionAffectedTableCells(a.document.selection), d = l[0].findAncestor("table"), { first: g, last: m } = i.getColumnIndexes(l), w = this.value ? g : m + 1;
          a.change((A) => {
            if (w) {
              const C = h5(d, w);
              for (const { cell: T, column: R } of C)
                f5(T, R, w, A);
            }
            On("headingColumns", w, d, A, 0);
          });
        }
      }
      class sr extends Ie {
        static get pluginName() {
          return "TableUtils";
        }
        init() {
          this.decorate("insertColumns"), this.decorate("insertRows");
        }
        getCellLocation(t) {
          const i = t.parent, a = i.parent, l = a.getChildIndex(i), d = new Yt(a, { row: l });
          for (const { cell: g, row: m, column: w } of d)
            if (g === t)
              return { row: m, column: w };
        }
        createTable(t, i) {
          const a = t.createElement("table"), l = parseInt(i.rows) || 2, d = parseInt(i.columns) || 2;
          return tv(t, a, 0, l, d), i.headingRows && On("headingRows", Math.min(i.headingRows, l), a, t, 0), i.headingColumns && On("headingColumns", Math.min(i.headingColumns, d), a, t, 0), a;
        }
        insertRows(t, i = {}) {
          const a = this.editor.model, l = i.at || 0, d = i.rows || 1, g = i.copyStructureFromAbove !== void 0, m = i.copyStructureFromAbove ? l - 1 : l, w = this.getRows(t), A = this.getColumns(t);
          if (l > w)
            throw new S("tableutils-insertrows-insert-out-of-range", this, { options: i });
          a.change((C) => {
            const T = t.getAttribute("headingRows") || 0;
            if (T > l && On("headingRows", T + d, t, C, 0), !g && (l === 0 || l === w))
              return void tv(C, t, l, d, A);
            const R = g ? Math.max(l, m) : l, j = new Yt(t, { endRow: R }), F = new Array(A).fill(1);
            for (const { row: V, column: W, cellHeight: ee, cellWidth: le, cell: be } of j) {
              const Ne = V + ee - 1, Je = V <= m && m <= Ne;
              V < l && l <= Ne ? (C.setAttribute("rowspan", ee + d, be), F[W] = -le) : g && Je && (F[W] = le);
            }
            for (let V = 0; V < d; V++) {
              const W = C.createElement("tableRow");
              C.insert(W, t, l);
              for (let ee = 0; ee < F.length; ee++) {
                const le = F[ee], be = C.createPositionAt(W, "end");
                le > 0 && ds(C, be, le > 1 ? { colspan: le } : null), ee += Math.abs(le) - 1;
              }
            }
          });
        }
        insertColumns(t, i = {}) {
          const a = this.editor.model, l = i.at || 0, d = i.columns || 1;
          a.change((g) => {
            const m = t.getAttribute("headingColumns");
            l < m && g.setAttribute("headingColumns", m + d, t);
            const w = this.getColumns(t);
            if (l === 0 || w === l) {
              for (const C of t.getChildren())
                C.is("element", "tableRow") && Dl(d, g, g.createPositionAt(C, l ? "end" : 0));
              return;
            }
            const A = new Yt(t, { column: l, includeAllSlots: !0 });
            for (const C of A) {
              const { row: T, cell: R, cellAnchorColumn: j, cellAnchorRow: F, cellWidth: V, cellHeight: W } = C;
              if (j < l) {
                g.setAttribute("colspan", V + d, R);
                const ee = F + W - 1;
                for (let le = T; le <= ee; le++)
                  A.skipRow(le);
              } else
                Dl(d, g, C.getPositionBefore());
            }
          });
        }
        removeRows(t, i) {
          const a = this.editor.model, l = i.rows || 1, d = this.getRows(t), g = i.at, m = g + l - 1;
          if (m > d - 1)
            throw new S("tableutils-removerows-row-index-out-of-range", this, { table: t, options: i });
          a.change((w) => {
            const { cellsToMove: A, cellsToTrim: C } = function(T, R, j) {
              const F = /* @__PURE__ */ new Map(), V = [];
              for (const { row: W, column: ee, cellHeight: le, cell: be } of new Yt(T, { endRow: j })) {
                const Ne = W + le - 1;
                if (W >= R && W <= j && Ne > j) {
                  const Je = le - (j - W + 1);
                  F.set(ee, { cell: be, rowspan: Je });
                }
                if (W < R && Ne >= R) {
                  let Je;
                  Je = Ne >= j ? j - R + 1 : Ne - R + 1, V.push({ cell: be, rowspan: le - Je });
                }
              }
              return { cellsToMove: F, cellsToTrim: V };
            }(t, g, m);
            A.size && function(T, R, j, F) {
              const V = new Yt(T, { includeAllSlots: !0, row: R }), W = [...V], ee = T.getChild(R);
              let le;
              for (const { column: be, cell: Ne, isAnchor: Je } of W)
                if (j.has(be)) {
                  const { cell: Mt, rowspan: Rt } = j.get(be), zn = le ? F.createPositionAfter(le) : F.createPositionAt(ee, 0);
                  F.move(F.createRangeOn(Mt), zn), On("rowspan", Rt, Mt, F), le = Mt;
                } else
                  Je && (le = Ne);
            }(t, m + 1, A, w);
            for (let T = m; T >= g; T--)
              w.remove(t.getChild(T));
            for (const { rowspan: T, cell: R } of C)
              On("rowspan", T, R, w);
            (function(T, R, j, F) {
              const V = T.getAttribute("headingRows") || 0;
              R < V && On("headingRows", j < V ? V - (j - R + 1) : R, T, F, 0);
            })(t, g, m, w), X0(t, this) || J0(t, this);
          });
        }
        removeColumns(t, i) {
          const a = this.editor.model, l = i.at, d = i.columns || 1, g = i.at + d - 1;
          a.change((m) => {
            (function(w, A, C) {
              const T = w.getAttribute("headingColumns") || 0;
              if (T && A.first < T) {
                const R = Math.min(T - 1, A.last) - A.first + 1;
                C.setAttribute("headingColumns", T - R, w);
              }
            })(t, { first: l, last: g }, m);
            for (let w = g; w >= l; w--)
              for (const { cell: A, column: C, cellWidth: T } of [...new Yt(t)])
                C <= w && T > 1 && C + T > w ? On("colspan", T - 1, A, m) : C === w && m.remove(A);
            J0(t, this) || X0(t, this);
          });
        }
        splitCellVertically(t, i = 2) {
          const a = this.editor.model, l = t.parent.parent, d = parseInt(t.getAttribute("rowspan") || 1), g = parseInt(t.getAttribute("colspan") || 1);
          a.change((m) => {
            if (g > 1) {
              const { newCellsSpan: w, updatedSpan: A } = b5(g, i);
              On("colspan", A, t, m);
              const C = {};
              w > 1 && (C.colspan = w), d > 1 && (C.rowspan = d), Dl(g > i ? i - 1 : g - 1, m, m.createPositionAfter(t), C);
            }
            if (g < i) {
              const w = i - g, A = [...new Yt(l)], { column: C } = A.find(({ cell: F }) => F === t), T = A.filter(({ cell: F, cellWidth: V, column: W }) => F !== t && W === C || W < C && W + V > C);
              for (const { cell: F, cellWidth: V } of T)
                m.setAttribute("colspan", V + w, F);
              const R = {};
              d > 1 && (R.rowspan = d), Dl(w, m, m.createPositionAfter(t), R);
              const j = l.getAttribute("headingColumns") || 0;
              j > C && On("headingColumns", j + w, l, m);
            }
          });
        }
        splitCellHorizontally(t, i = 2) {
          const a = this.editor.model, l = t.parent, d = l.parent, g = d.getChildIndex(l), m = parseInt(t.getAttribute("rowspan") || 1), w = parseInt(t.getAttribute("colspan") || 1);
          a.change((A) => {
            if (m > 1) {
              const C = [...new Yt(d, { startRow: g, endRow: g + m - 1, includeAllSlots: !0 })], { newCellsSpan: T, updatedSpan: R } = b5(m, i);
              On("rowspan", R, t, A);
              const { column: j } = C.find(({ cell: V }) => V === t), F = {};
              T > 1 && (F.rowspan = T), w > 1 && (F.colspan = w);
              for (const V of C) {
                const { column: W, row: ee } = V;
                ee >= g + R && W === j && (ee + g + R) % T == 0 && Dl(1, A, V.getPositionBefore(), F);
              }
            }
            if (m < i) {
              const C = i - m, T = [...new Yt(d, { startRow: 0, endRow: g })];
              for (const { cell: F, cellHeight: V, row: W } of T)
                if (F !== t && W + V > g) {
                  const ee = V + C;
                  A.setAttribute("rowspan", ee, F);
                }
              const R = {};
              w > 1 && (R.colspan = w), tv(A, d, g + 1, C, 1, R);
              const j = d.getAttribute("headingRows") || 0;
              j > g && On("headingRows", j + C, d, A);
            }
          });
        }
        getColumns(t) {
          return [...t.getChild(0).getChildren()].reduce((i, a) => i + parseInt(a.getAttribute("colspan") || 1), 0);
        }
        getRows(t) {
          return Array.from(t.getChildren()).reduce((i, a) => a.is("element", "tableRow") ? i + 1 : i, 0);
        }
        createTableWalker(t, i = {}) {
          return new Yt(t, i);
        }
        getSelectedTableCells(t) {
          const i = [];
          for (const a of this.sortRanges(t.getRanges())) {
            const l = a.getContainedElement();
            l && l.is("element", "tableCell") && i.push(l);
          }
          return i;
        }
        getTableCellsContainingSelection(t) {
          const i = [];
          for (const a of t.getRanges()) {
            const l = a.start.findAncestor("tableCell");
            l && i.push(l);
          }
          return i;
        }
        getSelectionAffectedTableCells(t) {
          const i = this.getSelectedTableCells(t);
          return i.length ? i : this.getTableCellsContainingSelection(t);
        }
        getRowIndexes(t) {
          const i = t.map((a) => a.parent.index);
          return this._getFirstLastIndexesObject(i);
        }
        getColumnIndexes(t) {
          const i = t[0].findAncestor("table"), a = [...new Yt(i)].filter((l) => t.includes(l.cell)).map((l) => l.column);
          return this._getFirstLastIndexesObject(a);
        }
        isSelectionRectangular(t) {
          if (t.length < 2 || !this._areCellInTheSameTableSection(t))
            return !1;
          const i = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
          let l = 0;
          for (const g of t) {
            const { row: m, column: w } = this.getCellLocation(g), A = parseInt(g.getAttribute("rowspan") || 1), C = parseInt(g.getAttribute("colspan") || 1);
            i.add(m), a.add(w), A > 1 && i.add(m + A - 1), C > 1 && a.add(w + C - 1), l += A * C;
          }
          return function(g, m) {
            const w = Array.from(g.values()), A = Array.from(m.values()), C = Math.max(...w), T = Math.min(...w), R = Math.max(...A), j = Math.min(...A);
            return (C - T + 1) * (R - j + 1);
          }(i, a) == l;
        }
        sortRanges(t) {
          return Array.from(t).sort($B);
        }
        _getFirstLastIndexesObject(t) {
          const i = t.sort((a, l) => a - l);
          return { first: i[0], last: i[i.length - 1] };
        }
        _areCellInTheSameTableSection(t) {
          const i = t[0].findAncestor("table"), a = this.getRowIndexes(t), l = parseInt(i.getAttribute("headingRows") || 0);
          if (!this._areIndexesInSameSection(a, l))
            return !1;
          const d = parseInt(i.getAttribute("headingColumns") || 0), g = this.getColumnIndexes(t);
          return this._areIndexesInSameSection(g, d);
        }
        _areIndexesInSameSection({ first: t, last: i }, a) {
          return t < a == i < a;
        }
      }
      function tv(c, t, i, a, l, d = {}) {
        for (let g = 0; g < a; g++) {
          const m = c.createElement("tableRow");
          c.insert(m, t, i), Dl(l, c, c.createPositionAt(m, "end"), d);
        }
      }
      function Dl(c, t, i, a = {}) {
        for (let l = 0; l < c; l++)
          ds(t, i, a);
      }
      function b5(c, t) {
        if (c < t)
          return { newCellsSpan: 1, updatedSpan: 1 };
        const i = Math.floor(c / t);
        return { newCellsSpan: i, updatedSpan: c - i * t + i };
      }
      function $B(c, t) {
        const i = c.start, a = t.start;
        return i.isBefore(a) ? -1 : 1;
      }
      class LB extends kt {
        refresh() {
          const t = this.editor.plugins.get(sr), i = t.getSelectedTableCells(this.editor.model.document.selection);
          this.isEnabled = t.isSelectionRectangular(i, this.editor.plugins.get(sr));
        }
        execute() {
          const t = this.editor.model, i = this.editor.plugins.get(sr);
          t.change((a) => {
            const l = i.getSelectedTableCells(t.document.selection), d = l.shift(), { mergeWidth: g, mergeHeight: m } = function(w, A, C) {
              let T = 0, R = 0;
              for (const ee of A) {
                const { row: le, column: be } = C.getCellLocation(ee);
                T = y5(ee, be, T, "colspan"), R = y5(ee, le, R, "rowspan");
              }
              const { row: j, column: F } = C.getCellLocation(w), V = T - F, W = R - j;
              return { mergeWidth: V, mergeHeight: W };
            }(d, l, i);
            On("colspan", g, d, a), On("rowspan", m, d, a);
            for (const w of l)
              jB(w, d, a);
            ev(d.findAncestor("table"), i), a.setSelection(d, "in");
          });
        }
      }
      function jB(c, t, i) {
        w5(c) || (w5(t) && i.remove(i.createRangeIn(t)), i.move(i.createRangeIn(c), i.createPositionAt(t, "end"))), i.remove(c);
      }
      function w5(c) {
        return c.childCount == 1 && c.getChild(0).is("element", "paragraph") && c.getChild(0).isEmpty;
      }
      function y5(c, t, i, a) {
        const l = parseInt(c.getAttribute(a) || 1);
        return Math.max(i, t + l);
      }
      class BB extends kt {
        constructor(t) {
          super(t), this.affectsData = !1;
        }
        refresh() {
          const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
        execute() {
          const t = this.editor.model, i = this.editor.plugins.get("TableUtils"), a = i.getSelectionAffectedTableCells(t.document.selection), l = i.getRowIndexes(a), d = a[0].findAncestor("table"), g = [];
          for (let m = l.first; m <= l.last; m++)
            for (const w of d.getChild(m).getChildren())
              g.push(t.createRangeOn(w));
          t.change((m) => {
            m.setSelection(g);
          });
        }
      }
      class FB extends kt {
        constructor(t) {
          super(t), this.affectsData = !1;
        }
        refresh() {
          const t = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
        execute() {
          const t = this.editor.plugins.get("TableUtils"), i = this.editor.model, a = t.getSelectionAffectedTableCells(i.document.selection), l = a[0], d = a.pop(), g = l.findAncestor("table"), m = t.getCellLocation(l), w = t.getCellLocation(d), A = Math.min(m.column, w.column), C = Math.max(m.column, w.column), T = [];
          for (const R of new Yt(g, { startColumn: A, endColumn: C }))
            T.push(i.createRangeOn(R.cell));
          i.change((R) => {
            R.setSelection(T);
          });
        }
      }
      function zB(c) {
        c.document.registerPostFixer((t) => function(i, a) {
          const l = a.document.differ.getChanges();
          let d = !1;
          const g = /* @__PURE__ */ new Set();
          for (const m of l) {
            let w;
            m.name == "table" && m.type == "insert" && (w = m.position.nodeAfter), m.name != "tableRow" && m.name != "tableCell" || (w = m.position.findAncestor("table")), UB(m) && (w = m.range.start.findAncestor("table")), w && !g.has(w) && (d = VB(w, i) || d, d = HB(w, i) || d, g.add(w));
          }
          return d;
        }(t, c));
      }
      function VB(c, t) {
        let i = !1;
        const a = function(l) {
          const d = parseInt(l.getAttribute("headingRows") || 0), g = Array.from(l.getChildren()).reduce((w, A) => A.is("element", "tableRow") ? w + 1 : w, 0), m = [];
          for (const { row: w, cell: A, cellHeight: C } of new Yt(l)) {
            if (C < 2)
              continue;
            const T = w < d ? d : g;
            if (w + C > T) {
              const R = T - w;
              m.push({ cell: A, rowspan: R });
            }
          }
          return m;
        }(c);
        if (a.length) {
          i = !0;
          for (const l of a)
            On("rowspan", l.rowspan, l.cell, t, 1);
        }
        return i;
      }
      function HB(c, t) {
        let i = !1;
        const a = function(m) {
          const w = new Array(m.childCount).fill(0);
          for (const { rowIndex: A } of new Yt(m, { includeAllSlots: !0 }))
            w[A]++;
          return w;
        }(c), l = [];
        for (const [m, w] of a.entries())
          !w && c.getChild(m).is("element", "tableRow") && l.push(m);
        if (l.length) {
          i = !0;
          for (const m of l.reverse())
            t.remove(c.getChild(m)), a.splice(m, 1);
        }
        const d = a.filter((m, w) => c.getChild(w).is("element", "tableRow")), g = d[0];
        if (!d.every((m) => m === g)) {
          const m = d.reduce((w, A) => A > w ? A : w, 0);
          for (const [w, A] of d.entries()) {
            const C = m - A;
            if (C) {
              for (let T = 0; T < C; T++)
                ds(t, t.createPositionAt(c.getChild(w), "end"));
              i = !0;
            }
          }
        }
        return i;
      }
      function UB(c) {
        const t = c.type === "attribute", i = c.attributeKey;
        return t && (i === "headingRows" || i === "colspan" || i === "rowspan");
      }
      function WB(c) {
        c.document.registerPostFixer((t) => function(i, a) {
          const l = a.document.differ.getChanges();
          let d = !1;
          for (const g of l)
            g.type == "insert" && g.name == "table" && (d = GB(g.position.nodeAfter, i) || d), g.type == "insert" && g.name == "tableRow" && (d = k5(g.position.nodeAfter, i) || d), g.type == "insert" && g.name == "tableCell" && (d = nv(g.position.nodeAfter, i) || d), qB(g) && (d = nv(g.position.parent, i) || d);
          return d;
        }(t, c));
      }
      function GB(c, t) {
        let i = !1;
        for (const a of c.getChildren())
          a.is("element", "tableRow") && (i = k5(a, t) || i);
        return i;
      }
      function k5(c, t) {
        let i = !1;
        for (const a of c.getChildren())
          i = nv(a, t) || i;
        return i;
      }
      function nv(c, t) {
        if (c.childCount == 0)
          return t.insertElement("paragraph", c), !0;
        const i = Array.from(c.getChildren()).filter((a) => a.is("$text"));
        for (const a of i)
          t.wrap(t.createRangeOn(a), "paragraph");
        return !!i.length;
      }
      function qB(c) {
        return !(!c.position || !c.position.parent.is("element", "tableCell")) && (c.type == "insert" && c.name == "$text" || c.type == "remove");
      }
      function KB(c, t) {
        if (!c.is("element", "paragraph"))
          return !1;
        const i = t.toViewElement(c);
        return !!i && o5(c) !== i.is("element", "span");
      }
      var _5 = s(3881), YB = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(_5.Z, YB), _5.Z.locals;
      class QB extends Ie {
        static get pluginName() {
          return "TableEditing";
        }
        static get requires() {
          return [sr];
        }
        init() {
          const t = this.editor, i = t.model, a = i.schema, l = t.conversion, d = t.plugins.get(sr);
          a.register("table", { inheritAllFrom: "$blockObject", allowAttributes: ["headingRows", "headingColumns"] }), a.register("tableRow", { allowIn: "table", isLimit: !0 }), a.register("tableCell", { allowContentOf: "$container", allowIn: "tableRow", allowAttributes: ["colspan", "rowspan"], isLimit: !0, isSelectable: !0 }), l.for("upcast").add((g) => {
            g.on("element:figure", (m, w, A) => {
              if (!A.consumable.test(w.viewItem, { name: !0, classes: "table" }))
                return;
              const C = function(R) {
                for (const j of R.getChildren())
                  if (j.is("element", "table"))
                    return j;
              }(w.viewItem);
              if (!C || !A.consumable.test(C, { name: !0 }))
                return;
              A.consumable.consume(w.viewItem, { name: !0, classes: "table" });
              const T = Fn(A.convertItem(C, w.modelCursor).modelRange.getItems());
              T ? (A.convertChildren(w.viewItem, A.writer.createPositionAt(T, "end")), A.updateConversionResult(T, w)) : A.consumable.revert(w.viewItem, { name: !0, classes: "table" });
            });
          }), l.for("upcast").add(MB()), l.for("editingDowncast").elementToStructure({ model: { name: "table", attributes: ["headingRows"] }, view: n5(d, { asWidget: !0 }) }), l.for("dataDowncast").elementToStructure({ model: { name: "table", attributes: ["headingRows"] }, view: n5(d) }), l.for("upcast").elementToElement({ model: "tableRow", view: "tr" }), l.for("upcast").add((g) => {
            g.on("element:tr", (m, w) => {
              w.viewItem.isEmpty && w.modelCursor.index == 0 && m.stop();
            }, { priority: "high" });
          }), l.for("downcast").elementToElement({ model: "tableRow", view: (g, { writer: m }) => g.isEmpty ? m.createEmptyElement("tr") : m.createContainerElement("tr") }), l.for("upcast").elementToElement({ model: "tableCell", view: "td" }), l.for("upcast").elementToElement({ model: "tableCell", view: "th" }), l.for("upcast").add(t5("td")), l.for("upcast").add(t5("th")), l.for("editingDowncast").elementToElement({ model: "tableCell", view: r5({ asWidget: !0 }) }), l.for("dataDowncast").elementToElement({ model: "tableCell", view: r5() }), l.for("editingDowncast").elementToElement({ model: "paragraph", view: i5({ asWidget: !0 }), converterPriority: "high" }), l.for("dataDowncast").elementToElement({ model: "paragraph", view: i5(), converterPriority: "high" }), l.for("downcast").attributeToAttribute({ model: "colspan", view: "colspan" }), l.for("upcast").attributeToAttribute({ model: { key: "colspan", value: A5("colspan") }, view: "colspan" }), l.for("downcast").attributeToAttribute({ model: "rowspan", view: "rowspan" }), l.for("upcast").attributeToAttribute({ model: { key: "rowspan", value: A5("rowspan") }, view: "rowspan" }), t.data.mapper.on("modelToViewPosition", (g, m) => {
            const w = m.modelPosition.parent, A = m.modelPosition.nodeBefore;
            if (!w.is("element", "tableCell") || !A || !A.is("element", "paragraph"))
              return;
            const C = m.mapper.toViewElement(A), T = m.mapper.toViewElement(w);
            C === T && (m.viewPosition = m.mapper.findPositionIn(T, A.maxOffset));
          }), t.config.define("table.defaultHeadings.rows", 0), t.config.define("table.defaultHeadings.columns", 0), t.commands.add("insertTable", new IB(t)), t.commands.add("insertTableRowAbove", new a5(t, { order: "above" })), t.commands.add("insertTableRowBelow", new a5(t, { order: "below" })), t.commands.add("insertTableColumnLeft", new s5(t, { order: "left" })), t.commands.add("insertTableColumnRight", new s5(t, { order: "right" })), t.commands.add("removeTableRow", new PB(t)), t.commands.add("removeTableColumn", new OB(t)), t.commands.add("splitTableCellVertically", new l5(t, { direction: "vertically" })), t.commands.add("splitTableCellHorizontally", new l5(t, { direction: "horizontally" })), t.commands.add("mergeTableCells", new LB(t)), t.commands.add("mergeTableCellRight", new Uh(t, { direction: "right" })), t.commands.add("mergeTableCellLeft", new Uh(t, { direction: "left" })), t.commands.add("mergeTableCellDown", new Uh(t, { direction: "down" })), t.commands.add("mergeTableCellUp", new Uh(t, { direction: "up" })), t.commands.add("setTableColumnHeader", new NB(t)), t.commands.add("setTableRowHeader", new RB(t)), t.commands.add("selectTableRow", new BB(t)), t.commands.add("selectTableColumn", new FB(t)), zB(i), WB(i), this.listenTo(i.document, "change:data", () => {
            (function(g, m) {
              const w = g.document.differ;
              for (const A of w.getChanges()) {
                let C, T = !1;
                if (A.type == "attribute") {
                  const V = A.range.start.nodeAfter;
                  if (!V || !V.is("element", "table") || A.attributeKey != "headingRows" && A.attributeKey != "headingColumns")
                    continue;
                  C = V, T = A.attributeKey == "headingRows";
                } else
                  A.name != "tableRow" && A.name != "tableCell" || (C = A.position.findAncestor("table"), T = A.name == "tableRow");
                if (!C)
                  continue;
                const R = C.getAttribute("headingRows") || 0, j = C.getAttribute("headingColumns") || 0, F = new Yt(C);
                for (const V of F) {
                  const W = V.row < R || V.column < j ? "th" : "td", ee = m.mapper.toViewElement(V.cell);
                  ee && ee.is("element") && ee.name != W && m.reconvertItem(T ? V.cell.parent : V.cell);
                }
              }
            })(i, t.editing), function(g, m) {
              const w = g.document.differ, A = /* @__PURE__ */ new Set();
              for (const C of w.getChanges()) {
                const T = C.type == "attribute" ? C.range.start.parent : C.position.parent;
                T.is("element", "tableCell") && A.add(T);
              }
              for (const C of A.values()) {
                const T = Array.from(C.getChildren()).filter((R) => KB(R, m.mapper));
                for (const R of T)
                  m.reconvertItem(R);
              }
            }(i, t.editing);
          });
        }
      }
      function A5(c) {
        return (t) => {
          const i = parseInt(t.getAttribute(c));
          return Number.isNaN(i) || i <= 0 ? null : i;
        };
      }
      var C5 = s(1613), ZB = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(C5.Z, ZB), C5.Z.locals;
      class XB extends At {
        constructor(t) {
          super(t);
          const i = this.bindTemplate;
          this.items = this._createGridCollection(), this.keystrokes = new Qi(), this.focusTracker = new Kr(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (a, l) => `${l} \xD7 ${a}`), this.setTemplate({ tag: "div", attributes: { class: ["ck"] }, children: [{ tag: "div", attributes: { class: ["ck-insert-table-dropdown__grid"] }, on: { "mouseover@.ck-insert-table-dropdown-grid-box": i.to("boxover") }, children: this.items }, { tag: "div", attributes: { class: ["ck", "ck-insert-table-dropdown__label"], "aria-hidden": !0 }, children: [{ text: i.to("label") }] }], on: { mousedown: i.to((a) => {
            a.preventDefault();
          }), click: i.to(() => {
            this.fire("execute");
          }) } }), this.on("boxover", (a, l) => {
            const { row: d, column: g } = l.target.dataset;
            this.items.get(10 * (parseInt(d, 10) - 1) + (parseInt(g, 10) - 1)).focus();
          }), this.focusTracker.on("change:focusedElement", (a, l, d) => {
            if (!d)
              return;
            const { row: g, column: m } = d.dataset;
            this.set({ rows: parseInt(g), columns: parseInt(m) });
          }), this.on("change:columns", () => this._highlightGridBoxes()), this.on("change:rows", () => this._highlightGridBoxes());
        }
        render() {
          super.render(), function({ keystrokeHandler: t, focusTracker: i, gridItems: a, numberOfColumns: l, uiLanguageDirection: d }) {
            const g = typeof l == "number" ? () => l : l;
            function m(C) {
              return (T) => {
                const R = a.find((V) => V.element === i.focusedElement), j = a.getIndex(R), F = C(j, a);
                a.get(F).focus(), T.stopPropagation(), T.preventDefault();
              };
            }
            function w(C, T) {
              return C === T - 1 ? 0 : C + 1;
            }
            function A(C, T) {
              return C === 0 ? T - 1 : C - 1;
            }
            t.set("arrowright", m((C, T) => d === "rtl" ? A(C, T.length) : w(C, T.length))), t.set("arrowleft", m((C, T) => d === "rtl" ? w(C, T.length) : A(C, T.length))), t.set("arrowup", m((C, T) => {
              let R = C - g();
              return R < 0 && (R = C + g() * Math.floor(T.length / g()), R > T.length - 1 && (R -= g())), R;
            })), t.set("arrowdown", m((C, T) => {
              let R = C + g();
              return R > T.length - 1 && (R = C % g()), R;
            }));
          }({ keystrokeHandler: this.keystrokes, focusTracker: this.focusTracker, gridItems: this.items, numberOfColumns: 10, uiLanguageDirection: this.locale && this.locale.uiLanguageDirection });
          for (const t of this.items)
            this.focusTracker.add(t.element);
          this.keystrokes.listenTo(this.element);
        }
        focus() {
          this.items.get(0).focus();
        }
        focusLast() {
          this.items.get(0).focus();
        }
        _highlightGridBoxes() {
          const t = this.rows, i = this.columns;
          this.items.map((a, l) => {
            const d = Math.floor(l / 10) < t && l % 10 < i;
            a.set("isOn", d);
          });
        }
        _createGridButton(t, i, a, l) {
          const d = new cn(t);
          return d.set({ label: l, class: "ck-insert-table-dropdown-grid-box" }), d.extendTemplate({ attributes: { "data-row": i, "data-column": a } }), d;
        }
        _createGridCollection() {
          const t = [];
          for (let i = 0; i < 100; i++) {
            const a = Math.floor(i / 10), l = i % 10, d = `${a + 1} \xD7 ${l + 1}`;
            t.push(this._createGridButton(this.locale, a + 1, l + 1, d));
          }
          return this.createCollection(t);
        }
      }
      class JB extends Ie {
        static get pluginName() {
          return "TableUI";
        }
        init() {
          const t = this.editor, i = this.editor.t, a = t.locale.contentLanguageDirection === "ltr";
          t.ui.componentFactory.add("insertTable", (l) => {
            const d = t.commands.get("insertTable"), g = ua(l);
            let m;
            return g.bind("isEnabled").to(d), g.buttonView.set({ icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>', label: i("Insert table"), tooltip: !0 }), g.on("change:isOpen", () => {
              m || (m = new XB(l), g.panelView.children.add(m), m.delegate("execute").to(g), g.on("execute", () => {
                t.execute("insertTable", { rows: m.rows, columns: m.columns }), t.editing.view.focus();
              }));
            }), g;
          }), t.ui.componentFactory.add("tableColumn", (l) => {
            const d = [{ type: "switchbutton", model: { commandName: "setTableColumnHeader", label: i("Header column"), bindIsOn: !0 } }, { type: "separator" }, { type: "button", model: { commandName: a ? "insertTableColumnLeft" : "insertTableColumnRight", label: i("Insert column left") } }, { type: "button", model: { commandName: a ? "insertTableColumnRight" : "insertTableColumnLeft", label: i("Insert column right") } }, { type: "button", model: { commandName: "removeTableColumn", label: i("Delete column") } }, { type: "button", model: { commandName: "selectTableColumn", label: i("Select column") } }];
            return this._prepareDropdown(i("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', d, l);
          }), t.ui.componentFactory.add("tableRow", (l) => {
            const d = [{ type: "switchbutton", model: { commandName: "setTableRowHeader", label: i("Header row"), bindIsOn: !0 } }, { type: "separator" }, { type: "button", model: { commandName: "insertTableRowAbove", label: i("Insert row above") } }, { type: "button", model: { commandName: "insertTableRowBelow", label: i("Insert row below") } }, { type: "button", model: { commandName: "removeTableRow", label: i("Delete row") } }, { type: "button", model: { commandName: "selectTableRow", label: i("Select row") } }];
            return this._prepareDropdown(i("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', d, l);
          }), t.ui.componentFactory.add("mergeTableCells", (l) => {
            const d = [{ type: "button", model: { commandName: "mergeTableCellUp", label: i("Merge cell up") } }, { type: "button", model: { commandName: a ? "mergeTableCellRight" : "mergeTableCellLeft", label: i("Merge cell right") } }, { type: "button", model: { commandName: "mergeTableCellDown", label: i("Merge cell down") } }, { type: "button", model: { commandName: a ? "mergeTableCellLeft" : "mergeTableCellRight", label: i("Merge cell left") } }, { type: "separator" }, { type: "button", model: { commandName: "splitTableCellVertically", label: i("Split cell vertically") } }, { type: "button", model: { commandName: "splitTableCellHorizontally", label: i("Split cell horizontally") } }];
            return this._prepareMergeSplitButtonDropdown(i("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', d, l);
          });
        }
        _prepareDropdown(t, i, a, l) {
          const d = this.editor, g = ua(l), m = this._fillDropdownWithListOptions(g, a);
          return g.buttonView.set({ label: t, icon: i, tooltip: !0 }), g.bind("isEnabled").toMany(m, "isEnabled", (...w) => w.some((A) => A)), this.listenTo(g, "execute", (w) => {
            d.execute(w.source.commandName), w.source instanceof Dh || d.editing.view.focus();
          }), g;
        }
        _prepareMergeSplitButtonDropdown(t, i, a, l) {
          const d = this.editor, g = ua(l, y0), m = "mergeTableCells", w = d.commands.get(m), A = this._fillDropdownWithListOptions(g, a);
          return g.buttonView.set({ label: t, icon: i, tooltip: !0, isEnabled: !0 }), g.bind("isEnabled").toMany([w, ...A], "isEnabled", (...C) => C.some((T) => T)), this.listenTo(g.buttonView, "execute", () => {
            d.execute(m), d.editing.view.focus();
          }), this.listenTo(g, "execute", (C) => {
            d.execute(C.source.commandName), d.editing.view.focus();
          }), g;
        }
        _fillDropdownWithListOptions(t, i) {
          const a = this.editor, l = [], d = new yi();
          for (const g of i)
            e8(g, a, l, d);
          return oC(t, d, a.ui.componentFactory), l;
        }
      }
      function e8(c, t, i, a) {
        const l = c.model = new fC(c.model), { commandName: d, bindIsOn: g } = c.model;
        if (c.type === "button" || c.type === "switchbutton") {
          const m = t.commands.get(d);
          i.push(m), l.set({ commandName: d }), l.bind("isEnabled").to(m), g && l.bind("isOn").to(m, "value");
        }
        l.set({ withText: !0 }), a.add(c);
      }
      var x5 = s(6945), t8 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(x5.Z, t8), x5.Z.locals;
      class hs extends Ie {
        static get pluginName() {
          return "TableSelection";
        }
        static get requires() {
          return [sr, sr];
        }
        init() {
          const t = this.editor, i = t.model, a = t.editing.view;
          this.listenTo(i, "deleteContent", (l, d) => this._handleDeleteContent(l, d), { priority: "high" }), this.listenTo(a.document, "insertText", (l, d) => this._handleInsertTextEvent(l, d), { priority: "high" }), this._defineSelectionConverter(), this._enablePluginDisabling();
        }
        getSelectedTableCells() {
          const t = this.editor.plugins.get(sr), i = this.editor.model.document.selection, a = t.getSelectedTableCells(i);
          return a.length == 0 ? null : a;
        }
        getSelectionAsFragment() {
          const t = this.editor.plugins.get(sr), i = this.getSelectedTableCells();
          return i ? this.editor.model.change((a) => {
            const l = a.createDocumentFragment(), { first: d, last: g } = t.getColumnIndexes(i), { first: m, last: w } = t.getRowIndexes(i), A = i[0].findAncestor("table");
            let C = w, T = g;
            if (t.isSelectionRectangular(i)) {
              const j = { firstColumn: d, lastColumn: g, firstRow: m, lastRow: w };
              C = g5(A, j), T = m5(A, j);
            }
            const R = c5(A, { startRow: m, startColumn: d, endRow: C, endColumn: T }, a);
            return a.insert(R, l, 0), l;
          }) : null;
        }
        setCellSelection(t, i) {
          const a = this._getCellsToSelect(t, i);
          this.editor.model.change((l) => {
            l.setSelection(a.cells.map((d) => l.createRangeOn(d)), { backward: a.backward });
          });
        }
        getFocusCell() {
          const t = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
          return t && t.is("element", "tableCell") ? t : null;
        }
        getAnchorCell() {
          const t = Fn(this.editor.model.document.selection.getRanges()).getContainedElement();
          return t && t.is("element", "tableCell") ? t : null;
        }
        _defineSelectionConverter() {
          const t = this.editor, i = /* @__PURE__ */ new Set();
          t.conversion.for("editingDowncast").add((a) => a.on("selection", (l, d, g) => {
            const m = g.writer;
            (function(C) {
              for (const T of i)
                C.removeClass("ck-editor__editable_selected", T);
              i.clear();
            })(m);
            const w = this.getSelectedTableCells();
            if (!w)
              return;
            for (const C of w) {
              const T = g.mapper.toViewElement(C);
              m.addClass("ck-editor__editable_selected", T), i.add(T);
            }
            const A = g.mapper.toViewElement(w[w.length - 1]);
            m.setSelection(A, 0);
          }, { priority: "lowest" }));
        }
        _enablePluginDisabling() {
          const t = this.editor;
          this.on("change:isEnabled", () => {
            if (!this.isEnabled) {
              const i = this.getSelectedTableCells();
              if (!i)
                return;
              t.model.change((a) => {
                const l = a.createPositionAt(i[0], 0), d = t.model.schema.getNearestSelectionRange(l);
                a.setSelection(d);
              });
            }
          });
        }
        _handleDeleteContent(t, i) {
          const a = this.editor.plugins.get(sr), [l, d] = i, g = this.editor.model, m = !d || d.direction == "backward", w = a.getSelectedTableCells(l);
          w.length && (t.stop(), g.change((A) => {
            const C = w[m ? w.length - 1 : 0];
            g.change((R) => {
              for (const j of w)
                g.deleteContent(R.createSelection(j, "in"));
            });
            const T = g.schema.getNearestSelectionRange(A.createPositionAt(C, 0));
            l.is("documentSelection") ? A.setSelection(T) : l.setTo(T);
          }));
        }
        _handleInsertTextEvent(t, i) {
          const a = this.editor, l = a.model.document.selection, d = this.getSelectedTableCells(l);
          if (!d)
            return;
          const g = a.editing.view, m = a.editing.mapper, w = d.map((A) => g.createRangeOn(m.toViewElement(A)));
          i.selection = g.createSelection(w);
        }
        _getCellsToSelect(t, i) {
          const a = this.editor.plugins.get("TableUtils"), l = a.getCellLocation(t), d = a.getCellLocation(i), g = Math.min(l.row, d.row), m = Math.max(l.row, d.row), w = Math.min(l.column, d.column), A = Math.max(l.column, d.column), C = new Array(m - g + 1).fill(null).map(() => []), T = { startRow: g, endRow: m, startColumn: w, endColumn: A };
          for (const { row: F, cell: V } of new Yt(t.findAncestor("table"), T))
            C[F - g].push(V);
          const R = d.row < l.row, j = d.column < l.column;
          return R && C.reverse(), j && C.forEach((F) => F.reverse()), { cells: C.flat(), backward: R || j };
        }
      }
      class n8 extends Ie {
        static get pluginName() {
          return "TableClipboard";
        }
        static get requires() {
          return [hs, sr];
        }
        init() {
          const t = this.editor, i = t.editing.view.document;
          this.listenTo(i, "copy", (a, l) => this._onCopyCut(a, l)), this.listenTo(i, "cut", (a, l) => this._onCopyCut(a, l)), this.listenTo(t.model, "insertContent", (a, l) => this._onInsertContent(a, ...l), { priority: "high" }), this.decorate("_replaceTableSlotCell");
        }
        _onCopyCut(t, i) {
          const a = this.editor.plugins.get(hs);
          if (!a.getSelectedTableCells() || t.name == "cut" && this.editor.isReadOnly)
            return;
          i.preventDefault(), t.stop();
          const l = this.editor.data, d = this.editor.editing.view.document, g = l.toView(a.getSelectionAsFragment());
          d.fire("clipboardOutput", { dataTransfer: i.dataTransfer, content: g, method: t.name });
        }
        _onInsertContent(t, i, a) {
          if (a && !a.is("documentSelection"))
            return;
          const l = this.editor.model, d = this.editor.plugins.get(sr);
          let g = E5(i, l);
          if (!g)
            return;
          const m = d.getSelectionAffectedTableCells(l.document.selection);
          m.length ? (t.stop(), l.change((w) => {
            const A = { width: d.getColumns(g), height: d.getRows(g) }, C = function(W, ee, le, be) {
              const Ne = W[0].findAncestor("table"), Je = be.getColumnIndexes(W), Mt = be.getRowIndexes(W), Rt = { firstColumn: Je.first, lastColumn: Je.last, firstRow: Mt.first, lastRow: Mt.last }, zn = W.length === 1;
              return zn && (Rt.lastRow += ee.height - 1, Rt.lastColumn += ee.width - 1, function(Jn, Il, ao, Xr) {
                const Po = Xr.getColumns(Jn), Oo = Xr.getRows(Jn);
                ao > Po && Xr.insertColumns(Jn, { at: Po, columns: ao - Po }), Il > Oo && Xr.insertRows(Jn, { at: Oo, rows: Il - Oo });
              }(Ne, Rt.lastRow + 1, Rt.lastColumn + 1, be)), zn || !be.isSelectionRectangular(W) ? function(Jn, Il, ao) {
                const { firstRow: Xr, lastRow: Po, firstColumn: Oo, lastColumn: Pl } = Il, O5 = { first: Xr, last: Po }, R5 = { first: Oo, last: Pl };
                iv(Jn, Oo, O5, ao), iv(Jn, Pl + 1, O5, ao), rv(Jn, Xr, R5, ao), rv(Jn, Po + 1, R5, ao, Xr);
              }(Ne, Rt, le) : (Rt.lastRow = g5(Ne, Rt), Rt.lastColumn = m5(Ne, Rt)), Rt;
            }(m, A, w, d), T = C.lastRow - C.firstRow + 1, R = C.lastColumn - C.firstColumn + 1, j = { startRow: 0, startColumn: 0, endRow: Math.min(T, A.height) - 1, endColumn: Math.min(R, A.width) - 1 };
            g = c5(g, j, w);
            const F = m[0].findAncestor("table"), V = this._replaceSelectedCellsWithPasted(g, A, F, C, w);
            if (this.editor.plugins.get("TableSelection").isEnabled) {
              const W = d.sortRanges(V.map((ee) => w.createRangeOn(ee)));
              w.setSelection(W);
            } else
              w.setSelection(V[0], 0);
          })) : ev(g, d);
        }
        _replaceSelectedCellsWithPasted(t, i, a, l, d) {
          const { width: g, height: m } = i, w = function(W, ee, le) {
            const be = new Array(le).fill(null).map(() => new Array(ee).fill(null));
            for (const { column: Ne, row: Je, cell: Mt } of new Yt(W))
              be[Je][Ne] = Mt;
            return be;
          }(t, g, m), A = [...new Yt(a, { startRow: l.firstRow, endRow: l.lastRow, startColumn: l.firstColumn, endColumn: l.lastColumn, includeAllSlots: !0 })], C = [];
          let T;
          for (const W of A) {
            const { row: ee, column: le } = W;
            le === l.firstColumn && (T = W.getPositionBefore());
            const be = ee - l.firstRow, Ne = le - l.firstColumn, Je = w[be % m][Ne % g], Mt = Je ? d.cloneElement(Je) : null, Rt = this._replaceTableSlotCell(W, Mt, T, d);
            Rt && (p5(Rt, ee, le, l.lastRow, l.lastColumn, d), C.push(Rt), T = d.createPositionAfter(Rt));
          }
          const R = parseInt(a.getAttribute("headingRows") || 0), j = parseInt(a.getAttribute("headingColumns") || 0), F = l.firstRow < R && R <= l.lastRow, V = l.firstColumn < j && j <= l.lastColumn;
          if (F) {
            const W = rv(a, R, { first: l.firstColumn, last: l.lastColumn }, d, l.firstRow);
            C.push(...W);
          }
          if (V) {
            const W = iv(a, j, { first: l.firstRow, last: l.lastRow }, d);
            C.push(...W);
          }
          return C;
        }
        _replaceTableSlotCell(t, i, a, l) {
          const { cell: d, isAnchor: g } = t;
          return g && l.remove(d), i ? (l.insert(i, a), i) : null;
        }
        getTableIfOnlyTableInContent(t, i) {
          return E5(t, i);
        }
      }
      function E5(c, t) {
        if (!c.is("documentFragment") && !c.is("element"))
          return null;
        if (c.is("element", "table"))
          return c;
        if (c.childCount == 1 && c.getChild(0).is("element", "table"))
          return c.getChild(0);
        const i = t.createRangeIn(c);
        for (const a of i.getItems())
          if (a.is("element", "table")) {
            const l = t.createRange(i.start, t.createPositionBefore(a));
            if (t.hasContent(l, { ignoreWhitespaces: !0 }))
              return null;
            const d = t.createRange(t.createPositionAfter(a), i.end);
            return t.hasContent(d, { ignoreWhitespaces: !0 }) ? null : a;
          }
        return null;
      }
      function rv(c, t, i, a, l = 0) {
        if (!(t < 1))
          return u5(c, t, l).filter(({ column: d, cellWidth: g }) => S5(d, g, i)).map(({ cell: d }) => d5(d, t, a));
      }
      function iv(c, t, i, a) {
        if (!(t < 1))
          return h5(c, t).filter(({ row: l, cellHeight: d }) => S5(l, d, i)).map(({ cell: l, column: d }) => f5(l, d, t, a));
      }
      function S5(c, t, i) {
        const a = c + t - 1, { first: l, last: d } = i;
        return c >= l && c <= d || c < l && a >= l;
      }
      class r8 extends Ie {
        static get pluginName() {
          return "TableKeyboard";
        }
        static get requires() {
          return [hs, sr];
        }
        init() {
          const t = this.editor.editing.view.document;
          this.listenTo(t, "arrowKey", (...i) => this._onArrowKey(...i), { context: "table" }), this.listenTo(t, "tab", (...i) => this._handleTabOnSelectedTable(...i), { context: "figure" }), this.listenTo(t, "tab", (...i) => this._handleTab(...i), { context: ["th", "td"] });
        }
        _handleTabOnSelectedTable(t, i) {
          const a = this.editor, l = a.model.document.selection.getSelectedElement();
          l && l.is("element", "table") && (i.preventDefault(), i.stopPropagation(), t.stop(), a.model.change((d) => {
            d.setSelection(d.createRangeIn(l.getChild(0).getChild(0)));
          }));
        }
        _handleTab(t, i) {
          const a = this.editor, l = this.editor.plugins.get(sr), d = a.model.document.selection, g = !i.shiftKey;
          let m = l.getTableCellsContainingSelection(d)[0];
          if (m || (m = this.editor.plugins.get("TableSelection").getFocusCell()), !m)
            return;
          i.preventDefault(), i.stopPropagation(), t.stop();
          const w = m.parent, A = w.parent, C = A.getChildIndex(w), T = w.getChildIndex(m), R = T === 0;
          if (!g && R && C === 0)
            return void a.model.change((W) => {
              W.setSelection(W.createRangeOn(A));
            });
          const j = T === w.childCount - 1, F = C === l.getRows(A) - 1;
          if (g && F && j && (a.execute("insertTableRowBelow"), C === l.getRows(A) - 1))
            return void a.model.change((W) => {
              W.setSelection(W.createRangeOn(A));
            });
          let V;
          if (g && j)
            V = A.getChild(C + 1).getChild(0);
          else if (!g && R) {
            const W = A.getChild(C - 1);
            V = W.getChild(W.childCount - 1);
          } else
            V = w.getChild(T + (g ? 1 : -1));
          a.model.change((W) => {
            W.setSelection(W.createRangeIn(V));
          });
        }
        _onArrowKey(t, i) {
          const a = this.editor, l = Im(i.keyCode, a.locale.contentLanguageDirection);
          this._handleArrowKeys(l, i.shiftKey) && (i.preventDefault(), i.stopPropagation(), t.stop());
        }
        _handleArrowKeys(t, i) {
          const a = this.editor.plugins.get(sr), l = this.editor.model, d = l.document.selection, g = ["right", "down"].includes(t), m = a.getSelectedTableCells(d);
          if (m.length) {
            let A;
            return A = i ? this.editor.plugins.get("TableSelection").getFocusCell() : g ? m[m.length - 1] : m[0], this._navigateFromCellInDirection(A, t, i), !0;
          }
          const w = d.focus.findAncestor("tableCell");
          if (!w)
            return !1;
          if (!d.isCollapsed)
            if (i) {
              if (d.isBackward == g && !d.containsEntireContent(w))
                return !1;
            } else {
              const A = d.getSelectedElement();
              if (!A || !l.schema.isObject(A))
                return !1;
            }
          return !!this._isSelectionAtCellEdge(d, w, g) && (this._navigateFromCellInDirection(w, t, i), !0);
        }
        _isSelectionAtCellEdge(t, i, a) {
          const l = this.editor.model, d = this.editor.model.schema, g = a ? t.getLastPosition() : t.getFirstPosition();
          if (!d.getLimitElement(g).is("element", "tableCell"))
            return l.createPositionAt(i, a ? "end" : 0).isTouching(g);
          const m = l.createSelection(g);
          return l.modifySelection(m, { direction: a ? "forward" : "backward" }), g.isEqual(m.focus);
        }
        _navigateFromCellInDirection(t, i, a = !1) {
          const l = this.editor.model, d = t.findAncestor("table"), g = [...new Yt(d, { includeAllSlots: !0 })], { row: m, column: w } = g[g.length - 1], A = g.find(({ cell: V }) => V == t);
          let { row: C, column: T } = A;
          switch (i) {
            case "left":
              T--;
              break;
            case "up":
              C--;
              break;
            case "right":
              T += A.cellWidth;
              break;
            case "down":
              C += A.cellHeight;
          }
          if (C < 0 || C > m || T < 0 && C <= 0 || T > w && C >= m)
            return void l.change((V) => {
              V.setSelection(V.createRangeOn(d));
            });
          T < 0 ? (T = a ? 0 : w, C--) : T > w && (T = a ? w : 0, C++);
          const R = g.find((V) => V.row == C && V.column == T).cell, j = ["right", "down"].includes(i), F = this.editor.plugins.get("TableSelection");
          if (a && F.isEnabled) {
            const V = F.getAnchorCell() || t;
            F.setCellSelection(V, R);
          } else {
            const V = l.createPositionAt(R, j ? 0 : "end");
            l.change((W) => {
              W.setSelection(V);
            });
          }
        }
      }
      class i8 extends sa {
        constructor(t) {
          super(t), this.domEventType = ["mousemove", "mouseleave"];
        }
        onDomEvent(t) {
          this.fire(t.type, t);
        }
      }
      class o8 extends Ie {
        static get pluginName() {
          return "TableMouse";
        }
        static get requires() {
          return [hs, sr];
        }
        init() {
          this.editor.editing.view.addObserver(i8), this._enableShiftClickSelection(), this._enableMouseDragSelection();
        }
        _enableShiftClickSelection() {
          const t = this.editor, i = t.plugins.get(sr);
          let a = !1;
          const l = t.plugins.get(hs);
          this.listenTo(t.editing.view.document, "mousedown", (d, g) => {
            const m = t.model.document.selection;
            if (!this.isEnabled || !l.isEnabled || !g.domEvent.shiftKey)
              return;
            const w = l.getAnchorCell() || i.getTableCellsContainingSelection(m)[0];
            if (!w)
              return;
            const A = this._getModelTableCellFromDomEvent(g);
            A && M5(w, A) && (a = !0, l.setCellSelection(w, A), g.preventDefault());
          }), this.listenTo(t.editing.view.document, "mouseup", () => {
            a = !1;
          }), this.listenTo(t.editing.view.document, "selectionChange", (d) => {
            a && d.stop();
          }, { priority: "highest" });
        }
        _enableMouseDragSelection() {
          const t = this.editor;
          let i, a, l = !1, d = !1;
          const g = t.plugins.get(hs);
          this.listenTo(t.editing.view.document, "mousedown", (m, w) => {
            this.isEnabled && g.isEnabled && (w.domEvent.shiftKey || w.domEvent.ctrlKey || w.domEvent.altKey || (i = this._getModelTableCellFromDomEvent(w)));
          }), this.listenTo(t.editing.view.document, "mousemove", (m, w) => {
            if (!w.domEvent.buttons || !i)
              return;
            const A = this._getModelTableCellFromDomEvent(w);
            A && M5(i, A) && (a = A, l || a == i || (l = !0)), l && (d = !0, g.setCellSelection(i, a), w.preventDefault());
          }), this.listenTo(t.editing.view.document, "mouseup", () => {
            l = !1, d = !1, i = null, a = null;
          }), this.listenTo(t.editing.view.document, "selectionChange", (m) => {
            d && m.stop();
          }, { priority: "highest" });
        }
        _getModelTableCellFromDomEvent(t) {
          const i = t.target, a = this.editor.editing.view.createPositionAt(i, 0);
          return this.editor.editing.mapper.toModelPosition(a).parent.findAncestor("tableCell", { includeSelf: !0 });
        }
      }
      function M5(c, t) {
        return c.parent.parent == t.parent.parent;
      }
      var T5 = s(6306), a8 = { injectType: "singletonStyleTag", attributes: { "data-cke": !0 }, insert: "head", singleton: !0 };
      rt()(T5.Z, a8), T5.Z.locals;
      function s8(c) {
        const t = c.getSelectedElement();
        return t && D5(t) ? t : null;
      }
      function l8(c) {
        const t = c.getFirstPosition();
        if (!t)
          return null;
        let i = t.parent;
        for (; i; ) {
          if (i.is("element") && D5(i))
            return i;
          i = i.parent;
        }
        return null;
      }
      function D5(c) {
        return !!c.getCustomProperty("table") && xn(c);
      }
      const ov = { autoRefresh: !0 }, I5 = 36e5;
      class Wh {
        constructor(t, i = ov) {
          if (!t)
            throw new S("token-missing-token-url", this);
          i.initValue && this._validateTokenValue(i.initValue), this.set("value", i.initValue), this._refresh = typeof t == "function" ? t : () => {
            return a = t, new Promise((l, d) => {
              const g = new XMLHttpRequest();
              g.open("GET", a), g.addEventListener("load", () => {
                const m = g.status, w = g.response;
                return m < 200 || m > 299 ? d(new S("token-cannot-download-new-token", null)) : l(w);
              }), g.addEventListener("error", () => d(new Error("Network Error"))), g.addEventListener("abort", () => d(new Error("Abort"))), g.send();
            });
            var a;
          }, this._options = Object.assign({}, ov, i);
        }
        init() {
          return new Promise((t, i) => {
            this.value ? (this._options.autoRefresh && this._registerRefreshTokenTimeout(), t(this)) : this.refreshToken().then(t).catch(i);
          });
        }
        refreshToken() {
          return this._refresh().then((t) => {
            this._validateTokenValue(t), this.set("value", t), this._options.autoRefresh && this._registerRefreshTokenTimeout();
          }).then(() => this);
        }
        destroy() {
          clearTimeout(this._tokenRefreshTimeout);
        }
        _validateTokenValue(t) {
          const i = typeof t == "string", a = !/^".*"$/.test(t), l = i && t.split(".").length === 3;
          if (!a || !l)
            throw new S("token-not-in-jwt-format", this);
        }
        _registerRefreshTokenTimeout() {
          const t = this._getTokenRefreshTimeoutTime();
          clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(() => {
            this.refreshToken();
          }, t);
        }
        _getTokenRefreshTimeoutTime() {
          try {
            const [, t] = this.value.split("."), { exp: i } = JSON.parse(atob(t));
            return i ? Math.floor((1e3 * i - Date.now()) / 2) : I5;
          } catch {
            return I5;
          }
        }
        static create(t, i = ov) {
          return new Wh(t, i).init();
        }
      }
      E(Wh, Te);
      const c8 = Wh, av = /^data:(\S*?);base64,/;
      class P5 {
        constructor(t, i, a) {
          if (!t)
            throw new S("fileuploader-missing-file", null);
          if (!i)
            throw new S("fileuploader-missing-token", null);
          if (!a)
            throw new S("fileuploader-missing-api-address", null);
          this.file = function(l) {
            if (typeof l != "string")
              return !1;
            const d = l.match(av);
            return !(!d || !d.length);
          }(t) ? function(l, d = 512) {
            try {
              const g = l.match(av)[1], m = atob(l.replace(av, "")), w = [];
              for (let A = 0; A < m.length; A += d) {
                const C = m.slice(A, A + d), T = new Array(C.length);
                for (let R = 0; R < C.length; R++)
                  T[R] = C.charCodeAt(R);
                w.push(new Uint8Array(T));
              }
              return new Blob(w, { type: g });
            } catch {
              throw new S("fileuploader-decoding-image-data-error", null);
            }
          }(t) : t, this._token = i, this._apiAddress = a;
        }
        onProgress(t) {
          return this.on("progress", (i, a) => t(a)), this;
        }
        onError(t) {
          return this.once("error", (i, a) => t(a)), this;
        }
        abort() {
          this.xhr.abort();
        }
        send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
        _prepareRequest() {
          const t = new XMLHttpRequest();
          t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
        }
        _attachXHRListeners() {
          const t = this, i = this.xhr;
          function a(l) {
            return () => t.fire("error", l);
          }
          i.addEventListener("error", a("Network Error")), i.addEventListener("abort", a("Abort")), i.upload && i.upload.addEventListener("progress", (l) => {
            l.lengthComputable && this.fire("progress", { total: l.total, uploaded: l.loaded });
          }), i.addEventListener("load", () => {
            const l = i.status, d = i.response;
            if (l < 200 || l > 299)
              return this.fire("error", d.message || d.error);
          });
        }
        _sendRequest() {
          const t = new FormData(), i = this.xhr;
          return t.append("file", this.file), new Promise((a, l) => {
            i.addEventListener("load", () => {
              const d = i.status, g = i.response;
              return d < 200 || d > 299 ? g.message ? l(new S("fileuploader-uploading-data-failed", this, { message: g.message })) : l(g.error) : a(g);
            }), i.addEventListener("error", () => l(new Error("Network Error"))), i.addEventListener("abort", () => l(new Error("Abort"))), i.send(t);
          });
        }
      }
      E(P5, ie);
      class u8 {
        constructor(t, i) {
          if (!t)
            throw new S("uploadgateway-missing-token", null);
          if (!i)
            throw new S("uploadgateway-missing-api-address", null);
          this._token = t, this._apiAddress = i;
        }
        upload(t) {
          return new P5(t, this._token, this._apiAddress);
        }
      }
      class d8 extends uh {
        static get pluginName() {
          return "CloudServicesCore";
        }
        createToken(t, i) {
          return new c8(t, i);
        }
        createUploadGateway(t, i) {
          return new u8(t, i);
        }
      }
      class sv extends A$ {
      }
      sv.builtinPlugins = [class extends Ie {
        static get requires() {
          return [r2, $h, oL, L$, S$, l2];
        }
        static get pluginName() {
          return "Essentials";
        }
      }, class extends Ie {
        static get requires() {
          return [xi];
        }
        static get pluginName() {
          return "CKFinderUploadAdapter";
        }
        init() {
          const c = this.editor.config.get("ckfinder.uploadUrl");
          c && (this.editor.plugins.get(xi).createUploadAdapter = (t) => new mL(t, c, this.editor.t));
        }
      }, class extends Ie {
        static get requires() {
          return [ha];
        }
        static get pluginName() {
          return "Autoformat";
        }
        afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
        }
        _addListAutoformats() {
          const c = this.editor.commands;
          c.get("bulletedList") && pa(this.editor, this, /^[*-]\s$/, "bulletedList"), c.get("numberedList") && pa(this.editor, this, /^1[.|)]\s$/, "numberedList"), c.get("todoList") && pa(this.editor, this, /^\[\s?\]\s$/, "todoList"), c.get("checkTodoList") && pa(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
            this.editor.execute("todoList"), this.editor.execute("checkTodoList");
          });
        }
        _addBasicStylesAutoformats() {
          const c = this.editor.commands;
          if (c.get("bold")) {
            const t = Bh(this.editor, "bold");
            El(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t), El(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t);
          }
          if (c.get("italic")) {
            const t = Bh(this.editor, "italic");
            El(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t), El(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t);
          }
          if (c.get("code")) {
            const t = Bh(this.editor, "code");
            El(this.editor, this, /(`)([^`]+)(`)$/g, t);
          }
          if (c.get("strikethrough")) {
            const t = Bh(this.editor, "strikethrough");
            El(this.editor, this, /(~~)([^~]+)(~~)$/g, t);
          }
        }
        _addHeadingAutoformats() {
          const c = this.editor.commands.get("heading");
          c && c.modelElements.filter((t) => t.match(/^heading[1-6]$/)).forEach((t) => {
            const i = t[7], a = new RegExp(`^(#{${i}})\\s$`);
            pa(this.editor, this, a, () => {
              if (!c.isEnabled || c.value === t)
                return !1;
              this.editor.execute("heading", { value: t });
            });
          });
        }
        _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && pa(this.editor, this, /^>\s$/, "blockQuote");
        }
        _addCodeBlockAutoformats() {
          const c = this.editor, t = c.model.document.selection;
          c.commands.get("codeBlock") && pa(c, this, /^```$/, () => {
            if (t.getFirstPosition().parent.is("element", "listItem"))
              return !1;
            this.editor.execute("codeBlock", { usePreviousLanguageChoice: !0 });
          });
        }
        _addHorizontalLineAutoformats() {
          this.editor.commands.get("horizontalLine") && pa(this.editor, this, /^---$/, "horizontalLine");
        }
      }, class extends Ie {
        static get requires() {
          return [vL, bL];
        }
        static get pluginName() {
          return "Bold";
        }
      }, class extends Ie {
        static get requires() {
          return [wL, yL];
        }
        static get pluginName() {
          return "Italic";
        }
      }, class extends Ie {
        static get requires() {
          return [_L, CL];
        }
        static get pluginName() {
          return "BlockQuote";
        }
      }, class extends Ie {
        static get pluginName() {
          return "CKBox";
        }
        static get requires() {
          return [N0, xL];
        }
      }, class extends Ie {
        static get pluginName() {
          return "CKFinder";
        }
        static get requires() {
          return ["Link", "CKFinderUploadAdapter", NL, OL];
        }
      }, class extends uh {
        static get pluginName() {
          return "CloudServices";
        }
        static get requires() {
          return [d8];
        }
        init() {
          const c = this.context.config.get("cloudServices") || {};
          for (const t in c)
            this[t] = c[t];
          if (this._tokens = /* @__PURE__ */ new Map(), this.tokenUrl)
            return this.token = this.context.plugins.get("CloudServicesCore").createToken(this.tokenUrl), this._tokens.set(this.tokenUrl, this.token), this.token.init();
          this.token = null;
        }
        registerTokenUrl(c) {
          if (this._tokens.has(c))
            return Promise.resolve(this.getTokenFor(c));
          const t = this.context.plugins.get("CloudServicesCore").createToken(c);
          return this._tokens.set(c, t), t.init();
        }
        getTokenFor(c) {
          const t = this._tokens.get(c);
          if (!t)
            throw new S("cloudservices-token-not-registered", this);
          return t;
        }
        destroy() {
          super.destroy();
          for (const c of this._tokens.values())
            c.destroy();
        }
      }, class extends Ie {
        static get requires() {
          return [$L, "ImageUpload"];
        }
        init() {
          const c = this.editor;
          c.plugins.has("ImageBlockEditing") || c.plugins.has("ImageInlineEditing") || $("easy-image-image-feature-missing", c);
        }
        static get pluginName() {
          return "EasyImage";
        }
      }, class extends Ie {
        static get requires() {
          return [zL, HL];
        }
        static get pluginName() {
          return "Heading";
        }
      }, class extends Ie {
        static get requires() {
          return [JL, tj];
        }
        static get pluginName() {
          return "Image";
        }
      }, class extends Ie {
        static get requires() {
          return [rj, ij];
        }
        static get pluginName() {
          return "ImageCaption";
        }
      }, class extends Ie {
        static get requires() {
          return [K2, cj];
        }
        static get pluginName() {
          return "ImageStyle";
        }
      }, class extends Ie {
        static get requires() {
          return [jh, Ei];
        }
        static get pluginName() {
          return "ImageToolbar";
        }
        afterInit() {
          const c = this.editor, t = c.t, i = c.plugins.get(jh), a = c.plugins.get("ImageUtils");
          var l;
          i.register("image", { ariaLabel: t("Image toolbar"), items: (l = c.config.get("image.toolbar") || [], l.map((d) => me(d) ? d.name : d)), getRelatedElement: (d) => a.getClosestSelectedImageWidget(d) });
        }
      }, class extends Ie {
        static get pluginName() {
          return "ImageUpload";
        }
        static get requires() {
          return [vj, dj, gj];
        }
      }, class extends Ie {
        static get pluginName() {
          return "Indent";
        }
        static get requires() {
          return [wj, yj];
        }
      }, class extends Ie {
        static get requires() {
          return [Fj, Wj, qj];
        }
        static get pluginName() {
          return "Link";
        }
      }, class extends Ie {
        static get requires() {
          return [aB, sB];
        }
        static get pluginName() {
          return "List";
        }
      }, class extends Ie {
        static get requires() {
          return [Hh, gB, hB, vu];
        }
        static get pluginName() {
          return "MediaEmbed";
        }
      }, bu, class extends Ie {
        static get pluginName() {
          return "PasteFromOffice";
        }
        static get requires() {
          return [io];
        }
        init() {
          const c = this.editor, t = c.editing.view.document, i = [];
          i.push(new EB(t)), i.push(new kB(t)), c.plugins.get("ClipboardPipeline").on("inputTransformation", (a, l) => {
            if (l._isTransformedWithPasteFromOffice || c.model.document.selection.getFirstPosition().parent.is("element", "codeBlock"))
              return;
            const d = l.dataTransfer.getData("text/html"), g = i.find((m) => m.isActive(d));
            g && (l._parsedData = SB(d, t.stylesProcessor), g.execute(l), l._isTransformedWithPasteFromOffice = !0);
          }, { priority: "high" });
        }
      }, class extends Ie {
        static get requires() {
          return [j0, Ei];
        }
        static get pluginName() {
          return "PictureEditing";
        }
        afterInit() {
          const c = this.editor;
          c.plugins.has("ImageBlockEditing") && c.model.schema.extend("imageBlock", { allowAttributes: ["sources"] }), c.plugins.has("ImageInlineEditing") && c.model.schema.extend("imageInline", { allowAttributes: ["sources"] }), this._setupConversion(), this._setupImageUploadEditingIntegration();
        }
        _setupConversion() {
          const c = this.editor, t = c.conversion, i = c.plugins.get("ImageUtils");
          t.for("upcast").add(function(a) {
            const l = ["srcset", "media", "type", "sizes"];
            return (g) => {
              g.on("element:picture", d);
            };
            function d(g, m, w) {
              const A = m.viewItem;
              if (!w.consumable.test(A, { name: !0 }))
                return;
              const C = /* @__PURE__ */ new Map();
              for (const j of A.getChildren())
                if (j.is("element", "source")) {
                  const F = {};
                  for (const V of l)
                    j.hasAttribute(V) && w.consumable.test(j, { attributes: V }) && (F[V] = j.getAttribute(V));
                  Object.keys(F).length && C.set(j, F);
                }
              const T = a.findViewImgElement(A);
              if (!T)
                return;
              let R = m.modelCursor.parent;
              if (!R.is("element", "imageBlock")) {
                const j = w.convertItem(T, m.modelCursor);
                m.modelRange = j.modelRange, m.modelCursor = j.modelCursor, R = Fn(j.modelRange.getItems());
              }
              w.consumable.consume(A, { name: !0 });
              for (const [j, F] of C)
                w.consumable.consume(j, { attributes: Object.keys(F) });
              C.size && w.writer.setAttribute("sources", Array.from(C.values()), R), w.convertChildren(A, R);
            }
          }(i)), t.for("downcast").add(function(a) {
            return (d) => {
              d.on("attribute:sources:imageBlock", l), d.on("attribute:sources:imageInline", l);
            };
            function l(d, g, m) {
              if (!m.consumable.consume(g.item, d.name))
                return;
              const w = m.writer, A = m.mapper.toViewElement(g.item), C = a.findViewImgElement(A);
              if (g.attributeNewValue && g.attributeNewValue.length) {
                const T = w.createContainerElement("picture", null, g.attributeNewValue.map((F) => w.createEmptyElement("source", F))), R = [];
                let j = C.parent;
                for (; j && j.is("attributeElement"); ) {
                  const F = j.parent;
                  w.unwrap(w.createRangeOn(C), j), R.unshift(j), j = F;
                }
                w.insert(w.createPositionBefore(C), T), w.move(w.createRangeOn(C), w.createPositionAt(T, "end"));
                for (const F of R)
                  w.wrap(w.createRangeOn(T), F);
              } else if (C.parent.is("element", "picture")) {
                const T = C.parent;
                w.move(w.createRangeOn(C), w.createPositionBefore(T)), w.remove(T);
              }
            }
          }(i));
        }
        _setupImageUploadEditingIntegration() {
          const c = this.editor;
          c.plugins.has("ImageUploadEditing") && this.listenTo(c.plugins.get("ImageUploadEditing"), "uploadComplete", (t, { imageElement: i, data: a }) => {
            const l = a.sources;
            l && c.model.change((d) => {
              d.setAttributes({ sources: l }, i);
            });
          });
        }
      }, class extends Ie {
        static get requires() {
          return [QB, JB, hs, o8, r8, n8, vu];
        }
        static get pluginName() {
          return "Table";
        }
      }, class extends Ie {
        static get requires() {
          return [jh];
        }
        static get pluginName() {
          return "TableToolbar";
        }
        afterInit() {
          const c = this.editor, t = c.t, i = c.plugins.get(jh), a = c.config.get("table.contentToolbar"), l = c.config.get("table.tableToolbar");
          a && i.register("tableContent", { ariaLabel: t("Table toolbar"), items: a, getRelatedElement: l8 }), l && i.register("table", { ariaLabel: t("Table toolbar"), items: l, getRelatedElement: s8 });
        }
      }, class extends Ie {
        static get requires() {
          return ["Delete", "Input"];
        }
        static get pluginName() {
          return "TextTransformation";
        }
        constructor(c) {
          super(c), c.config.define("typing", { transformations: { include: D$ } });
        }
        init() {
          const c = this.editor.model.document.selection;
          c.on("change:range", () => {
            this.isEnabled = !c.anchor.parent.is("element", "codeBlock");
          }), this._enableTransformationWatchers();
        }
        _enableTransformationWatchers() {
          const c = this.editor, t = c.model, i = c.plugins.get("Delete"), a = function(d) {
            const g = d.extra || [], m = d.remove || [], w = (A) => !m.includes(A);
            return function(A) {
              const C = /* @__PURE__ */ new Set();
              for (const T of A)
                if (typeof T == "string" && OC[T])
                  for (const R of OC[T])
                    C.add(R);
                else
                  C.add(T);
              return Array.from(C);
            }(d.include.concat(g).filter(w)).filter(w).map((A) => typeof A == "string" && PC[A] ? PC[A] : A).filter((A) => typeof A == "object").map((A) => ({ from: I$(A.from), to: P$(A.to) }));
          }(c.config.get("typing.transformations")), l = new TC(c.model, (d) => {
            for (const g of a)
              if (g.from.test(d))
                return { normalizedTransformation: g };
          });
          l.on("matched:data", (d, g) => {
            if (!g.batch.isTyping)
              return;
            const { from: m, to: w } = g.normalizedTransformation, A = m.exec(g.text), C = w(A.slice(1)), T = g.range;
            let R = A.index;
            t.enqueueChange((j) => {
              for (let F = 1; F < A.length; F++) {
                const V = A[F], W = C[F - 1];
                if (W == null) {
                  R += V.length;
                  continue;
                }
                const ee = T.start.getShiftedBy(R), le = t.createRange(ee, ee.getShiftedBy(V.length)), be = O$(ee);
                t.insertContent(j.createText(W, be), le), R += W.length;
              }
              t.enqueueChange(() => {
                i.requestUndoOnBackspace();
              });
            });
          }), l.bind("isEnabled").to(this);
        }
      }], sv.defaultConfig = { toolbar: { items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "uploadImage", "blockQuote", "insertTable", "mediaEmbed", "undo", "redo"] }, image: { toolbar: ["imageStyle:inline", "imageStyle:block", "imageStyle:side", "|", "toggleImageCaption", "imageTextAlternative"] }, table: { contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"] }, language: "en" };
    })(), u = u.default;
  })());
})(f1, f1.exports);
const iTe = /* @__PURE__ */ t4(f1.exports);
function XDe({
  defaultValue: e = "",
  label: n = "",
  onChange: r
}) {
  return /* @__PURE__ */ K("div", {
    className: "space-y-2 text-sm",
    children: [/* @__PURE__ */ M("p", {
      className: "block text-sm font-medium text-gray-700",
      children: n
    }), /* @__PURE__ */ M(h1.exports.CKEditor, {
      config: {
        toolbar: ["bold", "italic", "link", "lists", "bulletedList", "numberedList"]
      },
      editor: iTe,
      data: e,
      onChange: (o, s) => r(s.getData())
    })]
  });
}
const JDe = oe.forwardRef(({
  children: e,
  header: n,
  footer: r
}, o) => /* @__PURE__ */ K("div", {
  className: "bg-white overflow-hidden shadow divide-y divide-gray-200 rounded",
  ref: o,
  children: [n && /* @__PURE__ */ M("div", {
    className: "px-4 py-5 sm:px-6",
    children: n
  }), /* @__PURE__ */ M("div", {
    className: "px-4 py-5 sm:p-6",
    children: e
  }), r]
}));
function e4e({
  alignItems: e = "center",
  gap: n = 0,
  children: r
}) {
  return /* @__PURE__ */ M("div", {
    className: Ce("flex", eSe(e), D7(n)),
    children: r
  });
}
function oTe({
  navbar: e,
  buttons: n,
  children: r,
  footer: o
}) {
  const [s, u] = Ve(!1);
  return /* @__PURE__ */ K("div", {
    children: [e && /* @__PURE__ */ M(rr.Root, {
      show: s,
      as: ft,
      children: /* @__PURE__ */ K(Ss, {
        as: "div",
        className: "relative z-40 md:hidden",
        onClose: u,
        children: [/* @__PURE__ */ M(Uo, {
          as: ft,
          enter: "transition-opacity ease-linear duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition-opacity ease-linear duration-300",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ M("div", {
            className: "fixed inset-0 bg-gray-600 bg-opacity-75"
          })
        }), /* @__PURE__ */ K("div", {
          className: "fixed inset-0 z-40 flex",
          children: [/* @__PURE__ */ M(Uo, {
            as: ft,
            enter: "transition ease-in-out duration-300 transform",
            enterFrom: "-translate-x-full",
            enterTo: "translate-x-0",
            leave: "transition ease-in-out duration-300 transform",
            leaveFrom: "translate-x-0",
            leaveTo: "-translate-x-full",
            children: /* @__PURE__ */ K(wg, {
              className: "relative flex w-full flex-1 flex-col bg-white pt-5 pb-4",
              children: [/* @__PURE__ */ M(Uo, {
                as: ft,
                enter: "ease-in-out duration-300",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "ease-in-out duration-300",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /* @__PURE__ */ M("div", {
                  className: "absolute top-0 right-0 -mr-12 pt-2",
                  children: /* @__PURE__ */ K("button", {
                    type: "button",
                    className: "ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                    onClick: () => u(!1),
                    children: [/* @__PURE__ */ M("span", {
                      className: "sr-only",
                      children: "Close sidebar"
                    }), /* @__PURE__ */ M(Bt.X, {
                      className: "text-white",
                      "aria-hidden": "true"
                    })]
                  })
                })
              }), e]
            })
          }), /* @__PURE__ */ M("div", {
            className: "w-14 flex-shrink-0",
            "aria-hidden": "true"
          })]
        })]
      })
    }), e && /* @__PURE__ */ M("div", {
      className: "hidden md:fixed md:inset-y-0 md:flex md:w-44 md:flex-col",
      children: /* @__PURE__ */ M("div", {
        className: "flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5",
        children: e
      })
    }), /* @__PURE__ */ K("div", {
      className: Ce("min-h-screen flex flex-1 flex-col", {
        "md:pl-52": e
      }),
      children: [/* @__PURE__ */ K("div", {
        className: "md:px-4 lg:px-6",
        children: [/* @__PURE__ */ K("div", {
          className: Ce("sticky md:relative top-0 flex justify-between z-10 h-18 py-1", "border-b md:border-0 bg-white md:bg-transparent"),
          children: [/* @__PURE__ */ K("button", {
            type: "button",
            className: Ce("px-4 py-2 text-gray-700 hover:bg-gray-100 focus:ring-gray-500 rounded", "md:invisible", {
              invisible: !e
            }),
            onClick: () => u(!0),
            children: [/* @__PURE__ */ M("span", {
              className: "sr-only",
              children: "Open sidebar"
            }), /* @__PURE__ */ M(Bt.Bars, {})]
          }), n]
        }), /* @__PURE__ */ M("main", {
          children: /* @__PURE__ */ M("div", {
            className: "flex-1 gap-4",
            children: r
          })
        })]
      }), o]
    })]
  });
}
oTe.displayName = "SidebarLayout";
function aTe({
  items: e,
  logo: n
}) {
  return /* @__PURE__ */ K(bo, {
    children: [n && /* @__PURE__ */ M("div", {
      className: "flex flex-shrink-0 mx-auto items-center px-4",
      children: /* @__PURE__ */ M("img", {
        className: "h-10 w-auto",
        src: n.srcSmall,
        alt: n.alt
      })
    }), /* @__PURE__ */ M("nav", {
      className: "space-y-1 py-2",
      children: /* @__PURE__ */ M(a1, {
        srLabel: "Navbar",
        children: e.map((r) => /* @__PURE__ */ K("a", {
          href: r.href,
          className: Ce(r.current ? "text-blue-800 border-r-4 border-blue-800" : "text-gray-600 hover:text-gray-900", "flex flex-col items-center px-3 py-2 text-sm font-medium hover:bg-gray-50"),
          "aria-current": r.current ? "page" : void 0,
          children: [/* @__PURE__ */ M("div", {
            className: "mx-auto text-gray-500",
            children: r.icon
          }), /* @__PURE__ */ M("p", {
            className: "mt-1 font-bold tracking-tight text-blue-800",
            children: r.title
          })]
        }))
      })
    })]
  });
}
aTe.displayName = "SidebarNavigation";
function sTe({
  children: e
}) {
  return /* @__PURE__ */ K("footer", {
    "aria-labelledby": "footer-heading",
    className: "mt-auto",
    children: [/* @__PURE__ */ M("h2", {
      id: "footer-heading",
      className: "sr-only",
      children: "Footer"
    }), /* @__PURE__ */ M("div", {
      className: "mx-auto max-w-7xl py-4 px-4 sm:px-6 lg:px-8",
      children: /* @__PURE__ */ M("div", {
        className: "mt-8 text-base font-bold text-center leading-5 text-gray-400 md:order-1 md:mt-0",
        children: e
      })
    })]
  });
}
sTe.displayName = "PageFooter";
function lTe({
  children: e,
  buttons: n
}) {
  return /* @__PURE__ */ K("div", {
    className: "md:flex md:items-center md:justify-between",
    children: [/* @__PURE__ */ M("div", {
      className: "min-w-0 flex-1",
      children: e
    }), /* @__PURE__ */ M("div", {
      className: "mt-4 flex md:mt-0 md:ml-4",
      children: n
    })]
  });
}
lTe.displayName = "PageHeading";
function cTe({
  children: e,
  size: n = "large"
}) {
  return /* @__PURE__ */ M("div", {
    className: Ce("bg-white shadow sm:rounded-md", {
      "mx-auto": n !== "large"
    }, {
      "max-w-lg": n === "small"
    }, {
      "max-w-2xl": n === "medium"
    }),
    children: /* @__PURE__ */ M("div", {
      className: "px-4 py-2 sm:py-5 sm:p-6",
      children: e
    })
  });
}
cTe.displayName = "Panel";
function sO({
  title: e,
  children: n,
  defaultOpen: r = !1
}) {
  return /* @__PURE__ */ M(yv, {
    as: "div",
    className: "pt-6",
    defaultOpen: r,
    children: ({
      open: o
    }) => /* @__PURE__ */ K(bo, {
      children: [/* @__PURE__ */ M("dt", {
        className: "text-lg",
        children: /* @__PURE__ */ K(yv.Button, {
          className: "flex w-full items-start justify-between text-left text-gray-400",
          children: [/* @__PURE__ */ M("span", {
            className: "font-medium text-gray-900",
            children: e
          }), /* @__PURE__ */ M("span", {
            className: "flex h-7",
            children: o ? /* @__PURE__ */ M(Bt.ChevronUp, {}) : /* @__PURE__ */ M(Bt.Caret, {})
          })]
        })
      }), /* @__PURE__ */ M(yv.Panel, {
        as: "dd",
        className: "mt-2",
        children: n
      })]
    })
  });
}
sO.displayName = "Item";
function lO({
  children: e
}) {
  return /* @__PURE__ */ M("div", {
    className: "bg-white",
    children: /* @__PURE__ */ M("div", {
      className: "mx-auto",
      children: /* @__PURE__ */ M("dl", {
        className: "space-y-6 divide-y divide-gray-200",
        children: e
      })
    })
  });
}
lO.displayName = "Section";
lO.Item = sO;
function uTe({
  tabs: e,
  srLabel: n,
  onSelect: r
}) {
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ K("div", {
      className: "sm:hidden",
      children: [/* @__PURE__ */ M("label", {
        htmlFor: "tabs",
        className: "sr-only",
        children: n
      }), /* @__PURE__ */ M(cb, {
        fullWidth: !0,
        control: /* @__PURE__ */ M(wSe, {
          appearance: "outlined",
          fill: !0,
          iconAfter: /* @__PURE__ */ M(Bt.Caret, {
            className: "h-6 w-6 sm:h-5 sm:w-5"
          }),
          children: e.find((o) => o.current)?.label
        }),
        children: /* @__PURE__ */ M(cb.Section, {
          children: e.map((o) => /* @__PURE__ */ M(cb.Link, {
            iconBefore: o.current ? /* @__PURE__ */ M(Bt.Check, {}) : /* @__PURE__ */ M("div", {
              className: "w-9"
            }),
            onClick: () => {
              r(o.value);
            },
            children: o.label
          }))
        })
      })]
    }), /* @__PURE__ */ M("div", {
      className: "hidden sm:block",
      children: /* @__PURE__ */ M("div", {
        className: "border-b border-gray-300",
        children: /* @__PURE__ */ M("nav", {
          className: "-mb-px flex space-x-8",
          "aria-label": "Tabs",
          children: e.map((o) => /* @__PURE__ */ M("button", {
            type: "button",
            onClick: () => r(o.value),
            className: Ce(
              o.current ? "border-blue-800 text-blue-800" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
              "whitespace-nowrap flex py-1 px-1 border-b-2 font-semibold text-base cursor-pointer"
            ),
            "aria-current": o.current ? "page" : void 0,
            children: o.label
          }, o.value))
        })
      })
    })]
  });
}
uTe.displayName = "Tabs";
const Qp = zs(({
  avatar: e,
  primary: n,
  secondary: r,
  icons: o,
  style: s,
  anchorElement: u = "a",
  active: h = !1,
  compact: f = !1,
  ...p
}, v) => {
  const b = u;
  return /* @__PURE__ */ M("li", {
    className: Ce({
      "hover:bg-gray-50": !h
    }, {
      "bg-blue-50": h
    }, "focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-800"),
    style: s,
    children: /* @__PURE__ */ K("div", {
      className: Ce("px-6", f ? "py-2" : "py-4", "relative flex items-center space-x-3"),
      children: [e, /* @__PURE__ */ M("div", {
        className: "min-w-0 flex-1",
        children: /* @__PURE__ */ M(b, {
          ...p,
          ref: v,
          className: "block focus:outline-none",
          children: /* @__PURE__ */ K(bo, {
            children: [/* @__PURE__ */ M("span", {
              className: "absolute inset-0",
              "aria-hidden": "true"
            }), /* @__PURE__ */ M("p", {
              className: "text-sm font-medium text-gray-900",
              children: n
            }), r && /* @__PURE__ */ M("p", {
              className: "text-sm text-gray-500",
              children: r
            })]
          })
        })
      }), o && /* @__PURE__ */ M("div", {
        className: "flex-shrink-0 whitespace-nowrap text-gray-500",
        children: o
      })]
    })
  });
});
Qp.displayName = "Item";
function dTe({
  loading: e = !1,
  ...n
}) {
  const {
    avatar: r,
    primary: o,
    secondary: s,
    icons: u,
    ...h
  } = n;
  return e ? /* @__PURE__ */ M(Qp, {
    avatar: r ? /* @__PURE__ */ M(hb, {
      children: r
    }) : void 0,
    primary: /* @__PURE__ */ M(hb, {
      width: "80%"
    }),
    secondary: /* @__PURE__ */ M(hb, {
      width: "60%"
    }),
    ...h
  }) : /* @__PURE__ */ M(Qp, {
    ...n
  });
}
const hTe = oe.forwardRef(({
  children: e,
  ...n
}, r) => /* @__PURE__ */ M("ul", {
  ...n,
  className: "relative divide-y divide-gray-200 z-0",
  ref: r,
  children: e
})), t4e = Object.assign(hTe, {
  Item: Qp,
  LoadingItem: dTe
});
function n4e({
  data: e,
  icons: n,
  id: r,
  primary: o,
  secondary: s,
  center: u,
  preview: h,
  href: f,
  groupBy: p,
  side: v,
  condensed: b = !1,
  onClick: y
}) {
  const k = Re(() => C8(e).groupBy((_) => p && qo(_, p)).map((_) => {
    const E = x8(_);
    return {
      key: p && E && qo(E, p),
      render: p && E && ri(E, p),
      data: _
    };
  }).value(), [e, p]);
  return /* @__PURE__ */ M(bo, {
    children: k.map((_) => /* @__PURE__ */ K("div", {
      className: "bg-white shadow sm:rounded-md",
      children: [_.render && /* @__PURE__ */ M("div", {
        className: "z-10 sticky top-0 border-t border-b border-gray-200 bg-gray-50 px-4 py-1 text-sm font-medium text-gray-500",
        children: /* @__PURE__ */ M("h3", {
          className: "compat",
          children: _.render
        })
      }), /* @__PURE__ */ M("ul", {
        className: "divide-y divide-gray-200 z-0",
        children: _.data.map((E) => /* @__PURE__ */ K("li", {
          className: Ce(
            "px-4",
            {
              "hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-800": y || f
            },
            b ? "py-2" : "py-4"
          ),
          children: [/* @__PURE__ */ K("div", {
            className: "flex items-center",
            children: [/* @__PURE__ */ M("div", {
              className: "flex min-w-0 flex-1 items-center",
              children: /* @__PURE__ */ K("div", {
                className: Ce("min-w-0 flex-1", {
                  "md:grid md:grid-cols-2": u || v
                }),
                children: [/* @__PURE__ */ K("div", {
                  children: [/* @__PURE__ */ M("div", {
                    className: "text-md font-medium text-gray-900",
                    children: ri(E, o)
                  }), s && /* @__PURE__ */ M("div", {
                    className: "text-sm text-gray-500",
                    children: ri(E, s)
                  })]
                }), u && /* @__PURE__ */ M("div", {
                  children: ri(E, u)
                }), v && /* @__PURE__ */ M("div", {
                  className: "flex-shrink-0 text-sm text-gray-500",
                  children: ri(E, v)
                })]
              })
            }), n && /* @__PURE__ */ M("div", {
              className: "mt-4 flex-shrink-0 sm:mt-0 sm:ml-5",
              children: /* @__PURE__ */ M("p", {
                className: "line-clamp-2 text-sm text-gray-600",
                children: ri(E, n)
              })
            })]
          }), h && /* @__PURE__ */ M("div", {
            className: "mt-1",
            children: /* @__PURE__ */ M("p", {
              className: "line-clamp-2 text-sm text-gray-600",
              children: ri(E, h)
            })
          })]
        }, qo(E, r || o)))
      })]
    }, _.key))
  });
}
/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ea(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function gi(e, n) {
  return (r) => {
    n.setState((o) => ({
      ...o,
      [e]: Ea(r, o[e])
    }));
  };
}
function Zp(e) {
  return e instanceof Function;
}
function fTe(e, n) {
  const r = [], o = (s) => {
    s.forEach((u) => {
      r.push(u);
      const h = n(u);
      h?.length && o(h);
    });
  };
  return o(e), r;
}
function ut(e, n, r) {
  let o = [], s;
  return () => {
    let u;
    r.key && r.debug && (u = Date.now());
    const h = e();
    if (!(h.length !== o.length || h.some((v, b) => o[b] !== v)))
      return s;
    o = h;
    let p;
    if (r.key && r.debug && (p = Date.now()), s = n(...h), r?.onChange?.(s), r.key && r.debug && r?.debug()) {
      const v = Math.round((Date.now() - u) * 100) / 100, b = Math.round((Date.now() - p) * 100) / 100, y = b / 16, k = (_, E) => {
        for (_ = String(_); _.length < E; )
          _ = " " + _;
        return _;
      };
      console.info(`%c\u23F1 ${k(b, 5)} /${k(v, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * y, 120))}deg 100% 31%);`, r?.key);
    }
    return s;
  };
}
function pTe(e, n, r, o) {
  var s, u;
  const f = {
    ...e._getDefaultColumnDef(),
    ...n
  }, p = f.accessorKey;
  let v = (s = (u = f.id) != null ? u : p ? p.replace(".", "_") : void 0) != null ? s : typeof f.header == "string" ? f.header : void 0, b;
  if (f.accessorFn ? b = f.accessorFn : p && (p.includes(".") ? b = (k) => {
    let _ = k;
    for (const E of p.split("."))
      if (_ = _[E], process.env.NODE_ENV !== "production" && _ === void 0)
        throw new Error(`"${E}" in deeply nested key "${p}" returned undefined.`);
    return _;
  } : b = (k) => k[f.accessorKey]), !v)
    throw process.env.NODE_ENV !== "production" ? new Error(f.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let y = {
    id: `${String(v)}`,
    accessorFn: b,
    parent: o,
    depth: r,
    columnDef: f,
    columns: [],
    getFlatColumns: ut(() => [!0], () => [y, ...y.columns?.flatMap((k) => k.getFlatColumns())], {
      key: process.env.NODE_ENV === "production" && "column.getFlatColumns",
      debug: () => {
        var k;
        return (k = e.options.debugAll) != null ? k : e.options.debugColumns;
      }
    }),
    getLeafColumns: ut(() => [e._getOrderColumnsFn()], (k) => {
      if (y.columns?.length) {
        let _ = y.columns.flatMap((E) => E.getLeafColumns());
        return k(_);
      }
      return [y];
    }, {
      key: process.env.NODE_ENV === "production" && "column.getLeafColumns",
      debug: () => {
        var k;
        return (k = e.options.debugAll) != null ? k : e.options.debugColumns;
      }
    })
  };
  return y = e._features.reduce((k, _) => Object.assign(k, _.createColumn?.(y, e)), y), y;
}
function UD(e, n, r) {
  var o;
  let u = {
    id: (o = r.id) != null ? o : n.id,
    column: n,
    index: r.index,
    isPlaceholder: !!r.isPlaceholder,
    placeholderId: r.placeholderId,
    depth: r.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const h = [], f = (p) => {
        p.subHeaders && p.subHeaders.length && p.subHeaders.map(f), h.push(p);
      };
      return f(u), h;
    },
    getContext: () => ({
      table: e,
      header: u,
      column: n
    })
  };
  return e._features.forEach((h) => {
    Object.assign(u, h.createHeader?.(u, e));
  }), u;
}
const gTe = {
  createTable: (e) => ({
    getHeaderGroups: ut(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o, s) => {
      var u, h;
      const f = (u = o?.map((y) => r.find((k) => k.id === y)).filter(Boolean)) != null ? u : [], p = (h = s?.map((y) => r.find((k) => k.id === y)).filter(Boolean)) != null ? h : [], v = r.filter((y) => !o?.includes(y.id) && !s?.includes(y.id));
      return lf(n, [...f, ...v, ...p], e);
    }, {
      key: process.env.NODE_ENV === "development" && "getHeaderGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getCenterHeaderGroups: ut(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o, s) => (r = r.filter((u) => !o?.includes(u.id) && !s?.includes(u.id)), lf(n, r, e, "center")), {
      key: process.env.NODE_ENV === "development" && "getCenterHeaderGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getLeftHeaderGroups: ut(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, r, o) => {
      var s;
      const u = (s = o?.map((h) => r.find((f) => f.id === h)).filter(Boolean)) != null ? s : [];
      return lf(n, u, e, "left");
    }, {
      key: process.env.NODE_ENV === "development" && "getLeftHeaderGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getRightHeaderGroups: ut(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, r, o) => {
      var s;
      const u = (s = o?.map((h) => r.find((f) => f.id === h)).filter(Boolean)) != null ? s : [];
      return lf(n, u, e, "right");
    }, {
      key: process.env.NODE_ENV === "development" && "getRightHeaderGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getFooterGroups: ut(() => [e.getHeaderGroups()], (n) => [...n].reverse(), {
      key: process.env.NODE_ENV === "development" && "getFooterGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getLeftFooterGroups: ut(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), {
      key: process.env.NODE_ENV === "development" && "getLeftFooterGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getCenterFooterGroups: ut(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), {
      key: process.env.NODE_ENV === "development" && "getCenterFooterGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getRightFooterGroups: ut(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), {
      key: process.env.NODE_ENV === "development" && "getRightFooterGroups",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getFlatHeaders: ut(() => [e.getHeaderGroups()], (n) => n.map((r) => r.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getFlatHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getLeftFlatHeaders: ut(() => [e.getLeftHeaderGroups()], (n) => n.map((r) => r.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getLeftFlatHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getCenterFlatHeaders: ut(() => [e.getCenterHeaderGroups()], (n) => n.map((r) => r.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getCenterFlatHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getRightFlatHeaders: ut(() => [e.getRightHeaderGroups()], (n) => n.map((r) => r.headers).flat(), {
      key: process.env.NODE_ENV === "development" && "getRightFlatHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getCenterLeafHeaders: ut(() => [e.getCenterFlatHeaders()], (n) => n.filter((r) => !r.subHeaders?.length), {
      key: process.env.NODE_ENV === "development" && "getCenterLeafHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getLeftLeafHeaders: ut(() => [e.getLeftFlatHeaders()], (n) => n.filter((r) => !r.subHeaders?.length), {
      key: process.env.NODE_ENV === "development" && "getLeftLeafHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getRightLeafHeaders: ut(() => [e.getRightFlatHeaders()], (n) => n.filter((r) => !r.subHeaders?.length), {
      key: process.env.NODE_ENV === "development" && "getRightLeafHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    }),
    getLeafHeaders: ut(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, r, o) => {
      var s, u, h;
      return [...(s = n[0]?.headers) != null ? s : [], ...(u = r[0]?.headers) != null ? u : [], ...(h = o[0]?.headers) != null ? h : []].map((f) => f.getLeafHeaders()).flat();
    }, {
      key: process.env.NODE_ENV === "development" && "getLeafHeaders",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugHeaders;
      }
    })
  })
};
function lf(e, n, r, o) {
  var s;
  let u = 0;
  const h = function(y, k) {
    k === void 0 && (k = 1), u = Math.max(u, k), y.filter((_) => _.getIsVisible()).forEach((_) => {
      _.columns?.length && h(_.columns, k + 1);
    }, 0);
  };
  h(e);
  let f = [];
  const p = (y, k) => {
    const _ = {
      depth: k,
      id: [o, `${k}`].filter(Boolean).join("_"),
      headers: []
    }, E = [];
    y.forEach((x) => {
      const D = [...E].reverse()[0], I = x.column.depth === _.depth;
      let N, O = !1;
      if (I && x.column.parent ? N = x.column.parent : (N = x.column, O = !0), D && D?.column === N)
        D.subHeaders.push(x);
      else {
        const P = UD(r, N, {
          id: [o, k, N.id, x?.id].filter(Boolean).join("_"),
          isPlaceholder: O,
          placeholderId: O ? `${E.filter((S) => S.column === N).length}` : void 0,
          depth: k,
          index: E.length
        });
        P.subHeaders.push(x), E.push(P);
      }
      _.headers.push(x), x.headerGroup = _;
    }), f.push(_), k > 0 && p(E, k - 1);
  }, v = n.map((y, k) => UD(r, y, {
    depth: u,
    index: k
  }));
  p(v, u - 1), f.reverse();
  const b = (y) => y.filter((_) => _.column.getIsVisible()).map((_) => {
    let E = 0, x = 0, D = [0];
    _.subHeaders && _.subHeaders.length ? (D = [], b(_.subHeaders).forEach((N) => {
      let {
        colSpan: O,
        rowSpan: P
      } = N;
      E += O, D.push(P);
    })) : E = 1;
    const I = Math.min(...D);
    return x = x + I, _.colSpan = E, _.rowSpan = x, {
      colSpan: E,
      rowSpan: x
    };
  });
  return b((s = f[0]?.headers) != null ? s : []), f;
}
const cf = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, pb = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), mTe = {
  getDefaultColumnDef: () => cf,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: pb(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    onColumnSizingChange: gi("columnSizing", e),
    onColumnSizingInfoChange: gi("columnSizingInfo", e)
  }),
  createColumn: (e, n) => ({
    getSize: () => {
      var r, o, s;
      const u = n.getState().columnSizing[e.id];
      return Math.min(Math.max((r = e.columnDef.minSize) != null ? r : cf.minSize, (o = u ?? e.columnDef.size) != null ? o : cf.size), (s = e.columnDef.maxSize) != null ? s : cf.maxSize);
    },
    getStart: (r) => {
      const o = r ? r === "left" ? n.getLeftVisibleLeafColumns() : n.getRightVisibleLeafColumns() : n.getVisibleLeafColumns(), s = o.findIndex((u) => u.id === e.id);
      if (s > 0) {
        const u = o[s - 1];
        return u.getStart(r) + u.getSize();
      }
      return 0;
    },
    resetSize: () => {
      n.setColumnSizing((r) => {
        let {
          [e.id]: o,
          ...s
        } = r;
        return s;
      });
    },
    getCanResize: () => {
      var r, o;
      return ((r = e.columnDef.enableResizing) != null ? r : !0) && ((o = n.options.enableColumnResizing) != null ? o : !0);
    },
    getIsResizing: () => n.getState().columnSizingInfo.isResizingColumn === e.id
  }),
  createHeader: (e, n) => ({
    getSize: () => {
      let r = 0;
      const o = (s) => {
        if (s.subHeaders.length)
          s.subHeaders.forEach(o);
        else {
          var u;
          r += (u = s.column.getSize()) != null ? u : 0;
        }
      };
      return o(e), r;
    },
    getStart: () => {
      if (e.index > 0) {
        const r = e.headerGroup.headers[e.index - 1];
        return r.getStart() + r.getSize();
      }
      return 0;
    },
    getResizeHandler: () => {
      const r = n.getColumn(e.column.id), o = r.getCanResize();
      return (s) => {
        if (!o || (s.persist?.(), gb(s) && s.touches && s.touches.length > 1))
          return;
        const u = e.getSize(), h = e ? e.getLeafHeaders().map((E) => [E.column.id, E.column.getSize()]) : [[r.id, r.getSize()]], f = gb(s) ? Math.round(s.touches[0].clientX) : s.clientX, p = (E, x) => {
          if (typeof x != "number")
            return;
          let D = {};
          n.setColumnSizingInfo((I) => {
            var N, O;
            const P = x - ((N = I?.startOffset) != null ? N : 0), S = Math.max(P / ((O = I?.startSize) != null ? O : 0), -0.999999);
            return I.columnSizingStart.forEach(($) => {
              let [L, B] = $;
              D[L] = Math.round(Math.max(B + B * S, 0) * 100) / 100;
            }), {
              ...I,
              deltaOffset: P,
              deltaPercentage: S
            };
          }), (n.options.columnResizeMode === "onChange" || E === "end") && n.setColumnSizing((I) => ({
            ...I,
            ...D
          }));
        }, v = (E) => p("move", E), b = (E) => {
          p("end", E), n.setColumnSizingInfo((x) => ({
            ...x,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, y = {
          moveHandler: (E) => v(E.clientX),
          upHandler: (E) => {
            document.removeEventListener("mousemove", y.moveHandler), document.removeEventListener("mouseup", y.upHandler), b(E.clientX);
          }
        }, k = {
          moveHandler: (E) => (E.cancelable && (E.preventDefault(), E.stopPropagation()), v(E.touches[0].clientX), !1),
          upHandler: (E) => {
            document.removeEventListener("touchmove", k.moveHandler), document.removeEventListener("touchend", k.upHandler), E.cancelable && (E.preventDefault(), E.stopPropagation()), b(E.touches[0]?.clientX);
          }
        }, _ = vTe() ? {
          passive: !1
        } : !1;
        gb(s) ? (document.addEventListener("touchmove", k.moveHandler, _), document.addEventListener("touchend", k.upHandler, _)) : (document.addEventListener("mousemove", y.moveHandler, _), document.addEventListener("mouseup", y.upHandler, _)), n.setColumnSizingInfo((E) => ({
          ...E,
          startOffset: f,
          startSize: u,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: h,
          isResizingColumn: r.id
        }));
      };
    }
  }),
  createTable: (e) => ({
    setColumnSizing: (n) => e.options.onColumnSizingChange?.(n),
    setColumnSizingInfo: (n) => e.options.onColumnSizingInfoChange?.(n),
    resetColumnSizing: (n) => {
      var r;
      e.setColumnSizing(n ? {} : (r = e.initialState.columnSizing) != null ? r : {});
    },
    resetHeaderSizeInfo: (n) => {
      var r;
      e.setColumnSizingInfo(n ? pb() : (r = e.initialState.columnSizingInfo) != null ? r : pb());
    },
    getTotalSize: () => {
      var n;
      return (n = e.getHeaderGroups()[0]?.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    },
    getLeftTotalSize: () => {
      var n;
      return (n = e.getLeftHeaderGroups()[0]?.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    },
    getCenterTotalSize: () => {
      var n;
      return (n = e.getCenterHeaderGroups()[0]?.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    },
    getRightTotalSize: () => {
      var n;
      return (n = e.getRightHeaderGroups()[0]?.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? n : 0;
    }
  })
};
let uf = null;
function vTe() {
  if (typeof uf == "boolean")
    return uf;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, r = () => {
    };
    window.addEventListener("test", r, n), window.removeEventListener("test", r);
  } catch {
    e = !1;
  }
  return uf = e, uf;
}
function gb(e) {
  return e.type === "touchstart";
}
const bTe = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: gi("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, r = !1;
    return {
      _autoResetExpanded: () => {
        var o, s;
        if (!n) {
          e._queue(() => {
            n = !0;
          });
          return;
        }
        if ((o = (s = e.options.autoResetAll) != null ? s : e.options.autoResetExpanded) != null ? o : !e.options.manualExpanding) {
          if (r)
            return;
          r = !0, e._queue(() => {
            e.resetExpanded(), r = !1;
          });
        }
      },
      setExpanded: (o) => e.options.onExpandedChange?.(o),
      toggleAllRowsExpanded: (o) => {
        o ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
      },
      resetExpanded: (o) => {
        var s;
        e.setExpanded(o ? {} : (s = e.initialState?.expanded) != null ? s : {});
      },
      getCanSomeRowsExpand: () => e.getRowModel().flatRows.some((o) => o.getCanExpand()),
      getToggleAllRowsExpandedHandler: () => (o) => {
        o.persist?.(), e.toggleAllRowsExpanded();
      },
      getIsSomeRowsExpanded: () => {
        const o = e.getState().expanded;
        return o === !0 || Object.values(o).some(Boolean);
      },
      getIsAllRowsExpanded: () => {
        const o = e.getState().expanded;
        return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || e.getRowModel().flatRows.some((s) => !s.getIsExpanded()));
      },
      getExpandedDepth: () => {
        let o = 0;
        return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((u) => {
          const h = u.split(".");
          o = Math.max(o, h.length);
        }), o;
      },
      getPreExpandedRowModel: () => e.getSortedRowModel(),
      getExpandedRowModel: () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel())
    };
  },
  createRow: (e, n) => ({
    toggleExpanded: (r) => {
      n.setExpanded((o) => {
        var s;
        const u = o === !0 ? !0 : !!o?.[e.id];
        let h = {};
        if (o === !0 ? Object.keys(n.getRowModel().rowsById).forEach((f) => {
          h[f] = !0;
        }) : h = o, r = (s = r) != null ? s : !u, !u && r)
          return {
            ...h,
            [e.id]: !0
          };
        if (u && !r) {
          const {
            [e.id]: f,
            ...p
          } = h;
          return p;
        }
        return o;
      });
    },
    getIsExpanded: () => {
      var r;
      const o = n.getState().expanded;
      return !!((r = n.options.getIsRowExpanded?.(e)) != null ? r : o === !0 || o?.[e.id]);
    },
    getCanExpand: () => {
      var r, o;
      return (r = n.options.getRowCanExpand?.(e)) != null ? r : ((o = n.options.enableExpanding) != null ? o : !0) && !!e.subRows?.length;
    },
    getToggleExpandedHandler: () => {
      const r = e.getCanExpand();
      return () => {
        !r || e.toggleExpanded();
      };
    }
  })
}, cO = (e, n, r) => {
  const o = r.toLowerCase();
  return Boolean(e.getValue(n)?.toLowerCase().includes(o));
};
cO.autoRemove = (e) => Di(e);
const uO = (e, n, r) => Boolean(e.getValue(n)?.includes(r));
uO.autoRemove = (e) => Di(e);
const dO = (e, n, r) => e.getValue(n)?.toLowerCase() === r.toLowerCase();
dO.autoRemove = (e) => Di(e);
const hO = (e, n, r) => e.getValue(n)?.includes(r);
hO.autoRemove = (e) => Di(e) || !e?.length;
const fO = (e, n, r) => !r.some((o) => !e.getValue(n)?.includes(o));
fO.autoRemove = (e) => Di(e) || !e?.length;
const pO = (e, n, r) => r.some((o) => e.getValue(n)?.includes(o));
pO.autoRemove = (e) => Di(e) || !e?.length;
const gO = (e, n, r) => e.getValue(n) === r;
gO.autoRemove = (e) => Di(e);
const mO = (e, n, r) => e.getValue(n) == r;
mO.autoRemove = (e) => Di(e);
const hk = (e, n, r) => {
  let [o, s] = r;
  const u = e.getValue(n);
  return u >= o && u <= s;
};
hk.resolveFilterValue = (e) => {
  let [n, r] = e, o = typeof n != "number" ? parseFloat(n) : n, s = typeof r != "number" ? parseFloat(r) : r, u = n === null || Number.isNaN(o) ? -1 / 0 : o, h = r === null || Number.isNaN(s) ? 1 / 0 : s;
  if (u > h) {
    const f = u;
    u = h, h = f;
  }
  return [u, h];
};
hk.autoRemove = (e) => Di(e) || Di(e[0]) && Di(e[1]);
const $o = {
  includesString: cO,
  includesStringSensitive: uO,
  equalsString: dO,
  arrIncludes: hO,
  arrIncludesAll: fO,
  arrIncludesSome: pO,
  equals: gO,
  weakEquals: mO,
  inNumberRange: hk
};
function Di(e) {
  return e == null || e === "";
}
const wTe = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: gi("columnFilters", e),
    onGlobalFilterChange: gi("globalFilter", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100,
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      const r = e.getCoreRowModel().flatRows[0]?._getAllCellsByColumnId()[n.id]?.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, n) => ({
    getAutoFilterFn: () => {
      const o = n.getCoreRowModel().flatRows[0]?.getValue(e.id);
      return typeof o == "string" ? $o.includesString : typeof o == "number" ? $o.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? $o.equals : Array.isArray(o) ? $o.arrIncludes : $o.weakEquals;
    },
    getFilterFn: () => {
      var r;
      return Zp(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (r = n.options.filterFns?.[e.columnDef.filterFn]) != null ? r : $o[e.columnDef.filterFn];
    },
    getCanFilter: () => {
      var r, o, s;
      return ((r = e.columnDef.enableColumnFilter) != null ? r : !0) && ((o = n.options.enableColumnFilters) != null ? o : !0) && ((s = n.options.enableFilters) != null ? s : !0) && !!e.accessorFn;
    },
    getCanGlobalFilter: () => {
      var r, o, s, u;
      return ((r = e.columnDef.enableGlobalFilter) != null ? r : !0) && ((o = n.options.enableGlobalFilter) != null ? o : !0) && ((s = n.options.enableFilters) != null ? s : !0) && ((u = n.options.getColumnCanGlobalFilter?.(e)) != null ? u : !0) && !!e.accessorFn;
    },
    getIsFiltered: () => e.getFilterIndex() > -1,
    getFilterValue: () => n.getState().columnFilters?.find((r) => r.id === e.id)?.value,
    getFilterIndex: () => {
      var r;
      return (r = n.getState().columnFilters?.findIndex((o) => o.id === e.id)) != null ? r : -1;
    },
    setFilterValue: (r) => {
      n.setColumnFilters((o) => {
        const s = e.getFilterFn(), u = o?.find((b) => b.id === e.id), h = Ea(r, u ? u.value : void 0);
        if (WD(s, h, e)) {
          var f;
          return (f = o?.filter((b) => b.id !== e.id)) != null ? f : [];
        }
        const p = {
          id: e.id,
          value: h
        };
        if (u) {
          var v;
          return (v = o?.map((b) => b.id === e.id ? p : b)) != null ? v : [];
        }
        return o?.length ? [...o, p] : [p];
      });
    },
    _getFacetedRowModel: n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id),
    getFacetedRowModel: () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(),
    _getFacetedUniqueValues: n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id),
    getFacetedUniqueValues: () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(),
    _getFacetedMinMaxValues: n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id),
    getFacetedMinMaxValues: () => {
      if (!!e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    }
  }),
  createRow: (e, n) => ({
    columnFilters: {},
    columnFiltersMeta: {}
  }),
  createTable: (e) => ({
    getGlobalAutoFilterFn: () => $o.includesString,
    getGlobalFilterFn: () => {
      var n;
      const {
        globalFilterFn: r
      } = e.options;
      return Zp(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (n = e.options.filterFns?.[r]) != null ? n : $o[r];
    },
    setColumnFilters: (n) => {
      const r = e.getAllLeafColumns(), o = (s) => Ea(n, s)?.filter((u) => {
        const h = r.find((f) => f.id === u.id);
        if (h) {
          const f = h.getFilterFn();
          if (WD(f, u.value, h))
            return !1;
        }
        return !0;
      });
      e.options.onColumnFiltersChange?.(o);
    },
    setGlobalFilter: (n) => {
      e.options.onGlobalFilterChange?.(n);
    },
    resetGlobalFilter: (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    },
    resetColumnFilters: (n) => {
      var r;
      e.setColumnFilters(n ? [] : (r = e.initialState?.columnFilters) != null ? r : []);
    },
    getPreFilteredRowModel: () => e.getCoreRowModel(),
    getFilteredRowModel: () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel()),
    _getGlobalFacetedRowModel: e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"),
    getGlobalFacetedRowModel: () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(),
    _getGlobalFacetedUniqueValues: e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"),
    getGlobalFacetedUniqueValues: () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(),
    _getGlobalFacetedMinMaxValues: e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"),
    getGlobalFacetedMinMaxValues: () => {
      if (!!e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    }
  })
};
function WD(e, n, r) {
  return (e && e.autoRemove ? e.autoRemove(n, r) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const yTe = (e, n, r) => r.reduce((o, s) => {
  const u = s.getValue(e);
  return o + (typeof u == "number" ? u : 0);
}, 0), kTe = (e, n, r) => {
  let o;
  return r.forEach((s) => {
    const u = s.getValue(e);
    u != null && (o > u || o === void 0 && u >= u) && (o = u);
  }), o;
}, _Te = (e, n, r) => {
  let o;
  return r.forEach((s) => {
    const u = s.getValue(e);
    u != null && (o < u || o === void 0 && u >= u) && (o = u);
  }), o;
}, ATe = (e, n, r) => {
  let o, s;
  return r.forEach((u) => {
    const h = u.getValue(e);
    h != null && (o === void 0 ? h >= h && (o = s = h) : (o > h && (o = h), s < h && (s = h)));
  }), [o, s];
}, CTe = (e, n) => {
  let r = 0, o = 0;
  if (n.forEach((s) => {
    let u = s.getValue(e);
    u != null && (u = +u) >= u && (++r, o += u);
  }), r)
    return o / r;
}, xTe = (e, n) => {
  if (!n.length)
    return;
  let r = 0, o = 0;
  return n.forEach((s) => {
    let u = s.getValue(e);
    typeof u == "number" && (r = Math.min(r, u), o = Math.max(o, u));
  }), (r + o) / 2;
}, ETe = (e, n) => Array.from(new Set(n.map((r) => r.getValue(e))).values()), STe = (e, n) => new Set(n.map((r) => r.getValue(e))).size, MTe = (e, n) => n.length, mb = {
  sum: yTe,
  min: kTe,
  max: _Te,
  extent: ATe,
  mean: CTe,
  median: xTe,
  unique: ETe,
  uniqueCount: STe,
  count: MTe
}, TTe = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n;
      return (n = e.getValue()?.toString?.()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: gi("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => ({
    toggleGrouping: () => {
      n.setGrouping((r) => r?.includes(e.id) ? r.filter((o) => o !== e.id) : [...r ?? [], e.id]);
    },
    getCanGroup: () => {
      var r, o, s, u;
      return (r = (o = (s = (u = e.columnDef.enableGrouping) != null ? u : !0) != null ? s : n.options.enableGrouping) != null ? o : !0) != null ? r : !!e.accessorFn;
    },
    getIsGrouped: () => n.getState().grouping?.includes(e.id),
    getGroupedIndex: () => n.getState().grouping?.indexOf(e.id),
    getToggleGroupingHandler: () => {
      const r = e.getCanGroup();
      return () => {
        !r || e.toggleGrouping();
      };
    },
    getAutoAggregationFn: () => {
      const o = n.getCoreRowModel().flatRows[0]?.getValue(e.id);
      if (typeof o == "number")
        return mb.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return mb.extent;
    },
    getAggregationFn: () => {
      var r;
      if (!e)
        throw new Error();
      return Zp(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (r = n.options.aggregationFns?.[e.columnDef.aggregationFn]) != null ? r : mb[e.columnDef.aggregationFn];
    }
  }),
  createTable: (e) => ({
    setGrouping: (n) => e.options.onGroupingChange?.(n),
    resetGrouping: (n) => {
      var r;
      e.setGrouping(n ? [] : (r = e.initialState?.grouping) != null ? r : []);
    },
    getPreGroupedRowModel: () => e.getFilteredRowModel(),
    getGroupedRowModel: () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel())
  }),
  createRow: (e) => ({
    getIsGrouped: () => !!e.groupingColumnId,
    _groupingValuesCache: {}
  }),
  createCell: (e, n, r, o) => ({
    getIsGrouped: () => n.getIsGrouped() && n.id === r.groupingColumnId,
    getIsPlaceholder: () => !e.getIsGrouped() && n.getIsGrouped(),
    getIsAggregated: () => !e.getIsGrouped() && !e.getIsPlaceholder() && !!r.subRows?.length
  })
};
function DTe(e, n, r) {
  if (!n?.length || !r)
    return e;
  const o = e.filter((u) => !n.includes(u.id));
  return r === "remove" ? o : [...n.map((u) => e.find((h) => h.id === u)).filter(Boolean), ...o];
}
const ITe = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: gi("columnOrder", e)
  }),
  createTable: (e) => ({
    setColumnOrder: (n) => e.options.onColumnOrderChange?.(n),
    resetColumnOrder: (n) => {
      var r;
      e.setColumnOrder(n ? [] : (r = e.initialState.columnOrder) != null ? r : []);
    },
    _getOrderColumnsFn: ut(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, r, o) => (s) => {
      let u = [];
      if (!n?.length)
        u = s;
      else {
        const h = [...n], f = [...s];
        for (; f.length && h.length; ) {
          const p = h.shift(), v = f.findIndex((b) => b.id === p);
          v > -1 && u.push(f.splice(v, 1)[0]);
        }
        u = [...u, ...f];
      }
      return DTe(u, r, o);
    }, {
      key: process.env.NODE_ENV === "development" && "getOrderColumnsFn"
    })
  })
}, p1 = 0, g1 = 10, vb = () => ({
  pageIndex: p1,
  pageSize: g1
}), PTe = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...vb(),
      ...e?.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: gi("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, r = !1;
    return {
      _autoResetPageIndex: () => {
        var o, s;
        if (!n) {
          e._queue(() => {
            n = !0;
          });
          return;
        }
        if ((o = (s = e.options.autoResetAll) != null ? s : e.options.autoResetPageIndex) != null ? o : !e.options.manualPagination) {
          if (r)
            return;
          r = !0, e._queue(() => {
            e.resetPageIndex(), r = !1;
          });
        }
      },
      setPagination: (o) => {
        const s = (u) => Ea(o, u);
        return e.options.onPaginationChange?.(s);
      },
      resetPagination: (o) => {
        var s;
        e.setPagination(o ? vb() : (s = e.initialState.pagination) != null ? s : vb());
      },
      setPageIndex: (o) => {
        e.setPagination((s) => {
          let u = Ea(o, s.pageIndex);
          const h = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
          return u = Math.max(0, Math.min(u, h)), {
            ...s,
            pageIndex: u
          };
        });
      },
      resetPageIndex: (o) => {
        var s;
        e.setPageIndex(o ? p1 : (s = e.initialState?.pagination?.pageIndex) != null ? s : p1);
      },
      resetPageSize: (o) => {
        var s;
        e.setPageSize(o ? g1 : (s = e.initialState?.pagination?.pageSize) != null ? s : g1);
      },
      setPageSize: (o) => {
        e.setPagination((s) => {
          const u = Math.max(1, Ea(o, s.pageSize)), h = s.pageSize * s.pageIndex, f = Math.floor(h / u);
          return {
            ...s,
            pageIndex: f,
            pageSize: u
          };
        });
      },
      setPageCount: (o) => e.setPagination((s) => {
        var u;
        let h = Ea(o, (u = e.options.pageCount) != null ? u : -1);
        return typeof h == "number" && (h = Math.max(-1, h)), {
          ...s,
          pageCount: h
        };
      }),
      getPageOptions: ut(() => [e.getPageCount()], (o) => {
        let s = [];
        return o && o > 0 && (s = [...new Array(o)].fill(null).map((u, h) => h)), s;
      }, {
        key: process.env.NODE_ENV === "development" && "getPageOptions",
        debug: () => {
          var o;
          return (o = e.options.debugAll) != null ? o : e.options.debugTable;
        }
      }),
      getCanPreviousPage: () => e.getState().pagination.pageIndex > 0,
      getCanNextPage: () => {
        const {
          pageIndex: o
        } = e.getState().pagination, s = e.getPageCount();
        return s === -1 ? !0 : s === 0 ? !1 : o < s - 1;
      },
      previousPage: () => e.setPageIndex((o) => o - 1),
      nextPage: () => e.setPageIndex((o) => o + 1),
      getPrePaginationRowModel: () => e.getExpandedRowModel(),
      getPaginationRowModel: () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()),
      getPageCount: () => {
        var o;
        return (o = e.options.pageCount) != null ? o : Math.ceil(e.getPrePaginationRowModel().rows.length / e.getState().pagination.pageSize);
      }
    };
  }
}, bb = () => ({
  left: [],
  right: []
}), OTe = {
  getInitialState: (e) => ({
    columnPinning: bb(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: gi("columnPinning", e)
  }),
  createColumn: (e, n) => ({
    pin: (r) => {
      const o = e.getLeafColumns().map((s) => s.id).filter(Boolean);
      n.setColumnPinning((s) => {
        var u, h;
        if (r === "right") {
          var f, p;
          return {
            left: ((f = s?.left) != null ? f : []).filter((y) => !o?.includes(y)),
            right: [...((p = s?.right) != null ? p : []).filter((y) => !o?.includes(y)), ...o]
          };
        }
        if (r === "left") {
          var v, b;
          return {
            left: [...((v = s?.left) != null ? v : []).filter((y) => !o?.includes(y)), ...o],
            right: ((b = s?.right) != null ? b : []).filter((y) => !o?.includes(y))
          };
        }
        return {
          left: ((u = s?.left) != null ? u : []).filter((y) => !o?.includes(y)),
          right: ((h = s?.right) != null ? h : []).filter((y) => !o?.includes(y))
        };
      });
    },
    getCanPin: () => e.getLeafColumns().some((o) => {
      var s, u;
      return ((s = o.columnDef.enablePinning) != null ? s : !0) && ((u = n.options.enablePinning) != null ? u : !0);
    }),
    getIsPinned: () => {
      const r = e.getLeafColumns().map((f) => f.id), {
        left: o,
        right: s
      } = n.getState().columnPinning, u = r.some((f) => o?.includes(f)), h = r.some((f) => s?.includes(f));
      return u ? "left" : h ? "right" : !1;
    },
    getPinnedIndex: () => {
      var r;
      const o = e.getIsPinned();
      return o ? (r = n.getState().columnPinning?.[o]?.indexOf(e.id)) != null ? r : -1 : 0;
    }
  }),
  createRow: (e, n) => ({
    getCenterVisibleCells: ut(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (r, o, s) => {
      const u = [...o ?? [], ...s ?? []];
      return r.filter((h) => !u.includes(h.column.id));
    }, {
      key: process.env.NODE_ENV === "production" && "row.getCenterVisibleCells",
      debug: () => {
        var r;
        return (r = n.options.debugAll) != null ? r : n.options.debugRows;
      }
    }),
    getLeftVisibleCells: ut(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, ,], (r, o) => (o ?? []).map((u) => r.find((h) => h.column.id === u)).filter(Boolean).map((u) => ({
      ...u,
      position: "left"
    })), {
      key: process.env.NODE_ENV === "production" && "row.getLeftVisibleCells",
      debug: () => {
        var r;
        return (r = n.options.debugAll) != null ? r : n.options.debugRows;
      }
    }),
    getRightVisibleCells: ut(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (r, o) => (o ?? []).map((u) => r.find((h) => h.column.id === u)).filter(Boolean).map((u) => ({
      ...u,
      position: "right"
    })), {
      key: process.env.NODE_ENV === "production" && "row.getRightVisibleCells",
      debug: () => {
        var r;
        return (r = n.options.debugAll) != null ? r : n.options.debugRows;
      }
    })
  }),
  createTable: (e) => ({
    setColumnPinning: (n) => e.options.onColumnPinningChange?.(n),
    resetColumnPinning: (n) => {
      var r;
      return e.setColumnPinning(n ? bb() : (r = e.initialState?.columnPinning) != null ? r : bb());
    },
    getIsSomeColumnsPinned: (n) => {
      const r = e.getState().columnPinning;
      return Boolean(n ? r[n]?.length : r.left?.length || r.right?.length);
    },
    getLeftLeafColumns: ut(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, r) => (r ?? []).map((o) => n.find((s) => s.id === o)).filter(Boolean), {
      key: process.env.NODE_ENV === "development" && "getLeftLeafColumns",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugColumns;
      }
    }),
    getRightLeafColumns: ut(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, r) => (r ?? []).map((o) => n.find((s) => s.id === o)).filter(Boolean), {
      key: process.env.NODE_ENV === "development" && "getRightLeafColumns",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugColumns;
      }
    }),
    getCenterLeafColumns: ut(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, r, o) => {
      const s = [...r ?? [], ...o ?? []];
      return n.filter((u) => !s.includes(u.id));
    }, {
      key: process.env.NODE_ENV === "development" && "getCenterLeafColumns",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugColumns;
      }
    })
  })
}, RTe = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: gi("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
  }),
  createTable: (e) => ({
    setRowSelection: (n) => e.options.onRowSelectionChange?.(n),
    resetRowSelection: (n) => {
      var r;
      return e.setRowSelection(n ? {} : (r = e.initialState.rowSelection) != null ? r : {});
    },
    toggleAllRowsSelected: (n) => {
      e.setRowSelection((r) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const o = {
          ...r
        }, s = e.getPreGroupedRowModel().flatRows;
        return n ? s.forEach((u) => {
          !u.getCanSelect() || (o[u.id] = !0);
        }) : s.forEach((u) => {
          delete o[u.id];
        }), o;
      });
    },
    toggleAllPageRowsSelected: (n) => e.setRowSelection((r) => {
      const o = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), s = {
        ...r
      };
      return e.getRowModel().rows.forEach((u) => {
        m1(s, u.id, o, e);
      }), s;
    }),
    getPreSelectedRowModel: () => e.getCoreRowModel(),
    getSelectedRowModel: ut(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, r) => Object.keys(n).length ? wb(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "development" && "getSelectedRowModel",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugTable;
      }
    }),
    getFilteredSelectedRowModel: ut(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, r) => Object.keys(n).length ? wb(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "production" && "getFilteredSelectedRowModel",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugTable;
      }
    }),
    getGroupedSelectedRowModel: ut(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, r) => Object.keys(n).length ? wb(e, r) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, {
      key: process.env.NODE_ENV === "production" && "getGroupedSelectedRowModel",
      debug: () => {
        var n;
        return (n = e.options.debugAll) != null ? n : e.options.debugTable;
      }
    }),
    getIsAllRowsSelected: () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: r
      } = e.getState();
      let o = Boolean(n.length && Object.keys(r).length);
      return o && n.some((s) => s.getCanSelect() && !r[s.id]) && (o = !1), o;
    },
    getIsAllPageRowsSelected: () => {
      const n = e.getPaginationRowModel().flatRows, {
        rowSelection: r
      } = e.getState();
      let o = !!n.length;
      return o && n.some((s) => !r[s.id]) && (o = !1), o;
    },
    getIsSomeRowsSelected: () => {
      var n;
      const r = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return r > 0 && r < e.getFilteredRowModel().flatRows.length;
    },
    getIsSomePageRowsSelected: () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.some((r) => r.getIsSelected() || r.getIsSomeSelected());
    },
    getToggleAllRowsSelectedHandler: () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    },
    getToggleAllPageRowsSelectedHandler: () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    }
  }),
  createRow: (e, n) => ({
    toggleSelected: (r) => {
      const o = e.getIsSelected();
      n.setRowSelection((s) => {
        if (r = typeof r < "u" ? r : !o, o === r)
          return s;
        const u = {
          ...s
        };
        return m1(u, e.id, r, n), u;
      });
    },
    getIsSelected: () => {
      const {
        rowSelection: r
      } = n.getState();
      return fk(e, r);
    },
    getIsSomeSelected: () => {
      const {
        rowSelection: r
      } = n.getState();
      return GD(e, r) === "some";
    },
    getIsAllSubRowsSelected: () => {
      const {
        rowSelection: r
      } = n.getState();
      return GD(e, r) === "all";
    },
    getCanSelect: () => {
      var r;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (r = n.options.enableRowSelection) != null ? r : !0;
    },
    getCanSelectSubRows: () => {
      var r;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (r = n.options.enableSubRowSelection) != null ? r : !0;
    },
    getCanMultiSelect: () => {
      var r;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (r = n.options.enableMultiRowSelection) != null ? r : !0;
    },
    getToggleSelectedHandler: () => {
      const r = e.getCanSelect();
      return (o) => {
        !r || e.toggleSelected(o.target?.checked);
      };
    }
  })
}, m1 = (e, n, r, o) => {
  const s = o.getRow(n);
  r ? (s.getCanMultiSelect() || Object.keys(e).forEach((u) => delete e[u]), s.getCanSelect() && (e[n] = !0)) : delete e[n], s.subRows?.length && s.getCanSelectSubRows() && s.subRows.forEach((u) => m1(e, u.id, r, o));
};
function wb(e, n) {
  const r = e.getState().rowSelection, o = [], s = {}, u = function(h, f) {
    return h.map((p) => {
      const v = fk(p, r);
      if (v && (o.push(p), s[p.id] = p), p.subRows?.length && (p = {
        ...p,
        subRows: u(p.subRows)
      }), v)
        return p;
    }).filter(Boolean);
  };
  return {
    rows: u(n.rows),
    flatRows: o,
    rowsById: s
  };
}
function fk(e, n) {
  var r;
  return (r = n[e.id]) != null ? r : !1;
}
function GD(e, n, r) {
  if (e.subRows && e.subRows.length) {
    let o = !0, s = !1;
    return e.subRows.forEach((u) => {
      s && !o || (fk(u, n) ? s = !0 : o = !1);
    }), o ? "all" : s ? "some" : !1;
  }
  return !1;
}
const v1 = /([0-9]+)/gm, NTe = (e, n, r) => vO(Ra(e.getValue(r)).toLowerCase(), Ra(n.getValue(r)).toLowerCase()), $Te = (e, n, r) => vO(Ra(e.getValue(r)), Ra(n.getValue(r))), LTe = (e, n, r) => pk(Ra(e.getValue(r)).toLowerCase(), Ra(n.getValue(r)).toLowerCase()), jTe = (e, n, r) => pk(Ra(e.getValue(r)), Ra(n.getValue(r))), BTe = (e, n, r) => {
  const o = e.getValue(r), s = n.getValue(r);
  return o > s ? 1 : o < s ? -1 : 0;
}, FTe = (e, n, r) => pk(e.getValue(r), n.getValue(r));
function pk(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Ra(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function vO(e, n) {
  const r = e.split(v1).filter(Boolean), o = n.split(v1).filter(Boolean);
  for (; r.length && o.length; ) {
    const s = r.shift(), u = o.shift(), h = parseInt(s, 10), f = parseInt(u, 10), p = [h, f].sort();
    if (isNaN(p[0])) {
      if (s > u)
        return 1;
      if (u > s)
        return -1;
      continue;
    }
    if (isNaN(p[1]))
      return isNaN(h) ? -1 : 1;
    if (h > f)
      return 1;
    if (f > h)
      return -1;
  }
  return r.length - o.length;
}
const Pu = {
  alphanumeric: NTe,
  alphanumericCaseSensitive: $Te,
  text: LTe,
  textCaseSensitive: jTe,
  datetime: BTe,
  basic: FTe
}, zTe = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto"
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: gi("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => ({
    getAutoSortingFn: () => {
      const r = n.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const s of r) {
        const u = s?.getValue(e.id);
        if (Object.prototype.toString.call(u) === "[object Date]")
          return Pu.datetime;
        if (typeof u == "string" && (o = !0, u.split(v1).length > 1))
          return Pu.alphanumeric;
      }
      return o ? Pu.text : Pu.basic;
    },
    getAutoSortDir: () => typeof n.getFilteredRowModel().flatRows[0]?.getValue(e.id) == "string" ? "asc" : "desc",
    getSortingFn: () => {
      var r;
      if (!e)
        throw new Error();
      return Zp(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (r = n.options.sortingFns?.[e.columnDef.sortingFn]) != null ? r : Pu[e.columnDef.sortingFn];
    },
    toggleSorting: (r, o) => {
      const s = e.getNextSortingOrder(), u = typeof r < "u" && r !== null;
      n.setSorting((h) => {
        const f = h?.find((_) => _.id === e.id), p = h?.findIndex((_) => _.id === e.id);
        let v = [], b, y = u ? r : s === "desc";
        if (h?.length && e.getCanMultiSort() && o ? f ? b = "toggle" : b = "add" : h?.length && p !== h.length - 1 ? b = "replace" : f ? b = "toggle" : b = "replace", b === "toggle" && (u || s || (b = "remove")), b === "add") {
          var k;
          v = [...h, {
            id: e.id,
            desc: y
          }], v.splice(0, v.length - ((k = n.options.maxMultiSortColCount) != null ? k : Number.MAX_SAFE_INTEGER));
        } else
          b === "toggle" ? v = h.map((_) => _.id === e.id ? {
            ..._,
            desc: y
          } : _) : b === "remove" ? v = h.filter((_) => _.id !== e.id) : v = [{
            id: e.id,
            desc: y
          }];
        return v;
      });
    },
    getFirstSortDir: () => {
      var r, o;
      return ((r = (o = e.columnDef.sortDescFirst) != null ? o : n.options.sortDescFirst) != null ? r : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    },
    getNextSortingOrder: (r) => {
      var o, s;
      const u = e.getFirstSortDir(), h = e.getIsSorted();
      return h ? h !== u && ((o = n.options.enableSortingRemoval) != null ? o : !0) && (r && (s = n.options.enableMultiRemove) != null ? s : !0) ? !1 : h === "desc" ? "asc" : "desc" : u;
    },
    getCanSort: () => {
      var r, o;
      return ((r = e.columnDef.enableSorting) != null ? r : !0) && ((o = n.options.enableSorting) != null ? o : !0) && !!e.accessorFn;
    },
    getCanMultiSort: () => {
      var r, o;
      return (r = (o = e.columnDef.enableMultiSort) != null ? o : n.options.enableMultiSort) != null ? r : !!e.accessorFn;
    },
    getIsSorted: () => {
      const r = n.getState().sorting?.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    },
    getSortIndex: () => {
      var r;
      return (r = n.getState().sorting?.findIndex((o) => o.id === e.id)) != null ? r : -1;
    },
    clearSorting: () => {
      n.setSorting((r) => r?.length ? r.filter((o) => o.id !== e.id) : []);
    },
    getToggleSortingHandler: () => {
      const r = e.getCanSort();
      return (o) => {
        !r || (o.persist?.(), e.toggleSorting?.(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent?.(o) : !1));
      };
    }
  }),
  createTable: (e) => ({
    setSorting: (n) => e.options.onSortingChange?.(n),
    resetSorting: (n) => {
      var r;
      e.setSorting(n ? [] : (r = e.initialState?.sorting) != null ? r : []);
    },
    getPreSortedRowModel: () => e.getGroupedRowModel(),
    getSortedRowModel: () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel())
  })
}, VTe = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: gi("columnVisibility", e)
  }),
  createColumn: (e, n) => ({
    toggleVisibility: (r) => {
      e.getCanHide() && n.setColumnVisibility((o) => ({
        ...o,
        [e.id]: r ?? !e.getIsVisible()
      }));
    },
    getIsVisible: () => {
      var r;
      return (r = n.getState().columnVisibility?.[e.id]) != null ? r : !0;
    },
    getCanHide: () => {
      var r, o;
      return ((r = e.columnDef.enableHiding) != null ? r : !0) && ((o = n.options.enableHiding) != null ? o : !0);
    },
    getToggleVisibilityHandler: () => (r) => {
      e.toggleVisibility?.(r.target.checked);
    }
  }),
  createRow: (e, n) => ({
    _getAllVisibleCells: ut(() => [e.getAllCells(), n.getState().columnVisibility], (r) => r.filter((o) => o.column.getIsVisible()), {
      key: process.env.NODE_ENV === "production" && "row._getAllVisibleCells",
      debug: () => {
        var r;
        return (r = n.options.debugAll) != null ? r : n.options.debugRows;
      }
    }),
    getVisibleCells: ut(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (r, o, s) => [...r, ...o, ...s], {
      key: process.env.NODE_ENV === "development" && "row.getVisibleCells",
      debug: () => {
        var r;
        return (r = n.options.debugAll) != null ? r : n.options.debugRows;
      }
    })
  }),
  createTable: (e) => {
    const n = (r, o) => ut(() => [o(), o().filter((s) => s.getIsVisible()).map((s) => s.id).join("_")], (s) => s.filter((u) => u.getIsVisible?.()), {
      key: r,
      debug: () => {
        var s;
        return (s = e.options.debugAll) != null ? s : e.options.debugColumns;
      }
    });
    return {
      getVisibleFlatColumns: n("getVisibleFlatColumns", () => e.getAllFlatColumns()),
      getVisibleLeafColumns: n("getVisibleLeafColumns", () => e.getAllLeafColumns()),
      getLeftVisibleLeafColumns: n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()),
      getRightVisibleLeafColumns: n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()),
      getCenterVisibleLeafColumns: n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()),
      setColumnVisibility: (r) => e.options.onColumnVisibilityChange?.(r),
      resetColumnVisibility: (r) => {
        var o;
        e.setColumnVisibility(r ? {} : (o = e.initialState.columnVisibility) != null ? o : {});
      },
      toggleAllColumnsVisible: (r) => {
        var o;
        r = (o = r) != null ? o : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((s, u) => ({
          ...s,
          [u.id]: r || !u.getCanHide?.()
        }), {}));
      },
      getIsAllColumnsVisible: () => !e.getAllLeafColumns().some((r) => !r.getIsVisible?.()),
      getIsSomeColumnsVisible: () => e.getAllLeafColumns().some((r) => r.getIsVisible?.()),
      getToggleAllColumnsVisibilityHandler: () => (r) => {
        e.toggleAllColumnsVisible(r.target?.checked);
      }
    };
  }
}, qD = [gTe, VTe, ITe, OTe, wTe, zTe, TTe, bTe, PTe, RTe, mTe];
function HTe(e) {
  var n;
  (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  let r = {
    _features: qD
  };
  const o = r._features.reduce((b, y) => Object.assign(b, y.getDefaultOptions?.(r)), {}), s = (b) => r.options.mergeOptions ? r.options.mergeOptions(o, b) : {
    ...o,
    ...b
  };
  let h = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  r._features.forEach((b) => {
    var y;
    h = (y = b.getInitialState?.(h)) != null ? y : h;
  });
  const f = [];
  let p = !1;
  const v = {
    _features: qD,
    options: {
      ...o,
      ...e
    },
    initialState: h,
    _queue: (b) => {
      f.push(b), p || (p = !0, Promise.resolve().then(() => {
        for (; f.length; )
          f.shift()();
        p = !1;
      }).catch((y) => setTimeout(() => {
        throw y;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (b) => {
      const y = Ea(b, r.options);
      r.options = s(y);
    },
    getState: () => r.options.state,
    setState: (b) => {
      r.options.onStateChange?.(b);
    },
    _getRowId: (b, y, k) => {
      var _;
      return (_ = r.options.getRowId?.(b, y, k)) != null ? _ : `${k ? [k.id, y].join(".") : y}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    getRowModel: () => r.getPaginationRowModel(),
    getRow: (b) => {
      const y = r.getRowModel().rowsById[b];
      if (!y)
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow expected an ID, but got ${b}`) : new Error();
      return y;
    },
    _getDefaultColumnDef: ut(() => [r.options.defaultColumn], (b) => {
      var y;
      return b = (y = b) != null ? y : {}, {
        header: (k) => {
          const _ = k.header.column.columnDef;
          return _.accessorKey ? _.accessorKey : _.accessorFn ? _.id : null;
        },
        cell: (k) => {
          var _;
          return (_ = k.renderValue()?.toString?.()) != null ? _ : null;
        },
        ...r._features.reduce((k, _) => Object.assign(k, _.getDefaultColumnDef?.()), {}),
        ...b
      };
    }, {
      debug: () => {
        var b;
        return (b = r.options.debugAll) != null ? b : r.options.debugColumns;
      },
      key: process.env.NODE_ENV === "development" && "getDefaultColumnDef"
    }),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: ut(() => [r._getColumnDefs()], (b) => {
      const y = function(k, _, E) {
        return E === void 0 && (E = 0), k.map((x) => {
          const D = pTe(r, x, E, _), I = x;
          return D.columns = I.columns ? y(I.columns, D, E + 1) : [], D;
        });
      };
      return y(b);
    }, {
      key: process.env.NODE_ENV === "development" && "getAllColumns",
      debug: () => {
        var b;
        return (b = r.options.debugAll) != null ? b : r.options.debugColumns;
      }
    }),
    getAllFlatColumns: ut(() => [r.getAllColumns()], (b) => b.flatMap((y) => y.getFlatColumns()), {
      key: process.env.NODE_ENV === "development" && "getAllFlatColumns",
      debug: () => {
        var b;
        return (b = r.options.debugAll) != null ? b : r.options.debugColumns;
      }
    }),
    _getAllFlatColumnsById: ut(() => [r.getAllFlatColumns()], (b) => b.reduce((y, k) => (y[k.id] = k, y), {}), {
      key: process.env.NODE_ENV === "development" && "getAllFlatColumnsById",
      debug: () => {
        var b;
        return (b = r.options.debugAll) != null ? b : r.options.debugColumns;
      }
    }),
    getAllLeafColumns: ut(() => [r.getAllColumns(), r._getOrderColumnsFn()], (b, y) => {
      let k = b.flatMap((_) => _.getLeafColumns());
      return y(k);
    }, {
      key: process.env.NODE_ENV === "development" && "getAllLeafColumns",
      debug: () => {
        var b;
        return (b = r.options.debugAll) != null ? b : r.options.debugColumns;
      }
    }),
    getColumn: (b) => {
      const y = r._getAllFlatColumnsById()[b];
      if (!y)
        throw process.env.NODE_ENV !== "production" && console.warn(`[Table] Column with id ${b} does not exist.`), new Error();
      return y;
    }
  };
  return Object.assign(r, v), r._features.forEach((b) => Object.assign(r, b.createTable?.(r))), r;
}
function UTe(e, n, r, o) {
  const s = () => {
    var h;
    return (h = u.getValue()) != null ? h : e.options.renderFallbackValue;
  }, u = {
    id: `${n.id}_${r.id}`,
    row: n,
    column: r,
    getValue: () => n.getValue(o),
    renderValue: s,
    getContext: ut(() => [e, r, n, u], (h, f, p, v) => ({
      table: h,
      column: f,
      row: p,
      cell: v,
      getValue: v.getValue,
      renderValue: v.renderValue
    }), {
      key: process.env.NODE_ENV === "development" && "cell.getContext",
      debug: () => e.options.debugAll
    })
  };
  return e._features.forEach((h) => {
    Object.assign(u, h.createCell?.(u, r, n, e));
  }, {}), u;
}
const gk = (e, n, r, o, s, u) => {
  let h = {
    id: n,
    index: o,
    original: r,
    depth: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (f) => {
      if (h._valuesCache.hasOwnProperty(f))
        return h._valuesCache[f];
      const p = e.getColumn(f);
      if (!!p.accessorFn)
        return h._valuesCache[f] = p.accessorFn(h.original, o), h._valuesCache[f];
    },
    getUniqueValues: (f) => {
      if (h._uniqueValuesCache.hasOwnProperty(f))
        return h._uniqueValuesCache[f];
      const p = e.getColumn(f);
      if (!!p.accessorFn)
        return p.columnDef.getUniqueValues ? (h._uniqueValuesCache[f] = p.columnDef.getUniqueValues(h.original, o), h._uniqueValuesCache[f]) : (h._uniqueValuesCache[f] = [h.getValue(f)], h._uniqueValuesCache[f]);
    },
    renderValue: (f) => {
      var p;
      return (p = h.getValue(f)) != null ? p : e.options.renderFallbackValue;
    },
    subRows: u ?? [],
    getLeafRows: () => fTe(h.subRows, (f) => f.subRows),
    getAllCells: ut(() => [e.getAllLeafColumns()], (f) => f.map((p) => UTe(e, h, p, p.id)), {
      key: process.env.NODE_ENV === "development" && "row.getAllCells",
      debug: () => {
        var f;
        return (f = e.options.debugAll) != null ? f : e.options.debugRows;
      }
    }),
    _getAllCellsByColumnId: ut(() => [h.getAllCells()], (f) => f.reduce((p, v) => (p[v.column.id] = v, p), {}), {
      key: process.env.NODE_ENV === "production" && "row.getAllCellsByColumnId",
      debug: () => {
        var f;
        return (f = e.options.debugAll) != null ? f : e.options.debugRows;
      }
    })
  };
  for (let f = 0; f < e._features.length; f++) {
    const p = e._features[f];
    Object.assign(h, p?.createRow?.(h, e));
  }
  return h;
};
function WTe() {
  return (e) => ut(() => [e.options.data], (n) => {
    const r = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(s, u, h) {
      u === void 0 && (u = 0);
      const f = [];
      for (let p = 0; p < s.length; p++) {
        const v = gk(e, e._getRowId(s[p], p, h), s[p], p, u);
        r.flatRows.push(v), r.rowsById[v.id] = v, f.push(v), e.options.getSubRows && (v.originalSubRows = e.options.getSubRows(s[p], p), v.originalSubRows?.length && (v.subRows = o(v.originalSubRows, u + 1, v)));
      }
      return f;
    };
    return r.rows = o(n), r;
  }, {
    key: process.env.NODE_ENV === "development" && "getRowModel",
    debug: () => {
      var n;
      return (n = e.options.debugAll) != null ? n : e.options.debugTable;
    },
    onChange: () => {
      e._autoResetPageIndex();
    }
  });
}
function GTe(e, n, r) {
  return r.options.filterFromLeafRows ? qTe(e, n, r) : KTe(e, n, r);
}
function qTe(e, n, r) {
  var o;
  const s = [], u = {}, h = (o = r.options.maxLeafRowFilterDepth) != null ? o : 100, f = function(p, v) {
    v === void 0 && (v = 0);
    const b = [];
    for (let y = 0; y < p.length; y++) {
      let k = p[y];
      const _ = gk(r, k.id, k.original, k.index, k.depth);
      if (_.columnFilters = k.columnFilters, k.subRows?.length && v < h) {
        if (_.subRows = f(k.subRows, v + 1), k = _, n(k) && !_.subRows.length) {
          b.push(k), u[k.id] = k, u[y] = k;
          continue;
        }
        if (n(k) || _.subRows.length) {
          b.push(k), u[k.id] = k, u[y] = k;
          continue;
        }
      } else
        k = _, n(k) && (b.push(k), u[k.id] = k, u[y] = k);
    }
    return b;
  };
  return {
    rows: f(e),
    flatRows: s,
    rowsById: u
  };
}
function KTe(e, n, r) {
  var o;
  const s = [], u = {}, h = (o = r.options.maxLeafRowFilterDepth) != null ? o : 100, f = function(p, v) {
    v === void 0 && (v = 0);
    const b = [];
    for (let y = 0; y < p.length; y++) {
      let k = p[y];
      if (n(k)) {
        if (k.subRows?.length && v < h) {
          const E = gk(r, k.id, k.original, k.index, k.depth);
          E.subRows = f(k.subRows, v + 1), k = E;
        }
        b.push(k), s.push(k), u[k.id] = k;
      }
    }
    return b;
  };
  return {
    rows: f(e),
    flatRows: s,
    rowsById: u
  };
}
function YTe() {
  return (e) => ut(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (n, r, o) => {
    if (!n.rows.length || !r?.length && !o) {
      for (let k = 0; k < n.flatRows.length; k++)
        n.flatRows[k].columnFilters = {}, n.flatRows[k].columnFiltersMeta = {};
      return n;
    }
    const s = [], u = [];
    (r ?? []).forEach((k) => {
      var _;
      const E = e.getColumn(k.id);
      E || process.env.NODE_ENV !== "production" && console.warn(`Table: Could not find a column to filter with columnId: ${k.id}`);
      const x = E.getFilterFn();
      if (!x) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${E.id}.`);
        return;
      }
      s.push({
        id: k.id,
        filterFn: x,
        resolvedValue: (_ = x.resolveFilterValue?.(k.value)) != null ? _ : k.value
      });
    });
    const h = r.map((k) => k.id), f = e.getGlobalFilterFn(), p = e.getAllLeafColumns().filter((k) => k.getCanGlobalFilter());
    o && f && p.length && (h.push("__global__"), p.forEach((k) => {
      var _;
      u.push({
        id: k.id,
        filterFn: f,
        resolvedValue: (_ = f.resolveFilterValue?.(o)) != null ? _ : o
      });
    }));
    let v, b;
    for (let k = 0; k < n.flatRows.length; k++) {
      const _ = n.flatRows[k];
      if (_.columnFilters = {}, s.length)
        for (let E = 0; E < s.length; E++) {
          v = s[E];
          const x = v.id;
          _.columnFilters[x] = v.filterFn(_, x, v.resolvedValue, (D) => {
            _.columnFiltersMeta[x] = D;
          });
        }
      if (u.length) {
        for (let E = 0; E < u.length; E++) {
          b = u[E];
          const x = b.id;
          if (b.filterFn(_, x, b.resolvedValue, (D) => {
            _.columnFiltersMeta[x] = D;
          })) {
            _.columnFilters.__global__ = !0;
            break;
          }
        }
        _.columnFilters.__global__ !== !0 && (_.columnFilters.__global__ = !1);
      }
    }
    const y = (k) => {
      for (let _ = 0; _ < h.length; _++)
        if (k.columnFilters[h[_]] === !1)
          return !1;
      return !0;
    };
    return GTe(n.rows, y, e);
  }, {
    key: process.env.NODE_ENV === "development" && "getFilteredRowModel",
    debug: () => {
      var n;
      return (n = e.options.debugAll) != null ? n : e.options.debugTable;
    },
    onChange: () => {
      e._autoResetPageIndex();
    }
  });
}
function QTe() {
  return (e) => ut(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, r) => {
    if (!r.rows.length || !n?.length)
      return r;
    const o = e.getState().sorting, s = [], u = o.filter((p) => e.getColumn(p.id).getCanSort()), h = {};
    u.forEach((p) => {
      const v = e.getColumn(p.id);
      h[p.id] = {
        sortUndefined: v.columnDef.sortUndefined,
        invertSorting: v.columnDef.invertSorting,
        sortingFn: v.getSortingFn()
      };
    });
    const f = (p) => {
      const v = [...p];
      return v.sort((b, y) => {
        for (let _ = 0; _ < u.length; _ += 1) {
          var k;
          const E = u[_], x = h[E.id], D = (k = E?.desc) != null ? k : !1;
          if (x.sortUndefined) {
            const N = b.getValue(E.id), O = y.getValue(E.id), P = typeof N > "u", S = typeof O > "u";
            if (P || S)
              return P && S ? 0 : P ? x.sortUndefined : -x.sortUndefined;
          }
          let I = x.sortingFn(b, y, E.id);
          if (I !== 0)
            return D && (I *= -1), x.invertSorting && (I *= -1), I;
        }
        return b.index - y.index;
      }), v.forEach((b) => {
        s.push(b), b.subRows?.length && (b.subRows = f(b.subRows));
      }), v;
    };
    return {
      rows: f(r.rows),
      flatRows: s,
      rowsById: r.rowsById
    };
  }, {
    key: process.env.NODE_ENV === "development" && "getSortedRowModel",
    debug: () => {
      var n;
      return (n = e.options.debugAll) != null ? n : e.options.debugTable;
    },
    onChange: () => {
      e._autoResetPageIndex();
    }
  });
}
/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function bO(e, n) {
  return e ? ZTe(e) ? /* @__PURE__ */ M(e, {
    ...n
  }) : e : null;
}
function ZTe(e) {
  return XTe(e) || typeof e == "function" || JTe(e);
}
function XTe(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function JTe(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function eDe(e) {
  const n = {
    state: {},
    onStateChange: () => {
    },
    renderFallbackValue: null,
    ...e
  }, [r] = ne.useState(() => ({
    current: HTe(n)
  })), [o, s] = ne.useState(() => r.current.initialState);
  return r.current.setOptions((u) => ({
    ...u,
    ...e,
    state: {
      ...o,
      ...e.state
    },
    onStateChange: (h) => {
      s(h), e.onStateChange?.(h);
    }
  })), r.current;
}
const wO = oe.createContext(void 0), tDe = wO.Provider;
function im() {
  const e = tt(wO);
  if (!e)
    throw Error("Component must be used as a child of Table");
  return e;
}
function yO({
  children: e,
  aggregate: n,
  noCounter: r = !1,
  onRowClick: o,
  ...s
}) {
  const {
    counter: u,
    incCounter: h,
    hover: f
  } = im();
  return r || h(), /* @__PURE__ */ M("tr", {
    ...s,
    onClick: o,
    className: Ce(
      {
        "cursor-pointer": o
      },
      {
        "hover:bg-blue-50": f
      },
      {
        "font-medium": n
      },
      (u.current || 0) % 2 !== 1 ? "bg-gray-50" : "bg-white"
    ),
    children: e
  });
}
function nDe({
  children: e,
  colgroup: n,
  ...r
}) {
  const {
    condensed: o,
    fenced: s
  } = im();
  return /* @__PURE__ */ M("th", {
    ...r,
    title: "",
    scope: "col",
    className: Ce("relative px-3 py-3.5 text-left text-sm font-semibold text-gray-900", o ? "px-4 " : "px-6 ", "bg-gray-50", {
      "border-r last:border-r-0": s
    }),
    children: e
  });
}
const rDe = (e) => {
  const n = e.scrollHeight > e.clientHeight, o = window.getComputedStyle(e).overflowY.indexOf("hidden") !== -1;
  return n && !o;
}, kO = (e) => !e || e === document.body ? document.body : rDe(e) ? e : e.parentElement ? kO(e.parentElement) : document.body;
function iDe() {
  const [e, n] = Ve(!1), [r, o] = Ve(), s = et((u) => {
    u !== null && o(u);
  }, []);
  return Xe(() => {
    if (!r)
      return () => {
      };
    const u = new IntersectionObserver(
      ([h]) => {
        n(h.intersectionRatio === 0);
      },
      { threshold: [0], root: kO(r) }
    );
    return u.observe(r), () => u.unobserve(r);
  }, [r]), [s, e];
}
function oDe({
  stickyHeader: e = !1,
  headerGroups: n
}) {
  const [r, o] = iDe();
  return /* @__PURE__ */ K("thead", {
    className: Ce("relative", {
      "sticky -top-0.5": e
    }, {
      shadow: e && o
    }),
    children: [/* @__PURE__ */ M("tr", {
      className: "sticky left-0 invisible block",
      style: {
        height: 1
      },
      ref: r
    }), n.map((s) => /* @__PURE__ */ M(yO, {
      noCounter: !0,
      children: s.headers.map((u) => /* @__PURE__ */ M(nDe, {
        children: u.isPlaceholder ? null : /* @__PURE__ */ K("button", {
          type: "button",
          className: u.column.getCanSort() ? "cursor-pointer select-none group inline-flex" : "cursor-default",
          onClick: u.column.getToggleSortingHandler(),
          children: [bO(u.column.columnDef.header, u.getContext()), /* @__PURE__ */ M("span", {
            className: "ml-2 flex-none rounded text-gray-900",
            children: {
              asc: /* @__PURE__ */ M(Bt.Caret, {
                className: "ml-2 h-4 w-4 flex-none rounded"
              }),
              desc: /* @__PURE__ */ M(Bt.ChevronUp, {
                className: "ml-2 h-4 w-4 flex-none rounded"
              })
            }[u.column.getIsSorted()] ?? null
          })]
        })
      }))
    }))]
  });
}
const aDe = oe.forwardRef(({
  children: e,
  ...n
}, r) => {
  const {
    striped: o
  } = im();
  return /* @__PURE__ */ M("tbody", {
    ...n,
    ref: r,
    className: Ce("bg-white", {
      "divide-y divide-gray-200": !o
    }),
    children: e
  });
});
function sDe({
  children: e,
  ...n
}) {
  const {
    condensed: r,
    fenced: o
  } = im();
  return /* @__PURE__ */ M("td", {
    ...n,
    className: Ce("relative text-left whitespace-nowrap text-sm text-gray-500", r ? "px-4 py-2" : "px-6 py-4", {
      "border-r last:border-r-0": o
    }),
    children: e
  });
}
function lDe(e) {
  const {
    getIsSelected: n,
    getIsSomeSelected: r,
    getToggleSelectedHandler: o
  } = e;
  return /* @__PURE__ */ M("div", {
    className: "px-1",
    children: /* @__PURE__ */ M(uk, {
      checked: n(),
      indeterminate: r(),
      onChange: o()
    })
  });
}
function cDe(e) {
  const {
    getIsAllRowsSelected: n,
    getIsSomeRowsSelected: r,
    getToggleAllRowsSelectedHandler: o
  } = e;
  return /* @__PURE__ */ M("div", {
    className: "px-1",
    children: /* @__PURE__ */ M(uk, {
      checked: n(),
      indeterminate: r(),
      onChange: o()
    })
  });
}
function uDe({
  data: e,
  columns: n,
  stickyHeader: r = !1,
  striped: o = !0,
  hover: s = !1,
  condensed: u = !1,
  fenced: h = !1,
  onSelectionChange: f,
  onClick: p,
  ...v
}) {
  const [b, y] = Ve({}), [k, _] = Ve([]), E = Re(() => {
    const O = [...n];
    return f && O.unshift({
      id: "select",
      header: (P) => cDe(P.table),
      cell: (P) => lDe(P.row)
    }), O;
  }, [n, f]);
  Xe(() => {
    y({});
  }, [e]);
  const x = Le(0);
  x.current = 0;
  const D = () => {
    x.current += 1;
  }, {
    rounded: I
  } = Li(v), N = eDe({
    data: e,
    columns: E,
    state: {
      rowSelection: b,
      sorting: k
    },
    getCoreRowModel: WTe(),
    onRowSelectionChange: y,
    onSortingChange: _,
    getFilteredRowModel: YTe(),
    getSortedRowModel: QTe()
  });
  return Xe(() => {
    f && f(N.getSelectedRowModel().flatRows);
  }, [f, b, N]), /* @__PURE__ */ M("div", {
    className: "mt-8 flex flex-col",
    children: /* @__PURE__ */ M("div", {
      className: "-my-2 -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-auto",
      children: /* @__PURE__ */ M("div", {
        className: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8",
        children: /* @__PURE__ */ M("div", {
          className: Ce("relative shadow ring-1 ring-black ring-opacity-5 overflow-hidden", {
            "md:rounded-lg": I
          }),
          children: /* @__PURE__ */ M(tDe, {
            value: {
              condensed: u,
              fenced: h,
              striped: o,
              hover: s,
              counter: x,
              incCounter: D
            },
            children: /* @__PURE__ */ K("table", {
              className: Ce("min-w-full table-fixed divide-y divide-gray-300"),
              children: [/* @__PURE__ */ M(oDe, {
                stickyHeader: r,
                headerGroups: N.getHeaderGroups()
              }), /* @__PURE__ */ M(aDe, {
                children: N.getRowModel().rows.map((O) => /* @__PURE__ */ M(yO, {
                  onRowClick: p ? () => p(O) : void 0,
                  children: O.getVisibleCells().map((P) => /* @__PURE__ */ M(sDe, {
                    colSpan: 1,
                    children: bO(P.column.columnDef.cell, P.getContext())
                  }, P.id))
                }, O.id))
              })]
            })
          })
        })
      })
    })
  });
}
uDe.displayName = "Table";
function _O({
  children: e
}) {
  return /* @__PURE__ */ M(SI, {
    as: ft,
    children: e
  });
}
_O.displayName = "Tab.Group";
const AO = _t({
  border: "bottom"
});
function dDe() {
  return tt(AO);
}
function CO({
  children: e,
  border: n = "bottom"
}) {
  const r = Re(() => ({
    border: n
  }), [n]);
  return /* @__PURE__ */ M("div", {
    className: Ce(n === "top" ? "border-t" : "border-b", "border-gray-200"),
    children: /* @__PURE__ */ M(MI, {
      className: Ce("-mb-px", "flex space-x-8"),
      "aria-label": "Tabs",
      children: /* @__PURE__ */ M(AO.Provider, {
        value: r,
        children: e
      })
    })
  });
}
CO.displayName = "Tab.List";
function xO({
  children: e
}) {
  const n = Et();
  return /* @__PURE__ */ M(DI, {
    children: e
  }, n);
}
xO.displayName = "Tab.Panel";
function EO({
  children: e
}) {
  return /* @__PURE__ */ M(TI, {
    as: ft,
    children: e
  });
}
EO.displayName = "Tab.Panels";
const SO = oe.forwardRef(({
  children: e,
  ...n
}, r) => {
  const {
    border: o
  } = dDe();
  return /* @__PURE__ */ M(QY, {
    as: ft,
    children: ({
      selected: s
    }) => /* @__PURE__ */ M("button", {
      ...n,
      type: "button",
      ref: r,
      className: Ce(o === "top" ? "border-t-2" : "border-b-2", s ? "border-blue-800 text-blue-800" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700", "whitespace-nowrap text-base font-semibold", "text-left", "focus:outline-none", "hover:bg-gray-50"),
      "aria-current": s ? "page" : void 0,
      children: e
    })
  });
});
SO.displayName = "Tab.Group";
const r4e = Object.assign(SO, {
  Group: _O,
  List: CO,
  Panel: xO,
  Panels: EO
});
function hDe({
  heading: e,
  message: n,
  cancelButtonLabel: r,
  confirmButton: o,
  icon: s,
  ...u
}) {
  const {
    onClick: h,
    ...f
  } = u, [p, v] = Ve(!1), b = Le(null), y = (k) => {
    h && h(k);
  };
  return /* @__PURE__ */ K(bo, {
    children: [/* @__PURE__ */ M(di, {
      ...f,
      onClick: () => v(!0)
    }), /* @__PURE__ */ M(rr.Root, {
      show: p,
      as: ft,
      children: /* @__PURE__ */ K(Ss, {
        as: "div",
        className: "relative z-10",
        initialFocus: b,
        onClose: v,
        children: [/* @__PURE__ */ M(rr.Child, {
          as: ft,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ M("div", {
            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          })
        }), /* @__PURE__ */ M("div", {
          className: "fixed inset-0 z-10 overflow-y-auto",
          children: /* @__PURE__ */ M("div", {
            className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
            children: /* @__PURE__ */ M(rr.Child, {
              as: ft,
              enter: "ease-out duration-300",
              enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              enterTo: "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
              leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              children: /* @__PURE__ */ K(wg, {
                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6",
                children: [/* @__PURE__ */ K("div", {
                  className: "sm:flex sm:items-start",
                  children: [s && /* @__PURE__ */ M("div", {
                    className: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10",
                    children: s
                  }), /* @__PURE__ */ K("div", {
                    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                    children: [/* @__PURE__ */ M(yg, {
                      as: "h3",
                      className: "text-lg font-medium leading-6 text-gray-900",
                      children: e
                    }), /* @__PURE__ */ M("div", {
                      className: "mt-2",
                      children: n
                    })]
                  })]
                }), /* @__PURE__ */ M("div", {
                  className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-x-2",
                  children: /* @__PURE__ */ K(Sd.Provider, {
                    value: void 0,
                    children: [/* @__PURE__ */ M(di, {
                      onClick: () => v(!1),
                      children: r
                    }), typeof o == "string" ? /* @__PURE__ */ M(di, {
                      onClick: (k) => {
                        v(!1), y(k);
                      },
                      children: o
                    }) : oe.cloneElement(o, {
                      onClick: (k) => {
                        v(!1), y(k);
                      }
                    })]
                  })
                })]
              })
            })
          })
        })]
      })
    })]
  });
}
hDe.displayName = "ConfirmButton";
function fDe({
  children: e,
  show: n
}) {
  return /* @__PURE__ */ M(rr.Root, {
    show: n,
    as: ft,
    children: /* @__PURE__ */ M("div", {
      className: "relative z-10",
      children: /* @__PURE__ */ M("div", {
        className: "fixed z-10 right-0 mr-12 bottom-0 overflow-y-auto",
        children: /* @__PURE__ */ M("div", {
          className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
          children: /* @__PURE__ */ M(rr.Child, {
            as: ft,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /* @__PURE__ */ M("div", {
              className: "relative transform overflow-hidden border-2 border-gray-400 rounded-lg px-4 pt-5 pb-4 bg-gray-50 text-left shadow-md transition-all sm:my-8 sm:w-full sm:max-w-xl sm:p-6",
              children: e
            })
          })
        })
      })
    })
  });
}
fDe.displayName = "CornerDialog";
function pDe(e) {
  switch (e) {
    case "sm":
      return "max-w-sm";
    case "lg":
      return "max-w-lg";
    case "xl":
      return "max-w-xl";
    case "2xl":
      return "max-w-2xl";
    case "3xl":
      return "max-w-3xl";
    case "4xl":
      return "max-w-4xl";
    case "5xl":
      return "max-w-5xl";
    case "6xl":
      return "max-w-6xl";
    case "7xl":
      return "max-w-7xl";
    case "md":
    default:
      return "max-w-md";
  }
}
function gDe({
  isShown: e = !0,
  footer: n,
  children: r,
  title: o,
  maxWidth: s = "xl",
  hasHeader: u,
  onClose: h,
  ...f
}) {
  const {
    rounded: p
  } = Li(f), v = Le(null);
  return /* @__PURE__ */ M(rr.Root, {
    show: e,
    as: ft,
    children: /* @__PURE__ */ K(Ss, {
      as: "div",
      className: "relative z-10",
      initialFocus: v,
      onClose: h,
      open: !0,
      children: [/* @__PURE__ */ M(Uo, {
        as: ft,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ M("div", {
          className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        })
      }), /* @__PURE__ */ M("div", {
        className: "fixed inset-0 z-10 overflow-y-auto",
        children: /* @__PURE__ */ M("div", {
          className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
          children: /* @__PURE__ */ M(Uo, {
            as: ft,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /* @__PURE__ */ K(Ss.Panel, {
              className: Ce("relative w-full transform overflow-hidden bg-white", "p-6 my-8 text-left shadow-xl transition-all", {
                "rounded-lg": p
              }, pDe(s)),
              children: [u && /* @__PURE__ */ M("div", {
                className: "absolute right-0 top-0 hidden pr-4 pt-4 sm:block",
                children: /* @__PURE__ */ K("button", {
                  type: "button",
                  className: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                  onClick: h,
                  children: [/* @__PURE__ */ M("span", {
                    className: "sr-only",
                    children: "Close"
                  }), /* @__PURE__ */ M(Bt.X, {})]
                })
              }), /* @__PURE__ */ M("div", {
                className: "sm:flex sm:items-start",
                children: /* @__PURE__ */ K("div", {
                  className: "mt-2 text-center sm:mt-0 sm:text-left",
                  children: [u && /* @__PURE__ */ M(Ss.Title, {
                    as: "h3",
                    className: "text-lg font-medium leading-6 text-gray-900 mr-10",
                    children: o
                  }), /* @__PURE__ */ M("div", {
                    className: Ce({
                      "mt-2": u
                    }),
                    children: r
                  })]
                })
              }), n && /* @__PURE__ */ M("div", {
                className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-x-2",
                children: n
              })]
            })
          })
        })
      })]
    })
  });
}
gDe.displayName = "Dialog";
function mDe({
  children: e,
  control: n
}) {
  return /* @__PURE__ */ K(Ms, {
    children: [/* @__PURE__ */ M(ry, {
      className: "block text-sm/6 font-semibold text-white/50",
      children: n
    }), /* @__PURE__ */ M(iy, {
      transition: !0,
      anchor: "bottom",
      className: "z-20 pb-1 transition duration-200 ease-in-out [--anchor-gap:4px)] data-[closed]:-translate-y-1 data-[closed]:opacity-0",
      children: e
    })]
  });
}
mDe.displayName = "Popover";
function vDe({
  children: e,
  compact: n = !1
}) {
  return /* @__PURE__ */ M("div", {
    className: Ce("px-4 sm:px-6", n ? "py-2" : "py-6"),
    children: e
  });
}
function bDe(e) {
  const [{ panels: n }, r] = Ve(
    { panels: [e] }
  ), o = II();
  Xe(() => {
    !o && !D8(e, n[0]) && r((f) => ({ ...f, panels: [e, ...f.panels.slice(1)] }));
  }, [e]);
  const s = et(
    (f) => {
      r((p) => ({ ...p, panels: [...p.panels, f] }));
    },
    []
  ), u = et(
    () => {
      r((f) => ({ ...f, panels: f.panels.slice(0, -1) }));
    },
    []
  ), h = et(
    () => {
      r((f) => ({ ...f, panels: f.panels.slice(0, 1) }));
    },
    []
  );
  return [n, s, u, h];
}
function wDe() {
  const e = Et();
  return /* @__PURE__ */ K("div", {
    children: [/* @__PURE__ */ M("label", {
      htmlFor: e,
      className: "sr-only",
      children: "Progress:"
    }), /* @__PURE__ */ M("progress", {
      id: e,
      className: "nlg-ui-progress-bar w-full",
      style: {
        height: 3
      }
    })]
  });
}
function yDe({
  control: e,
  children: n,
  footer: r,
  title: o,
  onOpen: s,
  onClose: u,
  size: h = "small",
  initialFocus: f,
  offsetTop: p = 0,
  disabled: v = !1,
  contentRef: b,
  showProgressBar: y = !1
}) {
  const [k, _] = Ve(!1), [E, x] = Ve(!1), D = Le(null), I = et(() => {
    !v && !E && _(!0), s && s();
  }, [v, E, s]);
  Xe(() => () => {
    D.current && clearTimeout(D.current);
  }, []);
  const [N, O] = Ve(!1), [P, S, $, L] = bDe({
    children: n,
    footer: r,
    title: o
  }), B = E8(P, N ? -2 : -1), U = P.length > (N ? 2 : 1), G = et(() => {
    x(!0), _(!1), D.current = setTimeout(() => {
      L(), x(!1);
    }, 500), u && u();
  }, [u, L]), q = et(() => {
    O(!0), D.current = setTimeout(() => {
      $ && $(), O(!1);
    }, 500);
  }, [$]), Y = Re(() => ({
    close: G,
    pushPanel: S
  }), [G, S]);
  return /* @__PURE__ */ K(bo, {
    children: [oe.cloneElement(e, {
      onClick: I
    }), /* @__PURE__ */ M(Sd.Provider, {
      value: void 0,
      children: /* @__PURE__ */ M(rr.Root, {
        show: k,
        as: ft,
        appear: !0,
        children: /* @__PURE__ */ M(Ss, {
          as: "div",
          static: !0,
          className: "fixed overflow-hidden z-10",
          open: k,
          onClose: G,
          initialFocus: f,
          style: {
            bottom: 0,
            right: 0,
            left: 0,
            top: p
          },
          children: /* @__PURE__ */ K("div", {
            className: "absolute inset-0 overflow-hidden",
            children: [/* @__PURE__ */ M(rr.Child, {
              as: ft,
              enter: "ease-in-out duration-300",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "ease-in-out duration-300",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /* @__PURE__ */ M("div", {
                className: "absolute inset-0 bg-gray-400 bg-opacity-75 transition-opacity"
              })
            }), /* @__PURE__ */ M("div", {
              className: Ce("fixed right-0 max-w-full flex", h === "small" ? "pl-16" : "pl-10 sm:pl-16"),
              style: {
                bottom: 0,
                top: p
              },
              children: /* @__PURE__ */ M(rr.Child, {
                as: ft,
                enter: "transform transition ease-in-out duration-300 sm:duration-500",
                enterFrom: "translate-x-full",
                enterTo: "translate-x-0",
                leave: "transform transition ease-in-out duration-300 sm:duration-500",
                leaveFrom: "translate-x-0",
                leaveTo: "translate-x-full",
                children: /* @__PURE__ */ M("div", {
                  className: Ce("w-screen transition-all", {
                    "max-w-md": h === "small"
                  }, {
                    "max-w-xl": h === "medium"
                  }, {
                    "max-w-4xl": h === "double"
                  }, {
                    "max-w-6xl": h === "large"
                  }),
                  children: /* @__PURE__ */ M("div", {
                    className: "h-full flex flex-col bg-white shadow-xl",
                    children: /* @__PURE__ */ K("div", {
                      className: "flex-1 flex flex-col h-full",
                      children: [/* @__PURE__ */ K("div", {
                        className: "px-4 py-6 sm:px-6 relative",
                        children: [/* @__PURE__ */ K("div", {
                          className: "flex items-start",
                          children: [U && /* @__PURE__ */ M("div", {
                            className: "mr-3 h-7 w-7 flex items-center",
                            children: /* @__PURE__ */ K("button", {
                              type: "button",
                              className: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2",
                              onClick: q,
                              children: [/* @__PURE__ */ M("span", {
                                className: "sr-only",
                                children: "Close panel"
                              }), /* @__PURE__ */ M(Bt.Previous, {
                                "aria-hidden": "true"
                              })]
                            })
                          }), /* @__PURE__ */ M("div", {
                            className: "flex-grow flex flex-col gap-2",
                            children: /* @__PURE__ */ M(yg, {
                              className: "text-lg font-medium text-gray-900",
                              children: B?.title
                            })
                          }), /* @__PURE__ */ M("div", {
                            className: "ml-3 h-7 flex items-center",
                            children: /* @__PURE__ */ K("button", {
                              type: "button",
                              className: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2",
                              onClick: G,
                              children: [/* @__PURE__ */ M("span", {
                                className: "sr-only",
                                children: "Close panel"
                              }), /* @__PURE__ */ M(Bt.X, {
                                "aria-hidden": "true"
                              })]
                            })
                          })]
                        }), y && /* @__PURE__ */ M("div", {
                          className: "absolute w-full left-0 right-0 bottom-0",
                          children: /* @__PURE__ */ M(wDe, {})
                        })]
                      }), /* @__PURE__ */ M("div", {
                        className: Ce("flex-1 overflow-y-auto overflow-x-hidden relative", "slideover-content"),
                        ref: b,
                        children: P.map((Q, Z) => {
                          const ae = Z === P.length - (N ? 2 : 1);
                          return /* @__PURE__ */ M(rr, {
                            as: "div",
                            className: "divide-y divide-gray-200 bg-white",
                            enter: "transform transition ease-in-out duration-300 sm:duration-500 absolute inset-0",
                            enterFrom: Ce(N ? "-translate-x-full" : "translate-x-full"),
                            enterTo: "translate-x-0",
                            leave: "transform transition ease-in-out duration-300 sm:duration-500 absolute inset-0",
                            leaveFrom: "translate-x-0",
                            leaveTo: Ce(N ? "translate-x-full" : "-translate-x-full"),
                            show: ae,
                            appear: Z !== 0,
                            children: typeof Q.children == "function" ? Q.children(Y) : Q.children
                          }, Z);
                        })
                      }), B?.footer && /* @__PURE__ */ M("div", {
                        className: "flex-shrink-0 px-4 border-t border-gray-200 py-5 sm:px-6",
                        children: /* @__PURE__ */ M("div", {
                          className: "space-x-3 flex",
                          children: typeof B.footer == "function" ? B.footer(Y) : B.footer
                        })
                      })]
                    })
                  })
                })
              })
            })]
          })
        })
      })
    })]
  });
}
yDe.PaddedBody = vDe;
const MO = _t(void 0);
function Ac() {
  return tt(MO);
}
function TO({
  isOpen: e,
  open: n,
  close: r,
  closeAll: o,
  isNested: s,
  panelRef: u,
  children: h
}) {
  const f = Re(() => ({
    isOpen: e,
    open: n,
    close: r,
    closeAll: o,
    isNested: s,
    panelRef: u
  }), [r, o, s, e, n, u]);
  return /* @__PURE__ */ M(MO.Provider, {
    value: f,
    children: h
  });
}
TO.displayName = "Slideover2.ContextProvider";
function DO({
  children: e,
  size: n = "sm",
  initialFocus: r
}) {
  const {
    isOpen: o,
    closeAll: s
  } = Ac();
  return /* @__PURE__ */ M(Sd.Provider, {
    value: void 0,
    children: /* @__PURE__ */ M(rr, {
      show: o,
      as: ft,
      appear: !0,
      children: /* @__PURE__ */ M(Ss, {
        as: "div",
        static: !0,
        className: "fixed overflow-hidden z-10 inset-0",
        open: o,
        onClose: s,
        initialFocus: r,
        children: /* @__PURE__ */ K("div", {
          className: "absolute inset-0 overflow-hidden",
          children: [/* @__PURE__ */ M(Uo, {
            as: "div",
            enter: "ease-in-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in-out duration-300",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            className: "absolute inset-0 bg-gray-200 bg-opacity-75 transition-opacity"
          }), /* @__PURE__ */ M("div", {
            className: Ce("fixed right-0 max-w-full flex inset-y-0 pointer-events-none", n === "sm" ? "pl-16" : "pl-10 sm:pl-16"),
            children: /* @__PURE__ */ M(wg, {
              transition: !0,
              className: Ce("w-screen transition-all pointer-events-auto", "transition duration-500 ease-in-out data-[closed]:translate-x-full", "sm:duration-700", {
                "max-w-md": n === "sm"
              }, {
                "max-w-xl": n === "md"
              }, {
                "max-w-4xl": n === "lg"
              }, {
                "max-w-6xl": n === "xl"
              }),
              children: /* @__PURE__ */ M("div", {
                className: "h-full flex flex-col bg-white shadow-xl",
                children: e
              })
            })
          })]
        })
      })
    })
  });
}
DO.displayName = "Slideover2.Panel";
function IO({
  children: e
}) {
  const {
    close: n,
    closeAll: r,
    isNested: o
  } = Ac();
  return /* @__PURE__ */ M("div", {
    className: "px-4 py-6 bg-white sm:px-6 relative",
    children: /* @__PURE__ */ K("div", {
      className: "flex items-start",
      children: [/* @__PURE__ */ M("div", {
        className: "mr-3 h-7 w-7 flex items-center",
        children: o && /* @__PURE__ */ K("button", {
          type: "button",
          className: "bg-white text-gray-700 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-blue-100",
          onClick: n,
          children: [/* @__PURE__ */ M("span", {
            className: "sr-only",
            children: "Back"
          }), /* @__PURE__ */ M(Bt.Backspace, {
            "aria-hidden": "true"
          })]
        })
      }), /* @__PURE__ */ M("div", {
        className: "flex-grow flex flex-col gap-2",
        children: /* @__PURE__ */ M(yg, {
          className: "text-lg font-medium text-gray-700 text-center",
          children: e
        })
      }), /* @__PURE__ */ M("div", {
        className: "ml-3 h-7 flex items-center",
        children: /* @__PURE__ */ K("button", {
          type: "button",
          className: "text-gray-700 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-blue-100",
          onClick: r,
          children: [/* @__PURE__ */ M("span", {
            className: "sr-only",
            children: "Close panel"
          }), /* @__PURE__ */ M(Bt.X, {
            "aria-hidden": "true"
          })]
        })
      })]
    })
  });
}
IO.displayName = "Slideover2.Header";
const PO = oe.forwardRef(({
  children: e,
  padded: n
}, r) => {
  const {
    close: o,
    closeAll: s
  } = Ac(), u = Re(() => ({
    close: o,
    closeAll: s
  }), [o, s]);
  return /* @__PURE__ */ M("div", {
    className: Ce(
      "flex-1 overflow-y-auto overflow-x-hidden relative bg-white",
      {
        "px-4 sm:px-6 py-6": n
      }
    ),
    ref: r,
    children: typeof e == "function" ? e(u) : e
  });
});
PO.displayName = "Slideover2.Body";
function OO({
  children: e
}) {
  const {
    close: n,
    closeAll: r
  } = Ac(), o = Re(() => ({
    close: n,
    closeAll: r
  }), [n, r]);
  return /* @__PURE__ */ M("div", {
    className: "flex-shrink-0 px-4 border-t border-gray-200 py-5 sm:px-6",
    children: /* @__PURE__ */ M("div", {
      className: "space-x-3 flex",
      children: typeof e == "function" ? e(o) : e
    })
  });
}
OO.displayName = "Slideover2.Footer";
const kDe = di;
function RO(e, n) {
  const {
    open: r,
    panelRef: o
  } = Ac(), s = Et(), {
    id: u = `nalgoo-ui-slideover-button-${s}`,
    ...h
  } = e, f = ye((E) => {
    E.preventDefault(), E.stopPropagation(), r();
  }), p = ye((E) => {
    E.preventDefault(), E.stopPropagation();
  }), v = ye((E) => {
    switch (E.key) {
      case ze.Space:
      case ze.Enter:
        E.preventDefault(), E.stopPropagation(), r();
        break;
      case ze.Escape:
        break;
    }
  }), b = ye((E) => {
    E.key === ze.Space && E.preventDefault();
  }), y = {
    id: u,
    ref: n,
    "aria-haspopup": "dialog",
    "aria-controls": o.current?.id,
    "aria-expanded": r,
    onKeyDown: v,
    onKeyUp: b,
    onClick: f,
    onMouseDown: p
  }, k = Re(() => ({
    open: r
  }), [r]);
  return st()({
    ourProps: y,
    theirProps: h,
    slot: k,
    defaultTag: kDe,
    name: "Slideover2.Button"
  });
}
RO.displayName = "Slideover2.Button";
const _De = nt(RO);
function NO({
  children: e,
  onOpen: n,
  onClose: r,
  open: o
}) {
  const [s, u] = Ve(!1), [h, f] = Ve(!1), p = Ac(), v = o !== void 0, b = et(() => {
    h || (v || u(!0), n && n());
  }, [h, n, v]);
  Xe(() => {
    v && u(o);
  }, [o, v]), Xe(() => {
    let E;
    return s || (f(!0), E = setTimeout(() => {
      f(!1);
    }, 500)), () => {
      E && clearTimeout(E);
    };
  }, [s]);
  const y = et(() => {
    (o === void 0 || r === void 0) && u(!1), r && r();
  }, [r, o]), k = et(() => {
    y(), p && p.closeAll();
  }, [y, p]), _ = Le(null);
  return /* @__PURE__ */ M(TO, {
    isOpen: v ? o : s,
    open: b,
    close: y,
    closeAll: k,
    isNested: p !== void 0,
    panelRef: _,
    children: e
  });
}
NO.displayName = "Slideover2";
const i4e = Object.assign(NO, {
  Body: PO,
  Button: _De,
  Footer: OO,
  Header: IO,
  Panel: DO
});
export {
  CSe as Alert,
  $De as Appear,
  p1e as AreaChart,
  BDe as Avatar,
  E7 as Badge,
  wSe as Button,
  JDe as Card,
  uk as Checkbox,
  VDe as Combobox,
  g1e as ComposedChart,
  hDe as ConfirmButton,
  fDe as CornerDialog,
  zDe as DateDistance,
  USe as DateInput,
  HDe as DatePicker,
  UDe as DateRangePicker,
  gDe as Dialog,
  t4e as Directory,
  cb as Dropdown,
  tTe as Dropzone,
  e4e as Flex,
  WDe as Form,
  I7 as Grid,
  Bt as Icon,
  qs as Label,
  DSe as LineClamp,
  n4 as LocaleContext,
  O8 as LocaleProvider,
  FDe as Localization,
  WSe as LocalizedDateInput,
  a1 as Menu,
  sTe as PageFooter,
  lTe as PageHeading,
  cTe as Panel,
  b1e as PieChart,
  mDe as Popover,
  GSe as PopoverContent,
  GDe as RadioGroup,
  ZDe as RadioGroup2,
  lO as Section,
  ID as Select,
  qDe as SelectField,
  oTe as SidebarLayout,
  aTe as SidebarNavigation,
  hb as Skeleton,
  LDe as Slide,
  yDe as Slideover,
  i4e as Slideover2,
  gSe as Spinner,
  n4e as StackedList,
  aSe as StatsGrid,
  r4e as Tab,
  uDe as Table,
  uTe as Tabs,
  nMe as TextArea,
  KDe as TextAreaField,
  ed as TextInput,
  YDe as TextInputField,
  jDe as Theme,
  zSe as TimeInput,
  P7 as Timeline,
  QDe as Toggle,
  cSe as Tooltip,
  XDe as WysiwygEditor,
  s4 as useLocale,
  SSe as useLocalization,
  Li as useTheme
};
